"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5418],{

/***/ 57870:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml = __webpack_require__(16253);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Text = __webpack_require__(32348);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Util$SmartcutsMacros = __webpack_require__(25092);
var SerialId$SmartcutsMacros = __webpack_require__(45934);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
var EditGraph$SmartcutsMacros = __webpack_require__(14519);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
var DataExtraction__DataRecord__Types$SmartcutsMacros = __webpack_require__(36589);
var DataExtraction__DataRecord__Schema__Types$SmartcutsMacros = __webpack_require__(48828);
function t_encode(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "properties",
            Decco.arrayToJson(Curry._1(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.t_encode, encoder_dataNode), v.properties)
        ]
    ]);
}
function t_decode(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var properties = Decco.arrayFromJson(Curry._1(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.t_decode, decoder_dataNode), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
        if (properties.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    properties: properties._0
                }
            };
        }
        var e = properties._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".properties" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var manyThresholdCount = DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.EdgeCases.AnchorContainingManyProperties.manyThresholdCount;
function isLinkSchemaWithManyProperties(linkSchema) {
    return linkSchema.innerContent.length > manyThresholdCount;
}
function isDataNodeSchemaValueALinkWithManyProperties(dataNodeSchemaValue) {
    if (typeof dataNodeSchemaValue === "number") {
        return dataNodeSchemaValue >= 2;
    } else {
        return false;
    }
}
function areBothEditGraphValuesSatisfyBeingLinksWithManyProperties(schema1, schema2) {
    if (typeof schema1 === "number" && schema1 >= 2 && typeof schema2 === "number") {
        return schema2 >= 2;
    } else {
        return false;
    }
}
function t_encode$1(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "properties",
            Decco.arrayToJson(Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_encode, encoder_dataSchema), v.properties)
        ]
    ]);
}
function t_decode$1(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var properties = Decco.arrayFromJson(Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_decode, decoder_dataSchema), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
        if (properties.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    properties: properties._0
                }
            };
        }
        var e = properties._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".properties" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function isIdenticalTo(param, param$1) {
    var dataSchema2 = param$1.dataSchema;
    var dataSchema1 = param.dataSchema;
    if (Caml_obj.caml_equal(dataSchema1.htmlTagPathIdentifier, dataSchema2.htmlTagPathIdentifier)) {
        if (areBothEditGraphValuesSatisfyBeingLinksWithManyProperties(dataSchema1.schema, dataSchema2.schema)) {
            return true;
        } else {
            return Curry._4(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.doesContainSameValue, dataSchema1, function(dataSchema) {
                return dataSchema.schema;
            }, function(dataSchema) {
                return dataSchema.htmlTagPathIdentifier;
            }, dataSchema2);
        }
    } else {
        return false;
    }
}
var PropertyEditGraph = EditGraph$SmartcutsMacros.MakeArray({
    isIdenticalTo: isIdenticalTo
});
function valueFromDataNode(param) {
    return param.value;
}
function makeDataSchema(param, schema) {
    return {
        htmlTagPathIdentifier: param.htmlTagPathIdentifier,
        schema: schema
    };
}
function forDataRecords(dataRecords) {
    var propertySchemas1 = Belt_Array.reduceWithIndex(dataRecords, [], function(propertySchemas, dataRecord, dataRecordIndex) {
        var propertySchemasForCurrentDataRecord = Belt_Array.map(dataRecord.properties, Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema));
        if (propertySchemas.length === 0) {
            return propertySchemasForCurrentDataRecord;
        }
        var editScript = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas, propertySchemasForCurrentDataRecord);
        var len = editScript.length;
        if (len !== 1) {
            if (len === 0) {
                return propertySchemas;
            }
        } else {
            var match = editScript[0];
            switch(match.TAG | 0){
                case /* Add */ 0:
                case /* Remove */ 1:
                    break;
                case /* NoEdit */ 2:
                    return propertySchemas;
            }
        }
        var nextDataRecord = Belt_Array.get(dataRecords, dataRecordIndex + 1 | 0);
        if (nextDataRecord === undefined) {
            return ArrayUtils$SmartcutsMacros.flatMap(EditGraph$SmartcutsMacros.commandContent, editScript);
        }
        var arg = EditGraph$SmartcutsMacros.findArrangements(editScript);
        var arg$1 = Belt_Array.get(function(param) {
            return ArrayUtils$SmartcutsMacros.sort(param, arg);
        }(function(propertySchemas1, propertySchemas2) {
            var propertySchemasForNextDataRecord = Belt_Array.map(nextDataRecord.properties, Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema));
            var editScript1 = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas1, propertySchemasForNextDataRecord);
            var editScript2 = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas2, propertySchemasForNextDataRecord);
            return Caml.caml_int_compare(editScript1.length, editScript2.length);
        }), 0);
        var param1 = "Expect to get at least 1 arrangement of propertySchemas";
        return OptionUtils$SmartcutsMacros.getExn(param1, arg$1);
    });
    return {
        friendlyName: undefined,
        properties: propertySchemas1
    };
}
function dataSchema_encode(v) {
    return Js_dict.fromArray([
        [
            "dataNodeId",
            DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
        ],
        [
            "htmlTagPathIdentifier",
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
        ],
        [
            "tagPath",
            Decco.arrayToJson(Decco.stringToJson, v.tagPath)
        ],
        [
            "schema",
            Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.value_encode, dataSchema_encode, v.schema)
        ]
    ]);
}
function dataSchema_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
    if (dataNodeId.TAG === /* Ok */ 0) {
        var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
        if (htmlTagPathIdentifier.TAG === /* Ok */ 0) {
            var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
            if (tagPath.TAG === /* Ok */ 0) {
                var schema = Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.value_decode, dataSchema_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "schema"), null));
                if (schema.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            dataNodeId: dataNodeId._0,
                            htmlTagPathIdentifier: htmlTagPathIdentifier._0,
                            tagPath: tagPath._0,
                            schema: schema._0
                        }
                    };
                }
                var e = schema._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".schema" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = tagPath._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".tagPath" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = htmlTagPathIdentifier._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".htmlTagPathIdentifier" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = dataNodeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataNodeId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function propertySchema_encode(v) {
    return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_encode, dataSchema_encode, v);
}
function propertySchema_decode(v) {
    return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_decode, dataSchema_decode, v);
}
function t_encode$2(v) {
    return t_encode$1(dataSchema_encode, v);
}
function t_decode$2(v) {
    return t_decode$1(dataSchema_decode, v);
}
function valueFromDataSchema(dataSchema) {
    return dataSchema.schema;
}
function fromSchemaWithHtmlTagPathIdentifier(htmlTagPathByHtmlTagPathIdentifier, param2) {
    var makeId = SerialId$SmartcutsMacros.makeIdGenerator(undefined);
    var hoistDataSchema = Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.map, function(param3, f) {
        var htmlTagPathIdentifier = param3.htmlTagPathIdentifier;
        var arg = Belt_Map.get(htmlTagPathByHtmlTagPathIdentifier, htmlTagPathIdentifier);
        var match = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect to find tagPath by htmlTagPathIdentifier");
        return {
            dataNodeId: Curry._1(makeId, undefined),
            htmlTagPathIdentifier: htmlTagPathIdentifier,
            tagPath: match.tags,
            schema: Curry._1(f, param3.schema)
        };
    });
    return {
        friendlyName: param2.friendlyName,
        properties: Belt_Array.map(param2.properties, function(param) {
            return {
                friendlyName: param.friendlyName,
                dataSchema: Curry._1(hoistDataSchema, param.dataSchema)
            };
        })
    };
}
var WithHTPIAndTagPathAndDataNodeId = {
    dataSchema_encode: dataSchema_encode,
    dataSchema_decode: dataSchema_decode,
    propertySchema_encode: propertySchema_encode,
    propertySchema_decode: propertySchema_decode,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    valueFromDataSchema: valueFromDataSchema,
    fromSchemaWithHtmlTagPathIdentifier: fromSchemaWithHtmlTagPathIdentifier
};
function t_encode$3(encoder_htmlElement, encoder_textNode, v) {
    return t_encode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomElementOrTextNode.t_encode, encoder_htmlElement, encoder_textNode), v);
}
function t_decode$3(decoder_htmlElement, decoder_textNode, v) {
    return t_decode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomElementOrTextNode.t_decode, decoder_htmlElement, decoder_textNode), v);
}
function forHtmlElements(htmlElements) {
    var dataNodesFromChildElements = function dataNodesFromChildElements(htmlElement) {
        if (htmlElements.indexOf(htmlElement) === -1) {
            return [];
        }
        var childNodes = Array.prototype.slice.call(htmlElement.childNodes);
        if (Belt_Array.some(childNodes, function(childNode) {
            return Webapi__Dom__Node.nodeType(childNode) === /* Element */ 0;
        })) {
            return Belt_Array.concatMany(Belt_Array.map(childNodes, function(childNode) {
                var match = Webapi__Dom__Node.nodeType(childNode);
                if (match >= 3) {
                    return [];
                }
                switch(match){
                    case /* Element */ 0:
                        var arg = Curry._1(Webapi__Dom__HtmlElement.ofNode, childNode);
                        return dataNodesForSubtree(function(param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg);
                        }("Expect htmlElement when nodeType is Element"));
                    case /* Attribute */ 1:
                        return [];
                    case /* Text */ 2:
                        var arg$1 = Webapi__Dom__Text.ofNode(childNode);
                        var textNode = function(param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                        }("Expect text node when nodeType is Text");
                        return OptionUtils$SmartcutsMacros.toArray(Belt_Option.flatMap(OptionUtils$SmartcutsMacros.optionalString(textNode.data), function(textValue) {
                            if (DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
                                return {
                                    domElementOrTextNode: {
                                        TAG: /* TextNode */ 1,
                                        _0: textNode
                                    },
                                    value: {
                                        TAG: /* PlainText */ 0,
                                        _0: textValue
                                    }
                                };
                            }
                        }));
                }
            }));
        }
        if (DOM__HtmlElement$SmartcutsMacros.isNotVisibleOnPage(htmlElement)) {
            return [];
        }
        var match2 = htmlElement.tagName.toLowerCase();
        switch(match2){
            case "img":
            case "svg":
                return [];
            default:
                return [
                    {
                        domElementOrTextNode: {
                            TAG: /* HtmlElement */ 0,
                            _0: htmlElement
                        },
                        value: {
                            TAG: /* PlainText */ 0,
                            _0: htmlElement.innerText.trim()
                        }
                    }
                ];
        }
    };
    var dataNodesForSubtree = function dataNodesForSubtree(htmlElement) {
        var match = htmlElement.tagName.toLowerCase();
        switch(match){
            case "a":
                if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
                    return dataNodesFromChildElements(htmlElement);
                }
                var innerText = htmlElement.innerText.trim();
                var innerContent = dataNodesFromChildElements(htmlElement);
                var url1 = Belt_Option.map(DOM$SmartcutsMacros.HtmlAnchorElement.ofElement(htmlElement), function(htmlAnchorElement) {
                    return htmlAnchorElement.href.trim();
                });
                var maybeHref = url1 !== undefined && url1 !== "" ? url1 : undefined;
                if (Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.EdgeCases.AnchorContainingManyProperties.areEnoughChildPropertiesToSurfaceOutOfAnchorNode, innerContent)) {
                    return $$Array.append([
                        {
                            domElementOrTextNode: {
                                TAG: /* HtmlElement */ 0,
                                _0: htmlElement
                            },
                            value: Belt_Option.getWithDefault(Belt_Option.map(maybeHref, function(url) {
                                return {
                                    TAG: /* LinkContainingManyProperties */ 3,
                                    _0: url
                                };
                            }), {
                                TAG: /* Button */ 5,
                                _0: {
                                    maybeHref: undefined,
                                    innerText: innerText,
                                    innerContent: innerContent
                                }
                            })
                        }
                    ], innerContent);
                } else {
                    return [
                        {
                            domElementOrTextNode: {
                                TAG: /* HtmlElement */ 0,
                                _0: htmlElement
                            },
                            value: Belt_Option.getWithDefault(Belt_Option.map(maybeHref, function(url) {
                                return {
                                    TAG: /* Link */ 2,
                                    _0: {
                                        url: url,
                                        innerText: innerText,
                                        innerContent: innerContent
                                    }
                                };
                            }), {
                                TAG: /* Button */ 5,
                                _0: {
                                    maybeHref: undefined,
                                    innerText: innerText,
                                    innerContent: innerContent
                                }
                            })
                        }
                    ];
                }
            case "button":
                if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
                    return dataNodesFromChildElements(htmlElement);
                }
                var innerText$1 = htmlElement.innerText.trim();
                var maybeHref$1 = htmlElement.getAttribute("href");
                return [
                    {
                        domElementOrTextNode: {
                            TAG: /* HtmlElement */ 0,
                            _0: htmlElement
                        },
                        value: {
                            TAG: /* Button */ 5,
                            _0: {
                                maybeHref: maybeHref$1 == null ? undefined : Caml_option.some(maybeHref$1),
                                innerText: innerText$1,
                                innerContent: dataNodesFromChildElements(htmlElement)
                            }
                        }
                    }
                ];
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                break;
            case "img":
                if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
                    return dataNodesFromChildElements(htmlElement);
                }
                var altText1 = Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.getAttribute("alt")), function(text) {
                    var altText = text.trim();
                    if (altText === "") {
                        return;
                    } else {
                        return altText;
                    }
                });
                var arg = htmlElement.getAttribute("src");
                var arg$1 = arg == null ? undefined : Caml_option.some(arg);
                var src = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                }("Expect to get img.src");
                return [
                    {
                        domElementOrTextNode: {
                            TAG: /* HtmlElement */ 0,
                            _0: htmlElement
                        },
                        value: {
                            TAG: /* Image */ 1,
                            _0: {
                                src: src,
                                altText: altText1,
                                sources: []
                            }
                        }
                    }
                ];
            case "svg":
                return [];
            default:
                return dataNodesFromChildElements(htmlElement);
        }
        if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return dataNodesFromChildElements(htmlElement);
        }
        var innerText$2 = htmlElement.innerText.trim();
        return [
            {
                domElementOrTextNode: {
                    TAG: /* HtmlElement */ 0,
                    _0: htmlElement
                },
                value: {
                    TAG: /* Headline */ 4,
                    _0: {
                        hLevel: match,
                        innerText: innerText$2,
                        innerContent: dataNodesFromChildElements(htmlElement)
                    }
                }
            }
        ];
    };
    var match1 = Belt_Array.reduce(htmlElements, [
        undefined,
        []
    ], function(lastResult, htmlElement) {
        var maybeCurrentRootElement = lastResult[0];
        if (maybeCurrentRootElement !== undefined && Caml_option.valFromOption(maybeCurrentRootElement).contains(htmlElement)) {
            return lastResult;
        }
        var dataNodes = dataNodesForSubtree(htmlElement);
        return [
            Caml_option.some(htmlElement),
            Belt_Array.concat(lastResult[1], dataNodes)
        ];
    });
    return {
        friendlyName: undefined,
        properties: Belt_Array.map(match1[1], function(dataNode) {
            return {
                friendlyName: undefined,
                dataNode: dataNode
            };
        })
    };
}
function mapHtmlElement(mapHtmlElement$11, param4) {
    return {
        friendlyName: param4.friendlyName,
        properties: Belt_Array.map(param4.properties, function(property) {
            return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, function(dataNode) {
                var func = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.map;
                return Curry._2(func, function(param, f) {
                    return {
                        domElementOrTextNode: DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.mapHtmlElement(param.domElementOrTextNode, mapHtmlElement$11),
                        value: Curry._1(f, param.value)
                    };
                }, dataNode);
            });
        })
    };
}
var WithDomElementOrTextNode = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    forHtmlElements: forHtmlElements,
    mapHtmlElement: mapHtmlElement
};
function fromDataRecordWithDomElementOrTextNode(param5) {
    return {
        friendlyName: param5.friendlyName,
        properties: Belt_Array.map(param5.properties, function(param) {
            var match = param.dataNode;
            return {
                friendlyName: param.friendlyName,
                dataNode: {
                    domEntities: [
                        match.domElementOrTextNode
                    ],
                    value: Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.mapValue, match.value, DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomEntities.fromDataNodeWithDomElementOrTextNode)
                }
            };
        })
    };
}
function collapseSiblingPropertiesOfSameTypeAsArray(dataRecord) {
    return {
        friendlyName: dataRecord.friendlyName,
        properties: ArrayUtils$SmartcutsMacros.collapsePairs(function(property1, property2, _remaining) {
            var match = property1.dataNode;
            var value1 = match.value;
            var match$1 = property2.dataNode;
            var value2 = match$1.value;
            var domEntities2 = match$1.domEntities;
            switch(value1.TAG | 0){
                case /* PlainText */ 0:
                    if (value2.TAG !== /* PlainText */ 0) {
                        return /* KeepBoth */ 0;
                    }
                    break;
                case /* Image */ 1:
                    if (value2.TAG !== /* Image */ 1) {
                        return /* KeepBoth */ 0;
                    }
                    break;
                case /* Link */ 2:
                    if (value2.TAG !== /* Link */ 2) {
                        return /* KeepBoth */ 0;
                    }
                    break;
                case /* LinkContainingManyProperties */ 3:
                    return /* KeepBoth */ 0;
                case /* Headline */ 4:
                    if (value2.TAG !== /* Headline */ 4) {
                        return /* KeepBoth */ 0;
                    }
                    break;
                case /* Button */ 5:
                    if (value2.TAG !== /* Button */ 5) {
                        return /* KeepBoth */ 0;
                    }
                    break;
                case /* Array */ 6:
                    switch(value1._0.TAG | 0){
                        case /* PlainTexts */ 0:
                            if (value2.TAG !== /* PlainText */ 0) {
                                return /* KeepBoth */ 0;
                            }
                            break;
                        case /* Images */ 1:
                            if (value2.TAG !== /* Image */ 1) {
                                return /* KeepBoth */ 0;
                            }
                            break;
                        case /* Links */ 2:
                            if (value2.TAG !== /* Link */ 2) {
                                return /* KeepBoth */ 0;
                            }
                            break;
                        case /* Headlines */ 3:
                            if (value2.TAG !== /* Headline */ 4) {
                                return /* KeepBoth */ 0;
                            }
                            break;
                        case /* Buttons */ 4:
                            if (value2.TAG !== /* Button */ 5) {
                                return /* KeepBoth */ 0;
                            }
                            break;
                        case /* Records */ 5:
                            return /* KeepBoth */ 0;
                    }
                    break;
            }
            var arg = Belt_Option.map(Belt_Array.get(domEntities2, 0), function(domElementOrTextNode) {
                return Belt_Array.some(property1.dataNode.domEntities, function(param) {
                    return DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isSiblingOf(domElementOrTextNode, param);
                });
            });
            if (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }(false)) {
                return {
                    TAG: /* ReplaceWith */ 0,
                    _0: {
                        friendlyName: property1.friendlyName,
                        dataNode: {
                            domEntities: Belt_Array.concat(match.domEntities, domEntities2),
                            value: Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.combineValues, value1, value2)
                        }
                    }
                };
            } else {
                return /* KeepBoth */ 0;
            }
        }, dataRecord.properties)
    };
}
function predicate_arePropertiesStrictlyAdjacentTextNodesAndEmElements(propertiesUnderHtmlParent) {
    var allDomEntitiesUnderParent = Belt_Array.concatMany(Belt_Array.map(propertiesUnderHtmlParent, function(param) {
        return param.dataNode.domEntities;
    }));
    return Belt_Array.every(allDomEntitiesUnderParent, function(domEntity) {
        if (DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isTextNode(domEntity)) {
            return true;
        } else {
            return DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isHtmlElementSatisfying(domEntity, function(htmlElement) {
                return htmlElement.tagName === "EM";
            });
        }
    });
}
function replacementPropertiesFactory_forStrictlyAdjacentTextNodesAndEmElements(htmlParentForDomEntities, _properties) {
    return [
        {
            friendlyName: undefined,
            dataNode: {
                domEntities: [
                    {
                        TAG: /* HtmlElement */ 0,
                        _0: htmlParentForDomEntities
                    }
                ],
                value: {
                    TAG: /* PlainText */ 0,
                    _0: htmlParentForDomEntities.innerText.trim()
                }
            }
        }
    ];
}
var defaultStrategiesForTreatingPropertiesWithSharedParentHtmlElement = [
    [
        predicate_arePropertiesStrictlyAdjacentTextNodesAndEmElements,
        replacementPropertiesFactory_forStrictlyAdjacentTextNodesAndEmElements
    ]
];
function determineHowToTreatPropertiesWithSharedParentHtmlElement(htmlParentForDomEntities, propertiesUnderHtmlParent) {
    return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(defaultStrategiesForTreatingPropertiesWithSharedParentHtmlElement, function(param) {
        return Curry._1(param[0], propertiesUnderHtmlParent);
    }), function(param) {
        return Curry._2(param[1], htmlParentForDomEntities, propertiesUnderHtmlParent);
    }), propertiesUnderHtmlParent);
}
function maybeCombinePropertiesThatShareParentHtmlElement(dataRecord) {
    var match = Belt_Array.reduce(dataRecord.properties, [
        [],
        undefined
    ], function(param, property) {
        var maybeRecordsByCommonParent = param[1];
        var collapsedProperties = param[0];
        var parentHtmlElement = Belt_Option.getExn(DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.parentElement(Belt_Array.getExn(property.dataNode.domEntities, 0)));
        if (maybeRecordsByCommonParent === undefined) {
            return [
                collapsedProperties,
                [
                    parentHtmlElement,
                    [
                        property
                    ]
                ]
            ];
        }
        var propertiesUnderHtmlParent = maybeRecordsByCommonParent[1];
        var htmlParentForDomEntities = maybeRecordsByCommonParent[0];
        if (parentHtmlElement === htmlParentForDomEntities) {
            return [
                collapsedProperties,
                [
                    parentHtmlElement,
                    $$Array.append(propertiesUnderHtmlParent, [
                        property
                    ])
                ]
            ];
        } else {
            return [
                $$Array.append(collapsedProperties, determineHowToTreatPropertiesWithSharedParentHtmlElement(htmlParentForDomEntities, propertiesUnderHtmlParent)),
                [
                    parentHtmlElement,
                    [
                        property
                    ]
                ]
            ];
        }
    });
    var collapsedPropertiesThusFar = match[0];
    var newProperties = Belt_Option.getWithDefault(Belt_Option.map(match[1], function(param) {
        return $$Array.append(collapsedPropertiesThusFar, determineHowToTreatPropertiesWithSharedParentHtmlElement(param[0], param[1]));
    }), collapsedPropertiesThusFar);
    return {
        friendlyName: dataRecord.friendlyName,
        properties: newProperties
    };
}
var WithDomEntities = {
    fromDataRecordWithDomElementOrTextNode: fromDataRecordWithDomElementOrTextNode,
    collapseSiblingPropertiesOfSameTypeAsArray: collapseSiblingPropertiesOfSameTypeAsArray,
    maybeCombinePropertiesThatShareParentHtmlElement: maybeCombinePropertiesThatShareParentHtmlElement
};
function fromWithDomEntities(lookupTable, param6) {
    return {
        friendlyName: param6.friendlyName,
        properties: Belt_Array.map(param6.properties, function(property) {
            var func = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPI.fromDataNodeWithDomEntities;
            return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, function(param) {
                return Curry._2(func, param, lookupTable);
            });
        })
    };
}
function mapHtmlTagPathIdentifier(mapHtmlTagPathIdentifier$1, param) {
    return {
        friendlyName: param.friendlyName,
        properties: Belt_Array.map(param.properties, function(property) {
            return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, function(dataNode) {
                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPI.mapHtmlTagPathIdentifier, dataNode, mapHtmlTagPathIdentifier$1);
            });
        })
    };
}
var WithHtmlElementAndHTPI = {
    fromWithDomEntities: fromWithDomEntities,
    mapHtmlTagPathIdentifier: mapHtmlTagPathIdentifier
};
function t_encode$4(encoder_htmlElement, encoder_textNode, v) {
    return t_encode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode, encoder_htmlElement, encoder_textNode), v);
}
function t_decode$4(decoder_htmlElement, decoder_textNode, v) {
    return t_decode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode, decoder_htmlElement, decoder_textNode), v);
}
function makeDataNode(param7, param$1) {
    var hoistValue = function hoistValue(schema, value) {
        if (typeof schema === "number") {
            switch(schema){
                case /* PlainText */ 0:
                    if (value.TAG === /* PlainText */ 0) {
                        return {
                            TAG: /* PlainText */ 0,
                            _0: value._0
                        };
                    }
                    break;
                case /* Image */ 1:
                    if (value.TAG === /* Image */ 1) {
                        return {
                            TAG: /* Image */ 1,
                            _0: value._0
                        };
                    }
                    break;
                case /* LinkContainingManyProperties */ 2:
                    if (value.TAG === /* LinkContainingManyProperties */ 3) {
                        return {
                            TAG: /* LinkContainingManyProperties */ 3,
                            _0: value._0
                        };
                    }
                    break;
            }
        } else {
            switch(schema.TAG | 0){
                case /* Link */ 0:
                    if (value.TAG === /* Link */ 2) {
                        var linkNode = value._0;
                        return {
                            TAG: /* Link */ 2,
                            _0: {
                                url: linkNode.url,
                                innerText: linkNode.innerText,
                                innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, linkNode.innerContent), function(param) {
                                    return makeDataNode(param[0], param[1]);
                                })
                            }
                        };
                    }
                    break;
                case /* Headline */ 1:
                    if (value.TAG === /* Headline */ 4) {
                        var headlineNode = value._0;
                        return {
                            TAG: /* Headline */ 4,
                            _0: {
                                hLevel: headlineNode.hLevel,
                                innerText: headlineNode.innerText,
                                innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, headlineNode.innerContent), function(param) {
                                    return makeDataNode(param[0], param[1]);
                                })
                            }
                        };
                    }
                    break;
                case /* Button */ 2:
                    if (value.TAG === /* Button */ 5) {
                        var buttonNode = value._0;
                        return {
                            TAG: /* Button */ 5,
                            _0: {
                                maybeHref: buttonNode.maybeHref,
                                innerText: buttonNode.innerText,
                                innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, buttonNode.innerContent), function(param) {
                                    return makeDataNode(param[0], param[1]);
                                })
                            }
                        };
                    }
                    break;
                case /* Array */ 3:
                    var match = schema._0;
                    if (typeof match === "number") {
                        if (match === /* PlainTexts */ 0) {
                            if (value.TAG === /* Array */ 6) {
                                var texts = value._0;
                                if (texts.TAG === /* PlainTexts */ 0) {
                                    return {
                                        TAG: /* Array */ 6,
                                        _0: {
                                            TAG: /* PlainTexts */ 0,
                                            _0: texts._0
                                        }
                                    };
                                }
                            }
                        } else if (value.TAG === /* Array */ 6) {
                            var images = value._0;
                            if (images.TAG === /* Images */ 1) {
                                return {
                                    TAG: /* Array */ 6,
                                    _0: {
                                        TAG: /* Images */ 1,
                                        _0: images._0
                                    }
                                };
                            }
                        }
                    } else {
                        switch(match.TAG | 0){
                            case /* Links */ 0:
                                var innerSchema = match._0.innerContent;
                                if (value.TAG === /* Array */ 6) {
                                    var linkNodes = value._0;
                                    if (linkNodes.TAG === /* Links */ 2) {
                                        return {
                                            TAG: /* Array */ 6,
                                            _0: {
                                                TAG: /* Links */ 2,
                                                _0: Belt_Array.map(linkNodes._0, function(linkNode) {
                                                    return {
                                                        url: linkNode.url,
                                                        innerText: linkNode.innerText,
                                                        innerContent: Belt_Array.map(Belt_Array.zip(innerSchema, linkNode.innerContent), function(param) {
                                                            return makeDataNode(param[0], param[1]);
                                                        })
                                                    };
                                                })
                                            }
                                        };
                                    }
                                }
                                break;
                            case /* Headlines */ 1:
                                var innerSchema$1 = match._0.innerContent;
                                if (value.TAG === /* Array */ 6) {
                                    var headlineNodes = value._0;
                                    if (headlineNodes.TAG === /* Headlines */ 3) {
                                        return {
                                            TAG: /* Array */ 6,
                                            _0: {
                                                TAG: /* Headlines */ 3,
                                                _0: Belt_Array.map(headlineNodes._0, function(headlineNode) {
                                                    return {
                                                        hLevel: headlineNode.hLevel,
                                                        innerText: headlineNode.innerText,
                                                        innerContent: Belt_Array.map(Belt_Array.zip(innerSchema$1, headlineNode.innerContent), function(param) {
                                                            return makeDataNode(param[0], param[1]);
                                                        })
                                                    };
                                                })
                                            }
                                        };
                                    }
                                }
                                break;
                            case /* Buttons */ 2:
                                var innerSchema$2 = match._0.innerContent;
                                if (value.TAG === /* Array */ 6) {
                                    var buttonNodes = value._0;
                                    if (buttonNodes.TAG === /* Buttons */ 4) {
                                        return {
                                            TAG: /* Array */ 6,
                                            _0: {
                                                TAG: /* Buttons */ 4,
                                                _0: Belt_Array.map(buttonNodes._0, function(buttonNode) {
                                                    return {
                                                        maybeHref: buttonNode.maybeHref,
                                                        innerText: buttonNode.innerText,
                                                        innerContent: Belt_Array.map(Belt_Array.zip(innerSchema$2, buttonNode.innerContent), function(param) {
                                                            return makeDataNode(param[0], param[1]);
                                                        })
                                                    };
                                                })
                                            }
                                        };
                                    }
                                }
                                break;
                            case /* Records */ 3:
                                var propertySchemas = match._0.properties;
                                if (value.TAG === /* Array */ 6) {
                                    var records = value._0;
                                    if (records.TAG === /* Records */ 5) {
                                        return {
                                            TAG: /* Array */ 6,
                                            _0: {
                                                TAG: /* Records */ 5,
                                                _0: Belt_Array.map(records._0, function(record) {
                                                    return {
                                                        friendlyName: record.friendlyName,
                                                        properties: Belt_Array.map(Belt_Array.zip(propertySchemas, record.properties), function(param) {
                                                            var property = param[1];
                                                            return {
                                                                friendlyName: property.friendlyName,
                                                                dataNode: makeDataNode(param[0].dataSchema, property.dataNode)
                                                            };
                                                        })
                                                    };
                                                })
                                            }
                                        };
                                    }
                                }
                                break;
                        }
                    }
                    break;
            }
        }
        console.warn("schema", schema);
        console.warn("value", value);
        return Util$SmartcutsMacros.logAndRaiseJsError("Expect matching schema and value");
    };
    return {
        dataNodeId: param7.dataNodeId,
        htmlTagPathIdentifier: param7.htmlTagPathIdentifier,
        domEntities: param$1.domEntities,
        tagPath: param7.tagPath,
        value: hoistValue(param7.schema, param$1.value)
    };
}
function fromDataRecordWithHtmlElementAndHTPI(schema, param8) {
    return {
        friendlyName: param8.friendlyName,
        properties: Belt_Array.reduce(param8.properties, [
            schema.properties,
            []
        ], function(param9, param$1) {
            var dataNode1 = param$1.dataNode;
            var properties = param9[1];
            var propertySchemas = param9[0];
            var match = ArrayUtils$SmartcutsMacros.firstMatchi(function(param) {
                var dataSchema = param.dataSchema;
                if (Caml_obj.caml_equal(dataSchema.htmlTagPathIdentifier, dataNode1.htmlTagPathIdentifier)) {
                    if (isDataNodeSchemaValueALinkWithManyProperties(dataSchema.schema)) {
                        return true;
                    } else {
                        return Curry._6(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.doesMatchDataNode, dataSchema, valueFromDataSchema, function(dataNode) {
                            return dataNode.value;
                        }, undefined, undefined, dataNode1);
                    }
                } else {
                    return false;
                }
            }, propertySchemas);
            if (match === undefined) {
                return [
                    propertySchemas,
                    properties
                ];
            }
            var property_friendlyName = param$1.friendlyName;
            var property_dataNode = makeDataNode(match[0].dataSchema, dataNode1);
            var property = {
                friendlyName: property_friendlyName,
                dataNode: property_dataNode
            };
            return [
                Belt_Array.sliceToEnd(propertySchemas, match[1] + 1 | 0),
                Belt_Array.concat(properties, [
                    property
                ])
            ];
        })[1]
    };
}
function getDataNodesById(dataNodeId, param10) {
    return Belt_Array.keep(ArrayUtils$SmartcutsMacros.flatMap(function(param11) {
        return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.allNodes, param11.dataNode, function(param) {
            return param.value;
        });
    }, param10.properties), function(dataNode) {
        return dataNode.dataNodeId === dataNodeId;
    });
}
function mapHtmlElement$1(mapHtmlElement$2, param) {
    return {
        friendlyName: param.friendlyName,
        properties: Belt_Array.map(param.properties, function(property) {
            return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, function(dataNode) {
                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.mapHtmlElement, dataNode, mapHtmlElement$2);
            });
        })
    };
}
function mapTextNode(param, f) {
    return {
        friendlyName: param.friendlyName,
        properties: Belt_Array.map(param.properties, function(property) {
            return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, function(dataNode) {
                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.mapTextNode, dataNode, f);
            });
        })
    };
}
var WithHtmlElementAndHTPIAndTagPathAndDataNodeId = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    makeDataNode: makeDataNode,
    fromDataRecordWithHtmlElementAndHTPI: fromDataRecordWithHtmlElementAndHTPI,
    getDataNodesById: getDataNodesById,
    mapHtmlElement: mapHtmlElement$1,
    mapTextNode: mapTextNode
};
var EdgeCases2 = {
    AnchorContainingManyProperties: {
        isLinkSchemaWithManyProperties: isLinkSchemaWithManyProperties,
        areBothEditGraphValuesSatisfyBeingLinksWithManyProperties: areBothEditGraphValuesSatisfyBeingLinksWithManyProperties
    }
};
var Schema_WithHtmlTagPathIdentifier = {
    valueFromDataNode: valueFromDataNode,
    makeDataSchema: makeDataSchema,
    forDataRecords: forDataRecords
};
var Schema = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    WithHtmlTagPathIdentifier: Schema_WithHtmlTagPathIdentifier,
    WithHTPIAndTagPathAndDataNodeId: WithHTPIAndTagPathAndDataNodeId
};
exports.EdgeCases2 = EdgeCases2;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.Schema = Schema;
exports.WithDomElementOrTextNode = WithDomElementOrTextNode;
exports.WithDomEntities = WithDomEntities;
exports.WithHtmlElementAndHTPI = WithHtmlElementAndHTPI;
exports.WithHtmlElementAndHTPIAndTagPathAndDataNodeId = WithHtmlElementAndHTPIAndTagPathAndDataNodeId; /* PropertyEditGraph Not a pure module */ 


/***/ }),

/***/ 48828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_module = __webpack_require__(27236);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
function areEnoughChildPropertiesToSurfaceOutOfAnchorNode(innerContent) {
    return innerContent.length > 5;
}
var AnchorContainingManyProperties = {
    manyThresholdCount: 5,
    areEnoughChildPropertiesToSurfaceOutOfAnchorNode: areEnoughChildPropertiesToSurfaceOutOfAnchorNode
};
var EdgeCases = {
    AnchorContainingManyProperties: AnchorContainingManyProperties
};
var RecordPropertySchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    50,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromProperty"
        ],
        [
            /* Function */ 0,
            "doesMatchProperty"
        ]
    ]
});
var DataNodeSchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    151,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "value_encode"
        ],
        [
            /* Function */ 0,
            "value_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ],
        [
            /* Function */ 0,
            "fromDataNode"
        ],
        [
            /* Function */ 0,
            "doesMatchDataNode"
        ],
        [
            /* Function */ 0,
            "doesContainSameValue"
        ],
        [
            /* Function */ 0,
            "allNodesWithPath"
        ]
    ]
});
var LinkSchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    469,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromLinkNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var HeadlineSchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    511,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromHeadlineNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var ButtonSchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    555,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromButtonNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var ArraySchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    608,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromArrayNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var RecordSchema = Caml_module.init_mod([
    "DataExtraction__DataRecord__Schema__Types.re",
    696,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromRecord"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
function t_encode(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "dataSchema",
            Curry._1(encoder_dataSchema, v.dataSchema)
        ]
    ]);
}
function t_decode(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var dataSchema = Curry._1(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSchema"), null));
        if (dataSchema.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    dataSchema: dataSchema._0
                }
            };
        }
        var e = dataSchema._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataSchema" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromProperty(valueFromDataNode, makeDataSchema, param) {
    var func = Curry._1(DataNodeSchema.fromDataNode, valueFromDataNode);
    return {
        friendlyName: param.friendlyName,
        dataSchema: Curry._2(func, makeDataSchema, param.dataNode)
    };
}
function doesMatchProperty(param, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param$1) {
    return Curry._6(DataNodeSchema.doesMatchDataNode, param.dataSchema, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param$1.dataNode);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromProperty"
        ],
        [
            /* Function */ 0,
            "doesMatchProperty"
        ]
    ]
}, RecordPropertySchema, {
    t_encode: t_encode,
    t_decode: t_decode,
    fromProperty: fromProperty,
    doesMatchProperty: doesMatchProperty
});
function value_encode(encoder_dataSchema, v) {
    if (typeof v === "number") {
        switch(v){
            case /* PlainText */ 0:
                return [
                    "PlainText"
                ];
            case /* Image */ 1:
                return [
                    "Image"
                ];
            case /* LinkContainingManyProperties */ 2:
                return [
                    "LinkContainingManyProperties"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* Link */ 0:
                return [
                    "Link",
                    Curry._2(LinkSchema.t_encode, encoder_dataSchema, v._0)
                ];
            case /* Headline */ 1:
                return [
                    "Headline",
                    Curry._2(HeadlineSchema.t_encode, encoder_dataSchema, v._0)
                ];
            case /* Button */ 2:
                return [
                    "Button",
                    Curry._2(ButtonSchema.t_encode, encoder_dataSchema, v._0)
                ];
            case /* Array */ 3:
                return [
                    "Array",
                    Curry._2(ArraySchema.t_encode, encoder_dataSchema, v._0)
                ];
        }
    }
}
function value_decode(decoder_dataSchema, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Array":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._2(ArraySchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Array */ 3,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Button":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._2(ButtonSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Button */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Headline":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._2(HeadlineSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Headline */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Image":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Image */ 1
                    };
                }
            case "Link":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._2(LinkSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Link */ 0,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "LinkContainingManyProperties":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* LinkContainingManyProperties */ 2
                    };
                }
            case "PlainText":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PlainText */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map(mapSchema, dataSchema) {
    return Curry._2(mapSchema, dataSchema, function(value) {
        var f = function f(param) {
            return map(mapSchema, param);
        };
        if (typeof value === "number") {
            switch(value){
                case /* PlainText */ 0:
                    return /* PlainText */ 0;
                case /* Image */ 1:
                    return /* Image */ 1;
                case /* LinkContainingManyProperties */ 2:
                    return /* LinkContainingManyProperties */ 2;
            }
        } else {
            switch(value.TAG | 0){
                case /* Link */ 0:
                    return {
                        TAG: /* Link */ 0,
                        _0: Curry._2(LinkSchema.map, f, value._0)
                    };
                case /* Headline */ 1:
                    return {
                        TAG: /* Headline */ 1,
                        _0: Curry._2(HeadlineSchema.map, f, value._0)
                    };
                case /* Button */ 2:
                    return {
                        TAG: /* Button */ 2,
                        _0: Curry._2(ButtonSchema.map, f, value._0)
                    };
                case /* Array */ 3:
                    return {
                        TAG: /* Array */ 3,
                        _0: Curry._2(ArraySchema.map, mapSchema, value._0)
                    };
            }
        }
    });
}
function fromDataNode(valueFromDataNode, makeDataSchema, dataNode) {
    var _url = Curry._1(valueFromDataNode, dataNode);
    var tmp;
    switch(_url.TAG | 0){
        case /* PlainText */ 0:
            tmp = /* PlainText */ 0;
            break;
        case /* Image */ 1:
            tmp = /* Image */ 1;
            break;
        case /* Link */ 2:
            var func = Curry._1(LinkSchema.fromLinkNode, valueFromDataNode);
            tmp = {
                TAG: /* Link */ 0,
                _0: Curry._2(func, makeDataSchema, _url._0)
            };
            break;
        case /* LinkContainingManyProperties */ 3:
            tmp = /* LinkContainingManyProperties */ 2;
            break;
        case /* Headline */ 4:
            var func$1 = Curry._1(HeadlineSchema.fromHeadlineNode, valueFromDataNode);
            tmp = {
                TAG: /* Headline */ 1,
                _0: Curry._2(func$1, makeDataSchema, _url._0)
            };
            break;
        case /* Button */ 5:
            var func$2 = Curry._1(ButtonSchema.fromButtonNode, valueFromDataNode);
            tmp = {
                TAG: /* Button */ 2,
                _0: Curry._2(func$2, makeDataSchema, _url._0)
            };
            break;
        case /* Array */ 6:
            var func$3 = Curry._1(ArraySchema.fromArrayNode, valueFromDataNode);
            tmp = {
                TAG: /* Array */ 3,
                _0: Curry._2(func$3, makeDataSchema, _url._0)
            };
            break;
    }
    return Curry._2(makeDataSchema, dataNode, tmp);
}
function doesMatchDataNode(dataSchema, valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, dataNode) {
    var doesMatchDataNodeValue = function(dataSchemaValue, dataNodeValue) {
        var innerSchemas;
        var innerNodes;
        if (typeof dataSchemaValue === "number") {
            switch(dataSchemaValue){
                case /* PlainText */ 0:
                    if (dataNodeValue.TAG === /* PlainText */ 0) {
                        return true;
                    } else {
                        return false;
                    }
                case /* Image */ 1:
                    if (dataNodeValue.TAG === /* Image */ 1) {
                        return true;
                    } else {
                        return false;
                    }
                case /* LinkContainingManyProperties */ 2:
                    if (dataNodeValue.TAG === /* LinkContainingManyProperties */ 3) {
                        return true;
                    } else {
                        return false;
                    }
            }
        } else {
            switch(dataSchemaValue.TAG | 0){
                case /* Link */ 0:
                    if (dataNodeValue.TAG !== /* Link */ 2) {
                        return false;
                    }
                    innerSchemas = dataSchemaValue._0.innerContent;
                    innerNodes = dataNodeValue._0.innerContent;
                    break;
                case /* Headline */ 1:
                    var match = dataSchemaValue._0;
                    var innerSchemas$1 = match.innerContent;
                    if (dataNodeValue.TAG !== /* Headline */ 4) {
                        return false;
                    }
                    var match$1 = dataNodeValue._0;
                    var innerNodes$1 = match$1.innerContent;
                    if (match.hLevel === match$1.hLevel && innerSchemas$1.length === innerNodes$1.length) {
                        return Belt_Array.every(Belt_Array.zip(innerSchemas$1, innerNodes$1), function(param) {
                            return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataNode, param[1]));
                        });
                    } else {
                        return false;
                    }
                case /* Button */ 2:
                    if (dataNodeValue.TAG !== /* Button */ 5) {
                        return false;
                    }
                    innerSchemas = dataSchemaValue._0.innerContent;
                    innerNodes = dataNodeValue._0.innerContent;
                    break;
                case /* Array */ 3:
                    var arraySchema = dataSchemaValue._0;
                    if (dataNodeValue.TAG !== /* Array */ 6) {
                        return false;
                    }
                    var arrayNode = dataNodeValue._0;
                    if (typeof arraySchema === "number") {
                        if (arraySchema === /* PlainTexts */ 0) {
                            if (arrayNode.TAG === /* PlainTexts */ 0) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (arrayNode.TAG === /* Images */ 1) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    switch(arraySchema.TAG | 0){
                        case /* Links */ 0:
                            if (arrayNode.TAG !== /* Links */ 2) {
                                return false;
                            }
                            var dataSchemaValue$1 = {
                                TAG: /* Link */ 0,
                                _0: arraySchema._0
                            };
                            return Belt_Array.every(Belt_Array.map(arrayNode._0, function(linkNode) {
                                return {
                                    TAG: /* Link */ 2,
                                    _0: linkNode
                                };
                            }), function(param) {
                                return doesMatchDataNodeValue(dataSchemaValue$1, param);
                            });
                        case /* Headlines */ 1:
                            if (arrayNode.TAG !== /* Headlines */ 3) {
                                return false;
                            }
                            var dataSchemaValue$2 = {
                                TAG: /* Headline */ 1,
                                _0: arraySchema._0
                            };
                            return Belt_Array.every(Belt_Array.map(arrayNode._0, function(headlineNode) {
                                return {
                                    TAG: /* Headline */ 4,
                                    _0: headlineNode
                                };
                            }), function(param) {
                                return doesMatchDataNodeValue(dataSchemaValue$2, param);
                            });
                        case /* Buttons */ 2:
                            if (arrayNode.TAG !== /* Buttons */ 4) {
                                return false;
                            }
                            var dataSchemaValue$3 = {
                                TAG: /* Button */ 2,
                                _0: arraySchema._0
                            };
                            return Belt_Array.every(Belt_Array.map(arrayNode._0, function(buttonNode) {
                                return {
                                    TAG: /* Button */ 5,
                                    _0: buttonNode
                                };
                            }), function(param) {
                                return doesMatchDataNodeValue(dataSchemaValue$3, param);
                            });
                        case /* Records */ 3:
                            var propertySchemas = arraySchema._0.properties;
                            if (arrayNode.TAG === /* Records */ 5) {
                                return Belt_Array.every(arrayNode._0, function(param1) {
                                    var properties = param1.properties;
                                    if (propertySchemas.length === properties.length) {
                                        return Belt_Array.every(Belt_Array.zip(propertySchemas, properties), function(param) {
                                            return Curry._6(RecordPropertySchema.doesMatchProperty, param[0], valueFromDataSchema, valueFromDataNode, tagPathInfoFromSchema, tagPathInfoFromNode, param[1]);
                                        });
                                    } else {
                                        return false;
                                    }
                                });
                            } else {
                                return false;
                            }
                    }
            }
        }
        if (innerSchemas.length === innerNodes.length) {
            return Belt_Array.every(Belt_Array.zip(innerSchemas, innerNodes), function(param) {
                return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataNode, param[1]));
            });
        } else {
            return false;
        }
    };
    if (tagPathInfoFromSchema !== undefined && tagPathInfoFromNode !== undefined && !Caml_obj.caml_equal(Curry._1(tagPathInfoFromSchema, dataSchema), Curry._1(tagPathInfoFromNode, dataNode))) {
        return false;
    } else {
        return doesMatchDataNodeValue(Curry._1(valueFromDataSchema, dataSchema), Curry._1(valueFromDataNode, dataNode));
    }
}
function doesContainSameValue(dataSchema1, valueFromDataSchema, tagPathInfoFromSchema, dataSchema2) {
    var equalsDataSchemaValue = function(dataSchemaValue1, dataSchemaValue2) {
        var innerContent1;
        var innerContent2;
        if (typeof dataSchemaValue1 === "number") {
            switch(dataSchemaValue1){
                case /* PlainText */ 0:
                    return dataSchemaValue2 === 0;
                case /* Image */ 1:
                    return dataSchemaValue2 === 1;
                case /* LinkContainingManyProperties */ 2:
                    if (typeof dataSchemaValue2 === "number") {
                        return dataSchemaValue2 >= 2;
                    } else {
                        return false;
                    }
            }
        } else {
            switch(dataSchemaValue1.TAG | 0){
                case /* Link */ 0:
                    if (typeof dataSchemaValue2 === "number") {
                        return false;
                    }
                    if (dataSchemaValue2.TAG !== /* Link */ 0) {
                        return false;
                    }
                    innerContent1 = dataSchemaValue1._0.innerContent;
                    innerContent2 = dataSchemaValue2._0.innerContent;
                    break;
                case /* Headline */ 1:
                    var match = dataSchemaValue1._0;
                    var innerContent1$1 = match.innerContent;
                    if (typeof dataSchemaValue2 === "number") {
                        return false;
                    }
                    if (dataSchemaValue2.TAG !== /* Headline */ 1) {
                        return false;
                    }
                    var match$1 = dataSchemaValue2._0;
                    var innerContent2$1 = match$1.innerContent;
                    if (match.hLevel === match$1.hLevel && innerContent1$1.length === innerContent2$1.length) {
                        return Belt_Array.every(Belt_Array.zip(innerContent1$1, innerContent2$1), function(param) {
                            return equalsDataSchemaValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataSchema, param[1]));
                        });
                    } else {
                        return false;
                    }
                case /* Button */ 2:
                    if (typeof dataSchemaValue2 === "number") {
                        return false;
                    }
                    if (dataSchemaValue2.TAG !== /* Button */ 2) {
                        return false;
                    }
                    innerContent1 = dataSchemaValue1._0.innerContent;
                    innerContent2 = dataSchemaValue2._0.innerContent;
                    break;
                case /* Array */ 3:
                    if (typeof dataSchemaValue2 === "number" || dataSchemaValue2.TAG !== /* Array */ 3) {
                        return false;
                    } else {
                        return Caml_obj.caml_equal(dataSchemaValue1._0, dataSchemaValue2._0);
                    }
            }
        }
        if (innerContent1.length === innerContent2.length) {
            return Belt_Array.every(Belt_Array.zip(innerContent1, innerContent2), function(param) {
                return equalsDataSchemaValue(Curry._1(valueFromDataSchema, param[0]), Curry._1(valueFromDataSchema, param[1]));
            });
        } else {
            return false;
        }
    };
    if (tagPathInfoFromSchema !== undefined && !Caml_obj.caml_equal(Curry._1(tagPathInfoFromSchema, dataSchema1), Curry._1(tagPathInfoFromSchema, dataSchema2))) {
        return false;
    } else {
        return equalsDataSchemaValue(Curry._1(valueFromDataSchema, dataSchema1), Curry._1(valueFromDataSchema, dataSchema2));
    }
}
function allNodesWithPath(dataSchema3, valueFromDataSchema) {
    var collectNodesWithPath = function(currentPathOpt, dataSchema) {
        var currentPath = currentPathOpt !== undefined ? currentPathOpt : [];
        var collectNodesFromChildNode = function collectNodesFromChildNode(childNode) {
            return collectNodesWithPath(Belt_Array.concat(currentPath, [
                dataSchema
            ]), childNode);
        };
        var match = Curry._1(valueFromDataSchema, dataSchema);
        var tmp;
        var exit = 0;
        if (typeof match === "number") {
            tmp = [];
        } else {
            switch(match.TAG | 0){
                case /* Headline */ 1:
                    var innerContent = match._0.innerContent;
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent);
                    break;
                case /* Link */ 0:
                case /* Button */ 2:
                    exit = 1;
                    break;
                case /* Array */ 3:
                    var match$1 = match._0;
                    var exit$1 = 0;
                    if (typeof match$1 === "number") {
                        tmp = match$1 === /* PlainTexts */ 0 ? [] : [];
                    } else {
                        switch(match$1.TAG | 0){
                            case /* Headlines */ 1:
                                var innerContent$1 = match$1._0.innerContent;
                                tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$1);
                                break;
                            case /* Links */ 0:
                            case /* Buttons */ 2:
                                exit$1 = 2;
                                break;
                            case /* Records */ 3:
                                tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                                    return collectNodesFromChildNode(param.dataSchema);
                                }, match$1._0.properties);
                                break;
                        }
                    }
                    if (exit$1 === 2) {
                        var innerContent$2 = match$1._0.innerContent;
                        tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$2);
                    }
                    break;
            }
        }
        if (exit === 1) {
            var innerContent$3 = match._0.innerContent;
            tmp = ArrayUtils$SmartcutsMacros.flatMap(collectNodesFromChildNode, innerContent$3);
        }
        return Belt_Array.concat([
            [
                dataSchema,
                currentPath
            ]
        ], tmp);
    };
    return collectNodesWithPath(undefined, dataSchema3);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "value_encode"
        ],
        [
            /* Function */ 0,
            "value_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ],
        [
            /* Function */ 0,
            "fromDataNode"
        ],
        [
            /* Function */ 0,
            "doesMatchDataNode"
        ],
        [
            /* Function */ 0,
            "doesContainSameValue"
        ],
        [
            /* Function */ 0,
            "allNodesWithPath"
        ]
    ]
}, DataNodeSchema, {
    value_encode: value_encode,
    value_decode: value_decode,
    map: map,
    fromDataNode: fromDataNode,
    doesMatchDataNode: doesMatchDataNode,
    doesContainSameValue: doesContainSameValue,
    allNodesWithPath: allNodesWithPath
});
function t_encode$1(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataSchema, v.innerContent)
        ]
    ]);
}
function t_decode$1(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict._0, "innerContent"), null));
    if (innerContent.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                innerContent: innerContent._0
            }
        };
    }
    var e = innerContent._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".innerContent" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function fromLinkNode(valueFromDataNode, makeDataSchema, param) {
    return {
        innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
    };
}
function map$1(f, param) {
    return {
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromLinkNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, LinkSchema, {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromLinkNode: fromLinkNode,
    map: map$1
});
function t_encode$2(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "hLevel",
            Decco.stringToJson(v.hLevel)
        ],
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataSchema, v.innerContent)
        ]
    ]);
}
function t_decode$2(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hLevel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hLevel"), null));
    if (hLevel.TAG === /* Ok */ 0) {
        var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
        if (innerContent.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    hLevel: hLevel._0,
                    innerContent: innerContent._0
                }
            };
        }
        var e = innerContent._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".innerContent" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = hLevel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hLevel" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromHeadlineNode(valueFromDataNode, makeDataSchema, param) {
    return {
        hLevel: param.hLevel,
        innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
    };
}
function map$2(f, param) {
    return {
        hLevel: param.hLevel,
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromHeadlineNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, HeadlineSchema, {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromHeadlineNode: fromHeadlineNode,
    map: map$2
});
function t_encode$3(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataSchema, v.innerContent)
        ]
    ]);
}
function t_decode$3(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var innerContent = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict._0, "innerContent"), null));
    if (innerContent.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                innerContent: innerContent._0
            }
        };
    }
    var e = innerContent._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".innerContent" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function fromButtonNode(valueFromDataNode, makeDataSchema, param) {
    return {
        innerContent: Belt_Array.map(param.innerContent, Curry._2(DataNodeSchema.fromDataNode, valueFromDataNode, makeDataSchema))
    };
}
function map$3(f, param) {
    return {
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromButtonNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, ButtonSchema, {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromButtonNode: fromButtonNode,
    map: map$3
});
function t_encode$4(encoder_dataSchema, v) {
    if (typeof v === "number") {
        if (v === /* PlainTexts */ 0) {
            return [
                "PlainTexts"
            ];
        } else {
            return [
                "Images"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* Links */ 0:
            return [
                "Links",
                Curry._2(LinkSchema.t_encode, encoder_dataSchema, v._0)
            ];
        case /* Headlines */ 1:
            return [
                "Headlines",
                Curry._2(HeadlineSchema.t_encode, encoder_dataSchema, v._0)
            ];
        case /* Buttons */ 2:
            return [
                "Buttons",
                Curry._2(ButtonSchema.t_encode, encoder_dataSchema, v._0)
            ];
        case /* Records */ 3:
            return [
                "Records",
                Curry._2(RecordSchema.t_encode, encoder_dataSchema, v._0)
            ];
    }
}
function t_decode$4(decoder_dataSchema, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Buttons":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._2(ButtonSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Buttons */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Headlines":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._2(HeadlineSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Headlines */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Images":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Images */ 1
                    };
                }
            case "Links":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._2(LinkSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Links */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "PlainTexts":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PlainTexts */ 0
                    };
                }
            case "Records":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._2(RecordSchema.t_decode, decoder_dataSchema, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Records */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromArrayNode(valueFromDataNode, makeDataSchema, arrayNode) {
    switch(arrayNode.TAG | 0){
        case /* PlainTexts */ 0:
            return /* PlainTexts */ 0;
        case /* Images */ 1:
            return /* Images */ 1;
        case /* Links */ 2:
            var func = LinkSchema.fromLinkNode;
            var arg = Caml_array.get(arrayNode._0, 0);
            return {
                TAG: /* Links */ 0,
                _0: (function(param2) {
                    var func$1 = Curry._1(func, param2);
                    return function(param) {
                        return Curry._2(func$1, param, arg);
                    };
                })(valueFromDataNode)(makeDataSchema)
            };
        case /* Headlines */ 3:
            var func$11 = HeadlineSchema.fromHeadlineNode;
            var arg$1 = Caml_array.get(arrayNode._0, 0);
            return {
                TAG: /* Headlines */ 1,
                _0: (function(param3) {
                    var func$2 = Curry._1(func$11, param3);
                    return function(param) {
                        return Curry._2(func$2, param, arg$1);
                    };
                })(valueFromDataNode)(makeDataSchema)
            };
        case /* Buttons */ 4:
            var func$21 = ButtonSchema.fromButtonNode;
            var arg$2 = Caml_array.get(arrayNode._0, 0);
            return {
                TAG: /* Buttons */ 2,
                _0: (function(param4) {
                    var func$3 = Curry._1(func$21, param4);
                    return function(param) {
                        return Curry._2(func$3, param, arg$2);
                    };
                })(valueFromDataNode)(makeDataSchema)
            };
        case /* Records */ 5:
            var func$31 = RecordSchema.fromRecord;
            var arg$3 = Caml_array.get(arrayNode._0, 0);
            return {
                TAG: /* Records */ 3,
                _0: (function(param5) {
                    var func$4 = Curry._1(func$31, param5);
                    return function(param) {
                        return Curry._2(func$4, param, arg$3);
                    };
                })(valueFromDataNode)(makeDataSchema)
            };
    }
}
function map$4(mapSchema, arraySchema) {
    var f = Curry._1(DataNodeSchema.map, mapSchema);
    if (typeof arraySchema === "number") {
        if (arraySchema === /* PlainTexts */ 0) {
            return /* PlainTexts */ 0;
        } else {
            return /* Images */ 1;
        }
    }
    switch(arraySchema.TAG | 0){
        case /* Links */ 0:
            return {
                TAG: /* Links */ 0,
                _0: Curry._2(LinkSchema.map, f, arraySchema._0)
            };
        case /* Headlines */ 1:
            return {
                TAG: /* Headlines */ 1,
                _0: Curry._2(HeadlineSchema.map, f, arraySchema._0)
            };
        case /* Buttons */ 2:
            return {
                TAG: /* Buttons */ 2,
                _0: Curry._2(ButtonSchema.map, f, arraySchema._0)
            };
        case /* Records */ 3:
            return {
                TAG: /* Records */ 3,
                _0: Curry._2(RecordSchema.map, f, arraySchema._0)
            };
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromArrayNode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, ArraySchema, {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    fromArrayNode: fromArrayNode,
    map: map$4
});
function t_encode$5(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "properties",
            Decco.arrayToJson(Curry._1(RecordPropertySchema.t_encode, encoder_dataSchema), v.properties)
        ]
    ]);
}
function t_decode$5(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var properties = Decco.arrayFromJson(Curry._1(RecordPropertySchema.t_decode, decoder_dataSchema), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
        if (properties.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    properties: properties._0
                }
            };
        }
        var e = properties._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".properties" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromRecord(valueFromDataNode, makeDataSchema, param) {
    return {
        friendlyName: param.friendlyName,
        properties: Belt_Array.map(param.properties, Curry._2(RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema))
    };
}
function map$5(f, param6) {
    return {
        friendlyName: param6.friendlyName,
        properties: Belt_Array.map(param6.properties, function(param) {
            return {
                friendlyName: param.friendlyName,
                dataSchema: Curry._1(f, param.dataSchema)
            };
        })
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "fromRecord"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, RecordSchema, {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromRecord: fromRecord,
    map: map$5
});
var DataNodePath;
exports.EdgeCases = EdgeCases;
exports.RecordPropertySchema = RecordPropertySchema;
exports.DataNodePath = DataNodePath;
exports.DataNodeSchema = DataNodeSchema;
exports.LinkSchema = LinkSchema;
exports.HeadlineSchema = HeadlineSchema;
exports.ButtonSchema = ButtonSchema;
exports.ArraySchema = ArraySchema;
exports.RecordSchema = RecordSchema; /* RecordPropertySchema Not a pure module */ 


/***/ }),

/***/ 36589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_module = __webpack_require__(27236);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
function t_encode(encoder_htmlElement, encoder_textNode, v) {
    if (v.TAG === /* HtmlElement */ 0) {
        return [
            "HtmlElement",
            Curry._1(encoder_htmlElement, v._0)
        ];
    } else {
        return [
            "TextNode",
            Curry._1(encoder_textNode, v._0)
        ];
    }
}
function t_decode(decoder_htmlElement, decoder_textNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "HtmlElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* HtmlElement */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "TextNode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_textNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextNode */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapHtmlElement(x, f) {
    if (x.TAG === /* HtmlElement */ 0) {
        return {
            TAG: /* HtmlElement */ 0,
            _0: Curry._1(f, x._0)
        };
    } else {
        return {
            TAG: /* TextNode */ 1,
            _0: x._0
        };
    }
}
function mapTextNode(x, f) {
    if (x.TAG === /* HtmlElement */ 0) {
        return {
            TAG: /* HtmlElement */ 0,
            _0: x._0
        };
    } else {
        return {
            TAG: /* TextNode */ 1,
            _0: Curry._1(f, x._0)
        };
    }
}
function parentElement(x) {
    return Caml_option.nullable_to_opt(x._0.parentElement);
}
function isTextNode(x) {
    if (x.TAG === /* HtmlElement */ 0) {
        return false;
    } else {
        return true;
    }
}
function isHtmlElementSatisfying(x, predicate) {
    if (x.TAG === /* HtmlElement */ 0) {
        return Curry._1(predicate, x._0);
    } else {
        return false;
    }
}
function isSiblingOf(htmlElementOrText1, htmlElementOrText2) {
    var element;
    var textNode;
    if (htmlElementOrText1.TAG === /* HtmlElement */ 0) {
        var element1 = htmlElementOrText1._0;
        if (htmlElementOrText2.TAG === /* HtmlElement */ 0) {
            return DOM__HtmlElement$SmartcutsMacros.isSiblingOf(htmlElementOrText2._0, element1);
        }
        element = element1;
        textNode = htmlElementOrText2._0;
    } else {
        var textNode1 = htmlElementOrText1._0;
        if (htmlElementOrText2.TAG === /* HtmlElement */ 0) {
            element = htmlElementOrText2._0;
            textNode = textNode1;
        } else {
            var match = textNode1.parentElement;
            var match$1 = htmlElementOrText2._0.parentElement;
            if (!(match == null) && !(match$1 == null)) {
                return DOM__Element$SmartcutsMacros.isSiblingOf(match$1, match);
            } else {
                return false;
            }
        }
    }
    var parentElementOfTextNode = textNode.parentElement;
    if (parentElementOfTextNode == null) {
        return false;
    } else {
        return DOM__Element$SmartcutsMacros.isSiblingOf(parentElementOfTextNode, element);
    }
}
var DomHtmlElementOrTextNode = {
    t_encode: t_encode,
    t_decode: t_decode,
    mapHtmlElement: mapHtmlElement,
    mapTextNode: mapTextNode,
    parentElement: parentElement,
    isTextNode: isTextNode,
    isHtmlElementSatisfying: isHtmlElementSatisfying,
    isSiblingOf: isSiblingOf
};
var t_encode$1 = Decco.intToJson;
var t_decode$1 = Decco.intFromJson;
function fromInt(i) {
    return i;
}
function stringify(prim) {
    return String(prim);
}
var DataNodeId = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromInt: fromInt,
    stringify: stringify
};
var Record = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    114,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var RecordProperty = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    159,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "mapDataNode"
        ]
    ]
});
var DataNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    266,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "value_encode"
        ],
        [
            /* Function */ 0,
            "value_decode"
        ],
        [
            /* Function */ 0,
            "combineValues"
        ],
        [
            /* Function */ 0,
            "mapValue"
        ],
        [
            /* Function */ 0,
            "map"
        ],
        [
            /* Function */ 0,
            "allNodes"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ]
                ]
            },
            "WithDomElementOrTextNode"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "fromDataNodeWithDomElementOrTextNode"
                    ]
                ]
            },
            "WithDomEntities"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "fromDataNodeWithDomEntities"
                    ],
                    [
                        /* Function */ 0,
                        "mapHtmlTagPathIdentifier"
                    ]
                ]
            },
            "WithHtmlElementAndHTPI"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "mapHtmlElement"
                    ],
                    [
                        /* Function */ 0,
                        "mapTextNode"
                    ]
                ]
            },
            "WithHtmlElementAndHTPIAndTagPathAndDataNodeId"
        ]
    ]
});
var ImageNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    629,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ]
                ]
            },
            "Source"
        ],
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ]
    ]
});
var LinkNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    658,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var HeadlineNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    683,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var ButtonNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    708,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
var ArrayNode = Caml_module.init_mod([
    "DataExtraction__DataRecord__Types.re",
    735,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
});
function t_encode$2(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "properties",
            Decco.arrayToJson(Curry._1(RecordProperty.t_encode, encoder_dataNode), v.properties)
        ]
    ]);
}
function t_decode$2(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var properties = Decco.arrayFromJson(Curry._1(RecordProperty.t_decode, decoder_dataNode), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
        if (properties.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    properties: properties._0
                }
            };
        }
        var e = properties._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".properties" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function map(f, param1) {
    return {
        friendlyName: param1.friendlyName,
        properties: Belt_Array.map(param1.properties, function(param) {
            return {
                friendlyName: param.friendlyName,
                dataNode: Curry._1(f, param.dataNode)
            };
        })
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, Record, {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    map: map
});
function t_encode$3(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "friendlyName",
            Decco.optionToJson(Decco.stringToJson, v.friendlyName)
        ],
        [
            "dataNode",
            Curry._1(encoder_dataNode, v.dataNode)
        ]
    ]);
}
function t_decode$3(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
    if (friendlyName.TAG === /* Ok */ 0) {
        var dataNode = Curry._1(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNode"), null));
        if (dataNode.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    friendlyName: friendlyName._0,
                    dataNode: dataNode._0
                }
            };
        }
        var e = dataNode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataNode" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = friendlyName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function mapDataNode(param, f) {
    return {
        friendlyName: param.friendlyName,
        dataNode: Curry._1(f, param.dataNode)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "mapDataNode"
        ]
    ]
}, RecordProperty, {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    mapDataNode: mapDataNode
});
function value_encode(encoder_dataNode, v) {
    switch(v.TAG | 0){
        case /* PlainText */ 0:
            return [
                "PlainText",
                Decco.stringToJson(v._0)
            ];
        case /* Image */ 1:
            return [
                "Image",
                Curry._1(ImageNode.t_encode, v._0)
            ];
        case /* Link */ 2:
            return [
                "Link",
                Curry._2(LinkNode.t_encode, encoder_dataNode, v._0)
            ];
        case /* LinkContainingManyProperties */ 3:
            return [
                "LinkContainingManyProperties",
                Decco.stringToJson(v._0)
            ];
        case /* Headline */ 4:
            return [
                "Headline",
                Curry._2(HeadlineNode.t_encode, encoder_dataNode, v._0)
            ];
        case /* Button */ 5:
            return [
                "Button",
                Curry._2(ButtonNode.t_encode, encoder_dataNode, v._0)
            ];
        case /* Array */ 6:
            return [
                "Array",
                Curry._2(ArrayNode.t_encode, encoder_dataNode, v._0)
            ];
    }
}
function value_decode(decoder_dataNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Array":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._2(ArrayNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Array */ 6,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Button":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._2(ButtonNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Button */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Headline":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._2(HeadlineNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Headline */ 4,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Image":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(ImageNode.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Image */ 1,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Link":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._2(LinkNode.t_decode, decoder_dataNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Link */ 2,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "LinkContainingManyProperties":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LinkContainingManyProperties */ 3,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "PlainText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlainText */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function combineValues(value1, value2) {
    switch(value1.TAG | 0){
        case /* PlainText */ 0:
            if (value2.TAG === /* PlainText */ 0) {
                return {
                    TAG: /* Array */ 6,
                    _0: {
                        TAG: /* PlainTexts */ 0,
                        _0: [
                            value1._0,
                            value2._0
                        ]
                    }
                };
            }
            break;
        case /* Image */ 1:
            if (value2.TAG === /* Image */ 1) {
                return {
                    TAG: /* Array */ 6,
                    _0: {
                        TAG: /* Images */ 1,
                        _0: [
                            value1._0,
                            value2._0
                        ]
                    }
                };
            }
            break;
        case /* Link */ 2:
            if (value2.TAG === /* Link */ 2) {
                return {
                    TAG: /* Array */ 6,
                    _0: {
                        TAG: /* Links */ 2,
                        _0: [
                            value1._0,
                            value2._0
                        ]
                    }
                };
            }
            break;
        case /* LinkContainingManyProperties */ 3:
            break;
        case /* Headline */ 4:
            if (value2.TAG === /* Headline */ 4) {
                return {
                    TAG: /* Array */ 6,
                    _0: {
                        TAG: /* Headlines */ 3,
                        _0: [
                            value1._0,
                            value2._0
                        ]
                    }
                };
            }
            break;
        case /* Button */ 5:
            if (value2.TAG === /* Button */ 5) {
                return {
                    TAG: /* Array */ 6,
                    _0: {
                        TAG: /* Buttons */ 4,
                        _0: [
                            value1._0,
                            value2._0
                        ]
                    }
                };
            }
            break;
        case /* Array */ 6:
            var texts = value1._0;
            switch(texts.TAG | 0){
                case /* PlainTexts */ 0:
                    if (value2.TAG === /* PlainText */ 0) {
                        return {
                            TAG: /* Array */ 6,
                            _0: {
                                TAG: /* PlainTexts */ 0,
                                _0: $$Array.append(texts._0, [
                                    value2._0
                                ])
                            }
                        };
                    }
                    break;
                case /* Images */ 1:
                    if (value2.TAG === /* Image */ 1) {
                        return {
                            TAG: /* Array */ 6,
                            _0: {
                                TAG: /* Images */ 1,
                                _0: $$Array.append(texts._0, [
                                    value2._0
                                ])
                            }
                        };
                    }
                    break;
                case /* Links */ 2:
                    if (value2.TAG === /* Link */ 2) {
                        return {
                            TAG: /* Array */ 6,
                            _0: {
                                TAG: /* Links */ 2,
                                _0: $$Array.append(texts._0, [
                                    value2._0
                                ])
                            }
                        };
                    }
                    break;
                case /* Headlines */ 3:
                    if (value2.TAG === /* Headline */ 4) {
                        return {
                            TAG: /* Array */ 6,
                            _0: {
                                TAG: /* Headlines */ 3,
                                _0: $$Array.append(texts._0, [
                                    value2._0
                                ])
                            }
                        };
                    }
                    break;
                case /* Buttons */ 4:
                    if (value2.TAG === /* Button */ 5) {
                        return {
                            TAG: /* Array */ 6,
                            _0: {
                                TAG: /* Buttons */ 4,
                                _0: $$Array.append(texts._0, [
                                    value2._0
                                ])
                            }
                        };
                    }
                    break;
                case /* Records */ 5:
                    break;
            }
            break;
    }
    console.warn("value1", value1);
    console.warn("value2", value2);
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected value combination");
}
function mapValue(value, transformDataNode) {
    switch(value.TAG | 0){
        case /* PlainText */ 0:
            return {
                TAG: /* PlainText */ 0,
                _0: value._0
            };
        case /* Image */ 1:
            return {
                TAG: /* Image */ 1,
                _0: value._0
            };
        case /* Link */ 2:
            return {
                TAG: /* Link */ 2,
                _0: Curry._2(LinkNode.map, transformDataNode, value._0)
            };
        case /* LinkContainingManyProperties */ 3:
            return {
                TAG: /* LinkContainingManyProperties */ 3,
                _0: value._0
            };
        case /* Headline */ 4:
            return {
                TAG: /* Headline */ 4,
                _0: Curry._2(HeadlineNode.map, transformDataNode, value._0)
            };
        case /* Button */ 5:
            return {
                TAG: /* Button */ 5,
                _0: Curry._2(ButtonNode.map, transformDataNode, value._0)
            };
        case /* Array */ 6:
            return {
                TAG: /* Array */ 6,
                _0: Curry._2(ArrayNode.map, transformDataNode, value._0)
            };
    }
}
function map$1(mapValue1, dataNode) {
    var f = function f(param) {
        return map$1(mapValue1, param);
    };
    return Curry._2(mapValue1, dataNode, function(value) {
        switch(value.TAG | 0){
            case /* PlainText */ 0:
                return {
                    TAG: /* PlainText */ 0,
                    _0: value._0
                };
            case /* Image */ 1:
                return {
                    TAG: /* Image */ 1,
                    _0: value._0
                };
            case /* Link */ 2:
                return {
                    TAG: /* Link */ 2,
                    _0: Curry._2(LinkNode.map, f, value._0)
                };
            case /* LinkContainingManyProperties */ 3:
                return {
                    TAG: /* LinkContainingManyProperties */ 3,
                    _0: value._0
                };
            case /* Headline */ 4:
                return {
                    TAG: /* Headline */ 4,
                    _0: Curry._2(HeadlineNode.map, f, value._0)
                };
            case /* Button */ 5:
                return {
                    TAG: /* Button */ 5,
                    _0: Curry._2(ButtonNode.map, f, value._0)
                };
            case /* Array */ 6:
                return {
                    TAG: /* Array */ 6,
                    _0: Curry._2(ArrayNode.map, f, value._0)
                };
        }
    });
}
function allNodes(dataNode, valueFromDataNode) {
    var match = Curry._1(valueFromDataNode, dataNode);
    var tmp;
    var exit = 0;
    switch(match.TAG | 0){
        case /* Link */ 2:
        case /* Headline */ 4:
        case /* Button */ 5:
            exit = 1;
            break;
        case /* Array */ 6:
            var linkNodes = match._0;
            switch(linkNodes.TAG | 0){
                case /* PlainTexts */ 0:
                case /* Images */ 1:
                    tmp = [];
                    break;
                case /* Links */ 2:
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param2) {
                        return ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                            return allNodes(param, valueFromDataNode);
                        }, param2.innerContent);
                    }, linkNodes._0);
                    break;
                case /* Headlines */ 3:
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param3) {
                        return ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                            return allNodes(param, valueFromDataNode);
                        }, param3.innerContent);
                    }, linkNodes._0);
                    break;
                case /* Buttons */ 4:
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param4) {
                        return ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                            return allNodes(param, valueFromDataNode);
                        }, param4.innerContent);
                    }, linkNodes._0);
                    break;
                case /* Records */ 5:
                    tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param5) {
                        return ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                            return allNodes(param.dataNode, valueFromDataNode);
                        }, param5.properties);
                    }, linkNodes._0);
                    break;
            }
            break;
        default:
            tmp = [];
    }
    if (exit === 1) {
        tmp = ArrayUtils$SmartcutsMacros.flatMap(function(param) {
            return allNodes(param, valueFromDataNode);
        }, match._0.innerContent);
    }
    return Belt_Array.concat([
        dataNode
    ], tmp);
}
function t_encode$4(encoder_htmlElement, encoder_textNode, v) {
    return Js_dict.fromArray([
        [
            "domElementOrTextNode",
            t_encode(encoder_htmlElement, encoder_textNode, v.domElementOrTextNode)
        ],
        [
            "value",
            value_encode(function(param) {
                return t_encode$4(encoder_htmlElement, encoder_textNode, param);
            }, v.value)
        ]
    ]);
}
function t_decode$4(decoder_htmlElement, decoder_textNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementOrTextNode = t_decode(decoder_htmlElement, decoder_textNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementOrTextNode"), null));
    if (domElementOrTextNode.TAG === /* Ok */ 0) {
        var value = value_decode(function(param) {
            return t_decode$4(decoder_htmlElement, decoder_textNode, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementOrTextNode: domElementOrTextNode._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementOrTextNode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementOrTextNode" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var WithDomElementOrTextNode = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function t_encode$5(encoder_htmlElement, encoder_textNode, v) {
    return Js_dict.fromArray([
        [
            "domEntities",
            Decco.arrayToJson(function(param) {
                return t_encode(encoder_htmlElement, encoder_textNode, param);
            }, v.domEntities)
        ],
        [
            "value",
            value_encode(function(param) {
                return t_encode$5(encoder_htmlElement, encoder_textNode, param);
            }, v.value)
        ]
    ]);
}
function t_decode$5(decoder_htmlElement, decoder_textNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domEntities = Decco.arrayFromJson(function(param) {
        return t_decode(decoder_htmlElement, decoder_textNode, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domEntities"), null));
    if (domEntities.TAG === /* Ok */ 0) {
        var value = value_decode(function(param) {
            return t_decode$5(decoder_htmlElement, decoder_textNode, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domEntities: domEntities._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domEntities._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domEntities" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromDataNodeWithDomElementOrTextNode(dataNodeWithDomElementOrTextNode) {
    var transformDataNode = function(param) {
        return {
            domEntities: [
                param.domElementOrTextNode
            ],
            value: Curry._2(DataNode.mapValue, param.value, transformDataNode)
        };
    };
    return transformDataNode(dataNodeWithDomElementOrTextNode);
}
var WithDomEntities = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromDataNodeWithDomElementOrTextNode: fromDataNodeWithDomElementOrTextNode
};
function fromDataNodeWithDomEntities(dataNodeWithDomEntities, lookupTable) {
    return map$1(function(param, f) {
        var domEntities = param.domEntities;
        var htmlElement = Belt_Array.getExn(domEntities, 0);
        var tmp;
        tmp = htmlElement.TAG === /* HtmlElement */ 0 ? List.assoc(htmlElement._0, lookupTable) : List.assoc(Belt_Option.getExn(Caml_option.nullable_to_opt(htmlElement._0.parentElement)), lookupTable);
        return {
            htmlTagPathIdentifier: tmp,
            domEntities: domEntities,
            value: Curry._1(f, param.value)
        };
    }, dataNodeWithDomEntities);
}
function mapHtmlTagPathIdentifier(param, f) {
    var value = param.value;
    var tmp;
    switch(value.TAG | 0){
        case /* Link */ 2:
            tmp = {
                TAG: /* Link */ 2,
                _0: Curry._2(LinkNode.map, function(nestedDataNode) {
                    return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Headline */ 4:
            tmp = {
                TAG: /* Headline */ 4,
                _0: Curry._2(HeadlineNode.map, function(nestedDataNode) {
                    return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Button */ 5:
            tmp = {
                TAG: /* Button */ 5,
                _0: Curry._2(ButtonNode.map, function(nestedDataNode) {
                    return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Array */ 6:
            tmp = {
                TAG: /* Array */ 6,
                _0: Curry._2(ArrayNode.map, function(nestedDataNode) {
                    return mapHtmlTagPathIdentifier(nestedDataNode, f);
                }, value._0)
            };
            break;
        default:
            tmp = value;
    }
    return {
        htmlTagPathIdentifier: Curry._1(f, param.htmlTagPathIdentifier),
        domEntities: param.domEntities,
        value: tmp
    };
}
var WithHtmlElementAndHTPI = {
    fromDataNodeWithDomEntities: fromDataNodeWithDomEntities,
    mapHtmlTagPathIdentifier: mapHtmlTagPathIdentifier
};
function t_encode$6(encoder_htmlElement, encoder_textNode, v) {
    return Js_dict.fromArray([
        [
            "dataNodeId",
            Decco.intToJson(v.dataNodeId)
        ],
        [
            "htmlTagPathIdentifier",
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
        ],
        [
            "domEntities",
            Decco.arrayToJson(function(param) {
                return t_encode(encoder_htmlElement, encoder_textNode, param);
            }, v.domEntities)
        ],
        [
            "tagPath",
            Decco.arrayToJson(Decco.stringToJson, v.tagPath)
        ],
        [
            "value",
            value_encode(function(param) {
                return t_encode$6(encoder_htmlElement, encoder_textNode, param);
            }, v.value)
        ]
    ]);
}
function t_decode$6(decoder_htmlElement, decoder_textNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataNodeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
    if (dataNodeId.TAG === /* Ok */ 0) {
        var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
        if (htmlTagPathIdentifier.TAG === /* Ok */ 0) {
            var domEntities = Decco.arrayFromJson(function(param) {
                return t_decode(decoder_htmlElement, decoder_textNode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domEntities"), null));
            if (domEntities.TAG === /* Ok */ 0) {
                var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
                if (tagPath.TAG === /* Ok */ 0) {
                    var value = value_decode(function(param) {
                        return t_decode$6(decoder_htmlElement, decoder_textNode, param);
                    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
                    if (value.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                dataNodeId: dataNodeId._0,
                                htmlTagPathIdentifier: htmlTagPathIdentifier._0,
                                domEntities: domEntities._0,
                                tagPath: tagPath._0,
                                value: value._0
                            }
                        };
                    }
                    var e = value._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".value" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = tagPath._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".tagPath" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = domEntities._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".domEntities" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = htmlTagPathIdentifier._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".htmlTagPathIdentifier" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = dataNodeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataNodeId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function mapHtmlElement$1(param, f) {
    var value = param.value;
    var tmp;
    switch(value.TAG | 0){
        case /* PlainText */ 0:
            tmp = {
                TAG: /* PlainText */ 0,
                _0: value._0
            };
            break;
        case /* Image */ 1:
            tmp = {
                TAG: /* Image */ 1,
                _0: value._0
            };
            break;
        case /* Link */ 2:
            tmp = {
                TAG: /* Link */ 2,
                _0: Curry._2(LinkNode.map, function(nestedDataNode) {
                    return mapHtmlElement$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* LinkContainingManyProperties */ 3:
            tmp = {
                TAG: /* LinkContainingManyProperties */ 3,
                _0: value._0
            };
            break;
        case /* Headline */ 4:
            tmp = {
                TAG: /* Headline */ 4,
                _0: Curry._2(HeadlineNode.map, function(nestedDataNode) {
                    return mapHtmlElement$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Button */ 5:
            tmp = {
                TAG: /* Button */ 5,
                _0: Curry._2(ButtonNode.map, function(nestedDataNode) {
                    return mapHtmlElement$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Array */ 6:
            tmp = {
                TAG: /* Array */ 6,
                _0: Curry._2(ArrayNode.map, function(nestedDataNode) {
                    return mapHtmlElement$1(nestedDataNode, f);
                }, value._0)
            };
            break;
    }
    return {
        dataNodeId: param.dataNodeId,
        htmlTagPathIdentifier: param.htmlTagPathIdentifier,
        domEntities: Belt_Array.map(param.domEntities, function(__x) {
            return mapHtmlElement(__x, f);
        }),
        tagPath: param.tagPath,
        value: tmp
    };
}
function mapTextNode$1(param, f) {
    var value = param.value;
    var tmp;
    switch(value.TAG | 0){
        case /* PlainText */ 0:
            tmp = {
                TAG: /* PlainText */ 0,
                _0: value._0
            };
            break;
        case /* Image */ 1:
            tmp = {
                TAG: /* Image */ 1,
                _0: value._0
            };
            break;
        case /* Link */ 2:
            tmp = {
                TAG: /* Link */ 2,
                _0: Curry._2(LinkNode.map, function(nestedDataNode) {
                    return mapTextNode$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* LinkContainingManyProperties */ 3:
            tmp = {
                TAG: /* LinkContainingManyProperties */ 3,
                _0: value._0
            };
            break;
        case /* Headline */ 4:
            tmp = {
                TAG: /* Headline */ 4,
                _0: Curry._2(HeadlineNode.map, function(nestedDataNode) {
                    return mapTextNode$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Button */ 5:
            tmp = {
                TAG: /* Button */ 5,
                _0: Curry._2(ButtonNode.map, function(nestedDataNode) {
                    return mapTextNode$1(nestedDataNode, f);
                }, value._0)
            };
            break;
        case /* Array */ 6:
            tmp = {
                TAG: /* Array */ 6,
                _0: Curry._2(ArrayNode.map, function(nestedDataNode) {
                    return mapTextNode$1(nestedDataNode, f);
                }, value._0)
            };
            break;
    }
    return {
        dataNodeId: param.dataNodeId,
        htmlTagPathIdentifier: param.htmlTagPathIdentifier,
        domEntities: Belt_Array.map(param.domEntities, function(__x) {
            return mapTextNode(__x, f);
        }),
        tagPath: param.tagPath,
        value: tmp
    };
}
var WithHtmlElementAndHTPIAndTagPathAndDataNodeId = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    mapHtmlElement: mapHtmlElement$1,
    mapTextNode: mapTextNode$1
};
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "value_encode"
        ],
        [
            /* Function */ 0,
            "value_decode"
        ],
        [
            /* Function */ 0,
            "combineValues"
        ],
        [
            /* Function */ 0,
            "mapValue"
        ],
        [
            /* Function */ 0,
            "map"
        ],
        [
            /* Function */ 0,
            "allNodes"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ]
                ]
            },
            "WithDomElementOrTextNode"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "fromDataNodeWithDomElementOrTextNode"
                    ]
                ]
            },
            "WithDomEntities"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "fromDataNodeWithDomEntities"
                    ],
                    [
                        /* Function */ 0,
                        "mapHtmlTagPathIdentifier"
                    ]
                ]
            },
            "WithHtmlElementAndHTPI"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "mapHtmlElement"
                    ],
                    [
                        /* Function */ 0,
                        "mapTextNode"
                    ]
                ]
            },
            "WithHtmlElementAndHTPIAndTagPathAndDataNodeId"
        ]
    ]
}, DataNode, {
    value_encode: value_encode,
    value_decode: value_decode,
    combineValues: combineValues,
    mapValue: mapValue,
    map: map$1,
    allNodes: allNodes,
    WithDomElementOrTextNode: WithDomElementOrTextNode,
    WithDomEntities: WithDomEntities,
    WithHtmlElementAndHTPI: WithHtmlElementAndHTPI,
    WithHtmlElementAndHTPIAndTagPathAndDataNodeId: WithHtmlElementAndHTPIAndTagPathAndDataNodeId
});
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "mimeType",
            Decco.optionToJson(Decco.stringToJson, v.mimeType)
        ],
        [
            "media",
            Decco.optionToJson(Decco.stringToJson, v.media)
        ],
        [
            "widthOrPixelDensity",
            Decco.optionToJson(Decco.stringToJson, v.widthOrPixelDensity)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var mimeType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mimeType"), null));
        if (mimeType.TAG === /* Ok */ 0) {
            var media = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "media"), null));
            if (media.TAG === /* Ok */ 0) {
                var widthOrPixelDensity = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "widthOrPixelDensity"), null));
                if (widthOrPixelDensity.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            url: url._0,
                            mimeType: mimeType._0,
                            media: media._0,
                            widthOrPixelDensity: widthOrPixelDensity._0
                        }
                    };
                }
                var e = widthOrPixelDensity._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".widthOrPixelDensity" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = media._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".media" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = mimeType._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".mimeType" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var Source = {
    t_encode: t_encode$7,
    t_decode: t_decode$7
};
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "src",
            Decco.stringToJson(v.src)
        ],
        [
            "altText",
            Decco.optionToJson(Decco.stringToJson, v.altText)
        ],
        [
            "sources",
            Decco.arrayToJson(t_encode$7, v.sources)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
    if (src.TAG === /* Ok */ 0) {
        var altText = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "altText"), null));
        if (altText.TAG === /* Ok */ 0) {
            var sources = Decco.arrayFromJson(t_decode$7, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sources"), null));
            if (sources.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        src: src._0,
                        altText: altText._0,
                        sources: sources._0
                    }
                };
            }
            var e = sources._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".sources" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = altText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".altText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = src._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".src" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ]
                ]
            },
            "Source"
        ],
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ]
    ]
}, ImageNode, {
    Source: Source,
    t_encode: t_encode$8,
    t_decode: t_decode$8
});
function t_encode$9(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "innerText",
            Decco.stringToJson(v.innerText)
        ],
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataNode, v.innerContent)
        ]
    ]);
}
function t_decode$9(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
        if (innerText.TAG === /* Ok */ 0) {
            var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
            if (innerContent.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        url: url._0,
                        innerText: innerText._0,
                        innerContent: innerContent._0
                    }
                };
            }
            var e = innerContent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".innerContent" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = innerText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".innerText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function map$2(f, param) {
    return {
        url: param.url,
        innerText: param.innerText,
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, LinkNode, {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    map: map$2
});
function t_encode$10(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "hLevel",
            Decco.stringToJson(v.hLevel)
        ],
        [
            "innerText",
            Decco.stringToJson(v.innerText)
        ],
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataNode, v.innerContent)
        ]
    ]);
}
function t_decode$10(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hLevel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hLevel"), null));
    if (hLevel.TAG === /* Ok */ 0) {
        var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
        if (innerText.TAG === /* Ok */ 0) {
            var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
            if (innerContent.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        hLevel: hLevel._0,
                        innerText: innerText._0,
                        innerContent: innerContent._0
                    }
                };
            }
            var e = innerContent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".innerContent" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = innerText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".innerText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = hLevel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hLevel" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function map$3(f, param) {
    return {
        hLevel: param.hLevel,
        innerText: param.innerText,
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, HeadlineNode, {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    map: map$3
});
function t_encode$11(encoder_dataNode, v) {
    return Js_dict.fromArray([
        [
            "maybeHref",
            Decco.optionToJson(Decco.stringToJson, v.maybeHref)
        ],
        [
            "innerText",
            Decco.stringToJson(v.innerText)
        ],
        [
            "innerContent",
            Decco.arrayToJson(encoder_dataNode, v.innerContent)
        ]
    ]);
}
function t_decode$11(decoder_dataNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var maybeHref = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeHref"), null));
    if (maybeHref.TAG === /* Ok */ 0) {
        var innerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
        if (innerText.TAG === /* Ok */ 0) {
            var innerContent = Decco.arrayFromJson(decoder_dataNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerContent"), null));
            if (innerContent.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        maybeHref: maybeHref._0,
                        innerText: innerText._0,
                        innerContent: innerContent._0
                    }
                };
            }
            var e = innerContent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".innerContent" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = innerText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".innerText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = maybeHref._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybeHref" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function map$4(f, param) {
    return {
        maybeHref: param.maybeHref,
        innerText: param.innerText,
        innerContent: Belt_Array.map(param.innerContent, f)
    };
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, ButtonNode, {
    t_encode: t_encode$11,
    t_decode: t_decode$11,
    map: map$4
});
function t_encode$12(encoder_dataNode, v) {
    switch(v.TAG | 0){
        case /* PlainTexts */ 0:
            return [
                "PlainTexts",
                Decco.arrayToJson(Decco.stringToJson, v._0)
            ];
        case /* Images */ 1:
            return [
                "Images",
                Decco.arrayToJson(ImageNode.t_encode, v._0)
            ];
        case /* Links */ 2:
            return [
                "Links",
                Decco.arrayToJson(Curry._1(LinkNode.t_encode, encoder_dataNode), v._0)
            ];
        case /* Headlines */ 3:
            return [
                "Headlines",
                Decco.arrayToJson(Curry._1(HeadlineNode.t_encode, encoder_dataNode), v._0)
            ];
        case /* Buttons */ 4:
            return [
                "Buttons",
                Decco.arrayToJson(Curry._1(ButtonNode.t_encode, encoder_dataNode), v._0)
            ];
        case /* Records */ 5:
            return [
                "Records",
                Decco.arrayToJson(Curry._1(Record.t_encode, encoder_dataNode), v._0)
            ];
    }
}
function t_decode$12(decoder_dataNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Buttons":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(Curry._1(ButtonNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Buttons */ 4,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Headlines":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.arrayFromJson(Curry._1(HeadlineNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Headlines */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Images":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.arrayFromJson(ImageNode.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Images */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Links":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.arrayFromJson(Curry._1(LinkNode.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Links */ 2,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "PlainTexts":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PlainTexts */ 0,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Records":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.arrayFromJson(Curry._1(Record.t_decode, decoder_dataNode), Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Records */ 5,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$5(f, arrayNode) {
    switch(arrayNode.TAG | 0){
        case /* PlainTexts */ 0:
            return {
                TAG: /* PlainTexts */ 0,
                _0: arrayNode._0
            };
        case /* Images */ 1:
            return {
                TAG: /* Images */ 1,
                _0: arrayNode._0
            };
        case /* Links */ 2:
            return {
                TAG: /* Links */ 2,
                _0: Belt_Array.map(arrayNode._0, Curry._1(LinkNode.map, f))
            };
        case /* Headlines */ 3:
            return {
                TAG: /* Headlines */ 3,
                _0: Belt_Array.map(arrayNode._0, Curry._1(HeadlineNode.map, f))
            };
        case /* Buttons */ 4:
            return {
                TAG: /* Buttons */ 4,
                _0: Belt_Array.map(arrayNode._0, Curry._1(ButtonNode.map, f))
            };
        case /* Records */ 5:
            return {
                TAG: /* Records */ 5,
                _0: Belt_Array.map(arrayNode._0, Curry._1(Record.map, f))
            };
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "map"
        ]
    ]
}, ArrayNode, {
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    map: map$5
});
exports.DomHtmlElementOrTextNode = DomHtmlElementOrTextNode;
exports.DataNodeId = DataNodeId;
exports.Record = Record;
exports.RecordProperty = RecordProperty;
exports.DataNode = DataNode;
exports.ImageNode = ImageNode;
exports.LinkNode = LinkNode;
exports.HeadlineNode = HeadlineNode;
exports.ButtonNode = ButtonNode;
exports.ArrayNode = ArrayNode; /* Record Not a pure module */ 


/***/ }),

/***/ 88644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "startsAt",
            Decco.intToJson(v.startsAt)
        ],
        [
            "endsAt",
            Decco.intToJson(v.endsAt)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var startsAt = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startsAt"), null));
    if (startsAt.TAG === /* Ok */ 0) {
        var endsAt = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endsAt"), null));
        if (endsAt.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    startsAt: startsAt._0,
                    endsAt: endsAt._0
                }
            };
        }
        var e = endsAt._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".endsAt" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = startsAt._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".startsAt" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function mergeIfOverlap(r1, r2) {
    if (r1.endsAt > r2.startsAt && r2.startsAt >= r1.startsAt) {
        return {
            startsAt: r1.startsAt,
            endsAt: Math.max(r1.endsAt, r2.endsAt)
        };
    } else if (r2.endsAt > r1.startsAt && r1.startsAt >= r2.startsAt) {
        return {
            startsAt: r2.startsAt,
            endsAt: Math.max(r1.endsAt, r2.endsAt)
        };
    } else {
        return;
    }
}
function length(param) {
    return param.endsAt - param.startsAt | 0;
}
var $$Range = {
    t_encode: t_encode,
    t_decode: t_decode,
    mergeIfOverlap: mergeIfOverlap,
    length: length
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "fullRange",
            t_encode(v.fullRange)
        ],
        [
            "rangeList",
            Decco.listToJson(t_encode, v.rangeList)
        ],
        [
            "additionalRange",
            Decco.optionToJson(t_encode, v.additionalRange)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var fullRange = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fullRange"), null));
    if (fullRange.TAG === /* Ok */ 0) {
        var rangeList = Decco.listFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rangeList"), null));
        if (rangeList.TAG === /* Ok */ 0) {
            var additionalRange = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "additionalRange"), null));
            if (additionalRange.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        fullRange: fullRange._0,
                        rangeList: rangeList._0,
                        additionalRange: additionalRange._0
                    }
                };
            }
            var e = additionalRange._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".additionalRange" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = rangeList._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".rangeList" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = fullRange._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".fullRange" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function maybeMergeWithRange(dataRecord, dataRecordRange) {
    return Belt_Option.map(mergeIfOverlap(dataRecord.fullRange, dataRecordRange), function(fullRange) {
        return {
            fullRange: fullRange,
            rangeList: Belt_List.add(dataRecord.rangeList, dataRecordRange),
            additionalRange: dataRecord.additionalRange
        };
    });
}
function maybeMergeWith(dataRecord, dataRecord$p) {
    return Belt_Option.map(mergeIfOverlap(dataRecord.fullRange, dataRecord$p.fullRange), function(fullRange) {
        return {
            fullRange: fullRange,
            rangeList: Belt_List.concat(dataRecord.rangeList, dataRecord$p.rangeList),
            additionalRange: dataRecord.additionalRange
        };
    });
}
function fromRange(dataRecordRange) {
    return {
        fullRange: dataRecordRange,
        rangeList: {
            hd: dataRecordRange,
            tl: /* [] */ 0
        },
        additionalRange: undefined
    };
}
function Make(Sequence) {
    var fromOccurrence = function fromOccurrence(nodes, startsAt) {
        return {
            startsAt: startsAt,
            endsAt: startsAt + nodes.length | 0
        };
    };
    var $$Range1 = {
        t_encode: t_encode,
        t_decode: t_decode,
        mergeIfOverlap: mergeIfOverlap,
        length: length,
        fromOccurrence: fromOccurrence
    };
    var getNodes = function getNodes(sequence, param) {
        return Curry._2(Sequence.getRange, sequence, param.fullRange);
    };
    var maybeAdditionalRange = function maybeAdditionalRange(sequence, dataRegion) {
        var nodes = Curry._2(Sequence.getRange, sequence, dataRegion.fullRange);
        var nodesAfterEndsAt = Curry._2(Sequence.sliceToEnd, sequence, dataRegion.fullRange.endsAt);
        var maybeExtendToPosition = ArrayUtils$SmartcutsMacros.firstMatchi(function(node) {
            return Belt_Array.every(nodes, function(nodeInSequence) {
                return !Curry._3(Sequence.isNodeAncestorOf, sequence, nodeInSequence, node);
            });
        }, nodesAfterEndsAt);
        if (maybeExtendToPosition !== undefined) {
            var len = maybeExtendToPosition[1];
            if (len === 0) {
                return;
            }
            var startsAt = dataRegion.fullRange.endsAt;
            var endsAt = startsAt + len | 0;
            return {
                startsAt: startsAt,
                endsAt: endsAt
            };
        }
        var startsAt$1 = dataRegion.fullRange.endsAt;
        var endsAt$1 = Curry._1(Sequence.length, sequence) + 1 | 0;
        return {
            startsAt: startsAt$1,
            endsAt: endsAt$1
        };
    };
    return {
        $$Range: $$Range1,
        getNodes: getNodes,
        maybeAdditionalRange: maybeAdditionalRange
    };
}
exports.$$Range = $$Range;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.maybeMergeWithRange = maybeMergeWithRange;
exports.maybeMergeWith = maybeMergeWith;
exports.fromRange = fromRange;
exports.Make = Make; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 87148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Format = (__webpack_require__(74201)/* ["default"] */ .Z);
var SerialId$SmartcutsMacros = __webpack_require__(45934);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var CustomMapBuilders$SmartcutsMacros = __webpack_require__(22926);
var DataExtraction__DataRecord$SmartcutsMacros = __webpack_require__(57870);
var GoogleApis__Sheets__Schema$SmartcutsMacros = __webpack_require__(11815);
var DataExtraction__DataRecord__Types$SmartcutsMacros = __webpack_require__(36589);
var DataExtraction__DataRecord__Schema__Types$SmartcutsMacros = __webpack_require__(48828);
function cellValue_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ArrayOfString":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ArrayOfString */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "String":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* String */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Url":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Url */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function cellValue_encode(v) {
    switch(v.TAG | 0){
        case /* String */ 0:
            return [
                "String",
                Decco.stringToJson(v._0)
            ];
        case /* Url */ 1:
            return [
                "Url",
                Decco.stringToJson(v._0)
            ];
        case /* ArrayOfString */ 2:
            return [
                "ArrayOfString",
                Decco.arrayToJson(Decco.stringToJson, v._0)
            ];
    }
}
function attribute_encode(v) {
    switch(v){
        case /* Text */ 0:
            return [
                "Text"
            ];
        case /* ImageSrc */ 1:
            return [
                "ImageSrc"
            ];
        case /* AltText */ 2:
            return [
                "AltText"
            ];
        case /* LinkUrl */ 3:
            return [
                "LinkUrl"
            ];
    }
}
function attribute_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AltText":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AltText */ 2
                    };
                }
            case "ImageSrc":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ImageSrc */ 1
                    };
                }
            case "LinkUrl":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* LinkUrl */ 3
                    };
                }
            case "Text":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Text */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function column_decode(decoder_dataSchema, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
        if (dataNodeId.TAG === /* Ok */ 0) {
            var attribute = attribute_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "attribute"), null));
            if (attribute.TAG === /* Ok */ 0) {
                var path = Decco.arrayFromJson(decoder_dataSchema, Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
                if (path.TAG === /* Ok */ 0) {
                    var _$columnName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "columnName"), null));
                    if (_$columnName.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                id: id._0,
                                dataNodeId: dataNodeId._0,
                                attribute: attribute._0,
                                path: path._0,
                                columnName: _$columnName._0
                            }
                        };
                    }
                    var e = _$columnName._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".columnName" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = path._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".path" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = attribute._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".attribute" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = dataNodeId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataNodeId" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function cell_decode(decoder_column, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var column = Curry._1(decoder_column, Belt_Option.getWithDefault(Js_dict.get(dict$1, "column"), null));
    if (column.TAG === /* Ok */ 0) {
        var value = Decco.optionFromJson(cellValue_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    column: column._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = column._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".column" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var columnId_encode = Decco.intToJson;
function cell_encode(encoder_column, v) {
    return Js_dict.fromArray([
        [
            "column",
            Curry._1(encoder_column, v.column)
        ],
        [
            "value",
            Decco.optionToJson(cellValue_encode, v.value)
        ]
    ]);
}
function column_encode(encoder_dataSchema, v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.intToJson(v.id)
        ],
        [
            "dataNodeId",
            DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
        ],
        [
            "attribute",
            attribute_encode(v.attribute)
        ],
        [
            "path",
            Decco.arrayToJson(encoder_dataSchema, v.path)
        ],
        [
            "columnName",
            Decco.stringToJson(v.columnName)
        ]
    ]);
}
var columnId_decode = Decco.intFromJson;
function t_encode(encoder_dataSchema, encoder_column, v) {
    return Js_dict.fromArray([
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return column_encode(encoder_dataSchema, param);
            }, v.columns)
        ],
        [
            "rows",
            Decco.arrayToJson(function(param1) {
                return Decco.arrayToJson(function(param) {
                    return cell_encode(encoder_column, param);
                }, param1);
            }, v.rows)
        ]
    ]);
}
function t_decode(decoder_dataSchema, decoder_column, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var columns = Decco.arrayFromJson(function(param) {
        return column_decode(decoder_dataSchema, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */ 0) {
        var rows = Decco.arrayFromJson(function(param2) {
            return Decco.arrayFromJson(function(param) {
                return cell_decode(decoder_column, param);
            }, param2);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
        if (rows.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    columns: columns._0,
                    rows: rows._0
                }
            };
        }
        var e = rows._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".rows" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = columns._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".columns" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function columnRef_encode(v) {
    return [
        "ColumnById",
        Decco.intToJson(v._0)
    ];
}
function columnRef_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ColumnById") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ColumnById */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var t_encode$1 = Decco.intToJson;
var t_decode$1 = Decco.intFromJson;
var cmp = Caml_obj.caml_compare;
var MapColumnId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    cmp: cmp
});
function defaultColumnName_(fullPath, attribute) {
    var prefixies = Belt_Array.map(fullPath, function(param) {
        var schema = param.schema;
        if (typeof schema === "number") {
            switch(schema){
                case /* PlainText */ 0:
                    return "field";
                case /* Image */ 1:
                    return "image";
                case /* LinkContainingManyProperties */ 2:
                    return "link";
            }
        } else {
            switch(schema.TAG | 0){
                case /* Link */ 0:
                    return "link";
                case /* Headline */ 1:
                    return schema._0.hLevel;
                case /* Button */ 2:
                    return "button";
                case /* Array */ 3:
                    return "list[x]";
            }
        }
    });
    var suffix;
    switch(attribute){
        case /* Text */ 0:
            suffix = "text";
            break;
        case /* ImageSrc */ 1:
            suffix = "src";
            break;
        case /* AltText */ 2:
            suffix = "alt";
            break;
        case /* LinkUrl */ 3:
            suffix = "url";
            break;
    }
    return Belt_Array.concat(prefixies, [
        suffix
    ]).join(".");
}
function defaultColumnName(param3) {
    var prefixies = Belt_Array.map(param3.path, function(param) {
        var schema = param.schema;
        if (typeof schema === "number") {
            switch(schema){
                case /* PlainText */ 0:
                    return "field";
                case /* Image */ 1:
                    return "image";
                case /* LinkContainingManyProperties */ 2:
                    return "link";
            }
        } else {
            switch(schema.TAG | 0){
                case /* Link */ 0:
                    return "link";
                case /* Headline */ 1:
                    return schema._0.hLevel;
                case /* Button */ 2:
                    return "button";
                case /* Array */ 3:
                    return "list[x]";
            }
        }
    });
    var suffix;
    switch(param3.attribute){
        case /* Text */ 0:
            suffix = "text";
            break;
        case /* ImageSrc */ 1:
            suffix = "src";
            break;
        case /* AltText */ 2:
            suffix = "alt";
            break;
        case /* LinkUrl */ 3:
            suffix = "url";
            break;
    }
    return Belt_Array.concat(prefixies, [
        suffix
    ]).join(".");
}
function getAttributeAsTextValue(attribute, param4) {
    var value = param4.value;
    var exit = 0;
    switch(value.TAG | 0){
        case /* PlainText */ 0:
            if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(value._0);
            }
            exit = 1;
            break;
        case /* Image */ 1:
            var match = value._0;
            if (attribute !== 0) {
                switch(attribute){
                    case /* ImageSrc */ 1:
                        return match.src;
                    case /* AltText */ 2:
                        return match.altText;
                    case /* LinkUrl */ 3:
                        exit = 1;
                        break;
                }
            } else {
                exit = 1;
            }
            break;
        case /* Link */ 2:
            var match$1 = value._0;
            if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(match$1.innerText);
            }
            if (attribute >= 3) {
                return match$1.url;
            }
            exit = 1;
            break;
        case /* LinkContainingManyProperties */ 3:
            if (attribute >= 3) {
                return value._0;
            }
            exit = 1;
            break;
        case /* Headline */ 4:
            if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(value._0.innerText);
            }
            exit = 1;
            break;
        case /* Button */ 5:
            var match$2 = value._0;
            if (attribute === 0) {
                return OptionUtils$SmartcutsMacros.optionalString(match$2.innerText);
            }
            if (attribute >= 3) {
                return match$2.maybeHref;
            }
            exit = 1;
            break;
        case /* Array */ 6:
            var texts = value._0;
            switch(texts.TAG | 0){
                case /* PlainTexts */ 0:
                    if (attribute === 0) {
                        return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.keepMap(texts._0, OptionUtils$SmartcutsMacros.optionalString).join(", "));
                    }
                    exit = 1;
                    break;
                case /* Links */ 2:
                    if (attribute === 0) {
                        return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.map(texts._0, function(param) {
                            return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                        }).join(", "));
                    }
                    exit = 1;
                    break;
                case /* Headlines */ 3:
                    if (attribute === 0) {
                        return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.map(texts._0, function(param) {
                            return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                        }).join(", "));
                    }
                    exit = 1;
                    break;
                case /* Buttons */ 4:
                    if (attribute === 0) {
                        return OptionUtils$SmartcutsMacros.optionalString(Belt_Array.keepMap(texts._0, function(param) {
                            return OptionUtils$SmartcutsMacros.optionalString(param.innerText);
                        }).join(", "));
                    }
                    exit = 1;
                    break;
                case /* Images */ 1:
                case /* Records */ 5:
                    exit = 2;
                    break;
            }
            break;
    }
    switch(exit){
        case 1:
        case 2:
            console.warn("trying to getAttributeAsTextValue(", value, attribute, ")");
            return;
    }
}
function rowFromDataNodeWithId(columns, dataRecord) {
    return Belt_Array.map(columns, function(param5) {
        var attribute = param5.attribute;
        var func = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById;
        var values = Belt_Array.keepMap(Curry._2(func, param5.dataNodeId, dataRecord), function(param) {
            return getAttributeAsTextValue(attribute, param);
        });
        var len = values.length;
        var value;
        if (len !== 1) {
            value = len !== 0 ? {
                TAG: /* ArrayOfString */ 2,
                _0: values
            } : undefined;
        } else {
            var textValue = values[0];
            value = textValue === "" ? undefined : attribute !== 1 && attribute < 3 ? {
                TAG: /* String */ 0,
                _0: textValue
            } : {
                TAG: /* Url */ 1,
                _0: textValue
            };
        }
        return {
            column: /* ColumnById */ {
                _0: param5.id
            },
            value: value
        };
    });
}
function attributesFromDataSchema(dataSchema, dataRecordsWithDataNodeId) {
    var schema = dataSchema.schema;
    var dataNodeId = dataSchema.dataNodeId;
    var exit = 0;
    if (typeof schema === "number") {
        switch(schema){
            case /* PlainText */ 0:
                return [
                    /* Text */ 0
                ];
            case /* Image */ 1:
                exit = 1;
                break;
            case /* LinkContainingManyProperties */ 2:
                return [
                    /* LinkUrl */ 3
                ];
        }
    } else {
        switch(schema.TAG | 0){
            case /* Link */ 0:
                return [
                    /* LinkUrl */ 3,
                    /* Text */ 0
                ];
            case /* Headline */ 1:
                return [
                    /* Text */ 0
                ];
            case /* Button */ 2:
                exit = 2;
                break;
            case /* Array */ 3:
                var match = schema._0;
                if (typeof match === "number") {
                    if (match === /* PlainTexts */ 0) {
                        return [
                            /* Text */ 0
                        ];
                    }
                    exit = 1;
                } else {
                    switch(match.TAG | 0){
                        case /* Links */ 0:
                            return [
                                /* LinkUrl */ 3,
                                /* Text */ 0
                            ];
                        case /* Headlines */ 1:
                            return [
                                /* Text */ 0
                            ];
                        case /* Buttons */ 2:
                            exit = 2;
                            break;
                        case /* Records */ 3:
                            return ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                                return attributesFromDataSchema(param.dataSchema, dataRecordsWithDataNodeId);
                            }, match._0.properties);
                    }
                }
                break;
        }
    }
    switch(exit){
        case 1:
            var arg = ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById(dataNodeId, param);
            }, dataRecordsWithDataNodeId);
            return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(Belt_Option.map(function(param) {
                return ArrayUtils$SmartcutsMacros.firstMatch(param, arg);
            }(function(dataNode) {
                var match = dataNode.value;
                if (match.TAG === /* Image */ 1) {
                    return match._0.altText !== undefined;
                } else {
                    return false;
                }
            }), function(_altText) {
                return /* AltText */ 2;
            })), [
                /* ImageSrc */ 1
            ]);
        case 2:
            var arg$1 = ArrayUtils$SmartcutsMacros.flatMap(function(param) {
                return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById(dataNodeId, param);
            }, dataRecordsWithDataNodeId);
            return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(Belt_Option.map(function(param) {
                return ArrayUtils$SmartcutsMacros.firstMatch(param, arg$1);
            }(function(dataNode) {
                var match = dataNode.value;
                if (match.TAG === /* Button */ 5) {
                    return match._0.maybeHref !== undefined;
                } else {
                    return false;
                }
            }), function(_href) {
                return /* LinkUrl */ 3;
            })), [
                /* Text */ 0
            ]);
    }
}
function fromDataRecords(param6) {
    var dataRecords = param6.dataRecords;
    var makeId = SerialId$SmartcutsMacros.makeIdGenerator(undefined);
    var arg = param6.unifiedSchema.properties;
    var arg$1 = Belt_Array.keep(function(param) {
        return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
    }(function(param) {
        return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.allNodesWithPath, param.dataSchema, DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.valueFromDataSchema);
    }), function(param) {
        var match = ArrayUtils$SmartcutsMacros.last(param[1]);
        if (param[0].schema !== 0) {
            return true;
        }
        if (match === undefined) {
            return true;
        }
        var tmp = match.schema;
        if (typeof tmp === "number") {
            return true;
        }
        switch(tmp.TAG | 0){
            case /* Link */ 0:
            case /* Button */ 2:
                return false;
            default:
                return true;
        }
    });
    var columns = function(param) {
        return ArrayUtils$SmartcutsMacros.flatMap(param, arg$1);
    }(function(param7) {
        var path = param7[1];
        var dataSchema = param7[0];
        return Belt_Array.keepMap(attributesFromDataSchema(dataSchema, dataRecords), function(attribute) {
            var dataNodeId = dataSchema.dataNodeId;
            var fullPath = Belt_Array.concat(path, [
                dataSchema
            ]);
            var _values = ArrayUtils$SmartcutsMacros.flatMap(function(dataRecord) {
                var func = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.getDataNodesById;
                return Belt_Array.keepMap(Curry._2(func, dataNodeId, dataRecord), function(param) {
                    return getAttributeAsTextValue(attribute, param);
                });
            }, dataRecords);
            if (_values.length !== 0) {
                return {
                    id: Curry._1(makeId, undefined),
                    dataNodeId: dataNodeId,
                    attribute: attribute,
                    path: fullPath,
                    columnName: defaultColumnName_(fullPath, attribute)
                };
            }
        });
    });
    var rows = Belt_Array.map(dataRecords, function(param) {
        return rowFromDataNodeWithId(columns, param);
    });
    return {
        columns: columns,
        rows: rows
    };
}
function resolveCellValueAsText(cellValue) {
    switch(cellValue.TAG | 0){
        case /* String */ 0:
        case /* Url */ 1:
            return cellValue._0;
        case /* ArrayOfString */ 2:
            return cellValue._0.join(", ");
    }
}
function t_encode$2(v) {
    if (v) {
        return [
            "CurrentUrl"
        ];
    } else {
        return [
            "CurrentDateTime"
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CurrentDateTime":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CurrentDateTime */ 0
                    };
                }
            case "CurrentUrl":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CurrentUrl */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var allExtraColumns = [
    /* CurrentDateTime */ 0,
    /* CurrentUrl */ 1
];
function stringify(extraColumn) {
    if (extraColumn) {
        return "CurrentUrl";
    } else {
        return "CurrentDateTime";
    }
}
function columnName(extraColumn) {
    if (extraColumn) {
        return "Saved from web page";
    } else {
        return "Saved at date time";
    }
}
var ExtraColumn = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    allExtraColumns: allExtraColumns,
    stringify: stringify,
    columnName: columnName
};
function fromCellValue(cellValue) {
    switch(cellValue.TAG | 0){
        case /* String */ 0:
            return {
                TAG: /* Text */ 0,
                _0: cellValue._0
            };
        case /* Url */ 1:
            return {
                TAG: /* Link */ 1,
                _0: cellValue._0
            };
        case /* ArrayOfString */ 2:
            return {
                TAG: /* Text */ 0,
                _0: cellValue._0.join(", ")
            };
    }
}
function fromExtraColumn(extraColumn, currentUrl, maybeCurrentDateTime, param) {
    if (extraColumn) {
        return {
            TAG: /* Link */ 1,
            _0: currentUrl
        };
    } else {
        return {
            TAG: /* DateTime */ 2,
            _0: OptionUtils$SmartcutsMacros.withDefault(new Date(), maybeCurrentDateTime)
        };
    }
}
function resolveAsText(cellContent) {
    switch(cellContent.TAG | 0){
        case /* Text */ 0:
        case /* Link */ 1:
            return cellContent._0;
        case /* DateTime */ 2:
            return Format(cellContent._0, "eeee, M/d/yyyy 'at' h:mm");
    }
}
function resolveAsCellData(cellContent, dataValidation, param) {
    switch(cellContent.TAG | 0){
        case /* Text */ 0:
            return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(cellContent._0), undefined);
        case /* Link */ 1:
            return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.formulaValue('=HYPERLINK("' + cellContent._0 + '")'), undefined);
        case /* DateTime */ 2:
            var datetime = cellContent._0;
            var dateString = datetime.toDateString();
            var timeString = Format(datetime, "HH:mm:ss");
            return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(dataValidation, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                numberFormat: GoogleApis__Sheets__Schema$SmartcutsMacros.NumberFormat.make("DATE_TIME", "dddd, m/d/yyyy at h:mm")
            }, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.formulaValue('=DATEVALUE("' + dateString + '") + TIMEVALUE("' + timeString + '")'), undefined);
    }
}
var CellContent = {
    fromCellValue: fromCellValue,
    fromExtraColumn: fromExtraColumn,
    resolveAsText: resolveAsText,
    resolveAsCellData: resolveAsCellData
};
var GoogleSheet = {
    CellContent: CellContent
};
var DataRecord;
var DataRecordsAndSchema;
exports.DataRecord = DataRecord;
exports.DataRecordsAndSchema = DataRecordsAndSchema;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.column_encode = column_encode;
exports.column_decode = column_decode;
exports.columnId_encode = columnId_encode;
exports.columnId_decode = columnId_decode;
exports.columnRef_encode = columnRef_encode;
exports.columnRef_decode = columnRef_decode;
exports.attribute_encode = attribute_encode;
exports.attribute_decode = attribute_decode;
exports.cell_encode = cell_encode;
exports.cell_decode = cell_decode;
exports.cellValue_encode = cellValue_encode;
exports.cellValue_decode = cellValue_decode;
exports.MapColumnId = MapColumnId;
exports.defaultColumnName = defaultColumnName;
exports.rowFromDataNodeWithId = rowFromDataNodeWithId;
exports.fromDataRecords = fromDataRecords;
exports.resolveCellValueAsText = resolveCellValueAsText;
exports.ExtraColumn = ExtraColumn;
exports.GoogleSheet = GoogleSheet; /* MapColumnId Not a pure module */ 


/***/ }),

/***/ 97563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var GenericTree$SmartcutsMacros = __webpack_require__(57165);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
var DataExtraction__DataRegion$SmartcutsMacros = __webpack_require__(88644);
var defaultFilters = [
    {
        TAG: /* ByNodeFrequencyAndEdgeLength */ 0,
        _0: {
            nodeFrequencyEqualsOrGreaterThan: 2,
            substringLengthEqualsOrGreaterThan: 2
        }
    },
    {
        TAG: /* ByLongestCommonSubSequence */ 1,
        _0: {
            recordValidationRate: 0.05,
            patternValidationRate: 0.6
        }
    },
    /* ByTreeStructure */ 0,
    /* ByRepetition */ 1
];
function make(param) {
    return {
        identifiersByHtmlTagPath: {
            contents: Curry._1(CustomMap$SmartcutsMacros.MapHtmlTagPath.make, undefined)
        },
        nextHtmlTagPathIdentifier: {
            contents: STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.init
        }
    };
}
function identifierForHtmlTagPath(generator, htmlTagPath) {
    var identifiersByHtmlTagPath = generator.identifiersByHtmlTagPath.contents;
    var identifier = Belt_Map.get(identifiersByHtmlTagPath, htmlTagPath);
    if (identifier !== undefined) {
        return Caml_option.valFromOption(identifier);
    }
    var nextHtmlTagPathIdentifier = generator.nextHtmlTagPathIdentifier.contents;
    generator.nextHtmlTagPathIdentifier.contents = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.increment(nextHtmlTagPathIdentifier);
    generator.identifiersByHtmlTagPath.contents = Belt_Map.set(identifiersByHtmlTagPath, htmlTagPath, nextHtmlTagPathIdentifier);
    return nextHtmlTagPathIdentifier;
}
var HtmlTagPathIdentifierGenerator = {
    make: make,
    identifierForHtmlTagPath: identifierForHtmlTagPath
};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "tags",
            Decco.arrayToJson(Decco.stringToJson, v.tags)
        ],
        [
            "htmlTagPathIdentifier",
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tags = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tags"), null));
    if (tags.TAG === /* Ok */ 0) {
        var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
        if (htmlTagPathIdentifier.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    tags: tags._0,
                    htmlTagPathIdentifier: htmlTagPathIdentifier._0
                }
            };
        }
        var e = htmlTagPathIdentifier._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".htmlTagPathIdentifier" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = tags._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tags" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function toTagPathString(param) {
    return param.tags.join(">");
}
function forHtmlElement(htmlTagPathIdentifierGenerator, previousTags, includeTagComponentsOpt, htmlElement) {
    var includeTagComponents = includeTagComponentsOpt !== undefined ? includeTagComponentsOpt : [
        /* TagName */ 0
    ];
    var currTag = Belt_Array.reduce(includeTagComponents, "", function(tag, component) {
        if (component) {
            return tag + Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.getAttribute("class")), OptionUtils$SmartcutsMacros.optionalString), function(classValue) {
                return "[class=" + (classValue.trim().replace(/\n/g, " ").replace(/\s\s+/g, " ").split(" ").sort().join(" ") + "]");
            }), "");
        } else {
            return htmlElement.tagName.toLowerCase();
        }
    });
    var tags = Belt_Array.concat(previousTags, [
        currTag
    ]);
    var htmlTagPathIdentifier = identifierForHtmlTagPath(htmlTagPathIdentifierGenerator, tags);
    return {
        tags: tags,
        htmlTagPathIdentifier: htmlTagPathIdentifier
    };
}
function isSame(param, param$1) {
    return Caml_obj.caml_equal(param.htmlTagPathIdentifier, param$1.htmlTagPathIdentifier);
}
function compare(param, param$1) {
    return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.compare(param.htmlTagPathIdentifier, param$1.htmlTagPathIdentifier);
}
function doesMatchHtmlTagPathIdentifier(tagPath, htmlTagPathIdentifier) {
    return Caml_obj.caml_equal(htmlTagPathIdentifier, tagPath.htmlTagPathIdentifier);
}
var HtmlTagPath = {
    t_encode: t_encode,
    t_decode: t_decode,
    toTagPathString: toTagPathString,
    forHtmlElement: forHtmlElement,
    isSame: isSame,
    compare: compare,
    doesMatchHtmlTagPathIdentifier: doesMatchHtmlTagPathIdentifier
};
function t_encode$1(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "tagPath",
            t_encode(v.tagPath)
        ],
        [
            "parentId",
            Decco.optionToJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.parentId)
        ],
        [
            "htmlElement",
            Curry._1(encoder_htmlElement, v.htmlElement)
        ]
    ]);
}
function t_decode$1(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tagPath = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
    if (tagPath.TAG === /* Ok */ 0) {
        var parentId = Decco.optionFromJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentId"), null));
        if (parentId.TAG === /* Ok */ 0) {
            var htmlElement = Curry._1(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlElement"), null));
            if (htmlElement.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        tagPath: tagPath._0,
                        parentId: parentId._0,
                        htmlElement: htmlElement._0
                    }
                };
            }
            var e = htmlElement._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".htmlElement" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = parentId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".parentId" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = tagPath._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tagPath" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function mapHtmlElement(mapHtmlElement$11, param) {
    return {
        tagPath: param.tagPath,
        parentId: param.parentId,
        htmlElement: Curry._1(mapHtmlElement$11, param.htmlElement)
    };
}
var Generic = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    mapHtmlElement: mapHtmlElement
};
function forHtmlElement$1(parentId, htmlTagPathIdentifierGenerator, previousTags, htmlElement) {
    var tagPath = forHtmlElement(htmlTagPathIdentifierGenerator, previousTags, undefined, htmlElement);
    return {
        tagPath: tagPath,
        parentId: parentId,
        htmlElement: htmlElement
    };
}
var NodeWithPath = {
    Generic: Generic,
    forHtmlElement: forHtmlElement$1
};
function t_encode$2(encoder_htmlElement, v) {
    return Js_dict.fromArray([
        [
            "htmlTagPathByHtmlTagPathIdentifier",
            Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_encode, t_encode, v.htmlTagPathByHtmlTagPathIdentifier)
        ],
        [
            "webPageSequence",
            Decco.arrayToJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.webPageSequence)
        ],
        [
            "allNodesInWebPageSequence",
            Decco.arrayToJson(function(param) {
                return t_encode$1(encoder_htmlElement, param);
            }, v.allNodesInWebPageSequence)
        ],
        [
            "encodedWebPageSequence",
            STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.t_encode(v.encodedWebPageSequence)
        ],
        [
            "htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier",
            Curry._2(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.t_encode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier)
        ],
        [
            "htmlTagPathIdentifierParentMap",
            Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_encode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode, v.htmlTagPathIdentifierParentMap)
        ]
    ]);
}
function t_decode$2(decoder_htmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var htmlTagPathByHtmlTagPathIdentifier = Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_decode, t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathByHtmlTagPathIdentifier"), null));
    if (htmlTagPathByHtmlTagPathIdentifier.TAG === /* Ok */ 0) {
        var webPageSequence = Decco.arrayFromJson(STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "webPageSequence"), null));
        if (webPageSequence.TAG === /* Ok */ 0) {
            var allNodesInWebPageSequence = Decco.arrayFromJson(function(param) {
                return t_decode$1(decoder_htmlElement, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allNodesInWebPageSequence"), null));
            if (allNodesInWebPageSequence.TAG === /* Ok */ 0) {
                var encodedWebPageSequence = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "encodedWebPageSequence"), null));
                if (encodedWebPageSequence.TAG === /* Ok */ 0) {
                    var htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier = Curry._2(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.t_decode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier"), null));
                    if (htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier.TAG === /* Ok */ 0) {
                        var htmlTagPathIdentifierParentMap = Curry._2(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.t_decode, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifierParentMap"), null));
                        if (htmlTagPathIdentifierParentMap.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    htmlTagPathByHtmlTagPathIdentifier: htmlTagPathByHtmlTagPathIdentifier._0,
                                    webPageSequence: webPageSequence._0,
                                    allNodesInWebPageSequence: allNodesInWebPageSequence._0,
                                    encodedWebPageSequence: encodedWebPageSequence._0,
                                    htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier._0,
                                    htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap._0
                                }
                            };
                        }
                        var e = htmlTagPathIdentifierParentMap._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".htmlTagPathIdentifierParentMap" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = encodedWebPageSequence._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".encodedWebPageSequence" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = allNodesInWebPageSequence._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".allNodesInWebPageSequence" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = webPageSequence._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".webPageSequence" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = htmlTagPathByHtmlTagPathIdentifier._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".htmlTagPathByHtmlTagPathIdentifier" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function mapHtmlElement$1(mapHtmlElement$2, param1) {
    return {
        htmlTagPathByHtmlTagPathIdentifier: param1.htmlTagPathByHtmlTagPathIdentifier,
        webPageSequence: param1.webPageSequence,
        allNodesInWebPageSequence: Belt_Array.map(param1.allNodesInWebPageSequence, function(param) {
            return mapHtmlElement(mapHtmlElement$2, param);
        }),
        encodedWebPageSequence: param1.encodedWebPageSequence,
        htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: param1.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
        htmlTagPathIdentifierParentMap: param1.htmlTagPathIdentifierParentMap
    };
}
var Generic$1 = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    mapHtmlElement: mapHtmlElement$1
};
function shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement) {
    return Belt_Array.some(subtreesWithCollectedDataRecords, function(htmlElement$p) {
        return htmlElement === htmlElement$p;
    });
}
function fromDocument(subtreesWithCollectedDataRecords) {
    var htmlTagPathIdentifierGenerator = make(undefined);
    var arg1 = Array.prototype.slice.call(document.childNodes);
    var arg$1 = function(param) {
        return ArrayUtils$SmartcutsMacros.shortcut(param, arg1);
    }(function(node) {
        return Belt_Option.flatMap(Curry._1(Webapi__Dom__HtmlElement.ofNode, node), function(htmlElement) {
            var tagName = htmlElement.tagName;
            if (tagName !== "HTML") {
                return;
            }
            var arg = [];
            return forHtmlElement$1(undefined, htmlTagPathIdentifierGenerator, arg, htmlElement);
        });
    });
    var htmlNodeWithPath = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expect to get <html> element from document's childNodes");
    return GenericTree$SmartcutsMacros.depthFirst(function(param2) {
        var htmlElement = param2.htmlElement;
        var tagPath = param2.tagPath;
        var pathToSvgElement = tagPath.tags;
        if (pathToSvgElement.length === 2) {
            var match = pathToSvgElement[0];
            if (match === "html") {
                var match$1 = pathToSvgElement[1];
                if (match$1 === "head") {
                    return [];
                }
            }
        }
        if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "svg")) {
            return [];
        }
        if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "style")) {
            return [];
        }
        if (Caml_obj.caml_equal(ArrayUtils$SmartcutsMacros.last(pathToSvgElement), "script")) {
            return [];
        }
        if (htmlElement.id === "smartcuts-htmlPreprocessing") {
            return [];
        }
        if (shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement)) {
            return [];
        }
        var parentId = tagPath.htmlTagPathIdentifier;
        var partial_arg = tagPath.tags;
        var partial_arg$1 = Caml_option.some(parentId);
        return Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(htmlElement.childNodes), Webapi__Dom__HtmlElement.ofNode), function(param) {
            return forHtmlElement$1(partial_arg$1, htmlTagPathIdentifierGenerator, partial_arg, param);
        });
    }, [], function(node, result) {
        return Belt_Array.concat(result, [
            node
        ]);
    }, htmlNodeWithPath);
}
function toWebPageSequence(allNodes) {
    return Belt_Array.map(allNodes, function(param) {
        return param.tagPath.htmlTagPathIdentifier;
    });
}
function getHtmlElementsForRange(allNodes, param3) {
    var startsAt = param3.startsAt;
    return Belt_Array.map(Belt_Array.slice(allNodes, startsAt, param3.endsAt - startsAt | 0), function(param) {
        return param.htmlElement;
    });
}
function getIndexesForNodesThatMatchHtpiSequence(allNodes, htmlTagPathIdentifierSequence) {
    return Belt_Option.getWithDefault(Belt_Option.map(ArrayUtils$SmartcutsMacros.splitAtFirst(htmlTagPathIdentifierSequence), function(param4) {
        var nextHtmlTagPathIdentifierSequence = param4[1];
        var firstHtmlTagPathIdentifier = param4[0];
        var len = nextHtmlTagPathIdentifierSequence.length;
        return Belt_Array.keep(ArrayUtils$SmartcutsMacros.filterMapi(function(index, param) {
            if (Caml_obj.caml_equal(firstHtmlTagPathIdentifier, param.tagPath.htmlTagPathIdentifier)) {
                return index;
            }
        }, allNodes), function(startsAt) {
            if ((startsAt + len | 0) >= allNodes.length) {
                return false;
            }
            var offset = startsAt + 1 | 0;
            return ArrayUtils$SmartcutsMacros.everyWithIndex(nextHtmlTagPathIdentifierSequence, function(indexInNextHtpiSequence, htmlTagPathIdentifier) {
                var nodeWithPath = Caml_array.get(allNodes, offset + indexInNextHtpiSequence | 0);
                return Caml_obj.caml_equal(htmlTagPathIdentifier, nodeWithPath.tagPath.htmlTagPathIdentifier);
            });
        });
    }), []);
}
var AllNodes = {
    fromDocument: fromDocument,
    toWebPageSequence: toWebPageSequence,
    getHtmlElementsForRange: getHtmlElementsForRange,
    getIndexesForNodesThatMatchHtpiSequence: getIndexesForNodesThatMatchHtpiSequence
};
function doArrayOfTagsMatch(tags_1, tags_2) {
    if (tags_1.length === tags_2.length) {
        return Belt_Array.every2(tags_1, tags_2, function(tag_a, tab_b) {
            return tag_a === tab_b;
        });
    } else {
        return false;
    }
}
function forSequenceOfTagPathsAppliedToAllNodes(allNodes, sequenceOfTagPathArrays) {
    return Belt_Option.getWithDefault(Belt_Option.map(ArrayUtils$SmartcutsMacros.splitAtFirst(sequenceOfTagPathArrays), function(param5) {
        var nextSequenceOfTagPathArrays = param5[1];
        var firstTagPathArray = param5[0];
        return Belt_Array.map(Belt_Array.map(ArrayUtils$SmartcutsMacros.filterMapi(function(index, param) {
            var tags = param.tagPath.tags;
            if (doArrayOfTagsMatch(tags, firstTagPathArray)) {
                console.warn("MATCHES TAGS", tags);
                return index;
            }
        }, allNodes), function(startsAt) {
            var offset1 = startsAt + 1 | 0;
            var match = Belt_Array.reduceWithIndex(nextSequenceOfTagPathArrays, [
                [
                    0
                ],
                offset1
            ], function(param, tagPathArray, indexInNextSequence) {
                var offset = param[1];
                var matchingIndexes = param[0];
                var currNodeTagPathArray = Caml_array.get(allNodes, offset).tagPath.tags;
                if (doArrayOfTagsMatch(tagPathArray, currNodeTagPathArray)) {
                    return [
                        $$Array.append(matchingIndexes, [
                            indexInNextSequence
                        ]),
                        offset + 1 | 0
                    ];
                } else {
                    return [
                        matchingIndexes,
                        offset
                    ];
                }
            });
            return [
                startsAt,
                match[0]
            ];
        }), function(param) {
            var matchingIndexes = param[1];
            var startsAt = param[0];
            var endsAt = startsAt + matchingIndexes.length | 0;
            var score = matchingIndexes.length / sequenceOfTagPathArrays.length;
            return [
                {
                    startsAt: startsAt,
                    endsAt: endsAt
                },
                score
            ];
        });
    }), []);
}
function toArrayOfRangesWithHighestScoreChosenPerStartsAt(rangesWithScores1) {
    return Belt_MapString.valuesToArray(Belt_MapString.map(ArrayUtils$SmartcutsMacros.groupBy(function(param) {
        return String(param[0].startsAt);
    }, rangesWithScores1), function(rangesWithScores) {
        var match = ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expected at least one range with score", rangesWithScores);
        return Belt_Array.reduce(match[1], match[0], function(rangeWithMaxScore, currRangeWithScore) {
            if (currRangeWithScore[1] > rangeWithMaxScore[1]) {
                return currRangeWithScore;
            } else {
                return rangeWithMaxScore;
            }
        })[0];
    }));
}
var RangesWithScores = {
    doArrayOfTagsMatch: doArrayOfTagsMatch,
    forSequenceOfTagPathsAppliedToAllNodes: forSequenceOfTagPathsAppliedToAllNodes,
    toArrayOfRangesWithHighestScoreChosenPerStartsAt: toArrayOfRangesWithHighestScoreChosenPerStartsAt
};
function forAllNodesInDocument(subtreesWithCollectedDataRecords) {
    var allNodes = fromDocument(subtreesWithCollectedDataRecords);
    var htmlTagPathByHtmlTagPathIdentifier = Curry._1(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.fromArray, Belt_Array.map(allNodes, function(param) {
        var tagPath = param.tagPath;
        return [
            tagPath.htmlTagPathIdentifier,
            tagPath
        ];
    }));
    var allNodesInWebPageSequence = Belt_Array.keep(allNodes, function(param) {
        var htmlElement = param.htmlElement;
        if (DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return !shouldIgnoreElementAlreadyCollectedDataRecords(subtreesWithCollectedDataRecords, htmlElement);
        } else {
            return false;
        }
    });
    var webPageSequence = toWebPageSequence(allNodesInWebPageSequence);
    var match = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(webPageSequence);
    var htmlTagPathIdentifierParentMap = Curry._1(STEM__Interfaces$SmartcutsMacros.MapHtmlTagPathIdentifier.fromArray, Belt_Array.keepMap(allNodes, function(param) {
        var htmlTagPathIdentifier = param.tagPath.htmlTagPathIdentifier;
        return Belt_Option.map(param.parentId, function(parentId) {
            return [
                htmlTagPathIdentifier,
                parentId
            ];
        });
    }));
    return {
        htmlTagPathByHtmlTagPathIdentifier: htmlTagPathByHtmlTagPathIdentifier,
        webPageSequence: webPageSequence,
        allNodesInWebPageSequence: allNodesInWebPageSequence,
        encodedWebPageSequence: match[0],
        htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: match[1],
        htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap
    };
}
function extractSignal(client) {
    var allHtmlTagPathIdentifiers = [];
    Belt_Array.forEach(Belt_Map.keysToArray(client.htmlTagPathByHtmlTagPathIdentifier), function(htmlTagPathIdentifier) {
        var index = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toInt(htmlTagPathIdentifier);
        allHtmlTagPathIdentifiers[index] = htmlTagPathIdentifier;
    });
    var encodedHtmlTagPathIdentifierString = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(allHtmlTagPathIdentifiers)[0]);
    return {
        encodedWebPageSequenceString: STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(client.encodedWebPageSequence),
        encodedHtmlTagPathIdentifierString: encodedHtmlTagPathIdentifierString,
        htmlTagPathIdentifierParentMap: client.htmlTagPathIdentifierParentMap
    };
}
function toConcatenatedString(htmlTagPathIdentifierSequence) {
    return Belt_Array.map(htmlTagPathIdentifierSequence, STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toString).join(",");
}
function splitAtHtmlTagPathIdentifier(sequence, htmlTagPathIdentifier) {
    var splitSequence = function(htmlTagPathIdentifierSequence) {
        var len = htmlTagPathIdentifierSequence.length;
        var end_ = htmlTagPathIdentifierSequence.indexOf(htmlTagPathIdentifier);
        if (end_ === -1) {
            return {
                hd: htmlTagPathIdentifierSequence,
                tl: /* [] */ 0
            };
        }
        if (end_ !== 0) {
            return Belt_List.add(splitSequence(htmlTagPathIdentifierSequence.slice(end_, len)), htmlTagPathIdentifierSequence.slice(0, end_));
        }
        var end_$1 = htmlTagPathIdentifierSequence.indexOf(htmlTagPathIdentifier, 1);
        if (end_$1 !== -1) {
            return Belt_List.add(splitSequence(htmlTagPathIdentifierSequence.slice(end_$1, len)), htmlTagPathIdentifierSequence.slice(0, end_$1));
        } else {
            return {
                hd: htmlTagPathIdentifierSequence,
                tl: /* [] */ 0
            };
        }
    };
    return splitSequence(sequence);
}
var HtmlTagPathIdentifierSequence = {
    toConcatenatedString: toConcatenatedString,
    splitAtHtmlTagPathIdentifier: splitAtHtmlTagPathIdentifier
};
function isAncestorOf($$this, id1, id2) {
    var _id = id2;
    while(true){
        var id = _id;
        var parentId = Belt_Map.get($$this.htmlTagPathIdentifierParentMap, id);
        if (parentId === undefined) {
            return false;
        }
        var parentId$1 = Caml_option.valFromOption(parentId);
        if (Caml_obj.caml_equal(parentId$1, id1)) {
            return true;
        }
        _id = parentId$1;
        continue;
    }
    ;
}
function length(client) {
    return client.allNodesInWebPageSequence.length;
}
function getRange(client, param) {
    var startsAt = param.startsAt;
    return Belt_Array.slice(client.allNodesInWebPageSequence, startsAt, param.endsAt - startsAt | 0);
}
function sliceToEnd(client, offset) {
    return Belt_Array.sliceToEnd(client.allNodesInWebPageSequence, offset);
}
function isNodeAncestorOf(client, node1, node2) {
    return isAncestorOf(client, node1.tagPath.htmlTagPathIdentifier, node2.tagPath.htmlTagPathIdentifier);
}
function isNodeSiblingOf(_client, node1, node2) {
    return DOM__HtmlElement$SmartcutsMacros.isSiblingOf(node1.htmlElement, node2.htmlElement);
}
var include = DataExtraction__DataRegion$SmartcutsMacros.Make({
    length: length,
    getRange: getRange,
    sliceToEnd: sliceToEnd,
    isNodeAncestorOf: isNodeAncestorOf,
    isNodeSiblingOf: isNodeSiblingOf
});
var $$Range = include.$$Range;
var getNodes = include.getNodes;
var maybeAdditionalRange = include.maybeAdditionalRange;
function getHtmlElements(dataRegion, client) {
    return Belt_Array.map(Curry._2(getNodes, client, dataRegion), function(param) {
        return param.htmlElement;
    });
}
function getHtmlTagPathIdentifierSequence(param, client) {
    var match = param.fullRange;
    var startsAt = match.startsAt;
    return Belt_Array.slice(client.webPageSequence, startsAt, match.endsAt - startsAt | 0);
}
function findOccurrencesAsRanges(htmlTagPathIdentifierSequence, client) {
    var len = htmlTagPathIdentifierSequence.length;
    return Belt_Array.map(getIndexesForNodesThatMatchHtpiSequence(client.allNodesInWebPageSequence, htmlTagPathIdentifierSequence), function(startsAt) {
        var endsAt = startsAt + len | 0;
        return {
            startsAt: startsAt,
            endsAt: endsAt
        };
    });
}
function mergeIntoDataRegions(ranges, client) {
    return Belt_Array.reduce(ranges, [], function(dataRegions, range) {
        var maybeReplaceDataRegionAtIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(dataRegion, index) {
            var dataRegion$p = DataExtraction__DataRegion$SmartcutsMacros.maybeMergeWithRange(dataRegion, range);
            if (dataRegion$p !== undefined) {
                return [
                    dataRegion$p,
                    index
                ];
            } else if (Belt_Array.every(getHtmlElementsForRange(client.allNodesInWebPageSequence, range), function(childElement) {
                return Belt_Array.some(getHtmlElements(dataRegion, client), function(htmlElement) {
                    return htmlElement.contains(childElement);
                });
            })) {
                return [
                    {
                        fullRange: {
                            startsAt: Math.min(dataRegion.fullRange.startsAt, range.startsAt),
                            endsAt: Math.max(dataRegion.fullRange.endsAt, range.endsAt)
                        },
                        rangeList: Belt_List.add(dataRegion.rangeList, range),
                        additionalRange: dataRegion.additionalRange
                    },
                    index
                ];
            } else {
                return;
            }
        }, dataRegions);
        if (maybeReplaceDataRegionAtIndex !== undefined) {
            return ArrayUtils$SmartcutsMacros.replaceAtIndex(dataRegions, maybeReplaceDataRegionAtIndex[1], maybeReplaceDataRegionAtIndex[0]);
        } else {
            return Belt_Array.concat(dataRegions, [
                DataExtraction__DataRegion$SmartcutsMacros.fromRange(range)
            ]);
        }
    });
}
function maybeAppendAdditionalRanges(dataRegions, client) {
    return Belt_Array.reduce(Belt_Array.map(dataRegions, function(dataRegion) {
        var additionalRange = Curry._2(maybeAdditionalRange, client, dataRegion);
        if (additionalRange === undefined) {
            return dataRegion;
        }
        if (Belt_Array.keepMap(dataRegions, function(nextRegion) {
            return Curry._2($$Range.mergeIfOverlap, nextRegion.fullRange, additionalRange);
        }).length !== 0) {
            console.warn("Ignoring additionalRange that bleeds into nextDataRegion");
            return dataRegion;
        }
        var init = dataRegion.fullRange;
        return {
            fullRange: {
                startsAt: init.startsAt,
                endsAt: additionalRange.endsAt
            },
            rangeList: dataRegion.rangeList,
            additionalRange: additionalRange
        };
    }), [], function(dataRecords, dataRecord) {
        var maybeReplaceDataRecordAtIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(dataRecord$p1, index) {
            return Belt_Option.map(DataExtraction__DataRegion$SmartcutsMacros.maybeMergeWith(dataRecord$p1, dataRecord), function(dataRecord$p) {
                return [
                    dataRecord$p,
                    index
                ];
            });
        }, dataRecords);
        if (maybeReplaceDataRecordAtIndex !== undefined) {
            return ArrayUtils$SmartcutsMacros.replaceAtIndex(dataRecords, maybeReplaceDataRecordAtIndex[1], maybeReplaceDataRecordAtIndex[0]);
        } else {
            return Belt_Array.concat(dataRecords, [
                dataRecord
            ]);
        }
    });
}
function groupByFirstNode(dataRegions, client) {
    return Belt_MapString.valuesToArray(ArrayUtils$SmartcutsMacros.groupBy(function(dataRegion) {
        return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.toString(Caml_array.get(client.allNodesInWebPageSequence, dataRegion.fullRange.startsAt).tagPath.htmlTagPathIdentifier);
    }, dataRegions));
}
var DataRegion = {
    $$Range: $$Range,
    getNodes: getNodes,
    maybeAdditionalRange: maybeAdditionalRange,
    getHtmlElements: getHtmlElements,
    getHtmlTagPathIdentifierSequence: getHtmlTagPathIdentifierSequence,
    findOccurrencesAsRanges: findOccurrencesAsRanges,
    mergeIntoDataRegions: mergeIntoDataRegions,
    maybeAppendAdditionalRanges: maybeAppendAdditionalRanges,
    groupByFirstNode: groupByFirstNode
};
function processPatternsIntoDataRegionGroups(client, uniqueEncodedHtmlTagPathIdentifierStrings) {
    var arg = Belt_Array.map(uniqueEncodedHtmlTagPathIdentifierStrings, function(substring) {
        return STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(substring), client.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
    });
    return groupByFirstNode(maybeAppendAdditionalRanges(mergeIntoDataRegions(function(param) {
        return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
    }(function(param) {
        return findOccurrencesAsRanges(param, client);
    }), client), client), client);
}
exports.defaultFilters = defaultFilters;
exports.HtmlTagPathIdentifierGenerator = HtmlTagPathIdentifierGenerator;
exports.HtmlTagPath = HtmlTagPath;
exports.NodeWithPath = NodeWithPath;
exports.Generic = Generic$1;
exports.AllNodes = AllNodes;
exports.RangesWithScores = RangesWithScores;
exports.forAllNodesInDocument = forAllNodesInDocument;
exports.extractSignal = extractSignal;
exports.HtmlTagPathIdentifierSequence = HtmlTagPathIdentifierSequence;
exports.isAncestorOf = isAncestorOf;
exports.DataRegion = DataRegion;
exports.processPatternsIntoDataRegionGroups = processPatternsIntoDataRegionGroups; /* include Not a pure module */ 


/***/ }),

/***/ 32985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml = __webpack_require__(16253);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Json_decode = __webpack_require__(50957);
var Json_encode = __webpack_require__(82065);
var Caml_js_exceptions = __webpack_require__(74518);
var Util$SmartcutsMacros = __webpack_require__(25092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var CustomMapBuilders$SmartcutsMacros = __webpack_require__(22926);
var t_encode = Decco.intToJson;
var t_decode = Decco.intFromJson;
function toString(htmlTagPathIdentifier) {
    return String(htmlTagPathIdentifier);
}
function toInt(htmlTagPathIdentifier) {
    return htmlTagPathIdentifier;
}
var compare = Caml.caml_int_compare;
function increment(htmlTagPathIdentifier) {
    return htmlTagPathIdentifier + 1 | 0;
}
function fromInt(i) {
    return i;
}
var t_encode$1 = Decco.intToJson;
var t_decode$1 = Decco.intFromJson;
var MapHtmlTagPathIdentifier = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    cmp: compare
});
var t_encode$2 = Decco.intToJson;
var t_decode$2 = Decco.intFromJson;
var compare$1 = Caml_obj.caml_compare;
function make(htmlTagPathIdentifier) {
    return 19968 + htmlTagPathIdentifier | 0;
}
function EncodedHtmlTagPathIdentifier_fromInt(prim) {
    return prim;
}
function EncodedHtmlTagPathIdentifier_asInt(prim) {
    return prim;
}
var t_encode$3 = Decco.intToJson;
var t_decode$3 = Decco.intFromJson;
var MapEncodedHtmlTagPathIdentifier = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    cmp: compare$1
});
function t_encode$4($$this) {
    var len = $$this.length;
    var array = Caml_array.make(0, len);
    $$this.forEach(function(v, index) {
        array[index] = v;
    });
    return Json_encode.array(function(prim) {
        return prim;
    }, array);
}
function t_decode$4(json) {
    try {
        var array = Json_decode.array(Json_decode.$$int, json);
        var len = array.length;
        var $$this = new Uint16Array(len);
        array.forEach(function(v, index) {
            $$this[index] = v;
        });
        return {
            TAG: /* Ok */ 0,
            _0: $$this
        };
    } catch (raw_message) {
        var message = Caml_js_exceptions.internalToOCamlException(raw_message);
        if (message.RE_EXN_ID === Json_decode.DecodeError) {
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "",
                    message: message._1,
                    value: json
                }
            };
        }
        throw message;
    }
}
function encodeFromHtmlTagPathIdentifierSequence(sequence) {
    var encodedSequence = new Uint16Array(sequence.length);
    var dictionary1 = Belt_Array.reduceWithIndex(sequence, Curry._1(MapEncodedHtmlTagPathIdentifier.make, undefined), function(dictionary, htmlTagPathIdentifier, index) {
        var encoded = 19968 + htmlTagPathIdentifier | 0;
        encodedSequence[index] = Curry._1(EncodedHtmlTagPathIdentifier_asInt, encoded);
        return Belt_Map.set(dictionary, encoded, htmlTagPathIdentifier);
    });
    return [
        encodedSequence,
        dictionary1
    ];
}
function makeText(encodedSequence) {
    var textDecoder = Curry._1(StringUtils$SmartcutsMacros.$$TextDecoder.Utf16.make, undefined);
    return Curry._2(StringUtils$SmartcutsMacros.$$TextDecoder.Utf16.decode, textDecoder, encodedSequence);
}
function fromText(text) {
    var len = text.length;
    var encodedSequence = new Uint16Array(len);
    $$String.iteri(function(index, _char) {
        var codePoint = text.codePointAt(index);
        if (codePoint !== undefined) {
            encodedSequence[index] = codePoint;
            return;
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Got None from codePointAt(" + (String(index) + ")"));
        }
    }, text);
    return encodedSequence;
}
function decodeToHtmlTagPathIdentifierSequence(encodedSequence, dictionary) {
    var hasEndingDollarChar = encodedSequence.indexOf(36) > -1;
    var encodedSequenceAfterElidingPossibleTrailingDollarChar = hasEndingDollarChar ? encodedSequence.slice(0, encodedSequence.length - 1 | 0) : encodedSequence;
    var len = encodedSequenceAfterElidingPossibleTrailingDollarChar.length;
    var sequence = Caml_array.make(len, -1);
    encodedSequenceAfterElidingPossibleTrailingDollarChar.forEach(function(encoded, index) {
        var arg = Belt_Map.get(dictionary, Curry._1(EncodedHtmlTagPathIdentifier_fromInt, encoded));
        var htmlTagPathIdentifier = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect to find htmlTagPathIdentifier by encoded " + String(encoded));
        sequence[index] = htmlTagPathIdentifier;
    });
    return sequence;
}
function toArray(encodedSequence) {
    var array = [];
    encodedSequence.forEach(function(encodedHtmlTagPathIdentifier, index) {
        array[index] = Curry._1(EncodedHtmlTagPathIdentifier_fromInt, encodedHtmlTagPathIdentifier);
    });
    return array;
}
var EncodedHtmlTagPathIdentifierSequence = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    encodeFromHtmlTagPathIdentifierSequence: encodeFromHtmlTagPathIdentifierSequence,
    makeText: makeText,
    fromText: fromText,
    decodeToHtmlTagPathIdentifierSequence: decodeToHtmlTagPathIdentifierSequence,
    toArray: toArray
};
function signal_encode(v) {
    return Js_dict.fromArray([
        [
            "wps_enc",
            Decco.stringToJson(v.encodedWebPageSequenceString)
        ],
        [
            "htpi_enc",
            Decco.stringToJson(v.encodedHtmlTagPathIdentifierString)
        ],
        [
            "htpi_pMap",
            Curry._2(MapHtmlTagPathIdentifier.t_encode, t_encode, v.htmlTagPathIdentifierParentMap)
        ]
    ]);
}
function signal_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var encodedWebPageSequenceString = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wps_enc"), null));
    if (encodedWebPageSequenceString.TAG === /* Ok */ 0) {
        var encodedHtmlTagPathIdentifierString = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htpi_enc"), null));
        if (encodedHtmlTagPathIdentifierString.TAG === /* Ok */ 0) {
            var htmlTagPathIdentifierParentMap = Curry._2(MapHtmlTagPathIdentifier.t_decode, t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "htpi_pMap"), null));
            if (htmlTagPathIdentifierParentMap.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        encodedWebPageSequenceString: encodedWebPageSequenceString._0,
                        encodedHtmlTagPathIdentifierString: encodedHtmlTagPathIdentifierString._0,
                        htmlTagPathIdentifierParentMap: htmlTagPathIdentifierParentMap._0
                    }
                };
            }
            var e = htmlTagPathIdentifierParentMap._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".htpi_pMap" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = encodedHtmlTagPathIdentifierString._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".htpi_enc" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = encodedWebPageSequenceString._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".wps_enc" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function output_encode(v) {
    return Js_dict.fromArray([
        [
            "htpi_enc_seq",
            Decco.arrayToJson(Decco.stringToJson, v.uniqueEncodedHtmlTagPathIdentifierStrings)
        ]
    ]);
}
function output_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var uniqueEncodedHtmlTagPathIdentifierStrings = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "htpi_enc_seq"), null));
    if (uniqueEncodedHtmlTagPathIdentifierStrings.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                uniqueEncodedHtmlTagPathIdentifierStrings: uniqueEncodedHtmlTagPathIdentifierStrings._0
            }
        };
    }
    var e = uniqueEncodedHtmlTagPathIdentifierStrings._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".htpi_enc_seq" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function nodeFrequencyAndEdgeLength_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var nodeFrequencyEqualsOrGreaterThan = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeFrequencyEqualsOrGreaterThan"), null));
    if (nodeFrequencyEqualsOrGreaterThan.TAG === /* Ok */ 0) {
        var substringLengthEqualsOrGreaterThan = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "substringLengthEqualsOrGreaterThan"), null));
        if (substringLengthEqualsOrGreaterThan.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    nodeFrequencyEqualsOrGreaterThan: nodeFrequencyEqualsOrGreaterThan._0,
                    substringLengthEqualsOrGreaterThan: substringLengthEqualsOrGreaterThan._0
                }
            };
        }
        var e = substringLengthEqualsOrGreaterThan._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".substringLengthEqualsOrGreaterThan" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = nodeFrequencyEqualsOrGreaterThan._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".nodeFrequencyEqualsOrGreaterThan" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function longestCommonSubSequence_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var recordValidationRate = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordValidationRate"), null));
    if (recordValidationRate.TAG === /* Ok */ 0) {
        var patternValidationRate = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "patternValidationRate"), null));
        if (patternValidationRate.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    recordValidationRate: recordValidationRate._0,
                    patternValidationRate: patternValidationRate._0
                }
            };
        }
        var e = patternValidationRate._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".patternValidationRate" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = recordValidationRate._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".recordValidationRate" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function longestCommonSubSequence_encode(v) {
    return Js_dict.fromArray([
        [
            "recordValidationRate",
            Decco.floatToJson(v.recordValidationRate)
        ],
        [
            "patternValidationRate",
            Decco.floatToJson(v.patternValidationRate)
        ]
    ]);
}
function nodeFrequencyAndEdgeLength_encode(v) {
    return Js_dict.fromArray([
        [
            "nodeFrequencyEqualsOrGreaterThan",
            Decco.intToJson(v.nodeFrequencyEqualsOrGreaterThan)
        ],
        [
            "substringLengthEqualsOrGreaterThan",
            Decco.intToJson(v.substringLengthEqualsOrGreaterThan)
        ]
    ]);
}
function filter_encode(v) {
    if (typeof v === "number") {
        if (v === /* ByTreeStructure */ 0) {
            return [
                "ByTreeStructure"
            ];
        } else {
            return [
                "ByRepetition"
            ];
        }
    } else if (v.TAG === /* ByNodeFrequencyAndEdgeLength */ 0) {
        return [
            "ByNodeFrequencyAndEdgeLength",
            nodeFrequencyAndEdgeLength_encode(v._0)
        ];
    } else {
        return [
            "ByLongestCommonSubSequence",
            longestCommonSubSequence_encode(v._0)
        ];
    }
}
function filter_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ByLongestCommonSubSequence":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = longestCommonSubSequence_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ByLongestCommonSubSequence */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ByNodeFrequencyAndEdgeLength":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = nodeFrequencyAndEdgeLength_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ByNodeFrequencyAndEdgeLength */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ByRepetition":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ByRepetition */ 1
                    };
                }
            case "ByTreeStructure":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ByTreeStructure */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyFilterName(filter) {
    if (typeof filter === "number") {
        if (filter === /* ByTreeStructure */ 0) {
            return "ByTreeStructure";
        } else {
            return "ByRepetition";
        }
    } else if (filter.TAG === /* ByNodeFrequencyAndEdgeLength */ 0) {
        return "ByNodeFrequencyAndEdgeLength";
    } else {
        return "ByLongestCommonSubSequence";
    }
}
function HtmlTagPathIdentifier_toPrintable(prim) {
    return prim;
}
var HtmlTagPathIdentifier = {
    t_encode: t_encode,
    t_decode: t_decode,
    toInt: toInt,
    toString: toString,
    compare: compare,
    init: 0,
    increment: increment,
    fromInt: fromInt,
    toPrintable: HtmlTagPathIdentifier_toPrintable
};
var MapHtmlTagPathIdentifier_KeyCompare = {};
var MapHtmlTagPathIdentifier_t_encode = MapHtmlTagPathIdentifier.t_encode;
var MapHtmlTagPathIdentifier_t_decode = MapHtmlTagPathIdentifier.t_decode;
var MapHtmlTagPathIdentifier_make = MapHtmlTagPathIdentifier.make;
var MapHtmlTagPathIdentifier_fromArray = MapHtmlTagPathIdentifier.fromArray;
var MapHtmlTagPathIdentifier$1 = {
    KeyCompare: MapHtmlTagPathIdentifier_KeyCompare,
    t_encode: MapHtmlTagPathIdentifier_t_encode,
    t_decode: MapHtmlTagPathIdentifier_t_decode,
    make: MapHtmlTagPathIdentifier_make,
    fromArray: MapHtmlTagPathIdentifier_fromArray
};
var EncodedHtmlTagPathIdentifier = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    make: make
};
var MapEncodedHtmlTagPathIdentifier_KeyCompare = {};
var MapEncodedHtmlTagPathIdentifier_t_encode = MapEncodedHtmlTagPathIdentifier.t_encode;
var MapEncodedHtmlTagPathIdentifier_t_decode = MapEncodedHtmlTagPathIdentifier.t_decode;
var MapEncodedHtmlTagPathIdentifier_make = MapEncodedHtmlTagPathIdentifier.make;
var MapEncodedHtmlTagPathIdentifier_fromArray = MapEncodedHtmlTagPathIdentifier.fromArray;
var MapEncodedHtmlTagPathIdentifier$1 = {
    KeyCompare: MapEncodedHtmlTagPathIdentifier_KeyCompare,
    t_encode: MapEncodedHtmlTagPathIdentifier_t_encode,
    t_decode: MapEncodedHtmlTagPathIdentifier_t_decode,
    make: MapEncodedHtmlTagPathIdentifier_make,
    fromArray: MapEncodedHtmlTagPathIdentifier_fromArray
};
exports.HtmlTagPathIdentifier = HtmlTagPathIdentifier;
exports.MapHtmlTagPathIdentifier = MapHtmlTagPathIdentifier$1;
exports.EncodedHtmlTagPathIdentifier = EncodedHtmlTagPathIdentifier;
exports.MapEncodedHtmlTagPathIdentifier = MapEncodedHtmlTagPathIdentifier$1;
exports.EncodedHtmlTagPathIdentifierSequence = EncodedHtmlTagPathIdentifierSequence;
exports.signal_encode = signal_encode;
exports.signal_decode = signal_decode;
exports.output_encode = output_encode;
exports.output_decode = output_decode;
exports.filter_encode = filter_encode;
exports.filter_decode = filter_decode;
exports.nodeFrequencyAndEdgeLength_encode = nodeFrequencyAndEdgeLength_encode;
exports.nodeFrequencyAndEdgeLength_decode = nodeFrequencyAndEdgeLength_decode;
exports.longestCommonSubSequence_encode = longestCommonSubSequence_encode;
exports.longestCommonSubSequence_decode = longestCommonSubSequence_decode;
exports.stringifyFilterName = stringifyFilterName; /* MapHtmlTagPathIdentifier Not a pure module */ 


/***/ }),

/***/ 14519:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
function init(oldLen, newLen) {
    var indexOffset = oldLen + newLen | 0;
    return {
        indexOffset: indexOffset,
        contents: Caml_array.make(indexOffset << 1, undefined)
    };
}
function get($$this, diagonalIndex) {
    return Belt_Option.flatMap(Belt_Array.get($$this.contents, diagonalIndex + $$this.indexOffset | 0), function(x) {
        return x;
    });
}
function set($$this, diagonalIndex, path) {
    $$this.contents[diagonalIndex + $$this.indexOffset | 0] = path;
}
function mapWithDiagonalIndex(f, $$this) {
    return Belt_Array.map(Belt_Array.keepMap(Belt_Array.mapWithIndex($$this.contents, function(index, maybePath) {
        return Belt_Option.map(maybePath, function(path) {
            return [
                index,
                path
            ];
        });
    }), function(x) {
        return x;
    }), function(param) {
        var diagonalIndex = param[0] - $$this.indexOffset | 0;
        return Curry._2(f, diagonalIndex, param[1]);
    });
}
var BestPaths = {
    init: init,
    get: get,
    set: set,
    mapWithDiagonalIndex: mapWithDiagonalIndex
};
function Make(Type) {
    var _$init$1 = function _$init$1(s1, s2) {
        var oldLen = Curry._1(Type.length, s1);
        var newLen = Curry._1(Type.length, s2);
        var bestPaths = init(oldLen, newLen);
        set(bestPaths, 1, {
            location: [
                0,
                -1
            ],
            components: []
        });
        return {
            s1: s1,
            s2: s2,
            oldLen: oldLen,
            newLen: newLen,
            bestPaths: bestPaths,
            editLength: 0
        };
    };
    var _$execEditLength = function _$execEditLength(context) {
        var editLength = context.editLength;
        var bestPaths = context.bestPaths;
        var newLen = context.newLen;
        var oldLen = context.oldLen;
        var s2 = context.s2;
        var s1 = context.s1;
        var execCommon = function execCommon($$location, components) {
            var y1 = $$location[1];
            var x1 = $$location[0];
            var extractCommon = function(x, y) {
                if (x >= oldLen || y >= newLen) {
                    return 0;
                }
                var a = Curry._2(Type.get, s1, x);
                var b = Curry._2(Type.get, s2, y);
                if (Curry._2(Type.isIdenticalTo, a, b)) {
                    return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
                } else {
                    return 0;
                }
            };
            var d = extractCommon(x1, y1);
            if (d !== 0) {
                return {
                    location: [
                        x1 + d | 0,
                        y1 + d | 0
                    ],
                    components: Belt_Array.concat(components, [
                        {
                            TAG: /* NoEdit */ 2,
                            _0: [
                                $$location,
                                d
                            ]
                        }
                    ])
                };
            } else {
                return {
                    location: $$location,
                    components: components
                };
            }
        };
        var _diagonalIndex = -editLength | 0;
        while(true){
            var diagonalIndex = _diagonalIndex;
            if (diagonalIndex > editLength) {
                return;
            }
            var match = get(bestPaths, diagonalIndex - 1 | 0);
            var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
            var match$2;
            var exit = 0;
            if (diagonalIndex === (-editLength | 0)) {
                var match$3 = match$1 !== undefined ? [
                    match$1.location,
                    match$1.components
                ] : [
                    [
                        0,
                        editLength
                    ],
                    []
                ];
                var $$location1 = match$3[0];
                match$2 = [
                    [
                        $$location1[0],
                        $$location1[1] + 1 | 0
                    ],
                    Belt_Array.concat(match$3[1], [
                        {
                            TAG: /* Add */ 0,
                            _0: [
                                $$location1,
                                1
                            ]
                        }
                    ])
                ];
            } else if (match !== undefined && match$1 !== undefined) {
                var $$location$1 = match$1.location;
                var xRemove = $$location$1[0];
                if (diagonalIndex !== editLength && match.location[0] < xRemove) {
                    match$2 = [
                        [
                            xRemove,
                            $$location$1[1] + 1 | 0
                        ],
                        Belt_Array.concat(match$1.components, [
                            {
                                TAG: /* Add */ 0,
                                _0: [
                                    $$location$1,
                                    1
                                ]
                            }
                        ])
                    ];
                } else {
                    exit = 1;
                }
            } else {
                exit = 1;
            }
            if (exit === 1) {
                var match$4 = match !== undefined ? [
                    match.location,
                    match.components
                ] : [
                    [
                        editLength,
                        0
                    ],
                    []
                ];
                var $$location$2 = match$4[0];
                match$2 = [
                    [
                        $$location$2[0] + 1 | 0,
                        $$location$2[1]
                    ],
                    Belt_Array.concat(match$4[1], [
                        {
                            TAG: /* Remove */ 1,
                            _0: [
                                $$location$2,
                                1
                            ]
                        }
                    ])
                ];
            }
            var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
            set(bestPaths, diagonalIndex, pathByEditAndSnake);
            var match$5 = pathByEditAndSnake.location;
            if (match$5[0] >= oldLen && match$5[1] >= newLen) {
                return pathByEditAndSnake.components;
            }
            _diagonalIndex = diagonalIndex + 2 | 0;
            continue;
        }
        ;
    };
    var _$collapseConsecutiveEdits = function _$collapseConsecutiveEdits(components) {
        return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs(function(c1, c2, _remainingCommands) {
            switch(c1.TAG | 0){
                case /* Add */ 0:
                    var match = c1._0;
                    var loc1 = match[0];
                    if (loc1[1] === -1) {
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: c2
                        };
                    }
                    switch(c2.TAG | 0){
                        case /* Add */ 0:
                            return {
                                TAG: /* ReplaceWith */ 0,
                                _0: {
                                    TAG: /* Add */ 0,
                                    _0: [
                                        loc1,
                                        match[1] + c2._0[1] | 0
                                    ]
                                }
                            };
                        case /* Remove */ 1:
                        case /* NoEdit */ 2:
                            return /* KeepBoth */ 0;
                    }
                case /* Remove */ 1:
                    var match$1 = c1._0;
                    var loc1$1 = match$1[0];
                    if (loc1$1[1] === -1) {
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: c2
                        };
                    }
                    switch(c2.TAG | 0){
                        case /* Remove */ 1:
                            return {
                                TAG: /* ReplaceWith */ 0,
                                _0: {
                                    TAG: /* Remove */ 1,
                                    _0: [
                                        loc1$1,
                                        match$1[1] + c2._0[1] | 0
                                    ]
                                }
                            };
                        case /* Add */ 0:
                        case /* NoEdit */ 2:
                            return /* KeepBoth */ 0;
                    }
                case /* NoEdit */ 2:
                    return /* KeepBoth */ 0;
            }
        }, $$Array.to_list(components)));
    };
    var _$populateEditScriptWithValues = function _$populateEditScriptWithValues(context, component) {
        var s1 = context.s1;
        switch(component.TAG | 0){
            case /* Add */ 0:
                var match = component._0;
                return {
                    TAG: /* Add */ 0,
                    _0: Curry._3(Type.slice, context.s2, match[0][1], match[1])
                };
            case /* Remove */ 1:
                var match$1 = component._0;
                return {
                    TAG: /* Remove */ 1,
                    _0: Curry._3(Type.slice, s1, match$1[0][0], match$1[1])
                };
            case /* NoEdit */ 2:
                var match$2 = component._0;
                return {
                    TAG: /* NoEdit */ 2,
                    _0: Curry._3(Type.slice, s1, match$2[0][0], match$2[1])
                };
        }
    };
    var _$findShortestEditScript = function _$findShortestEditScript(s1, s2) {
        var search = function search(_context) {
            while(true){
                var context = _context;
                var result = _$execEditLength(context);
                if (result !== undefined) {
                    return [
                        result,
                        context
                    ];
                }
                _context = {
                    s1: context.s1,
                    s2: context.s2,
                    oldLen: context.oldLen,
                    newLen: context.newLen,
                    bestPaths: context.bestPaths,
                    editLength: context.editLength + 1 | 0
                };
                continue;
            }
            ;
        };
        var match = search(_$init$1(s1, s2));
        var context1 = match[1];
        return Belt_Array.map(_$collapseConsecutiveEdits(match[0]), function(param) {
            return _$populateEditScriptWithValues(context1, param);
        });
    };
    return {
        init: _$init$1,
        execEditLength: _$execEditLength,
        collapseConsecutiveEdits: _$collapseConsecutiveEdits,
        populateEditScriptWithValues: _$populateEditScriptWithValues,
        findShortestEditScript: _$findShortestEditScript
    };
}
function slice(str, from, len) {
    return str.slice(from, from + len | 0);
}
function init$1(s1, s2) {
    var oldLen = s1.length;
    var newLen = s2.length;
    var bestPaths = init(oldLen, newLen);
    set(bestPaths, 1, {
        location: [
            0,
            -1
        ],
        components: []
    });
    return {
        s1: s1,
        s2: s2,
        oldLen: oldLen,
        newLen: newLen,
        bestPaths: bestPaths,
        editLength: 0
    };
}
function execEditLength(context) {
    var editLength = context.editLength;
    var bestPaths = context.bestPaths;
    var newLen = context.newLen;
    var oldLen = context.oldLen;
    var s2 = context.s2;
    var s1 = context.s1;
    var execCommon = function execCommon($$location, components) {
        var y2 = $$location[1];
        var x2 = $$location[0];
        var extractCommon = function(x, y) {
            if (x >= oldLen || y >= newLen) {
                return 0;
            }
            var a = s1.charAt(x);
            var b = s2.charAt(y);
            if (Caml_obj.caml_equal(a, b)) {
                return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
            } else {
                return 0;
            }
        };
        var d = extractCommon(x2, y2);
        if (d !== 0) {
            return {
                location: [
                    x2 + d | 0,
                    y2 + d | 0
                ],
                components: Belt_Array.concat(components, [
                    {
                        TAG: /* NoEdit */ 2,
                        _0: [
                            $$location,
                            d
                        ]
                    }
                ])
            };
        } else {
            return {
                location: $$location,
                components: components
            };
        }
    };
    var _diagonalIndex = -editLength | 0;
    while(true){
        var diagonalIndex = _diagonalIndex;
        if (diagonalIndex > editLength) {
            return;
        }
        var match = get(bestPaths, diagonalIndex - 1 | 0);
        var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
        var match$2;
        var exit = 0;
        if (diagonalIndex === (-editLength | 0)) {
            var match$3 = match$1 !== undefined ? [
                match$1.location,
                match$1.components
            ] : [
                [
                    0,
                    editLength
                ],
                []
            ];
            var $$location2 = match$3[0];
            match$2 = [
                [
                    $$location2[0],
                    $$location2[1] + 1 | 0
                ],
                Belt_Array.concat(match$3[1], [
                    {
                        TAG: /* Add */ 0,
                        _0: [
                            $$location2,
                            1
                        ]
                    }
                ])
            ];
        } else if (match !== undefined && match$1 !== undefined) {
            var $$location$1 = match$1.location;
            var xRemove = $$location$1[0];
            if (diagonalIndex !== editLength && match.location[0] < xRemove) {
                match$2 = [
                    [
                        xRemove,
                        $$location$1[1] + 1 | 0
                    ],
                    Belt_Array.concat(match$1.components, [
                        {
                            TAG: /* Add */ 0,
                            _0: [
                                $$location$1,
                                1
                            ]
                        }
                    ])
                ];
            } else {
                exit = 1;
            }
        } else {
            exit = 1;
        }
        if (exit === 1) {
            var match$4 = match !== undefined ? [
                match.location,
                match.components
            ] : [
                [
                    editLength,
                    0
                ],
                []
            ];
            var $$location$2 = match$4[0];
            match$2 = [
                [
                    $$location$2[0] + 1 | 0,
                    $$location$2[1]
                ],
                Belt_Array.concat(match$4[1], [
                    {
                        TAG: /* Remove */ 1,
                        _0: [
                            $$location$2,
                            1
                        ]
                    }
                ])
            ];
        }
        var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
        set(bestPaths, diagonalIndex, pathByEditAndSnake);
        var match$5 = pathByEditAndSnake.location;
        if (match$5[0] >= oldLen && match$5[1] >= newLen) {
            return pathByEditAndSnake.components;
        }
        _diagonalIndex = diagonalIndex + 2 | 0;
        continue;
    }
    ;
}
function collapseConsecutiveEdits(components) {
    return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs(function(c1, c2, _remainingCommands) {
        switch(c1.TAG | 0){
            case /* Add */ 0:
                var match = c1._0;
                var loc1 = match[0];
                if (loc1[1] === -1) {
                    return {
                        TAG: /* ReplaceWith */ 0,
                        _0: c2
                    };
                }
                switch(c2.TAG | 0){
                    case /* Add */ 0:
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: {
                                TAG: /* Add */ 0,
                                _0: [
                                    loc1,
                                    match[1] + c2._0[1] | 0
                                ]
                            }
                        };
                    case /* Remove */ 1:
                    case /* NoEdit */ 2:
                        return /* KeepBoth */ 0;
                }
            case /* Remove */ 1:
                var match$1 = c1._0;
                var loc1$1 = match$1[0];
                if (loc1$1[1] === -1) {
                    return {
                        TAG: /* ReplaceWith */ 0,
                        _0: c2
                    };
                }
                switch(c2.TAG | 0){
                    case /* Remove */ 1:
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: {
                                TAG: /* Remove */ 1,
                                _0: [
                                    loc1$1,
                                    match$1[1] + c2._0[1] | 0
                                ]
                            }
                        };
                    case /* Add */ 0:
                    case /* NoEdit */ 2:
                        return /* KeepBoth */ 0;
                }
            case /* NoEdit */ 2:
                return /* KeepBoth */ 0;
        }
    }, $$Array.to_list(components)));
}
function populateEditScriptWithValues(context, component) {
    var s1 = context.s1;
    switch(component.TAG | 0){
        case /* Add */ 0:
            var match = component._0;
            return {
                TAG: /* Add */ 0,
                _0: slice(context.s2, match[0][1], match[1])
            };
        case /* Remove */ 1:
            var match$1 = component._0;
            return {
                TAG: /* Remove */ 1,
                _0: slice(s1, match$1[0][0], match$1[1])
            };
        case /* NoEdit */ 2:
            var match$2 = component._0;
            return {
                TAG: /* NoEdit */ 2,
                _0: slice(s1, match$2[0][0], match$2[1])
            };
    }
}
function findShortestEditScript(s1, s2) {
    var search = function search(_context) {
        while(true){
            var context = _context;
            var result = execEditLength(context);
            if (result !== undefined) {
                return [
                    result,
                    context
                ];
            }
            _context = {
                s1: context.s1,
                s2: context.s2,
                oldLen: context.oldLen,
                newLen: context.newLen,
                bestPaths: context.bestPaths,
                editLength: context.editLength + 1 | 0
            };
            continue;
        }
        ;
    };
    var match = search(init$1(s1, s2));
    var context2 = match[1];
    return Belt_Array.map(collapseConsecutiveEdits(match[0]), function(param) {
        return populateEditScriptWithValues(context2, param);
    });
}
var Debug = {
    init: init$1,
    execEditLength: execEditLength,
    collapseConsecutiveEdits: collapseConsecutiveEdits,
    populateEditScriptWithValues: populateEditScriptWithValues
};
var $$String = {
    findShortestEditScript: findShortestEditScript,
    Debug: Debug
};
function MakeArray(Item) {
    var isIdenticalTo = Item.isIdenticalTo;
    var init$2 = function init$2(s1, s2) {
        var oldLen = s1.length;
        var newLen = s2.length;
        var bestPaths = init(oldLen, newLen);
        set(bestPaths, 1, {
            location: [
                0,
                -1
            ],
            components: []
        });
        return {
            s1: s1,
            s2: s2,
            oldLen: oldLen,
            newLen: newLen,
            bestPaths: bestPaths,
            editLength: 0
        };
    };
    var _$execEditLength = function _$execEditLength(context) {
        var editLength = context.editLength;
        var bestPaths = context.bestPaths;
        var newLen = context.newLen;
        var oldLen = context.oldLen;
        var s2 = context.s2;
        var s1 = context.s1;
        var execCommon = function execCommon($$location, components) {
            var y3 = $$location[1];
            var x3 = $$location[0];
            var extractCommon = function(x, y) {
                if (x >= oldLen || y >= newLen) {
                    return 0;
                }
                var a = Caml_array.get(s1, x);
                var b = Caml_array.get(s2, y);
                if (Curry._2(isIdenticalTo, a, b)) {
                    return 1 + extractCommon(x + 1 | 0, y + 1 | 0) | 0;
                } else {
                    return 0;
                }
            };
            var d = extractCommon(x3, y3);
            if (d !== 0) {
                return {
                    location: [
                        x3 + d | 0,
                        y3 + d | 0
                    ],
                    components: Belt_Array.concat(components, [
                        {
                            TAG: /* NoEdit */ 2,
                            _0: [
                                $$location,
                                d
                            ]
                        }
                    ])
                };
            } else {
                return {
                    location: $$location,
                    components: components
                };
            }
        };
        var _diagonalIndex = -editLength | 0;
        while(true){
            var diagonalIndex = _diagonalIndex;
            if (diagonalIndex > editLength) {
                return;
            }
            var match = get(bestPaths, diagonalIndex - 1 | 0);
            var match$1 = get(bestPaths, diagonalIndex + 1 | 0);
            var match$2;
            var exit = 0;
            if (diagonalIndex === (-editLength | 0)) {
                var match$3 = match$1 !== undefined ? [
                    match$1.location,
                    match$1.components
                ] : [
                    [
                        0,
                        editLength
                    ],
                    []
                ];
                var $$location3 = match$3[0];
                match$2 = [
                    [
                        $$location3[0],
                        $$location3[1] + 1 | 0
                    ],
                    Belt_Array.concat(match$3[1], [
                        {
                            TAG: /* Add */ 0,
                            _0: [
                                $$location3,
                                1
                            ]
                        }
                    ])
                ];
            } else if (match !== undefined && match$1 !== undefined) {
                var $$location$1 = match$1.location;
                var xRemove = $$location$1[0];
                if (diagonalIndex !== editLength && match.location[0] < xRemove) {
                    match$2 = [
                        [
                            xRemove,
                            $$location$1[1] + 1 | 0
                        ],
                        Belt_Array.concat(match$1.components, [
                            {
                                TAG: /* Add */ 0,
                                _0: [
                                    $$location$1,
                                    1
                                ]
                            }
                        ])
                    ];
                } else {
                    exit = 1;
                }
            } else {
                exit = 1;
            }
            if (exit === 1) {
                var match$4 = match !== undefined ? [
                    match.location,
                    match.components
                ] : [
                    [
                        editLength,
                        0
                    ],
                    []
                ];
                var $$location$2 = match$4[0];
                match$2 = [
                    [
                        $$location$2[0] + 1 | 0,
                        $$location$2[1]
                    ],
                    Belt_Array.concat(match$4[1], [
                        {
                            TAG: /* Remove */ 1,
                            _0: [
                                $$location$2,
                                1
                            ]
                        }
                    ])
                ];
            }
            var pathByEditAndSnake = execCommon(match$2[0], match$2[1]);
            set(bestPaths, diagonalIndex, pathByEditAndSnake);
            var match$5 = pathByEditAndSnake.location;
            if (match$5[0] >= oldLen && match$5[1] >= newLen) {
                return pathByEditAndSnake.components;
            }
            _diagonalIndex = diagonalIndex + 2 | 0;
            continue;
        }
        ;
    };
    var _$collapseConsecutiveEdits = function _$collapseConsecutiveEdits(components) {
        return $$Array.of_list(ListUtils$SmartcutsMacros.collapsePairs(function(c1, c2, _remainingCommands) {
            switch(c1.TAG | 0){
                case /* Add */ 0:
                    var match = c1._0;
                    var loc1 = match[0];
                    if (loc1[1] === -1) {
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: c2
                        };
                    }
                    switch(c2.TAG | 0){
                        case /* Add */ 0:
                            return {
                                TAG: /* ReplaceWith */ 0,
                                _0: {
                                    TAG: /* Add */ 0,
                                    _0: [
                                        loc1,
                                        match[1] + c2._0[1] | 0
                                    ]
                                }
                            };
                        case /* Remove */ 1:
                        case /* NoEdit */ 2:
                            return /* KeepBoth */ 0;
                    }
                case /* Remove */ 1:
                    var match$1 = c1._0;
                    var loc1$1 = match$1[0];
                    if (loc1$1[1] === -1) {
                        return {
                            TAG: /* ReplaceWith */ 0,
                            _0: c2
                        };
                    }
                    switch(c2.TAG | 0){
                        case /* Remove */ 1:
                            return {
                                TAG: /* ReplaceWith */ 0,
                                _0: {
                                    TAG: /* Remove */ 1,
                                    _0: [
                                        loc1$1,
                                        match$1[1] + c2._0[1] | 0
                                    ]
                                }
                            };
                        case /* Add */ 0:
                        case /* NoEdit */ 2:
                            return /* KeepBoth */ 0;
                    }
                case /* NoEdit */ 2:
                    return /* KeepBoth */ 0;
            }
        }, $$Array.to_list(components)));
    };
    var _$findShortestEditScript = function _$findShortestEditScript(s1, s2) {
        var search = function search(_context) {
            while(true){
                var context = _context;
                var result = _$execEditLength(context);
                if (result !== undefined) {
                    return [
                        result,
                        context
                    ];
                }
                _context = {
                    s1: context.s1,
                    s2: context.s2,
                    oldLen: context.oldLen,
                    newLen: context.newLen,
                    bestPaths: context.bestPaths,
                    editLength: context.editLength + 1 | 0
                };
                continue;
            }
            ;
        };
        var match1 = search(init$2(s1, s2));
        var context3 = match1[1];
        return Belt_Array.map(_$collapseConsecutiveEdits(match1[0]), function(param) {
            var _$s1 = context3.s1;
            switch(param.TAG | 0){
                case /* Add */ 0:
                    var match = param._0;
                    return {
                        TAG: /* Add */ 0,
                        _0: Belt_Array.slice(context3.s2, match[0][1], match[1])
                    };
                case /* Remove */ 1:
                    var match$1 = param._0;
                    return {
                        TAG: /* Remove */ 1,
                        _0: Belt_Array.slice(_$s1, match$1[0][0], match$1[1])
                    };
                case /* NoEdit */ 2:
                    var match$2 = param._0;
                    return {
                        TAG: /* NoEdit */ 2,
                        _0: Belt_Array.slice(_$s1, match$2[0][0], match$2[1])
                    };
            }
        });
    };
    return {
        findShortestEditScript: _$findShortestEditScript
    };
}
function commandContent(command) {
    return command._0;
}
function findArrangements(editScript) {
    var _arrangmentsOpt;
    var _indexOpt;
    var _param;
    while(true){
        var arrangmentsOpt = _arrangmentsOpt;
        var indexOpt = _indexOpt;
        var arrangments = arrangmentsOpt !== undefined ? arrangmentsOpt : [
            []
        ];
        var index = indexOpt !== undefined ? indexOpt : 0;
        var match2 = Belt_Array.get(editScript, index);
        var match$1 = Belt_Array.get(editScript, index + 1 | 0);
        if (match2 === undefined) {
            return arrangments;
        }
        switch(match2.TAG | 0){
            case /* Remove */ 1:
                if (match$1 !== undefined) {
                    var removed1 = match2._0;
                    switch(match$1.TAG | 0){
                        case /* Add */ 0:
                            var added1 = match$1._0;
                            _param = undefined;
                            _indexOpt = index + 2 | 0;
                            _arrangmentsOpt = Belt_Array.concat(Belt_Array.map(arrangments, function(removed, added) {
                                return function(propertySchemas) {
                                    return Belt_Array.concat(Belt_Array.concat(propertySchemas, removed), added);
                                };
                            }(removed1, added1)), Belt_Array.map(arrangments, function(removed, added) {
                                return function(propertySchemas) {
                                    return Belt_Array.concat(Belt_Array.concat(propertySchemas, added), removed);
                                };
                            }(removed1, added1)));
                            continue;
                        case /* Remove */ 1:
                        case /* NoEdit */ 2:
                            break;
                    }
                }
                break;
            case /* Add */ 0:
            case /* NoEdit */ 2:
                break;
        }
        if (match$1 === undefined) {
            return Belt_Array.map(arrangments, function(match) {
                return function(propertySchemas) {
                    return Belt_Array.concat(propertySchemas, match._0);
                };
            }(match2));
        }
        _param = undefined;
        _indexOpt = index + 1 | 0;
        _arrangmentsOpt = Belt_Array.map(arrangments, function(match) {
            return function(propertySchemas) {
                return Belt_Array.concat(propertySchemas, match._0);
            };
        }(match2));
        continue;
    }
    ;
}
exports.BestPaths = BestPaths;
exports.Make = Make;
exports.$$String = $$String;
exports.MakeArray = MakeArray;
exports.commandContent = commandContent;
exports.findArrangements = findArrangements; /* No side effect */ 


/***/ }),

/***/ 45694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var GoogleApis__Sheets__BatchUpdate$SmartcutsMacros = __webpack_require__(71097);
var GoogleApis__Sheets__DeveloperMetadata$SmartcutsMacros = __webpack_require__(17985);
function load(param) {
    return new Promise(function(resolve, param) {
        gapi.client.load("sheets", "v4", function(param) {
            var client = gapi.client.sheets;
            return resolve(client);
        });
    });
}
var Create = {};
function create(accessToken, alt, callback, fields, key, oauthToken, prettyPrint, quotaUser, uploadProtocol, uploadType, resource, client) {
    return client.spreadsheets.create({
        access_token: accessToken,
        alt: alt,
        callback: callback,
        fields: fields,
        key: key,
        oauth_token: oauthToken,
        prettyPrint: prettyPrint,
        quotaUser: quotaUser,
        upload_protocol: uploadProtocol,
        uploadType: uploadType,
        resource: resource
    }).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var Get = {};
function get(accessToken, alt, callback, fields, includeGridData, key, oauthToken, prettyPrint, quotaUser, ranges, spreadsheetId, uploadProtocol, uploadType, client) {
    return client.spreadsheets.get({
        access_token: accessToken,
        alt: alt,
        callback: callback,
        fields: fields,
        includeGridData: includeGridData,
        key: key,
        oauth_token: oauthToken,
        prettyPrint: prettyPrint,
        quotaUser: quotaUser,
        ranges: ranges,
        spreadsheetId: spreadsheetId,
        upload_protocol: uploadProtocol,
        uploadType: uploadType
    }).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var BatchUpdate = GoogleApis__Sheets__BatchUpdate$SmartcutsMacros;
function batchUpdate(spreadsheetId, accessToken, requestBody, client) {
    return client.spreadsheets.batchUpdate({
        access_token: accessToken,
        spreadsheetId: spreadsheetId
    }, requestBody).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var DeveloperMetadata = GoogleApis__Sheets__DeveloperMetadata$SmartcutsMacros;
function searchDeveloperMetadata(spreadsheetId, accessToken, requestBody, client) {
    return client.spreadsheets.developerMetadata.search({
        access_token: accessToken,
        spreadsheetId: spreadsheetId
    }, requestBody).then(function(param) {
        return Promise.resolve(param.result);
    });
}
var Shared;
var Schema;
var Values;
exports.Shared = Shared;
exports.load = load;
exports.Schema = Schema;
exports.Create = Create;
exports.create = create;
exports.Get = Get;
exports.get = get;
exports.Values = Values;
exports.BatchUpdate = BatchUpdate;
exports.batchUpdate = batchUpdate;
exports.DeveloperMetadata = DeveloperMetadata;
exports.searchDeveloperMetadata = searchDeveloperMetadata; /* GoogleApis__Sheets__BatchUpdate-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 71097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var UpdateSpreadsheetPropertiesRequest = {};
var UpdateSheetPropertiesRequest = {};
var UpdateDimensionPropertiesRequest = {};
var UpdateNamedRangeRequest = {};
var RepeatCellRequest = {};
var AddNamedRangeRequest = {};
var DeleteNamedRangeRequest = {};
var AddSheetRequest = {};
var DeleteSheetRequest = {};
var AutoFillRequest = {};
var CutPasteRequest = {};
var CopyPasteRequest = {};
var MergeCellsRequest = {};
var UnmergeCellsRequest = {};
var UpdateBordersRequest = {};
var UpdateCellsRequest = {};
var AddFilterViewRequest = {};
var AppendCellsRequest = {};
var ClearBasicFilterRequest = {};
var DeleteDimensionRequest = {};
var DeleteEmbeddedObjectRequest = {};
var DeleteFilterViewRequest = {};
var DuplicateFilterViewRequest = {};
var DuplicateSheetRequest = {};
var FindReplaceRequest = {};
var InsertDimensionRequest = {};
var InsertRangeRequest = {};
var MoveDimensionRequest = {};
var UpdateEmbeddedObjectPositionRequest = {};
var PasteDataRequest = {};
var TextToColumnsRequest = {};
var UpdateFilterViewRequest = {};
var DeleteRangeRequest = {};
var AppendDimensionRequest = {};
var AddConditionalFormatRuleRequest = {};
var UpdateConditionalFormatRuleRequest = {};
var DeleteConditionalFormatRuleRequest = {};
var SortRangeRequest = {};
var SetDataValidationRequest = {};
var SetBasicFilterRequest = {};
var AddProtectedRangeRequest = {};
var UpdateProtectedRangeRequest = {};
var DeleteProtectedRangeRequest = {};
var AutoResizeDimensionsRequest = {};
var AddChartRequest = {};
var UpdateChartSpecRequest = {};
var UpdateBandingRequest = {};
var AddBandingRequest = {};
var DeleteBandingRequest = {};
var CreateDeveloperMetadataRequest = {};
var UpdateDeveloperMetadataRequest = {};
var DeleteDeveloperMetadataRequest = {};
var RandomizeRangeRequest = {};
var AddDimensionGroupRequest = {};
var DeleteDimensionGroupRequest = {};
var UpdateDimensionGroupRequest = {};
var TrimWhitespaceRequest = {};
var DeleteDuplicatesRequest = {};
var UpdateEmbeddedObjectBorderRequest = {};
var AddSlicerRequest = {};
var UpdateSlicerSpecRequest = {};
var AddDataSourceRequest = {};
var UpdateDataSourceRequest = {};
var DeleteDataSourceRequest = {};
var RefreshDataSourceRequest = {};
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
var t_encode = include.t_encode;
var t_decode = include.t_decode;
var $$Request = {
    t_encode: t_encode,
    t_decode: t_decode
};
var Requests = {
    UpdateSpreadsheetPropertiesRequest: UpdateSpreadsheetPropertiesRequest,
    UpdateSheetPropertiesRequest: UpdateSheetPropertiesRequest,
    UpdateDimensionPropertiesRequest: UpdateDimensionPropertiesRequest,
    UpdateNamedRangeRequest: UpdateNamedRangeRequest,
    RepeatCellRequest: RepeatCellRequest,
    AddNamedRangeRequest: AddNamedRangeRequest,
    DeleteNamedRangeRequest: DeleteNamedRangeRequest,
    AddSheetRequest: AddSheetRequest,
    DeleteSheetRequest: DeleteSheetRequest,
    AutoFillRequest: AutoFillRequest,
    CutPasteRequest: CutPasteRequest,
    CopyPasteRequest: CopyPasteRequest,
    MergeCellsRequest: MergeCellsRequest,
    UnmergeCellsRequest: UnmergeCellsRequest,
    UpdateBordersRequest: UpdateBordersRequest,
    UpdateCellsRequest: UpdateCellsRequest,
    AddFilterViewRequest: AddFilterViewRequest,
    AppendCellsRequest: AppendCellsRequest,
    ClearBasicFilterRequest: ClearBasicFilterRequest,
    DeleteDimensionRequest: DeleteDimensionRequest,
    DeleteEmbeddedObjectRequest: DeleteEmbeddedObjectRequest,
    DeleteFilterViewRequest: DeleteFilterViewRequest,
    DuplicateFilterViewRequest: DuplicateFilterViewRequest,
    DuplicateSheetRequest: DuplicateSheetRequest,
    FindReplaceRequest: FindReplaceRequest,
    InsertDimensionRequest: InsertDimensionRequest,
    InsertRangeRequest: InsertRangeRequest,
    MoveDimensionRequest: MoveDimensionRequest,
    UpdateEmbeddedObjectPositionRequest: UpdateEmbeddedObjectPositionRequest,
    PasteDataRequest: PasteDataRequest,
    TextToColumnsRequest: TextToColumnsRequest,
    UpdateFilterViewRequest: UpdateFilterViewRequest,
    DeleteRangeRequest: DeleteRangeRequest,
    AppendDimensionRequest: AppendDimensionRequest,
    AddConditionalFormatRuleRequest: AddConditionalFormatRuleRequest,
    UpdateConditionalFormatRuleRequest: UpdateConditionalFormatRuleRequest,
    DeleteConditionalFormatRuleRequest: DeleteConditionalFormatRuleRequest,
    SortRangeRequest: SortRangeRequest,
    SetDataValidationRequest: SetDataValidationRequest,
    SetBasicFilterRequest: SetBasicFilterRequest,
    AddProtectedRangeRequest: AddProtectedRangeRequest,
    UpdateProtectedRangeRequest: UpdateProtectedRangeRequest,
    DeleteProtectedRangeRequest: DeleteProtectedRangeRequest,
    AutoResizeDimensionsRequest: AutoResizeDimensionsRequest,
    AddChartRequest: AddChartRequest,
    UpdateChartSpecRequest: UpdateChartSpecRequest,
    UpdateBandingRequest: UpdateBandingRequest,
    AddBandingRequest: AddBandingRequest,
    DeleteBandingRequest: DeleteBandingRequest,
    CreateDeveloperMetadataRequest: CreateDeveloperMetadataRequest,
    UpdateDeveloperMetadataRequest: UpdateDeveloperMetadataRequest,
    DeleteDeveloperMetadataRequest: DeleteDeveloperMetadataRequest,
    RandomizeRangeRequest: RandomizeRangeRequest,
    AddDimensionGroupRequest: AddDimensionGroupRequest,
    DeleteDimensionGroupRequest: DeleteDimensionGroupRequest,
    UpdateDimensionGroupRequest: UpdateDimensionGroupRequest,
    TrimWhitespaceRequest: TrimWhitespaceRequest,
    DeleteDuplicatesRequest: DeleteDuplicatesRequest,
    UpdateEmbeddedObjectBorderRequest: UpdateEmbeddedObjectBorderRequest,
    AddSlicerRequest: AddSlicerRequest,
    UpdateSlicerSpecRequest: UpdateSlicerSpecRequest,
    AddDataSourceRequest: AddDataSourceRequest,
    UpdateDataSourceRequest: UpdateDataSourceRequest,
    DeleteDataSourceRequest: DeleteDataSourceRequest,
    RefreshDataSourceRequest: RefreshDataSourceRequest,
    $$Request: $$Request
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "requests",
            Decco.arrayToJson(t_encode, v.requests)
        ],
        [
            "includeSpreadsheetInResponse",
            DeccoUtils$SmartcutsMacros.Nullable.t_encode(Decco.boolToJson, v.includeSpreadsheetInResponse)
        ],
        [
            "responseRanges",
            DeccoUtils$SmartcutsMacros.Nullable.t_encode(function(param) {
                return Decco.arrayToJson(Decco.stringToJson, param);
            }, v.responseRanges)
        ],
        [
            "responseIncludeGridData",
            DeccoUtils$SmartcutsMacros.Nullable.t_encode(Decco.boolToJson, v.responseIncludeGridData)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var requests = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "requests"), null));
    if (requests.TAG === /* Ok */ 0) {
        var includeSpreadsheetInResponse = DeccoUtils$SmartcutsMacros.Nullable.t_decode(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "includeSpreadsheetInResponse"), null));
        if (includeSpreadsheetInResponse.TAG === /* Ok */ 0) {
            var responseRanges = DeccoUtils$SmartcutsMacros.Nullable.t_decode(function(param) {
                return Decco.arrayFromJson(Decco.stringFromJson, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "responseRanges"), null));
            if (responseRanges.TAG === /* Ok */ 0) {
                var responseIncludeGridData = DeccoUtils$SmartcutsMacros.Nullable.t_decode(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "responseIncludeGridData"), null));
                if (responseIncludeGridData.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            requests: requests._0,
                            includeSpreadsheetInResponse: includeSpreadsheetInResponse._0,
                            responseRanges: responseRanges._0,
                            responseIncludeGridData: responseIncludeGridData._0
                        }
                    };
                }
                var e = responseIncludeGridData._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".responseIncludeGridData" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = responseRanges._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".responseRanges" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = includeSpreadsheetInResponse._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".includeSpreadsheetInResponse" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = requests._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".requests" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function make(requests, includeSpreadsheetInResponseOpt, responseRangesOpt, responseIncludeGridDataOpt, param) {
    var includeSpreadsheetInResponse = includeSpreadsheetInResponseOpt !== undefined ? Caml_option.valFromOption(includeSpreadsheetInResponseOpt) : null;
    var responseRanges = responseRangesOpt !== undefined ? Caml_option.valFromOption(responseRangesOpt) : null;
    var responseIncludeGridData = responseIncludeGridDataOpt !== undefined ? Caml_option.valFromOption(responseIncludeGridDataOpt) : null;
    return {
        requests: requests,
        includeSpreadsheetInResponse: includeSpreadsheetInResponse,
        responseRanges: responseRanges,
        responseIncludeGridData: responseIncludeGridData
    };
}
var RequestBody = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    make: make
};
var $$Response = {};
var Responses = {
    $$Response: $$Response
};
exports.Requests = Requests;
exports.RequestBody = RequestBody;
exports.Responses = Responses; /* include Not a pure module */ 


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var RequestBody = {};
var Search = {
    RequestBody: RequestBody
};
exports.Search = Search; /* No side effect */ 


/***/ }),

/***/ 11815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var _map = {
    "Unspecified": "DIMENSION_UNSPECIFIED",
    "Rows": "ROWS",
    "Columns": "COLUMNS"
};
var _revMap = {
    "DIMENSION_UNSPECIFIED": "Unspecified",
    "ROWS": "Rows",
    "COLUMNS": "Columns"
};
function tToJs(param) {
    return _map[param];
}
function tFromJs(param) {
    return _revMap[param];
}
var Dimension = {
    tToJs: tToJs,
    tFromJs: tFromJs
};
var DimensionRange = {};
var _map$1 = {
    "Unspecified": "DEVELOPER_METADATA_LOCATION_TYPE_UNSPECIFIED",
    "Row": "ROW",
    "Column": "COLUMN",
    "Sheet": "SHEET",
    "Spreadsheet": " SPREADSHEET"
};
var _revMap$1 = {
    "DEVELOPER_METADATA_LOCATION_TYPE_UNSPECIFIED": "Unspecified",
    "ROW": "Row",
    "COLUMN": "Column",
    "SHEET": "Sheet",
    " SPREADSHEET": "Spreadsheet"
};
function tToJs$1(param) {
    return _map$1[param];
}
function tFromJs$1(param) {
    return _revMap$1[param];
}
var DeveloperMetadataLocationType = {
    tToJs: tToJs$1,
    tFromJs: tFromJs$1
};
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
var t_encode = include.t_encode;
var t_decode = include.t_decode;
function spreadsheet(param) {
    return {
        spreadsheet: true
    };
}
function sheet(sheetId) {
    return {
        sheetId: sheetId
    };
}
function dimensionRange(dimensionRange$1) {
    return {
        dimensionRange: dimensionRange$1
    };
}
function DeveloperMetadataLocation_locationTypeGet(prim) {
    return Caml_option.undefined_to_opt(prim.locationType);
}
function DeveloperMetadataLocation_spreadsheetGet(prim) {
    return Caml_option.undefined_to_opt(prim.spreadsheet);
}
function DeveloperMetadataLocation_sheetIdGet(prim) {
    return Caml_option.undefined_to_opt(prim.sheetId);
}
function DeveloperMetadataLocation_dimensionRangeGet(prim) {
    return Caml_option.undefined_to_opt(prim.dimensionRange);
}
var DeveloperMetadataLocation = {
    t_encode: t_encode,
    t_decode: t_decode,
    locationTypeGet: DeveloperMetadataLocation_locationTypeGet,
    spreadsheetGet: DeveloperMetadataLocation_spreadsheetGet,
    sheetIdGet: DeveloperMetadataLocation_sheetIdGet,
    dimensionRangeGet: DeveloperMetadataLocation_dimensionRangeGet,
    spreadsheet: spreadsheet,
    sheet: sheet,
    dimensionRange: dimensionRange
};
var _map$2 = {
    "Unspecified": "DEVELOPER_METADATA_VISIBILITY_UNSPECIFIED",
    "Document": "DOCUMENT",
    "Project": "PROJECT"
};
var _revMap$2 = {
    "DEVELOPER_METADATA_VISIBILITY_UNSPECIFIED": "Unspecified",
    "DOCUMENT": "Document",
    "PROJECT": "Project"
};
function tToJs$2(param) {
    return _map$2[param];
}
function tFromJs$2(param) {
    return _revMap$2[param];
}
var include$1 = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "GoogleApis.Sheets.Schema.DeveloperMetadataVisibility",
    tToJs: tToJs$2,
    tFromJs: tFromJs$2
});
var t_encode$1 = include$1.t_encode;
var t_decode$1 = include$1.t_decode;
var DeveloperMetadataVisibility = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "metadataId",
            Decco.optionToJson(Decco.intToJson, v.metadataId)
        ],
        [
            "metadataKey",
            Decco.stringToJson(v.metadataKey)
        ],
        [
            "metadataValue",
            Decco.stringToJson(v.metadataValue)
        ],
        [
            "location",
            Curry._1(t_encode, v.location)
        ],
        [
            "visibility",
            Curry._1(t_encode$1, v.visibility)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var metadataId = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataId"), null));
    if (metadataId.TAG === /* Ok */ 0) {
        var metadataKey = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataKey"), null));
        if (metadataKey.TAG === /* Ok */ 0) {
            var metadataValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metadataValue"), null));
            if (metadataValue.TAG === /* Ok */ 0) {
                var $$location = Curry._1(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
                if ($$location.TAG === /* Ok */ 0) {
                    var visibility = Curry._1(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                    if (visibility.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                metadataId: metadataId._0,
                                metadataKey: metadataKey._0,
                                metadataValue: metadataValue._0,
                                location: $$location._0,
                                visibility: visibility._0
                            }
                        };
                    }
                    var e = visibility._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".visibility" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = $$location._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".location" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = metadataValue._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".metadataValue" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = metadataKey._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".metadataKey" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = metadataId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".metadataId" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var DeveloperMetadata = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
var GridRange = {};
var DeveloperMetadataLocationMatchingStrategy = {};
var DeveloperMetadaLookup = {};
var NamedRange = {};
var _map$3 = {
    "NUMBER_FORMAT_TYPE_UNSPECIFIED": "NUMBER_FORMAT_TYPE_UNSPECIFIED",
    "TEXT": "TEXT",
    "NUMBER": "NUMBER",
    "PERCENT": "PERCENT",
    "CURRENCY": "CURRENCY",
    "DATE": "DATE",
    "TIME": "TIME",
    "DATE_TIME": "DATE_TIME",
    "SCIENTIFIC": "SCIENTIFIC"
};
function tToJs$3(param) {
    return param;
}
function tFromJs$3(param) {
    return _map$3[param];
}
var NumberFormatType = {
    tToJs: tToJs$3,
    tFromJs: tFromJs$3
};
function make(type_, pattern) {
    return {
        type: type_,
        pattern: pattern
    };
}
var NumberFormat = {
    make: make
};
var CellFormat = {};
var IterativeCalculationSettings = {};
var SpreadsheetTheme = {};
function make$1(autoRecalc, defaultFormat, iterativeCalculationSettings, locale, spreadsheetTheme, timeZone, title, param) {
    return {
        autoRecalc: autoRecalc,
        defaultFormat: defaultFormat,
        iterativeCalculationSettings: iterativeCalculationSettings,
        locale: locale,
        spreadsheetTheme: spreadsheetTheme,
        timeZone: timeZone,
        title: title
    };
}
var SpreadsheetProperties = {
    make: make$1
};
var BandedRange = {};
var BasicFilter = {};
var EmbeddedChart = {};
var DimensionGroup = {};
var ConditionalFormatRule = {};
var DimensionProperties = {};
var ConditionValue = {};
var _map$4 = {
    "CONDITION_TYPE_UNSPECIFIED": "CONDITION_TYPE_UNSPECIFIED",
    "NUMBER_GREATER": "NUMBER_GREATER",
    "NUMBER_GREATER_THAN_EQ": "NUMBER_GREATER_THAN_EQ",
    "NUMBER_LESS": "NUMBER_LESS",
    "NUMBER_LESS_THAN_EQ": "NUMBER_LESS_THAN_EQ",
    "NUMBER_EQ": "NUMBER_EQ",
    "NUMBER_NOT_EQ": "NUMBER_NOT_EQ",
    "NUMBER_BETWEEN": "NUMBER_BETWEEN",
    "NUMBER_NOT_BETWEEN": "NUMBER_NOT_BETWEEN",
    "TEXT_CONTAINS": "TEXT_CONTAINS",
    "TEXT_NOT_CONTAINS": "TEXT_NOT_CONTAINS",
    "TEXT_STARTS_WITH": "TEXT_STARTS_WITH",
    "TEXT_ENDS_WITH": "TEXT_ENDS_WITH",
    "TEXT_EQ": "TEXT_EQ",
    "TEXT_IS_EMAIL": "TEXT_IS_EMAIL",
    "TEXT_IS_URL": "TEXT_IS_URL",
    "DATE_EQ": "DATE_EQ",
    "DATE_BEFORE": "DATE_BEFORE",
    "DATE_AFTER": "DATE_AFTER",
    "DATE_ON_OR_BEFORE": "DATE_ON_OR_BEFORE",
    "DATE_ON_OR_AFTER": "DATE_ON_OR_AFTER",
    "DATE_BETWEEN": "DATE_BETWEEN",
    "DATE_NOT_BETWEEN": "DATE_NOT_BETWEEN",
    "DATE_IS_VALID": "DATE_IS_VALID",
    "ONE_OF_RANGE": "ONE_OF_RANGE",
    "ONE_OF_LIST": "ONE_OF_LIST",
    "BLANK": "BLANK",
    "NOT_BLANK": "NOT_BLANK",
    "CUSTOM_FORMULA": "CUSTOM_FORMULA",
    "BOOLEAN": "BOOLEAN",
    "TEXT_NOT_EQ": "TEXT_NOT_EQ",
    "DATE_NOT_EQ": "DATE_NOT_EQ"
};
function tToJs$4(param) {
    return param;
}
function tFromJs$4(param) {
    return _map$4[param];
}
var ConditionType = {
    tToJs: tToJs$4,
    tFromJs: tFromJs$4
};
function make$2(type_, values, param) {
    return {
        type: Belt_Option.map(type_, tToJs$4),
        values: values
    };
}
var BooleanCondition = {
    make: make$2
};
var DataValidationRule = {};
var ErrorValue = {};
function stringValue(string) {
    return {
        boolValue: undefined,
        errorValue: undefined,
        formulaValue: undefined,
        numberValue: undefined,
        stringValue: string
    };
}
function formulaValue(formula) {
    return {
        boolValue: undefined,
        errorValue: undefined,
        formulaValue: formula,
        numberValue: undefined,
        stringValue: undefined
    };
}
var ExtendedValue = {
    stringValue: stringValue,
    formulaValue: formulaValue
};
var PivotTable = {};
var TextFormatRun = {};
function make$3(dataValidation, effectiveFormat, effectiveValue, formattedValue, hyperlink, note, pivotTable, textFormatRuns, userEnteredFormat, userEnteredValue, param) {
    return {
        dataValidation: dataValidation,
        effectiveFormat: effectiveFormat,
        effectiveValue: effectiveValue,
        formattedValue: formattedValue,
        hyperlink: hyperlink,
        note: note,
        pivotTable: pivotTable,
        textFormatRuns: textFormatRuns,
        userEnteredFormat: userEnteredFormat,
        userEnteredValue: userEnteredValue
    };
}
var CellData = {
    make: make$3
};
var RowData = {};
function countRowsMinusHeaderRow(maybeOnlyFirstNRows, param) {
    var arg = Belt_Option.map(param.rowData, function(rowData) {
        var len = rowData.length;
        var nRows = len === 0 ? len : len - 1 | 0;
        if (maybeOnlyFirstNRows !== undefined && maybeOnlyFirstNRows > nRows) {
            return maybeOnlyFirstNRows;
        } else {
            return nRows;
        }
    });
    var param$1 = 0;
    return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}
var GridData = {
    countRowsMinusHeaderRow: countRowsMinusHeaderRow
};
var FilterView = {};
var GridProperties = {};
var Color = {};
var ColorStyle = {};
var SheetProperties = {};
var WithoutEnum = {};
function majorDimensionToJs(majorDimension) {
    switch(majorDimension){
        case /* Rows */ 0:
            return "Rows";
        case /* Cols */ 1:
            return "Cols";
        case /* DimensionUnspecified */ 2:
            return "DimensionUnspecified";
    }
}
function fromWithoutEnum(param) {
    var tmp;
    switch(param.majorDimension){
        case "COLS":
            tmp = /* Cols */ 1;
            break;
        case "DIMENSION_UNSPECIFIED":
            tmp = /* DimensionUnspecified */ 2;
            break;
        case "ROWS":
            tmp = /* Rows */ 0;
            break;
        default:
            tmp = /* DimensionUnspecified */ 2;
    }
    return {
        range: param.range,
        majorDimension: tmp,
        values: param.values
    };
}
function toWithoutEnum(param) {
    return {
        range: param.range,
        majorDimension: majorDimensionToJs(param.majorDimension),
        values: param.values
    };
}
var fromJson = fromWithoutEnum;
var ValueRange = {
    WithoutEnum: WithoutEnum,
    majorDimensionToJs: majorDimensionToJs,
    fromWithoutEnum: fromWithoutEnum,
    toWithoutEnum: toWithoutEnum,
    fromJson: fromJson
};
var ProtectedRange = {};
var Slicer = {};
function make$4(bandedRanges, basicFilter, charts, columnGroups, conditionalFormats, data, developerMetadata, filterViews, merges, properties, protectedRanges, rowGroups, slicers, param) {
    return {
        bandedRanges: bandedRanges,
        basicFilter: basicFilter,
        charts: charts,
        columnGroups: columnGroups,
        conditionalFormats: conditionalFormats,
        data: data,
        developerMetadata: developerMetadata,
        filterViews: filterViews,
        merges: merges,
        properties: properties,
        protectedRanges: protectedRanges,
        rowGroups: rowGroups,
        slicers: slicers
    };
}
var Sheet = {
    make: make$4
};
function make$5(developerMetadata, namedRanges, properties, sheets, spreadsheetId, spreadsheetUrl, param) {
    return {
        developerMetadata: developerMetadata,
        namedRanges: namedRanges,
        properties: properties,
        sheets: sheets,
        spreadsheetId: spreadsheetId,
        spreadsheetUrl: spreadsheetUrl
    };
}
function getGridDataFor(spreadsheet1, sheetIndex, gridDataIndex) {
    return Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(spreadsheet1.sheets, function(sheets) {
        return Belt_Array.get(sheets, sheetIndex);
    }), function(param) {
        return param.data;
    }), function(data) {
        return Belt_Array.get(data, gridDataIndex);
    });
}
var Spreadsheet = {
    make: make$5,
    getGridDataFor: getGridDataFor
};
var UpdateValuesResponse = {};
var _map$5 = {
    "InputValueOptionUnspecified": "INPUT_VALUE_OPTION_UNSPECIFIED",
    "Raw": "RAW",
    "UserEntered": "USER_ENTERED"
};
var _revMap$3 = {
    "INPUT_VALUE_OPTION_UNSPECIFIED": "InputValueOptionUnspecified",
    "RAW": "Raw",
    "USER_ENTERED": "UserEntered"
};
function tToJs$5(param) {
    return _map$5[param];
}
function tFromJs$5(param) {
    return _revMap$3[param];
}
var ValueInputOption = {
    tToJs: tToJs$5,
    tFromJs: tFromJs$5
};
var _map$6 = {
    "FormattedValue": "FORMATTED_VALUE",
    "UnformattedValue": "UNFORMATTED_VALUE",
    "Formula": "FORMULA"
};
var _revMap$4 = {
    "FORMATTED_VALUE": "FormattedValue",
    "UNFORMATTED_VALUE": "UnformattedValue",
    "FORMULA": "Formula"
};
function tToJs$6(param) {
    return _map$6[param];
}
function tFromJs$6(param) {
    return _revMap$4[param];
}
var ValueRenderOption = {
    tToJs: tToJs$6,
    tFromJs: tFromJs$6
};
var _map$7 = {
    "SerialNumber": "SERIAL_NUMBER",
    "FormattedString": "FORMATTED_STRING"
};
var _revMap$5 = {
    "SERIAL_NUMBER": "SerialNumber",
    "FORMATTED_STRING": "FormattedString"
};
function tToJs$7(param) {
    return _map$7[param];
}
function tFromJs$7(param) {
    return _revMap$5[param];
}
var DateTimeRenderOption = {
    tToJs: tToJs$7,
    tFromJs: tFromJs$7
};
function developerMetadataLookup(developerMetadataLookup$1) {
    return {
        developerMetadataLookup: developerMetadataLookup$1
    };
}
function a1Range(a1Range$1) {
    return {
        a1Range: a1Range$1
    };
}
function gridRange(gridRange$1) {
    return {
        gridRange: gridRange$1
    };
}
var DataFilter = {
    developerMetadataLookup: developerMetadataLookup,
    a1Range: a1Range,
    gridRange: gridRange
};
var MatchedDeveloperMetadata = {};
exports.Dimension = Dimension;
exports.DimensionRange = DimensionRange;
exports.DeveloperMetadataLocationType = DeveloperMetadataLocationType;
exports.DeveloperMetadataLocation = DeveloperMetadataLocation;
exports.DeveloperMetadataVisibility = DeveloperMetadataVisibility;
exports.DeveloperMetadata = DeveloperMetadata;
exports.GridRange = GridRange;
exports.DeveloperMetadataLocationMatchingStrategy = DeveloperMetadataLocationMatchingStrategy;
exports.DeveloperMetadaLookup = DeveloperMetadaLookup;
exports.NamedRange = NamedRange;
exports.NumberFormatType = NumberFormatType;
exports.NumberFormat = NumberFormat;
exports.CellFormat = CellFormat;
exports.IterativeCalculationSettings = IterativeCalculationSettings;
exports.SpreadsheetTheme = SpreadsheetTheme;
exports.SpreadsheetProperties = SpreadsheetProperties;
exports.BandedRange = BandedRange;
exports.BasicFilter = BasicFilter;
exports.EmbeddedChart = EmbeddedChart;
exports.DimensionGroup = DimensionGroup;
exports.ConditionalFormatRule = ConditionalFormatRule;
exports.DimensionProperties = DimensionProperties;
exports.ConditionValue = ConditionValue;
exports.ConditionType = ConditionType;
exports.BooleanCondition = BooleanCondition;
exports.DataValidationRule = DataValidationRule;
exports.ErrorValue = ErrorValue;
exports.ExtendedValue = ExtendedValue;
exports.PivotTable = PivotTable;
exports.TextFormatRun = TextFormatRun;
exports.CellData = CellData;
exports.RowData = RowData;
exports.GridData = GridData;
exports.FilterView = FilterView;
exports.GridProperties = GridProperties;
exports.Color = Color;
exports.ColorStyle = ColorStyle;
exports.SheetProperties = SheetProperties;
exports.ValueRange = ValueRange;
exports.ProtectedRange = ProtectedRange;
exports.Slicer = Slicer;
exports.Sheet = Sheet;
exports.Spreadsheet = Spreadsheet;
exports.UpdateValuesResponse = UpdateValuesResponse;
exports.ValueInputOption = ValueInputOption;
exports.ValueRenderOption = ValueRenderOption;
exports.DateTimeRenderOption = DateTimeRenderOption;
exports.DataFilter = DataFilter;
exports.MatchedDeveloperMetadata = MatchedDeveloperMetadata; /* include Not a pure module */ 


/***/ }),

/***/ 43718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var CustomMap3$SmartcutsMacros = __webpack_require__(74762);
function imageResolved_encode(v) {
    if (v.TAG === /* Base64Encoded */ 0) {
        return [
            "Base64Encoded",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "BlobObject",
            Decco.stringToJson(v._0)
        ];
    }
}
function imageResolved_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Base64Encoded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Base64Encoded */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "BlobObject":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BlobObject */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyImageResolved(imageResolved) {
    if (imageResolved.TAG === /* Base64Encoded */ 0) {
        return "Base64Encoded(encodedString)";
    } else {
        return "BlobObject(" + (imageResolved._0 + ")");
    }
}
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "NoCopiedContentBecauseElementNotFound"
        ];
    } else if (v.TAG === /* CopiedText */ 0) {
        return [
            "CopiedText",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "CopiedImage",
            imageResolved_encode(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CopiedImage":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = imageResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CopiedImage */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "CopiedText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopiedText */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "NoCopiedContentBecauseElementNotFound":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoCopiedContentBecauseElementNotFound */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function getText(v) {
    if (typeof v === "number" || v.TAG !== /* CopiedText */ 0) {
        return;
    } else {
        return v._0;
    }
}
function getTextExn(v) {
    if (typeof v === "number") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Cannot get text that couldn't be copied due to element not found");
    } else if (v.TAG === /* CopiedText */ 0) {
        return v._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Cannot get text because this entry is CopiedImage");
    }
}
var ClipboardContent = {
    t_encode: t_encode,
    t_decode: t_decode,
    getText: getText,
    getTextExn: getTextExn
};
function t_encode$1(v) {
    return CustomMap3$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(t_encode, v);
}
function t_decode$1(v) {
    return CustomMap3$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(t_decode, v);
}
function stringify(clipboardByCommandLogIndex) {
    return JSON.stringify(Js_dict.fromArray(Belt_Array.map(Belt_MapInt.toArray(clipboardByCommandLogIndex), function(param) {
        var v = param[1];
        var tmp;
        tmp = typeof v === "number" ? "NoCopiedContentBecauseElementNotFound" : v.TAG === /* CopiedText */ 0 ? v._0 : v._0.TAG === /* Base64Encoded */ 0 ? "CopiedImage(Base64Encoded(...), " + (Image$SmartcutsMacros.Metadata.stringify(v._1) + ")") : "CopiedImage(BlobObject, " + (Image$SmartcutsMacros.Metadata.stringify(v._1) + ")");
        return [
            String(param[0]),
            tmp
        ];
    })));
}
var ClipboardByCommandLogIndex = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    empty: undefined,
    stringify: stringify
};
exports.imageResolved_encode = imageResolved_encode;
exports.imageResolved_decode = imageResolved_decode;
exports.stringifyImageResolved = stringifyImageResolved;
exports.ClipboardContent = ClipboardContent;
exports.ClipboardByCommandLogIndex = ClipboardByCommandLogIndex; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 4290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var KeyCommand$SmartcutsMacros = __webpack_require__(74935);
var URLCommand$SmartcutsMacros = __webpack_require__(91028);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var TypeCommand$SmartcutsMacros = __webpack_require__(92095);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var RadioCommand$SmartcutsMacros = __webpack_require__(84259);
var NewTabCommand$SmartcutsMacros = __webpack_require__(5864);
var PromisedValue$SmartcutsMacros = __webpack_require__(19949);
var ScrollCommand$SmartcutsMacros = __webpack_require__(34650);
var SelectCommand$SmartcutsMacros = __webpack_require__(16997);
var SwitchCommand$SmartcutsMacros = __webpack_require__(469);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var CheckboxCommand$SmartcutsMacros = __webpack_require__(50108);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var FocusTabCommand$SmartcutsMacros = __webpack_require__(14632);
var KeyComboCommand$SmartcutsMacros = __webpack_require__(461);
var PasswordCommand$SmartcutsMacros = __webpack_require__(9448);
var NewWindowCommand$SmartcutsMacros = __webpack_require__(90834);
var ClickInputCommand$SmartcutsMacros = __webpack_require__(78612);
var OpenedLinkCommand$SmartcutsMacros = __webpack_require__(28769);
var SubmitFormCommand$SmartcutsMacros = __webpack_require__(58935);
var ContextMenuCommand$SmartcutsMacros = __webpack_require__(48662);
var ClickToOAuthCommand$SmartcutsMacros = __webpack_require__(57114);
var CopyImageSrcCommand$SmartcutsMacros = __webpack_require__(68875);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var PasteInInputCommand$SmartcutsMacros = __webpack_require__(15220);
var NewTabWithUrlCommand$SmartcutsMacros = __webpack_require__(83228);
var ClientRedirectCommand$SmartcutsMacros = __webpack_require__(7);
var ServerRedirectCommand$SmartcutsMacros = __webpack_require__(50783);
var CopyLinkAddressCommand$SmartcutsMacros = __webpack_require__(67606);
var MoveInputCursorCommand$SmartcutsMacros = __webpack_require__(10806);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
var NewWindowWithUrlCommand$SmartcutsMacros = __webpack_require__(23374);
var SelectionRelatedCommands$SmartcutsMacros = __webpack_require__(92787);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var SubmitFormRedirectCommand$SmartcutsMacros = __webpack_require__(16614);
var ClickContentEditableCommand$SmartcutsMacros = __webpack_require__(76406);
var ScreenshotToClipboardCommand$SmartcutsMacros = __webpack_require__(96617);
var PasteInContentEditableCommand$SmartcutsMacros = __webpack_require__(74512);
var GenericCommandWithContextGlobal$SmartcutsMacros = __webpack_require__(95551);
var MoveContentEditableCursorCommand$SmartcutsMacros = __webpack_require__(45156);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
var PasteImageInContentEditableCommand$SmartcutsMacros = __webpack_require__(93978);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
var schemaVersion = "19.0.0";
function t_encode(encoder_domElementRepresentation, encoder_clickCommandValue, encoder_typeCommandValue, encoder_focusTabCommandValue, encoder_checkboxCommandValue, encoder_selectCommandValue, encoder_selectionRelatedCommandValue, encoder_copyLinkAddressCommandValue, encoder_pasteInInputCommandValue, encoder_pasteInContentEditableCommandValue, encoder_moveInputCursorCommandValue, encoder_clickInputCommandValue, encoder_moveContentEditableCommandValue, encoder_clickContentEditableCommandValue, encoder_radioCommandValue, encoder_downloadCommandValue, encoder_googleSheetsCommandValue, encoder_contextMenuCommandValue, encoder_screenshotToClipboardCommandValue, encoder_pasteImageInContentEditableCommandValue, encoder_passwordCommandValue, encoder_clickToOAuthCommandValue, encoder_uploadCommandValue, encoder_copyImageSrcCommandValue, encoder_withElementGroupsCommandValue, v) {
    if (typeof v === "number") {
        switch(v){
            case /* ReloadCommand */ 0:
                return [
                    "ReloadCommand"
                ];
            case /* ForwardCommand */ 1:
                return [
                    "ForwardCommand"
                ];
            case /* BackCommand */ 2:
                return [
                    "BackCommand"
                ];
        }
    } else {
        switch(v.TAG | 0){
            case /* NewWindowCommand */ 0:
                return [
                    "NewWindowCommand",
                    NewWindowCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewWindowWithUrlCommand */ 1:
                return [
                    "NewWindowWithUrlCommand",
                    NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewTabCommand */ 2:
                return [
                    "NewTabCommand",
                    NewTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* NewTabWithUrlCommand */ 3:
                return [
                    "NewTabWithUrlCommand",
                    NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* CloseTabCommand */ 4:
                return [
                    "CloseTabCommand",
                    InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
                ];
            case /* FocusTabCommand */ 5:
                return [
                    "FocusTabCommand",
                    Curry._1(encoder_focusTabCommandValue, v._0)
                ];
            case /* URLCommand */ 6:
                return [
                    "URLCommand",
                    URLCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* OpenedLinkCommand */ 7:
                return [
                    "OpenedLinkCommand",
                    OpenedLinkCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SubmitFormCommand */ 8:
                return [
                    "SubmitFormCommand",
                    SubmitFormCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SubmitFormRedirectCommand */ 9:
                return [
                    "SubmitFormRedirectCommand",
                    SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ClientRedirectCommand */ 10:
                return [
                    "ClientRedirectCommand",
                    ClientRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ServerRedirectCommand */ 11:
                return [
                    "ServerRedirectCommand",
                    ServerRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* ClickCommand */ 12:
                return [
                    "ClickCommand",
                    Curry._1(encoder_clickCommandValue, v._0)
                ];
            case /* ClickInputCommand */ 13:
                return [
                    "ClickInputCommand",
                    Curry._1(encoder_clickInputCommandValue, v._0)
                ];
            case /* ClickContentEditableCommand */ 14:
                return [
                    "ClickContentEditableCommand",
                    Curry._1(encoder_clickContentEditableCommandValue, v._0)
                ];
            case /* TypeCommand */ 15:
                return [
                    "TypeCommand",
                    Curry._1(encoder_typeCommandValue, v._0)
                ];
            case /* CheckboxCommand */ 16:
                return [
                    "CheckboxCommand",
                    Curry._1(encoder_checkboxCommandValue, v._0)
                ];
            case /* SelectCommand */ 17:
                return [
                    "SelectCommand",
                    Curry._1(encoder_selectCommandValue, v._0)
                ];
            case /* RadioCommand */ 18:
                return [
                    "RadioCommand",
                    Curry._1(encoder_radioCommandValue, v._0)
                ];
            case /* KeyCommand */ 19:
                return [
                    "KeyCommand",
                    KeyCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* KeyComboCommand */ 20:
                return [
                    "KeyComboCommand",
                    KeyComboCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SelectionCommand */ 21:
                return [
                    "SelectionCommand",
                    Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
            case /* MoveInputCursorCommand */ 22:
                return [
                    "MoveInputCursorCommand",
                    Curry._1(encoder_moveInputCursorCommandValue, v._0)
                ];
            case /* MoveContentEditableCursorCommand */ 23:
                return [
                    "MoveContentEditableCursorCommand",
                    Curry._1(encoder_moveContentEditableCommandValue, v._0)
                ];
            case /* CopyCommand */ 24:
                return [
                    "CopyCommand",
                    Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
            case /* CopyLinkAddressCommand */ 25:
                return [
                    "CopyLinkAddressCommand",
                    Curry._1(encoder_copyLinkAddressCommandValue, v._0)
                ];
            case /* CutCommand */ 26:
                return [
                    "CutCommand",
                    Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
            case /* PasteInInputCommand */ 27:
                return [
                    "PasteInInputCommand",
                    Curry._1(encoder_pasteInInputCommandValue, v._0)
                ];
            case /* PasteInContentEditableCommand */ 28:
                return [
                    "PasteInContentEditableCommand",
                    Curry._1(encoder_pasteInContentEditableCommandValue, v._0)
                ];
            case /* DragCommand */ 29:
                return [
                    "DragCommand",
                    Curry._1(encoder_domElementRepresentation, v._0)
                ];
            case /* DropCommand */ 30:
                return [
                    "DropCommand",
                    Curry._1(encoder_domElementRepresentation, v._0)
                ];
            case /* ScrollCommand */ 31:
                return [
                    "ScrollCommand",
                    ScrollCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* DownloadCommand */ 32:
                return [
                    "DownloadCommand",
                    Curry._1(encoder_downloadCommandValue, v._0)
                ];
            case /* GoogleSheetsCommand */ 33:
                return [
                    "GoogleSheetsCommand",
                    Curry._1(encoder_googleSheetsCommandValue, v._0)
                ];
            case /* ContextMenuCommand */ 34:
                return [
                    "ContextMenuCommand",
                    Curry._1(encoder_contextMenuCommandValue, v._0)
                ];
            case /* LoopCommand */ 35:
                return [
                    "LoopCommand",
                    LoopCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
            case /* SwitchCommand */ 36:
                return [
                    "SwitchCommand",
                    SwitchCommand$SmartcutsMacros.CommandValue.t_encode(function(param) {
                        return t_encode(encoder_domElementRepresentation, encoder_clickCommandValue, encoder_typeCommandValue, encoder_focusTabCommandValue, encoder_checkboxCommandValue, encoder_selectCommandValue, encoder_selectionRelatedCommandValue, encoder_copyLinkAddressCommandValue, encoder_pasteInInputCommandValue, encoder_pasteInContentEditableCommandValue, encoder_moveInputCursorCommandValue, encoder_clickInputCommandValue, encoder_moveContentEditableCommandValue, encoder_clickContentEditableCommandValue, encoder_radioCommandValue, encoder_downloadCommandValue, encoder_googleSheetsCommandValue, encoder_contextMenuCommandValue, encoder_screenshotToClipboardCommandValue, encoder_pasteImageInContentEditableCommandValue, encoder_passwordCommandValue, encoder_clickToOAuthCommandValue, encoder_uploadCommandValue, encoder_copyImageSrcCommandValue, encoder_withElementGroupsCommandValue, param);
                    }, v._0)
                ];
            case /* ScreenshotToClipboardCommand */ 37:
                return [
                    "ScreenshotToClipboardCommand",
                    Curry._1(encoder_screenshotToClipboardCommandValue, v._0)
                ];
            case /* PasteImageInContentEditableCommand */ 38:
                return [
                    "PasteImageInContentEditableCommand",
                    Curry._1(encoder_pasteImageInContentEditableCommandValue, v._0)
                ];
            case /* PasswordCommand */ 39:
                return [
                    "PasswordCommand",
                    Curry._1(encoder_passwordCommandValue, v._0)
                ];
            case /* ClickToOAuthCommand */ 40:
                return [
                    "ClickToOAuthCommand",
                    Curry._1(encoder_clickToOAuthCommandValue, v._0)
                ];
            case /* UploadCommand */ 41:
                return [
                    "UploadCommand",
                    Curry._1(encoder_uploadCommandValue, v._0)
                ];
            case /* CopyImageSrcCommand */ 42:
                return [
                    "CopyImageSrcCommand",
                    Curry._1(encoder_copyImageSrcCommandValue, v._0)
                ];
            case /* WithElementGroupsCommand */ 43:
                return [
                    "WithElementGroupsCommand",
                    Curry._1(encoder_withElementGroupsCommandValue, v._0)
                ];
        }
    }
}
function t_decode(decoder_domElementRepresentation, decoder_clickCommandValue, decoder_typeCommandValue, decoder_focusTabCommandValue, decoder_checkboxCommandValue, decoder_selectCommandValue, decoder_selectionRelatedCommandValue, decoder_copyLinkAddressCommandValue, decoder_pasteInInputCommandValue, decoder_pasteInContentEditableCommandValue, decoder_moveInputCursorCommandValue, decoder_clickInputCommandValue, decoder_moveContentEditableCommandValue, decoder_clickContentEditableCommandValue, decoder_radioCommandValue, decoder_downloadCommandValue, decoder_googleSheetsCommandValue, decoder_contextMenuCommandValue, decoder_screenshotToClipboardCommandValue, decoder_pasteImageInContentEditableCommandValue, decoder_passwordCommandValue, decoder_clickToOAuthCommandValue, decoder_uploadCommandValue, decoder_copyImageSrcCommandValue, decoder_withElementGroupsCommandValue, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BackCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BackCommand */ 2
                    };
                }
            case "CheckboxCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_checkboxCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CheckboxCommand */ 16,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ClickCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_clickCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickCommand */ 12,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ClickContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(decoder_clickContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickContentEditableCommand */ 14,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "ClickInputCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Curry._1(decoder_clickInputCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickInputCommand */ 13,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ClickToOAuthCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Curry._1(decoder_clickToOAuthCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickToOAuthCommand */ 40,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "ClientRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = ClientRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClientRedirectCommand */ 10,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "CloseTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CloseTabCommand */ 4,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "ContextMenuCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = Curry._1(decoder_contextMenuCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContextMenuCommand */ 34,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "CopyCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyCommand */ 24,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "CopyImageSrcCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = Curry._1(decoder_copyImageSrcCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyImageSrcCommand */ 42,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "CopyLinkAddressCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = Curry._1(decoder_copyLinkAddressCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CopyLinkAddressCommand */ 25,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "CutCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$11 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CutCommand */ 26,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "DownloadCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$12 = Curry._1(decoder_downloadCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadCommand */ 32,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "DragCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$13 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DragCommand */ 29,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "DropCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$14 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$14.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DropCommand */ 30,
                            _0: v0$14._0
                        }
                    };
                }
                var e$14 = v0$14._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "FocusTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$15 = Curry._1(decoder_focusTabCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$15.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FocusTabCommand */ 5,
                            _0: v0$15._0
                        }
                    };
                }
                var e$15 = v0$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            case "ForwardCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ForwardCommand */ 1
                    };
                }
            case "GoogleSheetsCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$16 = Curry._1(decoder_googleSheetsCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$16.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsCommand */ 33,
                            _0: v0$16._0
                        }
                    };
                }
                var e$16 = v0$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$16.path,
                        message: e$16.message,
                        value: e$16.value
                    }
                };
            case "KeyComboCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$17 = KeyComboCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$17.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KeyComboCommand */ 20,
                            _0: v0$17._0
                        }
                    };
                }
                var e$17 = v0$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$17.path,
                        message: e$17.message,
                        value: e$17.value
                    }
                };
            case "KeyCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$18 = KeyCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$18.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KeyCommand */ 19,
                            _0: v0$18._0
                        }
                    };
                }
                var e$18 = v0$18._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$18.path,
                        message: e$18.message,
                        value: e$18.value
                    }
                };
            case "LoopCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$19 = LoopCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$19.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoopCommand */ 35,
                            _0: v0$19._0
                        }
                    };
                }
                var e$19 = v0$19._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$19.path,
                        message: e$19.message,
                        value: e$19.value
                    }
                };
            case "MoveContentEditableCursorCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$20 = Curry._1(decoder_moveContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$20.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MoveContentEditableCursorCommand */ 23,
                            _0: v0$20._0
                        }
                    };
                }
                var e$20 = v0$20._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "MoveInputCursorCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$21 = Curry._1(decoder_moveInputCursorCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$21.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MoveInputCursorCommand */ 22,
                            _0: v0$21._0
                        }
                    };
                }
                var e$21 = v0$21._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$21.path,
                        message: e$21.message,
                        value: e$21.value
                    }
                };
            case "NewTabCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$22 = NewTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$22.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewTabCommand */ 2,
                            _0: v0$22._0
                        }
                    };
                }
                var e$22 = v0$22._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$22.path,
                        message: e$22.message,
                        value: e$22.value
                    }
                };
            case "NewTabWithUrlCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$23 = NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$23.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewTabWithUrlCommand */ 3,
                            _0: v0$23._0
                        }
                    };
                }
                var e$23 = v0$23._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$23.path,
                        message: e$23.message,
                        value: e$23.value
                    }
                };
            case "NewWindowCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$24 = NewWindowCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$24.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewWindowCommand */ 0,
                            _0: v0$24._0
                        }
                    };
                }
                var e$24 = v0$24._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$24.path,
                        message: e$24.message,
                        value: e$24.value
                    }
                };
            case "NewWindowWithUrlCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$25 = NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$25.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewWindowWithUrlCommand */ 1,
                            _0: v0$25._0
                        }
                    };
                }
                var e$25 = v0$25._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                    }
                };
            case "OpenedLinkCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$26 = OpenedLinkCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$26.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OpenedLinkCommand */ 7,
                            _0: v0$26._0
                        }
                    };
                }
                var e$26 = v0$26._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$26.path,
                        message: e$26.message,
                        value: e$26.value
                    }
                };
            case "PasswordCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$27 = Curry._1(decoder_passwordCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$27.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasswordCommand */ 39,
                            _0: v0$27._0
                        }
                    };
                }
                var e$27 = v0$27._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$27.path,
                        message: e$27.message,
                        value: e$27.value
                    }
                };
            case "PasteImageInContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$28 = Curry._1(decoder_pasteImageInContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$28.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteImageInContentEditableCommand */ 38,
                            _0: v0$28._0
                        }
                    };
                }
                var e$28 = v0$28._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$28.path,
                        message: e$28.message,
                        value: e$28.value
                    }
                };
            case "PasteInContentEditableCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$29 = Curry._1(decoder_pasteInContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$29.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteInContentEditableCommand */ 28,
                            _0: v0$29._0
                        }
                    };
                }
                var e$29 = v0$29._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$29.path,
                        message: e$29.message,
                        value: e$29.value
                    }
                };
            case "PasteInInputCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$30 = Curry._1(decoder_pasteInInputCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$30.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteInInputCommand */ 27,
                            _0: v0$30._0
                        }
                    };
                }
                var e$30 = v0$30._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$30.path,
                        message: e$30.message,
                        value: e$30.value
                    }
                };
            case "RadioCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$31 = Curry._1(decoder_radioCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$31.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RadioCommand */ 18,
                            _0: v0$31._0
                        }
                    };
                }
                var e$31 = v0$31._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$31.path,
                        message: e$31.message,
                        value: e$31.value
                    }
                };
            case "ReloadCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ReloadCommand */ 0
                    };
                }
            case "ScreenshotToClipboardCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$32 = Curry._1(decoder_screenshotToClipboardCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$32.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScreenshotToClipboardCommand */ 37,
                            _0: v0$32._0
                        }
                    };
                }
                var e$32 = v0$32._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$32.path,
                        message: e$32.message,
                        value: e$32.value
                    }
                };
            case "ScrollCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$33 = ScrollCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$33.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScrollCommand */ 31,
                            _0: v0$33._0
                        }
                    };
                }
                var e$33 = v0$33._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$33.path,
                        message: e$33.message,
                        value: e$33.value
                    }
                };
            case "SelectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$34 = Curry._1(decoder_selectCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$34.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectCommand */ 17,
                            _0: v0$34._0
                        }
                    };
                }
                var e$34 = v0$34._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$34.path,
                        message: e$34.message,
                        value: e$34.value
                    }
                };
            case "SelectionCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$35 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$35.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectionCommand */ 21,
                            _0: v0$35._0
                        }
                    };
                }
                var e$35 = v0$35._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$35.path,
                        message: e$35.message,
                        value: e$35.value
                    }
                };
            case "ServerRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$36 = ServerRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$36.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ServerRedirectCommand */ 11,
                            _0: v0$36._0
                        }
                    };
                }
                var e$36 = v0$36._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$36.path,
                        message: e$36.message,
                        value: e$36.value
                    }
                };
            case "SubmitFormCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$37 = SubmitFormCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$37.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SubmitFormCommand */ 8,
                            _0: v0$37._0
                        }
                    };
                }
                var e$37 = v0$37._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$37.path,
                        message: e$37.message,
                        value: e$37.value
                    }
                };
            case "SubmitFormRedirectCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$38 = SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$38.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SubmitFormRedirectCommand */ 9,
                            _0: v0$38._0
                        }
                    };
                }
                var e$38 = v0$38._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$38.path,
                        message: e$38.message,
                        value: e$38.value
                    }
                };
            case "SwitchCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$39 = SwitchCommand$SmartcutsMacros.CommandValue.t_decode(function(param) {
                    return t_decode(decoder_domElementRepresentation, decoder_clickCommandValue, decoder_typeCommandValue, decoder_focusTabCommandValue, decoder_checkboxCommandValue, decoder_selectCommandValue, decoder_selectionRelatedCommandValue, decoder_copyLinkAddressCommandValue, decoder_pasteInInputCommandValue, decoder_pasteInContentEditableCommandValue, decoder_moveInputCursorCommandValue, decoder_clickInputCommandValue, decoder_moveContentEditableCommandValue, decoder_clickContentEditableCommandValue, decoder_radioCommandValue, decoder_downloadCommandValue, decoder_googleSheetsCommandValue, decoder_contextMenuCommandValue, decoder_screenshotToClipboardCommandValue, decoder_pasteImageInContentEditableCommandValue, decoder_passwordCommandValue, decoder_clickToOAuthCommandValue, decoder_uploadCommandValue, decoder_copyImageSrcCommandValue, decoder_withElementGroupsCommandValue, param);
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$39.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SwitchCommand */ 36,
                            _0: v0$39._0
                        }
                    };
                }
                var e$39 = v0$39._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$39.path,
                        message: e$39.message,
                        value: e$39.value
                    }
                };
            case "TypeCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$40 = Curry._1(decoder_typeCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$40.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TypeCommand */ 15,
                            _0: v0$40._0
                        }
                    };
                }
                var e$40 = v0$40._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$40.path,
                        message: e$40.message,
                        value: e$40.value
                    }
                };
            case "URLCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$41 = URLCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$41.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* URLCommand */ 6,
                            _0: v0$41._0
                        }
                    };
                }
                var e$41 = v0$41._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$41.path,
                        message: e$41.message,
                        value: e$41.value
                    }
                };
            case "UploadCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$42 = Curry._1(decoder_uploadCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$42.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UploadCommand */ 41,
                            _0: v0$42._0
                        }
                    };
                }
                var e$42 = v0$42._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$42.path,
                        message: e$42.message,
                        value: e$42.value
                    }
                };
            case "WithElementGroupsCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$43 = Curry._1(decoder_withElementGroupsCommandValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$43.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WithElementGroupsCommand */ 43,
                            _0: v0$43._0
                        }
                    };
                }
                var e$43 = v0$43._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$43.path,
                        message: e$43.message,
                        value: e$43.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function recordingCommand_encode(v) {
    return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, ClickCommand$SmartcutsMacros.CommandValue.Recording.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Recording.t_encode, function(param) {
        return PromisedValue$SmartcutsMacros.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, param);
    }, CheckboxCommand$SmartcutsMacros.CommandValue.Recording.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Recording.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Recording.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Recording.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Recording.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, v);
}
function recordingCommand_decode(v) {
    return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, ClickCommand$SmartcutsMacros.CommandValue.Recording.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Recording.t_decode, function(param) {
        return PromisedValue$SmartcutsMacros.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, param);
    }, CheckboxCommand$SmartcutsMacros.CommandValue.Recording.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Recording.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Recording.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Recording.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Recording.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, v);
}
function factorOutDynamicVars(cmd) {
    if (typeof cmd === "number") {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    if (cmd.TAG !== /* TypeCommand */ 15) {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Recording.Pack.factorOutDynamicVars, cmd._0);
    return {
        vars: match.vars,
        factoredValue: {
            TAG: /* TypeCommand */ 15,
            _0: match.factoredValue
        }
    };
}
function substituteInDynamicVars(param1) {
    var factoredValue = param1.factoredValue;
    var vars = param1.vars;
    if (typeof factoredValue === "number") {
        return factoredValue;
    }
    if (factoredValue.TAG !== /* TypeCommand */ 15) {
        return factoredValue;
    }
    var match = factoredValue._0;
    var match$1 = match.labeledTextInputValueDiff;
    var match$2 = match.domElementIdentifierWithSelector;
    var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
    var varsForValueDiff = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected array of vars");
    var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
    var varsForSelector = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected array of vars");
    var tmp;
    if (match$1.valueDiff.TAG === /* AddText */ 0) {
        var arg$2 = Js_json.decodeString(Caml_array.get(varsForValueDiff, 0));
        var addText = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
        }("Expected var to be a string");
        tmp = {
            TAG: /* AddText */ 0,
            _0: addText
        };
    } else {
        var deleteText = Caml_array.get(varsForValueDiff, 0);
        tmp = {
            TAG: /* DeleteText */ 1,
            _0: deleteText
        };
    }
    return {
        TAG: /* TypeCommand */ 15,
        _0: {
            domElementIdentifierWithSelector: {
                domElementIdentifier: match$2.domElementIdentifier,
                selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                    vars: varsForSelector,
                    factoredValue: match$2.selector
                })
            },
            labeledTextInputValueDiff: {
                label: match$1.label,
                valueDiff: tmp
            }
        }
    };
}
var Pack = {
    factorOutDynamicVars: factorOutDynamicVars,
    substituteInDynamicVars: substituteInDynamicVars
};
var ForRecording = {
    Pack: Pack
};
function authoringCommand_encode(v) {
    return t_encode(Selector$SmartcutsMacros.selector_encode, ClickCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, FocusTabCommand$SmartcutsMacros.CommandValue.t_encode, CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, v);
}
function authoringCommand_decode(v) {
    return t_decode(Selector$SmartcutsMacros.selector_decode, ClickCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, FocusTabCommand$SmartcutsMacros.CommandValue.t_decode, CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, v);
}
function factorOutDynamicVars$1(cmd) {
    if (typeof cmd === "number") {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    if (cmd.TAG !== /* TypeCommand */ 15) {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Authoring.Pack.factorOutDynamicVars, cmd._0);
    return {
        vars: match.vars,
        factoredValue: {
            TAG: /* TypeCommand */ 15,
            _0: match.factoredValue
        }
    };
}
function substituteInDynamicVars$1(param2) {
    var factoredValue = param2.factoredValue;
    var vars = param2.vars;
    if (typeof factoredValue === "number") {
        return factoredValue;
    }
    if (factoredValue.TAG !== /* TypeCommand */ 15) {
        return factoredValue;
    }
    var match = factoredValue._0;
    var match$1 = match.labeledTextInputValueDiff;
    var valueDiff = match$1.valueDiff;
    var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
    var varsForValueDiff = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected array of vars");
    var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
    var varsForSelector = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected array of vars");
    var tmp;
    if (valueDiff.TAG === /* AddText */ 0) {
        tmp = {
            TAG: /* AddText */ 0,
            _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
                vars: vars,
                factoredValue: valueDiff._0
            })
        };
    } else {
        var deleteText = Caml_array.get(varsForValueDiff, 0);
        tmp = {
            TAG: /* DeleteText */ 1,
            _0: {
                recording: deleteText,
                semantics: valueDiff._0.semantics
            }
        };
    }
    return {
        TAG: /* TypeCommand */ 15,
        _0: {
            selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                vars: varsForSelector,
                factoredValue: match.selector
            }),
            labeledTextInputValueDiff: {
                label: match$1.label,
                valueDiff: tmp
            }
        }
    };
}
var Pack$1 = {
    factorOutDynamicVars: factorOutDynamicVars$1,
    substituteInDynamicVars: substituteInDynamicVars$1
};
var ForAuthoring = {
    Pack: Pack$1
};
function playbackCommand_encode(v) {
    return t_encode(Selector$SmartcutsMacros.selector_encode, ClickCommand$SmartcutsMacros.CommandValue.Playback.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Playback.t_encode, FocusTabCommand$SmartcutsMacros.CommandValue.t_encode, CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Playback.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Playback.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v);
}
function playbackCommand_decode(v) {
    return t_decode(Selector$SmartcutsMacros.selector_decode, ClickCommand$SmartcutsMacros.CommandValue.Playback.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Playback.t_decode, FocusTabCommand$SmartcutsMacros.CommandValue.t_decode, CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Playback.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Playback.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, v);
}
function factorOutDynamicVars$2(cmd) {
    if (typeof cmd === "number") {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    if (cmd.TAG !== /* TypeCommand */ 15) {
        return {
            vars: [],
            factoredValue: cmd
        };
    }
    var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.Pack.factorOutDynamicVars, cmd._0);
    return {
        vars: match.vars,
        factoredValue: {
            TAG: /* TypeCommand */ 15,
            _0: match.factoredValue
        }
    };
}
function substituteInDynamicVars$2(param) {
    var factoredValue = param.factoredValue;
    if (typeof factoredValue === "number" || factoredValue.TAG !== /* TypeCommand */ 15) {
        return factoredValue;
    } else {
        return {
            TAG: /* TypeCommand */ 15,
            _0: Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.Pack.substituteInDynamicVars, {
                vars: param.vars,
                factoredValue: factoredValue._0
            })
        };
    }
}
var Pack$2 = {
    factorOutDynamicVars: factorOutDynamicVars$2,
    substituteInDynamicVars: substituteInDynamicVars$2
};
function isDownloadCommand(command) {
    if (typeof command === "number" || command.TAG !== /* DownloadCommand */ 32) {
        return false;
    } else {
        return true;
    }
}
function isOpenedLinkCommand(command) {
    if (typeof command === "number" || command.TAG !== /* OpenedLinkCommand */ 7) {
        return false;
    } else {
        return true;
    }
}
function isLoopCommand(command) {
    if (typeof command === "number" || command.TAG !== /* LoopCommand */ 35) {
        return false;
    } else {
        return true;
    }
}
function selectorGet(command) {
    if (typeof command === "number") {
        return [];
    }
    switch(command.TAG | 0){
        case /* ClickCommand */ 12:
            return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickInputCommand */ 13:
            return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickContentEditableCommand */ 14:
            return Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* TypeCommand */ 15:
            return Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* CheckboxCommand */ 16:
            return Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.CheckboxPlaybackCommandValue.selectorGet, command._0);
        case /* SelectCommand */ 17:
            return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* RadioCommand */ 18:
            return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* MoveInputCursorCommand */ 22:
            return Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* MoveContentEditableCursorCommand */ 23:
            return Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* CopyLinkAddressCommand */ 25:
            return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* SelectionCommand */ 21:
        case /* CopyCommand */ 24:
        case /* CutCommand */ 26:
            break;
        case /* PasteInInputCommand */ 27:
            return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasteInContentEditableCommand */ 28:
            return Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* DragCommand */ 29:
        case /* DropCommand */ 30:
            return [
                command._0
            ];
        case /* ScrollCommand */ 31:
            return ScrollCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* ContextMenuCommand */ 34:
            return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* LoopCommand */ 35:
            return LoopCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* SwitchCommand */ 36:
            var func = SwitchCommand$SmartcutsMacros.CommandValue.selectorGet;
            return Curry._2(func, selectorGet, command._0);
        case /* ScreenshotToClipboardCommand */ 37:
            return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasteImageInContentEditableCommand */ 38:
            return Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* PasswordCommand */ 39:
            return Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* ClickToOAuthCommand */ 40:
            return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* UploadCommand */ 41:
            return UploadCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
        case /* CopyImageSrcCommand */ 42:
            return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
        case /* WithElementGroupsCommand */ 43:
            return [];
        default:
            return [];
    }
    return Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
}
function isFollowedBySubsequentNetworkLatency(command) {
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
            case /* ForwardCommand */ 1:
            case /* BackCommand */ 2:
                return true;
        }
    } else {
        switch(command.TAG | 0){
            case /* ClickCommand */ 12:
                var match = Selector$SmartcutsMacros.maybeGetLeafNode(command._0.selector);
                if (match === undefined) {
                    return false;
                }
                var s = match.innerText;
                if (typeof s === "number") {
                    return false;
                }
                if (s.TAG !== /* FullInnerText */ 0) {
                    return false;
                }
                var match$1 = $$String.lowercase_ascii(s._0);
                switch(match$1){
                    case "confirm":
                    case "create":
                    case "save":
                        return true;
                    default:
                        return false;
                }
            case /* NewWindowWithUrlCommand */ 1:
            case /* NewTabWithUrlCommand */ 3:
            case /* URLCommand */ 6:
            case /* OpenedLinkCommand */ 7:
            case /* SubmitFormCommand */ 8:
            case /* SubmitFormRedirectCommand */ 9:
            case /* ClientRedirectCommand */ 10:
            case /* ServerRedirectCommand */ 11:
            case /* ClickToOAuthCommand */ 40:
            case /* UploadCommand */ 41:
                return true;
            default:
                return false;
        }
    }
}
var ForPlayback = {
    Pack: Pack$2,
    isDownloadCommand: isDownloadCommand,
    isOpenedLinkCommand: isOpenedLinkCommand,
    isLoopCommand: isLoopCommand,
    selectorGet: selectorGet,
    isFollowedBySubsequentNetworkLatency: isFollowedBySubsequentNetworkLatency
};
function stringify(stringifyDomElementRepresentation, stringifyClickCommandValue, stringifyTypeCommandValue, stringifyFocusTabCommandValue, stringifyCheckboxCommandValue, stringifySelectCommandValue, stringifySelectionRelatedCommandValue, stringifyCopyLinkAddressCommandValue, stringifyPasteInInputCommandValue, stringifyPasteInContentEditableCommandValue, stringifyMoveInputCursorCommandValue, stringifyClickInputCommandValue, stringifyMoveContentEditableCursorCommandValue, stringifyClickContentEditableCommandValue, stringifyRadioCommandValue, stringifyDownloadCommandValue, stringifyGoogleSheetsCommandValue, stringifyContextMenuCommandValue, stringifyScreenshotToClipboardCommandValue, stringifyPasteImageInContentEditableCommandValue, stringifyPasswordCommandValue, stringifyClickToOAuthCommandValue, stringifyUploadCommandValue, stringifyCopyImageSrcCommandValue, stringifyWithElementGroupsCommandValue, command) {
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
                return "ReloadCommand";
            case /* ForwardCommand */ 1:
                return "ForwardCommand";
            case /* BackCommand */ 2:
                return "BackCommand";
        }
    } else {
        switch(command.TAG | 0){
            case /* NewWindowCommand */ 0:
                return "NewWindowCommand(" + (NewWindowCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewWindowWithUrlCommand */ 1:
                return "NewWindowWithUrlCommand(" + (NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewTabCommand */ 2:
                return "NewTabCommand(" + (NewTabCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* NewTabWithUrlCommand */ 3:
                return "NewTabWithUrlCommand(" + (NewTabWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* CloseTabCommand */ 4:
                return "CloseTabCommand(tabRef=" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(command._0) + ")");
            case /* FocusTabCommand */ 5:
                return "FocusTabCommand(tabRef=" + (Curry._1(stringifyFocusTabCommandValue, command._0) + ")");
            case /* URLCommand */ 6:
                return "URLCommand(" + (URLCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* OpenedLinkCommand */ 7:
                return "OpenedLinkCommand(" + (OpenedLinkCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SubmitFormCommand */ 8:
                return "SubmitFormCommand(" + (SubmitFormCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SubmitFormRedirectCommand */ 9:
                return "SubmitFormRedirectCommand(" + (SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ClientRedirectCommand */ 10:
                return "ClientRedirectCommand(" + (ClientRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ServerRedirectCommand */ 11:
                return "ServerRedirectCommand(" + (ServerRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* ClickCommand */ 12:
                return "ClickCommand(" + (Curry._1(stringifyClickCommandValue, command._0) + ")");
            case /* ClickInputCommand */ 13:
                return "ClickInputCommand(" + (Curry._1(stringifyClickInputCommandValue, command._0) + ")");
            case /* ClickContentEditableCommand */ 14:
                return "ClickContentEditableCommand(" + (Curry._1(stringifyClickContentEditableCommandValue, command._0) + ")");
            case /* TypeCommand */ 15:
                return "TypeCommand(" + (Curry._1(stringifyTypeCommandValue, command._0) + ")");
            case /* CheckboxCommand */ 16:
                return "CheckboxCommand(" + (Curry._1(stringifyCheckboxCommandValue, command._0) + ")");
            case /* SelectCommand */ 17:
                return "SelectCommand(" + (Curry._1(stringifySelectCommandValue, command._0) + ")");
            case /* RadioCommand */ 18:
                return "RadioCommand(" + (Curry._1(stringifyRadioCommandValue, command._0) + ")");
            case /* KeyCommand */ 19:
                return "KeyCommand(" + (KeyCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* KeyComboCommand */ 20:
                return "KeyComboCommand(" + (KeyComboCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
            case /* SelectionCommand */ 21:
                return "SelectionCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
            case /* MoveInputCursorCommand */ 22:
                return "MoveInputCursorCommand(" + (Curry._1(stringifyMoveInputCursorCommandValue, command._0) + ")");
            case /* MoveContentEditableCursorCommand */ 23:
                return "MoveContentEditableCursorCommand(" + (Curry._1(stringifyMoveContentEditableCursorCommandValue, command._0) + ")");
            case /* CopyCommand */ 24:
                return "CopyCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
            case /* CopyLinkAddressCommand */ 25:
                return "CopyLinkAddressCommand(" + (Curry._1(stringifyCopyLinkAddressCommandValue, command._0) + ")");
            case /* CutCommand */ 26:
                return "CutCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
            case /* PasteInInputCommand */ 27:
                return "PasteInInputCommand(" + (Curry._1(stringifyPasteInInputCommandValue, command._0) + ")");
            case /* PasteInContentEditableCommand */ 28:
                return "PasteInContentEditableCommand(" + (Curry._1(stringifyPasteInContentEditableCommandValue, command._0) + ")");
            case /* DragCommand */ 29:
                return "DragCommand(domElement=" + (Curry._1(stringifyDomElementRepresentation, command._0) + ")");
            case /* DropCommand */ 30:
                return "DropCommand(domElement=" + (Curry._1(stringifyDomElementRepresentation, command._0) + ")");
            case /* ScrollCommand */ 31:
                return "ScrollCommand(delta(x, y))";
            case /* DownloadCommand */ 32:
                return "DownloadCommand(" + (Curry._1(stringifyDownloadCommandValue, command._0) + ")");
            case /* GoogleSheetsCommand */ 33:
                return "GoogleSheetsCommand(" + (Curry._1(stringifyGoogleSheetsCommandValue, command._0) + ")");
            case /* ContextMenuCommand */ 34:
                return "ContextMenuCommand(" + (Curry._1(stringifyContextMenuCommandValue, command._0) + ")");
            case /* LoopCommand */ 35:
                return "LoopCommand(" + LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0);
            case /* SwitchCommand */ 36:
                var func = SwitchCommand$SmartcutsMacros.CommandValue.stringify;
                return "SwitchCommand(" + Curry._2(func, function(param) {
                    return stringify(stringifyDomElementRepresentation, stringifyClickCommandValue, stringifyTypeCommandValue, stringifyFocusTabCommandValue, stringifyCheckboxCommandValue, stringifySelectCommandValue, stringifySelectionRelatedCommandValue, stringifyCopyLinkAddressCommandValue, stringifyPasteInInputCommandValue, stringifyPasteInContentEditableCommandValue, stringifyMoveInputCursorCommandValue, stringifyClickInputCommandValue, stringifyMoveContentEditableCursorCommandValue, stringifyClickContentEditableCommandValue, stringifyRadioCommandValue, stringifyDownloadCommandValue, stringifyGoogleSheetsCommandValue, stringifyContextMenuCommandValue, stringifyScreenshotToClipboardCommandValue, stringifyPasteImageInContentEditableCommandValue, stringifyPasswordCommandValue, stringifyClickToOAuthCommandValue, stringifyUploadCommandValue, stringifyCopyImageSrcCommandValue, stringifyWithElementGroupsCommandValue, param);
                }, command._0);
            case /* ScreenshotToClipboardCommand */ 37:
                return "ScreenshotToClipboardCommand(" + (Curry._1(stringifyScreenshotToClipboardCommandValue, command._0) + ")");
            case /* PasteImageInContentEditableCommand */ 38:
                return "PasteImageInContentEditableCommand(" + (Curry._1(stringifyPasteImageInContentEditableCommandValue, command._0) + ")");
            case /* PasswordCommand */ 39:
                return "PasswordCommand(" + (Curry._1(stringifyPasswordCommandValue, command._0) + ")");
            case /* ClickToOAuthCommand */ 40:
                return "ClickToOAuthCommand(" + (Curry._1(stringifyClickToOAuthCommandValue, command._0) + ")");
            case /* UploadCommand */ 41:
                return "UploadCommand(" + (Curry._1(stringifyUploadCommandValue, command._0) + ")");
            case /* CopyImageSrcCommand */ 42:
                return "CopyImageSrcCommand(" + (Curry._1(stringifyCopyImageSrcCommandValue, command._0) + ")");
            case /* WithElementGroupsCommand */ 43:
                return "WithElementGroupsCommand(" + (Curry._1(stringifyWithElementGroupsCommandValue, command._0) + ")");
        }
    }
}
function stringifyRecordingCommand(param3) {
    return stringify(function(param) {
        return "(domElementIdentifier=" + (String(param.domElementIdentifier) + (", selector=" + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ")")));
    }, ClickCommand$SmartcutsMacros.CommandValue.Recording.stringify, TypeCommand$SmartcutsMacros.CommandValue.Recording.stringify, function(param) {
        return PromisedValue$SmartcutsMacros.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify, param);
    }, CheckboxCommand$SmartcutsMacros.CommandValue.Recording.stringify, SelectCommand$SmartcutsMacros.CommandValue.Recording.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, RadioCommand$SmartcutsMacros.CommandValue.Recording.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Recording.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.stringify, UploadCommand$SmartcutsMacros.CommandValue.Recording.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, param3);
}
function stringifyAuthoringCommand(param4) {
    return stringify(function(selector) {
        return Selector$SmartcutsMacros.stringify(undefined, false, selector);
    }, ClickCommand$SmartcutsMacros.CommandValue.Authoring.stringify, TypeCommand$SmartcutsMacros.CommandValue.Authoring.stringify, function(param) {
        return FocusTabCommand$SmartcutsMacros.CommandValue.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, param);
    }, CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.stringify, SelectCommand$SmartcutsMacros.CommandValue.Authoring.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, RadioCommand$SmartcutsMacros.CommandValue.Authoring.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.stringify, UploadCommand$SmartcutsMacros.CommandValue.Authoring.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, param4);
}
function stringifyPlaybackCommand(param5) {
    return stringify(function(selector) {
        return Selector$SmartcutsMacros.stringify(undefined, false, selector);
    }, ClickCommand$SmartcutsMacros.CommandValue.Playback.stringify, TypeCommand$SmartcutsMacros.CommandValue.Playback.stringify, function(param) {
        return FocusTabCommand$SmartcutsMacros.CommandValue.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, param);
    }, CheckboxCommand$SmartcutsMacros.CommandValue.Playback.stringify, SelectCommand$SmartcutsMacros.CommandValue.Playback.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, RadioCommand$SmartcutsMacros.CommandValue.Playback.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Playback.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.stringify, UploadCommand$SmartcutsMacros.CommandValue.Playback.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, param5);
}
function updateSelectorInAuthoringCommand(f, command) {
    if (typeof command === "number") {
        return command;
    }
    switch(command.TAG | 0){
        case /* ClickCommand */ 12:
            var func = ClickCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
            return {
                TAG: /* ClickCommand */ 12,
                _0: Curry._2(func, f, command._0)
            };
        case /* ClickInputCommand */ 13:
            var commandValue = command._0;
            var inputCursorWithSemantics = commandValue.inputCursorWithSemantics;
            return {
                TAG: /* ClickInputCommand */ 13,
                _0: {
                    inputCursorWithSemantics: {
                        inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.updateSelector(f, inputCursorWithSemantics.inputCursor),
                        semantics: inputCursorWithSemantics.semantics
                    },
                    positionRelToElement: commandValue.positionRelToElement,
                    label: commandValue.label
                }
            };
        case /* ClickContentEditableCommand */ 14:
            return {
                TAG: /* ClickContentEditableCommand */ 14,
                _0: Curry._2(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* TypeCommand */ 15:
            return {
                TAG: /* TypeCommand */ 15,
                _0: Curry._2(TypeCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* SelectCommand */ 17:
            return {
                TAG: /* SelectCommand */ 17,
                _0: Curry._2(SelectCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* RadioCommand */ 18:
            return {
                TAG: /* RadioCommand */ 18,
                _0: Curry._2(RadioCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* SelectionCommand */ 21:
            return {
                TAG: /* SelectionCommand */ 21,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* MoveInputCursorCommand */ 22:
            return {
                TAG: /* MoveInputCursorCommand */ 22,
                _0: Curry._2(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* MoveContentEditableCursorCommand */ 23:
            return {
                TAG: /* MoveContentEditableCursorCommand */ 23,
                _0: Curry._2(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* CopyCommand */ 24:
            return {
                TAG: /* CopyCommand */ 24,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* CopyLinkAddressCommand */ 25:
            return {
                TAG: /* CopyLinkAddressCommand */ 25,
                _0: Curry._2(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* CutCommand */ 26:
            return {
                TAG: /* CutCommand */ 26,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* PasteInInputCommand */ 27:
            return {
                TAG: /* PasteInInputCommand */ 27,
                _0: Curry._2(PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* PasteInContentEditableCommand */ 28:
            return {
                TAG: /* PasteInContentEditableCommand */ 28,
                _0: Curry._2(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* DragCommand */ 29:
            return {
                TAG: /* DragCommand */ 29,
                _0: Curry._1(f, command._0)
            };
        case /* DropCommand */ 30:
            return {
                TAG: /* DropCommand */ 30,
                _0: Curry._1(f, command._0)
            };
        case /* ContextMenuCommand */ 34:
            var commandValue$1 = command._0;
            return {
                TAG: /* ContextMenuCommand */ 34,
                _0: {
                    selector: Curry._1(f, commandValue$1.selector),
                    viewportPosition: commandValue$1.viewportPosition,
                    positionRelToElement: commandValue$1.positionRelToElement,
                    maybeSubPathToImg: commandValue$1.maybeSubPathToImg
                }
            };
        case /* LoopCommand */ 35:
            var func$1 = LoopCommand$SmartcutsMacros.CommandValue.mapSelector;
            return {
                TAG: /* LoopCommand */ 35,
                _0: Curry._2(func$1, f, command._0)
            };
        case /* SwitchCommand */ 36:
            var func$2 = SwitchCommand$SmartcutsMacros.CommandValue.mapSelector;
            var func$3 = Curry._1(func$2, f);
            return {
                TAG: /* SwitchCommand */ 36,
                _0: Curry._2(func$3, function(commandWithContext) {
                    return {
                        id: commandWithContext.id,
                        command: updateSelectorInAuthoringCommand(f, commandWithContext.command),
                        contextGlobal: commandWithContext.contextGlobal
                    };
                }, command._0)
            };
        case /* ScreenshotToClipboardCommand */ 37:
            var func$4 = ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
            return {
                TAG: /* ScreenshotToClipboardCommand */ 37,
                _0: Curry._2(func$4, f, command._0)
            };
        case /* PasteImageInContentEditableCommand */ 38:
            var func$5 = PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
            return {
                TAG: /* PasteImageInContentEditableCommand */ 38,
                _0: Curry._2(func$5, f, command._0)
            };
        case /* PasswordCommand */ 39:
            return {
                TAG: /* PasswordCommand */ 39,
                _0: Curry._2(PasswordCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* ClickToOAuthCommand */ 40:
            return {
                TAG: /* ClickToOAuthCommand */ 40,
                _0: Curry._2(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
            };
        case /* UploadCommand */ 41:
            return {
                TAG: /* UploadCommand */ 41,
                _0: UploadCommand$SmartcutsMacros.CommandValue.mapSelector(f, command._0)
            };
        case /* CopyImageSrcCommand */ 42:
            return {
                TAG: /* CopyImageSrcCommand */ 42,
                _0: Curry._2(CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.updateSelector, f, command._0)
            };
        case /* WithElementGroupsCommand */ 43:
            return {
                TAG: /* WithElementGroupsCommand */ 43,
                _0: command._0
            };
        default:
            return command;
    }
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "command",
            recordingCommand_encode(v.command)
        ],
        [
            "contextLocal",
            CommandContext$SmartcutsMacros.commandContextLocal_encode(v.contextLocal)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var command = recordingCommand_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
    if (command.TAG === /* Ok */ 0) {
        var contextLocal = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contextLocal"), null));
        if (contextLocal.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    command: command._0,
                    contextLocal: contextLocal._0
                }
            };
        }
        var e = contextLocal._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".contextLocal" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = command._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".command" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{command: " + (stringifyRecordingCommand(param.command) + ", contextLocal}");
}
var CommandWithContextLocal = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.intToJson(v.id)
        ],
        [
            "command",
            recordingCommand_encode(v.command)
        ],
        [
            "contextGlobal",
            CommandContext$SmartcutsMacros.CommandContextGlobalPromised.t_encode(v.contextGlobal)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var command = recordingCommand_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
        if (command.TAG === /* Ok */ 0) {
            var contextGlobal = CommandContext$SmartcutsMacros.CommandContextGlobalPromised.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contextGlobal"), null));
            if (contextGlobal.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        id: id._0,
                        command: command._0,
                        contextGlobal: contextGlobal._0
                    }
                };
            }
            var e = contextGlobal._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".contextGlobal" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = command._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".command" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function minify(param) {
    return {
        id: param.id,
        command: param.command,
        contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalPromised.minify(param.contextGlobal)
    };
}
function calcSize(unit, commandWithContext) {
    return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(t_encode$2(commandWithContext)));
}
function getMaybeDevicePixelRatio(param) {
    return CommandContext$SmartcutsMacros.CommandContextGlobalPromised.getMaybeDevicePixelRatio(param.contextGlobal);
}
function getMaybeResolvedTabRefAndWindowRef(param) {
    var contextGlobal = param.contextGlobal;
    var tabRef = contextGlobal.tabRef;
    if (tabRef.TAG === /* Resolved */ 0) {
        return [
            tabRef._0,
            contextGlobal.windowRef
        ];
    }
}
var CommandWithContextGlobalForRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    minify: minify,
    calcSize: calcSize,
    getMaybeDevicePixelRatio: getMaybeDevicePixelRatio,
    getMaybeResolvedTabRefAndWindowRef: getMaybeResolvedTabRefAndWindowRef
};
function t_encode$3(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(recordingCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}
function t_decode$3(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(recordingCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}
function fromCommandWithContextGlobalForRecording(param) {
    return {
        id: param.id,
        command: param.command,
        contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.fromCommandContextGlobalPromised(param.contextGlobal)
    };
}
function minify$1(param) {
    return {
        id: param.id,
        command: param.command,
        contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
    };
}
function calcSize$1(unit, param) {
    return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(recordingCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}
function toGraphql(index, cmdWithContext) {
    return {
        index: index,
        recordedSmartcut: undefined,
        commandSerialized: JSON.stringify(recordingCommand_encode(cmdWithContext.command)),
        contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(cmdWithContext.contextGlobal))),
        schemaVersion: schemaVersion,
        size: calcSize$1(/* Kilobytes */ 1, cmdWithContext)
    };
}
var CommandWithContextGlobalForRecordingResolved = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromCommandWithContextGlobalForRecording: fromCommandWithContextGlobalForRecording,
    minify: minify$1,
    calcSize: calcSize$1,
    toGraphql: toGraphql
};
function t_encode$4(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(authoringCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}
function t_decode$4(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(authoringCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}
function minify$2(param) {
    return {
        id: param.id,
        command: param.command,
        contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
    };
}
function calcSize$2(unit, param) {
    return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(authoringCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}
function toGraphql$1(index, cmdWithContext) {
    return {
        index: index,
        recordedSmartcut: undefined,
        commandSerialized: JSON.stringify(authoringCommand_encode(cmdWithContext.command)),
        contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(cmdWithContext.contextGlobal))),
        schemaVersion: schemaVersion,
        size: calcSize$2(/* Kilobytes */ 1, cmdWithContext)
    };
}
var CommandWithContextGlobalForAuthoring = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    minify: minify$2,
    calcSize: calcSize$2,
    toGraphql: toGraphql$1
};
function t_encode$5(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(playbackCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}
function t_decode$5(v) {
    return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(playbackCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}
function calcSize$3(unit, param) {
    return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(playbackCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}
function minify$3(param) {
    return {
        id: param.id,
        command: param.command,
        contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
    };
}
function rehydrate(commandWithContext) {
    return CommandContext$SmartcutsMacros.CommandContextGlobalResolved.rehydrate(commandWithContext.contextGlobal).then(function(rehydratedeContextGlobal) {
        return Promise.resolve({
            id: commandWithContext.id,
            command: commandWithContext.command,
            contextGlobal: rehydratedeContextGlobal
        });
    });
}
function toGraphql$2(index, cmdWithContext) {
    return {
        index: index,
        recordedSmartcut: undefined,
        commandSerialized: JSON.stringify(playbackCommand_encode(cmdWithContext.command)),
        contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(cmdWithContext.contextGlobal)),
        schemaVersion: schemaVersion,
        size: calcSize$3(/* Kilobytes */ 1, cmdWithContext)
    };
}
function toGraphqlPartialUpdate(cmdWithContext) {
    return {
        commandSerialized: JSON.stringify(playbackCommand_encode(cmdWithContext.command)),
        contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(cmdWithContext.contextGlobal)),
        schemaVersion: schemaVersion,
        size: calcSize$3(/* Kilobytes */ 1, cmdWithContext)
    };
}
function maybeSubstituteUrlFromCompletedCommandWithContextGlobal(completedCommandWithContextGlobal, commandWithContextGlobal) {
    var match = completedCommandWithContextGlobal.command;
    var exit = 0;
    var urlFromCompletedCommand;
    var tabRefFromCompletedCommand;
    if (typeof match === "number") {
        return commandWithContextGlobal;
    }
    switch(match.TAG | 0){
        case /* NewWindowWithUrlCommand */ 1:
        case /* NewTabWithUrlCommand */ 3:
            exit = 1;
            break;
        case /* URLCommand */ 6:
            var match$1 = match._0;
            urlFromCompletedCommand = match$1.url;
            tabRefFromCompletedCommand = match$1.tabRef;
            exit = 2;
            break;
        case /* OpenedLinkCommand */ 7:
            var match$2 = match._0;
            urlFromCompletedCommand = match$2.url;
            tabRefFromCompletedCommand = match$2.tabRef;
            exit = 2;
            break;
        default:
            return commandWithContextGlobal;
    }
    switch(exit){
        case 1:
            if (!(Caml_obj.caml_equal(commandWithContextGlobal.contextGlobal.tabRef.recordingId, completedCommandWithContextGlobal.contextGlobal.tabRef.recordingId) && commandWithContextGlobal.contextGlobal.url === completedCommandWithContextGlobal.contextGlobal.url)) {
                return commandWithContextGlobal;
            }
            var init = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: init.windowRef,
                    tabRef: init.tabRef,
                    url: match._0.url,
                    focusStatus: init.focusStatus,
                    title: init.title,
                    frame: init.frame,
                    windowGeometry: init.windowGeometry,
                    targetBoundingRect: init.targetBoundingRect,
                    timestamp: init.timestamp,
                    htmlSnapshot: init.htmlSnapshot,
                    screenshot: init.screenshot,
                    croppedScreenshot: init.croppedScreenshot,
                    preconditions: init.preconditions,
                    maybeLogoutLocator: init.maybeLogoutLocator
                }
            };
        case 2:
            if (!(Caml_obj.caml_equal(commandWithContextGlobal.contextGlobal.tabRef.recordingId, tabRefFromCompletedCommand.recordingId) && commandWithContextGlobal.contextGlobal.url === completedCommandWithContextGlobal.contextGlobal.url)) {
                return commandWithContextGlobal;
            }
            var init$1 = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: init$1.windowRef,
                    tabRef: init$1.tabRef,
                    url: urlFromCompletedCommand,
                    focusStatus: init$1.focusStatus,
                    title: init$1.title,
                    frame: init$1.frame,
                    windowGeometry: init$1.windowGeometry,
                    targetBoundingRect: init$1.targetBoundingRect,
                    timestamp: init$1.timestamp,
                    htmlSnapshot: init$1.htmlSnapshot,
                    screenshot: init$1.screenshot,
                    croppedScreenshot: init$1.croppedScreenshot,
                    preconditions: init$1.preconditions,
                    maybeLogoutLocator: init$1.maybeLogoutLocator
                }
            };
    }
}
function substituteTabIdInCommandWithContextGlobal(tabIdToReplace, newTabId, commandWithContextGlobal) {
    var contextGlobal = commandWithContextGlobal.contextGlobal;
    var command = commandWithContextGlobal.command;
    var newCommand;
    if (typeof command === "number") {
        newCommand = command;
    } else {
        switch(command.TAG | 0){
            case /* NewTabCommand */ 2:
                var match = command._0;
                var tabRef = match.tabRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef) ? {
                    TAG: /* NewTabCommand */ 2,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef),
                        windowRef: match.windowRef,
                        focusStatus: match.focusStatus
                    }
                } : command;
                break;
            case /* NewTabWithUrlCommand */ 3:
                var match$1 = command._0;
                var tabRef$1 = match$1.tabRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$1) ? {
                    TAG: /* NewTabWithUrlCommand */ 3,
                    _0: {
                        url: match$1.url,
                        title: match$1.title,
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$1),
                        windowRef: match$1.windowRef,
                        focusStatus: match$1.focusStatus
                    }
                } : command;
                break;
            case /* CloseTabCommand */ 4:
                var tabRef$2 = command._0;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$2) ? {
                    TAG: /* CloseTabCommand */ 4,
                    _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$2)
                } : command;
                break;
            case /* FocusTabCommand */ 5:
                var commandValue = command._0;
                var tabRef$3 = commandValue.tabRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$3) ? {
                    TAG: /* FocusTabCommand */ 5,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$3),
                        url: commandValue.url,
                        title: commandValue.title
                    }
                } : command;
                break;
            case /* URLCommand */ 6:
                var match$2 = command._0;
                var tabRef$4 = match$2.tabRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$4) ? {
                    TAG: /* URLCommand */ 6,
                    _0: {
                        url: match$2.url,
                        title: match$2.title,
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$4)
                    }
                } : command;
                break;
            case /* OpenedLinkCommand */ 7:
                var cmdVal = command._0;
                var openerTabRef = cmdVal.maybeOpenerTab;
                var tabRef$5 = cmdVal.tabRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$5) ? {
                    TAG: /* OpenedLinkCommand */ 7,
                    _0: {
                        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$5),
                        windowRef: cmdVal.windowRef,
                        url: cmdVal.url,
                        title: cmdVal.title,
                        maybeOpenerTab: cmdVal.maybeOpenerTab,
                        viaHistoryApi: cmdVal.viaHistoryApi
                    }
                } : openerTabRef !== undefined && InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, openerTabRef) ? {
                    TAG: /* OpenedLinkCommand */ 7,
                    _0: {
                        tabRef: cmdVal.tabRef,
                        windowRef: cmdVal.windowRef,
                        url: cmdVal.url,
                        title: cmdVal.title,
                        maybeOpenerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, openerTabRef),
                        viaHistoryApi: cmdVal.viaHistoryApi
                    }
                } : command;
                break;
            case /* DownloadCommand */ 32:
                newCommand = {
                    TAG: /* DownloadCommand */ 32,
                    _0: Curry._3(DownloadCommand$SmartcutsMacros.CommandValue.Playback.maybeAssignPlaybackTabId, tabIdToReplace, newTabId, command._0)
                };
                break;
            case /* SwitchCommand */ 36:
                var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
                newCommand = {
                    TAG: /* SwitchCommand */ 36,
                    _0: Curry._2(func, function(param) {
                        return substituteTabIdInCommandWithContextGlobal(tabIdToReplace, newTabId, param);
                    }, command._0)
                };
                break;
            default:
                newCommand = command;
        }
    }
    var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId;
    var arg = contextGlobal.tabRef;
    var newContextGlobal = function(param) {
        return Curry._2(func$1, param, arg);
    }(tabIdToReplace) ? {
        windowRef: contextGlobal.windowRef,
        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, contextGlobal.tabRef),
        url: contextGlobal.url,
        focusStatus: contextGlobal.focusStatus,
        title: contextGlobal.title,
        frame: contextGlobal.frame,
        windowGeometry: contextGlobal.windowGeometry,
        targetBoundingRect: contextGlobal.targetBoundingRect,
        timestamp: contextGlobal.timestamp,
        htmlSnapshot: contextGlobal.htmlSnapshot,
        screenshot: contextGlobal.screenshot,
        croppedScreenshot: contextGlobal.croppedScreenshot,
        preconditions: contextGlobal.preconditions,
        maybeLogoutLocator: contextGlobal.maybeLogoutLocator
    } : contextGlobal;
    return {
        id: commandWithContextGlobal.id,
        command: newCommand,
        contextGlobal: newContextGlobal
    };
}
function maybeCreatedWindow(param) {
    var match = param.contextGlobal;
    var tabRef = match.tabRef;
    var windowRef = match.windowRef;
    var tmp = param.command;
    if (typeof tmp === "number") {
        return;
    }
    switch(tmp.TAG | 0){
        case /* NewWindowCommand */ 0:
        case /* NewWindowWithUrlCommand */ 1:
            return [
                windowRef,
                tabRef
            ];
        default:
            return;
    }
}
function maybeCreatedTab(param) {
    var contextGlobal = param.contextGlobal;
    var command = param.command;
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* NewTabCommand */ 2:
            return command._0.tabRef;
        case /* NewTabWithUrlCommand */ 3:
            return command._0.tabRef;
        case /* OpenedLinkCommand */ 7:
            var match = command._0;
            if (match.maybeOpenerTab !== undefined && !match.viaHistoryApi) {
                return match.tabRef;
            } else {
                return;
            }
        case /* NewWindowCommand */ 0:
        case /* NewWindowWithUrlCommand */ 1:
        case /* ServerRedirectCommand */ 11:
            return contextGlobal.tabRef;
        case /* DownloadCommand */ 32:
            var match$1 = command._0.tabOrigin;
            if (match$1.TAG === /* DownloadInNewTab */ 0) {
                return match$1._0.newTab;
            } else {
                return;
            }
        default:
            return;
    }
}
function substituteWindowIdInCommandWithContextGlobal(windowIdToReplace, newWindowId, commandWithContextGlobal) {
    var contextGlobal = commandWithContextGlobal.contextGlobal;
    var command = commandWithContextGlobal.command;
    var newCommand;
    if (typeof command === "number") {
        newCommand = command;
    } else {
        switch(command.TAG | 0){
            case /* NewWindowCommand */ 0:
                var match = command._0;
                var windowRef = match.windowRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef) ? {
                    TAG: /* NewWindowCommand */ 0,
                    _0: {
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef),
                        focusStatus: match.focusStatus
                    }
                } : command;
                break;
            case /* NewTabCommand */ 2:
                var match$1 = command._0;
                var windowRef$1 = match$1.windowRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef$1) ? {
                    TAG: /* NewTabCommand */ 2,
                    _0: {
                        tabRef: match$1.tabRef,
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef$1),
                        focusStatus: match$1.focusStatus
                    }
                } : command;
                break;
            case /* NewTabWithUrlCommand */ 3:
                var match$2 = command._0;
                var windowRef$2 = match$2.windowRef;
                newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef$2) ? {
                    TAG: /* NewTabWithUrlCommand */ 3,
                    _0: {
                        url: match$2.url,
                        title: match$2.title,
                        tabRef: match$2.tabRef,
                        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef$2),
                        focusStatus: match$2.focusStatus
                    }
                } : command;
                break;
            case /* SwitchCommand */ 36:
                var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
                newCommand = {
                    TAG: /* SwitchCommand */ 36,
                    _0: Curry._2(func, function(param) {
                        return substituteWindowIdInCommandWithContextGlobal(windowIdToReplace, newWindowId, param);
                    }, command._0)
                };
                break;
            default:
                newCommand = command;
        }
    }
    var newContextGlobal = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, contextGlobal.windowRef) ? {
        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, contextGlobal.windowRef),
        tabRef: contextGlobal.tabRef,
        url: contextGlobal.url,
        focusStatus: contextGlobal.focusStatus,
        title: contextGlobal.title,
        frame: contextGlobal.frame,
        windowGeometry: contextGlobal.windowGeometry,
        targetBoundingRect: contextGlobal.targetBoundingRect,
        timestamp: contextGlobal.timestamp,
        htmlSnapshot: contextGlobal.htmlSnapshot,
        screenshot: contextGlobal.screenshot,
        croppedScreenshot: contextGlobal.croppedScreenshot,
        preconditions: contextGlobal.preconditions,
        maybeLogoutLocator: contextGlobal.maybeLogoutLocator
    } : contextGlobal;
    return {
        id: commandWithContextGlobal.id,
        command: newCommand,
        contextGlobal: newContextGlobal
    };
}
function getGoogleSheetOutputUrl(param) {
    var command = param.command;
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* GoogleSheetsCommand */ 33:
            return param.contextGlobal.url;
        case /* WithElementGroupsCommand */ 43:
            return ArrayUtils$SmartcutsMacros.shortcut(function(action) {
                var destination = action._0.destination;
                if (destination.TAG === /* ExistingGoogleSheet */ 0) {
                    return destination._0.spreadsheetUrl;
                }
                var googleSheet = destination._0;
                if (googleSheet.TAG === /* Resolved */ 0) {
                    return googleSheet._0.spreadsheetUrl;
                }
            }, command._0.actions);
        default:
            return;
    }
}
var CommandWithContextGlobalForPlayback = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    calcSize: calcSize$3,
    minify: minify$3,
    rehydrate: rehydrate,
    toGraphql: toGraphql$2,
    toGraphqlPartialUpdate: toGraphqlPartialUpdate,
    maybeSubstituteUrlFromCompletedCommandWithContextGlobal: maybeSubstituteUrlFromCompletedCommandWithContextGlobal,
    substituteTabIdInCommandWithContextGlobal: substituteTabIdInCommandWithContextGlobal,
    maybeCreatedWindow: maybeCreatedWindow,
    maybeCreatedTab: maybeCreatedTab,
    substituteWindowIdInCommandWithContextGlobal: substituteWindowIdInCommandWithContextGlobal,
    getGoogleSheetOutputUrl: getGoogleSheetOutputUrl
};
function decorateCommandWithGlobalContext(commandId, tab, tabId, focusStatus, screenshot, croppedScreenshotOpt, preconditions, maybeLogoutLocator, cmd) {
    var croppedScreenshot = croppedScreenshotOpt !== undefined ? croppedScreenshotOpt : /* NoImage */ 0;
    var windowId = tab.windowId;
    var width = tab.width;
    var height = tab.height;
    return {
        id: commandId,
        command: cmd,
        contextGlobal: {
            windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.makeFromRecordingWindowId(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.makeRecordingId(windowId)),
            tabRef: {
                TAG: /* Resolved */ 0,
                _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.makeFromRecordingTabId(tabId)
            },
            url: {
                TAG: /* Resolved */ 0,
                _0: OptionUtils$SmartcutsMacros.getExn("Undefined tab url during Command.decorateCommandWithGlobalContext", tab.url)
            },
            focusStatus: focusStatus,
            title: {
                TAG: /* Resolved */ 0,
                _0: tab.title
            },
            frame: {
                TAG: /* Resolved */ 0,
                _0: {
                    TAG: /* TopFrame */ 0,
                    _0: "TODO"
                }
            },
            windowGeometry: {
                TAG: /* Resolved */ 0,
                _0: {
                    width: width !== undefined ? width : Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: no width"),
                    height: height !== undefined ? height : Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: no height"),
                    zoomFactor: 1.0,
                    devicePixelRatio: {
                        TAG: /* FromBgScript */ 1,
                        _0: window.devicePixelRatio
                    }
                }
            },
            targetBoundingRect: undefined,
            timestamp: Date.now(),
            htmlSnapshot: "TODO",
            screenshot: screenshot,
            croppedScreenshot: croppedScreenshot,
            preconditions: preconditions,
            maybeLogoutLocator: maybeLogoutLocator
        }
    };
}
function decorateCommandWithLocalContextWithGlobalContext(commandId, tab, tabId, focusStatus, screenshot, commandWithContextLocal) {
    var windowId = tab.windowId;
    var match = commandWithContextLocal.contextLocal;
    return {
        id: commandId,
        command: commandWithContextLocal.command,
        contextGlobal: {
            windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.makeFromRecordingWindowId(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.makeRecordingId(windowId)),
            tabRef: {
                TAG: /* Resolved */ 0,
                _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.makeFromRecordingTabId(tabId)
            },
            url: {
                TAG: /* Resolved */ 0,
                _0: OptionUtils$SmartcutsMacros.getExn("undefined tab url during Command.decorateCommandWithLocalContextWithGlobalContext", tab.url)
            },
            focusStatus: focusStatus,
            title: {
                TAG: /* Resolved */ 0,
                _0: tab.title
            },
            frame: {
                TAG: /* Resolved */ 0,
                _0: match.frame
            },
            windowGeometry: {
                TAG: /* Resolved */ 0,
                _0: match.windowGeometry
            },
            targetBoundingRect: match.targetBoundingRect,
            timestamp: match.timestamp,
            htmlSnapshot: match.htmlSnapshot,
            screenshot: screenshot,
            croppedScreenshot: /* NoImage */ 0,
            preconditions: match.preconditions,
            maybeLogoutLocator: match.maybeLogoutLocator
        }
    };
}
exports.schemaVersion = schemaVersion;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.recordingCommand_encode = recordingCommand_encode;
exports.recordingCommand_decode = recordingCommand_decode;
exports.ForRecording = ForRecording;
exports.authoringCommand_encode = authoringCommand_encode;
exports.authoringCommand_decode = authoringCommand_decode;
exports.ForAuthoring = ForAuthoring;
exports.playbackCommand_encode = playbackCommand_encode;
exports.playbackCommand_decode = playbackCommand_decode;
exports.ForPlayback = ForPlayback;
exports.stringify = stringify;
exports.stringifyRecordingCommand = stringifyRecordingCommand;
exports.stringifyAuthoringCommand = stringifyAuthoringCommand;
exports.stringifyPlaybackCommand = stringifyPlaybackCommand;
exports.updateSelectorInAuthoringCommand = updateSelectorInAuthoringCommand;
exports.CommandWithContextLocal = CommandWithContextLocal;
exports.CommandWithContextGlobalForRecording = CommandWithContextGlobalForRecording;
exports.CommandWithContextGlobalForRecordingResolved = CommandWithContextGlobalForRecordingResolved;
exports.CommandWithContextGlobalForAuthoring = CommandWithContextGlobalForAuthoring;
exports.CommandWithContextGlobalForPlayback = CommandWithContextGlobalForPlayback;
exports.decorateCommandWithGlobalContext = decorateCommandWithGlobalContext;
exports.decorateCommandWithLocalContextWithGlobalContext = decorateCommandWithLocalContextWithGlobalContext; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 81848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var Screenshot$SmartcutsMacros = __webpack_require__(80449);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromisedValue$SmartcutsMacros = __webpack_require__(19949);
var Storage__Images$SmartcutsMacros = __webpack_require__(28891);
var CommandPreconditions$SmartcutsMacros = __webpack_require__(89645);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    if (v.TAG === /* FromContentScript */ 0) {
        return [
            "FromContentScript",
            Decco.floatToJson(v._0)
        ];
    } else {
        return [
            "FromBgScript",
            Decco.floatToJson(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FromBgScript":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FromBgScript */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FromContentScript":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FromContentScript */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toFloat(v) {
    return v._0;
}
var ContextDependentDevicePixelRatio = {
    t_encode: t_encode,
    t_decode: t_decode,
    toFloat: toFloat
};
function windowGeometry_encode(v) {
    return Js_dict.fromArray([
        [
            "width",
            Decco.intToJson(v.width)
        ],
        [
            "height",
            Decco.intToJson(v.height)
        ],
        [
            "zoomFactor",
            Decco.floatToJson(v.zoomFactor)
        ],
        [
            "devicePixelRatio",
            t_encode(v.devicePixelRatio)
        ]
    ]);
}
function windowGeometry_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */ 0) {
        var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
        if (height.TAG === /* Ok */ 0) {
            var zoomFactor = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "zoomFactor"), null));
            if (zoomFactor.TAG === /* Ok */ 0) {
                var devicePixelRatio = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "devicePixelRatio"), null));
                if (devicePixelRatio.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            width: width._0,
                            height: height._0,
                            zoomFactor: zoomFactor._0,
                            devicePixelRatio: devicePixelRatio._0
                        }
                    };
                }
                var e = devicePixelRatio._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".devicePixelRatio" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = zoomFactor._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".zoomFactor" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = height._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".height" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = width._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".width" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function frame_encode(v) {
    if (v.TAG === /* TopFrame */ 0) {
        return [
            "TopFrame",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Frame",
            Decco.intToJson(v._0),
            Decco.stringToJson(v._1),
            Decco.intToJson(v._2)
        ];
    }
}
function frame_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Frame":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* Frame */ 1,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "TopFrame":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TopFrame */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$3 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function focusStatus_encode(v) {
    if (v) {
        return [
            "NotFocused"
        ];
    } else {
        return [
            "Focused"
        ];
    }
}
function focusStatus_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Focused":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Focused */ 0
                    };
                }
            case "NotFocused":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotFocused */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyFocusStatus(focusState) {
    if (focusState) {
        return "NotFocused";
    } else {
        return "Focused";
    }
}
function commandContextLocal_encode(v) {
    return Js_dict.fromArray([
        [
            "frame",
            frame_encode(v.frame)
        ],
        [
            "windowGeometry",
            windowGeometry_encode(v.windowGeometry)
        ],
        [
            "targetBoundingRect",
            Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
        ],
        [
            "timestamp",
            Decco.floatToJson(v.timestamp)
        ],
        [
            "htmlSnapshot",
            Decco.stringToJson(v.htmlSnapshot)
        ],
        [
            "preconditions",
            Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
        ],
        [
            "maybeLogoutLocator",
            Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
        ]
    ]);
}
function commandContextLocal_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var frame = frame_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
    if (frame.TAG === /* Ok */ 0) {
        var windowGeometry = windowGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
        if (windowGeometry.TAG === /* Ok */ 0) {
            var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
            if (targetBoundingRect.TAG === /* Ok */ 0) {
                var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                if (timestamp.TAG === /* Ok */ 0) {
                    var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
                    if (htmlSnapshot.TAG === /* Ok */ 0) {
                        var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
                        if (preconditions.TAG === /* Ok */ 0) {
                            var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
                            if (maybeLogoutLocator.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        frame: frame._0,
                                        windowGeometry: windowGeometry._0,
                                        targetBoundingRect: targetBoundingRect._0,
                                        timestamp: timestamp._0,
                                        htmlSnapshot: htmlSnapshot._0,
                                        preconditions: preconditions._0,
                                        maybeLogoutLocator: maybeLogoutLocator._0
                                    }
                                };
                            }
                            var e = maybeLogoutLocator._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".maybeLogoutLocator" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = preconditions._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".preconditions" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = htmlSnapshot._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".htmlSnapshot" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = timestamp._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".timestamp" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = targetBoundingRect._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".targetBoundingRect" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = windowGeometry._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".windowGeometry" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = frame._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".frame" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
var associatedElementBoundingRectFromTargetDomEvent = DOM__Event$SmartcutsMacros.boundingClientRectGet;
function targetBoundingRectFromDomElement(element) {
    return Rect$SmartcutsMacros.fromDomRect(element.getBoundingClientRect());
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "tabRef",
            PromisedValue$SmartcutsMacros.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.tabRef)
        ],
        [
            "url",
            PromisedValue$SmartcutsMacros.t_encode(Decco.stringToJson, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.url)
        ],
        [
            "focusStatus",
            focusStatus_encode(v.focusStatus)
        ],
        [
            "title",
            PromisedValue$SmartcutsMacros.t_encode(function(param) {
                return Decco.optionToJson(Decco.stringToJson, param);
            }, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.title)
        ],
        [
            "frame",
            PromisedValue$SmartcutsMacros.t_encode(frame_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.frame)
        ],
        [
            "windowGeometry",
            PromisedValue$SmartcutsMacros.t_encode(windowGeometry_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, v.windowGeometry)
        ],
        [
            "targetBoundingRect",
            Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
        ],
        [
            "timestamp",
            Decco.floatToJson(v.timestamp)
        ],
        [
            "htmlSnapshot",
            Decco.stringToJson(v.htmlSnapshot)
        ],
        [
            "screenshot",
            PromisedValue$SmartcutsMacros.t_encode(Screenshot$SmartcutsMacros.t_encode, Image$SmartcutsMacros.id_encode, v.screenshot)
        ],
        [
            "croppedScreenshot",
            Screenshot$SmartcutsMacros.t_encode(v.croppedScreenshot)
        ],
        [
            "preconditions",
            Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
        ],
        [
            "maybeLogoutLocator",
            Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
    if (windowRef.TAG === /* Ok */ 0) {
        var tabRef = PromisedValue$SmartcutsMacros.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
        if (tabRef.TAG === /* Ok */ 0) {
            var url = PromisedValue$SmartcutsMacros.t_decode(Decco.stringFromJson, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                var focusStatus = focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
                if (focusStatus.TAG === /* Ok */ 0) {
                    var title = PromisedValue$SmartcutsMacros.t_decode(function(param) {
                        return Decco.optionFromJson(Decco.stringFromJson, param);
                    }, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                    if (title.TAG === /* Ok */ 0) {
                        var frame = PromisedValue$SmartcutsMacros.t_decode(frame_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
                        if (frame.TAG === /* Ok */ 0) {
                            var windowGeometry = PromisedValue$SmartcutsMacros.t_decode(windowGeometry_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
                            if (windowGeometry.TAG === /* Ok */ 0) {
                                var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
                                if (targetBoundingRect.TAG === /* Ok */ 0) {
                                    var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                                    if (timestamp.TAG === /* Ok */ 0) {
                                        var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
                                        if (htmlSnapshot.TAG === /* Ok */ 0) {
                                            var screenshot = PromisedValue$SmartcutsMacros.t_decode(Screenshot$SmartcutsMacros.t_decode, Image$SmartcutsMacros.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenshot"), null));
                                            if (screenshot.TAG === /* Ok */ 0) {
                                                var croppedScreenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "croppedScreenshot"), null));
                                                if (croppedScreenshot.TAG === /* Ok */ 0) {
                                                    var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
                                                    if (preconditions.TAG === /* Ok */ 0) {
                                                        var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
                                                        if (maybeLogoutLocator.TAG === /* Ok */ 0) {
                                                            return {
                                                                TAG: /* Ok */ 0,
                                                                _0: {
                                                                    windowRef: windowRef._0,
                                                                    tabRef: tabRef._0,
                                                                    url: url._0,
                                                                    focusStatus: focusStatus._0,
                                                                    title: title._0,
                                                                    frame: frame._0,
                                                                    windowGeometry: windowGeometry._0,
                                                                    targetBoundingRect: targetBoundingRect._0,
                                                                    timestamp: timestamp._0,
                                                                    htmlSnapshot: htmlSnapshot._0,
                                                                    screenshot: screenshot._0,
                                                                    croppedScreenshot: croppedScreenshot._0,
                                                                    preconditions: preconditions._0,
                                                                    maybeLogoutLocator: maybeLogoutLocator._0
                                                                }
                                                            };
                                                        }
                                                        var e = maybeLogoutLocator._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".maybeLogoutLocator" + e.path,
                                                                message: e.message,
                                                                value: e.value
                                                            }
                                                        };
                                                    }
                                                    var e$1 = preconditions._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".preconditions" + e$1.path,
                                                            message: e$1.message,
                                                            value: e$1.value
                                                        }
                                                    };
                                                }
                                                var e$2 = croppedScreenshot._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".croppedScreenshot" + e$2.path,
                                                        message: e$2.message,
                                                        value: e$2.value
                                                    }
                                                };
                                            }
                                            var e$3 = screenshot._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".screenshot" + e$3.path,
                                                    message: e$3.message,
                                                    value: e$3.value
                                                }
                                            };
                                        }
                                        var e$4 = htmlSnapshot._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".htmlSnapshot" + e$4.path,
                                                message: e$4.message,
                                                value: e$4.value
                                            }
                                        };
                                    }
                                    var e$5 = timestamp._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".timestamp" + e$5.path,
                                            message: e$5.message,
                                            value: e$5.value
                                        }
                                    };
                                }
                                var e$6 = targetBoundingRect._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".targetBoundingRect" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                    }
                                };
                            }
                            var e$7 = windowGeometry._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".windowGeometry" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                }
                            };
                        }
                        var e$8 = frame._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".frame" + e$8.path,
                                message: e$8.message,
                                value: e$8.value
                            }
                        };
                    }
                    var e$9 = title._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".title" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = focusStatus._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".focusStatus" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            }
            var e$11 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                }
            };
        }
        var e$12 = tabRef._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tabRef" + e$12.path,
                message: e$12.message,
                value: e$12.value
            }
        };
    }
    var e$13 = windowRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowRef" + e$13.path,
            message: e$13.message,
            value: e$13.value
        }
    };
}
function minify(context) {
    var screenshot = context.screenshot;
    var tmp;
    tmp = screenshot.TAG === /* Resolved */ 0 ? {
        TAG: /* Resolved */ 0,
        _0: Screenshot$SmartcutsMacros.minify(screenshot._0)
    } : screenshot;
    return {
        windowRef: context.windowRef,
        tabRef: context.tabRef,
        url: context.url,
        focusStatus: context.focusStatus,
        title: context.title,
        frame: context.frame,
        windowGeometry: context.windowGeometry,
        targetBoundingRect: context.targetBoundingRect,
        timestamp: context.timestamp,
        htmlSnapshot: context.htmlSnapshot,
        screenshot: tmp,
        croppedScreenshot: Screenshot$SmartcutsMacros.minify(context.croppedScreenshot),
        preconditions: context.preconditions,
        maybeLogoutLocator: context.maybeLogoutLocator
    };
}
function getMaybeDevicePixelRatio(param) {
    var windowGeometry = param.windowGeometry;
    if (windowGeometry.TAG === /* Resolved */ 0) {
        return windowGeometry._0.devicePixelRatio._0;
    }
}
var CommandContextGlobalPromised = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    minify: minify,
    getMaybeDevicePixelRatio: getMaybeDevicePixelRatio
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "focusStatus",
            focusStatus_encode(v.focusStatus)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "frame",
            frame_encode(v.frame)
        ],
        [
            "windowGeometry",
            windowGeometry_encode(v.windowGeometry)
        ],
        [
            "targetBoundingRect",
            Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
        ],
        [
            "timestamp",
            Decco.floatToJson(v.timestamp)
        ],
        [
            "htmlSnapshot",
            Decco.stringToJson(v.htmlSnapshot)
        ],
        [
            "screenshot",
            Screenshot$SmartcutsMacros.t_encode(v.screenshot)
        ],
        [
            "croppedScreenshot",
            Screenshot$SmartcutsMacros.t_encode(v.croppedScreenshot)
        ],
        [
            "preconditions",
            Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v.preconditions)
        ],
        [
            "maybeLogoutLocator",
            Decco.optionToJson(Selector$SmartcutsMacros.elementSelector_encode, v.maybeLogoutLocator)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
    if (windowRef.TAG === /* Ok */ 0) {
        var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
        if (tabRef.TAG === /* Ok */ 0) {
            var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                var focusStatus = focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
                if (focusStatus.TAG === /* Ok */ 0) {
                    var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                    if (title.TAG === /* Ok */ 0) {
                        var frame = frame_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frame"), null));
                        if (frame.TAG === /* Ok */ 0) {
                            var windowGeometry = windowGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowGeometry"), null));
                            if (windowGeometry.TAG === /* Ok */ 0) {
                                var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
                                if (targetBoundingRect.TAG === /* Ok */ 0) {
                                    var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
                                    if (timestamp.TAG === /* Ok */ 0) {
                                        var htmlSnapshot = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlSnapshot"), null));
                                        if (htmlSnapshot.TAG === /* Ok */ 0) {
                                            var screenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenshot"), null));
                                            if (screenshot.TAG === /* Ok */ 0) {
                                                var croppedScreenshot = Screenshot$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "croppedScreenshot"), null));
                                                if (croppedScreenshot.TAG === /* Ok */ 0) {
                                                    var preconditions = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preconditions"), null));
                                                    if (preconditions.TAG === /* Ok */ 0) {
                                                        var maybeLogoutLocator = Decco.optionFromJson(Selector$SmartcutsMacros.elementSelector_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLogoutLocator"), null));
                                                        if (maybeLogoutLocator.TAG === /* Ok */ 0) {
                                                            return {
                                                                TAG: /* Ok */ 0,
                                                                _0: {
                                                                    windowRef: windowRef._0,
                                                                    tabRef: tabRef._0,
                                                                    url: url._0,
                                                                    focusStatus: focusStatus._0,
                                                                    title: title._0,
                                                                    frame: frame._0,
                                                                    windowGeometry: windowGeometry._0,
                                                                    targetBoundingRect: targetBoundingRect._0,
                                                                    timestamp: timestamp._0,
                                                                    htmlSnapshot: htmlSnapshot._0,
                                                                    screenshot: screenshot._0,
                                                                    croppedScreenshot: croppedScreenshot._0,
                                                                    preconditions: preconditions._0,
                                                                    maybeLogoutLocator: maybeLogoutLocator._0
                                                                }
                                                            };
                                                        }
                                                        var e = maybeLogoutLocator._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".maybeLogoutLocator" + e.path,
                                                                message: e.message,
                                                                value: e.value
                                                            }
                                                        };
                                                    }
                                                    var e$1 = preconditions._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".preconditions" + e$1.path,
                                                            message: e$1.message,
                                                            value: e$1.value
                                                        }
                                                    };
                                                }
                                                var e$2 = croppedScreenshot._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".croppedScreenshot" + e$2.path,
                                                        message: e$2.message,
                                                        value: e$2.value
                                                    }
                                                };
                                            }
                                            var e$3 = screenshot._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".screenshot" + e$3.path,
                                                    message: e$3.message,
                                                    value: e$3.value
                                                }
                                            };
                                        }
                                        var e$4 = htmlSnapshot._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".htmlSnapshot" + e$4.path,
                                                message: e$4.message,
                                                value: e$4.value
                                            }
                                        };
                                    }
                                    var e$5 = timestamp._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".timestamp" + e$5.path,
                                            message: e$5.message,
                                            value: e$5.value
                                        }
                                    };
                                }
                                var e$6 = targetBoundingRect._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".targetBoundingRect" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                    }
                                };
                            }
                            var e$7 = windowGeometry._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".windowGeometry" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                }
                            };
                        }
                        var e$8 = frame._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".frame" + e$8.path,
                                message: e$8.message,
                                value: e$8.value
                            }
                        };
                    }
                    var e$9 = title._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".title" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = focusStatus._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".focusStatus" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            }
            var e$11 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                }
            };
        }
        var e$12 = tabRef._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tabRef" + e$12.path,
                message: e$12.message,
                value: e$12.value
            }
        };
    }
    var e$13 = windowRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowRef" + e$13.path,
            message: e$13.message,
            value: e$13.value
        }
    };
}
function stringify(v) {
    return JSON.stringify(t_encode$2(v));
}
function fromCommandContextGlobalPromised(param) {
    var screenshot = param.screenshot;
    var tmp;
    tmp = screenshot.TAG === /* Resolved */ 0 ? screenshot._0 : /* NoImage */ 0;
    return {
        windowRef: param.windowRef,
        tabRef: PromisedValue$SmartcutsMacros.getResolvedExn(function(pendingPlaceholder) {
            return "for tabRef w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
        }, param.tabRef),
        url: PromisedValue$SmartcutsMacros.getResolvedExn(function(pendingPlaceholder) {
            return "for url w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
        }, param.url),
        focusStatus: param.focusStatus,
        title: PromisedValue$SmartcutsMacros.getResolvedExn(function(pendingPlaceholder) {
            return "for title w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
        }, param.title),
        frame: PromisedValue$SmartcutsMacros.getResolvedExn(function(pendingPlaceholder) {
            return "for frame w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
        }, param.frame),
        windowGeometry: PromisedValue$SmartcutsMacros.getResolvedExn(function(pendingPlaceholder) {
            return "for windowGeometry w/placeholder" + PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify(pendingPlaceholder);
        }, param.windowGeometry),
        targetBoundingRect: param.targetBoundingRect,
        timestamp: param.timestamp,
        htmlSnapshot: param.htmlSnapshot,
        screenshot: tmp,
        croppedScreenshot: param.croppedScreenshot,
        preconditions: param.preconditions,
        maybeLogoutLocator: param.maybeLogoutLocator
    };
}
function minify$1(context) {
    return {
        windowRef: context.windowRef,
        tabRef: context.tabRef,
        url: context.url,
        focusStatus: context.focusStatus,
        title: context.title,
        frame: context.frame,
        windowGeometry: context.windowGeometry,
        targetBoundingRect: context.targetBoundingRect,
        timestamp: context.timestamp,
        htmlSnapshot: context.htmlSnapshot,
        screenshot: Screenshot$SmartcutsMacros.minify(context.screenshot),
        croppedScreenshot: Screenshot$SmartcutsMacros.minify(context.croppedScreenshot),
        preconditions: context.preconditions,
        maybeLogoutLocator: context.maybeLogoutLocator
    };
}
function rehydrate(context) {
    return Promise.all([
        Storage__Images$SmartcutsMacros.rehydrateScreenshot(context.screenshot),
        Storage__Images$SmartcutsMacros.rehydrateScreenshot(context.croppedScreenshot)
    ]).then(function(param) {
        return Promise.resolve({
            windowRef: context.windowRef,
            tabRef: context.tabRef,
            url: context.url,
            focusStatus: context.focusStatus,
            title: context.title,
            frame: context.frame,
            windowGeometry: context.windowGeometry,
            targetBoundingRect: context.targetBoundingRect,
            timestamp: context.timestamp,
            htmlSnapshot: context.htmlSnapshot,
            screenshot: param[0],
            croppedScreenshot: param[1],
            preconditions: context.preconditions,
            maybeLogoutLocator: context.maybeLogoutLocator
        });
    });
}
function factorOutDynamicVars(commandContext) {
    var screenshot = commandContext.screenshot;
    var targetBoundingRect = commandContext.targetBoundingRect;
    var tmp;
    if (typeof screenshot === "number") {
        tmp = /* NoImage */ 0;
    } else {
        switch(screenshot.TAG | 0){
            case /* Image */ 0:
                tmp = {
                    TAG: /* Image */ 0,
                    _0: Image$SmartcutsMacros.makeIdFromString(""),
                    _1: screenshot._1
                };
                break;
            case /* SavingToCloud */ 1:
                tmp = {
                    TAG: /* SavingToCloud */ 1,
                    _0: Image$SmartcutsMacros.makeIdFromString(""),
                    _1: screenshot._1
                };
                break;
            case /* Cloud */ 2:
                tmp = {
                    TAG: /* Cloud */ 2,
                    _0: Image$SmartcutsMacros.makeIdFromString(""),
                    _1: screenshot._1
                };
                break;
        }
    }
    return {
        vars: [
            commandContext.timestamp,
            typeof screenshot === "number" ? "" : Image$SmartcutsMacros.idAsString(screenshot._0),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, function(r) {
                return r.x;
            })),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, function(r) {
                return r.y;
            })),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, function(r) {
                return r.width;
            })),
            OptionUtils$SmartcutsMacros.withDefault(0, OptionUtils$SmartcutsMacros.map(targetBoundingRect, function(r) {
                return r.height;
            }))
        ],
        factoredValue: {
            windowRef: commandContext.windowRef,
            tabRef: commandContext.tabRef,
            url: commandContext.url,
            focusStatus: commandContext.focusStatus,
            title: commandContext.title,
            frame: commandContext.frame,
            windowGeometry: commandContext.windowGeometry,
            targetBoundingRect: OptionUtils$SmartcutsMacros.map(targetBoundingRect, function(_r) {
                return {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }),
            timestamp: 0,
            htmlSnapshot: commandContext.htmlSnapshot,
            screenshot: tmp,
            croppedScreenshot: commandContext.croppedScreenshot,
            preconditions: commandContext.preconditions,
            maybeLogoutLocator: commandContext.maybeLogoutLocator
        }
    };
}
function substituteInDynamicVars(param1) {
    var factoredValue = param1.factoredValue;
    var vars = param1.vars;
    var arg = Js_json.decodeNumber(Caml_array.get(vars, 0));
    var timestamp = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected timestamp to be a number");
    var arg$1 = Js_json.decodeString(Caml_array.get(vars, 1));
    var screenshotId = Image$SmartcutsMacros.makeIdFromString(function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected screenshotId to be a string"));
    var arg$2 = Js_json.decodeNumber(Caml_array.get(vars, 2));
    var targetBoundingRect_x = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
    }("Expected targetBoundingRect x to be a number");
    var arg$3 = Js_json.decodeNumber(Caml_array.get(vars, 3));
    var targetBoundingRect_y = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
    }("Expected targetBoundingRect y to be a number");
    var arg$4 = Js_json.decodeNumber(Caml_array.get(vars, 4));
    var targetBoundingRect_width = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
    }("Expected targetBoundingRect width to be a number");
    var arg$5 = Js_json.decodeNumber(Caml_array.get(vars, 5));
    var targetBoundingRect_height = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$5);
    }("Expected targetBoundingRect height to be a number");
    var match = factoredValue.screenshot;
    var tmp;
    if (typeof match === "number") {
        tmp = /* NoImage */ 0;
    } else {
        switch(match.TAG | 0){
            case /* Image */ 0:
                tmp = {
                    TAG: /* Image */ 0,
                    _0: screenshotId,
                    _1: match._1
                };
                break;
            case /* SavingToCloud */ 1:
                tmp = {
                    TAG: /* SavingToCloud */ 1,
                    _0: screenshotId,
                    _1: match._1
                };
                break;
            case /* Cloud */ 2:
                tmp = {
                    TAG: /* Cloud */ 2,
                    _0: screenshotId,
                    _1: match._1
                };
                break;
        }
    }
    return {
        windowRef: factoredValue.windowRef,
        tabRef: factoredValue.tabRef,
        url: factoredValue.url,
        focusStatus: factoredValue.focusStatus,
        title: factoredValue.title,
        frame: factoredValue.frame,
        windowGeometry: factoredValue.windowGeometry,
        targetBoundingRect: OptionUtils$SmartcutsMacros.map(factoredValue.targetBoundingRect, function(_r) {
            return {
                x: targetBoundingRect_x,
                y: targetBoundingRect_y,
                width: targetBoundingRect_width,
                height: targetBoundingRect_height
            };
        }),
        timestamp: timestamp,
        htmlSnapshot: factoredValue.htmlSnapshot,
        screenshot: tmp,
        croppedScreenshot: factoredValue.croppedScreenshot,
        preconditions: factoredValue.preconditions,
        maybeLogoutLocator: factoredValue.maybeLogoutLocator
    };
}
var Pack = {
    factorOutDynamicVars: factorOutDynamicVars,
    substituteInDynamicVars: substituteInDynamicVars
};
var CommandContextGlobalResolved = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify,
    fromCommandContextGlobalPromised: fromCommandContextGlobalPromised,
    minify: minify$1,
    rehydrate: rehydrate,
    Pack: Pack
};
exports.ContextDependentDevicePixelRatio = ContextDependentDevicePixelRatio;
exports.windowGeometry_encode = windowGeometry_encode;
exports.windowGeometry_decode = windowGeometry_decode;
exports.frame_encode = frame_encode;
exports.frame_decode = frame_decode;
exports.focusStatus_encode = focusStatus_encode;
exports.focusStatus_decode = focusStatus_decode;
exports.stringifyFocusStatus = stringifyFocusStatus;
exports.commandContextLocal_encode = commandContextLocal_encode;
exports.commandContextLocal_decode = commandContextLocal_decode;
exports.associatedElementBoundingRectFromTargetDomEvent = associatedElementBoundingRectFromTargetDomEvent;
exports.targetBoundingRectFromDomElement = targetBoundingRectFromDomElement;
exports.CommandContextGlobalPromised = CommandContextGlobalPromised;
exports.CommandContextGlobalResolved = CommandContextGlobalResolved; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 23831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Command$SmartcutsMacros = __webpack_require__(4290);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromisedValue$SmartcutsMacros = __webpack_require__(19949);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
var GenericCommandWithContextGlobal$SmartcutsMacros = __webpack_require__(95551);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function local_encode(v) {
    return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextLocal.t_encode, v);
}
function local_decode(v) {
    return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextLocal.t_decode, v);
}
var t_encode = GenericCommandWithContextGlobal$SmartcutsMacros.t_encode;
var t_decode = GenericCommandWithContextGlobal$SmartcutsMacros.t_decode;
var Entry = {
    t_encode: t_encode,
    t_decode: t_decode
};
function t_encode$1(encoder_command, encoder_contextGlobal, v) {
    return Decco.listToJson(function(param) {
        return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_command, encoder_contextGlobal, param);
    }, v);
}
function t_decode$1(decoder_command, decoder_contextGlobal, v) {
    return Decco.listFromJson(function(param) {
        return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_command, decoder_contextGlobal, param);
    }, v);
}
var GlobalForGeneric = {
    Entry: Entry,
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_encode, v);
}
function t_decode$2(v) {
    return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_decode, v);
}
function insertAfterId(id, offset, commandsWithContextGlobal, commandLog) {
    var commandLogArray = $$Array.of_list(commandLog);
    var arg = Belt_Array.getIndexBy(commandLogArray, function(cmdWithContext) {
        return cmdWithContext.id === id;
    });
    var index = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected command log entry with id=" + String(id));
    return $$Array.to_list($$Array.concat({
        hd: Belt_Array.slice(commandLogArray, 0, (index + 1 | 0) + offset | 0),
        tl: {
            hd: $$Array.of_list(commandsWithContextGlobal),
            tl: {
                hd: Belt_Array.sliceToEnd(commandLogArray, (index + 1 | 0) + offset | 0),
                tl: /* [] */ 0
            }
        }
    }));
}
function extractOrigins(commandLog) {
    return ArrayUtils$SmartcutsMacros.unique(ArrayUtils$SmartcutsMacros.filterMap(function(param) {
        var url = param.contextGlobal.url;
        if (url.TAG === /* Resolved */ 0) {
            return Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(url._0), function(urlRecord) {
                return urlRecord.origin;
            });
        }
    }, Belt_Array.keep($$Array.of_list(commandLog), function(param) {
        var url = param.contextGlobal.url;
        if (url.TAG === /* Resolved */ 0) {
            return url._0 !== "";
        } else {
            return false;
        }
    })));
}
function toPrintable(commandLog) {
    return $$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_encode, commandLog));
}
function toPrintableCommands(commandLog) {
    return $$Array.of_list(List.map(function(param) {
        return Command$SmartcutsMacros.recordingCommand_encode(param.command);
    }, commandLog));
}
function getFirstURL(log) {
    if (!log) {
        return Util$SmartcutsMacros.logAndRaiseJsError("log must be non-empty");
    }
    var match = log.hd.command;
    if (typeof match === "number" || match.TAG !== /* NewWindowWithUrlCommand */ 1) {
        return Util$SmartcutsMacros.logAndRaiseJsError("First command of command log must be NewWindowWithUrlCommand(_, _)");
    } else {
        return match._0.url;
    }
}
function checkIfPromisedTabRefMatchesExistingTabInCommandLog(promisedTabRef, commandLog) {
    if (promisedTabRef.TAG === /* Resolved */ 0) {
        return Belt_List.reduce(commandLog, /* DoesNotMatchAnyTabs */ 0, function(matchingTabResult, param) {
            var comparisonResult = PromisedValue$SmartcutsMacros.compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef, param.contextGlobal.tabRef, promisedTabRef);
            if (matchingTabResult === 1) {
                return /* MatchesAtLeastOneTab */ 1;
            }
            if (matchingTabResult === 0) {
                switch(comparisonResult){
                    case /* ResolvedValuesAreEqual */ 0:
                        break;
                    case /* ResolvedValuesAreNotEqual */ 1:
                        return /* DoesNotMatchAnyTabs */ 0;
                    case /* UnableToDetermineEqualityBecauseOneIsNotResolved */ 2:
                        return /* UnableToDeterminIfDoesNotMatchAnyTabsBecauseSomeTabsStillPending */ 2;
                }
            }
            if (comparisonResult !== 0) {
                if (matchingTabResult >= 3) {
                    return /* UnableToDetermineIfDoesNotMatchAnyTabsBecauseTargetTabIsStillPending */ 3;
                } else {
                    return /* UnableToDeterminIfDoesNotMatchAnyTabsBecauseSomeTabsStillPending */ 2;
                }
            } else {
                return /* MatchesAtLeastOneTab */ 1;
            }
        });
    } else {
        return /* UnableToDetermineIfDoesNotMatchAnyTabsBecauseTargetTabIsStillPending */ 3;
    }
}
function prependCommandsToReverseCommandLogAccountingForTabId(commandsWithContextGlobal, _insertAfterOpt, _commandLogReversed) {
    while(true){
        var insertAfterOpt = _insertAfterOpt;
        var commandLogReversed = _commandLogReversed;
        var insertAfter = insertAfterOpt !== undefined ? insertAfterOpt : /* [] */ 0;
        var match = Belt_List.get(commandsWithContextGlobal, 0);
        if (match === undefined) {
            return commandLogReversed;
        }
        var tmp = match.command;
        if (typeof tmp !== "number" && tmp.TAG === /* FocusTabCommand */ 5) {
            return List.concat({
                hd: insertAfter,
                tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                        hd: commandLogReversed,
                        tl: /* [] */ 0
                    }
                }
            });
        }
        var promisedTabRef = match.contextGlobal.tabRef;
        var match$1 = checkIfPromisedTabRefMatchesExistingTabInCommandLog(promisedTabRef, commandLogReversed);
        if (match$1 !== 1) {
            return List.concat({
                hd: insertAfter,
                tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                        hd: commandLogReversed,
                        tl: /* [] */ 0
                    }
                }
            });
        }
        if (!commandLogReversed) {
            return List.append(insertAfter, List.rev(commandsWithContextGlobal));
        }
        var currCommandWithContext = commandLogReversed.hd;
        var comparisonResult = PromisedValue$SmartcutsMacros.compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef, currCommandWithContext.contextGlobal.tabRef, promisedTabRef);
        if (comparisonResult !== 1) {
            return List.concat({
                hd: insertAfter,
                tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                        hd: commandLogReversed,
                        tl: /* [] */ 0
                    }
                }
            });
        }
        _commandLogReversed = commandLogReversed.tl;
        _insertAfterOpt = List.append(insertAfter, {
            hd: currCommandWithContext,
            tl: /* [] */ 0
        });
        continue;
    }
    ;
}
function appendCommandsTakingIntoAccountTabs(commandsWithContextGlobal, commandLog) {
    return List.rev(prependCommandsToReverseCommandLogAccountingForTabId(commandsWithContextGlobal, undefined, List.rev(commandLog)));
}
var GlobalForRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    insertAfterId: insertAfterId,
    extractOrigins: extractOrigins,
    toPrintable: toPrintable,
    toPrintableCommands: toPrintableCommands,
    getFirstURL: getFirstURL,
    checkIfPromisedTabRefMatchesExistingTabInCommandLog: checkIfPromisedTabRefMatchesExistingTabInCommandLog,
    appendCommandsTakingIntoAccountTabs: appendCommandsTakingIntoAccountTabs
};
function t_encode$3(v) {
    return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_encode, v);
}
function t_decode$3(v) {
    return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_decode, v);
}
function calcSize(unit, commandLog) {
    return Belt_List.reduce(commandLog, 0, function(size, cmd) {
        var func = Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.calcSize;
        return size + Curry._2(func, unit, cmd) | 0;
    });
}
function minify(commandLog) {
    return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.minify, commandLog);
}
function toGraphql(commandLog) {
    return $$Array.mapi(function(i, commandWithContext) {
        return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.toGraphql(i, commandWithContext));
    }, $$Array.of_list(commandLog));
}
function toPrintable$1(commandLog) {
    return $$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_encode, commandLog));
}
function toPrintableCommands$1(commandLog) {
    return $$Array.of_list(List.map(function(param) {
        return Command$SmartcutsMacros.authoringCommand_encode(param.command);
    }, commandLog));
}
var GlobalForAuthoring = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    calcSize: calcSize,
    minify: minify,
    toGraphql: toGraphql,
    toPrintable: toPrintable$1,
    toPrintableCommands: toPrintableCommands$1
};
function t_encode$4(v) {
    return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.t_encode, v);
}
function t_decode$4(v) {
    return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.t_decode, v);
}
function toPrintable$2(commandLog) {
    return $$Array.of_list(List.map(function(param) {
        return Command$SmartcutsMacros.playbackCommand_encode(param.command);
    }, commandLog));
}
function calcSize$1(unit, commandLog) {
    return Belt_List.reduce(commandLog, 0, function(size, cmd) {
        return size + Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.calcSize(unit, cmd) | 0;
    });
}
function minify$1(commandLog) {
    return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, commandLog);
}
function rehydrate(commandLog) {
    return Promise.all($$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.rehydrate, commandLog))).then(function(arr) {
        return Promise.resolve($$Array.to_list(arr));
    });
}
function toGraphql$1(commandLog) {
    return $$Array.mapi(function(i, commandWithContext) {
        return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.toGraphql(i, commandWithContext));
    }, $$Array.of_list(commandLog));
}
function doesRequireGoogleOAuth(commandLog) {
    return Belt_List.some(commandLog, function(param) {
        return GoogleSheetHelpers$SmartcutsMacros.isGoogleSheetUrl(param.contextGlobal.url);
    });
}
function updateNextOpenedLinkCommandWithPlaybackUrl(tabId, playbackUrl, commandLog) {
    return ListUtils$SmartcutsMacros.updateFirstMatch(function(param) {
        var command = param.command;
        if (typeof command === "number") {
            return false;
        }
        if (command.TAG !== /* OpenedLinkCommand */ 7) {
            return false;
        }
        var playbackTabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(command._0.tabRef);
        if (playbackTabId !== undefined) {
            return Caml_obj.caml_equal(Caml_option.valFromOption(playbackTabId), tabId);
        } else {
            return false;
        }
    }, function(commandWithContext) {
        var contextGlobal = commandWithContext.contextGlobal;
        var command = commandWithContext.command;
        if (typeof command === "number") {
            return commandWithContext;
        }
        if (command.TAG !== /* OpenedLinkCommand */ 7) {
            return commandWithContext;
        }
        var cmdVal = command._0;
        return {
            id: commandWithContext.id,
            command: {
                TAG: /* OpenedLinkCommand */ 7,
                _0: {
                    tabRef: cmdVal.tabRef,
                    windowRef: cmdVal.windowRef,
                    url: playbackUrl,
                    title: cmdVal.title,
                    maybeOpenerTab: cmdVal.maybeOpenerTab,
                    viaHistoryApi: cmdVal.viaHistoryApi
                }
            },
            contextGlobal: {
                windowRef: contextGlobal.windowRef,
                tabRef: contextGlobal.tabRef,
                url: playbackUrl,
                focusStatus: contextGlobal.focusStatus,
                title: contextGlobal.title,
                frame: contextGlobal.frame,
                windowGeometry: contextGlobal.windowGeometry,
                targetBoundingRect: contextGlobal.targetBoundingRect,
                timestamp: contextGlobal.timestamp,
                htmlSnapshot: contextGlobal.htmlSnapshot,
                screenshot: contextGlobal.screenshot,
                croppedScreenshot: contextGlobal.croppedScreenshot,
                preconditions: contextGlobal.preconditions,
                maybeLogoutLocator: contextGlobal.maybeLogoutLocator
            }
        };
    }, commandLog);
}
function doesNotKnowAllUrlsAheadOfTime(commandLog) {
    return Belt_List.some(commandLog, function(param) {
        var command = param.command;
        if (Command$SmartcutsMacros.ForPlayback.isOpenedLinkCommand(command)) {
            return true;
        } else {
            return Command$SmartcutsMacros.ForPlayback.isLoopCommand(command);
        }
    });
}
var GlobalForPlayback = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    toPrintable: toPrintable$2,
    calcSize: calcSize$1,
    minify: minify$1,
    rehydrate: rehydrate,
    toGraphql: toGraphql$1,
    doesRequireGoogleOAuth: doesRequireGoogleOAuth,
    updateNextOpenedLinkCommandWithPlaybackUrl: updateNextOpenedLinkCommandWithPlaybackUrl,
    doesNotKnowAllUrlsAheadOfTime: doesNotKnowAllUrlsAheadOfTime
};
function t_encode$5(v) {
    return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.t_encode, v);
}
function t_decode$5(v) {
    return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.t_decode, v);
}
function fromGlobalForRecording(globalForRecording) {
    return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.fromCommandWithContextGlobalForRecording, globalForRecording);
}
function calcSize$2(unit, commandLog) {
    return Belt_List.reduce(commandLog, 0, function(size, cmd) {
        return size + Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.calcSize(unit, cmd) | 0;
    });
}
function minify$2(commandLog) {
    return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.minify, commandLog);
}
function toGraphql$2(commandLog) {
    return $$Array.mapi(function(i, commandWithContext) {
        return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.toGraphql(i, commandWithContext));
    }, $$Array.of_list(commandLog));
}
var GlobalForRecordingResolved = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromGlobalForRecording: fromGlobalForRecording,
    calcSize: calcSize$2,
    minify: minify$2,
    toGraphql: toGraphql$2
};
exports.local_encode = local_encode;
exports.local_decode = local_decode;
exports.GlobalForGeneric = GlobalForGeneric;
exports.GlobalForRecording = GlobalForRecording;
exports.GlobalForAuthoring = GlobalForAuthoring;
exports.GlobalForPlayback = GlobalForPlayback;
exports.GlobalForRecordingResolved = GlobalForRecordingResolved; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 89645:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__FocusTrail$SmartcutsMacros = __webpack_require__(62912);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "focusedElement",
            Decco.optionToJson(Selector$SmartcutsMacros.selector_encode, v.focusedElement)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var focusedElement = Decco.optionFromJson(Selector$SmartcutsMacros.selector_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "focusedElement"), null));
    if (focusedElement.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                focusedElement: focusedElement._0
            }
        };
    }
    var e = focusedElement._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".focusedElement" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function isRelevantCommandFocusPrecondition(htmlElement) {
    var _otherTagName = htmlElement.tagName;
    switch(_otherTagName){
        case "INPUT":
            var match = htmlElement.type;
            switch(match){
                case "date":
                case "datetime-local":
                case "email":
                case "month":
                case "number":
                case "password":
                case "search":
                case "tel":
                case "text":
                case "time":
                case "url":
                case "week":
                    return true;
                default:
                    return false;
            }
        case "TEXTAREA":
            return true;
        default:
            return htmlElement.isContentEditable;
    }
}
function maybeFromFocusedHtmlElement(htmlElement) {
    if (isRelevantCommandFocusPrecondition(htmlElement)) {
        return {
            focusedElement: Selector$SmartcutsMacros.forDomElement(htmlElement)
        };
    }
}
function maybeFromDomEventAndFocusTrail(focusTrail, domEvent) {
    if (domEvent.TAG !== /* MouseEvent */ 0) {
        return;
    }
    if (domEvent._0 !== "click") {
        return;
    }
    var func = function func(param, param$1) {
        return DOM__FocusTrail$SmartcutsMacros.getFocusedElementJustBeforeClickEvent(150, param, param$1);
    };
    return Belt_Option.flatMap(Curry._2(func, domEvent._1, focusTrail), maybeFromFocusedHtmlElement);
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.maybeFromDomEventAndFocusTrail = maybeFromDomEventAndFocusTrail; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var GoogleSheetTypes$SmartcutsMacros = __webpack_require__(25330);
var CopyImageSrcCommand$SmartcutsMacros = __webpack_require__(68875);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
function findCommandIndexWithMatchingUrl(url, log) {
    return ListUtils$SmartcutsMacros.findIndex(function(param) {
        return param.contextGlobal.url === url;
    }, log);
}
function maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef1, value) {
    if (typeof value === "number") {
        return value;
    }
    if (value.TAG !== /* Value */ 1) {
        return value;
    }
    var newDataRef = Curry._2(maybeSubstituteUrlIntoDataRef1, log, value._0);
    if (newDataRef !== undefined) {
        return {
            TAG: /* Value */ 1,
            _0: newDataRef
        };
    } else {
        return value;
    }
}
function maybeSubstituteUrlIntoDataRef(log, dataRef) {
    var maybeUrl;
    var exit = 0;
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            exit = 1;
            break;
        default:
            maybeUrl = undefined;
    }
    if (exit === 1) {
        var str = dataRef._0;
        maybeUrl = RegExUtils$SmartcutsMacros.isUrl(str) ? str : undefined;
    }
    return OptionUtils$SmartcutsMacros.andThen(function(url) {
        var matchingCommandIndex = findCommandIndexWithMatchingUrl(url, log);
        if (matchingCommandIndex !== undefined) {
            return {
                TAG: /* TextFromUrl */ 5,
                _0: {
                    commandId: matchingCommandIndex,
                    commandIndex: matchingCommandIndex,
                    url: url
                }
            };
        }
    }, maybeUrl);
}
function maybeSubstituteUrlIntoAuthoringCommandWithContext(log, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return commandWithContext;
    }
    switch(command.TAG | 0){
        case /* PasteInInputCommand */ 27:
            var commandValue = command._0;
            var dataRef1 = commandValue.text;
            var newDataRef1 = maybeSubstituteUrlIntoDataRef(log, dataRef1);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInInputCommand */ 27,
                    _0: {
                        positioning: commandValue.positioning,
                        text: newDataRef1 !== undefined ? newDataRef1 : dataRef1,
                        label: commandValue.label
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* PasteInContentEditableCommand */ 28:
            var commandValue$1 = command._0;
            var dataRef$1 = commandValue$1.text;
            var newDataRef$1 = maybeSubstituteUrlIntoDataRef(log, dataRef$1);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInContentEditableCommand */ 28,
                    _0: {
                        positioning: commandValue$1.positioning,
                        text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* GoogleSheetsCommand */ 33:
            var commandValue$2 = command._0;
            var upsertRowParam = commandValue$2.update;
            if (upsertRowParam.TAG === /* UpsertRow */ 0) {
                var match = upsertRowParam._0;
                var rowLocation = match.rowLocation;
                return {
                    id: commandWithContext.id,
                    command: {
                        TAG: /* GoogleSheetsCommand */ 33,
                        _0: {
                            spreadsheetId: commandValue$2.spreadsheetId,
                            sheetName: commandValue$2.sheetName,
                            colNames: commandValue$2.colNames,
                            update: {
                                TAG: /* UpsertRow */ 0,
                                _0: {
                                    rowLocation: {
                                        rowIndex: rowLocation.rowIndex,
                                        keyColumnIndex: rowLocation.keyColumnIndex,
                                        rowData: $$Array.map(function(param) {
                                            return maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef, param);
                                        }, rowLocation.rowData)
                                    },
                                    cellValues: Belt_Array.map(match.cellValues, function(cellValue) {
                                        if (typeof cellValue === "number") {
                                            return cellValue;
                                        }
                                        if (cellValue.TAG !== /* Value */ 1) {
                                            return cellValue;
                                        }
                                        var dataRef = cellValue._0;
                                        var newDataRef = maybeSubstituteUrlIntoDataRef(log, dataRef);
                                        return {
                                            TAG: /* Value */ 1,
                                            _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                    })
                                }
                            }
                        }
                    },
                    contextGlobal: commandWithContext.contextGlobal
                };
            }
            var upsertRowParam$1 = upsertRowParam._0;
            var cellUpdate = upsertRowParam$1.cellUpdate;
            var rowLocation$1 = upsertRowParam$1.rowLocation;
            var dataRef$2 = cellUpdate.toValue;
            var tmp;
            if (typeof dataRef$2 === "number" || dataRef$2.TAG !== /* Value */ 1) {
                tmp = cellUpdate;
            } else {
                var dataRef$3 = dataRef$2._0;
                var newDataRef$2 = maybeSubstituteUrlIntoDataRef(log, dataRef$3);
                tmp = {
                    fromValue: cellUpdate.fromValue,
                    toValue: {
                        TAG: /* Value */ 1,
                        _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$3
                    }
                };
            }
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* GoogleSheetsCommand */ 33,
                    _0: {
                        spreadsheetId: commandValue$2.spreadsheetId,
                        sheetName: commandValue$2.sheetName,
                        colNames: commandValue$2.colNames,
                        update: {
                            TAG: /* UpdateCell */ 1,
                            _0: {
                                rowLocation: {
                                    rowIndex: rowLocation$1.rowIndex,
                                    keyColumnIndex: rowLocation$1.keyColumnIndex,
                                    rowData: $$Array.map(function(param) {
                                        return maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef, param);
                                    }, rowLocation$1.rowData)
                                },
                                updatedColIndex: upsertRowParam$1.updatedColIndex,
                                cellUpdate: tmp
                            }
                        }
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        default:
            return commandWithContext;
    }
}
function lookupMaybePriorMatchingImgSrcFromContextMenuCommand(commandLog, commandLogIndex, text) {
    var imageUrl = URLUtils$SmartcutsMacros.$$URL.fromString(text);
    if (imageUrl === undefined) {
        return;
    }
    var arg = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
    var param1 = function param1(param$1, i) {
        var tabUrl = param$1.contextGlobal.url;
        var command = param$1.command;
        if (typeof command === "number") {
            return;
        }
        if (command.TAG !== /* ContextMenuCommand */ 34) {
            return;
        }
        var match = command._0;
        var maybeSubPathToImg = match.maybeSubPathToImg;
        var selector = match.selector;
        var match$1 = Selector$SmartcutsMacros.maybeGetLeafNode(selector);
        if (match$1 === undefined) {
            return;
        }
        var match$2 = match$1.tagName;
        if (match$2 !== undefined && match$2 === "img" && Belt_Array.some(match$1.attributes, function(param) {
            if (param[0] === "src") {
                return CopyImageSrcCommand$SmartcutsMacros.isImgSrcEqualToImageUrl(param[1], imageUrl, tabUrl);
            } else {
                return false;
            }
        })) {
            return [
                i,
                {
                    selector: selector,
                    src: text
                }
            ];
        }
        if (maybeSubPathToImg === undefined) {
            return;
        }
        var nestedImgSrc = maybeSubPathToImg[1];
        if (nestedImgSrc !== undefined && CopyImageSrcCommand$SmartcutsMacros.isImgSrcEqualToImageUrl(nestedImgSrc, imageUrl, tabUrl)) {
            return [
                i,
                {
                    selector: List.append(selector, maybeSubPathToImg[0]),
                    src: text
                }
            ];
        }
    };
    return ArrayUtils$SmartcutsMacros.shortcutWithIndex(param1, arg);
}
function maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text, commandWithContext, buildNewCommandWithTextFromCommandDataRef) {
    return Belt_Option.map(lookupMaybePriorMatchingImgSrcFromContextMenuCommand(commandLog, commandLogIndex, text), function(param) {
        var indexToUpdate = param[0];
        return [
            {
                id: commandWithContext.id,
                command: Curry._1(buildNewCommandWithTextFromCommandDataRef, {
                    TAG: /* TextFromCommand */ 2,
                    _0: {
                        commandId: Belt_List.getExn(commandLog, indexToUpdate).id,
                        commandInfo: null,
                        text: text
                    }
                }),
                contextGlobal: commandWithContext.contextGlobal
            },
            [
                indexToUpdate,
                param[1]
            ]
        ];
    });
}
function maybeConvertContextMenuCmdsToCopyImageSrcCmds(commandLog, commandLogIndex, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* PasteInInputCommand */ 27:
            var cmdVal = command._0;
            var text1 = cmdVal.text;
            switch(text1.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    break;
                default:
                    return;
            }
            var text$11 = text1._0;
            if (text$11.startsWith("http")) {
                return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$11, commandWithContext, function(textFromCommandDataRef) {
                    return {
                        TAG: /* PasteInInputCommand */ 27,
                        _0: {
                            positioning: cmdVal.positioning,
                            text: textFromCommandDataRef,
                            label: cmdVal.label
                        }
                    };
                });
            } else {
                return;
            }
        case /* PasteInContentEditableCommand */ 28:
            var cmdVal$1 = command._0;
            var text$2 = cmdVal$1.text;
            switch(text$2.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    break;
                default:
                    return;
            }
            var text$3 = text$2._0;
            if (text$3.startsWith("http")) {
                return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$3, commandWithContext, function(textFromCommandDataRef) {
                    return {
                        TAG: /* PasteInContentEditableCommand */ 28,
                        _0: {
                            positioning: cmdVal$1.positioning,
                            text: textFromCommandDataRef
                        }
                    };
                });
            } else {
                return;
            }
        case /* GoogleSheetsCommand */ 33:
            var cmdVal$2 = command._0;
            var update = cmdVal$2.update;
            if (update.TAG === /* UpsertRow */ 0) {
                var upsertRow = update._0;
                var cellValues = upsertRow.cellValues;
                var maybeReferencedUrlAndIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(cellValue, i) {
                    if (typeof cellValue === "number") {
                        return;
                    }
                    if (cellValue.TAG !== /* Value */ 1) {
                        return;
                    }
                    var text = cellValue._0;
                    switch(text.TAG | 0){
                        case /* StaticText */ 0:
                        case /* PasteText */ 1:
                            break;
                        default:
                            return;
                    }
                    var text$1 = text._0;
                    if (text$1.startsWith("http")) {
                        return [
                            text$1,
                            i
                        ];
                    }
                }, cellValues);
                return Belt_Option.flatMap(maybeReferencedUrlAndIndex, function(param) {
                    var index = param[1];
                    return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, param[0], commandWithContext, function(textFromCommandDataRef) {
                        return {
                            TAG: /* GoogleSheetsCommand */ 33,
                            _0: {
                                spreadsheetId: cmdVal$2.spreadsheetId,
                                sheetName: cmdVal$2.sheetName,
                                colNames: cmdVal$2.colNames,
                                update: {
                                    TAG: /* UpsertRow */ 0,
                                    _0: {
                                        rowLocation: upsertRow.rowLocation,
                                        cellValues: ArrayUtils$SmartcutsMacros.setWithoutFill2(cellValues, index, {
                                            TAG: /* Value */ 1,
                                            _0: textFromCommandDataRef
                                        })
                                    }
                                }
                            }
                        };
                    });
                });
            }
            var updateCell = update._0;
            var cellUpdate = updateCell.cellUpdate;
            var match = cellUpdate.toValue;
            if (typeof match === "number") {
                return;
            }
            if (match.TAG !== /* Value */ 1) {
                return;
            }
            var text$4 = match._0;
            switch(text$4.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    break;
                default:
                    return;
            }
            var text$5 = text$4._0;
            if (text$5.startsWith("http")) {
                return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$5, commandWithContext, function(textFromCommandDataRef) {
                    return {
                        TAG: /* GoogleSheetsCommand */ 33,
                        _0: {
                            spreadsheetId: cmdVal$2.spreadsheetId,
                            sheetName: cmdVal$2.sheetName,
                            colNames: cmdVal$2.colNames,
                            update: {
                                TAG: /* UpdateCell */ 1,
                                _0: {
                                    rowLocation: updateCell.rowLocation,
                                    updatedColIndex: updateCell.updatedColIndex,
                                    cellUpdate: {
                                        fromValue: cellUpdate.fromValue,
                                        toValue: {
                                            TAG: /* Value */ 1,
                                            _0: textFromCommandDataRef
                                        }
                                    }
                                }
                            }
                        }
                    };
                });
            } else {
                return;
            }
            break;
        default:
            return;
    }
}
function adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell(commandLog, spreadsheetId, sheetName, commandLogIndex, rowLocation) {
    var priorCommandsWithContext = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
    var maybeIndexOfMatchingCommand = Belt_Option.map(Belt_Array.getIndexBy(Belt_Array.reverse(priorCommandsWithContext), function(param) {
        var command = param.command;
        if (typeof command === "number") {
            return false;
        }
        if (command.TAG !== /* GoogleSheetsCommand */ 33) {
            return false;
        }
        var curr = command._0;
        var upsert = curr.update;
        if (upsert.TAG === /* UpsertRow */ 0 && curr.spreadsheetId === spreadsheetId && curr.sheetName === sheetName) {
            return Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, upsert._0.rowLocation) === Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, rowLocation);
        } else {
            return false;
        }
    }), function(reversedIndex) {
        return (commandLogIndex - 1 | 0) - reversedIndex | 0;
    });
    var maybeCommandId = OptionUtils$SmartcutsMacros.andThen(function(index) {
        var match = Belt_List.get(commandLog, index);
        if (match !== undefined) {
            return match.id;
        }
    }, maybeIndexOfMatchingCommand);
    var arg = Belt_Option.map(maybeCommandId, function(commandId) {
        return {
            rowIndex: rowLocation.rowIndex,
            keyColumnIndex: rowLocation.keyColumnIndex,
            rowData: ArrayUtils$SmartcutsMacros.setWithoutFill(rowLocation.keyColumnIndex, {
                TAG: /* Value */ 1,
                _0: {
                    TAG: /* TextFromGSheetUpsertCommand */ 3,
                    _0: {
                        commandId: commandId,
                        text: Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, rowLocation)
                    }
                }
            }, rowLocation.rowData)
        };
    });
    return OptionUtils$SmartcutsMacros.withDefault(rowLocation, arg);
}
function adjustGoogleSheetCommandPrimaryLookups(commandLog, commandLogIndex, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return commandWithContext;
    }
    if (command.TAG !== /* GoogleSheetsCommand */ 33) {
        return commandWithContext;
    }
    var cmdVal = command._0;
    var update = cmdVal.update;
    var tmp;
    if (update.TAG === /* UpsertRow */ 0) {
        tmp = update;
    } else {
        var updateCell = update._0;
        tmp = {
            TAG: /* UpdateCell */ 1,
            _0: {
                rowLocation: adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell(commandLog, cmdVal.spreadsheetId, cmdVal.sheetName, commandLogIndex, updateCell.rowLocation),
                updatedColIndex: updateCell.updatedColIndex,
                cellUpdate: updateCell.cellUpdate
            }
        };
    }
    return {
        id: commandWithContext.id,
        command: {
            TAG: /* GoogleSheetsCommand */ 33,
            _0: {
                spreadsheetId: cmdVal.spreadsheetId,
                sheetName: cmdVal.sheetName,
                colNames: cmdVal.colNames,
                update: tmp
            }
        },
        contextGlobal: commandWithContext.contextGlobal
    };
}
function getCommandLogIdOfLastCopyOrCutCommand(text, commandLog) {
    var maybeIndexOfMatchingCommand = OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(Belt_Array.reverse($$Array.of_list(commandLog)), function(param) {
        var tmp = param.command;
        if (typeof tmp === "number") {
            return false;
        }
        switch(tmp.TAG | 0){
            case /* CopyCommand */ 24:
            case /* CopyLinkAddressCommand */ 25:
            case /* CutCommand */ 26:
                return true;
            default:
                return false;
        }
    }), function(reversedIndex) {
        return (List.length(commandLog) - 1 | 0) - reversedIndex | 0;
    });
    return OptionUtils$SmartcutsMacros.andThen(function(index) {
        var match = Belt_List.get(commandLog, index);
        if (match === undefined) {
            return;
        }
        var match$1 = match.command;
        var commandId = match.id;
        if (typeof match$1 === "number") {
            return;
        }
        switch(match$1.TAG | 0){
            case /* CopyLinkAddressCommand */ 25:
                if (match$1._0.href === text) {
                    return commandId;
                } else {
                    return;
                }
            case /* CopyCommand */ 24:
            case /* CutCommand */ 26:
                break;
            default:
                return;
        }
        var match$2 = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(match$1._0.selection);
        if (match$2[1] === text) {
            return commandId;
        }
    }, maybeIndexOfMatchingCommand);
}
function substituteStaticTextWithPossibleDataRefToLastCopyOrCut(currSemantic, currChosen, text, currIntentionChoices, priorCommands, wrapTextFromCommand) {
    var commandId = getCommandLogIdOfLastCopyOrCutCommand(text, priorCommands);
    var match;
    if (commandId !== undefined) {
        var nextChosen = Curry._1(wrapTextFromCommand, {
            TAG: /* TextFromCommand */ 2,
            _0: {
                commandId: commandId,
                commandInfo: null,
                text: text
            }
        });
        match = [
            [
                nextChosen
            ],
            nextChosen
        ];
    } else {
        match = [
            [],
            currChosen
        ];
    }
    return [
        $$Array.concat({
            hd: match[0],
            tl: {
                hd: currIntentionChoices,
                tl: {
                    hd: [
                        currSemantic
                    ],
                    tl: /* [] */ 0
                }
            }
        }),
        match[1]
    ];
}
function maybeAdjustInnerTextConfigWithDataRefs(priorCommands, param3) {
    var chosen = param3.chosen;
    var match1 = Belt_Array.reduce(param3.intentionChoices, [
        [],
        chosen,
        chosen
    ], function(param, intention) {
        var preferredChosen = param[2];
        var nextChosen = param[1];
        var nextIntentionChoices = param[0];
        var match;
        var exit = 0;
        if (typeof intention === "number") {
            exit = 1;
        } else {
            switch(intention.TAG | 0){
                case /* MatchesFullInnerText */ 0:
                    var text = intention._0;
                    if (text.TAG === /* StaticText */ 0) {
                        match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text._0, nextIntentionChoices, priorCommands, function(textFromCommand) {
                            return {
                                TAG: /* MatchesFullInnerText */ 0,
                                _0: textFromCommand
                            };
                        });
                    } else {
                        exit = 1;
                    }
                    break;
                case /* MatchesInnerTextPrefix */ 1:
                    var text$1 = intention._0;
                    if (text$1.TAG === /* StaticText */ 0) {
                        match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text$1._0, nextIntentionChoices, priorCommands, function(textFromCommand) {
                            return {
                                TAG: /* MatchesInnerTextPrefix */ 1,
                                _0: textFromCommand
                            };
                        });
                    } else {
                        exit = 1;
                    }
                    break;
                case /* ContainsInnerText */ 2:
                    var text$2 = intention._0;
                    if (text$2.TAG === /* StaticText */ 0) {
                        match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text$2._0, nextIntentionChoices, priorCommands, function(textFromCommand) {
                            return {
                                TAG: /* ContainsInnerText */ 2,
                                _0: textFromCommand
                            };
                        });
                    } else {
                        exit = 1;
                    }
                    break;
                default:
                    exit = 1;
            }
        }
        if (exit === 1) {
            match = [
                $$Array.append(nextIntentionChoices, [
                    intention
                ]),
                nextChosen
            ];
        }
        var nextChosen2 = match[1];
        var preferredChosen2;
        var exit$1 = 0;
        var exit$2 = 0;
        var exit$3 = 0;
        if (typeof preferredChosen === "number" || !(preferredChosen.TAG === /* ContainsInnerText */ 2 && preferredChosen._0.TAG === /* TextFromCommand */ 2)) {
            exit$3 = 3;
        } else {
            preferredChosen2 = preferredChosen;
        }
        if (exit$3 === 3) {
            if (typeof nextChosen2 === "number" || !(nextChosen2.TAG === /* ContainsInnerText */ 2 && nextChosen2._0.TAG === /* TextFromCommand */ 2)) {
                exit$2 = 2;
            } else {
                preferredChosen2 = nextChosen2;
            }
        }
        if (exit$2 === 2) {
            if (typeof preferredChosen === "number" || !(preferredChosen.TAG === /* ContainsInnerText */ 2 && preferredChosen._0.TAG === /* StaticText */ 0)) {
                exit$1 = 1;
            } else {
                preferredChosen2 = preferredChosen;
            }
        }
        if (exit$1 === 1) {
            preferredChosen2 = nextChosen2;
        }
        return [
            match[0],
            nextChosen2,
            preferredChosen2
        ];
    });
    return {
        intentionChoices: match1[0],
        chosen: match1[2]
    };
}
var AuthoringConfig = {
    maybeAdjustInnerTextConfigWithDataRefs: maybeAdjustInnerTextConfigWithDataRefs
};
function maybeSubstituteUrlIntoDataRef$1(log, dataRef) {
    if (dataRef.TAG !== /* TextFromUrl */ 5) {
        return;
    }
    var textFromUrlParam = dataRef._0;
    var match = Belt_List.get(log, textFromUrlParam.commandIndex);
    if (match !== undefined) {
        return {
            TAG: /* TextFromUrl */ 5,
            _0: {
                commandId: textFromUrlParam.commandId,
                commandIndex: textFromUrlParam.commandIndex,
                url: match.contextGlobal.url
            }
        };
    }
}
function maybeSubstituteUrlIntoPlaybackCommandWithContext(log, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return commandWithContext;
    }
    switch(command.TAG | 0){
        case /* PasteInInputCommand */ 27:
            var commandValue = command._0;
            var dataRef2 = commandValue.text;
            var newDataRef2 = maybeSubstituteUrlIntoDataRef$1(log, dataRef2);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInInputCommand */ 27,
                    _0: {
                        positioning: commandValue.positioning,
                        text: newDataRef2 !== undefined ? newDataRef2 : dataRef2,
                        label: commandValue.label
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* PasteInContentEditableCommand */ 28:
            var commandValue$1 = command._0;
            var dataRef$1 = commandValue$1.text;
            var newDataRef$1 = maybeSubstituteUrlIntoDataRef$1(log, dataRef$1);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInContentEditableCommand */ 28,
                    _0: {
                        positioning: commandValue$1.positioning,
                        text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* GoogleSheetsCommand */ 33:
            var commandValue$2 = command._0;
            var upsertRowParam = commandValue$2.update;
            if (upsertRowParam.TAG === /* UpsertRow */ 0) {
                var match = upsertRowParam._0;
                var rowLocation = match.rowLocation;
                return {
                    id: commandWithContext.id,
                    command: {
                        TAG: /* GoogleSheetsCommand */ 33,
                        _0: {
                            spreadsheetId: commandValue$2.spreadsheetId,
                            sheetName: commandValue$2.sheetName,
                            colNames: commandValue$2.colNames,
                            update: {
                                TAG: /* UpsertRow */ 0,
                                _0: {
                                    rowLocation: {
                                        keyColumnIndex: rowLocation.keyColumnIndex,
                                        keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$1, rowLocation.keyColumnValue)
                                    },
                                    cellValues: Belt_Array.map(match.cellValues, function(cellValue) {
                                        if (typeof cellValue === "number") {
                                            return cellValue;
                                        }
                                        if (cellValue.TAG !== /* Value */ 1) {
                                            return cellValue;
                                        }
                                        var dataRef = cellValue._0;
                                        var newDataRef = maybeSubstituteUrlIntoDataRef$1(log, dataRef);
                                        return {
                                            TAG: /* Value */ 1,
                                            _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                    })
                                }
                            }
                        }
                    },
                    contextGlobal: commandWithContext.contextGlobal
                };
            }
            var upsertRowParam$1 = upsertRowParam._0;
            var cellUpdate = upsertRowParam$1.cellUpdate;
            var rowLocation$1 = upsertRowParam$1.rowLocation;
            var tmp;
            if (typeof cellUpdate === "number" || cellUpdate.TAG !== /* Value */ 1) {
                tmp = cellUpdate;
            } else {
                var dataRef$2 = cellUpdate._0;
                var newDataRef$2 = maybeSubstituteUrlIntoDataRef$1(log, dataRef$2);
                tmp = {
                    TAG: /* Value */ 1,
                    _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$2
                };
            }
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* GoogleSheetsCommand */ 33,
                    _0: {
                        spreadsheetId: commandValue$2.spreadsheetId,
                        sheetName: commandValue$2.sheetName,
                        colNames: commandValue$2.colNames,
                        update: {
                            TAG: /* UpdateCell */ 1,
                            _0: {
                                rowLocation: {
                                    keyColumnIndex: rowLocation$1.keyColumnIndex,
                                    keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$1, rowLocation$1.keyColumnValue)
                                },
                                updatedColIndex: upsertRowParam$1.updatedColIndex,
                                cellUpdate: tmp
                            }
                        }
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        default:
            return commandWithContext;
    }
}
function adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell$1(commandLog, spreadsheetId, sheetName, commandLogIndex, rowLocation) {
    var priorCommandsWithContext = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
    var arg = Belt_Array.reverse(priorCommandsWithContext);
    var maybeMatchingUpsert = function(param) {
        return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
    }(function(param) {
        var command = param.command;
        var id = param.id;
        if (typeof command === "number") {
            return;
        }
        if (command.TAG !== /* GoogleSheetsCommand */ 33) {
            return;
        }
        var curr = command._0;
        var upsert = curr.update;
        if (upsert.TAG !== /* UpsertRow */ 0) {
            return;
        }
        var upsert$1 = upsert._0;
        if (curr.spreadsheetId === spreadsheetId && curr.sheetName === sheetName && (Caml_obj.caml_equal(Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.maybeGetCommandIdPointedToByMaybePrimaryKeyRef, rowLocation), id) || Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.getPrimaryKeyText, upsert$1.rowLocation) === Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.getPrimaryKeyText, rowLocation))) {
            return [
                id,
                upsert$1
            ];
        }
    });
    var arg$1 = Belt_Option.map(maybeMatchingUpsert, function(param) {
        return {
            keyColumnIndex: rowLocation.keyColumnIndex,
            keyColumnValue: {
                TAG: /* Value */ 1,
                _0: {
                    TAG: /* TextFromGSheetUpsertCommand */ 3,
                    _0: {
                        commandId: param[0],
                        text: Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, param[1].rowLocation.keyColumnValue)
                    }
                }
            }
        };
    });
    return OptionUtils$SmartcutsMacros.withDefault(rowLocation, arg$1);
}
function adjustGoogleSheetCommandPrimaryLookups$1(commandLog, commandLogIndex, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return commandWithContext;
    }
    if (command.TAG !== /* GoogleSheetsCommand */ 33) {
        return commandWithContext;
    }
    var cmdVal = command._0;
    var update = cmdVal.update;
    var tmp;
    if (update.TAG === /* UpsertRow */ 0) {
        tmp = update;
    } else {
        var updateCell = update._0;
        tmp = {
            TAG: /* UpdateCell */ 1,
            _0: {
                rowLocation: adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell$1(commandLog, cmdVal.spreadsheetId, cmdVal.sheetName, commandLogIndex, updateCell.rowLocation),
                updatedColIndex: updateCell.updatedColIndex,
                cellUpdate: updateCell.cellUpdate
            }
        };
    }
    return {
        id: commandWithContext.id,
        command: {
            TAG: /* GoogleSheetsCommand */ 33,
            _0: {
                spreadsheetId: cmdVal.spreadsheetId,
                sheetName: cmdVal.sheetName,
                colNames: cmdVal.colNames,
                update: tmp
            }
        },
        contextGlobal: commandWithContext.contextGlobal
    };
}
var Playback = {
    maybeSubstituteUrlIntoPlaybackCommandWithContext: maybeSubstituteUrlIntoPlaybackCommandWithContext,
    adjustGoogleSheetCommandPrimaryLookups: adjustGoogleSheetCommandPrimaryLookups$1
};
function maybeSubstituteUrlIntoDataRef$2(log, dataRef) {
    if (dataRef.TAG !== /* TextFromUrl */ 5) {
        return;
    }
    var textFromUrlParam = dataRef._0;
    var match = Belt_List.get(log, textFromUrlParam.commandIndex);
    if (match !== undefined) {
        return {
            TAG: /* TextFromUrl */ 5,
            _0: {
                commandId: textFromUrlParam.commandId,
                commandIndex: textFromUrlParam.commandIndex,
                url: match.contextGlobal.url
            }
        };
    }
}
function maybeSubstituteUrlIntoPlaybackCommandWithContext$1(log, commandWithContext) {
    var command = commandWithContext.command;
    if (typeof command === "number") {
        return commandWithContext;
    }
    switch(command.TAG | 0){
        case /* PasteInInputCommand */ 27:
            var commandValue = command._0;
            var dataRef3 = commandValue.text;
            var newDataRef3 = maybeSubstituteUrlIntoDataRef$2(log, dataRef3);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInInputCommand */ 27,
                    _0: {
                        positioning: commandValue.positioning,
                        text: newDataRef3 !== undefined ? newDataRef3 : dataRef3,
                        label: commandValue.label
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* PasteInContentEditableCommand */ 28:
            var commandValue$1 = command._0;
            var dataRef$1 = commandValue$1.text;
            var newDataRef$1 = maybeSubstituteUrlIntoDataRef$2(log, dataRef$1);
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* PasteInContentEditableCommand */ 28,
                    _0: {
                        positioning: commandValue$1.positioning,
                        text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        case /* GoogleSheetsCommand */ 33:
            var commandValue$2 = command._0;
            var upsertRowParam = commandValue$2.update;
            if (upsertRowParam.TAG === /* UpsertRow */ 0) {
                var match = upsertRowParam._0;
                var rowLocation = match.rowLocation;
                return {
                    id: commandWithContext.id,
                    command: {
                        TAG: /* GoogleSheetsCommand */ 33,
                        _0: {
                            spreadsheetId: commandValue$2.spreadsheetId,
                            sheetName: commandValue$2.sheetName,
                            colNames: commandValue$2.colNames,
                            update: {
                                TAG: /* UpsertRow */ 0,
                                _0: {
                                    rowLocation: {
                                        keyColumnIndex: rowLocation.keyColumnIndex,
                                        keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$2, rowLocation.keyColumnValue)
                                    },
                                    cellValues: Belt_Array.map(match.cellValues, function(cellValue) {
                                        if (typeof cellValue === "number") {
                                            return cellValue;
                                        }
                                        if (cellValue.TAG !== /* Value */ 1) {
                                            return cellValue;
                                        }
                                        var dataRef = cellValue._0;
                                        var newDataRef = maybeSubstituteUrlIntoDataRef$2(log, dataRef);
                                        return {
                                            TAG: /* Value */ 1,
                                            _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                    })
                                }
                            }
                        }
                    },
                    contextGlobal: commandWithContext.contextGlobal
                };
            }
            var upsertRowParam$1 = upsertRowParam._0;
            var cellUpdate = upsertRowParam$1.cellUpdate;
            var rowLocation$1 = upsertRowParam$1.rowLocation;
            var tmp;
            if (typeof cellUpdate === "number" || cellUpdate.TAG !== /* Value */ 1) {
                tmp = cellUpdate;
            } else {
                var dataRef$2 = cellUpdate._0;
                var newDataRef$2 = maybeSubstituteUrlIntoDataRef$2(log, dataRef$2);
                tmp = {
                    TAG: /* Value */ 1,
                    _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$2
                };
            }
            return {
                id: commandWithContext.id,
                command: {
                    TAG: /* GoogleSheetsCommand */ 33,
                    _0: {
                        spreadsheetId: commandValue$2.spreadsheetId,
                        sheetName: commandValue$2.sheetName,
                        colNames: commandValue$2.colNames,
                        update: {
                            TAG: /* UpdateCell */ 1,
                            _0: {
                                rowLocation: {
                                    keyColumnIndex: rowLocation$1.keyColumnIndex,
                                    keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$2, rowLocation$1.keyColumnValue)
                                },
                                updatedColIndex: upsertRowParam$1.updatedColIndex,
                                cellUpdate: tmp
                            }
                        }
                    }
                },
                contextGlobal: commandWithContext.contextGlobal
            };
        default:
            return commandWithContext;
    }
}
var PlaybackRuntime = {
    maybeSubstituteUrlIntoPlaybackCommandWithContext: maybeSubstituteUrlIntoPlaybackCommandWithContext$1
};
function getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog) {
    var maybeIndexOfMatchingCommand = OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(Belt_Array.reverse($$Array.of_list(commandLog)), function(param) {
        var command = param.command;
        if (typeof command === "number") {
            return false;
        }
        switch(command.TAG | 0){
            case /* CopyLinkAddressCommand */ 25:
                return command._0.href === text;
            case /* CopyCommand */ 24:
            case /* CutCommand */ 26:
                break;
            default:
                return false;
        }
        var match = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(command._0);
        return match[1] === text;
    }), function(reversedIndex) {
        return (List.length(commandLog) - 1 | 0) - reversedIndex | 0;
    });
    return OptionUtils$SmartcutsMacros.andThen(function(index) {
        var match = Belt_List.get(commandLog, index);
        if (match !== undefined) {
            return match.id;
        }
    }, maybeIndexOfMatchingCommand);
}
function maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, value) {
    if (typeof value === "number") {
        return value;
    }
    if (value.TAG !== /* Value */ 1) {
        return value;
    }
    var dataRef = value._0;
    var tmp;
    var exit = 0;
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            exit = 1;
            break;
        default:
            tmp = dataRef;
    }
    if (exit === 1) {
        var text = dataRef._0;
        var commandId = getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog);
        tmp = commandId !== undefined ? {
            TAG: /* TextFromCommand */ 2,
            _0: {
                commandId: commandId,
                commandInfo: null,
                text: text
            }
        } : dataRef;
    }
    return {
        TAG: /* Value */ 1,
        _0: tmp
    };
}
function adjustPasteCommand(commandLog, commandWithContextLocal) {
    var command = commandWithContextLocal.command;
    if (typeof command === "number") {
        return commandWithContextLocal;
    }
    switch(command.TAG | 0){
        case /* PasteInInputCommand */ 27:
            var cmdVal = command._0;
            var dataRef = cmdVal.text;
            var tmp;
            var exit = 0;
            switch(dataRef.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    exit = 1;
                    break;
                default:
                    tmp = dataRef;
            }
            if (exit === 1) {
                var text = dataRef._0;
                var commandId = getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog);
                tmp = commandId !== undefined ? {
                    TAG: /* TextFromCommand */ 2,
                    _0: {
                        commandId: commandId,
                        commandInfo: null,
                        text: text
                    }
                } : dataRef;
            }
            return {
                command: {
                    TAG: /* PasteInInputCommand */ 27,
                    _0: {
                        positioning: cmdVal.positioning,
                        text: tmp,
                        label: cmdVal.label
                    }
                },
                contextLocal: commandWithContextLocal.contextLocal
            };
        case /* PasteInContentEditableCommand */ 28:
            var cmdVal$1 = command._0;
            var dataRef$1 = cmdVal$1.text;
            var tmp$1;
            var exit$1 = 0;
            switch(dataRef$1.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    exit$1 = 1;
                    break;
                default:
                    tmp$1 = dataRef$1;
            }
            if (exit$1 === 1) {
                var text$1 = dataRef$1._0;
                var commandId$1 = getCommandLogIdOfLastCopyOrCutCommand$1(text$1, commandLog);
                tmp$1 = commandId$1 !== undefined ? {
                    TAG: /* TextFromCommand */ 2,
                    _0: {
                        commandId: commandId$1,
                        commandInfo: null,
                        text: text$1
                    }
                } : dataRef$1;
            }
            return {
                command: {
                    TAG: /* PasteInContentEditableCommand */ 28,
                    _0: {
                        positioning: cmdVal$1.positioning,
                        text: tmp$1
                    }
                },
                contextLocal: commandWithContextLocal.contextLocal
            };
        case /* GoogleSheetsCommand */ 33:
            var cmdVal$2 = command._0;
            var sheetDiff = cmdVal$2.sheetDiff;
            var tmp$2;
            switch(sheetDiff.TAG | 0){
                case /* UpdateCell */ 0:
                    var row = sheetDiff._1;
                    var cellDiff = sheetDiff._0;
                    var diff = cellDiff.diff;
                    var nextDiff;
                    switch(diff.TAG | 0){
                        case /* FromTo */ 0:
                            var fromTo = diff._0;
                            nextDiff = {
                                TAG: /* FromTo */ 0,
                                _0: {
                                    from: fromTo.from,
                                    to_: maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, fromTo.to_)
                                }
                            };
                            break;
                        case /* Added */ 1:
                            nextDiff = {
                                TAG: /* Added */ 1,
                                _0: maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, diff._0)
                            };
                            break;
                        case /* Removed */ 2:
                            nextDiff = diff;
                            break;
                    }
                    tmp$2 = {
                        TAG: /* UpdateCell */ 0,
                        _0: {
                            rowIndex: cellDiff.rowIndex,
                            colIndex: cellDiff.colIndex,
                            diff: nextDiff
                        },
                        _1: {
                            rowIndex: row.rowIndex,
                            cells: Belt_Array.map(row.cells, function(param) {
                                return maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, param);
                            })
                        }
                    };
                    break;
                case /* AppendRow */ 1:
                    var row$1 = sheetDiff._0;
                    tmp$2 = {
                        TAG: /* AppendRow */ 1,
                        _0: {
                            rowIndex: row$1.rowIndex,
                            cells: Belt_Array.map(row$1.cells, function(param) {
                                return maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, param);
                            })
                        }
                    };
                    break;
                case /* DeleteRow */ 2:
                    tmp$2 = sheetDiff;
                    break;
            }
            return {
                command: {
                    TAG: /* GoogleSheetsCommand */ 33,
                    _0: {
                        spreadsheetId: cmdVal$2.spreadsheetId,
                        sheetName: cmdVal$2.sheetName,
                        colNames: cmdVal$2.colNames,
                        sheetDiff: tmp$2
                    }
                },
                contextLocal: commandWithContextLocal.contextLocal
            };
        default:
            return commandWithContextLocal;
    }
}
var Authoring = {
    maybeSubstituteUrlIntoAuthoringCommandWithContext: maybeSubstituteUrlIntoAuthoringCommandWithContext,
    maybeConvertContextMenuCmdsToCopyImageSrcCmds: maybeConvertContextMenuCmdsToCopyImageSrcCmds,
    adjustGoogleSheetCommandPrimaryLookups: adjustGoogleSheetCommandPrimaryLookups
};
exports.Authoring = Authoring;
exports.AuthoringConfig = AuthoringConfig;
exports.Playback = Playback;
exports.PlaybackRuntime = PlaybackRuntime;
exports.adjustPasteCommand = adjustPasteCommand; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 32527:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Command$SmartcutsMacros = __webpack_require__(4290);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var URLCommand$SmartcutsMacros = __webpack_require__(91028);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var TypeCommand$SmartcutsMacros = __webpack_require__(92095);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var RadioCommand$SmartcutsMacros = __webpack_require__(84259);
var SelectCommand$SmartcutsMacros = __webpack_require__(16997);
var SwitchCommand$SmartcutsMacros = __webpack_require__(469);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var CheckboxCommand$SmartcutsMacros = __webpack_require__(50108);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var ClickInputCommand$SmartcutsMacros = __webpack_require__(78612);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var ContextMenuCommand$SmartcutsMacros = __webpack_require__(48662);
var URLRelatedCommands$SmartcutsMacros = __webpack_require__(9697);
var ClickToOAuthCommand$SmartcutsMacros = __webpack_require__(57114);
var CopyImageSrcCommand$SmartcutsMacros = __webpack_require__(68875);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var PasteInInputCommand$SmartcutsMacros = __webpack_require__(15220);
var NewTabWithUrlCommand$SmartcutsMacros = __webpack_require__(83228);
var CopyLinkAddressCommand$SmartcutsMacros = __webpack_require__(67606);
var MoveInputCursorCommand$SmartcutsMacros = __webpack_require__(10806);
var NewWindowWithUrlCommand$SmartcutsMacros = __webpack_require__(23374);
var SelectionRelatedCommands$SmartcutsMacros = __webpack_require__(92787);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var CommandProcessing__DataRef$SmartcutsMacros = __webpack_require__(4837);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
var ScreenshotToClipboardCommand$SmartcutsMacros = __webpack_require__(96617);
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = __webpack_require__(80093);
var MoveContentEditableCursorCommand$SmartcutsMacros = __webpack_require__(45156);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function stringifyConfig(config) {
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            return "AddTextInputConfig(_)";
        case /* DeleteTextInputConfig */ 1:
            return "DeleteTextInputConfig(_)";
        case /* InnerTextConfig */ 2:
            return "InnerTextConfig(_)";
        case /* CheckboxConfig */ 3:
            return "CheckboxConfig(_)";
        case /* SelectInputConfig */ 4:
            return "SelectInputConfig(_)";
        case /* RadioInputConfig */ 5:
            return "RadioInputConfig(_)";
        case /* URLConfig */ 6:
            return "URLConfig(_)";
        case /* CopyLinkAddressConfig */ 7:
            return "CopyLinkAddressConfig(_)";
        case /* CopyImageSrcConfig */ 8:
            return "CopyImageSrcConfig(_)";
        case /* SelectionConfig */ 9:
            return "SelectionConfig(_)";
        case /* MoveInputCursorConfig */ 10:
            return "MoveInputCursorConfig(_)";
        case /* MoveContentEditableCursorConfig */ 11:
            return "MoveContentEditableCursorConfig(_)";
        case /* DownloadConfig */ 12:
            return "DownloadConfig(_)";
        case /* GoogleSheetsConfig */ 13:
            return "GoogleSheetsConfig(_)";
        case /* ClickInputConfig */ 14:
            return "ClickInputConfig(_)";
        case /* PasteInInputConfig */ 15:
            return "PasteInInputConfig(_)";
        case /* LoopConfig */ 16:
            return "LoopConfig(_)";
        case /* UploadConfig */ 17:
            return "UploadConfig(_)";
        case /* WithElementGroupsConfig */ 18:
            return "WithElementGroupsConfig(_)";
    }
}
function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            var inputConfig = config._0;
            return {
                TAG: /* AddTextInputConfig */ 0,
                _0: {
                    targetLocator: inputConfig.targetLocator,
                    originalLabeledAddText: inputConfig.originalLabeledAddText,
                    selectedLabelIndex: inputConfig.selectedLabelIndex,
                    playbackFormLabel: playbackFormLabel,
                    strategy: inputConfig.strategy
                }
            };
        case /* InnerTextConfig */ 2:
            return {
                TAG: /* InnerTextConfig */ 2,
                _0: InnerTextSemanticAuthoringConfig$SmartcutsMacros.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
            };
        case /* CheckboxConfig */ 3:
            var inputConfig$1 = config._0;
            return {
                TAG: /* CheckboxConfig */ 3,
                _0: {
                    checkboxChoice: inputConfig$1.checkboxChoice,
                    playbackFormLabel: playbackFormLabel,
                    dynamic: inputConfig$1.dynamic
                }
            };
        case /* SelectInputConfig */ 4:
            var inputConfig$2 = config._0;
            return {
                TAG: /* SelectInputConfig */ 4,
                _0: {
                    targetLocator: inputConfig$2.targetLocator,
                    originalLabeledValue: inputConfig$2.originalLabeledValue,
                    playbackFormLabel: playbackFormLabel,
                    dynamic: inputConfig$2.dynamic
                }
            };
        case /* RadioInputConfig */ 5:
            var inputConfig$3 = config._0;
            return {
                TAG: /* RadioInputConfig */ 5,
                _0: {
                    targetLocator: inputConfig$3.targetLocator,
                    originalLabeledValue: inputConfig$3.originalLabeledValue,
                    playbackFormLabel: playbackFormLabel,
                    dynamic: inputConfig$3.dynamic
                }
            };
        case /* DownloadConfig */ 12:
            return {
                TAG: /* DownloadConfig */ 12,
                _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
            };
        case /* GoogleSheetsConfig */ 13:
            return {
                TAG: /* GoogleSheetsConfig */ 13,
                _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
            };
        case /* LoopConfig */ 16:
            return {
                TAG: /* LoopConfig */ 16,
                _0: LoopCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
            };
        case /* UploadConfig */ 17:
            var func = UploadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel;
            return {
                TAG: /* UploadConfig */ 17,
                _0: Curry._2(func, config._0, playbackFormLabel)
            };
        case /* WithElementGroupsConfig */ 18:
            return {
                TAG: /* WithElementGroupsConfig */ 18,
                _0: WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
            };
        default:
            return config;
    }
}
function isDynamic(param) {
    var config = param.config;
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            return Curry._1(TypeCommand$SmartcutsMacros.AuthoringConfig.AddTextInputConfig.isDynamic, config._0);
        case /* DeleteTextInputConfig */ 1:
            return Curry._1(TypeCommand$SmartcutsMacros.AuthoringConfig.DeleteTextInputConfig.isDynamic, config._0);
        case /* InnerTextConfig */ 2:
            return InnerTextSemanticAuthoringConfig$SmartcutsMacros.isDynamic(config._0);
        case /* CheckboxConfig */ 3:
            return CheckboxCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* SelectInputConfig */ 4:
            return SelectCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* RadioInputConfig */ 5:
            return RadioCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* URLConfig */ 6:
            return URLRelatedCommands$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* CopyLinkAddressConfig */ 7:
            return CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* CopyImageSrcConfig */ 8:
            return CopyImageSrcCommand$SmartcutsMacros.AuthoringConfig.willGenerateAPlaybackParam(config._0);
        case /* SelectionConfig */ 9:
            return SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* MoveInputCursorConfig */ 10:
            return MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* MoveContentEditableCursorConfig */ 11:
            return MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* DownloadConfig */ 12:
            return DownloadCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* GoogleSheetsConfig */ 13:
            return GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* ClickInputConfig */ 14:
            return ClickInputCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* PasteInInputConfig */ 15:
            return PasteInInputCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* LoopConfig */ 16:
            return LoopCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* UploadConfig */ 17:
            return UploadCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
        case /* WithElementGroupsConfig */ 18:
            return WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    }
}
function getAllCommandIndexes(param) {
    return {
        hd: param.firstCommandIndex,
        tl: param.otherCommandIndexes
    };
}
function getLastCommandIndex(param) {
    var otherCommandIndexes = param.otherCommandIndexes;
    if (otherCommandIndexes) {
        return otherCommandIndexes.hd;
    } else {
        return param.firstCommandIndex;
    }
}
function getAllCommandIndexesExceptLast(param) {
    var otherCommandIndexes = param.otherCommandIndexes;
    if (otherCommandIndexes) {
        return List.append(otherCommandIndexes.tl, {
            hd: param.firstCommandIndex,
            tl: /* [] */ 0
        });
    } else {
        return /* [] */ 0;
    }
}
function maybeConfigFromCommand(priorCommands, contextGlobal, command) {
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* NewWindowWithUrlCommand */ 1:
            return {
                TAG: /* URLConfig */ 6,
                _0: NewWindowWithUrlCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* NewTabWithUrlCommand */ 3:
            return {
                TAG: /* URLConfig */ 6,
                _0: NewTabWithUrlCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* URLCommand */ 6:
            return {
                TAG: /* URLConfig */ 6,
                _0: URLCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* ClickCommand */ 12:
            return Belt_Option.map(Curry._1(ClickCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue, command._0), function(authoringConfig) {
                return {
                    TAG: /* InnerTextConfig */ 2,
                    _0: CommandProcessing__DataRef$SmartcutsMacros.AuthoringConfig.maybeAdjustInnerTextConfigWithDataRefs(priorCommands, authoringConfig)
                };
            });
        case /* ClickInputCommand */ 13:
            return Belt_Option.map(ClickInputCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0), function(config) {
                return {
                    TAG: /* ClickInputConfig */ 14,
                    _0: config
                };
            });
        case /* TypeCommand */ 15:
            var config1 = TypeCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0);
            var tmp;
            tmp = config1.TAG === /* AddTextInputConfig */ 0 ? {
                TAG: /* AddTextInputConfig */ 0,
                _0: config1._0
            } : {
                TAG: /* DeleteTextInputConfig */ 1,
                _0: config1._0
            };
            return tmp;
        case /* CheckboxCommand */ 16:
            return {
                TAG: /* CheckboxConfig */ 3,
                _0: CheckboxCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* SelectCommand */ 17:
            return {
                TAG: /* SelectInputConfig */ 4,
                _0: SelectCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* RadioCommand */ 18:
            return {
                TAG: /* RadioInputConfig */ 5,
                _0: RadioCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* MoveInputCursorCommand */ 22:
            return {
                TAG: /* MoveInputCursorConfig */ 10,
                _0: MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* MoveContentEditableCursorCommand */ 23:
            return {
                TAG: /* MoveContentEditableCursorConfig */ 11,
                _0: MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* CopyLinkAddressCommand */ 25:
            var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(contextGlobal.url);
            var urlRecord$1;
            if (urlRecord !== undefined) {
                urlRecord$1 = urlRecord;
            } else {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                    _1: contextGlobal.url,
                    Error: new Error()
                };
            }
            return {
                TAG: /* CopyLinkAddressConfig */ 7,
                _0: CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(urlRecord$1.origin, command._0)
            };
        case /* SelectionCommand */ 21:
        case /* CopyCommand */ 24:
        case /* CutCommand */ 26:
            break;
        case /* PasteInInputCommand */ 27:
            return Belt_Option.map(PasteInInputCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0), function(config) {
                return {
                    TAG: /* PasteInInputConfig */ 15,
                    _0: config
                };
            });
        case /* DownloadCommand */ 32:
            return {
                TAG: /* DownloadConfig */ 12,
                _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* GoogleSheetsCommand */ 33:
            return {
                TAG: /* GoogleSheetsConfig */ 13,
                _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* ContextMenuCommand */ 34:
            return Belt_Option.map(Curry._1(ContextMenuCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue, command._0), function(authoringConfig) {
                return {
                    TAG: /* InnerTextConfig */ 2,
                    _0: CommandProcessing__DataRef$SmartcutsMacros.AuthoringConfig.maybeAdjustInnerTextConfigWithDataRefs(priorCommands, authoringConfig)
                };
            });
        case /* LoopCommand */ 35:
            return {
                TAG: /* LoopConfig */ 16,
                _0: LoopCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
            };
        case /* UploadCommand */ 41:
            return {
                TAG: /* UploadConfig */ 17,
                _0: UploadCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
            };
        case /* CopyImageSrcCommand */ 42:
            return {
                TAG: /* CopyImageSrcConfig */ 8,
                _0: CopyImageSrcCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
            };
        case /* WithElementGroupsCommand */ 43:
            return {
                TAG: /* WithElementGroupsConfig */ 18,
                _0: WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
            };
        default:
            return;
    }
    return {
        TAG: /* SelectionConfig */ 9,
        _0: SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
    };
}
function maybeUpdateConfigWithCommand(command, config) {
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            if (typeof command !== "number" && command.TAG === /* TypeCommand */ 15) {
                return {
                    TAG: /* AddTextInputConfig */ 0,
                    _0: Curry._2(TypeCommand$SmartcutsMacros.AuthoringConfig.AddTextInputConfig.updateConfigWithAuthoringCommandValue, command._0, config._0)
                };
            }
            break;
        case /* DeleteTextInputConfig */ 1:
            if (typeof command !== "number" && command.TAG === /* TypeCommand */ 15) {
                return {
                    TAG: /* DeleteTextInputConfig */ 1,
                    _0: Curry._2(TypeCommand$SmartcutsMacros.AuthoringConfig.DeleteTextInputConfig.updateConfigWithAuthoringCommandValue, command._0, config._0)
                };
            }
            break;
        case /* CheckboxConfig */ 3:
            if (typeof command !== "number" && command.TAG === /* CheckboxCommand */ 16) {
                return {
                    TAG: /* CheckboxConfig */ 3,
                    _0: CheckboxCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
            }
            break;
        case /* SelectInputConfig */ 4:
            if (typeof command !== "number" && command.TAG === /* SelectCommand */ 17) {
                return {
                    TAG: /* SelectInputConfig */ 4,
                    _0: SelectCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
            }
            break;
        case /* RadioInputConfig */ 5:
            if (typeof command !== "number" && command.TAG === /* RadioCommand */ 18) {
                return {
                    TAG: /* RadioInputConfig */ 5,
                    _0: RadioCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
            }
            break;
        case /* DownloadConfig */ 12:
            if (typeof command !== "number" && command.TAG === /* DownloadCommand */ 32) {
                return {
                    TAG: /* DownloadConfig */ 12,
                    _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
            }
            break;
        case /* GoogleSheetsConfig */ 13:
            if (typeof command !== "number" && command.TAG === /* GoogleSheetsCommand */ 33) {
                return {
                    TAG: /* GoogleSheetsConfig */ 13,
                    _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
            }
            break;
        default:
    }
    if (typeof command === "number") {
        return config;
    }
    switch(command.TAG | 0){
        case /* TypeCommand */ 15:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with TypeCommand was not of type AddTextInputConfig or DeleteTextInputConfig, but was " + (stringifyConfig(config) + (" for command " + Command$SmartcutsMacros.stringifyAuthoringCommand(command))));
        case /* CheckboxCommand */ 16:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with CheckboxCommand was not of type CheckboxboxConfig");
        case /* SelectCommand */ 17:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with SelectCommand was not of type SelectInputConfig");
        case /* RadioCommand */ 18:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with RadioCommand was not of type RadioInputConfig");
        case /* DownloadCommand */ 32:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with DownloadCommand was not of type DownloadConfig");
        case /* GoogleSheetsCommand */ 33:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with GoogleSheetsCommand was not of type GoogleSheetsConfig");
        default:
            return config;
    }
}
function registerNewPageForTab(recordingTabId, map) {
    var tabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(recordingTabId);
    return Belt_MapInt.update(map, tabId, function(maybePageIndexToRest) {
        if (maybePageIndexToRest !== undefined) {
            return {
                currentPage: undefined,
                priorPages: {
                    hd: maybePageIndexToRest.currentPage,
                    tl: maybePageIndexToRest.priorPages
                }
            };
        } else {
            return {
                currentPage: undefined,
                priorPages: /* [] */ 0
            };
        }
    });
}
function update(param, fn, map) {
    var attribute = param[1];
    var tabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(param[0]);
    return Belt_MapInt.update(map, tabId, function(maybeTabConfig) {
        if (maybeTabConfig !== undefined) {
            return {
                currentPage: Belt_MapString.update(maybeTabConfig.currentPage, attribute, fn),
                priorPages: maybeTabConfig.priorPages
            };
        }
        var newConfig = Curry._1(fn, undefined);
        if (newConfig !== undefined) {
            return {
                currentPage: Belt_MapString.fromArray([
                    [
                        attribute,
                        newConfig
                    ]
                ]),
                priorPages: /* [] */ 0
            };
        }
    });
}
function getInputIdentifierForCommand(command, commandIndex) {
    if (typeof command === "number") {
        return;
    }
    switch(command.TAG | 0){
        case /* NewWindowWithUrlCommand */ 1:
        case /* NewTabWithUrlCommand */ 3:
        case /* URLCommand */ 6:
            return command._0.url;
        case /* ClickCommand */ 12:
            return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* ClickInputCommand */ 13:
            return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* TypeCommand */ 15:
            return Curry._2(TypeCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
        case /* CheckboxCommand */ 16:
            var match = command._0;
            if (match.TAG !== /* IndividualCheckOrUncheck */ 0) {
                return "input[type=checkbox][name='" + (match._0.name + "']");
            }
            var match$1 = match._0.interaction;
            var name = match$1.name;
            return name !== undefined ? "input[type=checkbox][name='" + (name + "']") : CheckboxCommand$SmartcutsMacros.getQuerySelectorForCheckboxIdAndNameAndValue(match$1.id, name, match$1.value);
        case /* SelectCommand */ 17:
            return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* RadioCommand */ 18:
            return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* MoveInputCursorCommand */ 22:
            return Curry._2(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
        case /* MoveContentEditableCursorCommand */ 23:
            return Curry._2(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
        case /* CopyLinkAddressCommand */ 25:
            return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* SelectionCommand */ 21:
        case /* CopyCommand */ 24:
        case /* CutCommand */ 26:
            break;
        case /* PasteInInputCommand */ 27:
            return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* DownloadCommand */ 32:
            return String(command._0.chromeId);
        case /* GoogleSheetsCommand */ 33:
            return Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
        case /* ContextMenuCommand */ 34:
            return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* LoopCommand */ 35:
            return LoopCommand$SmartcutsMacros.CommandValue.getIdentifier(command._0);
        case /* SwitchCommand */ 36:
            return SwitchCommand$SmartcutsMacros.CommandValue.getIdentifier(command._0);
        case /* ScreenshotToClipboardCommand */ 37:
            return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
        case /* ClickToOAuthCommand */ 40:
            return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
        case /* UploadCommand */ 41:
            return Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
        case /* CopyImageSrcCommand */ 42:
            return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.getInputIdentifier, command._0);
        case /* WithElementGroupsCommand */ 43:
            return Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.getIdentifier, command._0);
        default:
            return;
    }
    var match$2 = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(command._0.selection);
    return match$2[1];
}
function applyCommandWithContext(commandIndex, priorCommands, param1, map) {
    var contextGlobal = param1.contextGlobal;
    var tabRef = contextGlobal.tabRef;
    var command = param1.command;
    var commandId = param1.id;
    var mapWithMaybeNewPage;
    if (typeof command === "number") {
        switch(command){
            case /* ReloadCommand */ 0:
            case /* ForwardCommand */ 1:
            case /* BackCommand */ 2:
                mapWithMaybeNewPage = registerNewPageForTab(tabRef.recordingId, map);
                break;
        }
    } else {
        switch(command.TAG | 0){
            case /* NewWindowWithUrlCommand */ 1:
            case /* NewTabWithUrlCommand */ 3:
            case /* URLCommand */ 6:
            case /* OpenedLinkCommand */ 7:
            case /* SubmitFormCommand */ 8:
            case /* SubmitFormRedirectCommand */ 9:
            case /* ClientRedirectCommand */ 10:
            case /* ServerRedirectCommand */ 11:
                mapWithMaybeNewPage = registerNewPageForTab(tabRef.recordingId, map);
                break;
            default:
                mapWithMaybeNewPage = map;
        }
    }
    var identifier = getInputIdentifierForCommand(command, commandIndex);
    if (identifier !== undefined) {
        return update([
            tabRef.recordingId,
            identifier
        ], function(maybeConfig) {
            if (maybeConfig !== undefined) {
                var commandValueConfigurability = maybeConfig.commandValueConfigurability;
                return {
                    commandIndexes: {
                        hd: commandIndex,
                        tl: maybeConfig.commandIndexes
                    },
                    commandIds: {
                        hd: commandId,
                        tl: maybeConfig.commandIds
                    },
                    commandValueConfigurability: {
                        firstCommandIndex: commandValueConfigurability.firstCommandIndex,
                        otherCommandIndexes: {
                            hd: commandIndex,
                            tl: commandValueConfigurability.otherCommandIndexes
                        },
                        firstCommandId: commandValueConfigurability.firstCommandId,
                        otherCommandIds: {
                            hd: commandId,
                            tl: commandValueConfigurability.otherCommandIds
                        },
                        config: maybeUpdateConfigWithCommand(command, commandValueConfigurability.config)
                    }
                };
            }
            var func = function func(param, param$1) {
                return maybeConfigFromCommand(priorCommands, param, param$1);
            };
            return Belt_Option.map(Curry._2(func, contextGlobal, command), function(inputConfig) {
                return {
                    commandIndexes: {
                        hd: commandIndex,
                        tl: /* [] */ 0
                    },
                    commandIds: {
                        hd: commandId,
                        tl: /* [] */ 0
                    },
                    commandValueConfigurability: {
                        firstCommandIndex: commandIndex,
                        otherCommandIndexes: /* [] */ 0,
                        firstCommandId: commandId,
                        otherCommandIds: /* [] */ 0,
                        config: inputConfig
                    }
                };
            });
        }, mapWithMaybeNewPage);
    } else {
        return mapWithMaybeNewPage;
    }
}
function fromAuthoringCommandLog(commandLog) {
    return ListUtils$SmartcutsMacros.foldLefti(undefined, function(commandIndex, commandWithContext, configByTabAndPageAndAttribute) {
        return applyCommandWithContext(commandIndex, Belt_Option.getWithDefault(Belt_List.take(commandLog, commandIndex), /* [] */ 0), commandWithContext, configByTabAndPageAndAttribute);
    }, commandLog);
}
function toSortedCommandValueConfigurabilities(map) {
    var flattenedConfigs = Belt_Array.concatMany($$Array.map(function(param) {
        return Belt_Array.concatMany($$Array.of_list(List.map(Belt_MapString.valuesToArray, {
            hd: param.currentPage,
            tl: param.priorPages
        })));
    }, Belt_MapInt.valuesToArray(map)));
    return $$Array.of_list(List.map(function(param) {
        return param.commandValueConfigurability;
    }, ListUtils$SmartcutsMacros.sortBy(function(config) {
        var arg = ListUtils$SmartcutsMacros.minimum(config.commandIndexes);
        var param = "Expected commandIndexes to have length >= 1";
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }, $$Array.to_list(flattenedConfigs))));
}
var ByTabAndPageAndInputIdentifier = {
    empty: undefined,
    registerNewPageForTab: registerNewPageForTab,
    update: update,
    getInputIdentifierForCommand: getInputIdentifierForCommand,
    applyCommandWithContext: applyCommandWithContext,
    fromAuthoringCommandLog: fromAuthoringCommandLog,
    toSortedCommandValueConfigurabilities: toSortedCommandValueConfigurabilities
};
function getMatchingCheckboxConfigurabilityForIndividualInteraction(singleCheckboxInteraction, commandValueConfigurabilities) {
    return Belt_Array.getBy(commandValueConfigurabilities, function(param) {
        var config = param.config;
        if (config.TAG !== /* CheckboxConfig */ 3) {
            return false;
        }
        var match = config._0.checkboxChoice;
        if (match.TAG === /* SingleCheckbox */ 0) {
            return Curry._2(CheckboxCommand$SmartcutsMacros.CommandValue.SingleCheckboxInteraction.didInteractWithCheckboxOption, match._0, singleCheckboxInteraction);
        }
        var match$1 = match._0;
        var name = match$1.name;
        var doesNameMatch = Belt_Option.getWithDefault(Belt_Option.map(singleCheckboxInteraction.name, function(name$p) {
            return name$p === name;
        }), false);
        if (doesNameMatch) {
            return List.exists(function(checkboxOption) {
                return Curry._2(CheckboxCommand$SmartcutsMacros.CommandValue.SingleCheckboxInteraction.didInteractWithCheckboxOption, checkboxOption, singleCheckboxInteraction);
            }, match$1.options);
        } else {
            return false;
        }
    });
}
function getMatchingCheckboxConfigurabilityForMultipleInteraction(checkboxGroupWithChosenValues, commandValueConfigurabilities) {
    return Belt_Array.getBy(commandValueConfigurabilities, function(param) {
        var config = param.config;
        if (config.TAG !== /* CheckboxConfig */ 3) {
            return false;
        }
        var match = config._0.checkboxChoice;
        if (match.TAG === /* SingleCheckbox */ 0) {
            return false;
        }
        var match$1 = match._0;
        var options = match$1.options;
        if (match$1.name === checkboxGroupWithChosenValues.name) {
            return Belt_List.every(checkboxGroupWithChosenValues.checkedValues, function(checkedValue) {
                return List.exists(function(checkboxOption) {
                    return checkedValue === checkboxOption.value;
                }, options);
            });
        } else {
            return false;
        }
    });
}
function getMatchingSelectConfigurabilityParams(locator, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* SelectInputConfig */ 4) {
            return;
        }
        var match = config._0;
        if (!Caml_obj.caml_equal(match.targetLocator, locator)) {
            return;
        }
        var allCommandIndexesActingOnThisInput = List.append(param.otherCommandIndexes, {
            hd: param.firstCommandIndex,
            tl: /* [] */ 0
        });
        return [
            match.dynamic,
            allCommandIndexesActingOnThisInput
        ];
    }, commandValueConfigurabilities);
}
function getMatchingRadioConfigurabilityParams(locator, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* RadioInputConfig */ 5) {
            return;
        }
        var match = config._0;
        if (!Caml_obj.caml_equal(match.targetLocator, locator)) {
            return;
        }
        var allCommandIndexesActingOnThisInput = List.append(param.otherCommandIndexes, {
            hd: param.firstCommandIndex,
            tl: /* [] */ 0
        });
        return [
            match.dynamic,
            allCommandIndexesActingOnThisInput
        ];
    }, commandValueConfigurabilities);
}
function getMatchingSelectionConfig(commandValue, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* SelectionConfig */ 9) {
            return;
        }
        var selectionConfig = config._0;
        if (SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, selectionConfig)) {
            return selectionConfig;
        }
    }, commandValueConfigurabilities);
}
function getMatchingCopyLinkAddressConfig(commandValue, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* CopyLinkAddressConfig */ 7) {
            return;
        }
        var copyLinkAddressConfig = config._0;
        if (CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, copyLinkAddressConfig)) {
            return copyLinkAddressConfig;
        }
    }, commandValueConfigurabilities);
}
function getMatchingCopyImageSrcConfig(commandId, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG === /* CopyImageSrcConfig */ 8 && commandId === param.firstCommandId) {
            return config._0;
        }
    }, commandValueConfigurabilities);
}
function getMatchingMoveInputCursorConfig(commandValue, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* MoveInputCursorConfig */ 10) {
            return;
        }
        var cursorConfig = config._0;
        if (MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, cursorConfig)) {
            return cursorConfig;
        }
    }, commandValueConfigurabilities);
}
function getMatchingMoveContentEditableCursorConfig(commandValue, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* MoveContentEditableCursorConfig */ 11) {
            return;
        }
        var cursorConfig = config._0;
        if (MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, cursorConfig)) {
            return cursorConfig;
        }
    }, commandValueConfigurabilities);
}
function getMatchingDownloadConfig(commandValue, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG !== /* DownloadConfig */ 12) {
            return;
        }
        var downloadConfig = config._0;
        if (DownloadCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, downloadConfig)) {
            return downloadConfig;
        }
    }, commandValueConfigurabilities);
}
function getMatchingConfigForTypeCommand(commandId, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        var otherCommandIndexes = param.otherCommandIndexes;
        var firstCommandIndex = param.firstCommandIndex;
        switch(config.TAG | 0){
            case /* AddTextInputConfig */ 0:
                if (firstCommandIndex === commandId || List.mem(commandId, otherCommandIndexes)) {
                    return {
                        TAG: /* AddTextInputConfig */ 0,
                        _0: config._0
                    };
                } else {
                    return;
                }
            case /* DeleteTextInputConfig */ 1:
                if (firstCommandIndex === commandId || List.mem(commandId, otherCommandIndexes)) {
                    return {
                        TAG: /* DeleteTextInputConfig */ 1,
                        _0: config._0
                    };
                } else {
                    return;
                }
            default:
                return;
        }
    }, commandValueConfigurabilities);
}
function getMatchingInnerTextConfig(commandId, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG === /* InnerTextConfig */ 2 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
            return config._0;
        }
    }, commandValueConfigurabilities);
}
function getMatchingClickInputConfig(commandId, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG === /* ClickInputConfig */ 14 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
            return config._0;
        }
    }, commandValueConfigurabilities);
}
function getMatchingPasteInInputConfig(commandId, commandValueConfigurabilities) {
    return Util$SmartcutsMacros.shortcut(function(param) {
        var config = param.config;
        if (config.TAG === /* PasteInInputConfig */ 15 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
            return config._0;
        }
    }, commandValueConfigurabilities);
}
function mapDataRefInConfig(f, config) {
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            var addTextInputConfig = config._0;
            var originalLabeledAddText = addTextInputConfig.originalLabeledAddText;
            return {
                TAG: /* AddTextInputConfig */ 0,
                _0: {
                    targetLocator: addTextInputConfig.targetLocator,
                    originalLabeledAddText: {
                        label: originalLabeledAddText.label,
                        addText: Curry._1(f, originalLabeledAddText.addText)
                    },
                    selectedLabelIndex: addTextInputConfig.selectedLabelIndex,
                    playbackFormLabel: addTextInputConfig.playbackFormLabel,
                    strategy: addTextInputConfig.strategy
                }
            };
        case /* InnerTextConfig */ 2:
            var match = config._0;
            return {
                TAG: /* InnerTextConfig */ 2,
                _0: {
                    intentionChoices: Belt_Array.map(match.intentionChoices, function(param) {
                        return InnerTextSemantic$SmartcutsMacros.mapDataRef(f, param);
                    }),
                    chosen: InnerTextSemantic$SmartcutsMacros.mapDataRef(f, match.chosen)
                }
            };
        case /* GoogleSheetsConfig */ 13:
            var func = GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.mapDataRef;
            return {
                TAG: /* GoogleSheetsConfig */ 13,
                _0: Curry._2(func, f, config._0)
            };
        case /* UploadConfig */ 17:
            return {
                TAG: /* UploadConfig */ 17,
                _0: UploadCommand$SmartcutsMacros.AuthoringConfig.mapDataRef(config._0, f)
            };
        default:
            return config;
    }
}
exports.stringifyConfig = stringifyConfig;
exports.updateConfigWithPlaybackFormLabel = updateConfigWithPlaybackFormLabel;
exports.isDynamic = isDynamic;
exports.getAllCommandIndexes = getAllCommandIndexes;
exports.getLastCommandIndex = getLastCommandIndex;
exports.getAllCommandIndexesExceptLast = getAllCommandIndexesExceptLast;
exports.maybeConfigFromCommand = maybeConfigFromCommand;
exports.maybeUpdateConfigWithCommand = maybeUpdateConfigWithCommand;
exports.ByTabAndPageAndInputIdentifier = ByTabAndPageAndInputIdentifier;
exports.getMatchingCheckboxConfigurabilityForIndividualInteraction = getMatchingCheckboxConfigurabilityForIndividualInteraction;
exports.getMatchingCheckboxConfigurabilityForMultipleInteraction = getMatchingCheckboxConfigurabilityForMultipleInteraction;
exports.getMatchingSelectConfigurabilityParams = getMatchingSelectConfigurabilityParams;
exports.getMatchingRadioConfigurabilityParams = getMatchingRadioConfigurabilityParams;
exports.getMatchingSelectionConfig = getMatchingSelectionConfig;
exports.getMatchingCopyLinkAddressConfig = getMatchingCopyLinkAddressConfig;
exports.getMatchingCopyImageSrcConfig = getMatchingCopyImageSrcConfig;
exports.getMatchingMoveInputCursorConfig = getMatchingMoveInputCursorConfig;
exports.getMatchingMoveContentEditableCursorConfig = getMatchingMoveContentEditableCursorConfig;
exports.getMatchingDownloadConfig = getMatchingDownloadConfig;
exports.getMatchingConfigForTypeCommand = getMatchingConfigForTypeCommand;
exports.getMatchingInnerTextConfig = getMatchingInnerTextConfig;
exports.getMatchingClickInputConfig = getMatchingClickInputConfig;
exports.getMatchingPasteInInputConfig = getMatchingPasteInInputConfig;
exports.mapDataRefInConfig = mapDataRefInConfig; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 55838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_obj = __webpack_require__(14923);
var AppConfig$SmartcutsMacros = __webpack_require__(59730);
function hostnameForUser(user) {
    var match = user.role;
    if (match === "REVIEWER") {
        return process.env.HOSTNAME_CHROME_REVIEW;
    } else if (Caml_obj.caml_equal(user.build, "CANARY")) {
        return "https://canary.trysmartcuts.com";
    } else {
        return "https://trysmartcuts.com";
    }
}
var domSnapshots = Caml_obj.caml_equal("", "true");
var htmlPreprocessing = Caml_obj.caml_equal(process.env.HTML_PREPROCESSING, "true");
var Default = {
    millisecondsBetweenCommands: 300,
    millisecondsBetweenTypingCharacter: 50,
    millisecondsBetweenKeyDownKeyUp: 10,
    millisecondsBetweenTypingCharacterAndNonCharacterKeypress: 400,
    useFastestTypePlayback: true,
    replaceUiCommandsWithApiCommands: true,
    domSnapshots: domSnapshots,
    numConsecutiveFailuresBeforeExit: 5,
    htmlPreprocessing: htmlPreprocessing
};
var OAuth = {
    googleApiKey: "AIzaSyCMyVKWlffaM43SBZMePIzwZyN-8HyTHG8"
};
var Dev = {
    projectDir: "__PROJECT__DIR__"
};
function extensionUrl(user) {
    var match = process.env.HOST_EXTENSION;
    if (match !== undefined) {
        if (match === "1") {
            return hostnameForUser(user) + "/app/download";
        } else {
            return "https://chrome.google.com/webstore/detail/" + AppConfig$SmartcutsMacros.extensionId;
        }
    } else {
        return "https://chrome.google.com/webstore/detail/" + AppConfig$SmartcutsMacros.extensionId;
    }
}
var shouldSaveRecordingCommandLog = false;
exports.hostnameForUser = hostnameForUser;
exports.shouldSaveRecordingCommandLog = shouldSaveRecordingCommandLog;
exports.Default = Default;
exports.OAuth = OAuth;
exports.Dev = Dev;
exports.extensionUrl = extensionUrl; /* domSnapshots Not a pure module */ 


/***/ }),

/***/ 73890:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var id = "ff7knizrg1";
var publicKey = "public_LTITuhHFzH8N6pTJcwrzhK5ImLE=";
exports.id = id;
exports.publicKey = publicKey; /* No side effect */ 


/***/ }),

/***/ 65706:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml = __webpack_require__(16253);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Belt_Id = __webpack_require__(66638);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var LoginScenario$SmartcutsMacros = __webpack_require__(93777);
var CustomMapBuilders$SmartcutsMacros = __webpack_require__(22926);
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = __webpack_require__(20229);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
var UserCredential__PasswordCredential$SmartcutsMacros = __webpack_require__(83292);
var DomElementCompare = Belt_Id.MakeComparable({
    cmp: DOM__Element$SmartcutsMacros.compare
});
function make(param) {
    return Belt_Map.make(DomElementCompare);
}
function fromArray(param) {
    return Belt_Map.fromArray(param, DomElementCompare);
}
var MapDomElement = {
    make: make,
    fromArray: fromArray
};
var t_encode = Selector$SmartcutsMacros.selector_encode;
var t_decode = Selector$SmartcutsMacros.selector_decode;
function cmp(a, b) {
    if (a === b) {
        return 0;
    } else {
        return 1;
    }
}
var MapSelector = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode,
    t_decode: t_decode,
    cmp: cmp
});
function t_encode$1(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_encode(v);
}
function t_decode$1(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_decode(v);
}
function cmp$1(a, b) {
    return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(b));
}
var MapRecordingTabId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    cmp: cmp$1
});
function t_encode$2(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_encode(v);
}
function t_decode$2(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_decode(v);
}
function cmp$2(a, b) {
    return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(b));
}
var MapRecordingWindowId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    cmp: cmp$2
});
function t_encode$3(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_encode(v);
}
function t_decode$3(v) {
    return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_decode(v);
}
function cmp$3(a, b) {
    return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(b));
}
var MapPlaybackTabId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    cmp: cmp$3
});
var t_encode$4 = SmartcutIds$SmartcutsMacros.smartcutId_encode;
var t_decode$4 = SmartcutIds$SmartcutsMacros.smartcutId_decode;
var cmp$4 = SmartcutIds$SmartcutsMacros.SmartcutId.cmp;
var MapSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    cmp: cmp$4
});
var t_encode$5 = SmartcutIds$SmartcutsMacros.installedSmartcutId_encode;
var t_decode$5 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode;
var cmp$5 = SmartcutIds$SmartcutsMacros.InstalledSmartcutId.cmp;
var MapInstalledSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    cmp: cmp$5
});
var t_encode$6 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode;
var t_decode$6 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode;
var cmp$6 = SmartcutIds$SmartcutsMacros.RecordedSmartcutId.cmp;
var MapRecordedSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    cmp: cmp$6
});
function kvPairs_encode(encoder_value, v) {
    return Decco.arrayToJson(function(param) {
        return [
            Decco.stringToJson(param[0]),
            Curry._1(encoder_value, param[1])
        ];
    }, v);
}
function kvPairs_decode(decoder_value, v) {
    return Decco.arrayFromJson(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.stringFromJson(v0);
        var match$3 = Curry._1(decoder_value, v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, v);
}
function t_encode$7(value_encode, m) {
    return kvPairs_encode(value_encode, Belt_MapString.toArray(m));
}
function t_decode$7(value_decode, encoded) {
    var decodeError = kvPairs_decode(value_decode, encoded);
    if (decodeError.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: Belt_MapString.fromArray(decodeError._0)
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: decodeError._0
        };
    }
}
var MapStringWithDeccoSupport = {
    kvPairs_encode: kvPairs_encode,
    kvPairs_decode: kvPairs_decode,
    t_encode: t_encode$7,
    t_decode: t_decode$7
};
function kvPairs_encode$1(encoder_value, v) {
    return Decco.arrayToJson(function(param) {
        return [
            Decco.intToJson(param[0]),
            Curry._1(encoder_value, param[1])
        ];
    }, v);
}
function kvPairs_decode$1(decoder_value, v) {
    return Decco.arrayFromJson(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.intFromJson(v0);
        var match$3 = Curry._1(decoder_value, v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, v);
}
function t_encode$8(value_encode, m) {
    return kvPairs_encode$1(value_encode, Belt_MapInt.toArray(m));
}
function t_decode$8(value_decode, encoded) {
    var decodeError = kvPairs_decode$1(value_decode, encoded);
    if (decodeError.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: Belt_MapInt.fromArray(decodeError._0)
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: decodeError._0
        };
    }
}
var MapIntWithDeccoSupport = {
    kvPairs_encode: kvPairs_encode$1,
    kvPairs_decode: kvPairs_decode$1,
    t_encode: t_encode$8,
    t_decode: t_decode$8
};
function t_encode$9(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v);
}
function t_decode$9(v) {
    return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(v);
}
var cmp$7 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.cmp;
var include = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    cmp: cmp$7
});
function stringify(v) {
    return "keys=[" + (Belt_Array.map(Belt_Map.keysToArray(v), InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify).join(", ") + "];");
}
var MapContentScriptFailureId_KeyCompare = include.KeyCompare;
var MapContentScriptFailureId_make = include.make;
var MapContentScriptFailureId_fromArray = include.fromArray;
var MapContentScriptFailureId_kvPairs_encode = include.kvPairs_encode;
var MapContentScriptFailureId_kvPairs_decode = include.kvPairs_decode;
var MapContentScriptFailureId_t_encode = include.t_encode;
var MapContentScriptFailureId_t_decode = include.t_decode;
var MapContentScriptFailureId = {
    KeyCompare: MapContentScriptFailureId_KeyCompare,
    make: MapContentScriptFailureId_make,
    fromArray: MapContentScriptFailureId_fromArray,
    kvPairs_encode: MapContentScriptFailureId_kvPairs_encode,
    kvPairs_decode: MapContentScriptFailureId_kvPairs_decode,
    t_encode: MapContentScriptFailureId_t_encode,
    t_decode: MapContentScriptFailureId_t_decode,
    stringify: stringify
};
var t_encode$10 = LoginScenario$SmartcutsMacros.t_encode;
var t_decode$10 = LoginScenario$SmartcutsMacros.t_decode;
function cmp$8(s1, s2) {
    return LoginScenario$SmartcutsMacros.indexOf(s1) - LoginScenario$SmartcutsMacros.indexOf(s2) | 0;
}
var include$1 = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    cmp: cmp$8
});
var fromArray$1 = include$1.fromArray;
function keepMap(v, f) {
    return Curry._1(fromArray$1, Belt_Array.keepMap(Belt_Map.toArray(v), function(param) {
        return Curry._2(f, param[0], param[1]);
    }));
}
var MapLoginScenario_KeyCompare = include$1.KeyCompare;
var MapLoginScenario_make = include$1.make;
var MapLoginScenario_kvPairs_encode = include$1.kvPairs_encode;
var MapLoginScenario_kvPairs_decode = include$1.kvPairs_decode;
var MapLoginScenario_t_encode = include$1.t_encode;
var MapLoginScenario_t_decode = include$1.t_decode;
var MapLoginScenario = {
    KeyCompare: MapLoginScenario_KeyCompare,
    make: MapLoginScenario_make,
    fromArray: fromArray$1,
    kvPairs_encode: MapLoginScenario_kvPairs_encode,
    kvPairs_decode: MapLoginScenario_kvPairs_decode,
    t_encode: MapLoginScenario_t_encode,
    t_decode: MapLoginScenario_t_decode,
    keepMap: keepMap
};
function t_encode$11(v) {
    return Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}
function t_decode$11(v) {
    return Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}
var cmp$9 = Caml.caml_string_compare;
var MapPasswordCredentialId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$11,
    t_decode: t_decode$11,
    cmp: cmp$9
});
function t_encode$12(v) {
    return Decco.arrayToJson(Decco.stringToJson, v);
}
function t_decode$12(v) {
    return Decco.arrayFromJson(Decco.stringFromJson, v);
}
function cmp$10(htmlTagPath1, htmlTagPath2) {
    var longPath = htmlTagPath1.length >= htmlTagPath2.length ? htmlTagPath1 : htmlTagPath2;
    var arg = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(_item, index) {
        var match = Belt_Array.get(htmlTagPath1, index);
        var match$1 = Belt_Array.get(htmlTagPath2, index);
        if (match === undefined) {
            if (match$1 !== undefined) {
                return -1;
            } else {
                return;
            }
        }
        if (match$1 === undefined) {
            return 1;
        }
        var result = Caml_obj.caml_compare(Caml_option.valFromOption(match), Caml_option.valFromOption(match$1));
        if (result === 0) {
            return;
        } else {
            return result;
        }
    }, longPath);
    var param = 0;
    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}
var MapHtmlTagPath = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    cmp: cmp$10
});
exports.DomElementCompare = DomElementCompare;
exports.MapDomElement = MapDomElement;
exports.MapSelector = MapSelector;
exports.MapRecordingTabId = MapRecordingTabId;
exports.MapRecordingWindowId = MapRecordingWindowId;
exports.MapPlaybackTabId = MapPlaybackTabId;
exports.MapSmartcutId = MapSmartcutId;
exports.MapInstalledSmartcutId = MapInstalledSmartcutId;
exports.MapRecordedSmartcutId = MapRecordedSmartcutId;
exports.MapStringWithDeccoSupport = MapStringWithDeccoSupport;
exports.MapIntWithDeccoSupport = MapIntWithDeccoSupport;
exports.MapContentScriptFailureId = MapContentScriptFailureId;
exports.MapLoginScenario = MapLoginScenario;
exports.MapPasswordCredentialId = MapPasswordCredentialId;
exports.MapHtmlTagPath = MapHtmlTagPath; /* DomElementCompare Not a pure module */ 


/***/ }),

/***/ 74762:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_MapInt = __webpack_require__(91094);
function kvPairs_encode(encoder_value, v) {
    return Decco.arrayToJson(function(param) {
        return [
            Decco.intToJson(param[0]),
            Curry._1(encoder_value, param[1])
        ];
    }, v);
}
function kvPairs_decode(decoder_value, v) {
    return Decco.arrayFromJson(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.intFromJson(v0);
        var match$3 = Curry._1(decoder_value, v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, v);
}
function t_encode(value_encode, m) {
    return kvPairs_encode(value_encode, Belt_MapInt.toArray(m));
}
function t_decode(value_decode, encoded) {
    var decodeError = kvPairs_decode(value_decode, encoded);
    if (decodeError.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: Belt_MapInt.fromArray(decodeError._0)
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: decodeError._0
        };
    }
}
var MapIntWithDeccoSupport = {
    kvPairs_encode: kvPairs_encode,
    kvPairs_decode: kvPairs_decode,
    t_encode: t_encode,
    t_decode: t_decode
};
exports.MapIntWithDeccoSupport = MapIntWithDeccoSupport; /* No side effect */ 


/***/ }),

/***/ 22926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Belt_Id = __webpack_require__(66638);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
function MakeCustomMapWithDeccoSupport(ComparableArg) {
    var KeyCompare = Belt_Id.MakeComparable({
        cmp: ComparableArg.cmp
    });
    var make = function make(param) {
        return Belt_Map.make(KeyCompare);
    };
    var fromArray = function fromArray(param) {
        return Belt_Map.fromArray(param, KeyCompare);
    };
    var kvPairs_encode = function kvPairs_encode(encoder_value, v) {
        return Decco.arrayToJson(function(param) {
            return [
                Curry._1(ComparableArg.t_encode, param[0]),
                Curry._1(encoder_value, param[1])
            ];
        }, v);
    };
    var kvPairs_decode = function kvPairs_decode(decoder_value, v) {
        return Decco.arrayFromJson(function(json) {
            var match = Js_json.classify(json);
            if (typeof match === "number") {
                return Decco.error(undefined, "Not a tuple", json);
            }
            if (match.TAG !== /* JSONArray */ 3) {
                return Decco.error(undefined, "Not a tuple", json);
            }
            var match$1 = match._0;
            if (match$1.length !== 2) {
                return Decco.error(undefined, "Incorrect cardinality", json);
            }
            var v0 = match$1[0];
            var v1 = match$1[1];
            var match$2 = Curry._1(ComparableArg.t_decode, v0);
            var match$3 = Curry._1(decoder_value, v1);
            if (match$2.TAG === /* Ok */ 0) {
                if (match$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: [
                            match$2._0,
                            match$3._0
                        ]
                    };
                }
                var e = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[1]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = match$2._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }, v);
    };
    var t_encode = function t_encode(value_encode, m) {
        return kvPairs_encode(value_encode, Belt_Map.toArray(m));
    };
    var t_decode = function t_decode(value_decode, encoded) {
        var decodeError = kvPairs_decode(value_decode, encoded);
        if (decodeError.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: Belt_Map.fromArray(decodeError._0, KeyCompare)
            };
        } else {
            return {
                TAG: /* Error */ 1,
                _0: decodeError._0
            };
        }
    };
    return {
        KeyCompare: KeyCompare,
        make: make,
        fromArray: fromArray,
        kvPairs_encode: kvPairs_encode,
        kvPairs_decode: kvPairs_decode,
        t_encode: t_encode,
        t_decode: t_decode
    };
}
exports.MakeCustomMapWithDeccoSupport = MakeCustomMapWithDeccoSupport; /* No side effect */ 


/***/ }),

/***/ 4607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var DOM__File$SmartcutsMacros = __webpack_require__(2246);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DOM__EventType$SmartcutsMacros = __webpack_require__(41639);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var Navigator__Clipboard$SmartcutsMacros = __webpack_require__(33595);
var mvpEventTypesWithoutCapture = [
    "input",
    "change",
    "copy",
    "cut",
    "dragend",
    "wheel",
    "selectionchange"
];
var mvpEventTypesWithCapture = [
    "click",
    "contextmenu",
    "mouseup",
    "mousedown",
    "mousemove",
    "dragstart",
    "drop",
    "focus",
    "blur",
    "keydown",
    "keyup",
    "keypress",
    "paste"
];
function fromMouseEvent(mouseEvent) {
    var i = mouseEvent.button;
    if (i > 4 || i < 0) {
        return /* InvalidMouseButton */ {
            _0: i
        };
    } else {
        return i;
    }
}
var MouseButtonPressed = {
    fromMouseEvent: fromMouseEvent
};
var _map = {
    "input": "input",
    "button": "button",
    "select": "select",
    "div": "div"
};
function tagNameToJs(param) {
    return param;
}
function tagNameFromJs(param) {
    return _map[param];
}
var _map$1 = {
    "text": "text",
    "password": "password",
    "file": "file",
    "datetime": "datetime",
    "datetimeLocal": "datetime-local",
    "date": "date",
    "month": "month",
    "time": "time",
    "week": "week",
    "number": "number",
    "range": "range",
    "email": "email",
    "url": "url",
    "search": "search",
    "tel": "tel",
    "color": "color"
};
var _revMap = {
    "text": "text",
    "password": "password",
    "file": "file",
    "datetime": "datetime",
    "datetime-local": "datetimeLocal",
    "date": "date",
    "month": "month",
    "time": "time",
    "week": "week",
    "number": "number",
    "range": "range",
    "email": "email",
    "url": "url",
    "search": "search",
    "tel": "tel",
    "color": "color"
};
function inputTypeToJs(param) {
    return _map$1[param];
}
function inputTypeFromJs(param) {
    return _revMap[param];
}
var _map$2 = {
    "beforepaste": "beforepaste",
    "paste": "paste"
};
function eventTypeToJs(param) {
    return param;
}
function eventTypeFromJs(param) {
    return _map$2[param];
}
function make(type_, data, dataType) {
    var clipboardData = new DataTransfer();
    clipboardData.setData(dataType, data);
    return new ClipboardEvent(type_, {
        clipboardData: clipboardData,
        dataType: dataType,
        data: data,
        bubbles: true,
        cancelable: true,
        composed: true
    });
}
function makeWithDataItems(type_, dataItems) {
    var clipboardData1 = Belt_Array.reduce(dataItems, new DataTransfer(), function(clipboardData, param) {
        var data = param[1];
        var dataType = param[0];
        var exit = 0;
        if (dataType === "text/html") {
            switch(data.TAG | 0){
                case /* Blob */ 0:
                    exit = 1;
                    break;
                case /* String */ 2:
                    clipboardData.setData(dataType, data._0);
                    break;
                case /* File */ 1:
                case /* Promise */ 3:
                    Util$SmartcutsMacros.logAndRaiseJsError("Unexpected data type and data combo");
                    break;
            }
        } else {
            exit = 1;
        }
        if (exit === 1) {
            if (data.TAG === /* Blob */ 0 && dataType.startsWith("image/")) {
                var file = DOM__File$SmartcutsMacros.makeWithBlob(data._0, "image.png", dataType, undefined, undefined);
                clipboardData.items.add(file);
            } else {
                Util$SmartcutsMacros.logAndRaiseJsError("Unexpected data type and data combo");
            }
        }
        return clipboardData;
    });
    return new ClipboardEvent(type_, {
        clipboardData: clipboardData1,
        bubbles: true,
        cancelable: true,
        composed: true
    });
}
function makeWithText(type_, text) {
    return make(type_, text, "text");
}
var $$ClipboardEvent$1 = {
    eventTypeToJs: eventTypeToJs,
    eventTypeFromJs: eventTypeFromJs,
    make: make,
    makeWithDataItems: makeWithDataItems,
    makeWithText: makeWithText
};
function ofElement(element) {
    var tagName = element.tagName.toLowerCase();
    if (tagName === "a") {
        return Caml_option.some(element);
    }
}
var HtmlAnchorElement = {
    ofElement: ofElement
};
function stringify(_nodeList) {
    return "nodeList";
}
function t__encode(v) {
    return Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function t__decode(v) {
    return Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
function fromNodeList(nodeList) {
    return $$Array.map(DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode, Array.prototype.slice.call(nodeList));
}
function stringify$1(serializedNodeList) {
    return "[" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(DOM__Node$SmartcutsMacros.ForSerialization.stringify, serializedNodeList))) + "]");
}
var ForSerialization = {
    t__encode: t__encode,
    t__decode: t__decode,
    fromNodeList: fromNodeList,
    stringify: stringify$1
};
var $$NodeList = {
    stringify: stringify,
    ForSerialization: ForSerialization
};
function treatBlankValueAsNone(maybeString) {
    return OptionUtils$SmartcutsMacros.andThen(function(str) {
        if (str === "") {
            return;
        } else {
            return str;
        }
    }, OptionUtils$SmartcutsMacros.map(maybeString, function(prim) {
        return prim.trim();
    }));
}
function findLabelForIdOrName(nameOrId) {
    return Caml_option.nullable_to_opt(document.querySelector("label[for=" + (StringUtils$SmartcutsMacros.quote(nameOrId) + "]")));
}
function deduceNameOfInput(element) {
    var maybeNameAttribute = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("name")));
    var label = Belt_Option.flatMap(treatBlankValueAsNone(element.id), findLabelForIdOrName);
    var maybeLabel = label !== undefined ? Caml_option.some(Caml_option.valFromOption(label)) : Belt_Option.flatMap(maybeNameAttribute, findLabelForIdOrName);
    if (maybeLabel !== undefined) {
        return Caml_option.valFromOption(maybeLabel).innerText;
    }
    var placeholder = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("placeholder")));
    var title = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("title")));
    var role = treatBlankValueAsNone(Caml_option.nullable_to_opt(element.getAttribute("role")));
    if (placeholder !== undefined) {
        return placeholder;
    } else if (title !== undefined) {
        return title;
    } else if (maybeNameAttribute !== undefined) {
        return maybeNameAttribute;
    } else if (role !== undefined) {
        return role;
    } else {
        return;
    }
}
var $$EventTarget = {
    deduceNameOfInput: deduceNameOfInput
};
function optionsGet(selectElement) {
    return Array.prototype.slice.call(selectElement.options);
}
function HtmlSelectElement_fromReactEventTarget(prim) {
    return prim;
}
function HtmlSelectElement_fromElement(prim) {
    return prim;
}
function HtmlSelectElement_selectedIndexGet(prim) {
    return prim.selectedIndex;
}
var HtmlSelectElement = {
    fromReactEventTarget: HtmlSelectElement_fromReactEventTarget,
    fromElement: HtmlSelectElement_fromElement,
    selectedIndexGet: HtmlSelectElement_selectedIndexGet,
    optionsGet: optionsGet
};
var listenState_documentListeners = {};
var listenState_eventTypesWithoutCapture = {
    contents: []
};
var listenState_eventTypesWithCapture = {
    contents: []
};
var listenState = {
    documentListeners: listenState_documentListeners,
    eventTypesWithoutCapture: listenState_eventTypesWithoutCapture,
    eventTypesWithCapture: listenState_eventTypesWithCapture
};
function registerListenerForEventType(useCapture, onDOMEvent, eventType) {
    var onEvent = function onEvent($$event) {
        var timestamp = $$event.timeStamp;
        var eventTransported;
        if ($$event.isTrusted) {
            if (eventType === "blur") {
                eventTransported = {
                    TAG: /* BlurEvent */ 7,
                    _0: "blur",
                    _1: $$event
                };
            } else if (eventType === "dragenter" || eventType === "pause" || eventType === "dragover" || eventType === "invalid" || eventType === "beforeprint" || eventType === "dblclick" || eventType === "loadeddata" || eventType === "open_" || eventType === "stalled" || eventType === "volumechange" || eventType === "animationend" || eventType === "mouseout" || eventType === "loadedmetadata" || eventType === "touchmove" || eventType === "abort" || eventType === "message" || eventType === "submit" || eventType === "ratechange" || eventType === "afterprint" || eventType === "fullscreenerror" || eventType === "transitionend" || eventType === "durationchange" || eventType === "focusout" || eventType === "toggle" || eventType === "loadstart" || eventType === "mouseover" || eventType === "playing" || eventType === "resize" || eventType === "progress" || eventType === "animationstart" || eventType === "touchend" || eventType === "online" || eventType === "seeking" || eventType === "canplay" || eventType === "mouseleave" || eventType === "mouseenter" || eventType === "suspend" || eventType === "error" || eventType === "ended" || eventType === "timeupdate" || eventType === "touchstart" || eventType === "pageshow" || eventType === "select" || eventType === "touchcancel" || eventType === "reset" || eventType === "seeked" || eventType === "unload" || eventType === "pagehide" || eventType === "search" || eventType === "fullscreenchange" || eventType === "waiting" || eventType === "beforeunload" || eventType === "popstate" || eventType === "hashchange" || eventType === "mousewheel" || eventType === "offline" || eventType === "show" || eventType === "play" || eventType === "animationiteration" || eventType === "canplaythrough" || eventType === "load" || eventType === "scroll" || eventType === "storage" || eventType === "focusin" || eventType === "dragleave") {
                Curry._2(Log$SmartcutsMacros.dom.log2, "Event captured but not transported", $$event);
                eventTransported = undefined;
            } else if (eventType === "copy") {
                eventTransported = {
                    TAG: /* ClipboardEvent */ 3,
                    _0: "copy",
                    _1: $$event
                };
            } else if (eventType === "drag") {
                eventTransported = {
                    TAG: /* DragEvent */ 4,
                    _0: "drag",
                    _1: $$event
                };
            } else if (eventType === "drop") {
                eventTransported = {
                    TAG: /* DragEvent */ 4,
                    _0: "drop",
                    _1: $$event
                };
            } else if (eventType === "click") {
                eventTransported = {
                    TAG: /* MouseEvent */ 0,
                    _0: "click",
                    _1: $$event
                };
            } else if (eventType === "wheel") {
                eventTransported = {
                    TAG: /* WheelEvent */ 5,
                    _0: "wheel",
                    _1: $$event
                };
            } else if (eventType === "dragstart") {
                eventTransported = {
                    TAG: /* DragEvent */ 4,
                    _0: "dragstart",
                    _1: $$event
                };
            } else if (eventType === "keyup") {
                eventTransported = {
                    TAG: /* KeyboardEvent */ 2,
                    _0: "keyup",
                    _1: $$event
                };
            } else if (eventType === "dragend") {
                eventTransported = {
                    TAG: /* DragEvent */ 4,
                    _0: "dragend",
                    _1: $$event
                };
            } else if (eventType === "selectionchange") {
                eventTransported = {
                    TAG: /* Event */ 9,
                    _0: "selectionchange",
                    _1: $$event
                };
            } else if (eventType === "keypress") {
                eventTransported = {
                    TAG: /* KeyboardEvent */ 2,
                    _0: "keypress",
                    _1: $$event
                };
            } else if (eventType === "cut") {
                eventTransported = {
                    TAG: /* ClipboardEvent */ 3,
                    _0: "cut",
                    _1: $$event
                };
            } else if (eventType === "mousedown") {
                eventTransported = {
                    TAG: /* MouseEvent */ 0,
                    _0: "mousedown",
                    _1: $$event
                };
            } else if (eventType === "focus") {
                eventTransported = {
                    TAG: /* FocusEvent */ 6,
                    _0: "focus",
                    _1: $$event
                };
            } else if (eventType === "mousemove") {
                eventTransported = {
                    TAG: /* MouseEvent */ 0,
                    _0: "mousemove",
                    _1: $$event
                };
            } else if (eventType === "keydown") {
                eventTransported = {
                    TAG: /* KeyboardEvent */ 2,
                    _0: "keydown",
                    _1: $$event
                };
            } else if (eventType === "change") {
                eventTransported = {
                    TAG: /* ChangeEvent */ 8,
                    _0: $$event,
                    _1: $$event.target.value
                };
            } else if (eventType === "contextmenu") {
                var target = $$event.target;
                Navigator__Clipboard$SmartcutsMacros.readText(undefined).then(function(clipboardTextWhenOpened) {
                    document.addEventListener("mousemove", function(_event) {
                        var exitTimestamp = Date.now();
                        Navigator__Clipboard$SmartcutsMacros.readText(undefined).then(function(clipboardTextWhenClosed) {
                            Curry._2(onDOMEvent, exitTimestamp, {
                                TAG: /* SyntheticEvent */ 10,
                                _0: /* ContextMenuClosed */ {
                                    _0: {
                                        target: target,
                                        clipboardWhenOpened: clipboardTextWhenOpened,
                                        clipboardWhenClosed: clipboardTextWhenClosed
                                    }
                                }
                            });
                            return Promise.resolve(undefined);
                        });
                    }, {
                        capture: false,
                        once: true,
                        passive: true
                    });
                    return Promise.resolve(undefined);
                });
                eventTransported = {
                    TAG: /* MouseEvent */ 0,
                    _0: "contextmenu",
                    _1: $$event
                };
            } else {
                eventTransported = eventType === "paste" ? {
                    TAG: /* ClipboardEvent */ 3,
                    _0: "paste",
                    _1: $$event
                } : eventType === "input" ? {
                    TAG: /* InputEvent */ 1,
                    _0: "input",
                    _1: $$event
                } : {
                    TAG: /* MouseEvent */ 0,
                    _0: "mouseup",
                    _1: $$event
                };
            }
        } else {
            eventTransported = undefined;
        }
        OptionUtils$SmartcutsMacros.$neg$question$great(eventTransported, Curry._1(onDOMEvent, timestamp));
    };
    var eventTypeStr = DOM__EventType$SmartcutsMacros.tToJs(eventType);
    listenState_documentListeners[eventTypeStr] = onEvent;
    var addEventListener = useCapture ? function addEventListener(prim0, prim1, prim2) {
        prim0.addEventListener(prim1, prim2, true);
    } : function(prim0, prim1, prim2) {
        prim0.addEventListener(prim1, prim2);
    };
    return Curry._3(addEventListener, document, eventTypeStr, onEvent);
}
function listen(eventTypesWithoutCaptureOpt, eventTypesWithCaptureOpt, onDOMEvent) {
    var eventTypesWithoutCapture = eventTypesWithoutCaptureOpt !== undefined ? eventTypesWithoutCaptureOpt : mvpEventTypesWithoutCapture;
    var eventTypesWithCapture = eventTypesWithCaptureOpt !== undefined ? eventTypesWithCaptureOpt : mvpEventTypesWithCapture;
    eventTypesWithoutCapture.forEach(function(param) {
        return registerListenerForEventType(false, onDOMEvent, param);
    });
    listenState_eventTypesWithoutCapture.contents = eventTypesWithoutCapture;
    eventTypesWithCapture.forEach(function(param) {
        return registerListenerForEventType(true, onDOMEvent, param);
    });
    listenState_eventTypesWithCapture.contents = eventTypesWithCapture;
}
function unlistenEvents(events, removeListener) {
    return $$Array.map(function(eventType) {
        var eventTypeStr = DOM__EventType$SmartcutsMacros.tToJs(eventType);
        var listener = Js_dict.get(listenState_documentListeners, eventTypeStr);
        if (listener !== undefined) {
            return Curry._2(removeListener, DOM__EventType$SmartcutsMacros.tToJs(eventType), listener);
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected a listener to clean up for event: " + eventTypeStr);
        }
    }, events);
}
function unlisten(param) {
    unlistenEvents(listenState_eventTypesWithoutCapture.contents, function($$event, listener) {
        document.removeEventListener($$event, listener);
    });
    unlistenEvents(listenState_eventTypesWithCapture.contents, function($$event, listener) {
        document.removeEventListener($$event, listener, true);
    });
}
function findClosestAncestorThatSatisfies(predicate, _node) {
    while(true){
        var node = _node;
        var parent = node.parentNode;
        if (parent == null) {
            return;
        }
        if (Curry._1(predicate, parent)) {
            return Caml_option.some(parent);
        }
        _node = parent;
        continue;
    }
    ;
}
var NodeTraversal = {
    findClosestAncestorThatSatisfies: findClosestAncestorThatSatisfies
};
var _map$3 = {
    "attributes": "attributes",
    "characterData": "characterData",
    "childList": "childList"
};
function recordTypeToJs(param) {
    return param;
}
function recordTypeFromJs(param) {
    return _map$3[param];
}
function makeOptions(attributes, attributeFilter, attributeOldValue, characterData, characterDataOldValue, childList, subtree, param) {
    var tmp = {};
    if (attributeFilter !== undefined) {
        tmp.attributeFilter = Caml_option.valFromOption(attributeFilter);
    }
    if (attributeOldValue !== undefined) {
        tmp.attributeOldValue = Caml_option.valFromOption(attributeOldValue);
    }
    if (attributes !== undefined) {
        tmp.attributes = Caml_option.valFromOption(attributes);
    }
    if (characterData !== undefined) {
        tmp.characterData = Caml_option.valFromOption(characterData);
    }
    if (characterDataOldValue !== undefined) {
        tmp.characterDataOldValue = Caml_option.valFromOption(characterDataOldValue);
    }
    if (childList !== undefined) {
        tmp.childList = Caml_option.valFromOption(childList);
    }
    if (subtree !== undefined) {
        tmp.subtree = Caml_option.valFromOption(subtree);
    }
    return tmp;
}
var ObserverInit = {
    makeOptions: makeOptions
};
var Mutation = {
    recordTypeToJs: recordTypeToJs,
    recordTypeFromJs: recordTypeFromJs,
    ObserverInit: ObserverInit
};
function findHost(_htmlElement) {
    while(true){
        var htmlElement = _htmlElement;
        if (DOM__Element$SmartcutsMacros.isNotVisibleOnPage(htmlElement)) {
            var parent = DOM__HtmlElement$SmartcutsMacros.parentHtmlElement(htmlElement);
            if (parent === undefined) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unable to locate parent element of a invisible element when ContentEditable.findHost");
            }
            _htmlElement = Caml_option.valFromOption(parent);
            continue;
        }
        var parent$1 = DOM__HtmlElement$SmartcutsMacros.parentHtmlElement(htmlElement);
        if (parent$1 === undefined) {
            return htmlElement;
        }
        var parent$2 = Caml_option.valFromOption(parent$1);
        if (!parent$2.isContentEditable) {
            return htmlElement;
        }
        _htmlElement = parent$2;
        continue;
    }
    ;
}
var ContentEditable = {
    findHost: findHost
};
function stringify$2(record) {
    return "{type: " + (record.type + ", target, addedNodes, removedNodes, previousSibling, nextSibling, attributeName, attributeNamespace, oldValue}");
}
function t__encode$1(v) {
    return Js_dict.fromArray([
        [
            "type_",
            Decco.stringToJson(v.type_)
        ],
        [
            "target",
            DOM__Node$SmartcutsMacros.ForSerialization.t__encode(v.target)
        ],
        [
            "addedNodes",
            Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.addedNodes)
        ],
        [
            "removedNodes",
            Decco.arrayToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.removedNodes)
        ],
        [
            "previousSibling",
            Decco.optionToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.previousSibling)
        ],
        [
            "nextSibling",
            Decco.optionToJson(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v.nextSibling)
        ],
        [
            "attributeName",
            Decco.optionToJson(Decco.stringToJson, v.attributeName)
        ],
        [
            "attributeNamespace",
            Decco.optionToJson(Decco.stringToJson, v.attributeNamespace)
        ],
        [
            "oldValue",
            Decco.optionToJson(Decco.stringToJson, v.oldValue)
        ]
    ]);
}
function t__decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
    if (type_.TAG === /* Ok */ 0) {
        var target = DOM__Node$SmartcutsMacros.ForSerialization.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
        if (target.TAG === /* Ok */ 0) {
            var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "addedNodes"), null);
            var addedNodes = Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v$1);
            if (addedNodes.TAG === /* Ok */ 0) {
                var v$2 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "removedNodes"), null);
                var removedNodes = Decco.arrayFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v$2);
                if (removedNodes.TAG === /* Ok */ 0) {
                    var previousSibling = Decco.optionFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "previousSibling"), null));
                    if (previousSibling.TAG === /* Ok */ 0) {
                        var nextSibling = Decco.optionFromJson(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextSibling"), null));
                        if (nextSibling.TAG === /* Ok */ 0) {
                            var attributeName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeName"), null));
                            if (attributeName.TAG === /* Ok */ 0) {
                                var attributeNamespace = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeNamespace"), null));
                                if (attributeNamespace.TAG === /* Ok */ 0) {
                                    var oldValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "oldValue"), null));
                                    if (oldValue.TAG === /* Ok */ 0) {
                                        return {
                                            TAG: /* Ok */ 0,
                                            _0: {
                                                type_: type_._0,
                                                target: target._0,
                                                addedNodes: addedNodes._0,
                                                removedNodes: removedNodes._0,
                                                previousSibling: previousSibling._0,
                                                nextSibling: nextSibling._0,
                                                attributeName: attributeName._0,
                                                attributeNamespace: attributeNamespace._0,
                                                oldValue: oldValue._0
                                            }
                                        };
                                    }
                                    var e = oldValue._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".oldValue" + e.path,
                                            message: e.message,
                                            value: e.value
                                        }
                                    };
                                }
                                var e$1 = attributeNamespace._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".attributeNamespace" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                    }
                                };
                            }
                            var e$2 = attributeName._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".attributeName" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                }
                            };
                        }
                        var e$3 = nextSibling._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".nextSibling" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                            }
                        };
                    }
                    var e$4 = previousSibling._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".previousSibling" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = removedNodes._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".removedNodes" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            }
            var e$6 = addedNodes._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".addedNodes" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                }
            };
        }
        var e$7 = target._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".target" + e$7.path,
                message: e$7.message,
                value: e$7.value
            }
        };
    }
    var e$8 = type_._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".type_" + e$8.path,
            message: e$8.message,
            value: e$8.value
        }
    };
}
function fromMutationRecord(record) {
    return {
        type_: record.type,
        target: DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode(record.target),
        addedNodes: fromNodeList(record.addedNodes),
        removedNodes: fromNodeList(record.removedNodes),
        previousSibling: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(record.previousSibling), DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode),
        nextSibling: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(record.nextSibling), DOM__Node$SmartcutsMacros.ForSerialization.fromDomNode),
        attributeName: Caml_option.nullable_to_opt(record.attributeName),
        attributeNamespace: Caml_option.nullable_to_opt(record.attributeNamespace),
        oldValue: Caml_option.nullable_to_opt(record.oldValue)
    };
}
function stringify$3(param) {
    return "{type: " + (param.type_ + (", target: " + (DOM__Node$SmartcutsMacros.ForSerialization.stringify(param.target) + (", addedNodes: " + (stringify$1(param.addedNodes) + (", removedNodes: " + (stringify$1(param.removedNodes) + (", previousSibling: " + (OptionUtils$SmartcutsMacros.withDefault("null", OptionUtils$SmartcutsMacros.map(param.previousSibling, DOM__Node$SmartcutsMacros.ForSerialization.stringify)) + (", nextSibling: " + (OptionUtils$SmartcutsMacros.withDefault("null", OptionUtils$SmartcutsMacros.map(param.nextSibling, DOM__Node$SmartcutsMacros.ForSerialization.stringify)) + (", attributeName: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.attributeName) + (", attributeNamespace: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.attributeNamespace) + (", oldValue: " + (OptionUtils$SmartcutsMacros.withDefault("null", param.oldValue) + "}")))))))))))))))));
}
var ForSerialization$1 = {
    t__encode: t__encode$1,
    t__decode: t__decode$1,
    fromMutationRecord: fromMutationRecord,
    stringify: stringify$3
};
var $$MutationRecord = {
    stringify: stringify$2,
    ForSerialization: ForSerialization$1
};
var EventType;
var $$DataTransfer$1;
var $$Event;
var $$Document;
var Attributes;
var $$Element;
var HtmlElement;
var HtmlInputElement;
var $$Node;
var Topology;
var $$Window;
var $$File;
var $$FileList;
var FileInputElement;
exports.EventType = EventType;
exports.mvpEventTypesWithoutCapture = mvpEventTypesWithoutCapture;
exports.mvpEventTypesWithCapture = mvpEventTypesWithCapture;
exports.MouseButtonPressed = MouseButtonPressed;
exports.$$DataTransfer = $$DataTransfer$1;
exports.tagNameToJs = tagNameToJs;
exports.tagNameFromJs = tagNameFromJs;
exports.inputTypeToJs = inputTypeToJs;
exports.inputTypeFromJs = inputTypeFromJs;
exports.$$Event = $$Event;
exports.$$ClipboardEvent = $$ClipboardEvent$1;
exports.$$Document = $$Document;
exports.Attributes = Attributes;
exports.$$Element = $$Element;
exports.HtmlElement = HtmlElement;
exports.HtmlInputElement = HtmlInputElement;
exports.HtmlAnchorElement = HtmlAnchorElement;
exports.$$Node = $$Node;
exports.$$NodeList = $$NodeList;
exports.$$EventTarget = $$EventTarget;
exports.HtmlSelectElement = HtmlSelectElement;
exports.listenState = listenState;
exports.registerListenerForEventType = registerListenerForEventType;
exports.listen = listen;
exports.unlistenEvents = unlistenEvents;
exports.unlisten = unlisten;
exports.NodeTraversal = NodeTraversal;
exports.Mutation = Mutation;
exports.ContentEditable = ContentEditable;
exports.$$MutationRecord = $$MutationRecord;
exports.Topology = Topology;
exports.$$Window = $$Window;
exports.$$File = $$File;
exports.$$FileList = $$FileList;
exports.FileInputElement = FileInputElement; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 92169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
function collectFromKeyValuePairs(kvs) {
    return Belt_Array.reduce(kvs, {
        type_: undefined,
        value: undefined,
        name: undefined,
        title: undefined,
        placeholder: undefined,
        selected: false,
        contenteditable: undefined
    }, function(attributes, param) {
        var value = param[1];
        switch(param[0]){
            case "contenteditable":
                return {
                    type_: attributes.type_,
                    value: attributes.value,
                    name: attributes.name,
                    title: attributes.title,
                    placeholder: attributes.placeholder,
                    selected: attributes.selected,
                    contenteditable: Pervasives.bool_of_string(value)
                };
            case "name":
                return {
                    type_: attributes.type_,
                    value: attributes.value,
                    name: value,
                    title: attributes.title,
                    placeholder: attributes.placeholder,
                    selected: attributes.selected,
                    contenteditable: attributes.contenteditable
                };
            case "placeholder":
                return {
                    type_: attributes.type_,
                    value: attributes.value,
                    name: attributes.name,
                    title: attributes.title,
                    placeholder: value,
                    selected: attributes.selected,
                    contenteditable: attributes.contenteditable
                };
            case "selected":
                var tmp;
                switch(value){
                    case "false":
                        tmp = false;
                        break;
                    case "":
                    case "selected":
                    case "true":
                        tmp = true;
                        break;
                    default:
                        tmp = false;
                }
                return {
                    type_: attributes.type_,
                    value: attributes.value,
                    name: attributes.name,
                    title: attributes.title,
                    placeholder: attributes.placeholder,
                    selected: tmp,
                    contenteditable: attributes.contenteditable
                };
            case "title":
                return {
                    type_: attributes.type_,
                    value: attributes.value,
                    name: attributes.name,
                    title: value,
                    placeholder: attributes.placeholder,
                    selected: attributes.selected,
                    contenteditable: attributes.contenteditable
                };
            case "type":
                return {
                    type_: value,
                    value: attributes.value,
                    name: attributes.name,
                    title: attributes.title,
                    placeholder: attributes.placeholder,
                    selected: attributes.selected,
                    contenteditable: attributes.contenteditable
                };
            case "value":
                return {
                    type_: attributes.type_,
                    value: value,
                    name: attributes.name,
                    title: attributes.title,
                    placeholder: attributes.placeholder,
                    selected: attributes.selected,
                    contenteditable: attributes.contenteditable
                };
            default:
                return attributes;
        }
    });
}
function ofDomElement(domElement) {
    var attributes;
    try {
        attributes = Array.prototype.slice.call(domElement.attributes);
    } catch (exn) {
        attributes = [];
    }
    return collectFromKeyValuePairs($$Array.map(function(domAttribute) {
        var key = domAttribute.name;
        var value = domAttribute.value;
        return [
            key,
            value
        ];
    }, attributes));
}
function ofSelectorNode(param) {
    return collectFromKeyValuePairs(param.attributes);
}
exports.ofDomElement = ofDomElement;
exports.ofSelectorNode = ofSelectorNode; /* No side effect */ 


/***/ }),

/***/ 44129:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var _map = {
    "none": "none",
    "copy": "copy",
    "link": "link",
    "move": "move"
};
function dropEffectToJs(param) {
    return param;
}
function dropEffectFromJs(param) {
    return _map[param];
}
var _map$1 = {
    "none": "none",
    "copy": "copy",
    "link": "link",
    "move": "move",
    "copyLink": "copyLink",
    "copyMove": "copyMove",
    "all": "all",
    "uninitialized": "uninitialized"
};
function effectAllowedToJs(param) {
    return param;
}
function effectAllowedFromJs(param) {
    return _map$1[param];
}
var _map$2 = {
    "text": "text",
    "url": "url",
    "textHtml": "text/html"
};
var _revMap = {
    "text": "text",
    "url": "url",
    "text/html": "textHtml"
};
function formatToJs(param) {
    return _map$2[param];
}
function formatFromJs(param) {
    return _revMap[param];
}
var ItemList = {};
function getData(format, dataTransfer) {
    return dataTransfer.getData(formatToJs(format));
}
exports.dropEffectToJs = dropEffectToJs;
exports.dropEffectFromJs = dropEffectFromJs;
exports.effectAllowedToJs = effectAllowedToJs;
exports.effectAllowedFromJs = effectAllowedFromJs;
exports.formatToJs = formatToJs;
exports.formatFromJs = formatFromJs;
exports.ItemList = ItemList;
exports.getData = getData; /* No side effect */ 


/***/ }),

/***/ 79990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_option = __webpack_require__(57175);
var Js_null_undefined = __webpack_require__(5733);
var Webapi__Dom__Element = __webpack_require__(33116);
var Webapi__Dom__Document = __webpack_require__(8416);
var XPath$SmartcutsMacros = __webpack_require__(73029);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function toString(cmd) {
    switch(cmd){
        case /* Paste */ 0:
            return "paste";
        case /* Copy */ 1:
            return "copy";
        case /* Cut */ 2:
            return "cut";
    }
}
var Command = {
    toString: toString
};
var ExecCommand = {
    Command: Command
};
function execCommand(command) {
    document.execCommand(toString(command));
}
var Evaluate = {};
function evaluate(xpathExpression, contextNode, namespaceResolver, resultType, result, htmlDocument) {
    return htmlDocument.evaluate(xpathExpression, contextNode, Js_null_undefined.fromOption(namespaceResolver), XPath$SmartcutsMacros.Result.resultTypeToJs(resultType), Js_null_undefined.fromOption(result));
}
function getActiveElement(param) {
    return OptionUtils$SmartcutsMacros.andThen(function(prim) {
        return Caml_option.nullable_to_opt(prim.activeElement);
    }, Webapi__Dom__Document.asHtmlDocument(document));
}
function getActiveHtmlElement(param) {
    return OptionUtils$SmartcutsMacros.andThen(Webapi__Dom__Element.asHtmlElement, OptionUtils$SmartcutsMacros.andThen(function(prim) {
        return Caml_option.nullable_to_opt(prim.activeElement);
    }, Webapi__Dom__Document.asHtmlDocument(document)));
}
function getBodyExn(param1) {
    var arg = Webapi__Dom__Document.asHtmlDocument(document);
    var arg$1 = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect htmlDocument").body;
    var arg$2 = arg$1 == null ? undefined : Caml_option.some(arg$1);
    var param$1 = "Expect htmlDocument.body";
    return OptionUtils$SmartcutsMacros.getExn(param$1, arg$2);
}
exports.ExecCommand = ExecCommand;
exports.execCommand = execCommand;
exports.Evaluate = Evaluate;
exports.evaluate = evaluate;
exports.getActiveElement = getActiveElement;
exports.getActiveHtmlElement = getActiveHtmlElement;
exports.getBodyExn = getBodyExn; /* Webapi__Dom__Element Not a pure module */ 


/***/ }),

/***/ 97209:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var Webapi__Dom__Document = __webpack_require__(8416);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PlaybackModal$SmartcutsMacros = __webpack_require__(15618);
function maybeInnerText(element) {
    return Caml_option.nullable_to_opt(element.innerText);
}
function checkSelectionStartCapability(element) {
    var match = element.nodeName;
    switch(match){
        case "INPUT":
            var match$1 = element.type;
            switch(match$1){
                case "email":
                case "number":
                    return false;
                case "password":
                case "search":
                case "tel":
                case "text":
                case "url":
                    return true;
                default:
                    return false;
            }
        case "TEXTAREA":
            return true;
        default:
            return false;
    }
}
function innerTextGet(domElement) {
    var text = domElement.innerText;
    if (text === "") {
        return;
    } else {
        return text;
    }
}
function toHtmlInputElement(element) {
    var match = $$String.lowercase_ascii(element.nodeName);
    if (match === "input") {
        return Caml_option.some(element);
    }
}
function getTextContent(element) {
    var match = $$String.lowercase_ascii(element.nodeName);
    if (match !== "input") {
        return innerTextGet(element);
    }
    var match$1 = $$String.lowercase_ascii(element.type);
    switch(match$1){
        case "email":
        case "password":
        case "search":
        case "tel":
        case "text":
        case "url":
            return element.value;
        default:
            return;
    }
}
function idGet(domElement) {
    var id = domElement.id;
    if (id === "") {
        return;
    } else {
        return id;
    }
}
function isNotVisibleOnPage(element) {
    var domRect = element.getBoundingClientRect();
    if (domRect.height <= 1.0) {
        return true;
    } else {
        return domRect.width <= 1.0;
    }
}
function isVisibleOnPage(element) {
    return !isNotVisibleOnPage(element);
}
function isVisibleInViewport(element) {
    var domRect = element.getBoundingClientRect();
    var left = domRect.left;
    var top = domRect.top;
    var bottom = domRect.bottom;
    var right = domRect.right;
    if (left > 0 && top > 0 && bottom < window.innerHeight) {
        return right < window.innerWidth;
    } else {
        return false;
    }
}
function getClientXAndClientYOfCenterOfElement(element) {
    var rect = element.getBoundingClientRect();
    var left = rect.left;
    var top = rect.top;
    var width = rect.width;
    var height = rect.height;
    var clientX = left + width / 2;
    var clientY = top + height / 2;
    return [
        clientX,
        clientY
    ];
}
function ancestorNodes(element) {
    var ancestorsRef = [];
    var nodeRef = element;
    var $$break = false;
    while(!$$break){
        var node = nodeRef;
        ancestorsRef = $$Array.append([
            node
        ], ancestorsRef);
        var match = Webapi__Dom__Node.nodeType(node);
        var maybeParentNode = match !== 10 ? Caml_option.nullable_to_opt(node.parentNode) : Caml_option.some(node.host);
        if (maybeParentNode !== undefined) {
            nodeRef = Caml_option.valFromOption(maybeParentNode);
        } else {
            $$break = true;
        }
    }
    ;
    return ancestorsRef;
}
function ancestorElements(element) {
    return $$Array.to_list(Belt_Array.keepMap(ancestorNodes(element), Webapi__Dom__Element.ofNode));
}
var contains = DOM__Node$SmartcutsMacros.contains;
function isAttached(element) {
    return contains(document.documentElement, element);
}
var isUndefined = function isUndefined(a) {
    return typeof a == "undefined";
};
var getPathTo = function getPathTo1(element) {
    if (element.id !== "") return 'id("' + element.id + '")';
    if (element === document.body) return element.tagName;
    var ix = 0;
    var siblings = element.parentNode.childNodes;
    for(var i = 0; i < siblings.length; i++){
        var sibling = siblings[i];
        if (sibling === element) return getPathTo1(element.parentNode) + "/" + element.tagName + "[" + (ix + 1) + "]";
        if (sibling.nodeType === 1 && sibling.tagName === element.tagName) ix++;
    }
};
function commonAncestor(elementA, elementB) {
    if (elementA === elementB) {
        return elementA;
    }
    if (contains(elementA, elementB)) {
        return elementA;
    }
    if (contains(elementB, elementA)) {
        return elementB;
    }
    var ancestorElementsA = ancestorElements(elementA);
    var ancestorElementsB = ancestorElements(elementB);
    var match1 = List.length(ancestorElementsA) > List.length(ancestorElementsB) ? [
        ancestorElementsA,
        ancestorElementsB
    ] : [
        ancestorElementsB,
        ancestorElementsA
    ];
    var shorterAncestors = match1[1];
    var arg = ListUtils$SmartcutsMacros.shortcutWithIndex(function(ancestor_1, index) {
        var match = ListUtils$SmartcutsMacros.elemIndex(ancestor_1, shorterAncestors);
        if (match !== undefined) {
            return;
        } else {
            return Belt_List.get(shorterAncestors, index - 1 | 0);
        }
    }, match1[0]);
    var param = "Expected to find common ancestor of two elements";
    return OptionUtils$SmartcutsMacros.getExn(param, arg);
}
function isContentEditable(element) {
    var htmlElement = Webapi__Dom__HtmlElement.ofElement(element);
    if (htmlElement !== undefined) {
        return Caml_option.valFromOption(htmlElement).isContentEditable;
    } else {
        return false;
    }
}
function compare(elementA, elementB) {
    if (elementA === elementB) {
        return 0;
    }
    var match = contains(document.documentElement, elementA);
    var match$1 = contains(document.documentElement, elementB);
    if (!match) {
        if (match$1) {
            return -1;
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpect: doesn't make sense to compare two detached nodes");
        }
    }
    if (!match$1) {
        return 1;
    }
    var ancestorElementsA = ancestorElements(elementA);
    var ancestorElementsB = ancestorElements(elementB);
    var _commonNode;
    var _ancestorsA = ancestorElementsA;
    var _ancestorsB = ancestorElementsB;
    while(true){
        var ancestorsB = _ancestorsB;
        var ancestorsA = _ancestorsA;
        var commonNode = _commonNode;
        if (!ancestorsA) {
            if (ancestorsB) {
                return -1;
            } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Expected elementA to not equal element B");
            }
        }
        var ancestorA1 = ancestorsA.hd;
        if (!ancestorsB) {
            return 1;
        }
        var ancestorB1 = ancestorsB.hd;
        if (ancestorA1 === ancestorB1) {
            _ancestorsB = ancestorsB.tl;
            _ancestorsA = ancestorsA.tl;
            _commonNode = Caml_option.some(ancestorA1);
            continue;
        }
        var _$commonAncestor = OptionUtils$SmartcutsMacros.getExn("Expect to get commonAncestor", commonNode);
        var siblings = Array.prototype.slice.call(_$commonAncestor.childNodes);
        var arg = Util$SmartcutsMacros.shortcut2(siblings, function(ancestorA, ancestorB) {
            return function(sib) {
                if (sib === ancestorA) {
                    return -1;
                } else if (sib === ancestorB) {
                    return 1;
                } else {
                    return;
                }
            };
        }(ancestorA1, ancestorB1));
        var param = "Expected to find ancestorA or ancestorB";
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }
    ;
}
function isYScrollable(el) {
    return el.scrollHeight > el.clientHeight;
}
function isXScrollable(el) {
    return el.scrollWidth > el.clientWidth;
}
function isScrollable(el) {
    if (isYScrollable(el)) {
        return true;
    } else {
        return isXScrollable(el);
    }
}
function closest(f, _el) {
    while(true){
        var el = _el;
        var parentEl = el.parentElement;
        if (parentEl == null) {
            return;
        }
        if (Curry._1(f, parentEl)) {
            return Caml_option.some(parentEl);
        }
        _el = parentEl;
        continue;
    }
    ;
}
function closestSome(f, _el) {
    while(true){
        var el = _el;
        var parentEl = el.parentElement;
        if (parentEl == null) {
            return;
        }
        var v = Curry._1(f, parentEl);
        if (v !== undefined) {
            return [
                parentEl,
                Caml_option.valFromOption(v)
            ];
        }
        _el = parentEl;
        continue;
    }
    ;
}
function scrollableClosestParentOrSelf(param) {
    return closest(isScrollable, param);
}
function getBoundingClientRectInViewport(element) {
    var boundingRect = Rect$SmartcutsMacros.fromDomRect(element.getBoundingClientRect());
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var viewport = {
        x: 0.0,
        y: 0.0,
        width: windowWidth,
        height: windowHeight
    };
    return Rect$SmartcutsMacros.intersect(boundingRect, viewport);
}
function isOutsideOfViewport(element) {
    return Rect$SmartcutsMacros.isEmpty(getBoundingClientRectInViewport(element));
}
function scrollIntoViewIfNeeded(xRel1, yRel1, element) {
    var isPointInsideIntersectionRect = function isPointInsideIntersectionRect(xRel, yRel, intersectionRect) {
        if (intersectionRect.width > xRel) {
            return intersectionRect.height > yRel;
        } else {
            return false;
        }
    };
    var boundingClientRectInViewport = getBoundingClientRectInViewport(element);
    if (Rect$SmartcutsMacros.isNotEmpty(boundingClientRectInViewport) && isPointInsideIntersectionRect(xRel1, yRel1, boundingClientRectInViewport)) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    } else {
        return new Promise(function(resolve, param) {
            var match = Webapi__Dom__Document.visibilityState(document);
            if (match !== 0) {
                if (match >= 3) {
                    return resolve({
                        TAG: /* Error */ 1,
                        _0: /* TabOrWindowVisibilityUnknownOrUnloaded */ 3
                    });
                } else {
                    return resolve({
                        TAG: /* Error */ 1,
                        _0: /* TabOrWindowNotVisible */ 2
                    });
                }
            }
            var onIntersectionChange = function onIntersectionChange(entries, observer) {
                var hasElementScrolledIntoView = Belt_Array.some(entries, function(entry) {
                    var target = entry.target;
                    if (target === element) {
                        return entry.isIntersecting;
                    } else {
                        return false;
                    }
                });
                if (hasElementScrolledIntoView) {
                    observer.disconnect();
                    return resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
            };
            var observer1 = new IntersectionObserver(onIntersectionChange, {
                thresholds: 1.0
            });
            observer1.observe(element);
            element.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        });
    }
}
function isTopZIndexAtLocation(maybeRelPosition, element1, param1) {
    var rect = element1.getBoundingClientRect();
    var left = rect.left;
    var top = rect.top;
    var width = rect.width;
    var height = rect.height;
    var bottom = rect.bottom;
    var match;
    if (maybeRelPosition !== undefined) {
        var match$1 = maybeRelPosition.parent;
        var parentHeight = match$1.height;
        var parentWidth = match$1.width;
        var xRatio = parentWidth > 0 ? maybeRelPosition.x / parentWidth : 0.5;
        var yRatio = parentHeight > 0 ? maybeRelPosition.y / parentHeight : 0.5;
        match = [
            width * xRatio,
            height * yRatio
        ];
    } else {
        match = [
            width / 2,
            height / 2
        ];
    }
    var x = left + match[0];
    var y = top + match[1];
    var elementAtPoint = document.elementFromPoint(x | 0, y | 0);
    if (elementAtPoint == null) {
        return /* ElementNotInViewport */ 1;
    }
    if (elementAtPoint === element1 || contains(elementAtPoint, element1) || contains(element1, elementAtPoint)) {
        return /* ElementIsTopZIndexAtLocation */ 0;
    }
    if (Belt_Option.isSome(closest(function(element) {
        var id = element.id;
        return id === PlaybackModal$SmartcutsMacros.PlaybackModal.containerId;
    }, elementAtPoint))) {
        return /* HideSmartcutsPlaybackModalUntilCompletedCommand */ 2;
    }
    var arg1 = commonAncestor(elementAtPoint, element1);
    var arg$1 = Curry._1((function(param) {
        return function(param$1) {
            return function(param$2) {
                var findVisibleDescendantContainsElementAtPoint = function(element) {
                    var arg = Array.prototype.slice.call(element.childNodes);
                    var param$3 = function param$3(node) {
                        return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), function(descendant) {
                            var descendantRect = getBoundingClientRectInViewport(descendant);
                            if (!contains(descendant, param$2)) {
                                return;
                            }
                            var tmp = false;
                            if (Rect$SmartcutsMacros.isNotEmpty(descendantRect)) {
                                var func = function func(param$4, param$5) {
                                    return Rect$SmartcutsMacros.containsPoint(param, param$4, param$5);
                                };
                                tmp = Curry._2(func, param$1, descendantRect);
                            }
                            if (tmp) {
                                return Caml_option.some(descendant);
                            } else {
                                return findVisibleDescendantContainsElementAtPoint(descendant);
                            }
                        });
                    };
                    return ArrayUtils$SmartcutsMacros.shortcut(param$3, arg);
                };
                return findVisibleDescendantContainsElementAtPoint(arg1);
            };
        };
    })(x)(y), elementAtPoint);
    var overlay = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("got None from nextVisibleDescendantContainsElementAtPoint");
    var windowHeight = window.innerHeight;
    var overlayRect = Rect$SmartcutsMacros.fromDomRect(overlay.getBoundingClientRect());
    var scrollable = closest(isScrollable, element1);
    if (scrollable === undefined) {
        return {
            TAG: /* WaitForOverlayToDisappear */ 0,
            _0: overlay
        };
    }
    if (overlayRect.height >= windowHeight) {
        return {
            TAG: /* WaitForOverlayToDisappear */ 0,
            _0: overlay
        };
    }
    var overlayTop = Rect$SmartcutsMacros.top(overlayRect);
    var overlayBottom = Rect$SmartcutsMacros.bottom(overlayRect);
    var distanceToScroll = windowHeight - overlayBottom > overlayTop ? top - overlayBottom : overlayTop - bottom;
    return {
        TAG: /* ScrollToRevealElement */ 1,
        _0: Caml_option.valFromOption(scrollable),
        _1: distanceToScroll
    };
}
var Style = {};
function waitForAnyPossibleOverlayToDisappear(element, positionRelToElement, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
    var rect = element.getBoundingClientRect();
    var width = rect.width;
    var height = rect.height;
    var match2;
    if (positionRelToElement !== undefined) {
        var match$1 = positionRelToElement.parent;
        var parentHeight = match$1.height;
        var parentWidth = match$1.width;
        var xRatio = parentWidth > 0 ? positionRelToElement.x / parentWidth : 0.5;
        var yRatio = parentHeight > 0 ? positionRelToElement.y / parentHeight : 0.5;
        match2 = [
            width * xRatio,
            height * yRatio
        ];
    } else {
        match2 = [
            width / 2,
            height / 2
        ];
    }
    var yRel = match2[1];
    var xRel = match2[0];
    return Util$SmartcutsMacros.waitForPromise2(10000, 500, function(param) {
        var overlayElement = isTopZIndexAtLocation(positionRelToElement, element, undefined);
        if (typeof overlayElement === "number") {
            switch(overlayElement){
                case /* ElementIsTopZIndexAtLocation */ 0:
                    return Promise.resolve({
                        TAG: /* PredicateSatisfied */ 0,
                        _0: undefined
                    });
                case /* ElementNotInViewport */ 1:
                    return scrollIntoViewIfNeeded(xRel, yRel, element).then(function(result) {
                        if (result.TAG === /* Ok */ 0) {
                            return Promise.resolve(/* PredicateNotSatisfied */ 0);
                        } else {
                            return Promise.resolve({
                                TAG: /* ErrorDuringPredicate */ 2,
                                _0: result._0
                            });
                        }
                    });
                case /* HideSmartcutsPlaybackModalUntilCompletedCommand */ 2:
                    return Curry._1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(param) {
                        return Promise.resolve(/* PredicateNotSatisfied */ 0);
                    });
            }
        } else {
            if (overlayElement.TAG === /* WaitForOverlayToDisappear */ 0) {
                return Promise.resolve({
                    TAG: /* PredicateNotSatisfiedWithExtraInfo */ 1,
                    _0: overlayElement._0
                });
            }
            overlayElement._0.scrollBy(0.0, overlayElement._1);
            return Promise.resolve(/* PredicateNotSatisfied */ 0);
        }
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var match = result._0;
            switch(match.TAG | 0){
                case /* PredicateDidResolveTo */ 0:
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                case /* TimedOut */ 1:
                case /* PredicateTimedOut */ 2:
                    break;
            }
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* OverlayStillBlockingElementAfterMs */ 5,
                    _0: {
                        element: element,
                        maybeOverlayElement: match._1,
                        ms: match._0
                    }
                }
            });
        }
        var jsPromiseError = result._0;
        if (jsPromiseError.TAG === /* UncaughtPredicateError */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ErrorWhileWaitForPossibleOverlayToDisappear */ 6,
                    _0: jsPromiseError._0
                }
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: jsPromiseError._0
            });
        }
    });
}
function rootElementContainingDifferentInnnerText(element2) {
    var elementInnerText = element2.innerText;
    var findRootElementContainingDifferentInnerText = function(element) {
        if (element.innerText !== elementInnerText) {
            return Caml_option.some(element);
        } else {
            return Belt_Option.flatMap(Caml_option.nullable_to_opt(element.parentElement), findRootElementContainingDifferentInnerText);
        }
    };
    return findRootElementContainingDifferentInnerText(element2);
}
function downMostElementWithSameInnnerText(element) {
    var elementInnerText = element.innerText;
    var _element = element;
    while(true){
        var element$1 = _element;
        var elements = Belt_Array.keepMap(Array.prototype.slice.call(element$1.childNodes), function(node) {
            return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), function(childElement) {
                if (childElement.innerText === elementInnerText) {
                    return Caml_option.some(childElement);
                }
            });
        });
        if (elements.length === 0) {
            return element$1;
        }
        _element = Caml_array.get(elements, 0);
        continue;
    }
    ;
}
function proximalElementsWithInnerText(element) {
    var elementInnerText = element.innerText;
    var rootElement = rootElementContainingDifferentInnnerText(element);
    if (rootElement !== undefined) {
        return Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(Caml_option.valFromOption(rootElement).childNodes), function(node) {
            return Belt_Option.flatMap(Webapi__Dom__Element.ofNode(node), function(siblingElement) {
                if (isNotVisibleOnPage(siblingElement)) {
                    return;
                }
                var innerText = siblingElement.innerText;
                var innerText$1 = innerText == null ? undefined : Caml_option.some(innerText);
                if (innerText == null || innerText$1 === "" || contains(siblingElement, element) || innerText$1.length > 100 || innerText$1 === elementInnerText) {
                    return;
                } else {
                    return Caml_option.some(siblingElement);
                }
            });
        }), downMostElementWithSameInnnerText);
    } else {
        return [];
    }
}
function hasParent(element) {
    return Caml_option.nullable_to_opt(element.parentElement) !== undefined;
}
var getDepthRelativeToBody = DOM__Node$SmartcutsMacros.getDepthRelativeToBody;
function isActive(element) {
    var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
    if (activeElement !== undefined) {
        return Caml_option.valFromOption(activeElement) === element;
    } else {
        return false;
    }
}
function isLikelyAutosuggestResult(htmlInputElement, element) {
    var inputRect = htmlInputElement.getBoundingClientRect();
    var bottomForInput = inputRect.bottom;
    var leftForInput = inputRect.left;
    var widthForInput = inputRect.width;
    var rect = element.getBoundingClientRect();
    var top = rect.top;
    var left = rect.left;
    var width = rect.width;
    var height = rect.height;
    var x = rect.x;
    var y = rect.y;
    var isElementLikelyFirstAutosuggestResultUnderInput = Util$SmartcutsMacros.isFloatWithin(bottomForInput, bottomForInput + 2, top) && Util$SmartcutsMacros.isFloatWithin(leftForInput - 2, leftForInput + 2, left) && Util$SmartcutsMacros.isFloatWithin(widthForInput - 2, widthForInput + 2, width);
    if (isElementLikelyFirstAutosuggestResultUnderInput) {
        return true;
    }
    var elementBelow = Belt_Option.map(Caml_option.nullable_to_opt(document.elementFromPoint(x | 0, y + height / 2 | 0)), function(prim) {
        return prim;
    });
    if (elementBelow === undefined) {
        return false;
    }
    var elementBelow$1 = Caml_option.valFromOption(elementBelow);
    if ((width | 0) === elementBelow$1.offsetWidth) {
        return (height | 0) === elementBelow$1.offsetHeight;
    } else {
        return false;
    }
}
function isElementAPositionedGeometricallyInsideElementB(elementA, elementB) {
    var rectA = elementA.getBoundingClientRect();
    var rectB = elementB.getBoundingClientRect();
    var topA = rectA.x;
    var leftA = rectA.y;
    var bottomA = rectA.width;
    var rightA = rectA.height;
    var topB = rectB.x;
    var leftB = rectB.y;
    var bottomB = rectB.width;
    var rightB = rectB.height;
    if (topA >= topB && leftA >= leftB && bottomA <= bottomB) {
        return rightA <= rightB;
    } else {
        return false;
    }
}
function doElementsGeometricallyOverlap(elementA, elementB) {
    var rectA = elementA.getBoundingClientRect();
    var rectB = elementB.getBoundingClientRect();
    var topA = rectA.x;
    var leftA = rectA.y;
    var bottomA = rectA.width;
    var rightA = rectA.height;
    var topB = rectB.x;
    var leftB = rectB.y;
    var bottomB = rectB.width;
    var rightB = rectB.height;
    var isTopAInsideBoundsOfB = topA >= topB && topA <= bottomB;
    var isBottomAInsideBoundsOfB = bottomA <= bottomB && bottomA >= topB;
    var isLeftAInsideBoundsOfB = leftA >= leftB && leftA <= rightB;
    var isRightAInsideBoundsOfB = rightA <= rightB && rightA >= leftB;
    if (isTopAInsideBoundsOfB || isBottomAInsideBoundsOfB || isLeftAInsideBoundsOfB) {
        return true;
    } else {
        return isRightAInsideBoundsOfB;
    }
}
function isSiblingOf(e1, e2) {
    var match = e1.parentElement;
    var match$1 = e2.parentElement;
    if (!(match == null) && !(match$1 == null)) {
        return match === match$1;
    } else {
        return false;
    }
}
var Cell = {};
function getCellAtIndex(row, index) {
    return Caml_option.undefined_to_opt(row.cells[index]);
}
var Row = {
    getCellAtIndex: getCellAtIndex
};
function getRowAtIndex(table, index) {
    return Caml_option.undefined_to_opt(table.rows[index]);
}
var TableElement = {
    Cell: Cell,
    Row: Row,
    getRowAtIndex: getRowAtIndex
};
exports.maybeInnerText = maybeInnerText;
exports.checkSelectionStartCapability = checkSelectionStartCapability;
exports.innerTextGet = innerTextGet;
exports.toHtmlInputElement = toHtmlInputElement;
exports.getTextContent = getTextContent;
exports.idGet = idGet;
exports.isNotVisibleOnPage = isNotVisibleOnPage;
exports.isVisibleOnPage = isVisibleOnPage;
exports.isVisibleInViewport = isVisibleInViewport;
exports.getClientXAndClientYOfCenterOfElement = getClientXAndClientYOfCenterOfElement;
exports.ancestorNodes = ancestorNodes;
exports.ancestorElements = ancestorElements;
exports.contains = contains;
exports.isAttached = isAttached;
exports.isUndefined = isUndefined;
exports.getPathTo = getPathTo;
exports.commonAncestor = commonAncestor;
exports.isContentEditable = isContentEditable;
exports.compare = compare;
exports.isYScrollable = isYScrollable;
exports.isXScrollable = isXScrollable;
exports.isScrollable = isScrollable;
exports.closest = closest;
exports.closestSome = closestSome;
exports.scrollableClosestParentOrSelf = scrollableClosestParentOrSelf;
exports.isOutsideOfViewport = isOutsideOfViewport;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.isTopZIndexAtLocation = isTopZIndexAtLocation;
exports.Style = Style;
exports.waitForAnyPossibleOverlayToDisappear = waitForAnyPossibleOverlayToDisappear;
exports.proximalElementsWithInnerText = proximalElementsWithInnerText;
exports.hasParent = hasParent;
exports.getDepthRelativeToBody = getDepthRelativeToBody;
exports.isActive = isActive;
exports.isLikelyAutosuggestResult = isLikelyAutosuggestResult;
exports.isElementAPositionedGeometricallyInsideElementB = isElementAPositionedGeometricallyInsideElementB;
exports.doElementsGeometricallyOverlap = doElementsGeometricallyOverlap;
exports.isSiblingOf = isSiblingOf;
exports.TableElement = TableElement; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 46307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Js_math = __webpack_require__(84763);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__EventType$SmartcutsMacros = __webpack_require__(41639);
var DOM__DataTransfer$SmartcutsMacros = __webpack_require__(44129);
var $$CustomEvent = {};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "height",
            Decco.intToJson(v.height)
        ],
        [
            "top",
            Decco.floatToJson(v.top)
        ],
        [
            "width",
            Decco.intToJson(v.width)
        ],
        [
            "left",
            Decco.floatToJson(v.left)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
    if (height.TAG === /* Ok */ 0) {
        var top = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "top"), null));
        if (top.TAG === /* Ok */ 0) {
            var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
            if (width.TAG === /* Ok */ 0) {
                var left = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "left"), null));
                if (left.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            height: height._0,
                            top: top._0,
                            width: width._0,
                            left: left._0
                        }
                    };
                }
                var e = left._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".left" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = width._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".width" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = top._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".top" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = height._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".height" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function fromElement(element) {
    return {
        height: element.scrollHeight,
        top: element.scrollTop,
        width: element.scrollWidth,
        left: element.scrollLeft
    };
}
function fromHtmlElement(element) {
    return {
        height: element.scrollHeight,
        top: element.scrollTop,
        width: element.scrollWidth,
        left: element.scrollLeft
    };
}
var ScrollInfo = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromElement: fromElement,
    fromHtmlElement: fromHtmlElement
};
function fromEventTarget(target) {
    if (target === window) {
        return {
            TAG: /* TargetWindow */ 0,
            _0: window
        };
    } else if (target === document) {
        return {
            TAG: /* TargetDocument */ 1,
            _0: document
        };
    } else {
        return {
            TAG: /* TargetElement */ 2,
            _0: target
        };
    }
}
var TypedEventTarget = {
    fromEventTarget: fromEventTarget
};
function parentGeometry_encode(v) {
    return Js_dict.fromArray([
        [
            "width",
            Decco.intToJson(v.width)
        ],
        [
            "height",
            Decco.intToJson(v.height)
        ]
    ]);
}
function parentGeometry_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */ 0) {
        var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
        if (height.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    width: width._0,
                    height: height._0
                }
            };
        }
        var e = height._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".height" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = width._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".width" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "x",
            Decco.intToJson(v.x)
        ],
        [
            "y",
            Decco.intToJson(v.y)
        ],
        [
            "parent",
            parentGeometry_encode(v.parent)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
    if (x.TAG === /* Ok */ 0) {
        var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
        if (y.TAG === /* Ok */ 0) {
            var parent = parentGeometry_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
            if (parent.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        x: x._0,
                        y: y._0,
                        parent: parent._0
                    }
                };
            }
            var e = parent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".parent" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = y._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".y" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = x._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".x" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromMouseEvent($$event) {
    var target = $$event.target;
    var targetElement = fromEventTarget(target);
    switch(targetElement.TAG | 0){
        case /* TargetWindow */ 0:
        case /* TargetDocument */ 1:
            break;
        case /* TargetElement */ 2:
            var targetElement$1 = targetElement._0;
            var targetRect = target.getBoundingClientRect();
            var targetClientX = targetRect.left;
            var targetClientY = targetRect.top;
            return {
                x: Js_math.floor($$event.clientX - targetClientX),
                y: Js_math.floor($$event.clientY - targetClientY),
                parent: {
                    width: targetElement$1.clientWidth,
                    height: targetElement$1.clientHeight
                }
            };
    }
    return {
        x: $$event.clientX | 0,
        y: $$event.clientY | 0,
        parent: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    };
}
function getClientXYForDifferentParentInstance(parent, param) {
    var match = param.parent;
    var rect = parent.getBoundingClientRect();
    var newParentClientX = rect.left;
    var newParentClientY = rect.top;
    var newParentWidth = rect.width;
    var newParentHeight = rect.height;
    var xRatio = param.x / match.width;
    var yRatio = param.y / match.height;
    var newClientX = newParentClientX + xRatio * newParentWidth | 0;
    var newClientY = newParentClientY + yRatio * newParentHeight | 0;
    return [
        newClientX,
        newClientY
    ];
}
var PositionRelToElement = {
    parentGeometry_encode: parentGeometry_encode,
    parentGeometry_decode: parentGeometry_decode,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromMouseEvent: fromMouseEvent,
    getClientXYForDifferentParentInstance: getClientXYForDifferentParentInstance
};
function parentGeometry_encode$1(v) {
    return Js_dict.fromArray([
        [
            "width",
            Decco.intToJson(v.width)
        ],
        [
            "height",
            Decco.intToJson(v.height)
        ],
        [
            "scroll",
            t_encode(v.scroll)
        ]
    ]);
}
function parentGeometry_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */ 0) {
        var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
        if (height.TAG === /* Ok */ 0) {
            var scroll = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scroll"), null));
            if (scroll.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        width: width._0,
                        height: height._0,
                        scroll: scroll._0
                    }
                };
            }
            var e = scroll._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".scroll" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = height._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".height" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = width._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".width" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "x",
            Decco.intToJson(v.x)
        ],
        [
            "y",
            Decco.intToJson(v.y)
        ],
        [
            "parent",
            parentGeometry_encode$1(v.parent)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var x = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
    if (x.TAG === /* Ok */ 0) {
        var y = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
        if (y.TAG === /* Ok */ 0) {
            var parent = parentGeometry_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
            if (parent.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        x: x._0,
                        y: y._0,
                        parent: parent._0
                    }
                };
            }
            var e = parent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".parent" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = y._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".y" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = x._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".x" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromMouseEvent$1($$event) {
    var target = $$event.target;
    var targetElement = fromEventTarget(target);
    switch(targetElement.TAG | 0){
        case /* TargetWindow */ 0:
        case /* TargetDocument */ 1:
            break;
        case /* TargetElement */ 2:
            var targetElement$1 = targetElement._0;
            var targetRect = target.getBoundingClientRect();
            var targetClientX = targetRect.left;
            var targetClientY = targetRect.top;
            return {
                x: Js_math.floor($$event.clientX - targetClientX),
                y: Js_math.floor($$event.clientY - targetClientY),
                parent: {
                    width: targetElement$1.clientWidth,
                    height: targetElement$1.clientHeight,
                    scroll: fromElement(targetElement$1)
                }
            };
    }
    return {
        x: $$event.clientX | 0,
        y: $$event.clientY | 0,
        parent: {
            width: window.innerWidth,
            height: window.innerHeight,
            scroll: fromElement(document.documentElement)
        }
    };
}
function getClientXYForDifferentParentInstance$1(parent, param) {
    var match = param.parent;
    var rect = parent.getBoundingClientRect();
    var newParentClientX = rect.left;
    var newParentClientY = rect.top;
    var newParentWidth = rect.width;
    var newParentHeight = rect.height;
    var xRatio = param.x / match.width;
    var yRatio = param.y / match.height;
    var newClientX = newParentClientX + xRatio * newParentWidth | 0;
    var newClientY = newParentClientY + yRatio * newParentHeight | 0;
    return [
        newClientX,
        newClientY
    ];
}
var PositionRelToElementWithScrollInfo = {
    parentGeometry_encode: parentGeometry_encode$1,
    parentGeometry_decode: parentGeometry_decode$1,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromMouseEvent: fromMouseEvent$1,
    getClientXYForDifferentParentInstance: getClientXYForDifferentParentInstance$1
};
var $$MouseEvent = {};
var $$InputEvent = {};
var $$ClipboardEvent = {};
var $$KeyboardEvent = {};
var $$DragEvent = {};
var $$FocusEvent = {};
var BlurEvent = {};
var $$WheelEvent = {};
function stringify(param) {
    return "{target, clipboardWhenOpened: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenOpened) + (", clipboardWhenClosed: " + (StringUtils$SmartcutsMacros.quote(param.clipboardWhenClosed) + ")")));
}
var ContextMenuClosed = {
    stringify: stringify
};
function stringify$1(v) {
    return "ContentMenuClosed(" + (stringify(v._0) + ")");
}
var SyntheticEvent = {
    ContextMenuClosed: ContextMenuClosed,
    stringify: stringify$1
};
function boundingClientRectGet($$event) {
    var boundingRectFromEventTarget = function boundingRectFromEventTarget(domEvent) {
        var eventTarget1;
        switch(domEvent.TAG | 0){
            case /* WheelEvent */ 5:
                eventTarget1 = undefined;
                break;
            case /* FocusEvent */ 6:
            case /* BlurEvent */ 7:
                eventTarget1 = Caml_option.some(domEvent._1.target);
                break;
            case /* ChangeEvent */ 8:
                eventTarget1 = Caml_option.some(domEvent._0.target);
                break;
            case /* SyntheticEvent */ 10:
                eventTarget1 = Caml_option.some(domEvent._0._0.target);
                break;
            default:
                eventTarget1 = Caml_option.some(domEvent._1.target);
        }
        var targetElementFromEventTaraget = function targetElementFromEventTaraget(eventTarget) {
            switch(eventTarget.TAG | 0){
                case /* TargetWindow */ 0:
                case /* TargetDocument */ 1:
                    return DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
                case /* TargetElement */ 2:
                    return Caml_option.some(eventTarget._0);
            }
        };
        return OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.map(Belt_Option.flatMap(OptionUtils$SmartcutsMacros.map(eventTarget1, fromEventTarget), targetElementFromEventTaraget), function(prim) {
            return prim.getBoundingClientRect();
        }), Rect$SmartcutsMacros.fromDomRect);
    };
    var maybeSelection = window.getSelection();
    var selection;
    switch($$event.TAG | 0){
        case /* MouseEvent */ 0:
            if ($$event._0 !== "click") {
                return boundingRectFromEventTarget($$event);
            }
            var mouseEvent = $$event._1;
            var exit = 0;
            if (maybeSelection == null) {
                exit = 2;
            } else {
                if (mouseEvent.target.isContentEditable && maybeSelection.rangeCount > 0) {
                    var range = maybeSelection.getRangeAt(0);
                    var rectFromSelectionRange = Rect$SmartcutsMacros.fromDomRect(range.getBoundingClientRect());
                    if (Rect$SmartcutsMacros.isEmpty(rectFromSelectionRange)) {
                        return boundingRectFromEventTarget($$event);
                    } else {
                        return rectFromSelectionRange;
                    }
                }
                exit = 2;
            }
            if (exit === 2) {
                var match = fromEventTarget(mouseEvent.target);
                var exit$1 = 0;
                switch(match.TAG | 0){
                    case /* TargetWindow */ 0:
                    case /* TargetDocument */ 1:
                        exit$1 = 3;
                        break;
                    case /* TargetElement */ 2:
                        return boundingRectFromEventTarget($$event);
                }
                if (exit$1 === 3) {
                    var x0 = mouseEvent.clientX;
                    var y0 = mouseEvent.clientY;
                    return Rect$SmartcutsMacros.withPadding(50, {
                        x: x0,
                        y: y0,
                        width: 0.0,
                        height: 0.0
                    });
                }
            }
            break;
        case /* InputEvent */ 1:
            if ($$event._0 !== "input") {
                return boundingRectFromEventTarget($$event);
            }
            if (maybeSelection == null) {
                return boundingRectFromEventTarget($$event);
            }
            selection = maybeSelection;
            break;
        case /* ClipboardEvent */ 3:
            var match$1 = $$event._0;
            if (!(match$1 === "paste" || match$1 === "copy")) {
                return boundingRectFromEventTarget($$event);
            }
            if (maybeSelection == null) {
                return boundingRectFromEventTarget($$event);
            }
            selection = maybeSelection;
            break;
        case /* Event */ 9:
            if ($$event._0 !== "selectionchange") {
                return boundingRectFromEventTarget($$event);
            }
            if (maybeSelection == null) {
                return boundingRectFromEventTarget($$event);
            }
            selection = maybeSelection;
            break;
        default:
            return boundingRectFromEventTarget($$event);
    }
    if (selection.rangeCount <= 0) {
        return boundingRectFromEventTarget($$event);
    }
    var range$1 = selection.getRangeAt(0);
    var rectFromSelectionRange$1 = Rect$SmartcutsMacros.fromDomRect(range$1.getBoundingClientRect());
    if (Rect$SmartcutsMacros.isEmpty(rectFromSelectionRange$1)) {
        return boundingRectFromEventTarget($$event);
    } else {
        return rectFromSelectionRange$1;
    }
}
function stringify$2($$event) {
    switch($$event.TAG | 0){
        case /* MouseEvent */ 0:
            return "MouseEvent(" + (DOM__EventType$SmartcutsMacros.mouseToJs($$event._0) + ", mouseEvent)");
        case /* InputEvent */ 1:
            var arg = Belt_Option.map(Caml_option.nullable_to_opt($$event._1.data), StringUtils$SmartcutsMacros.quote);
            return "InputEvent(" + (DOM__EventType$SmartcutsMacros.inputToJs($$event._0) + (", inputEvent(data=" + (function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("undefined") + "))")));
        case /* KeyboardEvent */ 2:
            var code = $$event._1.code;
            return "KeyboardEvent(" + (DOM__EventType$SmartcutsMacros.keyboardToJs($$event._0) + (", keyboardEvent={code: " + (code + "})")));
        case /* ClipboardEvent */ 3:
            return "ClipboardEvent(" + (DOM__EventType$SmartcutsMacros.clipboardToJs($$event._0) + (", clipboardEvent=" + (DOM__DataTransfer$SmartcutsMacros.getData("text", $$event._1.clipboardData) + ")")));
        case /* DragEvent */ 4:
            return "DragEvent(" + (DOM__EventType$SmartcutsMacros.dragToJs($$event._0) + ", dragEvent)");
        case /* WheelEvent */ 5:
            return "WheelEvent(" + (DOM__EventType$SmartcutsMacros.wheelToJs($$event._0) + ", wheelEvent)");
        case /* FocusEvent */ 6:
            return "FocusEvent(" + (DOM__EventType$SmartcutsMacros.focusToJs($$event._0) + ", focusEvent)");
        case /* BlurEvent */ 7:
            return "BlurEvent(" + (DOM__EventType$SmartcutsMacros.blurToJs($$event._0) + ", blurEvent)");
        case /* ChangeEvent */ 8:
            return "ChangeEvent(event, " + (StringUtils$SmartcutsMacros.quote($$event._1) + ")");
        case /* Event */ 9:
            return "Event(" + (DOM__EventType$SmartcutsMacros.tToJs($$event._0) + ", event)");
        case /* SyntheticEvent */ 10:
            return "SyntheticEvent(" + (stringify$1($$event._0) + ")");
    }
}
var EventType;
exports.EventType = EventType;
exports.$$CustomEvent = $$CustomEvent;
exports.ScrollInfo = ScrollInfo;
exports.TypedEventTarget = TypedEventTarget;
exports.PositionRelToElement = PositionRelToElement;
exports.PositionRelToElementWithScrollInfo = PositionRelToElementWithScrollInfo;
exports.$$MouseEvent = $$MouseEvent;
exports.$$InputEvent = $$InputEvent;
exports.$$ClipboardEvent = $$ClipboardEvent;
exports.$$KeyboardEvent = $$KeyboardEvent;
exports.$$DragEvent = $$DragEvent;
exports.$$FocusEvent = $$FocusEvent;
exports.BlurEvent = BlurEvent;
exports.$$WheelEvent = $$WheelEvent;
exports.SyntheticEvent = SyntheticEvent;
exports.boundingClientRectGet = boundingClientRectGet;
exports.stringify = stringify$2; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 41639:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var _map = {
    "abort": "abort",
    "afterprint": "afterprint",
    "animationend": "animationend",
    "animationiteration": "animationiteration",
    "animationstart": "animationstart",
    "beforeprint": "beforeprint",
    "beforeunload": "beforeunload",
    "blur": "blur",
    "canplay": "canplay",
    "canplaythrough": "canplaythrough",
    "change": "change",
    "click": "click",
    "contextmenu": "contextmenu",
    "copy": "copy",
    "cut": "cut",
    "dblclick": "dblclick",
    "drag": "drag",
    "dragend": "dragend",
    "dragenter": "dragenter",
    "dragleave": "dragleave",
    "dragover": "dragover",
    "dragstart": "dragstart",
    "drop": "drop",
    "durationchange": "durationchange",
    "ended": "ended",
    "error": "error",
    "focus": "focus",
    "focusin": "focusin",
    "focusout": "focusout",
    "fullscreenchange": "fullscreenchange",
    "fullscreenerror": "fullscreenerror",
    "hashchange": "hashchange",
    "input": "input",
    "invalid": "invalid",
    "keydown": "keydown",
    "keypress": "keypress",
    "keyup": "keyup",
    "load": "load",
    "loadeddata": "loadeddata",
    "loadedmetadata": "loadedmetadata",
    "loadstart": "loadstart",
    "message": "message",
    "mousedown": "mousedown",
    "mouseenter": "mouseenter",
    "mouseleave": "mouseleave",
    "mousemove": "mousemove",
    "mouseover": "mouseover",
    "mouseout": "mouseout",
    "mouseup": "mouseup",
    "mousewheel": "mousewheel",
    "offline": "offline",
    "online": "online",
    "open_": "open",
    "pagehide": "pagehide",
    "pageshow": "pageshow",
    "paste": "paste",
    "pause": "pause",
    "play": "play",
    "playing": "playing",
    "popstate": "popstate",
    "progress": "progress",
    "ratechange": "ratechange",
    "resize": "resize",
    "reset": "reset",
    "scroll": "scroll",
    "search": "search",
    "seeked": "seeked",
    "seeking": "seeking",
    "select": "select",
    "selectionchange": "selectionchange",
    "show": "show",
    "stalled": "stalled",
    "storage": "storage",
    "submit": "submit",
    "suspend": "suspend",
    "timeupdate": "timeupdate",
    "toggle": "toggle",
    "touchcancel": "touchcancel",
    "touchend": "touchend",
    "touchmove": "touchmove",
    "touchstart": "touchstart",
    "transitionend": "transitionend",
    "unload": "unload",
    "volumechange": "volumechange",
    "waiting": "waiting",
    "wheel": "wheel"
};
var _revMap = {
    "abort": "abort",
    "afterprint": "afterprint",
    "animationend": "animationend",
    "animationiteration": "animationiteration",
    "animationstart": "animationstart",
    "beforeprint": "beforeprint",
    "beforeunload": "beforeunload",
    "blur": "blur",
    "canplay": "canplay",
    "canplaythrough": "canplaythrough",
    "change": "change",
    "click": "click",
    "contextmenu": "contextmenu",
    "copy": "copy",
    "cut": "cut",
    "dblclick": "dblclick",
    "drag": "drag",
    "dragend": "dragend",
    "dragenter": "dragenter",
    "dragleave": "dragleave",
    "dragover": "dragover",
    "dragstart": "dragstart",
    "drop": "drop",
    "durationchange": "durationchange",
    "ended": "ended",
    "error": "error",
    "focus": "focus",
    "focusin": "focusin",
    "focusout": "focusout",
    "fullscreenchange": "fullscreenchange",
    "fullscreenerror": "fullscreenerror",
    "hashchange": "hashchange",
    "input": "input",
    "invalid": "invalid",
    "keydown": "keydown",
    "keypress": "keypress",
    "keyup": "keyup",
    "load": "load",
    "loadeddata": "loadeddata",
    "loadedmetadata": "loadedmetadata",
    "loadstart": "loadstart",
    "message": "message",
    "mousedown": "mousedown",
    "mouseenter": "mouseenter",
    "mouseleave": "mouseleave",
    "mousemove": "mousemove",
    "mouseover": "mouseover",
    "mouseout": "mouseout",
    "mouseup": "mouseup",
    "mousewheel": "mousewheel",
    "offline": "offline",
    "online": "online",
    "open": "open_",
    "pagehide": "pagehide",
    "pageshow": "pageshow",
    "paste": "paste",
    "pause": "pause",
    "play": "play",
    "playing": "playing",
    "popstate": "popstate",
    "progress": "progress",
    "ratechange": "ratechange",
    "resize": "resize",
    "reset": "reset",
    "scroll": "scroll",
    "search": "search",
    "seeked": "seeked",
    "seeking": "seeking",
    "select": "select",
    "selectionchange": "selectionchange",
    "show": "show",
    "stalled": "stalled",
    "storage": "storage",
    "submit": "submit",
    "suspend": "suspend",
    "timeupdate": "timeupdate",
    "toggle": "toggle",
    "touchcancel": "touchcancel",
    "touchend": "touchend",
    "touchmove": "touchmove",
    "touchstart": "touchstart",
    "transitionend": "transitionend",
    "unload": "unload",
    "volumechange": "volumechange",
    "waiting": "waiting",
    "wheel": "wheel"
};
function tToJs(param) {
    return _map[param];
}
function tFromJs(param) {
    return _revMap[param];
}
var _map$1 = {
    "click": "click",
    "contextmenu": "contextmenu",
    "dblclick": "dblclick",
    "mousedown": "mousedown",
    "mouseenter": "mouseenter",
    "mouseleave": "mouseleave",
    "mousemove": "mousemove",
    "mouseout": "mouseout",
    "mouseover": "mouseover",
    "mouseup": "mouseup"
};
function mouseToJs(param) {
    return param;
}
function mouseFromJs(param) {
    return _map$1[param];
}
var _map$2 = {
    "keydown": "keydown",
    "keypress": "keypress",
    "keyup": "keyup"
};
function keyboardToJs(param) {
    return param;
}
function keyboardFromJs(param) {
    return _map$2[param];
}
var _map$3 = {
    "beforeinput": "beforeinput",
    "input": "input"
};
function inputToJs(param) {
    return param;
}
function inputFromJs(param) {
    return _map$3[param];
}
var _map$4 = {
    "change": "change"
};
function changeToJs(param) {
    return param;
}
function changeFromJs(param) {
    return _map$4[param];
}
var _map$5 = {
    "copy": "copy",
    "cut": "cut",
    "paste": "paste"
};
function clipboardToJs(param) {
    return param;
}
function clipboardFromJs(param) {
    return _map$5[param];
}
var _map$6 = {
    "drag": "drag",
    "dragend": "dragend",
    "dragenter": "dragenter",
    "dragleave": "dragleave",
    "dragover": "dragover",
    "dragstart": "dragstart",
    "drop": "drop"
};
function dragToJs(param) {
    return param;
}
function dragFromJs(param) {
    return _map$6[param];
}
var _map$7 = {
    "wheel": "wheel"
};
function wheelToJs(param) {
    return param;
}
function wheelFromJs(param) {
    return _map$7[param];
}
var _map$8 = {
    "focus": "focus",
    "focusin": "focusin"
};
function focusToJs(param) {
    return param;
}
function focusFromJs(param) {
    return _map$8[param];
}
var _map$9 = {
    "blur": "blur",
    "focusout": "focusout"
};
function blurToJs(param) {
    return param;
}
function blurFromJs(param) {
    return _map$9[param];
}
exports.tToJs = tToJs;
exports.tFromJs = tFromJs;
exports.mouseToJs = mouseToJs;
exports.mouseFromJs = mouseFromJs;
exports.keyboardToJs = keyboardToJs;
exports.keyboardFromJs = keyboardFromJs;
exports.inputToJs = inputToJs;
exports.inputFromJs = inputFromJs;
exports.changeToJs = changeToJs;
exports.changeFromJs = changeFromJs;
exports.clipboardToJs = clipboardToJs;
exports.clipboardFromJs = clipboardFromJs;
exports.dragToJs = dragToJs;
exports.dragFromJs = dragFromJs;
exports.wheelToJs = wheelToJs;
exports.wheelFromJs = wheelFromJs;
exports.focusToJs = focusToJs;
exports.focusFromJs = focusFromJs;
exports.blurToJs = blurToJs;
exports.blurFromJs = blurFromJs; /* No side effect */ 


/***/ }),

/***/ 2246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_option = __webpack_require__(57175);
function arrayBuffer(arrayBuffer$1) {
    return arrayBuffer$1;
}
function blob(blob$1) {
    return blob$1;
}
function string(usvString) {
    return usvString;
}
var Data = {
    arrayBuffer: arrayBuffer,
    blob: blob,
    string: string
};
function makeWithArrayBuffer(arrayBuffer1, name, type_, lastModified, param) {
    var tmp = {};
    if (type_ !== undefined) {
        tmp.type = Caml_option.valFromOption(type_);
    }
    if (lastModified !== undefined) {
        tmp.lastModified = Caml_option.valFromOption(lastModified);
    }
    return new File([
        arrayBuffer1
    ], name, tmp);
}
function makeWithBlob(blob1, name, type_, lastModified, param) {
    var tmp = {};
    if (type_ !== undefined) {
        tmp.type = Caml_option.valFromOption(type_);
    }
    if (lastModified !== undefined) {
        tmp.lastModified = Caml_option.valFromOption(lastModified);
    }
    return new File([
        blob1
    ], name, tmp);
}
function makeWithString(domString, name, type_, lastModified, param) {
    var tmp = {};
    if (type_ !== undefined) {
        tmp.type = Caml_option.valFromOption(type_);
    }
    if (lastModified !== undefined) {
        tmp.lastModified = Caml_option.valFromOption(lastModified);
    }
    return new File([
        domString
    ], name, tmp);
}
function t_encode(file) {
    return "File#name=" + file.name;
}
function t_decode(json) {
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".",
            message: "We are not suppose to decode JSON into DOME__File.t",
            value: json
        }
    };
}
exports.Data = Data;
exports.makeWithArrayBuffer = makeWithArrayBuffer;
exports.makeWithBlob = makeWithBlob;
exports.makeWithString = makeWithString;
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* No side effect */ 


/***/ }),

/***/ 40542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$String = __webpack_require__(65760);
var Caml_option = __webpack_require__(57175);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Attributes$SmartcutsMacros = __webpack_require__(92169);
var typecaseFromElement = function(x) {
    return x;
};
function ofElement(element) {
    var tagName = element.tagName.toLowerCase();
    var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
    var attributesWithLowercaseType_type_ = OptionUtils$SmartcutsMacros.map(attributes.type_, $$String.lowercase_ascii);
    var attributesWithLowercaseType_value = attributes.value;
    var attributesWithLowercaseType_name = attributes.name;
    var attributesWithLowercaseType_title = attributes.title;
    var attributesWithLowercaseType_placeholder = attributes.placeholder;
    var attributesWithLowercaseType_selected = attributes.selected;
    var attributesWithLowercaseType_contenteditable = attributes.contenteditable;
    if (tagName !== "input") {
        return;
    }
    var match = attributesWithLowercaseType_type_;
    if (match === "file") {
        return Caml_option.some(typecaseFromElement(element));
    }
}
exports.ofElement = ofElement; /* No side effect */ 


/***/ }),

/***/ 62912:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function t_encode(encoder_domHtmlElement, v) {
    return Js_dict.fromArray([
        [
            "target",
            Curry._1(encoder_domHtmlElement, v.target)
        ],
        [
            "relatedTarget",
            Decco.optionToJson(encoder_domHtmlElement, v.relatedTarget)
        ],
        [
            "timeStamp",
            Decco.floatToJson(v.timeStamp)
        ]
    ]);
}
function t_decode(decoder_domHtmlElement, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var target = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
    if (target.TAG === /* Ok */ 0) {
        var relatedTarget = Decco.optionFromJson(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "relatedTarget"), null));
        if (relatedTarget.TAG === /* Ok */ 0) {
            var timeStamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeStamp"), null));
            if (timeStamp.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        target: target._0,
                        relatedTarget: relatedTarget._0,
                        timeStamp: timeStamp._0
                    }
                };
            }
            var e = timeStamp._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".timeStamp" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = relatedTarget._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".relatedTarget" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = target._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".target" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function map(mapDomHtmlElement, item) {
    return {
        target: Curry._1(mapDomHtmlElement, item.target),
        relatedTarget: OptionUtils$SmartcutsMacros.map(item.relatedTarget, mapDomHtmlElement),
        timeStamp: item.timeStamp
    };
}
var Item = {
    t_encode: t_encode,
    t_decode: t_decode,
    map: map
};
function init(param) {
    return /* [] */ 0;
}
function update(focusEvent, trail) {
    return {
        hd: {
            target: focusEvent.target,
            relatedTarget: OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(focusEvent.relatedTarget), function(target) {
                return target;
            }),
            timeStamp: focusEvent.timeStamp
        },
        tl: trail
    };
}
function getFocusedElementJustBeforeClickEvent(withinMilliseconds, clickEvent, trail) {
    var mouseTimeStamp = clickEvent.timeStamp;
    var maybeIndex = ListUtils$SmartcutsMacros.findIndex(function(param) {
        return mouseTimeStamp - param.timeStamp > withinMilliseconds;
    }, trail);
    if (maybeIndex === undefined) {
        return;
    }
    var desiredIndex = maybeIndex - 1 | 0;
    return OptionUtils$SmartcutsMacros.andThen(function(param) {
        return param.relatedTarget;
    }, Belt_List.get(trail, desiredIndex));
}
exports.Item = Item;
exports.init = init;
exports.update = update;
exports.getFocusedElementJustBeforeClickEvent = getFocusedElementJustBeforeClickEvent; /* No side effect */ 


/***/ }),

/***/ 74457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
function stringify(_element) {
    return "domHtmlElement";
}
function ofNodeOrItsAncestor(_node) {
    while(true){
        var node = _node;
        var match = Curry._1(Webapi__Dom__HtmlElement.ofNode, node);
        var match$1 = node.parentNode;
        if (match !== undefined) {
            return Caml_option.valFromOption(match);
        }
        if (match$1 == null) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: cannot cast Node into HTMLElement and failed to locate its parent");
        }
        _node = match$1;
        continue;
    }
    ;
}
function parentHtmlElement(htmlElement) {
    var parentElement = htmlElement.parentElement;
    if (!(parentElement == null)) {
        return Webapi__Dom__HtmlElement.ofElement(parentElement);
    }
}
function isSiblingOf(e1, e2) {
    var match = e1.parentElement;
    var match$1 = e2.parentElement;
    if (!(match == null) && !(match$1 == null)) {
        return match === match$1;
    } else {
        return false;
    }
}
function t__encode(v) {
    return Js_dict.fromArray([
        [
            "hidden",
            Decco.boolToJson(v.hidden)
        ],
        [
            "isContentEditable",
            Decco.boolToJson(v.isContentEditable)
        ],
        [
            "tagName",
            Decco.stringToJson(v.tagName)
        ],
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "className",
            Decco.stringToJson(v.className)
        ]
    ]);
}
function t__decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hidden = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hidden"), null));
    if (hidden.TAG === /* Ok */ 0) {
        var isContentEditable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isContentEditable"), null));
        if (isContentEditable.TAG === /* Ok */ 0) {
            var tagName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
            if (tagName.TAG === /* Ok */ 0) {
                var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
                if (id.TAG === /* Ok */ 0) {
                    var className = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "className"), null));
                    if (className.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                hidden: hidden._0,
                                isContentEditable: isContentEditable._0,
                                tagName: tagName._0,
                                id: id._0,
                                className: className._0
                            }
                        };
                    }
                    var e = className._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".className" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = id._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".id" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = tagName._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".tagName" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = isContentEditable._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".isContentEditable" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = hidden._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hidden" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function fromDomHtmlElement(htmlElement) {
    return {
        hidden: htmlElement.hidden,
        isContentEditable: htmlElement.isContentEditable,
        tagName: htmlElement.tagName,
        id: htmlElement.id,
        className: htmlElement.className
    };
}
function stringify$1(element) {
    return JSON.stringify(t__encode(element));
}
var ForSerialization = {
    t__encode: t__encode,
    t__decode: t__decode,
    fromDomHtmlElement: fromDomHtmlElement,
    stringify: stringify$1
};
function isNotVisibleOnPage(element) {
    var domRect = element.getBoundingClientRect();
    if (domRect.height <= 1.0) {
        return true;
    } else {
        return domRect.width <= 1.0;
    }
}
function isVisibleOnPage(element) {
    return !isNotVisibleOnPage(element);
}
exports.stringify = stringify;
exports.ofNodeOrItsAncestor = ofNodeOrItsAncestor;
exports.parentHtmlElement = parentHtmlElement;
exports.isSiblingOf = isSiblingOf;
exports.ForSerialization = ForSerialization;
exports.isNotVisibleOnPage = isNotVisibleOnPage;
exports.isVisibleOnPage = isVisibleOnPage; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 73466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Option = __webpack_require__(46517);
var Caml_format = __webpack_require__(63979);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom = __webpack_require__(89948);
var Webapi__Dom__Node = __webpack_require__(98727);
var Caml_js_exceptions = __webpack_require__(74518);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function stringify(_node) {
    return "domNode";
}
function whenContentEditable(f, node) {
    var htmlElement = Curry._1(Webapi__Dom__HtmlElement.ofNode, node);
    if (htmlElement !== undefined && Caml_option.valFromOption(htmlElement).isContentEditable) {
        return Curry._1(f, node);
    }
}
function isNodeOrItsAncestorDetached(node) {
    var _node = node;
    while(true){
        var node$1 = _node;
        var match = Webapi__Dom__Node.nodeType(node$1);
        if (match === 8) {
            return false;
        }
        var parent = node$1.parentNode;
        if (parent == null) {
            return true;
        }
        _node = parent;
        continue;
    }
    ;
}
function nodeType_encode(nodeType) {
    var tmp;
    switch(nodeType){
        case /* Element */ 0:
            tmp = 1;
            break;
        case /* Attribute */ 1:
            tmp = 2;
            break;
        case /* Text */ 2:
            tmp = 3;
            break;
        case /* CDATASection */ 3:
            tmp = 4;
            break;
        case /* EntityReference */ 4:
            tmp = 5;
            break;
        case /* Entity */ 5:
            tmp = 6;
            break;
        case /* ProcessingInstruction */ 6:
            tmp = 7;
            break;
        case /* Comment */ 7:
            tmp = 8;
            break;
        case /* Document */ 8:
            tmp = 9;
            break;
        case /* DocumentType */ 9:
            tmp = 10;
            break;
        case /* DocumentFragment */ 10:
            tmp = 11;
            break;
        case /* Notation */ 11:
            tmp = 12;
            break;
        case /* Unknown */ 12:
            tmp = -1;
            break;
    }
    return String(tmp);
}
function nodeType_decode(encoded) {
    var strInt = Js_json.decodeString(encoded);
    if (strInt !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: Webapi__Dom.decodeNodeType(Caml_format.caml_int_of_string(strInt))
        };
    } else {
        return Decco.error(undefined, "Couldn't decode json into DOM.Node.nodeType", encoded);
    }
}
function t__encode(v) {
    return Js_dict.fromArray([
        [
            "nodeName",
            Decco.stringToJson(v.nodeName)
        ],
        [
            "nodeValue",
            Decco.optionToJson(Decco.stringToJson, v.nodeValue)
        ],
        [
            "nodeType",
            nodeType_encode(v.nodeType)
        ]
    ]);
}
function t__decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var nodeName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeName"), null));
    if (nodeName.TAG === /* Ok */ 0) {
        var nodeValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeValue"), null));
        if (nodeValue.TAG === /* Ok */ 0) {
            var nodeType = nodeType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeType"), null));
            if (nodeType.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        nodeName: nodeName._0,
                        nodeValue: nodeValue._0,
                        nodeType: nodeType._0
                    }
                };
            }
            var e = nodeType._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".nodeType" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = nodeValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".nodeValue" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = nodeName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".nodeName" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromDomNode(node) {
    return {
        nodeName: node.nodeName,
        nodeValue: Caml_option.nullable_to_opt(node.nodeValue),
        nodeType: Webapi__Dom__Node.nodeType(node)
    };
}
function stringify$1(node) {
    return JSON.stringify(t__encode(node));
}
var ForSerialization = {
    nodeType_encode: nodeType_encode,
    nodeType_decode: nodeType_decode,
    t__encode: t__encode,
    t__decode: t__decode,
    fromDomNode: fromDomNode,
    stringify: stringify$1
};
function contains(_nodeA, _nodeB) {
    while(true){
        var nodeB = _nodeB;
        var nodeA = _nodeA;
        var exit = 0;
        var rootNodeA;
        try {
            rootNodeA = nodeA.getRootNode();
            exit = 1;
        } catch (raw_obj) {
            var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
            if (obj.RE_EXN_ID === Js_exn.$$Error) {
                if (Caml_obj.caml_equal(obj._1.message, "Cannot read properties of undefined (reading 'getRootNode')")) {
                    return false;
                }
                throw obj;
            }
            throw obj;
        }
        if (exit === 1) {
            var exit$1 = 0;
            var rootNodeB;
            try {
                rootNodeB = nodeB.getRootNode();
                exit$1 = 2;
            } catch (raw_obj$1) {
                var obj$1 = Caml_js_exceptions.internalToOCamlException(raw_obj$1);
                if (obj$1.RE_EXN_ID === Js_exn.$$Error) {
                    if (Caml_obj.caml_equal(obj$1._1.message, "Cannot read properties of undefined (reading 'getRootNode')")) {
                        return false;
                    }
                    throw obj$1;
                }
                throw obj$1;
            }
            if (exit$1 === 2) {
                var match = Webapi__Dom__Node.nodeType(rootNodeA);
                var match$1 = Webapi__Dom__Node.nodeType(rootNodeB);
                var exit$2 = 0;
                var exit$3 = 0;
                if (match >= 11) {
                    exit$3 = 4;
                } else {
                    switch(match){
                        case /* Element */ 0:
                            return false;
                        case /* Document */ 8:
                            if (match$1 >= 11) {
                                exit$2 = 3;
                            } else {
                                switch(match$1){
                                    case /* Element */ 0:
                                        exit$3 = 4;
                                        break;
                                    case /* Document */ 8:
                                        return nodeA.contains(nodeB);
                                    case /* Attribute */ 1:
                                    case /* Text */ 2:
                                    case /* CDATASection */ 3:
                                    case /* EntityReference */ 4:
                                    case /* Entity */ 5:
                                    case /* ProcessingInstruction */ 6:
                                    case /* Comment */ 7:
                                    case /* DocumentType */ 9:
                                        exit$2 = 3;
                                        break;
                                    case /* DocumentFragment */ 10:
                                        _nodeB = rootNodeB.host;
                                        continue;
                                }
                            }
                            break;
                        case /* Attribute */ 1:
                        case /* Text */ 2:
                        case /* CDATASection */ 3:
                        case /* EntityReference */ 4:
                        case /* Entity */ 5:
                        case /* ProcessingInstruction */ 6:
                        case /* Comment */ 7:
                        case /* DocumentType */ 9:
                            exit$3 = 4;
                            break;
                        case /* DocumentFragment */ 10:
                            if (match$1 >= 11) {
                                exit$2 = 3;
                            } else {
                                switch(match$1){
                                    case /* Element */ 0:
                                        exit$3 = 4;
                                        break;
                                    case /* Document */ 8:
                                        _nodeA = rootNodeA.host;
                                        continue;
                                    case /* Attribute */ 1:
                                    case /* Text */ 2:
                                    case /* CDATASection */ 3:
                                    case /* EntityReference */ 4:
                                    case /* Entity */ 5:
                                    case /* ProcessingInstruction */ 6:
                                    case /* Comment */ 7:
                                    case /* DocumentType */ 9:
                                        exit$2 = 3;
                                        break;
                                    case /* DocumentFragment */ 10:
                                        if (rootNodeA === rootNodeB) {
                                            return nodeA.contains(nodeB);
                                        }
                                        _nodeB = rootNodeB.host;
                                        continue;
                                }
                            }
                            break;
                    }
                }
                if (exit$3 === 4) {
                    if (match$1 === 0) {
                        return false;
                    }
                    exit$2 = 3;
                }
                if (exit$2 === 3) {
                    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid nodeType combo (" + (JSON.stringify(nodeType_encode(match)) + (", " + (JSON.stringify(nodeType_encode(match$1)) + ")"))));
                }
            }
        }
    }
    ;
}
function hasParent(node) {
    var match = Webapi__Dom__Node.nodeType(node);
    return (match !== 10 ? Caml_option.nullable_to_opt(node.parentNode) : Caml_option.some(node.host)) !== undefined;
}
function getDepthRelativeToBody(node) {
    var currNode = node;
    var depth = 0;
    while(hasParent(currNode) && !StringUtils$SmartcutsMacros.isAnyOf(currNode.nodeName, [
        "#document",
        "HTML",
        "html"
    ])){
        depth = depth + 1 | 0;
        var match = Webapi__Dom__Node.nodeType(currNode);
        if (match !== 10) {
            var arg = currNode.parentNode;
            var arg$11 = arg == null ? undefined : Caml_option.some(arg);
            currNode = (function(arg$1) {
                return function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                };
            })(arg$11)("Expected parent node");
        } else {
            currNode = currNode.host;
        }
    }
    ;
    return depth;
}
exports.stringify = stringify;
exports.whenContentEditable = whenContentEditable;
exports.isNodeOrItsAncestorDetached = isNodeOrItsAncestorDetached;
exports.ForSerialization = ForSerialization;
exports.contains = contains;
exports.hasParent = hasParent;
exports.getDepthRelativeToBody = getDepthRelativeToBody; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 2497:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var $$String = __webpack_require__(65760);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Element = __webpack_require__(33116);
var Webapi__Dom__Document = __webpack_require__(8416);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function maybeShadowRoot(el) {
    return Caml_option.nullable_to_opt(el.shadowRoot);
}
function isCustomWebComponentTagName(tagName) {
    return $$String.contains(tagName, /* '-' */ 45);
}
function isNodeNameDocumentFragment(nodeName) {
    return nodeName === "#document-fragment";
}
function isCustomWebComponent(element) {
    return $$String.contains(element.tagName, /* '-' */ 45);
}
function elementGet(v) {
    return v._0;
}
var ComposedPathNode = {
    elementGet: elementGet
};
function getComposedPath($$event) {
    var nativeComposedPath = $$event.composedPath();
    return Belt_Array.reduce(nativeComposedPath, [
        [],
        false
    ], function(param, eventTarget) {
        var transformedComposedPath = param[0];
        if (eventTarget === window) {
            return [
                transformedComposedPath,
                false
            ];
        }
        var match = Webapi__Dom__Node.nodeType(eventTarget);
        if (match >= 11) {
            return [
                transformedComposedPath,
                false
            ];
        }
        switch(match){
            case /* Element */ 0:
            case /* Text */ 2:
                break;
            case /* Attribute */ 1:
            case /* CDATASection */ 3:
            case /* EntityReference */ 4:
            case /* Entity */ 5:
            case /* ProcessingInstruction */ 6:
            case /* Comment */ 7:
            case /* Document */ 8:
            case /* DocumentType */ 9:
                return [
                    transformedComposedPath,
                    false
                ];
            case /* DocumentFragment */ 10:
                return [
                    transformedComposedPath,
                    true
                ];
        }
        var nextTransformedComposedPath = $$Array.append(transformedComposedPath, [
            param[1] ? {
                TAG: /* ShadowRoot */ 0,
                _0: eventTarget
            } : {
                TAG: /* Element */ 1,
                _0: eventTarget
            }
        ]);
        return [
            nextTransformedComposedPath,
            false
        ];
    })[0];
}
function getTargetFromEvent($$event) {
    var immediateTargetElement = $$event.target;
    if (!$$String.contains(immediateTargetElement.tagName, /* '-' */ 45)) {
        return immediateTargetElement;
    }
    var composedPath = getComposedPath($$event);
    return Caml_array.get(composedPath, 0)._0;
}
function getActiveElementForDocument(param1) {
    var arg1 = Webapi__Dom__Document.asHtmlDocument(document);
    return Belt_Option.map(function(param) {
        return OptionUtils$SmartcutsMacros.andThen(param, arg1);
    }(function(prim) {
        return Caml_option.nullable_to_opt(prim.activeElement);
    }), function(activeElement) {
        if (!$$String.contains(activeElement.tagName, /* '-' */ 45)) {
            return activeElement;
        }
        console.warn("activeElement", activeElement);
        var arg = Belt_Option.flatMap(Caml_option.nullable_to_opt(activeElement.shadowRoot), function(prim) {
            return prim.activeElement;
        });
        return OptionUtils$SmartcutsMacros.withDefault(activeElement, arg);
    });
}
function getActiveHtmlElementForDocument(param) {
    return OptionUtils$SmartcutsMacros.andThen(Webapi__Dom__Element.asHtmlElement, getActiveElementForDocument(undefined));
}
exports.maybeShadowRoot = maybeShadowRoot;
exports.isCustomWebComponentTagName = isCustomWebComponentTagName;
exports.isNodeNameDocumentFragment = isNodeNameDocumentFragment;
exports.isCustomWebComponent = isCustomWebComponent;
exports.ComposedPathNode = ComposedPathNode;
exports.getComposedPath = getComposedPath;
exports.getTargetFromEvent = getTargetFromEvent;
exports.getActiveElementForDocument = getActiveElementForDocument;
exports.getActiveHtmlElementForDocument = getActiveHtmlElementForDocument; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 35071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_int32 = __webpack_require__(48723);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var RandomCss$SmartcutsMacros = __webpack_require__(48206);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function nodeAttributesForPattern(node) {
    return ArrayUtils$SmartcutsMacros.filterMap(function(param) {
        var key = param[0];
        switch(key){
            case "href":
            case "style":
                return;
            default:
                if (key.startsWith("data-") || key.startsWith("aria-")) {
                    return;
                } else {
                    return key;
                }
        }
    }, node.attributes);
}
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "UnknownPattern"
        ];
    } else if (v.TAG === /* SampleSizeOne */ 0) {
        return [
            "SampleSizeOne",
            Decco.optionToJson(Decco.intToJson, v._0)
        ];
    } else {
        return [
            "NPlusK",
            Decco.intToJson(v._0),
            Decco.intToJson(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NPlusK":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NPlusK */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SampleSizeOne":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.optionFromJson(Decco.intFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SampleSizeOne */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "UnknownPattern":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UnknownPattern */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function initWithTwoIndexes(maybeIndex1, maybeIndex2) {
    if (maybeIndex1 !== undefined) {
        if (maybeIndex2 !== undefined && maybeIndex1 !== maybeIndex2) {
            if (maybeIndex1 < maybeIndex2) {
                return {
                    TAG: /* NPlusK */ 1,
                    _0: maybeIndex2 - maybeIndex1 | 0,
                    _1: maybeIndex1
                };
            } else {
                return {
                    TAG: /* NPlusK */ 1,
                    _0: maybeIndex1 - maybeIndex2 | 0,
                    _1: maybeIndex2
                };
            }
        } else {
            return {
                TAG: /* SampleSizeOne */ 0,
                _0: maybeIndex1
            };
        }
    } else if (maybeIndex2 !== undefined) {
        return {
            TAG: /* SampleSizeOne */ 0,
            _0: maybeIndex2
        };
    } else {
        return {
            TAG: /* SampleSizeOne */ 0,
            _0: undefined
        };
    }
}
function updateWithAdditionalSiblingIndex(maybeIndex, pattern) {
    if (typeof pattern === "number") {
        return /* UnknownPattern */ 0;
    }
    if (pattern.TAG !== /* SampleSizeOne */ 0) {
        if (maybeIndex !== undefined && Caml_int32.mod_(maybeIndex - pattern._1 | 0, pattern._0) === 0) {
            return pattern;
        } else {
            return /* UnknownPattern */ 0;
        }
    }
    var index = pattern._0;
    if (index !== undefined) {
        if (maybeIndex !== undefined) {
            if (index === maybeIndex) {
                return {
                    TAG: /* SampleSizeOne */ 0,
                    _0: index
                };
            } else if (index < maybeIndex) {
                return {
                    TAG: /* NPlusK */ 1,
                    _0: maybeIndex - index | 0,
                    _1: index
                };
            } else {
                return {
                    TAG: /* NPlusK */ 1,
                    _0: index - maybeIndex | 0,
                    _1: maybeIndex
                };
            }
        } else {
            return /* UnknownPattern */ 0;
        }
    } else if (maybeIndex !== undefined) {
        return {
            TAG: /* SampleSizeOne */ 0,
            _0: maybeIndex
        };
    } else {
        return pattern;
    }
}
function merge(pattern_1, pattern_2) {
    if (typeof pattern_1 === "number") {
        return /* UnknownPattern */ 0;
    }
    if (pattern_1.TAG !== /* SampleSizeOne */ 0 && typeof pattern_2 !== "number" && pattern_2.TAG !== /* SampleSizeOne */ 0) {
        return /* UnknownPattern */ 0;
    }
    if (typeof pattern_2 === "number") {
        return /* UnknownPattern */ 0;
    } else if (pattern_2.TAG === /* SampleSizeOne */ 0) {
        return updateWithAdditionalSiblingIndex(pattern_2._0, pattern_1);
    } else {
        return updateWithAdditionalSiblingIndex(pattern_1._0, pattern_2);
    }
}
var NthChildPattern = {
    t_encode: t_encode,
    t_decode: t_decode,
    initWithTwoIndexes: initWithTwoIndexes,
    updateWithAdditionalSiblingIndex: updateWithAdditionalSiblingIndex,
    merge: merge
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "tagName",
            Decco.optionToJson(Decco.stringToJson, v.tagName)
        ],
        [
            "classNames",
            Decco.arrayToJson(Decco.stringToJson, v.classNames)
        ],
        [
            "attributes",
            Decco.arrayToJson(Decco.stringToJson, v.attributes)
        ],
        [
            "nthChildPattern",
            t_encode(v.nthChildPattern)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
    if (tagName.TAG === /* Ok */ 0) {
        var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
        if (classNames.TAG === /* Ok */ 0) {
            var attributes = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
            if (attributes.TAG === /* Ok */ 0) {
                var nthChildPattern = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthChildPattern"), null));
                if (nthChildPattern.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            tagName: tagName._0,
                            classNames: classNames._0,
                            attributes: attributes._0,
                            nthChildPattern: nthChildPattern._0
                        }
                    };
                }
                var e = nthChildPattern._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".nthChildPattern" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = attributes._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".attributes" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = classNames._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".classNames" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = tagName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tagName" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function fromNode(node) {
    return {
        tagName: node.tagName,
        classNames: node.classNames,
        attributes: nodeAttributesForPattern(node),
        nthChildPattern: {
            TAG: /* SampleSizeOne */ 0,
            _0: node.index
        }
    };
}
function isEqualDuringProcessing(looseMatch_1, looseMatch_2) {
    if (Caml_obj.caml_equal(looseMatch_1.tagName, looseMatch_2.tagName) && Caml_obj.caml_equal(looseMatch_1.classNames, looseMatch_2.classNames)) {
        return Caml_obj.caml_equal(looseMatch_1.attributes, looseMatch_2.attributes);
    } else {
        return false;
    }
}
function mergeIdenticalLooseMatchesToUpdateNthChildPattern(looseMatch_1, param) {
    return {
        tagName: looseMatch_1.tagName,
        classNames: looseMatch_1.classNames,
        attributes: looseMatch_1.attributes,
        nthChildPattern: merge(looseMatch_1.nthChildPattern, param.nthChildPattern)
    };
}
function toCssSelector(exampleSelectorNode, param1) {
    var nthChildPattern = param1.nthChildPattern;
    var tmp;
    if (typeof nthChildPattern === "number") {
        tmp = "";
    } else if (nthChildPattern.TAG === /* SampleSizeOne */ 0) {
        var n = nthChildPattern._0;
        tmp = n !== undefined ? ":nth-child(" + (String(n) + ")") : "";
    } else {
        tmp = ":nth-child(" + (String(nthChildPattern._0) + ("n+" + (String(nthChildPattern._1) + ")")));
    }
    return OptionUtils$SmartcutsMacros.withDefault("*", param1.tagName) + (Belt_Array.map(param1.classNames, function(className) {
        return "." + window.CSS.escape(className);
    }).join("") + (Belt_Array.map(param1.attributes, function(attrName) {
        var arg = Belt_Option.map(Belt_Array.getBy(exampleSelectorNode.attributes, function(param) {
            return param[0] === attrName;
        }), function(param) {
            var attrVal = param[1];
            if (attrVal.trim() === "") {
                return "";
            } else {
                return "=" + window.CSS.escape(attrVal);
            }
        });
        return "[" + (window.CSS.escape(attrName) + (function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("") + "]"));
    }).join("") + tmp));
}
function toSelectorTreeNode(exampleSelectorNode, param2) {
    var attributes = param2.attributes;
    return {
        id: undefined,
        tagName: param2.tagName,
        classNames: param2.classNames,
        attributes: Belt_Array.keep(exampleSelectorNode.attributes, function(param) {
            return $$Array.mem(param[0], attributes);
        }),
        index: undefined,
        innerText: /* Ignored */ 0,
        isScrollable: undefined,
        attributeBlacklist: []
    };
}
var LooseMatch = {
    NthChildPattern: NthChildPattern,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromNode: fromNode,
    isEqualDuringProcessing: isEqualDuringProcessing,
    mergeIdenticalLooseMatchesToUpdateNthChildPattern: mergeIdenticalLooseMatchesToUpdateNthChildPattern,
    toCssSelector: toCssSelector,
    toSelectorTreeNode: toSelectorTreeNode
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.optionToJson(Decco.stringToJson, v.id)
        ],
        [
            "tagName",
            Decco.optionToJson(Decco.stringToJson, v.tagName)
        ],
        [
            "classNames",
            Decco.arrayToJson(Decco.stringToJson, v.classNames)
        ],
        [
            "attributes",
            Decco.arrayToJson(Decco.stringToJson, v.attributes)
        ],
        [
            "index",
            Decco.optionToJson(Decco.intToJson, v.index)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
        if (tagName.TAG === /* Ok */ 0) {
            var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
            if (classNames.TAG === /* Ok */ 0) {
                var attributes = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
                if (attributes.TAG === /* Ok */ 0) {
                    var index = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
                    if (index.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                id: id._0,
                                tagName: tagName._0,
                                classNames: classNames._0,
                                attributes: attributes._0,
                                index: index._0
                            }
                        };
                    }
                    var e = index._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".index" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = attributes._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".attributes" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = classNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".classNames" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = tagName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tagName" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function fromNode$1(node) {
    return {
        id: OptionUtils$SmartcutsMacros.andThen(function(id) {
            if (RandomCss$SmartcutsMacros.isGeneratedId(id)) {
                return;
            } else {
                return id;
            }
        }, node.id),
        tagName: node.tagName,
        classNames: node.classNames,
        attributes: nodeAttributesForPattern(node),
        index: node.index
    };
}
function fromElement(element) {
    var partial_arg = window.location.origin;
    var arg = ListUtils$SmartcutsMacros.last(Belt_List.map(Selector$SmartcutsMacros.forDomElement(element), function(param) {
        return Selector$SmartcutsMacros.pruneSelectorTreeNodeUsingOriginBlacklist(partial_arg, param);
    }));
    return fromNode$1(function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect non-empty selector"));
}
function doesMatchLooseMatch(looseMatch, exactMatch) {
    if (Caml_obj.caml_equal(looseMatch.tagName, exactMatch.tagName) && Caml_obj.caml_equal(looseMatch.classNames, exactMatch.classNames)) {
        return Caml_obj.caml_equal(looseMatch.attributes, exactMatch.attributes);
    } else {
        return false;
    }
}
function doesMatchElement(element, indexBufferOpt, exactMatch) {
    var indexBuffer = indexBufferOpt !== undefined ? indexBufferOpt : 0;
    var exactMatch_2 = fromElement(element);
    var isEquivalentToExactMatch = Caml_obj.caml_equal(exactMatch, exactMatch_2);
    if (isEquivalentToExactMatch) {
        return isEquivalentToExactMatch;
    }
    var match = exactMatch.index;
    var match$1 = exactMatch_2.index;
    if (match !== undefined && match$1 !== undefined) {
        if (Math.abs(match - match$1 | 0) <= indexBuffer && Caml_obj.caml_equal({
            id: exactMatch.id,
            tagName: exactMatch.tagName,
            classNames: exactMatch.classNames,
            attributes: exactMatch.attributes,
            index: undefined
        }, {
            id: exactMatch_2.id,
            tagName: exactMatch_2.tagName,
            classNames: exactMatch_2.classNames,
            attributes: exactMatch_2.attributes,
            index: undefined
        })) {
            return true;
        } else {
            return false;
        }
    } else {
        return isEquivalentToExactMatch;
    }
}
function maybeLooseMatchWhenPairedWithExactMatch(exactMatch_2, exactMatch) {
    var match = exactMatch.tagName;
    var match$1 = exactMatch_2.tagName;
    if (match !== undefined && match === "a" && match$1 === "a") {
        return;
    }
    if (Caml_obj.caml_equal(exactMatch.tagName, exactMatch_2.tagName) && Caml_obj.caml_equal(exactMatch.classNames, exactMatch_2.classNames) && Caml_obj.caml_equal(exactMatch.attributes, exactMatch_2.attributes) && !(Caml_obj.caml_equal(exactMatch.id, exactMatch_2.id) && Caml_obj.caml_equal(exactMatch.index, exactMatch_2.index))) {
        return {
            tagName: exactMatch.tagName,
            classNames: exactMatch.classNames,
            attributes: exactMatch.attributes,
            nthChildPattern: initWithTwoIndexes(exactMatch.index, exactMatch_2.index)
        };
    }
}
function couldBeLooseMatchWithNode(node, exactMatchPattern) {
    var match = exactMatchPattern.tagName;
    var match$1 = node.tagName;
    if (match !== undefined && match === "a" && match$1 === "a") {
        return false;
    }
    if (Caml_obj.caml_equal(exactMatchPattern.tagName, node.tagName) && Caml_obj.caml_equal(exactMatchPattern.classNames, node.classNames) && $$Array.for_all(function(key) {
        return $$Array.exists(function(param) {
            return key === param[0];
        }, node.attributes);
    }, exactMatchPattern.attributes)) {
        return !(Caml_obj.caml_equal(exactMatchPattern.id, node.id) && Caml_obj.caml_equal(exactMatchPattern.index, node.index));
    } else {
        return false;
    }
}
function toCssSelector$1(exampleSelectorNode, param3) {
    var arg1 = OptionUtils$SmartcutsMacros.map(param3.id, function(s) {
        return "#" + window.CSS.escape(s);
    });
    var arg$1 = OptionUtils$SmartcutsMacros.map(param3.index, function(i) {
        return ":nth-child(" + (String(i) + ")");
    });
    return OptionUtils$SmartcutsMacros.withDefault("*", param3.tagName) + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg1);
    }("") + (Belt_Array.map(param3.classNames, function(className) {
        return "." + window.CSS.escape(className);
    }).join("") + (Belt_Array.map(param3.attributes, function(attrName) {
        var arg = Belt_Option.map(Belt_Array.getBy(exampleSelectorNode.attributes, function(param) {
            return param[0] === attrName;
        }), function(param) {
            var attrVal = param[1];
            if (attrVal.trim() === "") {
                return "";
            } else {
                return "=" + StringUtils$SmartcutsMacros.quote(window.CSS.escape(attrVal));
            }
        });
        return "[" + (window.CSS.escape(attrName) + (function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("") + "]"));
    }).join("") + function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }(""))));
}
function toSelectorTreeNode$1(exampleSelectorNode, param4) {
    var attributes = param4.attributes;
    return {
        id: param4.id,
        tagName: param4.tagName,
        classNames: param4.classNames,
        attributes: Belt_Array.keep(exampleSelectorNode.attributes, function(param) {
            return $$Array.mem(param[0], attributes);
        }),
        index: param4.index,
        innerText: /* Ignored */ 0,
        isScrollable: undefined,
        attributeBlacklist: []
    };
}
var ExactMatch = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromNode: fromNode$1,
    fromElement: fromElement,
    doesMatchLooseMatch: doesMatchLooseMatch,
    doesMatchElement: doesMatchElement,
    maybeLooseMatchWhenPairedWithExactMatch: maybeLooseMatchWhenPairedWithExactMatch,
    couldBeLooseMatchWithNode: couldBeLooseMatchWithNode,
    toCssSelector: toCssSelector$1,
    toSelectorTreeNode: toSelectorTreeNode$1
};
function t_encode$3(v) {
    if (v.TAG === /* ExactMatch */ 0) {
        return [
            "ExactMatch",
            t_encode$2(v._0)
        ];
    } else {
        return [
            "LooseMatch",
            t_encode$1(v._0)
        ];
    }
}
function t_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExactMatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExactMatch */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "LooseMatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LooseMatch */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function exactMatchFromNode(node) {
    return {
        TAG: /* ExactMatch */ 0,
        _0: fromNode$1(node)
    };
}
function looseMatchFromNode(node) {
    return {
        TAG: /* LooseMatch */ 1,
        _0: fromNode(node)
    };
}
function compareNodeAttributes(node_1, node_2) {
    var match = node_1.tagName;
    var match$1 = node_2.tagName;
    if (match !== undefined && match === "a" && match$1 === "a") {
        return Caml_obj.caml_equal(Belt_Array.keep(node_1.attributes, function(param) {
            return param[0] !== "href";
        }), Belt_Array.keep(node_2.attributes, function(param) {
            return param[0] !== "href";
        }));
    }
    return Caml_obj.caml_equal(node_1.attributes, node_2.attributes);
}
function maybeFromPairOfSelectorTreeNodes(node_1, node_2) {
    var match = node_1.tagName;
    var match$1 = node_2.tagName;
    if (match !== undefined && match$1 !== undefined && match === match$1 && Caml_obj.caml_equal(node_1.classNames, node_2.classNames) && compareNodeAttributes(node_1, node_2)) {
        if (Caml_obj.caml_equal(node_1.id, node_2.id) && Caml_obj.caml_equal(node_1.index, node_2.index)) {
            return {
                TAG: /* One */ 0,
                _0: {
                    TAG: /* ExactMatch */ 0,
                    _0: fromNode$1(node_1)
                }
            };
        } else if (match === "a" && match$1 === "a") {
            return {
                TAG: /* Two */ 1,
                _0: {
                    TAG: /* ExactMatch */ 0,
                    _0: fromNode$1(node_1)
                },
                _1: {
                    TAG: /* ExactMatch */ 0,
                    _0: fromNode$1(node_2)
                }
            };
        } else {
            return {
                TAG: /* One */ 0,
                _0: {
                    TAG: /* LooseMatch */ 1,
                    _0: fromNode(node_1)
                }
            };
        }
    } else {
        return {
            TAG: /* Two */ 1,
            _0: {
                TAG: /* ExactMatch */ 0,
                _0: fromNode$1(node_1)
            },
            _1: {
                TAG: /* ExactMatch */ 0,
                _0: fromNode$1(node_2)
            }
        };
    }
}
function isLooseMatch(treeNodePattern) {
    if (treeNodePattern.TAG === /* ExactMatch */ 0) {
        return false;
    } else {
        return true;
    }
}
function exactMatchGet(treeNodePattern) {
    if (treeNodePattern.TAG === /* ExactMatch */ 0) {
        return treeNodePattern._0;
    }
}
var TreeNodePattern = {
    nodeAttributesForPattern: nodeAttributesForPattern,
    LooseMatch: LooseMatch,
    ExactMatch: ExactMatch,
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    exactMatchFromNode: exactMatchFromNode,
    looseMatchFromNode: looseMatchFromNode,
    compareNodeAttributes: compareNodeAttributes,
    maybeFromPairOfSelectorTreeNodes: maybeFromPairOfSelectorTreeNodes,
    isLooseMatch: isLooseMatch,
    exactMatchGet: exactMatchGet
};
function t_encode$4(v) {
    return Decco.listToJson(t_encode$3, v);
}
function t_decode$4(v) {
    return Decco.listFromJson(t_decode$3, v);
}
function doesMatchElement$1(indexBufferOpt, element, pattern) {
    var indexBuffer = indexBufferOpt !== undefined ? indexBufferOpt : 0;
    var _element = element;
    var _index = 0;
    while(true){
        var index = _index;
        var element$1 = _element;
        var match = Belt_List.get(pattern, index);
        var doesMatchThisLevel = match !== undefined ? match.TAG === /* ExactMatch */ 0 ? doesMatchElement(element$1, indexBuffer, match._0) : doesMatchLooseMatch(match._0, fromElement(element$1)) : true;
        var parentElement = element$1.parentElement;
        if (parentElement == null) {
            return doesMatchThisLevel;
        }
        if (!doesMatchThisLevel) {
            return doesMatchThisLevel;
        }
        _index = index + 1 | 0;
        _element = parentElement;
        continue;
    }
    ;
}
function truncateToTopMostRepeatingElement(pattern) {
    var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
    var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
    var arg = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, function(i) {
        return i + 1 | 0;
    });
    var lengthToSlice = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(treeNodePatternsFromRootToLeaf.length);
    return $$Array.to_list(Belt_Array.reverse(Belt_Array.slice(treeNodePatternsFromRootToLeaf, 0, lengthToSlice)));
}
function getSelectorToParentOfFirstLooseMatch(selectorOfAMemberElement, pattern) {
    var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
    var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
    var arg2 = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, function(index) {
        var arg = Belt_List.take(selectorOfAMemberElement, index);
        var param = "Expected selector to have length >= " + String(index);
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    });
    return OptionUtils$SmartcutsMacros.withDefault(selectorOfAMemberElement, arg2);
}
function keepOnlyFirstContiguousExactMatches(pattern) {
    var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
    var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
    var arg = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, function(index) {
        return Belt_Array.slice(treeNodePatternsFromRootToLeaf, 0, index);
    });
    return $$Array.to_list(function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(treeNodePatternsFromRootToLeaf));
}
function updateFirstTreeNodePattern(f, selectorPattern) {
    return ListUtils$SmartcutsMacros.updateAt(0, f, selectorPattern);
}
var SelectorPattern = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    empty: /* [] */ 0,
    toPrintable: $$Array.of_list,
    doesMatchElement: doesMatchElement$1,
    truncateToTopMostRepeatingElement: truncateToTopMostRepeatingElement,
    getSelectorToParentOfFirstLooseMatch: getSelectorToParentOfFirstLooseMatch,
    keepOnlyFirstContiguousExactMatches: keepOnlyFirstContiguousExactMatches,
    updateFirstTreeNodePattern: updateFirstTreeNodePattern
};
function mapPattern(f, param) {
    return [
        Curry._1(f, param[0]),
        param[1]
    ];
}
function truncatePatternToTopMostRepeatingElement(group1) {
    return mapPattern(truncateToTopMostRepeatingElement, group1);
}
function toCssSelector$2(param) {
    var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(param[0]));
    var exampleSelector = Caml_array.get(param[1], 0)[1];
    return Belt_Array.mapWithIndex(treeNodePatternsFromRootToLeaf, function(treeLevel, treeNodePattern) {
        var exampleSelectorNode = Belt_List.getExn(exampleSelector, treeLevel);
        if (treeNodePattern.TAG === /* ExactMatch */ 0) {
            return toCssSelector$1(exampleSelectorNode, treeNodePattern._0);
        } else {
            return toCssSelector(exampleSelectorNode, treeNodePattern._0);
        }
    }).join(" > ");
}
function toSelector(param) {
    var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(param[0]));
    var exampleSelector = Caml_array.get(param[1], 0)[1];
    return $$Array.to_list(Belt_Array.mapWithIndex(treeNodePatternsFromRootToLeaf, function(treeLevel, treeNodePattern) {
        var exampleSelectorNode = Belt_List.getExn(exampleSelector, treeLevel);
        if (treeNodePattern.TAG === /* ExactMatch */ 0) {
            return toSelectorTreeNode$1(exampleSelectorNode, treeNodePattern._0);
        } else {
            return toSelectorTreeNode(exampleSelectorNode, treeNodePattern._0);
        }
    }));
}
var TopologyGroup = {
    mapPattern: mapPattern,
    truncatePatternToTopMostRepeatingElement: truncatePatternToTopMostRepeatingElement,
    toCssSelector: toCssSelector$2,
    toSelector: toSelector
};
function getFirstGroup(grouper) {
    return Belt_Array.get(grouper, 0);
}
function toPrintable(grouper) {
    return $$Array.map(function(param5) {
        return [
            $$Array.of_list(param5[0]),
            $$Array.map(function(param) {
                return [
                    param[0],
                    $$Array.of_list(param[1])
                ];
            }, param5[1])
        ];
    }, grouper);
}
var empty = [];
function make(origin, elements) {
    var elementSelectorPairs = $$Array.map(function(element) {
        return [
            element,
            Belt_List.map(Selector$SmartcutsMacros.forDomElement(element), function(param) {
                return Selector$SmartcutsMacros.pruneSelectorTreeNodeUsingOriginBlacklist(origin, param);
            })
        ];
    }, elements);
    return [
        [
            /* [] */ 0,
            elementSelectorPairs
        ]
    ];
}
function stillNeedsProcessing(grouper) {
    return Belt_Array.some(grouper, function(param6) {
        var selectorPattern = param6[0];
        return Belt_Array.some(param6[1], function(param) {
            return List.length(param[1]) > List.length(selectorPattern);
        });
    });
}
function mergeElementSelectorPairAndPatternIn(elementSelectorPair, patternToMergeIn, grouper) {
    var match = Belt_Array.reduce(grouper, [
        false,
        []
    ], function(param7, param$1) {
        var elementSelectorPairs = param$1[1];
        var existingSelectorPattern = param$1[0];
        var nextGrouper = param7[1];
        if (param7[0]) {
            return [
                true,
                $$Array.append(nextGrouper, [
                    [
                        existingSelectorPattern,
                        elementSelectorPairs
                    ]
                ])
            ];
        }
        if (!patternToMergeIn) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected empty selector pattern");
        }
        var exactMatch = patternToMergeIn.hd;
        if (!existingSelectorPattern) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected empty selector pattern");
        }
        if (Caml_obj.caml_notequal(patternToMergeIn.tl, existingSelectorPattern.tl)) {
            return [
                false,
                $$Array.append(nextGrouper, [
                    [
                        existingSelectorPattern,
                        elementSelectorPairs
                    ]
                ])
            ];
        }
        if (exactMatch.TAG === /* ExactMatch */ 0) {
            var looseMatch = existingSelectorPattern.hd;
            var exactMatch$1 = exactMatch._0;
            if (looseMatch.TAG === /* ExactMatch */ 0) {
                var exactMatch_2 = looseMatch._0;
                if (Caml_obj.caml_equal(exactMatch$1, exactMatch_2)) {
                    return [
                        true,
                        $$Array.append(nextGrouper, [
                            [
                                existingSelectorPattern,
                                Belt_Array.some(elementSelectorPairs, function(param) {
                                    return param[0] === elementSelectorPair[0];
                                }) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [
                                    elementSelectorPair
                                ])
                            ]
                        ])
                    ];
                }
                var looseMatch$1 = maybeLooseMatchWhenPairedWithExactMatch(exactMatch_2, exactMatch$1);
                if (looseMatch$1 !== undefined) {
                    return [
                        true,
                        $$Array.append(nextGrouper, [
                            [
                                {
                                    hd: {
                                        TAG: /* LooseMatch */ 1,
                                        _0: looseMatch$1
                                    },
                                    tl: existingSelectorPattern.tl
                                },
                                Belt_Array.some(elementSelectorPairs, function(param) {
                                    return param[0] === elementSelectorPair[0];
                                }) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [
                                    elementSelectorPair
                                ])
                            ]
                        ])
                    ];
                } else {
                    return [
                        false,
                        $$Array.append(nextGrouper, [
                            [
                                existingSelectorPattern,
                                elementSelectorPairs
                            ]
                        ])
                    ];
                }
            }
            var looseMatch$2 = looseMatch._0;
            if (doesMatchLooseMatch(looseMatch$2, exactMatch$1)) {
                return [
                    true,
                    $$Array.append(nextGrouper, [
                        [
                            updateFirstTreeNodePattern(function(param) {
                                return {
                                    TAG: /* LooseMatch */ 1,
                                    _0: {
                                        tagName: looseMatch$2.tagName,
                                        classNames: looseMatch$2.classNames,
                                        attributes: looseMatch$2.attributes,
                                        nthChildPattern: updateWithAdditionalSiblingIndex(exactMatch$1.index, looseMatch$2.nthChildPattern)
                                    }
                                };
                            }, existingSelectorPattern),
                            Belt_Array.some(elementSelectorPairs, function(param) {
                                return param[0] === elementSelectorPair[0];
                            }) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [
                                elementSelectorPair
                            ])
                        ]
                    ])
                ];
            } else {
                return [
                    false,
                    $$Array.append(nextGrouper, [
                        [
                            existingSelectorPattern,
                            elementSelectorPairs
                        ]
                    ])
                ];
            }
        }
        var exactMatch$2 = existingSelectorPattern.hd;
        var looseMatch$3 = exactMatch._0;
        if (exactMatch$2.TAG === /* ExactMatch */ 0) {
            var exactMatch$3 = exactMatch$2._0;
            if (doesMatchLooseMatch(looseMatch$3, exactMatch$3)) {
                return [
                    true,
                    $$Array.append(nextGrouper, [
                        [
                            updateFirstTreeNodePattern(function(param) {
                                return {
                                    TAG: /* LooseMatch */ 1,
                                    _0: {
                                        tagName: looseMatch$3.tagName,
                                        classNames: looseMatch$3.classNames,
                                        attributes: looseMatch$3.attributes,
                                        nthChildPattern: updateWithAdditionalSiblingIndex(exactMatch$3.index, looseMatch$3.nthChildPattern)
                                    }
                                };
                            }, patternToMergeIn),
                            Belt_Array.some(elementSelectorPairs, function(param) {
                                return param[0] === elementSelectorPair[0];
                            }) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [
                                elementSelectorPair
                            ])
                        ]
                    ])
                ];
            } else {
                return [
                    false,
                    $$Array.append(nextGrouper, [
                        [
                            existingSelectorPattern,
                            elementSelectorPairs
                        ]
                    ])
                ];
            }
        }
        var looseMatch_2 = exactMatch$2._0;
        if (isEqualDuringProcessing(looseMatch$3, looseMatch_2)) {
            return [
                true,
                $$Array.append(nextGrouper, [
                    [
                        updateFirstTreeNodePattern(function(param) {
                            return {
                                TAG: /* LooseMatch */ 1,
                                _0: mergeIdenticalLooseMatchesToUpdateNthChildPattern(looseMatch_2, looseMatch$3)
                            };
                        }, existingSelectorPattern),
                        Belt_Array.some(elementSelectorPairs, function(param) {
                            return param[0] === elementSelectorPair[0];
                        }) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [
                            elementSelectorPair
                        ])
                    ]
                ])
            ];
        } else {
            return [
                false,
                $$Array.append(nextGrouper, [
                    [
                        existingSelectorPattern,
                        elementSelectorPairs
                    ]
                ])
            ];
        }
    });
    var nextGrouper1 = match[1];
    if (match[0]) {
        return nextGrouper1;
    } else {
        return $$Array.append(nextGrouper1, [
            [
                patternToMergeIn,
                [
                    elementSelectorPair
                ]
            ]
        ]);
    }
}
function nextIteration(treeWalker) {
    return Belt_Array.reduce(treeWalker, [], function(nextGrouper, param8) {
        var elementSelectorPairs = param8[1];
        var selectorPattern = param8[0];
        var levelToInspect = List.length(selectorPattern);
        if (elementSelectorPairs.length !== 1) {
            return Belt_Array.reduce(ArrayUtils$SmartcutsMacros.windowMap2(function(elementSelectorPair_1, elementSelectorPair_2) {
                return [
                    elementSelectorPair_1,
                    elementSelectorPair_2
                ];
            }, elementSelectorPairs), nextGrouper, function(nextGrouper_2, param) {
                var elementSelectorPair_2 = param[1];
                var elementSelectorPair_1 = param[0];
                var match = Belt_List.get(elementSelectorPair_1[1], levelToInspect);
                var match$1 = Belt_List.get(elementSelectorPair_2[1], levelToInspect);
                if (match === undefined) {
                    if (match$1 !== undefined) {
                        return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                            hd: {
                                TAG: /* ExactMatch */ 0,
                                _0: fromNode$1(match$1)
                            },
                            tl: selectorPattern
                        }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, selectorPattern, nextGrouper_2));
                    } else {
                        return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, selectorPattern, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, selectorPattern, nextGrouper_2));
                    }
                }
                if (match$1 === undefined) {
                    return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, selectorPattern, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                        hd: {
                            TAG: /* ExactMatch */ 0,
                            _0: fromNode$1(match)
                        },
                        tl: selectorPattern
                    }, nextGrouper_2));
                }
                var match$2 = maybeFromPairOfSelectorTreeNodes(match, match$1);
                if (match$2.TAG !== /* One */ 0) {
                    return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                        hd: match$2._1,
                        tl: selectorPattern
                    }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                        hd: match$2._0,
                        tl: selectorPattern
                    }, nextGrouper_2));
                }
                var treeNodePattern = match$2._0;
                return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                    hd: treeNodePattern,
                    tl: selectorPattern
                }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                    hd: treeNodePattern,
                    tl: selectorPattern
                }, nextGrouper_2));
            });
        }
        var elementSelectorPair = Caml_array.get(elementSelectorPairs, 0);
        var node = Belt_List.get(elementSelectorPair[1], levelToInspect);
        if (node !== undefined) {
            return mergeElementSelectorPairAndPatternIn(elementSelectorPair, {
                hd: {
                    TAG: /* ExactMatch */ 0,
                    _0: fromNode$1(node)
                },
                tl: selectorPattern
            }, nextGrouper);
        } else {
            return $$Array.append(nextGrouper, [
                [
                    selectorPattern,
                    elementSelectorPairs
                ]
            ]);
        }
    });
}
function doAllGroupsShareSameAncestorPatternOfExactMatches(grouper) {
    var ancestorsPatternPerGroup = Belt_Array.keepMap(grouper, function(param) {
        return Belt_List.tail(param[0]);
    });
    var firstAncestorsPattern = Belt_Array.get(ancestorsPatternPerGroup, 0);
    if (firstAncestorsPattern !== undefined && firstAncestorsPattern && !Belt_List.some(firstAncestorsPattern, isLooseMatch)) {
        return Belt_Array.every(Belt_Array.sliceToEnd(ancestorsPatternPerGroup, 1), function(otherPattern) {
            return Caml_obj.caml_equal(otherPattern, firstAncestorsPattern);
        });
    } else {
        return false;
    }
}
function doAllGroupsEndWithAnchor(grouper) {
    var leafPatternPerGroup = Belt_Array.keepMap(grouper, function(param) {
        return Belt_List.get(param[0], 0);
    });
    return Belt_Array.every(leafPatternPerGroup, function(pattern) {
        if (pattern.TAG !== /* ExactMatch */ 0) {
            return false;
        }
        var match = pattern._0.tagName;
        if (match === "a") {
            return true;
        } else {
            return false;
        }
    });
}
function $$process(_grouper) {
    while(true){
        var grouper = _grouper;
        if (!stillNeedsProcessing(grouper)) {
            if (doAllGroupsShareSameAncestorPatternOfExactMatches(grouper) && doAllGroupsEndWithAnchor(grouper)) {
                return Belt_Array.reduce(grouper, empty, function(newGrouper, param) {
                    var elementSelectorPairs = param[1];
                    var pattern = param[0];
                    if (!pattern) {
                        return newGrouper;
                    }
                    var match = pattern.hd;
                    if (match.TAG !== /* ExactMatch */ 0) {
                        return newGrouper;
                    }
                    var ancestorPattern = pattern.tl;
                    var match$1 = match._0;
                    var index = match$1.index;
                    var attributes = match$1.attributes;
                    var classNames = match$1.classNames;
                    var tagName = match$1.tagName;
                    var match$2 = Belt_Array.get(newGrouper, 0);
                    if (match$2 !== undefined) {
                        var match$3 = match$2[0];
                        if (!match$3) {
                            return newGrouper;
                        }
                        var wipLooseMatch = match$3.hd;
                        if (wipLooseMatch.TAG === /* ExactMatch */ 0) {
                            return newGrouper;
                        }
                        var looseMatch_nthChildPattern = {
                            TAG: /* SampleSizeOne */ 0,
                            _0: index
                        };
                        var looseMatch = {
                            tagName: tagName,
                            classNames: classNames,
                            attributes: attributes,
                            nthChildPattern: looseMatch_nthChildPattern
                        };
                        var newLooseMatch = mergeIdenticalLooseMatchesToUpdateNthChildPattern(wipLooseMatch._0, looseMatch);
                        return [
                            [
                                {
                                    hd: {
                                        TAG: /* LooseMatch */ 1,
                                        _0: newLooseMatch
                                    },
                                    tl: ancestorPattern
                                },
                                $$Array.append(match$2[1], elementSelectorPairs)
                            ]
                        ];
                    }
                    var looseMatch_nthChildPattern$1 = {
                        TAG: /* SampleSizeOne */ 0,
                        _0: index
                    };
                    var looseMatch$1 = {
                        tagName: tagName,
                        classNames: classNames,
                        attributes: attributes,
                        nthChildPattern: looseMatch_nthChildPattern$1
                    };
                    return [
                        [
                            {
                                hd: {
                                    TAG: /* LooseMatch */ 1,
                                    _0: looseMatch$1
                                },
                                tl: ancestorPattern
                            },
                            elementSelectorPairs
                        ]
                    ];
                });
            } else {
                return grouper;
            }
        }
        _grouper = nextIteration(grouper);
        continue;
    }
    ;
}
var ElementGrouper = {
    TreeNodePattern: TreeNodePattern,
    SelectorPattern: SelectorPattern,
    TopologyGroup: TopologyGroup,
    getFirstGroup: getFirstGroup,
    toPrintable: toPrintable,
    empty: empty,
    make: make,
    doAllGroupsShareSameAncestorPatternOfExactMatches: doAllGroupsShareSameAncestorPatternOfExactMatches,
    doAllGroupsEndWithAnchor: doAllGroupsEndWithAnchor,
    $$process: $$process
};
function group(origin, elements) {
    return $$process(make(origin, elements));
}
exports.ElementGrouper = ElementGrouper;
exports.group = group; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 84557:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Element = __webpack_require__(33116);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function make(param) {
    return {
        identifierByDomElement: {
            contents: CustomMap$SmartcutsMacros.MapDomElement.make(undefined)
        },
        nextDomElementIdentifier: {
            contents: 0
        }
    };
}
function t_encode(_generator) {
    return "domElementIdentifierGenerator";
}
function t_decode(encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
        if (str === "domElementIdentifierGenerator") {
            return {
                TAG: /* Ok */ 0,
                _0: make(undefined)
            };
        } else {
            return Decco.error(undefined, "Expected 'domElementIdentifierGenerator' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
        }
    } else {
        return Decco.error(undefined, "Couldn't decode json into DomElementIdentifierGenerator.t", encoded);
    }
}
function stringify(param1) {
    return "{identifierByDomElement=" + (StringUtils$SmartcutsMacros.join(", ", List.map(function(param) {
        return "[element]=" + String(param[1]);
    }, Belt_Map.toList(param1.identifierByDomElement.contents))) + (", nextDomElementIdentifier=" + (String(param1.nextDomElementIdentifier.contents) + "}")));
}
function identifierForElement(element, generator) {
    var identifierByDomElement = generator.identifierByDomElement.contents;
    var domElementIdentifier = Belt_Map.get(identifierByDomElement, element);
    if (domElementIdentifier !== undefined) {
        return domElementIdentifier;
    }
    var nextDomElementIdentifier = generator.nextDomElementIdentifier.contents;
    generator.identifierByDomElement.contents = Belt_Map.set(identifierByDomElement, element, nextDomElementIdentifier);
    generator.nextDomElementIdentifier.contents = nextDomElementIdentifier + 1 | 0;
    return nextDomElementIdentifier;
}
function identifierForNode(node, domElementIdentifierGenerator) {
    var element = Webapi__Dom__Element.ofNode(node);
    if (element !== undefined) {
        return identifierForElement(Caml_option.valFromOption(element), domElementIdentifierGenerator);
    }
}
exports.make = make;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.identifierForElement = identifierForElement;
exports.identifierForNode = identifierForNode; /* Webapi__Dom__Element Not a pure module */ 


/***/ }),

/***/ 95016:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifier",
            Decco.intToJson(v.domElementIdentifier)
        ],
        [
            "inputCursor",
            Selection__InputCursor$SmartcutsMacros.ForRecording.t_encode(v.inputCursor)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifier = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifier"), null));
    if (domElementIdentifier.TAG === /* Ok */ 0) {
        var inputCursor = Selection__InputCursor$SmartcutsMacros.ForRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputCursor"), null));
        if (inputCursor.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifier: domElementIdentifier._0,
                    inputCursor: inputCursor._0
                }
            };
        }
        var e = inputCursor._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".inputCursor" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifier._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifier" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* Selection__InputCursor-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 25763:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifier",
            Decco.intToJson(v.domElementIdentifier)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifier = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifier"), null));
    if (domElementIdentifier.TAG === /* Ok */ 0) {
        var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
        if (selector.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifier: domElementIdentifier._0,
                    selector: selector._0
                }
            };
        }
        var e = selector._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selector" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifier._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifier" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromElement(domElementIdentifierGenerator, element) {
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
    return {
        domElementIdentifier: domElementIdentifier,
        selector: Selector$SmartcutsMacros.forDomElement(element)
    };
}
function isEqual(x, y) {
    return x.domElementIdentifier === y.domElementIdentifier;
}
function stringify(param) {
    return "{domElementIdentifier: " + (String(param.domElementIdentifier) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + "}")));
}
function mapSelector(f, pair) {
    return {
        domElementIdentifier: pair.domElementIdentifier,
        selector: Curry._1(f, pair.selector)
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.fromElement = fromElement;
exports.isEqual = isEqual;
exports.stringify = stringify;
exports.mapSelector = mapSelector; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 95551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
function t_encode(encoder_command, encoder_contextGlobal, v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.intToJson(v.id)
        ],
        [
            "command",
            Curry._1(encoder_command, v.command)
        ],
        [
            "contextGlobal",
            Curry._1(encoder_contextGlobal, v.contextGlobal)
        ]
    ]);
}
function t_decode(decoder_command, decoder_contextGlobal, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var command = Curry._1(decoder_command, Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
        if (command.TAG === /* Ok */ 0) {
            var contextGlobal = Curry._1(decoder_contextGlobal, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contextGlobal"), null));
            if (contextGlobal.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        id: id._0,
                        command: command._0,
                        contextGlobal: contextGlobal._0
                    }
                };
            }
            var e = contextGlobal._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".contextGlobal" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = command._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".command" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* No side effect */ 


/***/ }),

/***/ 81530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Browser__Identity$SmartcutsMacros = __webpack_require__(60051);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(invalidAccessToken, client, fn) {
    return Browser__Identity$SmartcutsMacros.removeCachedAuthToken(invalidAccessToken).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            return Browser__Identity$SmartcutsMacros.getAuthToken(false, true, undefined, undefined, undefined).then(function(maybeNewToken) {
                if (maybeNewToken !== undefined) {
                    return Curry._2(fn, maybeNewToken, client).then(function(return_) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* MethodDidReturnWithNewToken */ 1,
                                return_: return_,
                                newToken: maybeNewToken,
                                oldToken: invalidAccessToken
                            }
                        });
                    }).catch(function(jsPromiseError) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* MethodDidThrowPromiseError */ 0,
                                errorType: Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError),
                                maybeNewToken: maybeNewToken,
                                originalToken: invalidAccessToken
                            }
                        });
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: /* OAuthNotGrantedWhenTryingToGetNewToken */ 0
                    });
                }
            }).catch(function(jsPromiseError) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* PromiseErrorWhileGetNewOAuthToken */ 2,
                        promiseErrorType: Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError),
                        removedToken: invalidAccessToken
                    }
                });
            });
        }
        var jsExn = result._0;
        console.error(jsExn);
        return Promise.resolve({
            TAG: /* Error */ 1,
            _0: {
                TAG: /* JsExnWhileRemoveCachedOAuthToken */ 1,
                jsExn: jsExn,
                cachedToken: invalidAccessToken
            }
        });
    });
}
function wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(fn, accessToken, client) {
    return Curry._2(fn, accessToken, client).then(function(res) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: {
                TAG: /* MethodDidReturnUsingOriginalToken */ 0,
                _0: res
            }
        });
    }).catch(function(jsPromiseError) {
        var errorType = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
        if (typeof errorType === "number") {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* MethodDidThrowPromiseError */ 0,
                    errorType: errorType,
                    maybeNewToken: undefined,
                    originalToken: accessToken
                }
            });
        }
        switch(errorType.TAG | 0){
            case /* GapiIsUndefined */ 2:
                Util$SmartcutsMacros.wait(250).then(function(_timeoutId) {
                    return browser.runtime.reload();
                });
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* MethodDidThrowPromiseError */ 0,
                        errorType: errorType,
                        maybeNewToken: undefined,
                        originalToken: accessToken
                    }
                });
            case /* UnauthorizedApiResponse */ 10:
                return removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(accessToken, client, fn);
            case /* HttpResponse */ 12:
                var httpResponse = errorType._0;
                console.warn("Google api call failed:", httpResponse);
                var _non401HttpStatusCode = httpResponse.result.error.code;
                if (_non401HttpStatusCode !== 401) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* MethodDidThrowPromiseError */ 0,
                            errorType: errorType,
                            maybeNewToken: undefined,
                            originalToken: accessToken
                        }
                    });
                } else {
                    return removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall(accessToken, client, fn);
                }
            default:
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* MethodDidThrowPromiseError */ 0,
                        errorType: errorType,
                        maybeNewToken: undefined,
                        originalToken: accessToken
                    }
                });
        }
    });
}
exports.removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall = removeCachedAuthTokenAndGetNewAuthTokenAndRetryApiCall;
exports.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi = wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 42828:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_format = __webpack_require__(63979);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var GoogleApis$SmartcutsMacros = __webpack_require__(10192);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var GoogleApiHelpers$SmartcutsMacros = __webpack_require__(81530);
var GoogleSheetTypes$SmartcutsMacros = __webpack_require__(25330);
var GoogleApis__Sheets$SmartcutsMacros = __webpack_require__(45694);
var GoogleApis__Sheets__Schema$SmartcutsMacros = __webpack_require__(11815);
function loadClientButReloadExtensionIfGapiIsNotDefined(param) {
    if (GoogleApis$SmartcutsMacros.isGapiUndefined(undefined)) {
        return Util$SmartcutsMacros.wait(250).then(function(_timeoutId) {
            return browser.runtime.reload();
        }).then(function(param) {
            return GoogleApis__Sheets$SmartcutsMacros.load(undefined);
        });
    } else {
        return GoogleApis__Sheets$SmartcutsMacros.load(undefined);
    }
}
function maybeGetSpreadsheetIdFromUrl(url) {
    var captures = OptionUtils$SmartcutsMacros.map(Caml_option.null_to_opt(RegExUtils$SmartcutsMacros.googleSheetsRe.exec(url)), function(prim) {
        return prim;
    });
    if (captures !== undefined && captures.length > 1) {
        return Caml_option.nullable_to_opt(Caml_array.get(captures, 1));
    }
}
function isGoogleSheetUrl(param) {
    return RegExUtils$SmartcutsMacros.googleSheetsRe.test(param);
}
function diffCells(expectPaste, _indexOpt, _diffsOpt, _row1, row2) {
    while(true){
        var indexOpt = _indexOpt;
        var diffsOpt = _diffsOpt;
        var row1 = _row1;
        var index = indexOpt !== undefined ? indexOpt : 0;
        var diffs = diffsOpt !== undefined ? diffsOpt : [];
        var match = Belt_Array.get(row1.cells, index);
        var match$1 = Belt_Array.get(row2.cells, index);
        if (match !== undefined) {
            if (match$1 !== undefined) {
                var cellDiff = Curry._4(GoogleSheetTypes$SmartcutsMacros.Cell.WithPosition.compare, expectPaste, {
                    colIndex: index,
                    rowIndex: row1.rowIndex,
                    value: match
                }, {
                    colIndex: index,
                    rowIndex: row2.rowIndex,
                    value: match$1
                }, undefined);
                if (cellDiff !== undefined) {
                    _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff, row1);
                    _diffsOpt = $$Array.append(diffs, [
                        {
                            TAG: /* UpdateCell */ 0,
                            _0: cellDiff,
                            _1: row1
                        }
                    ]);
                    _indexOpt = index + 1 | 0;
                    continue;
                }
                _diffsOpt = diffs;
                _indexOpt = index + 1 | 0;
                continue;
            }
            var cellDiff_rowIndex = row1.rowIndex;
            var cellDiff_diff = {
                TAG: /* Removed */ 2,
                _0: match
            };
            var cellDiff$1 = {
                rowIndex: cellDiff_rowIndex,
                colIndex: index,
                diff: cellDiff_diff
            };
            _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff$1, row1);
            _diffsOpt = $$Array.append(diffs, [
                {
                    TAG: /* UpdateCell */ 0,
                    _0: cellDiff$1,
                    _1: row1
                }
            ]);
            _indexOpt = index + 1 | 0;
            continue;
        }
        if (match$1 === undefined) {
            return diffs;
        }
        var tmp;
        var exit = 0;
        if (expectPaste !== undefined) {
            if (typeof match$1 === "number" || match$1.TAG !== /* Value */ 1) {
                exit = 1;
            } else {
                var text = match$1._0;
                var exit$1 = 0;
                switch(text.TAG | 0){
                    case /* StaticText */ 0:
                    case /* PasteText */ 1:
                        exit$1 = 2;
                        break;
                    default:
                        exit = 1;
                }
                if (exit$1 === 2) {
                    var text$1 = text._0;
                    if (text$1 === expectPaste || text$1 === expectPaste + " ") {
                        tmp = {
                            TAG: /* Value */ 1,
                            _0: {
                                TAG: /* PasteText */ 1,
                                _0: expectPaste
                            }
                        };
                    } else {
                        exit = 1;
                    }
                }
            }
        } else {
            tmp = match$1;
        }
        if (exit === 1) {
            if (typeof match$1 === "number" || match$1.TAG !== /* Value */ 1) {
                tmp = match$1;
            } else {
                var text$2 = match$1._0;
                switch(text$2.TAG | 0){
                    case /* StaticText */ 0:
                    case /* PasteText */ 1:
                        tmp = {
                            TAG: /* Value */ 1,
                            _0: {
                                TAG: /* StaticText */ 0,
                                _0: text$2._0
                            }
                        };
                        break;
                    default:
                        tmp = match$1;
                }
            }
        }
        var cellDiff_rowIndex$1 = row2.rowIndex;
        var cellDiff_diff$1 = {
            TAG: /* Added */ 1,
            _0: tmp
        };
        var cellDiff$2 = {
            rowIndex: cellDiff_rowIndex$1,
            colIndex: index,
            diff: cellDiff_diff$1
        };
        var diffs$1 = match$1 === /* Empty */ 0 ? diffs : Belt_Array.concat(diffs, [
            {
                TAG: /* UpdateCell */ 0,
                _0: cellDiff$2,
                _1: row1
            }
        ]);
        _row1 = GoogleSheetTypes$SmartcutsMacros.Row.applyCellDiff(cellDiff$2, row1);
        _diffsOpt = diffs$1;
        _indexOpt = index + 1 | 0;
        continue;
    }
    ;
}
function allCellsEmpty(row) {
    if (row !== undefined) {
        return Belt_Array.every(row.cells, function(cell) {
            return cell === 0;
        });
    } else {
        return true;
    }
}
function compare(expectPaste, sheet1, sheet2) {
    if (sheet1.id !== sheet2.id) {
        Util$SmartcutsMacros.logAndRaiseJsError("Sheets don't have same id");
    } else if (Caml_obj.caml_notequal(sheet1.headers, sheet2.headers)) {
        Util$SmartcutsMacros.logAndRaiseJsError("Sheets don't have same columns");
    }
    var rows1 = sheet1.rows;
    var rows2 = sheet2.rows;
    var _indexOpt;
    var _diffsOpt;
    var _param;
    while(true){
        var indexOpt = _indexOpt;
        var diffsOpt = _diffsOpt;
        var index = indexOpt !== undefined ? indexOpt : 0;
        var diffs = diffsOpt !== undefined ? diffsOpt : [];
        var match = Belt_Array.get(rows1, index);
        var match$1 = Belt_Array.get(rows2, index);
        if (match !== undefined && allCellsEmpty(match$1) && !allCellsEmpty(match)) {
            _param = undefined;
            _diffsOpt = Belt_Array.concat(diffs, [
                {
                    TAG: /* DeleteRow */ 2,
                    _0: match
                }
            ]);
            _indexOpt = index + 1 | 0;
            continue;
        }
        if (match$1 === undefined) {
            return diffs;
        }
        if (allCellsEmpty(match) && !allCellsEmpty(match$1)) {
            var newRow_rowIndex = match$1.rowIndex;
            var newRow_cells = Belt_Array.map(match$1.cells, function(value) {
                if (typeof value === "number") {
                    return value;
                }
                if (value.TAG !== /* Value */ 1) {
                    return value;
                }
                var textContent = value._0;
                if (textContent.TAG !== /* StaticText */ 0) {
                    return value;
                }
                var textContent$1 = textContent._0;
                if (OptionUtils$SmartcutsMacros.equalsSome(textContent$1, expectPaste)) {
                    return {
                        TAG: /* Value */ 1,
                        _0: {
                            TAG: /* PasteText */ 1,
                            _0: textContent$1
                        }
                    };
                } else {
                    return value;
                }
            });
            var newRow = {
                rowIndex: newRow_rowIndex,
                cells: newRow_cells
            };
            _param = undefined;
            _diffsOpt = Belt_Array.concat(diffs, [
                {
                    TAG: /* AppendRow */ 1,
                    _0: newRow
                }
            ]);
            _indexOpt = index + 1 | 0;
            continue;
        }
        if (match === undefined) {
            return diffs;
        }
        var updates = diffCells(expectPaste, undefined, undefined, match, match$1);
        var match$2 = updates.length;
        if (match$2 !== 0) {
            _param = undefined;
            _diffsOpt = Belt_Array.concat(diffs, updates);
            _indexOpt = index + 1 | 0;
            continue;
        }
        _param = undefined;
        _diffsOpt = diffs;
        _indexOpt = index + 1 | 0;
        continue;
    }
    ;
}
function maybePadMissingCellsWithEmptyValues(cellDiffColIndex, cells) {
    if (cellDiffColIndex <= (cells.length - 1 | 0)) {
        return cells;
    }
    var missingCellCount = cellDiffColIndex - (cells.length - 1 | 0) | 0;
    var cellsForPadding = Caml_array.make(missingCellCount, /* Empty */ 0);
    return $$Array.append(cells, cellsForPadding);
}
function getGridLimitsFromErrorMessage(message) {
    var re = /Range \(.+\) exceeds grid limits. Max rows: (\d+), max columns: (\d+)/;
    var result = re.exec(message);
    var maybeMaxRows = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 1)) : undefined;
    var maybeMaxCols = result !== null ? Caml_option.nullable_to_opt(Caml_array.get(result, 2)) : undefined;
    var arg = OptionUtils$SmartcutsMacros.map(maybeMaxRows, Caml_format.caml_float_of_string);
    var arg$1 = OptionUtils$SmartcutsMacros.map(maybeMaxCols, Caml_format.caml_float_of_string);
    return {
        maxRows: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(-1),
        maxCols: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
        }(-1)
    };
}
function getSpreadsheetSize_withEdgeCaseHandling(spreadsheetId, accessToken1, maybeOnlyFirstNRows, client1) {
    var wrappedGet = function wrappedGet(param, param$1) {
        return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi(function(accessToken, client) {
            return GoogleApis__Sheets$SmartcutsMacros.get(accessToken, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, spreadsheetId, undefined, undefined, client);
        }, param, param$1);
    };
    return wrappedGet(accessToken1, client1).then(function(result) {
        var maybeSpreadsheet;
        if (result.TAG === /* Ok */ 0) {
            var maybeSpreadsheet$1 = result._0;
            if (typeof maybeSpreadsheet$1 === "number") {
                return Util$SmartcutsMacros.logAndRaiseJsError("Could not reset invalid token");
            }
            maybeSpreadsheet = maybeSpreadsheet$1.TAG === /* MethodDidReturnUsingOriginalToken */ 0 ? maybeSpreadsheet$1._0 : maybeSpreadsheet$1.return_;
        } else {
            var match = result._0;
            switch(match.TAG | 0){
                case /* MethodDidThrowPromiseError */ 0:
                    var httpResponse = match.errorType;
                    if (typeof httpResponse === "number") {
                        return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                    }
                    switch(httpResponse.TAG | 0){
                        case /* GapiIsUndefined */ 2:
                            return Util$SmartcutsMacros.logAndRaiseJsError("Gapi not loaded");
                        case /* HttpResponse */ 12:
                            var httpResponse$1 = httpResponse._0;
                            console.warn("Google api call failed:", httpResponse$1);
                            return Util$SmartcutsMacros.logAndRaiseJsError("Google api call failed with http response " + String(httpResponse$1.result.error.code));
                        default:
                            return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                    }
                case /* JsExnWhileRemoveCachedOAuthToken */ 1:
                    return Util$SmartcutsMacros.logAndRaiseJsError("Error while removing cached token");
                case /* PromiseErrorWhileGetNewOAuthToken */ 2:
                    return Util$SmartcutsMacros.logAndRaiseJsError("Error while getting new token");
            }
        }
        var func = GoogleApis__Sheets__Schema$SmartcutsMacros.Spreadsheet.getGridDataFor;
        var arg = Belt_Option.map(Belt_Option.flatMap(maybeSpreadsheet, function(param) {
            return Curry._3(func, param, 0, 0);
        }), function(param) {
            return GoogleApis__Sheets__Schema$SmartcutsMacros.GridData.countRowsMinusHeaderRow(maybeOnlyFirstNRows, param);
        });
        return Promise.resolve(function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(0));
    });
}
var Schema;
exports.Schema = Schema;
exports.loadClientButReloadExtensionIfGapiIsNotDefined = loadClientButReloadExtensionIfGapiIsNotDefined;
exports.maybeGetSpreadsheetIdFromUrl = maybeGetSpreadsheetIdFromUrl;
exports.isGoogleSheetUrl = isGoogleSheetUrl;
exports.compare = compare;
exports.maybePadMissingCellsWithEmptyValues = maybePadMissingCellsWithEmptyValues;
exports.getGridLimitsFromErrorMessage = getGridLimitsFromErrorMessage;
exports.getSpreadsheetSize_withEdgeCaseHandling = getSpreadsheetSize_withEdgeCaseHandling; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 25330:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
function t_encode(v) {
    if (typeof v === "number") {
        if (v === /* Empty */ 0) {
            return [
                "Empty"
            ];
        } else {
            return [
                "Unknown"
            ];
        }
    } else if (v.TAG === /* Formula */ 0) {
        return [
            "Formula",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Value",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Empty":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Empty */ 0
                    };
                }
            case "Formula":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Formula */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Unknown":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Unknown */ 1
                    };
                }
            case "Value":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Value */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(value) {
    if (typeof value === "number") {
        if (value === /* Empty */ 0) {
            return "Empty";
        } else {
            return "Unknown";
        }
    } else if (value.TAG === /* Formula */ 0) {
        return "Formula(" + (value._0 + ")");
    } else {
        return "Value(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, value._0) + ")");
    }
}
function isEmpty(x) {
    if (typeof x === "number") {
        if (x === /* Empty */ 0) {
            return true;
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Cannot determine if Unknown value for cell is empty");
        }
    }
    if (x.TAG === /* Formula */ 0) {
        return false;
    }
    var match = x._0;
    if (match.TAG === /* StaticText */ 0 && match._0 === "") {
        return true;
    } else {
        return false;
    }
}
function isValueWithDataRef(value, f) {
    if (typeof value === "number" || value.TAG !== /* Value */ 1) {
        return false;
    } else {
        return Curry._1(f, value._0);
    }
}
function normalizeForKeyColumnComparison(v) {
    if (typeof v === "number" || v.TAG !== /* Value */ 1) {
        return v;
    } else {
        return {
            TAG: /* Value */ 1,
            _0: {
                TAG: /* StaticText */ 0,
                _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, v._0)
            }
        };
    }
}
function adjustAnyPasteToReferenceLastCopyCommand(lastCopyInfo, v) {
    if (typeof v === "number" || v.TAG !== /* Value */ 1) {
        return v;
    } else {
        return {
            TAG: /* Value */ 1,
            _0: Curry._2(DataDependency$SmartcutsMacros.DataRef.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo, v._0)
        };
    }
}
function getReferencedCommandIds(cellValue) {
    if (typeof cellValue === "number") {
        return [];
    } else if (cellValue.TAG === /* Value */ 1) {
        return Curry._1(DataDependency$SmartcutsMacros.DataRef.getReferencedCommandIds, cellValue._0);
    } else {
        return [];
    }
}
function stringGet(cellValue) {
    if (typeof cellValue === "number") {
        if (cellValue === /* Empty */ 0) {
            return "";
        } else {
            return "?";
        }
    } else if (cellValue.TAG === /* Formula */ 0) {
        return cellValue._0;
    } else {
        return Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, cellValue._0);
    }
}
function humanize(value) {
    if (typeof value === "number") {
        if (value === /* Empty */ 0) {
            return "";
        } else {
            return "?";
        }
    } else if (value.TAG === /* Formula */ 0) {
        return value._0;
    } else {
        return Curry._1(DataDependency$SmartcutsMacros.DataRef.humanize, value._0);
    }
}
function humanizeWithConcreteValue(value) {
    if (typeof value === "number") {
        if (value === /* Empty */ 0) {
            return "";
        } else {
            return "?";
        }
    } else if (value.TAG === /* Formula */ 0) {
        return value._0;
    } else {
        return Curry._1(DataDependency$SmartcutsMacros.DataRef.humanizeWithConcreteValue, value._0);
    }
}
function fromCellData(cellData) {
    var match = cellData.effectiveValue;
    if (match !== undefined) {
        var formulaString = match.formulaValue;
        if (formulaString !== undefined) {
            return {
                TAG: /* Formula */ 0,
                _0: formulaString
            };
        }
    }
    var value = cellData.formattedValue;
    if (value !== undefined && value !== "") {
        return {
            TAG: /* Value */ 1,
            _0: {
                TAG: /* StaticText */ 0,
                _0: value
            }
        };
    } else {
        return /* Empty */ 0;
    }
}
function mapDataRef(f, value) {
    if (typeof value === "number") {
        if (value === /* Empty */ 0) {
            return /* Empty */ 0;
        } else {
            return /* Unknown */ 1;
        }
    } else if (value.TAG === /* Formula */ 0) {
        return {
            TAG: /* Formula */ 0,
            _0: value._0
        };
    } else {
        return {
            TAG: /* Value */ 1,
            _0: Curry._1(f, value._0)
        };
    }
}
var Value = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    isEmpty: isEmpty,
    isValueWithDataRef: isValueWithDataRef,
    normalizeForKeyColumnComparison: normalizeForKeyColumnComparison,
    adjustAnyPasteToReferenceLastCopyCommand: adjustAnyPasteToReferenceLastCopyCommand,
    getReferencedCommandIds: getReferencedCommandIds,
    stringGet: stringGet,
    humanize: humanize,
    humanizeWithConcreteValue: humanizeWithConcreteValue,
    fromCellData: fromCellData,
    mapDataRef: mapDataRef
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "from",
            t_encode(v.from)
        ],
        [
            "to_",
            t_encode(v.to_)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var from = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "from"), null));
    if (from.TAG === /* Ok */ 0) {
        var to_ = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "to_"), null));
        if (to_.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    from: from._0,
                    to_: to_._0
                }
            };
        }
        var e = to_._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".to_" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = from._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".from" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var FromTo = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    switch(v.TAG | 0){
        case /* FromTo */ 0:
            return [
                "FromTo",
                t_encode$1(v._0)
            ];
        case /* Added */ 1:
            return [
                "Added",
                t_encode(v._0)
            ];
        case /* Removed */ 2:
            return [
                "Removed",
                t_encode(v._0)
            ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Added":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Added */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FromTo":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FromTo */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Removed":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Removed */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(diff) {
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            var match = diff._0;
            return "FromTo({ from: " + (stringify(match.from) + (", to: " + (stringify(match.to_) + " })")));
        case /* Added */ 1:
            return "Added(" + (stringify(diff._0) + ")");
        case /* Removed */ 2:
            return "Removed(" + (stringify(diff._0) + ")");
    }
}
function lhs(diff) {
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            return diff._0.from;
        case /* Added */ 1:
            return /* Empty */ 0;
        case /* Removed */ 2:
            return diff._0;
    }
}
function rhs(diff) {
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            return diff._0.to_;
        case /* Added */ 1:
            return diff._0;
        case /* Removed */ 2:
            return /* Empty */ 0;
    }
}
function getReferencedCommandIds$1(cellDiff) {
    switch(cellDiff.TAG | 0){
        case /* FromTo */ 0:
            var match = cellDiff._0;
            var arg = [
                match.from,
                match.to_
            ];
            return ArrayUtils$SmartcutsMacros.mapcat(getReferencedCommandIds, arg);
        case /* Added */ 1:
        case /* Removed */ 2:
            return getReferencedCommandIds(cellDiff._0);
    }
}
function humanizeDiff(diff) {
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            var match = diff._0;
            return "from " + (stringGet(match.from) + (" to " + stringGet(match.to_)));
        case /* Added */ 1:
            return "to " + stringGet(diff._0);
        case /* Removed */ 2:
            return "removed";
    }
}
var ContentDiff = {
    FromTo: FromTo,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$1,
    lhs: lhs,
    rhs: rhs,
    getReferencedCommandIds: getReferencedCommandIds$1,
    humanizeDiff: humanizeDiff
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "rowIndex",
            Decco.intToJson(v.rowIndex)
        ],
        [
            "colIndex",
            Decco.intToJson(v.colIndex)
        ],
        [
            "diff",
            t_encode$2(v.diff)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
    if (rowIndex.TAG === /* Ok */ 0) {
        var colIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "colIndex"), null));
        if (colIndex.TAG === /* Ok */ 0) {
            var diff = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "diff"), null));
            if (diff.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        rowIndex: rowIndex._0,
                        colIndex: colIndex._0,
                        diff: diff._0
                    }
                };
            }
            var e = diff._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".diff" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = colIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".colIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = rowIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rowIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(param) {
    return "{ rowIndex: " + (String(param.rowIndex) + (", colIndex: " + (String(param.colIndex) + (", diff: " + (stringify$1(param.diff) + " }")))));
}
var CellDiff = {
    ContentDiff: ContentDiff,
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$2
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "colIndex",
            Decco.intToJson(v.colIndex)
        ],
        [
            "rowIndex",
            Decco.intToJson(v.rowIndex)
        ],
        [
            "value",
            t_encode(v.value)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var colIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "colIndex"), null));
    if (colIndex.TAG === /* Ok */ 0) {
        var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
        if (rowIndex.TAG === /* Ok */ 0) {
            var value = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        colIndex: colIndex._0,
                        rowIndex: rowIndex._0,
                        value: value._0
                    }
                };
            }
            var e = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = rowIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".rowIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = colIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".colIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromCellData$1(colIndex, rowIndex, cellData) {
    return {
        colIndex: colIndex,
        rowIndex: rowIndex,
        value: fromCellData(cellData)
    };
}
function stringify$3(param) {
    return "{ rowIndex: " + (String(param.rowIndex) + (", colIndex: " + (String(param.colIndex) + (", value: " + (stringify(param.value) + " }")))));
}
function isEmpty$1(param) {
    return param.value === /* Empty */ 0;
}
function compare(expectPaste, cell1, cell2, param) {
    var value2 = cell2.value;
    var value1 = cell1.value;
    var rowIndex1 = cell1.rowIndex;
    var colIndex1 = cell1.colIndex;
    if (rowIndex1 !== cell2.rowIndex) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: should not compare two cells at different rowIndex");
    }
    if (colIndex1 !== cell2.colIndex) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: should not compare two cells at different colIndex");
    }
    var maybeDiff;
    var exit = 0;
    var exit$1 = 0;
    if (value1 === 0) {
        if (typeof value2 === "number") {
            if (value2 === /* Empty */ 0) {
                maybeDiff = undefined;
            } else {
                exit$1 = 2;
            }
        } else if (value2.TAG === /* Formula */ 0) {
            exit$1 = 2;
        } else {
            var textAfter = value2._0;
            var exit$2 = 0;
            switch(textAfter.TAG | 0){
                case /* StaticText */ 0:
                case /* PasteText */ 1:
                    exit$2 = 3;
                    break;
                default:
                    exit$1 = 2;
            }
            if (exit$2 === 3) {
                if (expectPaste !== undefined) {
                    if (textAfter._0 === expectPaste) {
                        maybeDiff = {
                            TAG: /* Added */ 1,
                            _0: {
                                TAG: /* Value */ 1,
                                _0: {
                                    TAG: /* PasteText */ 1,
                                    _0: expectPaste
                                }
                            }
                        };
                    } else {
                        exit = 1;
                    }
                } else {
                    exit$1 = 2;
                }
            }
        }
    } else if (value2 === 0) {
        maybeDiff = {
            TAG: /* Removed */ 2,
            _0: value1
        };
    } else {
        exit$1 = 2;
    }
    if (exit$1 === 2) {
        if (value1 === 0 && expectPaste === undefined) {
            maybeDiff = {
                TAG: /* Added */ 1,
                _0: value2
            };
        } else {
            exit = 1;
        }
    }
    if (exit === 1) {
        var exit$3 = 0;
        if (value1 === 0) {
            maybeDiff = {
                TAG: /* Added */ 1,
                _0: value2
            };
        } else if (Caml_obj.caml_equal(value1, value2)) {
            maybeDiff = undefined;
        } else if (expectPaste !== undefined) {
            if (typeof value1 === "number" || value1.TAG === /* Formula */ 0 || typeof value2 === "number" || value2.TAG === /* Formula */ 0) {
                exit$3 = 2;
            } else {
                var match = Curry._3(DataDependency$SmartcutsMacros.DataRef.compareRawSnapshotAndCalcUpdate, expectPaste, value1._0, value2._0);
                maybeDiff = match !== undefined ? {
                    TAG: /* FromTo */ 0,
                    _0: {
                        from: value1,
                        to_: {
                            TAG: /* Value */ 1,
                            _0: match[0]
                        }
                    }
                } : undefined;
            }
        } else {
            maybeDiff = {
                TAG: /* FromTo */ 0,
                _0: {
                    from: value1,
                    to_: value2
                }
            };
        }
        if (exit$3 === 2) {
            maybeDiff = {
                TAG: /* FromTo */ 0,
                _0: {
                    from: value1,
                    to_: value2
                }
            };
        }
    }
    if (maybeDiff !== undefined) {
        return {
            rowIndex: rowIndex1,
            colIndex: colIndex1,
            diff: maybeDiff
        };
    }
}
var WithPosition = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    fromCellData: fromCellData$1,
    stringify: stringify$3,
    isEmpty: isEmpty$1,
    compare: compare
};
var Cell = {
    Value: Value,
    CellDiff: CellDiff,
    WithPosition: WithPosition
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "rowIndex",
            Decco.intToJson(v.rowIndex)
        ],
        [
            "cells",
            Decco.arrayToJson(t_encode, v.cells)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
    if (rowIndex.TAG === /* Ok */ 0) {
        var cells = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cells"), null));
        if (cells.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    rowIndex: rowIndex._0,
                    cells: cells._0
                }
            };
        }
        var e = cells._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".cells" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = rowIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rowIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromRowData(rowIndex, rowData) {
    var values = rowData.values;
    var cells = values !== undefined ? $$Array.map(fromCellData, values) : [];
    return {
        rowIndex: rowIndex,
        cells: cells
    };
}
function applyCellDiff(param, row) {
    var diff = param.diff;
    var colIndex = param.colIndex;
    var rowIndex = param.rowIndex;
    if (rowIndex !== row.rowIndex) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Trying to apply a diff meant for row " + (String(rowIndex) + (" on row " + String(row.rowIndex))));
    }
    var value;
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            value = diff._0.to_;
            break;
        case /* Added */ 1:
            value = diff._0;
            break;
        case /* Removed */ 2:
            return {
                rowIndex: row.rowIndex,
                cells: ArrayUtils$SmartcutsMacros.updateAt(/* Empty */ 0, colIndex, function(_maybeVal) {
                    return /* Empty */ 0;
                }, row.cells)
            };
    }
    return {
        rowIndex: row.rowIndex,
        cells: ArrayUtils$SmartcutsMacros.updateAt(/* Empty */ 0, colIndex, function(_maybeVal) {
            return value;
        }, row.cells)
    };
}
function stringify$4(param) {
    return "{ rowIndex: " + (String(param.rowIndex) + (", cells: [" + ($$Array.map(stringify, param.cells).join(", ") + "]}")));
}
function isEmpty$2(param) {
    return Belt_Array.every(param.cells, isEmpty);
}
var Row = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromRowData: fromRowData,
    applyCellDiff: applyCellDiff,
    stringify: stringify$4,
    isEmpty: isEmpty$2
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.intToJson(v.id)
        ],
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "headers",
            t_encode$5(v.headers)
        ],
        [
            "rows",
            Decco.arrayToJson(t_encode$5, v.rows)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var headers = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "headers"), null));
            if (headers.TAG === /* Ok */ 0) {
                var rows = Decco.arrayFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
                if (rows.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            name: name._0,
                            headers: headers._0,
                            rows: rows._0
                        }
                    };
                }
                var e = rows._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".rows" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = headers._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".headers" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function fromSheet(sheet) {
    var gridData = sheet.data;
    var values;
    if (gridData !== undefined) {
        if (gridData.length !== 0) {
            var rowData1 = Caml_array.get(gridData, 0).rowData;
            values = rowData1 !== undefined ? ArrayUtils$SmartcutsMacros.filterMapi(function(rowIndex, rowData) {
                var row = fromRowData(rowIndex, rowData);
                if (row.cells.length !== 0) {
                    return row;
                }
            }, rowData1) : [];
        } else {
            values = [];
        }
    } else {
        values = [];
    }
    var arg = sheet.properties;
    var sheetProperties = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect some sheet.properties");
    var arg$1 = sheetProperties.title;
    var name = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expect some properties.title");
    var arg$2 = sheetProperties.sheetId;
    var id = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
    }("Expect some properties.sheetId");
    var headers = Belt_Array.get(values, 0);
    if (headers !== undefined) {
        return {
            id: id,
            name: name,
            headers: headers,
            rows: Belt_Array.slice(values, 1, values.length - 1 | 0)
        };
    }
}
var Worksheet = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    fromSheet: fromSheet
};
function t_encode$7(v) {
    switch(v.TAG | 0){
        case /* UpdateCell */ 0:
            return [
                "UpdateCell",
                t_encode$3(v._0),
                t_encode$5(v._1)
            ];
        case /* AppendRow */ 1:
            return [
                "AppendRow",
                t_encode$5(v._0)
            ];
        case /* DeleteRow */ 2:
            return [
                "DeleteRow",
                t_encode$5(v._0)
            ];
    }
}
function t_decode$7(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AppendRow":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AppendRow */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DeleteRow":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DeleteRow */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "UpdateCell":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = t_decode$5(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* UpdateCell */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$5(sheetDiff) {
    switch(sheetDiff.TAG | 0){
        case /* UpdateCell */ 0:
            return "UpdateCell(" + (stringify$2(sheetDiff._0) + (", " + (stringify$4(sheetDiff._1) + ")")));
        case /* AppendRow */ 1:
            return "AppendRow(" + (stringify$4(sheetDiff._0) + ")");
        case /* DeleteRow */ 2:
            return "DeleteRow(" + (stringify$4(sheetDiff._0) + ")");
    }
}
function getReferencedCommandIds$2(sheetDiff) {
    switch(sheetDiff.TAG | 0){
        case /* UpdateCell */ 0:
            return getReferencedCommandIds$1(sheetDiff._0.diff);
        case /* AppendRow */ 1:
        case /* DeleteRow */ 2:
            return ArrayUtils$SmartcutsMacros.mapcat(getReferencedCommandIds, sheetDiff._0.cells);
    }
}
var SheetDiff = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$5,
    getReferencedCommandIds: getReferencedCommandIds$2
};
var Schema;
exports.Schema = Schema;
exports.Cell = Cell;
exports.Row = Row;
exports.Worksheet = Worksheet;
exports.SheetDiff = SheetDiff; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 20229:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Uuid = __webpack_require__(97466);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__HtmlElement = __webpack_require__(47577);
var t_encode = Decco.stringToJson;
var t_decode = Decco.stringFromJson;
function make(param) {
    return Uuid.v1();
}
function stringify(id) {
    return id;
}
var cmp = $$String.compare;
var ContentScriptFailureId = {
    t_encode: t_encode,
    t_decode: t_decode,
    make: make,
    stringify: stringify,
    cmp: cmp
};
function t_encode$1(v) {
    if (v.TAG === /* ContentScriptFailure */ 0) {
        return [
            "ContentScriptFailure",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "ErrorMessage",
            Decco.stringToJson(v._0)
        ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentScriptFailure":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContentScriptFailure */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ErrorMessage":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ErrorMessage */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(responseError) {
    if (responseError.TAG === /* ContentScriptFailure */ 0) {
        return "ContentScriptFailure(failureId=" + (responseError._0 + ")");
    } else {
        return "ErrorMessage(" + (responseError._0 + ")");
    }
}
var ContentScriptResponseError = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function nthChild_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NthChild":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NthChild */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "OnlyChild":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OnlyChild */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function nthChild_encode(v) {
    if (v) {
        return [
            "NthChild",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "OnlyChild"
        ];
    }
}
function node_encode(v) {
    return Js_dict.fromArray([
        [
            "tag",
            Decco.stringToJson(v.tag)
        ],
        [
            "nthChild",
            nthChild_encode(v.nthChild)
        ]
    ]);
}
function node_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tag = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tag"), null));
    if (tag.TAG === /* Ok */ 0) {
        var nthChild = nthChild_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthChild"), null));
        if (nthChild.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    tag: tag._0,
                    nthChild: nthChild._0
                }
            };
        }
        var e = nthChild._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".nthChild" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = tag._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tag" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function nodesFromHtmlElement(htmlElement1) {
    var walkUp = function(htmlElement) {
        var tag = htmlElement.tagName.toLowerCase();
        var parentHtmlElement = Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.parentElement), Webapi__Dom__HtmlElement.ofElement);
        if (parentHtmlElement === undefined) {
            return [
                {
                    tag: tag,
                    nthChild: /* OnlyChild */ 0
                }
            ];
        }
        var parentHtmlElement$1 = Caml_option.valFromOption(parentHtmlElement);
        var siblingHtmlElemnts = Belt_Array.keepMap(Array.prototype.slice.call(parentHtmlElement$1.childNodes), Webapi__Dom__HtmlElement.ofNode);
        var index = siblingHtmlElemnts.findIndex(function(sibHtmlElement) {
            return sibHtmlElement === htmlElement;
        });
        var nthChild = index !== 0 || siblingHtmlElemnts.length !== 1 ? /* NthChild */ ({
            _0: index + 1 | 0
        }) : /* OnlyChild */ 0;
        return Belt_Array.concat(walkUp(parentHtmlElement$1), [
            {
                tag: tag,
                nthChild: nthChild
            }
        ]);
    };
    return walkUp(htmlElement1);
}
function asXPathExpr(nodes) {
    var separator = "/";
    return separator + Belt_Array.map(nodes, function(param) {
        var nthChild = param.nthChild;
        var tag = param.tag;
        if (nthChild) {
            return "" + tag + "[" + nthChild._0 + "]";
        } else {
            return tag;
        }
    }).join(separator);
}
var Path = {
    node_encode: node_encode,
    node_decode: node_decode,
    nthChild_encode: nthChild_encode,
    nthChild_decode: nthChild_decode,
    nodesFromHtmlElement: nodesFromHtmlElement,
    asXPathExpr: asXPathExpr
};
function t_encode$2(v) {
    return [
        "Path",
        Decco.arrayToJson(node_encode, v._0)
    ];
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Path") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.arrayFromJson(node_decode, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* Path */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$2(elementRef) {
    return "Path(" + (asXPathExpr(elementRef._0) + ")");
}
var ElementRef = {
    Path: Path,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2
};
exports.ContentScriptFailureId = ContentScriptFailureId;
exports.ContentScriptResponseError = ContentScriptResponseError;
exports.ElementRef = ElementRef; /* uuid Not a pure module */ 


/***/ }),

/***/ 54837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function recordingId_encode(id) {
    return id;
}
function recordingId_decode(json) {
    var num = Js_json.decodeNumber(json);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "recordingId_decode error",
                value: json
            }
        };
    }
}
function playbackId_encode(tabId) {
    return tabId;
}
function playbackId_decode(json) {
    var num = Js_json.decodeNumber(json);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "playbackId_decode error",
                value: json
            }
        };
    }
}
function makeRecordingId(id) {
    return id;
}
function makePlaybackId(id) {
    return id;
}
function asInt(id) {
    return id;
}
function stringOfRecordingId(id) {
    return String(id);
}
function stringOfPlaybackId(id) {
    return String(id);
}
var TabId = {
    recordingId_encode: recordingId_encode,
    recordingId_decode: recordingId_decode,
    playbackId_encode: playbackId_encode,
    playbackId_decode: playbackId_decode,
    makeRecordingId: makeRecordingId,
    makePlaybackId: makePlaybackId,
    asInt: asInt,
    stringOfRecordingId: stringOfRecordingId,
    stringOfPlaybackId: stringOfPlaybackId
};
function recordingId_encode$1(id) {
    return id;
}
function recordingId_decode$1(json) {
    var num = Js_json.decodeNumber(json);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "recordingId_decode error",
                value: json
            }
        };
    }
}
function playbackId_encode$1(tabId) {
    return tabId;
}
function playbackId_decode$1(json) {
    var num = Js_json.decodeNumber(json);
    if (num !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: num | 0
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "playbackId_decode error",
                value: json
            }
        };
    }
}
function makeRecordingId$1(id) {
    return id;
}
function makePlaybackId$1(id) {
    return id;
}
function asInt$1(id) {
    return id;
}
function stringOfRecordingId$1(id) {
    return String(id);
}
function stringOfPlaybackId$1(id) {
    return String(id);
}
var WindowId = {
    recordingId_encode: recordingId_encode$1,
    recordingId_decode: recordingId_decode$1,
    playbackId_encode: playbackId_encode$1,
    playbackId_decode: playbackId_decode$1,
    makeRecordingId: makeRecordingId$1,
    makePlaybackId: makePlaybackId$1,
    asInt: asInt$1,
    stringOfRecordingId: stringOfRecordingId$1,
    stringOfPlaybackId: stringOfPlaybackId$1
};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "recordingId",
            v.recordingId
        ],
        [
            "playbackId",
            Decco.optionToJson(playbackId_encode, v.playbackId)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var recordingId = recordingId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingId"), null));
    if (recordingId.TAG === /* Ok */ 0) {
        var playbackId = Decco.optionFromJson(playbackId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackId"), null));
        if (playbackId.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    recordingId: recordingId._0,
                    playbackId: playbackId._0
                }
            };
        }
        var e = playbackId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".playbackId" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = recordingId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".recordingId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function makeFromRecordingId(recordingId) {
    return {
        recordingId: recordingId,
        playbackId: undefined
    };
}
function assignPlaybackTabId(tabId, tabRef) {
    return {
        recordingId: tabRef.recordingId,
        playbackId: Caml_option.some(tabId)
    };
}
function equalsRecordingTabId(tabId, tabRef) {
    return Caml_obj.caml_equal(tabRef.recordingId, tabId);
}
function equalsPlaybackTabId(tabId, tabRef) {
    var playbackId = tabRef.playbackId;
    if (playbackId !== undefined) {
        return Caml_obj.caml_equal(Caml_option.valFromOption(playbackId), tabId);
    } else {
        return false;
    }
}
function getRecordingTabId(tabRef) {
    return tabRef.recordingId;
}
function getPlaybackTabId(tabRef) {
    return tabRef.playbackId;
}
function getPlaybackTabIdExn(tabRef) {
    var exnMessage = "Expected tab ref to have a playbackTabId";
    var playbackId = tabRef.playbackId;
    if (playbackId !== undefined) {
        return Caml_option.valFromOption(playbackId);
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError(exnMessage);
    }
}
function equalsTabRef(tabRefA, tabRefB) {
    return Caml_obj.caml_equal(tabRefA.recordingId, tabRefB.recordingId);
}
function stringify(param) {
    var recordingIdLabel = "recordingTabId";
    var playbackIdLabel = "playbackTabId";
    return "{" + (recordingIdLabel + ("=" + (String(param.recordingId) + (", " + (playbackIdLabel + ("=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.playbackId, stringOfPlaybackId)) + "}")))))));
}
var TabRef = {
    t_encode: t_encode,
    t_decode: t_decode,
    makeFromRecordingTabId: makeFromRecordingId,
    assignPlaybackTabId: assignPlaybackTabId,
    equalsTabRef: equalsTabRef,
    equalsRecordingTabId: equalsRecordingTabId,
    equalsPlaybackTabId: equalsPlaybackTabId,
    getRecordingTabId: getRecordingTabId,
    getPlaybackTabId: getPlaybackTabId,
    getPlaybackTabIdExn: getPlaybackTabIdExn,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "recordingId",
            v.recordingId
        ],
        [
            "playbackId",
            Decco.optionToJson(playbackId_encode$1, v.playbackId)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var recordingId = recordingId_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingId"), null));
    if (recordingId.TAG === /* Ok */ 0) {
        var playbackId = Decco.optionFromJson(playbackId_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackId"), null));
        if (playbackId.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    recordingId: recordingId._0,
                    playbackId: playbackId._0
                }
            };
        }
        var e = playbackId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".playbackId" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = recordingId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".recordingId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function makeFromRecordingId$1(recordingId) {
    return {
        recordingId: recordingId,
        playbackId: undefined
    };
}
function assignPlaybackWindowId(windowId, windowRef) {
    return {
        recordingId: windowRef.recordingId,
        playbackId: Caml_option.some(windowId)
    };
}
function equalsRecordingWindowId(windowId, windowRef) {
    return Caml_obj.caml_equal(windowRef.recordingId, windowId);
}
function equalsPlaybackWindowId(windowId, windowRef) {
    var playbackId = windowRef.playbackId;
    if (playbackId !== undefined) {
        return Caml_obj.caml_equal(Caml_option.valFromOption(playbackId), windowId);
    } else {
        return false;
    }
}
function getRecordingWindowId(windowRef) {
    return windowRef.recordingId;
}
function getPlaybackWindowId(windowRef) {
    return windowRef.playbackId;
}
function getPlaybackWindowIdExn(windowRef) {
    var exnMessage = "Expected tab ref to have a playbackWindowId";
    var playbackId = windowRef.playbackId;
    if (playbackId !== undefined) {
        return Caml_option.valFromOption(playbackId);
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError(exnMessage);
    }
}
function stringify$1(param) {
    var recordingIdLabel = "recordingWindowId";
    var playbackIdLabel = "playbackWindowId";
    return "{" + (recordingIdLabel + ("=" + (String(param.recordingId) + (", " + (playbackIdLabel + ("=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.playbackId, stringOfPlaybackId$1)) + "}")))))));
}
var WindowRef = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    makeFromRecordingWindowId: makeFromRecordingId$1,
    assignPlaybackWindowId: assignPlaybackWindowId,
    equalsRecordingWindowId: equalsRecordingWindowId,
    equalsPlaybackWindowId: equalsPlaybackWindowId,
    getRecordingWindowId: getRecordingWindowId,
    getPlaybackWindowId: getPlaybackWindowId,
    getPlaybackWindowIdExn: getPlaybackWindowIdExn,
    stringify: stringify$1
};
exports.TabId = TabId;
exports.WindowId = WindowId;
exports.TabRef = TabRef;
exports.WindowRef = WindowRef; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 41256:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function isArrowKey(key) {
    if (key === "ArrowLeft" || key === "ArrowRight" || key === "ArrowUp") {
        return true;
    } else {
        return key === "ArrowDown";
    }
}
var filteredKeyCodes = {
    hd: "Key[A-Z]",
    tl: {
        hd: "Digit[0-9]",
        tl: {
            hd: "Numpad[0-9]",
            tl: {
                hd: "Backquote",
                tl: {
                    hd: "Minus",
                    tl: {
                        hd: "Equal",
                        tl: {
                            hd: "Backspace",
                            tl: {
                                hd: "Delete",
                                tl: {
                                    hd: "Bracket",
                                    tl: {
                                        hd: "Backslash",
                                        tl: {
                                            hd: "Semicolon",
                                            tl: {
                                                hd: "Quote",
                                                tl: {
                                                    hd: "Comma",
                                                    tl: {
                                                        hd: "Period",
                                                        tl: {
                                                            hd: "Slash",
                                                            tl: {
                                                                hd: "Space",
                                                                tl: /* [] */ 0
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
var reVisual = new RegExp($$String.concat("|", filteredKeyCodes));
function isVisualCode(code) {
    return reVisual.test(code);
}
function isMetaCode(code) {
    switch(code){
        case "MetaLeft":
        case "MetaRight":
            return true;
        default:
            return false;
    }
}
function isModifierCode(code) {
    switch(code){
        case "AltLeft":
        case "AltRight":
        case "ControlLeft":
        case "ControlRight":
        case "MetaLeft":
        case "MetaRight":
        case "ShiftLeft":
        case "ShiftRight":
            return true;
        default:
            return false;
    }
}
var reCode = /^Key(.)$/;
var reDigitCode = /^Digit(\d)$/;
var reNumpadCode = /^Numpad(\d)$/;
function processRegExExecResult(result) {
    Curry._2(Log$SmartcutsMacros.keyLogic.log2, "Captures", result);
    var nullableString = ArrayUtils$SmartcutsMacros.get(1, result);
    if (nullableString === undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected match");
    }
    var arg = Caml_option.nullable_to_opt(Caml_option.valFromOption(nullableString));
    return (function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    })("Expected at least 1 regex capture").toLowerCase();
}
function getCharFromCode(key, code) {
    var result = reCode.exec(code);
    if (result !== null) {
        return processRegExExecResult(result);
    }
    var result$1 = reDigitCode.exec(code);
    if (result$1 !== null) {
        return processRegExExecResult(result$1);
    }
    var result$2 = reNumpadCode.exec(code);
    if (result$2 !== null) {
        return processRegExExecResult(result$2);
    } else {
        Curry._3(Log$SmartcutsMacros.keyLogic.log3, "NO CAPTURES or exact match", code, reCode);
        return key;
    }
}
var keyCodesAssocWithCursorMove = {
    hd: 37,
    tl: {
        hd: 38,
        tl: {
            hd: 39,
            tl: {
                hd: 40,
                tl: /* [] */ 0
            }
        }
    }
};
exports.keyCodesAssocWithCursorMove = keyCodesAssocWithCursorMove;
exports.isArrowKey = isArrowKey;
exports.filteredKeyCodes = filteredKeyCodes;
exports.reVisual = reVisual;
exports.isVisualCode = isVisualCode;
exports.isMetaCode = isMetaCode;
exports.isModifierCode = isModifierCode;
exports.reCode = reCode;
exports.reDigitCode = reDigitCode;
exports.reNumpadCode = reNumpadCode;
exports.getCharFromCode = getCharFromCode; /* reVisual Not a pure module */ 


/***/ }),

/***/ 93777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function t_encode(v) {
    if (v) {
        return [
            "AskOnlyForPasswordAgain"
        ];
    } else {
        return [
            "AskForUsernamePassword"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AskForUsernamePassword":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AskForUsernamePassword */ 0
                    };
                }
            case "AskOnlyForPasswordAgain":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AskOnlyForPasswordAgain */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function indexOf(loginScenario) {
    if (loginScenario) {
        return 1;
    } else {
        return 0;
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.indexOf = indexOf; /* No side effect */ 


/***/ }),

/***/ 26553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Map = __webpack_require__(26810);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var CommandLog$SmartcutsMacros = __webpack_require__(23831);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
function t_encode(v) {
    if (v.TAG === /* InstalledSmartcutPointer */ 0) {
        return [
            "InstalledSmartcutPointer",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
        ];
    } else {
        return [
            "SmartcutPointer",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InstalledSmartcutPointer":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InstalledSmartcutPointer */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SmartcutPointer":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SmartcutPointer */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function getSmartcutPageUrl(v) {
    if (v.TAG === /* InstalledSmartcutPointer */ 0) {
        return "/app/my_smartcuts/" + v._0;
    } else {
        return "/smartcuts/" + v._0;
    }
}
function stringify(v) {
    if (v.TAG === /* InstalledSmartcutPointer */ 0) {
        return "InstalledSmartcutPointer(" + v._0 + ")";
    } else {
        return "SmartcutPointer(" + v._0 + ")";
    }
}
var SmartcutOrInstalledSmartcutPointer = {
    t_encode: t_encode,
    t_decode: t_decode,
    getSmartcutPageUrl: getSmartcutPageUrl,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "loginBeforeStepIds",
            Decco.arrayToJson(Decco.intToJson, v.loginBeforeStepIds)
        ],
        [
            "smartcutOrInstalledSmartcutPointer",
            t_encode(v.smartcutOrInstalledSmartcutPointer)
        ],
        [
            "smartcutName",
            Decco.stringToJson(v.smartcutName)
        ],
        [
            "commandLog",
            CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var loginBeforeStepIds = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginBeforeStepIds"), null));
    if (loginBeforeStepIds.TAG === /* Ok */ 0) {
        var smartcutOrInstalledSmartcutPointer = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutOrInstalledSmartcutPointer"), null));
        if (smartcutOrInstalledSmartcutPointer.TAG === /* Ok */ 0) {
            var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
            if (smartcutName.TAG === /* Ok */ 0) {
                var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
                if (commandLog.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            loginBeforeStepIds: loginBeforeStepIds._0,
                            smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer._0,
                            smartcutName: smartcutName._0,
                            commandLog: commandLog._0
                        }
                    };
                }
                var e = commandLog._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".commandLog" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = smartcutName._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".smartcutName" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = smartcutOrInstalledSmartcutPointer._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".smartcutOrInstalledSmartcutPointer" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = loginBeforeStepIds._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".loginBeforeStepIds" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function minify(param) {
    return {
        loginBeforeStepIds: param.loginBeforeStepIds,
        smartcutOrInstalledSmartcutPointer: param.smartcutOrInstalledSmartcutPointer,
        smartcutName: param.smartcutName,
        commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(param.commandLog)
    };
}
var SmartcutNameAndCommandLogData = {};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "smartcutOrInstalledSmartcutPointer",
            t_encode(v.smartcutOrInstalledSmartcutPointer)
        ],
        [
            "version",
            Decco.intToJson(v.version)
        ],
        [
            "loginBeforeStepIds",
            Decco.arrayToJson(Decco.intToJson, v.loginBeforeStepIds)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var smartcutOrInstalledSmartcutPointer = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutOrInstalledSmartcutPointer"), null));
    if (smartcutOrInstalledSmartcutPointer.TAG === /* Ok */ 0) {
        var version = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "version"), null));
        if (version.TAG === /* Ok */ 0) {
            var loginBeforeStepIds = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginBeforeStepIds"), null));
            if (loginBeforeStepIds.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer._0,
                        version: version._0,
                        loginBeforeStepIds: loginBeforeStepIds._0
                    }
                };
            }
            var e = loginBeforeStepIds._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".loginBeforeStepIds" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = version._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".version" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = smartcutOrInstalledSmartcutPointer._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".smartcutOrInstalledSmartcutPointer" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var Ref = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function toRef(param) {
    return {
        smartcutOrInstalledSmartcutPointer: param.smartcutOrInstalledSmartcutPointer,
        version: 1,
        loginBeforeStepIds: param.loginBeforeStepIds
    };
}
function t__encode(v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_encode, t_encode$1), v);
}
function t__decode(v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_decode, t_decode$1), v);
}
function castFromMap(x) {
    return x;
}
function isEmpty(v) {
    return Belt_MapString.size(v) === 0;
}
function minify$1(map1) {
    return Belt_MapString.map(map1, function(map2) {
        return Belt_Map.map(map2, minify);
    });
}
function hasAnyLoginSmartcuts(loginSmartcutsByHostnameAndScenario) {
    return Belt_MapString.some(loginSmartcutsByHostnameAndScenario, function(_hostname, map) {
        return Belt_Map.size(map) > 0;
    });
}
function hasNoLoginSmartcutsForHostname(loginSmartcutsByHostnameAndScenario, hostname) {
    var mapLoginScenario = Belt_MapString.get(loginSmartcutsByHostnameAndScenario, hostname);
    if (mapLoginScenario !== undefined) {
        return Belt_Map.size(Caml_option.valFromOption(mapLoginScenario)) === 0;
    } else {
        return true;
    }
}
function toRefsByHostnameAndScenario(loginSmartcutsByHostnameAndScenario) {
    return Belt_MapString.map(loginSmartcutsByHostnameAndScenario, function(map) {
        return Belt_Map.map(map, toRef);
    });
}
function getHostnamesWithAtLeastOneLoginSmartcut(loginSmartcutsByHostnameAndScenario) {
    return Belt_Array.keepMap(Belt_MapString.toArray(loginSmartcutsByHostnameAndScenario), function(param) {
        var _n = Belt_Map.size(param[1]);
        if (_n !== 0) {
            return param[0];
        }
    });
}
function getPairsOfLoginScenarioAndLoginSmartcutForHostname(loginSmartcutsByHostnameAndScenario, hostname) {
    var arg = Belt_Option.map(Belt_MapString.get(loginSmartcutsByHostnameAndScenario, hostname), Belt_Map.toArray);
    var param = [];
    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}
function concatAllLoginCommandLogsIntoSingleCommandLog(smartcutLoginsByHostnameAndScenario) {
    var arg = Belt_MapString.valuesToArray(smartcutLoginsByHostnameAndScenario);
    return Belt_List.concatMany(Belt_Array.map(function(param) {
        return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
    }(Belt_Map.valuesToArray), function(param) {
        return param.commandLog;
    }));
}
function prependCommandsToCommandLog(smartcutLoginsByHostnameAndScenario, commandLog) {
    return List.append(concatAllLoginCommandLogsIntoSingleCommandLog(smartcutLoginsByHostnameAndScenario), commandLog);
}
function reduce(smartcutLoginsByHostnameAndScenario, init, f) {
    return Belt_MapString.reduce(smartcutLoginsByHostnameAndScenario, init, function(accum1, hostname, loginSmartcutByLoginScenario) {
        return Belt_Map.reduce(loginSmartcutByLoginScenario, accum1, function(accum, loginScenario, loginSmartcut) {
            return Curry._4(f, accum, hostname, loginScenario, loginSmartcut);
        });
    });
}
function removeLoginSmartcutForHostname(smartcutLoginsByHostnameAndScenario, hostname, loginSmartcutAsSmartcutOrPointer) {
    var map = Belt_MapString.get(smartcutLoginsByHostnameAndScenario, hostname);
    if (map === undefined) {
        return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
    }
    var map$1 = Caml_option.valFromOption(map);
    if (Belt_Map.size(map$1) <= 0) {
        return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
    }
    var emptyMap = Belt_Map.keep(map$1, function(_key, param) {
        return Caml_obj.caml_notequal(param.smartcutOrInstalledSmartcutPointer, loginSmartcutAsSmartcutOrPointer);
    });
    if (Belt_Map.isEmpty(emptyMap)) {
        return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
    } else {
        return Belt_MapString.set(smartcutLoginsByHostnameAndScenario, hostname, emptyMap);
    }
}
var ByHostnameAndScenario = {
    t__encode: t__encode,
    t__decode: t__decode,
    castFromMap: castFromMap,
    toRefsByHostnameAndScenario: toRefsByHostnameAndScenario,
    empty: undefined,
    isEmpty: isEmpty,
    minify: minify$1,
    hasAnyLoginSmartcuts: hasAnyLoginSmartcuts,
    hasNoLoginSmartcutsForHostname: hasNoLoginSmartcutsForHostname,
    getHostnames: Belt_MapString.keysToArray,
    getHostnamesWithAtLeastOneLoginSmartcut: getHostnamesWithAtLeastOneLoginSmartcut,
    prependCommandsToCommandLog: prependCommandsToCommandLog,
    getPairsOfLoginScenarioAndLoginSmartcutForHostname: getPairsOfLoginScenarioAndLoginSmartcutForHostname,
    reduce: reduce,
    removeLoginSmartcutForHostname: removeLoginSmartcutForHostname
};
function t_encode$3(v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_encode, t_encode$2), v);
}
function t_decode$3(v) {
    return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_decode, t_decode$2), v);
}
function hydrate(loginSmartcutRefsByHostnameAndScenario, loginSmartcuts) {
    return Curry._1(castFromMap, Belt_MapString.map(loginSmartcutRefsByHostnameAndScenario, function(mapLoginScenario) {
        return CustomMap$SmartcutsMacros.MapLoginScenario.keepMap(mapLoginScenario, function(loginScenario, param1) {
            var loginBeforeStepIds = param1.loginBeforeStepIds;
            var smartcutOrInstalledSmartcutPointer = param1.smartcutOrInstalledSmartcutPointer;
            return ArrayUtils$SmartcutsMacros.shortcut(function(param) {
                var match = param[1];
                var commandLogData = match.commandLogData;
                if (commandLogData.TAG === /* Decoded */ 0 && Caml_obj.caml_equal(param[0], smartcutOrInstalledSmartcutPointer)) {
                    return [
                        loginScenario,
                        {
                            loginBeforeStepIds: loginBeforeStepIds,
                            smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer,
                            smartcutName: match.smartcutName,
                            commandLog: commandLogData._0
                        }
                    ];
                }
            }, loginSmartcuts);
        });
    }));
}
var RefsByHostnameAndScenario = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    hydrate: hydrate
};
exports.SmartcutOrInstalledSmartcutPointer = SmartcutOrInstalledSmartcutPointer;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.minify = minify;
exports.SmartcutNameAndCommandLogData = SmartcutNameAndCommandLogData;
exports.Ref = Ref;
exports.toRef = toRef;
exports.ByHostnameAndScenario = ByHostnameAndScenario;
exports.RefsByHostnameAndScenario = RefsByHostnameAndScenario; /* CustomMap-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 33595:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Js_dict = __webpack_require__(97076);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
function blob(blob$1) {
    return blob$1;
}
function file(file$1) {
    return file$1;
}
function string(str) {
    return str;
}
function promise(promise$1) {
    return promise$1;
}
var JsType = {
    blob: blob,
    file: file,
    string: string,
    promise: promise
};
function toJsType(data) {
    switch(data.TAG | 0){
        case /* Blob */ 0:
        case /* File */ 1:
        case /* String */ 2:
            return data._0;
        case /* Promise */ 3:
            return data._0.then(function(resolved) {
                switch(resolved.TAG | 0){
                    case /* Blob */ 0:
                    case /* File */ 1:
                    case /* String */ 2:
                        return Promise.resolve(resolved._0);
                }
            });
    }
}
var ClipboardItemData = {
    JsType: JsType,
    toJsType: toJsType
};
function view(type_) {
    return type_;
}
var Type = {
    view: view
};
function make(maybePresentationStyle, clipboardDataByType) {
    var maybeInitOptionsWithString = Belt_Option.map(maybePresentationStyle, function(presentationStyle) {
        return {
            presentationStyle: presentationStyle
        };
    });
    return new ClipboardItem(Js_dict.fromArray(Belt_MapString.toArray(Belt_MapString.map(clipboardDataByType, toJsType))), maybeInitOptionsWithString);
}
function ClipboardItem_types(prim) {
    return prim.types;
}
function ClipboardItem_getByType(prim0, prim1) {
    return prim0.getType(prim1);
}
var ClipboardItem$1 = {
    Type: Type,
    types: ClipboardItem_types,
    getByType: ClipboardItem_getByType,
    make: make
};
function readText(prim) {
    return navigator.clipboard.readText();
}
function writeText(prim) {
    return navigator.clipboard.writeText(prim);
}
function read(prim) {
    return navigator.clipboard.read();
}
function write(prim) {
    return navigator.clipboard.write(prim);
}
exports.ClipboardItemData = ClipboardItemData;
exports.ClipboardItem = ClipboardItem$1;
exports.readText = readText;
exports.writeText = writeText;
exports.read = read;
exports.write = write; /* No side effect */ 


/***/ }),

/***/ 86090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
function t_encode(v) {
    switch(v){
        case /* Google */ 0:
            return [
                "Google"
            ];
        case /* Facebook */ 1:
            return [
                "Facebook"
            ];
        case /* Twitter */ 2:
            return [
                "Twitter"
            ];
        case /* LinkedIn */ 3:
            return [
                "LinkedIn"
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Facebook":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Facebook */ 1
                    };
                }
            case "Google":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Google */ 0
                    };
                }
            case "LinkedIn":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* LinkedIn */ 3
                    };
                }
            case "Twitter":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Twitter */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var allOauthProviders = [
    /* Google */ 0,
    /* Facebook */ 1,
    /* Twitter */ 2,
    /* LinkedIn */ 3
];
function stringify(oauthProvider) {
    switch(oauthProvider){
        case /* Google */ 0:
            return "Google";
        case /* Facebook */ 1:
            return "Facebook";
        case /* Twitter */ 2:
            return "Twitter";
        case /* LinkedIn */ 3:
            return "LinkedIn";
    }
}
function doesUrlMatchProvider(url1, provider) {
    var tmp;
    switch(provider){
        case /* Google */ 0:
            tmp = [
                "com",
                "google"
            ];
            break;
        case /* Facebook */ 1:
            tmp = [
                "com",
                "facebook"
            ];
            break;
        case /* Twitter */ 2:
            tmp = [
                "com",
                "twitter"
            ];
            break;
        case /* LinkedIn */ 3:
            tmp = [
                "com",
                "linkedin"
            ];
            break;
    }
    return Caml_obj.caml_equal(Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(url1), function(url) {
        return Belt_Array.slice(Belt_Array.reverse(url.hostname.split(".")), 0, 2);
    }), tmp);
}
function getHostname(oauthProvider) {
    switch(oauthProvider){
        case /* Google */ 0:
            return "https://accounts.google.com";
        case /* Facebook */ 1:
            return "https://www.facebook.com";
        case /* Twitter */ 2:
            return "https://twitter.com";
        case /* LinkedIn */ 3:
            return "https://www.linkedin.com";
    }
}
function maybeMatchingOAuthProviderFromUrl(url) {
    return Belt_Array.getBy(allOauthProviders, function(provider) {
        switch(provider){
            case /* Google */ 0:
                return url.startsWith("https://accounts.google.com/o/oauth2/auth");
            case /* Facebook */ 1:
                return /https:\/\/www\.facebook\.com\/v\.\d+\.\d+\/dialog\/oauth/.test(url);
            case /* Twitter */ 2:
                return url.startsWith("https://api.twitter.com/oauth/");
            case /* LinkedIn */ 3:
                return url.startsWith("https://www.linkedin.com/oauth/v2/authorization");
        }
    });
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.allOauthProviders = allOauthProviders;
exports.stringify = stringify;
exports.doesUrlMatchProvider = doesUrlMatchProvider;
exports.getHostname = getHostname;
exports.maybeMatchingOAuthProviderFromUrl = maybeMatchingOAuthProviderFromUrl; /* URLUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 71191:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var t_encode = Decco.stringToJson;
var t_decode = Decco.stringFromJson;
function fromString(x) {
    return x;
}
function obfuscate(param) {
    return "********";
}
function toString(x) {
    return x;
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.fromString = fromString;
exports.obfuscate = obfuscate;
exports.toString = toString; /* No side effect */ 


/***/ }),

/***/ 14724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var Browser__Windows$SmartcutsMacros = __webpack_require__(49325);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function bridgeWindows_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowIdsInBackgroundMode = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowIdsInBackgroundMode"), null));
    if (windowIdsInBackgroundMode.TAG === /* Ok */ 0) {
        var minimizedWindowIdMapPlaybackTabId = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "minimizedWindowIdMapPlaybackTabId"), null));
        if (minimizedWindowIdMapPlaybackTabId.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    windowIdsInBackgroundMode: windowIdsInBackgroundMode._0,
                    minimizedWindowIdMapPlaybackTabId: minimizedWindowIdMapPlaybackTabId._0
                }
            };
        }
        var e = minimizedWindowIdMapPlaybackTabId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".minimizedWindowIdMapPlaybackTabId" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = windowIdsInBackgroundMode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowIdsInBackgroundMode" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function bridgeWindows_encode(v) {
    return Js_dict.fromArray([
        [
            "windowIdsInBackgroundMode",
            Decco.arrayToJson(Decco.intToJson, v.windowIdsInBackgroundMode)
        ],
        [
            "minimizedWindowIdMapPlaybackTabId",
            CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_encode, v.minimizedWindowIdMapPlaybackTabId)
        ]
    ]);
}
function t_encode(v) {
    if (v) {
        return [
            "Windows",
            bridgeWindows_encode(v._0)
        ];
    } else {
        return [
            "MacOsAndUnixLike"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "MacOsAndUnixLike":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MacOsAndUnixLike */ 0
                    };
                }
            case "Windows":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = bridgeWindows_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Windows */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(osBridge) {
    if (!osBridge) {
        return "MacOsAndUnixLike";
    }
    var match = osBridge._0;
    return "Windows({windowIdsInBackgroundMode: [" + (Belt_Array.map(match.windowIdsInBackgroundMode, function(prim) {
        return String(prim);
    }).join(", ") + ("], minimizedWindows: [" + (Belt_Array.map(Belt_MapInt.keysToArray(match.minimizedWindowIdMapPlaybackTabId), function(prim) {
        return String(prim);
    }).join(", ") + "]})")));
}
function doesRequireWindowsBackgroundModeSupport(windowId, osBridge) {
    if (osBridge) {
        return $$Array.mem(windowId, osBridge._0.windowIdsInBackgroundMode);
    } else {
        return false;
    }
}
function markWindowIdAsMinimized(windowId, playbackTabId, osBridge) {
    if (!osBridge) {
        return /* MacOsAndUnixLike */ 0;
    }
    var bridgeWindows = osBridge._0;
    return /* Windows */ {
        _0: {
            windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
            minimizedWindowIdMapPlaybackTabId: Belt_MapInt.set(bridgeWindows.minimizedWindowIdMapPlaybackTabId, windowId, playbackTabId)
        }
    };
}
function markWindowIdAsNotMinimized(windowId, osBridge) {
    if (!osBridge) {
        return /* MacOsAndUnixLike */ 0;
    }
    var bridgeWindows = osBridge._0;
    return /* Windows */ {
        _0: {
            windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
            minimizedWindowIdMapPlaybackTabId: Belt_MapInt.remove(bridgeWindows.minimizedWindowIdMapPlaybackTabId, windowId)
        }
    };
}
function isWindowMinimized(windowId, osBridge) {
    if (osBridge) {
        return Belt_MapInt.has(osBridge._0.minimizedWindowIdMapPlaybackTabId, windowId);
    } else {
        return false;
    }
}
function maybeMinimizedWindowIdForTab(tabId, osBridge) {
    if (!osBridge) {
        return;
    }
    var arg = Belt_MapInt.toArray(osBridge._0.minimizedWindowIdMapPlaybackTabId);
    var param = function param(param$1) {
        if (Caml_obj.caml_equal(tabId, param$1[1])) {
            return param$1[0];
        }
    };
    return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
}
function createWindowWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpenerOpt, param1) {
    var setSelfAsOpener = setSelfAsOpenerOpt !== undefined ? setSelfAsOpenerOpt : true;
    if (focused !== undefined && !focused && Caml_obj.caml_notequal(state, "minimized")) {
        return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, undefined, undefined, undefined, undefined, undefined, incognito, type_, "minimized", setSelfAsOpener, undefined).then(function($$window) {
            var arg = $$window.id;
            var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
            var windowId = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expect window.id");
            return Browser__Windows$SmartcutsMacros.update(windowId, left, top, width, height, focused, undefined, state, undefined);
        });
    }
    return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined);
}
function createWindowWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpenerOpt, param2) {
    var setSelfAsOpener = setSelfAsOpenerOpt !== undefined ? setSelfAsOpenerOpt : true;
    if (focused !== undefined && !focused && Caml_obj.caml_notequal(state, "minimized")) {
        return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, undefined, undefined, undefined, undefined, undefined, incognito, type_, "minimized", setSelfAsOpener, undefined).then(function($$window) {
            var arg = $$window.id;
            var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
            var windowId = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expect window.id");
            return Browser__Windows$SmartcutsMacros.update(windowId, left, top, width, height, focused, undefined, state, undefined);
        });
    }
    return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined);
}
function createTab(maybeWindowId, index, url, active, selected, pinned, openerTabId, osBridge) {
    if (maybeWindowId !== undefined && doesRequireWindowsBackgroundModeSupport(maybeWindowId, osBridge)) {
        return Browser__Windows$SmartcutsMacros.update(maybeWindowId, undefined, undefined, undefined, undefined, undefined, undefined, "minimized", undefined).then(function(_window) {
            return Browser__Tabs$SmartcutsMacros.create(maybeWindowId, index, url, active, selected, pinned, openerTabId, undefined);
        }).then(function(tab) {
            var arg = tab.id;
            var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
            var tabId = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expect tab.id");
            var nextPlaybackBridgeOs;
            if (osBridge) {
                var bridgeWindows = osBridge._0;
                nextPlaybackBridgeOs = /* Windows */ {
                    _0: {
                        windowIdsInBackgroundMode: bridgeWindows.windowIdsInBackgroundMode,
                        minimizedWindowIdMapPlaybackTabId: Belt_MapInt.set(bridgeWindows.minimizedWindowIdMapPlaybackTabId, maybeWindowId, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.makePlaybackId(tabId))
                    }
                };
            } else {
                nextPlaybackBridgeOs = Util$SmartcutsMacros.logAndRaiseJsError("Expect Windows(_) when calling Windows.createTab()");
            }
            return Promise.resolve([
                tab,
                nextPlaybackBridgeOs
            ]);
        });
    }
    return Browser__Tabs$SmartcutsMacros.create(maybeWindowId, index, url, active, selected, pinned, openerTabId, undefined).then(function(tab) {
        return Promise.resolve([
            tab,
            osBridge
        ]);
    });
}
var Windows = {
    createWindowWithNoUrl: createWindowWithNoUrl,
    createWindowWithUrl: createWindowWithUrl,
    createTab: createTab
};
var MacOsAndUnixLike = {
    createWindowWithNoUrl: Browser__Windows$SmartcutsMacros.createWithNoUrl,
    createWindowWithUrl: Browser__Windows$SmartcutsMacros.createWithUrl,
    createTab: Browser__Tabs$SmartcutsMacros.create
};
function fromBrowserPlatformOs(platformOs) {
    if (platformOs !== 1) {
        return /* MacOsAndUnixLike */ 0;
    } else {
        return /* Windows */ {
            _0: {
                windowIdsInBackgroundMode: [],
                minimizedWindowIdMapPlaybackTabId: undefined
            }
        };
    }
}
function createWindowWithNoUrl$1(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, osBridge) {
    if (!osBridge) {
        return Browser__Windows$SmartcutsMacros.createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function($$window) {
            return Promise.resolve([
                $$window,
                osBridge
            ]);
        });
    }
    var bridgeWindows = osBridge._0;
    var windowIdsInBackgroundMode = bridgeWindows.windowIdsInBackgroundMode;
    return createWindowWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function($$window) {
        var arg = $$window.id;
        var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
        var windowId = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }("Expect to get windowId");
        return Promise.resolve([
            $$window,
            /* Windows */ {
                _0: {
                    windowIdsInBackgroundMode: Belt_Array.concat(windowIdsInBackgroundMode, [
                        windowId
                    ]),
                    minimizedWindowIdMapPlaybackTabId: bridgeWindows.minimizedWindowIdMapPlaybackTabId
                }
            }
        ]);
    });
}
function createWindowWithUrl$1(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, osBridge) {
    if (!osBridge) {
        return Browser__Windows$SmartcutsMacros.createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function($$window) {
            return Promise.resolve([
                $$window,
                osBridge
            ]);
        });
    }
    var bridgeWindows = osBridge._0;
    var windowIdsInBackgroundMode = bridgeWindows.windowIdsInBackgroundMode;
    return createWindowWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, undefined).then(function($$window) {
        var arg = $$window.id;
        var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
        var windowId = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }("Expect to get windowId");
        return Promise.resolve([
            $$window,
            /* Windows */ {
                _0: {
                    windowIdsInBackgroundMode: Belt_Array.concat(windowIdsInBackgroundMode, [
                        windowId
                    ]),
                    minimizedWindowIdMapPlaybackTabId: bridgeWindows.minimizedWindowIdMapPlaybackTabId
                }
            }
        ]);
    });
}
function createTab$1(windowId, index, url, active, selected, pinned, openerTabId, osBridge) {
    if (osBridge) {
        return createTab(windowId, index, url, active, selected, pinned, openerTabId, osBridge);
    } else {
        return Browser__Tabs$SmartcutsMacros.create(windowId, index, url, active, selected, pinned, openerTabId, undefined).then(function(tab) {
            return Promise.resolve([
                tab,
                osBridge
            ]);
        });
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.bridgeWindows_encode = bridgeWindows_encode;
exports.bridgeWindows_decode = bridgeWindows_decode;
exports.stringify = stringify;
exports.doesRequireWindowsBackgroundModeSupport = doesRequireWindowsBackgroundModeSupport;
exports.markWindowIdAsMinimized = markWindowIdAsMinimized;
exports.markWindowIdAsNotMinimized = markWindowIdAsNotMinimized;
exports.isWindowMinimized = isWindowMinimized;
exports.maybeMinimizedWindowIdForTab = maybeMinimizedWindowIdForTab;
exports.Windows = Windows;
exports.MacOsAndUnixLike = MacOsAndUnixLike;
exports.fromBrowserPlatformOs = fromBrowserPlatformOs;
exports.createWindowWithNoUrl = createWindowWithNoUrl$1;
exports.createWindowWithUrl = createWindowWithUrl$1;
exports.createTab = createTab$1; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 84094:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Config$SmartcutsMacros = __webpack_require__(55838);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var schemaVersion = "0.0.1";
function t_encode(v) {
    if (v) {
        return [
            "StartOnTab",
            Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
        ];
    } else {
        return [
            "StartOnNewWindow"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "StartOnNewWindow":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* StartOnNewWindow */ 0
                    };
                }
            case "StartOnTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* StartOnTab */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(context) {
    if (!context) {
        return "StartOnNewWindow";
    }
    var arg = context._0.id;
    return "StartOnTab(tabId=" + (function(param) {
        return OptionUtils$SmartcutsMacros.stringify(param, arg);
    }(function(prim) {
        return String(prim);
    }) + ")");
}
var StartContext = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    if (v) {
        return [
            "DocumentExecCommand"
        ];
    } else {
        return [
            "BgDispatchShortcutKeys"
        ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BgDispatchShortcutKeys":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BgDispatchShortcutKeys */ 0
                    };
                }
            case "DocumentExecCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DocumentExecCommand */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var FallbackStrategy = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "DocumentExecCommand"
            ];
        } else {
            return [
                "BgDispatchShortcutKeys"
            ];
        }
    } else {
        return [
            "AttemptEmitFakePasteWithFallback",
            t_encode$1(v._0)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AttemptEmitFakePasteWithFallback":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AttemptEmitFakePasteWithFallback */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "BgDispatchShortcutKeys":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* BgDispatchShortcutKeys */ 0
                    };
                }
            case "DocumentExecCommand":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DocumentExecCommand */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var HybridPlaybackStrategy__PasteStrategy = {
    FallbackStrategy: FallbackStrategy,
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "pasteStrategy",
            t_encode$2(v.pasteStrategy)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var pasteStrategy = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict._0, "pasteStrategy"), null));
    if (pasteStrategy.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                pasteStrategy: pasteStrategy._0
            }
        };
    }
    var e = pasteStrategy._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".pasteStrategy" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
var HybridPlaybackStrategy = {
    t_encode: t_encode$3,
    t_decode: t_decode$3
};
function t_encode$4(v) {
    if (v) {
        return [
            "Hybrid",
            t_encode$3(v._0)
        ];
    } else {
        return [
            "ContentScriptOnly"
        ];
    }
}
function t_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentScriptOnly":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentScriptOnly */ 0
                    };
                }
            case "Hybrid":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Hybrid */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var PlaybackStrategy = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function t_encode$5(v) {
    if (v) {
        return [
            "UseVirtualAndNativeClipboard"
        ];
    } else {
        return [
            "OnlyUseVirtualClipboard"
        ];
    }
}
function t_decode$5(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OnlyUseVirtualClipboard":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OnlyUseVirtualClipboard */ 0
                    };
                }
            case "UseVirtualAndNativeClipboard":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UseVirtualAndNativeClipboard */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var ClipboardBehavior = {
    t_encode: t_encode$5,
    t_decode: t_decode$5
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "millisecondsBetweenCommands",
            Decco.intToJson(v.millisecondsBetweenCommands)
        ],
        [
            "millisecondsBetweenTypingCharacter",
            Decco.intToJson(v.millisecondsBetweenTypingCharacter)
        ],
        [
            "millisecondsBetweenKeyDownKeyUp",
            Decco.intToJson(v.millisecondsBetweenKeyDownKeyUp)
        ],
        [
            "millisecondsBetweenTypingCharacterAndNonCharacterKeypress",
            Decco.intToJson(v.millisecondsBetweenTypingCharacterAndNonCharacterKeypress)
        ],
        [
            "useFastestTypePlayback",
            Decco.boolToJson(v.useFastestTypePlayback)
        ],
        [
            "preserveClipboard",
            Decco.boolToJson(v.preserveClipboard)
        ],
        [
            "clipboardBehavior",
            Decco.optionToJson(t_encode$5, v.clipboardBehavior)
        ],
        [
            "startContext",
            t_encode(v.startContext)
        ],
        [
            "closeWindowWhenFinish",
            Decco.boolToJson(v.closeWindowWhenFinish)
        ],
        [
            "doNotFocus",
            Decco.boolToJson(v.doNotFocus)
        ],
        [
            "playbackStrategy",
            t_encode$4(v.playbackStrategy)
        ],
        [
            "replaceUiCommandsWithApiCommands",
            Decco.boolToJson(v.replaceUiCommandsWithApiCommands)
        ],
        [
            "msBeforeNextCommand",
            Decco.arrayToJson(Decco.intToJson, v.msBeforeNextCommand)
        ],
        [
            "selectorTimeout",
            Util$SmartcutsMacros.HasDefault.t_encode(Decco.floatToJson, v.selectorTimeout)
        ],
        [
            "domSnapshots",
            Decco.boolToJson(v.domSnapshots)
        ],
        [
            "doNotShowSplashScreen",
            Decco.boolToJson(v.doNotShowSplashScreen)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var millisecondsBetweenCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenCommands"), null));
    if (millisecondsBetweenCommands.TAG === /* Ok */ 0) {
        var millisecondsBetweenTypingCharacter = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacter"), null));
        if (millisecondsBetweenTypingCharacter.TAG === /* Ok */ 0) {
            var millisecondsBetweenKeyDownKeyUp = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenKeyDownKeyUp"), null));
            if (millisecondsBetweenKeyDownKeyUp.TAG === /* Ok */ 0) {
                var millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacterAndNonCharacterKeypress"), null));
                if (millisecondsBetweenTypingCharacterAndNonCharacterKeypress.TAG === /* Ok */ 0) {
                    var useFastestTypePlayback = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "useFastestTypePlayback"), null));
                    if (useFastestTypePlayback.TAG === /* Ok */ 0) {
                        var preserveClipboard = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "preserveClipboard"), null));
                        if (preserveClipboard.TAG === /* Ok */ 0) {
                            var clipboardBehavior = Decco.optionFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardBehavior"), null));
                            if (clipboardBehavior.TAG === /* Ok */ 0) {
                                var startContext = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
                                if (startContext.TAG === /* Ok */ 0) {
                                    var closeWindowWhenFinish = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "closeWindowWhenFinish"), null));
                                    if (closeWindowWhenFinish.TAG === /* Ok */ 0) {
                                        var doNotFocus = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotFocus"), null));
                                        if (doNotFocus.TAG === /* Ok */ 0) {
                                            var playbackStrategy = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackStrategy"), null));
                                            if (playbackStrategy.TAG === /* Ok */ 0) {
                                                var replaceUiCommandsWithApiCommands = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceUiCommandsWithApiCommands"), null));
                                                if (replaceUiCommandsWithApiCommands.TAG === /* Ok */ 0) {
                                                    var msBeforeNextCommand = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
                                                    if (msBeforeNextCommand.TAG === /* Ok */ 0) {
                                                        var selectorTimeout = Util$SmartcutsMacros.HasDefault.t_decode(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorTimeout"), null));
                                                        if (selectorTimeout.TAG === /* Ok */ 0) {
                                                            var domSnapshots = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domSnapshots"), null));
                                                            if (domSnapshots.TAG === /* Ok */ 0) {
                                                                var doNotShowSplashScreen = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotShowSplashScreen"), null));
                                                                if (doNotShowSplashScreen.TAG === /* Ok */ 0) {
                                                                    return {
                                                                        TAG: /* Ok */ 0,
                                                                        _0: {
                                                                            millisecondsBetweenCommands: millisecondsBetweenCommands._0,
                                                                            millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter._0,
                                                                            millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp._0,
                                                                            millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0,
                                                                            useFastestTypePlayback: useFastestTypePlayback._0,
                                                                            preserveClipboard: preserveClipboard._0,
                                                                            clipboardBehavior: clipboardBehavior._0,
                                                                            startContext: startContext._0,
                                                                            closeWindowWhenFinish: closeWindowWhenFinish._0,
                                                                            doNotFocus: doNotFocus._0,
                                                                            playbackStrategy: playbackStrategy._0,
                                                                            replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands._0,
                                                                            msBeforeNextCommand: msBeforeNextCommand._0,
                                                                            selectorTimeout: selectorTimeout._0,
                                                                            domSnapshots: domSnapshots._0,
                                                                            doNotShowSplashScreen: doNotShowSplashScreen._0
                                                                        }
                                                                    };
                                                                }
                                                                var e = doNotShowSplashScreen._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".doNotShowSplashScreen" + e.path,
                                                                        message: e.message,
                                                                        value: e.value
                                                                    }
                                                                };
                                                            }
                                                            var e$1 = domSnapshots._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".domSnapshots" + e$1.path,
                                                                    message: e$1.message,
                                                                    value: e$1.value
                                                                }
                                                            };
                                                        }
                                                        var e$2 = selectorTimeout._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".selectorTimeout" + e$2.path,
                                                                message: e$2.message,
                                                                value: e$2.value
                                                            }
                                                        };
                                                    }
                                                    var e$3 = msBeforeNextCommand._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".msBeforeNextCommand" + e$3.path,
                                                            message: e$3.message,
                                                            value: e$3.value
                                                        }
                                                    };
                                                }
                                                var e$4 = replaceUiCommandsWithApiCommands._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".replaceUiCommandsWithApiCommands" + e$4.path,
                                                        message: e$4.message,
                                                        value: e$4.value
                                                    }
                                                };
                                            }
                                            var e$5 = playbackStrategy._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".playbackStrategy" + e$5.path,
                                                    message: e$5.message,
                                                    value: e$5.value
                                                }
                                            };
                                        }
                                        var e$6 = doNotFocus._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".doNotFocus" + e$6.path,
                                                message: e$6.message,
                                                value: e$6.value
                                            }
                                        };
                                    }
                                    var e$7 = closeWindowWhenFinish._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".closeWindowWhenFinish" + e$7.path,
                                            message: e$7.message,
                                            value: e$7.value
                                        }
                                    };
                                }
                                var e$8 = startContext._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".startContext" + e$8.path,
                                        message: e$8.message,
                                        value: e$8.value
                                    }
                                };
                            }
                            var e$9 = clipboardBehavior._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".clipboardBehavior" + e$9.path,
                                    message: e$9.message,
                                    value: e$9.value
                                }
                            };
                        }
                        var e$10 = preserveClipboard._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".preserveClipboard" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                            }
                        };
                    }
                    var e$11 = useFastestTypePlayback._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".useFastestTypePlayback" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$12 = millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".millisecondsBetweenTypingCharacterAndNonCharacterKeypress" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            }
            var e$13 = millisecondsBetweenKeyDownKeyUp._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".millisecondsBetweenKeyDownKeyUp" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                }
            };
        }
        var e$14 = millisecondsBetweenTypingCharacter._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".millisecondsBetweenTypingCharacter" + e$14.path,
                message: e$14.message,
                value: e$14.value
            }
        };
    }
    var e$15 = millisecondsBetweenCommands._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".millisecondsBetweenCommands" + e$15.path,
            message: e$15.message,
            value: e$15.value
        }
    };
}
var defaultPlaybackOptions_millisecondsBetweenCommands = Config$SmartcutsMacros.Default.millisecondsBetweenCommands;
var defaultPlaybackOptions_millisecondsBetweenTypingCharacter = Config$SmartcutsMacros.Default.millisecondsBetweenTypingCharacter;
var defaultPlaybackOptions_millisecondsBetweenKeyDownKeyUp = Config$SmartcutsMacros.Default.millisecondsBetweenKeyDownKeyUp;
var defaultPlaybackOptions_millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Config$SmartcutsMacros.Default.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;
var defaultPlaybackOptions_useFastestTypePlayback = Config$SmartcutsMacros.Default.useFastestTypePlayback;
var defaultPlaybackOptions_clipboardBehavior = /* OnlyUseVirtualClipboard */ 0;
var defaultPlaybackOptions_replaceUiCommandsWithApiCommands = Config$SmartcutsMacros.Default.replaceUiCommandsWithApiCommands;
var defaultPlaybackOptions_msBeforeNextCommand = [];
var defaultPlaybackOptions_domSnapshots = Config$SmartcutsMacros.Default.domSnapshots;
var defaultPlaybackOptions = {
    millisecondsBetweenCommands: defaultPlaybackOptions_millisecondsBetweenCommands,
    millisecondsBetweenTypingCharacter: defaultPlaybackOptions_millisecondsBetweenTypingCharacter,
    millisecondsBetweenKeyDownKeyUp: defaultPlaybackOptions_millisecondsBetweenKeyDownKeyUp,
    millisecondsBetweenTypingCharacterAndNonCharacterKeypress: defaultPlaybackOptions_millisecondsBetweenTypingCharacterAndNonCharacterKeypress,
    useFastestTypePlayback: defaultPlaybackOptions_useFastestTypePlayback,
    preserveClipboard: false,
    clipboardBehavior: defaultPlaybackOptions_clipboardBehavior,
    startContext: /* StartOnNewWindow */ 0,
    closeWindowWhenFinish: true,
    doNotFocus: true,
    playbackStrategy: /* ContentScriptOnly */ 0,
    replaceUiCommandsWithApiCommands: defaultPlaybackOptions_replaceUiCommandsWithApiCommands,
    msBeforeNextCommand: defaultPlaybackOptions_msBeforeNextCommand,
    selectorTimeout: /* Default */ 0,
    domSnapshots: defaultPlaybackOptions_domSnapshots,
    doNotShowSplashScreen: false
};
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
function serialize(opts) {
    return JSON.stringify(opts);
}
function maybeDeserialize(playbackOptionsSchemaVersion, serialized) {
    if (Caml_obj.caml_notequal(playbackOptionsSchemaVersion, schemaVersion)) {
        return;
    } else {
        return Caml_option.some(JSON.parse(serialized));
    }
}
function substituteIntoPlaybackOptions(overrides, maybeStartContext, maybeMsBeforeNextCommand, playbackOptions) {
    var arg = overrides.millisecondsBetweenCommands;
    var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
    var arg$2 = overrides.millisecondsBetweenTypingCharacter;
    var arg$3 = arg$2 === undefined ? undefined : Caml_option.some(arg$2);
    var arg$4 = overrides.millisecondsBetweenKeyDownKeyUp;
    var arg$5 = arg$4 === undefined ? undefined : Caml_option.some(arg$4);
    var arg$6 = overrides.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;
    var arg$7 = arg$6 === undefined ? undefined : Caml_option.some(arg$6);
    var arg$8 = overrides.useFastestTypePlayback;
    var arg$9 = arg$8 === undefined ? undefined : Caml_option.some(arg$8);
    var arg$10 = overrides.preserveClipboard;
    var arg$11 = arg$10 === undefined ? undefined : Caml_option.some(arg$10);
    var arg$12 = overrides.clipboardBehavior;
    var arg$13 = arg$12 === undefined ? undefined : Caml_option.some(arg$12);
    var arg$14 = overrides.closeWindowWhenFinish;
    var arg$15 = arg$14 === undefined ? undefined : Caml_option.some(arg$14);
    var arg$16 = overrides.doNotFocus;
    var arg$17 = arg$16 === undefined ? undefined : Caml_option.some(arg$16);
    var arg$18 = overrides.playbackStrategy;
    var arg$19 = arg$18 === undefined ? undefined : Caml_option.some(arg$18);
    var arg$20 = overrides.replaceUiCommandsWithApiCommands;
    var arg$21 = arg$20 === undefined ? undefined : Caml_option.some(arg$20);
    var arg$22 = OptionUtils$SmartcutsMacros.orElse(Caml_option.undefined_to_opt(overrides.msBeforeNextCommand), maybeMsBeforeNextCommand);
    var arg$23 = overrides.selectorTimeout;
    var arg$24 = arg$23 === undefined ? undefined : Caml_option.some(arg$23);
    var arg$25 = overrides.domSnapshots;
    var arg$26 = arg$25 === undefined ? undefined : Caml_option.some(arg$25);
    var arg$27 = overrides.doNotShowSplashScreen;
    var arg$28 = arg$27 === undefined ? undefined : Caml_option.some(arg$27);
    return {
        millisecondsBetweenCommands: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
        }(playbackOptions.millisecondsBetweenCommands),
        millisecondsBetweenTypingCharacter: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
        }(playbackOptions.millisecondsBetweenTypingCharacter),
        millisecondsBetweenKeyDownKeyUp: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$5);
        }(playbackOptions.millisecondsBetweenKeyDownKeyUp),
        millisecondsBetweenTypingCharacterAndNonCharacterKeypress: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$7);
        }(playbackOptions.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
        useFastestTypePlayback: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
        }(playbackOptions.useFastestTypePlayback),
        preserveClipboard: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
        }(playbackOptions.preserveClipboard),
        clipboardBehavior: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$13);
        }(playbackOptions.clipboardBehavior),
        startContext: OptionUtils$SmartcutsMacros.withDefault(playbackOptions.startContext, maybeStartContext),
        closeWindowWhenFinish: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$15);
        }(playbackOptions.closeWindowWhenFinish),
        doNotFocus: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$17);
        }(playbackOptions.doNotFocus),
        playbackStrategy: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$19);
        }(playbackOptions.playbackStrategy),
        replaceUiCommandsWithApiCommands: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$21);
        }(playbackOptions.replaceUiCommandsWithApiCommands),
        msBeforeNextCommand: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$22);
        }(playbackOptions.msBeforeNextCommand),
        selectorTimeout: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$24);
        }(playbackOptions.selectorTimeout),
        domSnapshots: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$26);
        }(playbackOptions.domSnapshots),
        doNotShowSplashScreen: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$28);
        }(playbackOptions.doNotShowSplashScreen)
    };
}
var SmartcutDefaultPlaybackOptions_t_encode = include.t_encode;
var SmartcutDefaultPlaybackOptions_t_decode = include.t_decode;
var SmartcutDefaultPlaybackOptions = {
    t_encode: SmartcutDefaultPlaybackOptions_t_encode,
    t_decode: SmartcutDefaultPlaybackOptions_t_decode,
    serialize: serialize,
    maybeDeserialize: maybeDeserialize,
    substituteIntoPlaybackOptions: substituteIntoPlaybackOptions
};
function t__encode(v) {
    return Js_dict.fromArray([
        [
            "millisecondsBetweenCommands",
            Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenCommands)
        ],
        [
            "millisecondsBetweenTypingCharacter",
            Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenTypingCharacter)
        ],
        [
            "millisecondsBetweenKeyDownKeyUp",
            Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenKeyDownKeyUp)
        ],
        [
            "millisecondsBetweenTypingCharacterAndNonCharacterKeypress",
            Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenTypingCharacterAndNonCharacterKeypress)
        ],
        [
            "useFastestTypePlayback",
            Decco.optionToJson(Decco.boolToJson, v.useFastestTypePlayback)
        ],
        [
            "preserveClipboard",
            Decco.optionToJson(Decco.boolToJson, v.preserveClipboard)
        ],
        [
            "clipboardBehavior",
            Decco.optionToJson(t_encode$5, v.clipboardBehavior)
        ],
        [
            "startContext",
            Decco.optionToJson(t_encode, v.startContext)
        ],
        [
            "closeWindowWhenFinish",
            Decco.optionToJson(Decco.boolToJson, v.closeWindowWhenFinish)
        ],
        [
            "doNotFocus",
            Decco.optionToJson(Decco.boolToJson, v.doNotFocus)
        ],
        [
            "playbackStrategy",
            Decco.optionToJson(t_encode$4, v.playbackStrategy)
        ],
        [
            "replaceUiCommandsWithApiCommands",
            Decco.optionToJson(Decco.boolToJson, v.replaceUiCommandsWithApiCommands)
        ],
        [
            "msBeforeNextCommand",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(Decco.intToJson, param);
            }, v.msBeforeNextCommand)
        ],
        [
            "selectorTimeout",
            Decco.optionToJson(function(param) {
                return Util$SmartcutsMacros.HasDefault.t_encode(Decco.floatToJson, param);
            }, v.selectorTimeout)
        ],
        [
            "domSnapshots",
            Decco.optionToJson(Decco.boolToJson, v.domSnapshots)
        ],
        [
            "doNotShowSplashScreen",
            Decco.optionToJson(Decco.boolToJson, v.doNotShowSplashScreen)
        ]
    ]);
}
function t__decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var millisecondsBetweenCommands = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenCommands"), null));
    if (millisecondsBetweenCommands.TAG === /* Ok */ 0) {
        var millisecondsBetweenTypingCharacter = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacter"), null));
        if (millisecondsBetweenTypingCharacter.TAG === /* Ok */ 0) {
            var millisecondsBetweenKeyDownKeyUp = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenKeyDownKeyUp"), null));
            if (millisecondsBetweenKeyDownKeyUp.TAG === /* Ok */ 0) {
                var millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacterAndNonCharacterKeypress"), null));
                if (millisecondsBetweenTypingCharacterAndNonCharacterKeypress.TAG === /* Ok */ 0) {
                    var useFastestTypePlayback = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "useFastestTypePlayback"), null));
                    if (useFastestTypePlayback.TAG === /* Ok */ 0) {
                        var preserveClipboard = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preserveClipboard"), null));
                        if (preserveClipboard.TAG === /* Ok */ 0) {
                            var clipboardBehavior = Decco.optionFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardBehavior"), null));
                            if (clipboardBehavior.TAG === /* Ok */ 0) {
                                var startContext = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
                                if (startContext.TAG === /* Ok */ 0) {
                                    var closeWindowWhenFinish = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "closeWindowWhenFinish"), null));
                                    if (closeWindowWhenFinish.TAG === /* Ok */ 0) {
                                        var doNotFocus = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotFocus"), null));
                                        if (doNotFocus.TAG === /* Ok */ 0) {
                                            var playbackStrategy = Decco.optionFromJson(t_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackStrategy"), null));
                                            if (playbackStrategy.TAG === /* Ok */ 0) {
                                                var replaceUiCommandsWithApiCommands = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceUiCommandsWithApiCommands"), null));
                                                if (replaceUiCommandsWithApiCommands.TAG === /* Ok */ 0) {
                                                    var msBeforeNextCommand = Decco.optionFromJson(function(param) {
                                                        return Decco.arrayFromJson(Decco.intFromJson, param);
                                                    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
                                                    if (msBeforeNextCommand.TAG === /* Ok */ 0) {
                                                        var selectorTimeout = Decco.optionFromJson(function(param) {
                                                            return Util$SmartcutsMacros.HasDefault.t_decode(Decco.floatFromJson, param);
                                                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorTimeout"), null));
                                                        if (selectorTimeout.TAG === /* Ok */ 0) {
                                                            var domSnapshots = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domSnapshots"), null));
                                                            if (domSnapshots.TAG === /* Ok */ 0) {
                                                                var doNotShowSplashScreen = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotShowSplashScreen"), null));
                                                                if (doNotShowSplashScreen.TAG === /* Ok */ 0) {
                                                                    return {
                                                                        TAG: /* Ok */ 0,
                                                                        _0: {
                                                                            millisecondsBetweenCommands: millisecondsBetweenCommands._0,
                                                                            millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter._0,
                                                                            millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp._0,
                                                                            millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0,
                                                                            useFastestTypePlayback: useFastestTypePlayback._0,
                                                                            preserveClipboard: preserveClipboard._0,
                                                                            clipboardBehavior: clipboardBehavior._0,
                                                                            startContext: startContext._0,
                                                                            closeWindowWhenFinish: closeWindowWhenFinish._0,
                                                                            doNotFocus: doNotFocus._0,
                                                                            playbackStrategy: playbackStrategy._0,
                                                                            replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands._0,
                                                                            msBeforeNextCommand: msBeforeNextCommand._0,
                                                                            selectorTimeout: selectorTimeout._0,
                                                                            domSnapshots: domSnapshots._0,
                                                                            doNotShowSplashScreen: doNotShowSplashScreen._0
                                                                        }
                                                                    };
                                                                }
                                                                var e = doNotShowSplashScreen._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".doNotShowSplashScreen" + e.path,
                                                                        message: e.message,
                                                                        value: e.value
                                                                    }
                                                                };
                                                            }
                                                            var e$1 = domSnapshots._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".domSnapshots" + e$1.path,
                                                                    message: e$1.message,
                                                                    value: e$1.value
                                                                }
                                                            };
                                                        }
                                                        var e$2 = selectorTimeout._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".selectorTimeout" + e$2.path,
                                                                message: e$2.message,
                                                                value: e$2.value
                                                            }
                                                        };
                                                    }
                                                    var e$3 = msBeforeNextCommand._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".msBeforeNextCommand" + e$3.path,
                                                            message: e$3.message,
                                                            value: e$3.value
                                                        }
                                                    };
                                                }
                                                var e$4 = replaceUiCommandsWithApiCommands._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".replaceUiCommandsWithApiCommands" + e$4.path,
                                                        message: e$4.message,
                                                        value: e$4.value
                                                    }
                                                };
                                            }
                                            var e$5 = playbackStrategy._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".playbackStrategy" + e$5.path,
                                                    message: e$5.message,
                                                    value: e$5.value
                                                }
                                            };
                                        }
                                        var e$6 = doNotFocus._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".doNotFocus" + e$6.path,
                                                message: e$6.message,
                                                value: e$6.value
                                            }
                                        };
                                    }
                                    var e$7 = closeWindowWhenFinish._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".closeWindowWhenFinish" + e$7.path,
                                            message: e$7.message,
                                            value: e$7.value
                                        }
                                    };
                                }
                                var e$8 = startContext._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".startContext" + e$8.path,
                                        message: e$8.message,
                                        value: e$8.value
                                    }
                                };
                            }
                            var e$9 = clipboardBehavior._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".clipboardBehavior" + e$9.path,
                                    message: e$9.message,
                                    value: e$9.value
                                }
                            };
                        }
                        var e$10 = preserveClipboard._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".preserveClipboard" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                            }
                        };
                    }
                    var e$11 = useFastestTypePlayback._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".useFastestTypePlayback" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$12 = millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".millisecondsBetweenTypingCharacterAndNonCharacterKeypress" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            }
            var e$13 = millisecondsBetweenKeyDownKeyUp._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".millisecondsBetweenKeyDownKeyUp" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                }
            };
        }
        var e$14 = millisecondsBetweenTypingCharacter._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".millisecondsBetweenTypingCharacter" + e$14.path,
                message: e$14.message,
                value: e$14.value
            }
        };
    }
    var e$15 = millisecondsBetweenCommands._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".millisecondsBetweenCommands" + e$15.path,
            message: e$15.message,
            value: e$15.value
        }
    };
}
function make(millisecondsBetweenCommands, millisecondsBetweenTypingCharacter, millisecondsBetweenKeyDownKeyUp, millisecondsBetweenTypingCharacterAndNonCharacterKeypress, useFastestTypePlayback, preserveClipboard, clipboardBehavior, closeWindowWhenFinish, doNotFocus, playbackStrategy, replaceUiCommandsWithApiCommands, msBeforeNextCommand, selectorTimeout, domSnapshots, doNotShowSplashScreen, param) {
    return {
        millisecondsBetweenCommands: millisecondsBetweenCommands,
        millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter,
        millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp,
        millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress,
        useFastestTypePlayback: useFastestTypePlayback,
        preserveClipboard: preserveClipboard,
        clipboardBehavior: clipboardBehavior,
        startContext: undefined,
        closeWindowWhenFinish: closeWindowWhenFinish,
        doNotFocus: doNotFocus,
        playbackStrategy: playbackStrategy,
        replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands,
        msBeforeNextCommand: msBeforeNextCommand,
        selectorTimeout: selectorTimeout,
        domSnapshots: domSnapshots,
        doNotShowSplashScreen: doNotShowSplashScreen
    };
}
function substituteIntoPlaybackOptions$1(overrides, startContext, msBeforeNextCommand, playbackOptions) {
    var arg = overrides.millisecondsBetweenCommands;
    var arg$1 = overrides.millisecondsBetweenTypingCharacter;
    var arg$2 = overrides.millisecondsBetweenKeyDownKeyUp;
    var arg$3 = overrides.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;
    var arg$4 = overrides.useFastestTypePlayback;
    var arg$5 = overrides.preserveClipboard;
    var arg$6 = overrides.clipboardBehavior;
    var arg$7 = overrides.closeWindowWhenFinish;
    var arg$8 = overrides.doNotFocus;
    var arg$9 = overrides.playbackStrategy;
    var arg$10 = overrides.replaceUiCommandsWithApiCommands;
    var arg$11 = overrides.selectorTimeout;
    var arg$12 = overrides.domSnapshots;
    var arg$13 = overrides.doNotShowSplashScreen;
    return {
        millisecondsBetweenCommands: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(playbackOptions.millisecondsBetweenCommands),
        millisecondsBetweenTypingCharacter: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
        }(playbackOptions.millisecondsBetweenTypingCharacter),
        millisecondsBetweenKeyDownKeyUp: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
        }(playbackOptions.millisecondsBetweenKeyDownKeyUp),
        millisecondsBetweenTypingCharacterAndNonCharacterKeypress: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
        }(playbackOptions.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
        useFastestTypePlayback: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$4);
        }(playbackOptions.useFastestTypePlayback),
        preserveClipboard: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$5);
        }(playbackOptions.preserveClipboard),
        clipboardBehavior: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
        }(playbackOptions.clipboardBehavior),
        startContext: startContext,
        closeWindowWhenFinish: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$7);
        }(playbackOptions.closeWindowWhenFinish),
        doNotFocus: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$8);
        }(playbackOptions.doNotFocus),
        playbackStrategy: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
        }(playbackOptions.playbackStrategy),
        replaceUiCommandsWithApiCommands: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$10);
        }(playbackOptions.replaceUiCommandsWithApiCommands),
        msBeforeNextCommand: msBeforeNextCommand,
        selectorTimeout: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
        }(playbackOptions.selectorTimeout),
        domSnapshots: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$12);
        }(playbackOptions.domSnapshots),
        doNotShowSplashScreen: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$13);
        }(playbackOptions.doNotShowSplashScreen)
    };
}
function prepopulateWithSmartcutDefaultPlaybackOptions(smartcutDefaultPlaybackOptions, defaultPlaybackOptionsOpt, param1) {
    var defaultPlaybackOptions$1 = defaultPlaybackOptionsOpt !== undefined ? defaultPlaybackOptionsOpt : defaultPlaybackOptions;
    var arg = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.millisecondsBetweenCommands);
    });
    var arg$1 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.millisecondsBetweenTypingCharacter);
    });
    var arg$2 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.millisecondsBetweenKeyDownKeyUp);
    });
    var arg$3 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.millisecondsBetweenTypingCharacterAndNonCharacterKeypress);
    });
    var arg$4 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.useFastestTypePlayback);
    });
    var arg$5 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.preserveClipboard);
    });
    var arg$6 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.clipboardBehavior);
    });
    var arg$7 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.closeWindowWhenFinish);
    });
    var arg$8 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.doNotFocus);
    });
    var arg$9 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.playbackStrategy);
    });
    var arg$10 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.replaceUiCommandsWithApiCommands);
    });
    var arg$11 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.msBeforeNextCommand);
    });
    var arg$12 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.selectorTimeout);
    });
    var arg$13 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.domSnapshots);
    });
    var arg$14 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, function(prim) {
        return Caml_option.undefined_to_opt(prim.doNotShowSplashScreen);
    });
    return {
        millisecondsBetweenCommands: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg);
        }(defaultPlaybackOptions$1.millisecondsBetweenCommands),
        millisecondsBetweenTypingCharacter: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
        }(defaultPlaybackOptions$1.millisecondsBetweenTypingCharacter),
        millisecondsBetweenKeyDownKeyUp: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$2);
        }(defaultPlaybackOptions$1.millisecondsBetweenKeyDownKeyUp),
        millisecondsBetweenTypingCharacterAndNonCharacterKeypress: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$3);
        }(defaultPlaybackOptions$1.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
        useFastestTypePlayback: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$4);
        }(defaultPlaybackOptions$1.useFastestTypePlayback),
        preserveClipboard: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$5);
        }(defaultPlaybackOptions$1.preserveClipboard),
        clipboardBehavior: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
        }(defaultPlaybackOptions$1.clipboardBehavior),
        startContext: undefined,
        closeWindowWhenFinish: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$7);
        }(defaultPlaybackOptions$1.closeWindowWhenFinish),
        doNotFocus: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$8);
        }(defaultPlaybackOptions$1.doNotFocus),
        playbackStrategy: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$9);
        }(defaultPlaybackOptions$1.playbackStrategy),
        replaceUiCommandsWithApiCommands: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$10);
        }(defaultPlaybackOptions$1.replaceUiCommandsWithApiCommands),
        msBeforeNextCommand: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$11);
        }(defaultPlaybackOptions$1.msBeforeNextCommand),
        selectorTimeout: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$12);
        }(defaultPlaybackOptions$1.selectorTimeout),
        domSnapshots: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$13);
        }(defaultPlaybackOptions$1.domSnapshots),
        doNotShowSplashScreen: function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$14);
        }(defaultPlaybackOptions$1.doNotShowSplashScreen)
    };
}
function stringify$1(userSpecifiedPlaybackOptions) {
    return JSON.stringify(t__encode(userSpecifiedPlaybackOptions));
}
var UserSpecifiedPlaybackOptions = {
    t__encode: t__encode,
    t__decode: t__decode,
    make: make,
    substituteIntoPlaybackOptions: substituteIntoPlaybackOptions$1,
    prepopulateWithSmartcutDefaultPlaybackOptions: prepopulateWithSmartcutDefaultPlaybackOptions,
    stringify: stringify$1
};
function substituteInUserSpecifiedAndSmartcutDefaultOverrides(userSpecifiedPlaybackOptions, maybeSmartcutDefaultPlaybackOptions, startContext, msBeforeNextCommand, playbackOptions) {
    if (maybeSmartcutDefaultPlaybackOptions === undefined) {
        return substituteIntoPlaybackOptions$1(userSpecifiedPlaybackOptions, startContext, msBeforeNextCommand, playbackOptions);
    }
    var smartcutDefaultPlaybackOptions = Caml_option.valFromOption(maybeSmartcutDefaultPlaybackOptions);
    var arg = function arg(param, param$1, param$2) {
        return substituteIntoPlaybackOptions(smartcutDefaultPlaybackOptions, param, param$1, param$2);
    };
    return substituteIntoPlaybackOptions$1(userSpecifiedPlaybackOptions, startContext, msBeforeNextCommand, arg(undefined, undefined, playbackOptions));
}
function stringify$2(param) {
    return "{millisecondsBetweenCommands: " + (String(param.millisecondsBetweenCommands) + (", millisecondsBetweenTypingCharacter: " + (String(param.millisecondsBetweenTypingCharacter) + (", millisecondsBetweenKeyDownKeyUp: " + (String(param.millisecondsBetweenKeyDownKeyUp) + (", millisecondsBetweenTypingCharacterAndNonCharacterKeypress: " + (String(param.millisecondsBetweenTypingCharacterAndNonCharacterKeypress) + (", useFastestTypePlayback: " + (Pervasives.string_of_bool(param.useFastestTypePlayback) + (", preserveClipboard: " + (Pervasives.string_of_bool(param.preserveClipboard) + (", closeWindowWhenFinish: " + (Pervasives.string_of_bool(param.closeWindowWhenFinish) + (", doNotFocus: " + (Pervasives.string_of_bool(param.doNotFocus) + (", startContext: " + (stringify(param.startContext) + (", playbackStrategy: '<elided>', replaceUiCommandsWithApiCommands: " + (Pervasives.string_of_bool(param.replaceUiCommandsWithApiCommands) + (", domSnapshots: " + (Pervasives.string_of_bool(param.domSnapshots) + "}")))))))))))))))))))));
}
exports.schemaVersion = schemaVersion;
exports.StartContext = StartContext;
exports.HybridPlaybackStrategy__PasteStrategy = HybridPlaybackStrategy__PasteStrategy;
exports.HybridPlaybackStrategy = HybridPlaybackStrategy;
exports.PlaybackStrategy = PlaybackStrategy;
exports.ClipboardBehavior = ClipboardBehavior;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.defaultPlaybackOptions = defaultPlaybackOptions;
exports.SmartcutDefaultPlaybackOptions = SmartcutDefaultPlaybackOptions;
exports.UserSpecifiedPlaybackOptions = UserSpecifiedPlaybackOptions;
exports.substituteInUserSpecifiedAndSmartcutDefaultOverrides = substituteInUserSpecifiedAndSmartcutDefaultOverrides;
exports.stringify = stringify$2; /* include Not a pure module */ 


/***/ }),

/***/ 19949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Util$SmartcutsMacros = __webpack_require__(25092);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(encoder_value, encoder_pendingPlaceholder, v) {
    if (v.TAG === /* Resolved */ 0) {
        return [
            "Resolved",
            Curry._1(encoder_value, v._0)
        ];
    } else {
        return [
            "Pending",
            Curry._1(encoder_pendingPlaceholder, v._0)
        ];
    }
}
function t_decode(decoder_value, decoder_pendingPlaceholder, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Pending":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_pendingPlaceholder, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Pending */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Resolved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_value, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Resolved */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(stringifyValue, stringifyPlaceholder, pval) {
    if (pval.TAG === /* Resolved */ 0) {
        return "Resolved(" + (Curry._1(stringifyValue, pval._0) + ")");
    } else {
        return "Pending(" + (Curry._1(stringifyPlaceholder, pval._0) + ")");
    }
}
function getResolvedExn(buildMsg, x) {
    if (x.TAG === /* Resolved */ 0) {
        return x._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected value to be resolved, not pending: " + Curry._1(buildMsg, x._0));
    }
}
function compare(compareResolvedValues, v1, v2) {
    if (v1.TAG === /* Resolved */ 0 && v2.TAG === /* Resolved */ 0) {
        if (Curry._2(compareResolvedValues, v1._0, v2._0)) {
            return /* ResolvedValuesAreEqual */ 0;
        } else {
            return /* ResolvedValuesAreNotEqual */ 1;
        }
    } else {
        return /* UnableToDetermineEqualityBecauseOneIsNotResolved */ 2;
    }
}
function t_encode$1(v) {
    switch(v.TAG | 0){
        case /* OnWindowInfoFetched */ 0:
            return [
                "OnWindowInfoFetched",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_encode(v._0)
            ];
        case /* OnTabInfoFetched */ 1:
            return [
                "OnTabInfoFetched",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_encode(v._0)
            ];
        case /* OnTabInfoFetchedByUrl */ 2:
            return [
                "OnTabInfoFetchedByUrl",
                Decco.stringToJson(v._0)
            ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "OnTabInfoFetched":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnTabInfoFetched */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "OnTabInfoFetchedByUrl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnTabInfoFetchedByUrl */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "OnWindowInfoFetched":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* OnWindowInfoFetched */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(v) {
    switch(v.TAG | 0){
        case /* OnWindowInfoFetched */ 0:
            return "OnWindowInfoFetched(" + (String(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(v._0)) + ")");
        case /* OnTabInfoFetched */ 1:
            return "OnTabInfoFetched(" + (String(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(v._0)) + ")");
        case /* OnTabInfoFetchedByUrl */ 2:
            return "OnTabInfoFetchedByUrl(url=" + (v._0 + ")");
    }
}
var PendingPlaceholderForRecording = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.getResolvedExn = getResolvedExn;
exports.compare = compare;
exports.PendingPlaceholderForRecording = PendingPlaceholderForRecording; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 35646:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Query$SmartcutsMacros = __webpack_require__(33429);
var Selector__Background$SmartcutsMacros = __webpack_require__(89403);
var include = Query$SmartcutsMacros.MakeQueryInPromise({
    getCurrentUrl: Selector__Background$SmartcutsMacros.getCurrentUrl,
    getDomShadowRoot: Selector__Background$SmartcutsMacros.getDomShadowRoot,
    getElementAttributes: Selector__Background$SmartcutsMacros.getElementAttributes,
    idFromAttributes: Selector__Background$SmartcutsMacros.idFromAttributes,
    classNamesFromAttributes: Selector__Background$SmartcutsMacros.classNamesFromAttributes,
    keepAttributes: Selector__Background$SmartcutsMacros.keepAttributes,
    querySelectorAll: Selector__Background$SmartcutsMacros.querySelectorAll,
    maxRetries: Selector__Background$SmartcutsMacros.maxRetries,
    queryXPath: Selector__Background$SmartcutsMacros.queryXPath,
    getTagName: Selector__Background$SmartcutsMacros.getTagName,
    fetchDomTree: Selector__Background$SmartcutsMacros.fetchDomTree,
    couldElementMatchSelectorTreeNode: Selector__Background$SmartcutsMacros.couldElementMatchSelectorTreeNode,
    isVisibleOnPage: Selector__Background$SmartcutsMacros.isVisibleOnPage,
    getParentChain: Selector__Background$SmartcutsMacros.getParentChain,
    getParentElement: Selector__Background$SmartcutsMacros.getParentElement,
    getParentElements: Selector__Background$SmartcutsMacros.getParentElements,
    getSiblingIndex: Selector__Background$SmartcutsMacros.getSiblingIndex,
    getUpdatedElementFromDomTree: Selector__Background$SmartcutsMacros.getUpdatedElementFromDomTree,
    getInnerTextForElement: Selector__Background$SmartcutsMacros.getInnerTextForElement,
    shouldRetryForJsPromiseError: Selector__Background$SmartcutsMacros.shouldRetryForJsPromiseError,
    isElementEqualTo: Selector__Background$SmartcutsMacros.isElementEqualTo,
    getScrollHeight: Selector__Background$SmartcutsMacros.getScrollHeight,
    getClientHeight: Selector__Background$SmartcutsMacros.getClientHeight,
    getOverflowYForElement: Selector__Background$SmartcutsMacros.getOverflowYForElement,
    scrollTo: Selector__Background$SmartcutsMacros.scrollTo
});
var CandidateBranches = include.CandidateBranches;
var search1 = include.search1;
var searchWithScrolling = include.searchWithScrolling;
var search2 = include.search2;
exports.CandidateBranches = CandidateBranches;
exports.search1 = search1;
exports.searchWithScrolling = searchWithScrolling;
exports.search2 = search2; /* include Not a pure module */ 


/***/ }),

/***/ 80449:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var Browser__Helpers$SmartcutsMacros = __webpack_require__(57783);
var Browser__Helpers2$SmartcutsMacros = __webpack_require__(40495);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "NoImage"
        ];
    }
    switch(v.TAG | 0){
        case /* Image */ 0:
            return [
                "Image",
                Image$SmartcutsMacros.id_encode(v._0),
                Image$SmartcutsMacros.t_encode(v._1)
            ];
        case /* SavingToCloud */ 1:
            return [
                "SavingToCloud",
                Image$SmartcutsMacros.id_encode(v._0),
                Image$SmartcutsMacros.t_encode(v._1)
            ];
        case /* Cloud */ 2:
            return [
                "Cloud",
                Image$SmartcutsMacros.id_encode(v._0),
                Decco.stringToJson(v._1)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Cloud":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Cloud */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Image":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Image$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Image */ 0,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "NoImage":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoImage */ 0
                    };
                }
            case "SavingToCloud":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Image$SmartcutsMacros.id_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Image$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SavingToCloud */ 1,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function minify(v) {
    if (typeof v === "number") {
        return /* NoImage */ 0;
    }
    switch(v.TAG | 0){
        case /* Image */ 0:
            return {
                TAG: /* Image */ 0,
                _0: v._0,
                _1: Image$SmartcutsMacros.minify(v._1)
            };
        case /* SavingToCloud */ 1:
            return {
                TAG: /* SavingToCloud */ 1,
                _0: v._0,
                _1: Image$SmartcutsMacros.minify(v._1)
            };
        case /* Cloud */ 2:
            return {
                TAG: /* Cloud */ 2,
                _0: v._0,
                _1: v._1
            };
    }
}
function stringify(screenshot) {
    if (typeof screenshot === "number") {
        return "NoImage";
    }
    switch(screenshot.TAG | 0){
        case /* Image */ 0:
            return "Image(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + ")");
        case /* SavingToCloud */ 1:
            return "SavingToCloud(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + ")");
        case /* Cloud */ 2:
            return "Cloud(" + (Image$SmartcutsMacros.idAsString(screenshot._0) + (", " + (screenshot._1 + ")")));
    }
}
function deriveFolderName(recordedSmartcutId) {
    return "/" + ("production" + ("/" + recordedSmartcutId));
}
function deriveFileName(screenshotId, format) {
    return Image$SmartcutsMacros.idAsString(screenshotId) + ("." + Image$SmartcutsMacros.Format.extension(format));
}
function getSrcForImgTag(screenshot) {
    if (typeof screenshot === "number") {
        return "";
    }
    switch(screenshot.TAG | 0){
        case /* Image */ 0:
        case /* SavingToCloud */ 1:
            return Image$SmartcutsMacros.Data.toImageSrc(screenshot._1.data);
        case /* Cloud */ 2:
            return screenshot._1;
    }
}
function imageGet(screenshot) {
    if (typeof screenshot === "number") {
        return;
    }
    switch(screenshot.TAG | 0){
        case /* Image */ 0:
        case /* SavingToCloud */ 1:
            return screenshot._1;
        case /* Cloud */ 2:
            return;
    }
}
function idGet(screenshot) {
    if (typeof screenshot === "number") {
        return;
    } else {
        return Caml_option.some(screenshot._0);
    }
}
function doesMatchId(id, screenshot) {
    if (typeof screenshot === "number") {
        return false;
    } else {
        return Caml_obj.caml_equal(screenshot._0, id);
    }
}
function tryToScreenshotTab(tabId, url, format, quality) {
    return Browser__Helpers2$SmartcutsMacros.runPromiseWhileAlsoHandlingTabDraggingError(function(param) {
        return Browser__Helpers$SmartcutsMacros.getActiveTabOfLastFocusedWindow(undefined);
    }).then(function(maybeFocusedTab_1) {
        var arg1 = OptionUtils$SmartcutsMacros.map(maybeFocusedTab_1, function(tab) {
            if (Caml_obj.caml_equal(tab.id, tabId)) {
                return Caml_obj.caml_equal(tab.url, url);
            } else {
                return false;
            }
        });
        var isTabWithUrlFocused_1 = function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg1);
        }(false);
        if (isTabWithUrlFocused_1) {
            return Browser__Tabs$SmartcutsMacros.captureVisibleTab(undefined, format, quality, undefined).then(function(image) {
                return Promise.resolve(image);
            }).catch(function(error1) {
                Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "error during screenshot", error1);
                var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error1);
                if (typeof jsExn !== "number" && jsExn.TAG === /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1) {
                    console.warn("Delay strategy for MAX_CAPTURE_VISIBLE_TAB_CALLS_PER_SECOND not working");
                    console.error(jsExn._0);
                    return Promise.resolve(undefined);
                }
                return Util$SmartcutsMacros.waitForPromise(undefined, undefined, function(param) {
                    return Browser__Tabs$SmartcutsMacros.captureVisibleTab(undefined, format, quality, undefined).then(function(image) {
                        return Promise.resolve(image);
                    }).catch(function(error) {
                        Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "error during screenshot retry", error);
                        return Promise.resolve(undefined);
                    });
                }, undefined, undefined).then(function(image) {
                    return Promise.resolve(image);
                }).catch(function(error) {
                    Curry._2(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.consoleError2, "final screenshot error", error);
                    return Promise.resolve(undefined);
                });
            }).then(function(maybeImage) {
                if (maybeImage !== undefined) {
                    return Browser__Helpers$SmartcutsMacros.getActiveTabOfLastFocusedWindow(undefined).then(function(maybeFocusedTab_2) {
                        var arg = OptionUtils$SmartcutsMacros.map(maybeFocusedTab_2, function(tab) {
                            if (Caml_obj.caml_equal(tab.id, tabId)) {
                                return Caml_obj.caml_equal(tab.url, url);
                            } else {
                                return false;
                            }
                        });
                        var isTabWithUrlFocused_2 = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }(false);
                        return Promise.resolve(isTabWithUrlFocused_2 ? maybeImage : undefined);
                    });
                } else {
                    return Promise.resolve(undefined);
                }
            });
        } else {
            return Promise.resolve(undefined);
        }
    });
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "rect",
            Rect$SmartcutsMacros.t_encode(v.rect)
        ],
        [
            "windowSize",
            Image$SmartcutsMacros.Size.t_encode(v.windowSize)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rect"), null));
    if (rect.TAG === /* Ok */ 0) {
        var windowSize = Image$SmartcutsMacros.Size.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowSize"), null));
        if (windowSize.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    rect: rect._0,
                    windowSize: windowSize._0
                }
            };
        }
        var e = windowSize._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".windowSize" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = rect._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rect" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{rect: " + (Rect$SmartcutsMacros.stringify(param.rect) + (", windowSize: " + (Image$SmartcutsMacros.Size.stringify(param.windowSize) + "}")));
}
var TargetBoundingRectWithWindowSize = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "key",
            Image$SmartcutsMacros.id_encode(v.key)
        ],
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "url",
            Decco.optionToJson(Decco.stringToJson, v.url)
        ],
        [
            "targetBoundingRectWithWindowSize",
            Decco.optionToJson(t_encode$1, v.targetBoundingRectWithWindowSize)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var key = Image$SmartcutsMacros.id_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "key"), null));
    if (key.TAG === /* Ok */ 0) {
        var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
        if (tabId.TAG === /* Ok */ 0) {
            var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                var targetBoundingRectWithWindowSize = Decco.optionFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRectWithWindowSize"), null));
                if (targetBoundingRectWithWindowSize.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            key: key._0,
                            tabId: tabId._0,
                            url: url._0,
                            targetBoundingRectWithWindowSize: targetBoundingRectWithWindowSize._0
                        }
                    };
                }
                var e = targetBoundingRectWithWindowSize._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".targetBoundingRectWithWindowSize" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = tabId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tabId" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = key._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".key" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$2(param1) {
    var arg = OptionUtils$SmartcutsMacros.map(param1.targetBoundingRectWithWindowSize, stringify$1);
    return "{key: " + (Image$SmartcutsMacros.idAsString(param1.key) + (", tabId: " + (String(param1.tabId) + (", url: " + (OptionUtils$SmartcutsMacros.withDefault("None", param1.url) + (", targetBoundingRectWithWindowSize: " + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("None") + "}")))))));
}
function doesMatch(maybeKey, maybeTabId, param2) {
    var arg = OptionUtils$SmartcutsMacros.map(maybeKey, function(keyToMatch, key$p) {
        return Caml_obj.caml_equal(key$p, keyToMatch);
    });
    var doesMatchKey = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(function(param) {
        return true;
    });
    var arg$1 = OptionUtils$SmartcutsMacros.map(maybeTabId, function(tabIdToMatch, tabId$p) {
        return tabId$p === tabIdToMatch;
    });
    var doesMatchTabId = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }(function(param) {
        return true;
    });
    if (Curry._1(doesMatchKey, param2.key)) {
        return Curry._1(doesMatchTabId, param2.tabId);
    } else {
        return false;
    }
}
function cropImageToDesiredScreenshot(image, param3) {
    var maybeTargetBoundingRectWithWindowSize = param3.targetBoundingRectWithWindowSize;
    var currKey = param3.key;
    if (maybeTargetBoundingRectWithWindowSize === undefined) {
        return Promise.resolve([
            currKey,
            undefined
        ]);
    }
    var windowSizeWhenBoundingRectTaken = maybeTargetBoundingRectWithWindowSize.windowSize;
    var boundingRect = maybeTargetBoundingRectWithWindowSize.rect;
    var arg = function arg(param, param$1) {
        return function(param$2) {
            return Image$SmartcutsMacros.cropToContainingCircle(param, param$1, boundingRect, windowSizeWhenBoundingRectTaken, param$2);
        };
    };
    return Curry._1(arg(undefined, undefined), image).then(function(maybeCroppedImage) {
        return Promise.resolve([
            currKey,
            maybeCroppedImage
        ]);
    });
}
var DesiredTabScreenshot = {
    TargetBoundingRectWithWindowSize: TargetBoundingRectWithWindowSize,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    doesMatch: doesMatch,
    cropImageToDesiredScreenshot: cropImageToDesiredScreenshot
};
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.minify = minify;
exports.stringify = stringify;
exports.deriveFolderName = deriveFolderName;
exports.deriveFileName = deriveFileName;
exports.getSrcForImgTag = getSrcForImgTag;
exports.imageGet = imageGet;
exports.idGet = idGet;
exports.doesMatchId = doesMatchId;
exports.tryToScreenshotTab = tryToScreenshotTab;
exports.DesiredTabScreenshot = DesiredTabScreenshot; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 43378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var TextContents$SmartcutsMacros = __webpack_require__(20114);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "contentEditableHost",
            Curry._1(encoder_domElementRepresentation, v.contentEditableHost)
        ],
        [
            "domElementRepresentation",
            Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
        ],
        [
            "textNodeIndex",
            Decco.intToJson(v.textNodeIndex)
        ],
        [
            "offset",
            Decco.intToJson(v.offset)
        ],
        [
            "textContents",
            TextContents$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v.textContents)
        ]
    ]);
}
function t_decode(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var contentEditableHost = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
    if (contentEditableHost.TAG === /* Ok */ 0) {
        var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
        if (domElementRepresentation.TAG === /* Ok */ 0) {
            var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
            if (textNodeIndex.TAG === /* Ok */ 0) {
                var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
                if (offset.TAG === /* Ok */ 0) {
                    var textContents = TextContents$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textContents"), null));
                    if (textContents.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                contentEditableHost: contentEditableHost._0,
                                domElementRepresentation: domElementRepresentation._0,
                                textNodeIndex: textNodeIndex._0,
                                offset: offset._0,
                                textContents: textContents._0
                            }
                        };
                    }
                    var e = textContents._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".textContents" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = offset._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".offset" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = textNodeIndex._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".textNodeIndex" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = domElementRepresentation._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".domElementRepresentation" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = contentEditableHost._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".contentEditableHost" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify(stringifyDomElementRepresentation, param) {
    return "{contentEditableHost: " + (Curry._1(stringifyDomElementRepresentation, param.contentEditableHost) + (", domElementRepresentation: " + (Curry._1(stringifyDomElementRepresentation, param.domElementRepresentation) + (", textNodeIndex: " + (String(param.textNodeIndex) + (", offset: " + (String(param.offset) + ", textContents}")))))));
}
var Generic = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$1(v) {
    return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
    if (!selectionSnapshot) {
        return;
    }
    var match = selectionSnapshot._0;
    if (!match.collapsed) {
        return;
    }
    var offset = match.startOffset;
    var rootNode = match.rootNode;
    var contentEditableHost = DOM$SmartcutsMacros.ContentEditable.findHost(DOM__HtmlElement$SmartcutsMacros.ofNodeOrItsAncestor(rootNode));
    var match$1 = Webapi__Dom__Node.nodeType(rootNode);
    var maybeElementAndTextNodeIndex;
    if (match$1 >= 3) {
        maybeElementAndTextNodeIndex = undefined;
    } else {
        switch(match$1){
            case /* Element */ 0:
                if (offset === 0) {
                    var arg = Webapi__Dom__Element.ofNode(rootNode);
                    var rootElement = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expected node to be an element");
                    var textSegments = TextContents$SmartcutsMacros.TextSegment.textSegmentsFromElement(rootElement);
                    if (textSegments) {
                        var element = textSegments.hd;
                        if (element.TAG === /* NonEmptySegment */ 0) {
                            var match$2 = element._0;
                            var textNodeIndex = match$2.textNodeIndex;
                            var parentElement = match$2.parentElement;
                            if (textSegments.tl) {
                                var domElementRepresentation = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement);
                                maybeElementAndTextNodeIndex = [
                                    domElementRepresentation,
                                    textNodeIndex
                                ];
                            } else {
                                var domElementRepresentation$1 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement);
                                maybeElementAndTextNodeIndex = [
                                    domElementRepresentation$1,
                                    textNodeIndex
                                ];
                            }
                        } else {
                            var element$1 = element._0;
                            if (textSegments.tl) {
                                var domElementRepresentation$2 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, element$1);
                                maybeElementAndTextNodeIndex = [
                                    domElementRepresentation$2,
                                    -1
                                ];
                            } else {
                                var domElementRepresentation$3 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, element$1);
                                maybeElementAndTextNodeIndex = [
                                    domElementRepresentation$3,
                                    -1
                                ];
                            }
                        }
                    } else {
                        var domElementRepresentation$4 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, rootElement);
                        maybeElementAndTextNodeIndex = [
                            domElementRepresentation$4,
                            -1
                        ];
                    }
                } else {
                    maybeElementAndTextNodeIndex = undefined;
                }
                break;
            case /* Attribute */ 1:
                maybeElementAndTextNodeIndex = undefined;
                break;
            case /* Text */ 2:
                var arg$1 = rootNode.parentElement;
                var arg$2 = arg$1 == null ? undefined : Caml_option.some(arg$1);
                var parentElement$1 = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                }("Expected to get parentElement of Text node");
                var arg$3 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(parentElement$1.childNodes), function(node, index) {
                    if (node === rootNode) {
                        return index;
                    }
                });
                var textNodeIndex$1 = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
                }("Expected to find index Text node in parentElement.childNodes");
                var domElementRepresentation$5 = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, parentElement$1);
                maybeElementAndTextNodeIndex = [
                    domElementRepresentation$5,
                    textNodeIndex$1
                ];
                break;
        }
    }
    return OptionUtils$SmartcutsMacros.map(maybeElementAndTextNodeIndex, function(param) {
        var domElementIdentifierPairedWithSelector_for_contentEditableHost = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.fromElement(domElementIdentifierGenerator, contentEditableHost);
        var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, contentEditableHost);
        return {
            contentEditableHost: domElementIdentifierPairedWithSelector_for_contentEditableHost,
            domElementRepresentation: param[0],
            textNodeIndex: param[1],
            offset: offset,
            textContents: textContents
        };
    });
}
function isEqual(cursorA, cursorB) {
    if (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.isEqual(cursorA.contentEditableHost, cursorB.contentEditableHost) && DomElementIdentifierPaired__WithSelector$SmartcutsMacros.isEqual(cursorA.domElementRepresentation, cursorB.domElementRepresentation) && cursorA.textNodeIndex === cursorB.textNodeIndex && cursorA.offset === cursorB.offset) {
        return Caml_obj.caml_equal(cursorA.textContents, cursorB.textContents);
    } else {
        return false;
    }
}
function isCursorAtEndOfContentEditable(param) {
    var textContents = param.textContents;
    var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
    var func$1 = Curry._1(func, param.domElementRepresentation.domElementIdentifier);
    var maybeSearchResult = Curry._2(func$1, param.textNodeIndex, textContents);
    if (maybeSearchResult === undefined) {
        return false;
    }
    var text = TextContents$SmartcutsMacros.textGet(maybeSearchResult.textContent);
    if (maybeSearchResult.index === (List.length(textContents) - 1 | 0)) {
        return param.offset === text.length;
    } else {
        return false;
    }
}
function isCursorAtStartOfContentEditable(param) {
    var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
    var func$1 = Curry._1(func, param.domElementRepresentation.domElementIdentifier);
    var maybeSearchResult = Curry._2(func$1, param.textNodeIndex, param.textContents);
    if (maybeSearchResult !== undefined && maybeSearchResult.index === 0) {
        return param.offset === 0;
    } else {
        return false;
    }
}
function updateSelector(f, param) {
    var domElementRepresentation = param.domElementRepresentation;
    var contentEditableHost = param.contentEditableHost;
    return {
        contentEditableHost: {
            domElementIdentifier: contentEditableHost.domElementIdentifier,
            selector: Curry._1(f, contentEditableHost.selector)
        },
        domElementRepresentation: {
            domElementIdentifier: domElementRepresentation.domElementIdentifier,
            selector: Curry._1(f, domElementRepresentation.selector)
        },
        textNodeIndex: param.textNodeIndex,
        offset: param.offset,
        textContents: TextContents$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, param.textContents)
    };
}
var ForRecordingAndAuthoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromSelectionSnapshot: fromSelectionSnapshot,
    isEqual: isEqual,
    isCursorAtEndOfContentEditable: isCursorAtEndOfContentEditable,
    isCursorAtStartOfContentEditable: isCursorAtStartOfContentEditable,
    updateSelector: updateSelector
};
var SelectionSnapshot;
var NonInputSelection;
exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 92190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var TextContents$SmartcutsMacros = __webpack_require__(20114);
var DOM__HtmlElement$SmartcutsMacros = __webpack_require__(74457);
var Selection__NonInputSelection$SmartcutsMacros = __webpack_require__(80878);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var Selection__ContentEditableCursor$SmartcutsMacros = __webpack_require__(43378);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(encoder_domElementRepresentation, v) {
    if (typeof v === "number") {
        return [
            "OutdatedSelection"
        ];
    } else if (v.TAG === /* ContentEditableSelection */ 0) {
        return [
            "ContentEditableSelection",
            Curry._1(encoder_domElementRepresentation, v._0),
            Selection__NonInputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._1),
            TextContents$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._2)
        ];
    } else {
        return [
            "ContentEditableCursor",
            Curry._1(encoder_domElementRepresentation, v._0),
            Selection__ContentEditableCursor$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._1)
        ];
    }
}
function t_decode(decoder_domElementRepresentation, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditableCursor":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Selection__ContentEditableCursor$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ContentEditableCursor */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ContentEditableSelection":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Selection__NonInputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 2));
                var match$5 = TextContents$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 3));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        if (match$5.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* ContentEditableSelection */ 0,
                                    _0: match$3._0,
                                    _1: match$4._0,
                                    _2: match$5._0
                                }
                            };
                        }
                        var e$2 = match$5._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "OutdatedSelection":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* OutdatedSelection */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(stringifyDomElementRepresentation, v) {
    if (typeof v === "number") {
        return "OutdatedSelection";
    }
    if (v.TAG === /* ContentEditableSelection */ 0) {
        var func = Selection__NonInputSelection$SmartcutsMacros.Generic.stringify;
        return "ContentEditableSelection(" + (Curry._1(stringifyDomElementRepresentation, v._0) + (", " + (Curry._2(func, stringifyDomElementRepresentation, v._1) + ", textContents)")));
    }
    var func$1 = Selection__ContentEditableCursor$SmartcutsMacros.Generic.stringify;
    return "ContentEditableCursor(" + (Curry._1(stringifyDomElementRepresentation, v._0) + (Curry._2(func$1, stringifyDomElementRepresentation, v._1) + ")"));
}
var Generic = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$1(v) {
    return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function stringify$1(param) {
    return stringify(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify, param);
}
function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
    if (!selectionSnapshot) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected selectionSnapshot to have a range when ContentEditableSelectionOrCursor.ForRecordingAndAuthoring.fromSelectionSnapshot()");
    }
    var match = selectionSnapshot._0;
    var rootNode = match.rootNode;
    if (DOM__Node$SmartcutsMacros.isNodeOrItsAncestorDetached(rootNode)) {
        return /* OutdatedSelection */ 0;
    }
    var contentEditableHost = DOM$SmartcutsMacros.ContentEditable.findHost(DOM__HtmlElement$SmartcutsMacros.ofNodeOrItsAncestor(rootNode));
    if (match.collapsed) {
        var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(contentEditableHost, domElementIdentifierGenerator);
        var maybeCursor = Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
        var cursor = OptionUtils$SmartcutsMacros.getExn("Expected to get cursor", maybeCursor);
        return {
            TAG: /* ContentEditableCursor */ 1,
            _0: {
                domElementIdentifier: domElementIdentifier,
                selector: Selector$SmartcutsMacros.forDomElement(contentEditableHost)
            },
            _1: cursor
        };
    }
    var domElementIdentifier$1 = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(contentEditableHost, domElementIdentifierGenerator);
    var selection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
    var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, contentEditableHost);
    return {
        TAG: /* ContentEditableSelection */ 0,
        _0: {
            domElementIdentifier: domElementIdentifier$1,
            selector: Selector$SmartcutsMacros.forDomElement(contentEditableHost)
        },
        _1: selection,
        _2: textContents
    };
}
function extractSelectorToContentEditableHost(selectionOrCursor) {
    if (typeof selectionOrCursor === "number") {
        return;
    } else {
        return selectionOrCursor._0.selector;
    }
}
function updateSelector(f, selectionOrCursor) {
    if (typeof selectionOrCursor === "number") {
        return /* OutdatedSelection */ 0;
    }
    if (selectionOrCursor.TAG === /* ContentEditableSelection */ 0) {
        var contentEditableHost = selectionOrCursor._0;
        return {
            TAG: /* ContentEditableSelection */ 0,
            _0: {
                domElementIdentifier: contentEditableHost.domElementIdentifier,
                selector: Curry._1(f, contentEditableHost.selector)
            },
            _1: Selection__NonInputSelection$SmartcutsMacros.ForRecording.updateSelector(f, selectionOrCursor._1),
            _2: TextContents$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, selectionOrCursor._2)
        };
    }
    var contentEditableHost$1 = selectionOrCursor._0;
    return {
        TAG: /* ContentEditableCursor */ 1,
        _0: {
            domElementIdentifier: contentEditableHost$1.domElementIdentifier,
            selector: Curry._1(f, contentEditableHost$1.selector)
        },
        _1: Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, selectionOrCursor._1)
    };
}
var ForRecordingAndAuthoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    fromSelectionSnapshot: fromSelectionSnapshot,
    extractSelectorToContentEditableHost: extractSelectorToContentEditableHost,
    updateSelector: updateSelector
};
var SelectionSnapshot;
var NonInputSelection;
var ContentEditableCursor;
exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.ContentEditableCursor = ContentEditableCursor;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring; /* DOM-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 10207:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "domElementRepresentation",
            Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
        ],
        [
            "cursorPosition",
            Decco.intToJson(v.cursorPosition)
        ],
        [
            "value",
            Decco.stringToJson(v.value)
        ]
    ]);
}
function t_decode(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
    if (domElementRepresentation.TAG === /* Ok */ 0) {
        var cursorPosition = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cursorPosition"), null));
        if (cursorPosition.TAG === /* Ok */ 0) {
            var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        domElementRepresentation: domElementRepresentation._0,
                        cursorPosition: cursorPosition._0,
                        value: value._0
                    }
                };
            }
            var e = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = cursorPosition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".cursorPosition" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = domElementRepresentation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementRepresentation" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function isCursorAtEndOfInput(param) {
    return param.cursorPosition === param.value.length;
}
function isCursorAtStartOfInput(param) {
    return param.cursorPosition === 0;
}
var Generic = {
    t_encode: t_encode,
    t_decode: t_decode,
    isCursorAtEndOfInput: isCursorAtEndOfInput,
    isCursorAtStartOfInput: isCursorAtStartOfInput
};
function t_encode$1(v) {
    return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$1(v) {
    return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
var ForRecording = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    return t_encode(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$2(v) {
    return t_decode(Selector$SmartcutsMacros.selector_decode, v);
}
function fromRecording(inputCursor) {
    return {
        domElementRepresentation: inputCursor.domElementRepresentation.selector,
        cursorPosition: inputCursor.cursorPosition,
        value: inputCursor.value
    };
}
function updateSelector(f, inputCursor) {
    return {
        domElementRepresentation: Curry._1(f, inputCursor.domElementRepresentation),
        cursorPosition: inputCursor.cursorPosition,
        value: inputCursor.value
    };
}
var ForNonRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromRecording: fromRecording,
    updateSelector: updateSelector
};
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 6078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
function t_encode(v) {
    switch(v){
        case /* Forward */ 0:
            return [
                "Forward"
            ];
        case /* Backward */ 1:
            return [
                "Backward"
            ];
        case /* NoDirection */ 2:
            return [
                "NoDirection"
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Backward":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Backward */ 1
                    };
                }
            case "Forward":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Forward */ 0
                    };
                }
            case "NoDirection":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoDirection */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromString(str) {
    switch(str){
        case "backward":
            return /* Backward */ 1;
        case "forward":
            return /* Forward */ 0;
        case "none":
            return /* NoDirection */ 2;
        default:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unrecognized selection direction: " + str);
    }
}
function stringify(dir) {
    switch(dir){
        case /* Forward */ 0:
            return "Forward";
        case /* Backward */ 1:
            return "Backward";
        case /* NoDirection */ 2:
            return "NoDirection";
    }
}
var SelectionDirection = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromString: fromString,
    stringify: stringify
};
function extractTextsFromStartAndEndAndValue(start, end_, value) {
    var prefix = StringUtils$SmartcutsMacros.slice(0, start, value);
    var selectedText = StringUtils$SmartcutsMacros.slice(start, end_, value);
    var suffix = StringUtils$SmartcutsMacros.slice(end_, value.length, value);
    return [
        prefix,
        selectedText,
        suffix
    ];
}
function t_encode$1(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "domElementRepresentation",
            Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
        ],
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "start",
            Decco.intToJson(v.start)
        ],
        [
            "end_",
            Decco.intToJson(v.end_)
        ],
        [
            "selectionDirection",
            t_encode(v.selectionDirection)
        ]
    ]);
}
function t_decode$1(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
    if (domElementRepresentation.TAG === /* Ok */ 0) {
        var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            var start = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
            if (start.TAG === /* Ok */ 0) {
                var end_ = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
                if (end_.TAG === /* Ok */ 0) {
                    var selectionDirection = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectionDirection"), null));
                    if (selectionDirection.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                domElementRepresentation: domElementRepresentation._0,
                                value: value._0,
                                start: start._0,
                                end_: end_._0,
                                selectionDirection: selectionDirection._0
                            }
                        };
                    }
                    var e = selectionDirection._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".selectionDirection" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = end_._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".end_" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = start._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".start" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = domElementRepresentation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementRepresentation" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function extractTexts(param) {
    return extractTextsFromStartAndEndAndValue(param.start, param.end_, param.value);
}
function stringify$1(stringifyDomElementRepresentation, param) {
    return "{domElementRepresentation" + (Curry._1(stringifyDomElementRepresentation, param.domElementRepresentation) + (", value: " + (StringUtils$SmartcutsMacros.quote(param.value) + (", start: " + (String(param.start) + (", end_: " + (String(param.end_) + (", selectionDirection: " + (stringify(param.selectionDirection) + "}")))))))));
}
var Generic = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    extractTexts: extractTexts,
    stringify: stringify$1
};
function fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement) {
    var selector = Selector$SmartcutsMacros.forDomElement(htmlInputElement);
    var value = htmlInputElement.value;
    var start = htmlInputElement.selectionStart;
    var end_ = htmlInputElement.selectionEnd;
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(htmlInputElement, domElementIdentifierGenerator);
    var selectionDirection = fromString(htmlInputElement.selectionDirection);
    return {
        domElementRepresentation: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
        },
        value: value,
        start: start,
        end_: end_,
        selectionDirection: selectionDirection
    };
}
function actsOnSameNodeAsOtherSelection(param, param$1) {
    return param.domElementRepresentation.domElementIdentifier === param$1.domElementRepresentation.domElementIdentifier;
}
function actsOnNode(node, param) {
    return param.domElementRepresentation.domElementIdentifier === node.domElementIdentifier;
}
var ForRecording = {
    fromHtmlInputElement: fromHtmlInputElement,
    actsOnSameNodeAsOtherSelection: actsOnSameNodeAsOtherSelection,
    actsOnNode: actsOnNode
};
function fromRecording(selection) {
    return {
        domElementRepresentation: selection.domElementRepresentation.selector,
        value: selection.value,
        start: selection.start,
        end_: selection.end_,
        selectionDirection: selection.selectionDirection
    };
}
function updateSelector(f, selection) {
    return {
        domElementRepresentation: Curry._1(f, selection.domElementRepresentation),
        value: selection.value,
        start: selection.start,
        end_: selection.end_,
        selectionDirection: selection.selectionDirection
    };
}
var ForNonRecording = {
    fromRecording: fromRecording,
    updateSelector: updateSelector
};
exports.SelectionDirection = SelectionDirection;
exports.extractTextsFromStartAndEndAndValue = extractTextsFromStartAndEndAndValue;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 2374:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var Selection__InputSelection$SmartcutsMacros = __webpack_require__(6078);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "start",
            Decco.intToJson(v.start)
        ],
        [
            "end_",
            Decco.intToJson(v.end_)
        ],
        [
            "selectionDirection",
            Selection__InputSelection$SmartcutsMacros.SelectionDirection.t_encode(v.selectionDirection)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var start = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
    if (start.TAG === /* Ok */ 0) {
        var end_ = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
        if (end_.TAG === /* Ok */ 0) {
            var selectionDirection = Selection__InputSelection$SmartcutsMacros.SelectionDirection.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectionDirection"), null));
            if (selectionDirection.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        start: start._0,
                        end_: end_._0,
                        selectionDirection: selectionDirection._0
                    }
                };
            }
            var e = selectionDirection._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selectionDirection" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = end_._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".end_" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = start._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".start" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var InputSelectionParams = {
    t_encode: t_encode,
    t_decode: t_decode
};
function params_encode(v) {
    if (typeof v === "number") {
        return [
            "SelectionNotSupported"
        ];
    } else if (v.TAG === /* InputSelectionParams */ 0) {
        return [
            "InputSelectionParams",
            t_encode(v._0)
        ];
    } else {
        return [
            "InputCursorPosition",
            Decco.intToJson(v._0)
        ];
    }
}
function params_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InputCursorPosition":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputCursorPosition */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "InputSelectionParams":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputSelectionParams */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SelectionNotSupported":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectionNotSupported */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "domElementRepresentation",
            Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
        ],
        [
            "params",
            params_encode(v.params)
        ],
        [
            "value",
            Decco.stringToJson(v.value)
        ]
    ]);
}
function t_decode$1(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
    if (domElementRepresentation.TAG === /* Ok */ 0) {
        var params = params_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "params"), null));
        if (params.TAG === /* Ok */ 0) {
            var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        domElementRepresentation: domElementRepresentation._0,
                        params: params._0,
                        value: value._0
                    }
                };
            }
            var e = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = params._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".params" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = domElementRepresentation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementRepresentation" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var Generic = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    return t_encode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$2(v) {
    return t_decode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement) {
    var selector = Selector$SmartcutsMacros.forDomElement(htmlInputElement);
    var value = htmlInputElement.value;
    var start = htmlInputElement.selectionStart;
    var end_ = htmlInputElement.selectionEnd;
    var params;
    if (start === end_) {
        params = {
            TAG: /* InputCursorPosition */ 1,
            _0: start
        };
    } else {
        var selectionDirection = Selection__InputSelection$SmartcutsMacros.SelectionDirection.fromString(htmlInputElement.selectionDirection);
        params = {
            TAG: /* InputSelectionParams */ 0,
            _0: {
                start: start,
                end_: end_,
                selectionDirection: selectionDirection
            }
        };
    }
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(htmlInputElement, domElementIdentifierGenerator);
    return {
        domElementRepresentation: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
        },
        params: params,
        value: value
    };
}
var ForRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromHtmlInputElement: fromHtmlInputElement
};
function t_encode$3(v) {
    return t_encode$1(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$3(v) {
    return t_decode$1(Selector$SmartcutsMacros.selector_decode, v);
}
function fromRecording(selectionOrCursor) {
    return {
        domElementRepresentation: selectionOrCursor.domElementRepresentation.selector,
        params: selectionOrCursor.params,
        value: selectionOrCursor.value
    };
}
function updateSelector(f, param) {
    return {
        domElementRepresentation: Curry._1(f, param.domElementRepresentation),
        params: param.params,
        value: param.value
    };
}
var ForNonRecording = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromRecording: fromRecording,
    updateSelector: updateSelector
};
var SelectionDirection;
exports.SelectionDirection = SelectionDirection;
exports.InputSelectionParams = InputSelectionParams;
exports.params_encode = params_encode;
exports.params_decode = params_decode;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 80878:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Text = __webpack_require__(32348);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var TextContents$SmartcutsMacros = __webpack_require__(20114);
var Selection__Snapshot$SmartcutsMacros = __webpack_require__(27836);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "siblingIndex",
            Decco.intToJson(v.siblingIndex)
        ],
        [
            "text",
            Decco.stringToJson(v.text)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var siblingIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "siblingIndex"), null));
    if (siblingIndex.TAG === /* Ok */ 0) {
        var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    siblingIndex: siblingIndex._0,
                    text: text._0
                }
            };
        }
        var e = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = siblingIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".siblingIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{siblingIndex: " + (String(param.siblingIndex) + (", text: " + (StringUtils$SmartcutsMacros.quote(param.text) + "}")));
}
var TextNode = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "domElementRepresentation",
            Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
        ],
        [
            "childTextNodes",
            Decco.arrayToJson(t_encode, v.childTextNodes)
        ]
    ]);
}
function t_decode$1(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
    if (domElementRepresentation.TAG === /* Ok */ 0) {
        var childTextNodes = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "childTextNodes"), null));
        if (childTextNodes.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementRepresentation: domElementRepresentation._0,
                    childTextNodes: childTextNodes._0
                }
            };
        }
        var e = childTextNodes._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".childTextNodes" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementRepresentation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementRepresentation" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(stringifyDomElementRepresentation, param) {
    return "{domElementRepresentation: " + (Curry._1(stringifyDomElementRepresentation, param.domElementRepresentation) + (", childTextNodes: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.childTextNodes, stringify))) + "}")));
}
var ElementNode = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return t_encode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$2(v) {
    return t_decode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function fromDomElement(domElementIdentifierGenerator, element) {
    var selector = Selector$SmartcutsMacros.forDomElement(element);
    var childNodes = element.childNodes;
    var childTextNodes = OptionUtils$SmartcutsMacros.arrayOfOptionsToArrayOfUnboxedSomes($$Array.mapi(function(siblingIndex, node) {
        var textNode = Webapi__Dom__Text.ofNode(node);
        if (textNode === undefined) {
            return;
        }
        var text = Caml_option.valFromOption(textNode).data;
        return {
            siblingIndex: siblingIndex,
            text: text
        };
    }, Array.prototype.slice.call(childNodes)));
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
    return {
        domElementRepresentation: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
        },
        childTextNodes: childTextNodes
    };
}
function updateSelector(f, node) {
    var domElementRepresentation = node.domElementRepresentation;
    return {
        domElementRepresentation: {
            domElementIdentifier: domElementRepresentation.domElementIdentifier,
            selector: Curry._1(f, domElementRepresentation.selector)
        },
        childTextNodes: node.childTextNodes
    };
}
var ElementNodeForRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromDomElement: fromDomElement,
    updateSelector: updateSelector
};
function t_encode$3(v) {
    return t_encode$1(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$3(v) {
    return t_decode$1(Selector$SmartcutsMacros.selector_decode, v);
}
function fromElementNodeForRecording(elementNode) {
    return {
        domElementRepresentation: elementNode.domElementRepresentation.selector,
        childTextNodes: elementNode.childTextNodes
    };
}
function updateSelector$1(f, node) {
    return {
        domElementRepresentation: Curry._1(f, node.domElementRepresentation),
        childTextNodes: node.childTextNodes
    };
}
var ElementNodeForNonRecording = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromElementNodeForRecording: fromElementNodeForRecording,
    updateSelector: updateSelector$1
};
function t_encode$4(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "elementNode",
            t_encode$1(encoder_domElementRepresentation, v.elementNode)
        ],
        [
            "textNode",
            Decco.optionToJson(t_encode, v.textNode)
        ],
        [
            "offset",
            Decco.intToJson(v.offset)
        ]
    ]);
}
function t_decode$4(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var elementNode = t_decode$1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementNode"), null));
    if (elementNode.TAG === /* Ok */ 0) {
        var textNode = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNode"), null));
        if (textNode.TAG === /* Ok */ 0) {
            var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
            if (offset.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        elementNode: elementNode._0,
                        textNode: textNode._0,
                        offset: offset._0
                    }
                };
            }
            var e = offset._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".offset" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = textNode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".textNode" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = elementNode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".elementNode" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(stringifyDomElementRepresentation, param) {
    return "{elementNode: " + (stringify$1(stringifyDomElementRepresentation, param.elementNode) + (", textNode: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.textNode, stringify)) + (", offset: " + (String(param.offset) + "}")))));
}
function extractElementNode(boundary) {
    return boundary.elementNode;
}
function extractTextAndOffset(boundary) {
    return [
        OptionUtils$SmartcutsMacros.withDefault("", OptionUtils$SmartcutsMacros.map(boundary.textNode, function(textNode) {
            return textNode.text;
        })),
        boundary.offset
    ];
}
function isSame(isDomElementRepresentationEqual, param, param$1) {
    var textNodeB = param$1.textNode;
    var textNodeA = param.textNode;
    if (Curry._2(isDomElementRepresentationEqual, param.elementNode.domElementRepresentation, param$1.elementNode.domElementRepresentation)) {
        if (textNodeA !== undefined) {
            if (textNodeB !== undefined) {
                return textNodeA.siblingIndex === textNodeB.siblingIndex;
            } else {
                return false;
            }
        } else {
            return textNodeB === undefined;
        }
    } else {
        return false;
    }
}
var SelectionBoundary = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$2,
    extractElementNode: extractElementNode,
    extractTextAndOffset: extractTextAndOffset,
    isSame: isSame
};
function t_encode$5(v) {
    return t_encode$4(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$5(v) {
    return t_decode$4(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function ofTextNodeAndOffset(domElementIdentifierGenerator, textNode, offset) {
    var arg = textNode.parentNode;
    var arg$1 = arg == null ? undefined : Caml_option.some(arg);
    var arg$2 = Webapi__Dom__Element.ofNode(function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected text parent node for Text node in Selection.Cursor.ofNodeAndOffset"));
    var parentElement = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
    }("Expected element node for parent text node in Selection.Cursor.ofNodeAndOffset");
    var arg$3 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(parentElement.childNodes), function(sibling, index) {
        if (Caml_obj.caml_equal(sibling, textNode)) {
            return index;
        }
    });
    var siblingIndex = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
    }("Expected to find Text node among parentElement childNodes in Selection.Cursor.ofNodeAndOffset");
    var elementNode = fromDomElement(domElementIdentifierGenerator, parentElement);
    var text = textNode.data;
    var textNode$1 = {
        siblingIndex: siblingIndex,
        text: text
    };
    return {
        elementNode: elementNode,
        textNode: textNode$1,
        offset: offset
    };
}
function ofNodeAndOffset(domElementIdentifierGenerator, _node, offset) {
    while(true){
        var node = _node;
        var match = Webapi__Dom__Node.nodeType(node);
        if (match >= 3) {
            return Js_exn.raiseError("Expected nodeType = Element | Text");
        }
        switch(match){
            case /* Element */ 0:
                if (offset === 0) {
                    var arg1 = Webapi__Dom__Element.ofNode(node);
                    var element = (function(arg) {
                        return function(param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg);
                        };
                    })(arg1)("Expected node");
                    return {
                        elementNode: fromDomElement(domElementIdentifierGenerator, element),
                        textNode: undefined,
                        offset: 0
                    };
                }
                var arg$11 = Webapi__Dom__Element.ofNode(node);
                var element$1 = (function(arg$1) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    };
                })(arg$11)("Expected node");
                var node$1 = element$1.firstChild;
                if (node$1 == null) {
                    return {
                        elementNode: {
                            domElementRepresentation: {
                                domElementIdentifier: DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element$1, domElementIdentifierGenerator),
                                selector: Selector$SmartcutsMacros.forDomElement(element$1)
                            },
                            childTextNodes: []
                        },
                        textNode: undefined,
                        offset: 0
                    };
                }
                if (Webapi__Dom__Node.nodeType(node$1) === /* Text */ 2) {
                    var arg$21 = Webapi__Dom__Text.ofNode(node$1);
                    var textNode = (function(arg$2) {
                        return function(param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                        };
                    })(arg$21)("SelectionBoundary.ofNodeAndOffset error: Expected to get TextNode if nodeType == Text");
                    return ofTextNodeAndOffset(domElementIdentifierGenerator, textNode, offset);
                }
                if (Webapi__Dom__Node.nodeType(node$1) !== /* Element */ 0) {
                    return Util$SmartcutsMacros.logAndRaiseJsError("SelectionBoundary.ofNodeAndOffset error: Expected first child node to be a text or element node");
                }
                _node = node$1;
                continue;
            case /* Attribute */ 1:
                return Js_exn.raiseError("Expected nodeType = Element | Text");
            case /* Text */ 2:
                var arg$31 = Webapi__Dom__Text.ofNode(node);
                var textNode$1 = (function(arg$3) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
                    };
                })(arg$31)("Expected text node for Text node in Selection.Cursor.ofNodeAndOffset");
                return ofTextNodeAndOffset(domElementIdentifierGenerator, textNode$1, offset);
        }
    }
    ;
}
function isSame$1(param1, param$11) {
    return isSame(function(param, param$1) {
        return param.domElementIdentifier === param$1.domElementIdentifier;
    }, param1, param$11);
}
function endsOnNode(node, param) {
    return param.elementNode.domElementRepresentation.domElementIdentifier === node.domElementIdentifier;
}
function updateSelector$2(f, boundary) {
    return {
        elementNode: updateSelector(f, boundary.elementNode),
        textNode: boundary.textNode,
        offset: boundary.offset
    };
}
var SelectionBoundaryForRecording = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    ofTextNodeAndOffset: ofTextNodeAndOffset,
    ofNodeAndOffset: ofNodeAndOffset,
    isSame: isSame$1,
    endsOnNode: endsOnNode,
    updateSelector: updateSelector$2
};
function t_encode$6(v) {
    return t_encode$4(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$6(v) {
    return t_decode$4(Selector$SmartcutsMacros.selector_decode, v);
}
function fromSelectionBoundaryForRecording(boundary) {
    return {
        elementNode: fromElementNodeForRecording(boundary.elementNode),
        textNode: boundary.textNode,
        offset: boundary.offset
    };
}
function updateSelector$3(f, boundary) {
    return {
        elementNode: updateSelector$1(f, boundary.elementNode),
        textNode: boundary.textNode,
        offset: boundary.offset
    };
}
var SelectionBoundaryForNonRecording = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    fromSelectionBoundaryForRecording: fromSelectionBoundaryForRecording,
    updateSelector: updateSelector$3
};
function singleElement_encode(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "elementNode",
            t_encode$1(encoder_domElementRepresentation, v.elementNode)
        ],
        [
            "textNode",
            Decco.optionToJson(t_encode, v.textNode)
        ],
        [
            "startOffset",
            Decco.intToJson(v.startOffset)
        ],
        [
            "endOffset",
            Decco.intToJson(v.endOffset)
        ],
        [
            "selectedText",
            Decco.stringToJson(v.selectedText)
        ]
    ]);
}
function singleElement_decode(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var elementNode = t_decode$1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementNode"), null));
    if (elementNode.TAG === /* Ok */ 0) {
        var textNode = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNode"), null));
        if (textNode.TAG === /* Ok */ 0) {
            var startOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startOffset"), null));
            if (startOffset.TAG === /* Ok */ 0) {
                var endOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endOffset"), null));
                if (endOffset.TAG === /* Ok */ 0) {
                    var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
                    if (selectedText.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                elementNode: elementNode._0,
                                textNode: textNode._0,
                                startOffset: startOffset._0,
                                endOffset: endOffset._0,
                                selectedText: selectedText._0
                            }
                        };
                    }
                    var e = selectedText._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".selectedText" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = endOffset._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".endOffset" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = startOffset._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".startOffset" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = textNode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".textNode" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = elementNode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".elementNode" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function adjacentText_encode(v) {
    return Js_dict.fromArray([
        [
            "text",
            Decco.stringToJson(v.text)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "textNodeIndex",
            Decco.intToJson(v.textNodeIndex)
        ]
    ]);
}
function adjacentText_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
    if (text.TAG === /* Ok */ 0) {
        var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
        if (selector.TAG === /* Ok */ 0) {
            var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
            if (textNodeIndex.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        text: text._0,
                        selector: selector._0,
                        textNodeIndex: textNodeIndex._0
                    }
                };
            }
            var e = textNodeIndex._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".textNodeIndex" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = selector._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selector" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = text._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function crossNodes_encode(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "start",
            t_encode$4(encoder_domElementRepresentation, v.start)
        ],
        [
            "end_",
            t_encode$4(encoder_domElementRepresentation, v.end_)
        ],
        [
            "selectedText",
            Decco.stringToJson(v.selectedText)
        ],
        [
            "prevAdjacentText",
            Decco.optionToJson(adjacentText_encode, v.prevAdjacentText)
        ],
        [
            "nextAdjacentText",
            Decco.optionToJson(adjacentText_encode, v.nextAdjacentText)
        ]
    ]);
}
function crossNodes_decode(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var start = t_decode$4(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
    if (start.TAG === /* Ok */ 0) {
        var end_ = t_decode$4(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
        if (end_.TAG === /* Ok */ 0) {
            var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
            if (selectedText.TAG === /* Ok */ 0) {
                var prevAdjacentText = Decco.optionFromJson(adjacentText_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "prevAdjacentText"), null));
                if (prevAdjacentText.TAG === /* Ok */ 0) {
                    var nextAdjacentText = Decco.optionFromJson(adjacentText_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextAdjacentText"), null));
                    if (nextAdjacentText.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                start: start._0,
                                end_: end_._0,
                                selectedText: selectedText._0,
                                prevAdjacentText: prevAdjacentText._0,
                                nextAdjacentText: nextAdjacentText._0
                            }
                        };
                    }
                    var e = nextAdjacentText._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".nextAdjacentText" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = prevAdjacentText._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".prevAdjacentText" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = selectedText._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selectedText" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = end_._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".end_" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = start._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".start" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function t_encode$7(encoder_domElementRepresentation, v) {
    if (v.TAG === /* SingleNode */ 0) {
        return [
            "SingleNode",
            singleElement_encode(encoder_domElementRepresentation, v._0)
        ];
    } else {
        return [
            "CrossNodes",
            crossNodes_encode(encoder_domElementRepresentation, v._0)
        ];
    }
}
function t_decode$7(decoder_domElementRepresentation, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CrossNodes":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = crossNodes_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CrossNodes */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SingleNode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = singleElement_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SingleNode */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyAdjacentText(param) {
    return "{text: " + (StringUtils$SmartcutsMacros.quote(param.text) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", textNodeIndex: " + (String(param.textNodeIndex) + "}")))));
}
function stringify$3(stringifyDomElementRepresentation, selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var match = selection._0;
        var textNode = match.textNode;
        return "SingleNode({elementNode: " + (stringify$1(stringifyDomElementRepresentation, match.elementNode) + (", textNode: " + ((textNode !== undefined ? stringify(textNode) : "undefined") + (", startOffset: " + (String(match.startOffset) + (", endOffset: " + (String(match.endOffset) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(match.selectedText) + "})")))))))));
    }
    var match$1 = selection._0;
    return "CrossNodes({start: " + (stringify$2(stringifyDomElementRepresentation, match$1.start) + ("end_: " + (stringify$2(stringifyDomElementRepresentation, match$1.end_) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(match$1.selectedText) + (", prevAdjacentText: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(match$1.prevAdjacentText, stringifyAdjacentText)) + (", nextAdjacentText: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(match$1.nextAdjacentText, stringifyAdjacentText)) + "})")))))))));
}
function extractTexts(selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var match = selection._0;
        var text = OptionUtils$SmartcutsMacros.withDefault("", OptionUtils$SmartcutsMacros.map(match.textNode, function(textNode) {
            return textNode.text;
        }));
        var prefix = text.slice(0, match.startOffset);
        var suffix = text.slice(match.endOffset);
        return [
            prefix,
            match.selectedText,
            suffix
        ];
    }
    var match$1 = selection._0;
    var nextAdjacentText = match$1.nextAdjacentText;
    var prevAdjacentText = match$1.prevAdjacentText;
    var match$2 = extractTextAndOffset(match$1.start);
    var match$3 = extractTextAndOffset(match$1.end_);
    var prefix$1 = match$2[0].slice(0, match$2[1]);
    var suffix$1 = match$3[0].slice(match$3[1]);
    var prefixWithAdjacentText = prevAdjacentText !== undefined ? prevAdjacentText.text + prefix$1 : prefix$1;
    var suffixWithAdjacentText = nextAdjacentText !== undefined ? suffix$1 + nextAdjacentText.text : suffix$1;
    return [
        prefixWithAdjacentText,
        match$1.selectedText,
        suffixWithAdjacentText
    ];
}
function extractBoundaryPair(selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var match = selection._0;
        var textNode = match.textNode;
        var elementNode = match.elementNode;
        return [
            {
                elementNode: elementNode,
                textNode: textNode,
                offset: match.startOffset
            },
            {
                elementNode: elementNode,
                textNode: textNode,
                offset: match.endOffset
            }
        ];
    }
    var match$1 = selection._0;
    return [
        match$1.start,
        match$1.end_
    ];
}
function extractSelectors(selectorFromDomElementRepresentation, selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        return [
            Curry._1(selectorFromDomElementRepresentation, selection._0.elementNode.domElementRepresentation)
        ];
    }
    var match = selection._0;
    return [
        Curry._1(selectorFromDomElementRepresentation, match.start.elementNode.domElementRepresentation),
        Curry._1(selectorFromDomElementRepresentation, match.end_.elementNode.domElementRepresentation)
    ];
}
var Generic = {
    singleElement_encode: singleElement_encode,
    singleElement_decode: singleElement_decode,
    adjacentText_encode: adjacentText_encode,
    adjacentText_decode: adjacentText_decode,
    crossNodes_encode: crossNodes_encode,
    crossNodes_decode: crossNodes_decode,
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringifyAdjacentText: stringifyAdjacentText,
    stringify: stringify$3,
    extractTexts: extractTexts,
    extractBoundaryPair: extractBoundaryPair,
    extractSelectors: extractSelectors
};
function t_encode$8(v) {
    return t_encode$7(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$8(v) {
    return t_decode$7(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
    if (!selectionSnapshot) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected selectionSnapshot to have a range when NonInputSelection.ForRecording.fromSelectionSnapshot()");
    }
    var match1 = selectionSnapshot._0;
    var selectedText = match1.selectedText;
    var endOffset = match1.endOffset;
    var endNode = match1.endNode;
    var startOffset = match1.startOffset;
    var startNode = match1.startNode;
    var start = ofNodeAndOffset(domElementIdentifierGenerator, startNode, startOffset);
    if (startNode === endNode) {
        return {
            TAG: /* SingleNode */ 0,
            _0: {
                elementNode: start.elementNode,
                textNode: start.textNode,
                startOffset: startOffset,
                endOffset: endOffset,
                selectedText: selectedText
            }
        };
    }
    var end_ = ofNodeAndOffset(domElementIdentifierGenerator, endNode, endOffset);
    var arg = Webapi__Dom__Element.ofNode(match1.rootNode);
    var rootElement = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected rootNode to be an Element if startNode != endNode");
    var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, rootElement);
    var maybeSearchResultForStartNode = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.searchNode(domElementIdentifierGenerator, startNode, textContents);
    var maybeSearchResultForEndNode = endOffset === 0 ? undefined : TextContents$SmartcutsMacros.ForRecordingAndAuthoring.searchNode(domElementIdentifierGenerator, endNode, textContents);
    return {
        TAG: /* CrossNodes */ 1,
        _0: {
            start: start,
            end_: end_,
            selectedText: selectedText,
            prevAdjacentText: OptionUtils$SmartcutsMacros.andThen(function(param) {
                var match = Belt_List.get(textContents, param.index - 1 | 0);
                if (match === undefined) {
                    return;
                }
                if (match.TAG === /* TextSegment */ 0) {
                    var match$1 = match._0;
                    if (match$1.TAG !== /* NonEmptySegment */ 0) {
                        return {
                            text: "",
                            selector: match$1._0.selector,
                            textNodeIndex: -1
                        };
                    }
                    var match$2 = match$1._0;
                    return {
                        text: match$2.text,
                        selector: match$2.parentElement.selector,
                        textNodeIndex: match$2.textNodeIndex
                    };
                }
                var match$3 = match._0;
                if (match$3.TAG !== /* NonEmptySegment */ 0) {
                    return {
                        text: "",
                        selector: match$3._0.selector,
                        textNodeIndex: -1
                    };
                }
                var match$4 = match$3._0;
                return {
                    text: match$4.text,
                    selector: match$4.parentElement.selector,
                    textNodeIndex: 0
                };
            }, maybeSearchResultForStartNode),
            nextAdjacentText: OptionUtils$SmartcutsMacros.andThen(function(param) {
                var match = Belt_List.get(textContents, param.index + 1 | 0);
                if (match === undefined) {
                    return;
                }
                if (match.TAG === /* TextSegment */ 0) {
                    var match$1 = match._0;
                    if (match$1.TAG !== /* NonEmptySegment */ 0) {
                        return {
                            text: "",
                            selector: match$1._0.selector,
                            textNodeIndex: -1
                        };
                    }
                    var match$2 = match$1._0;
                    return {
                        text: match$2.text,
                        selector: match$2.parentElement.selector,
                        textNodeIndex: match$2.textNodeIndex
                    };
                }
                var match$3 = match._0;
                if (match$3.TAG !== /* NonEmptySegment */ 0) {
                    return {
                        text: "",
                        selector: match$3._0.selector,
                        textNodeIndex: -1
                    };
                }
                var match$4 = match$3._0;
                return {
                    text: match$4.text,
                    selector: match$4.parentElement.selector,
                    textNodeIndex: 0
                };
            }, maybeSearchResultForEndNode)
        }
    };
}
function fromDomSelection(domElementIdentifierGenerator, domSelection) {
    return fromSelectionSnapshot(domElementIdentifierGenerator, Selection__Snapshot$SmartcutsMacros.Regular.fromDomSelection(domSelection));
}
function extractSelectors$1(param2) {
    return extractSelectors(function(param) {
        return param.selector;
    }, param2);
}
function actsOnSameNodeAsOtherSelection(selectionA, selectionB) {
    var match = extractBoundaryPair(selectionA);
    var match$1 = extractBoundaryPair(selectionB);
    if (isSame$1(match[0], match$1[0])) {
        return true;
    } else {
        return isSame$1(match[1], match$1[1]);
    }
}
function endsOnNode$1(node, selection) {
    var match = extractBoundaryPair(selection);
    return endsOnNode(node, match[1]);
}
function updateSelector$4(f, selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var singleElement = selection._0;
        return {
            TAG: /* SingleNode */ 0,
            _0: {
                elementNode: updateSelector(f, singleElement.elementNode),
                textNode: singleElement.textNode,
                startOffset: singleElement.startOffset,
                endOffset: singleElement.endOffset,
                selectedText: singleElement.selectedText
            }
        };
    }
    var crossNodes = selection._0;
    return {
        TAG: /* CrossNodes */ 1,
        _0: {
            start: updateSelector$2(f, crossNodes.start),
            end_: updateSelector$2(f, crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
        }
    };
}
var ForRecording = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    fromSelectionSnapshot: fromSelectionSnapshot,
    fromDomSelection: fromDomSelection,
    extractSelectors: extractSelectors$1,
    actsOnSameNodeAsOtherSelection: actsOnSameNodeAsOtherSelection,
    endsOnNode: endsOnNode$1,
    updateSelector: updateSelector$4
};
function t_encode$9(v) {
    return t_encode$7(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$9(v) {
    return t_decode$7(Selector$SmartcutsMacros.selector_decode, v);
}
function fromRecording(selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var singleNode = selection._0;
        return {
            TAG: /* SingleNode */ 0,
            _0: {
                elementNode: fromElementNodeForRecording(singleNode.elementNode),
                textNode: singleNode.textNode,
                startOffset: singleNode.startOffset,
                endOffset: singleNode.endOffset,
                selectedText: singleNode.selectedText
            }
        };
    }
    var crossNodes = selection._0;
    return {
        TAG: /* CrossNodes */ 1,
        _0: {
            start: fromSelectionBoundaryForRecording(crossNodes.start),
            end_: fromSelectionBoundaryForRecording(crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
        }
    };
}
function updateSelector$5(f, selection) {
    if (selection.TAG === /* SingleNode */ 0) {
        var singleElement = selection._0;
        return {
            TAG: /* SingleNode */ 0,
            _0: {
                elementNode: updateSelector$1(f, singleElement.elementNode),
                textNode: singleElement.textNode,
                startOffset: singleElement.startOffset,
                endOffset: singleElement.endOffset,
                selectedText: singleElement.selectedText
            }
        };
    }
    var crossNodes = selection._0;
    return {
        TAG: /* CrossNodes */ 1,
        _0: {
            start: updateSelector$3(f, crossNodes.start),
            end_: updateSelector$3(f, crossNodes.end_),
            selectedText: crossNodes.selectedText,
            prevAdjacentText: crossNodes.prevAdjacentText,
            nextAdjacentText: crossNodes.nextAdjacentText
        }
    };
}
function extractSelectors$2(param) {
    return extractSelectors(function(selector) {
        return selector;
    }, param);
}
var ForNonRecording = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    fromRecording: fromRecording,
    updateSelector: updateSelector$5,
    extractSelectors: extractSelectors$2
};
var SelectionSnapshot;
exports.SelectionSnapshot = SelectionSnapshot;
exports.TextNode = TextNode;
exports.ElementNode = ElementNode;
exports.ElementNodeForRecording = ElementNodeForRecording;
exports.ElementNodeForNonRecording = ElementNodeForNonRecording;
exports.SelectionBoundary = SelectionBoundary;
exports.SelectionBoundaryForRecording = SelectionBoundaryForRecording;
exports.SelectionBoundaryForNonRecording = SelectionBoundaryForNonRecording;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 27836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var DOM__Node$SmartcutsMacros = __webpack_require__(73466);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function range_encode(encoder_domNode, v) {
    return Js_dict.fromArray([
        [
            "rootNode",
            Curry._1(encoder_domNode, v.rootNode)
        ],
        [
            "startNode",
            Curry._1(encoder_domNode, v.startNode)
        ],
        [
            "startOffset",
            Decco.intToJson(v.startOffset)
        ],
        [
            "endNode",
            Curry._1(encoder_domNode, v.endNode)
        ],
        [
            "endOffset",
            Decco.intToJson(v.endOffset)
        ],
        [
            "collapsed",
            Decco.boolToJson(v.collapsed)
        ],
        [
            "selectedText",
            Decco.stringToJson(v.selectedText)
        ]
    ]);
}
function range_decode(decoder_domNode, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rootNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rootNode"), null));
    if (rootNode.TAG === /* Ok */ 0) {
        var startNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startNode"), null));
        if (startNode.TAG === /* Ok */ 0) {
            var startOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startOffset"), null));
            if (startOffset.TAG === /* Ok */ 0) {
                var endNode = Curry._1(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "endNode"), null));
                if (endNode.TAG === /* Ok */ 0) {
                    var endOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endOffset"), null));
                    if (endOffset.TAG === /* Ok */ 0) {
                        var collapsed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "collapsed"), null));
                        if (collapsed.TAG === /* Ok */ 0) {
                            var selectedText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedText"), null));
                            if (selectedText.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        rootNode: rootNode._0,
                                        startNode: startNode._0,
                                        startOffset: startOffset._0,
                                        endNode: endNode._0,
                                        endOffset: endOffset._0,
                                        collapsed: collapsed._0,
                                        selectedText: selectedText._0
                                    }
                                };
                            }
                            var e = selectedText._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".selectedText" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = collapsed._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".collapsed" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = endOffset._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".endOffset" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = endNode._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".endNode" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = startOffset._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".startOffset" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = startNode._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".startNode" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = rootNode._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rootNode" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function t_encode(encoder_domNode, v) {
    if (v) {
        return [
            "Range",
            range_encode(encoder_domNode, v._0)
        ];
    } else {
        return [
            "NoRange"
        ];
    }
}
function t_decode(decoder_domNode, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NoRange":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoRange */ 0
                    };
                }
            case "Range":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = range_decode(decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Range */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapRange(mapDomNode, param) {
    return {
        rootNode: Curry._1(mapDomNode, param.rootNode),
        startNode: Curry._1(mapDomNode, param.startNode),
        startOffset: param.startOffset,
        endNode: Curry._1(mapDomNode, param.endNode),
        endOffset: param.endOffset,
        collapsed: param.collapsed,
        selectedText: param.selectedText
    };
}
function stringifyRange(stringifyDomNode, param) {
    return "{rootNode: " + (Curry._1(stringifyDomNode, param.rootNode) + (", startNode: " + (Curry._1(stringifyDomNode, param.startNode) + (", startOffset: " + (String(param.startOffset) + (", endNode: " + (Curry._1(stringifyDomNode, param.endNode) + (", endOffset: " + (String(param.endOffset) + (", collapsed: " + (Pervasives.string_of_bool(param.collapsed) + (", selectedText: " + (StringUtils$SmartcutsMacros.quote(param.selectedText) + "}")))))))))))));
}
function map(mapDomNode, snapshot) {
    if (snapshot) {
        return /* Range */ {
            _0: mapRange(mapDomNode, snapshot._0)
        };
    } else {
        return /* NoRange */ 0;
    }
}
function stringify(stringifyDomNode, snapshot) {
    if (snapshot) {
        return "Range(" + (stringifyRange(stringifyDomNode, snapshot._0) + ")");
    } else {
        return "NoRange";
    }
}
var Generic = {
    range_encode: range_encode,
    range_decode: range_decode,
    t_encode: t_encode,
    t_decode: t_decode,
    mapRange: mapRange,
    stringifyRange: stringifyRange,
    map: map,
    stringify: stringify
};
function fromDomSelection(selection) {
    var match = selection.rangeCount;
    if (match === 0) {
        return /* NoRange */ 0;
    }
    var range = selection.getRangeAt(0);
    return /* Range */ {
        _0: {
            rootNode: range.commonAncestorContainer,
            startNode: range.startContainer,
            startOffset: range.startOffset,
            endNode: range.endContainer,
            endOffset: range.endOffset,
            collapsed: range.collapsed,
            selectedText: selection.toString()
        }
    };
}
function capture(param) {
    var arg = Belt_Option.map(Caml_option.nullable_to_opt(window.getSelection()), fromDomSelection);
    var param$1 = /* NoRange */ 0;
    return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}
var Regular = {
    fromDomSelection: fromDomSelection,
    capture: capture
};
function t_encode$1(v) {
    return t_encode(DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}
function t_decode$1(v) {
    return t_decode(DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}
var ForSerialization = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization; /* DOM__Node-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 874:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var Selection__InputSelection$SmartcutsMacros = __webpack_require__(6078);
var Selection__NonInputSelection$SmartcutsMacros = __webpack_require__(80878);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(encoder_domElementRepresentation, v) {
    if (v.TAG === /* NonInputSelection */ 0) {
        return [
            "NonInputSelection",
            Selection__NonInputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._0)
        ];
    } else {
        return [
            "InputSelection",
            Selection__InputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._0)
        ];
    }
}
function t_decode(decoder_domElementRepresentation, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InputSelection":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selection__InputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputSelection */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NonInputSelection":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Selection__NonInputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NonInputSelection */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function extractTexts(selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return Selection__NonInputSelection$SmartcutsMacros.Generic.extractTexts(selection._0);
    } else {
        return Selection__InputSelection$SmartcutsMacros.Generic.extractTexts(selection._0);
    }
}
function extractSelectors(selectorFromDomElementRepresentation, selection) {
    if (selection.TAG !== /* NonInputSelection */ 0) {
        return [
            Curry._1(selectorFromDomElementRepresentation, selection._0.domElementRepresentation)
        ];
    }
    var func = Selection__NonInputSelection$SmartcutsMacros.Generic.extractSelectors;
    return Curry._2(func, selectorFromDomElementRepresentation, selection._0);
}
function stringify(stringifyDomElementRepresentation, strictSelection) {
    if (strictSelection.TAG === /* NonInputSelection */ 0) {
        return "NonInputSelection(" + (Selection__NonInputSelection$SmartcutsMacros.Generic.stringify(stringifyDomElementRepresentation, strictSelection._0) + ")");
    } else {
        return "InputSelection(" + (Selection__InputSelection$SmartcutsMacros.Generic.stringify(stringifyDomElementRepresentation, strictSelection._0) + ")");
    }
}
var Generic = {
    t_encode: t_encode,
    t_decode: t_decode,
    extractTexts: extractTexts,
    extractSelectors: extractSelectors,
    stringify: stringify
};
function t_encode$1(v) {
    return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}
function t_decode$1(v) {
    return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}
function stringify$1(param) {
    return stringify(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify, param);
}
function fromDomSelection(domElementIdentifierGenerator, domSelection) {
    var strictSelection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromDomSelection(domElementIdentifierGenerator, domSelection);
    return {
        TAG: /* NonInputSelection */ 0,
        _0: strictSelection
    };
}
function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
    var strictSelection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
    return {
        TAG: /* NonInputSelection */ 0,
        _0: strictSelection
    };
}
function actsOnSameNodeAsOtherSelection(selectionA, selectionB) {
    if (selectionA.TAG === /* NonInputSelection */ 0) {
        if (selectionB.TAG === /* NonInputSelection */ 0) {
            return Selection__NonInputSelection$SmartcutsMacros.ForRecording.actsOnSameNodeAsOtherSelection(selectionA._0, selectionB._0);
        } else {
            return false;
        }
    } else if (selectionB.TAG === /* NonInputSelection */ 0) {
        return false;
    } else {
        return Selection__InputSelection$SmartcutsMacros.ForRecording.actsOnSameNodeAsOtherSelection(selectionA._0, selectionB._0);
    }
}
function endsOnNode(node, selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return Selection__NonInputSelection$SmartcutsMacros.ForRecording.endsOnNode(node, selection._0);
    } else {
        return Selection__InputSelection$SmartcutsMacros.ForRecording.actsOnNode(node, selection._0);
    }
}
function fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement) {
    var inputSelection = Selection__InputSelection$SmartcutsMacros.ForRecording.fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement);
    return {
        TAG: /* InputSelection */ 1,
        _0: inputSelection
    };
}
function extractSelectors$1(param1) {
    return extractSelectors(function(param) {
        return param.selector;
    }, param1);
}
var ForRecording = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    fromDomSelection: fromDomSelection,
    fromSelectionSnapshot: fromSelectionSnapshot,
    actsOnSameNodeAsOtherSelection: actsOnSameNodeAsOtherSelection,
    endsOnNode: endsOnNode,
    fromHtmlInputElement: fromHtmlInputElement,
    extractSelectors: extractSelectors$1
};
function t_encode$2(v) {
    return t_encode(Selector$SmartcutsMacros.selector_encode, v);
}
function t_decode$2(v) {
    return t_decode(Selector$SmartcutsMacros.selector_decode, v);
}
function fromRecording(selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return {
            TAG: /* NonInputSelection */ 0,
            _0: Selection__NonInputSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection._0)
        };
    } else {
        return {
            TAG: /* InputSelection */ 1,
            _0: Selection__InputSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection._0)
        };
    }
}
function updateSelector(f, selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return {
            TAG: /* NonInputSelection */ 0,
            _0: Selection__NonInputSelection$SmartcutsMacros.ForNonRecording.updateSelector(f, selection._0)
        };
    } else {
        return {
            TAG: /* InputSelection */ 1,
            _0: Selection__InputSelection$SmartcutsMacros.ForNonRecording.updateSelector(f, selection._0)
        };
    }
}
function extractSelectors$2(param) {
    return extractSelectors(function(selector) {
        return selector;
    }, param);
}
function getSelectedText(selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return Selection__NonInputSelection$SmartcutsMacros.Generic.extractTexts(selection._0)[1];
    } else {
        return Selection__InputSelection$SmartcutsMacros.Generic.extractTexts(selection._0)[1];
    }
}
var ForNonRecording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromRecording: fromRecording,
    updateSelector: updateSelector,
    extractSelectors: extractSelectors$2,
    getSelectedText: getSelectedText
};
var SelectionSnapshot;
var NonInputSelection;
var InputSelection;
exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.InputSelection = InputSelection;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 21014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Ord = __webpack_require__(61618);
var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var TextContents$SmartcutsMacros = __webpack_require__(20114);
var SelectionSemantics__Shared$SmartcutsMacros = __webpack_require__(47401);
var ContentScriptPlayback__Click$SmartcutsMacros = __webpack_require__(22142);
var Selection__ContentEditableCursor$SmartcutsMacros = __webpack_require__(43378);
var SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros = __webpack_require__(69932);
function t_encode(v) {
    if (typeof v === "number") {
        if (v === /* CursorAtStartOfContentEditable */ 0) {
            return [
                "CursorAtStartOfContentEditable"
            ];
        } else {
            return [
                "CursorAtEndOfContentEditable"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* CursorAtStartOfNthParagraph */ 0:
            return [
                "CursorAtStartOfNthParagraph",
                Decco.intToJson(v._0)
            ];
        case /* CursorAtEndOfNthParagraph */ 1:
            return [
                "CursorAtEndOfNthParagraph",
                Decco.intToJson(v._0)
            ];
        case /* CursorAfterWordAtIndexInNthParagraph */ 2:
            return [
                "CursorAfterWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
            ];
        case /* CursorBeforeWordAtIndexInNthParagraph */ 3:
            return [
                "CursorBeforeWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
            ];
        case /* CursorInsideWordAtIndexInNthParagraph */ 4:
            return [
                "CursorInsideWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
            ];
        case /* CursorInsideWordInNthParagraph */ 5:
            return [
                "CursorInsideWordInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWord_encode(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CursorAfterWordAtIndexInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorAfterWordAtIndexInNthParagraph */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CursorAtEndOfContentEditable":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CursorAtEndOfContentEditable */ 1
                    };
                }
            case "CursorAtEndOfNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorAtEndOfNthParagraph */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "CursorAtStartOfContentEditable":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CursorAtStartOfContentEditable */ 0
                    };
                }
            case "CursorAtStartOfNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorAtStartOfNthParagraph */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "CursorBeforeWordAtIndexInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorBeforeWordAtIndexInNthParagraph */ 3,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "CursorInsideWordAtIndexInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorInsideWordAtIndexInNthParagraph */ 4,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "CursorInsideWordInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWord_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorInsideWordInNthParagraph */ 5,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function contentsInsideNthParagraph(nthParagraph, textContents) {
    var arg = Belt_List.get(Belt_List.reverse(Belt_List.reduce(textContents, /* [] */ 0, function(paragraphs, textContent) {
        if (textContent.TAG === /* TextSegment */ 0) {
            var element = textContent._0;
            if (element.TAG === /* NonEmptySegment */ 0) {
                var match = element._0;
                var text = match.text;
                var index = match.textNodeIndex;
                var parentElement = match.parentElement;
                if (paragraphs) {
                    return Belt_List.add(paragraphs.tl, Belt_List.add(paragraphs.hd, [
                        parentElement,
                        index,
                        text
                    ]));
                } else {
                    return {
                        hd: {
                            hd: [
                                parentElement,
                                index,
                                text
                            ],
                            tl: /* [] */ 0
                        },
                        tl: /* [] */ 0
                    };
                }
            }
            var element$1 = element._0;
            var text$1 = "";
            if (paragraphs) {
                return Belt_List.add(paragraphs.tl, Belt_List.add(paragraphs.hd, [
                    element$1,
                    -1,
                    text$1
                ]));
            } else {
                return {
                    hd: {
                        hd: [
                            element$1,
                            -1,
                            text$1
                        ],
                        tl: /* [] */ 0
                    },
                    tl: /* [] */ 0
                };
            }
        }
        var element$2 = textContent._0;
        if (element$2.TAG !== /* NonEmptySegment */ 0) {
            return Belt_List.add(paragraphs, {
                hd: [
                    element$2._0,
                    -1,
                    ""
                ],
                tl: /* [] */ 0
            });
        }
        var match$1 = element$2._0;
        return Belt_List.add(paragraphs, {
            hd: [
                match$1.parentElement,
                0,
                match$1.text
            ],
            tl: /* [] */ 0
        });
    })), nthParagraph);
    return Belt_List.reverse(function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(/* [] */ 0));
}
function locateWordAtIndexInTexts(wordIndex, texts) {
    var func = function func(param, param$1) {
        return ListUtils$SmartcutsMacros.shortcutWithState(wordIndex, param, param$1);
    };
    var arg = Curry._2(func, function(remainingWords, param) {
        var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, param[2]);
        if (words.length > remainingWords) {
            return [
                0,
                [
                    param[0],
                    param[1],
                    Caml_array.get(words, remainingWords)
                ]
            ];
        } else {
            return [
                remainingWords - words.length | 0,
                undefined
            ];
        }
    }, texts);
    var param1 = "Expected to locateWordAtIndexInTexts()";
    return OptionUtils$SmartcutsMacros.getExn(param1, arg);
}
function moveCursorToNodeAndOffset(node, offset) {
    var domRange = document.createRange();
    domRange.setStart(node, offset);
    domRange.setEnd(node, offset);
    var maybeSelection = window.getSelection();
    if (!(maybeSelection == null)) {
        if (maybeSelection.rangeCount > 0) {
            maybeSelection.removeAllRanges();
        }
        maybeSelection.addRange(domRange);
    }
    return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: undefined
    });
}
function moveCursorInsideContentEditable(contentEditableHost, semantic) {
    var textContents = TextContents$SmartcutsMacros.ForPlayback.fromElement(contentEditableHost);
    if (typeof semantic === "number") {
        if (semantic === /* CursorAtStartOfContentEditable */ 0) {
            var match = Belt_List.get(textContents, 0);
            if (match === undefined) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
            var nodeAndOffset = TextContents$SmartcutsMacros.TextSegment.toMaybeRangeContainerAndOffsetForCursor(/* Start */ 0, match._0);
            var node = nodeAndOffset[0];
            if (node !== undefined) {
                return moveCursorToNodeAndOffset(Caml_option.valFromOption(node), nodeAndOffset[1]);
            } else {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        }
        var match$1 = ListUtils$SmartcutsMacros.last(textContents);
        if (match$1 === undefined) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
        var nodeAndOffset$1 = TextContents$SmartcutsMacros.TextSegment.toMaybeRangeContainerAndOffsetForCursor(/* End */ 1, match$1._0);
        var node$1 = nodeAndOffset$1[0];
        if (node$1 !== undefined) {
            return moveCursorToNodeAndOffset(Caml_option.valFromOption(node$1), nodeAndOffset$1[1]);
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
    } else {
        switch(semantic.TAG | 0){
            case /* CursorAtStartOfNthParagraph */ 0:
                var nthParagraph = semantic._0;
                var match$2 = contentsInsideNthParagraph(nthParagraph, textContents);
                if (!match$2) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthParagraph */ 0,
                            _0: nthParagraph
                        }
                    });
                }
                var match$3 = match$2.hd;
                var maybeNode = match$3[0].childNodes.item(match$3[1]);
                if (maybeNode == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return moveCursorToNodeAndOffset(maybeNode, 0);
                }
            case /* CursorAtEndOfNthParagraph */ 1:
                var nthParagraph$1 = semantic._0;
                var match$4 = ListUtils$SmartcutsMacros.last(contentsInsideNthParagraph(nthParagraph$1, textContents));
                if (match$4 === undefined) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthParagraph */ 0,
                            _0: nthParagraph$1
                        }
                    });
                }
                var maybeNode$1 = match$4[0].childNodes.item(match$4[1]);
                if (maybeNode$1 == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                var offset = match$4[2].length;
                return moveCursorToNodeAndOffset(maybeNode$1, offset);
            case /* CursorAfterWordAtIndexInNthParagraph */ 2:
                var match$5 = semantic._0;
                var match$6 = locateWordAtIndexInTexts(match$5.wordIndex, contentsInsideNthParagraph(match$5.nthParagraph, textContents));
                var match$7 = match$6[2];
                var wordEnds = match$7[0] + match$7[1].length | 0;
                var maybeNode$2 = match$6[0].childNodes.item(match$6[1]);
                if (maybeNode$2 == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return moveCursorToNodeAndOffset(maybeNode$2, match$5.offset + wordEnds | 0);
                }
            case /* CursorBeforeWordAtIndexInNthParagraph */ 3:
                var match$8 = semantic._0;
                var match$9 = locateWordAtIndexInTexts(match$8.wordIndex, contentsInsideNthParagraph(match$8.nthParagraph, textContents));
                var maybeNode$3 = match$9[0].childNodes.item(match$9[1]);
                if (maybeNode$3 == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return moveCursorToNodeAndOffset(maybeNode$3, match$9[2][0] - match$8.offset | 0);
                }
            case /* CursorInsideWordAtIndexInNthParagraph */ 4:
                var match$10 = semantic._0;
                var match$11 = locateWordAtIndexInTexts(match$10.wordIndex, contentsInsideNthParagraph(match$10.nthParagraph, textContents));
                var maybeNode$4 = match$11[0].childNodes.item(match$11[1]);
                if (maybeNode$4 == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return moveCursorToNodeAndOffset(maybeNode$4, match$10.offset + match$11[2][0] | 0);
                }
            case /* CursorInsideWordInNthParagraph */ 5:
                var match$12 = semantic._0;
                var match$13 = locateWordAtIndexInTexts(match$12.wordIndex, contentsInsideNthParagraph(match$12.nthParagraph, textContents));
                var match$14 = match$13[2];
                var maybeNode$5 = match$13[0].childNodes.item(match$13[1]);
                if (maybeNode$5 == null) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                var offset$1 = match$14[1].length >> 1;
                return moveCursorToNodeAndOffset(maybeNode$5, match$14[0] + offset$1 | 0);
        }
    }
}
function moveCursorInsideContentEditableLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function(result_contentEditableHost) {
        if (result_contentEditableHost.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_contentEditableHost._0
            });
        }
        var contentEditableHost = result_contentEditableHost._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(contentEditableHost, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result1) {
            if (result1.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result1._0
                });
            }
            var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
            var tmp;
            if (activeElement !== undefined) {
                if (Caml_option.valFromOption(activeElement) === contentEditableHost) {
                    tmp = Promise.resolve(undefined);
                } else {
                    var match = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(contentEditableHost);
                    tmp = ContentScriptPlayback__Click$SmartcutsMacros.click(match[0], match[1], contentEditableHost);
                }
            } else {
                var match$1 = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(contentEditableHost);
                tmp = ContentScriptPlayback__Click$SmartcutsMacros.click(match$1[0], match$1[1], contentEditableHost);
            }
            return tmp.then(function(param) {
                return moveCursorInsideContentEditable(contentEditableHost, semantic);
            }).then(function(result) {
                if (result.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* ContentEditableCursorSemanticError */ 3,
                            _0: result._0
                        }
                    });
                }
            });
        });
    });
}
function toHumanReadable(semantic) {
    if (typeof semantic === "number") {
        if (semantic === /* CursorAtStartOfContentEditable */ 0) {
            return "to the start of the editor";
        } else {
            return "to the end of the editor";
        }
    }
    switch(semantic.TAG | 0){
        case /* CursorAtStartOfNthParagraph */ 0:
            return "to the start of the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
        case /* CursorAtEndOfNthParagraph */ 1:
            return "to the end of the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
        case /* CursorAfterWordAtIndexInNthParagraph */ 2:
            var match = semantic._0;
            return "after the " + (StringUtils$SmartcutsMacros.withOrd(match.wordIndex + 1 | 0) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match.nthParagraph + 1 | 0) + " paragraph")));
        case /* CursorBeforeWordAtIndexInNthParagraph */ 3:
            var match$1 = semantic._0;
            var offset = match$1.offset;
            return "to the " + ((offset === 0 ? "beginning of the " : Ord(offset + 1 | 0) + " character of the ") + (StringUtils$SmartcutsMacros.withOrd(match$1.wordIndex + 1 | 0) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$1.nthParagraph + 1 | 0) + " paragraph"))));
        case /* CursorInsideWordAtIndexInNthParagraph */ 4:
            var match$2 = semantic._0;
            var nthChar = match$2.offset + 1 | 0;
            var nthWord = match$2.wordIndex + 1 | 0;
            return "before the " + (StringUtils$SmartcutsMacros.withOrd(nthChar) + (" character of the " + (StringUtils$SmartcutsMacros.withOrd(nthWord) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$2.nthParagraph + 1 | 0) + " paragraph")))));
        case /* CursorInsideWordInNthParagraph */ 5:
            var match$3 = semantic._0;
            var nthWord$1 = match$3.wordIndex + 1 | 0;
            return "anywhere inside the " + (StringUtils$SmartcutsMacros.withOrd(nthWord$1) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$3.nthParagraph + 1 | 0) + " paragraph")));
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    contentsInsideNthParagraph: contentsInsideNthParagraph,
    locateWordAtIndexInTexts: locateWordAtIndexInTexts,
    moveCursorToNodeAndOffset: moveCursorToNodeAndOffset,
    moveCursorInsideContentEditable: moveCursorInsideContentEditable,
    moveCursorInsideContentEditableLocatedAtSelector: moveCursorInsideContentEditableLocatedAtSelector,
    toHumanReadable: toHumanReadable
};
function t_encode$1(v) {
    return Decco.arrayToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.arrayFromJson(t_decode, v);
}
function ofContentEditableCursor(cursor) {
    var textContents = cursor.textContents;
    if (Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isCursorAtStartOfContentEditable(cursor)) {
        return [
            /* CursorAtStartOfContentEditable */ 0
        ];
    }
    if (Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isCursorAtEndOfContentEditable(cursor)) {
        return [
            /* CursorAtEndOfContentEditable */ 1
        ];
    }
    var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
    var func$1 = Curry._1(func, cursor.domElementRepresentation.domElementIdentifier);
    var maybeResult = Curry._2(func$1, cursor.textNodeIndex, textContents);
    if (maybeResult === undefined) {
        return [];
    }
    var index = maybeResult.index;
    var nthParagraph = maybeResult.nthParagraph;
    var contentsAfterTextNode = ListUtils$SmartcutsMacros.drop(index + 1 | 0, textContents);
    var contentsInParagraphUntilTextNode = $$Array.of_list(ListUtils$SmartcutsMacros.drop(maybeResult.currentParagraphStartsAtIndex, ListUtils$SmartcutsMacros.take(index, textContents)));
    var contentsInParagraphAfterTextNode = ListUtils$SmartcutsMacros.takeWhile(function(textContent) {
        if (textContent.TAG === /* TextSegment */ 0) {
            return true;
        } else {
            return false;
        }
    }, contentsAfterTextNode);
    var offsetSinceParagraphStarts = Belt_Array.reduce(contentsInParagraphUntilTextNode, cursor.offset, function(acc, content) {
        return acc + TextContents$SmartcutsMacros.textGet(content).length | 0;
    });
    if (offsetSinceParagraphStarts === 0) {
        return [
            {
                TAG: /* CursorAtStartOfNthParagraph */ 0,
                _0: nthParagraph
            }
        ];
    }
    if (index === List.length(textContents) && contentsInParagraphAfterTextNode === /* [] */ 0) {
        return [
            {
                TAG: /* CursorAtEndOfNthParagraph */ 1,
                _0: nthParagraph
            }
        ];
    }
    var textInParagraphUpToAndIncludingTextNode = $$Array.map(TextContents$SmartcutsMacros.textGet, $$Array.append(contentsInParagraphUntilTextNode, [
        List.nth(textContents, index)
    ])).join("");
    if (textInParagraphUpToAndIncludingTextNode.length === offsetSinceParagraphStarts) {
        return [
            {
                TAG: /* CursorAtEndOfNthParagraph */ 1,
                _0: nthParagraph
            }
        ];
    }
    var wordsSinceParagraphStarts = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, textInParagraphUpToAndIncludingTextNode);
    var arg = Util$SmartcutsMacros.shortcutWithIndex2(wordsSinceParagraphStarts, function(param, wordIndex) {
        var wordStartOffset = param[0];
        var wordEndOffset = wordStartOffset + param[1].length | 0;
        if (wordEndOffset < offsetSinceParagraphStarts) {
            return;
        }
        if (wordEndOffset === offsetSinceParagraphStarts) {
            return [
                {
                    TAG: /* CursorAfterWordAtIndexInNthParagraph */ 2,
                    _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: 0
                    }
                }
            ];
        }
        if (wordStartOffset === offsetSinceParagraphStarts) {
            return [
                {
                    TAG: /* CursorBeforeWordAtIndexInNthParagraph */ 3,
                    _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: 0
                    }
                }
            ];
        }
        if (wordStartOffset <= offsetSinceParagraphStarts) {
            return [
                {
                    TAG: /* CursorInsideWordInNthParagraph */ 5,
                    _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex
                    }
                },
                {
                    TAG: /* CursorInsideWordAtIndexInNthParagraph */ 4,
                    _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: offsetSinceParagraphStarts - wordStartOffset | 0
                    }
                }
            ];
        }
        if (wordIndex === 0) {
            return [
                {
                    TAG: /* CursorBeforeWordAtIndexInNthParagraph */ 3,
                    _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: wordStartOffset - offsetSinceParagraphStarts | 0
                    }
                }
            ];
        }
        var match = Caml_array.get(wordsSinceParagraphStarts, wordIndex - 1 | 0);
        var offsetAfterLastWord = offsetSinceParagraphStarts - (match[0] + match[1].length | 0) | 0;
        return [
            {
                TAG: /* CursorAfterWordAtIndexInNthParagraph */ 2,
                _0: {
                    nthParagraph: nthParagraph,
                    wordIndex: wordIndex - 1 | 0,
                    offset: offsetAfterLastWord
                }
            }
        ];
    });
    var param2 = "Expected cursorPosition, " + (String(offsetSinceParagraphStarts) + (", to fall within bounds of value " + StringUtils$SmartcutsMacros.quote($$Array.map(TextContents$SmartcutsMacros.textGet, $$Array.append(contentsInParagraphUntilTextNode, [
        List.nth(textContents, index)
    ])).join(""))));
    return OptionUtils$SmartcutsMacros.getExn(param2, arg);
}
function stringify(_semantics) {
    return "TODO";
}
var $$Text;
exports.$$Text = $$Text;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.ofContentEditableCursor = ofContentEditableCursor;
exports.stringify = stringify; /* ord Not a pure module */ 


/***/ }),

/***/ 69932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
function paragraphWordOffset_encode(v) {
    return Js_dict.fromArray([
        [
            "nthParagraph",
            Decco.intToJson(v.nthParagraph)
        ],
        [
            "wordIndex",
            Decco.intToJson(v.wordIndex)
        ],
        [
            "offset",
            Decco.intToJson(v.offset)
        ]
    ]);
}
function paragraphWordOffset_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var nthParagraph = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthParagraph"), null));
    if (nthParagraph.TAG === /* Ok */ 0) {
        var wordIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wordIndex"), null));
        if (wordIndex.TAG === /* Ok */ 0) {
            var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
            if (offset.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        nthParagraph: nthParagraph._0,
                        wordIndex: wordIndex._0,
                        offset: offset._0
                    }
                };
            }
            var e = offset._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".offset" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = wordIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".wordIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = nthParagraph._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".nthParagraph" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function paragraphWord_encode(v) {
    return Js_dict.fromArray([
        [
            "nthParagraph",
            Decco.intToJson(v.nthParagraph)
        ],
        [
            "wordIndex",
            Decco.intToJson(v.wordIndex)
        ]
    ]);
}
function paragraphWord_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var nthParagraph = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthParagraph"), null));
    if (nthParagraph.TAG === /* Ok */ 0) {
        var wordIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wordIndex"), null));
        if (wordIndex.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    nthParagraph: nthParagraph._0,
                    wordIndex: wordIndex._0
                }
            };
        }
        var e = wordIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".wordIndex" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = nthParagraph._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".nthParagraph" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function semanticError_encode(v) {
    switch(v.TAG | 0){
        case /* CouldNotFindNthParagraph */ 0:
            return [
                "CouldNotFindNthParagraph",
                Decco.intToJson(v._0)
            ];
        case /* CouldNotFindWordAtIndexInNthParagraph */ 1:
            return [
                "CouldNotFindWordAtIndexInNthParagraph",
                paragraphWord_encode(v._0)
            ];
        case /* CouldNotFindOffsetInsideWordInNthParagraph */ 2:
            return [
                "CouldNotFindOffsetInsideWordInNthParagraph",
                paragraphWordOffset_encode(v._0)
            ];
    }
}
function semanticError_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CouldNotFindNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindNthParagraph */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CouldNotFindOffsetInsideWordInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindOffsetInsideWordInNthParagraph */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "CouldNotFindWordAtIndexInNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = paragraphWord_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CouldNotFindWordAtIndexInNthParagraph */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
exports.paragraphWordOffset_encode = paragraphWordOffset_encode;
exports.paragraphWordOffset_decode = paragraphWordOffset_decode;
exports.paragraphWord_encode = paragraphWord_encode;
exports.paragraphWord_decode = paragraphWord_decode;
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode; /* No side effect */ 


/***/ }),

/***/ 82156:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros = __webpack_require__(21014);
var SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros = __webpack_require__(60527);
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "EmptySemantic"
        ];
    } else if (v.TAG === /* ContentEditableCursorSemantic */ 0) {
        return [
            "ContentEditableCursorSemantic",
            Selector$SmartcutsMacros.selector_encode(v._0),
            SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_encode(v._1)
        ];
    } else {
        return [
            "ContentEditableSelectionSemantic",
            Selector$SmartcutsMacros.selector_encode(v._0),
            SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditableCursorSemantic":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ContentEditableCursorSemantic */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ContentEditableSelectionSemantic":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ContentEditableSelectionSemantic */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "EmptySemantic":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* EmptySemantic */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectorGet(v) {
    if (typeof v === "number") {
        return [];
    } else {
        return [
            v._0
        ];
    }
}
function selectOrMoveCursorInsideContentEditable(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    if (typeof semantic === "number") {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    } else if (semantic.TAG === /* ContentEditableCursorSemantic */ 0) {
        return SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.moveCursorInsideContentEditableLocatedAtSelector(semantic._0, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    } else {
        return SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.selectInsideContentEditableLocatedAtSelector(semantic._0, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    }
}
function toHumanReadable(semantic) {
    if (typeof semantic === "number") {
        return "Do nothing";
    } else if (semantic.TAG === /* ContentEditableCursorSemantic */ 0) {
        return SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(semantic._1);
    } else {
        return SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.toHumanReadable(semantic._1);
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    selectorGet: selectorGet,
    selectOrMoveCursorInsideContentEditable: selectOrMoveCursorInsideContentEditable,
    toHumanReadable: toHumanReadable
};
function t_encode$1(v) {
    if (typeof v === "number") {
        return [
            "RelyOnPreviousSelection"
        ];
    } else if (v.TAG === /* ContentEditableCursorSemantics */ 0) {
        return [
            "ContentEditableCursorSemantics",
            Selector$SmartcutsMacros.selector_encode(v._0),
            Decco.arrayToJson(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_encode, v._1)
        ];
    } else {
        return [
            "ContentEditableSelectionSemantics",
            Selector$SmartcutsMacros.selector_encode(v._0),
            Decco.arrayToJson(SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.t_encode, v._1)
        ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentEditableCursorSemantics":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.arrayFromJson(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ContentEditableCursorSemantics */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ContentEditableSelectionSemantics":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.arrayFromJson(SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* ContentEditableSelectionSemantics */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "RelyOnPreviousSelection":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RelyOnPreviousSelection */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function ofSelectionOrCursor(selectionOrCursor) {
    if (typeof selectionOrCursor === "number") {
        return /* RelyOnPreviousSelection */ 0;
    }
    if (selectionOrCursor.TAG !== /* ContentEditableSelection */ 0) {
        return {
            TAG: /* ContentEditableCursorSemantics */ 0,
            _0: selectionOrCursor._0.selector,
            _1: SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.ofContentEditableCursor(selectionOrCursor._1)
        };
    }
    var match = SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.ofSelection(selectionOrCursor._0, selectionOrCursor._2, selectionOrCursor._1);
    return {
        TAG: /* ContentEditableSelectionSemantics */ 1,
        _0: match.selector,
        _1: match.semantics
    };
}
function atIndex(index, semantics) {
    if (typeof semantics === "number") {
        return /* EmptySemantic */ 0;
    } else if (semantics.TAG === /* ContentEditableCursorSemantics */ 0) {
        return {
            TAG: /* ContentEditableCursorSemantic */ 0,
            _0: semantics._0,
            _1: Caml_array.get(semantics._1, index)
        };
    } else {
        return {
            TAG: /* ContentEditableSelectionSemantic */ 1,
            _0: semantics._0,
            _1: Caml_array.get(semantics._1, index)
        };
    }
}
function stringify(semantics) {
    if (typeof semantics === "number") {
        return "RelyOnPreviousSelection";
    } else if (semantics.TAG === /* ContentEditableCursorSemantics */ 0) {
        return "ContentEditableCursorSemantics(selector, " + (SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.stringify(semantics._1) + ")");
    } else {
        return "ContentEditableSelectionSemantics(selector, " + (SelectionSemantics__ContentEditableSelectionSemantics$SmartcutsMacros.stringify(semantics._1) + ")");
    }
}
var ContentEditableCursorSemantics;
var ContentEditableSelectionSemantics;
exports.ContentEditableCursorSemantics = ContentEditableCursorSemantics;
exports.ContentEditableSelectionSemantics = ContentEditableSelectionSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.ofSelectionOrCursor = ofSelectionOrCursor;
exports.atIndex = atIndex;
exports.stringify = stringify; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 60527:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var TextContents$SmartcutsMacros = __webpack_require__(20114);
var SelectionSemantics__Shared$SmartcutsMacros = __webpack_require__(47401);
var SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros = __webpack_require__(2569);
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "SelectAll_InsideContenEditable"
        ];
    }
    switch(v.TAG | 0){
        case /* SelectAll_FromNthParagraph */ 0:
            return [
                "SelectAll_FromNthParagraph",
                Decco.intToJson(v._0)
            ];
        case /* SelectAll_ToNthParagraphEnds */ 1:
            return [
                "SelectAll_ToNthParagraphEnds",
                Decco.intToJson(v._0)
            ];
        case /* SelectAll_AfterPrefixInNthParagraph */ 2:
            return [
                "SelectAll_AfterPrefixInNthParagraph",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* SelectAll_BeforeSuffixInNthParagraph */ 3:
            return [
                "SelectAll_BeforeSuffixInNthParagraph",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* SelectInNthParagraph */ 4:
            return [
                "SelectInNthParagraph",
                Decco.intToJson(v._0),
                SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._1)
            ];
        case /* SelectParagraphs */ 5:
            return [
                "SelectParagraphs",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* SelectBetweenIndexes */ 6:
            var v1 = v._1;
            var v0 = v._0;
            return [
                "SelectBetweenIndexes",
                [
                    Decco.intToJson(v0[0]),
                    Decco.intToJson(v0[1])
                ],
                [
                    Decco.intToJson(v1[0]),
                    Decco.intToJson(v1[1])
                ]
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SelectAll_AfterPrefixInNthParagraph":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectAll_AfterPrefixInNthParagraph */ 2,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SelectAll_BeforeSuffixInNthParagraph":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectAll_BeforeSuffixInNthParagraph */ 3,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "SelectAll_FromNthParagraph":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectAll_FromNthParagraph */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$4 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "SelectAll_InsideContenEditable":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectAll_InsideContenEditable */ 0
                    };
                }
            case "SelectAll_ToNthParagraphEnds":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectAll_ToNthParagraphEnds */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$5 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "SelectBetweenIndexes":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var json = Belt_Array.getExn(jsonArr$1, 1);
                var match$5 = Js_json.classify(json);
                var match$6;
                if (typeof match$5 === "number" || match$5.TAG !== /* JSONArray */ 3) {
                    match$6 = Decco.error(undefined, "Not a tuple", json);
                } else {
                    var match$7 = match$5._0;
                    if (match$7.length !== 2) {
                        match$6 = Decco.error(undefined, "Incorrect cardinality", json);
                    } else {
                        var v0$2 = match$7[0];
                        var v1 = match$7[1];
                        var match$8 = Decco.intFromJson(v0$2);
                        var match$9 = Decco.intFromJson(v1);
                        if (match$8.TAG === /* Ok */ 0) {
                            if (match$9.TAG === /* Ok */ 0) {
                                match$6 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$8._0,
                                        match$9._0
                                    ]
                                };
                            } else {
                                var e$6 = match$9._0;
                                match$6 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                    }
                                };
                            }
                        } else {
                            var e$7 = match$8._0;
                            match$6 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$7.path,
                                    message: e$7.message,
                                    value: e$7.value
                                }
                            };
                        }
                    }
                }
                var json$1 = Belt_Array.getExn(jsonArr$1, 2);
                var match$10 = Js_json.classify(json$1);
                var match$11;
                if (typeof match$10 === "number" || match$10.TAG !== /* JSONArray */ 3) {
                    match$11 = Decco.error(undefined, "Not a tuple", json$1);
                } else {
                    var match$12 = match$10._0;
                    if (match$12.length !== 2) {
                        match$11 = Decco.error(undefined, "Incorrect cardinality", json$1);
                    } else {
                        var v0$3 = match$12[0];
                        var v1$1 = match$12[1];
                        var match$13 = Decco.intFromJson(v0$3);
                        var match$14 = Decco.intFromJson(v1$1);
                        if (match$13.TAG === /* Ok */ 0) {
                            if (match$14.TAG === /* Ok */ 0) {
                                match$11 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$13._0,
                                        match$14._0
                                    ]
                                };
                            } else {
                                var e$8 = match$14._0;
                                match$11 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$8.path,
                                        message: e$8.message,
                                        value: e$8.value
                                    }
                                };
                            }
                        } else {
                            var e$9 = match$13._0;
                            match$11 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$9.path,
                                    message: e$9.message,
                                    value: e$9.value
                                }
                            };
                        }
                    }
                }
                if (match$6.TAG === /* Ok */ 0) {
                    if (match$11.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectBetweenIndexes */ 6,
                                _0: match$6._0,
                                _1: match$11._0
                            }
                        };
                    }
                    var e$10 = match$11._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "SelectInNthParagraph":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$16 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$15.TAG === /* Ok */ 0) {
                    if (match$16.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectInNthParagraph */ 4,
                                _0: match$15._0,
                                _1: match$16._0
                            }
                        };
                    }
                    var e$12 = match$16._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                        }
                    };
                }
                var e$13 = match$15._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            case "SelectParagraphs":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$17 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$18 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$17.TAG === /* Ok */ 0) {
                    if (match$18.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectParagraphs */ 5,
                                _0: match$17._0,
                                _1: match$18._0
                            }
                        };
                    }
                    var e$14 = match$18._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$14.path,
                            message: e$14.message,
                            value: e$14.value
                        }
                    };
                }
                var e$15 = match$17._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectInsideContentEditable(contentEditableHost, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    var applySelection = function applySelection(startNode, endNode, startOffset, endOffset) {
        if (startNode === undefined) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected to find both startNode and endNode while ContentEditableSelectionSemantics.Semantic.selectInsideContentEditable()");
        }
        if (endNode === undefined) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected to find both startNode and endNode while ContentEditableSelectionSemantics.Semantic.selectInsideContentEditable()");
        }
        var maybeSelection = window.getSelection();
        var range = document.createRange();
        range.setStart(Caml_option.valFromOption(startNode), startOffset);
        range.setEnd(Caml_option.valFromOption(endNode), endOffset);
        if (!(maybeSelection == null)) {
            if (maybeSelection.rangeCount > 0) {
                maybeSelection.removeAllRanges();
            }
            maybeSelection.addRange(range);
        }
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    };
    var element1 = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
    if (element1 !== undefined && Caml_obj.caml_equal(Caml_option.valFromOption(element1), contentEditableHost)) {} else {
        Util$SmartcutsMacros.logAndRaiseJsError("Expected contentEditableHost be document.activeElement when selectInsideContentEditable()");
    }
    var textContents = TextContents$SmartcutsMacros.ForPlayback.fromElement(contentEditableHost);
    var nodeOfTextSegmentAtIndex = function nodeOfTextSegmentAtIndex(index) {
        var match = Belt_List.get(textContents, index);
        if (match === undefined) {
            return;
        }
        if (match.TAG === /* TextSegment */ 0) {
            var element = match._0;
            if (element.TAG !== /* NonEmptySegment */ 0) {
                return Caml_option.some(element._0);
            }
            var match$1 = element._0;
            return Caml_option.nullable_to_opt(match$1.parentElement.childNodes.item(match$1.textNodeIndex));
        }
        var element$1 = match._0;
        if (element$1.TAG === /* NonEmptySegment */ 0) {
            return Caml_option.nullable_to_opt(element$1._0.parentElement.firstChild);
        } else {
            return Caml_option.some(element$1._0);
        }
    };
    var nodeAndEndOffsetOfTextSegmentAtIndex = function nodeAndEndOffsetOfTextSegmentAtIndex(index) {
        var match = Belt_List.get(textContents, index);
        if (match === undefined) {
            return [
                undefined,
                0
            ];
        }
        if (match.TAG === /* TextSegment */ 0) {
            var element = match._0;
            if (element.TAG !== /* NonEmptySegment */ 0) {
                return [
                    Caml_option.some(element._0),
                    0
                ];
            }
            var match$1 = element._0;
            return [
                Caml_option.nullable_to_opt(match$1.parentElement.childNodes.item(match$1.textNodeIndex)),
                match$1.text.length
            ];
        }
        var element$1 = match._0;
        if (element$1.TAG !== /* NonEmptySegment */ 0) {
            return [
                Caml_option.some(element$1._0),
                0
            ];
        }
        var match$2 = element$1._0;
        return [
            Caml_option.nullable_to_opt(match$2.parentElement.firstChild),
            match$2.text.length
        ];
    };
    var match1 = ListUtils$SmartcutsMacros.last(textContents);
    var nodeAndEndOffsetOfLastTextSegment;
    if (match1 !== undefined) {
        if (match1.TAG === /* TextSegment */ 0) {
            var element$11 = match1._0;
            if (element$11.TAG === /* NonEmptySegment */ 0) {
                var match$19 = element$11._0;
                nodeAndEndOffsetOfLastTextSegment = [
                    Caml_option.nullable_to_opt(match$19.parentElement.childNodes.item(match$19.textNodeIndex)),
                    match$19.text.length
                ];
            } else {
                nodeAndEndOffsetOfLastTextSegment = [
                    Caml_option.some(element$11._0),
                    0
                ];
            }
        } else {
            var element$2 = match1._0;
            if (element$2.TAG === /* NonEmptySegment */ 0) {
                var match$21 = element$2._0;
                nodeAndEndOffsetOfLastTextSegment = [
                    Caml_option.nullable_to_opt(match$21.parentElement.firstChild),
                    match$21.text.length
                ];
            } else {
                nodeAndEndOffsetOfLastTextSegment = [
                    Caml_option.some(element$2._0),
                    0
                ];
            }
        }
    } else {
        nodeAndEndOffsetOfLastTextSegment = [
            undefined,
            0
        ];
    }
    if (typeof semantic === "number") {
        return applySelection(nodeOfTextSegmentAtIndex(0), nodeAndEndOffsetOfLastTextSegment[0], 0, nodeAndEndOffsetOfLastTextSegment[1]);
    }
    switch(semantic.TAG | 0){
        case /* SelectAll_FromNthParagraph */ 0:
            var match$3 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
            var startNode1 = match$3 !== undefined ? nodeOfTextSegmentAtIndex(match$3[0]) : undefined;
            return applySelection(startNode1, nodeAndEndOffsetOfLastTextSegment[0], 0, nodeAndEndOffsetOfLastTextSegment[1]);
        case /* SelectAll_ToNthParagraphEnds */ 1:
            var match$4 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
            var match$5 = match$4 !== undefined ? nodeAndEndOffsetOfTextSegmentAtIndex(match$4[1]) : [
                undefined,
                0
            ];
            return applySelection(nodeOfTextSegmentAtIndex(0), match$5[0], 0, match$5[1]);
        case /* SelectAll_AfterPrefixInNthParagraph */ 2:
            var prefix = semantic._0;
            var func = TextContents$SmartcutsMacros.Generic.locateNthParagraph;
            var arg = Curry._2(func, semantic._1, textContents);
            var match$6 = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
            }("Expected to locateNathParagraph when applying SelectAll_AfterPrefixInNthParagraph semantic");
            var result1 = ListUtils$SmartcutsMacros.shortcut(function(textContent) {
                if (textContent.TAG !== /* TextSegment */ 0) {
                    return;
                }
                var element = textContent._0;
                if (element.TAG !== /* NonEmptySegment */ 0) {
                    return [
                        Caml_option.some(element._0),
                        0
                    ];
                }
                var match = element._0;
                var prefixStarts = match.text.indexOf(prefix);
                if (prefixStarts === -1) {
                    return;
                }
                var node = match.parentElement.childNodes.item(match.textNodeIndex);
                return [
                    node == null ? undefined : Caml_option.some(node),
                    prefixStarts + prefix.length | 0
                ];
            }, ListUtils$SmartcutsMacros.take(match$6[0], textContents));
            var match$7 = result1 !== undefined ? result1 : [
                undefined,
                0
            ];
            var match$8 = nodeAndEndOffsetOfTextSegmentAtIndex(match$6[1]);
            return applySelection(match$7[0], match$8[0], match$7[1], match$8[1]);
        case /* SelectAll_BeforeSuffixInNthParagraph */ 3:
            var suffix = semantic._0;
            var func$1 = TextContents$SmartcutsMacros.Generic.locateNthParagraph;
            var arg$1 = Curry._2(func$1, semantic._1, textContents);
            var match$9 = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expected to locateNathParagraph when applying SelectAll_BeforeSuffixInNthParagraph semantic");
            var startIndex = match$9[0];
            var result$1 = ListUtils$SmartcutsMacros.shortcut(function(textContent) {
                if (textContent.TAG !== /* TextSegment */ 0) {
                    return;
                }
                var element = textContent._0;
                if (element.TAG !== /* NonEmptySegment */ 0) {
                    return [
                        Caml_option.some(element._0),
                        0
                    ];
                }
                var match = element._0;
                var offset = match.text.indexOf(suffix);
                if (offset === -1) {
                    return;
                }
                var node = match.parentElement.childNodes.item(match.textNodeIndex);
                return [
                    node == null ? undefined : Caml_option.some(node),
                    offset
                ];
            }, ListUtils$SmartcutsMacros.take(startIndex, textContents));
            var match$10 = result$1 !== undefined ? result$1 : [
                undefined,
                0
            ];
            return applySelection(nodeOfTextSegmentAtIndex(startIndex), match$10[0], 0, match$10[1]);
        case /* SelectInNthParagraph */ 4:
            var nthParagraph1 = semantic._0;
            return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function(result) {
                if (result.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                var nonInputSemanticApplicationError = result._0;
                if (typeof nonInputSemanticApplicationError === "number" || nonInputSemanticApplicationError.TAG !== /* NonInputSelectionSemanticError */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: nonInputSemanticApplicationError
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* ContentEditableSelectionSemanticError */ 4,
                            _0: {
                                TAG: /* CouldNotApplyNonInputSelectionSemanticInNthParagraph */ 1,
                                _0: nthParagraph1,
                                _1: nonInputSemanticApplicationError._0
                            }
                        }
                    });
                }
            });
        case /* SelectParagraphs */ 5:
            var match$11 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
            var match$12 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._1, textContents);
            if (match$11 === undefined) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
            }
            if (match$12 === undefined) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
            }
            var match$13 = nodeAndEndOffsetOfTextSegmentAtIndex(match$12[1]);
            return applySelection(nodeOfTextSegmentAtIndex(match$11[0]), match$13[0], 0, match$13[1]);
        case /* SelectBetweenIndexes */ 6:
            var match$14 = semantic._1;
            var match$15 = semantic._0;
            var locateNodeAndOffset = function locateNodeAndOffset(nthParagraph, offsetFromParagraphStarts) {
                var match2 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(nthParagraph, textContents);
                if (match2 !== undefined) {
                    return ListUtils$SmartcutsMacros.shortcutWithState(offsetFromParagraphStarts, function(remainingOffset, textContent) {
                        var textLength = TextContents$SmartcutsMacros.textGet(textContent).length;
                        if (remainingOffset > textLength) {
                            return [
                                remainingOffset - textLength | 0,
                                undefined
                            ];
                        }
                        var element;
                        if (textContent.TAG === /* TextSegment */ 0) {
                            var element$1 = textContent._0;
                            if (element$1.TAG === /* NonEmptySegment */ 0) {
                                var match = element$1._0;
                                return [
                                    remainingOffset,
                                    [
                                        Caml_option.nullable_to_opt(match.parentElement.childNodes.item(match.textNodeIndex)),
                                        remainingOffset
                                    ]
                                ];
                            }
                            element = element$1._0;
                        } else {
                            var element$2 = textContent._0;
                            if (element$2.TAG === /* NonEmptySegment */ 0) {
                                return [
                                    remainingOffset,
                                    [
                                        Caml_option.nullable_to_opt(element$2._0.parentElement.firstChild),
                                        remainingOffset
                                    ]
                                ];
                            }
                            element = element$2._0;
                        }
                        return [
                            remainingOffset,
                            [
                                Caml_option.some(element),
                                remainingOffset
                            ]
                        ];
                    }, ListUtils$SmartcutsMacros.drop(match2[0], ListUtils$SmartcutsMacros.take(match2[1], textContents)));
                }
            };
            var match$16 = locateNodeAndOffset(match$15[0], match$15[1]);
            var match$17 = locateNodeAndOffset(match$14[0], match$14[1]);
            if (match$16 !== undefined && match$17 !== undefined) {
                return applySelection(match$16[0], match$17[0], match$16[1], match$17[1]);
            } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
            }
    }
}
function selectInsideContentEditableLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function(result_contentEditableHost) {
        if (result_contentEditableHost.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_contentEditableHost._0
            });
        }
        var contentEditableHost = result_contentEditableHost._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(contentEditableHost, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return selectInsideContentEditable(contentEditableHost, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic);
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    });
}
function toHumanReadable(semantic) {
    if (typeof semantic === "number") {
        return "All content inside the editor";
    }
    switch(semantic.TAG | 0){
        case /* SelectAll_FromNthParagraph */ 0:
            return "From the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " to the end");
        case /* SelectAll_ToNthParagraphEnds */ 1:
            return "Until the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
        case /* SelectAll_AfterPrefixInNthParagraph */ 2:
            return 'From "' + semantic._0 + '" in ' + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " to the end");
        case /* SelectAll_BeforeSuffixInNthParagraph */ 3:
            return 'Until "' + semantic._0 + '" ' + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " paragraph");
        case /* SelectInNthParagraph */ 4:
            return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.stringify(semantic._1) + (" in " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph"));
        case /* SelectParagraphs */ 5:
            return "From the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + (" paragraphuntil the end of " + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " paragraph")));
        case /* SelectBetweenIndexes */ 6:
            var match = semantic._1;
            var match$1 = semantic._0;
            return "Between position " + match$1[1] + " in the " + (StringUtils$SmartcutsMacros.withOrd(match$1[0] + 1 | 0) + (" paragraph to position " + match[1] + " in the " + (StringUtils$SmartcutsMacros.withOrd(match[0] + 1 | 0) + " paragraph")));
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    selectInsideContentEditable: selectInsideContentEditable,
    selectInsideContentEditableLocatedAtSelector: selectInsideContentEditableLocatedAtSelector,
    toHumanReadable: toHumanReadable
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "semantics",
            Decco.arrayToJson(t_encode, v.semantics)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var semantics = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function ofSelection(contentEditableHost, textContents, selection) {
    var semantics;
    if (selection.TAG === /* SingleNode */ 0) {
        var match = selection._0;
        var endOffset = match.endOffset;
        var startOffset = match.startOffset;
        var textNode = match.textNode;
        var exit = 0;
        var exit$1 = 0;
        var text;
        if (textContents) {
            var match$1 = textContents.hd;
            if (match$1.TAG === /* TextSegment */ 0) {
                var match$2 = match$1._0;
                if (match$2.TAG === /* NonEmptySegment */ 0) {
                    if (textContents.tl) {
                        exit = 1;
                    } else {
                        text = match$2._0.text;
                        exit$1 = 2;
                    }
                } else if (textContents.tl) {
                    exit = 1;
                } else {
                    exit$1 = 3;
                }
            } else {
                var match$3 = match$1._0;
                if (match$3.TAG === /* NonEmptySegment */ 0) {
                    if (textContents.tl) {
                        exit = 1;
                    } else {
                        text = match$3._0.text;
                        exit$1 = 2;
                    }
                } else if (textContents.tl) {
                    exit = 1;
                } else {
                    exit$1 = 3;
                }
            }
        } else {
            exit = 1;
        }
        switch(exit$1){
            case 2:
                if (startOffset === 0 && endOffset === text.length) {
                    semantics = [
                        /* SelectAll_InsideContenEditable */ 0
                    ];
                } else {
                    exit = 1;
                }
                break;
            case 3:
                if (startOffset === 0 && endOffset === 0) {
                    semantics = [
                        /* SelectAll_InsideContenEditable */ 0
                    ];
                } else {
                    exit = 1;
                }
                break;
        }
        if (exit === 1) {
            var nonInputSemantics = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.ofSelection(selection);
            var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
            var func$1 = Curry._1(func, match.elementNode.domElementRepresentation.domElementIdentifier);
            var maybeResult = Curry._2(func$1, textNode !== undefined ? textNode.siblingIndex : -1, textContents);
            if (maybeResult !== undefined) {
                var nthParagraph = maybeResult.nthParagraph;
                semantics = Belt_Array.map(nonInputSemantics, function(semantic) {
                    return {
                        TAG: /* SelectInNthParagraph */ 4,
                        _0: nthParagraph,
                        _1: semantic
                    };
                });
            } else {
                semantics = [];
            }
        }
    } else {
        var match$4 = selection._0;
        var match$5 = match$4.end_;
        var endOffset$1 = match$5.offset;
        var endTextNode = match$5.textNode;
        var match$6 = match$4.start;
        var startOffset$1 = match$6.offset;
        var startTextNode = match$6.textNode;
        var textNodeIndexForStart = startTextNode !== undefined ? startTextNode.siblingIndex : -1;
        var textNodeIndexForEnd = endTextNode !== undefined ? endTextNode.siblingIndex : -1;
        var func$2 = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
        var func$3 = Curry._1(func$2, match$6.elementNode.domElementRepresentation.domElementIdentifier);
        var arg = Curry._2(func$3, textNodeIndexForStart, textContents);
        var startPointer = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expected to find startPointer");
        var func$4 = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
        var func$5 = Curry._1(func$4, match$5.elementNode.domElementRepresentation.domElementIdentifier);
        var arg$1 = Curry._2(func$5, textNodeIndexForEnd, textContents);
        var endPointer = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }("Expected to find endPointer");
        var fullText = TextContents$SmartcutsMacros.Generic.fullText(textContents);
        var match$7 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(fullText, TextContents$SmartcutsMacros.Generic.offsetFormBeginning(startPointer.index, startOffset$1, textContents), fullText, TextContents$SmartcutsMacros.Generic.offsetFormBeginning(endPointer.index, endOffset$1, textContents));
        var suffixWord = match$7[1];
        var prefixWord = match$7[0];
        var startIndex = startPointer.index;
        var nthParagraph$1 = startPointer.nthParagraph;
        var exit$2 = 0;
        var exit$3 = 0;
        if (startIndex !== 0 || !(startOffset$1 === 0 && endPointer.index === List.length(textContents) && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length)) {
            exit$3 = 2;
        } else {
            semantics = [
                /* SelectAll_InsideContenEditable */ 0
            ];
        }
        if (exit$3 === 2) {
            if (endPointer.index === List.length(textContents)) {
                semantics = startIndex === startPointer.currentParagraphStartsAtIndex && startOffset$1 === 0 ? [
                    {
                        TAG: /* SelectAll_FromNthParagraph */ 0,
                        _0: nthParagraph$1
                    }
                ] : prefixWord !== undefined ? [
                    {
                        TAG: /* SelectAll_AfterPrefixInNthParagraph */ 2,
                        _0: prefixWord[1],
                        _1: nthParagraph$1
                    }
                ] : Util$SmartcutsMacros.logAndRaiseJsError("Expected to find a prefix");
            } else if (startIndex !== 0) {
                exit$2 = 1;
            } else {
                var nthParagraph$2 = endPointer.nthParagraph;
                if (startOffset$1 === 0 && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length) {
                    semantics = TextContents$SmartcutsMacros.Generic.isAtParagraphBoundary(endPointer.index + 1 | 0, textContents) ? [
                        {
                            TAG: /* SelectAll_ToNthParagraphEnds */ 1,
                            _0: nthParagraph$2
                        }
                    ] : suffixWord !== undefined ? [
                        {
                            TAG: /* SelectAll_BeforeSuffixInNthParagraph */ 3,
                            _0: suffixWord[1],
                            _1: nthParagraph$2
                        }
                    ] : Util$SmartcutsMacros.logAndRaiseJsError("Expected to find a suffix");
                } else {
                    exit$2 = 1;
                }
            }
        }
        if (exit$2 === 1) {
            var endIndex = endPointer.index;
            var endParagraph = endPointer.nthParagraph;
            var indexOfStartParagraph = startPointer.currentParagraphStartsAtIndex;
            if (nthParagraph$1 === endParagraph) {
                var nonInputSemantics$1 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.ofSelection(selection);
                semantics = Belt_Array.map(nonInputSemantics$1, function(semantic) {
                    return {
                        TAG: /* SelectInNthParagraph */ 4,
                        _0: nthParagraph$1,
                        _1: semantic
                    };
                });
            } else if (startOffset$1 === 0 && startIndex === indexOfStartParagraph && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length && TextContents$SmartcutsMacros.Generic.isAtParagraphBoundary(endIndex + 1 | 0, textContents)) {
                semantics = [
                    {
                        TAG: /* SelectParagraphs */ 5,
                        _0: nthParagraph$1,
                        _1: endParagraph
                    }
                ];
            } else {
                var startOffsetInParagraph = TextContents$SmartcutsMacros.Generic.offsetFormBeginningOfParagraph(startIndex, indexOfStartParagraph, startOffset$1, textContents);
                var endOffsetInParagraph = TextContents$SmartcutsMacros.Generic.offsetFormBeginningOfParagraph(endIndex, endPointer.currentParagraphStartsAtIndex, endOffset$1, textContents);
                semantics = [
                    {
                        TAG: /* SelectBetweenIndexes */ 6,
                        _0: [
                            nthParagraph$1,
                            startOffsetInParagraph
                        ],
                        _1: [
                            endParagraph,
                            endOffsetInParagraph
                        ]
                    }
                ];
            }
        }
    }
    return {
        selector: contentEditableHost.selector,
        semantics: semantics
    };
}
function stringify(semantics) {
    return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}
var SemanticsPrefixSuffix;
var NonInputSelection;
var NonInputSelectionSemantics;
exports.SemanticsPrefixSuffix = SemanticsPrefixSuffix;
exports.NonInputSelection = NonInputSelection;
exports.NonInputSelectionSemantics = NonInputSelectionSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.ofSelection = ofSelection;
exports.stringify = stringify; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 65768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Util$SmartcutsMacros = __webpack_require__(25092);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
var SelectionSemantics__Shared$SmartcutsMacros = __webpack_require__(47401);
function t_encode(v) {
    if (typeof v === "number") {
        if (v === /* CursorAtStartOfInput */ 0) {
            return [
                "CursorAtStartOfInput"
            ];
        } else {
            return [
                "CursorAtEndOfInput"
            ];
        }
    }
    switch(v.TAG | 0){
        case /* CursorAfterNthWord */ 0:
            return [
                "CursorAfterNthWord",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* CursorBeforeNthWord */ 1:
            return [
                "CursorBeforeNthWord",
                Decco.intToJson(v._0)
            ];
        case /* CursorInsideNthWordAndOffset */ 2:
            return [
                "CursorInsideNthWordAndOffset",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* CursorInsideNthWord */ 3:
            return [
                "CursorInsideNthWord",
                Decco.intToJson(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CursorAfterNthWord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CursorAfterNthWord */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "CursorAtEndOfInput":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CursorAtEndOfInput */ 1
                    };
                }
            case "CursorAtStartOfInput":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CursorAtStartOfInput */ 0
                    };
                }
            case "CursorBeforeNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorBeforeNthWord */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "CursorInsideNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CursorInsideNthWord */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$3 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "CursorInsideNthWordAndOffset":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* CursorInsideNthWordAndOffset */ 2,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$4 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function moveCursorToPosition(htmlInputElement, cursorPosition) {
    htmlInputElement.setSelectionRange(cursorPosition, cursorPosition);
}
function moveCursorInsideInput(element, semantic) {
    var value = element.value;
    if (typeof semantic === "number") {
        if (semantic === /* CursorAtStartOfInput */ 0) {
            moveCursorToPosition(element, 0);
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
        var cursorPosition = value.length;
        moveCursorToPosition(element, cursorPosition);
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    } else {
        switch(semantic.TAG | 0){
            case /* CursorAfterNthWord */ 0:
                var nth = semantic._0;
                var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
                var match = Belt_Array.get(wordsWithOffsets, nth);
                if (match === undefined) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthWord */ 0,
                            _0: nth
                        }
                    });
                }
                var word = match[1];
                var wordOffset = match[0];
                var cursorPosition$1 = (wordOffset + word.length | 0) + semantic._1 | 0;
                if (cursorPosition$1 > value.length) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindOffsetInsideNthWord */ 1,
                            _0: nth,
                            _1: word,
                            _2: wordOffset
                        }
                    });
                } else {
                    moveCursorToPosition(element, cursorPosition$1);
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
            case /* CursorBeforeNthWord */ 1:
                var nth$1 = semantic._0;
                var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
                var match$1 = Belt_Array.get(wordsWithOffsets$1, nth$1);
                if (match$1 !== undefined) {
                    moveCursorToPosition(element, match$1[0]);
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthWord */ 0,
                            _0: nth$1
                        }
                    });
                }
            case /* CursorInsideNthWordAndOffset */ 2:
                var offsetInsideWord = semantic._1;
                var nth$2 = semantic._0;
                var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
                var match$2 = Belt_Array.get(wordsWithOffsets$2, nth$2);
                if (match$2 === undefined) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthWord */ 0,
                            _0: nth$2
                        }
                    });
                }
                var word$1 = match$2[1];
                if (offsetInsideWord > word$1.length) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindOffsetInsideNthWord */ 1,
                            _0: nth$2,
                            _1: word$1,
                            _2: offsetInsideWord
                        }
                    });
                }
                var cursorPosition$2 = match$2[0] + offsetInsideWord | 0;
                moveCursorToPosition(element, cursorPosition$2);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            case /* CursorInsideNthWord */ 3:
                var nth$3 = semantic._0;
                var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
                var match$3 = Belt_Array.get(wordsWithOffsets$3, nth$3);
                if (match$3 === undefined) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* CouldNotFindNthWord */ 0,
                            _0: nth$3
                        }
                    });
                }
                var offsetInsideWord$1 = match$3[1].length >> 1;
                var cursorPosition$3 = match$3[0] + offsetInsideWord$1 | 0;
                moveCursorToPosition(element, cursorPosition$3);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
        }
    }
}
function moveCursorInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function(result_element) {
        if (result_element.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_element._0
            });
        }
        var element = result_element._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result1) {
            if (result1.TAG === /* Ok */ 0) {
                return moveCursorInsideInput(element, semantic).then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    } else {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* InputCursorSemanticError */ 2,
                                _0: result._0
                            }
                        });
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result1._0
                });
            }
        });
    });
}
function toHumanReadable(semantic) {
    if (typeof semantic === "number") {
        if (semantic === /* CursorAtStartOfInput */ 0) {
            return "To the beginning of the field";
        } else {
            return "To the end of the field";
        }
    }
    switch(semantic.TAG | 0){
        case /* CursorAfterNthWord */ 0:
            var n = semantic._0 + 1 | 0;
            var nth = StringUtils$SmartcutsMacros.withOrd(n);
            return "" + semantic._1 + " characters after the " + nth + " word";
        case /* CursorBeforeNthWord */ 1:
            var n$1 = semantic._0 + 1 | 0;
            var nth$1 = StringUtils$SmartcutsMacros.withOrd(n$1);
            return "Before the " + nth$1 + " word";
        case /* CursorInsideNthWordAndOffset */ 2:
            var n$2 = semantic._0 + 1 | 0;
            var nth$2 = StringUtils$SmartcutsMacros.withOrd(n$2);
            var nthInsideWord = StringUtils$SmartcutsMacros.withOrd(semantic._1);
            return "Inside the " + nth$2 + " word, after the " + nthInsideWord + " character";
        case /* CursorInsideNthWord */ 3:
            var n$3 = semantic._0 + 1 | 0;
            var nth$3 = StringUtils$SmartcutsMacros.withOrd(n$3);
            return "Anywhere inside the " + nth$3 + " word";
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    moveCursorToPosition: moveCursorToPosition,
    moveCursorInsideInput: moveCursorInsideInput,
    moveCursorInsideInputLocatedAtSelector: moveCursorInsideInputLocatedAtSelector,
    toHumanReadable: toHumanReadable
};
function t_encode$1(v) {
    return Decco.arrayToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.arrayFromJson(t_decode, v);
}
function stringify(semantics) {
    return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}
function ofInputCursor(inputCursor) {
    var value = inputCursor.value;
    var cursorPosition = inputCursor.cursorPosition;
    if (Selection__InputCursor$SmartcutsMacros.Generic.isCursorAtStartOfInput(inputCursor)) {
        return [
            /* CursorAtStartOfInput */ 0
        ];
    }
    if (Selection__InputCursor$SmartcutsMacros.Generic.isCursorAtEndOfInput(inputCursor)) {
        return [
            /* CursorAtEndOfInput */ 1
        ];
    }
    var wordsWithPositions = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
    var arg = Util$SmartcutsMacros.shortcutWithIndex2(wordsWithPositions, function(param, index) {
        var wordStartOffset = param[0];
        var wordEndOffset = wordStartOffset + param[1].length | 0;
        if (wordEndOffset < cursorPosition) {
            return;
        }
        if (wordEndOffset === cursorPosition) {
            return [
                {
                    TAG: /* CursorAfterNthWord */ 0,
                    _0: index,
                    _1: 0
                }
            ];
        }
        if (wordStartOffset === cursorPosition) {
            return [
                {
                    TAG: /* CursorBeforeNthWord */ 1,
                    _0: index
                }
            ];
        }
        if (wordStartOffset <= cursorPosition) {
            return [
                {
                    TAG: /* CursorInsideNthWord */ 3,
                    _0: index
                },
                {
                    TAG: /* CursorInsideNthWordAndOffset */ 2,
                    _0: index,
                    _1: cursorPosition - wordStartOffset | 0
                }
            ];
        }
        var match = Caml_array.get(wordsWithPositions, index - 1 | 0);
        var offsetAfterLastWord = cursorPosition - (match[0] + match[1].length | 0) | 0;
        return [
            {
                TAG: /* CursorAfterNthWord */ 0,
                _0: index - 1 | 0,
                _1: offsetAfterLastWord
            }
        ];
    });
    var param1 = "Expected cursorPosition, " + (String(cursorPosition) + (", to fall within bounds of value " + value));
    return OptionUtils$SmartcutsMacros.getExn(param1, arg);
}
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.ofInputCursor = ofInputCursor; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 22436:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = __webpack_require__(65768);
var SelectionSemantics__InputSelectionSemantics$SmartcutsMacros = __webpack_require__(35275);
function t_encode(v) {
    if (v.TAG === /* InputSelectionSemantic */ 0) {
        return [
            "InputSelectionSemantic",
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._0)
        ];
    } else {
        return [
            "InputCursorSemantic",
            SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_encode(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InputCursorSemantic":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputCursorSemantic */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "InputSelectionSemantic":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InputSelectionSemantic */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toHumanReadable(v) {
    if (v.TAG === /* InputSelectionSemantic */ 0) {
        return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._0);
    } else {
        return SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._0);
    }
}
function selectOrMoveCursorInsideInput(element, semantic) {
    if (semantic.TAG === /* InputSelectionSemantic */ 0) {
        var func = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.selectInsideInput;
        return Curry._2(func, element, semantic._0).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* InputSelectionSemanticError */ 1,
                        _0: result._0
                    }
                });
            }
        });
    }
    var func$1 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.moveCursorInsideInput;
    return Curry._2(func$1, element, semantic._0).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* InputCursorSemanticError */ 2,
                    _0: result._0
                }
            });
        }
    });
}
function selectOrMoveCursorInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    if (semantic.TAG === /* InputSelectionSemantic */ 0) {
        var func = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.selectInsideInputLocatedAtSelector;
        var func$1 = Curry._1(func, selector);
        return Curry._2(func$1, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    }
    var func$2 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.moveCursorInsideInputLocatedAtSelector;
    var func$3 = Curry._1(func$2, selector);
    return Curry._2(func$3, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result._0
            });
        }
    });
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    toHumanReadable: toHumanReadable,
    selectOrMoveCursorInsideInput: selectOrMoveCursorInsideInput,
    selectOrMoveCursorInsideInputLocatedAtSelector: selectOrMoveCursorInsideInputLocatedAtSelector
};
function t_encode$1(v) {
    return Decco.arrayToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.arrayFromJson(t_decode, v);
}
function stringify(semantics) {
    return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}
function ofSelectionOrCursor(param) {
    var value = param.value;
    var params = param.params;
    var domElementRepresentation = param.domElementRepresentation;
    if (typeof params === "number") {
        return [];
    }
    if (params.TAG !== /* InputSelectionParams */ 0) {
        return $$Array.map(function(semantic) {
            return {
                TAG: /* InputCursorSemantic */ 1,
                _0: semantic
            };
        }, SelectionSemantics__InputCursorSemantics$SmartcutsMacros.ofInputCursor({
            domElementRepresentation: domElementRepresentation,
            cursorPosition: params._0,
            value: value
        }));
    }
    var match = params._0;
    return $$Array.map(function(semantic) {
        return {
            TAG: /* InputSelectionSemantic */ 0,
            _0: semantic
        };
    }, SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.ofSelection({
        domElementRepresentation: domElementRepresentation,
        value: value,
        start: match.start,
        end_: match.end_,
        selectionDirection: match.selectionDirection
    }));
}
var InputSelectionSemantics;
var InputCursorSemantics;
exports.InputSelectionSemantics = InputSelectionSemantics;
exports.InputCursorSemantics = InputCursorSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.ofSelectionOrCursor = ofSelectionOrCursor; /* SelectionSemantics__InputCursorSemantics-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 35275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Ord = __webpack_require__(61618);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var SelectionSemantics__Shared$SmartcutsMacros = __webpack_require__(47401);
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "SelectAll"
        ];
    }
    switch(v.TAG | 0){
        case /* SelectNthWord */ 0:
            return [
                "SelectNthWord",
                Decco.intToJson(v._0)
            ];
        case /* SelectBetweenIndexes */ 1:
            return [
                "SelectBetweenIndexes",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* SelectBetweenNthWords */ 2:
            return [
                "SelectBetweenNthWords",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
            ];
        case /* SelectBetweenTexts */ 3:
            return [
                "SelectBetweenTexts",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* SelectAfterIndex */ 4:
            return [
                "SelectAfterIndex",
                Decco.intToJson(v._0)
            ];
        case /* SelectAfterNthWord */ 5:
            return [
                "SelectAfterNthWord",
                Decco.intToJson(v._0)
            ];
        case /* SelectAfterPrefix */ 6:
            return [
                "SelectAfterPrefix",
                Decco.stringToJson(v._0)
            ];
        case /* SelectBeforeIndex */ 7:
            return [
                "SelectBeforeIndex",
                Decco.intToJson(v._0)
            ];
        case /* SelectBeforeNthWord */ 8:
            return [
                "SelectBeforeNthWord",
                Decco.intToJson(v._0)
            ];
        case /* SelectBeforeSuffix */ 9:
            return [
                "SelectBeforeSuffix",
                Decco.stringToJson(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SelectAfterIndex":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectAfterIndex */ 4,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SelectAfterNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectAfterNthWord */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "SelectAfterPrefix":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectAfterPrefix */ 6,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "SelectAll":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SelectAll */ 0
                    };
                }
            case "SelectBeforeIndex":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectBeforeIndex */ 7,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "SelectBeforeNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectBeforeNthWord */ 8,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "SelectBeforeSuffix":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectBeforeSuffix */ 9,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "SelectBetweenIndexes":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectBetweenIndexes */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$6 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "SelectBetweenNthWords":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectBetweenNthWords */ 2,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$8 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "SelectBetweenTexts":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectBetweenTexts */ 3,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$10 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$10.path,
                            message: e$10.message,
                            value: e$10.value
                        }
                    };
                }
                var e$11 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "SelectNthWord":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectNthWord */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$12 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectInsideInput(element, semantic) {
    var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
    if (activeElement !== undefined && Caml_option.valFromOption(activeElement) === element) {} else {
        element.focus();
    }
    var value = element.value;
    if (typeof semantic === "number") {
        element.setSelectionRange(0, value.length);
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    }
    switch(semantic.TAG | 0){
        case /* SelectNthWord */ 0:
            var wordIndex = semantic._0;
            var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match = Belt_Array.get(wordsWithOffsets, wordIndex);
            if (match !== undefined) {
                var wordOffset = match[0];
                var endOffset = wordOffset + match[1].length | 0;
                element.setSelectionRange(wordOffset, endOffset);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
            var nth = wordIndex + 1 | 0;
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* CouldNotFindNthWord */ 0,
                    _0: nth,
                    _1: wordsWithOffsets
                }
            });
        case /* SelectBetweenIndexes */ 1:
            var endOffset$1 = semantic._1;
            var startOffset = semantic._0;
            var value$1 = element.value;
            if (startOffset > value$1.length) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: startOffset,
                        _1: value$1
                    }
                });
            } else if (endOffset$1 > value$1.length) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: endOffset$1,
                        _1: value$1
                    }
                });
            } else {
                element.setSelectionRange(startOffset, endOffset$1);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        case /* SelectBetweenNthWords */ 2:
            var k = semantic._1;
            var i = semantic._0;
            var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$1 = Belt_Array.get(wordsWithOffsets$1, i);
            var match$2 = Belt_Array.get(wordsWithOffsets$1, k);
            if (match$1 === undefined) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: i,
                        _1: wordsWithOffsets$1
                    }
                });
            }
            if (match$2 === undefined) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: k,
                        _1: wordsWithOffsets$1
                    }
                });
            }
            var startOffset$1 = match$1[0] + match$1[1].length | 0;
            element.setSelectionRange(startOffset$1, match$2[0]);
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        case /* SelectBetweenTexts */ 3:
            var suffix = semantic._1;
            var prefix = semantic._0;
            var prefixIndex = value.indexOf(prefix);
            if (prefixIndex === -1) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindPrefix */ 2,
                        _0: prefix,
                        _1: value
                    }
                });
            }
            var startOffset$2 = prefixIndex + prefix.length | 0;
            var endOffset$2 = value.indexOf(suffix);
            if (endOffset$2 === -1) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindSuffix */ 3,
                        _0: suffix,
                        _1: value
                    }
                });
            } else {
                element.setSelectionRange(startOffset$2, endOffset$2);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        case /* SelectAfterIndex */ 4:
            var index = semantic._0;
            if (index > value.length) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: index,
                        _1: value
                    }
                });
            } else {
                element.setSelectionRange(index + 1 | 0, value.length);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        case /* SelectAfterNthWord */ 5:
            var index$1 = semantic._0;
            var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$3 = Belt_Array.get(wordsWithOffsets$2, index$1);
            if (match$3 === undefined) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: index$1,
                        _1: wordsWithOffsets$2
                    }
                });
            }
            var startOffset$3 = match$3[0] + match$3[1].length | 0;
            element.setSelectionRange(startOffset$3, value.length);
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        case /* SelectAfterPrefix */ 6:
            var prefix$1 = semantic._0;
            var prefixIndex$1 = value.indexOf(prefix$1);
            if (prefixIndex$1 === -1) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindPrefix */ 2,
                        _0: prefix$1,
                        _1: value
                    }
                });
            }
            var startOffset$4 = prefixIndex$1 + prefix$1.length | 0;
            element.setSelectionRange(startOffset$4, value.length);
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        case /* SelectBeforeIndex */ 7:
            var index$2 = semantic._0;
            if (index$2 > value.length) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: index$2,
                        _1: value
                    }
                });
            } else {
                element.setSelectionRange(0, index$2);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        case /* SelectBeforeNthWord */ 8:
            var index$3 = semantic._0;
            var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$4 = Belt_Array.get(wordsWithOffsets$3, index$3);
            if (match$4 !== undefined) {
                element.setSelectionRange(0, match$4[0]);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: index$3,
                        _1: wordsWithOffsets$3
                    }
                });
            }
        case /* SelectBeforeSuffix */ 9:
            var suffix$1 = semantic._0;
            var endOffset$3 = value.indexOf(suffix$1);
            if (endOffset$3 === -1) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindSuffix */ 3,
                        _0: suffix$1,
                        _1: value
                    }
                });
            } else {
                element.setSelectionRange(0, endOffset$3);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
    }
}
function selectInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function(result_element) {
        if (result_element.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_element._0
            });
        }
        var element = result_element._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result1) {
            if (result1.TAG === /* Ok */ 0) {
                return selectInsideInput(element, semantic).then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    } else {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* InputSelectionSemanticError */ 1,
                                _0: result._0
                            }
                        });
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result1._0
                });
            }
        });
    });
}
function applyToInputValue(value, semantic) {
    if (typeof semantic === "number") {
        return {
            TAG: /* Ok */ 0,
            _0: value
        };
    }
    switch(semantic.TAG | 0){
        case /* SelectNthWord */ 0:
            var wordIndex = semantic._0;
            var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match = Belt_Array.get(wordsWithOffsets, wordIndex);
            if (match !== undefined) {
                return {
                    TAG: /* Ok */ 0,
                    _0: match[1]
                };
            } else {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: wordIndex,
                        _1: wordsWithOffsets
                    }
                };
            }
        case /* SelectBetweenIndexes */ 1:
            var from = semantic._0;
            if (from > value.length) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: from,
                        _1: value
                    }
                };
            }
            var to_ = semantic._1;
            if (to_ > value.length) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: to_,
                        _1: value
                    }
                };
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(from, to_, value)
                };
            }
        case /* SelectBetweenNthWords */ 2:
            var k = semantic._1;
            var i = semantic._0;
            var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$1 = Belt_Array.get(wordsWithOffsets$1, i);
            var match$2 = Belt_Array.get(wordsWithOffsets$1, k);
            if (match$1 === undefined) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: i,
                        _1: wordsWithOffsets$1
                    }
                };
            }
            if (match$2 === undefined) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: k,
                        _1: wordsWithOffsets$1
                    }
                };
            }
            var startOffset = match$1[0] + match$1[1].length | 0;
            return {
                TAG: /* Ok */ 0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset, match$2[0], value)
            };
        case /* SelectBetweenTexts */ 3:
            var suffix = semantic._1;
            var prefix = semantic._0;
            var prefixIndex = value.indexOf(prefix);
            if (prefixIndex === -1) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindPrefix */ 2,
                        _0: prefix,
                        _1: value
                    }
                };
            }
            var startOffset$1 = prefixIndex + prefix.length | 0;
            var endOffset = value.indexOf(suffix);
            if (endOffset === -1) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindSuffix */ 3,
                        _0: suffix,
                        _1: value
                    }
                };
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(startOffset$1, endOffset, value)
                };
            }
        case /* SelectAfterIndex */ 4:
            var index = semantic._0;
            if (index > value.length) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: index,
                        _1: value
                    }
                };
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(index + 1 | 0, value.length, value)
                };
            }
        case /* SelectAfterNthWord */ 5:
            var index$1 = semantic._0;
            var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$3 = Belt_Array.get(wordsWithOffsets$2, index$1);
            if (match$3 === undefined) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: index$1,
                        _1: wordsWithOffsets$2
                    }
                };
            }
            var startOffset$2 = match$3[0] + match$3[1].length | 0;
            return {
                TAG: /* Ok */ 0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset$2, value.length, value)
            };
        case /* SelectAfterPrefix */ 6:
            var prefix$1 = semantic._0;
            var prefixIndex$1 = value.indexOf(prefix$1);
            if (prefixIndex$1 === -1) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindPrefix */ 2,
                        _0: prefix$1,
                        _1: value
                    }
                };
            }
            var startOffset$3 = prefixIndex$1 + prefix$1.length | 0;
            return {
                TAG: /* Ok */ 0,
                _0: StringUtils$SmartcutsMacros.slice(startOffset$3, value.length, value)
            };
        case /* SelectBeforeIndex */ 7:
            var index$2 = semantic._0;
            if (index$2 > value.length) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindIndex */ 1,
                        _0: index$2,
                        _1: value
                    }
                };
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(0, index$2, value)
                };
            }
        case /* SelectBeforeNthWord */ 8:
            var index$3 = semantic._0;
            var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
            var match$4 = Belt_Array.get(wordsWithOffsets$3, index$3);
            if (match$4 !== undefined) {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(0, match$4[0], value)
                };
            } else {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindNthWord */ 0,
                        _0: index$3,
                        _1: wordsWithOffsets$3
                    }
                };
            }
        case /* SelectBeforeSuffix */ 9:
            var suffix$1 = semantic._0;
            var endOffset$1 = value.indexOf(suffix$1);
            if (endOffset$1 === -1) {
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* CouldNotFindSuffix */ 3,
                        _0: suffix$1,
                        _1: value
                    }
                };
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: StringUtils$SmartcutsMacros.slice(0, endOffset$1, value)
                };
            }
    }
}
function getText(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function(result_element) {
        if (result_element.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_element._0
            });
        }
        var element = result_element._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var value = element.value;
            var str = applyToInputValue(value, semantic);
            if (str.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: str._0
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* InputSelectionSemanticError */ 1,
                        _0: str._0
                    }
                });
            }
        });
    });
}
function toHumanReadable(semantic) {
    if (typeof semantic === "number") {
        return "All content inside the form text box";
    }
    switch(semantic.TAG | 0){
        case /* SelectNthWord */ 0:
            var nth = semantic._0 + 1 | 0;
            return "The " + nth + (Ord(nth) + " word");
        case /* SelectBetweenIndexes */ 1:
            return "Between position " + semantic._0 + " and " + semantic._1;
        case /* SelectBetweenNthWords */ 2:
            var nth$p = semantic._1;
            var nth$1 = semantic._0;
            return "Between " + nth$1 + (Ord(nth$1) + (" and " + nth$p + (Ord(nth$p) + " words")));
        case /* SelectBetweenTexts */ 3:
            return 'Between "' + semantic._0 + '" and "' + semantic._1 + '"';
        case /* SelectAfterIndex */ 4:
            var nth$2 = semantic._0 + 1 | 0;
            return "After the " + nth$2 + (Ord(nth$2) + " character");
        case /* SelectAfterNthWord */ 5:
            var nth$3 = semantic._0;
            return "After the " + nth$3 + (Ord(nth$3) + " word");
        case /* SelectAfterPrefix */ 6:
            return 'After "' + semantic._0 + '"';
        case /* SelectBeforeIndex */ 7:
            var nth$4 = semantic._0 + 1 | 0;
            return "Before the " + nth$4 + (Ord(nth$4) + " character");
        case /* SelectBeforeNthWord */ 8:
            var nth$5 = semantic._0;
            return "Before the " + nth$5 + (Ord(nth$5) + " word");
        case /* SelectBeforeSuffix */ 9:
            return 'Before "' + semantic._0 + '"';
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    selectInsideInput: selectInsideInput,
    selectInsideInputLocatedAtSelector: selectInsideInputLocatedAtSelector,
    applyToInputValue: applyToInputValue,
    getText: getText,
    toHumanReadable: toHumanReadable
};
function t_encode$1(v) {
    return Decco.arrayToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.arrayFromJson(t_decode, v);
}
function maybeFromWordsWithPositionsAndToken(wordsWithPositions, selectedString) {
    if (StringUtils$SmartcutsMacros.isToken(selectedString)) {
        return OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(wordsWithPositions, function(param) {
            return param[1] === selectedString;
        }), function(index) {
            return {
                TAG: /* SelectNthWord */ 0,
                _0: index
            };
        });
    }
}
var SelectNthWord = {
    maybeFromWordsWithPositionsAndToken: maybeFromWordsWithPositionsAndToken
};
function fromSelectionStartAndEndAndValue(start, end_, value) {
    var match = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(value, start, value, end_);
    var suffixWord = match[1];
    var prefixWord = match[0];
    var isStartAtBeginningOfInputValue = start === 0;
    var isEndAtEndOfInputValue = end_ === value.length;
    if (isStartAtBeginningOfInputValue) {
        if (isEndAtEndOfInputValue) {
            return [
                /* SelectAll */ 0
            ];
        }
        var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var index = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, words);
        var endCursorAtNthWordStarts;
        if (index !== undefined) {
            var match$1 = Caml_array.get(words, index);
            endCursorAtNthWordStarts = match$1[0] === end_ ? index + 1 | 0 : undefined;
        } else {
            endCursorAtNthWordStarts = undefined;
        }
        var maybeNthWordSemantic = maybeFromWordsWithPositionsAndToken(words, value.slice(start, end_));
        var tmp;
        if (suffixWord !== undefined) {
            var suffix = suffixWord[1];
            tmp = endCursorAtNthWordStarts !== undefined ? [
                {
                    TAG: /* SelectBeforeSuffix */ 9,
                    _0: suffix
                },
                {
                    TAG: /* SelectBeforeNthWord */ 8,
                    _0: endCursorAtNthWordStarts
                },
                {
                    TAG: /* SelectBeforeIndex */ 7,
                    _0: end_
                }
            ] : [
                {
                    TAG: /* SelectBeforeSuffix */ 9,
                    _0: suffix
                },
                {
                    TAG: /* SelectBeforeIndex */ 7,
                    _0: end_
                }
            ];
        } else {
            tmp = endCursorAtNthWordStarts !== undefined ? [
                {
                    TAG: /* SelectBeforeNthWord */ 8,
                    _0: endCursorAtNthWordStarts
                },
                {
                    TAG: /* SelectBeforeIndex */ 7,
                    _0: end_
                }
            ] : [
                {
                    TAG: /* SelectBeforeIndex */ 7,
                    _0: end_
                }
            ];
        }
        return $$Array.append(maybeNthWordSemantic !== undefined ? [
            maybeNthWordSemantic
        ] : [], tmp);
    }
    if (isEndAtEndOfInputValue) {
        var words$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
        var index$1 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, words$1);
        var startCursorAtNthWordsEnds;
        if (index$1 !== undefined) {
            var match$2 = Caml_array.get(words$1, index$1);
            var wordEnds = match$2[0] + match$2[1].length | 0;
            startCursorAtNthWordsEnds = wordEnds === start ? index$1 : undefined;
        } else {
            startCursorAtNthWordsEnds = undefined;
        }
        var maybeNthWordSemantic$1 = maybeFromWordsWithPositionsAndToken(words$1, value.slice(start, end_));
        var tmp$1;
        if (prefixWord !== undefined) {
            var prefix = prefixWord[1];
            tmp$1 = startCursorAtNthWordsEnds !== undefined ? [
                {
                    TAG: /* SelectAfterPrefix */ 6,
                    _0: prefix
                },
                {
                    TAG: /* SelectAfterNthWord */ 5,
                    _0: startCursorAtNthWordsEnds
                },
                {
                    TAG: /* SelectAfterIndex */ 4,
                    _0: start - 1 | 0
                },
                /* SelectAll */ 0
            ] : [
                {
                    TAG: /* SelectAfterPrefix */ 6,
                    _0: prefix
                },
                {
                    TAG: /* SelectAfterIndex */ 4,
                    _0: start - 1 | 0
                },
                /* SelectAll */ 0
            ];
        } else {
            tmp$1 = startCursorAtNthWordsEnds !== undefined ? [
                {
                    TAG: /* SelectAfterNthWord */ 5,
                    _0: startCursorAtNthWordsEnds
                },
                {
                    TAG: /* SelectAfterIndex */ 4,
                    _0: start - 1 | 0
                },
                /* SelectAll */ 0
            ] : [
                {
                    TAG: /* SelectAfterIndex */ 4,
                    _0: start - 1 | 0
                },
                /* SelectAll */ 0
            ];
        }
        return $$Array.append(maybeNthWordSemantic$1 !== undefined ? [
            maybeNthWordSemantic$1
        ] : [], tmp$1);
    }
    var startWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
    var index$2 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, startWords);
    var startCursorAtNthWordsEnds$1;
    if (index$2 !== undefined) {
        var match$3 = Caml_array.get(startWords, index$2);
        var wordEnds$1 = match$3[0] + match$3[1].length | 0;
        startCursorAtNthWordsEnds$1 = wordEnds$1 === start ? index$2 : undefined;
    } else {
        startCursorAtNthWordsEnds$1 = undefined;
    }
    var endWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
    var index$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(start, endWords);
    var endCursorAtNthWordStarts$1;
    if (index$3 !== undefined) {
        var match$4 = Caml_array.get(endWords, index$3);
        endCursorAtNthWordStarts$1 = match$4[0] === end_ ? index$3 : undefined;
    } else {
        endCursorAtNthWordStarts$1 = undefined;
    }
    var maybeNthWordSemantic$2 = maybeFromWordsWithPositionsAndToken(startWords, value.slice(start, end_));
    var tmp$2;
    if (prefixWord !== undefined) {
        if (suffixWord !== undefined) {
            var suffix$1 = suffixWord[1];
            var prefix$1 = prefixWord[1];
            var exit = 0;
            if (startCursorAtNthWordsEnds$1 !== undefined && endCursorAtNthWordStarts$1 !== undefined) {
                tmp$2 = [
                    {
                        TAG: /* SelectBetweenTexts */ 3,
                        _0: prefix$1,
                        _1: suffix$1
                    },
                    {
                        TAG: /* SelectBetweenNthWords */ 2,
                        _0: startCursorAtNthWordsEnds$1,
                        _1: endCursorAtNthWordStarts$1
                    },
                    {
                        TAG: /* SelectBetweenIndexes */ 1,
                        _0: start,
                        _1: end_
                    }
                ];
            } else {
                exit = 1;
            }
            if (exit === 1) {
                tmp$2 = [
                    {
                        TAG: /* SelectBetweenTexts */ 3,
                        _0: prefix$1,
                        _1: suffix$1
                    },
                    {
                        TAG: /* SelectBetweenIndexes */ 1,
                        _0: start,
                        _1: end_
                    }
                ];
            }
        } else {
            tmp$2 = [
                {
                    TAG: /* SelectBetweenIndexes */ 1,
                    _0: start,
                    _1: end_
                }
            ];
        }
    } else {
        tmp$2 = [
            {
                TAG: /* SelectBetweenIndexes */ 1,
                _0: start,
                _1: end_
            }
        ];
    }
    return $$Array.append(maybeNthWordSemantic$2 !== undefined ? [
        maybeNthWordSemantic$2
    ] : [], tmp$2);
}
function ofSelection(param) {
    return fromSelectionStartAndEndAndValue(param.start, param.end_, param.value);
}
function stringify(semantics) {
    return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.SelectNthWord = SelectNthWord;
exports.fromSelectionStartAndEndAndValue = fromSelectionStartAndEndAndValue;
exports.ofSelection = ofSelection;
exports.stringify = stringify; /* ord Not a pure module */ 


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Ord = __webpack_require__(61618);
var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Belt_Result = __webpack_require__(86369);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var SelectorTree$SmartcutsMacros = __webpack_require__(47118);
var SelectionSemantics__Shared$SmartcutsMacros = __webpack_require__(47401);
var Selection__NonInputSelection$SmartcutsMacros = __webpack_require__(80878);
function t_encode(v) {
    if (v.TAG === /* Element */ 0) {
        return [
            "Element",
            Selector$SmartcutsMacros.selector_encode(v._0)
        ];
    } else {
        return [
            "Text",
            Selector$SmartcutsMacros.selector_encode(v._0),
            Decco.intToJson(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Element":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Element */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Text":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Text */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(path) {
    if (path.TAG === /* Element */ 0) {
        return "Element(selector=" + (SelectorTree$SmartcutsMacros.stringify(false, path._0) + ")");
    } else {
        return "Text(selector=" + (SelectorTree$SmartcutsMacros.stringify(false, path._0) + (", index=" + (String(path._1) + ")")));
    }
}
function deepEquals(pathA, pathB) {
    if (pathA.TAG === /* Element */ 0) {
        if (pathB.TAG === /* Element */ 0) {
            return Selector$SmartcutsMacros.deepEquals(pathA._0, pathB._0);
        } else {
            return false;
        }
    }
    var indexA = pathA._1;
    if (pathB.TAG === /* Element */ 0) {
        return false;
    }
    var indexB = pathB._1;
    if (indexA !== indexB || !Selector$SmartcutsMacros.deepEquals(pathA._0, pathB._0)) {
        return false;
    } else {
        return indexA === indexB;
    }
}
function ofBoundary(boundary) {
    var textNode = boundary.textNode;
    if (textNode !== undefined) {
        return {
            TAG: /* Text */ 1,
            _0: boundary.elementNode.domElementRepresentation.selector,
            _1: textNode.siblingIndex
        };
    } else {
        return {
            TAG: /* Element */ 0,
            _0: boundary.elementNode.domElementRepresentation.selector
        };
    }
}
function findDomNode(path, maybeInnerTextSemantic, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand) {
    if (path.TAG === /* Element */ 0) {
        return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, Belt_Option.isSome(maybeInnerTextSemantic), maybeInnerTextSemantic, undefined, undefined, path._0).then(function(result_element) {
            if (result_element.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_element._0
                });
            }
            var element = result_element._0;
            return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result) {
                if (result.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FoundExpectedNode */ 0,
                            _0: element
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result._0
                    });
                }
            });
        });
    }
    var index = path._1;
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, Belt_Option.isSome(maybeInnerTextSemantic), maybeInnerTextSemantic, undefined, undefined, path._0).then(function(result_element) {
        if (result_element.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_element._0
            });
        }
        var element = result_element._0;
        return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var arg = element.childNodes.item(index);
            var arg$1 = arg == null ? undefined : Caml_option.some(arg);
            var node = function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            }("Expect childNode to exist at index(" + index + ")");
            var match = Webapi__Dom__Node.nodeType(node);
            if (match !== 2) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: {
                        TAG: /* FoundNodeButNotExpectedType */ 1,
                        _0: node
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: {
                        TAG: /* FoundExpectedNode */ 0,
                        _0: node
                    }
                });
            }
        });
    });
}
function extractSelector(path) {
    return path._0;
}
function updateSelector(f, path) {
    if (path.TAG === /* Element */ 0) {
        return {
            TAG: /* Element */ 0,
            _0: Curry._1(f, path._0)
        };
    } else {
        return {
            TAG: /* Text */ 1,
            _0: Curry._1(f, path._0),
            _1: path._1
        };
    }
}
var Path = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    deepEquals: deepEquals,
    ofBoundary: ofBoundary,
    findDomNode: findDomNode,
    extractSelector: extractSelector,
    updateSelector: updateSelector
};
function t_encode$1(v) {
    return [
        t_encode(v[0]),
        Decco.stringToJson(v[1])
    ];
}
function t_decode$1(v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
        return Decco.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
        return Decco.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = t_decode(v0);
    var match$3 = Decco.stringFromJson(v1);
    if (match$2.TAG === /* Ok */ 0) {
        if (match$3.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: [
                    match$2._0,
                    match$3._0
                ]
            };
        }
        var e = match$3._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = match$2._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function updateSelector$1(f, param) {
    return [
        updateSelector(f, param[0]),
        param[1]
    ];
}
function selectorGet(param) {
    return param[0]._0;
}
var PathStringPair = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    updateSelector: updateSelector$1,
    selectorGet: selectorGet
};
function acrossNodes_encode(v) {
    return Js_dict.fromArray([
        [
            "start",
            t_encode$1(v.start)
        ],
        [
            "end_",
            t_encode$1(v.end_)
        ]
    ]);
}
function acrossNodes_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var start = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
    if (start.TAG === /* Ok */ 0) {
        var end_ = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
        if (end_.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    start: start._0,
                    end_: end_._0
                }
            };
        }
        var e = end_._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".end_" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = start._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".start" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$2(v) {
    if (v.TAG === /* InSingleNode */ 0) {
        return [
            "InSingleNode",
            t_encode$1(v._0)
        ];
    } else {
        return [
            "AcrossNodes",
            acrossNodes_encode(v._0)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AcrossNodes":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = acrossNodes_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AcrossNodes */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "InSingleNode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InSingleNode */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function updateSelector$2(f, range) {
    if (range.TAG === /* InSingleNode */ 0) {
        return {
            TAG: /* InSingleNode */ 0,
            _0: updateSelector$1(f, range._0)
        };
    }
    var match = range._0;
    return {
        TAG: /* AcrossNodes */ 1,
        _0: {
            start: updateSelector$1(f, match.start),
            end_: updateSelector$1(f, match.end_)
        }
    };
}
function selectorGet$1(range) {
    if (range.TAG === /* InSingleNode */ 0) {
        return [
            selectorGet(range._0)
        ];
    }
    var match = range._0;
    return [
        selectorGet(match.start),
        selectorGet(match.end_)
    ];
}
var StringRange = {
    acrossNodes_encode: acrossNodes_encode,
    acrossNodes_decode: acrossNodes_decode,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    updateSelector: updateSelector$2,
    selectorGet: selectorGet$1
};
function discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param1) {
    var prefix = param1[1];
    var path = param1[0];
    return findDomNode(path, {
        TAG: /* ContainsInnerText */ 2,
        _0: {
            TAG: /* StaticText */ 0,
            _0: prefix
        }
    }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
        if (result_nodeResult.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_nodeResult._0
            });
        }
        var _node = result_nodeResult._0;
        if (_node.TAG !== /* FoundExpectedNode */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* NonInputSelectionSemanticError */ 0,
                    _0: {
                        TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                        _0: path._0
                    }
                }
            });
        }
        var node = _node._0;
        var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
        var text = function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("");
        var prefixStarts = text.indexOf(prefix);
        var prefixEnds = prefixStarts + prefix.length | 0;
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: [
                node,
                prefixEnds
            ]
        });
    });
}
var Prefix__Shared = {
    discoverRangeStart: discoverRangeStart
};
function toDomRange(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param2) {
    var domRange = document.createRange();
    return discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, [
        param2[0],
        param2[1]
    ]).then(function(result) {
        return Promise.resolve(Belt_Result.map(result, function(param3) {
            var node = param3[0];
            domRange.setStart(node, param3[1]);
            var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
            var text = function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }("");
            domRange.setEnd(node, text.length);
            return domRange;
        }));
    });
}
var AfterPrefix = {
    toDomRange: toDomRange
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "prefix",
            Decco.stringToJson(v.prefix)
        ],
        [
            "prefixRange",
            t_encode$2(v.prefixRange)
        ],
        [
            "selectionEndPath",
            t_encode(v.selectionEndPath)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var prefix = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prefix"), null));
    if (prefix.TAG === /* Ok */ 0) {
        var prefixRange = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prefixRange"), null));
        if (prefixRange.TAG === /* Ok */ 0) {
            var selectionEndPath = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectionEndPath"), null));
            if (selectionEndPath.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        prefix: prefix._0,
                        prefixRange: prefixRange._0,
                        selectionEndPath: selectionEndPath._0
                    }
                };
            }
            var e = selectionEndPath._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selectionEndPath" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = prefixRange._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".prefixRange" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = prefix._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".prefix" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return 'After "' + (param.prefix + '"');
}
function updateSelector$3(f, semantic) {
    return {
        prefix: semantic.prefix,
        prefixRange: updateSelector$2(f, semantic.prefixRange),
        selectionEndPath: updateSelector(f, semantic.selectionEndPath)
    };
}
function selectorGet$2(param) {
    return $$Array.append(selectorGet$1(param.prefixRange), [
        param.selectionEndPath._0
    ]);
}
function determineRangeEnd(prefixNode, prefixEndAtPathWithPrefixFragment, selectionEndPath) {
    var selectorWherePrefixEnds = selectorGet(prefixEndAtPathWithPrefixFragment);
    var selectorWhereSelectionEnds = selectionEndPath._0;
    var selectorCommonAncestor = Selector$SmartcutsMacros.getCommonAncestor(selectorWherePrefixEnds, selectorWhereSelectionEnds);
    var arg = Belt_List.drop(selectorWhereSelectionEnds, List.length(selectorCommonAncestor));
    var subSelectorToSelectionEnd = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(/* [] */ 0);
    var numLevelsAbovePrefixThatCommonAncestorResides = List.length(selectorWherePrefixEnds) - List.length(selectorCommonAncestor) | 0;
    var _node = prefixNode;
    var _levelsAboveRemaining = numLevelsAbovePrefixThatCommonAncestorResides;
    while(true){
        var levelsAboveRemaining = _levelsAboveRemaining;
        var node = _node;
        if (levelsAboveRemaining !== 0) {
            if (levelsAboveRemaining !== 1) {
                var arg$1 = node.parentNode;
                var arg$21 = arg$1 == null ? undefined : Caml_option.some(arg$1);
                _levelsAboveRemaining = levelsAboveRemaining - 1 | 0;
                _node = (function(arg$2) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                    };
                })(arg$21)("Expected node to have parent node");
                continue;
            }
            var match = Webapi__Dom__Node.nodeType(node);
            var parentNode;
            if (match >= 3) {
                parentNode = Util$SmartcutsMacros.logAndRaiseJsError("Unexpected node type");
            } else {
                switch(match){
                    case /* Element */ 0:
                        var arg$3 = node.parentNode;
                        var arg$41 = arg$3 == null ? undefined : Caml_option.some(arg$3);
                        parentNode = (function(arg$4) {
                            return function(param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
                            };
                        })(arg$41)("Expected node to have parent node");
                        break;
                    case /* Attribute */ 1:
                        parentNode = Util$SmartcutsMacros.logAndRaiseJsError("Unexpected node type");
                        break;
                    case /* Text */ 2:
                        var arg$5 = node.parentNode;
                        var arg$61 = arg$5 == null ? undefined : Caml_option.some(arg$5);
                        var arg$7 = (function(arg$6) {
                            return function(param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg$6);
                            };
                        })(arg$61)("Expected node to have parent node").parentNode;
                        var arg$81 = arg$7 == null ? undefined : Caml_option.some(arg$7);
                        parentNode = (function(arg$8) {
                            return function(param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg$8);
                            };
                        })(arg$81)("Expected node to have parent node");
                        break;
                }
            }
            var arg$91 = {
                TAG: /* Element */ 0,
                _0: parentNode,
                _1: List.length(selectorCommonAncestor)
            };
            var arg$10 = function(arg$9) {
                return function arg$10(param, param$1) {
                    return Curry._6(DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch, param, param$1, arg$9, false, undefined, undefined);
                };
            }(arg$91);
            return Curry._2(arg$10(undefined, undefined), undefined, subSelectorToSelectionEnd).then(function(result) {
                return Promise.resolve(Belt_Result.map(result, function(domElement) {
                    var endOffset = domElement.childNodes.length;
                    return [
                        domElement,
                        endOffset
                    ];
                }));
            });
        }
        var arg$111 = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
        var text = (function(arg$11) {
            return function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
            };
        })(arg$111)("");
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: [
                node,
                text.length
            ]
        });
    }
    ;
}
function toDomRange$1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, param) {
    var selectionEndPath = param.selectionEndPath;
    var prefixRange = param.prefixRange;
    var domRange = document.createRange();
    var prefixEndAtPathWithPrefixFragment;
    prefixEndAtPathWithPrefixFragment = prefixRange.TAG === /* InSingleNode */ 0 ? prefixRange._0 : prefixRange._0.end_;
    return discoverRangeStart(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, prefixEndAtPathWithPrefixFragment).then(function(result1) {
        if (result1.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result1._0
            });
        }
        var match1 = result1._0;
        var node = match1[0];
        domRange.setStart(node, match1[1]);
        return determineRangeEnd(node, prefixEndAtPathWithPrefixFragment, selectionEndPath).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var match = result._0;
            domRange.setEnd(match[0], match[1]);
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: domRange
            });
        });
    });
}
var AfterPrefixAcrossNodes = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$1,
    updateSelector: updateSelector$3,
    selectorGet: selectorGet$2,
    determineRangeEnd: determineRangeEnd,
    toDomRange: toDomRange$1
};
function t_encode$4(v) {
    switch(v.TAG | 0){
        case /* SelectAll */ 0:
            return [
                "SelectAll",
                t_encode(v._0),
                t_encode(v._1)
            ];
        case /* SelectAllExceptSurroundingWhitespace */ 1:
            return [
                "SelectAllExceptSurroundingWhitespace",
                t_encode(v._0),
                t_encode(v._1)
            ];
        case /* BetweenIndexes */ 2:
            var v1 = v._1;
            var v0 = v._0;
            return [
                "BetweenIndexes",
                [
                    t_encode(v0[0]),
                    Decco.intToJson(v0[1])
                ],
                [
                    t_encode(v1[0]),
                    Decco.intToJson(v1[1])
                ]
            ];
        case /* BetweenNthWords */ 3:
            var v1$1 = v._1;
            var v0$1 = v._0;
            return [
                "BetweenNthWords",
                [
                    t_encode(v0$1[0]),
                    Decco.intToJson(v0$1[1])
                ],
                [
                    t_encode(v1$1[0]),
                    Decco.intToJson(v1$1[1])
                ]
            ];
        case /* BetweenTexts */ 4:
            var v1$2 = v._1;
            var v0$2 = v._0;
            return [
                "BetweenTexts",
                [
                    t_encode(v0$2[0]),
                    Decco.stringToJson(v0$2[1])
                ],
                [
                    t_encode(v1$2[0]),
                    Decco.stringToJson(v1$2[1])
                ]
            ];
        case /* NthWord */ 5:
            return [
                "NthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
            ];
        case /* AfterIndex */ 6:
            return [
                "AfterIndex",
                t_encode(v._0),
                Decco.intToJson(v._1)
            ];
        case /* AfterNthWord */ 7:
            return [
                "AfterNthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
            ];
        case /* AfterPrefix */ 8:
            return [
                "AfterPrefix",
                t_encode(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* AfterPrefixAcrossNodes */ 9:
            return [
                "AfterPrefixAcrossNodes",
                t_encode$3(v._0)
            ];
        case /* BeforeIndex */ 10:
            return [
                "BeforeIndex",
                t_encode(v._0),
                Decco.intToJson(v._1)
            ];
        case /* BeforeNthWord */ 11:
            return [
                "BeforeNthWord",
                t_encode(v._0),
                Decco.intToJson(v._1)
            ];
        case /* BeforeSuffix */ 12:
            return [
                "BeforeSuffix",
                t_encode(v._0),
                Decco.stringToJson(v._1)
            ];
        case /* BeforeAnySuffix */ 13:
            return [
                "BeforeAnySuffix",
                t_encode(v._0),
                Decco.arrayToJson(Decco.stringToJson, v._1)
            ];
    }
}
function t_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AfterIndex":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* AfterIndex */ 6,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "AfterNthWord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* AfterNthWord */ 7,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "AfterPrefix":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$5 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$5.TAG === /* Ok */ 0) {
                    if (match$6.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* AfterPrefix */ 8,
                                _0: match$5._0,
                                _1: match$6._0
                            }
                        };
                    }
                    var e$4 = match$6._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "AfterPrefixAcrossNodes":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AfterPrefixAcrossNodes */ 9,
                            _0: v0._0
                        }
                    };
                }
                var e$6 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "BeforeAnySuffix":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BeforeAnySuffix */ 13,
                                _0: match$7._0,
                                _1: match$8._0
                            }
                        };
                    }
                    var e$7 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "BeforeIndex":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$9 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$10 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$9.TAG === /* Ok */ 0) {
                    if (match$10.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BeforeIndex */ 10,
                                _0: match$9._0,
                                _1: match$10._0
                            }
                        };
                    }
                    var e$9 = match$10._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$9.path,
                            message: e$9.message,
                            value: e$9.value
                        }
                    };
                }
                var e$10 = match$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "BeforeNthWord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$11 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$12 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$11.TAG === /* Ok */ 0) {
                    if (match$12.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BeforeNthWord */ 11,
                                _0: match$11._0,
                                _1: match$12._0
                            }
                        };
                    }
                    var e$11 = match$12._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$11.path,
                            message: e$11.message,
                            value: e$11.value
                        }
                    };
                }
                var e$12 = match$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "BeforeSuffix":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$13 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$14 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$13.TAG === /* Ok */ 0) {
                    if (match$14.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BeforeSuffix */ 12,
                                _0: match$13._0,
                                _1: match$14._0
                            }
                        };
                    }
                    var e$13 = match$14._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$13.path,
                            message: e$13.message,
                            value: e$13.value
                        }
                    };
                }
                var e$14 = match$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                    }
                };
            case "BetweenIndexes":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var json = Belt_Array.getExn(jsonArr$1, 1);
                var match$15 = Js_json.classify(json);
                var match$16;
                if (typeof match$15 === "number" || match$15.TAG !== /* JSONArray */ 3) {
                    match$16 = Decco.error(undefined, "Not a tuple", json);
                } else {
                    var match$17 = match$15._0;
                    if (match$17.length !== 2) {
                        match$16 = Decco.error(undefined, "Incorrect cardinality", json);
                    } else {
                        var v0$1 = match$17[0];
                        var v1 = match$17[1];
                        var match$18 = t_decode(v0$1);
                        var match$19 = Decco.intFromJson(v1);
                        if (match$18.TAG === /* Ok */ 0) {
                            if (match$19.TAG === /* Ok */ 0) {
                                match$16 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$18._0,
                                        match$19._0
                                    ]
                                };
                            } else {
                                var e$15 = match$19._0;
                                match$16 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$15.path,
                                        message: e$15.message,
                                        value: e$15.value
                                    }
                                };
                            }
                        } else {
                            var e$16 = match$18._0;
                            match$16 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$16.path,
                                    message: e$16.message,
                                    value: e$16.value
                                }
                            };
                        }
                    }
                }
                var json$1 = Belt_Array.getExn(jsonArr$1, 2);
                var match$20 = Js_json.classify(json$1);
                var match$21;
                if (typeof match$20 === "number" || match$20.TAG !== /* JSONArray */ 3) {
                    match$21 = Decco.error(undefined, "Not a tuple", json$1);
                } else {
                    var match$22 = match$20._0;
                    if (match$22.length !== 2) {
                        match$21 = Decco.error(undefined, "Incorrect cardinality", json$1);
                    } else {
                        var v0$2 = match$22[0];
                        var v1$1 = match$22[1];
                        var match$23 = t_decode(v0$2);
                        var match$24 = Decco.intFromJson(v1$1);
                        if (match$23.TAG === /* Ok */ 0) {
                            if (match$24.TAG === /* Ok */ 0) {
                                match$21 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$23._0,
                                        match$24._0
                                    ]
                                };
                            } else {
                                var e$17 = match$24._0;
                                match$21 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$17.path,
                                        message: e$17.message,
                                        value: e$17.value
                                    }
                                };
                            }
                        } else {
                            var e$18 = match$23._0;
                            match$21 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$18.path,
                                    message: e$18.message,
                                    value: e$18.value
                                }
                            };
                        }
                    }
                }
                if (match$16.TAG === /* Ok */ 0) {
                    if (match$21.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BetweenIndexes */ 2,
                                _0: match$16._0,
                                _1: match$21._0
                            }
                        };
                    }
                    var e$19 = match$21._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$19.path,
                            message: e$19.message,
                            value: e$19.value
                        }
                    };
                }
                var e$20 = match$16._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                    }
                };
            case "BetweenNthWords":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var json$2 = Belt_Array.getExn(jsonArr$1, 1);
                var match$25 = Js_json.classify(json$2);
                var match$26;
                if (typeof match$25 === "number" || match$25.TAG !== /* JSONArray */ 3) {
                    match$26 = Decco.error(undefined, "Not a tuple", json$2);
                } else {
                    var match$27 = match$25._0;
                    if (match$27.length !== 2) {
                        match$26 = Decco.error(undefined, "Incorrect cardinality", json$2);
                    } else {
                        var v0$3 = match$27[0];
                        var v1$2 = match$27[1];
                        var match$28 = t_decode(v0$3);
                        var match$29 = Decco.intFromJson(v1$2);
                        if (match$28.TAG === /* Ok */ 0) {
                            if (match$29.TAG === /* Ok */ 0) {
                                match$26 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$28._0,
                                        match$29._0
                                    ]
                                };
                            } else {
                                var e$21 = match$29._0;
                                match$26 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$21.path,
                                        message: e$21.message,
                                        value: e$21.value
                                    }
                                };
                            }
                        } else {
                            var e$22 = match$28._0;
                            match$26 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$22.path,
                                    message: e$22.message,
                                    value: e$22.value
                                }
                            };
                        }
                    }
                }
                var json$3 = Belt_Array.getExn(jsonArr$1, 2);
                var match$30 = Js_json.classify(json$3);
                var match$31;
                if (typeof match$30 === "number" || match$30.TAG !== /* JSONArray */ 3) {
                    match$31 = Decco.error(undefined, "Not a tuple", json$3);
                } else {
                    var match$32 = match$30._0;
                    if (match$32.length !== 2) {
                        match$31 = Decco.error(undefined, "Incorrect cardinality", json$3);
                    } else {
                        var v0$4 = match$32[0];
                        var v1$3 = match$32[1];
                        var match$33 = t_decode(v0$4);
                        var match$34 = Decco.intFromJson(v1$3);
                        if (match$33.TAG === /* Ok */ 0) {
                            if (match$34.TAG === /* Ok */ 0) {
                                match$31 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$33._0,
                                        match$34._0
                                    ]
                                };
                            } else {
                                var e$23 = match$34._0;
                                match$31 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$23.path,
                                        message: e$23.message,
                                        value: e$23.value
                                    }
                                };
                            }
                        } else {
                            var e$24 = match$33._0;
                            match$31 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$24.path,
                                    message: e$24.message,
                                    value: e$24.value
                                }
                            };
                        }
                    }
                }
                if (match$26.TAG === /* Ok */ 0) {
                    if (match$31.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BetweenNthWords */ 3,
                                _0: match$26._0,
                                _1: match$31._0
                            }
                        };
                    }
                    var e$25 = match$31._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$25.path,
                            message: e$25.message,
                            value: e$25.value
                        }
                    };
                }
                var e$26 = match$26._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$26.path,
                        message: e$26.message,
                        value: e$26.value
                    }
                };
            case "BetweenTexts":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var json$4 = Belt_Array.getExn(jsonArr$1, 1);
                var match$35 = Js_json.classify(json$4);
                var match$36;
                if (typeof match$35 === "number" || match$35.TAG !== /* JSONArray */ 3) {
                    match$36 = Decco.error(undefined, "Not a tuple", json$4);
                } else {
                    var match$37 = match$35._0;
                    if (match$37.length !== 2) {
                        match$36 = Decco.error(undefined, "Incorrect cardinality", json$4);
                    } else {
                        var v0$5 = match$37[0];
                        var v1$4 = match$37[1];
                        var match$38 = t_decode(v0$5);
                        var match$39 = Decco.stringFromJson(v1$4);
                        if (match$38.TAG === /* Ok */ 0) {
                            if (match$39.TAG === /* Ok */ 0) {
                                match$36 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$38._0,
                                        match$39._0
                                    ]
                                };
                            } else {
                                var e$27 = match$39._0;
                                match$36 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$27.path,
                                        message: e$27.message,
                                        value: e$27.value
                                    }
                                };
                            }
                        } else {
                            var e$28 = match$38._0;
                            match$36 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$28.path,
                                    message: e$28.message,
                                    value: e$28.value
                                }
                            };
                        }
                    }
                }
                var json$5 = Belt_Array.getExn(jsonArr$1, 2);
                var match$40 = Js_json.classify(json$5);
                var match$41;
                if (typeof match$40 === "number" || match$40.TAG !== /* JSONArray */ 3) {
                    match$41 = Decco.error(undefined, "Not a tuple", json$5);
                } else {
                    var match$42 = match$40._0;
                    if (match$42.length !== 2) {
                        match$41 = Decco.error(undefined, "Incorrect cardinality", json$5);
                    } else {
                        var v0$6 = match$42[0];
                        var v1$5 = match$42[1];
                        var match$43 = t_decode(v0$6);
                        var match$44 = Decco.stringFromJson(v1$5);
                        if (match$43.TAG === /* Ok */ 0) {
                            if (match$44.TAG === /* Ok */ 0) {
                                match$41 = {
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match$43._0,
                                        match$44._0
                                    ]
                                };
                            } else {
                                var e$29 = match$44._0;
                                match$41 = {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: "[1]" + e$29.path,
                                        message: e$29.message,
                                        value: e$29.value
                                    }
                                };
                            }
                        } else {
                            var e$30 = match$43._0;
                            match$41 = {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: "[0]" + e$30.path,
                                    message: e$30.message,
                                    value: e$30.value
                                }
                            };
                        }
                    }
                }
                if (match$36.TAG === /* Ok */ 0) {
                    if (match$41.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BetweenTexts */ 4,
                                _0: match$36._0,
                                _1: match$41._0
                            }
                        };
                    }
                    var e$31 = match$41._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$31.path,
                            message: e$31.message,
                            value: e$31.value
                        }
                    };
                }
                var e$32 = match$36._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$32.path,
                        message: e$32.message,
                        value: e$32.value
                    }
                };
            case "NthWord":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$45 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$46 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$45.TAG === /* Ok */ 0) {
                    if (match$46.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* NthWord */ 5,
                                _0: match$45._0,
                                _1: match$46._0
                            }
                        };
                    }
                    var e$33 = match$46._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$33.path,
                            message: e$33.message,
                            value: e$33.value
                        }
                    };
                }
                var e$34 = match$45._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$34.path,
                        message: e$34.message,
                        value: e$34.value
                    }
                };
            case "SelectAll":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$47 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$48 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$47.TAG === /* Ok */ 0) {
                    if (match$48.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectAll */ 0,
                                _0: match$47._0,
                                _1: match$48._0
                            }
                        };
                    }
                    var e$35 = match$48._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$35.path,
                            message: e$35.message,
                            value: e$35.value
                        }
                    };
                }
                var e$36 = match$47._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$36.path,
                        message: e$36.message,
                        value: e$36.value
                    }
                };
            case "SelectAllExceptSurroundingWhitespace":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$49 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$50 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$49.TAG === /* Ok */ 0) {
                    if (match$50.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                                _0: match$49._0,
                                _1: match$50._0
                            }
                        };
                    }
                    var e$37 = match$50._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$37.path,
                            message: e$37.message,
                            value: e$37.value
                        }
                    };
                }
                var e$38 = match$49._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$38.path,
                        message: e$38.message,
                        value: e$38.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectorGet$3(semantic) {
    var exit = 0;
    switch(semantic.TAG | 0){
        case /* SelectAll */ 0:
        case /* SelectAllExceptSurroundingWhitespace */ 1:
            exit = 1;
            break;
        case /* BetweenIndexes */ 2:
        case /* BetweenNthWords */ 3:
        case /* BetweenTexts */ 4:
            exit = 2;
            break;
        case /* AfterPrefixAcrossNodes */ 9:
            return selectorGet$2(semantic._0);
        default:
            return [
                semantic._0._0
            ];
    }
    switch(exit){
        case 1:
            return [
                semantic._0._0,
                semantic._1._0
            ];
        case 2:
            return [
                semantic._0[0]._0,
                semantic._1[0]._0
            ];
    }
}
function updateSelector$4(f, semantic) {
    switch(semantic.TAG | 0){
        case /* SelectAll */ 0:
            return {
                TAG: /* SelectAll */ 0,
                _0: updateSelector(f, semantic._0),
                _1: updateSelector(f, semantic._1)
            };
        case /* SelectAllExceptSurroundingWhitespace */ 1:
            return {
                TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                _0: updateSelector(f, semantic._0),
                _1: updateSelector(f, semantic._1)
            };
        case /* BetweenIndexes */ 2:
            var match = semantic._1;
            var match$1 = semantic._0;
            return {
                TAG: /* BetweenIndexes */ 2,
                _0: [
                    updateSelector(f, match$1[0]),
                    match$1[1]
                ],
                _1: [
                    updateSelector(f, match[0]),
                    match[1]
                ]
            };
        case /* BetweenNthWords */ 3:
            var match$2 = semantic._1;
            var match$3 = semantic._0;
            return {
                TAG: /* BetweenNthWords */ 3,
                _0: [
                    updateSelector(f, match$3[0]),
                    match$3[1]
                ],
                _1: [
                    updateSelector(f, match$2[0]),
                    match$2[1]
                ]
            };
        case /* BetweenTexts */ 4:
            var match$4 = semantic._1;
            var match$5 = semantic._0;
            return {
                TAG: /* BetweenTexts */ 4,
                _0: [
                    updateSelector(f, match$5[0]),
                    match$5[1]
                ],
                _1: [
                    updateSelector(f, match$4[0]),
                    match$4[1]
                ]
            };
        case /* NthWord */ 5:
            return {
                TAG: /* NthWord */ 5,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* AfterIndex */ 6:
            return {
                TAG: /* AfterIndex */ 6,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* AfterNthWord */ 7:
            return {
                TAG: /* AfterNthWord */ 7,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* AfterPrefix */ 8:
            return {
                TAG: /* AfterPrefix */ 8,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* AfterPrefixAcrossNodes */ 9:
            return {
                TAG: /* AfterPrefixAcrossNodes */ 9,
                _0: updateSelector$3(f, semantic._0)
            };
        case /* BeforeIndex */ 10:
            return {
                TAG: /* BeforeIndex */ 10,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* BeforeNthWord */ 11:
            return {
                TAG: /* BeforeNthWord */ 11,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* BeforeSuffix */ 12:
            return {
                TAG: /* BeforeSuffix */ 12,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
        case /* BeforeAnySuffix */ 13:
            return {
                TAG: /* BeforeAnySuffix */ 13,
                _0: updateSelector(f, semantic._0),
                _1: semantic._1
            };
    }
}
function stringify$2(semantic) {
    switch(semantic.TAG | 0){
        case /* SelectAll */ 0:
        case /* SelectAllExceptSurroundingWhitespace */ 1:
            return "All content in the given section of the page";
        case /* BetweenIndexes */ 2:
            return "Between position " + semantic._0[1] + " and " + semantic._1[1];
        case /* BetweenNthWords */ 3:
            var nth$p = semantic._1[1];
            var nth = semantic._0[1];
            return "Between " + nth + (Ord(nth) + (" and " + nth$p + (Ord(nth$p) + " words")));
        case /* BetweenTexts */ 4:
            return 'Between "' + semantic._0[1] + '" and "' + semantic._1[1] + '"';
        case /* NthWord */ 5:
            var nth$1 = semantic._1;
            return "The " + nth$1 + (Ord(nth$1) + " word");
        case /* AfterIndex */ 6:
            var nth$2 = semantic._1 + 1 | 0;
            return "After the " + nth$2 + (Ord(nth$2) + " character");
        case /* AfterNthWord */ 7:
            var nth$3 = semantic._1;
            return "After " + nth$3 + (Ord(nth$3) + " word");
        case /* AfterPrefix */ 8:
            return 'After "' + semantic._1 + '"';
        case /* AfterPrefixAcrossNodes */ 9:
            return stringify$1(semantic._0);
        case /* BeforeIndex */ 10:
            var nth$4 = semantic._1 + 1 | 0;
            return "Before the " + (StringUtils$SmartcutsMacros.withOrd(nth$4) + " character");
        case /* BeforeNthWord */ 11:
            var nth$5 = semantic._1 + 1 | 0;
            return "Before the " + (StringUtils$SmartcutsMacros.withOrd(nth$5) + " word");
        case /* BeforeSuffix */ 12:
            return 'Before "' + semantic._1 + '"';
        case /* BeforeAnySuffix */ 13:
            return "Before any of the following words: " + semantic._1.join(", ");
    }
}
function toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    var domRange = document.createRange();
    switch(semantic.TAG | 0){
        case /* SelectAll */ 0:
            var endPath = semantic._1;
            var startPath = semantic._0;
            return Promise.all([
                findDomNode(startPath, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                findDomNode(endPath, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
            ]).then(function(param4) {
                var result_endNodeResult = param4[1];
                var result_startNodeResult = param4[0];
                if (result_startNodeResult.TAG === /* Ok */ 0) {
                    var _node = result_startNodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* NonInputSelectionSemanticError */ 0,
                                _0: {
                                    TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                    _0: startPath._0
                                }
                            }
                        });
                    }
                    if (result_endNodeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_endNodeResult._0
                        });
                    }
                    var endNode = result_endNodeResult._0;
                    if (endNode.TAG === /* FoundExpectedNode */ 0) {
                        var endNode$1 = endNode._0;
                        domRange.setStart(_node._0, 0);
                        var maybeText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var arg = OptionUtils$SmartcutsMacros.map(maybeText, function(prim) {
                            return prim.length;
                        });
                        domRange.setEnd(endNode$1, function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }(0));
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: domRange
                        });
                    }
                }
                if (result_endNodeResult.TAG === /* Ok */ 0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: endPath._0
                            }
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_startNodeResult._0
                    });
                }
            });
        case /* SelectAllExceptSurroundingWhitespace */ 1:
            var endPath$1 = semantic._1;
            var startPath$1 = semantic._0;
            return Promise.all([
                findDomNode(startPath$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                findDomNode(endPath$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
            ]).then(function(param5) {
                var result_endNodeResult = param5[1];
                var result_startNodeResult = param5[0];
                if (result_startNodeResult.TAG === /* Ok */ 0) {
                    var _node = result_startNodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* NonInputSelectionSemanticError */ 0,
                                _0: {
                                    TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                    _0: startPath$1._0
                                }
                            }
                        });
                    }
                    var startNode = _node._0;
                    if (result_endNodeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_endNodeResult._0
                        });
                    }
                    var endNode = result_endNodeResult._0;
                    if (endNode.TAG === /* FoundExpectedNode */ 0) {
                        var endNode$1 = endNode._0;
                        var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode);
                        var startText = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }("");
                        var arg$1 = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var endText = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                        }("");
                        var indexOfFirstNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(startText);
                        domRange.setStart(startNode, indexOfFirstNonWhitespaceChar === -1 ? 0 : indexOfFirstNonWhitespaceChar);
                        var indexOfLastNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(endText);
                        domRange.setEnd(endNode$1, indexOfLastNonWhitespaceChar === -1 ? endText.length : indexOfLastNonWhitespaceChar + 1 | 0);
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: domRange
                        });
                    }
                }
                if (result_endNodeResult.TAG === /* Ok */ 0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: endPath$1._0
                            }
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_startNodeResult._0
                    });
                }
            });
        case /* BetweenIndexes */ 2:
            var match2 = semantic._1;
            var endOffset = match2[1];
            var endPath$2 = match2[0];
            var match$110 = semantic._0;
            var startOffset = match$110[1];
            var startPath$2 = match$110[0];
            return Promise.all([
                findDomNode(startPath$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                findDomNode(endPath$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
            ]).then(function(param) {
                var result_endNodeResult = param[1];
                var result_startNodeResult = param[0];
                if (result_startNodeResult.TAG === /* Ok */ 0) {
                    var _node = result_startNodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* NonInputSelectionSemanticError */ 0,
                                _0: {
                                    TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                    _0: startPath$2._0
                                }
                            }
                        });
                    }
                    if (result_endNodeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_endNodeResult._0
                        });
                    }
                    var endNode = result_endNodeResult._0;
                    if (endNode.TAG === /* FoundExpectedNode */ 0) {
                        domRange.setStart(_node._0, startOffset);
                        domRange.setEnd(endNode._0, endOffset);
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: domRange
                        });
                    }
                }
                if (result_endNodeResult.TAG === /* Ok */ 0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: endPath$2._0
                            }
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_startNodeResult._0
                    });
                }
            });
        case /* BetweenNthWords */ 3:
            var match$2 = semantic._1;
            var endsAtNth = match$2[1];
            var endPath$3 = match$2[0];
            var match$3 = semantic._0;
            var startsAtNth = match$3[1];
            var startPath$3 = match$3[0];
            return Promise.all([
                findDomNode(startPath$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                findDomNode(endPath$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
            ]).then(function(param6) {
                var result_endNodeResult = param6[1];
                var result_startNodeResult = param6[0];
                if (result_startNodeResult.TAG === /* Ok */ 0) {
                    var _node = result_startNodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* NonInputSelectionSemanticError */ 0,
                                _0: {
                                    TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                    _0: startPath$3._0
                                }
                            }
                        });
                    }
                    var startNode = _node._0;
                    if (result_endNodeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_endNodeResult._0
                        });
                    }
                    var endNode = result_endNodeResult._0;
                    if (endNode.TAG === /* FoundExpectedNode */ 0) {
                        var endNode$1 = endNode._0;
                        var arg = OptionUtils$SmartcutsMacros.map(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode), SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText);
                        var startWords = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }([]);
                        var match = Caml_array.get(startWords, startsAtNth);
                        var startWordEnds = match[0] + match[1].length | 0;
                        var endWords;
                        if (Caml_obj.caml_equal(startNode, endNode$1)) {
                            endWords = startWords;
                        } else {
                            var arg$1 = OptionUtils$SmartcutsMacros.map(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1), SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText);
                            endWords = function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            }([]);
                        }
                        var match$1 = Caml_array.get(endWords, endsAtNth);
                        domRange.setStart(startNode, startWordEnds);
                        domRange.setEnd(endNode$1, match$1[0]);
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: domRange
                        });
                    }
                }
                if (result_endNodeResult.TAG === /* Ok */ 0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: endPath$3._0
                            }
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_startNodeResult._0
                    });
                }
            });
        case /* BetweenTexts */ 4:
            var match$4 = semantic._1;
            var suffix1 = match$4[1];
            var endPath$4 = match$4[0];
            var match$5 = semantic._0;
            var prefix = match$5[1];
            var startPath$4 = match$5[0];
            return Promise.all([
                findDomNode(startPath$4, deepEquals(startPath$4, endPath$4) ? {
                    TAG: /* ContainsInnerTextAllStrings */ 4,
                    _0: prefix,
                    _1: suffix1,
                    _2: []
                } : {
                    TAG: /* ContainsInnerText */ 2,
                    _0: {
                        TAG: /* StaticText */ 0,
                        _0: prefix
                    }
                }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand),
                findDomNode(endPath$4, deepEquals(startPath$4, endPath$4) ? {
                    TAG: /* ContainsInnerTextAllStrings */ 4,
                    _0: prefix,
                    _1: suffix1,
                    _2: []
                } : {
                    TAG: /* ContainsInnerText */ 2,
                    _0: {
                        TAG: /* StaticText */ 0,
                        _0: suffix1
                    }
                }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand)
            ]).then(function(param7) {
                var result_endNodeResult = param7[1];
                var result_startNodeResult = param7[0];
                if (result_startNodeResult.TAG === /* Ok */ 0) {
                    var _node = result_startNodeResult._0;
                    if (_node.TAG !== /* FoundExpectedNode */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* NonInputSelectionSemanticError */ 0,
                                _0: {
                                    TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                    _0: startPath$4._0
                                }
                            }
                        });
                    }
                    var startNode = _node._0;
                    if (result_endNodeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_endNodeResult._0
                        });
                    }
                    var endNode = result_endNodeResult._0;
                    if (endNode.TAG === /* FoundExpectedNode */ 0) {
                        var endNode$1 = endNode._0;
                        var startText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(startNode);
                        var arg = OptionUtils$SmartcutsMacros.map(startText, function(param) {
                            return param.indexOf(prefix);
                        });
                        var prefixStarts = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }(0);
                        if (prefixStarts === -1) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* NonInputSelectionSemanticError */ 0,
                                    _0: {
                                        TAG: /* PrefixNotFound */ 2,
                                        _0: prefix,
                                        _1: OptionUtils$SmartcutsMacros.withDefault("", startText)
                                    }
                                }
                            });
                        }
                        var prefixEnds = prefixStarts + prefix.length | 0;
                        var endText = Caml_obj.caml_equal(startNode, endNode$1) ? startText : SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(endNode$1);
                        var suffixStarts;
                        if (Caml_obj.caml_equal(startNode, endNode$1)) {
                            var arg$1 = OptionUtils$SmartcutsMacros.map(endText, function(param) {
                                return param.indexOf(suffix1, prefixEnds);
                            });
                            suffixStarts = function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            }(0);
                        } else {
                            var arg$2 = OptionUtils$SmartcutsMacros.map(endText, function(param) {
                                return param.indexOf(suffix1);
                            });
                            suffixStarts = function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                            }(0);
                        }
                        if (suffixStarts === -1) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: {
                                    TAG: /* NonInputSelectionSemanticError */ 0,
                                    _0: {
                                        TAG: /* SuffixNotFound */ 0,
                                        _0: suffix1,
                                        _1: OptionUtils$SmartcutsMacros.withDefault("", endText)
                                    }
                                }
                            });
                        } else {
                            domRange.setStart(startNode, prefixEnds);
                            domRange.setEnd(endNode$1, suffixStarts);
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: domRange
                            });
                        }
                    }
                }
                if (result_endNodeResult.TAG === /* Ok */ 0 && result_endNodeResult._0.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: endPath$4._0
                            }
                        }
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_startNodeResult._0
                    });
                }
            });
        case /* NthWord */ 5:
            var nth = semantic._1;
            var path = semantic._0;
            return findDomNode(path, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var text = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("");
                var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                var match = Caml_array.get(words, nth - 1 | 0);
                var wordStartsIndex = match[0];
                var wordEndsIndex = wordStartsIndex + match[1].length | 0;
                domRange.setStart(node, wordStartsIndex);
                domRange.setEnd(node, wordEndsIndex);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: domRange
                });
            });
        case /* AfterIndex */ 6:
            var index = semantic._1;
            var path$1 = semantic._0;
            return findDomNode(path$1, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$1._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var text = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("");
                domRange.setStart(node, index + 1 | 0);
                domRange.setEnd(node, text.length);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: domRange
                });
            });
        case /* AfterNthWord */ 7:
            var nth$1 = semantic._1;
            var path$2 = semantic._0;
            return findDomNode(path$2, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$2._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var text = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("");
                var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                var match = Caml_array.get(words, nth$1);
                var wordEnds = match[0] + match[1].length | 0;
                domRange.setStart(node, wordEnds);
                domRange.setEnd(node, text.length);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: domRange
                });
            });
        case /* AfterPrefix */ 8:
            return toDomRange(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, [
                semantic._0,
                semantic._1
            ]);
        case /* AfterPrefixAcrossNodes */ 9:
            return toDomRange$1(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0);
        case /* BeforeIndex */ 10:
            var index$1 = semantic._1;
            var path$3 = semantic._0;
            return findDomNode(path$3, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$3._0
                            }
                        }
                    });
                }
                var node = _node._0;
                domRange.setStart(node, 0);
                domRange.setEnd(node, index$1);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: domRange
                });
            });
        case /* BeforeNthWord */ 11:
            var nth$2 = semantic._1;
            var path$4 = semantic._0;
            return findDomNode(path$4, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$4._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var arg = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var text = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("");
                var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, text);
                var match = Caml_array.get(words, nth$2);
                domRange.setStart(node, 0);
                domRange.setEnd(node, match[0]);
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: domRange
                });
            });
        case /* BeforeSuffix */ 12:
            var suffix$1 = semantic._1;
            var path$5 = semantic._0;
            return findDomNode(path$5, {
                TAG: /* ContainsInnerText */ 2,
                _0: {
                    TAG: /* StaticText */ 0,
                    _0: suffix$1
                }
            }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$5._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var text = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var arg = OptionUtils$SmartcutsMacros.map(text, function(param) {
                    return param.indexOf(suffix$1);
                });
                var suffixStarts = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }(-1);
                if (suffixStarts === -1) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* SuffixNotFound */ 0,
                                _0: suffix$1,
                                _1: OptionUtils$SmartcutsMacros.withDefault("", text)
                            }
                        }
                    });
                } else {
                    domRange.setStart(node, 0);
                    domRange.setEnd(node, suffixStarts);
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: domRange
                    });
                }
            });
        case /* BeforeAnySuffix */ 13:
            var suffixChoices = semantic._1;
            var path$6 = semantic._0;
            return findDomNode(path$6, {
                TAG: /* ContainsInnerTextEnum */ 3,
                _0: Caml_array.get(suffixChoices, 0),
                _1: Caml_array.get(suffixChoices, 1),
                _2: Belt_Array.sliceToEnd(suffixChoices, 2)
            }, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand).then(function(result_nodeResult) {
                if (result_nodeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_nodeResult._0
                    });
                }
                var _node = result_nodeResult._0;
                if (_node.TAG !== /* FoundExpectedNode */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* ExpectedTextNodeButGotAnotherNodeType */ 5,
                                _0: path$6._0
                            }
                        }
                    });
                }
                var node = _node._0;
                var maybeText = SelectionSemantics__Shared$SmartcutsMacros.$$Text.ofNode(node);
                var maybeFoundSuffixWithStringIndex1 = maybeText !== undefined ? Belt_Array.reduce(suffixChoices, undefined, function(maybeFoundSuffixWithStringIndex, suffix) {
                    if (maybeFoundSuffixWithStringIndex !== undefined) {
                        return maybeFoundSuffixWithStringIndex;
                    }
                    var indexOfSuffix = suffix.indexOf(maybeText);
                    if (indexOfSuffix === -1) {
                        return;
                    } else {
                        return [
                            suffix,
                            indexOfSuffix
                        ];
                    }
                }) : undefined;
                if (maybeFoundSuffixWithStringIndex1 !== undefined) {
                    domRange.setStart(node, 0);
                    domRange.setEnd(node, maybeFoundSuffixWithStringIndex1[1]);
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: domRange
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            TAG: /* NonInputSelectionSemanticError */ 0,
                            _0: {
                                TAG: /* NoneOfSuffixesFound */ 1,
                                _0: suffixChoices,
                                _1: OptionUtils$SmartcutsMacros.withDefault("", maybeText)
                            }
                        }
                    });
                }
            });
    }
}
function getText(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic).then(function(domRangeResult) {
        if (domRangeResult.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: domRangeResult._0
            });
        }
        var domRange = domRangeResult._0;
        var maybeSelection = window.getSelection();
        var maybeSelection$1 = maybeSelection == null ? undefined : Caml_option.some(maybeSelection);
        if (!(maybeSelection == null)) {
            if (maybeSelection.rangeCount > 0) {
                maybeSelection.removeAllRanges();
            }
            maybeSelection.addRange(domRange);
        }
        var commonAncestorContainer = domRange.commonAncestorContainer;
        var match = Webapi__Dom__Node.nodeType(commonAncestorContainer);
        var text;
        var exit = 0;
        if (match >= 3) {
            exit = 1;
        } else {
            switch(match){
                case /* Element */ 0:
                    var element = Webapi__Dom__Element.ofNode(commonAncestorContainer);
                    if (element !== undefined) {
                        var element$1 = Caml_option.valFromOption(element);
                        var oldStyle = element$1.style;
                        element$1.style = "user-select: text; " + oldStyle;
                        var arg = Belt_Option.map(maybeSelection$1, function(prim) {
                            return prim.toString();
                        });
                        var text$1 = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        }("");
                        element$1.style = oldStyle;
                        text = text$1;
                    } else {
                        var arg$1 = Belt_Option.map(maybeSelection$1, function(prim) {
                            return prim.toString();
                        });
                        text = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                        }("");
                    }
                    break;
                case /* Attribute */ 1:
                    exit = 1;
                    break;
                case /* Text */ 2:
                    var parentElement = commonAncestorContainer.parentElement;
                    if (parentElement == null) {
                        var arg$2 = Belt_Option.map(maybeSelection$1, function(prim) {
                            return prim.toString();
                        });
                        text = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                        }("");
                    } else {
                        var oldStyle$1 = parentElement.style;
                        parentElement.style = "user-select: text; " + oldStyle$1;
                        var arg$3 = Belt_Option.map(maybeSelection$1, function(prim) {
                            return prim.toString();
                        });
                        var text$2 = function(param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
                        }("");
                        parentElement.style = oldStyle$1;
                        text = text$2;
                    }
                    break;
            }
        }
        if (exit === 1) {
            var arg$4 = Belt_Option.map(maybeSelection$1, function(prim) {
                return prim.toString();
            });
            text = function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$4);
            }("");
        }
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: text
        });
    });
}
function applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    return toDomRange$2(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic).then(function(domRangeResult) {
        if (domRangeResult.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: domRangeResult._0
            });
        }
        var maybeSelection = window.getSelection();
        if (!(maybeSelection == null)) {
            if (maybeSelection.rangeCount > 0) {
                maybeSelection.removeAllRanges();
            }
            maybeSelection.addRange(domRangeResult._0);
        }
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    });
}
var Semantic = {
    PathStringPair: PathStringPair,
    StringRange: StringRange,
    Prefix__Shared: Prefix__Shared,
    AfterPrefix: AfterPrefix,
    AfterPrefixAcrossNodes: AfterPrefixAcrossNodes,
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    selectorGet: selectorGet$3,
    updateSelector: updateSelector$4,
    stringify: stringify$2,
    toDomRange: toDomRange$2,
    getText: getText,
    applyToDom: applyToDom
};
function t_encode$5(v) {
    return Decco.arrayToJson(t_encode$4, v);
}
function t_decode$5(v) {
    return Decco.arrayFromJson(t_decode$4, v);
}
function stringify$3(semantics) {
    return "[" + ($$Array.map(stringify$2, semantics).join(", ") + "]");
}
function isToken(str) {
    return !/\s/g.test(str.trim());
}
function maybeAddNthWordSemanticToSemantics(highlightedText, words, startPath, semantics) {
    if (!isToken(highlightedText)) {
        return semantics;
    }
    var index = Belt_Array.getIndexBy(words, function(param) {
        return param[1] === highlightedText.trim();
    });
    if (index === undefined) {
        return semantics;
    }
    var nth = index + 1 | 0;
    return $$Array.append([
        {
            TAG: /* NthWord */ 5,
            _0: startPath,
            _1: nth
        }
    ], semantics);
}
function isSelectingAllExceptSurroundingWhitespace(startText, startOffset, endText, endOffset) {
    var indexOfFirstNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(startText);
    var indexOfLastNonWhitespaceChar = SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(endText);
    if (startOffset === indexOfFirstNonWhitespaceChar) {
        return endOffset === (indexOfLastNonWhitespaceChar + 1 | 0);
    } else {
        return false;
    }
}
function getStartPathAndEndPathForCrossNodes(startOffset, endOffset, endText, crossNodes) {
    var match = crossNodes.prevAdjacentText;
    var match$1 = crossNodes.end_;
    var endTextNode = match$1.textNode;
    var selectorToEndElement = match$1.elementNode.domElementRepresentation.selector;
    var match$2 = crossNodes.start;
    var startTextNode = match$2.textNode;
    var selectorToStartElement = match$2.elementNode.domElementRepresentation.selector;
    var exit = 0;
    if (match !== undefined) {
        if (startOffset === 0) {
            var startPath_0 = match.selector;
            var startPath_1 = match.textNodeIndex;
            var startPath = {
                TAG: /* Text */ 1,
                _0: startPath_0,
                _1: startPath_1
            };
            var endPath = endTextNode !== undefined ? {
                TAG: /* Text */ 1,
                _0: selectorToEndElement,
                _1: endTextNode.siblingIndex
            } : {
                TAG: /* Element */ 0,
                _0: selectorToEndElement
            };
            return [
                startPath,
                endPath
            ];
        }
        exit = 2;
    } else {
        exit = 2;
    }
    if (exit === 2) {
        var match$3 = crossNodes.nextAdjacentText;
        if (match$3 !== undefined && endOffset === endText.length) {
            var startPath$1 = startTextNode !== undefined ? {
                TAG: /* Text */ 1,
                _0: selectorToStartElement,
                _1: startTextNode.siblingIndex
            } : {
                TAG: /* Element */ 0,
                _0: selectorToStartElement
            };
            var endPath_0 = match$3.selector;
            var endPath_1 = match$3.textNodeIndex;
            var endPath$1 = {
                TAG: /* Text */ 1,
                _0: endPath_0,
                _1: endPath_1
            };
            return [
                startPath$1,
                endPath$1
            ];
        }
    }
    var match$4;
    if (startTextNode !== undefined) {
        var startIndex = startTextNode.siblingIndex;
        if (endTextNode !== undefined) {
            var startPath$2 = {
                TAG: /* Text */ 1,
                _0: selectorToStartElement,
                _1: startIndex
            };
            var endPath_1$1 = endTextNode.siblingIndex;
            var endPath$2 = {
                TAG: /* Text */ 1,
                _0: selectorToEndElement,
                _1: endPath_1$1
            };
            match$4 = [
                startPath$2,
                endPath$2
            ];
        } else {
            var startPath$3 = {
                TAG: /* Text */ 1,
                _0: selectorToStartElement,
                _1: startIndex
            };
            var endPath$3 = {
                TAG: /* Element */ 0,
                _0: selectorToEndElement
            };
            match$4 = [
                startPath$3,
                endPath$3
            ];
        }
    } else if (endTextNode !== undefined) {
        var startPath$4 = {
            TAG: /* Element */ 0,
            _0: selectorToStartElement
        };
        var endPath_1$2 = endTextNode.siblingIndex;
        var endPath$4 = {
            TAG: /* Text */ 1,
            _0: selectorToEndElement,
            _1: endPath_1$2
        };
        match$4 = [
            startPath$4,
            endPath$4
        ];
    } else {
        var startPath$5 = {
            TAG: /* Element */ 0,
            _0: selectorToStartElement
        };
        var endPath$5 = {
            TAG: /* Element */ 0,
            _0: selectorToEndElement
        };
        match$4 = [
            startPath$5,
            endPath$5
        ];
    }
    return [
        match$4[0],
        match$4[1]
    ];
}
function ofSelection(selection) {
    var match = Selection__NonInputSelection$SmartcutsMacros.Generic.extractBoundaryPair(selection);
    var endBoundary = match[1];
    var startBoundary = match[0];
    if (selection.TAG === /* SingleNode */ 0) {
        var param8 = selection._0;
        var textNode1 = param8.textNode;
        var startPath = ofBoundary(startBoundary);
        var endPath = ofBoundary(endBoundary);
        var match$1 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(startBoundary);
        var startOffset = match$1[1];
        var startText = match$1[0];
        var match$2 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(endBoundary);
        var endOffset = match$2[1];
        var endText = match$2[0];
        var match$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(startText, startOffset, endText, endOffset);
        var suffixWord = match$3[1];
        var prefixWord = match$3[0];
        var isStartAtBeginningOfStartText = startOffset === 0;
        var isEndAtEndOfEndText = textNode1 !== undefined ? endOffset === textNode1.text.length : true;
        var indexOfFirstNonWhitespaceChar = OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(textNode1, function(textNode) {
            return SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfFirstNonWhitespaceChar(textNode.text);
        }));
        var indexOfLastNonWhitespaceChar = OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(textNode1, function(textNode) {
            return SelectionSemantics__Shared$SmartcutsMacros.$$Text.indexOfLastNonWhitespaceChar(textNode.text);
        }));
        if (isStartAtBeginningOfStartText) {
            if (isEndAtEndOfEndText) {
                return [
                    {
                        TAG: /* SelectAll */ 0,
                        _0: startPath,
                        _1: endPath
                    }
                ];
            }
            if ((indexOfLastNonWhitespaceChar + 1 | 0) === endOffset) {
                return [
                    {
                        TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                        _0: startPath,
                        _1: endPath
                    }
                ];
            }
            var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText);
            var index = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(endOffset, words);
            var endCursorAtNthWordStarts;
            if (index !== undefined) {
                var match$4 = Caml_array.get(words, index);
                endCursorAtNthWordStarts = match$4[0] === endOffset ? index : undefined;
            } else {
                endCursorAtNthWordStarts = undefined;
            }
            var semantics;
            if (suffixWord !== undefined) {
                var suffix = suffixWord[1];
                if (endCursorAtNthWordStarts !== undefined) {
                    var arg = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix), function(nonAlphaNumericPrefix) {
                        return [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath,
                                _1: nonAlphaNumericPrefix
                            }
                        ];
                    });
                    semantics = $$Array.concat({
                        hd: [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath,
                                _1: suffix
                            }
                        ],
                        tl: {
                            hd: function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            }([]),
                            tl: {
                                hd: [
                                    {
                                        TAG: /* BeforeAnySuffix */ 13,
                                        _0: endPath,
                                        _1: [
                                            suffix,
                                            "add your own custom words"
                                        ]
                                    },
                                    {
                                        TAG: /* BeforeNthWord */ 11,
                                        _0: endPath,
                                        _1: endCursorAtNthWordStarts
                                    },
                                    {
                                        TAG: /* BeforeIndex */ 10,
                                        _0: endPath,
                                        _1: endOffset
                                    }
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    });
                } else {
                    var arg$1 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix), function(nonAlphaNumericPrefix) {
                        return [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath,
                                _1: nonAlphaNumericPrefix
                            }
                        ];
                    });
                    semantics = $$Array.concat({
                        hd: [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath,
                                _1: suffix
                            }
                        ],
                        tl: {
                            hd: function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            }([]),
                            tl: {
                                hd: [
                                    {
                                        TAG: /* BeforeAnySuffix */ 13,
                                        _0: endPath,
                                        _1: [
                                            suffix,
                                            "add your own custom words"
                                        ]
                                    },
                                    {
                                        TAG: /* BeforeIndex */ 10,
                                        _0: endPath,
                                        _1: endOffset
                                    }
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    });
                }
            } else {
                semantics = endCursorAtNthWordStarts !== undefined ? [
                    {
                        TAG: /* BeforeNthWord */ 11,
                        _0: endPath,
                        _1: endCursorAtNthWordStarts
                    },
                    {
                        TAG: /* BeforeIndex */ 10,
                        _0: endPath,
                        _1: endOffset
                    }
                ] : [
                    {
                        TAG: /* BeforeIndex */ 10,
                        _0: endPath,
                        _1: endOffset
                    }
                ];
            }
            return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), words, startPath, semantics);
        }
        if (isEndAtEndOfEndText) {
            if (indexOfFirstNonWhitespaceChar === startOffset) {
                return [
                    {
                        TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                        _0: startPath,
                        _1: endPath
                    }
                ];
            }
            var words$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText);
            var index$1 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, words$1);
            var startCursorAtNthWordsEnds;
            if (index$1 !== undefined) {
                var match$5 = Caml_array.get(words$1, index$1);
                var wordEnds = match$5[0] + match$5[1].length | 0;
                startCursorAtNthWordsEnds = wordEnds === startOffset ? index$1 : undefined;
            } else {
                startCursorAtNthWordsEnds = undefined;
            }
            var semantics$1;
            if (prefixWord !== undefined) {
                var prefix = prefixWord[1];
                semantics$1 = startCursorAtNthWordsEnds !== undefined ? [
                    {
                        TAG: /* AfterPrefix */ 8,
                        _0: startPath,
                        _1: prefix
                    },
                    {
                        TAG: /* AfterNthWord */ 7,
                        _0: startPath,
                        _1: startCursorAtNthWordsEnds
                    },
                    {
                        TAG: /* AfterIndex */ 6,
                        _0: startPath,
                        _1: startOffset - 1 | 0
                    }
                ] : [
                    {
                        TAG: /* AfterPrefix */ 8,
                        _0: startPath,
                        _1: prefix
                    },
                    {
                        TAG: /* AfterIndex */ 6,
                        _0: startPath,
                        _1: startOffset - 1 | 0
                    }
                ];
            } else {
                semantics$1 = startCursorAtNthWordsEnds !== undefined ? [
                    {
                        TAG: /* AfterNthWord */ 7,
                        _0: startPath,
                        _1: startCursorAtNthWordsEnds
                    },
                    {
                        TAG: /* AfterIndex */ 6,
                        _0: startPath,
                        _1: startOffset - 1 | 0
                    }
                ] : [
                    {
                        TAG: /* AfterIndex */ 6,
                        _0: startPath,
                        _1: startOffset - 1 | 0
                    }
                ];
            }
            return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), words$1, startPath, semantics$1);
        }
        if (indexOfFirstNonWhitespaceChar === startOffset && (indexOfLastNonWhitespaceChar + 1 | 0) === endOffset) {
            return [
                {
                    TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                    _0: startPath,
                    _1: endPath
                }
            ];
        }
        if (indexOfFirstNonWhitespaceChar === startOffset && indexOfLastNonWhitespaceChar === endOffset) {
            return [
                {
                    TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                    _0: startPath,
                    _1: endPath
                }
            ];
        }
        var startWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText);
        var index$2 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, startWords);
        var startCursorAtNthWordsEnds$1;
        if (index$2 !== undefined) {
            var match$6 = Caml_array.get(startWords, index$2);
            var wordEnds$1 = match$6[0] + match$6[1].length | 0;
            startCursorAtNthWordsEnds$1 = wordEnds$1 === startOffset ? index$2 : undefined;
        } else {
            startCursorAtNthWordsEnds$1 = undefined;
        }
        var endWords = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText);
        var index$3 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset, endWords);
        var endCursorAtNthWordStarts$1;
        if (index$3 !== undefined) {
            var match$7 = Caml_array.get(endWords, index$3);
            endCursorAtNthWordStarts$1 = match$7[0] === endOffset ? index$3 : undefined;
        } else {
            endCursorAtNthWordStarts$1 = undefined;
        }
        var semantics$2;
        var exit = 0;
        if (prefixWord !== undefined && suffixWord !== undefined) {
            var suffix$1 = suffixWord[1];
            var prefix$1 = prefixWord[1];
            var exit$1 = 0;
            if (startCursorAtNthWordsEnds$1 !== undefined && endCursorAtNthWordStarts$1 !== undefined) {
                semantics$2 = [
                    {
                        TAG: /* BetweenTexts */ 4,
                        _0: [
                            startPath,
                            prefix$1
                        ],
                        _1: [
                            endPath,
                            suffix$1
                        ]
                    },
                    {
                        TAG: /* BetweenNthWords */ 3,
                        _0: [
                            startPath,
                            startCursorAtNthWordsEnds$1
                        ],
                        _1: [
                            startPath,
                            endCursorAtNthWordStarts$1
                        ]
                    },
                    {
                        TAG: /* BetweenIndexes */ 2,
                        _0: [
                            startPath,
                            startOffset
                        ],
                        _1: [
                            endPath,
                            endOffset
                        ]
                    }
                ];
            } else {
                exit$1 = 2;
            }
            if (exit$1 === 2) {
                semantics$2 = [
                    {
                        TAG: /* BetweenTexts */ 4,
                        _0: [
                            startPath,
                            prefix$1
                        ],
                        _1: [
                            endPath,
                            suffix$1
                        ]
                    },
                    {
                        TAG: /* BetweenIndexes */ 2,
                        _0: [
                            startPath,
                            startOffset
                        ],
                        _1: [
                            endPath,
                            endOffset
                        ]
                    }
                ];
            }
        } else {
            exit = 1;
        }
        if (exit === 1) {
            semantics$2 = [
                {
                    TAG: /* BetweenIndexes */ 2,
                    _0: [
                        startPath,
                        startOffset
                    ],
                    _1: [
                        endPath,
                        endOffset
                    ]
                }
            ];
        }
        return maybeAddNthWordSemanticToSemantics(startText.slice(startOffset, endOffset), startWords, startPath, semantics$2);
    } else {
        var crossNodes = selection._0;
        var match$8 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(startBoundary);
        var startOffset$1 = match$8[1];
        var startText$1 = match$8[0];
        var match$9 = Selection__NonInputSelection$SmartcutsMacros.SelectionBoundary.extractTextAndOffset(endBoundary);
        var endOffset$1 = match$9[1];
        var endText$1 = match$9[0];
        var match$10 = getStartPathAndEndPathForCrossNodes(startOffset$1, endOffset$1, endText$1, crossNodes);
        var endPath$1 = match$10[1];
        var startPath$1 = match$10[0];
        if (startOffset$1 === 0 && endOffset$1 === endText$1.length) {
            return [
                {
                    TAG: /* SelectAll */ 0,
                    _0: startPath$1,
                    _1: endPath$1
                }
            ];
        } else if (isSelectingAllExceptSurroundingWhitespace(startText$1, startOffset$1, endText$1, endOffset$1)) {
            return [
                {
                    TAG: /* SelectAllExceptSurroundingWhitespace */ 1,
                    _0: startPath$1,
                    _1: endPath$1
                }
            ];
        } else {
            var match$11 = crossNodes.prevAdjacentText;
            var match$12;
            if (match$11 !== undefined && startOffset$1 === 0) {
                var text = match$11.text;
                var startOffset$2 = text.length;
                match$12 = [
                    text,
                    startOffset$2
                ];
            } else {
                match$12 = [
                    startText$1,
                    startOffset$1
                ];
            }
            var startOffset_2 = match$12[1];
            var match$13 = crossNodes.nextAdjacentText;
            var match$14 = match$13 !== undefined && endOffset$1 === endText$1.length ? [
                match$13.text,
                0
            ] : [
                endText$1,
                endOffset$1
            ];
            var endOffset_2 = match$14[1];
            var match$15 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(match$12[0], startOffset_2, match$14[0], endOffset_2);
            var maybeSuffixWord = match$15[1];
            var maybePrefixWord = match$15[0];
            var startWords$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, startText$1);
            var index$4 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset$1, startWords$1);
            var startCursorAtNthWordsEnds$2;
            if (index$4 !== undefined) {
                var match$16 = Caml_array.get(startWords$1, index$4);
                var wordEnds$2 = match$16[0] + match$16[1].length | 0;
                startCursorAtNthWordsEnds$2 = wordEnds$2 === startOffset$1 ? index$4 : undefined;
            } else {
                startCursorAtNthWordsEnds$2 = undefined;
            }
            var endWords$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, endText$1);
            var index$5 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsNthWord.indexOfWordAtOffset(startOffset$1, endWords$1);
            var endCursorAtNthWordStarts$2;
            if (index$5 !== undefined) {
                var match$17 = Caml_array.get(endWords$1, index$5);
                endCursorAtNthWordStarts$2 = match$17[0] === endOffset$1 ? index$5 : undefined;
            } else {
                endCursorAtNthWordStarts$2 = undefined;
            }
            if (maybePrefixWord !== undefined) {
                var prefix$2 = maybePrefixWord[1];
                if (maybeSuffixWord !== undefined) {
                    var suffix$2 = maybeSuffixWord[1];
                    if (startCursorAtNthWordsEnds$2 !== undefined && endCursorAtNthWordStarts$2 !== undefined) {
                        return [
                            {
                                TAG: /* BetweenTexts */ 4,
                                _0: [
                                    startPath$1,
                                    prefix$2
                                ],
                                _1: [
                                    endPath$1,
                                    suffix$2
                                ]
                            },
                            {
                                TAG: /* BetweenNthWords */ 3,
                                _0: [
                                    startPath$1,
                                    startCursorAtNthWordsEnds$2
                                ],
                                _1: [
                                    startPath$1,
                                    endCursorAtNthWordStarts$2
                                ]
                            },
                            {
                                TAG: /* BetweenIndexes */ 2,
                                _0: [
                                    startPath$1,
                                    startOffset_2
                                ],
                                _1: [
                                    endPath$1,
                                    endOffset_2
                                ]
                            }
                        ];
                    }
                    return [
                        {
                            TAG: /* BetweenTexts */ 4,
                            _0: [
                                startPath$1,
                                prefix$2
                            ],
                            _1: [
                                endPath$1,
                                suffix$2
                            ]
                        },
                        {
                            TAG: /* BetweenIndexes */ 2,
                            _0: [
                                startPath$1,
                                startOffset_2
                            ],
                            _1: [
                                endPath$1,
                                endOffset_2
                            ]
                        }
                    ];
                }
                var semantics$3;
                if (maybePrefixWord !== undefined) {
                    var prefix$3 = maybePrefixWord[1];
                    semantics$3 = startCursorAtNthWordsEnds$2 !== undefined ? [
                        {
                            TAG: /* AfterPrefixAcrossNodes */ 9,
                            _0: {
                                prefix: prefix$3,
                                prefixRange: {
                                    TAG: /* InSingleNode */ 0,
                                    _0: [
                                        startPath$1,
                                        prefix$3
                                    ]
                                },
                                selectionEndPath: endPath$1
                            }
                        },
                        {
                            TAG: /* AfterNthWord */ 7,
                            _0: startPath$1,
                            _1: startCursorAtNthWordsEnds$2
                        },
                        {
                            TAG: /* AfterIndex */ 6,
                            _0: startPath$1,
                            _1: startOffset$1 - 1 | 0
                        }
                    ] : [
                        {
                            TAG: /* AfterPrefixAcrossNodes */ 9,
                            _0: {
                                prefix: prefix$3,
                                prefixRange: {
                                    TAG: /* InSingleNode */ 0,
                                    _0: [
                                        startPath$1,
                                        prefix$3
                                    ]
                                },
                                selectionEndPath: endPath$1
                            }
                        },
                        {
                            TAG: /* AfterIndex */ 6,
                            _0: startPath$1,
                            _1: startOffset$1 - 1 | 0
                        }
                    ];
                } else {
                    semantics$3 = startCursorAtNthWordsEnds$2 !== undefined ? [
                        {
                            TAG: /* AfterNthWord */ 7,
                            _0: startPath$1,
                            _1: startCursorAtNthWordsEnds$2
                        },
                        {
                            TAG: /* AfterIndex */ 6,
                            _0: startPath$1,
                            _1: startOffset$1 - 1 | 0
                        }
                    ] : [
                        {
                            TAG: /* AfterIndex */ 6,
                            _0: startPath$1,
                            _1: startOffset$1 - 1 | 0
                        }
                    ];
                }
                return maybeAddNthWordSemanticToSemantics(startText$1.slice(startOffset$1, endOffset$1), startWords$1, startPath$1, semantics$3);
            }
            if (maybeSuffixWord === undefined) {
                return [
                    {
                        TAG: /* BetweenIndexes */ 2,
                        _0: [
                            startPath$1,
                            startOffset_2
                        ],
                        _1: [
                            endPath$1,
                            endOffset_2
                        ]
                    }
                ];
            }
            var semantics$4;
            if (maybeSuffixWord !== undefined) {
                var suffix$3 = maybeSuffixWord[1];
                if (endCursorAtNthWordStarts$2 !== undefined) {
                    var arg$2 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix$3), function(nonAlphaNumericPrefix) {
                        return [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath$1,
                                _1: nonAlphaNumericPrefix
                            }
                        ];
                    });
                    semantics$4 = $$Array.concat({
                        hd: [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath$1,
                                _1: suffix$3
                            }
                        ],
                        tl: {
                            hd: function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                            }([]),
                            tl: {
                                hd: [
                                    {
                                        TAG: /* BeforeAnySuffix */ 13,
                                        _0: endPath$1,
                                        _1: [
                                            suffix$3,
                                            "add your own custom words"
                                        ]
                                    },
                                    {
                                        TAG: /* BeforeNthWord */ 11,
                                        _0: endPath$1,
                                        _1: endCursorAtNthWordStarts$2
                                    },
                                    {
                                        TAG: /* BeforeIndex */ 10,
                                        _0: endPath$1,
                                        _1: endOffset$1
                                    }
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    });
                } else {
                    var arg$3 = OptionUtils$SmartcutsMacros.map(StringUtils$SmartcutsMacros.getNonAlphaNumericSuffix(suffix$3), function(nonAlphaNumericPrefix) {
                        return [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath$1,
                                _1: nonAlphaNumericPrefix
                            }
                        ];
                    });
                    semantics$4 = $$Array.concat({
                        hd: [
                            {
                                TAG: /* BeforeSuffix */ 12,
                                _0: endPath$1,
                                _1: suffix$3
                            }
                        ],
                        tl: {
                            hd: function(param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
                            }([]),
                            tl: {
                                hd: [
                                    {
                                        TAG: /* BeforeAnySuffix */ 13,
                                        _0: endPath$1,
                                        _1: [
                                            suffix$3,
                                            "add your own custom words"
                                        ]
                                    },
                                    {
                                        TAG: /* BeforeIndex */ 10,
                                        _0: endPath$1,
                                        _1: endOffset$1
                                    }
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    });
                }
            } else {
                semantics$4 = endCursorAtNthWordStarts$2 !== undefined ? [
                    {
                        TAG: /* BeforeNthWord */ 11,
                        _0: endPath$1,
                        _1: endCursorAtNthWordStarts$2
                    },
                    {
                        TAG: /* BeforeIndex */ 10,
                        _0: endPath$1,
                        _1: endOffset$1
                    }
                ] : [
                    {
                        TAG: /* BeforeIndex */ 10,
                        _0: endPath$1,
                        _1: endOffset$1
                    }
                ];
            }
            return maybeAddNthWordSemanticToSemantics(startText$1.slice(startOffset$1, endOffset$1), endWords$1, startPath$1, semantics$4);
        }
    }
}
exports.Path = Path;
exports.Semantic = Semantic;
exports.t_encode = t_encode$5;
exports.t_decode = t_decode$5;
exports.stringify = stringify$3;
exports.isToken = isToken;
exports.maybeAddNthWordSemanticToSemantics = maybeAddNthWordSemanticToSemantics;
exports.ofSelection = ofSelection; /* ord Not a pure module */ 


/***/ }),

/***/ 47401:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Js_exn = __webpack_require__(82900);
var $$String = __webpack_require__(65760);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Text = __webpack_require__(32348);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function ofNode(_node) {
    while(true){
        var node = _node;
        var match = Webapi__Dom__Node.nodeType(node);
        if (match >= 3) {
            return Js_exn.raiseError("Expected nodeType = Element | Text");
        }
        switch(match){
            case /* Element */ 0:
                var arg1 = Webapi__Dom__Element.ofNode(node);
                var element = (function(arg) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    };
                })(arg1)("Expected element for Element node in Selection.Text.ofNode");
                var node$1 = element.firstChild;
                if (node$1 == null) {
                    return;
                }
                if (Webapi__Dom__Node.nodeType(node$1) === /* Text */ 2) {
                    var arg$11 = Webapi__Dom__Text.ofNode(node$1);
                    var textNode = (function(arg$1) {
                        return function(param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                        };
                    })(arg$11)("Text.ofNode error: Expected to get TextNode if nodeType == Text");
                    return textNode.data;
                }
                if (Webapi__Dom__Node.nodeType(node$1) !== /* Element */ 0) {
                    return;
                }
                _node = node$1;
                continue;
            case /* Attribute */ 1:
                return Js_exn.raiseError("Expected nodeType = Element | Text");
            case /* Text */ 2:
                var arg$21 = Webapi__Dom__Text.ofNode(node);
                return (function(arg$2) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                    };
                })(arg$21)("Expected text for Text node in Selection.Text.ofNode").data;
        }
    }
    ;
}
var regexWhitespace = /\w/g;
function indexOfFirstNonWhitespaceChar(s) {
    return s.search(regexWhitespace);
}
function indexOfLastNonWhitespaceChar(s) {
    var reversed = StringUtils$SmartcutsMacros.reverse(s);
    var i = reversed.search(regexWhitespace);
    if (i === -1) {
        return i;
    } else {
        return (s.length - 1 | 0) - i | 0;
    }
}
function isWhitespace(character) {
    var re = /^\s$/;
    return re.test(character);
}
function isComma(str) {
    return str === ",";
}
function isPeriod(str) {
    return str === ".";
}
function isBoundaryToken(str) {
    if (isWhitespace(str) || str === ",") {
        return true;
    } else {
        return str === ".";
    }
}
function fromText(text) {
    var characters = Array.from(text);
    var state1 = Belt_Array.reduceWithIndex(characters, {
        words: [],
        parsing: undefined
    }, function(state, token, index) {
        var parsing = state.parsing;
        var words = state.words;
        if (isWhitespace(token) || token === "," || token === ".") {
            if (parsing !== undefined) {
                return {
                    words: $$Array.append(words, [
                        parsing
                    ]),
                    parsing: undefined
                };
            } else {
                return state;
            }
        } else if (parsing !== undefined) {
            return {
                words: words,
                parsing: [
                    parsing[0],
                    parsing[1] + token
                ]
            };
        } else {
            return {
                words: words,
                parsing: [
                    index,
                    token
                ]
            };
        }
    });
    var word = state1.parsing;
    if (word !== undefined) {
        return $$Array.append(state1.words, [
            word
        ]);
    } else {
        return state1.words;
    }
}
function getIndexOfPriorNonBoundaryToken(index, text) {
    var arg = Belt_Array.getIndexBy(Belt_Array.reverse(Array.from(text.slice(0, index))), function($$char) {
        return !isBoundaryToken($$char);
    });
    return index - function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(0) | 0;
}
function getIndexOfNextNonBoundaryToken(index, text) {
    var arg = Belt_Array.getIndexBy(Array.from(text.slice(index)), function($$char) {
        return !isBoundaryToken($$char);
    });
    return index + function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(0) | 0;
}
var ParseWords = {
    isWhitespace: isWhitespace,
    isComma: isComma,
    isPeriod: isPeriod,
    isBoundaryToken: isBoundaryToken,
    fromText: fromText,
    getIndexOfPriorNonBoundaryToken: getIndexOfPriorNonBoundaryToken,
    getIndexOfNextNonBoundaryToken: getIndexOfNextNonBoundaryToken
};
var $$Text = {
    ofNode: ofNode,
    regexWhitespace: regexWhitespace,
    indexOfFirstNonWhitespaceChar: indexOfFirstNonWhitespaceChar,
    indexOfLastNonWhitespaceChar: indexOfLastNonWhitespaceChar,
    ParseWords: ParseWords
};
function getPrefixAndSuffixWord(startText, startOffset, endText, endOffset) {
    var textBeforeSelection = startText.slice(0, startOffset);
    var wordsBeforeSelection = fromText(textBeforeSelection);
    var length = wordsBeforeSelection.length;
    var prefixWord;
    if (length !== 0) {
        var match = Caml_array.get(wordsBeforeSelection, length - 1 | 0);
        var sliceFrom = getIndexOfPriorNonBoundaryToken(match[0], textBeforeSelection);
        var textUtilStartOffset = startText.slice(sliceFrom, startOffset);
        prefixWord = [
            sliceFrom,
            textUtilStartOffset
        ];
    } else {
        prefixWord = undefined;
    }
    var endTextLength = endText.length;
    var textAfterSelection = endText.slice(endOffset);
    var wordsAfterSelection = endOffset === endTextLength ? [] : fromText(textAfterSelection);
    var match$1 = Belt_Array.get(wordsAfterSelection, 0);
    var suffixWord;
    if (match$1 !== undefined) {
        var wordEnds = match$1[0] + match$1[1].length | 0;
        var substringLength = getIndexOfNextNonBoundaryToken(wordEnds, textAfterSelection);
        var textAfterEndOffset = $$String.sub(endText, endOffset, substringLength);
        suffixWord = [
            endOffset,
            textAfterEndOffset
        ];
    } else {
        suffixWord = undefined;
    }
    return [
        prefixWord,
        suffixWord
    ];
}
var SemanticsPrefixSuffix = {
    getPrefixAndSuffixWord: getPrefixAndSuffixWord
};
function indexOfWordAtOffset(offset, words) {
    return Util$SmartcutsMacros.shortcutWithIndex2(words, function(param, index) {
        if ((param[0] + param[1].length | 0) >= offset) {
            return index;
        }
    });
}
var SemanticsNthWord = {
    indexOfWordAtOffset: indexOfWordAtOffset
};
exports.$$Text = $$Text;
exports.SemanticsPrefixSuffix = SemanticsPrefixSuffix;
exports.SemanticsNthWord = SemanticsNthWord; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 33788:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var SelectionSemantics__InputSelectionSemantics$SmartcutsMacros = __webpack_require__(35275);
var SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros = __webpack_require__(2569);
function t_encode(v) {
    if (v.TAG === /* NonInputSelectionSemantic */ 0) {
        return [
            "NonInputSelectionSemantic",
            SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._0)
        ];
    } else {
        return [
            "InputSelectionSemantic",
            Selector$SmartcutsMacros.selector_encode(v._0),
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InputSelectionSemantic":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* InputSelectionSemantic */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "NonInputSelectionSemantic":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NonInputSelectionSemantic */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v.TAG === /* NonInputSelectionSemantic */ 0) {
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.stringify(v._0);
    } else {
        return "InputSelectionSemantic(selector=" + (Selector$SmartcutsMacros.stringify(undefined, false, v._0) + (", semantic=" + (SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._1) + ")")));
    }
}
function toHumanReadable(v) {
    if (v.TAG === /* NonInputSelectionSemantic */ 0) {
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.stringify(v._0);
    } else {
        return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._1);
    }
}
function selectorGet(v) {
    if (v.TAG === /* NonInputSelectionSemantic */ 0) {
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.selectorGet(v._0);
    } else {
        return [
            v._0
        ];
    }
}
function updateSelector(f, v) {
    if (v.TAG === /* NonInputSelectionSemantic */ 0) {
        return {
            TAG: /* NonInputSelectionSemantic */ 0,
            _0: SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.updateSelector(f, v._0)
        };
    } else {
        return {
            TAG: /* InputSelectionSemantic */ 1,
            _0: Curry._1(f, v._0),
            _1: v._1
        };
    }
}
function getText(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    if (semantic.TAG === /* NonInputSelectionSemantic */ 0) {
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.getText(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: result._0
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    } else {
        return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.getText(semantic._0, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: result._0
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    }
}
function applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
    if (semantic.TAG === /* NonInputSelectionSemantic */ 0) {
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    } else {
        return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.selectInsideInputLocatedAtSelector(semantic._0, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
        });
    }
}
var Semantic = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    toHumanReadable: toHumanReadable,
    selectorGet: selectorGet,
    updateSelector: updateSelector,
    getText: getText,
    applyToDom: applyToDom
};
function t_encode$1(v) {
    if (v.TAG === /* NonInputSelectionSemantics */ 0) {
        return [
            "NonInputSelectionSemantics",
            SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.t_encode(v._0)
        ];
    } else {
        return [
            "InputSelectionSemantics",
            Selector$SmartcutsMacros.selector_encode(v._0),
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_encode(v._1)
        ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "InputSelectionSemantics":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* InputSelectionSemantics */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "NonInputSelectionSemantics":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NonInputSelectionSemantics */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$2 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map(f, semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return $$Array.map(function(semantic) {
            return Curry._1(f, {
                TAG: /* NonInputSelectionSemantic */ 0,
                _0: semantic
            });
        }, semantics._0);
    }
    var selector = semantics._0;
    return $$Array.map(function(semantic) {
        return Curry._1(f, {
            TAG: /* InputSelectionSemantic */ 1,
            _0: selector,
            _1: semantic
        });
    }, semantics._1);
}
function length(semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return semantics._0.length;
    } else {
        return semantics._1.length;
    }
}
function extractSelectors(semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return Belt_Array.concatMany($$Array.map(SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.selectorGet, semantics._0));
    } else {
        return [
            semantics._0
        ];
    }
}
function indexOfWordAtOffset(offset, words) {
    return Util$SmartcutsMacros.shortcutWithIndex2(words, function(param, index) {
        if ((param[0] + param[1].length | 0) >= offset) {
            return index;
        }
    });
}
function ofSelection(selection) {
    if (selection.TAG === /* NonInputSelection */ 0) {
        return {
            TAG: /* NonInputSelectionSemantics */ 0,
            _0: SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.ofSelection(selection._0)
        };
    }
    var inputSelection = selection._0;
    return {
        TAG: /* InputSelectionSemantics */ 1,
        _0: inputSelection.domElementRepresentation.selector,
        _1: SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.ofSelection(inputSelection)
    };
}
function stringify$1(semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return "NonInputSelectionSemantics(" + (SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.stringify(semantics._0) + ")");
    } else {
        return "InputSelectionSemantics(selector" + (Selector$SmartcutsMacros.stringify(undefined, false, semantics._0) + (", semantics=" + (SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.stringify(semantics._1) + ")")));
    }
}
function getFirstSemantic(semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return {
            TAG: /* NonInputSelectionSemantic */ 0,
            _0: Caml_array.get(semantics._0, 0)
        };
    } else {
        return {
            TAG: /* InputSelectionSemantic */ 1,
            _0: semantics._0,
            _1: Caml_array.get(semantics._1, 0)
        };
    }
}
function updateSelector$1(f, semantics) {
    if (semantics.TAG === /* NonInputSelectionSemantics */ 0) {
        return {
            TAG: /* NonInputSelectionSemantics */ 0,
            _0: $$Array.map(function(param) {
                return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.updateSelector(f, param);
            }, semantics._0)
        };
    } else {
        return {
            TAG: /* InputSelectionSemantics */ 1,
            _0: Curry._1(f, semantics._0),
            _1: semantics._1
        };
    }
}
var NonInputSelectionSemantics;
var InputSelectionSemantics;
exports.NonInputSelectionSemantics = NonInputSelectionSemantics;
exports.InputSelectionSemantics = InputSelectionSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.map = map;
exports.length = length;
exports.extractSelectors = extractSelectors;
exports.indexOfWordAtOffset = indexOfWordAtOffset;
exports.ofSelection = ofSelection;
exports.stringify = stringify$1;
exports.getFirstSemantic = getFirstSemantic;
exports.updateSelector = updateSelector$1; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 14809:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Element = __webpack_require__(33116);
var HTMLNodes$SmartcutsMacros = __webpack_require__(22764);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var RandomCss$SmartcutsMacros = __webpack_require__(48206);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var SelectorTree$SmartcutsMacros = __webpack_require__(47118);
function contains(attr, value, attributes) {
    return $$Array.exists(function(param) {
        if (Caml_obj.caml_equal(param[0], attr)) {
            if (value !== undefined) {
                return Caml_obj.caml_equal(param[1], Caml_option.valFromOption(value));
            } else {
                return true;
            }
        } else {
            return false;
        }
    }, attributes);
}
var Attributes = {
    contains: contains
};
function selectorNode_encode(v) {
    return SelectorTree$SmartcutsMacros.$$Node.t_encode(v);
}
function selectorNode_decode(v) {
    return SelectorTree$SmartcutsMacros.$$Node.t_decode(v);
}
function selector_encode(v) {
    return Decco.listToJson(selectorNode_encode, v);
}
function selector_decode(v) {
    return Decco.listFromJson(selectorNode_decode, v);
}
function elementSelector_encode(v) {
    switch(v.TAG | 0){
        case /* Selector */ 0:
            return [
                "Selector",
                Decco.listToJson(selectorNode_encode, v._0)
            ];
        case /* CssSelector */ 1:
            return [
                "CssSelector",
                Decco.stringToJson(v._0)
            ];
        case /* XPath */ 2:
            return [
                "XPath",
                Decco.stringToJson(v._0)
            ];
    }
}
function elementSelector_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CssSelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CssSelector */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Selector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.listFromJson(selectorNode_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Selector */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "XPath":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* XPath */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function selectorNode(tagName, classNamesOpt, id, attributesOpt, index, innerText, isScrollable, attributeBlacklistOpt, param) {
    var classNames = classNamesOpt !== undefined ? classNamesOpt : [];
    var attributes = attributesOpt !== undefined ? attributesOpt : /* [] */ 0;
    var attributeBlacklist = attributeBlacklistOpt !== undefined ? attributeBlacklistOpt : [];
    return {
        id: id,
        tagName: tagName,
        classNames: classNames,
        attributes: $$Array.of_list(attributes),
        index: index,
        innerText: innerText,
        isScrollable: isScrollable,
        attributeBlacklist: attributeBlacklist
    };
}
function addNode(node, selector) {
    return Belt_List.concat(selector, {
        hd: node,
        tl: /* [] */ 0
    });
}
function stringify(componentFilterOpt, useScope, selector) {
    var componentFilter = componentFilterOpt !== undefined ? componentFilterOpt : function componentFilter(param) {
        return true;
    };
    return SelectorTree$SmartcutsMacros.stringify(useScope, List.map(function(node) {
        return Curry._1(SelectorTree$SmartcutsMacros.$$Node.Components.toNode, List.filter(componentFilter)(Curry._1(SelectorTree$SmartcutsMacros.$$Node.Components.fromSelectorNode, node)));
    }, selector));
}
function stringifyElementSelector(v) {
    switch(v.TAG | 0){
        case /* Selector */ 0:
            return "Selector(" + (stringify(undefined, true, v._0) + ")");
        case /* CssSelector */ 1:
            return "CssSelector(" + (v._0 + ")");
        case /* XPath */ 2:
            return "XPath(" + (v._0 + ")");
    }
}
function hasSelectionCapability(selector) {
    var node = Belt_List.get(selector, List.length(selector) - 1 | 0);
    if (node === undefined) {
        return true;
    }
    var match = node.tagName;
    if (match === undefined) {
        return true;
    }
    switch(match){
        case "input":
            var func = SelectorTree$SmartcutsMacros.$$Node.maybeGetAttributeValue;
            var type_ = Curry._2(func, "type", node);
            if (type_ === undefined) {
                return true;
            }
            var match$1 = type_.toLowerCase();
            switch(match$1){
                case "":
                case "password":
                case "search":
                case "tel":
                case "text":
                case "url":
                    return true;
                default:
                    return false;
            }
        case "textarea":
            return true;
        default:
            return true;
    }
}
function deepEquals(selectorA, selectorB) {
    if (List.length(selectorA) === List.length(selectorB)) {
        return Belt_List.reduceWithIndex(selectorA, true, function(acc, nodeA, i) {
            var nodeB = Belt_List.getExn(selectorB, i);
            if (acc) {
                return SelectorTree$SmartcutsMacros.$$Node.deepEquals(nodeA, nodeB);
            } else {
                return false;
            }
        });
    } else {
        return false;
    }
}
function shouldIgnoreId(idPrefixesToIgnore, id) {
    if (id.indexOf("-") === -1) {
        return [
            idPrefixesToIgnore,
            false
        ];
    }
    var _matchingPrefix = ArrayUtils$SmartcutsMacros.firstMatch(function(param) {
        return id.startsWith(param);
    }, idPrefixesToIgnore);
    if (_matchingPrefix !== undefined) {
        return [
            idPrefixesToIgnore,
            true
        ];
    }
    var maybePrefix = ArrayUtils$SmartcutsMacros.shortcutWithState([], function(previousPrefix, component1) {
        var prefix = Belt_Array.concat(previousPrefix, [
            component1
        ]);
        var prefixString = prefix.join("-").concat("-");
        var arg1 = Array.prototype.slice.call(document.querySelectorAll("*[id^=" + (window.CSS.escape(prefixString) + "]")));
        var otherIdsMatchingPrefix = function(param) {
            return ArrayUtils$SmartcutsMacros.filterMap(param, arg1);
        }(function(node) {
            var maybeElement = Webapi__Dom__Element.ofNode(node);
            if (maybeElement === undefined) {
                return;
            }
            var element = Caml_option.valFromOption(maybeElement);
            if (element.id === id) {
                return;
            } else {
                return element.id;
            }
        });
        var components = Belt_Array.map(otherIdsMatchingPrefix, function(param) {
            var arg = Belt_Array.get(param.slice(prefixString.length).split("-"), 0);
            var param$1 = "Expect to get idComponent after prefix " + (StringUtils$SmartcutsMacros.quote(prefixString) + (" from id " + StringUtils$SmartcutsMacros.quote(param)));
            return OptionUtils$SmartcutsMacros.getExn(param$1, arg);
        });
        var componentsMatchingLength = Belt_Array.keep(components, function(component) {
            return component.length === component.length;
        });
        if (componentsMatchingLength.length !== 0) {
            if (Belt_Array.some(componentsMatchingLength, function(component$p) {
                return component$p === component1;
            })) {
                return [
                    prefix,
                    undefined
                ];
            } else {
                return [
                    prefix,
                    prefix
                ];
            }
        } else {
            return [
                prefix,
                []
            ];
        }
    }, id.split("-"));
    if (maybePrefix === undefined) {
        return [
            idPrefixesToIgnore,
            false
        ];
    }
    if (maybePrefix.length === 0) {
        return [
            idPrefixesToIgnore,
            false
        ];
    }
    var prefixToIgnore = maybePrefix.join("-");
    return [
        Belt_Array.concat(idPrefixesToIgnore, [
            prefixToIgnore
        ]),
        true
    ];
}
var attributesToAvoidComparing = [
    "alt",
    "autofocus",
    "on",
    "checked",
    "selected",
    "style",
    "width",
    "height",
    "color",
    "bgcolor",
    "background",
    "border"
];
function websiteSpecificAttributesToAvoidComparing(origin) {
    switch(origin){
        case "https://drive.google.com":
            return [
                "data-complete",
                "aria-activedescendant",
                "jsaction"
            ];
        case "https://www.linkedin.com":
            return [
                "data-artdeco-is-focused"
            ];
        default:
            return;
    }
}
function websiteSpecificClassNamesToAvoidComparing(origin) {
    if (origin === "https://www.linkedin.com") {
        return [
            "cursor-text",
            "cursor-pointer"
        ];
    }
}
function pruneSelectorTreeNodeUsingOriginBlacklist(origin, selectorTreeNode) {
    var attributes = selectorTreeNode.attributes;
    var classNames = selectorTreeNode.classNames;
    var match = websiteSpecificClassNamesToAvoidComparing(origin);
    var match$1 = websiteSpecificAttributesToAvoidComparing(origin);
    if (match !== undefined) {
        if (match$1 !== undefined) {
            return {
                id: selectorTreeNode.id,
                tagName: selectorTreeNode.tagName,
                classNames: Belt_Array.keep(classNames, function(className) {
                    return !$$Array.mem(className, match);
                }),
                attributes: Belt_Array.keep(attributes, function(param) {
                    return !$$Array.mem(param[0], match$1);
                }),
                index: selectorTreeNode.index,
                innerText: selectorTreeNode.innerText,
                isScrollable: selectorTreeNode.isScrollable,
                attributeBlacklist: selectorTreeNode.attributeBlacklist
            };
        } else {
            return {
                id: selectorTreeNode.id,
                tagName: selectorTreeNode.tagName,
                classNames: Belt_Array.keep(classNames, function(className) {
                    return !$$Array.mem(className, match);
                }),
                attributes: selectorTreeNode.attributes,
                index: selectorTreeNode.index,
                innerText: selectorTreeNode.innerText,
                isScrollable: selectorTreeNode.isScrollable,
                attributeBlacklist: selectorTreeNode.attributeBlacklist
            };
        }
    } else if (match$1 !== undefined) {
        return {
            id: selectorTreeNode.id,
            tagName: selectorTreeNode.tagName,
            classNames: selectorTreeNode.classNames,
            attributes: Belt_Array.keep(attributes, function(param) {
                return !$$Array.mem(param[0], match$1);
            }),
            index: selectorTreeNode.index,
            innerText: selectorTreeNode.innerText,
            isScrollable: selectorTreeNode.isScrollable,
            attributeBlacklist: selectorTreeNode.attributeBlacklist
        };
    } else {
        return selectorTreeNode;
    }
}
function attributeNamesToUseForAttributeExistence(currentUrl, attributesFilter, param) {
    var attributesToAvoidComparing$1 = Belt_Array.concat(Belt_Option.getWithDefault(Belt_Option.flatMap(currentUrl, function(url) {
        var match = new URL(url);
        return websiteSpecificAttributesToAvoidComparing(match.origin);
    }), []), attributesToAvoidComparing);
    return $$Array.concat({
        hd: param.id !== undefined ? [
            "id"
        ] : [],
        tl: {
            hd: Belt_Array.keep(Belt_Array.keep(Belt_Array.concat(Belt_Array.map(param.attributes, function(prim) {
                return prim[0];
            }), param.classNames.length !== 0 ? [
                "class"
            ] : []), attributesFilter), function(attrName) {
                return !$$Array.mem(attrName, attributesToAvoidComparing$1);
            }),
            tl: /* [] */ 0
        }
    });
}
function toCssSelectorUsingTagChainAndAttributeExistence(useScope, attributesFilter, currentUrl, selector) {
    return (useScope ? ":scope " : "") + $$String.concat(" > ", List.mapi(function(selectorNodeIndex, selectorNode1) {
        var tagName = selectorNode1.tagName;
        var tagName$1 = tagName !== undefined ? tagName : "*";
        var _id = selectorNode1.id;
        if (_id !== undefined) {
            return "" + tagName$1 + "[id]";
        }
        var attributes = attributeNamesToUseForAttributeExistence(currentUrl, Curry._1(attributesFilter, selectorNodeIndex), selectorNode1);
        if (attributes.length !== 0) {
            return Belt_Array.reduce(attributes, tagName$1, function(cssSelector, attrKey) {
                if (attrKey.startsWith("data-") && RegExUtils$SmartcutsMacros.endsWithNumber(attrKey)) {
                    return cssSelector;
                }
                var key = SelectorTree$SmartcutsMacros.$$Node.maybeStringifyAttributeKey(attrKey);
                if (key !== undefined) {
                    return cssSelector + ("[" + key + "]");
                } else {
                    return cssSelector;
                }
            });
        } else {
            return tagName$1;
        }
    }, selector));
}
function removeGeneratedIdsFromSelector(selector) {
    return ListUtils$SmartcutsMacros.mapWithState([], function(idPrefixesToIgnore, selectorNode2) {
        var id = selectorNode2.id;
        if (id === undefined) {
            return [
                idPrefixesToIgnore,
                selectorNode2
            ];
        }
        var match = shouldIgnoreId(idPrefixesToIgnore, id);
        return [
            match[0],
            match[1] ? {
                id: undefined,
                tagName: selectorNode2.tagName,
                classNames: selectorNode2.classNames,
                attributes: selectorNode2.attributes,
                index: selectorNode2.index,
                innerText: selectorNode2.innerText,
                isScrollable: selectorNode2.isScrollable,
                attributeBlacklist: selectorNode2.attributeBlacklist
            } : selectorNode2
        ];
    }, selector);
}
function blacklistedValueForAttrName(attrKey, matchingElements, valueToRetain) {
    return Belt_Array.keepMap(matchingElements, function(element) {
        var value = element.getAttribute(attrKey);
        if (!(value == null) && value !== valueToRetain) {
            return value;
        }
    });
}
function selfAndAllAncestors(element) {
    var parentElement = element.parentElement;
    if (parentElement == null) {
        return [
            element
        ];
    } else {
        return Belt_Array.concat([
            element
        ], selfAndAllAncestors(parentElement));
    }
}
function blacklistAttributeValues(attrKeysToBlacklist, selector) {
    var func = function func(param, param$1, param$2) {
        return toCssSelectorUsingTagChainAndAttributeExistence(true, param, param$1, param$2);
    };
    var cssSelector = Curry._3(func, function(param, param$1) {
        return true;
    }, undefined, selector);
    var elementChains = Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(document.querySelectorAll(cssSelector)), Webapi__Dom__Element.ofNode), selfAndAllAncestors);
    return Belt_List.mapWithIndex(selector, function(index, selectorNode3) {
        var matchingElements = Belt_Array.map(elementChains, function(elements) {
            return Caml_array.get(elements, index);
        });
        var attributeBlacklist = Belt_Array.keepMap(selectorNode3.attributes, function(param) {
            var attrKey = param[0];
            if ($$Array.mem(attrKey, attrKeysToBlacklist)) {
                return [
                    attrKey,
                    blacklistedValueForAttrName(attrKey, matchingElements, param[1])
                ];
            }
        });
        return {
            id: selectorNode3.id,
            tagName: selectorNode3.tagName,
            classNames: selectorNode3.classNames,
            attributes: selectorNode3.attributes,
            index: selectorNode3.index,
            innerText: selectorNode3.innerText,
            isScrollable: selectorNode3.isScrollable,
            attributeBlacklist: attributeBlacklist
        };
    });
}
function forDomElement(domElement) {
    return SelectorTree$SmartcutsMacros.processInnerText(100, 2, [
        "button",
        "a"
    ], [
        "body"
    ], SelectorTree$SmartcutsMacros.fromHTMLNodes(HTMLNodes$SmartcutsMacros.forDomElementAndItsAncestors(undefined, domElement)));
}
var forHtmlElement = forDomElement;
var forDomEventTarget = forDomElement;
function forDomEvent($$event) {
    return forDomElement(DOM__Shadow$SmartcutsMacros.getTargetFromEvent($$event));
}
function stripGeneratedIds(node) {
    var id = node.id;
    if (id !== undefined && RandomCss$SmartcutsMacros.isGeneratedId(id)) {
        return {
            id: undefined,
            tagName: node.tagName,
            classNames: node.classNames,
            attributes: node.attributes,
            index: node.index,
            innerText: node.innerText,
            isScrollable: node.isScrollable,
            attributeBlacklist: node.attributeBlacklist
        };
    } else {
        return node;
    }
}
var $$Node = {
    stripGeneratedIds: stripGeneratedIds
};
function stripGeneratedIds$1(selector) {
    return List.map(stripGeneratedIds, selector);
}
function getCommonAncestor(aSelector, bSelector) {
    var loop = function loop(_aSelector, _bSelector, _commonAncestorSelectorAsArray) {
        while(true){
            var commonAncestorSelectorAsArray = _commonAncestorSelectorAsArray;
            var _$bSelector = _bSelector;
            var _$aSelector = _aSelector;
            if (!_$aSelector) {
                return commonAncestorSelectorAsArray;
            }
            if (!_$bSelector) {
                return commonAncestorSelectorAsArray;
            }
            var _currNodeA = _$aSelector.hd;
            var match = Curry._2(SelectorTree$SmartcutsMacros.$$Node.Diff.withNode, _currNodeA, _$bSelector.hd);
            if (typeof match !== "number") {
                if (match.TAG !== /* ClassNames */ 3) {
                    return commonAncestorSelectorAsArray;
                }
                if (match._2.length === 0) {
                    return commonAncestorSelectorAsArray;
                }
            }
            _commonAncestorSelectorAsArray = $$Array.append(commonAncestorSelectorAsArray, [
                _currNodeA
            ]);
            _bSelector = _$bSelector.tl;
            _aSelector = _$aSelector.tl;
            continue;
        }
        ;
    };
    return $$Array.to_list(loop(aSelector, bSelector, []));
}
function selectsParentOrEquivElement(aSelector, bSelector) {
    var _result;
    var _aSelector = aSelector;
    var _bSelector = bSelector;
    while(true){
        var bSelector$1 = _bSelector;
        var aSelector$1 = _aSelector;
        var result = _result;
        if (result !== undefined) {
            return result;
        }
        if (!aSelector$1) {
            return true;
        }
        var aSelector$p = aSelector$1.tl;
        if (!bSelector$1) {
            return false;
        }
        var bSelector$p = bSelector$1.tl;
        var match = Curry._2(SelectorTree$SmartcutsMacros.$$Node.Diff.withNode, aSelector$1.hd, bSelector$1.hd);
        if (typeof match === "number") {
            _bSelector = bSelector$p;
            _aSelector = aSelector$p;
            _result = undefined;
            continue;
        }
        switch(match.TAG | 0){
            case /* Id */ 0:
            case /* TagName */ 1:
                return false;
            case /* Index */ 2:
                _bSelector = bSelector$p;
                _aSelector = aSelector$p;
                _result = undefined;
                continue;
            case /* ClassNames */ 3:
                if (match._2.length === 0) {
                    return false;
                }
                _bSelector = bSelector$p;
                _aSelector = aSelector$p;
                _result = undefined;
                continue;
        }
    }
    ;
}
function isSame(aSelector, bSelector) {
    if (selectsParentOrEquivElement(aSelector, bSelector)) {
        return selectsParentOrEquivElement(bSelector, aSelector);
    } else {
        return false;
    }
}
function nodeWithExtraAttributes(node, extraAttributes) {
    return {
        id: node.id,
        tagName: node.tagName,
        classNames: node.classNames,
        attributes: $$Array.append($$Array.of_list(extraAttributes), node.attributes),
        index: node.index,
        innerText: node.innerText,
        isScrollable: node.isScrollable,
        attributeBlacklist: node.attributeBlacklist
    };
}
function updateLeafNode(f, selector) {
    var len = List.length(selector);
    if (len === 0) {
        return selector;
    } else {
        return ListUtils$SmartcutsMacros.updateAt(List.length(selector) - 1 | 0, f, selector);
    }
}
function maybeGetLeafAnchor(selector) {
    var len = List.length(selector);
    if (len === 0) {
        return;
    }
    var node = Belt_List.getExn(selector, len - 1 | 0);
    var match = node.tagName;
    if (match === undefined) {
        return;
    }
    switch(match){
        case "A":
        case "a":
            return node;
        default:
            return;
    }
}
function isContentEditable(selector) {
    return Belt_List.some(selector, function(selectorNode4) {
        var match = SelectorTree$SmartcutsMacros.$$Node.maybeGetAttributeValue("contenteditable", selectorNode4);
        if (match === undefined) {
            return false;
        }
        switch(match){
            case "false":
                return false;
            case "":
            case "true":
                return true;
            default:
                return false;
        }
    });
}
function toCssSelectorForPattern(selector) {
    return Belt_Array.map($$Array.of_list(selector), function(param1) {
        var arg = OptionUtils$SmartcutsMacros.map(param1.id, function(s) {
            return "#" + window.CSS.escape(s);
        });
        var arg$1 = OptionUtils$SmartcutsMacros.map(param1.index, function(i) {
            return ":nth-child(" + (String(i) + ")");
        });
        return OptionUtils$SmartcutsMacros.withDefault("*", param1.tagName) + (function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("") + (Belt_Array.map(param1.classNames, function(className) {
            return "." + window.CSS.escape(className);
        }).join("") + (Belt_Array.map(param1.attributes, function(param) {
            var attrValue = param[1];
            return "[" + (window.CSS.escape(param[0]) + ((attrValue.trim() === "" ? "" : "=" + StringUtils$SmartcutsMacros.quote(window.CSS.escape(attrValue))) + "]"));
        }).join("") + function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
        }(""))));
    }).join(" > ");
}
function splitForShadowDom(selector) {
    return Belt_Array.map(Belt_List.reduceWithIndex(selector, [], function(splits, selectorNode5, index) {
        var maybeTagName = selectorNode5.tagName;
        if (maybeTagName !== undefined && DOM__Shadow$SmartcutsMacros.isNodeNameDocumentFragment(maybeTagName)) {
            var indexOfLastSlice = splits.length - 1 | 0;
            var lastSelectorSlice = indexOfLastSlice === -1 ? [] : Caml_array.get(splits, indexOfLastSlice);
            var newSelectorSlice = [];
            return $$Array.concat({
                hd: Belt_Array.slice(splits, 0, indexOfLastSlice),
                tl: {
                    hd: [
                        lastSelectorSlice
                    ],
                    tl: {
                        hd: index === (List.length(selector) - 1 | 0) ? [] : [
                            newSelectorSlice
                        ],
                        tl: /* [] */ 0
                    }
                }
            });
        }
        var indexOfLastSlice$1 = splits.length - 1 | 0;
        var lastSelectorSlice$1 = indexOfLastSlice$1 === -1 ? [] : Caml_array.get(splits, indexOfLastSlice$1);
        return $$Array.append(Belt_Array.slice(splits, 0, indexOfLastSlice$1), [
            $$Array.append(lastSelectorSlice$1, [
                selectorNode5
            ])
        ]);
    }), $$Array.to_list);
}
function factorOutDynamicVarsFromReverseSelector(remainingInnerTextLevelsOpt, reversedSelector) {
    var remainingInnerTextLevels = remainingInnerTextLevelsOpt !== undefined ? remainingInnerTextLevelsOpt : 2;
    if (!reversedSelector) {
        return {
            vars: [],
            factoredValue: reversedSelector
        };
    }
    var restReversedSelector = reversedSelector.tl;
    var lastNode = reversedSelector.hd;
    var innerText = lastNode.innerText;
    var match;
    if ((remainingInnerTextLevels - 1 | 0) === 0) {
        match = [
            [],
            restReversedSelector
        ];
    } else {
        var match$1 = factorOutDynamicVarsFromReverseSelector(remainingInnerTextLevels - 1 | 0, restReversedSelector);
        match = [
            match$1.vars,
            match$1.factoredValue
        ];
    }
    var nextRestReversedSelector = match[1];
    var nextVars = match[0];
    if (typeof innerText === "number") {
        if (innerText === /* Ignored */ 0) {
            return {
                vars: [],
                factoredValue: reversedSelector
            };
        } else {
            return {
                vars: [],
                factoredValue: reversedSelector
            };
        }
    } else if (innerText.TAG === /* FullInnerText */ 0) {
        return {
            vars: $$Array.append([
                innerText._0
            ], nextVars),
            factoredValue: {
                hd: {
                    id: lastNode.id,
                    tagName: lastNode.tagName,
                    classNames: lastNode.classNames,
                    attributes: lastNode.attributes,
                    index: lastNode.index,
                    innerText: {
                        TAG: /* FullInnerText */ 0,
                        _0: ""
                    },
                    isScrollable: lastNode.isScrollable,
                    attributeBlacklist: lastNode.attributeBlacklist
                },
                tl: nextRestReversedSelector
            }
        };
    } else {
        return {
            vars: $$Array.append([
                innerText._0
            ], nextVars),
            factoredValue: {
                hd: {
                    id: lastNode.id,
                    tagName: lastNode.tagName,
                    classNames: lastNode.classNames,
                    attributes: lastNode.attributes,
                    index: lastNode.index,
                    innerText: {
                        TAG: /* TruncatedInnerText */ 1,
                        _0: "",
                        _1: innerText._1
                    },
                    isScrollable: lastNode.isScrollable,
                    attributeBlacklist: lastNode.attributeBlacklist
                },
                tl: nextRestReversedSelector
            }
        };
    }
}
function factorOutDynamicVars(selector) {
    var reversedSelector = List.rev(selector);
    var match = factorOutDynamicVarsFromReverseSelector(undefined, reversedSelector);
    return {
        vars: match.vars,
        factoredValue: List.rev(match.factoredValue)
    };
}
function substituteInDynamicVarsForReverseSelector($staropt$star, param2) {
    var factoredReversedSelector = param2.factoredValue;
    var vars = param2.vars;
    var remainingInnerTextLevels = $staropt$star !== undefined ? $staropt$star : 2;
    if (!factoredReversedSelector) {
        return factoredReversedSelector;
    }
    var rest = factoredReversedSelector.tl;
    var lastNode = factoredReversedSelector.hd;
    var innerText = lastNode.innerText;
    var nextRest = (remainingInnerTextLevels - 1 | 0) === 0 ? rest : substituteInDynamicVarsForReverseSelector(remainingInnerTextLevels - 1 | 0, {
        vars: Belt_Array.slice(vars, 1, vars.length - 1 | 0),
        factoredValue: rest
    });
    if (typeof innerText === "number") {
        return {
            hd: lastNode,
            tl: nextRest
        };
    }
    if (innerText.TAG === /* FullInnerText */ 0) {
        var arg = Js_json.decodeString(Caml_array.get(vars, 0));
        var text = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expected inner text to be string");
        return {
            hd: {
                id: lastNode.id,
                tagName: lastNode.tagName,
                classNames: lastNode.classNames,
                attributes: lastNode.attributes,
                index: lastNode.index,
                innerText: {
                    TAG: /* FullInnerText */ 0,
                    _0: text
                },
                isScrollable: lastNode.isScrollable,
                attributeBlacklist: lastNode.attributeBlacklist
            },
            tl: nextRest
        };
    }
    var arg$1 = Js_json.decodeString(Caml_array.get(vars, 0));
    var text$1 = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected inner text to be string");
    return {
        hd: {
            id: lastNode.id,
            tagName: lastNode.tagName,
            classNames: lastNode.classNames,
            attributes: lastNode.attributes,
            index: lastNode.index,
            innerText: {
                TAG: /* TruncatedInnerText */ 1,
                _0: text$1,
                _1: innerText._1
            },
            isScrollable: lastNode.isScrollable,
            attributeBlacklist: lastNode.attributeBlacklist
        },
        tl: nextRest
    };
}
function substituteInDynamicVars(param) {
    return List.rev(substituteInDynamicVarsForReverseSelector(undefined, {
        vars: param.vars,
        factoredValue: List.rev(param.factoredValue)
    }));
}
var Pack = {
    factorOutDynamicVars: factorOutDynamicVars,
    substituteInDynamicVars: substituteInDynamicVars
};
var defaultKeepLastNLevelsOfInnerText = 2;
var maybeGetLeafNode = SelectorTree$SmartcutsMacros.maybeGetLeafNode;
exports.Attributes = Attributes;
exports.selectorNode_encode = selectorNode_encode;
exports.selectorNode_decode = selectorNode_decode;
exports.selector_encode = selector_encode;
exports.selector_decode = selector_decode;
exports.elementSelector_encode = elementSelector_encode;
exports.elementSelector_decode = elementSelector_decode;
exports.selectorNode = selectorNode;
exports.addNode = addNode;
exports.stringify = stringify;
exports.stringifyElementSelector = stringifyElementSelector;
exports.defaultKeepLastNLevelsOfInnerText = defaultKeepLastNLevelsOfInnerText;
exports.hasSelectionCapability = hasSelectionCapability;
exports.deepEquals = deepEquals;
exports.shouldIgnoreId = shouldIgnoreId;
exports.attributesToAvoidComparing = attributesToAvoidComparing;
exports.pruneSelectorTreeNodeUsingOriginBlacklist = pruneSelectorTreeNodeUsingOriginBlacklist;
exports.toCssSelectorUsingTagChainAndAttributeExistence = toCssSelectorUsingTagChainAndAttributeExistence;
exports.removeGeneratedIdsFromSelector = removeGeneratedIdsFromSelector;
exports.blacklistAttributeValues = blacklistAttributeValues;
exports.forDomElement = forDomElement;
exports.forHtmlElement = forHtmlElement;
exports.forDomEventTarget = forDomEventTarget;
exports.forDomEvent = forDomEvent;
exports.$$Node = $$Node;
exports.stripGeneratedIds = stripGeneratedIds$1;
exports.getCommonAncestor = getCommonAncestor;
exports.selectsParentOrEquivElement = selectsParentOrEquivElement;
exports.isSame = isSame;
exports.nodeWithExtraAttributes = nodeWithExtraAttributes;
exports.maybeGetLeafNode = maybeGetLeafNode;
exports.updateLeafNode = updateLeafNode;
exports.maybeGetLeafAnchor = maybeGetLeafAnchor;
exports.isContentEditable = isContentEditable;
exports.toCssSelectorForPattern = toCssSelectorForPattern;
exports.splitForShadowDom = splitForShadowDom;
exports.Pack = Pack; /* Webapi__Dom__Element Not a pure module */ 


/***/ }),

/***/ 80424:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
function t_encode(encoder_semantic, v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "semantic",
            Curry._1(encoder_semantic, v.semantic)
        ]
    ]);
}
function t_decode(decoder_semantic, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var semantic = Curry._1(decoder_semantic, Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
        if (semantic.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    semantic: semantic._0
                }
            };
        }
        var e = semantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantic" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(stringifySemantic, param) {
    return "{selector=" + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", semantic=" + (Curry._1(stringifySemantic, param.semantic) + "}")));
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 89403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var $$String = __webpack_require__(65760);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Json_decode = __webpack_require__(50957);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var DevProtocol__CSS$SmartcutsMacros = __webpack_require__(81466);
var DevProtocol__DOM$SmartcutsMacros = __webpack_require__(58637);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var DevProtocol__DOMHelpers$SmartcutsMacros = __webpack_require__(21434);
function getCurrentUrl(param1) {
    return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
        return OptionUtils$SmartcutsMacros.getExn("Expect to get Some(url) when getCurrentUrl() in Background", param.url);
    }, Browser__Tabs$SmartcutsMacros.get(param1.tabId));
}
function getNodeIdBackendNodeIdPairsForNodeIds(tabId, nodeIds) {
    return Promise.all($$Array.map(function(nodeId) {
        return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeNode) {
            return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, function(node) {
                return [
                    nodeId,
                    node.backendNodeId
                ];
            }));
        });
    }, nodeIds)).then(function(maybeElements) {
        return Promise.resolve(ArrayUtils$SmartcutsMacros.filterMap(function(a) {
            return a;
        }, maybeElements));
    });
}
function querySelectorAll(context, queryRoot, maybeDomTree, _includeElementsNotVisible, selectorExpression) {
    var tabId = context.tabId;
    var query = function query(param2) {
        return DevProtocol__DOM$SmartcutsMacros.querySelectorAll(param2[0], selectorExpression, tabId, undefined, undefined, undefined).then(function(param) {
            return getNodeIdBackendNodeIdPairsForNodeIds(tabId, param);
        });
    };
    if (typeof queryRoot === "number") {
        return (maybeDomTree !== undefined ? Promise.resolve(Caml_option.some(Caml_option.valFromOption(maybeDomTree))) : DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined)).then(function(maybeDocument) {
            if (maybeDocument === undefined) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: /* CdpUnableToGetDocument */ 1
                });
            }
            var rootNode = Caml_option.valFromOption(maybeDocument);
            return PromiseUtils$SmartcutsMacros.map(query([
                rootNode.nodeId,
                rootNode.backendNodeId
            ]), function(element) {
                return {
                    TAG: /* Ok */ 0,
                    _0: element
                };
            });
        });
    } else if (queryRoot.TAG === /* Element */ 0) {
        return PromiseUtils$SmartcutsMacros.map(query(queryRoot._0), function(element) {
            return {
                TAG: /* Ok */ 0,
                _0: element
            };
        });
    } else {
        return PromiseUtils$SmartcutsMacros.map(query(queryRoot._0), function(element) {
            return {
                TAG: /* Ok */ 0,
                _0: element
            };
        });
    }
}
function isJsExnNodeIdFailure(jsExn) {
    var message = jsExn.message;
    var maybeErrorCode;
    if (message !== undefined) {
        try {
            maybeErrorCode = Json_decode.field("code", Json_decode.$$int, JSON.parse(message));
        } catch (exn) {
            maybeErrorCode = undefined;
        }
    } else {
        maybeErrorCode = undefined;
    }
    return Caml_obj.caml_equal(maybeErrorCode, -32000);
}
function shouldRetryForJsPromiseError(queryRoot, jsPromiseError) {
    var jsPromiseError$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
    var exit = 0;
    var jsExn;
    if (typeof jsPromiseError$1 === "number") {
        if (jsPromiseError$1 === /* PromiseCanceled */ 1) {
            return false;
        }
    } else {
        switch(jsPromiseError$1.TAG | 0){
            case /* JsExn */ 0:
                jsExn = jsPromiseError$1._0;
                exit = 2;
                break;
            case /* WaitForPredicateError */ 9:
                var jsExn$1 = jsPromiseError$1._0;
                if (typeof jsExn$1 !== "number" && jsExn$1.TAG === /* JsExn */ 0) {
                    jsExn = jsExn$1._0;
                    exit = 2;
                }
                break;
            case /* UnknownPromiseError */ 13:
                console.warn("Unknown promise error", jsPromiseError$1._0);
                return false;
            default:
        }
    }
    if (exit === 2 && isJsExnNodeIdFailure(jsExn)) {
        console.warn("NodeId or compute box model error", jsExn);
        var match = jsExn.message;
        if (match === '{"code":-32000,"message":"Could not compute box model."}') {
            return true;
        } else {
            return queryRoot === /* Document */ 0;
        }
    }
    console.warn("Other js promise error", jsPromiseError);
    return false;
}
function queryXPath(param, param$1, addCancelCallback, xpath) {
    var tabId = param.tabId;
    return DevProtocol__DOM$SmartcutsMacros.enable(tabId, undefined, undefined, undefined).then(function(param) {
        return DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined).then(function(param) {
            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return DevProtocol__DOM$SmartcutsMacros.performSearch(tabId, undefined, undefined, true, xpath, undefined);
            });
            Curry._1(addCancelCallback, match[1]);
            return Curry._1(match[0], undefined);
        }).then(function(maybeResult1) {
            if (maybeResult1 === undefined) {
                return Promise.resolve([]);
            }
            var resultCount = maybeResult1.resultCount;
            if (resultCount === 0) {
                return Promise.resolve([]);
            }
            var searchId = maybeResult1.searchId;
            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return DevProtocol__DOM$SmartcutsMacros.getSearchResults(tabId, undefined, undefined, searchId, 0, resultCount, undefined);
            });
            Curry._1(addCancelCallback, match[1]);
            return Curry._1(match[0], undefined).then(function(maybeResult) {
                if (maybeResult !== undefined) {
                    return Promise.resolve(maybeResult.nodeIds);
                } else {
                    return Promise.resolve([]);
                }
            });
        });
    }).then(function(nodeIds) {
        var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
            if (isCanceled.contents) {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                    Error: new Error()
                };
            }
            return getNodeIdBackendNodeIdPairsForNodeIds(tabId, nodeIds);
        });
        Curry._1(addCancelCallback, match[1]);
        return Curry._1(match[0], undefined);
    });
}
function getTagName(param, param$1) {
    return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, param$1[1], undefined, undefined, undefined, param.tabId, undefined, undefined, undefined).then(function(maybeNode) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, function(prim) {
            return prim.nodeName;
        }));
    });
}
function couldElementMatchSelectorTreeNode(context, element, node) {
    return getTagName(context, element).then(function(maybeTagName) {
        return Promise.resolve(Caml_obj.caml_equal(OptionUtils$SmartcutsMacros.map(maybeTagName, $$String.lowercase_ascii), node.tagName));
    });
}
function isVisibleOnPage(param, param$1) {
    return DevProtocol__DOMHelpers$SmartcutsMacros.getBoxModel(undefined, param$1[1], undefined, param.tabId, undefined, undefined, undefined).then(function(maybeBoxModel) {
        if (maybeBoxModel !== undefined) {
            return Promise.resolve(!(maybeBoxModel.width === 0 && maybeBoxModel.height === 0));
        } else {
            return Promise.resolve(false);
        }
    }).catch(function(jsPromiseError) {
        var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
        if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */ 0 && Caml_obj.caml_equal(jsExn._0.message, '{"code":-32000,"message":"Could not compute box model."}'))) {
            return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
        } else {
            return Promise.resolve(false);
        }
    });
}
function getInnerTextForNode(tabId, addCancelCallback1, node) {
    if (node.nodeName === "#text") {
        return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback1, function(addCancelCallback) {
            var nonZeroNodeId = node.nodeId;
            return (nonZeroNodeId !== 0 ? Promise.resolve(nonZeroNodeId) : DevProtocol__DOMHelpers$SmartcutsMacros.getNodeIdFromBackendNodeId(tabId, node.backendNodeId, addCancelCallback).then(function(maybeNodeId) {
                return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(0, maybeNodeId));
            })).then(function(nodeId) {
                return DevProtocol__DOMHelpers$SmartcutsMacros.isNodeVisible(tabId, addCancelCallback, nodeId);
            }).then(function(isVisible) {
                return Promise.resolve(isVisible ? node.nodeValue : "");
            });
        });
    }
    var children = node.children;
    if (children !== undefined) {
        return Promise.all(Belt_Array.map(children, function(param) {
            return getInnerTextForNode(tabId, addCancelCallback1, param);
        })).then(function(innerTexts) {
            return Promise.resolve(innerTexts.join(""));
        });
    } else {
        return Promise.resolve("");
    }
}
function fetchDomTree(param, addCancelCallback) {
    var tabId = param.tabId;
    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return DevProtocol__DOM$SmartcutsMacros.getDocument(/* EntireSubTree */ 0, true, tabId, undefined, undefined, undefined);
    });
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined);
}
function getParentElement(domTree, param) {
    var arg = DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, param[1]);
    var param$1 = function param$1(parentNode) {
        var match = parentNode.nodeName;
        switch(match){
            case "#document":
            case "HTML":
                return;
            default:
                return [
                    parentNode.nodeId,
                    parentNode.backendNodeId
                ];
        }
    };
    return OptionUtils$SmartcutsMacros.andThen(param$1, arg);
}
function getParentChainInner($staropt$star, domTree, element) {
    var backendNodeId = element[1];
    var chain = $staropt$star !== undefined ? $staropt$star : [];
    if (domTree.backendNodeId === backendNodeId) {
        return $$Array.append(chain, [
            element
        ]);
    }
    var match1 = domTree.children;
    var match$1 = domTree.shadowRoots;
    var exit = 0;
    var childrenNodes;
    var shadowRoots;
    if (match1 !== undefined) {
        var exit$1 = 0;
        if (match1.length !== 0) {
            exit$1 = 3;
        } else {
            if (match$1 === undefined) {
                return;
            }
            if (match$1.length === 0) {
                return;
            }
            exit$1 = 3;
        }
        if (exit$1 === 3) {
            if (match$1 !== undefined && match$1.length !== 0) {
                if (match1.length !== 0) {
                    var fullChain = Util$SmartcutsMacros.shortcut(function(subTree) {
                        var match = domTree.nodeName;
                        var nextChain;
                        switch(match){
                            case "#document":
                            case "HTML":
                            case "html":
                                nextChain = chain;
                                break;
                            default:
                                nextChain = $$Array.append(chain, [
                                    [
                                        domTree.nodeId,
                                        domTree.backendNodeId
                                    ]
                                ]);
                        }
                        return getParentChainInner(nextChain, subTree, element);
                    }, match$1);
                    if (fullChain !== undefined) {
                        return fullChain;
                    } else {
                        return Util$SmartcutsMacros.shortcut(function(subTree) {
                            var match = domTree.nodeName;
                            var nextChain;
                            switch(match){
                                case "#document":
                                case "HTML":
                                case "html":
                                    nextChain = chain;
                                    break;
                                default:
                                    nextChain = $$Array.append(chain, [
                                        [
                                            domTree.nodeId,
                                            domTree.backendNodeId
                                        ]
                                    ]);
                            }
                            return getParentChainInner(nextChain, subTree, element);
                        }, match1);
                    }
                }
                shadowRoots = match$1;
                exit = 2;
            } else {
                childrenNodes = match1;
                exit = 1;
            }
        }
    } else {
        if (match$1 === undefined) {
            return;
        }
        if (match$1.length === 0) {
            return;
        }
        shadowRoots = match$1;
        exit = 2;
    }
    switch(exit){
        case 1:
            return Util$SmartcutsMacros.shortcut(function(subTree) {
                var match = domTree.nodeName;
                var nextChain;
                switch(match){
                    case "#document":
                    case "HTML":
                    case "html":
                        nextChain = chain;
                        break;
                    default:
                        nextChain = $$Array.append(chain, [
                            [
                                domTree.nodeId,
                                domTree.backendNodeId
                            ]
                        ]);
                }
                return getParentChainInner(nextChain, subTree, element);
            }, childrenNodes);
        case 2:
            if (Belt_Array.some(shadowRoots, function(shadowRoot) {
                return shadowRoot.backendNodeId === backendNodeId;
            })) {
                return chain;
            } else {
                return Util$SmartcutsMacros.shortcut(function(subTree) {
                    var match = domTree.nodeName;
                    var nextChain;
                    switch(match){
                        case "#document":
                        case "HTML":
                        case "html":
                            nextChain = chain;
                            break;
                        default:
                            nextChain = $$Array.append(chain, [
                                [
                                    domTree.nodeId,
                                    domTree.backendNodeId
                                ]
                            ]);
                    }
                    return getParentChainInner(nextChain, subTree, element);
                }, shadowRoots);
            }
    }
}
function getParentChain(domTree, element) {
    var arg = getParentChainInner([], domTree, element);
    var param = [];
    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}
function getParentElements(domTree, elements) {
    return $$Array.map(function(maybeParent) {
        return OptionUtils$SmartcutsMacros.map(maybeParent, function(parentNode) {
            return [
                parentNode.nodeId,
                parentNode.backendNodeId
            ];
        });
    }, $$Array.map(function(param) {
        return DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, param[1]);
    }, elements));
}
function getSiblingIndex(domTree, param3) {
    var backendNodeId = param3[1];
    var parentNode = DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, backendNodeId);
    if (parentNode === undefined) {
        return 1;
    }
    var arg = Caml_option.valFromOption(parentNode).children;
    var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
    var arg$2 = Belt_Array.getIndexBy(function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }([]), function(childNode) {
        return childNode.backendNodeId === backendNodeId;
    });
    return 1 + function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
    }(0) | 0;
}
function describeNode(domTree, backendNodeId) {
    if (domTree.backendNodeId === backendNodeId) {
        return Caml_option.some(domTree);
    }
    var match = domTree.children;
    var match$1 = domTree.shadowRoots;
    var exit = 0;
    var childrenNodes;
    var shadowRoots;
    if (match !== undefined) {
        var exit$1 = 0;
        if (match.length !== 0) {
            exit$1 = 3;
        } else {
            if (match$1 === undefined) {
                return;
            }
            if (match$1.length === 0) {
                return;
            }
            exit$1 = 3;
        }
        if (exit$1 === 3) {
            if (match$1 !== undefined && match$1.length !== 0) {
                if (match.length !== 0) {
                    var matchingNode = Belt_Array.getBy(match$1, function(subTree) {
                        return subTree.backendNodeId === backendNodeId;
                    });
                    if (matchingNode !== undefined) {
                        return Caml_option.some(Caml_option.valFromOption(matchingNode));
                    }
                    var matchingNode$1 = Belt_Array.getBy(match, function(subTree) {
                        return subTree.backendNodeId === backendNodeId;
                    });
                    if (matchingNode$1 !== undefined) {
                        return Caml_option.some(Caml_option.valFromOption(matchingNode$1));
                    }
                    var matchingNode$2 = Util$SmartcutsMacros.shortcut(function(subTree) {
                        return describeNode(subTree, backendNodeId);
                    }, match$1);
                    if (matchingNode$2 !== undefined) {
                        return Caml_option.some(Caml_option.valFromOption(matchingNode$2));
                    }
                    var matchingNode$3 = Util$SmartcutsMacros.shortcut(function(subTree) {
                        return describeNode(subTree, backendNodeId);
                    }, match);
                    if (matchingNode$3 !== undefined) {
                        return Caml_option.some(Caml_option.valFromOption(matchingNode$3));
                    } else {
                        return;
                    }
                }
                shadowRoots = match$1;
                exit = 2;
            } else {
                childrenNodes = match;
                exit = 1;
            }
        }
    } else {
        if (match$1 === undefined) {
            return;
        }
        if (match$1.length === 0) {
            return;
        }
        shadowRoots = match$1;
        exit = 2;
    }
    switch(exit){
        case 1:
            return Util$SmartcutsMacros.shortcut(function(subTree) {
                return describeNode(subTree, backendNodeId);
            }, childrenNodes);
        case 2:
            return Util$SmartcutsMacros.shortcut(function(subTree) {
                return describeNode(subTree, backendNodeId);
            }, shadowRoots);
    }
}
function getDomShadowRoot(domTree, param4) {
    var arg1 = describeNode(domTree, param4[1]);
    var param$1 = function param$1(cdpDomNode1) {
        var arg = cdpDomNode1.shadowRoots;
        var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
        return OptionUtils$SmartcutsMacros.map(function(param) {
            return OptionUtils$SmartcutsMacros.andThen(param, arg$1);
        }(function(shadowRoots) {
            return Belt_Array.get(shadowRoots, 0);
        }), function(cdpDomNode) {
            return [
                cdpDomNode.nodeId,
                cdpDomNode.backendNodeId
            ];
        });
    };
    return OptionUtils$SmartcutsMacros.andThen(param$1, arg1);
}
function getElementFromDomTreeByBackendNodeId(domTree, backendNodeId) {
    var arg = describeNode(domTree, backendNodeId);
    return [
        function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect to find node with backendNodeId when getElementFromDomTreeByBackendNodeId()").nodeId,
        backendNodeId
    ];
}
function getElementAttributes(domTree, param) {
    var node = describeNode(domTree, param[1]);
    if (node === undefined) {
        return;
    }
    var arg = OptionUtils$SmartcutsMacros.map(Caml_option.undefined_to_opt(Caml_option.valFromOption(node).attributes), function(attributes) {
        return Belt_MapString.fromArray(ArrayUtils$SmartcutsMacros.groupIntoPairs(attributes));
    });
    var param$1;
    return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
}
function idFromAttributes(attributes) {
    return Belt_MapString.get(attributes, "id");
}
function classNamesFromAttributes(attributes) {
    var arg = OptionUtils$SmartcutsMacros.map(Belt_MapString.get(attributes, "class"), function(attr) {
        return Belt_Array.keepMap(attr.split(/\n+/), function(x) {
            return x;
        });
    });
    var param = [];
    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}
function keepAttributes(f, attributes) {
    return Belt_MapString.fromArray(Belt_Array.keep(Belt_MapString.toArray(attributes), function(param) {
        return Curry._2(f, param[0], param[1]);
    }));
}
function getUpdatedElementFromDomTree(domTree, param) {
    return getElementFromDomTreeByBackendNodeId(domTree, param[1]);
}
function getNthParent(domTree1, nth1, element) {
    var backendNodeIdOfNthParent = function(nth, domTree, backendNodeId) {
        if (nth === 0) {
            return backendNodeId;
        } else {
            return Belt_Option.flatMap(DevProtocol__DOMHelpers$SmartcutsMacros.getParentInDomTree(domTree, backendNodeId), function(node) {
                var arg = node.backendNodeId;
                var param = nth - 1 | 0;
                return backendNodeIdOfNthParent(param, domTree, arg);
            });
        }
    };
    if (nth1 === 0) {
        return element;
    }
    var func = function func(param, param$1) {
        return backendNodeIdOfNthParent(nth1, param, param$1);
    };
    return Belt_Option.map(Curry._2(func, domTree1, element[1]), function(param) {
        return getElementFromDomTreeByBackendNodeId(domTree1, param);
    });
}
function getInnerTextForElement(param, addCancelCallback2, param$1) {
    var backendNodeId = param$1[1];
    var nodeId = param$1[0];
    var tabId = param.tabId;
    return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback2, function(addCancelCallback) {
        return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, backendNodeId, undefined, /* EntireSubTree */ 0, false, tabId, undefined, undefined, undefined).then(function(maybeNode) {
            if (maybeNode !== undefined) {
                return getInnerTextForNode(tabId, addCancelCallback, Caml_option.valFromOption(maybeNode)).then(function(innerText) {
                    var trimmedInnerText = innerText.trim();
                    return Promise.resolve(trimmedInnerText === "" ? /* NoInnerText */ 1 : {
                        TAG: /* FullInnerText */ 0,
                        _0: trimmedInnerText
                    });
                });
            } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Couldn't find node: " + String(nodeId));
            }
        });
    });
}
function isElementEqualTo(param, param$1) {
    return param[1] === param$1[1];
}
function getScrollHeight(param, param$1) {
    return DevProtocol__DOMHelpers$SmartcutsMacros.getScrollHeight(param.tabId, param$1[1]).then(function(maybeScrollHeight) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expect to get Some(scrollHeight) for an element", maybeScrollHeight) | 0);
    });
}
function getClientHeight(param, param$1) {
    return PromiseUtils$SmartcutsMacros.resolveWith(function(maybeClientHeight) {
        return OptionUtils$SmartcutsMacros.withDefault(0, maybeClientHeight);
    }, DevProtocol__DOMHelpers$SmartcutsMacros.getClientHeight(param.tabId, param$1[0]));
}
function getOverflowYForElement(param5, param$1) {
    var nodeId = param$1[0];
    var tabId = param5.tabId;
    return DevProtocol__CSS$SmartcutsMacros.enable(tabId, undefined, undefined, undefined).then(function(param6) {
        return DevProtocol__CSS$SmartcutsMacros.getComputedStyleForNode(nodeId, tabId, undefined, undefined, undefined).then(function(maybeStyles) {
            var styles = OptionUtils$SmartcutsMacros.withDefault([], maybeStyles);
            var match = Belt_Array.getBy(styles, function(param) {
                return param.name === "overflowY";
            });
            if (match !== undefined) {
                return Promise.resolve(match.value);
            } else {
                return Promise.resolve("");
            }
        });
    });
}
function scrollTo(param, x, y, param$1) {
    return DevProtocol__DOMHelpers$SmartcutsMacros.scrollTo(param.tabId, param$1[0], x, y, undefined);
}
var maxRetries = 3;
exports.getCurrentUrl = getCurrentUrl;
exports.querySelectorAll = querySelectorAll;
exports.maxRetries = maxRetries;
exports.shouldRetryForJsPromiseError = shouldRetryForJsPromiseError;
exports.queryXPath = queryXPath;
exports.getTagName = getTagName;
exports.couldElementMatchSelectorTreeNode = couldElementMatchSelectorTreeNode;
exports.isVisibleOnPage = isVisibleOnPage;
exports.fetchDomTree = fetchDomTree;
exports.getParentElement = getParentElement;
exports.getParentChainInner = getParentChainInner;
exports.getParentChain = getParentChain;
exports.getParentElements = getParentElements;
exports.getSiblingIndex = getSiblingIndex;
exports.getDomShadowRoot = getDomShadowRoot;
exports.getElementAttributes = getElementAttributes;
exports.idFromAttributes = idFromAttributes;
exports.classNamesFromAttributes = classNamesFromAttributes;
exports.keepAttributes = keepAttributes;
exports.getUpdatedElementFromDomTree = getUpdatedElementFromDomTree;
exports.getNthParent = getNthParent;
exports.getInnerTextForElement = getInnerTextForElement;
exports.isElementEqualTo = isElementEqualTo;
exports.getScrollHeight = getScrollHeight;
exports.getClientHeight = getClientHeight;
exports.getOverflowYForElement = getOverflowYForElement;
exports.scrollTo = scrollTo; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 95418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Command$SmartcutsMacros = __webpack_require__(4290);
var ImageKit$SmartcutsMacros = __webpack_require__(48421);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var CommandLog$SmartcutsMacros = __webpack_require__(23831);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var Screenshot$SmartcutsMacros = __webpack_require__(80449);
var LoopCommand$SmartcutsMacros = __webpack_require__(67259);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var TypeCommand$SmartcutsMacros = __webpack_require__(92095);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var RadioCommand$SmartcutsMacros = __webpack_require__(84259);
var LoginSmartcut$SmartcutsMacros = __webpack_require__(26553);
var SelectCommand$SmartcutsMacros = __webpack_require__(16997);
var UploadCommand$SmartcutsMacros = __webpack_require__(68210);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var UrlLevenshtein$SmartcutsMacros = __webpack_require__(31682);
var CheckboxCommand$SmartcutsMacros = __webpack_require__(50108);
var DownloadCommand$SmartcutsMacros = __webpack_require__(59170);
var PlaybackOptions$SmartcutsMacros = __webpack_require__(84094);
var URLRelatedCommands$SmartcutsMacros = __webpack_require__(9697);
var GoogleSheetsCommand$SmartcutsMacros = __webpack_require__(39968);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var WithElementGroupsCommand$SmartcutsMacros = __webpack_require__(10160);
var CommandValueConfigurability$SmartcutsMacros = __webpack_require__(32527);
var InnerTextSemanticParamDescriptor$SmartcutsMacros = __webpack_require__(33143);
function param_encode(v) {
    switch(v.TAG | 0){
        case /* AddTextInputParam */ 0:
            return [
                "AddTextInputParam",
                Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.t_encode, v._0)
            ];
        case /* InnerTextParam */ 1:
            return [
                "InnerTextParam",
                InnerTextSemanticParamDescriptor$SmartcutsMacros.t_encode(v._0)
            ];
        case /* CheckboxParam */ 2:
            return [
                "CheckboxParam",
                CheckboxCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* SelectInputParam */ 3:
            return [
                "SelectInputParam",
                SelectCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* RadioInputParam */ 4:
            return [
                "RadioInputParam",
                RadioCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* URLParam */ 5:
            return [
                "URLParam",
                URLRelatedCommands$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* DownloadParam */ 6:
            return [
                "DownloadParam",
                DownloadCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* GoogleSheetsParam */ 7:
            return [
                "GoogleSheetsParam",
                GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* LoopParam */ 8:
            return [
                "LoopParam",
                LoopCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* UploadParam */ 9:
            return [
                "UploadParam",
                UploadCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
        case /* WithElementGroupsParam */ 10:
            return [
                "WithElementGroupsParam",
                WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
            ];
    }
}
function param_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AddTextInputParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AddTextInputParam */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "CheckboxParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = CheckboxCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CheckboxParam */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DownloadParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = DownloadCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadParam */ 6,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "GoogleSheetsParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GoogleSheetsParam */ 7,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "InnerTextParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = InnerTextSemanticParamDescriptor$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InnerTextParam */ 1,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "LoopParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = LoopCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoopParam */ 8,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "RadioInputParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = RadioCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RadioInputParam */ 4,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "SelectInputParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = SelectCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectInputParam */ 3,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "URLParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$8 = URLRelatedCommands$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* URLParam */ 5,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "UploadParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$9 = UploadCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UploadParam */ 9,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "WithElementGroupsParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$10 = WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WithElementGroupsParam */ 10,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function getPlaybackFormLabelFromParam(param) {
    switch(param.TAG | 0){
        case /* InnerTextParam */ 1:
            return InnerTextSemanticParamDescriptor$SmartcutsMacros.getPlaybackFormLabelFromParam(param._0);
        case /* CheckboxParam */ 2:
            return param._0.playbackFormLabel;
        case /* DownloadParam */ 6:
            return DownloadCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
        case /* GoogleSheetsParam */ 7:
            return GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
        case /* URLParam */ 5:
        case /* LoopParam */ 8:
            return;
        case /* UploadParam */ 9:
            return UploadCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
        case /* WithElementGroupsParam */ 10:
            return WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
        default:
            return param._0.playbackFormLabel;
    }
}
function minifyParam(param) {
    return param;
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "firstCommandIndex",
            Decco.intToJson(v.firstCommandIndex)
        ],
        [
            "otherCommandIndexes",
            Decco.listToJson(Decco.intToJson, v.otherCommandIndexes)
        ],
        [
            "param",
            param_encode(v.param)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var firstCommandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstCommandIndex"), null));
    if (firstCommandIndex.TAG === /* Ok */ 0) {
        var otherCommandIndexes = Decco.listFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "otherCommandIndexes"), null));
        if (otherCommandIndexes.TAG === /* Ok */ 0) {
            var param = param_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "param"), null));
            if (param.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        firstCommandIndex: firstCommandIndex._0,
                        otherCommandIndexes: otherCommandIndexes._0,
                        param: param._0
                    }
                };
            }
            var e = param._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".param" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = otherCommandIndexes._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".otherCommandIndexes" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = firstCommandIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".firstCommandIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function toGraphql(param) {
    return {
        firstCommandIndex: param.firstCommandIndex,
        otherCommandIndexes: $$Array.of_list(param.otherCommandIndexes),
        param: JSON.stringify(param_encode(param.param))
    };
}
function minify(param) {
    return {
        firstCommandIndex: param.firstCommandIndex,
        otherCommandIndexes: param.otherCommandIndexes,
        param: param.param
    };
}
function removePrivateInfo(paramDescriptor) {
    var param = paramDescriptor.param;
    var param$1;
    switch(param.TAG | 0){
        case /* AddTextInputParam */ 0:
            var match = param._0;
            var enums = match.enums;
            var match$1 = match.originalLabeledAddText;
            var addText = match$1.addText;
            var match$2 = Belt_Option.flatMap(enums, function($$enum) {
                return Belt_Array.get($$enum, 0);
            });
            var tmp;
            tmp = addText.TAG === /* StaticText */ 0 ? match$2 !== undefined ? {
                TAG: /* StaticText */ 0,
                _0: match$2
            } : {
                TAG: /* StaticText */ 0,
                _0: "Please insert text here"
            } : addText;
            param$1 = {
                TAG: /* AddTextInputParam */ 0,
                _0: {
                    targetLocator: match.targetLocator,
                    originalLabeledAddText: {
                        label: match$1.label,
                        addText: tmp
                    },
                    playbackFormLabel: match.playbackFormLabel,
                    enums: enums
                }
            };
            break;
        case /* InnerTextParam */ 1:
            param$1 = {
                TAG: /* InnerTextParam */ 1,
                _0: InnerTextSemanticParamDescriptor$SmartcutsMacros.removePrivateInfo(param._0)
            };
            break;
        case /* CheckboxParam */ 2:
            var match$3 = param._0;
            var match$4 = match$3.originalCheckboxChoice;
            if (match$4.TAG === /* SingleCheckbox */ 0) {
                param$1 = {
                    TAG: /* CheckboxParam */ 2,
                    _0: {
                        originalCheckboxChoice: {
                            TAG: /* SingleCheckbox */ 0,
                            _0: match$4._0,
                            _1: false
                        },
                        playbackFormLabel: match$3.playbackFormLabel
                    }
                };
            } else {
                var match$5 = match$4._0;
                param$1 = {
                    TAG: /* CheckboxParam */ 2,
                    _0: {
                        originalCheckboxChoice: {
                            TAG: /* CheckboxGroup */ 1,
                            _0: {
                                name: match$5.name,
                                checkedValues: /* [] */ 0,
                                options: match$5.options
                            }
                        },
                        playbackFormLabel: match$3.playbackFormLabel
                    }
                };
            }
            break;
        case /* SelectInputParam */ 3:
            var match$6 = param._0;
            var match$7 = match$6.originalLabeledValue;
            var match$8 = match$7.value;
            param$1 = {
                TAG: /* SelectInputParam */ 3,
                _0: {
                    targetLocator: match$6.targetLocator,
                    originalLabeledValue: {
                        label: match$7.label,
                        value: {
                            options: match$8.options,
                            selectedIndex: match$8.selectedIndex
                        }
                    },
                    playbackFormLabel: match$6.playbackFormLabel
                }
            };
            break;
        case /* RadioInputParam */ 4:
            var match$9 = param._0;
            var match$10 = match$9.originalLabeledValue;
            param$1 = {
                TAG: /* RadioInputParam */ 4,
                _0: {
                    targetLocator: match$9.targetLocator,
                    originalLabeledValue: {
                        label: match$10.label,
                        value: match$10.value
                    },
                    playbackFormLabel: match$9.playbackFormLabel
                }
            };
            break;
        case /* DownloadParam */ 6:
            param$1 = {
                TAG: /* DownloadParam */ 6,
                _0: DownloadCommand$SmartcutsMacros.ParamDescriptor.removePrivateInfo(param._0)
            };
            break;
        case /* GoogleSheetsParam */ 7:
            var match$11 = param._0;
            if (match$11.TAG === /* UpdateCellParam */ 0) {
                var match$12 = match$11._0;
                param$1 = {
                    TAG: /* GoogleSheetsParam */ 7,
                    _0: {
                        TAG: /* UpdateCellParam */ 0,
                        _0: {
                            spreadsheetId: "Insert sheet id here",
                            sheetName: "Insert sheet name here",
                            colNames: match$12.colNames,
                            keyColumnIndex: match$12.keyColumnIndex,
                            keyColumnValue: match$12.keyColumnValue,
                            updatedColIndex: match$12.updatedColIndex,
                            cellUpdate: match$12.cellUpdate,
                            playbackFormLabel: match$12.playbackFormLabel
                        }
                    }
                };
            } else {
                var match$13 = match$11._0;
                param$1 = {
                    TAG: /* GoogleSheetsParam */ 7,
                    _0: {
                        TAG: /* UpsertRowParam */ 1,
                        _0: {
                            spreadsheetId: "Insert sheet id here",
                            sheetName: "Insert sheet name here",
                            colNames: match$13.colNames,
                            keyColumnIndex: match$13.keyColumnIndex,
                            keyColumnValue: match$13.keyColumnValue,
                            rowData: match$13.rowData,
                            playbackFormLabel: match$13.playbackFormLabel
                        }
                    }
                };
            }
            break;
        case /* URLParam */ 5:
        case /* LoopParam */ 8:
            param$1 = param;
            break;
        case /* UploadParam */ 9:
            param$1 = {
                TAG: /* UploadParam */ 9,
                _0: param._0
            };
            break;
        case /* WithElementGroupsParam */ 10:
            param$1 = {
                TAG: /* WithElementGroupsParam */ 10,
                _0: WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.removePrivateInfo(param._0)
            };
            break;
    }
    return {
        firstCommandIndex: paramDescriptor.firstCommandIndex,
        otherCommandIndexes: paramDescriptor.otherCommandIndexes,
        param: param$1
    };
}
function maybeFromCommandValueConfigurability(param1) {
    var config = param1.config;
    var otherCommandIndexes = param1.otherCommandIndexes;
    var firstCommandIndex = param1.firstCommandIndex;
    var maybeParam;
    switch(config.TAG | 0){
        case /* AddTextInputConfig */ 0:
            maybeParam = {
                TAG: /* AddTextInputParam */ 0,
                _0: Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.fromAuthoringConfig, config._0)
            };
            break;
        case /* InnerTextConfig */ 2:
            maybeParam = OptionUtils$SmartcutsMacros.map(InnerTextSemanticParamDescriptor$SmartcutsMacros.fromAuthoringConfig(config._0), function(paramDescriptor) {
                return {
                    TAG: /* InnerTextParam */ 1,
                    _0: paramDescriptor
                };
            });
            break;
        case /* CheckboxConfig */ 3:
            maybeParam = {
                TAG: /* CheckboxParam */ 2,
                _0: CheckboxCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
            };
            break;
        case /* SelectInputConfig */ 4:
            maybeParam = {
                TAG: /* SelectInputParam */ 3,
                _0: SelectCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
            };
            break;
        case /* RadioInputConfig */ 5:
            maybeParam = {
                TAG: /* RadioInputParam */ 4,
                _0: RadioCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
            };
            break;
        case /* URLConfig */ 6:
            maybeParam = {
                TAG: /* URLParam */ 5,
                _0: URLRelatedCommands$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
            };
            break;
        case /* DownloadConfig */ 12:
            maybeParam = {
                TAG: /* DownloadParam */ 6,
                _0: DownloadCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
            };
            break;
        case /* GoogleSheetsConfig */ 13:
            var param$1 = GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.fromCommandValueConfigurability(config._0);
            maybeParam = {
                TAG: /* GoogleSheetsParam */ 7,
                _0: param$1
            };
            break;
        case /* LoopConfig */ 16:
            var param$2 = LoopCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
            maybeParam = {
                TAG: /* LoopParam */ 8,
                _0: param$2
            };
            break;
        case /* UploadConfig */ 17:
            var param$3 = UploadCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
            maybeParam = {
                TAG: /* UploadParam */ 9,
                _0: param$3
            };
            break;
        case /* WithElementGroupsConfig */ 18:
            var param$4 = WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
            maybeParam = {
                TAG: /* WithElementGroupsParam */ 10,
                _0: param$4
            };
            break;
        default:
            maybeParam = undefined;
    }
    return OptionUtils$SmartcutsMacros.map(maybeParam, function(param) {
        return {
            firstCommandIndex: firstCommandIndex,
            otherCommandIndexes: otherCommandIndexes,
            param: param
        };
    });
}
function arrayFromCommandValueConfigurabilities(commandValueConfigurabilities) {
    return Belt_Array.keepMap(Belt_Array.keep(commandValueConfigurabilities, CommandValueConfigurability$SmartcutsMacros.isDynamic), maybeFromCommandValueConfigurability);
}
var ParamDescriptor = {
    param_encode: param_encode,
    param_decode: param_decode,
    getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
    minifyParam: minifyParam,
    t_encode: t_encode,
    t_decode: t_decode,
    toGraphql: toGraphql,
    minify: minify,
    removePrivateInfo: removePrivateInfo,
    maybeFromCommandValueConfigurability: maybeFromCommandValueConfigurability,
    arrayFromCommandValueConfigurabilities: arrayFromCommandValueConfigurabilities
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "description",
            Decco.optionToJson(Decco.stringToJson, v.description)
        ],
        [
            "authoringCommandLog",
            CommandLog$SmartcutsMacros.GlobalForAuthoring.t_encode(v.authoringCommandLog)
        ],
        [
            "commandLog",
            CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
        ],
        [
            "smartcutParams",
            Decco.arrayToJson(t_encode, v.smartcutParams)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
            if (description.TAG === /* Ok */ 0) {
                var authoringCommandLog = CommandLog$SmartcutsMacros.GlobalForAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authoringCommandLog"), null));
                if (authoringCommandLog.TAG === /* Ok */ 0) {
                    var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
                    if (commandLog.TAG === /* Ok */ 0) {
                        var smartcutParams = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParams"), null));
                        if (smartcutParams.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    id: id._0,
                                    name: name._0,
                                    description: description._0,
                                    authoringCommandLog: authoringCommandLog._0,
                                    commandLog: commandLog._0,
                                    smartcutParams: smartcutParams._0
                                }
                            };
                        }
                        var e = smartcutParams._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".smartcutParams" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = commandLog._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".commandLog" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = authoringCommandLog._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".authoringCommandLog" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = description._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".description" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function minify$1(smartcut) {
    return {
        id: smartcut.id,
        name: smartcut.name,
        description: smartcut.description,
        authoringCommandLog: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.minify, smartcut.authoringCommandLog),
        commandLog: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, smartcut.commandLog),
        smartcutParams: smartcut.smartcutParams
    };
}
var ForAuthoringSubmission = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    minify: minify$1
};
var SavedSmartcut = {};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.id)
        ],
        [
            "maybeDefaultPlaybackOptions",
            Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeDefaultPlaybackOptions)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var maybeDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDefaultPlaybackOptions"), null));
        if (maybeDefaultPlaybackOptions.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    id: id._0,
                    maybeDefaultPlaybackOptions: maybeDefaultPlaybackOptions._0
                }
            };
        }
        var e = maybeDefaultPlaybackOptions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybeDefaultPlaybackOptions" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var InstalledSmartcut = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function t_encode$3(v) {
    switch(v){
        case /* PRIVATE */ 0:
            return [
                "PRIVATE"
            ];
        case /* PUBLIC */ 1:
            return [
                "PUBLIC"
            ];
        case /* UNLISTED */ 2:
            return [
                "UNLISTED"
            ];
    }
}
function t_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "PRIVATE":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PRIVATE */ 0
                    };
                }
            case "PUBLIC":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PUBLIC */ 1
                    };
                }
            case "UNLISTED":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UNLISTED */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromVariant(variant) {
    if (variant === "PRIVATE") {
        return /* PRIVATE */ 0;
    } else if (variant === "PUBLIC") {
        return /* PUBLIC */ 1;
    } else {
        return /* UNLISTED */ 2;
    }
}
function stringify(v) {
    switch(v){
        case /* PRIVATE */ 0:
            return "PRIVATE";
        case /* PUBLIC */ 1:
            return "PUBLIC";
        case /* UNLISTED */ 2:
            return "UNLISTED";
    }
}
var SmartcutVisibility = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromVariant: fromVariant,
    stringify: stringify
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "id",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.id)
        ],
        [
            "visibility",
            t_encode$3(v.visibility)
        ],
        [
            "stepDescriptions",
            Decco.arrayToJson(Decco.stringToJson, v.stepDescriptions)
        ],
        [
            "msBeforeNextCommand",
            Decco.arrayToJson(Decco.intToJson, v.msBeforeNextCommand)
        ],
        [
            "maybeMsBeforeCloseWindow",
            Decco.optionToJson(Decco.intToJson, v.maybeMsBeforeCloseWindow)
        ],
        [
            "loginUrls",
            Decco.arrayToJson(Decco.stringToJson, v.loginUrls)
        ],
        [
            "maybeDefaultPlaybackOptions",
            Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeDefaultPlaybackOptions)
        ],
        [
            "loginSmartcuts",
            Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.t__encode, v.loginSmartcuts)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var visibility = t_decode$3(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
        if (visibility.TAG === /* Ok */ 0) {
            var stepDescriptions = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stepDescriptions"), null));
            if (stepDescriptions.TAG === /* Ok */ 0) {
                var msBeforeNextCommand = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
                if (msBeforeNextCommand.TAG === /* Ok */ 0) {
                    var maybeMsBeforeCloseWindow = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeMsBeforeCloseWindow"), null));
                    if (maybeMsBeforeCloseWindow.TAG === /* Ok */ 0) {
                        var loginUrls = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrls"), null));
                        if (loginUrls.TAG === /* Ok */ 0) {
                            var maybeDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDefaultPlaybackOptions"), null));
                            if (maybeDefaultPlaybackOptions.TAG === /* Ok */ 0) {
                                var loginSmartcuts = Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginSmartcuts"), null));
                                if (loginSmartcuts.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            id: id._0,
                                            visibility: visibility._0,
                                            stepDescriptions: stepDescriptions._0,
                                            msBeforeNextCommand: msBeforeNextCommand._0,
                                            maybeMsBeforeCloseWindow: maybeMsBeforeCloseWindow._0,
                                            loginUrls: loginUrls._0,
                                            maybeDefaultPlaybackOptions: maybeDefaultPlaybackOptions._0,
                                            loginSmartcuts: loginSmartcuts._0
                                        }
                                    };
                                }
                                var e = loginSmartcuts._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".loginSmartcuts" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = maybeDefaultPlaybackOptions._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".maybeDefaultPlaybackOptions" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = loginUrls._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".loginUrls" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = maybeMsBeforeCloseWindow._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".maybeMsBeforeCloseWindow" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = msBeforeNextCommand._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".msBeforeNextCommand" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = stepDescriptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".stepDescriptions" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = visibility._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".visibility" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
var Smartcut = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "id",
            SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode(v.id)
        ],
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "description",
            Decco.optionToJson(Decco.stringToJson, v.description)
        ],
        [
            "startingUrlPattern",
            Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.startingUrlPattern)
        ],
        [
            "maybeRedirectedFromUrlPatterns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
            }, v.maybeRedirectedFromUrlPatterns)
        ],
        [
            "origins",
            Decco.arrayToJson(Decco.stringToJson, v.origins)
        ],
        [
            "schemaVersion",
            Decco.stringToJson(v.schemaVersion)
        ],
        [
            "numCommands",
            Decco.intToJson(v.numCommands)
        ],
        [
            "commandLogData",
            DeccoUtils$SmartcutsMacros.decodable_encode(CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode, v.commandLogData)
        ],
        [
            "smartcutParamsData",
            DeccoUtils$SmartcutsMacros.decodable_encode(function(param) {
                return Decco.arrayToJson(t_encode, param);
            }, v.smartcutParamsData)
        ],
        [
            "installedSmartcut",
            t_encode$2(v.installedSmartcut)
        ],
        [
            "smartcut",
            t_encode$4(v.smartcut)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */ 0) {
            var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
            if (description.TAG === /* Ok */ 0) {
                var startingUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startingUrlPattern"), null));
                if (startingUrlPattern.TAG === /* Ok */ 0) {
                    var maybeRedirectedFromUrlPatterns = Decco.optionFromJson(function(param) {
                        return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
                    if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */ 0) {
                        var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
                        if (origins.TAG === /* Ok */ 0) {
                            var schemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schemaVersion"), null));
                            if (schemaVersion.TAG === /* Ok */ 0) {
                                var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
                                if (numCommands.TAG === /* Ok */ 0) {
                                    var commandLogData = DeccoUtils$SmartcutsMacros.decodable_decode(CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLogData"), null));
                                    if (commandLogData.TAG === /* Ok */ 0) {
                                        var smartcutParamsData = DeccoUtils$SmartcutsMacros.decodable_decode(function(param) {
                                            return Decco.arrayFromJson(t_decode, param);
                                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParamsData"), null));
                                        if (smartcutParamsData.TAG === /* Ok */ 0) {
                                            var installedSmartcut = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcut"), null));
                                            if (installedSmartcut.TAG === /* Ok */ 0) {
                                                var smartcut = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcut"), null));
                                                if (smartcut.TAG === /* Ok */ 0) {
                                                    return {
                                                        TAG: /* Ok */ 0,
                                                        _0: {
                                                            id: id._0,
                                                            name: name._0,
                                                            description: description._0,
                                                            startingUrlPattern: startingUrlPattern._0,
                                                            maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0,
                                                            origins: origins._0,
                                                            schemaVersion: schemaVersion._0,
                                                            numCommands: numCommands._0,
                                                            commandLogData: commandLogData._0,
                                                            smartcutParamsData: smartcutParamsData._0,
                                                            installedSmartcut: installedSmartcut._0,
                                                            smartcut: smartcut._0
                                                        }
                                                    };
                                                }
                                                var e = smartcut._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".smartcut" + e.path,
                                                        message: e.message,
                                                        value: e.value
                                                    }
                                                };
                                            }
                                            var e$1 = installedSmartcut._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".installedSmartcut" + e$1.path,
                                                    message: e$1.message,
                                                    value: e$1.value
                                                }
                                            };
                                        }
                                        var e$2 = smartcutParamsData._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".smartcutParamsData" + e$2.path,
                                                message: e$2.message,
                                                value: e$2.value
                                            }
                                        };
                                    }
                                    var e$3 = commandLogData._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".commandLogData" + e$3.path,
                                            message: e$3.message,
                                            value: e$3.value
                                        }
                                    };
                                }
                                var e$4 = numCommands._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".numCommands" + e$4.path,
                                        message: e$4.message,
                                        value: e$4.value
                                    }
                                };
                            }
                            var e$5 = schemaVersion._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".schemaVersion" + e$5.path,
                                    message: e$5.message,
                                    value: e$5.value
                                }
                            };
                        }
                        var e$6 = origins._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".origins" + e$6.path,
                                message: e$6.message,
                                value: e$6.value
                            }
                        };
                    }
                    var e$7 = maybeRedirectedFromUrlPatterns._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".maybeRedirectedFromUrlPatterns" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = startingUrlPattern._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".startingUrlPattern" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            }
            var e$9 = description._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".description" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                }
            };
        }
        var e$10 = name._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".name" + e$10.path,
                message: e$10.message,
                value: e$10.value
            }
        };
    }
    var e$11 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$11.path,
            message: e$11.message,
            value: e$11.value
        }
    };
}
function minify$2(smartcut) {
    var commandLogData = smartcut.commandLogData;
    var tmp;
    tmp = commandLogData.TAG === /* Decoded */ 0 ? {
        TAG: /* Decoded */ 0,
        _0: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, commandLogData._0)
    } : {
        TAG: /* UnableToDecode */ 1,
        _0: null
    };
    return {
        id: smartcut.id,
        name: smartcut.name,
        description: smartcut.description,
        startingUrlPattern: smartcut.startingUrlPattern,
        maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
        origins: smartcut.origins,
        schemaVersion: smartcut.schemaVersion,
        numCommands: smartcut.numCommands,
        commandLogData: tmp,
        smartcutParamsData: smartcut.smartcutParamsData,
        installedSmartcut: smartcut.installedSmartcut,
        smartcut: smartcut.smartcut
    };
}
function rehydrate(smartcut) {
    var commandLogData = smartcut.commandLogData;
    if (commandLogData.TAG === /* Decoded */ 0) {
        return CommandLog$SmartcutsMacros.GlobalForPlayback.rehydrate(commandLogData._0).then(function(rehydratedCommandLog) {
            return Promise.resolve({
                id: smartcut.id,
                name: smartcut.name,
                description: smartcut.description,
                startingUrlPattern: smartcut.startingUrlPattern,
                maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
                origins: smartcut.origins,
                schemaVersion: smartcut.schemaVersion,
                numCommands: smartcut.numCommands,
                commandLogData: {
                    TAG: /* Decoded */ 0,
                    _0: rehydratedCommandLog
                },
                smartcutParamsData: smartcut.smartcutParamsData,
                installedSmartcut: smartcut.installedSmartcut,
                smartcut: smartcut.smartcut
            });
        });
    } else {
        return Promise.resolve(smartcut);
    }
}
function getStartingUrl(param2) {
    var smartcutParamsData = param2.smartcutParamsData;
    var commandLogData = param2.commandLogData;
    var maybeParamForFirstCommand;
    maybeParamForFirstCommand = smartcutParamsData.TAG === /* Decoded */ 0 ? Belt_Array.getBy(smartcutParamsData._0, function(param) {
        return param.firstCommandIndex === 0;
    }) : undefined;
    if (maybeParamForFirstCommand !== undefined) {
        var match = maybeParamForFirstCommand.param;
        if (match.TAG === /* URLParam */ 5) {
            return URLUtils$SmartcutsMacros.$$URL.fromString(match._0.originalUrl);
        } else {
            return;
        }
    }
    if (commandLogData.TAG !== /* Decoded */ 0) {
        return;
    }
    var match$1 = commandLogData._0;
    if (!match$1) {
        return;
    }
    var match$2 = match$1.hd.command;
    if (typeof match$2 === "number" || match$2.TAG !== /* NewWindowWithUrlCommand */ 1) {
        return;
    } else {
        return URLUtils$SmartcutsMacros.$$URL.fromString(match$2._0.url);
    }
}
function getStartingUrlExn(param3) {
    var smartcutParamsData = param3.smartcutParamsData;
    var commandLogData = param3.commandLogData;
    var origins = param3.origins;
    var maybeParamForFirstCommand;
    maybeParamForFirstCommand = smartcutParamsData.TAG === /* Decoded */ 0 ? Belt_Array.getBy(smartcutParamsData._0, function(param) {
        return param.firstCommandIndex === 0;
    }) : undefined;
    if (maybeParamForFirstCommand !== undefined) {
        var match = maybeParamForFirstCommand.param;
        if (match.TAG !== /* URLParam */ 5) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected param associated with first command to be a URLParam");
        }
        var originalUrl = match._0.originalUrl;
        var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(originalUrl);
        if (urlRecord !== undefined) {
            return urlRecord;
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: originalUrl,
            Error: new Error()
        };
    }
    if (commandLogData.TAG === /* Decoded */ 0) {
        var match$1 = commandLogData._0;
        if (!match$1) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected command log to be non-empty");
        }
        var match$2 = match$1.hd.command;
        if (typeof match$2 === "number") {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected first command of command log to be NewWindowWithUrlCommand(url, focusState)");
        }
        if (match$2.TAG !== /* NewWindowWithUrlCommand */ 1) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected first command of command log to be NewWindowWithUrlCommand(url, focusState)");
        }
        var url = match$2._0.url;
        var urlRecord$1 = URLUtils$SmartcutsMacros.$$URL.fromString(url);
        if (urlRecord$1 !== undefined) {
            return urlRecord$1;
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: url,
            Error: new Error()
        };
    } else {
        var urlRecord$2 = URLUtils$SmartcutsMacros.$$URL.fromString(Caml_array.get(origins, 0));
        if (urlRecord$2 !== undefined) {
            return urlRecord$2;
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: Caml_array.get(origins, 0),
            Error: new Error()
        };
    }
}
function getNumParams(param) {
    var smartcutParamsData = param.smartcutParamsData;
    if (smartcutParamsData.TAG === /* Decoded */ 0) {
        return smartcutParamsData._0.length;
    } else {
        return OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(Js_json.decodeArray(smartcutParamsData._0), function(prim) {
            return prim.length;
        }));
    }
}
function updateScreenshot(f, smartcut) {
    var commandLogData = smartcut.commandLogData;
    var tmp;
    tmp = commandLogData.TAG === /* Decoded */ 0 ? {
        TAG: /* Decoded */ 0,
        _0: List.map(function(commandWithContextGlobal) {
            var contextGlobal = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: contextGlobal.url,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: Curry._1(f, contextGlobal.screenshot),
                    croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                }
            };
        }, commandLogData._0)
    } : commandLogData;
    return {
        id: smartcut.id,
        name: smartcut.name,
        description: smartcut.description,
        startingUrlPattern: smartcut.startingUrlPattern,
        maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
        origins: smartcut.origins,
        schemaVersion: smartcut.schemaVersion,
        numCommands: smartcut.numCommands,
        commandLogData: tmp,
        smartcutParamsData: smartcut.smartcutParamsData,
        installedSmartcut: smartcut.installedSmartcut,
        smartcut: smartcut.smartcut
    };
}
function startingAndRedirectedFromUrlPatterns(param) {
    return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(param.startingUrlPattern), OptionUtils$SmartcutsMacros.withDefault([], param.maybeRedirectedFromUrlPatterns));
}
function doesMatchUrl(url, smartcut) {
    return Belt_Array.some(startingAndRedirectedFromUrlPatterns(smartcut), function(param) {
        return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, param);
    });
}
function determineRunFromPageCapability(maybePageUrl, smartcut) {
    var match = smartcut.commandLogData;
    if (match.TAG === /* Decoded */ 0 && maybePageUrl !== undefined && doesMatchUrl(maybePageUrl, smartcut)) {
        return /* CanRunFromPage */ 1;
    } else {
        return /* CannotRunFromPage */ 0;
    }
}
function makeComparator(targetUrl, aSmartcut, bSmartcut) {
    var match = aSmartcut.commandLogData;
    var match$1 = bSmartcut.commandLogData;
    var match$2 = getStartingUrlExn(aSmartcut);
    var match$3 = getStartingUrlExn(bSmartcut);
    var exit = 0;
    var url;
    var urlA;
    var urlB;
    if (match.TAG === /* Decoded */ 0) {
        if (match$1.TAG !== /* Decoded */ 0) {
            return -1;
        }
        if (targetUrl === undefined) {
            return 0;
        }
        url = targetUrl;
        urlA = match$2;
        urlB = match$3;
        exit = 1;
    } else {
        if (match$1.TAG === /* Decoded */ 0) {
            return 1;
        }
        if (targetUrl === undefined) {
            return 0;
        }
        url = targetUrl;
        urlA = match$2;
        urlB = match$3;
        exit = 1;
    }
    if (exit === 1) {
        var sharesTargetHostname = function sharesTargetHostname(param) {
            return URLUtils$SmartcutsMacros.$$URL.sharesHostname(true, url, param);
        };
        var match$4 = sharesTargetHostname(urlA) && urlA.protocol === url.protocol && urlA.port === url.port && URLUtils$SmartcutsMacros.$$URL.numPathComponents(urlA) === URLUtils$SmartcutsMacros.$$URL.numPathComponents(url);
        var match$5 = sharesTargetHostname(urlB) && urlB.protocol === url.protocol && urlB.port === url.port && URLUtils$SmartcutsMacros.$$URL.numPathComponents(urlB) === URLUtils$SmartcutsMacros.$$URL.numPathComponents(url);
        if (match$4) {
            if (!match$5) {
                return -1;
            }
            var levUrl = UrlLevenshtein$SmartcutsMacros.Url.fromString(url.toString());
            var levUrl$1;
            if (levUrl !== undefined) {
                levUrl$1 = levUrl;
            } else {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                    _1: url.toString(),
                    Error: new Error()
                };
            }
            var levUrlA = UrlLevenshtein$SmartcutsMacros.Url.fromString(urlA.toString());
            var levUrlA$1;
            if (levUrlA !== undefined) {
                levUrlA$1 = levUrlA;
            } else {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                    _1: urlA.toString(),
                    Error: new Error()
                };
            }
            var levUrlB = UrlLevenshtein$SmartcutsMacros.Url.fromString(urlB.toString());
            var levUrlB$1;
            if (levUrlB !== undefined) {
                levUrlB$1 = levUrlB;
            } else {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                    _1: urlB.toString(),
                    Error: new Error()
                };
            }
            return UrlLevenshtein$SmartcutsMacros.calcLevenshteinDistance(levUrl$1, levUrlA$1) - UrlLevenshtein$SmartcutsMacros.calcLevenshteinDistance(levUrl$1, levUrlB$1) | 0;
        }
        if (match$5) {
            return 1;
        }
        var arg = startingAndRedirectedFromUrlPatterns(aSmartcut);
        var match$6 = function(param) {
            return ArrayUtils$SmartcutsMacros.firstMatch(param, arg);
        }(function(urlPattern) {
            return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, urlPattern);
        });
        var arg$1 = startingAndRedirectedFromUrlPatterns(bSmartcut);
        var match$7 = function(param) {
            return ArrayUtils$SmartcutsMacros.firstMatch(param, arg$1);
        }(function(urlPattern) {
            return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, urlPattern);
        });
        var exit$1 = 0;
        if (match$6 !== undefined) {
            if (match$7 === undefined) {
                return -1;
            }
            exit$1 = 2;
        } else {
            if (match$7 !== undefined) {
                return 1;
            }
            exit$1 = 2;
        }
        if (exit$1 === 2) {
            if (URLUtils$SmartcutsMacros.$$URL.sharesHostname(true, urlA, urlB)) {
                return 0;
            }
            var match$8 = sharesTargetHostname(urlA);
            var match$9 = sharesTargetHostname(urlB);
            if (match$8) {
                if (match$9) {
                    return urlA.toString().localeCompare(urlB.toString()) | 0;
                } else {
                    return -1;
                }
            } else if (match$9) {
                return 1;
            } else {
                return urlA.toString().localeCompare(urlB.toString()) | 0;
            }
        }
    }
}
var RelativeToUrlWithOutdatedSmartcutsLast = {
    makeComparator: makeComparator
};
var Sort = {
    RelativeToUrlWithOutdatedSmartcutsLast: RelativeToUrlWithOutdatedSmartcutsLast
};
var LoadedSmartcut = {
    InstalledSmartcut: InstalledSmartcut,
    SmartcutVisibility: SmartcutVisibility,
    Smartcut: Smartcut,
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    minify: minify$2,
    rehydrate: rehydrate,
    getStartingUrl: getStartingUrl,
    getStartingUrlExn: getStartingUrlExn,
    getNumParams: getNumParams,
    updateScreenshot: updateScreenshot,
    startingAndRedirectedFromUrlPatterns: startingAndRedirectedFromUrlPatterns,
    doesMatchUrl: doesMatchUrl,
    determineRunFromPageCapability: determineRunFromPageCapability,
    Sort: Sort
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "localId",
            Decco.stringToJson(v.localId)
        ],
        [
            "dbId",
            Decco.optionToJson(Decco.stringToJson, v.dbId)
        ],
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "description",
            Decco.optionToJson(Decco.stringToJson, v.description)
        ],
        [
            "startingUrlPattern",
            Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.startingUrlPattern)
        ],
        [
            "maybeRedirectedFromUrlPatterns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
            }, v.maybeRedirectedFromUrlPatterns)
        ],
        [
            "origins",
            Decco.arrayToJson(Decco.stringToJson, v.origins)
        ],
        [
            "recordingCommandLog",
            CommandLog$SmartcutsMacros.GlobalForRecordingResolved.t_encode(v.recordingCommandLog)
        ],
        [
            "authoringCommandLog",
            CommandLog$SmartcutsMacros.GlobalForAuthoring.t_encode(v.authoringCommandLog)
        ],
        [
            "commandLog",
            CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
        ],
        [
            "smartcutParams",
            Decco.arrayToJson(t_encode, v.smartcutParams)
        ],
        [
            "recordingStartedAt",
            Decco.floatToJson(v.recordingStartedAt)
        ],
        [
            "recordingEndedAt",
            Decco.floatToJson(v.recordingEndedAt)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var localId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "localId"), null));
    if (localId.TAG === /* Ok */ 0) {
        var dbId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dbId"), null));
        if (dbId.TAG === /* Ok */ 0) {
            var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
            if (name.TAG === /* Ok */ 0) {
                var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                if (description.TAG === /* Ok */ 0) {
                    var startingUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startingUrlPattern"), null));
                    if (startingUrlPattern.TAG === /* Ok */ 0) {
                        var maybeRedirectedFromUrlPatterns = Decco.optionFromJson(function(param) {
                            return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
                        if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */ 0) {
                            var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
                            if (origins.TAG === /* Ok */ 0) {
                                var recordingCommandLog = CommandLog$SmartcutsMacros.GlobalForRecordingResolved.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingCommandLog"), null));
                                if (recordingCommandLog.TAG === /* Ok */ 0) {
                                    var authoringCommandLog = CommandLog$SmartcutsMacros.GlobalForAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authoringCommandLog"), null));
                                    if (authoringCommandLog.TAG === /* Ok */ 0) {
                                        var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
                                        if (commandLog.TAG === /* Ok */ 0) {
                                            var smartcutParams = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParams"), null));
                                            if (smartcutParams.TAG === /* Ok */ 0) {
                                                var recordingStartedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingStartedAt"), null));
                                                if (recordingStartedAt.TAG === /* Ok */ 0) {
                                                    var recordingEndedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingEndedAt"), null));
                                                    if (recordingEndedAt.TAG === /* Ok */ 0) {
                                                        return {
                                                            TAG: /* Ok */ 0,
                                                            _0: {
                                                                localId: localId._0,
                                                                dbId: dbId._0,
                                                                name: name._0,
                                                                description: description._0,
                                                                startingUrlPattern: startingUrlPattern._0,
                                                                maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0,
                                                                origins: origins._0,
                                                                recordingCommandLog: recordingCommandLog._0,
                                                                authoringCommandLog: authoringCommandLog._0,
                                                                commandLog: commandLog._0,
                                                                smartcutParams: smartcutParams._0,
                                                                recordingStartedAt: recordingStartedAt._0,
                                                                recordingEndedAt: recordingEndedAt._0
                                                            }
                                                        };
                                                    }
                                                    var e = recordingEndedAt._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".recordingEndedAt" + e.path,
                                                            message: e.message,
                                                            value: e.value
                                                        }
                                                    };
                                                }
                                                var e$1 = recordingStartedAt._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".recordingStartedAt" + e$1.path,
                                                        message: e$1.message,
                                                        value: e$1.value
                                                    }
                                                };
                                            }
                                            var e$2 = smartcutParams._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".smartcutParams" + e$2.path,
                                                    message: e$2.message,
                                                    value: e$2.value
                                                }
                                            };
                                        }
                                        var e$3 = commandLog._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".commandLog" + e$3.path,
                                                message: e$3.message,
                                                value: e$3.value
                                            }
                                        };
                                    }
                                    var e$4 = authoringCommandLog._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".authoringCommandLog" + e$4.path,
                                            message: e$4.message,
                                            value: e$4.value
                                        }
                                    };
                                }
                                var e$5 = recordingCommandLog._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".recordingCommandLog" + e$5.path,
                                        message: e$5.message,
                                        value: e$5.value
                                    }
                                };
                            }
                            var e$6 = origins._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".origins" + e$6.path,
                                    message: e$6.message,
                                    value: e$6.value
                                }
                            };
                        }
                        var e$7 = maybeRedirectedFromUrlPatterns._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".maybeRedirectedFromUrlPatterns" + e$7.path,
                                message: e$7.message,
                                value: e$7.value
                            }
                        };
                    }
                    var e$8 = startingUrlPattern._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".startingUrlPattern" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = description._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".description" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            }
            var e$10 = name._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".name" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                }
            };
        }
        var e$11 = dbId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dbId" + e$11.path,
                message: e$11.message,
                value: e$11.value
            }
        };
    }
    var e$12 = localId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".localId" + e$12.path,
            message: e$12.message,
            value: e$12.value
        }
    };
}
function toSavedSmartcut(id, param) {
    return {
        id: id,
        name: param.name,
        description: param.description,
        startingUrlPattern: param.startingUrlPattern,
        maybeRedirectedFromUrlPatterns: param.maybeRedirectedFromUrlPatterns,
        origins: param.origins,
        recordingCommandLog: param.recordingCommandLog,
        authoringCommandLog: param.authoringCommandLog,
        commandLog: param.commandLog,
        smartcutParams: param.smartcutParams
    };
}
function calcSize(unit, smartcut) {
    Curry._2(Log$SmartcutsMacros.faunaSize.log2, "recordingCommandLog size=", Belt_List.map(smartcut.recordingCommandLog, function(param) {
        return Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.calcSize(unit, param);
    }));
    Curry._2(Log$SmartcutsMacros.faunaSize.log2, "authoringCommandLog size=", Belt_List.map(smartcut.authoringCommandLog, function(param) {
        return Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.calcSize(unit, param);
    }));
    Curry._2(Log$SmartcutsMacros.faunaSize.log2, "commandLog size=", Belt_List.map(smartcut.commandLog, function(param) {
        return Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.calcSize(unit, param);
    }));
    return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(t_encode$6(smartcut)));
}
function minify$3(smartcut) {
    return {
        localId: smartcut.localId,
        dbId: smartcut.dbId,
        name: smartcut.name,
        description: smartcut.description,
        startingUrlPattern: smartcut.startingUrlPattern,
        maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
        origins: smartcut.origins,
        recordingCommandLog: CommandLog$SmartcutsMacros.GlobalForRecordingResolved.minify(smartcut.recordingCommandLog),
        authoringCommandLog: CommandLog$SmartcutsMacros.GlobalForAuthoring.minify(smartcut.authoringCommandLog),
        commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(smartcut.commandLog),
        smartcutParams: smartcut.smartcutParams,
        recordingStartedAt: smartcut.recordingStartedAt,
        recordingEndedAt: smartcut.recordingEndedAt
    };
}
function getImagesToSaveToCloud(param4) {
    return Belt_Array.keepMap(Belt_Array.reduce($$Array.of_list(param4.commandLog), [], function(imagesToSave, param) {
        var match = param.contextGlobal;
        return $$Array.append(imagesToSave, [
            match.screenshot,
            match.croppedScreenshot
        ]);
    }), function(screenshot) {
        if (typeof screenshot === "number" || screenshot.TAG !== /* Image */ 0) {
            return;
        } else {
            return {
                id: screenshot._0,
                image: screenshot._1
            };
        }
    });
}
function startSavingScreenshotsToCloud(recordedSmartcutId, singleQuerySccessCallbackOpt, imagesToSave) {
    var singleQuerySccessCallback = singleQuerySccessCallbackOpt !== undefined ? singleQuerySccessCallbackOpt : function singleQuerySccessCallback(param, param$1) {};
    return PromiseUtils$SmartcutsMacros.doAllWithProgressUpdate(function(nSaved) {
        return Curry._2(singleQuerySccessCallback, nSaved, imagesToSave.length);
    }, $$Array.map(function(param) {
        var match = param.image;
        var data = match.data;
        var screenshotId = param.id;
        var folder = Screenshot$SmartcutsMacros.deriveFolderName(recordedSmartcutId);
        var fileName = Screenshot$SmartcutsMacros.deriveFileName(screenshotId, match.format);
        var match$1 = PromiseUtils$SmartcutsMacros.withRetries(3, function(param, param$1) {
            if (data.TAG === /* Base64Encoded */ 0) {
                return ImageKit$SmartcutsMacros.uploadWithBase64({
                    file: data._0,
                    fileName: fileName,
                    folder: folder
                }, ImageKit$SmartcutsMacros.client);
            } else {
                return ImageKit$SmartcutsMacros.uploadWithBlob({
                    file: data._0,
                    fileName: fileName,
                    folder: folder
                }, ImageKit$SmartcutsMacros.client);
            }
        }, function(param) {
            return true;
        }, undefined, undefined);
        return Curry._1(match$1[0], undefined).then(function(res) {
            Curry._2(Log$SmartcutsMacros.imageKit.warn2, "RESULT", res);
            return Promise.resolve([
                screenshotId,
                res
            ]);
        }).catch(function(jsPromiseError) {
            Curry._1(Log$SmartcutsMacros.imageKit.error1, Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, jsPromiseError));
            return Promise.resolve(undefined);
        });
    }, imagesToSave)).then(function(idResultPairs) {
        return Promise.resolve(Belt_MapString.fromArray(Belt_Array.keepMap(idResultPairs, function(maybeIdAndResult) {
            return Belt_Option.map(maybeIdAndResult, function(param) {
                return [
                    Image$SmartcutsMacros.idAsString(param[0]),
                    param[1]
                ];
            });
        })));
    });
}
function updateScreenshot$1(f, smartcut) {
    return {
        localId: smartcut.localId,
        dbId: smartcut.dbId,
        name: smartcut.name,
        description: smartcut.description,
        startingUrlPattern: smartcut.startingUrlPattern,
        maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
        origins: smartcut.origins,
        recordingCommandLog: List.map(function(commandWithContextGlobal) {
            var contextGlobal = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: contextGlobal.url,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: Curry._1(f, contextGlobal.screenshot),
                    croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                }
            };
        }, smartcut.recordingCommandLog),
        authoringCommandLog: List.map(function(commandWithContextGlobal) {
            var contextGlobal = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: contextGlobal.url,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: Curry._1(f, contextGlobal.screenshot),
                    croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                }
            };
        }, smartcut.authoringCommandLog),
        commandLog: List.map(function(commandWithContextGlobal) {
            var contextGlobal = commandWithContextGlobal.contextGlobal;
            return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: contextGlobal.url,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: Curry._1(f, contextGlobal.screenshot),
                    croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                }
            };
        }, smartcut.commandLog),
        smartcutParams: smartcut.smartcutParams,
        recordingStartedAt: smartcut.recordingStartedAt,
        recordingEndedAt: smartcut.recordingEndedAt
    };
}
exports.ParamDescriptor = ParamDescriptor;
exports.ForAuthoringSubmission = ForAuthoringSubmission;
exports.SavedSmartcut = SavedSmartcut;
exports.LoadedSmartcut = LoadedSmartcut;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.toSavedSmartcut = toSavedSmartcut;
exports.calcSize = calcSize;
exports.minify = minify$3;
exports.getImagesToSaveToCloud = getImagesToSaveToCloud;
exports.startSavingScreenshotsToCloud = startSavingScreenshotsToCloud;
exports.updateScreenshot = updateScreenshot$1; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 62145:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var IdMaker$SmartcutsMacros = __webpack_require__(83188);
var SmartcutId = IdMaker$SmartcutsMacros.Make({
    name: "smartcutId"
});
var RecordedSmartcutId = IdMaker$SmartcutsMacros.Make({
    name: "recordedSmartcutId"
});
var include = IdMaker$SmartcutsMacros.Make({
    name: "installedSmartcutId"
});
var id_encode = include.id_encode;
var id_decode = include.id_decode;
var InstalledSmartcutId_doesEqualStringId = include.doesEqualStringId;
var InstalledSmartcutId_cmp = include.cmp;
var InstalledSmartcutId = {
    id_encode: id_encode,
    id_decode: id_decode,
    doesEqualStringId: InstalledSmartcutId_doesEqualStringId,
    cmp: InstalledSmartcutId_cmp,
    emptyId: "Empty id"
};
function smartcutId_encode(v) {
    return Curry._1(SmartcutId.id_encode, v);
}
function smartcutId_decode(v) {
    return Curry._1(SmartcutId.id_decode, v);
}
var installedSmartcutId_encode = Curry.__1(id_encode);
var installedSmartcutId_decode = Curry.__1(id_decode);
function recordedSmartcutId_encode(v) {
    return Curry._1(RecordedSmartcutId.id_encode, v);
}
function recordedSmartcutId_decode(v) {
    return Curry._1(RecordedSmartcutId.id_decode, v);
}
exports.SmartcutId = SmartcutId;
exports.RecordedSmartcutId = RecordedSmartcutId;
exports.InstalledSmartcutId = InstalledSmartcutId;
exports.smartcutId_encode = smartcutId_encode;
exports.smartcutId_decode = smartcutId_decode;
exports.installedSmartcutId_encode = installedSmartcutId_encode;
exports.installedSmartcutId_decode = installedSmartcutId_decode;
exports.recordedSmartcutId_encode = recordedSmartcutId_encode;
exports.recordedSmartcutId_decode = recordedSmartcutId_decode; /* SmartcutId Not a pure module */ 


/***/ }),

/***/ 47652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Js_dict = __webpack_require__(97076);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Json_decode = __webpack_require__(50957);
var Json_encode = __webpack_require__(82065);
var Caml_js_exceptions = __webpack_require__(74518);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
function Make(Record) {
    var currentLock = {
        contents: undefined
    };
    var releaseLock = function releaseLock(param) {
        var match = currentLock.contents;
        var tmp;
        if (match !== undefined && match) {
            var nReading = match._0;
            tmp = nReading !== 1 ? /* ReadLock */ ({
                _0: nReading - 1 | 0
            }) : undefined;
        } else {
            tmp = undefined;
        }
        currentLock.contents = tmp;
    };
    var waitForLock = function waitForLock(doesWrite) {
        var match = currentLock.contents;
        if (match !== undefined) {
            if (match && !doesWrite) {
                currentLock.contents = /* ReadLock */ {
                    _0: match._0 + 1 | 0
                };
                return Promise.resolve(undefined);
            }
        } else {
            currentLock.contents = doesWrite ? /* WriteLock */ 0 : /* ReadLock */ ({
                _0: 1
            });
            return Promise.resolve(undefined);
        }
        return Util$SmartcutsMacros.waitFor(1000.0, undefined, function(param) {
            if (currentLock.contents !== undefined) {
                return;
            } else {
                return Caml_option.some(undefined);
            }
        }, function(param) {
            throw {
                RE_EXN_ID: Util$SmartcutsMacros.WaitFor.TimedOut,
                _1: 1000.0,
                Error: new Error()
            };
        }, undefined).then(function(param) {
            currentLock.contents = doesWrite ? /* WriteLock */ 0 : /* ReadLock */ ({
                _0: 1
            });
            return Promise.resolve(undefined);
        });
    };
    var withLock = function withLock(doesWrite, f) {
        return PromiseUtils$SmartcutsMacros.resolveWith(function(result) {
            releaseLock(undefined);
            return result;
        }, waitForLock(doesWrite).then(Curry.__1(f)));
    };
    var get = function get(param) {
        return withLock(false, function(param) {
            return PromiseUtils$SmartcutsMacros.resolveWith(function(results) {
                var json = Js_dict.get(results, Record.name);
                if (json === undefined) {
                    return [];
                }
                try {
                    return Json_decode.array(Json_decode.string, Caml_option.valFromOption(json));
                } catch (exn) {
                    return [];
                }
            }, browser.storage.local.get([
                Record.name
            ]));
        });
    };
    var save = function save(indexes) {
        return withLock(true, function(param) {
            return browser.storage.local.set(Json_encode.object_({
                hd: [
                    Record.name,
                    Json_encode.array(function(prim) {
                        return prim;
                    }, indexes)
                ],
                tl: /* [] */ 0
            }));
        });
    };
    var create = function create(newIds) {
        return get(undefined).then(function(ids) {
            return save($$Array.append(newIds, ids));
        });
    };
    var storageKey = function storageKey(id) {
        return Record.name + (":" + id);
    };
    var saveRecord = function saveRecord(record) {
        var id = Curry._1(Record.idGet, record);
        return browser.storage.local.set(Json_encode.object_({
            hd: [
                storageKey(id),
                Curry._1(Record.t_encode, record)
            ],
            tl: /* [] */ 0
        })).then(function(param) {
            return Promise.resolve(id);
        });
    };
    var decode = function decode(json) {
        var record = Curry._1(Record.t_decode, json);
        if (record.TAG === /* Ok */ 0) {
            return Caml_option.some(record._0);
        }
    };
    var all = function all(param) {
        return get(undefined).then(function(ids) {
            var storageKeys = $$Array.map(storageKey, ids);
            return PromiseUtils$SmartcutsMacros.resolveWith(function(result) {
                return Belt_Array.keepMap(storageKeys, function(storageKey) {
                    return Belt_Option.flatMap(Js_dict.get(result, storageKey), decode);
                });
            }, browser.storage.local.get(storageKeys));
        });
    };
    var findById = function findById(id) {
        var storageKey$1 = storageKey(id);
        return PromiseUtils$SmartcutsMacros.resolveWith(function(result) {
            return Belt_Option.flatMap(Js_dict.get(result, storageKey$1), decode);
        }, browser.storage.local.get([
            storageKey$1
        ]));
    };
    var saveMany = function saveMany(recordsToAdd) {
        return Promise.all($$Array.map(saveRecord, recordsToAdd)).then(create);
    };
    var updateById = function updateById(id, f) {
        return findById(id).then(function(maybeRecord) {
            return saveRecord(Curry._1(f, OptionUtils$SmartcutsMacros.getExn("Expect to find storage item key=" + storageKey(id), maybeRecord)));
        }).then(function(_id) {
            return Promise.resolve(undefined);
        });
    };
    var upsert = function upsert(record) {
        var id = Curry._1(Record.idGet, record);
        var storageKey$1 = storageKey(id);
        return browser.storage.local.get([
            storageKey$1
        ]).then(function(result) {
            var shouldCreateIndex = Belt_Option.isNone(Js_dict.get(result, storageKey$1));
            return saveRecord(record).then(function(index) {
                if (shouldCreateIndex) {
                    return create([
                        index
                    ]);
                } else {
                    return Promise.resolve(undefined);
                }
            });
        });
    };
    var deleteByIds = function deleteByIds(ids) {
        return browser.storage.local.remove($$Array.map(storageKey, ids)).then(function(param) {
            return get(undefined).then(function(indexes) {
                return save(Belt_Array.keep(indexes, function(id) {
                    return !$$Array.mem(id, ids);
                }));
            });
        });
    };
    var decode$1 = function decode$1(json) {
        var record = Curry._1(Record.t_decode, json);
        if (record.TAG === /* Ok */ 0) {
            return {
                TAG: /* OldType_record */ 0,
                _0: record._0
            };
        }
        try {
            return {
                TAG: /* NewType_id */ 1,
                _0: Json_decode.string(json)
            };
        } catch (raw_error) {
            var error = Caml_js_exceptions.internalToOCamlException(raw_error);
            console.error(error);
            return;
        }
    };
    var decodeRecordOnly = function decodeRecordOnly(json) {
        var match = decode$1(json);
        if (match !== undefined && match.TAG === /* OldType_record */ 0) {
            return Caml_option.some(match._0);
        }
    };
    var migrate = function migrate(param) {
        return browser.storage.local.get([
            Record.name
        ]).then(function(results) {
            var json = Js_dict.get(results, Record.name);
            var records;
            if (json !== undefined) {
                var array;
                try {
                    array = Json_decode.array(decodeRecordOnly, Caml_option.valFromOption(json));
                } catch (raw_error) {
                    var error = Caml_js_exceptions.internalToOCamlException(raw_error);
                    console.error(error);
                    array = [];
                }
                records = ArrayUtils$SmartcutsMacros.filterMap(function(x) {
                    return x;
                }, array);
            } else {
                records = [];
            }
            if (records.length !== 0) {
                return Promise.all($$Array.map(saveRecord, records)).then(create);
            } else {
                return Promise.resolve(undefined);
            }
        });
    };
    return {
        all: all,
        findById: findById,
        saveMany: saveMany,
        updateById: updateById,
        upsert: upsert,
        deleteByIds: deleteByIds,
        migrate: migrate
    };
}
exports.Make = Make; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 28891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Image$SmartcutsMacros = __webpack_require__(68387);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StorageCollection$SmartcutsMacros = __webpack_require__(47652);
function t_encode(v) {
    return Image$SmartcutsMacros.ImageWithId.t__encode(v);
}
function t_decode(v) {
    return Image$SmartcutsMacros.ImageWithId.t__decode(v);
}
function idGet(param) {
    return Image$SmartcutsMacros.idAsString(param.id);
}
var include = StorageCollection$SmartcutsMacros.Make({
    t_encode: t_encode,
    t_decode: t_decode,
    name: "images",
    idGet: idGet
});
var findById = include.findById;
function rehydrateScreenshot(screenshot) {
    if (typeof screenshot === "number") {
        return Promise.resolve(screenshot);
    }
    switch(screenshot.TAG | 0){
        case /* Image */ 0:
            var id = screenshot._0;
            return Curry._1(findById, Image$SmartcutsMacros.idAsString(id)).then(function(maybeImage) {
                return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(screenshot, OptionUtils$SmartcutsMacros.map(maybeImage, function(param) {
                    return {
                        TAG: /* Image */ 0,
                        _0: id,
                        _1: param.image
                    };
                })));
            });
        case /* SavingToCloud */ 1:
            var id$1 = screenshot._0;
            return Curry._1(findById, Image$SmartcutsMacros.idAsString(id$1)).then(function(maybeImage) {
                return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(screenshot, OptionUtils$SmartcutsMacros.map(maybeImage, function(param) {
                    return {
                        TAG: /* SavingToCloud */ 1,
                        _0: id$1,
                        _1: param.image
                    };
                })));
            });
        case /* Cloud */ 2:
            return Promise.resolve(screenshot);
    }
}
var all = include.all;
var saveMany = include.saveMany;
var updateById = include.updateById;
var upsert = include.upsert;
var deleteByIds = include.deleteByIds;
var migrate = include.migrate;
exports.all = all;
exports.findById = findById;
exports.saveMany = saveMany;
exports.updateById = updateById;
exports.upsert = upsert;
exports.deleteByIds = deleteByIds;
exports.migrate = migrate;
exports.rehydrateScreenshot = rehydrateScreenshot; /* include Not a pure module */ 


/***/ }),

/***/ 20114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Text = __webpack_require__(32348);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(encoder_domElementRepresentation, v) {
    return Js_dict.fromArray([
        [
            "parentElement",
            Curry._1(encoder_domElementRepresentation, v.parentElement)
        ],
        [
            "textNodeIndex",
            Decco.intToJson(v.textNodeIndex)
        ],
        [
            "text",
            Decco.stringToJson(v.text)
        ]
    ]);
}
function t_decode(decoder_domElementRepresentation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var parentElement = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentElement"), null));
    if (parentElement.TAG === /* Ok */ 0) {
        var textNodeIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "textNodeIndex"), null));
        if (textNodeIndex.TAG === /* Ok */ 0) {
            var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
            if (text.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        parentElement: parentElement._0,
                        textNodeIndex: textNodeIndex._0,
                        text: text._0
                    }
                };
            }
            var e = text._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".text" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = textNodeIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".textNodeIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = parentElement._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".parentElement" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var NonEmptySegment = {
    t_encode: t_encode,
    t_decode: t_decode
};
function t_encode$1(encoder_domElementRepresentation, v) {
    if (v.TAG === /* NonEmptySegment */ 0) {
        return [
            "NonEmptySegment",
            t_encode(encoder_domElementRepresentation, v._0)
        ];
    } else {
        return [
            "EmptySegment",
            Curry._1(encoder_domElementRepresentation, v._0)
        ];
    }
}
function t_decode$1(decoder_domElementRepresentation, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "EmptySegment":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* EmptySegment */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NonEmptySegment":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NonEmptySegment */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function textSegmentsFromElement(element) {
    var childNodes = Array.prototype.slice.call(element.childNodes);
    if (childNodes.length === 0) {
        return {
            hd: {
                TAG: /* EmptySegment */ 1,
                _0: element
            },
            tl: /* [] */ 0
        };
    } else {
        return Belt_Array.reduceWithIndex(childNodes, /* [] */ 0, function(previousTextSegments, node, index) {
            var match = Webapi__Dom__Node.nodeType(node);
            if (match >= 3) {
                return previousTextSegments;
            }
            switch(match){
                case /* Element */ 0:
                    var arg = Webapi__Dom__Element.ofNode(node);
                    var textSegments = textSegmentsFromElement(function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expected to get Element from Node when nodeType = Element at TextContents.fromContentEditableHost"));
                    return List.append(previousTextSegments, textSegments);
                case /* Attribute */ 1:
                    return previousTextSegments;
                case /* Text */ 2:
                    var arg$1 = Webapi__Dom__Text.ofNode(node);
                    var text = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    }("Expected to get Text from Node when nodeType = Text at TextContents.fromContentEditableHost").data;
                    return List.append(previousTextSegments, {
                        hd: {
                            TAG: /* NonEmptySegment */ 0,
                            _0: {
                                parentElement: element,
                                textNodeIndex: index,
                                text: text
                            }
                        },
                        tl: /* [] */ 0
                    });
            }
        });
    }
}
function mapDomElementRepresentation(f, segment) {
    if (segment.TAG !== /* NonEmptySegment */ 0) {
        return {
            TAG: /* EmptySegment */ 1,
            _0: Curry._1(f, segment._0)
        };
    }
    var inner = segment._0;
    return {
        TAG: /* NonEmptySegment */ 0,
        _0: {
            parentElement: Curry._1(f, inner.parentElement),
            textNodeIndex: inner.textNodeIndex,
            text: inner.text
        }
    };
}
function elementGet(segment) {
    if (segment.TAG === /* NonEmptySegment */ 0) {
        return segment._0.parentElement;
    } else {
        return segment._0;
    }
}
function textGet(segment) {
    if (segment.TAG === /* NonEmptySegment */ 0) {
        return segment._0.text;
    } else {
        return "";
    }
}
function findFirstEmptySegmentContainingBreakBeforeNonEmptySegment(_reversedSegments) {
    while(true){
        var reversedSegments = _reversedSegments;
        if (!reversedSegments) {
            return;
        }
        var segment = reversedSegments.hd;
        if (segment.TAG === /* NonEmptySegment */ 0) {
            return;
        }
        if (segment._0.tagName === "BR") {
            return segment;
        }
        _reversedSegments = reversedSegments.tl;
        continue;
    }
    ;
}
function isPrecededByAnyEmptySegmentContainingBreak(index, textSegments) {
    var precedingSegments = Belt_List.take(textSegments, index);
    if (precedingSegments !== undefined) {
        return findFirstEmptySegmentContainingBreakBeforeNonEmptySegment(List.rev(precedingSegments)) !== undefined;
    } else {
        return false;
    }
}
function toMaybeRangeContainerAndOffsetForCursor(positionInside, textSegment) {
    if (textSegment.TAG === /* NonEmptySegment */ 0) {
        var match = textSegment._0;
        return [
            Caml_option.nullable_to_opt(match.parentElement.childNodes.item(match.textNodeIndex)),
            typeof positionInside === "number" ? positionInside !== 0 ? match.text.length : 0 : positionInside._0
        ];
    }
    var element = textSegment._0;
    var match$1 = element.tagName;
    if (match$1 !== "BR") {
        return [
            Caml_option.some(element),
            0
        ];
    }
    var arg = element.parentElement;
    var arg$1 = arg == null ? undefined : Caml_option.some(arg);
    var parentElement = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected parent element for <br>");
    var childNodesOfParent = parentElement.childNodes;
    var maybeIndex = Belt_Array.getIndexBy(Array.prototype.slice.call(childNodesOfParent), function(node) {
        return node === element;
    });
    var offset = maybeIndex !== undefined ? maybeIndex : childNodesOfParent.length;
    return [
        Caml_option.some(parentElement),
        offset
    ];
}
var TextSegment = {
    NonEmptySegment: NonEmptySegment,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    textSegmentsFromElement: textSegmentsFromElement,
    mapDomElementRepresentation: mapDomElementRepresentation,
    elementGet: elementGet,
    textGet: textGet,
    isPrecededByAnyEmptySegmentContainingBreak: isPrecededByAnyEmptySegmentContainingBreak,
    toMaybeRangeContainerAndOffsetForCursor: toMaybeRangeContainerAndOffsetForCursor
};
function textContent_encode(encoder_domElementRepresentation, v) {
    if (v.TAG === /* TextSegment */ 0) {
        return [
            "TextSegment",
            t_encode$1(encoder_domElementRepresentation, v._0)
        ];
    } else {
        return [
            "TextSegmentAtParagraphBoundary",
            t_encode$1(encoder_domElementRepresentation, v._0)
        ];
    }
}
function textContent_decode(decoder_domElementRepresentation, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "TextSegment":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextSegment */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "TextSegmentAtParagraphBoundary":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextSegmentAtParagraphBoundary */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function textGet$1(textContent) {
    if (textContent.TAG === /* TextSegment */ 0) {
        var match = textContent._0;
        if (match.TAG === /* NonEmptySegment */ 0) {
            return match._0.text;
        } else {
            return "";
        }
    }
    var match$1 = textContent._0;
    if (match$1.TAG === /* NonEmptySegment */ 0) {
        return match$1._0.text;
    } else {
        return "";
    }
}
function t_encode$2(encoder_domElementRepresentation, v) {
    return Decco.listToJson(function(param) {
        return textContent_encode(encoder_domElementRepresentation, param);
    }, v);
}
function t_decode$2(decoder_domElementRepresentation, v) {
    return Decco.listFromJson(function(param) {
        return textContent_decode(decoder_domElementRepresentation, param);
    }, v);
}
function fromElement(makeDomElementRepresentation, element) {
    var textSegments = textSegmentsFromElement(element);
    return Belt_List.reduceWithIndex(textSegments, /* [] */ 0, function(textContents, currTextSegment, index) {
        var match = Belt_List.get(textSegments, index - 1 | 0);
        var textContent = match !== undefined && (StringUtils$SmartcutsMacros.containsNewLine(DOM__Element$SmartcutsMacros.commonAncestor(elementGet(currTextSegment), elementGet(match)).innerText) || currTextSegment.TAG === /* NonEmptySegment */ 0 && isPrecededByAnyEmptySegmentContainingBreak(index, textSegments)) ? {
            TAG: /* TextSegmentAtParagraphBoundary */ 1,
            _0: mapDomElementRepresentation(makeDomElementRepresentation, currTextSegment)
        } : {
            TAG: /* TextSegment */ 0,
            _0: mapDomElementRepresentation(makeDomElementRepresentation, currTextSegment)
        };
        return Belt_List.concat(textContents, {
            hd: textContent,
            tl: /* [] */ 0
        });
    });
}
function isAtParagraphBoundary(index, textContents) {
    var match = Belt_List.get(textContents, index);
    if (match !== undefined && match.TAG !== /* TextSegment */ 0) {
        return true;
    } else {
        return false;
    }
}
function fullText(textContents) {
    return Belt_List.reduce(textContents, "", function(fullText1, textContent) {
        if (textContent.TAG === /* TextSegment */ 0) {
            return fullText1 + textGet(textContent._0);
        } else {
            return fullText1 + ("\n" + textGet(textContent._0));
        }
    });
}
function offsetFormBeginningOfParagraph(index, paragraphStartsAtIndex, offset1, textContens) {
    var func = function func(param, param$1) {
        return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(offset1, param, param$1);
    };
    var arg = Curry._2(func, function(offset, textContent, index$p) {
        if (index === index$p) {
            return [
                offset,
                offset
            ];
        }
        if (index$p >= paragraphStartsAtIndex) {
            return [
                offset,
                undefined
            ];
        }
        var text = textGet$1(textContent);
        return [
            offset + text.length | 0,
            undefined
        ];
    }, textContens);
    var param1 = "Expected to find offsetFromBegining()";
    return OptionUtils$SmartcutsMacros.getExn(param1, arg);
}
function offsetFormBeginning(index, offset2, textContens) {
    var func = function func(param, param$1) {
        return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(offset2, param, param$1);
    };
    var arg = Curry._2(func, function(offset, textContent, index$p) {
        if (index === index$p) {
            return [
                offset,
                offset
            ];
        }
        var text = textGet$1(textContent);
        return [
            offset + text.length | 0,
            undefined
        ];
    }, textContens);
    var param2 = "Expected to find offsetFromBegining()";
    return OptionUtils$SmartcutsMacros.getExn(param2, arg);
}
function locateNthParagraph(nthParagraph, textContents) {
    var match = Belt_List.reduceWithIndex(textContents, [
        nthParagraph,
        0,
        0
    ], function(state, textContent, index) {
        var startIndex = state[1];
        var nParagraphRemaining = state[0];
        if (textContent.TAG === /* TextSegment */ 0) {
            return state;
        } else if (nParagraphRemaining === 0) {
            return [
                nParagraphRemaining,
                startIndex,
                index - 1 | 0
            ];
        } else {
            return [
                nParagraphRemaining - 1 | 0,
                nParagraphRemaining === 1 ? index : startIndex,
                state[2]
            ];
        }
    });
    var endIndex = match[2];
    var startIndex1 = match[1];
    var length = List.length(textContents);
    if (length !== 0) {
        if (endIndex === 0) {
            return [
                startIndex1,
                length - 1 | 0
            ];
        } else {
            return [
                startIndex1,
                endIndex
            ];
        }
    }
}
var Generic = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromElement: fromElement,
    isAtParagraphBoundary: isAtParagraphBoundary,
    fullText: fullText,
    offsetFormBeginningOfParagraph: offsetFormBeginningOfParagraph,
    offsetFormBeginning: offsetFormBeginning,
    locateNthParagraph: locateNthParagraph
};
function t_encode$3(v) {
    return Decco.listToJson(function(param) {
        return textContent_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, param);
    }, v);
}
function t_decode$3(v) {
    return Decco.listFromJson(function(param) {
        return textContent_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, param);
    }, v);
}
function fromElement$1(domElementIdentifierGenerator, element1) {
    return fromElement(function(element) {
        var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
        return {
            domElementIdentifier: domElementIdentifier,
            selector: Selector$SmartcutsMacros.forDomElement(element)
        };
    }, element1);
}
function updateSelector(f, recording) {
    return Belt_List.map(recording, function(textContent) {
        if (textContent.TAG === /* TextSegment */ 0) {
            var domElementRepresentation = textContent._0;
            if (domElementRepresentation.TAG === /* NonEmptySegment */ 0) {
                var match = domElementRepresentation._0;
                var domElementRepresentation$1 = match.parentElement;
                return {
                    TAG: /* TextSegment */ 0,
                    _0: {
                        TAG: /* NonEmptySegment */ 0,
                        _0: {
                            parentElement: {
                                domElementIdentifier: domElementRepresentation$1.domElementIdentifier,
                                selector: Curry._1(f, domElementRepresentation$1.selector)
                            },
                            textNodeIndex: match.textNodeIndex,
                            text: match.text
                        }
                    }
                };
            }
            var domElementRepresentation$2 = domElementRepresentation._0;
            return {
                TAG: /* TextSegment */ 0,
                _0: {
                    TAG: /* EmptySegment */ 1,
                    _0: {
                        domElementIdentifier: domElementRepresentation$2.domElementIdentifier,
                        selector: Curry._1(f, domElementRepresentation$2.selector)
                    }
                }
            };
        }
        var textSegment = textContent._0;
        if (textSegment.TAG === /* NonEmptySegment */ 0) {
            var textSegment$1 = textSegment._0;
            var domElementRepresentation$3 = textSegment$1.parentElement;
            return {
                TAG: /* TextSegmentAtParagraphBoundary */ 1,
                _0: {
                    TAG: /* NonEmptySegment */ 0,
                    _0: {
                        parentElement: {
                            domElementIdentifier: domElementRepresentation$3.domElementIdentifier,
                            selector: Curry._1(f, domElementRepresentation$3.selector)
                        },
                        textNodeIndex: textSegment$1.textNodeIndex,
                        text: textSegment$1.text
                    }
                }
            };
        }
        var domElementRepresentation$4 = textSegment._0;
        return {
            TAG: /* TextSegmentAtParagraphBoundary */ 1,
            _0: {
                TAG: /* EmptySegment */ 1,
                _0: {
                    domElementIdentifier: domElementRepresentation$4.domElementIdentifier,
                    selector: Curry._1(f, domElementRepresentation$4.selector)
                }
            }
        };
    });
}
function search(domElementIdentifier, textNodeIndex, textContents) {
    var param_textContent = List.hd(textContents);
    var param = {
        nthParagraph: 0,
        index: 0,
        textContent: param_textContent,
        currentParagraphStartsAtIndex: 0
    };
    var param$1 = function param$1(searchResult, textContent, index) {
        var nthParagraph = searchResult.nthParagraph;
        if (textContent.TAG === /* TextSegment */ 0) {
            var match = textContent._0;
            if (match.TAG === /* NonEmptySegment */ 0) {
                var match$1 = match._0;
                if (!(match$1.parentElement.domElementIdentifier === domElementIdentifier && match$1.textNodeIndex === textNodeIndex)) {
                    return [
                        searchResult,
                        undefined
                    ];
                }
                var found_currentParagraphStartsAtIndex = searchResult.currentParagraphStartsAtIndex;
                var found = {
                    nthParagraph: nthParagraph,
                    index: index,
                    textContent: textContent,
                    currentParagraphStartsAtIndex: found_currentParagraphStartsAtIndex
                };
                return [
                    found,
                    found
                ];
            }
            if (match._0.domElementIdentifier !== domElementIdentifier) {
                return [
                    searchResult,
                    undefined
                ];
            }
            var found_currentParagraphStartsAtIndex$1 = searchResult.currentParagraphStartsAtIndex;
            var found$1 = {
                nthParagraph: nthParagraph,
                index: index,
                textContent: textContent,
                currentParagraphStartsAtIndex: found_currentParagraphStartsAtIndex$1
            };
            return [
                found$1,
                found$1
            ];
        }
        var match$2 = textContent._0;
        if (match$2.TAG === /* NonEmptySegment */ 0) {
            var match$3 = match$2._0;
            if (match$3.parentElement.domElementIdentifier === domElementIdentifier && match$3.textNodeIndex === 0) {
                var found_nthParagraph = nthParagraph + 1 | 0;
                var found$2 = {
                    nthParagraph: found_nthParagraph,
                    index: index,
                    textContent: textContent,
                    currentParagraphStartsAtIndex: index
                };
                return [
                    found$2,
                    found$2
                ];
            }
        } else if (match$2._0.domElementIdentifier === domElementIdentifier) {
            var found_nthParagraph$1 = nthParagraph + 1 | 0;
            var found$3 = {
                nthParagraph: found_nthParagraph$1,
                index: index,
                textContent: textContent,
                currentParagraphStartsAtIndex: index
            };
            return [
                found$3,
                found$3
            ];
        }
        return [
            {
                nthParagraph: nthParagraph + 1 | 0,
                index: searchResult.index,
                textContent: searchResult.textContent,
                currentParagraphStartsAtIndex: index
            },
            undefined
        ];
    };
    return ListUtils$SmartcutsMacros.shortcutWithIndexAndState(param, param$1, textContents);
}
function searchNode(domElementIdentifierGenerator, _node, textContents) {
    while(true){
        var node1 = _node;
        var match1 = Webapi__Dom__Node.nodeType(node1);
        if (match1 >= 3) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected Text or Element node when TextContents.searchNode()");
        }
        switch(match1){
            case /* Element */ 0:
                var childNodes = Array.prototype.slice.call(node1.childNodes);
                var firstTextChild = Util$SmartcutsMacros.shortcut2(childNodes, function(node) {
                    var match = Webapi__Dom__Node.nodeType(node);
                    if (match !== 2) {
                        return;
                    } else {
                        return Caml_option.some(node);
                    }
                });
                if (firstTextChild === undefined) {
                    return ArrayUtils$SmartcutsMacros.shortcut(function(childNode) {
                        return searchNode(domElementIdentifierGenerator, childNode, textContents);
                    }, childNodes);
                }
                _node = Caml_option.valFromOption(firstTextChild);
                continue;
            case /* Attribute */ 1:
                return Util$SmartcutsMacros.logAndRaiseJsError("Expected Text or Element node when TextContents.searchNode()");
            case /* Text */ 2:
                var arg = node1.parentElement;
                var arg$11 = arg == null ? undefined : Caml_option.some(arg);
                var element = (function(arg$1) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    };
                })(arg$11)("Expect Text node has Element parent node");
                var arg$21 = Util$SmartcutsMacros.shortcutWithIndex2(Array.prototype.slice.call(element.childNodes), function(node) {
                    return function(sibling, index) {
                        if (Caml_obj.caml_equal(sibling, node)) {
                            return index;
                        }
                    };
                }(node1));
                var textNodeIndex = (function(arg$2) {
                    return function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                    };
                })(arg$21)("Expected to find index of Text node in its containing Element");
                var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(element, domElementIdentifierGenerator);
                return search(domElementIdentifier, textNodeIndex, textContents);
        }
    }
    ;
}
var ForRecordingAndAuthoring = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromElement: fromElement$1,
    updateSelector: updateSelector,
    search: search,
    searchNode: searchNode
};
function fromElement$2(param) {
    return fromElement(function(element) {
        return element;
    }, param);
}
function getElementAtIndex(index, textContents) {
    var match = Belt_List.get(textContents, index);
    if (match === undefined) {
        return;
    }
    if (match.TAG === /* TextSegment */ 0) {
        var element = match._0;
        if (element.TAG === /* NonEmptySegment */ 0) {
            return Caml_option.some(element._0.parentElement);
        } else {
            return Caml_option.some(element._0);
        }
    }
    var element$1 = match._0;
    if (element$1.TAG === /* NonEmptySegment */ 0) {
        return Caml_option.some(element$1._0.parentElement);
    } else {
        return Caml_option.some(element$1._0);
    }
}
var ForPlayback = {
    fromElement: fromElement$2,
    getElementAtIndex: getElementAtIndex
};
exports.TextSegment = TextSegment;
exports.textContent_encode = textContent_encode;
exports.textContent_decode = textContent_decode;
exports.textGet = textGet$1;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring;
exports.ForPlayback = ForPlayback; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 68993:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "replace",
            Decco.stringToJson(v.replace)
        ],
        [
            "replaceWith",
            Decco.stringToJson(v.replaceWith)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var replace = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replace"), null));
    if (replace.TAG === /* Ok */ 0) {
        var replaceWith = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceWith"), null));
        if (replaceWith.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    replace: replace._0,
                    replaceWith: replaceWith._0
                }
            };
        }
        var e = replaceWith._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".replaceWith" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = replace._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".replace" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{replace=" + (param.replace + (", replaceWith=" + (param.replaceWith + "}")));
}
var Replacement = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    if (typeof v === "number") {
        return [
            "NoTransformation"
        ];
    }
    switch(v.TAG | 0){
        case /* ReplaceText */ 0:
            return [
                "ReplaceText",
                Decco.stringToJson(v._0),
                t_encode(v._1),
                Decco.stringToJson(v._2)
            ];
        case /* DeleteText */ 1:
            return [
                "DeleteText",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.stringToJson(v._2)
            ];
        case /* InsertText */ 2:
            return [
                "InsertText",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.stringToJson(v._2)
            ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DeleteText":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* DeleteText */ 1,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "InsertText":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
                if (match$4.TAG === /* Ok */ 0) {
                    if (match$5.TAG === /* Ok */ 0) {
                        if (match$6.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* InsertText */ 2,
                                    _0: match$4._0,
                                    _1: match$5._0,
                                    _2: match$6._0
                                }
                            };
                        }
                        var e$3 = match$6._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                            }
                        };
                    }
                    var e$4 = match$5._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = match$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "NoTransformation":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoTransformation */ 0
                    };
                }
            case "ReplaceText":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        if (match$9.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* ReplaceText */ 0,
                                    _0: match$7._0,
                                    _1: match$8._0,
                                    _2: match$9._0
                                }
                            };
                        }
                        var e$6 = match$9._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$6.path,
                                message: e$6.message,
                                value: e$6.value
                            }
                        };
                    }
                    var e$7 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                        }
                    };
                }
                var e$8 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(v) {
    if (typeof v === "number") {
        return "NoTransformation";
    }
    switch(v.TAG | 0){
        case /* ReplaceText */ 0:
            return "ReplaceText(sharedPrefix=" + (v._0 + (", replacement=" + (stringify(v._1) + (", sharedSuffix=" + (v._2 + ")")))));
        case /* DeleteText */ 1:
            return "DeleteText(sharedPrefix=" + (v._0 + (", deletedText=" + (v._1 + (", sharedSuffix=" + (v._2 + ")")))));
        case /* InsertText */ 2:
            return "InsertText(sharedPrefix=" + (v._0 + (", insertedText=" + (v._1 + (", sharedSuffix=" + (v._2 + ")")))));
    }
}
var StringTransformation = {
    Replacement: Replacement,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function findCommonLeadingChars(chars1, chars2) {
    if (!chars1) {
        return /* [] */ 0;
    }
    if (!chars2) {
        return /* [] */ 0;
    }
    var ch1 = chars1.hd;
    if (ch1 === chars2.hd) {
        return {
            hd: ch1,
            tl: findCommonLeadingChars(chars1.tl, chars2.tl)
        };
    } else {
        return /* [] */ 0;
    }
}
function findCommonPrefix(str1, str2) {
    var charsForStr1 = StringUtils$SmartcutsMacros.split("", str1);
    var charsForStr2 = StringUtils$SmartcutsMacros.split("", str2);
    return StringUtils$SmartcutsMacros.join("", findCommonLeadingChars(charsForStr1, charsForStr2));
}
function findCommonSuffix(str1, str2) {
    var charsForReverseStr1 = Belt_List.reverse(StringUtils$SmartcutsMacros.split("", str1));
    var charsForReverseStr2 = Belt_List.reverse(StringUtils$SmartcutsMacros.split("", str2));
    return StringUtils$SmartcutsMacros.join("", Belt_List.reverse(findCommonLeadingChars(charsForReverseStr1, charsForReverseStr2)));
}
function calcStringTransformation(orderOpt, str1Selection, str1, str2) {
    var order = orderOpt !== undefined ? orderOpt : /* Forward */ 0;
    if (str1 === str2) {
        return /* NoTransformation */ 0;
    }
    if (Caml_obj.caml_equal(str1Selection, [
        0,
        str1.length
    ]) && str1 !== str2) {
        return {
            TAG: /* ReplaceText */ 0,
            _0: "",
            _1: {
                replace: str1,
                replaceWith: str2
            },
            _2: ""
        };
    }
    var match;
    if (order) {
        var sharedSuffix = findCommonSuffix(str1, str2);
        var str1WithoutSharedSuffix = StringUtils$SmartcutsMacros.removeTrailingSuffix(str1, sharedSuffix);
        var str2WithoutSharedSuffix = StringUtils$SmartcutsMacros.removeTrailingSuffix(str2, sharedSuffix);
        var sharedPrefix = findCommonPrefix(str1WithoutSharedSuffix, str2WithoutSharedSuffix);
        var replace = StringUtils$SmartcutsMacros.removeLeadingPrefix(str1WithoutSharedSuffix, sharedPrefix);
        var replaceWith = StringUtils$SmartcutsMacros.removeLeadingPrefix(str2WithoutSharedSuffix, sharedPrefix);
        match = [
            sharedPrefix,
            sharedSuffix,
            replace,
            replaceWith
        ];
    } else {
        var sharedPrefix$1 = findCommonPrefix(str1, str2);
        var str1WithoutSharedPrefix = StringUtils$SmartcutsMacros.removeLeadingPrefix(str1, sharedPrefix$1);
        var str2WithoutSharedPrefix = StringUtils$SmartcutsMacros.removeLeadingPrefix(str2, sharedPrefix$1);
        var sharedSuffix$1 = findCommonSuffix(str1WithoutSharedPrefix, str2WithoutSharedPrefix);
        var replace$1 = StringUtils$SmartcutsMacros.removeTrailingSuffix(str1WithoutSharedPrefix, sharedSuffix$1);
        var replaceWith$1 = StringUtils$SmartcutsMacros.removeTrailingSuffix(str2WithoutSharedPrefix, sharedSuffix$1);
        match = [
            sharedPrefix$1,
            sharedSuffix$1,
            replace$1,
            replaceWith$1
        ];
    }
    var replaceWith$2 = match[3];
    var replace$2 = match[2];
    var sharedSuffix$2 = match[1];
    var sharedPrefix$2 = match[0];
    if (replace$2 === "") {
        return {
            TAG: /* InsertText */ 2,
            _0: sharedPrefix$2,
            _1: replaceWith$2,
            _2: sharedSuffix$2
        };
    } else if (replaceWith$2 === "") {
        return {
            TAG: /* DeleteText */ 1,
            _0: sharedPrefix$2,
            _1: replace$2,
            _2: sharedSuffix$2
        };
    } else {
        return {
            TAG: /* ReplaceText */ 0,
            _0: sharedPrefix$2,
            _1: {
                replace: replace$2,
                replaceWith: replaceWith$2
            },
            _2: sharedSuffix$2
        };
    }
}
exports.StringTransformation = StringTransformation;
exports.findCommonLeadingChars = findCommonLeadingChars;
exports.findCommonPrefix = findCommonPrefix;
exports.findCommonSuffix = findCommonSuffix;
exports.calcStringTransformation = calcStringTransformation; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 32600:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var EscapeStringRegexp = __webpack_require__(63150);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function existential_encode(encoder_a, v) {
    if (typeof v === "number") {
        return [
            "ShouldNotExist"
        ];
    } else if (v.TAG === /* MightExist */ 0) {
        return [
            "MightExist",
            Curry._1(encoder_a, v._0)
        ];
    } else {
        return [
            "MustExist",
            Curry._1(encoder_a, v._0)
        ];
    }
}
function existential_decode(decoder_a, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "MightExist":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MightExist */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "MustExist":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_a, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MustExist */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "ShouldNotExist":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ShouldNotExist */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var regExString_encode = Decco.stringToJson;
var regExString_decode = Decco.stringFromJson;
function t_encode(v) {
    if (v.TAG === /* FixedString */ 0) {
        return [
            "FixedString",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "RegEx",
            Decco.stringToJson(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FixedString":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FixedString */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "RegEx":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RegEx */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v.TAG === /* FixedString */ 0) {
        return v._0;
    } else {
        return "/" + (v._0 + "/");
    }
}
function toJsReSegment(v) {
    if (v.TAG === /* FixedString */ 0) {
        return EscapeStringRegexp(v._0);
    } else {
        return v._0;
    }
}
function fixed(s) {
    return {
        TAG: /* FixedString */ 0,
        _0: s
    };
}
function variable(regExString, param) {
    if (regExString !== undefined) {
        return {
            TAG: /* RegEx */ 1,
            _0: regExString
        };
    } else {
        return {
            TAG: /* RegEx */ 1,
            _0: ".+"
        };
    }
}
function doesMatchString(s, pattern) {
    if (pattern.TAG === /* FixedString */ 0) {
        return s === pattern._0;
    } else {
        return new RegExp(pattern._0).test(s);
    }
}
var StringPattern = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    toJsReSegment: toJsReSegment,
    fixed: fixed,
    variable: variable,
    doesMatchString: doesMatchString
};
function t_encode$1(v) {
    return Decco.arrayToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.arrayFromJson(t_decode, v);
}
function toJsReSegments(fixedStringsOrRegExes) {
    return $$Array.map(toJsReSegment, fixedStringsOrRegExes);
}
function fromStringWithSep(sep, isSepLeading, s) {
    var parts = StringUtils$SmartcutsMacros.split(sep, s);
    return Belt_Array.map((isSepLeading ? function(arr) {
        return Belt_Array.keep(arr, function(x) {
            return x !== "";
        });
    } : function(arr) {
        return arr;
    })($$Array.of_list(parts)), function(param) {
        return {
            TAG: /* RegEx */ 1,
            _0: ".+"
        };
    });
}
var StringArrayPattern = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    toJsReSegments: toJsReSegments,
    fromStringWithSep: fromStringWithSep
};
function t_encode$2(v) {
    if (v.TAG === /* FixedString */ 0) {
        return [
            "FixedString",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "RegExWithOriginal",
            Decco.stringToJson(v._0),
            Decco.stringToJson(v._1)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FixedString":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FixedString */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "RegExWithOriginal":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* RegExWithOriginal */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(v) {
    if (v.TAG === /* FixedString */ 0) {
        return v._0;
    } else {
        return "(/" + (v._0 + ("/, " + (v._1 + ")")));
    }
}
function toJsReSegment$1(v) {
    if (v.TAG === /* FixedString */ 0) {
        return EscapeStringRegexp(v._0);
    } else {
        return v._0;
    }
}
function fixed$1(s) {
    return {
        TAG: /* FixedString */ 0,
        _0: s
    };
}
function variable$1(regEx, originalValue) {
    if (typeof regEx !== "number") {
        return {
            TAG: /* RegExWithOriginal */ 1,
            _0: regEx._0,
            _1: originalValue
        };
    }
    if (regEx !== 0) {
        return {
            TAG: /* RegExWithOriginal */ 1,
            _0: ".+",
            _1: originalValue
        };
    }
    var regExStr = "^" + (EscapeStringRegexp(originalValue) + "$");
    return {
        TAG: /* RegExWithOriginal */ 1,
        _0: regExStr,
        _1: originalValue
    };
}
function doesMatchString$1(s, pattern) {
    if (pattern.TAG === /* FixedString */ 0) {
        return s === pattern._0;
    } else {
        return new RegExp(pattern._0).test(s);
    }
}
function removePrivateInfo(pattern) {
    if (pattern.TAG === /* FixedString */ 0) {
        return {
            TAG: /* FixedString */ 0,
            _0: pattern._0
        };
    }
    var regExString = pattern._0;
    return {
        TAG: /* RegExWithOriginal */ 1,
        _0: regExString,
        _1: regExString
    };
}
var StringPatternWithOriginalValue = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$1,
    toJsReSegment: toJsReSegment$1,
    fixed: fixed$1,
    variable: variable$1,
    doesMatchString: doesMatchString$1,
    removePrivateInfo: removePrivateInfo
};
function t_encode$3(v) {
    return Decco.arrayToJson(function(param) {
        return existential_encode(t_encode$2, param);
    }, v);
}
function t_decode$3(v) {
    return Decco.arrayFromJson(function(param) {
        return existential_decode(t_decode$2, param);
    }, v);
}
function fromStringWithSep$1(sep, isSepLeading, s) {
    var parts = StringUtils$SmartcutsMacros.split(sep, s);
    return Belt_Array.map((isSepLeading ? function(arr) {
        return Belt_Array.keep(arr, function(x) {
            return x !== "";
        });
    } : function(arr) {
        return arr;
    })($$Array.of_list(parts)), function(originalValue) {
        return {
            TAG: /* MightExist */ 0,
            _0: variable$1(/* Loose */ 1, originalValue)
        };
    });
}
var ExistentialStringArrayPatternWithOriginalValues = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromStringWithSep: fromStringWithSep$1
};
function t_encode$4(v) {
    return Decco.arrayToJson(t_encode$2, v);
}
function t_decode$4(v) {
    return Decco.arrayFromJson(t_decode$2, v);
}
function fromStringWithSep$2(sep, isSepLeading, s) {
    var parts = StringUtils$SmartcutsMacros.split(sep, s);
    return Belt_Array.map((isSepLeading ? function(arr) {
        return Belt_Array.keep(arr, function(x) {
            return x !== "";
        });
    } : function(arr) {
        return arr;
    })($$Array.of_list(parts)), function(originalValue) {
        return variable$1(/* Loose */ 1, originalValue);
    });
}
var StringArrayPatternWithOriginalValues = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    fromStringWithSep: fromStringWithSep$2
};
function t_encode$5(v) {
    return Decco.arrayToJson(function(param) {
        return existential_encode(t_encode$2, param);
    }, v);
}
function t_decode$5(v) {
    return Decco.arrayFromJson(function(param) {
        return existential_decode(t_decode$2, param);
    }, v);
}
function doesMatchHostname(hostname, pattern) {
    var patternAsList = $$Array.to_list(pattern);
    var hostnamePartsReversed = List.rev($$String.split_on_char(/* '.' */ 46, hostname));
    if (!hostnamePartsReversed) {
        if (patternAsList) {
            return false;
        } else {
            return true;
        }
    }
    var match1 = hostnamePartsReversed.tl;
    var singleTermDomain = hostnamePartsReversed.hd;
    if (match1) {
        if (!patternAsList) {
            return false;
        }
        var tldPattern = patternAsList.hd;
        if (typeof tldPattern === "number") {
            return false;
        }
        if (tldPattern.TAG === /* MightExist */ 0) {
            return false;
        }
        var match$1 = patternAsList.tl;
        if (!match$1) {
            return false;
        }
        var sldPattern = match$1.hd;
        if (typeof sldPattern === "number") {
            return false;
        }
        if (sldPattern.TAG === /* MightExist */ 0) {
            return false;
        }
        var subdomainsArray = $$Array.of_list(match1.tl);
        if (doesMatchString$1(singleTermDomain, tldPattern._0) && doesMatchString$1(match1.hd, sldPattern._0)) {
            return ArrayUtils$SmartcutsMacros.everyWithIndex($$Array.of_list(match$1.tl), function(i, existentialSubdomainPattern) {
                var match = Belt_Array.get(subdomainsArray, i);
                if (typeof existentialSubdomainPattern === "number") {
                    return match === undefined;
                } else if (existentialSubdomainPattern.TAG === /* MightExist */ 0) {
                    if (match !== undefined) {
                        return doesMatchString$1(match, existentialSubdomainPattern._0);
                    } else {
                        return true;
                    }
                } else if (match !== undefined) {
                    return doesMatchString$1(match, existentialSubdomainPattern._0);
                } else {
                    return false;
                }
            });
        } else {
            return false;
        }
    } else {
        if (!patternAsList) {
            return false;
        }
        var stringPattern = patternAsList.hd;
        if (typeof stringPattern === "number" || stringPattern.TAG === /* MightExist */ 0 || patternAsList.tl) {
            return false;
        } else {
            return doesMatchString$1(singleTermDomain, stringPattern._0);
        }
    }
}
var HostnamePattern = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    doesMatchHostname: doesMatchHostname
};
function t_encode$6(v) {
    return Decco.optionToJson(t_encode$2, v);
}
function t_decode$6(v) {
    return Decco.optionFromJson(t_decode$2, v);
}
function doesMatchPort(port, pattern) {
    if (pattern !== undefined) {
        return doesMatchString$1(port, pattern);
    } else {
        return port === "";
    }
}
var PortPattern = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    doesMatchPort: doesMatchPort
};
function t_encode$7(v) {
    return Decco.arrayToJson(t_encode$2, v);
}
function t_decode$7(v) {
    return Decco.arrayFromJson(t_decode$2, v);
}
function doesMatchPathname(pathname, pattern) {
    var pathnamePartsArray = Belt_Array.keep($$Array.of_list($$String.split_on_char(/* '/' */ 47, pathname)), function(x) {
        return x !== "";
    });
    if (pathnamePartsArray.length === pattern.length) {
        return Belt_Array.every(Belt_Array.zip(pathnamePartsArray, pattern), function(param) {
            return doesMatchString$1(param[0], param[1]);
        });
    } else {
        return false;
    }
}
var PathnamePattern = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    doesMatchPathname: doesMatchPathname
};
function t_encode$8(v) {
    if (typeof v === "number") {
        return [
            "NoVal"
        ];
    } else if (v.TAG === /* SingleVal */ 0) {
        return [
            "SingleVal",
            t_encode$2(v._0)
        ];
    } else {
        return [
            "MultipleVals",
            Decco.arrayToJson(t_encode$2, v._0)
        ];
    }
}
function t_decode$8(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "MultipleVals":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.arrayFromJson(t_decode$2, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MultipleVals */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NoVal":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoVal */ 0
                    };
                }
            case "SingleVal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SingleVal */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function removePrivateInfo$1(v) {
    if (typeof v === "number") {
        return /* NoVal */ 0;
    } else if (v.TAG === /* SingleVal */ 0) {
        return {
            TAG: /* SingleVal */ 0,
            _0: removePrivateInfo(v._0)
        };
    } else {
        return {
            TAG: /* MultipleVals */ 1,
            _0: $$Array.map(removePrivateInfo, v._0)
        };
    }
}
var QueryParamValue = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    removePrivateInfo: removePrivateInfo$1
};
var key_encode = Decco.stringToJson;
var key_decode = Decco.stringFromJson;
function t_encode$9(v) {
    return existential_encode(function(param) {
        return [
            Decco.stringToJson(param[0]),
            t_encode$8(param[1])
        ];
    }, v);
}
function t_decode$9(v) {
    return existential_decode(function(json) {
        var match = Js_json.classify(json);
        if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
        }
        if (match.TAG !== /* JSONArray */ 3) {
            return Decco.error(undefined, "Not a tuple", json);
        }
        var match$1 = match._0;
        if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
        }
        var v0 = match$1[0];
        var v1 = match$1[1];
        var match$2 = Decco.stringFromJson(v0);
        var match$3 = t_decode$8(v1);
        if (match$2.TAG === /* Ok */ 0) {
            if (match$3.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        match$2._0,
                        match$3._0
                    ]
                };
            }
            var e = match$3._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "[1]" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = match$2._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }, v);
}
var QueryParamPattern = {
    key_encode: key_encode,
    key_decode: key_decode,
    t_encode: t_encode$9,
    t_decode: t_decode$9
};
function t_encode$10(v) {
    return Decco.arrayToJson(t_encode$9, v);
}
function t_decode$10(v) {
    return Decco.arrayFromJson(t_decode$9, v);
}
function fromSearch(search) {
    if (search.length === 0) {
        return [];
    } else {
        return Belt_Array.map(Belt_MapString.toArray(Belt_Array.reduce($$Array.of_list($$String.split_on_char(/* '&' */ 38, $$String.sub(search, 1, search.length - 1 | 0))), undefined, function(queryParamByKey, queryParamAssignmentString) {
            var index = queryParamAssignmentString.indexOf("=");
            if (index === -1) {
                return Belt_MapString.update(queryParamByKey, decodeURIComponent(queryParamAssignmentString), function(maybeVal) {
                    if (maybeVal !== undefined && typeof maybeVal !== "number") {
                        return maybeVal;
                    } else {
                        return /* NoVal */ 0;
                    }
                });
            }
            var key = queryParamAssignmentString.slice(0, index);
            var value = queryParamAssignmentString.slice(index + 1 | 0);
            var decodedValue = decodeURIComponent(value);
            var newVal = variable$1(/* Loose */ 1, decodedValue);
            return Belt_MapString.update(queryParamByKey, decodeURIComponent(key), function(maybeVal) {
                if (maybeVal !== undefined && typeof maybeVal !== "number") {
                    if (maybeVal.TAG === /* SingleVal */ 0) {
                        return {
                            TAG: /* MultipleVals */ 1,
                            _0: [
                                maybeVal._0,
                                newVal
                            ]
                        };
                    } else {
                        return {
                            TAG: /* MultipleVals */ 1,
                            _0: $$Array.append(maybeVal._0, [
                                newVal
                            ])
                        };
                    }
                } else {
                    return {
                        TAG: /* SingleVal */ 0,
                        _0: newVal
                    };
                }
            });
        })), function(v) {
            return {
                TAG: /* MightExist */ 0,
                _0: v
            };
        });
    }
}
var QueryParametersPattern = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    fromSearch: fromSearch
};
function t_encode$11(v) {
    return existential_encode(t_encode$2, v);
}
function t_decode$11(v) {
    return existential_decode(t_decode$2, v);
}
function doesMatchHash(hash, pattern) {
    if (typeof pattern === "number") {
        return hash === "";
    } else if (pattern.TAG === /* MightExist */ 0) {
        if (hash === "") {
            return true;
        } else {
            return doesMatchString$1(hash, pattern._0);
        }
    } else if (hash !== "") {
        return doesMatchString$1(hash, pattern._0);
    } else {
        return false;
    }
}
var HashPattern = {
    t_encode: t_encode$11,
    t_decode: t_decode$11,
    doesMatchHash: doesMatchHash
};
function searchParamPattern_encode(v) {
    if (v.TAG === /* SingleVal */ 0) {
        return [
            "SingleVal",
            t_encode(v._0)
        ];
    } else {
        return [
            "ArrayOfVals",
            t_encode(v._0)
        ];
    }
}
function searchParamPattern_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ArrayOfVals":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ArrayOfVals */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SingleVal":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SingleVal */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function searchParamNameAndPattern_encode(v) {
    return [
        Decco.stringToJson(v[0]),
        searchParamPattern_encode(v[1])
    ];
}
function searchParamNameAndPattern_decode(v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
        return Decco.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
        return Decco.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = Decco.stringFromJson(v0);
    var match$3 = searchParamPattern_decode(v1);
    if (match$2.TAG === /* Ok */ 0) {
        if (match$3.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: [
                    match$2._0,
                    match$3._0
                ]
            };
        }
        var e = match$3._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = match$2._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$12(v) {
    return Js_dict.fromArray([
        [
            "protocol",
            Decco.stringToJson(v.protocol)
        ],
        [
            "hostname",
            Decco.arrayToJson(function(param) {
                return existential_encode(t_encode$2, param);
            }, v.hostname)
        ],
        [
            "port",
            Decco.optionToJson(t_encode$2, v.port)
        ],
        [
            "pathname",
            Decco.arrayToJson(t_encode$2, v.pathname)
        ],
        [
            "hash",
            existential_encode(t_encode$2, v.hash)
        ],
        [
            "search",
            Decco.arrayToJson(t_encode$9, v.search)
        ]
    ]);
}
function t_decode$12(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var protocol = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "protocol"), null));
    if (protocol.TAG === /* Ok */ 0) {
        var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null);
        var hostname = Decco.arrayFromJson(function(param) {
            return existential_decode(t_decode$2, param);
        }, v$1);
        if (hostname.TAG === /* Ok */ 0) {
            var port = Decco.optionFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "port"), null));
            if (port.TAG === /* Ok */ 0) {
                var pathname = Decco.arrayFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pathname"), null));
                if (pathname.TAG === /* Ok */ 0) {
                    var hash = existential_decode(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
                    if (hash.TAG === /* Ok */ 0) {
                        var search = Decco.arrayFromJson(t_decode$9, Belt_Option.getWithDefault(Js_dict.get(dict$1, "search"), null));
                        if (search.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    protocol: protocol._0,
                                    hostname: hostname._0,
                                    port: port._0,
                                    pathname: pathname._0,
                                    hash: hash._0,
                                    search: search._0
                                }
                            };
                        }
                        var e = search._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".search" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = hash._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".hash" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = pathname._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".pathname" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = port._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".port" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = hostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hostname" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = protocol._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".protocol" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function toChromeMatchPattern(param1) {
    var protocolToPathname = param1.protocol + ("//" + (Belt_Array.reduceWithIndex(Belt_Array.reverse(param1.hostname), [
        [],
        false
    ], function(param, component, i) {
        var didSeePattern = param[1];
        var hostPatterns = param[0];
        if (typeof component === "number") {
            return [
                hostPatterns,
                didSeePattern
            ];
        }
        if (component.TAG !== /* MightExist */ 0) {
            var str = component._0;
            if (str.TAG === /* FixedString */ 0) {
                return [
                    $$Array.append(hostPatterns, [
                        str._0
                    ]),
                    didSeePattern
                ];
            }
        }
        if (i !== 0) {
            if (didSeePattern) {
                return [
                    hostPatterns,
                    true
                ];
            } else {
                return [
                    [
                        "*"
                    ],
                    true
                ];
            }
        } else {
            return [
                [
                    "*"
                ],
                true
            ];
        }
    })[0].join(".") + ("/" + Belt_Array.map(param1.pathname, function(component) {
        if (component.TAG === /* FixedString */ 0) {
            return component._0;
        } else {
            return "*";
        }
    }).join("/"))));
    if (protocolToPathname.endsWith("*")) {
        return protocolToPathname;
    } else if (typeof param1.hash === "number") {
        if (param1.search.length !== 0) {
            return protocolToPathname + "*";
        } else {
            return protocolToPathname;
        }
    } else {
        return protocolToPathname + "*";
    }
}
function getOriginalUrl(param) {
    var search = param.search;
    var hash = param.hash;
    var pathname = param.pathname;
    var port = param.port;
    var hostname_ = Belt_Array.reverse(ArrayUtils$SmartcutsMacros.filterMap(function(component) {
        if (typeof component === "number") {
            return;
        }
        var v = component._0;
        if (v.TAG === /* FixedString */ 0) {
            return v._0;
        } else {
            return v._1;
        }
    }, param.hostname)).join(".");
    var port_ = port !== undefined ? port.TAG === /* FixedString */ 0 ? ":" + port._0 : ":" + port._1 : "";
    var pathname_ = pathname.length !== 0 ? "/" + $$Array.map(function(component) {
        if (component.TAG === /* FixedString */ 0) {
            return component._0;
        } else {
            return component._1;
        }
    }, pathname).join("/") : "";
    var hash_;
    if (typeof hash === "number" || hash.TAG === /* MightExist */ 0) {
        hash_ = "";
    } else {
        var v2 = hash._0;
        hash_ = v2.TAG === /* FixedString */ 0 ? "#" + v2._0 : "#" + v2._1;
    }
    var search_ = search.length !== 0 ? Belt_Array.reduce(search, "?", function(searchString, component) {
        var kv;
        if (typeof component === "number") {
            kv = undefined;
        } else {
            var match = component._0;
            var value = match[1];
            var key = match[0];
            if (typeof value === "number") {
                kv = undefined;
            } else if (value.TAG === /* SingleVal */ 0) {
                var v = value._0;
                kv = v.TAG === /* FixedString */ 0 ? [
                    key,
                    v._0
                ] : [
                    key,
                    v._1
                ];
            } else {
                kv = Util$SmartcutsMacros.logAndRaiseJsError("TODO: unhandled MultipleVals(_) at UrlPattern.getOriginalUrl()");
            }
        }
        if (kv === undefined) {
            return searchString;
        }
        var v$1 = kv[1];
        var k = kv[0];
        if (searchString === "?") {
            return searchString + (k + ("=" + v$1));
        } else {
            return searchString + ("&" + (k + ("=" + v$1)));
        }
    }) : "";
    return param.protocol + ("//" + (hostname_ + (port_ + (pathname_ + (hash_ + search_)))));
}
function removePrivateInfo$2(urlConstraint) {
    var pathname = $$Array.map(removePrivateInfo, urlConstraint.pathname);
    var v = urlConstraint.hash;
    var hash;
    hash = typeof v === "number" ? /* ShouldNotExist */ 0 : v.TAG === /* MightExist */ 0 ? {
        TAG: /* MightExist */ 0,
        _0: removePrivateInfo(v._0)
    } : {
        TAG: /* MustExist */ 1,
        _0: removePrivateInfo(v._0)
    };
    var search = Belt_Array.map(urlConstraint.search, function(component) {
        if (typeof component === "number") {
            return /* ShouldNotExist */ 0;
        }
        if (component.TAG === /* MightExist */ 0) {
            var match = component._0;
            return {
                TAG: /* MightExist */ 0,
                _0: [
                    match[0],
                    removePrivateInfo$1(match[1])
                ]
            };
        }
        var match$1 = component._0;
        return {
            TAG: /* MustExist */ 1,
            _0: [
                match$1[0],
                removePrivateInfo$1(match$1[1])
            ]
        };
    });
    return {
        protocol: urlConstraint.protocol,
        hostname: urlConstraint.hostname,
        port: urlConstraint.port,
        pathname: pathname,
        hash: hash,
        search: search
    };
}
function fromUrl(u) {
    var parts = List.rev(StringUtils$SmartcutsMacros.split(".", u.hostname));
    var tmp;
    if (parts) {
        var match = parts.tl;
        var singleTermDomain = parts.hd;
        tmp = match ? $$Array.of_list({
            hd: {
                TAG: /* MustExist */ 1,
                _0: {
                    TAG: /* FixedString */ 0,
                    _0: singleTermDomain
                }
            },
            tl: {
                hd: {
                    TAG: /* MustExist */ 1,
                    _0: {
                        TAG: /* FixedString */ 0,
                        _0: match.hd
                    }
                },
                tl: List.map(function(subdomain) {
                    return {
                        TAG: /* MightExist */ 0,
                        _0: variable$1(/* Loose */ 1, subdomain)
                    };
                }, match.tl)
            }
        }) : [
            {
                TAG: /* MustExist */ 1,
                _0: {
                    TAG: /* FixedString */ 0,
                    _0: singleTermDomain
                }
            }
        ];
    } else {
        tmp = [];
    }
    return {
        protocol: u.protocol,
        hostname: tmp,
        port: OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(u.port), function(port) {
            return variable$1(/* Loose */ 1, port);
        }),
        pathname: fromStringWithSep$2("/", true, u.pathname),
        hash: {
            TAG: /* MightExist */ 0,
            _0: variable$1(/* Loose */ 1, u.hash)
        },
        search: fromSearch(u.search)
    };
}
function doesMatchUrl(url, pattern) {
    if (url.protocol === pattern.protocol && doesMatchPort(url.port, pattern.port) && doesMatchHostname(url.hostname, pattern.hostname) && doesMatchPathname(url.pathname, pattern.pathname)) {
        return doesMatchHash(url.hash, pattern.hash);
    } else {
        return false;
    }
}
var UrlPattern = {
    searchParamPattern_encode: searchParamPattern_encode,
    searchParamPattern_decode: searchParamPattern_decode,
    searchParamNameAndPattern_encode: searchParamNameAndPattern_encode,
    searchParamNameAndPattern_decode: searchParamNameAndPattern_decode,
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    toChromeMatchPattern: toChromeMatchPattern,
    getOriginalUrl: getOriginalUrl,
    removePrivateInfo: removePrivateInfo$2,
    fromUrl: fromUrl,
    doesMatchUrl: doesMatchUrl
};
function t_encode$13(v) {
    if (v) {
        return [
            "FlexibleMatch",
            t_encode$12(v._0)
        ];
    } else {
        return [
            "ExactMatch"
        ];
    }
}
function t_decode$13(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExactMatch":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExactMatch */ 0
                    };
                }
            case "FlexibleMatch":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$12(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FlexibleMatch */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function flexibleMatchFromUrlString(url) {
    var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(url);
    if (urlRecord !== undefined) {
        return /* FlexibleMatch */ {
            _0: fromUrl(urlRecord)
        };
    }
    throw {
        RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
        _1: url,
        Error: new Error()
    };
}
function groupGen(urls) {
    return Belt_Array.reduce(urls, [], function(groups, url1) {
        if ($$Array.exists(function(param) {
            return Curry._1(param[1], url1);
        }, groups)) {
            return groups;
        }
        var segments = fromStringWithSep$2("/", true, url1.pathname);
        var pathPattern = Belt_Array.reduceWithIndex(segments, segments, function(patternWithDynamicPath, stringPattern, index) {
            var arg;
            arg = stringPattern.TAG === /* FixedString */ 0 ? stringPattern : {
                TAG: /* FixedString */ 0,
                _0: stringPattern._1
            };
            var patternWithFixedPath = function(param) {
                return ArrayUtils$SmartcutsMacros.replaceAtIndex(param, index, arg);
            }(patternWithDynamicPath);
            var match = Belt_Array.keep(urls, function(url) {
                return doesMatchPathname(url.pathname, patternWithFixedPath);
            });
            var match$1 = Belt_Array.keep(urls, function(url) {
                return doesMatchPathname(url.pathname, patternWithDynamicPath);
            });
            if (match.length > 1 || !(match.length < match$1.length || match.length !== match$1.length)) {
                return patternWithFixedPath;
            } else {
                return patternWithDynamicPath;
            }
        });
        var indexOfRegExps = ArrayUtils$SmartcutsMacros.filterMapi(function(index, stringPattern) {
            if (stringPattern.TAG === /* FixedString */ 0) {
                return;
            } else {
                return index;
            }
        }, pathPattern);
        var hostname = url1.hostname;
        var key = hostname + ("/" + $$Array.mapi(function(index, stringPattern) {
            if (stringPattern.TAG === /* FixedString */ 0) {
                return stringPattern._0;
            }
            var match = indexOfRegExps.length;
            if (match === 1) {
                return ":id";
            }
            var nth = indexOfRegExps.indexOf(index);
            return ":id" + String(nth + 1 | 0);
        }, pathPattern).join("/"));
        var fn = function fn(url) {
            if (url.hostname === hostname) {
                return doesMatchPathname(url.pathname, pathPattern);
            } else {
                return false;
            }
        };
        return $$Array.append(groups, [
            [
                key,
                fn
            ]
        ]);
    });
}
exports.existential_encode = existential_encode;
exports.existential_decode = existential_decode;
exports.regExString_encode = regExString_encode;
exports.regExString_decode = regExString_decode;
exports.StringPattern = StringPattern;
exports.StringArrayPattern = StringArrayPattern;
exports.StringPatternWithOriginalValue = StringPatternWithOriginalValue;
exports.ExistentialStringArrayPatternWithOriginalValues = ExistentialStringArrayPatternWithOriginalValues;
exports.StringArrayPatternWithOriginalValues = StringArrayPatternWithOriginalValues;
exports.HostnamePattern = HostnamePattern;
exports.PortPattern = PortPattern;
exports.PathnamePattern = PathnamePattern;
exports.QueryParamValue = QueryParamValue;
exports.QueryParamPattern = QueryParamPattern;
exports.QueryParametersPattern = QueryParametersPattern;
exports.HashPattern = HashPattern;
exports.UrlPattern = UrlPattern;
exports.t_encode = t_encode$13;
exports.t_decode = t_decode$13;
exports.flexibleMatchFromUrlString = flexibleMatchFromUrlString;
exports.groupGen = groupGen; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 31682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Js_dict = __webpack_require__(97076);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Belt_SetString = __webpack_require__(41367);
var FastLevenshtein = __webpack_require__(95493);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function fromString(urlString) {
    return Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(urlString), function(nativeUrl) {
        return {
            nativeUrl: nativeUrl,
            protocol: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.protocol),
            username: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.username),
            password: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.password),
            hostname: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.hostname),
            port: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.port),
            pathname: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.pathname),
            searchParams: Belt_MapString.fromArray(Js_dict.entries(Object.fromEntries(nativeUrl.searchParams.entries()))),
            hash: OptionUtils$SmartcutsMacros.optionalString(nativeUrl.hash)
        };
    });
}
function toString(url) {
    return url.nativeUrl.href;
}
var Url = {
    fromString: fromString,
    toString: toString
};
function calcLevenshteinBtwnComponents(pluckComponent, urlA, urlB) {
    var match = Curry._1(pluckComponent, urlA);
    var match$1 = Curry._1(pluckComponent, urlB);
    if (match !== undefined) {
        if (match$1 !== undefined) {
            return FastLevenshtein.get(match, match$1);
        } else {
            return FastLevenshtein.get("", match);
        }
    } else if (match$1 !== undefined) {
        return FastLevenshtein.get("", match$1);
    } else {
        return 0;
    }
}
function calcLevenshteinBtwnProtocols(param, param$1) {
    return calcLevenshteinBtwnComponents(function(url) {
        return url.protocol;
    }, param, param$1);
}
function calcLevenshteinBtwnUsernames(param, param$1) {
    return calcLevenshteinBtwnComponents(function(url) {
        return url.username;
    }, param, param$1);
}
function calcLevenshteinBtwnPasswords(param, param$1) {
    return calcLevenshteinBtwnComponents(function(url) {
        return url.password;
    }, param, param$1);
}
function calcLevenshteinBtwnPorts(param, param$1) {
    return calcLevenshteinBtwnComponents(function(url) {
        return url.port;
    }, param, param$1);
}
function calcLevenshteinBtwnHashes(param, param$1) {
    return calcLevenshteinBtwnComponents(function(url) {
        return url.hash;
    }, param, param$1);
}
function calcLevenshteinBtwnStringLists(listA, listB) {
    var str;
    var rest;
    if (listA) {
        var remainingA = listA.tl;
        var strA = listA.hd;
        if (listB) {
            return FastLevenshtein.get(strA, listB.hd) + calcLevenshteinBtwnStringLists(remainingA, listB.tl) | 0;
        }
        str = strA;
        rest = remainingA;
    } else {
        if (!listB) {
            return 0;
        }
        str = listB.hd;
        rest = listB.tl;
    }
    return FastLevenshtein.get(str, "") + calcLevenshteinBtwnStringLists(rest, /* [] */ 0) | 0;
}
function calcLevenshteinBtwnHostnames(urlA, urlB) {
    var partsA = List.rev(StringUtils$SmartcutsMacros.split(".", OptionUtils$SmartcutsMacros.withDefault("", urlA.hostname)));
    var partsB = List.rev(StringUtils$SmartcutsMacros.split(".", OptionUtils$SmartcutsMacros.withDefault("", urlB.hostname)));
    return calcLevenshteinBtwnStringLists(partsA, partsB);
}
function calcLevenshteinBtwnPathnames(urlA, urlB) {
    var partsA = StringUtils$SmartcutsMacros.split("/", OptionUtils$SmartcutsMacros.withDefault("", urlA.pathname));
    var partsB = StringUtils$SmartcutsMacros.split("/", OptionUtils$SmartcutsMacros.withDefault("", urlB.pathname));
    return calcLevenshteinBtwnStringLists(partsA, partsB);
}
function calcLevenshteinBtwnSearchParams(urlA, urlB) {
    var allKeys = Belt_SetString.toList(Belt_SetString.union(Belt_SetString.fromArray(Belt_MapString.keysToArray(urlA.searchParams)), Belt_SetString.fromArray(Belt_MapString.keysToArray(urlB.searchParams))));
    return Belt_List.reduce(allKeys, 0, function(accumLevenshteinDistance, key) {
        var match = Belt_MapString.get(urlA.searchParams, key);
        var match$1 = Belt_MapString.get(urlB.searchParams, key);
        return accumLevenshteinDistance + (match !== undefined ? match$1 !== undefined ? FastLevenshtein.get(match, match$1) : FastLevenshtein.get(key + match, "") : match$1 !== undefined ? FastLevenshtein.get(key + match$1, "") : 0) | 0;
    });
}
function calcLevenshteinDistance(urlA, urlB) {
    return ((((((calcLevenshteinBtwnUsernames(urlA, urlB) + calcLevenshteinBtwnUsernames(urlA, urlB) | 0) + calcLevenshteinBtwnPasswords(urlA, urlB) | 0) + calcLevenshteinBtwnPorts(urlA, urlB) | 0) + calcLevenshteinBtwnHostnames(urlA, urlB) | 0) + calcLevenshteinBtwnPathnames(urlA, urlB) | 0) + calcLevenshteinBtwnSearchParams(urlA, urlB) | 0) + calcLevenshteinBtwnHashes(urlA, urlB) | 0;
}
function sortUrlsByLevenshteinDistanceAsc(relativeToUrl, urlStrings) {
    var url = fromString(relativeToUrl);
    var relativeUrl;
    if (url !== undefined) {
        relativeUrl = url;
    } else {
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: relativeToUrl,
            Error: new Error()
        };
    }
    var arg = Belt_Array.map(urlStrings, function(urlStr) {
        var url$p = fromString(urlStr);
        if (url$p !== undefined) {
            return url$p;
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: urlStr,
            Error: new Error()
        };
    });
    return Belt_Array.map(function(param) {
        return ArrayUtils$SmartcutsMacros.sort(param, arg);
    }(function(urlA, urlB) {
        return calcLevenshteinDistance(relativeUrl, urlA) - calcLevenshteinDistance(relativeUrl, urlB) | 0;
    }), toString);
}
var NativeUrl;
exports.NativeUrl = NativeUrl;
exports.Url = Url;
exports.calcLevenshteinBtwnComponents = calcLevenshteinBtwnComponents;
exports.calcLevenshteinBtwnProtocols = calcLevenshteinBtwnProtocols;
exports.calcLevenshteinBtwnUsernames = calcLevenshteinBtwnUsernames;
exports.calcLevenshteinBtwnPasswords = calcLevenshteinBtwnPasswords;
exports.calcLevenshteinBtwnPorts = calcLevenshteinBtwnPorts;
exports.calcLevenshteinBtwnHashes = calcLevenshteinBtwnHashes;
exports.calcLevenshteinBtwnStringLists = calcLevenshteinBtwnStringLists;
exports.calcLevenshteinBtwnHostnames = calcLevenshteinBtwnHostnames;
exports.calcLevenshteinBtwnPathnames = calcLevenshteinBtwnPathnames;
exports.calcLevenshteinBtwnSearchParams = calcLevenshteinBtwnSearchParams;
exports.calcLevenshteinDistance = calcLevenshteinDistance;
exports.sortUrlsByLevenshteinDistanceAsc = sortUrlsByLevenshteinDistanceAsc; /* fast-levenshtein Not a pure module */ 


/***/ }),

/***/ 83292:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var IdMaker$SmartcutsMacros = __webpack_require__(83188);
var Password$SmartcutsMacros = __webpack_require__(71191);
var UserCredential__Shared$SmartcutsMacros = __webpack_require__(74605);
var include = IdMaker$SmartcutsMacros.Make({
    name: "PasswordCredentialId"
});
var id_encode = include.id_encode;
var id_decode = include.id_decode;
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
    if (hostname.TAG === /* Ok */ 0) {
        var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
        if (username.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    hostname: hostname._0,
                    username: username._0
                }
            };
        }
        var e = username._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".username" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = hostname._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hostname" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{hostname: " + (param.hostname + (", username: " + (param.username + "}")));
}
var WithoutIdOrPassword = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ],
        [
            "password",
            Password$SmartcutsMacros.t_encode(v.password)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
    if (hostname.TAG === /* Ok */ 0) {
        var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
        if (username.TAG === /* Ok */ 0) {
            var password = Password$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
            if (password.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        hostname: hostname._0,
                        username: username._0,
                        password: password._0
                    }
                };
            }
            var e = password._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".password" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = username._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".username" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = hostname._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hostname" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(x) {
    return "{hostname: " + (x.hostname + (", username: " + (x.username + (", password: " + (Password$SmartcutsMacros.obfuscate(x.password) + "}")))));
}
var WithoutIdWithPassword = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            Curry._1(id_encode, v.id)
        ],
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ],
        [
            "reEntryStatus",
            UserCredential__Shared$SmartcutsMacros.reEntryStatus_encode(v.reEntryStatus)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
        if (hostname.TAG === /* Ok */ 0) {
            var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
            if (username.TAG === /* Ok */ 0) {
                var reEntryStatus = UserCredential__Shared$SmartcutsMacros.reEntryStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reEntryStatus"), null));
                if (reEntryStatus.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            hostname: hostname._0,
                            username: username._0,
                            reEntryStatus: reEntryStatus._0
                        }
                    };
                }
                var e = reEntryStatus._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".reEntryStatus" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = username._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".username" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = hostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hostname" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var WithIdAndNeedsReEntryStatusWithoutPassword = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "id",
            Curry._1(id_encode, v.id)
        ],
        [
            "hostname",
            Decco.stringToJson(v.hostname)
        ],
        [
            "username",
            Decco.stringToJson(v.username)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Curry._1(id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
        if (hostname.TAG === /* Ok */ 0) {
            var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
            if (username.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        id: id._0,
                        hostname: hostname._0,
                        username: username._0
                    }
                };
            }
            var e = username._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".username" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = hostname._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".hostname" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var doesEqualStringId = include.doesEqualStringId;
var cmp = include.cmp;
exports.id_encode = id_encode;
exports.id_decode = id_decode;
exports.doesEqualStringId = doesEqualStringId;
exports.cmp = cmp;
exports.WithoutIdOrPassword = WithoutIdOrPassword;
exports.WithoutIdWithPassword = WithoutIdWithPassword;
exports.WithIdAndNeedsReEntryStatusWithoutPassword = WithIdAndNeedsReEntryStatusWithoutPassword;
exports.t_encode = t_encode$3;
exports.t_decode = t_decode$3; /* include Not a pure module */ 


/***/ }),

/***/ 74605:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var otherSecretData_encode = Decco.unitToJson;
var otherSecretData_decode = Decco.unitFromJson;
function stringifyOtherSecretData(param) {
    return "";
}
function minifyOtherSecretData(param) {}
function loginStatus_encode(v) {
    if (typeof v === "number") {
        return [
            "NoLoginAttemptedYet"
        ];
    } else if (v.TAG === /* LoginSucceeded */ 0) {
        return [
            "LoginSucceeded",
            Decco.floatToJson(v._0)
        ];
    } else {
        return [
            "LoginFailed",
            Decco.floatToJson(v._0)
        ];
    }
}
function loginStatus_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "LoginFailed":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoginFailed */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "LoginSucceeded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* LoginSucceeded */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "NoLoginAttemptedYet":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoLoginAttemptedYet */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function reEntryStatus_encode(v) {
    switch(v){
        case /* NotKnown */ 0:
            return [
                "NotKnown"
            ];
        case /* DoesNeedToBeReentered */ 1:
            return [
                "DoesNeedToBeReentered"
            ];
        case /* DoesNotNeedToBeReentered */ 2:
            return [
                "DoesNotNeedToBeReentered"
            ];
    }
}
function reEntryStatus_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DoesNeedToBeReentered":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoesNeedToBeReentered */ 1
                    };
                }
            case "DoesNotNeedToBeReentered":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoesNotNeedToBeReentered */ 2
                    };
                }
            case "NotKnown":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotKnown */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function question_encode(v) {
    return Js_dict.fromArray([
        [
            "questionText",
            Decco.stringToJson(v.questionText)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ]
    ]);
}
function question_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var questionText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "questionText"), null));
    if (questionText.TAG === /* Ok */ 0) {
        var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
        if (selector.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    questionText: questionText._0,
                    selector: selector._0
                }
            };
        }
        var e = selector._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selector" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = questionText._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".questionText" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function inputType_encode(v) {
    if (v) {
        return [
            "TextInput"
        ];
    } else {
        return [
            "Dropdown"
        ];
    }
}
function inputType_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Dropdown":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Dropdown */ 0
                    };
                }
            case "TextInput":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* TextInput */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function anwser_encode(v) {
    return Js_dict.fromArray([
        [
            "answerText",
            Decco.stringToJson(v.answerText)
        ],
        [
            "inputType",
            inputType_encode(v.inputType)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ]
    ]);
}
function anwser_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var answerText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "answerText"), null));
    if (answerText.TAG === /* Ok */ 0) {
        var inputType = inputType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputType"), null));
        if (inputType.TAG === /* Ok */ 0) {
            var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
            if (selector.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        answerText: answerText._0,
                        inputType: inputType._0,
                        selector: selector._0
                    }
                };
            }
            var e = selector._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selector" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = inputType._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".inputType" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = answerText._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".answerText" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var SecurityQuestion = {
    question_encode: question_encode,
    question_decode: question_decode,
    anwser_encode: anwser_encode,
    anwser_decode: anwser_decode,
    inputType_encode: inputType_encode,
    inputType_decode: inputType_decode
};
exports.otherSecretData_encode = otherSecretData_encode;
exports.otherSecretData_decode = otherSecretData_decode;
exports.stringifyOtherSecretData = stringifyOtherSecretData;
exports.minifyOtherSecretData = minifyOtherSecretData;
exports.loginStatus_encode = loginStatus_encode;
exports.loginStatus_decode = loginStatus_decode;
exports.reEntryStatus_encode = reEntryStatus_encode;
exports.reEntryStatus_decode = reEntryStatus_decode;
exports.SecurityQuestion = SecurityQuestion; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 94534:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Event = __webpack_require__(71451);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var states = [
    [
        0,
        /* EMPTY */ 0
    ],
    [
        1,
        /* LOADING */ 1
    ],
    [
        2,
        /* DONE */ 2
    ]
];
function stringify(readyState1) {
    switch(readyState1){
        case /* EMPTY */ 0:
            return "EMPTY";
        case /* LOADING */ 1:
            return "LOADING";
        case /* DONE */ 2:
            return "DONE";
    }
}
function toJs(readyState2) {
    var arg = ArrayUtils$SmartcutsMacros.shortcut(function(param) {
        if (param[1] === readyState2) {
            return param[0];
        }
    }, states);
    var param1 = "Expect to find numeric value for readyState=" + stringify(readyState2);
    return OptionUtils$SmartcutsMacros.getExn(param1, arg);
}
function fromJs(number) {
    return ArrayUtils$SmartcutsMacros.shortcut(function(param) {
        if (number === param[0]) {
            return param[1];
        }
    }, states);
}
function fromJsExn(number) {
    var arg = fromJs(number);
    var param = "Expect to find matching value of readyState for n=" + String(number);
    return OptionUtils$SmartcutsMacros.getExn(param, arg);
}
var include = Webapi__Dom__Event.Impl({});
var include$1 = Webapi__Dom__Event.Impl({});
function readyState(fileReader) {
    return fromJsExn(fileReader.readyState);
}
function readAsArrayBufferPromise(fileReader, blob) {
    return new Promise(function(resolve, param) {
        fileReader.onload = function(loadEvent) {
            return resolve({
                TAG: /* Ok */ 0,
                _0: Caml_option.nullable_to_opt(loadEvent.target.result)
            });
        };
        fileReader.onabort = function(param) {
            return resolve({
                TAG: /* Error */ 1,
                _0: /* FileReaderDidAbort */ 0
            });
        };
        fileReader.onerror = function(errorEvent) {
            return resolve({
                TAG: /* Error */ 1,
                _0: /* FileReaderDidError */ {
                    _0: errorEvent
                }
            });
        };
        fileReader.readAsArrayBuffer(blob);
    });
}
function readAsDataUrlPromise(fileReader, blob) {
    return new Promise(function(resolve, param) {
        fileReader.onload = function(loadEvent) {
            return resolve({
                TAG: /* Ok */ 0,
                _0: Caml_option.nullable_to_opt(loadEvent.target.result)
            });
        };
        fileReader.onabort = function(param) {
            return resolve({
                TAG: /* Error */ 1,
                _0: /* FileReaderDidAbort */ 0
            });
        };
        fileReader.onerror = function(errorEvent) {
            return resolve({
                TAG: /* Error */ 1,
                _0: /* FileReaderDidError */ {
                    _0: errorEvent
                }
            });
        };
        fileReader.readAsDataURL(blob);
    });
}
function make(prim) {
    return new FileReader();
}
function addEventListener(prim0, prim1, prim2) {
    prim0.addEventListener(prim1, prim2);
}
var ReadyState = {
    stringify: stringify,
    toJs: toJs,
    fromJs: fromJs,
    fromJsExn: fromJsExn
};
function LoadEvent_bubbles(prim) {
    return prim.bubbles;
}
function LoadEvent_cancelable(prim) {
    return prim.cancelable;
}
function LoadEvent_composed(prim) {
    return prim.composed;
}
function LoadEvent_currentTarget(prim) {
    return prim.currentTarget;
}
function LoadEvent_defaultPrevented(prim) {
    return prim.defaultPrevented;
}
var LoadEvent_eventPhase = include.eventPhase;
function LoadEvent_timeStamp(prim) {
    return prim.timeStamp;
}
function LoadEvent_type_(prim) {
    return prim.type;
}
function LoadEvent_isTrusted(prim) {
    return prim.isTrusted;
}
function LoadEvent_preventDefault(prim) {
    prim.preventDefault();
}
function LoadEvent_stopImmediatePropagation(prim) {
    prim.stopImmediatePropagation();
}
function LoadEvent_stopPropagation(prim) {
    prim.stopPropagation();
}
function LoadEvent_target(prim) {
    return prim.target;
}
var LoadEvent = {
    bubbles: LoadEvent_bubbles,
    cancelable: LoadEvent_cancelable,
    composed: LoadEvent_composed,
    currentTarget: LoadEvent_currentTarget,
    defaultPrevented: LoadEvent_defaultPrevented,
    eventPhase: LoadEvent_eventPhase,
    timeStamp: LoadEvent_timeStamp,
    type_: LoadEvent_type_,
    isTrusted: LoadEvent_isTrusted,
    preventDefault: LoadEvent_preventDefault,
    stopImmediatePropagation: LoadEvent_stopImmediatePropagation,
    stopPropagation: LoadEvent_stopPropagation,
    target: LoadEvent_target
};
function setOnload(prim0, prim1) {
    prim0.onload = prim1;
}
function ErrorEvent_bubbles(prim) {
    return prim.bubbles;
}
function ErrorEvent_cancelable(prim) {
    return prim.cancelable;
}
function ErrorEvent_composed(prim) {
    return prim.composed;
}
function ErrorEvent_currentTarget(prim) {
    return prim.currentTarget;
}
function ErrorEvent_defaultPrevented(prim) {
    return prim.defaultPrevented;
}
var ErrorEvent_eventPhase = include$1.eventPhase;
function ErrorEvent_timeStamp(prim) {
    return prim.timeStamp;
}
function ErrorEvent_type_(prim) {
    return prim.type;
}
function ErrorEvent_isTrusted(prim) {
    return prim.isTrusted;
}
function ErrorEvent_preventDefault(prim) {
    prim.preventDefault();
}
function ErrorEvent_stopImmediatePropagation(prim) {
    prim.stopImmediatePropagation();
}
function ErrorEvent_stopPropagation(prim) {
    prim.stopPropagation();
}
function ErrorEvent_target(prim) {
    return prim.target;
}
var $$ErrorEvent = {
    bubbles: ErrorEvent_bubbles,
    cancelable: ErrorEvent_cancelable,
    composed: ErrorEvent_composed,
    currentTarget: ErrorEvent_currentTarget,
    defaultPrevented: ErrorEvent_defaultPrevented,
    eventPhase: ErrorEvent_eventPhase,
    timeStamp: ErrorEvent_timeStamp,
    type_: ErrorEvent_type_,
    isTrusted: ErrorEvent_isTrusted,
    preventDefault: ErrorEvent_preventDefault,
    stopImmediatePropagation: ErrorEvent_stopImmediatePropagation,
    stopPropagation: ErrorEvent_stopPropagation,
    target: ErrorEvent_target
};
function setOnError(prim0, prim1) {
    prim0.onerror = prim1;
}
function setOnAbort(prim0, prim1) {
    prim0.onabort = prim1;
}
function DOMException_code(prim) {
    return prim.code;
}
function DOMException_name(prim) {
    return prim.name;
}
function DOMException_message(prim) {
    return prim.message;
}
var $$DOMException = {
    code: DOMException_code,
    name: DOMException_name,
    message: DOMException_message
};
function error(prim) {
    return prim.error;
}
function abort(prim) {
    prim.abort();
}
exports.make = make;
exports.addEventListener = addEventListener;
exports.ReadyState = ReadyState;
exports.LoadEvent = LoadEvent;
exports.setOnload = setOnload;
exports.$$ErrorEvent = $$ErrorEvent;
exports.setOnError = setOnError;
exports.setOnAbort = setOnAbort;
exports.readyState = readyState;
exports.$$DOMException = $$DOMException;
exports.error = error;
exports.abort = abort;
exports.readAsArrayBufferPromise = readAsArrayBufferPromise;
exports.readAsDataUrlPromise = readAsDataUrlPromise; /* include Not a pure module */ 


/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var _map = {
    "sha1": "SHA-1",
    "sha256": "SHA-256",
    "sha384": "SHA-384",
    "sha512": "SHA-512"
};
var _revMap = {
    "SHA-1": "sha1",
    "SHA-256": "sha256",
    "SHA-384": "sha384",
    "SHA-512": "sha512"
};
function algorithmToJs(param) {
    return _map[param];
}
function algorithmFromJs(param) {
    return _revMap[param];
}
var Digest = {
    algorithmToJs: algorithmToJs,
    algorithmFromJs: algorithmFromJs
};
function digest(algorithm, arrayBuffer) {
    return crypto.subtle.digest(_map[algorithm], arrayBuffer);
}
exports.Digest = Digest;
exports.digest = digest; /* No side effect */ 


/***/ }),

/***/ 73029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function resultTypeToJs(param) {
    return param + 0 | 0;
}
function resultTypeFromJs(param) {
    if (param <= 9 && 0 <= param) {
        return param - 0 | 0;
    }
}
var External = {};
var IteratorResult = {};
function snapshotItem(result, index) {
    return Caml_option.nullable_to_opt(result.ext.snapshotItem(index));
}
var SnapshotResult = {
    snapshotItem: snapshotItem
};
function classify(v) {
    var match = resultTypeFromJs(v.resultType);
    if (match === undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected resultType: " + String(v.resultType));
    }
    switch(match){
        case /* ANY_TYPE */ 0:
            return {
                TAG: /* AnyResult */ 0,
                _0: v
            };
        case /* NUMBER_TYPE */ 1:
            return {
                TAG: /* NumberResult */ 2,
                _0: v.numberValue
            };
        case /* STRING_TYPE */ 2:
            return {
                TAG: /* StringResult */ 3,
                _0: v.stringValue
            };
        case /* BOOLEAN_TYPE */ 3:
            return {
                TAG: /* BooleanResult */ 1,
                _0: v.booleanValue
            };
        case /* UNORDERED_NODE_ITERATOR_TYPE */ 4:
            return {
                TAG: /* UnorderedNodeIteratorResult */ 4,
                _0: {
                    invalidIteratorState: v.invalidIteratorState,
                    ext: v
                }
            };
        case /* ORDERED_NODE_ITERATOR_TYPE */ 5:
            return {
                TAG: /* OrderedNodeIteratorResult */ 5,
                _0: {
                    invalidIteratorState: v.invalidIteratorState,
                    ext: v
                }
            };
        case /* UNORDERED_NODE_SNAPSHOT_TYPE */ 6:
            return {
                TAG: /* UnorderedNodeSnapshotResult */ 6,
                _0: {
                    snapshotLength: v.snapshotLength,
                    ext: v
                }
            };
        case /* ORDERED_NODE_SNAPSHOT_TYPE */ 7:
            return {
                TAG: /* OrderedNodeSnapshotResult */ 7,
                _0: {
                    snapshotLength: v.snapshotLength,
                    ext: v
                }
            };
        case /* ANY_UNORDERED_NODE_TYPE */ 8:
            return {
                TAG: /* AnyUnorderedNodeResult */ 8,
                _0: {
                    invalidIteratorState: v.invalidIteratorState,
                    ext: v
                }
            };
        case /* FIRST_ORDERED_NODE_TYPE */ 9:
            return {
                TAG: /* FirstOrderedNodeResult */ 9,
                _0: {
                    invalidIteratorState: v.invalidIteratorState,
                    ext: v
                }
            };
    }
}
var Result = {
    resultTypeToJs: resultTypeToJs,
    resultTypeFromJs: resultTypeFromJs,
    External: External,
    IteratorResult: IteratorResult,
    SnapshotResult: SnapshotResult,
    classify: classify
};
var Expression = {};
var Evaluator = {};
function normalizeSpace(builder) {
    return "normalize-space(" + (builder + ")");
}
function translate(from, to_, builder) {
    return "translate(" + (builder + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(from)) + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(to_)) + ")")))));
}
function lowercase(param) {
    return translate("ABCDEFGHIJKLMNOPQRSTUVWXYZ", "abcdefghijklmnopqrstuvwxyz", param);
}
function equals(value, builder) {
    return builder + ("=" + StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(value)));
}
function contains(value, builder) {
    return "contains(" + (builder + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(value)) + ")")));
}
function elementWithOrDescendantElementsWith(builder) {
    return "(.//*|.)[" + (builder + "]");
}
var ExpressionBuilder = {
    text: "text()",
    dot: ".",
    normalizeSpace: normalizeSpace,
    translate: translate,
    lowercase: lowercase,
    equals: equals,
    contains: contains,
    elementWithOrDescendantElementsWith: elementWithOrDescendantElementsWith
};
exports.Result = Result;
exports.Expression = Expression;
exports.Evaluator = Evaluator;
exports.ExpressionBuilder = ExpressionBuilder; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 28538:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var DOM__Topology$SmartcutsMacros = __webpack_require__(35071);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "color",
            Decco.stringToJson(v.color)
        ],
        [
            "selected",
            Decco.boolToJson(v.selected)
        ],
        [
            "selectorPattern",
            Curry._1(DOM__Topology$SmartcutsMacros.ElementGrouper.SelectorPattern.t_encode, v.selectorPattern)
        ],
        [
            "expectedInitialLinkCount",
            Decco.intToJson(v.expectedInitialLinkCount)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */ 0) {
        var color = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "color"), null));
        if (color.TAG === /* Ok */ 0) {
            var selected = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selected"), null));
            if (selected.TAG === /* Ok */ 0) {
                var selectorPattern = Curry._1(DOM__Topology$SmartcutsMacros.ElementGrouper.SelectorPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorPattern"), null));
                if (selectorPattern.TAG === /* Ok */ 0) {
                    var expectedInitialLinkCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "expectedInitialLinkCount"), null));
                    if (expectedInitialLinkCount.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                name: name._0,
                                color: color._0,
                                selected: selected._0,
                                selectorPattern: selectorPattern._0,
                                expectedInitialLinkCount: expectedInitialLinkCount._0
                            }
                        };
                    }
                    var e = expectedInitialLinkCount._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".expectedInitialLinkCount" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = selectorPattern._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".selectorPattern" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = selected._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selected" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = color._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".color" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = name._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".name" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function doesMatchElement($staropt$star, element, param) {
    var indexBuffer = $staropt$star !== undefined ? $staropt$star : 0;
    return Curry._3(DOM__Topology$SmartcutsMacros.ElementGrouper.SelectorPattern.doesMatchElement, indexBuffer, element, param.selectorPattern);
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.doesMatchElement = doesMatchElement; /* DOM__Topology-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 12433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Selector$SmartcutsMacros = __webpack_require__(14809);
function t_encode(v) {
    if (v.TAG === /* FindAndClick */ 0) {
        return [
            "FindAndClick",
            Selector$SmartcutsMacros.selector_encode(v._0)
        ];
    } else {
        return [
            "ScrollBy",
            Decco.floatToJson(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FindAndClick":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FindAndClick */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ScrollBy":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ScrollBy */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v.TAG === /* FindAndClick */ 0) {
        return "FindAndClick(selector)";
    } else {
        return "ScrollBy(" + (v._0.toString() + ")");
    }
}
function selectorGet(v) {
    if (v.TAG === /* FindAndClick */ 0) {
        return v._0;
    }
}
function mapSelector(f, v) {
    if (v.TAG === /* FindAndClick */ 0) {
        return {
            TAG: /* FindAndClick */ 0,
            _0: Curry._1(f, v._0)
        };
    } else {
        return {
            TAG: /* ScrollBy */ 1,
            _0: v._0
        };
    }
}
var PaginateFn = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    selectorGet: selectorGet,
    mapSelector: mapSelector
};
function pageUntil_encode(v) {
    if (typeof v === "number") {
        if (v === /* UntilAllPages */ 0) {
            return [
                "UntilAllPages"
            ];
        } else {
            return [
                "NoMorePages"
            ];
        }
    } else if (v.TAG === /* UntilNextNPages */ 0) {
        return [
            "UntilNextNPages",
            Decco.intToJson(v._0)
        ];
    } else {
        return [
            "UntilNItems",
            Decco.intToJson(v._0)
        ];
    }
}
function pageUntil_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NoMorePages":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoMorePages */ 1
                    };
                }
            case "UntilAllPages":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UntilAllPages */ 0
                    };
                }
            case "UntilNItems":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UntilNItems */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UntilNextNPages":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UntilNextNPages */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyPageUntil(v) {
    if (typeof v === "number") {
        if (v === /* UntilAllPages */ 0) {
            return "UntilAllPages";
        } else {
            return "NoMorePages";
        }
    } else if (v.TAG === /* UntilNextNPages */ 0) {
        return "UntilNextNPages(" + (String(v._0) + ")");
    } else {
        return "UntilNItems(" + v._0 + ")";
    }
}
function humanizePageUntil(v) {
    if (typeof v === "number") {
        if (v === /* UntilAllPages */ 0) {
            return "Paginate all loadable pages";
        } else {
            return "Do not paginate";
        }
    } else if (v.TAG === /* UntilNextNPages */ 0) {
        return "Paginate next " + v._0 + " pages";
    } else {
        return "Paginate " + v._0 + " items";
    }
}
exports.PaginateFn = PaginateFn;
exports.pageUntil_encode = pageUntil_encode;
exports.pageUntil_decode = pageUntil_decode;
exports.stringifyPageUntil = stringifyPageUntil;
exports.humanizePageUntil = humanizePageUntil; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 15618:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Css = __webpack_require__(62418);
var Curry = __webpack_require__(41386);
var React = __webpack_require__(67294);
var ReactDom = __webpack_require__(73935);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Css_Legacy_Core = __webpack_require__(48050);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function getDocumentBody(param) {
    var arg = document.querySelector("body");
    var arg$1 = arg == null ? undefined : Caml_option.some(arg);
    var param$1 = "Expect to find <body> element";
    return OptionUtils$SmartcutsMacros.getExn(param$1, arg$1);
}
function PlaybackModal$Loader(Props) {
    var w = Props.width;
    var duration = Props.duration;
    var bounce = Curry._1(Css.keyframes, {
        hd: [
            0,
            {
                hd: Css.left("zero"),
                tl: /* [] */ 0
            }
        ],
        tl: {
            hd: [
                50,
                {
                    hd: Css.left({
                        NAME: "px",
                        VAL: w
                    }),
                    tl: /* [] */ 0
                }
            ],
            tl: {
                hd: [
                    100,
                    {
                        hd: Css.left("zero"),
                        tl: /* [] */ 0
                    }
                ],
                tl: /* [] */ 0
            }
        }
    });
    var dot = function dot(index) {
        return Curry._1(Css.style, {
            hd: Css.position("absolute"),
            tl: {
                hd: Css.width({
                    NAME: "px",
                    VAL: 6
                }),
                tl: {
                    hd: Css.height({
                        NAME: "px",
                        VAL: 6
                    }),
                    tl: {
                        hd: Css.borderRadius({
                            NAME: "percent",
                            VAL: 50.0
                        }),
                        tl: {
                            hd: Css.left("zero"),
                            tl: {
                                hd: Css.top("zero"),
                                tl: {
                                    hd: Css.background({
                                        NAME: "hex",
                                        VAL: "fff"
                                    }),
                                    tl: {
                                        hd: Css.animationName(bounce),
                                        tl: {
                                            hd: Css.animationDuration(duration),
                                            tl: {
                                                hd: Css.animationIterationCount("infinite"),
                                                tl: {
                                                    hd: Css.animationDelay(Math.imul(index, duration) / 20 | 0),
                                                    tl: /* [] */ 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    };
    return React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.height({
                NAME: "px",
                VAL: 24
            }),
            tl: {
                hd: Css.paddingTop({
                    NAME: "px",
                    VAL: 8
                }),
                tl: {
                    hd: Css.selector(".path", {
                        hd: Css.margin("auto"),
                        tl: {
                            hd: Css.height({
                                NAME: "px",
                                VAL: 6
                            }),
                            tl: {
                                hd: Css.position("relative"),
                                tl: {
                                    hd: Css.width({
                                        NAME: "px",
                                        VAL: w
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        })
    }, React.createElement("div", {
        className: "path"
    }, React.createElement("div", {
        className: dot(0)
    }), React.createElement("div", {
        className: dot(1)
    }), React.createElement("div", {
        className: dot(2)
    })));
}
var Loader = {
    make: PlaybackModal$Loader
};
var containerId = "smartcuts_playback_modal";
function PlaybackModal$PlaybackModal(Props) {
    return React.createElement("div", {
        className: Curry._1(Css.style, {
            hd: Css.position("fixed"),
            tl: {
                hd: Css.bottom({
                    NAME: "px",
                    VAL: 20
                }),
                tl: {
                    hd: Css.left({
                        NAME: "vw",
                        VAL: 50.0
                    }),
                    tl: {
                        hd: Css.transform({
                            NAME: "translateX",
                            VAL: {
                                NAME: "percent",
                                VAL: -50.0
                            }
                        }),
                        tl: {
                            hd: Css.zIndex(20000),
                            tl: {
                                hd: Css.background({
                                    NAME: "hex",
                                    VAL: "222"
                                }),
                                tl: {
                                    hd: Css.padding2({
                                        NAME: "px",
                                        VAL: 20
                                    }, {
                                        NAME: "px",
                                        VAL: 30
                                    }),
                                    tl: {
                                        hd: Css.borderRadius({
                                            NAME: "px",
                                            VAL: 8
                                        }),
                                        tl: {
                                            hd: Css.fontFamily("sansSerif"),
                                            tl: {
                                                hd: Css.boxShadow(Css_Legacy_Core.Shadow.box(undefined, undefined, {
                                                    NAME: "px",
                                                    VAL: 10
                                                }, {
                                                    NAME: "px",
                                                    VAL: 2
                                                }, undefined, {
                                                    NAME: "rgba",
                                                    VAL: [
                                                        0,
                                                        0,
                                                        0,
                                                        {
                                                            NAME: "percent",
                                                            VAL: 25.0
                                                        }
                                                    ]
                                                })),
                                                tl: {
                                                    hd: Css.selector("p, h2", {
                                                        hd: Css.color({
                                                            NAME: "hex",
                                                            VAL: "fff"
                                                        }),
                                                        tl: /* [] */ 0
                                                    }),
                                                    tl: {
                                                        hd: Css.selector("p", {
                                                            hd: Css.fontWeight("semiBold"),
                                                            tl: /* [] */ 0
                                                        }),
                                                        tl: {
                                                            hd: Css.selector(".actions", {
                                                                hd: Css.display("flex"),
                                                                tl: {
                                                                    hd: Css.flexDirection("row"),
                                                                    tl: {
                                                                        hd: Css.selector("& > *", {
                                                                            hd: Css.flexGrow(1.0),
                                                                            tl: /* [] */ 0
                                                                        }),
                                                                        tl: {
                                                                            hd: Css.selector("& > button", {
                                                                                hd: Css.flexGrow(0.0),
                                                                                tl: /* [] */ 0
                                                                            }),
                                                                            tl: /* [] */ 0
                                                                        }
                                                                    }
                                                                }
                                                            }),
                                                            tl: /* [] */ 0
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }, React.createElement(PlaybackModal$Loader, {
        width: 100,
        duration: 1500
    }), React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s("Smartcuts is operating")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("Please do not close or interact with this window while Smartcuts is operating. ")));
}
var PlaybackModal = {
    containerId: containerId,
    make: PlaybackModal$PlaybackModal
};
function render(param) {
    var container = document.createElement("div");
    container.id = containerId;
    getDocumentBody(undefined).appendChild(container);
    ReactDom.render(React.createElement(PlaybackModal$PlaybackModal, {}), container);
}
function remove(param) {
    Belt_Option.map(Caml_option.nullable_to_opt(document.getElementById(containerId)), function(borderLeft) {
        return getDocumentBody(undefined).removeChild(borderLeft);
    });
}
exports.Loader = Loader;
exports.PlaybackModal = PlaybackModal;
exports.render = render;
exports.remove = remove; /* Css Not a pure module */ 


/***/ }),

/***/ 48421:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_js_exceptions = __webpack_require__(74518);
var ImagekitJavascript = __webpack_require__(55710);
var Config__ImageKit$SmartcutsMacros = __webpack_require__(73890);
var InitParams = {};
var client = new ImagekitJavascript({
    publicKey: Config__ImageKit$SmartcutsMacros.publicKey,
    urlEndpoint: "https://ik.imagekit.io/" + Config__ImageKit$SmartcutsMacros.id,
    authenticationEndpoint: "https://trysmartcuts.com" + "/api/imagekit_auth"
});
var UploadWithBlobParams = {};
var UploadWithBase64Params = {};
var UploadResult = {};
function uploadWithBlob(params, client1) {
    return new Promise(function(resolve, reject) {
        try {
            client1.upload(params, function(nullableErr, result) {
                if (nullableErr == null) {
                    return resolve(result);
                } else {
                    return reject(nullableErr);
                }
            });
            return;
        } catch (raw_exn) {
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            return reject(exn);
        }
    });
}
function uploadWithBase64(params, client2) {
    return new Promise(function(resolve, reject) {
        try {
            client2.upload(params, function(nullableErr, result) {
                if (nullableErr == null) {
                    return resolve(result);
                } else {
                    return reject(nullableErr);
                }
            });
            return;
        } catch (raw_exn) {
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            return reject(exn);
        }
    });
}
exports.InitParams = InitParams;
exports.client = client;
exports.UploadWithBlobParams = UploadWithBlobParams;
exports.UploadWithBase64Params = UploadWithBase64Params;
exports.UploadResult = UploadResult;
exports.uploadWithBlob = uploadWithBlob;
exports.uploadWithBase64 = uploadWithBase64; /* client Not a pure module */ 


/***/ }),

/***/ 57783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
function getActiveTabOfLastFocusedWindow(param) {
    return Browser__Tabs$SmartcutsMacros.query({
        active: true,
        lastFocusedWindow: true
    }).then(function(results) {
        return Promise.resolve(Belt_Option.map(Belt_Array.get(results, 0), Browser__Tabs$SmartcutsMacros.Tab.fromJs));
    });
}
function getActiveTabOfCurrentWindow(param) {
    return Browser__Tabs$SmartcutsMacros.query({
        active: true,
        currentWindow: true
    }).then(function(tabs) {
        var tabWithStringStatus = Belt_Array.get(tabs, 0);
        if (tabWithStringStatus === undefined) {
            return Promise.resolve(undefined);
        }
        var tab = Browser__Tabs$SmartcutsMacros.Tab.fromJs(Caml_option.valFromOption(tabWithStringStatus));
        return Promise.resolve(tab);
    });
}
function findTabsWithFirstMatchingUrlPattern(urlPatterns) {
    if (!urlPatterns) {
        return Promise.resolve([]);
    }
    var remainingUrlPatterns = urlPatterns.tl;
    return Browser__Tabs$SmartcutsMacros.query({
        url: [
            urlPatterns.hd
        ]
    }).then(function(tabsWithStringStatus) {
        if (tabsWithStringStatus.length !== 0) {
            return Promise.resolve(tabsWithStringStatus);
        } else {
            return findTabsWithFirstMatchingUrlPattern(remainingUrlPatterns);
        }
    });
}
exports.getActiveTabOfLastFocusedWindow = getActiveTabOfLastFocusedWindow;
exports.getActiveTabOfCurrentWindow = getActiveTabOfCurrentWindow;
exports.findTabsWithFirstMatchingUrlPattern = findTabsWithFirstMatchingUrlPattern; /* Browser__Tabs-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 40495:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function runPromiseWhileAlsoHandlingTabDraggingError(doPromise) {
    return PromiseUtils$SmartcutsMacros.untilNoMatchingJsPromiseError(undefined, doPromise, function(error) {
        var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, error);
        if (typeof jsExn === "number") {
            return false;
        }
        if (jsExn.TAG !== /* JsExn */ 0) {
            return false;
        }
        var match = jsExn._0.message;
        if (match === undefined) {
            return false;
        }
        switch(match){
            case "Tabs cannot be edited right now (user may be dragging a tab).":
            case "Tabs cannot be queried right now (user may be dragging a tab).":
                return true;
            default:
                return false;
        }
    }, undefined);
}
exports.runPromiseWhileAlsoHandlingTabDraggingError = runPromiseWhileAlsoHandlingTabDraggingError; /* PromiseUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 60051:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Js_exn = __webpack_require__(82900);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var AccountInfo = {};
var GetAuthToken = {};
function getAuthToken(throwIfNotGrantedOrRevoked, interactive, account, scopes, param) {
    return new Promise(function(resolve, reject) {
        chrome.identity.getAuthToken({
            interactive: interactive,
            account: account,
            scopes: scopes
        }, function(authToken) {
            var jsExn = browser.runtime.lastError;
            if (jsExn == null) {
                return resolve(authToken);
            }
            var msg = jsExn.message;
            if (msg !== undefined && !throwIfNotGrantedOrRevoked && msg.includes("OAuth2 not granted or revoked.")) {
                return resolve(undefined);
            }
            return reject(Js_exn.raiseError(OptionUtils$SmartcutsMacros.withDefault("", jsExn.message)));
        });
    });
}
var RemoveCachedAuthToken = {};
function removeCachedAuthToken(token) {
    return new Promise(function(resolve, param) {
        chrome.identity.removeCachedAuthToken({
            token: token
        }, function(param) {
            var jsExn = browser.runtime.lastError;
            if (jsExn == null) {
                return resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            } else {
                return resolve({
                    TAG: /* Error */ 1,
                    _0: jsExn
                });
            }
        });
    });
}
var LaunchWebAuthFlow = {};
function launchWebAuthFlow(interactive, url, param) {
    return browser.identity.launchWebAuthFlow({
        url: url,
        interactive: interactive
    });
}
exports.AccountInfo = AccountInfo;
exports.GetAuthToken = GetAuthToken;
exports.getAuthToken = getAuthToken;
exports.RemoveCachedAuthToken = RemoveCachedAuthToken;
exports.removeCachedAuthToken = removeCachedAuthToken;
exports.LaunchWebAuthFlow = LaunchWebAuthFlow;
exports.launchWebAuthFlow = launchWebAuthFlow; /* No side effect */ 


/***/ }),

/***/ 49325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Belt_List = __webpack_require__(11332);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var _map = {
    "normal": "normal",
    "popup": "popup",
    "panel": "panel",
    "app": "app",
    "devtools": "devtools"
};
function windowTypeToJs(param) {
    return param;
}
function windowTypeFromJs(param) {
    return _map[param];
}
var _map$1 = {
    "normal": "normal",
    "minimized": "minimized",
    "maximized": "maximized",
    "fullscreen": "fullscreen"
};
function windowStateToJs(param) {
    return param;
}
function windowStateFromJs(param) {
    return _map$1[param];
}
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
function make(id, focused, top, left, width, height, tabs, incognito, type_, state, alwaysOnTop, sessionId, param) {
    var type_$1 = OptionUtils$SmartcutsMacros.$neg$question$great(type_, windowTypeToJs);
    var state$1 = OptionUtils$SmartcutsMacros.$neg$question$great(state, windowStateToJs);
    var tmp = {
        focused: focused,
        top: top,
        incognito: incognito,
        alwaysOnTop: alwaysOnTop
    };
    if (id !== undefined) {
        tmp.id = Caml_option.valFromOption(id);
    }
    if (left !== undefined) {
        tmp.left = Caml_option.valFromOption(left);
    }
    if (width !== undefined) {
        tmp.width = Caml_option.valFromOption(width);
    }
    if (height !== undefined) {
        tmp.height = Caml_option.valFromOption(height);
    }
    if (tabs !== undefined) {
        tmp.tabs = Caml_option.valFromOption(tabs);
    }
    if (type_$1 !== undefined) {
        tmp.type = Caml_option.valFromOption(type_$1);
    }
    if (state$1 !== undefined) {
        tmp.state = Caml_option.valFromOption(state$1);
    }
    if (sessionId !== undefined) {
        tmp.sessionId = Caml_option.valFromOption(sessionId);
    }
    return tmp;
}
function extractTabIds($$window) {
    var jsTabs = $$window.tabs;
    if (jsTabs !== undefined) {
        return Belt_List.keepMap($$Array.to_list($$Array.map(Browser__Tabs$SmartcutsMacros.Tab.fromJs, jsTabs)), function(tab) {
            return tab.id;
        });
    } else {
        return /* [] */ 0;
    }
}
var Window_t_encode = include.t_encode;
var Window_t_decode = include.t_decode;
var $$Window = {
    t_encode: Window_t_encode,
    t_decode: Window_t_decode,
    make: make,
    extractTabIds: extractTabIds
};
var OnCreated = {};
var OnRemoved = {};
var OnFocusedChanged = {};
function make$1(populate, windowTypes, param1) {
    var windowTypes$1 = OptionUtils$SmartcutsMacros.$neg$question$great(windowTypes, function(param) {
        return $$Array.map(windowTypeToJs, param);
    });
    var tmp = {};
    if (populate !== undefined) {
        tmp.populate = Caml_option.valFromOption(populate);
    }
    if (windowTypes$1 !== undefined) {
        tmp.windowTypes = Caml_option.valFromOption(windowTypes$1);
    }
    return tmp;
}
var GetInfo = {
    make: make$1
};
var CreateDataWithOptionalUrl = {};
var CreateDataWithMultipleUrls = {};
var CreateExternal = {
    CreateDataWithOptionalUrl: CreateDataWithOptionalUrl,
    CreateDataWithMultipleUrls: CreateDataWithMultipleUrls
};
var _map$2 = {
    "normal": "normal",
    "popup": "popup",
    "panel": "panel"
};
function createTypeToJs(param) {
    return param;
}
function createTypeFromJs(param) {
    return _map$2[param];
}
function createWithNoUrl(tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
    var tmp = {};
    if (tabId !== undefined) {
        tmp.tabId = Caml_option.valFromOption(tabId);
    }
    if (left !== undefined) {
        tmp.left = Caml_option.valFromOption(left);
    }
    if (top !== undefined) {
        tmp.top = Caml_option.valFromOption(top);
    }
    if (width !== undefined) {
        tmp.width = Caml_option.valFromOption(width);
    }
    if (height !== undefined) {
        tmp.height = Caml_option.valFromOption(height);
    }
    if (focused !== undefined) {
        tmp.focused = Caml_option.valFromOption(focused);
    }
    if (incognito !== undefined) {
        tmp.incognito = Caml_option.valFromOption(incognito);
    }
    var tmp$1 = type_ !== undefined ? type_ : undefined;
    if (tmp$1 !== undefined) {
        tmp.type = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = state !== undefined ? state : undefined;
    if (tmp$2 !== undefined) {
        tmp.state = Caml_option.valFromOption(tmp$2);
    }
    if (setSelfAsOpener !== undefined) {
        tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
    }
    return browser.windows.create(tmp);
}
function createWithUrl(url, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
    var tmp = {
        url: url
    };
    if (tabId !== undefined) {
        tmp.tabId = Caml_option.valFromOption(tabId);
    }
    if (left !== undefined) {
        tmp.left = Caml_option.valFromOption(left);
    }
    if (top !== undefined) {
        tmp.top = Caml_option.valFromOption(top);
    }
    if (width !== undefined) {
        tmp.width = Caml_option.valFromOption(width);
    }
    if (height !== undefined) {
        tmp.height = Caml_option.valFromOption(height);
    }
    if (focused !== undefined) {
        tmp.focused = Caml_option.valFromOption(focused);
    }
    if (incognito !== undefined) {
        tmp.incognito = Caml_option.valFromOption(incognito);
    }
    var tmp$1 = type_ !== undefined ? type_ : undefined;
    if (tmp$1 !== undefined) {
        tmp.type = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = state !== undefined ? state : undefined;
    if (tmp$2 !== undefined) {
        tmp.state = Caml_option.valFromOption(tmp$2);
    }
    if (setSelfAsOpener !== undefined) {
        tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
    }
    return browser.windows.create(tmp);
}
function createWithMultipleUrls(urls, tabId, left, top, width, height, focused, incognito, type_, state, setSelfAsOpener, param) {
    var tmp = {
        url: urls
    };
    if (tabId !== undefined) {
        tmp.tabId = Caml_option.valFromOption(tabId);
    }
    if (left !== undefined) {
        tmp.left = Caml_option.valFromOption(left);
    }
    if (top !== undefined) {
        tmp.top = Caml_option.valFromOption(top);
    }
    if (width !== undefined) {
        tmp.width = Caml_option.valFromOption(width);
    }
    if (height !== undefined) {
        tmp.height = Caml_option.valFromOption(height);
    }
    if (focused !== undefined) {
        tmp.focused = Caml_option.valFromOption(focused);
    }
    if (incognito !== undefined) {
        tmp.incognito = Caml_option.valFromOption(incognito);
    }
    var tmp$1 = type_ !== undefined ? type_ : undefined;
    if (tmp$1 !== undefined) {
        tmp.type = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = state !== undefined ? state : undefined;
    if (tmp$2 !== undefined) {
        tmp.state = Caml_option.valFromOption(tmp$2);
    }
    if (setSelfAsOpener !== undefined) {
        tmp.setSelfAsOpener = Caml_option.valFromOption(setSelfAsOpener);
    }
    return browser.windows.create(tmp);
}
var UpdateExternal = {};
function update(windowId, left, top, width, height, focused, drawAttention, state, param) {
    var tmp = {};
    if (left !== undefined) {
        tmp.left = Caml_option.valFromOption(left);
    }
    if (top !== undefined) {
        tmp.top = Caml_option.valFromOption(top);
    }
    if (width !== undefined) {
        tmp.width = Caml_option.valFromOption(width);
    }
    if (height !== undefined) {
        tmp.height = Caml_option.valFromOption(height);
    }
    if (focused !== undefined) {
        tmp.focused = Caml_option.valFromOption(focused);
    }
    if (drawAttention !== undefined) {
        tmp.drawAttention = Caml_option.valFromOption(drawAttention);
    }
    var tmp$1 = state !== undefined ? state : undefined;
    if (tmp$1 !== undefined) {
        tmp.state = Caml_option.valFromOption(tmp$1);
    }
    return browser.windows.update(windowId, tmp);
}
function getOnlyTabOfWindow($$window) {
    var arg = $$window.id;
    var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
    var windowId = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expect window.id");
    return Browser__Tabs$SmartcutsMacros.query({
        active: true,
        windowId: windowId
    }).then(function(tabs) {
        var len = tabs.length;
        if (len !== 1) {
            if (len !== 0) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: created window has more than 1 tab; should have exactly 1");
            } else {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: created window has no tabs");
            }
        }
        var jsTab = tabs[0];
        return Promise.resolve(Browser__Tabs$SmartcutsMacros.Tab.fromJs(jsTab));
    });
}
var Helpers = {
    getOnlyTabOfWindow: getOnlyTabOfWindow
};
exports.windowTypeToJs = windowTypeToJs;
exports.windowTypeFromJs = windowTypeFromJs;
exports.windowStateToJs = windowStateToJs;
exports.windowStateFromJs = windowStateFromJs;
exports.$$Window = $$Window;
exports.OnCreated = OnCreated;
exports.OnRemoved = OnRemoved;
exports.OnFocusedChanged = OnFocusedChanged;
exports.GetInfo = GetInfo;
exports.CreateExternal = CreateExternal;
exports.createTypeToJs = createTypeToJs;
exports.createTypeFromJs = createTypeFromJs;
exports.createWithNoUrl = createWithNoUrl;
exports.createWithUrl = createWithUrl;
exports.createWithMultipleUrls = createWithMultipleUrls;
exports.UpdateExternal = UpdateExternal;
exports.update = update;
exports.Helpers = Helpers; /* include Not a pure module */ 


/***/ }),

/***/ 50108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function getQuerySelectorForCheckboxIdAndNameAndValue(id, name, value) {
    if (id !== undefined) {
        return "#" + id;
    } else if (name !== undefined) {
        if (value === "on") {
            return "input[type=checkbox][name='" + (name + "']");
        } else {
            return "input[type=checkbox][name='" + (name + ("'][value='" + (value + "']")));
        }
    } else if (value === "on") {
        return "input[type=checkbox]";
    } else {
        return "input[type=checkbox][value='" + (value + "']");
    }
}
function t_encode(v) {
    if (v) {
        return [
            "Uncheck"
        ];
    } else {
        return [
            "Check"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Check":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Check */ 0
                    };
                }
            case "Uncheck":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Uncheck */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(action) {
    if (action) {
        return "Uncheck";
    } else {
        return "Check";
    }
}
function upsertOrRemoveValueInCheckedValues(action, value, checkedValues) {
    if (action) {
        return ListUtils$SmartcutsMacros.remove(value, checkedValues);
    } else {
        return ListUtils$SmartcutsMacros.upsert(value, checkedValues);
    }
}
var CheckboxAction = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    upsertOrRemoveValueInCheckedValues: upsertOrRemoveValueInCheckedValues
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.optionToJson(Decco.stringToJson, v.id)
        ],
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "checkedDefault",
            Decco.boolToJson(v.checkedDefault)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
        if (label.TAG === /* Ok */ 0) {
            var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                var checkedDefault = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkedDefault"), null));
                if (checkedDefault.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            id: id._0,
                            label: label._0,
                            value: value._0,
                            checkedDefault: checkedDefault._0
                        }
                    };
                }
                var e = checkedDefault._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".checkedDefault" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = label._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".label" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$1(param) {
    return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", value=" + (param.value + ((param.checkedDefault ? ", checked" : "") + (", id=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.id) + "}"))))));
}
var CheckboxOption = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "action",
            t_encode(v.action)
        ],
        [
            "id",
            Decco.optionToJson(Decco.stringToJson, v.id)
        ],
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "name",
            Decco.optionToJson(Decco.stringToJson, v.name)
        ],
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "options",
            Decco.listToJson(t_encode$1, v.options)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var action = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
    if (action.TAG === /* Ok */ 0) {
        var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
        if (id.TAG === /* Ok */ 0) {
            var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
                if (name.TAG === /* Ok */ 0) {
                    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
                    if (label.TAG === /* Ok */ 0) {
                        var options = Decco.listFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
                        if (options.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    action: action._0,
                                    id: id._0,
                                    value: value._0,
                                    name: name._0,
                                    label: label._0,
                                    options: options._0
                                }
                            };
                        }
                        var e = options._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".options" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = label._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".label" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = name._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".name" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = id._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".id" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = action._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".action" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function didInteractWithCheckboxOption(checkboxOption, interaction) {
    if (!Caml_obj.caml_equal(checkboxOption.id, interaction.id)) {
        return false;
    }
    if (!Caml_obj.caml_equal(checkboxOption.label, interaction.label)) {
        return false;
    }
    var match = interaction.value;
    var match$1 = checkboxOption.value;
    if (match === "on" && match$1 === "") {
        return true;
    } else {
        return interaction.value === checkboxOption.value;
    }
}
function stringify$2(param) {
    return "{action=" + ((param.action ? "Uncheck" : "Check") + (", value=" + (StringUtils$SmartcutsMacros.quote(param.value) + (", name=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.name) + (", label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", id=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.id) + (", options=" + (StringUtils$SmartcutsMacros.join(", ", List.map(stringify$1, param.options)) + "}")))))))))));
}
var SingleCheckboxInteraction = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    didInteractWithCheckboxOption: didInteractWithCheckboxOption,
    stringify: stringify$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "interaction",
            t_encode$2(v.interaction)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var interaction = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "interaction"), null));
        if (interaction.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    interaction: interaction._0
                }
            };
        }
        var e = interaction._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".interaction" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$3(param) {
    return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", interaction=" + (stringify$2(param.interaction) + "}")));
}
var LabeledSingleCheckboxInteraction = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$3
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "name",
            Decco.stringToJson(v.name)
        ],
        [
            "checkedValues",
            Decco.listToJson(Decco.stringToJson, v.checkedValues)
        ],
        [
            "options",
            Decco.listToJson(t_encode$1, v.options)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */ 0) {
        var checkedValues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkedValues"), null));
        if (checkedValues.TAG === /* Ok */ 0) {
            var options = Decco.listFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
            if (options.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        name: name._0,
                        checkedValues: checkedValues._0,
                        options: options._0
                    }
                };
            }
            var e = options._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".options" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = checkedValues._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".checkedValues" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = name._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".name" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$4(param) {
    return "{name=" + (param.name + (", checkedValues=" + (StringUtils$SmartcutsMacros.join(", ", param.checkedValues) + (", options=" + (StringUtils$SmartcutsMacros.join(", ", List.map(stringify$1, param.options)) + "}")))));
}
var CheckboxGroupWithChosenValues = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$4
};
function t_encode$5(v) {
    if (v.TAG === /* SingleCheckbox */ 0) {
        return [
            "SingleCheckbox",
            t_encode$1(v._0),
            Decco.boolToJson(v._1)
        ];
    } else {
        return [
            "CheckboxGroup",
            t_encode$4(v._0)
        ];
    }
}
function t_decode$5(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CheckboxGroup":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$4(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* CheckboxGroup */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SingleCheckbox":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* SingleCheckbox */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$5(choice) {
    if (choice.TAG === /* SingleCheckbox */ 0) {
        return "SingleCheckbox(checkboxOption" + (stringify$1(choice._0) + (", checked=" + (Pervasives.string_of_bool(choice._1) + ")")));
    } else {
        return "CheckboxGroup(" + (stringify$4(choice._0) + ")");
    }
}
var CheckboxChoice = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    stringify: stringify$5
};
function t_encode$6(v) {
    if (v.TAG === /* IndividualCheckOrUncheck */ 0) {
        return [
            "IndividualCheckOrUncheck",
            t_encode$3(v._0)
        ];
    } else {
        return [
            "MultipleChecksOrUnchecks",
            t_encode$4(v._0)
        ];
    }
}
function t_decode$6(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "IndividualCheckOrUncheck":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* IndividualCheckOrUncheck */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "MultipleChecksOrUnchecks":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$4(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MultipleChecksOrUnchecks */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$6(value) {
    if (value.TAG === /* IndividualCheckOrUncheck */ 0) {
        return "IndividualCheckOrUncheck(" + (stringify$3(value._0) + ")");
    } else {
        return "MultipleChecksOrUnchecks(" + (stringify$4(value._0) + ")");
    }
}
function selectorGet(param) {
    return [];
}
var CheckboxPlaybackCommandValue = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    stringify: stringify$6,
    selectorGet: selectorGet
};
var t_encode$7 = t_encode$3;
var t_decode$7 = t_decode$3;
var Recording = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$3
};
var t_encode$8 = t_encode$6;
var t_decode$8 = t_decode$6;
var Authoring = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    stringify: stringify$6
};
var t_encode$9 = t_encode$6;
var t_decode$9 = t_decode$6;
var Playback = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    stringify: stringify$6
};
var CommandValue = {
    CheckboxOption: CheckboxOption,
    SingleCheckboxInteraction: SingleCheckboxInteraction,
    LabeledSingleCheckboxInteraction: LabeledSingleCheckboxInteraction,
    CheckboxGroupWithChosenValues: CheckboxGroupWithChosenValues,
    CheckboxChoice: CheckboxChoice,
    CheckboxPlaybackCommandValue: CheckboxPlaybackCommandValue,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function t_encode$10(v) {
    return Js_dict.fromArray([
        [
            "checkboxChoice",
            t_encode$5(v.checkboxChoice)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "dynamic",
            Decco.boolToJson(v.dynamic)
        ]
    ]);
}
function t_decode$10(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var checkboxChoice = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkboxChoice"), null));
    if (checkboxChoice.TAG === /* Ok */ 0) {
        var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
        if (playbackFormLabel.TAG === /* Ok */ 0) {
            var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
            if (dynamic.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        checkboxChoice: checkboxChoice._0,
                        playbackFormLabel: playbackFormLabel._0,
                        dynamic: dynamic._0
                    }
                };
            }
            var e = dynamic._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".dynamic" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = playbackFormLabel._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".playbackFormLabel" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = checkboxChoice._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".checkboxChoice" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function isDynamic(param) {
    return param.dynamic;
}
function fromAuthoringCommandValue(cmdVal) {
    if (cmdVal.TAG === /* IndividualCheckOrUncheck */ 0) {
        var match = cmdVal._0;
        var match$1 = match.interaction;
        var options = match$1.options;
        var maybeName = match$1.name;
        var action = match$1.action;
        var checkboxChoice = options ? maybeName !== undefined ? options.tl ? {
            TAG: /* CheckboxGroup */ 1,
            _0: {
                name: maybeName,
                checkedValues: upsertOrRemoveValueInCheckedValues(action, match$1.value, List.map(function(param) {
                    return param.value;
                }, List.filter(function(param) {
                    return param.checkedDefault;
                })(options))),
                options: options
            }
        } : {
            TAG: /* SingleCheckbox */ 0,
            _0: options.hd,
            _1: action === /* Check */ 0
        } : options.tl ? Util$SmartcutsMacros.logAndRaiseJsError("A checkbox group must be unified by name") : {
            TAG: /* SingleCheckbox */ 0,
            _0: options.hd,
            _1: action === /* Check */ 0
        } : Util$SmartcutsMacros.logAndRaiseJsError("Expects at least one option");
        return {
            checkboxChoice: checkboxChoice,
            playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", match.label),
            dynamic: false
        };
    }
    var checkboxGroupWithChosenValues = cmdVal._0;
    return {
        checkboxChoice: {
            TAG: /* CheckboxGroup */ 1,
            _0: checkboxGroupWithChosenValues
        },
        playbackFormLabel: checkboxGroupWithChosenValues.name,
        dynamic: false
    };
}
function updateConfigWithAuthoringCommandValue(commandValue, config) {
    var checkboxGroupWithChosenValues = config.checkboxChoice;
    if (checkboxGroupWithChosenValues.TAG === /* SingleCheckbox */ 0) {
        var checkboxOption = checkboxGroupWithChosenValues._0;
        if (commandValue.TAG !== /* IndividualCheckOrUncheck */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Single checkbox config cannot be merged with multiple checkbox command");
        }
        var checkboxInteraction = commandValue._0.interaction;
        if (didInteractWithCheckboxOption(checkboxOption, checkboxInteraction)) {
            return {
                checkboxChoice: {
                    TAG: /* SingleCheckbox */ 0,
                    _0: checkboxOption,
                    _1: checkboxInteraction.action === /* Check */ 0
                },
                playbackFormLabel: config.playbackFormLabel,
                dynamic: config.dynamic
            };
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with the checkbox option from checkbox config");
        }
    }
    var checkboxGroupWithChosenValues$1 = checkboxGroupWithChosenValues._0;
    if (commandValue.TAG === /* IndividualCheckOrUncheck */ 0) {
        var checkboxInteraction$1 = commandValue._0.interaction;
        var isMatch = List.exists(function(checkboxOption) {
            return didInteractWithCheckboxOption(checkboxOption, checkboxInteraction$1);
        }, checkboxGroupWithChosenValues$1.options);
        if (isMatch) {
            return {
                checkboxChoice: {
                    TAG: /* CheckboxGroup */ 1,
                    _0: {
                        name: checkboxGroupWithChosenValues$1.name,
                        checkedValues: upsertOrRemoveValueInCheckedValues(checkboxInteraction$1.action, checkboxInteraction$1.value, checkboxGroupWithChosenValues$1.checkedValues),
                        options: checkboxGroupWithChosenValues$1.options
                    }
                },
                playbackFormLabel: config.playbackFormLabel,
                dynamic: config.dynamic
            };
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with one of the checkbox options from checkbox config");
        }
    }
    var match = commandValue._0;
    if (checkboxGroupWithChosenValues$1.name === match.name) {
        return {
            checkboxChoice: {
                TAG: /* CheckboxGroup */ 1,
                _0: {
                    name: checkboxGroupWithChosenValues$1.name,
                    checkedValues: match.checkedValues,
                    options: checkboxGroupWithChosenValues$1.options
                }
            },
            playbackFormLabel: config.playbackFormLabel,
            dynamic: config.dynamic
        };
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with one of the checkbox options from checkbox config");
    }
}
var AuthoringConfig = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};
function t_encode$11(v) {
    return Js_dict.fromArray([
        [
            "originalCheckboxChoice",
            t_encode$5(v.originalCheckboxChoice)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$11(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalCheckboxChoice = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalCheckboxChoice"), null));
    if (originalCheckboxChoice.TAG === /* Ok */ 0) {
        var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
        if (playbackFormLabel.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    originalCheckboxChoice: originalCheckboxChoice._0,
                    playbackFormLabel: playbackFormLabel._0
                }
            };
        }
        var e = playbackFormLabel._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".playbackFormLabel" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = originalCheckboxChoice._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalCheckboxChoice" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        originalCheckboxChoice: param.checkboxChoice,
        playbackFormLabel: param.playbackFormLabel
    };
}
var ParamDescriptor = {
    t_encode: t_encode$11,
    t_decode: t_decode$11,
    fromAuthoringConfig: fromAuthoringConfig
};
var t_encode$12 = t_encode$5;
var t_decode$12 = t_decode$5;
function fromParamDescriptor(param) {
    return param.originalCheckboxChoice;
}
function toCommandValueForPlayback(paramValue) {
    if (paramValue.TAG !== /* SingleCheckbox */ 0) {
        return {
            TAG: /* MultipleChecksOrUnchecks */ 1,
            _0: paramValue._0
        };
    }
    var checkboxOption = paramValue._0;
    var label = checkboxOption.label;
    return {
        TAG: /* IndividualCheckOrUncheck */ 0,
        _0: {
            label: label,
            interaction: {
                action: paramValue._1 ? /* Check */ 0 : /* Uncheck */ 1,
                id: checkboxOption.id,
                value: checkboxOption.value,
                name: undefined,
                label: label,
                options: {
                    hd: checkboxOption,
                    tl: /* [] */ 0
                }
            }
        }
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    stringify: stringify$5,
    fromParamDescriptor: fromParamDescriptor,
    toCommandValueForPlayback: toCommandValueForPlayback
};
exports.getQuerySelectorForCheckboxIdAndNameAndValue = getQuerySelectorForCheckboxIdAndNameAndValue;
exports.CheckboxAction = CheckboxAction;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var ModifierKeys$SmartcutsMacros = __webpack_require__(94429);
var ViewportPosition$SmartcutsMacros = __webpack_require__(21707);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var SelectorOverrides$SmartcutsMacros = __webpack_require__(51670);
var InnerTextSemanticFunctors$SmartcutsMacros = __webpack_require__(79854);
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = __webpack_require__(80093);
var InnerTextSemanticParamDescriptor$SmartcutsMacros = __webpack_require__(33143);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function eventSrc_encode(v) {
    switch(v){
        case /* Mouseup */ 0:
            return [
                "Mouseup"
            ];
        case /* Click */ 1:
            return [
                "Click"
            ];
        case /* RecordClick */ 2:
            return [
                "RecordClick"
            ];
    }
}
function eventSrc_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Click":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Click */ 1
                    };
                }
            case "Mouseup":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Mouseup */ 0
                    };
                }
            case "RecordClick":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* RecordClick */ 2
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "modifierKeys",
            ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
        ],
        [
            "eventSrc",
            eventSrc_encode(v.eventSrc)
        ],
        [
            "clickCount",
            Decco.intToJson(v.clickCount)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
        if (modifierKeys.TAG === /* Ok */ 0) {
            var eventSrc = eventSrc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
            if (eventSrc.TAG === /* Ok */ 0) {
                var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
                if (clickCount.TAG === /* Ok */ 0) {
                    var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
                    if (viewportPosition.TAG === /* Ok */ 0) {
                        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                        if (positionRelToElement.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                                    modifierKeys: modifierKeys._0,
                                    eventSrc: eventSrc._0,
                                    clickCount: clickCount._0,
                                    viewportPosition: viewportPosition._0,
                                    positionRelToElement: positionRelToElement._0
                                }
                            };
                        }
                        var e = positionRelToElement._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".positionRelToElement" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = viewportPosition._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".viewportPosition" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = clickCount._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".clickCount" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = eventSrc._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventSrc" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = modifierKeys._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".modifierKeys" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify(param) {
    var tmp;
    switch(param.eventSrc){
        case /* Mouseup */ 0:
            tmp = "Mouseup";
            break;
        case /* Click */ 1:
            tmp = "Click";
            break;
        case /* RecordClick */ 2:
            tmp = "RecordClick";
            break;
    }
    return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", eventSrc: " + (tmp + (", clickCount: " + (String(param.clickCount) + ", viewportPosition(x, y))")))))));
}
var Recording = {
    eventSrc_encode: eventSrc_encode,
    eventSrc_decode: eventSrc_decode,
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "modifierKeys",
            ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
        ],
        [
            "clickCount",
            Decco.intToJson(v.clickCount)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ],
        [
            "maybeSelectorOverrides",
            Decco.optionToJson(SelectorOverrides$SmartcutsMacros.t_encode, v.maybeSelectorOverrides)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
        if (modifierKeys.TAG === /* Ok */ 0) {
            var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
            if (clickCount.TAG === /* Ok */ 0) {
                var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
                if (viewportPosition.TAG === /* Ok */ 0) {
                    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                    if (positionRelToElement.TAG === /* Ok */ 0) {
                        var maybeSelectorOverrides = Decco.optionFromJson(SelectorOverrides$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSelectorOverrides"), null));
                        if (maybeSelectorOverrides.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    selector: selector._0,
                                    modifierKeys: modifierKeys._0,
                                    clickCount: clickCount._0,
                                    viewportPosition: viewportPosition._0,
                                    positionRelToElement: positionRelToElement._0,
                                    maybeSelectorOverrides: maybeSelectorOverrides._0
                                }
                            };
                        }
                        var e = maybeSelectorOverrides._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".maybeSelectorOverrides" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = positionRelToElement._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".positionRelToElement" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = viewportPosition._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".viewportPosition" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = clickCount._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".clickCount" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = modifierKeys._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".modifierKeys" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        selector: param.domElementIdentifierWithSelector.selector,
        modifierKeys: param.modifierKeys,
        clickCount: param.clickCount,
        viewportPosition: param.viewportPosition,
        positionRelToElement: param.positionRelToElement,
        maybeSelectorOverrides: undefined
    };
}
function updateSelector(f, v) {
    return {
        selector: Curry._1(f, v.selector),
        modifierKeys: v.modifierKeys,
        clickCount: v.clickCount,
        viewportPosition: v.viewportPosition,
        positionRelToElement: v.positionRelToElement,
        maybeSelectorOverrides: v.maybeSelectorOverrides
    };
}
function getInputIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
function stringify$1(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", clickCount: " + (String(param.clickCount) + (", maybeSelectorOverrides: " + (Belt_Option.getWithDefault(Belt_Option.map(param.maybeSelectorOverrides, SelectorOverrides$SmartcutsMacros.stringify), "undefined") + ", viewportPosition(x, y), positionRelToElement)")))))));
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "semantic",
            InnerTextSemantic$SmartcutsMacros.t_encode(v.semantic)
        ],
        [
            "modifierKeys",
            ModifierKeys$SmartcutsMacros.t_encode(v.modifierKeys)
        ],
        [
            "clickCount",
            Decco.intToJson(v.clickCount)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ],
        [
            "maybeSelectorOverrides",
            Decco.optionToJson(SelectorOverrides$SmartcutsMacros.t_encode, v.maybeSelectorOverrides)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var semantic = InnerTextSemantic$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
        if (semantic.TAG === /* Ok */ 0) {
            var modifierKeys = ModifierKeys$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modifierKeys"), null));
            if (modifierKeys.TAG === /* Ok */ 0) {
                var clickCount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickCount"), null));
                if (clickCount.TAG === /* Ok */ 0) {
                    var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
                    if (viewportPosition.TAG === /* Ok */ 0) {
                        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                        if (positionRelToElement.TAG === /* Ok */ 0) {
                            var maybeSelectorOverrides = Decco.optionFromJson(SelectorOverrides$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSelectorOverrides"), null));
                            if (maybeSelectorOverrides.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        selector: selector._0,
                                        semantic: semantic._0,
                                        modifierKeys: modifierKeys._0,
                                        clickCount: clickCount._0,
                                        viewportPosition: viewportPosition._0,
                                        positionRelToElement: positionRelToElement._0,
                                        maybeSelectorOverrides: maybeSelectorOverrides._0
                                    }
                                };
                            }
                            var e = maybeSelectorOverrides._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".maybeSelectorOverrides" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = positionRelToElement._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".positionRelToElement" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = viewportPosition._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".viewportPosition" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = clickCount._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".clickCount" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = modifierKeys._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".modifierKeys" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = semantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantic" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function stringify$2(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", maybeSelectorOverrides: " + (Belt_Option.getWithDefault(Belt_Option.map(param.maybeSelectorOverrides, SelectorOverrides$SmartcutsMacros.stringify), "undefined") + (", modifierKeys: " + (ModifierKeys$SmartcutsMacros.stringify(param.modifierKeys) + (", clickCount: " + (String(param.clickCount) + (", viewportPosition(x, y), positionRelToElement, semantic=" + (InnerTextSemantic$SmartcutsMacros.stringify(param.semantic) + ")")))))))));
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function updateSelector$1(f, v) {
    return {
        selector: Curry._1(f, v.selector),
        semantic: v.semantic,
        modifierKeys: v.modifierKeys,
        clickCount: v.clickCount,
        viewportPosition: v.viewportPosition,
        positionRelToElement: v.positionRelToElement,
        maybeSelectorOverrides: v.maybeSelectorOverrides
    };
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    selectorGet: selectorGet,
    updateSelector: updateSelector$1
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function getSelector(param) {
    return param.selector;
}
var partial_arg = {
    getSelector: getSelector
};
var partial_arg$1 = InnerTextSemanticAuthoringConfig$SmartcutsMacros.MakeTransformers;
function fromAuthoringCommandValueAndSemantic(commandValue, semantic) {
    return {
        selector: commandValue.selector,
        semantic: semantic,
        modifierKeys: commandValue.modifierKeys,
        clickCount: commandValue.clickCount,
        viewportPosition: commandValue.viewportPosition,
        positionRelToElement: commandValue.positionRelToElement,
        maybeSelectorOverrides: commandValue.maybeSelectorOverrides
    };
}
var include = function(param) {
    return partial_arg$1(partial_arg, param);
}({
    fromAuthoringCommandValueAndSemantic: fromAuthoringCommandValueAndSemantic
});
var AuthoringConfig = include;
var partial_arg$2 = InnerTextSemanticParamDescriptor$SmartcutsMacros;
var partial_arg$3 = InnerTextSemanticFunctors$SmartcutsMacros.MakePlaybackParamValue;
var PlaybackParamValue = function(param) {
    return partial_arg$3(partial_arg$2, param);
}({
    updateSelector: updateSelector$1
});
var ParamDescriptor;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* include Not a pure module */ 


/***/ }),

/***/ 76406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var SelectorWithSemantic$SmartcutsMacros = __webpack_require__(80424);
var Selection__ContentEditableCursor$SmartcutsMacros = __webpack_require__(43378);
var ContentEditableCursorWithSemantics$SmartcutsMacros = __webpack_require__(68998);
var SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros = __webpack_require__(21014);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "cursor",
            Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.cursor)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ],
        [
            "eventSrc",
            Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_encode, v.eventSrc)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var cursor = Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cursor"), null));
    if (cursor.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            var eventSrc = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
            if (eventSrc.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        cursor: cursor._0,
                        positionRelToElement: positionRelToElement._0,
                        eventSrc: eventSrc._0
                    }
                };
            }
            var e = eventSrc._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventSrc" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = cursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".cursor" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{cursor, positionRelToElement}";
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "cursorWithSemantics",
            ContentEditableCursorWithSemantics$SmartcutsMacros.t_encode(v.cursorWithSemantics)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var cursorWithSemantics = ContentEditableCursorWithSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cursorWithSemantics"), null));
    if (cursorWithSemantics.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    cursorWithSemantics: cursorWithSemantics._0,
                    positionRelToElement: positionRelToElement._0
                }
            };
        }
        var e = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = cursorWithSemantics._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".cursorWithSemantics" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{cursorWithSemantics: {cursor, semantics: [" + (SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.stringify(param.cursorWithSemantics.semantics) + "]}, positionRelToElement}");
}
function fromRecordingCommandValue(param) {
    var contentEditableCursor = param.cursor;
    var semantics = SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.ofContentEditableCursor(contentEditableCursor);
    return {
        cursorWithSemantics: {
            contentEditableCursor: contentEditableCursor,
            semantics: semantics
        },
        positionRelToElement: param.positionRelToElement
    };
}
function updateSelector(f, commandValue) {
    var contentEditableCursorWithSemantics = commandValue.cursorWithSemantics;
    return {
        cursorWithSemantics: {
            contentEditableCursor: Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, contentEditableCursorWithSemantics.contentEditableCursor),
            semantics: contentEditableCursorWithSemantics.semantics
        },
        positionRelToElement: commandValue.positionRelToElement
    };
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "selectorWithSemantic",
            SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_encode, v.selectorWithSemantic)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selectorWithSemantic = SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorWithSemantic"), null));
    if (selectorWithSemantic.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selectorWithSemantic: selectorWithSemantic._0,
                    positionRelToElement: positionRelToElement._0
                }
            };
        }
        var e = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selectorWithSemantic._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selectorWithSemantic" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorGet(param) {
    return [
        param.selectorWithSemantic.selector
    ];
}
function stringify$2(param) {
    return "{selectorWithSemantic: " + (SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param.selectorWithSemantic) + ", positionRelToElement}");
}
function fromAuthoringCommandValue(param) {
    var match = param.cursorWithSemantics;
    return {
        selectorWithSemantic: {
            selector: match.contentEditableCursor.contentEditableHost.selector,
            semantic: Caml_array.get(match.semantics, 0)
        },
        positionRelToElement: param.positionRelToElement
    };
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    selectorGet: selectorGet,
    stringify: stringify$2,
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.CommandValue = CommandValue; /* DOM__Event-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 78612:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var InputLabel$SmartcutsMacros = __webpack_require__(43647);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var SelectorWithSemantic$SmartcutsMacros = __webpack_require__(80424);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
var InputCursorWithSemantics$SmartcutsMacros = __webpack_require__(53022);
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = __webpack_require__(65768);
var DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros = __webpack_require__(95016);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithCursor",
            DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_encode(v.domElementIdentifierWithCursor)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
        ],
        [
            "eventSrc",
            Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_encode, v.eventSrc)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithCursor = DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithCursor"), null));
    if (domElementIdentifierWithCursor.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            var eventSrc = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
            if (eventSrc.TAG === /* Ok */ 0) {
                var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
                if (label.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            domElementIdentifierWithCursor: domElementIdentifierWithCursor._0,
                            positionRelToElement: positionRelToElement._0,
                            eventSrc: eventSrc._0,
                            label: label._0
                        }
                    };
                }
                var e = label._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".label" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = eventSrc._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventSrc" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = domElementIdentifierWithCursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithCursor" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(param) {
    return "cursor";
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "inputCursorWithSemantics",
            InputCursorWithSemantics$SmartcutsMacros.t_encode(v.inputCursorWithSemantics)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var inputCursorWithSemantics = InputCursorWithSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputCursorWithSemantics"), null));
    if (inputCursorWithSemantics.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        inputCursorWithSemantics: inputCursorWithSemantics._0,
                        positionRelToElement: positionRelToElement._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = inputCursorWithSemantics._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".inputCursorWithSemantics" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return "{inputCursorWithSemantics: {cursor, semantics: [" + (SelectionSemantics__InputCursorSemantics$SmartcutsMacros.stringify(param.inputCursorWithSemantics.semantics) + "], positionRelToElement}");
}
function fromRecordingCommandValue(param) {
    var inputCursor = param.domElementIdentifierWithCursor.inputCursor;
    var semantics = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.ofInputCursor(inputCursor);
    return {
        inputCursorWithSemantics: {
            inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.fromRecording(inputCursor),
            semantics: semantics
        },
        positionRelToElement: param.positionRelToElement,
        label: param.label
    };
}
function getInputIdentifier(param) {
    return "click:" + Selector$SmartcutsMacros.stringify(undefined, false, param.inputCursorWithSemantics.inputCursor.domElementRepresentation);
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    getInputIdentifier: getInputIdentifier
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "selectorWithSemantic",
            SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_encode, v.selectorWithSemantic)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElement.t_encode(v.positionRelToElement)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.t_encode, v.label)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selectorWithSemantic = SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorWithSemantic"), null));
    if (selectorWithSemantic.TAG === /* Ok */ 0) {
        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
        if (positionRelToElement.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selectorWithSemantic: selectorWithSemantic._0,
                        positionRelToElement: positionRelToElement._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = positionRelToElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".positionRelToElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selectorWithSemantic._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selectorWithSemantic" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringCommandValue(param) {
    var match = param.inputCursorWithSemantics;
    return {
        selectorWithSemantic: {
            selector: match.inputCursor.domElementRepresentation,
            semantic: Caml_array.get(match.semantics, 0)
        },
        positionRelToElement: param.positionRelToElement,
        label: Belt_Option.map(param.label, InputLabel$SmartcutsMacros.fromRecordingAndAuthoring)
    };
}
function selectorGet(param) {
    return [
        param.selectorWithSemantic.selector
    ];
}
function stringify$2(param) {
    return "{selectorWithSemantic: " + (SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param.selectorWithSemantic) + ", positionRelToElement}");
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    selectorGet: selectorGet,
    stringify: stringify$2
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function fromAuthoringCommandValue$1(authoringCommandValue) {
    var inputLabel = authoringCommandValue.label;
    if (inputLabel !== undefined && inputLabel.labels.length !== 0) {
        return {
            inputLabel: inputLabel,
            selectedLabelIndex: 0
        };
    }
}
function isDynamic(param) {
    return Belt_Option.isNone(param.selectedLabelIndex);
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, param1) {
    var match = param1.inputLabel;
    var labels = match.labels;
    var sharedRootDepth = match.sharedRootDepth;
    var init = fromAuthoringCommandValue(commandValue);
    return {
        selectorWithSemantic: init.selectorWithSemantic,
        positionRelToElement: init.positionRelToElement,
        label: Belt_Option.map(Belt_Option.flatMap(param1.selectedLabelIndex, function(index) {
            return Belt_Array.get(labels, index);
        }), function(param) {
            return {
                selector: param.selector,
                labelText: param.labelText,
                sharedRootDepth: sharedRootDepth
            };
        })
    };
}
var AuthoringConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    isDynamic: isDynamic,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 57114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Belt_MapString = __webpack_require__(35082);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var EmailLabel$SmartcutsMacros = __webpack_require__(5601);
var ClickCommand$SmartcutsMacros = __webpack_require__(658);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var OAuthProvider$SmartcutsMacros = __webpack_require__(86090);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var ViewportPosition$SmartcutsMacros = __webpack_require__(21707);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "eventSrc",
            Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_encode, v.eventSrc)
        ],
        [
            "oauthProvider",
            OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
        ],
        [
            "clickOnElement",
            Selector$SmartcutsMacros.selector_encode(v.clickOnElement)
        ],
        [
            "emailLabel",
            EmailLabel$SmartcutsMacros.t_encode(Decco.stringToJson, v.emailLabel)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var eventSrc = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Recording.eventSrc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
    if (eventSrc.TAG === /* Ok */ 0) {
        var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
        if (oauthProvider.TAG === /* Ok */ 0) {
            var clickOnElement = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickOnElement"), null));
            if (clickOnElement.TAG === /* Ok */ 0) {
                var emailLabel = EmailLabel$SmartcutsMacros.t_decode(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailLabel"), null));
                if (emailLabel.TAG === /* Ok */ 0) {
                    var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
                    if (viewportPosition.TAG === /* Ok */ 0) {
                        var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                        if (positionRelToElement.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    eventSrc: eventSrc._0,
                                    oauthProvider: oauthProvider._0,
                                    clickOnElement: clickOnElement._0,
                                    emailLabel: emailLabel._0,
                                    viewportPosition: viewportPosition._0,
                                    positionRelToElement: positionRelToElement._0
                                }
                            };
                        }
                        var e = positionRelToElement._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".positionRelToElement" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = viewportPosition._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".viewportPosition" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = emailLabel._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".emailLabel" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = clickOnElement._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".clickOnElement" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = oauthProvider._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".oauthProvider" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = eventSrc._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".eventSrc" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify(param) {
    return "{ oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", clickOnElement: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.clickOnElement) + (", emailLabel: " + (EmailLabel$SmartcutsMacros.stringify(function(x) {
        return x;
    }, param.emailLabel) + ", viewportPosition, positionRelToElement }")))));
}
function maybeForTargetElement(eventSrc, oauthProvider, clientX, clientY, positionRelToElement, targetElement) {
    var clickOnElement = Selector$SmartcutsMacros.forDomElement(targetElement);
    var firstElementWithEmailThatHasMostOccurrencies = function firstElementWithEmailThatHasMostOccurrencies(elements) {
        if (elements.length === 1) {
            return elements[0];
        }
        var elementsByEmail1 = Belt_Array.reduce(elements, undefined, function(elementsByEmail, element) {
            var email = element.innerText;
            var otherElements = Belt_MapString.get(elementsByEmail, email);
            return Belt_MapString.set(elementsByEmail, email, otherElements !== undefined ? Belt_Array.concat(otherElements, [
                element
            ]) : [
                element
            ]);
        });
        var arg = Belt_MapString.toArray(elementsByEmail1);
        var match = function(param) {
            return ArrayUtils$SmartcutsMacros.splitAtFirstExn(param, arg);
        }("Expect to get emails when calculating firstElementWithEmailThatHasMostOccurrencies");
        var match$1 = Belt_Array.reduce(match[1], match[0], function(currentEmailHasMostOccurrenciesWithElements, emailWithElements) {
            if (emailWithElements[1].length > currentEmailHasMostOccurrenciesWithElements[1].length) {
                return emailWithElements;
            } else {
                return currentEmailHasMostOccurrenciesWithElements;
            }
        });
        return Caml_array.get(match$1[1], 0);
    };
    return Belt_Option.map(EmailLabel$SmartcutsMacros.LocateEmailElements.forDomElement(targetElement), function(emailElements) {
        var match;
        match = typeof emailElements === "number" ? [
            targetElement,
            targetElement
        ] : emailElements.TAG === /* Children */ 0 ? [
            targetElement,
            firstElementWithEmailThatHasMostOccurrencies(emailElements._0)
        ] : [
            emailElements._0,
            firstElementWithEmailThatHasMostOccurrencies(emailElements._1)
        ];
        var emailElement = match[1];
        return {
            eventSrc: eventSrc,
            oauthProvider: oauthProvider,
            clickOnElement: clickOnElement,
            emailLabel: {
                emailText: emailElement.innerText,
                elementWithEmailText: Selector$SmartcutsMacros.forDomElement(emailElement),
                sharedRootDepth: DOM__Element$SmartcutsMacros.getDepthRelativeToBody(match[0])
            },
            viewportPosition: {
                clientX: clientX,
                clientY: clientY
            },
            positionRelToElement: positionRelToElement
        };
    });
}
function maybeFromClickEvent(eventSrc, oauthProvider, clickEvent) {
    var targetElement = clickEvent.target;
    if (targetElement.tagName === "INPUT") {
        return;
    }
    var clientX = clickEvent.clientX | 0;
    var clientY = clickEvent.clientY | 0;
    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.fromMouseEvent(clickEvent);
    return maybeForTargetElement(eventSrc, oauthProvider, clientX, clientY, positionRelToElement, targetElement);
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    maybeForTargetElement: maybeForTargetElement,
    maybeFromClickEvent: maybeFromClickEvent
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "oauthProvider",
            OAuthProvider$SmartcutsMacros.t_encode(v.oauthProvider)
        ],
        [
            "clickOnElement",
            Selector$SmartcutsMacros.selector_encode(v.clickOnElement)
        ],
        [
            "emailLabel",
            EmailLabel$SmartcutsMacros.t_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, v.emailLabel)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var oauthProvider = OAuthProvider$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oauthProvider"), null));
    if (oauthProvider.TAG === /* Ok */ 0) {
        var clickOnElement = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clickOnElement"), null));
        if (clickOnElement.TAG === /* Ok */ 0) {
            var emailLabel = EmailLabel$SmartcutsMacros.t_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailLabel"), null));
            if (emailLabel.TAG === /* Ok */ 0) {
                var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
                if (viewportPosition.TAG === /* Ok */ 0) {
                    var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                    if (positionRelToElement.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                oauthProvider: oauthProvider._0,
                                clickOnElement: clickOnElement._0,
                                emailLabel: emailLabel._0,
                                viewportPosition: viewportPosition._0,
                                positionRelToElement: positionRelToElement._0
                            }
                        };
                    }
                    var e = positionRelToElement._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".positionRelToElement" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = viewportPosition._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".viewportPosition" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = emailLabel._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".emailLabel" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = clickOnElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".clickOnElement" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = oauthProvider._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".oauthProvider" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify$1(param) {
    return "{ oauthProvider: " + (OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider) + (", clickOnElement: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.clickOnElement) + (", emailLabel: " + (EmailLabel$SmartcutsMacros.stringify(DataDependency$SmartcutsMacros.DataRef.stringify, param.emailLabel) + ", viewportPosition, positionRelToElement }")))));
}
function updateSelector(f, cmdVal) {
    var init = cmdVal.emailLabel;
    return {
        oauthProvider: cmdVal.oauthProvider,
        clickOnElement: Curry._1(f, cmdVal.clickOnElement),
        emailLabel: {
            emailText: init.emailText,
            elementWithEmailText: Curry._1(f, cmdVal.emailLabel.elementWithEmailText),
            sharedRootDepth: init.sharedRootDepth
        },
        viewportPosition: cmdVal.viewportPosition,
        positionRelToElement: cmdVal.positionRelToElement
    };
}
function getInputIdentifier(param) {
    return "OAuth via " + OAuthProvider$SmartcutsMacros.stringify(param.oauthProvider);
}
function fromRecording(param) {
    var match = param.emailLabel;
    return {
        oauthProvider: param.oauthProvider,
        clickOnElement: param.clickOnElement,
        emailLabel: {
            emailText: {
                TAG: /* StaticText */ 0,
                _0: match.emailText
            },
            elementWithEmailText: match.elementWithEmailText,
            sharedRootDepth: match.sharedRootDepth
        },
        viewportPosition: param.viewportPosition,
        positionRelToElement: param.positionRelToElement
    };
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier,
    fromRecording: fromRecording
};
var t_encode$2 = t_encode$1;
var t_decode$2 = t_decode$1;
function selectorGet(param) {
    return [
        param.clickOnElement,
        param.emailLabel.elementWithEmailText
    ];
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$1,
    selectorGet: selectorGet
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.CommandValue = CommandValue; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 7:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    title: title._0
                }
            };
        }
        var e = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "'}")));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 48662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var HTMLNodes$SmartcutsMacros = __webpack_require__(22764);
var DOM__Event$SmartcutsMacros = __webpack_require__(46307);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SelectorTree$SmartcutsMacros = __webpack_require__(47118);
var ViewportPosition$SmartcutsMacros = __webpack_require__(21707);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var InnerTextSemanticFunctors$SmartcutsMacros = __webpack_require__(79854);
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = __webpack_require__(80093);
var InnerTextSemanticParamDescriptor$SmartcutsMacros = __webpack_require__(33143);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ],
        [
            "maybeSubPathToImg",
            Decco.optionToJson(function(param) {
                return [
                    Selector$SmartcutsMacros.selector_encode(param[0]),
                    Decco.optionToJson(Decco.stringToJson, param[1])
                ];
            }, v.maybeSubPathToImg)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
        if (viewportPosition.TAG === /* Ok */ 0) {
            var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
            if (positionRelToElement.TAG === /* Ok */ 0) {
                var maybeSubPathToImg = Decco.optionFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = Selector$SmartcutsMacros.selector_decode(v0);
                    var match$3 = Decco.optionFromJson(Decco.stringFromJson, v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeSubPathToImg"), null));
                if (maybeSubPathToImg.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            selector: selector._0,
                            viewportPosition: viewportPosition._0,
                            positionRelToElement: positionRelToElement._0,
                            maybeSubPathToImg: maybeSubPathToImg._0
                        }
                    };
                }
                var e1 = maybeSubPathToImg._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".maybeSubPathToImg" + e1.path,
                        message: e1.message,
                        value: e1.value
                    }
                };
            }
            var e$11 = positionRelToElement._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".positionRelToElement" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                }
            };
        }
        var e$2 = viewportPosition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".viewportPosition" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(param1) {
    var arg = Belt_Option.map(param1.maybeSubPathToImg, function(param) {
        return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param[0]) + (", imgSrc: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param[1]) + "}")));
    });
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param1.selector) + (", viewportPosition, positionRelToElement, maybeSubPathToImg: " + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("None") + "}")));
}
function deriveMaybeSubPathToImgFromMouseEvent(mouseEvent) {
    var targetElement = mouseEvent.target;
    var tagName = $$String.lowercase_ascii(targetElement.tagName);
    if (tagName === "img") {
        return;
    } else {
        return Belt_Option.map(Caml_option.nullable_to_opt(document.querySelector("img")), function(imageElement) {
            var htmlNodesChainFromImgNodeToTargetElementExclusive = HTMLNodes$SmartcutsMacros.forDomElementAndItsAncestors(Caml_option.some(targetElement), imageElement);
            var selectorToImgRelativeToTargetElement = SelectorTree$SmartcutsMacros.fromHTMLNodes(htmlNodesChainFromImgNodeToTargetElementExclusive);
            return [
                selectorToImgRelativeToTargetElement,
                Caml_option.nullable_to_opt(imageElement.getAttribute("src"))
            ];
        });
    }
}
function fromMouseEvent(mouseEvent) {
    var maybeSubPathToImg = deriveMaybeSubPathToImgFromMouseEvent(mouseEvent);
    var selector = Selector$SmartcutsMacros.forDomEvent(mouseEvent);
    var clientX = mouseEvent.clientX;
    var clientY = mouseEvent.clientY;
    return {
        selector: selector,
        viewportPosition: {
            clientX: clientX | 0,
            clientY: clientY | 0
        },
        positionRelToElement: DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.fromMouseEvent(mouseEvent),
        maybeSubPathToImg: maybeSubPathToImg
    };
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    fromMouseEvent: fromMouseEvent
};
function getInputIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
var Authoring = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    fromMouseEvent: fromMouseEvent,
    getInputIdentifier: getInputIdentifier
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "semantic",
            InnerTextSemantic$SmartcutsMacros.t_encode(v.semantic)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ],
        [
            "positionRelToElement",
            DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_encode(v.positionRelToElement)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var semantic = InnerTextSemantic$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
        if (semantic.TAG === /* Ok */ 0) {
            var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
            if (viewportPosition.TAG === /* Ok */ 0) {
                var positionRelToElement = DOM__Event$SmartcutsMacros.PositionRelToElementWithScrollInfo.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positionRelToElement"), null));
                if (positionRelToElement.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            selector: selector._0,
                            semantic: semantic._0,
                            viewportPosition: viewportPosition._0,
                            positionRelToElement: positionRelToElement._0
                        }
                    };
                }
                var e = positionRelToElement._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".positionRelToElement" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = viewportPosition._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".viewportPosition" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = semantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantic" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$1(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", viewportPosition, positionRelToElement, semantic=" + (InnerTextSemantic$SmartcutsMacros.stringify(param.semantic) + "}")));
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function updateSelector(f, v) {
    return {
        selector: Curry._1(f, v.selector),
        semantic: v.semantic,
        viewportPosition: v.viewportPosition,
        positionRelToElement: v.positionRelToElement
    };
}
var Playback = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    selectorGet: selectorGet,
    updateSelector: updateSelector
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function getSelector(param) {
    return param.selector;
}
var partial_arg = {
    getSelector: getSelector
};
var partial_arg$1 = InnerTextSemanticAuthoringConfig$SmartcutsMacros.MakeTransformers;
function fromAuthoringCommandValueAndSemantic(commandValue, semantic) {
    return {
        selector: commandValue.selector,
        semantic: semantic,
        viewportPosition: commandValue.viewportPosition,
        positionRelToElement: commandValue.positionRelToElement
    };
}
var include = function(param) {
    return partial_arg$1(partial_arg, param);
}({
    fromAuthoringCommandValueAndSemantic: fromAuthoringCommandValueAndSemantic
});
var AuthoringConfig = include;
var partial_arg$2 = InnerTextSemanticParamDescriptor$SmartcutsMacros;
var partial_arg$3 = InnerTextSemanticFunctors$SmartcutsMacros.MakePlaybackParamValue;
var PlaybackParamValue = function(param) {
    return partial_arg$3(partial_arg$2, param);
}({
    updateSelector: updateSelector
});
var ParamDescriptor;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* include Not a pure module */ 


/***/ }),

/***/ 68875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var ContentOptionality$SmartcutsMacros = __webpack_require__(14017);
var ContentOptionalityConfig$SmartcutsMacros = __webpack_require__(79929);
var concatAndResolveUrl = function concatAndResolveUrl(url, concat) {
    var url1 = url.split("/");
    var url2 = concat.split("/");
    var url3 = [];
    for(var i = 0, l = url1.length; i < l; i++){
        if (url1[i] == "..") {
            url3.pop();
        } else if (url1[i] == ".") {
            continue;
        } else {
            url3.push(url1[i]);
        }
    }
    for(var i = 0, l = url2.length; i < l; i++){
        if (url2[i] == "..") {
            url3.pop();
        } else if (url2[i] == ".") {
            continue;
        } else {
            url3.push(url2[i]);
        }
    }
    return url3.join("/");
};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "src",
            Decco.stringToJson(v.src)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
        if (src.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    src: src._0
                }
            };
        }
        var e = src._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".src" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", src: " + (param.src + "}")));
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function updateSelector(f, v) {
    return {
        selector: Curry._1(f, v.selector),
        src: v.src
    };
}
function getInputIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
var RecordingAndAuthoring = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    selectorGet: selectorGet,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "src",
            Decco.stringToJson(v.src)
        ],
        [
            "optionality",
            ContentOptionality$SmartcutsMacros.t_encode(v.optionality)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var src = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "src"), null));
        if (src.TAG === /* Ok */ 0) {
            var optionality = ContentOptionality$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "optionality"), null));
            if (optionality.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        src: src._0,
                        optionality: optionality._0
                    }
                };
            }
            var e = optionality._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".optionality" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = src._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".src" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return "{optionality: " + (ContentOptionality$SmartcutsMacros.stringify(param.optionality) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", src: " + (param.src + "}")))));
}
function selectorGet$1(param) {
    return [
        param.selector
    ];
}
var Playback = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    selectorGet: selectorGet$1
};
var CommandValue = {
    RecordingAndAuthoring: RecordingAndAuthoring,
    Playback: Playback
};
function isImgSrcEqualToImageUrl(imgSrc, imageUrl, tabUrl) {
    var _imgSrcUrl = URLUtils$SmartcutsMacros.$$URL.fromString(imgSrc);
    if (_imgSrcUrl !== undefined) {
        return imgSrc === imageUrl.toString();
    }
    var arg = URLUtils$SmartcutsMacros.$$URL.fromString(tabUrl);
    var tabOrigin = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected tab url to be valid").origin;
    var fullImgSrcUrl = imgSrc.startsWith("/") ? tabOrigin + imgSrc : concatAndResolveUrl(tabOrigin, imgSrc);
    return fullImgSrcUrl === imageUrl.toString();
}
function willGenerateAPlaybackParam(param) {
    return false;
}
function fromAuthoringCommandValue(_authoringCommandValue) {
    return ContentOptionalityConfig$SmartcutsMacros.$$default;
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
    return {
        selector: commandValue.selector,
        src: commandValue.src,
        optionality: OptionUtils$SmartcutsMacros.withDefault(ContentOptionalityConfig$SmartcutsMacros.$$default, maybeConfig)
    };
}
var AuthoringConfig = {
    willGenerateAPlaybackParam: willGenerateAPlaybackParam,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};
exports.concatAndResolveUrl = concatAndResolveUrl;
exports.CommandValue = CommandValue;
exports.isImgSrcEqualToImageUrl = isImgSrcEqualToImageUrl;
exports.AuthoringConfig = AuthoringConfig; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 67606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var LinkSemantic$SmartcutsMacros = __webpack_require__(64372);
var ContentTiming$SmartcutsMacros = __webpack_require__(69679);
var ContentOptionality$SmartcutsMacros = __webpack_require__(14017);
var ContentOptionalityConfig$SmartcutsMacros = __webpack_require__(79929);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "href",
            Decco.stringToJson(v.href)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
        if (href.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                    href: href._0
                }
            };
        }
        var e = href._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".href" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", href: " + (param.href + "}")));
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "href",
            Decco.stringToJson(v.href)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
        if (href.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    href: href._0
                }
            };
        }
        var e = href._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".href" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        selector: param.domElementIdentifierWithSelector.selector,
        href: param.href
    };
}
function stringify$1(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", href: " + (param.href + "}")));
}
function updateSelector(f, param) {
    return {
        selector: Curry._1(f, param.selector),
        href: param.href
    };
}
function getInputIdentifier(param) {
    var selector = param.selector;
    console.warn("IDENTIFIER", Selector$SmartcutsMacros.stringify(undefined, false, selector));
    return Selector$SmartcutsMacros.stringify(undefined, false, selector);
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    stringify: stringify$1,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "originalHref",
            Decco.stringToJson(v.originalHref)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "semantic",
            LinkSemantic$SmartcutsMacros.t_encode(v.semantic)
        ],
        [
            "optionality",
            ContentOptionality$SmartcutsMacros.t_encode(v.optionality)
        ],
        [
            "contentTiming",
            ContentTiming$SmartcutsMacros.t_encode(v.contentTiming)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalHref = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalHref"), null));
    if (originalHref.TAG === /* Ok */ 0) {
        var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
        if (selector.TAG === /* Ok */ 0) {
            var semantic = LinkSemantic$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
            if (semantic.TAG === /* Ok */ 0) {
                var optionality = ContentOptionality$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "optionality"), null));
                if (optionality.TAG === /* Ok */ 0) {
                    var contentTiming = ContentTiming$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentTiming"), null));
                    if (contentTiming.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                originalHref: originalHref._0,
                                selector: selector._0,
                                semantic: semantic._0,
                                optionality: optionality._0,
                                contentTiming: contentTiming._0
                            }
                        };
                    }
                    var e = contentTiming._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".contentTiming" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = optionality._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".optionality" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = semantic._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".semantic" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = selector._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selector" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = originalHref._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalHref" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify$2(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ("semantic: " + (LinkSemantic$SmartcutsMacros.stringify(param.semantic) + (", optionality: " + (ContentOptionality$SmartcutsMacros.stringify(param.optionality) + (", originalHref: " + (param.originalHref + (", contentTiming: " + (ContentTiming$SmartcutsMacros.stringify(param.contentTiming) + "}")))))))));
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function updateSelector$1(f, v) {
    return {
        originalHref: v.originalHref,
        selector: Curry._1(f, v.selector),
        semantic: v.semantic,
        optionality: v.optionality,
        contentTiming: v.contentTiming
    };
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    selectorGet: selectorGet,
    updateSelector: updateSelector$1
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function fromAuthoringCommandValue(origin, param) {
    var href = param.href;
    var semantics = LinkSemantic$SmartcutsMacros.getIntentionChoicesFromOriginAndHref(origin, href);
    return {
        selector: param.selector,
        recordedHref: href,
        semantics: semantics,
        config: Caml_array.get(semantics, 0)
    };
}
function applyToAuthoringCommandValueToGetPlaybackSemantic(param, maybeConfig) {
    if (maybeConfig !== undefined) {
        return maybeConfig.config;
    } else {
        return /* AnyLink */ 0;
    }
}
function isForAuthoringCommandValue(param, config) {
    return Caml_obj.caml_equal(config.selector, param.selector);
}
var HrefConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    applyToAuthoringCommandValueToGetPlaybackSemantic: applyToAuthoringCommandValueToGetPlaybackSemantic,
    isForAuthoringCommandValue: isForAuthoringCommandValue
};
function fromAuthoringCommandValue$1(origin, commandValue) {
    return {
        hrefConfig: fromAuthoringCommandValue(origin, commandValue),
        contentOptionalityConfig: ContentOptionalityConfig$SmartcutsMacros.$$default,
        contentTimingConfig: ContentTiming$SmartcutsMacros.$$default
    };
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
    var arg = OptionUtils$SmartcutsMacros.map(maybeConfig, function(config) {
        return config.contentOptionalityConfig;
    });
    var arg$1 = OptionUtils$SmartcutsMacros.map(maybeConfig, function(config) {
        return config.contentTimingConfig;
    });
    return {
        originalHref: commandValue.href,
        selector: commandValue.selector,
        semantic: applyToAuthoringCommandValueToGetPlaybackSemantic(commandValue, OptionUtils$SmartcutsMacros.map(maybeConfig, function(config) {
            return config.hrefConfig;
        })),
        optionality: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(ContentOptionalityConfig$SmartcutsMacros.$$default),
        contentTiming: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
        }(ContentTiming$SmartcutsMacros.$$default)
    };
}
function isForAuthoringCommandValue$1(commandValue, config) {
    return isForAuthoringCommandValue(commandValue, config.hrefConfig);
}
function isDynamic(param) {
    return false;
}
var AuthoringConfig = {
    HrefConfig: HrefConfig,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
    isForAuthoringCommandValue: isForAuthoringCommandValue$1,
    isDynamic: isDynamic
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 59170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var PromisedValue$SmartcutsMacros = __webpack_require__(19949);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(encoder_newTab, v) {
    return Js_dict.fromArray([
        [
            "newTab",
            Curry._1(encoder_newTab, v.newTab)
        ],
        [
            "openerTab",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.openerTab)
        ],
        [
            "newTabUrl",
            Decco.optionToJson(Decco.stringToJson, v.newTabUrl)
        ]
    ]);
}
function t_decode(decoder_newTab, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var newTab = Curry._1(decoder_newTab, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newTab"), null));
    if (newTab.TAG === /* Ok */ 0) {
        var openerTab = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "openerTab"), null));
        if (openerTab.TAG === /* Ok */ 0) {
            var newTabUrl = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "newTabUrl"), null));
            if (newTabUrl.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        newTab: newTab._0,
                        openerTab: openerTab._0,
                        newTabUrl: newTabUrl._0
                    }
                };
            }
            var e = newTabUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".newTabUrl" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = openerTab._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".openerTab" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = newTab._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".newTab" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(stringifyNewTab, t) {
    return "{ newTab: " + (Curry._1(stringifyNewTab, t.newTab) + (", openerTab: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(t.openerTab) + (", newTabUrl: " + (OptionUtils$SmartcutsMacros.stringify(StringUtils$SmartcutsMacros.quote, t.newTabUrl) + " }")))));
}
var DownloadInNewTab = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(encoder_newTab, v) {
    if (v.TAG === /* DownloadInNewTab */ 0) {
        return [
            "DownloadInNewTab",
            t_encode(encoder_newTab, v._0)
        ];
    } else {
        return [
            "DownloadInOriginalTab",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
        ];
    }
}
function t_decode$1(decoder_newTab, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DownloadInNewTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(decoder_newTab, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadInNewTab */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DownloadInOriginalTab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DownloadInOriginalTab */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(stringifyNewTab, v) {
    if (v.TAG === /* DownloadInNewTab */ 0) {
        return "DownloadInNewTab(" + (stringify(stringifyNewTab, v._0) + ")");
    } else {
        return "DownloadInOriginalTab(" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(v._0) + ")");
    }
}
var DownloadTabOrigin = {
    DownloadInNewTab: DownloadInNewTab,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "chromeId",
            Decco.intToJson(v.chromeId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "finalUrl",
            Decco.stringToJson(v.finalUrl)
        ],
        [
            "referrer",
            Decco.stringToJson(v.referrer)
        ],
        [
            "filename",
            Decco.stringToJson(v.filename)
        ],
        [
            "mime",
            Decco.stringToJson(v.mime)
        ],
        [
            "startTime",
            Decco.floatToJson(v.startTime)
        ],
        [
            "estimatedEndTime",
            Decco.optionToJson(Decco.floatToJson, v.estimatedEndTime)
        ],
        [
            "totalBytes",
            Decco.floatToJson(v.totalBytes)
        ],
        [
            "fileSize",
            Decco.floatToJson(v.fileSize)
        ],
        [
            "tabOrigin",
            PromisedValue$SmartcutsMacros.t_encode(function(param) {
                return t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, param);
            }, Decco.unitToJson, v.tabOrigin)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var chromeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "chromeId"), null));
    if (chromeId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var finalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalUrl"), null));
            if (finalUrl.TAG === /* Ok */ 0) {
                var referrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referrer"), null));
                if (referrer.TAG === /* Ok */ 0) {
                    var filename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
                    if (filename.TAG === /* Ok */ 0) {
                        var mime = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mime"), null));
                        if (mime.TAG === /* Ok */ 0) {
                            var startTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startTime"), null));
                            if (startTime.TAG === /* Ok */ 0) {
                                var estimatedEndTime = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "estimatedEndTime"), null));
                                if (estimatedEndTime.TAG === /* Ok */ 0) {
                                    var totalBytes = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalBytes"), null));
                                    if (totalBytes.TAG === /* Ok */ 0) {
                                        var fileSize = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileSize"), null));
                                        if (fileSize.TAG === /* Ok */ 0) {
                                            var tabOrigin = PromisedValue$SmartcutsMacros.t_decode(function(param) {
                                                return t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, param);
                                            }, Decco.unitFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
                                            if (tabOrigin.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        chromeId: chromeId._0,
                                                        url: url._0,
                                                        finalUrl: finalUrl._0,
                                                        referrer: referrer._0,
                                                        filename: filename._0,
                                                        mime: mime._0,
                                                        startTime: startTime._0,
                                                        estimatedEndTime: estimatedEndTime._0,
                                                        totalBytes: totalBytes._0,
                                                        fileSize: fileSize._0,
                                                        tabOrigin: tabOrigin._0
                                                    }
                                                };
                                            }
                                            var e = tabOrigin._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".tabOrigin" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = fileSize._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".fileSize" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = totalBytes._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".totalBytes" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = estimatedEndTime._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".estimatedEndTime" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = startTime._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".startTime" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = mime._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".mime" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = filename._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".filename" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = referrer._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".referrer" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = finalUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".finalUrl" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = chromeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".chromeId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
function fromDownloadItem(param) {
    return {
        chromeId: param.id,
        url: param.url,
        finalUrl: param.finalUrl,
        referrer: param.referrer,
        filename: param.filename,
        mime: param.mime,
        startTime: Date.parse(param.startTime),
        estimatedEndTime: OptionUtils$SmartcutsMacros.map(param.estimatedEndTime, function(prim) {
            return Date.parse(prim);
        }),
        totalBytes: param.totalBytes,
        fileSize: param.fileSize,
        tabOrigin: {
            TAG: /* Pending */ 1,
            _0: undefined
        }
    };
}
function stringify$2(v) {
    return JSON.stringify(v);
}
var Recording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromDownloadItem: fromDownloadItem,
    stringify: stringify$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "chromeId",
            Decco.intToJson(v.chromeId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "finalUrl",
            Decco.stringToJson(v.finalUrl)
        ],
        [
            "referrer",
            Decco.stringToJson(v.referrer)
        ],
        [
            "filename",
            Decco.stringToJson(v.filename)
        ],
        [
            "mime",
            Decco.stringToJson(v.mime)
        ],
        [
            "startTime",
            Decco.floatToJson(v.startTime)
        ],
        [
            "estimatedEndTime",
            Decco.optionToJson(Decco.floatToJson, v.estimatedEndTime)
        ],
        [
            "totalBytes",
            Decco.floatToJson(v.totalBytes)
        ],
        [
            "fileSize",
            Decco.floatToJson(v.fileSize)
        ],
        [
            "tabOrigin",
            t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.tabOrigin)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var chromeId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "chromeId"), null));
    if (chromeId.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var finalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalUrl"), null));
            if (finalUrl.TAG === /* Ok */ 0) {
                var referrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "referrer"), null));
                if (referrer.TAG === /* Ok */ 0) {
                    var filename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
                    if (filename.TAG === /* Ok */ 0) {
                        var mime = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mime"), null));
                        if (mime.TAG === /* Ok */ 0) {
                            var startTime = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startTime"), null));
                            if (startTime.TAG === /* Ok */ 0) {
                                var estimatedEndTime = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "estimatedEndTime"), null));
                                if (estimatedEndTime.TAG === /* Ok */ 0) {
                                    var totalBytes = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalBytes"), null));
                                    if (totalBytes.TAG === /* Ok */ 0) {
                                        var fileSize = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileSize"), null));
                                        if (fileSize.TAG === /* Ok */ 0) {
                                            var tabOrigin = t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
                                            if (tabOrigin.TAG === /* Ok */ 0) {
                                                return {
                                                    TAG: /* Ok */ 0,
                                                    _0: {
                                                        chromeId: chromeId._0,
                                                        url: url._0,
                                                        finalUrl: finalUrl._0,
                                                        referrer: referrer._0,
                                                        filename: filename._0,
                                                        mime: mime._0,
                                                        startTime: startTime._0,
                                                        estimatedEndTime: estimatedEndTime._0,
                                                        totalBytes: totalBytes._0,
                                                        fileSize: fileSize._0,
                                                        tabOrigin: tabOrigin._0
                                                    }
                                                };
                                            }
                                            var e = tabOrigin._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".tabOrigin" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                }
                                            };
                                        }
                                        var e$1 = fileSize._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".fileSize" + e$1.path,
                                                message: e$1.message,
                                                value: e$1.value
                                            }
                                        };
                                    }
                                    var e$2 = totalBytes._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".totalBytes" + e$2.path,
                                            message: e$2.message,
                                            value: e$2.value
                                        }
                                    };
                                }
                                var e$3 = estimatedEndTime._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".estimatedEndTime" + e$3.path,
                                        message: e$3.message,
                                        value: e$3.value
                                    }
                                };
                            }
                            var e$4 = startTime._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".startTime" + e$4.path,
                                    message: e$4.message,
                                    value: e$4.value
                                }
                            };
                        }
                        var e$5 = mime._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".mime" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                            }
                        };
                    }
                    var e$6 = filename._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".filename" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                        }
                    };
                }
                var e$7 = referrer._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".referrer" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            }
            var e$8 = finalUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".finalUrl" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                }
            };
        }
        var e$9 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$9.path,
                message: e$9.message,
                value: e$9.value
            }
        };
    }
    var e$10 = chromeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".chromeId" + e$10.path,
            message: e$10.message,
            value: e$10.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        chromeId: param.chromeId,
        url: param.url,
        finalUrl: param.finalUrl,
        referrer: param.referrer,
        filename: param.filename,
        mime: param.mime,
        startTime: param.startTime,
        estimatedEndTime: param.estimatedEndTime,
        totalBytes: param.totalBytes,
        fileSize: param.fileSize,
        tabOrigin: PromisedValue$SmartcutsMacros.getResolvedExn(function(_unit) {
            return "Expect DownloadCommand.tabOrigin to be resolved when converting Recording -> Authoring";
        }, param.tabOrigin)
    };
}
function stringify$3(v) {
    return JSON.stringify(v);
}
var Authoring = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromRecordingCommandValue: fromRecordingCommandValue,
    stringify: stringify$3
};
function t_encode$4(v) {
    if (v) {
        return [
            "CustomFilename",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "DefaultFilename"
        ];
    }
}
function t_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "CustomFilename":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* CustomFilename */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DefaultFilename":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DefaultFilename */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$4(v) {
    if (v) {
        return "CustomFilename(" + (v._0 + ")");
    } else {
        return "DefaultFilename";
    }
}
var Filename = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$4
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "recordingReferrer",
            Decco.stringToJson(v.recordingReferrer)
        ],
        [
            "recordingUrl",
            Decco.stringToJson(v.recordingUrl)
        ],
        [
            "recordingFinalUrl",
            Decco.stringToJson(v.recordingFinalUrl)
        ],
        [
            "recordingFilename",
            Decco.stringToJson(v.recordingFilename)
        ],
        [
            "filename",
            t_encode$4(v.filename)
        ],
        [
            "tabOrigin",
            t_encode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.tabOrigin)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var recordingReferrer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingReferrer"), null));
    if (recordingReferrer.TAG === /* Ok */ 0) {
        var recordingUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingUrl"), null));
        if (recordingUrl.TAG === /* Ok */ 0) {
            var recordingFinalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingFinalUrl"), null));
            if (recordingFinalUrl.TAG === /* Ok */ 0) {
                var recordingFilename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingFilename"), null));
                if (recordingFilename.TAG === /* Ok */ 0) {
                    var filename = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
                    if (filename.TAG === /* Ok */ 0) {
                        var tabOrigin = t_decode$1(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabOrigin"), null));
                        if (tabOrigin.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    recordingReferrer: recordingReferrer._0,
                                    recordingUrl: recordingUrl._0,
                                    recordingFinalUrl: recordingFinalUrl._0,
                                    recordingFilename: recordingFilename._0,
                                    filename: filename._0,
                                    tabOrigin: tabOrigin._0
                                }
                            };
                        }
                        var e = tabOrigin._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".tabOrigin" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = filename._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".filename" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = recordingFilename._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".recordingFilename" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = recordingFinalUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".recordingFinalUrl" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = recordingUrl._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".recordingUrl" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = recordingReferrer._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".recordingReferrer" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function fromAuthoringCommandValue(param) {
    return {
        recordingReferrer: param.referrer,
        recordingUrl: param.url,
        recordingFinalUrl: param.finalUrl,
        recordingFilename: param.filename,
        filename: /* DefaultFilename */ 0,
        tabOrigin: param.tabOrigin
    };
}
function stringify$5(v) {
    return JSON.stringify(v);
}
function maybeAssignPlaybackTabId(recordingTabId, playbackTabId, cmdVal) {
    var tabOrigin = cmdVal.tabOrigin;
    if (tabOrigin.TAG === /* DownloadInNewTab */ 0) {
        var downloadInNewTab = tabOrigin._0;
        var tabRef = downloadInNewTab.openerTab;
        var tabRef$1 = downloadInNewTab.newTab;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef)) {
            return {
                recordingReferrer: cmdVal.recordingReferrer,
                recordingUrl: cmdVal.recordingUrl,
                recordingFinalUrl: cmdVal.recordingFinalUrl,
                recordingFilename: cmdVal.recordingFilename,
                filename: cmdVal.filename,
                tabOrigin: {
                    TAG: /* DownloadInNewTab */ 0,
                    _0: {
                        newTab: downloadInNewTab.newTab,
                        openerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef),
                        newTabUrl: downloadInNewTab.newTabUrl
                    }
                }
            };
        } else if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$1)) {
            return {
                recordingReferrer: cmdVal.recordingReferrer,
                recordingUrl: cmdVal.recordingUrl,
                recordingFinalUrl: cmdVal.recordingFinalUrl,
                recordingFilename: cmdVal.recordingFilename,
                filename: cmdVal.filename,
                tabOrigin: {
                    TAG: /* DownloadInNewTab */ 0,
                    _0: {
                        newTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$1),
                        openerTab: downloadInNewTab.openerTab,
                        newTabUrl: downloadInNewTab.newTabUrl
                    }
                }
            };
        } else {
            return cmdVal;
        }
    }
    var tabRef$2 = tabOrigin._0;
    if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$2)) {
        return {
            recordingReferrer: cmdVal.recordingReferrer,
            recordingUrl: cmdVal.recordingUrl,
            recordingFinalUrl: cmdVal.recordingFinalUrl,
            recordingFilename: cmdVal.recordingFilename,
            filename: cmdVal.filename,
            tabOrigin: {
                TAG: /* DownloadInOriginalTab */ 1,
                _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$2)
            }
        };
    } else {
        return cmdVal;
    }
}
var Playback = {
    Filename: Filename,
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    stringify: stringify$5,
    maybeAssignPlaybackTabId: maybeAssignPlaybackTabId
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
var FilenameStrategy = {};
function isMergeable(_config) {
    return false;
}
function isDynamic(param) {
    if (param.filenameStrategy) {
        return true;
    } else {
        return false;
    }
}
function isForAuthoringCommandValue(param, config) {
    return config.downloadId === param.chromeId;
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(param, maybeConfig) {
    var tmp;
    if (maybeConfig !== undefined) {
        var fname = maybeConfig.filenameStrategy;
        tmp = fname ? /* CustomFilename */ ({
            _0: fname._0
        }) : /* DefaultFilename */ 0;
    } else {
        tmp = /* DefaultFilename */ 0;
    }
    return {
        recordingReferrer: param.referrer,
        recordingUrl: param.url,
        recordingFinalUrl: param.finalUrl,
        recordingFilename: param.filename,
        filename: tmp,
        tabOrigin: param.tabOrigin
    };
}
function fromAuthoringCommandValue$1(param) {
    return {
        downloadId: param.chromeId,
        filenameStrategy: /* SaveUsingDefaultFilename */ 0,
        originalFilename: param.filename,
        playbackFormLabel: "What do you want to name the downloaded file?"
    };
}
function updateConfigWithAuthoringCommandValue(param, config) {
    return {
        downloadId: config.downloadId,
        filenameStrategy: config.filenameStrategy,
        originalFilename: param.filename,
        playbackFormLabel: config.playbackFormLabel
    };
}
function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
    return {
        downloadId: config.downloadId,
        filenameStrategy: config.filenameStrategy,
        originalFilename: config.originalFilename,
        playbackFormLabel: playbackFormLabel
    };
}
var AuthoringConfig = {
    FilenameStrategy: FilenameStrategy,
    isMergeable: isMergeable,
    isDynamic: isDynamic,
    isForAuthoringCommandValue: isForAuthoringCommandValue,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue,
    updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "originalFilename",
            Decco.stringToJson(v.originalFilename)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalFilename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFilename"), null));
    if (originalFilename.TAG === /* Ok */ 0) {
        var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
        if (playbackFormLabel.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    originalFilename: originalFilename._0,
                    playbackFormLabel: playbackFormLabel._0
                }
            };
        }
        var e = playbackFormLabel._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".playbackFormLabel" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = originalFilename._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalFilename" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        originalFilename: param.originalFilename,
        playbackFormLabel: param.playbackFormLabel
    };
}
function getPlaybackFormLabelFromParam(param) {
    return param.playbackFormLabel;
}
function removePrivateInfo(v) {
    return {
        originalFilename: "",
        playbackFormLabel: v.playbackFormLabel
    };
}
var ParamDescriptor = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    fromAuthoringConfig: fromAuthoringConfig,
    getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
    removePrivateInfo: removePrivateInfo
};
var t_encode$7 = t_encode$4;
var t_decode$7 = t_decode$4;
function fromParamDescriptor(param) {
    var originalFilename = param.originalFilename;
    var originalNameParts = $$Array.of_list(StringUtils$SmartcutsMacros.split(".", originalFilename));
    var lastPart = Belt_Array.get(originalNameParts, originalNameParts.length - 1 | 0);
    if (lastPart !== undefined) {
        return /* CustomFilename */ {
            _0: "yourOwnName." + lastPart
        };
    } else {
        return /* CustomFilename */ {
            _0: originalFilename
        };
    }
}
function toCommandValueForPlayback(oldCommandValue, filename) {
    return {
        recordingReferrer: oldCommandValue.recordingReferrer,
        recordingUrl: oldCommandValue.recordingUrl,
        recordingFinalUrl: oldCommandValue.recordingFinalUrl,
        recordingFilename: oldCommandValue.recordingFilename,
        filename: filename,
        tabOrigin: oldCommandValue.tabOrigin
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$4,
    fromParamDescriptor: fromParamDescriptor,
    toCommandValueForPlayback: toCommandValueForPlayback
};
exports.DownloadTabOrigin = DownloadTabOrigin;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 14632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
    if (tabRef.TAG === /* Ok */ 0) {
        var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
            if (title.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        tabRef: tabRef._0,
                        url: url._0,
                        title: title._0
                    }
                };
            }
            var e = title._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".title" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = tabRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabRef" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(stringifyTabRef, param) {
    var title = param.title;
    return "{ tabRef: " + (Curry._1(stringifyTabRef, param.tabRef) + (", url: " + (param.url + (", title: " + ((title !== undefined ? title : "None") + " }")))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* InterfaceBtwnRecordingAndPlayback-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 39968:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var A1Notation = __webpack_require__(52744);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var GoogleSheetTypes$SmartcutsMacros = __webpack_require__(25330);
var GoogleSheetHelpers$SmartcutsMacros = __webpack_require__(42828);
function columnForIndexStarting0(colIndex) {
    return A1Notation.toCol(colIndex + 1 | 0);
}
function fromRowColStarting0(rowIndex, colIndex) {
    return new A1Notation(colIndex + 1 | 0, rowIndex + 1 | 0).toString();
}
var A1 = {
    columnForIndexStarting0: columnForIndexStarting0,
    fromRowColStarting0: fromRowColStarting0
};
function t_encode(encoder_rowLocation, v) {
    return Js_dict.fromArray([
        [
            "rowLocation",
            Curry._1(encoder_rowLocation, v.rowLocation)
        ],
        [
            "cellValues",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.cellValues)
        ]
    ]);
}
function t_decode(decoder_rowLocation, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rowLocation = Curry._1(decoder_rowLocation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowLocation"), null));
    if (rowLocation.TAG === /* Ok */ 0) {
        var cellValues = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellValues"), null));
        if (cellValues.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    rowLocation: rowLocation._0,
                    cellValues: cellValues._0
                }
            };
        }
        var e = cellValues._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".cellValues" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = rowLocation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rowLocation" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(stringifyRowLocation, param) {
    return "{ rowLocation: " + (Curry._1(stringifyRowLocation, param.rowLocation) + (", cellValues: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.cellValues, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify))) + " }")));
}
var UpsertRow = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(encoder_rowLocation, encoder_cellUpdate, v) {
    return Js_dict.fromArray([
        [
            "rowLocation",
            Curry._1(encoder_rowLocation, v.rowLocation)
        ],
        [
            "updatedColIndex",
            Decco.intToJson(v.updatedColIndex)
        ],
        [
            "cellUpdate",
            Curry._1(encoder_cellUpdate, v.cellUpdate)
        ]
    ]);
}
function t_decode$1(decoder_rowLocation, decoder_cellUpdate, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rowLocation = Curry._1(decoder_rowLocation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowLocation"), null));
    if (rowLocation.TAG === /* Ok */ 0) {
        var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
        if (updatedColIndex.TAG === /* Ok */ 0) {
            var cellUpdate = Curry._1(decoder_cellUpdate, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
            if (cellUpdate.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        rowLocation: rowLocation._0,
                        updatedColIndex: updatedColIndex._0,
                        cellUpdate: cellUpdate._0
                    }
                };
            }
            var e = cellUpdate._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".cellUpdate" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = updatedColIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".updatedColIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = rowLocation._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rowLocation" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(stringifyRowLocation, stringifyCellUpdate, param) {
    return "{ rowLocation: " + (Curry._1(stringifyRowLocation, param.rowLocation) + ("], updatedColIndex: " + (String(param.updatedColIndex) + (", cellUpdate: " + (Curry._1(stringifyCellUpdate, param.cellUpdate) + " }")))));
}
var UpdateCell = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(encoder_rowLocation, encoder_cellUpdate, v) {
    if (v.TAG === /* UpsertRow */ 0) {
        return [
            "UpsertRow",
            t_encode(encoder_rowLocation, v._0)
        ];
    } else {
        return [
            "UpdateCell",
            t_encode$1(encoder_rowLocation, encoder_cellUpdate, v._0)
        ];
    }
}
function t_decode$2(decoder_rowLocation, decoder_cellUpdate, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "UpdateCell":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$1(decoder_rowLocation, decoder_cellUpdate, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpdateCell */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UpsertRow":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(decoder_rowLocation, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpsertRow */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$2(stringifyRowLocation, stringifyCellUpdate, commandValue) {
    if (commandValue.TAG === /* UpsertRow */ 0) {
        return "UpsertRow(" + (stringify(stringifyRowLocation, commandValue._0) + ")");
    } else {
        return "UpdateCell(" + (stringify$1(stringifyRowLocation, stringifyCellUpdate, commandValue._0) + ")");
    }
}
function getRowLocation(update) {
    return update._0.rowLocation;
}
function actOnSameRow(update1, update2, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation) {
    var rowLocation1 = update1._0.rowLocation;
    var rowLocation2 = update2._0.rowLocation;
    if (Curry._1(getKeyColumnIndexFromRowLocation, rowLocation1) !== Curry._1(getKeyColumnIndexFromRowLocation, rowLocation2)) {
        return false;
    }
    var match = Curry._1(getKeyColumnValueFromRowLocation, rowLocation1);
    var match$1 = Curry._1(getKeyColumnValueFromRowLocation, rowLocation2);
    if (typeof match === "number" || !(match.TAG === /* Value */ 1 && !(typeof match$1 === "number" || match$1.TAG !== /* Value */ 1))) {
        return Caml_obj.caml_equal(match, match$1);
    } else {
        return Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, match._0) === Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, match$1._0);
    }
}
function merge(lastCopyInfo, getNewValueFromCellUpdate, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation, intoUpdate, mapRowLocationData, update) {
    if (!actOnSameRow(intoUpdate, update, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation)) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Can't merge 2 updates that don't act on the same row");
    }
    if (intoUpdate.TAG === /* UpsertRow */ 0) {
        var match = intoUpdate._0;
        var cellValues = match.cellValues;
        if (update.TAG === /* UpsertRow */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: Merge 2 UpsertRows");
        }
        var match$1 = update._0;
        var func = function func(param, param$1, param$2) {
            return ArrayUtils$SmartcutsMacros.setAtIndexAndFillGap(match$1.updatedColIndex, param, param$1, param$2);
        };
        var param1 = Curry._2(GoogleSheetTypes$SmartcutsMacros.Cell.Value.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo, Curry._1(getNewValueFromCellUpdate, match$1.cellUpdate));
        var func$1 = Curry._1(func, param1);
        return {
            TAG: /* UpsertRow */ 0,
            _0: {
                rowLocation: Curry._2(mapRowLocationData, match.rowLocation, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo)),
                cellValues: Curry._1(function(param) {
                    return Curry._2(func$1, param, cellValues);
                }, /* Empty */ 0)
            }
        };
    }
    var match$2 = intoUpdate._0;
    var updatedColIndex_1 = match$2.updatedColIndex;
    var rowLocation = match$2.rowLocation;
    if (update.TAG === /* UpsertRow */ 0) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: Merge UpdateCell followed by UpsertRow");
    }
    var match$3 = update._0;
    var updatedColIndex_2 = match$3.updatedColIndex;
    return {
        TAG: /* UpsertRow */ 0,
        _0: {
            rowLocation: rowLocation,
            cellValues: ArrayUtils$SmartcutsMacros.setWithoutFill(updatedColIndex_2, Curry._1(getNewValueFromCellUpdate, match$3.cellUpdate), ArrayUtils$SmartcutsMacros.setWithoutFill(updatedColIndex_1, Curry._1(getNewValueFromCellUpdate, match$2.cellUpdate), ArrayUtils$SmartcutsMacros.setWithoutFill(Curry._1(getKeyColumnIndexFromRowLocation, rowLocation), Curry._1(getKeyColumnValueFromRowLocation, rowLocation), Caml_array.make((updatedColIndex_1 > updatedColIndex_2 ? updatedColIndex_1 : updatedColIndex_2) + 1 | 0, /* Unknown */ 1))))
        }
    };
}
var Update = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    getRowLocation: getRowLocation,
    actOnSameRow: actOnSameRow,
    merge: merge
};
function t_encode$3(encoder_rowLocation, encoder_cellUpdate, v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "update",
            t_encode$2(encoder_rowLocation, encoder_cellUpdate, v.update)
        ]
    ]);
}
function t_decode$3(decoder_rowLocation, decoder_cellUpdate, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var update = t_decode$2(decoder_rowLocation, decoder_cellUpdate, Belt_Option.getWithDefault(Js_dict.get(dict$1, "update"), null));
                if (update.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            spreadsheetId: spreadsheetId._0,
                            sheetName: sheetName._0,
                            colNames: colNames._0,
                            update: update._0
                        }
                    };
                }
                var e = update._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".update" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$3(stringifyRowLocation, stringifyCellUpdate, param) {
    return "{ spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", colNames: [" + (param.colNames.join(", ") + ("], update: " + (stringify$2(stringifyRowLocation, stringifyCellUpdate, param.update) + " }")))))));
}
var Generic = {
    UpsertRow: UpsertRow,
    UpdateCell: UpdateCell,
    Update: Update,
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$3
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "sheetDiff",
            GoogleSheetTypes$SmartcutsMacros.SheetDiff.t_encode(v.sheetDiff)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var sheetDiff = GoogleSheetTypes$SmartcutsMacros.SheetDiff.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetDiff"), null));
                if (sheetDiff.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            spreadsheetId: spreadsheetId._0,
                            sheetName: sheetName._0,
                            colNames: colNames._0,
                            sheetDiff: sheetDiff._0
                        }
                    };
                }
                var e = sheetDiff._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".sheetDiff" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$4(param) {
    return "{ spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", colNames: [" + (param.colNames.join(", ") + (", sheetDiff: " + (GoogleSheetTypes$SmartcutsMacros.SheetDiff.stringify(param.sheetDiff) + ")")))))));
}
var Recording = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$4
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "fromValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.fromValue)
        ],
        [
            "toValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.toValue)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var fromValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fromValue"), null));
    if (fromValue.TAG === /* Ok */ 0) {
        var toValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "toValue"), null));
        if (toValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    fromValue: fromValue._0,
                    toValue: toValue._0
                }
            };
        }
        var e = toValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".toValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = fromValue._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".fromValue" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$5(param) {
    return "{ fromValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.fromValue) + (", toValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.toValue) + " }")));
}
function fromCellContentDiff(diff) {
    switch(diff.TAG | 0){
        case /* FromTo */ 0:
            var match = diff._0;
            return {
                fromValue: match.from,
                toValue: match.to_
            };
        case /* Added */ 1:
            return {
                fromValue: /* Empty */ 0,
                toValue: diff._0
            };
        case /* Removed */ 2:
            return {
                fromValue: diff._0,
                toValue: /* Empty */ 0
            };
    }
}
function mapDataRef(f, param) {
    var func = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
    var func$1 = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
    return {
        fromValue: Curry._2(func, f, param.fromValue),
        toValue: Curry._2(func$1, f, param.toValue)
    };
}
var CellUpdate = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    stringify: stringify$5,
    fromCellContentDiff: fromCellContentDiff,
    mapDataRef: mapDataRef
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "rowIndex",
            Decco.intToJson(v.rowIndex)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "rowData",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
    if (rowIndex.TAG === /* Ok */ 0) {
        var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
        if (keyColumnIndex.TAG === /* Ok */ 0) {
            var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
            if (rowData.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        rowIndex: rowIndex._0,
                        keyColumnIndex: keyColumnIndex._0,
                        rowData: rowData._0
                    }
                };
            }
            var e = rowData._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".rowData" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = keyColumnIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".keyColumnIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = rowIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rowIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$6(param) {
    return "{ rowIndex: " + (String(param.rowIndex) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", rowData: [" + (param.rowData.join(", ") + "]}")))));
}
function getPrimaryKeyText(param) {
    return Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, Belt_Array.getExn(param.rowData, param.keyColumnIndex));
}
var RowLocation = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    stringify: stringify$6,
    getPrimaryKeyText: getPrimaryKeyText
};
function t_encode$7(v) {
    return t_encode$3(t_encode$6, t_encode$5, v);
}
function t_decode$7(v) {
    return t_decode$3(t_decode$6, t_decode$5, v);
}
function stringify$7(commandValue) {
    return stringify$3(stringify$6, stringify$5, commandValue);
}
function getIdentifier(param3) {
    var update = param3.update;
    var match;
    if (update.TAG === /* UpsertRow */ 0) {
        var match$1 = update._0;
        var firstUpdatedColIndex = OptionUtils$SmartcutsMacros.withDefault(0, Belt_Array.getIndexBy(match$1.cellValues, function(param) {
            return Util$SmartcutsMacros.compose(Util$SmartcutsMacros.not_, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, param);
        }));
        match = [
            match$1.rowLocation.rowIndex,
            firstUpdatedColIndex
        ];
    } else {
        var match$2 = update._0;
        match = [
            match$2.rowLocation.rowIndex,
            match$2.updatedColIndex
        ];
    }
    return param3.sheetName + ("!" + fromRowColStarting0(match[0], match[1]));
}
function fromRecordingCommandValue(param4) {
    var sheetDiff = param4.sheetDiff;
    var colNames = param4.colNames;
    var sheetName = param4.sheetName;
    var spreadsheetId = param4.spreadsheetId;
    switch(sheetDiff.TAG | 0){
        case /* UpdateCell */ 0:
            var match = sheetDiff._1;
            var priorCells = match.cells;
            var rowIndex = match.rowIndex;
            var match$1 = sheetDiff._0;
            var diff = match$1.diff;
            var colIndex = match$1.colIndex;
            var tmp;
            if (Belt_Array.every(priorCells, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty)) {
                var allPriorCells = GoogleSheetHelpers$SmartcutsMacros.maybePadMissingCellsWithEmptyValues(colIndex, priorCells);
                var updatedCells = ArrayUtils$SmartcutsMacros.replaceAtIndex(allPriorCells, colIndex, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.CellDiff.ContentDiff.rhs, diff));
                tmp = {
                    TAG: /* UpsertRow */ 0,
                    _0: {
                        rowLocation: {
                            rowIndex: rowIndex,
                            keyColumnIndex: colIndex,
                            rowData: updatedCells
                        },
                        cellValues: updatedCells
                    }
                };
            } else {
                var arg = ArrayUtils$SmartcutsMacros.shortcutWithIndex(function(cellValue, index) {
                    if (!Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, cellValue) && colIndex !== index) {
                        return index;
                    }
                }, priorCells);
                tmp = {
                    TAG: /* UpdateCell */ 1,
                    _0: {
                        rowLocation: {
                            rowIndex: rowIndex,
                            keyColumnIndex: function(param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg);
                            }("Expected to find a non-empty key col index != updated col index"),
                            rowData: priorCells
                        },
                        updatedColIndex: colIndex,
                        cellUpdate: fromCellContentDiff(diff)
                    }
                };
            }
            return {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: colNames,
                update: tmp
            };
        case /* AppendRow */ 1:
            var match$2 = sheetDiff._0;
            var cells = match$2.cells;
            var arg$1 = Belt_Array.getIndexBy(cells, function(param) {
                return Util$SmartcutsMacros.compose(Util$SmartcutsMacros.not_, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, param);
            });
            return {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: colNames,
                update: {
                    TAG: /* UpsertRow */ 0,
                    _0: {
                        rowLocation: {
                            rowIndex: match$2.rowIndex,
                            keyColumnIndex: function(param) {
                                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                            }("A new row must not be composed of all empty cells"),
                            rowData: cells
                        },
                        cellValues: cells
                    }
                }
            };
        case /* DeleteRow */ 2:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: DeleteRow(*)");
    }
}
var Authoring = {
    CellUpdate: CellUpdate,
    RowLocation: RowLocation,
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$7,
    getIdentifier: getIdentifier,
    fromRecordingCommandValue: fromRecordingCommandValue
};
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
    if (keyColumnIndex.TAG === /* Ok */ 0) {
        var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
        if (keyColumnValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    keyColumnIndex: keyColumnIndex._0,
                    keyColumnValue: keyColumnValue._0
                }
            };
        }
        var e = keyColumnValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".keyColumnValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = keyColumnIndex._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".keyColumnIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$8(param) {
    return "{ keyColumnIndex: " + (String(param.keyColumnIndex) + (", keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + " }")));
}
function getPrimaryKeyText$1(param) {
    return Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, param.keyColumnValue);
}
function maybeGetCommandIdPointedToByMaybePrimaryKeyRef(param) {
    var keyColumnValue = param.keyColumnValue;
    if (typeof keyColumnValue === "number") {
        return;
    }
    if (keyColumnValue.TAG !== /* Value */ 1) {
        return;
    }
    var match = keyColumnValue._0;
    if (match.TAG === /* TextFromGSheetUpsertCommand */ 3) {
        return match._0.commandId;
    }
}
var RowLocation$1 = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    stringify: stringify$8,
    getPrimaryKeyText: getPrimaryKeyText$1,
    maybeGetCommandIdPointedToByMaybePrimaryKeyRef: maybeGetCommandIdPointedToByMaybePrimaryKeyRef
};
function t_encode$9(v) {
    return t_encode$3(t_encode$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v);
}
function t_decode$9(v) {
    return t_decode$3(t_decode$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, v);
}
function stringify$9(commandValue) {
    return stringify$3(stringify$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, commandValue);
}
function fromAuthoringCommandValue(authoringCommandValue) {
    var update = authoringCommandValue.update;
    if (update.TAG === /* UpsertRow */ 0) {
        var match = update._0;
        var match$1 = match.rowLocation;
        var keyColumnIndex = match$1.keyColumnIndex;
        return {
            spreadsheetId: authoringCommandValue.spreadsheetId,
            sheetName: authoringCommandValue.sheetName,
            colNames: authoringCommandValue.colNames,
            update: {
                TAG: /* UpsertRow */ 0,
                _0: {
                    rowLocation: {
                        keyColumnIndex: keyColumnIndex,
                        keyColumnValue: Caml_array.get(match$1.rowData, keyColumnIndex)
                    },
                    cellValues: match.cellValues
                }
            }
        };
    }
    var match$2 = update._0;
    var match$3 = match$2.rowLocation;
    var keyColumnIndex$1 = match$3.keyColumnIndex;
    return {
        spreadsheetId: authoringCommandValue.spreadsheetId,
        sheetName: authoringCommandValue.sheetName,
        colNames: authoringCommandValue.colNames,
        update: {
            TAG: /* UpdateCell */ 1,
            _0: {
                rowLocation: {
                    keyColumnIndex: keyColumnIndex$1,
                    keyColumnValue: Caml_array.get(match$3.rowData, keyColumnIndex$1)
                },
                updatedColIndex: match$2.updatedColIndex,
                cellUpdate: match$2.cellUpdate.toValue
            }
        }
    };
}
var Playback = {
    RowLocation: RowLocation$1,
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    stringify: stringify$9,
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
var CommandValue = {
    Generic: Generic,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function t_encode$10(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "rowData",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "cellUpdate",
            t_encode$5(v.cellUpdate)
        ],
        [
            "updatedColIndex",
            Decco.intToJson(v.updatedColIndex)
        ],
        [
            "dynamic",
            Decco.boolToJson(v.dynamic)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$10(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
                if (rowData.TAG === /* Ok */ 0) {
                    var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
                    if (keyColumnIndex.TAG === /* Ok */ 0) {
                        var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                        if (keyColumnValue.TAG === /* Ok */ 0) {
                            var cellUpdate = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
                            if (cellUpdate.TAG === /* Ok */ 0) {
                                var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
                                if (updatedColIndex.TAG === /* Ok */ 0) {
                                    var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
                                    if (dynamic.TAG === /* Ok */ 0) {
                                        var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                                        if (playbackFormLabel.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: {
                                                    spreadsheetId: spreadsheetId._0,
                                                    sheetName: sheetName._0,
                                                    colNames: colNames._0,
                                                    rowData: rowData._0,
                                                    keyColumnIndex: keyColumnIndex._0,
                                                    keyColumnValue: keyColumnValue._0,
                                                    cellUpdate: cellUpdate._0,
                                                    updatedColIndex: updatedColIndex._0,
                                                    dynamic: dynamic._0,
                                                    playbackFormLabel: playbackFormLabel._0
                                                }
                                            };
                                        }
                                        var e = playbackFormLabel._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".playbackFormLabel" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = dynamic._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".dynamic" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }
                                var e$2 = updatedColIndex._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".updatedColIndex" + e$2.path,
                                        message: e$2.message,
                                        value: e$2.value
                                    }
                                };
                            }
                            var e$3 = cellUpdate._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".cellUpdate" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                }
                            };
                        }
                        var e$4 = keyColumnValue._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".keyColumnValue" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = keyColumnIndex._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".keyColumnIndex" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = rowData._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".rowData" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            }
            var e$7 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                }
            };
        }
        var e$8 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$8.path,
                message: e$8.message,
                value: e$8.value
            }
        };
    }
    var e$9 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$9.path,
            message: e$9.message,
            value: e$9.value
        }
    };
}
function generatePlaybackFormLabel(param, param$1, colNames, updatedColIndex) {
    return "Value for " + Caml_array.get(colNames, updatedColIndex);
}
function updateKeyColumnIndex(keyColumnIndex, config) {
    return {
        spreadsheetId: config.spreadsheetId,
        sheetName: config.sheetName,
        colNames: config.colNames,
        rowData: config.rowData,
        keyColumnIndex: keyColumnIndex,
        keyColumnValue: config.keyColumnValue,
        cellUpdate: config.cellUpdate,
        updatedColIndex: config.updatedColIndex,
        dynamic: config.dynamic,
        playbackFormLabel: generatePlaybackFormLabel(keyColumnIndex, config.rowData, config.colNames, config.updatedColIndex)
    };
}
var UpdateCellConfig = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    generatePlaybackFormLabel: generatePlaybackFormLabel,
    updateKeyColumnIndex: updateKeyColumnIndex
};
function t_encode$11(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "rowData",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "dynamic",
            Decco.boolToJson(v.dynamic)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$11(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
                if (rowData.TAG === /* Ok */ 0) {
                    var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
                    if (keyColumnIndex.TAG === /* Ok */ 0) {
                        var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                        if (keyColumnValue.TAG === /* Ok */ 0) {
                            var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
                            if (dynamic.TAG === /* Ok */ 0) {
                                var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                                if (playbackFormLabel.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            spreadsheetId: spreadsheetId._0,
                                            sheetName: sheetName._0,
                                            colNames: colNames._0,
                                            rowData: rowData._0,
                                            keyColumnIndex: keyColumnIndex._0,
                                            keyColumnValue: keyColumnValue._0,
                                            dynamic: dynamic._0,
                                            playbackFormLabel: playbackFormLabel._0
                                        }
                                    };
                                }
                                var e = playbackFormLabel._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".playbackFormLabel" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = dynamic._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".dynamic" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = keyColumnValue._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".keyColumnValue" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = keyColumnIndex._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".keyColumnIndex" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = rowData._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".rowData" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function generatePlaybackFormLabel$1(keyColumnIndex, param, colNames) {
    return Caml_array.get(colNames, keyColumnIndex);
}
function updateKeyColumnIndex$1(keyColumnIndex, config) {
    return {
        spreadsheetId: config.spreadsheetId,
        sheetName: config.sheetName,
        colNames: config.colNames,
        rowData: config.rowData,
        keyColumnIndex: keyColumnIndex,
        keyColumnValue: config.keyColumnValue,
        dynamic: config.dynamic,
        playbackFormLabel: Caml_array.get(config.colNames, keyColumnIndex)
    };
}
var UpsertRowConfig = {
    t_encode: t_encode$11,
    t_decode: t_decode$11,
    generatePlaybackFormLabel: generatePlaybackFormLabel$1,
    updateKeyColumnIndex: updateKeyColumnIndex$1
};
function t_encode$12(v) {
    if (v.TAG === /* UpdateCellConfig */ 0) {
        return [
            "UpdateCellConfig",
            t_encode$10(v._0)
        ];
    } else {
        return [
            "UpsertRowConfig",
            t_encode$11(v._0)
        ];
    }
}
function t_decode$12(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "UpdateCellConfig":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$10(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpdateCellConfig */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UpsertRowConfig":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$11(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpsertRowConfig */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function generatePlaybackFormLabelFromAuthoringCommandValue(param) {
    var update = param.update;
    var colNames = param.colNames;
    if (update.TAG === /* UpsertRow */ 0) {
        return Caml_array.get(colNames, 0);
    } else {
        return Caml_array.get(colNames, update._0.updatedColIndex);
    }
}
function fromAuthoringCommandValue$1(authoringCommandValue) {
    var update = authoringCommandValue.update;
    var colNames = authoringCommandValue.colNames;
    var sheetName = authoringCommandValue.sheetName;
    var spreadsheetId = authoringCommandValue.spreadsheetId;
    if (update.TAG === /* UpsertRow */ 0) {
        var match = update._0;
        return {
            TAG: /* UpsertRowConfig */ 1,
            _0: {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: colNames,
                rowData: match.cellValues,
                keyColumnIndex: 0,
                keyColumnValue: Caml_array.get(match.rowLocation.rowData, 0),
                dynamic: false,
                playbackFormLabel: generatePlaybackFormLabelFromAuthoringCommandValue(authoringCommandValue)
            }
        };
    }
    var match$1 = update._0;
    var priorCells = match$1.rowLocation.rowData;
    return {
        TAG: /* UpdateCellConfig */ 0,
        _0: {
            spreadsheetId: spreadsheetId,
            sheetName: sheetName,
            colNames: colNames,
            rowData: priorCells,
            keyColumnIndex: 0,
            keyColumnValue: Caml_array.get(priorCells, 0),
            cellUpdate: match$1.cellUpdate,
            updatedColIndex: match$1.updatedColIndex,
            dynamic: false,
            playbackFormLabel: generatePlaybackFormLabelFromAuthoringCommandValue(authoringCommandValue)
        }
    };
}
function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
    if (config.TAG === /* UpdateCellConfig */ 0) {
        var updateCellConfig = config._0;
        return {
            TAG: /* UpdateCellConfig */ 0,
            _0: {
                spreadsheetId: updateCellConfig.spreadsheetId,
                sheetName: updateCellConfig.sheetName,
                colNames: updateCellConfig.colNames,
                rowData: updateCellConfig.rowData,
                keyColumnIndex: updateCellConfig.keyColumnIndex,
                keyColumnValue: updateCellConfig.keyColumnValue,
                cellUpdate: updateCellConfig.cellUpdate,
                updatedColIndex: updateCellConfig.updatedColIndex,
                dynamic: updateCellConfig.dynamic,
                playbackFormLabel: playbackFormLabel
            }
        };
    }
    var upsertRowConfig = config._0;
    return {
        TAG: /* UpsertRowConfig */ 1,
        _0: {
            spreadsheetId: upsertRowConfig.spreadsheetId,
            sheetName: upsertRowConfig.sheetName,
            colNames: upsertRowConfig.colNames,
            rowData: upsertRowConfig.rowData,
            keyColumnIndex: upsertRowConfig.keyColumnIndex,
            keyColumnValue: upsertRowConfig.keyColumnValue,
            dynamic: upsertRowConfig.dynamic,
            playbackFormLabel: playbackFormLabel
        }
    };
}
function updateKeyColumnIndex$2(keyColumnIndex, config) {
    if (config.TAG === /* UpdateCellConfig */ 0) {
        return {
            TAG: /* UpdateCellConfig */ 0,
            _0: updateKeyColumnIndex(keyColumnIndex, config._0)
        };
    } else {
        return {
            TAG: /* UpsertRowConfig */ 1,
            _0: updateKeyColumnIndex$1(keyColumnIndex, config._0)
        };
    }
}
function isDynamic(config) {
    if (config.TAG === /* UpdateCellConfig */ 0) {
        return config._0.dynamic;
    } else {
        return config._0.dynamic;
    }
}
function updateConfigWithAuthoringCommandValue(param, config) {
    var update = param.update;
    var sheetName = param.sheetName;
    var spreadsheetId = param.spreadsheetId;
    if (update.TAG === /* UpsertRow */ 0) {
        if (config.TAG === /* UpdateCellConfig */ 0) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Google Sheet update and config mismatch");
        }
        var config$1 = config._0;
        return {
            TAG: /* UpsertRowConfig */ 1,
            _0: {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: config$1.colNames,
                rowData: update._0.cellValues,
                keyColumnIndex: config$1.keyColumnIndex,
                keyColumnValue: config$1.keyColumnValue,
                dynamic: config$1.dynamic,
                playbackFormLabel: config$1.playbackFormLabel
            }
        };
    }
    if (config.TAG !== /* UpdateCellConfig */ 0) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Google Sheet update and config mismatch");
    }
    var config$2 = config._0;
    return {
        TAG: /* UpdateCellConfig */ 0,
        _0: {
            spreadsheetId: spreadsheetId,
            sheetName: sheetName,
            colNames: config$2.colNames,
            rowData: config$2.rowData,
            keyColumnIndex: config$2.keyColumnIndex,
            keyColumnValue: config$2.keyColumnValue,
            cellUpdate: update._0.cellUpdate,
            updatedColIndex: config$2.updatedColIndex,
            dynamic: config$2.dynamic,
            playbackFormLabel: config$2.playbackFormLabel
        }
    };
}
function isMergeable(config) {
    return false;
}
function mapDataRef$1(f, v) {
    if (v.TAG === /* UpdateCellConfig */ 0) {
        var updateCellConfig = v._0;
        var func = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
        return {
            TAG: /* UpdateCellConfig */ 0,
            _0: {
                spreadsheetId: updateCellConfig.spreadsheetId,
                sheetName: updateCellConfig.sheetName,
                colNames: updateCellConfig.colNames,
                rowData: Belt_Array.map(updateCellConfig.rowData, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef, f)),
                keyColumnIndex: updateCellConfig.keyColumnIndex,
                keyColumnValue: Curry._2(func, f, updateCellConfig.keyColumnValue),
                cellUpdate: mapDataRef(f, updateCellConfig.cellUpdate),
                updatedColIndex: updateCellConfig.updatedColIndex,
                dynamic: updateCellConfig.dynamic,
                playbackFormLabel: updateCellConfig.playbackFormLabel
            }
        };
    }
    var upsertRowConfig = v._0;
    var func$1 = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
    return {
        TAG: /* UpsertRowConfig */ 1,
        _0: {
            spreadsheetId: upsertRowConfig.spreadsheetId,
            sheetName: upsertRowConfig.sheetName,
            colNames: upsertRowConfig.colNames,
            rowData: Belt_Array.map(upsertRowConfig.rowData, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef, f)),
            keyColumnIndex: upsertRowConfig.keyColumnIndex,
            keyColumnValue: Curry._2(func$1, f, upsertRowConfig.keyColumnValue),
            dynamic: upsertRowConfig.dynamic,
            playbackFormLabel: upsertRowConfig.playbackFormLabel
        }
    };
}
var AuthoringConfig = {
    UpdateCellConfig: UpdateCellConfig,
    UpsertRowConfig: UpsertRowConfig,
    t_encode: t_encode$12,
    t_decode: t_decode$12,
    generatePlaybackFormLabelFromAuthoringCommandValue: generatePlaybackFormLabelFromAuthoringCommandValue,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
    updateKeyColumnIndex: updateKeyColumnIndex$2,
    isDynamic: isDynamic,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue,
    isMergeable: isMergeable,
    mapDataRef: mapDataRef$1
};
function t_encode$13(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "rowData",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$13(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
                if (keyColumnIndex.TAG === /* Ok */ 0) {
                    var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                    if (keyColumnValue.TAG === /* Ok */ 0) {
                        var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
                        if (rowData.TAG === /* Ok */ 0) {
                            var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                            if (playbackFormLabel.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        spreadsheetId: spreadsheetId._0,
                                        sheetName: sheetName._0,
                                        colNames: colNames._0,
                                        keyColumnIndex: keyColumnIndex._0,
                                        keyColumnValue: keyColumnValue._0,
                                        rowData: rowData._0,
                                        playbackFormLabel: playbackFormLabel._0
                                    }
                                };
                            }
                            var e = playbackFormLabel._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".playbackFormLabel" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = rowData._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".rowData" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = keyColumnValue._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".keyColumnValue" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = keyColumnIndex._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".keyColumnIndex" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
var UpsertRowParam = {
    t_encode: t_encode$13,
    t_decode: t_decode$13
};
function t_encode$14(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "updatedColIndex",
            Decco.intToJson(v.updatedColIndex)
        ],
        [
            "cellUpdate",
            t_encode$5(v.cellUpdate)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$14(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
            if (colNames.TAG === /* Ok */ 0) {
                var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
                if (keyColumnIndex.TAG === /* Ok */ 0) {
                    var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                    if (keyColumnValue.TAG === /* Ok */ 0) {
                        var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
                        if (updatedColIndex.TAG === /* Ok */ 0) {
                            var cellUpdate = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
                            if (cellUpdate.TAG === /* Ok */ 0) {
                                var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                                if (playbackFormLabel.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            spreadsheetId: spreadsheetId._0,
                                            sheetName: sheetName._0,
                                            colNames: colNames._0,
                                            keyColumnIndex: keyColumnIndex._0,
                                            keyColumnValue: keyColumnValue._0,
                                            updatedColIndex: updatedColIndex._0,
                                            cellUpdate: cellUpdate._0,
                                            playbackFormLabel: playbackFormLabel._0
                                        }
                                    };
                                }
                                var e = playbackFormLabel._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".playbackFormLabel" + e.path,
                                        message: e.message,
                                        value: e.value
                                    }
                                };
                            }
                            var e$1 = cellUpdate._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".cellUpdate" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                }
                            };
                        }
                        var e$2 = updatedColIndex._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".updatedColIndex" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = keyColumnValue._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".keyColumnValue" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = keyColumnIndex._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".keyColumnIndex" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = colNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".colNames" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
var UpdateCellParam = {
    t_encode: t_encode$14,
    t_decode: t_decode$14
};
function t_encode$15(v) {
    if (v.TAG === /* UpdateCellParam */ 0) {
        return [
            "UpdateCellParam",
            t_encode$14(v._0)
        ];
    } else {
        return [
            "UpsertRowParam",
            t_encode$13(v._0)
        ];
    }
}
function t_decode$15(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "UpdateCellParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$14(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpdateCellParam */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UpsertRowParam":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$13(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpsertRowParam */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fromCommandValueConfigurability(config) {
    if (config.TAG === /* UpdateCellConfig */ 0) {
        var match = config._0;
        return {
            TAG: /* UpdateCellParam */ 0,
            _0: {
                spreadsheetId: match.spreadsheetId,
                sheetName: match.sheetName,
                colNames: match.colNames,
                keyColumnIndex: match.keyColumnIndex,
                keyColumnValue: match.keyColumnValue,
                updatedColIndex: match.updatedColIndex,
                cellUpdate: match.cellUpdate,
                playbackFormLabel: match.playbackFormLabel
            }
        };
    }
    var match$1 = config._0;
    return {
        TAG: /* UpsertRowParam */ 1,
        _0: {
            spreadsheetId: match$1.spreadsheetId,
            sheetName: match$1.sheetName,
            colNames: match$1.colNames,
            keyColumnIndex: match$1.keyColumnIndex,
            keyColumnValue: match$1.keyColumnValue,
            rowData: match$1.rowData,
            playbackFormLabel: match$1.playbackFormLabel
        }
    };
}
function getPlaybackFormLabelFromParam(config) {
    if (config.TAG === /* UpdateCellParam */ 0) {
        return config._0.playbackFormLabel;
    } else {
        return config._0.playbackFormLabel;
    }
}
var ParamDescriptor = {
    UpsertRowParam: UpsertRowParam,
    UpdateCellParam: UpdateCellParam,
    t_encode: t_encode$15,
    t_decode: t_decode$15,
    fromCommandValueConfigurability: fromCommandValueConfigurability,
    getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam
};
function t_encode$16(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "updatedColIndex",
            Decco.intToJson(v.updatedColIndex)
        ],
        [
            "cellUpdate",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.cellUpdate)
        ]
    ]);
}
function t_decode$16(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
            if (keyColumnIndex.TAG === /* Ok */ 0) {
                var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                if (keyColumnValue.TAG === /* Ok */ 0) {
                    var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
                    if (colNames.TAG === /* Ok */ 0) {
                        var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
                        if (updatedColIndex.TAG === /* Ok */ 0) {
                            var cellUpdate = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
                            if (cellUpdate.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        spreadsheetId: spreadsheetId._0,
                                        sheetName: sheetName._0,
                                        keyColumnIndex: keyColumnIndex._0,
                                        keyColumnValue: keyColumnValue._0,
                                        colNames: colNames._0,
                                        updatedColIndex: updatedColIndex._0,
                                        cellUpdate: cellUpdate._0
                                    }
                                };
                            }
                            var e = cellUpdate._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".cellUpdate" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = updatedColIndex._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".updatedColIndex" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = colNames._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".colNames" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = keyColumnValue._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".keyColumnValue" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = keyColumnIndex._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".keyColumnIndex" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function stringify$10(param) {
    return "{ keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", cellUpdate: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.cellUpdate) + "] }")))))))));
}
var UpdateCellParamValue = {
    t_encode: t_encode$16,
    t_decode: t_decode$16,
    stringify: stringify$10
};
function t_encode$17(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "sheetName",
            Decco.stringToJson(v.sheetName)
        ],
        [
            "keyColumnIndex",
            Decco.intToJson(v.keyColumnIndex)
        ],
        [
            "keyColumnValue",
            Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
        ],
        [
            "colNames",
            Decco.arrayToJson(Decco.stringToJson, v.colNames)
        ],
        [
            "rowData",
            Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
        ]
    ]);
}
function t_decode$17(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
        if (sheetName.TAG === /* Ok */ 0) {
            var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
            if (keyColumnIndex.TAG === /* Ok */ 0) {
                var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
                if (keyColumnValue.TAG === /* Ok */ 0) {
                    var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
                    if (colNames.TAG === /* Ok */ 0) {
                        var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
                        if (rowData.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    spreadsheetId: spreadsheetId._0,
                                    sheetName: sheetName._0,
                                    keyColumnIndex: keyColumnIndex._0,
                                    keyColumnValue: keyColumnValue._0,
                                    colNames: colNames._0,
                                    rowData: rowData._0
                                }
                            };
                        }
                        var e = rowData._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".rowData" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = colNames._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".colNames" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = keyColumnValue._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".keyColumnValue" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = keyColumnIndex._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".keyColumnIndex" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = sheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".sheetName" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify$11(param) {
    return "{ keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", cellUpdate: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.rowData, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify))) + "] }")))))))));
}
var UpsertRowParamValue = {
    t_encode: t_encode$17,
    t_decode: t_decode$17,
    stringify: stringify$11
};
function t_encode$18(v) {
    if (v.TAG === /* UpdateCellParamValue */ 0) {
        return [
            "UpdateCellParamValue",
            t_encode$16(v._0)
        ];
    } else {
        return [
            "UpsertRowParamValue",
            t_encode$17(v._0)
        ];
    }
}
function t_decode$18(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "UpdateCellParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$16(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpdateCellParamValue */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "UpsertRowParamValue":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode$17(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UpsertRowParamValue */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$12(v) {
    if (v.TAG === /* UpdateCellParamValue */ 0) {
        return "UpdateCellParamValue(" + (stringify$10(v._0) + ")");
    } else {
        return "UpsertRowParamValue(" + (stringify$11(v._0) + ")");
    }
}
function fromParamDescriptor(param) {
    if (param.TAG === /* UpdateCellParam */ 0) {
        var match = param._0;
        return {
            TAG: /* UpdateCellParamValue */ 0,
            _0: {
                spreadsheetId: match.spreadsheetId,
                sheetName: match.sheetName,
                keyColumnIndex: match.keyColumnIndex,
                keyColumnValue: match.keyColumnValue,
                colNames: match.colNames,
                updatedColIndex: match.updatedColIndex,
                cellUpdate: match.cellUpdate.toValue
            }
        };
    }
    var match$1 = param._0;
    return {
        TAG: /* UpsertRowParamValue */ 1,
        _0: {
            spreadsheetId: match$1.spreadsheetId,
            sheetName: match$1.sheetName,
            keyColumnIndex: match$1.keyColumnIndex,
            keyColumnValue: match$1.keyColumnValue,
            colNames: match$1.colNames,
            rowData: match$1.rowData
        }
    };
}
function toPlaybackCommandValue(param) {
    if (param.TAG === /* UpdateCellParamValue */ 0) {
        var match = param._0;
        return {
            spreadsheetId: match.spreadsheetId,
            sheetName: match.sheetName,
            colNames: match.colNames,
            update: {
                TAG: /* UpdateCell */ 1,
                _0: {
                    rowLocation: {
                        keyColumnIndex: match.keyColumnIndex,
                        keyColumnValue: match.keyColumnValue
                    },
                    updatedColIndex: match.updatedColIndex,
                    cellUpdate: match.cellUpdate
                }
            }
        };
    }
    var match$1 = param._0;
    return {
        spreadsheetId: match$1.spreadsheetId,
        sheetName: match$1.sheetName,
        colNames: match$1.colNames,
        update: {
            TAG: /* UpsertRow */ 0,
            _0: {
                rowLocation: {
                    keyColumnIndex: match$1.keyColumnIndex,
                    keyColumnValue: match$1.keyColumnValue
                },
                cellValues: match$1.rowData
            }
        }
    };
}
var PlaybackParamValue = {
    UpdateCellParamValue: UpdateCellParamValue,
    UpsertRowParamValue: UpsertRowParamValue,
    t_encode: t_encode$18,
    t_decode: t_decode$18,
    stringify: stringify$12,
    fromParamDescriptor: fromParamDescriptor,
    toPlaybackCommandValue: toPlaybackCommandValue
};
exports.A1 = A1;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* @segment/a1-notation Not a pure module */ 


/***/ }),

/***/ 461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_string = __webpack_require__(53739);
var Util$SmartcutsMacros = __webpack_require__(25092);
var KeyLogic$SmartcutsMacros = __webpack_require__(41256);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function humanize(code) {
    if (code >= 47) {
        switch(code){
            case 91:
                return "Left Window";
            case 92:
                return "Right Window";
            case 93:
                return "Select";
            case 112:
                return "f1";
            case 113:
                return "f2";
            case 114:
                return "f3";
            case 115:
                return "f4";
            case 116:
                return "f5";
            case 117:
                return "f6";
            case 118:
                return "f7";
            case 119:
                return "f8";
            case 120:
                return "f9";
            case 121:
                return "f10";
            case 122:
                return "f11";
            case 123:
                return "f12";
            case 94:
            case 95:
            case 96:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 124:
            case 125:
            case 126:
            case 127:
            case 128:
            case 129:
            case 130:
            case 131:
            case 132:
            case 133:
            case 134:
            case 135:
            case 136:
            case 137:
            case 138:
            case 139:
            case 140:
            case 141:
            case 142:
            case 143:
                return String.fromCharCode(code);
            case 144:
                return "Num Lock";
            case 145:
                return "Scroll Lock";
            default:
                return String.fromCharCode(code);
        }
    } else {
        if (code < 8) {
            return String.fromCharCode(code);
        }
        switch(code){
            case 8:
                return "Backspace";
            case 9:
                return "Tab";
            case 13:
                return "Enter";
            case 16:
                return "Shift";
            case 17:
                return "Ctrl";
            case 18:
                return "Alt";
            case 19:
                return "Pause/Break";
            case 20:
                return "Caps Lock";
            case 27:
                return "Esc";
            case 32:
                return "Space";
            case 33:
                return "Page Up";
            case 34:
                return "Page Down";
            case 35:
                return "End";
            case 36:
                return "Home";
            case 37:
                return "\u2190";
            case 38:
                return "\u2191";
            case 39:
                return "\u2192";
            case 40:
                return "\u2193";
            case 10:
            case 11:
            case 12:
            case 14:
            case 15:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 28:
            case 29:
            case 30:
            case 31:
            case 41:
            case 42:
            case 43:
            case 44:
                return String.fromCharCode(code);
            case 45:
                return "Insert";
            case 46:
                return "Delete";
        }
    }
}
var KeyDownKeyCode = {
    humanize: humanize
};
function t_encode(v) {
    switch(v.TAG | 0){
        case /* Alt */ 0:
            return [
                "Alt",
                Decco.stringToJson(v._0)
            ];
        case /* Tab */ 1:
            return [
                "Tab",
                Decco.stringToJson(v._0)
            ];
        case /* Ctrl */ 2:
            return [
                "Ctrl",
                Decco.stringToJson(v._0)
            ];
        case /* Meta */ 3:
            return [
                "Meta",
                Decco.stringToJson(v._0)
            ];
        case /* Shift */ 4:
            return [
                "Shift",
                Decco.stringToJson(v._0)
            ];
        case /* Char */ 5:
            return [
                "Char",
                Decco.stringToJson(v._0)
            ];
        case /* KeyCode */ 6:
            return [
                "KeyCode",
                Decco.intToJson(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Alt":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Alt */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Char":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Char */ 5,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "Ctrl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Ctrl */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "KeyCode":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* KeyCode */ 6,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "Meta":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Meta */ 3,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "Shift":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Shift */ 4,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "Tab":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Tab */ 1,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    switch(v.TAG | 0){
        case /* Alt */ 0:
            return "Alt";
        case /* Tab */ 1:
            return "Tab";
        case /* Ctrl */ 2:
            return "Ctrl";
        case /* Meta */ 3:
            return "Meta";
        case /* Shift */ 4:
            return "Shift";
        case /* Char */ 5:
            return v._0;
        case /* KeyCode */ 6:
            return String(v._0);
    }
}
function humanize$1(v) {
    switch(v.TAG | 0){
        case /* Alt */ 0:
            return "[Alt]";
        case /* Tab */ 1:
            return "[Tab]";
        case /* Ctrl */ 2:
            return "[Ctrl]";
        case /* Meta */ 3:
            return "[\u2318 Cmd]";
        case /* Shift */ 4:
            return "[Shift]";
        case /* Char */ 5:
            return v._0;
        case /* KeyCode */ 6:
            return "[" + (humanize(v._0) + "]");
    }
}
function keyComboComponentFromKeyAndCode(key, code) {
    switch(key){
        case "Alt":
            switch(code){
                case "AltLeft":
                case "AltRight":
                    return {
                        TAG: /* Alt */ 0,
                        _0: code
                    };
                default:
            }
            break;
        case "Control":
            switch(code){
                case "ControlLeft":
                case "ControlRight":
                    return {
                        TAG: /* Ctrl */ 2,
                        _0: code
                    };
                default:
            }
            break;
        case "Meta":
            switch(code){
                case "MetaLeft":
                case "MetaRight":
                    return {
                        TAG: /* Meta */ 3,
                        _0: code
                    };
                default:
            }
            break;
        case "Shift":
            switch(code){
                case "ShiftLeft":
                case "ShiftRight":
                    return {
                        TAG: /* Shift */ 4,
                        _0: code
                    };
                default:
            }
            break;
        case "Tab":
            switch(code){
                case "TabLeft":
                case "TabRight":
                    return {
                        TAG: /* Tab */ 1,
                        _0: code
                    };
                default:
            }
            break;
        default:
    }
    if (!KeyLogic$SmartcutsMacros.reCode.test(code)) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unhandled keyComboComponentFromKeyAndCode(~key, ~code) for (key, code) = (" + (key + (", " + (code + ")"))));
    }
    var $$char = KeyLogic$SmartcutsMacros.getCharFromCode(key, code);
    return {
        TAG: /* Char */ 5,
        _0: $$char
    };
}
function maybeCodeFromKeyComboComponent(v) {
    switch(v.TAG | 0){
        case /* Char */ 5:
        case /* KeyCode */ 6:
            return;
        default:
            return v._0;
    }
}
function isKeyComboComponentAModifier(component) {
    switch(component.TAG | 0){
        case /* Char */ 5:
        case /* KeyCode */ 6:
            return false;
        default:
            return KeyLogic$SmartcutsMacros.isModifierCode(component._0);
    }
}
function isEquivalentComboComponent(key, code, component) {
    switch(component.TAG | 0){
        case /* Alt */ 0:
        case /* Ctrl */ 2:
        case /* Meta */ 3:
            break;
        case /* Char */ 5:
            return component._0 === KeyLogic$SmartcutsMacros.getCharFromCode(key, code);
        default:
            return false;
    }
    switch(code){
        case "AltLeft":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                    return code === component._0;
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return false;
            }
        case "AltRight":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                    return code === component._0;
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return false;
            }
        case "ControlLeft":
            switch(component.TAG | 0){
                case /* Ctrl */ 2:
                    return code === component._0;
                case /* Alt */ 0:
                case /* Meta */ 3:
                    return false;
            }
        case "ControlRight":
            switch(component.TAG | 0){
                case /* Ctrl */ 2:
                    return code === component._0;
                case /* Alt */ 0:
                case /* Meta */ 3:
                    return false;
            }
        case "MetaLeft":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                case /* Ctrl */ 2:
                    return false;
                case /* Meta */ 3:
                    return code === component._0;
            }
        case "MetaRight":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                case /* Ctrl */ 2:
                    return false;
                case /* Meta */ 3:
                    return code === component._0;
            }
        case "ShiftLeft":
            switch(component.TAG | 0){
                case /* Ctrl */ 2:
                    return code === component._0;
                case /* Alt */ 0:
                case /* Meta */ 3:
                    return false;
            }
        case "ShiftRight":
            switch(component.TAG | 0){
                case /* Ctrl */ 2:
                    return code === component._0;
                case /* Alt */ 0:
                case /* Meta */ 3:
                    return false;
            }
        case "TabLeft":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                    return code === component._0;
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return false;
            }
        case "TabRight":
            switch(component.TAG | 0){
                case /* Alt */ 0:
                    return code === component._0;
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return false;
            }
        default:
            return false;
    }
}
var KeyComboComponent = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    humanize: humanize$1,
    keyComboComponentFromKeyAndCode: keyComboComponentFromKeyAndCode,
    maybeCodeFromKeyComboComponent: maybeCodeFromKeyComboComponent,
    isKeyComboComponentAModifier: isKeyComboComponentAModifier,
    isEquivalentComboComponent: isEquivalentComboComponent
};
function t_encode$1(v) {
    return Decco.listToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.listFromJson(t_decode, v);
}
function stringify$1(components) {
    return StringUtils$SmartcutsMacros.join(" + ", List.map(stringify, components));
}
function satisfies(predicate, len, combo) {
    return List.length(Belt_List.keep(combo, predicate)) >= len;
}
function hasAtLeast(keyDomains, combo) {
    var len = keyDomains.length;
    var predicate = function predicate(key) {
        return Belt_Array.some(keyDomains, function(doesKeyMatchDomain) {
            return Curry._1(doesKeyMatchDomain, key);
        });
    };
    return satisfies(predicate, len, combo);
}
function isShiftArrow(keys) {
    return hasAtLeast([
        function(key) {
            switch(key.TAG | 0){
                case /* Shift */ 4:
                    return true;
                case /* KeyCode */ 6:
                    return key._0 === 16;
                default:
                    return false;
            }
        },
        function(key) {
            if (key.TAG === /* KeyCode */ 6) {
                return ListUtils$SmartcutsMacros.member(key._0, KeyLogic$SmartcutsMacros.keyCodesAssocWithCursorMove);
            } else {
                return false;
            }
        }
    ], keys);
}
function isCmdOrCtrlShiftArrow(keys) {
    return hasAtLeast([
        function(key) {
            switch(key.TAG | 0){
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return true;
                default:
                    return false;
            }
        },
        function(key) {
            switch(key.TAG | 0){
                case /* Shift */ 4:
                    return true;
                case /* KeyCode */ 6:
                    return key._0 === 16;
                default:
                    return false;
            }
        },
        function(key) {
            if (key.TAG === /* KeyCode */ 6) {
                return ListUtils$SmartcutsMacros.member(key._0, KeyLogic$SmartcutsMacros.keyCodesAssocWithCursorMove);
            } else {
                return false;
            }
        }
    ], keys);
}
function isCmdOrCtrlPlusChar(char_, keys) {
    return hasAtLeast([
        function(key) {
            switch(key.TAG | 0){
                case /* Ctrl */ 2:
                case /* Meta */ 3:
                    return true;
                default:
                    return false;
            }
        },
        function(key) {
            if (key.TAG === /* Char */ 5) {
                return Caml_string.get(key._0, 0) === char_;
            } else {
                return false;
            }
        }
    ], keys);
}
function isCmdOrCtrlA(keys) {
    return isCmdOrCtrlPlusChar(/* 'a' */ 97, keys);
}
function isCmdOrCtrlV(keys) {
    return isCmdOrCtrlPlusChar(/* 'v' */ 118, keys);
}
function isCmdOrCtrlC(keys) {
    return isCmdOrCtrlPlusChar(/* 'c' */ 99, keys);
}
function isCmdOrCtrlX(keys) {
    return isCmdOrCtrlPlusChar(/* 'x' */ 120, keys);
}
function isShiftEnter(keys) {
    return hasAtLeast([
        function(key) {
            switch(key.TAG | 0){
                case /* Shift */ 4:
                    return true;
                case /* KeyCode */ 6:
                    return key._0 === 16;
                default:
                    return false;
            }
        },
        function(key) {
            switch(key.TAG | 0){
                case /* Char */ 5:
                    switch(key._0){
                        case "Enter":
                        case "NumpadEnter":
                            return true;
                        default:
                            return false;
                    }
                case /* KeyCode */ 6:
                    return key._0 === 13;
                default:
                    return false;
            }
        }
    ], keys);
}
function areKeyComboComponentsOnlyModifierComponents(components) {
    return Belt_List.every(components, isKeyComboComponentAModifier);
}
function doKeyComboComponentsAlreadyContainKey(key, code, components) {
    return List.exists(function(param) {
        return isEquivalentComboComponent(key, code, param);
    }, components);
}
function resetKeyComboComponentsIfDuplicateKeyDown(key, code, components) {
    var maybeIndex = ListUtils$SmartcutsMacros.findIndex(function(param) {
        return isEquivalentComboComponent(key, code, param);
    }, components);
    if (maybeIndex !== undefined) {
        return {
            hd: keyComboComponentFromKeyAndCode(key, code),
            tl: /* [] */ 0
        };
    } else {
        return components;
    }
}
function order(components) {
    return Belt_List.reduce(components, [
        [],
        {
            altKey: false,
            ctrlKey: false,
            metaKey: false,
            shiftKey: false
        }
    ], function(param, component) {
        var cumulativeModifiers = param[1];
        var newCumulativeModifiers;
        switch(component.TAG | 0){
            case /* Alt */ 0:
                newCumulativeModifiers = {
                    altKey: true,
                    ctrlKey: cumulativeModifiers.ctrlKey,
                    metaKey: cumulativeModifiers.metaKey,
                    shiftKey: cumulativeModifiers.shiftKey
                };
                break;
            case /* Ctrl */ 2:
                newCumulativeModifiers = {
                    altKey: cumulativeModifiers.altKey,
                    ctrlKey: true,
                    metaKey: cumulativeModifiers.metaKey,
                    shiftKey: cumulativeModifiers.shiftKey
                };
                break;
            case /* Meta */ 3:
                newCumulativeModifiers = {
                    altKey: cumulativeModifiers.altKey,
                    ctrlKey: cumulativeModifiers.ctrlKey,
                    metaKey: true,
                    shiftKey: cumulativeModifiers.shiftKey
                };
                break;
            case /* Shift */ 4:
                newCumulativeModifiers = {
                    altKey: cumulativeModifiers.altKey,
                    ctrlKey: cumulativeModifiers.ctrlKey,
                    metaKey: cumulativeModifiers.metaKey,
                    shiftKey: true
                };
                break;
            default:
                newCumulativeModifiers = cumulativeModifiers;
        }
        return [
            $$Array.append(param[0], [
                [
                    component,
                    newCumulativeModifiers
                ]
            ]),
            newCumulativeModifiers
        ];
    })[0];
}
var CommandValue = {
    KeyDownKeyCode: KeyDownKeyCode,
    KeyComboComponent: KeyComboComponent,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    satisfies: satisfies,
    hasAtLeast: hasAtLeast,
    isShiftArrow: isShiftArrow,
    isCmdOrCtrlShiftArrow: isCmdOrCtrlShiftArrow,
    isCmdOrCtrlPlusChar: isCmdOrCtrlPlusChar,
    isCmdOrCtrlA: isCmdOrCtrlA,
    isCmdOrCtrlV: isCmdOrCtrlV,
    isCmdOrCtrlC: isCmdOrCtrlC,
    isCmdOrCtrlX: isCmdOrCtrlX,
    isShiftEnter: isShiftEnter,
    areKeyComboComponentsOnlyModifierComponents: areKeyComboComponentsOnlyModifierComponents,
    doKeyComboComponentsAlreadyContainKey: doKeyComboComponentsAlreadyContainKey,
    resetKeyComboComponentsIfDuplicateKeyDown: resetKeyComboComponentsIfDuplicateKeyDown,
    order: order
};
exports.CommandValue = CommandValue; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 74935:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var ModifierKeys$SmartcutsMacros = __webpack_require__(94429);
function t_encode(v) {
    switch(v.TAG | 0){
        case /* Char */ 0:
            return [
                "Char",
                Decco.stringToJson(v._0)
            ];
        case /* RawKeyDown */ 1:
            return [
                "RawKeyDown",
                Decco.intToJson(v._0)
            ];
        case /* RawKeyUp */ 2:
            return [
                "RawKeyUp",
                Decco.intToJson(v._0)
            ];
        case /* KeyDown */ 3:
            return [
                "KeyDown",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                ModifierKeys$SmartcutsMacros.t_encode(v._2)
            ];
        case /* KeyUp */ 4:
            return [
                "KeyUp",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                ModifierKeys$SmartcutsMacros.t_encode(v._2)
            ];
        case /* RawKeypress */ 5:
            return [
                "RawKeypress",
                Decco.intToJson(v._0)
            ];
        case /* Keypress */ 6:
            return [
                "Keypress",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                ModifierKeys$SmartcutsMacros.t_encode(v._2)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Char":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Char */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "KeyDown":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = ModifierKeys$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* KeyDown */ 3,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "KeyUp":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$6 = ModifierKeys$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$4.TAG === /* Ok */ 0) {
                    if (match$5.TAG === /* Ok */ 0) {
                        if (match$6.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* KeyUp */ 4,
                                    _0: match$4._0,
                                    _1: match$5._0,
                                    _2: match$6._0
                                }
                            };
                        }
                        var e$4 = match$6._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$5._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "Keypress":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$9 = ModifierKeys$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$7.TAG === /* Ok */ 0) {
                    if (match$8.TAG === /* Ok */ 0) {
                        if (match$9.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* Keypress */ 6,
                                    _0: match$7._0,
                                    _1: match$8._0,
                                    _2: match$9._0
                                }
                            };
                        }
                        var e$7 = match$9._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$7.path,
                                message: e$7.message,
                                value: e$7.value
                            }
                        };
                    }
                    var e$8 = match$8._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$8.path,
                            message: e$8.message,
                            value: e$8.value
                        }
                    };
                }
                var e$9 = match$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "RawKeyDown":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RawKeyDown */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$10 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "RawKeyUp":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RawKeyUp */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$11 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "RawKeypress":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* RawKeypress */ 5,
                            _0: v0$3._0
                        }
                    };
                }
                var e$12 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(keyEvent) {
    switch(keyEvent.TAG | 0){
        case /* Char */ 0:
            var text = keyEvent._0;
            if (text === "\r") {
                return "Char(Enter)";
            } else {
                return "Char(" + text + ")";
            }
        case /* RawKeyDown */ 1:
            return "RawKeyDown(" + keyEvent._0 + ")";
        case /* RawKeyUp */ 2:
            return "RawKeyUp|(" + keyEvent._0 + ")";
        case /* KeyDown */ 3:
            return "KeyDown(" + keyEvent._0 + ", " + keyEvent._1 + ", " + (JSON.stringify(keyEvent._2) + ")");
        case /* KeyUp */ 4:
            return "KeyUp(" + keyEvent._0 + ", " + keyEvent._1 + ", " + (JSON.stringify(keyEvent._2) + ")");
        case /* RawKeypress */ 5:
            return "RawKeypress|(" + keyEvent._0 + ")";
        case /* Keypress */ 6:
            return "Keypress(" + keyEvent._0 + ", " + keyEvent._1 + ", " + JSON.stringify(keyEvent._2);
    }
}
function typeString(v) {
    switch(v.TAG | 0){
        case /* Char */ 0:
            return "char";
        case /* RawKeyDown */ 1:
        case /* KeyDown */ 3:
            return "keydown";
        case /* RawKeyUp */ 2:
        case /* KeyUp */ 4:
            return "keyup";
        case /* RawKeypress */ 5:
        case /* Keypress */ 6:
            return "keypress";
    }
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    typeString: typeString
};
exports.CommandValue = CommandValue; /* ModifierKeys-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 67259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var SmartcutIds$SmartcutsMacros = __webpack_require__(62145);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var MultiUrlTriggering__Types$SmartcutsMacros = __webpack_require__(12433);
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = __webpack_require__(28538);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "paginateFn",
            MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode(v.paginateFn)
        ],
        [
            "pageUntil",
            MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode(v.pageUntil)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var paginateFn = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateFn"), null));
    if (paginateFn.TAG === /* Ok */ 0) {
        var pageUntil = MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageUntil"), null));
        if (pageUntil.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    paginateFn: paginateFn._0,
                    pageUntil: pageUntil._0
                }
            };
        }
        var e = pageUntil._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".pageUntil" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = paginateFn._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".paginateFn" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorGet(param) {
    return MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.selectorGet(param.paginateFn);
}
function mapSelector(f, paginate) {
    var func = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.mapSelector;
    return {
        paginateFn: Curry._2(func, f, paginate.paginateFn),
        pageUntil: paginate.pageUntil
    };
}
function stringify(param) {
    return "{ paginateFn: " + (MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.stringify(param.paginateFn) + (", pageUntil: " + (MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil(param.pageUntil) + " }")));
}
var Paginate = {
    t_encode: t_encode,
    t_decode: t_decode,
    selectorGet: selectorGet,
    mapSelector: mapSelector,
    stringify: stringify
};
function topologyAlgoResult_encode(v) {
    return [
        "TopologyAlgoResultV1",
        Decco.arrayToJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v._0)
    ];
}
function topologyAlgoResult_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TopologyAlgoResultV1") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.arrayFromJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* TopologyAlgoResultV1 */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ],
        [
            "smartcutName",
            Decco.stringToJson(v.smartcutName)
        ],
        [
            "paginate",
            Decco.optionToJson(t_encode, v.paginate)
        ],
        [
            "topologyResult",
            topologyAlgoResult_encode(v.topologyResult)
        ],
        [
            "smartcutUrlPattern",
            Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.smartcutUrlPattern)
        ],
        [
            "maybeRedirectedFromUrlPatterns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
            }, v.maybeRedirectedFromUrlPatterns)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
        if (smartcutId.TAG === /* Ok */ 0) {
            var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
            if (smartcutName.TAG === /* Ok */ 0) {
                var paginate = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginate"), null));
                if (paginate.TAG === /* Ok */ 0) {
                    var topologyResult = topologyAlgoResult_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "topologyResult"), null));
                    if (topologyResult.TAG === /* Ok */ 0) {
                        var smartcutUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutUrlPattern"), null));
                        if (smartcutUrlPattern.TAG === /* Ok */ 0) {
                            var maybeRedirectedFromUrlPatterns = Decco.optionFromJson(function(param) {
                                return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
                            if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */ 0) {
                                return {
                                    TAG: /* Ok */ 0,
                                    _0: {
                                        url: url._0,
                                        smartcutId: smartcutId._0,
                                        smartcutName: smartcutName._0,
                                        paginate: paginate._0,
                                        topologyResult: topologyResult._0,
                                        smartcutUrlPattern: smartcutUrlPattern._0,
                                        maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0
                                    }
                                };
                            }
                            var e = maybeRedirectedFromUrlPatterns._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".maybeRedirectedFromUrlPatterns" + e.path,
                                    message: e.message,
                                    value: e.value
                                }
                            };
                        }
                        var e$1 = smartcutUrlPattern._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".smartcutUrlPattern" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = topologyResult._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".topologyResult" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = paginate._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".paginate" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            }
            var e$4 = smartcutName._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".smartcutName" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                }
            };
        }
        var e$5 = smartcutId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".smartcutId" + e$5.path,
                message: e$5.message,
                value: e$5.value
            }
        };
    }
    var e$6 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$6.path,
            message: e$6.message,
            value: e$6.value
        }
    };
}
function stringify$1(param) {
    return "{ url: " + (param.url + (", smartcutId: " + (param.smartcutId + (", smartcutName: " + (param.smartcutName + (", paginate: " + (OptionUtils$SmartcutsMacros.stringify(stringify, param.paginate) + " }")))))));
}
function smartcutIdGet(param) {
    return param.smartcutId;
}
function selectorGet$1(param) {
    return OptionUtils$SmartcutsMacros.toArray(Belt_Option.flatMap(param.paginate, selectorGet));
}
function mapSelector$1(f, commandValue) {
    return {
        url: commandValue.url,
        smartcutId: commandValue.smartcutId,
        smartcutName: commandValue.smartcutName,
        paginate: Belt_Option.map(commandValue.paginate, function(param) {
            return mapSelector(f, param);
        }),
        topologyResult: commandValue.topologyResult,
        smartcutUrlPattern: commandValue.smartcutUrlPattern,
        maybeRedirectedFromUrlPatterns: commandValue.maybeRedirectedFromUrlPatterns
    };
}
function getIdentifier(param) {
    return "Loop(" + param.smartcutId + ")(" + param.url + ")";
}
var CommandValue = {
    Paginate: Paginate,
    topologyAlgoResult_encode: topologyAlgoResult_encode,
    topologyAlgoResult_decode: topologyAlgoResult_decode,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    smartcutIdGet: smartcutIdGet,
    selectorGet: selectorGet$1,
    mapSelector: mapSelector$1,
    getIdentifier: getIdentifier
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "originalUrl",
            Decco.stringToJson(v.originalUrl)
        ],
        [
            "paginate",
            Decco.optionToJson(t_encode, v.paginate)
        ],
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
    if (originalUrl.TAG === /* Ok */ 0) {
        var paginate = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginate"), null));
        if (paginate.TAG === /* Ok */ 0) {
            var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
            if (smartcutId.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        originalUrl: originalUrl._0,
                        paginate: paginate._0,
                        smartcutId: smartcutId._0
                    }
                };
            }
            var e = smartcutId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".smartcutId" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = paginate._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".paginate" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = originalUrl._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalUrl" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(param) {
    return "{ originalUrl: " + (param.originalUrl + (", smartcutId: " + (param.smartcutId + " }")));
}
function updateConfigWithPlaybackFormLabel(param, config) {
    return config;
}
function isDynamic(param) {
    return true;
}
function fromCommandValue(param) {
    return {
        originalUrl: param.url,
        paginate: param.paginate,
        smartcutId: param.smartcutId
    };
}
var AuthoringConfig = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
    isDynamic: isDynamic,
    fromCommandValue: fromCommandValue
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "originalUrl",
            Decco.stringToJson(v.originalUrl)
        ],
        [
            "maybePageUntil",
            Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode, v.maybePageUntil)
        ],
        [
            "urlPattern",
            UrlConstraint$SmartcutsMacros.UrlPattern.t_encode(v.urlPattern)
        ],
        [
            "smartcutId",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
    if (originalUrl.TAG === /* Ok */ 0) {
        var maybePageUntil = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePageUntil"), null));
        if (maybePageUntil.TAG === /* Ok */ 0) {
            var urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPattern"), null));
            if (urlPattern.TAG === /* Ok */ 0) {
                var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
                if (smartcutId.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            originalUrl: originalUrl._0,
                            maybePageUntil: maybePageUntil._0,
                            urlPattern: urlPattern._0,
                            smartcutId: smartcutId._0
                        }
                    };
                }
                var e = smartcutId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".smartcutId" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = urlPattern._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".urlPattern" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = maybePageUntil._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybePageUntil" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = originalUrl._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalUrl" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify$3(param) {
    return "{ originalUrl: " + (StringUtils$SmartcutsMacros.quote(param.originalUrl) + (", maybePageUntil: " + (OptionUtils$SmartcutsMacros.stringify(MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil, param.maybePageUntil) + (", smartcutId: " + param.smartcutId))));
}
function fromAuthoringConfig(param1) {
    var originalUrl = param1.originalUrl;
    var url = URLUtils$SmartcutsMacros.$$URL.fromString(originalUrl);
    var urlPattern;
    if (url !== undefined) {
        urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.fromUrl(url);
    } else {
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
            _1: originalUrl,
            Error: new Error()
        };
    }
    return {
        originalUrl: originalUrl,
        maybePageUntil: Belt_Option.map(param1.paginate, function(param) {
            return param.pageUntil;
        }),
        urlPattern: urlPattern,
        smartcutId: param1.smartcutId
    };
}
var ParamDescriptor = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$3,
    fromAuthoringConfig: fromAuthoringConfig
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "maybePageUntil",
            Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode, v.maybePageUntil)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var maybePageUntil = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "maybePageUntil"), null));
    if (maybePageUntil.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                maybePageUntil: maybePageUntil._0
            }
        };
    }
    var e = maybePageUntil._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".maybePageUntil" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function stringify$4(param) {
    return "{ maybePageUntil: " + (OptionUtils$SmartcutsMacros.stringify(MultiUrlTriggering__Types$SmartcutsMacros.stringifyPageUntil, param.maybePageUntil) + " }");
}
function fromParamDescriptor(param) {
    return {
        maybePageUntil: param.maybePageUntil
    };
}
function toPlaybackCommandValue(oldCommandValue, param) {
    var maybePageUntil = param.maybePageUntil;
    var match = oldCommandValue.paginate;
    return {
        url: oldCommandValue.url,
        smartcutId: oldCommandValue.smartcutId,
        smartcutName: oldCommandValue.smartcutName,
        paginate: match !== undefined && maybePageUntil !== undefined ? {
            paginateFn: match.paginateFn,
            pageUntil: maybePageUntil
        } : undefined,
        topologyResult: oldCommandValue.topologyResult,
        smartcutUrlPattern: oldCommandValue.smartcutUrlPattern,
        maybeRedirectedFromUrlPatterns: oldCommandValue.maybeRedirectedFromUrlPatterns
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$4,
    fromParamDescriptor: fromParamDescriptor,
    toPlaybackCommandValue: toPlaybackCommandValue
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* URLUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 45156:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var SelectorWithSemantic$SmartcutsMacros = __webpack_require__(80424);
var Selection__ContentEditableCursor$SmartcutsMacros = __webpack_require__(43378);
var ContentEditableCursorWithSemantics$SmartcutsMacros = __webpack_require__(68998);
var SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros = __webpack_require__(21014);
function t_encode(v) {
    return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v);
}
function t_decode(v) {
    return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(v);
}
function stringify(param) {
    return "cursor";
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
var t_encode$1 = ContentEditableCursorWithSemantics$SmartcutsMacros.t_encode;
var t_decode$1 = ContentEditableCursorWithSemantics$SmartcutsMacros.t_decode;
function fromRecordingCommandValue(contentEditableCursor) {
    return {
        contentEditableCursor: contentEditableCursor,
        semantics: SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.ofContentEditableCursor(contentEditableCursor)
    };
}
var updateSelector = ContentEditableCursorWithSemantics$SmartcutsMacros.updateSelector;
function stringify$1(param) {
    return "{cursor, semantics: [" + (SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.stringify(param.semantics) + "]}");
}
function getInputIdentifier(commandIndex, param) {
    return String(param.contentEditableCursor.domElementRepresentation.domElementIdentifier) + ("_" + String(commandIndex));
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector,
    stringify: stringify$1,
    getInputIdentifier: getInputIdentifier
};
function t_encode$2(v) {
    return SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_encode, v);
}
function t_decode$2(v) {
    return SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.t_decode, v);
}
function stringify$2(param) {
    return SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param);
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function fromAuthoringCommandValue(param) {
    return {
        selector: param.contentEditableCursor.contentEditableHost.selector,
        semantic: Caml_array.get(param.semantics, 0)
    };
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    selectorGet: selectorGet,
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function isDynamic(param) {
    return false;
}
function fromAuthoringCommandValue$1(param) {
    var semantics = param.semantics;
    return {
        contentEditableCursor: param.contentEditableCursor,
        semantics: semantics,
        config: Belt_Array.getExn(semantics, 0)
    };
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
    var semantic = maybeConfig !== undefined ? maybeConfig.config : Belt_Array.getExn(commandValue.semantics, 0);
    return {
        selector: commandValue.contentEditableCursor.domElementRepresentation.selector,
        semantic: semantic
    };
}
function isForAuthoringCommandValue(param, config) {
    return Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isEqual(config.contentEditableCursor, param.contentEditableCursor);
}
var AuthoringConfig = {
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
    isForAuthoringCommandValue: isForAuthoringCommandValue
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* SelectorWithSemantic-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 10806:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var SelectorWithSemantic$SmartcutsMacros = __webpack_require__(80424);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
var InputCursorWithSemantics$SmartcutsMacros = __webpack_require__(53022);
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = __webpack_require__(65768);
var DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros = __webpack_require__(95016);
var t_encode = DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_encode;
var t_decode = DomElementIdentifierPaired__WithInputCursor$SmartcutsMacros.t_decode;
function stringify(param) {
    return "cursor";
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
var t_encode$1 = InputCursorWithSemantics$SmartcutsMacros.t_encode;
var t_decode$1 = InputCursorWithSemantics$SmartcutsMacros.t_decode;
function fromRecordingCommandValue(param) {
    var inputCursor = param.inputCursor;
    var semantics = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.ofInputCursor(inputCursor);
    return {
        inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.fromRecording(inputCursor),
        semantics: semantics
    };
}
function getInputIdentifier(commandIndex, param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.inputCursor.domElementRepresentation) + String(commandIndex);
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: InputCursorWithSemantics$SmartcutsMacros.updateSelector,
    stringify: InputCursorWithSemantics$SmartcutsMacros.stringify,
    getInputIdentifier: getInputIdentifier
};
function t_encode$2(v) {
    return SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_encode, v);
}
function t_decode$2(v) {
    return SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_decode, v);
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function stringify$1(param) {
    return SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param);
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    selectorGet: selectorGet,
    stringify: stringify$1
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function isDynamic(param) {
    return false;
}
function fromAuthoringCommandValue(param) {
    var semantics = param.semantics;
    return {
        inputCursor: param.inputCursor,
        semantics: semantics,
        config: Belt_Array.getExn(semantics, 0)
    };
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
    var semantic = maybeConfig !== undefined ? maybeConfig.config : Belt_Array.getExn(commandValue.semantics, 0);
    return {
        selector: commandValue.inputCursor.domElementRepresentation,
        semantic: semantic
    };
}
function isForAuthoringCommandValue(param, config) {
    return Caml_obj.caml_equal(config.inputCursor, param.inputCursor);
}
var AuthoringConfig = {
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
    isForAuthoringCommandValue: isForAuthoringCommandValue
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 5864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var PlaybackBridge__OS$SmartcutsMacros = __webpack_require__(14724);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ],
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "focusStatus",
            CommandContext$SmartcutsMacros.focusStatus_encode(v.focusStatus)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
    if (tabRef.TAG === /* Ok */ 0) {
        var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
        if (windowRef.TAG === /* Ok */ 0) {
            var focusStatus = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
            if (focusStatus.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        tabRef: tabRef._0,
                        windowRef: windowRef._0,
                        focusStatus: focusStatus._0
                    }
                };
            }
            var e = focusStatus._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".focusStatus" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = windowRef._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".windowRef" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = tabRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabRef" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{tabRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(param.tabRef) + (", windowRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + ("', focusState: " + (CommandContext$SmartcutsMacros.stringifyFocusStatus(param.focusStatus) + "}")))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function execute(param1, param$11, playbackBridgeOs, param$2) {
    var windowRef = param$2.windowRef;
    var arg = param$2.focusStatus === /* Focused */ 0;
    var arg$1 = function arg$1(param, param$1) {
        return Curry._4(PlaybackBridge__OS$SmartcutsMacros.createTab, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.getPlaybackWindowIdExn(windowRef)), param, param$1, arg);
    };
    return Curry._4(arg$1(undefined, undefined), undefined, undefined, undefined, playbackBridgeOs).then(function(param) {
        return Promise.resolve([
            Browser__Tabs$SmartcutsMacros.Tab.fromJs(param[0]),
            param[1]
        ]);
    });
}
var CommandControlBg = {
    execute: execute
};
exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg; /* Browser__Tabs-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 83228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var PlaybackBridge__OS$SmartcutsMacros = __webpack_require__(14724);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ],
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "focusStatus",
            CommandContext$SmartcutsMacros.focusStatus_encode(v.focusStatus)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
            if (tabRef.TAG === /* Ok */ 0) {
                var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
                if (windowRef.TAG === /* Ok */ 0) {
                    var focusStatus = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
                    if (focusStatus.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                url: url._0,
                                title: title._0,
                                tabRef: tabRef._0,
                                windowRef: windowRef._0,
                                focusStatus: focusStatus._0
                            }
                        };
                    }
                    var e = focusStatus._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".focusStatus" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = windowRef._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".windowRef" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = tabRef._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".tabRef" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify(param) {
    return "{url: '" + (param.url + ("', tabRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(param.tabRef) + (", windowRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + ("', focusStatus: " + (CommandContext$SmartcutsMacros.stringifyFocusStatus(param.focusStatus) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "}")))))))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function execute(param1, param$1, playbackBridgeOs, param$2) {
    var windowRef = param$2.windowRef;
    var arg = param$2.url;
    var arg$1 = param$2.focusStatus === /* Focused */ 0;
    var arg$2 = function arg$2(param) {
        return Curry._4(PlaybackBridge__OS$SmartcutsMacros.createTab, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.getPlaybackWindowIdExn(windowRef)), param, arg, arg$1);
    };
    return Curry._4(arg$2(undefined), undefined, undefined, undefined, playbackBridgeOs).then(function(param) {
        return Promise.resolve([
            Browser__Tabs$SmartcutsMacros.Tab.fromJs(param[0]),
            param[1]
        ]);
    });
}
var CommandControlBg = {
    execute: execute
};
function fromAuthoringCommandValue(param) {
    var url = param.url;
    return {
        originalUrl: url,
        urlCommandType: {
            TAG: /* NewTabWithUrlCommand */ 1,
            _0: param.tabRef,
            _1: param.windowRef,
            _2: param.focusStatus
        },
        urlConfig: UrlConstraint$SmartcutsMacros.flexibleMatchFromUrlString(url)
    };
}
var AuthoringConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg;
exports.AuthoringConfig = AuthoringConfig; /* Browser__Tabs-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 90834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var Browser__Windows$SmartcutsMacros = __webpack_require__(49325);
var PlaybackBridge__OS$SmartcutsMacros = __webpack_require__(14724);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "focusStatus",
            CommandContext$SmartcutsMacros.focusStatus_encode(v.focusStatus)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
    if (windowRef.TAG === /* Ok */ 0) {
        var focusStatus = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
        if (focusStatus.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    windowRef: windowRef._0,
                    focusStatus: focusStatus._0
                }
            };
        }
        var e = focusStatus._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".focusStatus" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = windowRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowRef" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{windowRef: '" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + ("', focusStatus: " + (CommandContext$SmartcutsMacros.stringifyFocusStatus(param.focusStatus) + "}")));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function execute(playbackOptions, contextGlobal, playbackBridgeOs, param1) {
    var focused = playbackOptions.doNotFocus ? false : param1.focusStatus === /* Focused */ 0;
    var match = contextGlobal.windowGeometry;
    var arg = match.width;
    var arg$1 = match.height;
    var arg$2 = focused;
    var arg$3 = function arg$3(param, param$1, param$2, param$3) {
        return Curry.app(PlaybackBridge__OS$SmartcutsMacros.createWindowWithNoUrl, [
            param,
            param$1,
            param$2,
            arg,
            arg$1,
            arg$2,
            param$3,
            "normal",
            "normal"
        ]);
    };
    return Curry._2(arg$3(undefined, undefined, undefined, undefined), undefined, playbackBridgeOs).then(function(param) {
        var nextPlaybackBridgeOs = param[1];
        var $$window = param[0];
        return PromiseUtils$SmartcutsMacros.resolveWith(function(onlyTab) {
            return [
                $$window,
                onlyTab,
                nextPlaybackBridgeOs
            ];
        }, Browser__Windows$SmartcutsMacros.Helpers.getOnlyTabOfWindow($$window));
    });
}
var CommandControlBg = {
    execute: execute
};
exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg; /* PromiseUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 23374:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var Browser__Windows$SmartcutsMacros = __webpack_require__(49325);
var PlaybackBridge__OS$SmartcutsMacros = __webpack_require__(14724);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "focusStatus",
            CommandContext$SmartcutsMacros.focusStatus_encode(v.focusStatus)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            var focusStatus = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusStatus"), null));
            if (focusStatus.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        url: url._0,
                        title: title._0,
                        focusStatus: focusStatus._0
                    }
                };
            }
            var e = focusStatus._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".focusStatus" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{url: '" + (param.url + ("', focusStatus: " + (CommandContext$SmartcutsMacros.stringifyFocusStatus(param.focusStatus) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "}")))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function execute(playbackOptions, contextGlobal, playbackBridgeOs, param1) {
    var url = param1.url;
    var focused = playbackOptions.doNotFocus ? false : param1.focusStatus === /* Focused */ 0;
    var match = contextGlobal.windowGeometry;
    var arg = match.width;
    var arg$1 = match.height;
    var arg$2 = focused;
    var arg$3 = function arg$3(param, param$1, param$2, param$3) {
        var partial_arg = "normal";
        var partial_arg$1 = "normal";
        return function(param$4, param$5) {
            return PlaybackBridge__OS$SmartcutsMacros.createWindowWithUrl(url, param, param$1, param$2, arg, arg$1, arg$2, param$3, partial_arg$1, partial_arg, param$4, param$5);
        };
    };
    return arg$3(undefined, undefined, undefined, undefined)(undefined, playbackBridgeOs).then(function(param) {
        var nextPlaybackBridgeOs = param[1];
        var $$window = param[0];
        return PromiseUtils$SmartcutsMacros.resolveWith(function(onlyTab) {
            return [
                $$window,
                onlyTab,
                url,
                nextPlaybackBridgeOs
            ];
        }, Browser__Windows$SmartcutsMacros.Helpers.getOnlyTabOfWindow($$window));
    });
}
var CommandControlBg = {
    execute: execute
};
function fromAuthoringCommandValue(param) {
    var url = param.url;
    return {
        originalUrl: url,
        urlCommandType: {
            TAG: /* NewWindowWithUrlCommand */ 0,
            _0: param.focusStatus
        },
        urlConfig: UrlConstraint$SmartcutsMacros.flexibleMatchFromUrlString(url)
    };
}
var AuthoringConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg;
exports.AuthoringConfig = AuthoringConfig; /* PromiseUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 28769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ],
        [
            "windowRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v.windowRef)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "maybeOpenerTab",
            Decco.optionToJson(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, v.maybeOpenerTab)
        ],
        [
            "viaHistoryApi",
            Decco.boolToJson(v.viaHistoryApi)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
    if (tabRef.TAG === /* Ok */ 0) {
        var windowRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowRef"), null));
        if (windowRef.TAG === /* Ok */ 0) {
            var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                if (title.TAG === /* Ok */ 0) {
                    var maybeOpenerTab = Decco.optionFromJson(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeOpenerTab"), null));
                    if (maybeOpenerTab.TAG === /* Ok */ 0) {
                        var viaHistoryApi = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viaHistoryApi"), null));
                        if (viaHistoryApi.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    tabRef: tabRef._0,
                                    windowRef: windowRef._0,
                                    url: url._0,
                                    title: title._0,
                                    maybeOpenerTab: maybeOpenerTab._0,
                                    viaHistoryApi: viaHistoryApi._0
                                }
                            };
                        }
                        var e = viaHistoryApi._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".viaHistoryApi" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = maybeOpenerTab._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".maybeOpenerTab" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = title._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".title" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = windowRef._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".windowRef" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = tabRef._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabRef" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
function stringify(param) {
    var maybeOpenerTab = param.maybeOpenerTab;
    return "{tabRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(param.tabRef) + (", windowRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.stringify(param.windowRef) + (", url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + (", openerTab: " + ((maybeOpenerTab !== undefined ? InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(maybeOpenerTab) : "undefined") + (", viaHistoryApi: " + (Pervasives.string_of_bool(param.viaHistoryApi) + "')")))))))))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 9448:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Password$SmartcutsMacros = __webpack_require__(71191);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function usernamePassword_encode(v) {
    return Js_dict.fromArray([
        [
            "username",
            Decco.stringToJson(v.username)
        ],
        [
            "password",
            Password$SmartcutsMacros.t_encode(v.password)
        ]
    ]);
}
function usernamePassword_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var username = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
    if (username.TAG === /* Ok */ 0) {
        var password = Password$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
        if (password.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    username: username._0,
                    password: password._0
                }
            };
        }
        var e = password._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".password" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = username._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".username" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode(v) {
    if (typeof v === "number") {
        return [
            "NotSelected"
        ];
    } else if (v.TAG === /* NotResolved */ 0) {
        return [
            "NotResolved",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Resolved",
            usernamePassword_encode(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NotResolved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NotResolved */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NotSelected":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotSelected */ 0
                    };
                }
            case "Resolved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = usernamePassword_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Resolved */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(t) {
    if (typeof t === "number") {
        return "NotSelected";
    } else if (t.TAG === /* NotResolved */ 0) {
        return "NotResolved(" + (t._0 + ")");
    } else {
        return "Resolved(" + (t._0.username + ")");
    }
}
var PasswordForPlayback = {
    usernamePassword_encode: usernamePassword_encode,
    usernamePassword_decode: usernamePassword_decode,
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function eventSrc_encode(v) {
    if (v) {
        return [
            "Pasting"
        ];
    } else {
        return [
            "Typing"
        ];
    }
}
function eventSrc_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Pasting":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Pasting */ 1
                    };
                }
            case "Typing":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Typing */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "password",
            Password$SmartcutsMacros.t_encode(v.password)
        ],
        [
            "eventSrc",
            eventSrc_encode(v.eventSrc)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var password = Password$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
        if (password.TAG === /* Ok */ 0) {
            var eventSrc = eventSrc_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eventSrc"), null));
            if (eventSrc.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                        password: password._0,
                        eventSrc: eventSrc._0
                    }
                };
            }
            var e = eventSrc._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".eventSrc" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = password._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".password" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return "{ domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", eventSrc:" + ((param.eventSrc ? "Pasting" : "Typing") + (", password: " + (Password$SmartcutsMacros.obfuscate(param.password) + " }")))));
}
var Recording = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    eventSrc_encode: eventSrc_encode,
    eventSrc_decode: eventSrc_decode,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "password",
            t_encode(v.password)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var password = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "password"), null));
        if (password.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                    password: password._0
                }
            };
        }
        var e = password._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".password" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$2(param) {
    return "{ domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", password: " + (stringify(param.password) + " }")));
}
function updateSelector(f, cmdVal) {
    var domElementIdentifierWithSelector = cmdVal.domElementIdentifierWithSelector;
    return {
        domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifierWithSelector.domElementIdentifier,
            selector: Curry._1(f, domElementIdentifierWithSelector.selector)
        },
        password: cmdVal.password
    };
}
function fromRecording(param) {
    return {
        domElementIdentifierWithSelector: param.domElementIdentifierWithSelector,
        password: /* NotSelected */ 0
    };
}
var Authoring = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    updateSelector: updateSelector,
    fromRecording: fromRecording
};
var t_encode$3 = t_encode$2;
var t_decode$3 = t_decode$2;
function selectorGet(param) {
    return [
        param.domElementIdentifierWithSelector.selector
    ];
}
var stringify$3 = stringify$2;
var Playback = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    selectorGet: selectorGet,
    stringify: stringify$3
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.PasswordForPlayback = PasswordForPlayback;
exports.CommandValue = CommandValue; /* DomElementIdentifierPaired__WithSelector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 93978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var Webapi__FileReader$SmartcutsMacros = __webpack_require__(94534);
var PasteInContentEditableCommand$SmartcutsMacros = __webpack_require__(74512);
var Webapi__SecureContext__SubtleCrypto$SmartcutsMacros = __webpack_require__(3976);
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = __webpack_require__(92190);
var SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros = __webpack_require__(82156);
function notResolved_encode(v) {
    return Js_dict.fromArray([
        [
            "hash",
            Decco.stringToJson(v.hash)
        ],
        [
            "size",
            Decco.floatToJson(v.size)
        ]
    ]);
}
function notResolved_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var hash = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
    if (hash.TAG === /* Ok */ 0) {
        var size = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
        if (size.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    hash: hash._0,
                    size: size._0
                }
            };
        }
        var e = size._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".size" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = hash._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".hash" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function image_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ImageFromCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ImageFromCommand */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NotResolved":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = notResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NotResolved */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function image_encode(v) {
    if (v.TAG === /* NotResolved */ 0) {
        return [
            "NotResolved",
            notResolved_encode(v._0)
        ];
    } else {
        return [
            "ImageFromCommand",
            Decco.intToJson(v._0)
        ];
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.positioning)
        ],
        [
            "image",
            image_encode(v.image)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var image = image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    image: image._0
                }
            };
        }
        var e = image._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    var image = param.image;
    var tmp;
    if (image.TAG === /* NotResolved */ 0) {
        var match = image._0;
        tmp = "NotResolved({hash: " + (match.hash + (", size: " + (match.size.toString() + "})")));
    } else {
        tmp = "ImageFromCommand(commandId=" + (String(image._0) + "})");
    }
    return "{ positioning: " + (Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.stringify(param.positioning) + (", image: " + (tmp + " }")));
}
function fromBlobWithSelection(selection, blob) {
    var fileReader = Webapi__FileReader$SmartcutsMacros.make(undefined);
    return Webapi__FileReader$SmartcutsMacros.readAsArrayBufferPromise(fileReader, blob).then(function(result_maybeArrayBuffer) {
        if (result_maybeArrayBuffer.TAG === /* Ok */ 0) {
            var arrayBuffer = OptionUtils$SmartcutsMacros.getExn("Expect to get array buffer from FileReader.readAsArrayBufferPromise()", result_maybeArrayBuffer._0);
            return Webapi__SecureContext__SubtleCrypto$SmartcutsMacros.digest("sha256", arrayBuffer).then(function(hashBuffer) {
                var hash = Belt_Array.map(Array.from(new Uint8Array(hashBuffer)), function(b) {
                    return b.toString(16).padStart(2, "0");
                }).join("");
                var size = blob.size;
                return Promise.resolve({
                    positioning: selection,
                    image: {
                        TAG: /* NotResolved */ 0,
                        _0: {
                            hash: hash,
                            size: size
                        }
                    }
                });
            });
        }
        var error = result_maybeArrayBuffer._0;
        if (error) {
            console.error("FileReader did error while trying to read image blob: ", error._0);
            return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did error while trying to read image blob");
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did abort while trying to read image blob");
        }
    });
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    image_encode: image_encode,
    image_decode: image_decode,
    notResolved_encode: notResolved_encode,
    notResolved_decode: notResolved_decode,
    stringify: stringify,
    fromBlobWithSelection: fromBlobWithSelection
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.t_encode, v.positioning)
        ],
        [
            "image",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.image)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var image = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    image: image._0
                }
            };
        }
        var e = image._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{positioning: " + (Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.stringify, param.positioning) + (", image:" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.image) + "}")));
}
function fromRecordingCommandValue(param) {
    var image = param.image;
    var contentEditableSelectionOrCursor = param.positioning;
    var semantics = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.ofSelectionOrCursor(contentEditableSelectionOrCursor);
    var tmp;
    tmp = image.TAG === /* NotResolved */ 0 ? Util$SmartcutsMacros.logAndRaiseJsError("Expect Resolved image when convert PasteImageCommand fromRecordingCommandValue") : {
        TAG: /* ImageFromCommand */ 7,
        _0: {
            commandId: image._0,
            image: /* NotResolved */ 0
        }
    };
    return {
        positioning: {
            contentEditableSelectionOrCursor: contentEditableSelectionOrCursor,
            semantics: semantics
        },
        image: tmp
    };
}
function updateSelector(f, param) {
    return {
        positioning: Curry._2(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.ContentEditablePasteSelectionWithSemantics.updateSelector, f, param.positioning),
        image: param.image
    };
}
var Authoring = {
    ContentEditablePasteSelectionWithSemantics: undefined,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_encode(v.positioning)
        ],
        [
            "image",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.image)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var image = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    image: image._0
                }
            };
        }
        var e = image._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorGet(param) {
    return SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.selectorGet(param.positioning);
}
function stringify$2(param) {
    return "{positioning: " + (SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(param.positioning) + (", image: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.image) + "}")));
}
function fromAuthoringCommand(param) {
    return {
        positioning: SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.atIndex(0, param.positioning.semantics),
        image: param.image
    };
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    selectorGet: selectorGet,
    stringify: stringify$2,
    fromAuthoringCommand: fromAuthoringCommand
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.CommandValue = CommandValue; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 74512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = __webpack_require__(92190);
var SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros = __webpack_require__(82156);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    text: text._0
                }
            };
        }
        var e = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{positioning: selectionOrCursor, text: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text) + "}");
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "contentEditableSelectionOrCursor",
            Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.contentEditableSelectionOrCursor)
        ],
        [
            "semantics",
            SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var contentEditableSelectionOrCursor = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableSelectionOrCursor"), null));
    if (contentEditableSelectionOrCursor.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    contentEditableSelectionOrCursor: contentEditableSelectionOrCursor._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = contentEditableSelectionOrCursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".contentEditableSelectionOrCursor" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{selectionOrCursor, semantics: " + (SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.stringify(param.semantics) + "}");
}
function updateSelector(f, param) {
    return {
        contentEditableSelectionOrCursor: Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, param.contentEditableSelectionOrCursor),
        semantics: param.semantics
    };
}
var ContentEditablePasteSelectionWithSemantics = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    updateSelector: updateSelector
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            t_encode$1(v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    text: text._0
                }
            };
        }
        var e = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$2(param) {
    return "{positioning: " + (stringify$1(param.positioning) + (", text:" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text) + "}")));
}
function fromRecordingCommandValue(param) {
    var contentEditableSelectionOrCursor = param.positioning;
    var semantics = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.ofSelectionOrCursor(contentEditableSelectionOrCursor);
    return {
        positioning: {
            contentEditableSelectionOrCursor: contentEditableSelectionOrCursor,
            semantics: semantics
        },
        text: param.text
    };
}
function updateSelector$1(f, param) {
    return {
        positioning: updateSelector(f, param.positioning),
        text: param.text
    };
}
var Authoring = {
    ContentEditablePasteSelectionWithSemantics: ContentEditablePasteSelectionWithSemantics,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector$1
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_encode(v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    positioning: positioning._0,
                    text: text._0
                }
            };
        }
        var e = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorGet(param) {
    return SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.selectorGet(param.positioning);
}
function stringify$3(param) {
    return "{positioning: " + (SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(param.positioning) + (", text: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text) + "}")));
}
function fromAuthoringCommand(param) {
    return {
        positioning: SelectionSemantics__ContentEditableSelectionOrCursorSemantics$SmartcutsMacros.atIndex(0, param.positioning.semantics),
        text: param.text
    };
}
var Playback = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    selectorGet: selectorGet,
    stringify: stringify$3,
    fromAuthoringCommand: fromAuthoringCommand
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.CommandValue = CommandValue; /* DataDependency-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 15220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var InputLabel$SmartcutsMacros = __webpack_require__(43647);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var SelectorWithSemantic$SmartcutsMacros = __webpack_require__(80424);
var Selection__InputSelectionOrCursor$SmartcutsMacros = __webpack_require__(2374);
var SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros = __webpack_require__(22436);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            Selection__InputSelectionOrCursor$SmartcutsMacros.ForRecording.t_encode(v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = Selection__InputSelectionOrCursor$SmartcutsMacros.ForRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        positioning: positioning._0,
                        text: text._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{positioning: selection, text: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text) + "}");
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "inputSelectionOrCursor",
            Selection__InputSelectionOrCursor$SmartcutsMacros.ForNonRecording.t_encode(v.inputSelectionOrCursor)
        ],
        [
            "semantics",
            SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var inputSelectionOrCursor = Selection__InputSelectionOrCursor$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputSelectionOrCursor"), null));
    if (inputSelectionOrCursor.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    inputSelectionOrCursor: inputSelectionOrCursor._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = inputSelectionOrCursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".inputSelectionOrCursor" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{inputSelectionOrCursor, semantics: " + (SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.stringify(param.semantics) + "}");
}
function updateSelector(f, param) {
    return {
        inputSelectionOrCursor: Selection__InputSelectionOrCursor$SmartcutsMacros.ForNonRecording.updateSelector(f, param.inputSelectionOrCursor),
        semantics: param.semantics
    };
}
var PasteSelectionWithSemantics = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    updateSelector: updateSelector
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            t_encode$1(v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.label)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        positioning: positioning._0,
                        text: text._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(param) {
    return "{positioning: " + (stringify$1(param.positioning) + (", text: " + (StringUtils$SmartcutsMacros.quote(Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text)) + "}")));
}
function fromRecordingCommandValue(param) {
    var inputSelectionOrCursor = param.positioning;
    var semantics = SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.ofSelectionOrCursor(inputSelectionOrCursor);
    return {
        positioning: {
            inputSelectionOrCursor: Selection__InputSelectionOrCursor$SmartcutsMacros.ForNonRecording.fromRecording(inputSelectionOrCursor),
            semantics: semantics
        },
        text: param.text,
        label: param.label
    };
}
function updateSelector$1(f, param1) {
    return {
        positioning: updateSelector(f, param1.positioning),
        text: param1.text,
        label: Belt_Option.map(param1.label, function(param) {
            return InputLabel$SmartcutsMacros.RecordingAndAuthoring.updateSelector(f, param);
        })
    };
}
function getInputIdentifier(param) {
    return "pasteIn:" + Selector$SmartcutsMacros.stringify(undefined, false, param.positioning.inputSelectionOrCursor.domElementRepresentation);
}
var Authoring = {
    PasteSelectionWithSemantics: PasteSelectionWithSemantics,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector$1,
    getInputIdentifier: getInputIdentifier
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "positioning",
            SelectorWithSemantic$SmartcutsMacros.t_encode(SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_encode, v.positioning)
        ],
        [
            "text",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.text)
        ],
        [
            "label",
            Decco.optionToJson(InputLabel$SmartcutsMacros.t_encode, v.label)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var positioning = SelectorWithSemantic$SmartcutsMacros.t_decode(SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.Semantic.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "positioning"), null));
    if (positioning.TAG === /* Ok */ 0) {
        var text = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(InputLabel$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        positioning: positioning._0,
                        text: text._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = positioning._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".positioning" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function selectorGet(param) {
    return [
        param.positioning.selector
    ];
}
function stringify$3(param) {
    return "{positioning: " + (SelectorWithSemantic$SmartcutsMacros.stringify(SelectionSemantics__InputSelectionOrCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable, param.positioning) + (", text: " + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, param.text) + "}")));
}
function fromAuthoringCommand(param) {
    var match = param.positioning;
    return {
        positioning: {
            selector: match.inputSelectionOrCursor.domElementRepresentation,
            semantic: Caml_array.get(match.semantics, 0)
        },
        text: param.text,
        label: Belt_Option.map(param.label, InputLabel$SmartcutsMacros.fromRecordingAndAuthoring)
    };
}
var Playback = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    selectorGet: selectorGet,
    stringify: stringify$3,
    fromAuthoringCommand: fromAuthoringCommand
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function fromAuthoringCommandValue(authoringCommandValue) {
    var inputLabel = authoringCommandValue.label;
    if (inputLabel !== undefined && inputLabel.labels.length !== 0) {
        return {
            inputLabel: inputLabel,
            selectedLabelIndex: 0
        };
    }
}
function isDynamic(param) {
    return Belt_Option.isNone(param.selectedLabelIndex);
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, param2) {
    var match = param2.inputLabel;
    var labels = match.labels;
    var sharedRootDepth = match.sharedRootDepth;
    var init = fromAuthoringCommand(commandValue);
    return {
        positioning: init.positioning,
        text: init.text,
        label: Belt_Option.map(Belt_Option.flatMap(param2.selectedLabelIndex, function(index) {
            return Belt_Array.get(labels, index);
        }), function(param) {
            return {
                selector: param.selector,
                labelText: param.labelText,
                sharedRootDepth: sharedRootDepth
            };
        })
    };
}
var AuthoringConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    isDynamic: isDynamic,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 84259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Attributes$SmartcutsMacros = __webpack_require__(92169);
var RadioOrSelectOption$SmartcutsMacros = __webpack_require__(48300);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function radioOptions_encode(v) {
    return Js_dict.fromArray([
        [
            "options",
            Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
        ],
        [
            "indexSelected",
            Decco.intToJson(v.indexSelected)
        ]
    ]);
}
function radioOptions_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
    if (options.TAG === /* Ok */ 0) {
        var indexSelected = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "indexSelected"), null));
        if (indexSelected.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    options: options._0,
                    indexSelected: indexSelected._0
                }
            };
        }
        var e = indexSelected._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".indexSelected" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = options._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function radioInput_encode(v) {
    return Js_dict.fromArray([
        [
            "options",
            Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
        ],
        [
            "selected",
            RadioOrSelectOption$SmartcutsMacros.t_encode(v.selected)
        ]
    ]);
}
function radioInput_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
    if (options.TAG === /* Ok */ 0) {
        var selected = RadioOrSelectOption$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selected"), null));
        if (selected.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    options: options._0,
                    selected: selected._0
                }
            };
        }
        var e = selected._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selected" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = options._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function labeledRadioInputValue_encode(v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "value",
            radioInput_encode(v.value)
        ]
    ]);
}
function labeledRadioInputValue_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var value = radioInput_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function labeledRadioOptions_encode(v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "value",
            radioOptions_encode(v.value)
        ]
    ]);
}
function labeledRadioOptions_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var value = radioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "radioInputParam",
            labeledRadioOptions_encode(v.radioInputParam)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var radioInputParam = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
        if (radioInputParam.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                    radioInputParam: radioInputParam._0
                }
            };
        }
        var e = radioInputParam._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".radioInputParam" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + ", radioInputParam}");
}
function fromInputEvent(domElementIdentifierGenerator, inputEvent) {
    var target = inputEvent.target;
    var tagName = target.tagName.toLowerCase();
    var match = DOM__Attributes$SmartcutsMacros.ofDomElement(target);
    var type_ = match.type_;
    if (tagName !== "input") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
    }
    if (type_ === undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
    }
    if (type_ !== "radio") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<input type='radio'>'");
    }
    var selectorString = Selector$SmartcutsMacros.stringify(function(v) {
        switch(v.TAG | 0){
            case /* Id */ 1:
            case /* AtIndex */ 4:
                return false;
            default:
                return true;
        }
    }, false, Selector$SmartcutsMacros.forDomEventTarget(target));
    var value = Belt_Array.reduceWithIndex(Array.prototype.slice.call(document.querySelectorAll(selectorString)), {
        options: [],
        indexSelected: -1
    }, function(state, node, index) {
        var arg = Webapi__Dom__Element.ofNode(node);
        var optionElement = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("expected element nodes as result of document.querySelectorAll()");
        var options = $$Array.append(state.options, [
            RadioOrSelectOption$SmartcutsMacros.fromDomElement(optionElement)
        ]);
        if (Caml_obj.caml_equal(optionElement, target)) {
            return {
                options: options,
                indexSelected: index
            };
        } else {
            return {
                options: options,
                indexSelected: state.indexSelected
            };
        }
    });
    var selector = Selector$SmartcutsMacros.forDomEventTarget(target);
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(target, domElementIdentifierGenerator);
    var label = OptionUtils$SmartcutsMacros.map(DOM$SmartcutsMacros.$$EventTarget.deduceNameOfInput(target), function(name) {
        return name.replace(/_+/g, " ");
    });
    return {
        domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
        },
        radioInputParam: {
            label: label,
            value: value
        }
    };
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    fromInputEvent: fromInputEvent
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "radioInputParam",
            labeledRadioOptions_encode(v.radioInputParam)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var radioInputParam = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
        if (radioInputParam.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    radioInputParam: radioInputParam._0
                }
            };
        }
        var e = radioInputParam._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".radioInputParam" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        selector: param.domElementIdentifierWithSelector.selector,
        radioInputParam: param.radioInputParam
    };
}
function updateSelector(f, param) {
    return {
        selector: Curry._1(f, param.selector),
        radioInputParam: param.radioInputParam
    };
}
function getInputIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
function stringify$1(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ", radioInputParam}");
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "radioInputParam",
            labeledRadioInputValue_encode(v.radioInputParam)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var radioInputParam = labeledRadioInputValue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "radioInputParam"), null));
        if (radioInputParam.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    radioInputParam: radioInputParam._0
                }
            };
        }
        var e = radioInputParam._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".radioInputParam" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromAuthoringCommandValue(param) {
    var match = param.radioInputParam;
    var match$1 = match.value;
    var options = match$1.options;
    var selected = Caml_array.get(options, match$1.indexSelected);
    return {
        selector: param.selector,
        radioInputParam: {
            label: match.label,
            value: {
                options: options,
                selected: selected
            }
        }
    };
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function stringify$2(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ", radioInputParam}");
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    selectorGet: selectorGet,
    stringify: stringify$2
};
var CommandValue = {
    radioOptions_encode: radioOptions_encode,
    radioOptions_decode: radioOptions_decode,
    radioInput_encode: radioInput_encode,
    radioInput_decode: radioInput_decode,
    labeledRadioInputValue_encode: labeledRadioInputValue_encode,
    labeledRadioInputValue_decode: labeledRadioInputValue_decode,
    labeledRadioOptions_encode: labeledRadioOptions_encode,
    labeledRadioOptions_decode: labeledRadioOptions_decode,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function isDynamic(param) {
    return param.dynamic;
}
function fromAuthoringCommandValue$1(param) {
    var originalLabeledValue = param.radioInputParam;
    return {
        targetLocator: param.selector,
        originalLabeledValue: originalLabeledValue,
        playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", originalLabeledValue.label),
        dynamic: false
    };
}
function updateConfigWithAuthoringCommandValue(param, config) {
    return {
        targetLocator: config.targetLocator,
        originalLabeledValue: param.radioInputParam,
        playbackFormLabel: config.playbackFormLabel,
        dynamic: config.dynamic
    };
}
var AuthoringConfig = {
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "originalLabeledValue",
            labeledRadioOptions_encode(v.originalLabeledValue)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var originalLabeledValue = labeledRadioOptions_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledValue"), null));
        if (originalLabeledValue.TAG === /* Ok */ 0) {
            var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
            if (playbackFormLabel.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        targetLocator: targetLocator._0,
                        originalLabeledValue: originalLabeledValue._0,
                        playbackFormLabel: playbackFormLabel._0
                    }
                };
            }
            var e = playbackFormLabel._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".playbackFormLabel" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = originalLabeledValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".originalLabeledValue" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        targetLocator: param.targetLocator,
        originalLabeledValue: param.originalLabeledValue,
        playbackFormLabel: param.playbackFormLabel
    };
}
var ParamDescriptor = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromAuthoringConfig: fromAuthoringConfig
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "labeledValue",
            labeledRadioInputValue_encode(v.labeledValue)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var labeledValue = labeledRadioInputValue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledValue"), null));
        if (labeledValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    targetLocator: targetLocator._0,
                    labeledValue: labeledValue._0
                }
            };
        }
        var e = labeledValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$3(param) {
    return "{targetLocator: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.targetLocator) + ", labeledValue}");
}
function fromParamDescriptor(param) {
    var match = param.originalLabeledValue;
    var match$1 = match.value;
    var options = match$1.options;
    var selected = Caml_array.get(options, match$1.indexSelected);
    return {
        targetLocator: param.targetLocator,
        labeledValue: {
            label: match.label,
            value: {
                options: options,
                selected: selected
            }
        }
    };
}
function toCommandValueForPlayback(param) {
    return {
        selector: param.targetLocator,
        radioInputParam: param.labeledValue
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$3,
    fromParamDescriptor: fromParamDescriptor,
    toCommandValueForPlayback: toCommandValueForPlayback
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* DOM-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 96617:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function resizeOption_encode(v) {
    if (typeof v === "number") {
        return [
            "Original"
        ];
    } else if (v.TAG === /* ResizeByScale */ 0) {
        return [
            "ResizeByScale",
            Decco.floatToJson(v._0)
        ];
    } else {
        return [
            "ResizeToFitWidthInPx",
            Decco.intToJson(v._0)
        ];
    }
}
function resizeOption_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Original":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Original */ 0
                    };
                }
            case "ResizeByScale":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ResizeByScale */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ResizeToFitWidthInPx":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ResizeToFitWidthInPx */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyResizeOption(resizeOption) {
    if (typeof resizeOption === "number") {
        return "Original";
    } else if (resizeOption.TAG === /* ResizeByScale */ 0) {
        return "ResizeByScale(" + (resizeOption._0.toString() + "x)");
    } else {
        return "ResizeToFitWidthInPx(" + (String(resizeOption._0) + "px)");
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "clientRect",
            Rect$SmartcutsMacros.t_encode(v.clientRect)
        ],
        [
            "resizeOption",
            resizeOption_encode(v.resizeOption)
        ],
        [
            "size",
            Decco.floatToJson(v.size)
        ],
        [
            "hash",
            Decco.stringToJson(v.hash)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var clientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientRect"), null));
        if (clientRect.TAG === /* Ok */ 0) {
            var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
            if (resizeOption.TAG === /* Ok */ 0) {
                var size = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
                if (size.TAG === /* Ok */ 0) {
                    var hash = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
                    if (hash.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                selector: selector._0,
                                clientRect: clientRect._0,
                                resizeOption: resizeOption._0,
                                size: size._0,
                                hash: hash._0
                            }
                        };
                    }
                    var e = hash._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".hash" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = size._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".size" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = resizeOption._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".resizeOption" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = clientRect._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".clientRect" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringify(param) {
    return "{ clientRect: " + (Rect$SmartcutsMacros.stringify(param.clientRect) + (", resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", size: " + (param.size.toString() + (", hash: " + (StringUtils$SmartcutsMacros.quote(param.hash) + (" , selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")))))))));
}
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "recordedClientRect",
            Rect$SmartcutsMacros.t_encode(v.recordedClientRect)
        ],
        [
            "resizeOption",
            resizeOption_encode(v.resizeOption)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var recordedClientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordedClientRect"), null));
        if (recordedClientRect.TAG === /* Ok */ 0) {
            var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
            if (resizeOption.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        recordedClientRect: recordedClientRect._0,
                        resizeOption: resizeOption._0
                    }
                };
            }
            var e = resizeOption._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".resizeOption" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = recordedClientRect._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".recordedClientRect" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        selector: param.selector,
        recordedClientRect: param.clientRect,
        resizeOption: param.resizeOption
    };
}
function stringify$1(param) {
    return "{ resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")));
}
function updateSelector(f, cmdVal) {
    return {
        selector: Curry._1(f, cmdVal.selector),
        recordedClientRect: cmdVal.recordedClientRect,
        resizeOption: cmdVal.resizeOption
    };
}
function getIdentifier(param) {
    return "screenshot:" + Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fromRecordingCommandValue: fromRecordingCommandValue,
    stringify: stringify$1,
    updateSelector: updateSelector,
    getIdentifier: getIdentifier
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "recordedClientRect",
            Rect$SmartcutsMacros.t_encode(v.recordedClientRect)
        ],
        [
            "resizeOption",
            resizeOption_encode(v.resizeOption)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var recordedClientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordedClientRect"), null));
        if (recordedClientRect.TAG === /* Ok */ 0) {
            var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
            if (resizeOption.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        recordedClientRect: recordedClientRect._0,
                        resizeOption: resizeOption._0
                    }
                };
            }
            var e = resizeOption._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".resizeOption" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = recordedClientRect._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".recordedClientRect" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoring(param) {
    return {
        selector: param.selector,
        recordedClientRect: param.recordedClientRect,
        resizeOption: param.resizeOption
    };
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function stringify$2(param) {
    return "{ resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")));
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    fromAuthoring: fromAuthoring,
    selectorGet: selectorGet,
    stringify: stringify$2
};
var CommandValue = {
    resizeOption_encode: resizeOption_encode,
    resizeOption_decode: resizeOption_decode,
    stringifyResizeOption: stringifyResizeOption,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
exports.CommandValue = CommandValue; /* Rect-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 34650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var ViewportPosition$SmartcutsMacros = __webpack_require__(21707);
function delta_encode(v) {
    return Js_dict.fromArray([
        [
            "deltaX",
            Decco.floatToJson(v.deltaX)
        ],
        [
            "deltaY",
            Decco.floatToJson(v.deltaY)
        ]
    ]);
}
function delta_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var deltaX = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaX"), null));
    if (deltaX.TAG === /* Ok */ 0) {
        var deltaY = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deltaY"), null));
        if (deltaY.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    deltaX: deltaX._0,
                    deltaY: deltaY._0
                }
            };
        }
        var e = deltaY._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".deltaY" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = deltaX._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".deltaX" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "delta",
            delta_encode(v.delta)
        ],
        [
            "viewportPosition",
            ViewportPosition$SmartcutsMacros.t_encode(v.viewportPosition)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var delta = delta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "delta"), null));
    if (delta.TAG === /* Ok */ 0) {
        var viewportPosition = ViewportPosition$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "viewportPosition"), null));
        if (viewportPosition.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    delta: delta._0,
                    viewportPosition: viewportPosition._0
                }
            };
        }
        var e = viewportPosition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".viewportPosition" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = delta._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".delta" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorGet(param) {
    return [];
}
var CommandValue = {
    delta_encode: delta_encode,
    delta_decode: delta_decode,
    t_encode: t_encode,
    t_decode: t_decode,
    selectorGet: selectorGet
};
exports.CommandValue = CommandValue; /* No side effect */ 


/***/ }),

/***/ 16997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var DOM$SmartcutsMacros = __webpack_require__(4607);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var RadioOrSelectOption$SmartcutsMacros = __webpack_require__(48300);
var DomElementIdentifierGenerator$SmartcutsMacros = __webpack_require__(84557);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "options",
            Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
        ],
        [
            "selectedIndex",
            Decco.intToJson(v.selectedIndex)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
    if (options.TAG === /* Ok */ 0) {
        var selectedIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedIndex"), null));
        if (selectedIndex.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    options: options._0,
                    selectedIndex: selectedIndex._0
                }
            };
        }
        var e = selectedIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".selectedIndex" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = options._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{options=" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(RadioOrSelectOption$SmartcutsMacros.stringify, param.options))) + (", selectedIndex=" + (String(param.selectedIndex) + "}")));
}
var SelectInput = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(Decco.stringToJson, v.label)
        ],
        [
            "value",
            t_encode(v.value)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var value = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    value: value._0
                }
            };
        }
        var e = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(param) {
    return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", value=" + (stringify(param.value) + "}")));
}
var LabeledSelectInputValue = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "labeledSelectInputValue",
            t_encode$1(v.labeledSelectInputValue)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var labeledSelectInputValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledSelectInputValue"), null));
        if (labeledSelectInputValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                    labeledSelectInputValue: labeledSelectInputValue._0
                }
            };
        }
        var e = labeledSelectInputValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledSelectInputValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$2(param) {
    return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + ", labeledSelectInputValue}");
}
function fromInputEvent(domElementIdentifierGenerator, inputEvent) {
    var target = inputEvent.target;
    var tagName = target.tagName.toLowerCase();
    if (tagName !== "select") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<select>'");
    }
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(target, domElementIdentifierGenerator);
    var label = OptionUtils$SmartcutsMacros.map(DOM$SmartcutsMacros.$$EventTarget.deduceNameOfInput(target), function(name) {
        return name.replace(/_+/g, " ");
    });
    var selectElement = Curry._1(DOM$SmartcutsMacros.HtmlSelectElement.fromElement, target);
    var selectedIndex = Curry._1(DOM$SmartcutsMacros.HtmlSelectElement.selectedIndexGet, selectElement);
    var options = $$Array.map(RadioOrSelectOption$SmartcutsMacros.fromDomElement, DOM$SmartcutsMacros.HtmlSelectElement.optionsGet(selectElement));
    var value = {
        options: options,
        selectedIndex: selectedIndex
    };
    var selector = Selector$SmartcutsMacros.forDomEventTarget(target);
    return {
        domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
        },
        labeledSelectInputValue: {
            label: label,
            value: value
        }
    };
}
var Recording = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    fromInputEvent: fromInputEvent
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "labeledSelectInputValue",
            t_encode$1(v.labeledSelectInputValue)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var labeledSelectInputValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledSelectInputValue"), null));
        if (labeledSelectInputValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    labeledSelectInputValue: labeledSelectInputValue._0
                }
            };
        }
        var e = labeledSelectInputValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledSelectInputValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromRecordingCommandValue(param) {
    return {
        selector: param.domElementIdentifierWithSelector.selector,
        labeledSelectInputValue: param.labeledSelectInputValue
    };
}
function updateSelector(f, param) {
    return {
        selector: Curry._1(f, param.selector),
        labeledSelectInputValue: param.labeledSelectInputValue
    };
}
function getInputIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}
function stringify$3(param) {
    return "{selector: " + (StringUtils$SmartcutsMacros.quote(Selector$SmartcutsMacros.stringify(undefined, false, param.selector)) + ", labeledSelectInputValue}");
}
var Authoring = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier,
    stringify: stringify$3
};
var t_encode$4 = t_encode$3;
var t_decode$4 = t_decode$3;
function selectorGet(param) {
    return [
        param.selector
    ];
}
function fromAuthoringCommandValue(v) {
    return v;
}
var Playback = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$3,
    selectorGet: selectorGet,
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function isDynamic(param) {
    return param.dynamic;
}
function fromAuthoringCommandValue$1(param) {
    var originalLabeledValue = param.labeledSelectInputValue;
    return {
        targetLocator: param.selector,
        originalLabeledValue: originalLabeledValue,
        playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", originalLabeledValue.label),
        dynamic: false
    };
}
function updateConfigWithAuthoringCommandValue(param, config) {
    return {
        targetLocator: config.targetLocator,
        originalLabeledValue: param.labeledSelectInputValue,
        playbackFormLabel: config.playbackFormLabel,
        dynamic: config.dynamic
    };
}
var AuthoringConfig = {
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "originalLabeledValue",
            t_encode$1(v.originalLabeledValue)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var originalLabeledValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledValue"), null));
        if (originalLabeledValue.TAG === /* Ok */ 0) {
            var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
            if (playbackFormLabel.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        targetLocator: targetLocator._0,
                        originalLabeledValue: originalLabeledValue._0,
                        playbackFormLabel: playbackFormLabel._0
                    }
                };
            }
            var e = playbackFormLabel._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".playbackFormLabel" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = originalLabeledValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".originalLabeledValue" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        targetLocator: param.targetLocator,
        originalLabeledValue: param.originalLabeledValue,
        playbackFormLabel: param.playbackFormLabel
    };
}
var ParamDescriptor = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromAuthoringConfig: fromAuthoringConfig
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "labeledValue",
            t_encode$1(v.labeledValue)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var labeledValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledValue"), null));
        if (labeledValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    targetLocator: targetLocator._0,
                    labeledValue: labeledValue._0
                }
            };
        }
        var e = labeledValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$4(param) {
    return "{targetLocator, labeledValue=" + (stringify$1(param.labeledValue) + "}");
}
function fromParamDescriptor(param) {
    return {
        targetLocator: param.targetLocator,
        labeledValue: param.originalLabeledValue
    };
}
function toCommandValueForPlayback(param) {
    return {
        selector: param.targetLocator,
        labeledSelectInputValue: param.labeledValue
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    stringify: stringify$4,
    fromParamDescriptor: fromParamDescriptor,
    toCommandValueForPlayback: toCommandValueForPlayback
};
exports.SelectInput = SelectInput;
exports.LabeledSelectInputValue = LabeledSelectInputValue;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* DOM-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 50783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    title: title._0
                }
            };
        }
        var e = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "'}")));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 58935:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    title: title._0
                }
            };
        }
        var e = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "'}")));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 16614:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    title: title._0
                }
            };
        }
        var e = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{url: " + (StringUtils$SmartcutsMacros.quote(param.url) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "'}")));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
exports.CommandValue = CommandValue; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
var GenericCommandWithContextGlobal$SmartcutsMacros = __webpack_require__(95551);
var SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros = __webpack_require__(33788);
function t_encode(encoder_command, v) {
    return [
        "CommandLog",
        Decco.listToJson(function(param) {
            return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_command, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, param);
        }, v._0)
    ];
}
function t_decode(decoder_command, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "CommandLog") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Decco.listFromJson(function(param) {
            return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_command, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, param);
        }, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* CommandLog */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map(mapCommandWithContext, commandLogRef) {
    return /* CommandLog */ {
        _0: Belt_List.map(commandLogRef._0, mapCommandWithContext)
    };
}
function stringify(stringifyCommand, cmdVal) {
    return "CommandLog([" + (Belt_Array.map($$Array.of_list(cmdVal._0), function(param) {
        return "{id: " + (String(param.id) + (", command: " + (Curry._1(stringifyCommand, param.command) + ("commandContext: " + (CommandContext$SmartcutsMacros.CommandContextGlobalResolved.stringify(param.contextGlobal) + "}")))));
    }).join(", ") + "])");
}
var CommandLogRef = {
    t_encode: t_encode,
    t_decode: t_decode,
    map: map,
    stringify: stringify
};
function t_encode$1(encoder_command, v) {
    if (v) {
        return [
            "ExecuteCommands",
            t_encode(encoder_command, v._0)
        ];
    } else {
        return [
            "DoNothing"
        ];
    }
}
function t_decode$1(decoder_command, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DoNothing":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* DoNothing */ 0
                    };
                }
            case "ExecuteCommands":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(decoder_command, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ExecuteCommands */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$1(mapCommandWithContext, action) {
    if (action) {
        return /* ExecuteCommands */ {
            _0: map(mapCommandWithContext, action._0)
        };
    } else {
        return /* DoNothing */ 0;
    }
}
function selectorGet(getSelectorInCommand, action) {
    if (!action) {
        return [];
    }
    var arg = $$Array.of_list(action._0._0);
    var param = function param(param$1) {
        return Curry._1(getSelectorInCommand, param$1.command);
    };
    return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
}
function stringify$1(stringifyCommand, action) {
    if (action) {
        return "ExecuteCommands(" + (stringify(stringifyCommand, action._0) + ")");
    } else {
        return "DoNothing";
    }
}
function someCommands(f, action) {
    if (action) {
        return Belt_List.some(action._0._0, f);
    } else {
        return false;
    }
}
var SwitchAction = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    map: map$1,
    selectorGet: selectorGet,
    stringify: stringify$1,
    someCommands: someCommands
};
function selectionExistsPredicate_encode(v) {
    return Js_dict.fromArray([
        [
            "semantic",
            SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.semantic)
        ],
        [
            "originalSelection",
            Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.originalSelection)
        ]
    ]);
}
function selectionExistsPredicate_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var semantic = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
    if (semantic.TAG === /* Ok */ 0) {
        var originalSelection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalSelection"), null));
        if (originalSelection.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    semantic: semantic._0,
                    originalSelection: originalSelection._0
                }
            };
        }
        var e = originalSelection._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".originalSelection" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = semantic._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".semantic" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$2(v) {
    if (v.TAG === /* SelectorExists */ 0) {
        return [
            "SelectorExists",
            Selector$SmartcutsMacros.selector_encode(v._0)
        ];
    } else {
        return [
            "SelectionExists",
            selectionExistsPredicate_encode(v._0)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "SelectionExists":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = selectionExistsPredicate_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectionExists */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "SelectorExists":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectorExists */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function mapSelector(f, predicate) {
    if (predicate.TAG === /* SelectorExists */ 0) {
        return {
            TAG: /* SelectorExists */ 0,
            _0: Curry._1(f, predicate._0)
        };
    }
    var match = predicate._0;
    var func = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.updateSelector;
    var func$1 = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.updateSelector;
    return {
        TAG: /* SelectionExists */ 1,
        _0: {
            semantic: Curry._2(func, f, match.semantic),
            originalSelection: Curry._2(func$1, f, match.originalSelection)
        }
    };
}
function stringify$2(predicate) {
    if (predicate.TAG === /* SelectorExists */ 0) {
        return "SelectorExists(" + (Selector$SmartcutsMacros.stringify(undefined, false, predicate._0) + ")");
    } else {
        return "SelectionExists({originalSelection, semantic: " + (SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.stringify(predicate._0.semantic) + "})");
    }
}
var Predicate = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    selectionExistsPredicate_encode: selectionExistsPredicate_encode,
    selectionExistsPredicate_decode: selectionExistsPredicate_decode,
    mapSelector: mapSelector,
    stringify: stringify$2
};
function t_encode$3(encoder_command, v) {
    if (v) {
        return [
            "SwitchAction",
            t_encode$1(encoder_command, v._0)
        ];
    } else {
        return [
            "FailWithNoPredicateSatisfied"
        ];
    }
}
function t_decode$3(decoder_command, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FailWithNoPredicateSatisfied":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FailWithNoPredicateSatisfied */ 0
                    };
                }
            case "SwitchAction":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$1(decoder_command, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* SwitchAction */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function map$2(mapCommandWithContext, v) {
    if (v) {
        return /* SwitchAction */ {
            _0: map$1(mapCommandWithContext, v._0)
        };
    } else {
        return /* FailWithNoPredicateSatisfied */ 0;
    }
}
function someCommands$1(f, v) {
    if (v) {
        return someCommands(f, v._0);
    } else {
        return false;
    }
}
var SwitchActionOrFailure = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    map: map$2,
    someCommands: someCommands$1
};
function t_encode$4(encoder_command, v) {
    return Js_dict.fromArray([
        [
            "predicate",
            t_encode$2(v.predicate)
        ],
        [
            "action",
            t_encode$1(encoder_command, v.action)
        ]
    ]);
}
function t_decode$4(decoder_command, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var predicate = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "predicate"), null));
    if (predicate.TAG === /* Ok */ 0) {
        var action = t_decode$1(decoder_command, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
        if (action.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    predicate: predicate._0,
                    action: action._0
                }
            };
        }
        var e = action._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".action" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = predicate._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".predicate" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function mapSelector$1(f, mapCommandWithContext, param) {
    return {
        predicate: mapSelector(f, param.predicate),
        action: map$1(mapCommandWithContext, param.action)
    };
}
var PredicateAndAction = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    mapSelector: mapSelector$1
};
function t_encode$5(encoder_command, v) {
    return Js_dict.fromArray([
        [
            "clauses",
            Decco.arrayToJson(function(param) {
                return t_encode$4(encoder_command, param);
            }, v.clauses)
        ],
        [
            "default",
            t_encode$3(encoder_command, v.default)
        ]
    ]);
}
function t_decode$5(decoder_command, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var clauses = Decco.arrayFromJson(function(param) {
        return t_decode$4(decoder_command, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clauses"), null));
    if (clauses.TAG === /* Ok */ 0) {
        var $$default = t_decode$3(decoder_command, Belt_Option.getWithDefault(Js_dict.get(dict$1, "default"), null));
        if ($$default.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    clauses: clauses._0,
                    default: $$default._0
                }
            };
        }
        var e = $$default._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".default" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = clauses._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".clauses" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function map$3(mapCommandWithContext, param1) {
    var $$default = param1.default;
    return {
        clauses: Belt_Array.map(param1.clauses, function(param) {
            return {
                predicate: param.predicate,
                action: map$1(mapCommandWithContext, param.action)
            };
        }),
        default: $$default ? /* SwitchAction */ ({
            _0: map$1(mapCommandWithContext, $$default._0)
        }) : /* FailWithNoPredicateSatisfied */ 0
    };
}
function getIdentifier(param2) {
    return "switch([" + (Belt_Array.map(param2.clauses, function(param) {
        var predicate = param.predicate;
        if (predicate.TAG === /* SelectorExists */ 0) {
            return "SelectorExists(" + (Selector$SmartcutsMacros.stringify(undefined, false, predicate._0) + ")");
        }
        var match = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(predicate._0.originalSelection);
        return "SelectionExists(" + (match[1] + ")");
    }).join(",") + ("],default:" + ((param2.default ? "SwitchAction" : "FailWithNoPredicateSatisfied") + ")")));
}
function stringify$3(stringifyCommand, param3) {
    var $$default = param3.default;
    return "{ clauses: [" + (Belt_Array.map(param3.clauses, function(param) {
        var predicateString = stringify$2(param.predicate);
        var actionString = stringify$1(stringifyCommand, param.action);
        return predicateString + (" => " + actionString);
    }).join(", ") + ("], default: " + (($$default ? "SwitchAction(" + (stringify$1(stringifyCommand, $$default._0) + ")") : "FailWithNoPredicateSatisfied") + " }")));
}
function selectorGet$1(getSelectorInCommand, param4) {
    var $$default = param4.default;
    return Belt_Array.concat(ArrayUtils$SmartcutsMacros.flatMap(function(param) {
        var predicate = param.predicate;
        var tmp;
        tmp = predicate.TAG === /* SelectorExists */ 0 ? [
            predicate._0
        ] : Selection__StrictSelection$SmartcutsMacros.ForNonRecording.extractSelectors(predicate._0.originalSelection);
        return Belt_Array.concat(selectorGet(getSelectorInCommand, param.action), tmp);
    }, param4.clauses), $$default ? selectorGet(getSelectorInCommand, $$default._0) : []);
}
function mapSelector$2(f, mapCommandWithContext, param) {
    return {
        clauses: Belt_Array.map(param.clauses, function(predicateAndAction) {
            return mapSelector$1(f, mapCommandWithContext, predicateAndAction);
        }),
        default: map$2(mapCommandWithContext, param.default)
    };
}
function someCommands$2(f, param5) {
    if (Belt_Array.some(param5.clauses, function(param) {
        return someCommands(f, param.action);
    })) {
        return true;
    } else {
        return someCommands$1(f, param5.default);
    }
}
var CommandValue = {
    Predicate: Predicate,
    SwitchActionOrFailure: SwitchActionOrFailure,
    PredicateAndAction: PredicateAndAction,
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    map: map$3,
    getIdentifier: getIdentifier,
    stringify: stringify$3,
    selectorGet: selectorGet$1,
    mapSelector: mapSelector$2,
    someCommands: someCommands$2
};
exports.CommandLogRef = CommandLogRef;
exports.SwitchAction = SwitchAction;
exports.CommandValue = CommandValue; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 92095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var InputLabel$SmartcutsMacros = __webpack_require__(43647);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = __webpack_require__(25763);
var SelectionSemantics__InputSelectionSemantics$SmartcutsMacros = __webpack_require__(35275);
function labeledAddTextInput_encode(encoder_inputLabel, encoder_addedValue, v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(encoder_inputLabel, v.label)
        ],
        [
            "addText",
            Curry._1(encoder_addedValue, v.addText)
        ]
    ]);
}
function labeledAddTextInput_decode(decoder_inputLabel, decoder_addedValue, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var addText = Curry._1(decoder_addedValue, Belt_Option.getWithDefault(Js_dict.get(dict$1, "addText"), null));
        if (addText.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    addText: addText._0
                }
            };
        }
        var e = addText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".addText" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringifyLabeledAddTextInput(stringifyAddedValue, stringifyInputLabel, param) {
    return "{label=" + (OptionUtils$SmartcutsMacros.stringify(stringifyInputLabel, param.label) + (", addText=" + (Curry._1(stringifyAddedValue, param.addText) + "}")));
}
function diff_encode(encoder_addedValue, encoder_deletedValue, v) {
    if (v.TAG === /* AddText */ 0) {
        return [
            "AddText",
            Curry._1(encoder_addedValue, v._0)
        ];
    } else {
        return [
            "DeleteText",
            Curry._1(encoder_deletedValue, v._0)
        ];
    }
}
function diff_decode(decoder_addedValue, decoder_deletedValue, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AddText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(decoder_addedValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* AddText */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DeleteText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(decoder_deletedValue, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DeleteText */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringGetGeneral(stringifyAddedValue, stringifyDeletedValue, diff) {
    if (diff.TAG === /* AddText */ 0) {
        return Curry._1(stringifyAddedValue, diff._0);
    } else {
        return Curry._1(stringifyDeletedValue, diff._0);
    }
}
function stringify(stringifyAddedValue, stringifyDeletedValue, diff) {
    if (diff.TAG === /* AddText */ 0) {
        return "AddText(" + (Curry._1(stringifyAddedValue, diff._0) + ")");
    } else {
        return Curry._1(stringifyDeletedValue, diff._0);
    }
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "start",
            Decco.intToJson(v.start)
        ],
        [
            "end_",
            Decco.intToJson(v.end_)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */ 0) {
        var start = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
        if (start.TAG === /* Ok */ 0) {
            var end_ = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
            if (end_.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        value: value._0,
                        start: start._0,
                        end_: end_._0
                    }
                };
            }
            var e = end_._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".end_" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = start._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".start" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = value._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".value" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function prefixGet(param) {
    return StringUtils$SmartcutsMacros.slice(0, param.start, param.value);
}
function deletedTextGet(param) {
    return StringUtils$SmartcutsMacros.slice(param.start, param.end_, param.value);
}
function suffixGet(param) {
    var value = param.value;
    return StringUtils$SmartcutsMacros.slice(param.end_, value.length, value);
}
function combine(param, param$1) {
    return {
        value: param.value,
        start: param$1.start,
        end_: param.end_
    };
}
function toString(param) {
    return StringUtils$SmartcutsMacros.slice(param.start, param.end_, param.value);
}
function stringify$1(param) {
    return "{value=" + (param.value + (", start=" + (String(param.start) + (", end_=" + (String(param.end_) + "}")))));
}
var DeletedValueForRecording = {
    t_encode: t_encode,
    t_decode: t_decode,
    prefixGet: prefixGet,
    deletedTextGet: deletedTextGet,
    suffixGet: suffixGet,
    combine: combine,
    toString: toString,
    stringify: stringify$1
};
function t_encode$1(v) {
    return diff_encode(Decco.stringToJson, t_encode, v);
}
function t_decode$1(v) {
    return diff_decode(Decco.stringFromJson, t_decode, v);
}
function stringGet(diff) {
    if (diff.TAG === /* AddText */ 0) {
        return diff._0;
    }
    var match = diff._0;
    return StringUtils$SmartcutsMacros.slice(match.start, match.end_, match.value);
}
function maybeCombine(diffA, diffB) {
    if (diffA.TAG === /* AddText */ 0) {
        var textToAddA = diffA._0;
        if (diffB.TAG === /* AddText */ 0) {
            var textToAddB = diffB._0;
            var match = StringUtils$SmartcutsMacros.isNewLine(textToAddA);
            var match$1 = StringUtils$SmartcutsMacros.isNewLine(textToAddB);
            if (match || match$1) {
                return /* KeepBoth */ 0;
            } else {
                return {
                    TAG: /* ReplaceWith */ 0,
                    _0: {
                        TAG: /* AddText */ 0,
                        _0: textToAddA + textToAddB
                    }
                };
            }
        }
        var match$2 = diffB._0;
        var end_ = match$2.end_;
        var start = match$2.start;
        var value = match$2.value;
        var textToDelete = StringUtils$SmartcutsMacros.slice(start, end_, value);
        var numCharsToAdd = textToAddA.length;
        var numCharsToRemove = textToDelete.length;
        if (numCharsToRemove > numCharsToAdd) {
            if (StringUtils$SmartcutsMacros.endsWith(textToDelete, textToAddA)) {
                return {
                    TAG: /* ReplaceWith */ 0,
                    _0: {
                        TAG: /* DeleteText */ 1,
                        _0: {
                            value: value,
                            start: start,
                            end_: end_ - textToAddA.length | 0
                        }
                    }
                };
            } else {
                Curry._1(Log$SmartcutsMacros.cmdTypeRecording.warn1, "When combining text diffs and the 2nd diff removes more characters than the 1st diff, then the second diff needs to end with the first diff");
                return /* KeepBoth */ 0;
            }
        }
        if (StringUtils$SmartcutsMacros.endsWith(textToAddA, textToDelete)) {
            var newTextToAdd = StringUtils$SmartcutsMacros.removeTrailingSuffix(textToAddA, textToDelete);
            if (newTextToAdd === "") {
                return /* RemoveBoth */ 1;
            } else {
                return {
                    TAG: /* ReplaceWith */ 0,
                    _0: {
                        TAG: /* AddText */ 0,
                        _0: newTextToAdd
                    }
                };
            }
        }
        Curry._1(Log$SmartcutsMacros.cmdTypeRecording.warn1, "When combining text diffs and the 2nd deletion diff removes more characters than the 1st addition diff, then the second diff is expected to end with the 1st diff");
        return /* KeepBoth */ 0;
    }
    var a = diffA._0;
    var end_$1 = a.end_;
    var start$1 = a.start;
    var value$1 = a.value;
    if (diffB.TAG !== /* AddText */ 0) {
        return {
            TAG: /* ReplaceWith */ 0,
            _0: {
                TAG: /* DeleteText */ 1,
                _0: combine(a, diffB._0)
            }
        };
    }
    var textToAdd = diffB._0;
    var textToDelete$1 = StringUtils$SmartcutsMacros.slice(start$1, end_$1, value$1);
    if (StringUtils$SmartcutsMacros.beginsWith(textToDelete$1, textToAdd)) {
        return {
            TAG: /* ReplaceWith */ 0,
            _0: {
                TAG: /* DeleteText */ 1,
                _0: {
                    value: value$1,
                    start: start$1 + textToAdd.length | 0,
                    end_: end_$1
                }
            }
        };
    } else {
        return /* KeepBoth */ 0;
    }
}
function factorOutDynamicVars(valueDiff) {
    var tmp;
    tmp = valueDiff._0;
    var vars = [
        tmp
    ];
    var factoredValue;
    factoredValue = valueDiff.TAG === /* AddText */ 0 ? {
        TAG: /* AddText */ 0,
        _0: ""
    } : {
        TAG: /* DeleteText */ 1,
        _0: {
            value: "",
            start: 0,
            end_: 0
        }
    };
    return {
        vars: vars,
        factoredValue: factoredValue
    };
}
function substituteInDynamicVars(param1) {
    var vars = param1.vars;
    if (param1.factoredValue.TAG === /* AddText */ 0) {
        var arg1 = Js_json.decodeString(Caml_array.get(vars, 0));
        var addText = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg1);
        }("Expected var to be a string");
        return {
            TAG: /* AddText */ 0,
            _0: addText
        };
    }
    var deleteText = Caml_array.get(vars, 0);
    return {
        TAG: /* DeleteText */ 1,
        _0: deleteText
    };
}
var Pack = {
    factorOutDynamicVars: factorOutDynamicVars,
    substituteInDynamicVars: substituteInDynamicVars
};
var ForRecording = {
    DeletedValueForRecording: DeletedValueForRecording,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringGet: stringGet,
    maybeCombine: maybeCombine,
    Pack: Pack
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "recording",
            t_encode(v.recording)
        ],
        [
            "semantics",
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var recording = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recording"), null));
    if (recording.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    recording: recording._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = recording._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".recording" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringGet$1(param) {
    return toString(param.recording);
}
function stringify$2(param) {
    return "{recording=" + (stringify$1(param.recording) + (", semantics=" + (SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.stringify(param.semantics) + "}")));
}
var DeletedValueAndSemantics = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringGet: stringGet$1,
    stringify: stringify$2
};
function t_encode$3(v) {
    return diff_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, t_encode$2, v);
}
function t_decode$3(v) {
    return diff_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, t_decode$2, v);
}
function stringGet$2(param) {
    return function(param$1) {
        return stringGetGeneral(param, stringGet$1, param$1);
    };
}
function stringify$3(param) {
    return stringify(DataDependency$SmartcutsMacros.DataRef.stringify, stringify$2, param);
}
function fromRecordingValueDiff(recordingDiff) {
    if (recordingDiff.TAG === /* AddText */ 0) {
        return {
            TAG: /* AddText */ 0,
            _0: {
                TAG: /* StaticText */ 0,
                _0: recordingDiff._0
            }
        };
    }
    var deletedValueForRecording = recordingDiff._0;
    return {
        TAG: /* DeleteText */ 1,
        _0: {
            recording: deletedValueForRecording,
            semantics: SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.fromSelectionStartAndEndAndValue(deletedValueForRecording.start, deletedValueForRecording.end_, deletedValueForRecording.value)
        }
    };
}
function factorOutDynamicVars$1(valueDiff) {
    if (valueDiff.TAG === /* AddText */ 0) {
        var factoredDataRef = Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.factorOutDynamicVars, valueDiff._0);
        return {
            vars: factoredDataRef.vars,
            factoredValue: {
                TAG: /* AddText */ 0,
                _0: factoredDataRef.factoredValue
            }
        };
    }
    var match = valueDiff._0;
    return {
        vars: [
            match.recording
        ],
        factoredValue: {
            TAG: /* DeleteText */ 1,
            _0: {
                recording: {
                    value: "",
                    start: 0,
                    end_: 0
                },
                semantics: match.semantics
            }
        }
    };
}
function substituteInDynamicVars$1(param) {
    var factoredValueDiff = param.factoredValue;
    var vars = param.vars;
    if (factoredValueDiff.TAG === /* AddText */ 0) {
        return {
            TAG: /* AddText */ 0,
            _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
                vars: vars,
                factoredValue: factoredValueDiff._0
            })
        };
    } else {
        return {
            TAG: /* DeleteText */ 1,
            _0: {
                recording: Caml_array.get(vars, 0),
                semantics: factoredValueDiff._0.semantics
            }
        };
    }
}
var Pack$1 = {
    factorOutDynamicVars: factorOutDynamicVars$1,
    substituteInDynamicVars: substituteInDynamicVars$1
};
var ForAuthoring = {
    DeletedValueAndSemantics: DeletedValueAndSemantics,
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringGet: stringGet$2,
    stringify: stringify$3,
    fromRecordingValueDiff: fromRecordingValueDiff,
    Pack: Pack$1
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "value",
            Decco.stringToJson(v.value)
        ],
        [
            "deletedSemantic",
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.deletedSemantic)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */ 0) {
        var deletedSemantic = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deletedSemantic"), null));
        if (deletedSemantic.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    value: value._0,
                    deletedSemantic: deletedSemantic._0
                }
            };
        }
        var e = deletedSemantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".deletedSemantic" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = value._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringGet$3(param) {
    return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.applyToInputValue(param.value, param.deletedSemantic);
}
var OriginalValueWithDeletedSemantic = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringGet: stringGet$3
};
function t_encode$5(v) {
    return diff_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, t_encode$4, v);
}
function t_decode$5(v) {
    return diff_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, t_decode$4, v);
}
function fromAuthoringValueDiff(authoringDiff) {
    if (authoringDiff.TAG === /* AddText */ 0) {
        return {
            TAG: /* AddText */ 0,
            _0: authoringDiff._0
        };
    }
    var match = authoringDiff._0;
    return {
        TAG: /* DeleteText */ 1,
        _0: {
            value: match.recording.value,
            deletedSemantic: Caml_array.get(match.semantics, 0)
        }
    };
}
function arg(semantic) {
    var text = stringGet$3(semantic);
    if (text.TAG === /* Ok */ 0) {
        return text._0;
    } else {
        return "";
    }
}
function stringGet$4(param) {
    return function(param$1) {
        return stringGetGeneral(param, arg, param$1);
    };
}
function factorOutDynamicVars$2(valueDiff) {
    if (valueDiff.TAG !== /* AddText */ 0) {
        return {
            vars: [],
            factoredValue: valueDiff
        };
    }
    var factoredDataRef = Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.factorOutDynamicVars, valueDiff._0);
    return {
        vars: factoredDataRef.vars,
        factoredValue: {
            TAG: /* AddText */ 0,
            _0: factoredDataRef.factoredValue
        }
    };
}
function substituteInDynamicVars$2(param) {
    var factoredValueDiff = param.factoredValue;
    if (factoredValueDiff.TAG === /* AddText */ 0) {
        return {
            TAG: /* AddText */ 0,
            _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
                vars: param.vars,
                factoredValue: factoredValueDiff._0
            })
        };
    } else {
        return {
            TAG: /* DeleteText */ 1,
            _0: factoredValueDiff._0
        };
    }
}
var Pack$2 = {
    factorOutDynamicVars: factorOutDynamicVars$2,
    substituteInDynamicVars: substituteInDynamicVars$2
};
var ForPlayback = {
    OriginalValueWithDeletedSemantic: OriginalValueWithDeletedSemantic,
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromAuthoringValueDiff: fromAuthoringValueDiff,
    stringGet: stringGet$4,
    Pack: Pack$2
};
var TextInputValueDiff = {
    InputSelectionSemantics: undefined,
    diff_encode: diff_encode,
    diff_decode: diff_decode,
    stringGetGeneral: stringGetGeneral,
    stringify: stringify,
    ForRecording: ForRecording,
    ForAuthoring: ForAuthoring,
    ForPlayback: ForPlayback
};
function labeledTextInputValueDiff_encode(encoder_valueDiff, encoder_inputLabel, v) {
    return Js_dict.fromArray([
        [
            "label",
            Decco.optionToJson(encoder_inputLabel, v.label)
        ],
        [
            "valueDiff",
            Curry._1(encoder_valueDiff, v.valueDiff)
        ]
    ]);
}
function labeledTextInputValueDiff_decode(decoder_valueDiff, decoder_inputLabel, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */ 0) {
        var valueDiff = Curry._1(decoder_valueDiff, Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueDiff"), null));
        if (valueDiff.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    label: label._0,
                    valueDiff: valueDiff._0
                }
            };
        }
        var e = valueDiff._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".valueDiff" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = label._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringifyLabeledTextInputValueDiff(stringifyValueDiff, stringifyInputLabel, param) {
    return "{label=" + (OptionUtils$SmartcutsMacros.stringify(stringifyInputLabel, param.label) + (", valueDiff=" + (Curry._1(stringifyValueDiff, param.valueDiff) + "}")));
}
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "domElementIdentifierWithSelector",
            DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
        ],
        [
            "labeledTextInputValueDiff",
            labeledTextInputValueDiff_encode(t_encode$1, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.labeledTextInputValueDiff)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
    if (domElementIdentifierWithSelector.TAG === /* Ok */ 0) {
        var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$1, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
        if (labeledTextInputValueDiff.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                    labeledTextInputValueDiff: labeledTextInputValueDiff._0
                }
            };
        }
        var e = labeledTextInputValueDiff._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledTextInputValueDiff" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = domElementIdentifierWithSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$4(param2) {
    return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param2.domElementIdentifierWithSelector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff(function(param) {
        return stringify(function(s) {
            return s;
        }, stringify$1, param);
    }, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param2.labeledTextInputValueDiff) + "}")));
}
function factorOutDynamicVars$3(param) {
    var match = param.labeledTextInputValueDiff;
    var match$1 = param.domElementIdentifierWithSelector;
    var match$2 = factorOutDynamicVars(match.valueDiff);
    var match$3 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(match$1.selector);
    return {
        vars: [
            match$2.vars,
            match$3.vars
        ],
        factoredValue: {
            domElementIdentifierWithSelector: {
                domElementIdentifier: match$1.domElementIdentifier,
                selector: match$3.factoredValue
            },
            labeledTextInputValueDiff: {
                label: match.label,
                valueDiff: match$2.factoredValue
            }
        }
    };
}
function substituteInDynamicVars$3(param3) {
    var match = param3.factoredValue;
    var match$1 = match.labeledTextInputValueDiff;
    var match$2 = match.domElementIdentifierWithSelector;
    var vars = param3.vars;
    var arg2 = Js_json.decodeArray(Caml_array.get(vars, 0));
    var varsForValueDiff = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg2);
    }("Expected array of vars");
    var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
    var varsForSelector = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected array of vars");
    return {
        domElementIdentifierWithSelector: {
            domElementIdentifier: match$2.domElementIdentifier,
            selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                vars: varsForSelector,
                factoredValue: match$2.selector
            })
        },
        labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars({
                vars: varsForValueDiff,
                factoredValue: match$1.valueDiff
            })
        }
    };
}
var Pack$3 = {
    factorOutDynamicVars: factorOutDynamicVars$3,
    substituteInDynamicVars: substituteInDynamicVars$3
};
var Recording = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    stringify: stringify$4,
    Pack: Pack$3
};
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "labeledTextInputValueDiff",
            labeledTextInputValueDiff_encode(t_encode$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.labeledTextInputValueDiff)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
        if (labeledTextInputValueDiff.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    labeledTextInputValueDiff: labeledTextInputValueDiff._0
                }
            };
        }
        var e = labeledTextInputValueDiff._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledTextInputValueDiff" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$5(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff(stringify$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param.labeledTextInputValueDiff) + "}")));
}
function fromRecordingCommandValue(param) {
    var match = param.labeledTextInputValueDiff;
    return {
        selector: param.domElementIdentifierWithSelector.selector,
        labeledTextInputValueDiff: {
            label: match.label,
            valueDiff: fromRecordingValueDiff(match.valueDiff)
        }
    };
}
function updateSelector(f, param) {
    return {
        selector: Curry._1(f, param.selector),
        labeledTextInputValueDiff: param.labeledTextInputValueDiff
    };
}
function getInputIdentifier(commandIndex, param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + String(commandIndex);
}
function factorOutDynamicVars$4(param) {
    var match = param.labeledTextInputValueDiff;
    var match$1 = factorOutDynamicVars$1(match.valueDiff);
    var match$2 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(param.selector);
    return {
        vars: [
            match$1.vars,
            match$2.vars
        ],
        factoredValue: {
            selector: match$2.factoredValue,
            labeledTextInputValueDiff: {
                label: match.label,
                valueDiff: match$1.factoredValue
            }
        }
    };
}
function substituteInDynamicVars$4(param4) {
    var match = param4.factoredValue;
    var match$1 = match.labeledTextInputValueDiff;
    var vars = param4.vars;
    var arg3 = Js_json.decodeArray(Caml_array.get(vars, 0));
    var varsForValueDiff = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg3);
    }("Expected array of vars");
    var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
    var varsForSelector = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected array of vars");
    return {
        selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
            vars: varsForSelector,
            factoredValue: match.selector
        }),
        labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars$1({
                vars: varsForValueDiff,
                factoredValue: match$1.valueDiff
            })
        }
    };
}
var Pack$4 = {
    factorOutDynamicVars: factorOutDynamicVars$4,
    substituteInDynamicVars: substituteInDynamicVars$4
};
function maybeGetDataRef(param) {
    var valueDiff = param.labeledTextInputValueDiff.valueDiff;
    if (valueDiff.TAG === /* AddText */ 0) {
        return valueDiff._0;
    }
}
function maybeUpdateDataRef(dataRef, cmdVal) {
    var labeledTextInputValueDiff = cmdVal.labeledTextInputValueDiff;
    var valueDiff = labeledTextInputValueDiff.valueDiff;
    var tmp;
    tmp = valueDiff.TAG === /* AddText */ 0 ? {
        TAG: /* AddText */ 0,
        _0: dataRef
    } : valueDiff;
    return {
        selector: cmdVal.selector,
        labeledTextInputValueDiff: {
            label: labeledTextInputValueDiff.label,
            valueDiff: tmp
        }
    };
}
var Authoring = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    stringify: stringify$5,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector,
    getInputIdentifier: getInputIdentifier,
    Pack: Pack$4,
    maybeGetDataRef: maybeGetDataRef,
    maybeUpdateDataRef: maybeUpdateDataRef
};
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "labeledTextInputValueDiff",
            labeledTextInputValueDiff_encode(t_encode$5, InputLabel$SmartcutsMacros.t_encode, v.labeledTextInputValueDiff)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$5, InputLabel$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
        if (labeledTextInputValueDiff.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selector: selector._0,
                    labeledTextInputValueDiff: labeledTextInputValueDiff._0
                }
            };
        }
        var e = labeledTextInputValueDiff._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledTextInputValueDiff" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fromAuthoringCommandValue(param) {
    var match1 = param.labeledTextInputValueDiff;
    return {
        selector: param.selector,
        labeledTextInputValueDiff: {
            label: Belt_Option.flatMap(match1.label, function(inputLabel) {
                var match = Caml_array.get(inputLabel.labels, 0).derivedVia;
                if (match >= 2) {
                    return;
                } else {
                    return InputLabel$SmartcutsMacros.fromRecordingAndAuthoring(inputLabel);
                }
            }),
            valueDiff: fromAuthoringValueDiff(match1.valueDiff)
        }
    };
}
function selectorGet(param) {
    return [
        param.selector
    ];
}
function stringify$6(param) {
    return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff(function(param) {
        return "_";
    }, InputLabel$SmartcutsMacros.stringify, param.labeledTextInputValueDiff) + "}")));
}
function maybeGetDataRef$1(param) {
    var valueDiff = param.labeledTextInputValueDiff.valueDiff;
    if (valueDiff.TAG === /* AddText */ 0) {
        return valueDiff._0;
    }
}
function maybeUpdateDataRef$1(dataRef, cmdVal) {
    var labeledTextInputValueDiff = cmdVal.labeledTextInputValueDiff;
    var valueDiff = labeledTextInputValueDiff.valueDiff;
    var tmp;
    tmp = valueDiff.TAG === /* AddText */ 0 ? {
        TAG: /* AddText */ 0,
        _0: dataRef
    } : valueDiff;
    return {
        selector: cmdVal.selector,
        labeledTextInputValueDiff: {
            label: labeledTextInputValueDiff.label,
            valueDiff: tmp
        }
    };
}
function factorOutDynamicVars$5(param) {
    var match = param.labeledTextInputValueDiff;
    var match$1 = factorOutDynamicVars$2(match.valueDiff);
    var match$2 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(param.selector);
    return {
        vars: [
            match$1.vars,
            match$2.vars
        ],
        factoredValue: {
            selector: match$2.factoredValue,
            labeledTextInputValueDiff: {
                label: match.label,
                valueDiff: match$1.factoredValue
            }
        }
    };
}
function substituteInDynamicVars$5(param5) {
    var match = param5.factoredValue;
    var match$1 = match.labeledTextInputValueDiff;
    var vars = param5.vars;
    var arg4 = Js_json.decodeArray(Caml_array.get(vars, 0));
    var varsForValueDiff = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg4);
    }("Expected array of vars");
    var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
    var varsForSelector = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expected array of vars");
    return {
        selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
            vars: varsForSelector,
            factoredValue: match.selector
        }),
        labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars$2({
                vars: varsForValueDiff,
                factoredValue: match$1.valueDiff
            })
        }
    };
}
var Pack$5 = {
    factorOutDynamicVars: factorOutDynamicVars$5,
    substituteInDynamicVars: substituteInDynamicVars$5
};
var Playback = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    selectorGet: selectorGet,
    stringify: stringify$6,
    maybeGetDataRef: maybeGetDataRef$1,
    maybeUpdateDataRef: maybeUpdateDataRef$1,
    Pack: Pack$5
};
var CommandValue = {
    labeledAddTextInput_encode: labeledAddTextInput_encode,
    labeledAddTextInput_decode: labeledAddTextInput_decode,
    stringifyLabeledAddTextInput: stringifyLabeledAddTextInput,
    TextInputValueDiff: TextInputValueDiff,
    labeledTextInputValueDiff_encode: labeledTextInputValueDiff_encode,
    labeledTextInputValueDiff_decode: labeledTextInputValueDiff_decode,
    stringifyLabeledTextInputValueDiff: stringifyLabeledTextInputValueDiff,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function stringify$7(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return "Variable";
        } else {
            return "NotVariable";
        }
    } else {
        return "VariableWithinEnums(enums)";
    }
}
function updateVariableWithinEnums(f, strategy) {
    if (typeof strategy === "number") {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected VariableWithinEnums");
    } else {
        return /* VariableWithinEnums */ {
            _0: Curry._1(f, strategy._0)
        };
    }
}
var Strategy = {
    stringify: stringify$7,
    updateVariableWithinEnums: updateVariableWithinEnums
};
function stringify$8(param6) {
    var originalLabeledAddText = param6.originalLabeledAddText;
    var param$1 = DataDependency$SmartcutsMacros.DataRef.stringify;
    var arg5 = OptionUtils$SmartcutsMacros.map(param6.selectedLabelIndex, function(prim) {
        return String(prim);
    });
    return "{targetLocator, originalLabeledAddText: " + (function(param$2) {
        return stringifyLabeledAddTextInput(param$1, param$2, originalLabeledAddText);
    }(InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify) + (", selectedLabelIndex: " + (function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg5);
    }("Undefined") + (", playbackFormLabel: " + (param6.playbackFormLabel + (", strategy: " + (stringify$7(param6.strategy) + "}")))))));
}
function isDynamic(param) {
    var strategy = param.strategy;
    return strategy !== 0;
}
function updateConfigWithAuthoringCommandValue(commandValue, config) {
    var match = commandValue.labeledTextInputValueDiff;
    var addText = match.valueDiff;
    if (addText.TAG === /* AddText */ 0) {
        return {
            targetLocator: config.targetLocator,
            originalLabeledAddText: {
                label: match.label,
                addText: addText._0
            },
            selectedLabelIndex: config.selectedLabelIndex,
            playbackFormLabel: config.playbackFormLabel,
            strategy: config.strategy
        };
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: AddTextInputConfig cannot be paired with valueDiff DeleteText(_)");
    }
}
var AddTextInputConfig = {
    Strategy: Strategy,
    stringify: stringify$8,
    isDynamic: isDynamic,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};
function isDynamic$1(param) {
    return false;
}
function stringify$9(param) {
    return "deleteTextInputConfig";
}
function updateConfigWithAuthoringCommandValue$1(commandValue, config) {
    var match = commandValue.labeledTextInputValueDiff.valueDiff;
    if (match.TAG === /* AddText */ 0) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: DeleteTextInputConfig cannot be paired with valueDiff AddText(_)");
    } else {
        return {
            targetLocator: config.targetLocator,
            label: config.label,
            selectedLabelIndex: config.selectedLabelIndex,
            originalDelete: match._0.recording,
            semantics: config.semantics,
            config: config.config
        };
    }
}
var DeleteTextInputConfig = {
    isDynamic: isDynamic$1,
    stringify: stringify$9,
    updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue$1
};
function stringify$10(config) {
    if (config.TAG === /* AddTextInputConfig */ 0) {
        return "AddTextInputConfig(" + (stringify$8(config._0) + ")");
    } else {
        return "DeleteTextInputConfig(_)";
    }
}
function fromAuthoringCommandValue$1(cmdVal) {
    var match = cmdVal.labeledTextInputValueDiff;
    var addText = match.valueDiff;
    var label = match.label;
    var targetLocator = cmdVal.selector;
    if (addText.TAG === /* AddText */ 0) {
        var arg6 = Belt_Option.flatMap(label, InputLabel$SmartcutsMacros.RecordingAndAuthoring.getLabelText);
        return {
            TAG: /* AddTextInputConfig */ 0,
            _0: {
                targetLocator: targetLocator,
                originalLabeledAddText: {
                    label: label,
                    addText: addText._0
                },
                selectedLabelIndex: label !== undefined && label.labels.length !== 0 ? 0 : undefined,
                playbackFormLabel: function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg6);
                }("[Add a label]"),
                strategy: /* NotVariable */ 0
            }
        };
    }
    var match$1 = addText._0;
    var semantics = match$1.semantics;
    return {
        TAG: /* DeleteTextInputConfig */ 1,
        _0: {
            targetLocator: targetLocator,
            label: label,
            selectedLabelIndex: label !== undefined && label.labels.length !== 0 ? 0 : undefined,
            originalDelete: match$1.recording,
            semantics: semantics,
            config: Caml_array.get(semantics, 0)
        }
    };
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, config) {
    var playbackCommand = fromAuthoringCommandValue(commandValue);
    var init = playbackCommand.labeledTextInputValueDiff;
    var tmp;
    var exit = 0;
    var sharedRootDepth;
    var labels;
    var selectedLabelIndex;
    if (config.TAG === /* AddTextInputConfig */ 0) {
        var match = config._0;
        var match$1 = match.originalLabeledAddText.label;
        if (match$1 !== undefined) {
            var selectedLabelIndex$1 = match.selectedLabelIndex;
            if (selectedLabelIndex$1 !== undefined) {
                sharedRootDepth = match$1.sharedRootDepth;
                labels = match$1.labels;
                selectedLabelIndex = selectedLabelIndex$1;
                exit = 1;
            } else {
                tmp = undefined;
            }
        } else {
            tmp = undefined;
        }
    } else {
        var match$2 = config._0;
        var match$3 = match$2.label;
        if (match$3 !== undefined) {
            var selectedLabelIndex$2 = match$2.selectedLabelIndex;
            if (selectedLabelIndex$2 !== undefined) {
                sharedRootDepth = match$3.sharedRootDepth;
                labels = match$3.labels;
                selectedLabelIndex = selectedLabelIndex$2;
                exit = 1;
            } else {
                tmp = undefined;
            }
        } else {
            tmp = undefined;
        }
    }
    if (exit === 1) {
        tmp = {
            selector: Caml_array.get(labels, selectedLabelIndex).selector,
            labelText: Caml_array.get(labels, selectedLabelIndex).labelText,
            sharedRootDepth: sharedRootDepth
        };
    }
    return {
        selector: playbackCommand.selector,
        labeledTextInputValueDiff: {
            label: tmp,
            valueDiff: init.valueDiff
        }
    };
}
var AuthoringConfig = {
    AddTextInputConfig: AddTextInputConfig,
    DeleteTextInputConfig: DeleteTextInputConfig,
    stringify: stringify$10,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};
function t_encode$9(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "originalLabeledAddText",
            labeledAddTextInput_encode(InputLabel$SmartcutsMacros.t_encode, DataDependency$SmartcutsMacros.DataRef.t_encode, v.originalLabeledAddText)
        ],
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "enums",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(Decco.stringToJson, param);
            }, v.enums)
        ]
    ]);
}
function t_decode$9(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var originalLabeledAddText = labeledAddTextInput_decode(InputLabel$SmartcutsMacros.t_decode, DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledAddText"), null));
        if (originalLabeledAddText.TAG === /* Ok */ 0) {
            var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
            if (playbackFormLabel.TAG === /* Ok */ 0) {
                var enums = Decco.optionFromJson(function(param) {
                    return Decco.arrayFromJson(Decco.stringFromJson, param);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "enums"), null));
                if (enums.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            targetLocator: targetLocator._0,
                            originalLabeledAddText: originalLabeledAddText._0,
                            playbackFormLabel: playbackFormLabel._0,
                            enums: enums._0
                        }
                    };
                }
                var e = enums._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".enums" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = playbackFormLabel._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".playbackFormLabel" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = originalLabeledAddText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".originalLabeledAddText" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function fromAuthoringConfig(param7) {
    var strategy = param7.strategy;
    var selectedLabelIndex = param7.selectedLabelIndex;
    var match = param7.originalLabeledAddText;
    var match$1;
    if (typeof strategy === "number") {
        match$1 = strategy !== 0 ? [
            match.addText,
            undefined
        ] : Util$SmartcutsMacros.logAndRaiseJsError("Can't create param descriptor for non-dynamic authoring config");
    } else {
        var enums = strategy._0;
        var arg7 = Belt_Array.get(enums, 0);
        var defaultText = {
            TAG: /* StaticText */ 0,
            _0: function(param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg7);
            }("Expect enums to have at least 1 value")
        };
        match$1 = [
            defaultText,
            enums
        ];
    }
    return {
        targetLocator: param7.targetLocator,
        originalLabeledAddText: {
            label: Belt_Option.flatMap(match.label, function(param) {
                if (selectedLabelIndex === undefined) {
                    return;
                }
                var labels = param.labels;
                return {
                    selector: Caml_array.get(labels, selectedLabelIndex).selector,
                    labelText: Caml_array.get(labels, selectedLabelIndex).labelText,
                    sharedRootDepth: param.sharedRootDepth
                };
            }),
            addText: match$1[0]
        },
        playbackFormLabel: param7.playbackFormLabel,
        enums: match$1[1]
    };
}
var AddTextInputParam = {
    t_encode: t_encode$9,
    t_decode: t_decode$9,
    fromAuthoringConfig: fromAuthoringConfig
};
var ParamDescriptor = {
    AddTextInputParam: AddTextInputParam
};
function t_encode$10(v) {
    return Js_dict.fromArray([
        [
            "targetLocator",
            Selector$SmartcutsMacros.selector_encode(v.targetLocator)
        ],
        [
            "labeledAddTextInput",
            labeledAddTextInput_encode(InputLabel$SmartcutsMacros.t_encode, DataDependency$SmartcutsMacros.DataRef.t_encode, v.labeledAddTextInput)
        ]
    ]);
}
function t_decode$10(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
    if (targetLocator.TAG === /* Ok */ 0) {
        var labeledAddTextInput = labeledAddTextInput_decode(InputLabel$SmartcutsMacros.t_decode, DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledAddTextInput"), null));
        if (labeledAddTextInput.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    targetLocator: targetLocator._0,
                    labeledAddTextInput: labeledAddTextInput._0
                }
            };
        }
        var e = labeledAddTextInput._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labeledAddTextInput" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = targetLocator._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$11(param) {
    return "{targetLocator, labeledAddTextInput: " + (stringifyLabeledAddTextInput(DataDependency$SmartcutsMacros.DataRef.stringify, InputLabel$SmartcutsMacros.stringify, param.labeledAddTextInput) + "}");
}
function fromParamDescriptor(param) {
    var match = param.originalLabeledAddText;
    return {
        targetLocator: param.targetLocator,
        labeledAddTextInput: {
            label: match.label,
            addText: match.addText
        }
    };
}
function toCommandValueForPlayback(param) {
    var match = param.labeledAddTextInput;
    return {
        selector: param.targetLocator,
        labeledTextInputValueDiff: {
            label: match.label,
            valueDiff: {
                TAG: /* AddText */ 0,
                _0: match.addText
            }
        }
    };
}
function valueForFormInput(param) {
    var addText = param.labeledAddTextInput.addText;
    if (addText.TAG === /* StaticText */ 0) {
        return addText._0;
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented - valueForFormInput for non static text");
    }
}
function paramValueBuilderFromParamDescriptor(param) {
    var originalLabeledAddText = param.originalLabeledAddText;
    var targetLocator = param.targetLocator;
    return function(value) {
        return {
            targetLocator: targetLocator,
            labeledAddTextInput: {
                label: originalLabeledAddText.label,
                addText: value
            }
        };
    };
}
var AddTextInputParam$1 = {
    t_encode: t_encode$10,
    t_decode: t_decode$10,
    stringify: stringify$11,
    fromParamDescriptor: fromParamDescriptor,
    toCommandValueForPlayback: toCommandValueForPlayback,
    valueForFormInput: valueForFormInput,
    paramValueBuilderFromParamDescriptor: paramValueBuilderFromParamDescriptor
};
var PlaybackParamValue = {
    AddTextInputParam: AddTextInputParam$1
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 91028:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "tabRef",
            InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v.tabRef)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
        if (title.TAG === /* Ok */ 0) {
            var tabRef = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabRef"), null));
            if (tabRef.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        url: url._0,
                        title: title._0,
                        tabRef: tabRef._0
                    }
                };
            }
            var e = tabRef._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".tabRef" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = title._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".title" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{url: '" + (param.url + ("', tabRef: " + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(param.tabRef) + (", title: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.title) + "}")))));
}
var CommandValue = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function execute(param, param$1, param$2) {
    var url = param$2.url;
    var tabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabIdExn(param$2.tabRef);
    return Browser__Tabs$SmartcutsMacros.updateTab(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(tabId), url, undefined, undefined, undefined, undefined, undefined, undefined, undefined).then(function(tab) {
        return Promise.resolve([
            url,
            tab,
            tabId
        ]);
    });
}
var CommandControlBg = {
    execute: execute
};
function fromAuthoringCommandValue(param) {
    var url = param.url;
    return {
        originalUrl: url,
        urlCommandType: {
            TAG: /* URLCommand */ 2,
            _0: param.tabRef
        },
        urlConfig: UrlConstraint$SmartcutsMacros.flexibleMatchFromUrlString(url)
    };
}
var AuthoringConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
exports.CommandValue = CommandValue;
exports.CommandControlBg = CommandControlBg;
exports.AuthoringConfig = AuthoringConfig; /* Browser__Tabs-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 68210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Js_math = __webpack_require__(84763);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Pervasives = __webpack_require__(78942);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var InputLabel$SmartcutsMacros = __webpack_require__(43647);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var DOM__FileInputElement$SmartcutsMacros = __webpack_require__(40542);
var fakePath = "C:\\fakepath\\";
function fileInputElement_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "accept",
            Decco.optionToJson(Decco.stringToJson, v.accept)
        ],
        [
            "isVisibleOnPage",
            Decco.boolToJson(v.isVisibleOnPage)
        ]
    ]);
}
function fileUpload_encode(encoder_fileInfo, v) {
    return [
        "SingleFile",
        Curry._1(encoder_fileInfo, v._0)
    ];
}
function fileInputElement_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var accept = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "accept"), null));
        if (accept.TAG === /* Ok */ 0) {
            var isVisibleOnPage = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isVisibleOnPage"), null));
            if (isVisibleOnPage.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        accept: accept._0,
                        isVisibleOnPage: isVisibleOnPage._0
                    }
                };
            }
            var e = isVisibleOnPage._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".isVisibleOnPage" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = accept._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".accept" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fileUpload_decode(decoder_fileInfo, v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SingleFile") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = Curry._1(decoder_fileInfo, Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* SingleFile */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode(encoder_fileInfo, encoder_inputLabel, v) {
    return Js_dict.fromArray([
        [
            "fileUpload",
            fileUpload_encode(encoder_fileInfo, v.fileUpload)
        ],
        [
            "fileInputElement",
            fileInputElement_encode(v.fileInputElement)
        ],
        [
            "label",
            Decco.optionToJson(encoder_inputLabel, v.label)
        ]
    ]);
}
function t_decode(decoder_fileInfo, decoder_inputLabel, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var fileUpload = fileUpload_decode(decoder_fileInfo, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileUpload"), null));
    if (fileUpload.TAG === /* Ok */ 0) {
        var fileInputElement = fileInputElement_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileInputElement"), null));
        if (fileInputElement.TAG === /* Ok */ 0) {
            var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
            if (label.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        fileUpload: fileUpload._0,
                        fileInputElement: fileInputElement._0,
                        label: label._0
                    }
                };
            }
            var e = label._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".label" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = fileInputElement._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".fileInputElement" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = fileUpload._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".fileUpload" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringifyFileInpuElement(param) {
    return "{ selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", accept: " + (OptionUtils$SmartcutsMacros.stringify(function(x) {
        return x;
    }, param.accept) + (", isVisibleOnPage: " + (Pervasives.string_of_bool(param.isVisibleOnPage) + " }")))));
}
function stringify(stringifyFileInfo1, stringifyLabel, param) {
    return "{ fileUpload: " + ("SingleFile(" + (Curry._1(stringifyFileInfo1, param.fileUpload._0) + ")") + (", fileInputElement: " + (stringifyFileInpuElement(param.fileInputElement) + (", label: " + (OptionUtils$SmartcutsMacros.stringify(stringifyLabel, param.label) + " }")))));
}
var Generic = {
    t_encode: t_encode,
    t_decode: t_decode,
    fileInputElement_encode: fileInputElement_encode,
    fileInputElement_decode: fileInputElement_decode,
    fileUpload_encode: fileUpload_encode,
    fileUpload_decode: fileUpload_decode,
    stringifyFileInpuElement: stringifyFileInpuElement,
    stringify: stringify
};
function fileInfo_encode(v) {
    return Js_dict.fromArray([
        [
            "originalFileName",
            Decco.stringToJson(v.originalFileName)
        ],
        [
            "originalFileType",
            Decco.stringToJson(v.originalFileType)
        ]
    ]);
}
function fileInfo_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalFileName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFileName"), null));
    if (originalFileName.TAG === /* Ok */ 0) {
        var originalFileType = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFileType"), null));
        if (originalFileType.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    originalFileName: originalFileName._0,
                    originalFileType: originalFileType._0
                }
            };
        }
        var e = originalFileType._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".originalFileType" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = originalFileName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalFileName" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$1(v) {
    return t_encode(fileInfo_encode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v);
}
function t_decode$1(v) {
    return t_decode(fileInfo_decode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, v);
}
function stringifyFileInfo(param) {
    return "{ originalFileName: " + (param.originalFileName + (", originalFileType: " + (param.originalFileType + " }")));
}
function stringify$1(param) {
    return stringify(stringifyFileInfo, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param);
}
function fromFileAndInputElment(file, inputElement) {
    var selector = Selector$SmartcutsMacros.forDomElement(inputElement);
    var arg = DOM__FileInputElement$SmartcutsMacros.ofElement(inputElement);
    var fileInputElement = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect to get file input from element");
    var partial_arg = /_+/g;
    var partial_arg$1 = function partial_arg$1(param) {
        return param.replace(partial_arg, " ");
    };
    var label = OptionUtils$SmartcutsMacros.map(InputLabel$SmartcutsMacros.RecordingAndAuthoring.forHtmlInputElement(inputElement), function(param) {
        return InputLabel$SmartcutsMacros.RecordingAndAuthoring.mapAllLabelTexts(partial_arg$1, param);
    });
    var accept = fileInputElement.accept;
    var accept$1 = accept === "" ? undefined : accept;
    var isVisibleOnPage = false;
    if (DOM__Element$SmartcutsMacros.isVisibleInViewport(inputElement)) {
        var match = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(inputElement);
        isVisibleOnPage = Caml_obj.caml_equal(Caml_option.nullable_to_opt(document.elementFromPoint(Js_math.floor(match[0]), Js_math.floor(match[1]))), Caml_option.some(inputElement));
    }
    return {
        fileUpload: /* SingleFile */ {
            _0: {
                originalFileName: file.name,
                originalFileType: file.type
            }
        },
        fileInputElement: {
            selector: selector,
            accept: accept$1,
            isVisibleOnPage: isVisibleOnPage
        },
        label: label
    };
}
function fromInputEvent(inputEvent) {
    var target = inputEvent.target;
    var arg = DOM__FileInputElement$SmartcutsMacros.ofElement(target);
    var fileInputElement = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect to get file input from element");
    var arg$1 = fileInputElement.files.item(0);
    var file = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
    }("Expect to get first file from file input");
    return fromFileAndInputElment(file, target);
}
var Recording = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    fileInfo_encode: fileInfo_encode,
    fileInfo_decode: fileInfo_decode,
    stringifyFileInfo: stringifyFileInfo,
    stringify: stringify$1,
    fromFileAndInputElment: fromFileAndInputElment,
    fromInputEvent: fromInputEvent
};
function t_encode$2(v) {
    return t_encode(fileInfo_encode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v);
}
function t_decode$2(v) {
    return t_decode(fileInfo_decode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, v);
}
function stringify$2(param) {
    return stringify(stringifyFileInfo, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param);
}
function fromRecordingCommandValue(param) {
    return {
        fileUpload: param.fileUpload,
        fileInputElement: param.fileInputElement,
        label: param.label
    };
}
function getIdentifier(param) {
    return Selector$SmartcutsMacros.stringify(undefined, false, param.fileInputElement.selector);
}
var Authoring = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    stringify: stringify$2,
    fromRecordingCommandValue: fromRecordingCommandValue,
    getIdentifier: getIdentifier
};
function fileObject_encode(v) {
    return Js_dict.fromArray([
        [
            "objectUrl",
            Decco.stringToJson(v.objectUrl)
        ],
        [
            "fileName",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.fileName)
        ]
    ]);
}
function fileObject_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var objectUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "objectUrl"), null));
    if (objectUrl.TAG === /* Ok */ 0) {
        var fileName = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileName"), null));
        if (fileName.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    objectUrl: objectUrl._0,
                    fileName: fileName._0
                }
            };
        }
        var e = fileName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".fileName" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = objectUrl._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".objectUrl" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function fileInfo_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FileObject":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = fileObject_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FileObject */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "FileReference":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FileReference */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function fileInfo_encode$1(v) {
    if (v.TAG === /* FileObject */ 0) {
        return [
            "FileObject",
            fileObject_encode(v._0)
        ];
    } else {
        return [
            "FileReference",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
        ];
    }
}
function t_encode$3(v) {
    return t_encode(fileInfo_encode$1, InputLabel$SmartcutsMacros.t_encode, v);
}
function t_decode$3(v) {
    return t_decode(fileInfo_decode$1, InputLabel$SmartcutsMacros.t_decode, v);
}
function stringifyFileInfo$1(fileInfo) {
    if (fileInfo.TAG === /* FileObject */ 0) {
        return "FileObject(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, fileInfo._0.fileName) + ")");
    } else {
        return "FileReference(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, fileInfo._0) + ")");
    }
}
function stringify$3(param) {
    return stringify(stringifyFileInfo$1, InputLabel$SmartcutsMacros.stringify, param);
}
function fromAuthoringCommandValue(param) {
    var fileUpload$p = /* SingleFile */ {
        _0: {
            TAG: /* FileReference */ 1,
            _0: {
                TAG: /* StaticText */ 0,
                _0: fakePath + param.fileUpload._0.originalFileName
            }
        }
    };
    return {
        fileUpload: fileUpload$p,
        fileInputElement: param.fileInputElement,
        label: Belt_Option.map(param.label, InputLabel$SmartcutsMacros.fromRecordingAndAuthoring)
    };
}
var Playback = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    fileInfo_encode: fileInfo_encode$1,
    fileInfo_decode: fileInfo_decode$1,
    fileObject_encode: fileObject_encode,
    fileObject_decode: fileObject_decode,
    stringifyFileInfo: stringifyFileInfo$1,
    stringify: stringify$3,
    fromAuthoringCommandValue: fromAuthoringCommandValue
};
function selectorGet(param) {
    return [
        param.fileInputElement.selector
    ];
}
function mapSelector(f, commandValue) {
    var fileInputElement = commandValue.fileInputElement;
    return {
        fileUpload: commandValue.fileUpload,
        fileInputElement: {
            selector: Curry._1(f, fileInputElement.selector),
            accept: fileInputElement.accept,
            isVisibleOnPage: fileInputElement.isVisibleOnPage
        },
        label: commandValue.label
    };
}
var CommandValue = {
    Generic: Generic,
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback,
    selectorGet: selectorGet,
    mapSelector: mapSelector
};
function updateConfigWithPlaybackFormLabel(config, playbackFormLabel) {
    return {
        originalFileName: config.originalFileName,
        label: config.label,
        selectedLabelIndex: config.selectedLabelIndex,
        playbackFormLabel: playbackFormLabel,
        accept: config.accept
    };
}
function isDynamic(param) {
    return true;
}
function mapDataRef(config, param) {
    return config;
}
function fromCommandValue(param1) {
    var label = param1.label;
    var arg = Belt_Option.flatMap(label, InputLabel$SmartcutsMacros.RecordingAndAuthoring.getLabelText);
    return {
        originalFileName: param1.fileUpload._0.originalFileName,
        label: label,
        selectedLabelIndex: undefined,
        playbackFormLabel: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }("[Add a label]"),
        accept: param1.fileInputElement.accept
    };
}
var AuthoringConfig = {
    updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
    isDynamic: isDynamic,
    mapDataRef: mapDataRef,
    fromCommandValue: fromCommandValue
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "accept",
            Decco.optionToJson(Decco.stringToJson, v.accept)
        ],
        [
            "fullPath",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.fullPath)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */ 0) {
        var accept = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "accept"), null));
        if (accept.TAG === /* Ok */ 0) {
            var fullPath = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fullPath"), null));
            if (fullPath.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        playbackFormLabel: playbackFormLabel._0,
                        accept: accept._0,
                        fullPath: fullPath._0
                    }
                };
            }
            var e = fullPath._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".fullPath" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = accept._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".accept" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = playbackFormLabel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        playbackFormLabel: param.playbackFormLabel,
        accept: param.accept,
        fullPath: {
            TAG: /* StaticText */ 0,
            _0: fakePath + param.originalFileName
        }
    };
}
function getPlaybackFormLabelFromParam(param) {
    return param.playbackFormLabel;
}
var ParamDescriptor = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    fromAuthoringConfig: fromAuthoringConfig,
    getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam
};
var t_encode$5 = fileInfo_encode$1;
var t_decode$5 = fileInfo_decode$1;
function fromParamDescriptor(param) {
    return {
        TAG: /* FileReference */ 1,
        _0: param.fullPath
    };
}
function toPlaybackCommandValue(oldCommandValue, fileInfo) {
    return {
        fileUpload: /* SingleFile */ {
            _0: fileInfo
        },
        fileInputElement: oldCommandValue.fileInputElement,
        label: oldCommandValue.label
    };
}
var stringify$4 = stringifyFileInfo$1;
function hasUserSetTheFileReference(dataRef) {
    return !Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, dataRef).startsWith(fakePath);
}
var PlaybackParamValue = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    fromParamDescriptor: fromParamDescriptor,
    toPlaybackCommandValue: toPlaybackCommandValue,
    stringify: stringify$4,
    hasUserSetTheFileReference: hasUserSetTheFileReference
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 10160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Caml_module = __webpack_require__(27236);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var STEM__Client$SmartcutsMacros = __webpack_require__(97563);
var PromisedValue$SmartcutsMacros = __webpack_require__(19949);
var PaginateOptions$SmartcutsMacros = __webpack_require__(1555);
var STEM__Interfaces$SmartcutsMacros = __webpack_require__(32985);
var DataExtraction__DataRecord$SmartcutsMacros = __webpack_require__(57870);
var DataExtraction__ExportToTable$SmartcutsMacros = __webpack_require__(87148);
var DataExtraction__DataRecord__Types$SmartcutsMacros = __webpack_require__(36589);
function dataNodeId_encode(v) {
    return DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v);
}
function dataNodeId_decode(v) {
    return DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(v);
}
function htmlTagPathIdentifier_encode(v) {
    return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v);
}
function htmlTagPathIdentifier_decode(v) {
    return STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(v);
}
function googleSheet_encode(v) {
    return Js_dict.fromArray([
        [
            "spreadsheetId",
            Decco.stringToJson(v.spreadsheetId)
        ],
        [
            "spreadsheetName",
            Decco.stringToJson(v.spreadsheetName)
        ],
        [
            "spreadsheetUrl",
            Decco.stringToJson(v.spreadsheetUrl)
        ],
        [
            "worksheetName",
            Decco.stringToJson(v.worksheetName)
        ]
    ]);
}
function googleSheet_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
    if (spreadsheetId.TAG === /* Ok */ 0) {
        var spreadsheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetName"), null));
        if (spreadsheetName.TAG === /* Ok */ 0) {
            var spreadsheetUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetUrl"), null));
            if (spreadsheetUrl.TAG === /* Ok */ 0) {
                var worksheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "worksheetName"), null));
                if (worksheetName.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            spreadsheetId: spreadsheetId._0,
                            spreadsheetName: spreadsheetName._0,
                            spreadsheetUrl: spreadsheetUrl._0,
                            worksheetName: worksheetName._0
                        }
                    };
                }
                var e = worksheetName._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".worksheetName" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = spreadsheetUrl._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".spreadsheetUrl" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = spreadsheetName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".spreadsheetName" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = spreadsheetId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function snapshotOfDataExported_encode(v) {
    return Js_dict.fromArray([
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
            }, v.columns)
        ],
        [
            "rows",
            Decco.arrayToJson(function(param1) {
                return Decco.arrayToJson(function(param) {
                    return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                }, param1);
            }, v.rows)
        ]
    ]);
}
function snapshotOfDataExported_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var columns = Decco.arrayFromJson(function(param) {
        return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
    }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */ 0) {
        var rows = Decco.arrayFromJson(function(param2) {
            return Decco.arrayFromJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
            }, param2);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
        if (rows.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    columns: columns._0,
                    rows: rows._0
                }
            };
        }
        var e = rows._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".rows" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = columns._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".columns" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var HtpiByTagPathString = Caml_module.init_mod([
    "WithElementGroupsCommand.re",
    32,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "lookupByTagPath"
        ],
        [
            /* Function */ 0,
            "fromDataRecordPatterns"
        ]
    ]
});
var DataRecordPattern = Caml_module.init_mod([
    "WithElementGroupsCommand.re",
    84,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "subPattern_encode"
                    ],
                    [
                        /* Function */ 0,
                        "subPattern_decode"
                    ]
                ]
            },
            "TagPaths"
        ],
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "doesMatchDataRegionGroup"
        ]
    ]
});
function lookupByTagPath(htpiByTagPathString, tagPath) {
    return List.assoc_opt(STEM__Client$SmartcutsMacros.HtmlTagPath.toTagPathString(tagPath), htpiByTagPathString);
}
function fromDataRecordPatterns(dataRecordPatterns) {
    return $$Array.to_list(ArrayUtils$SmartcutsMacros.flatMap(function(dataRecordPattern) {
        var match = dataRecordPattern._0;
        var rootPath = match.rootPath;
        return Belt_Array.map(match.subPatterns, function(param) {
            return [
                Belt_Array.concat(rootPath, param.path).join(">"),
                param.id
            ];
        });
    }, dataRecordPatterns));
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "lookupByTagPath"
        ],
        [
            /* Function */ 0,
            "fromDataRecordPatterns"
        ]
    ]
}, HtpiByTagPathString, {
    lookupByTagPath: lookupByTagPath,
    fromDataRecordPatterns: fromDataRecordPatterns
});
function subPattern_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var path = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
        if (path.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    id: id._0,
                    path: path._0
                }
            };
        }
        var e = path._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".path" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function subPattern_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.id)
        ],
        [
            "path",
            Decco.arrayToJson(Decco.stringToJson, v.path)
        ]
    ]);
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "rootPath",
            Decco.arrayToJson(Decco.stringToJson, v.rootPath)
        ],
        [
            "subPatterns",
            Decco.arrayToJson(subPattern_encode, v.subPatterns)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var rootPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rootPath"), null));
    if (rootPath.TAG === /* Ok */ 0) {
        var subPatterns = Decco.arrayFromJson(subPattern_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subPatterns"), null));
        if (subPatterns.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    rootPath: rootPath._0,
                    subPatterns: subPatterns._0
                }
            };
        }
        var e = subPatterns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".subPatterns" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = rootPath._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".rootPath" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var TagPaths = {
    t_encode: t_encode,
    t_decode: t_decode,
    subPattern_encode: subPattern_encode,
    subPattern_decode: subPattern_decode
};
function t_encode$1(v) {
    return [
        "TagPaths",
        t_encode(v._0)
    ];
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "TagPaths") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* TagPaths */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function doesMatchDataRegionGroup(firstDataRecordPatternOfRecording, dataRegionGroup, client, htmlTagPathIdentifierByTagPathString) {
    var subPatterns = firstDataRecordPatternOfRecording._0.subPatterns;
    return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(dataRegionGroup, 0), function(firstDataRegion) {
        return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(Curry._2(STEM__Client$SmartcutsMacros.DataRegion.getNodes, client, firstDataRegion), 0), function(param) {
            return Belt_Option.getWithDefault(Belt_Option.map(Curry._2(HtpiByTagPathString.lookupByTagPath, htmlTagPathIdentifierByTagPathString, param.tagPath), function(htpi) {
                return Caml_obj.caml_equal(htpi, Caml_array.get(subPatterns, 0).id);
            }), false);
        }), false);
    }), false);
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "t_encode"
                    ],
                    [
                        /* Function */ 0,
                        "t_decode"
                    ],
                    [
                        /* Function */ 0,
                        "subPattern_encode"
                    ],
                    [
                        /* Function */ 0,
                        "subPattern_decode"
                    ]
                ]
            },
            "TagPaths"
        ],
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "doesMatchDataRegionGroup"
        ]
    ]
}, DataRecordPattern, {
    TagPaths: TagPaths,
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    doesMatchDataRegionGroup: doesMatchDataRegionGroup
});
function condition_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "Todo") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* Todo */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function condition_encode(v) {
    return [
        "Todo"
    ];
}
function keepOnly_encode(v) {
    return Js_dict.fromArray([
        [
            "dataNodeId",
            DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
        ],
        [
            "condition",
            [
                "Todo"
            ]
        ]
    ]);
}
function keepOnly_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
    if (dataNodeId.TAG === /* Ok */ 0) {
        var condition = condition_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "condition"), null));
        if (condition.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    dataNodeId: dataNodeId._0,
                    condition: condition._0
                }
            };
        }
        var e = condition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".condition" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = dataNodeId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataNodeId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$2(v) {
    return [
        "KeepOnly",
        keepOnly_encode(v._0)
    ];
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "KeepOnly") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = keepOnly_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* KeepOnly */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyCondition(condition) {
    return "Todo";
}
function stringify(transducer) {
    return "KeeyOnly({dataNodeId: " + (DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.stringify(transducer._0.dataNodeId) + ", condition: Todo})");
}
var Transducer = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    keepOnly_encode: keepOnly_encode,
    keepOnly_decode: keepOnly_decode,
    condition_encode: condition_encode,
    condition_decode: condition_decode,
    stringifyCondition: stringifyCondition,
    stringify: stringify
};
function destination_encode(v) {
    return [
        "GoogleSheet",
        googleSheet_encode(v._0)
    ];
}
function exportTo_encode(v) {
    return Js_dict.fromArray([
        [
            "destination",
            destination_encode(v.destination)
        ],
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
            }, v.columns)
        ],
        [
            "maybeExtraColumns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
            }, v.maybeExtraColumns)
        ],
        [
            "maybePrimayKeys",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
            }, v.maybePrimayKeys)
        ],
        [
            "snapshotOfDataExported",
            snapshotOfDataExported_encode(v.snapshotOfDataExported)
        ]
    ]);
}
function dataNode_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
    if (tagPath.TAG === /* Ok */ 0) {
        var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
        if (htmlTagPathIdentifier.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    tagPath: tagPath._0,
                    htmlTagPathIdentifier: htmlTagPathIdentifier._0
                }
            };
        }
        var e = htmlTagPathIdentifier._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".htmlTagPathIdentifier" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = tagPath._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tagPath" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function dataRegionResolved_encode(v) {
    return Decco.arrayToJson(dataNode_encode, v);
}
function dataRegionResolved_decode(v) {
    return Decco.arrayFromJson(dataNode_decode, v);
}
function sequenceOfElementsOnPage_encode(v) {
    return Js_dict.fromArray([
        [
            "dataRegionsResolved",
            Decco.arrayToJson(dataRegionResolved_encode, v.dataRegionsResolved)
        ],
        [
            "dataSchema",
            Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_encode, v.dataSchema)
        ]
    ]);
}
function dataNode_encode(v) {
    return Js_dict.fromArray([
        [
            "tagPath",
            Decco.arrayToJson(Decco.stringToJson, v.tagPath)
        ],
        [
            "htmlTagPathIdentifier",
            STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
        ]
    ]);
}
function exportTo_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var destination = destination_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
    if (destination.TAG === /* Ok */ 0) {
        var columns = Decco.arrayFromJson(function(param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
        if (columns.TAG === /* Ok */ 0) {
            var maybeExtraColumns = Decco.optionFromJson(function(param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
            if (maybeExtraColumns.TAG === /* Ok */ 0) {
                var maybePrimayKeys = Decco.optionFromJson(function(param) {
                    return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePrimayKeys"), null));
                if (maybePrimayKeys.TAG === /* Ok */ 0) {
                    var snapshotOfDataExported = snapshotOfDataExported_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "snapshotOfDataExported"), null));
                    if (snapshotOfDataExported.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                destination: destination._0,
                                columns: columns._0,
                                maybeExtraColumns: maybeExtraColumns._0,
                                maybePrimayKeys: maybePrimayKeys._0,
                                snapshotOfDataExported: snapshotOfDataExported._0
                            }
                        };
                    }
                    var e = snapshotOfDataExported._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".snapshotOfDataExported" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = maybePrimayKeys._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".maybePrimayKeys" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = maybeExtraColumns._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeExtraColumns" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = columns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".columns" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = destination._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".destination" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function destination_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "GoogleSheet") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* GoogleSheet */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sequenceOfElementsOnPage_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var dataRegionsResolved = Decco.arrayFromJson(dataRegionResolved_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRegionsResolved"), null));
    if (dataRegionsResolved.TAG === /* Ok */ 0) {
        var dataSchema = Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSchema"), null));
        if (dataSchema.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    dataRegionsResolved: dataRegionsResolved._0,
                    dataSchema: dataSchema._0
                }
            };
        }
        var e = dataSchema._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataSchema" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = dataRegionsResolved._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".dataRegionsResolved" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function action_encode(v) {
    return [
        "ExportTo",
        exportTo_encode(v._0)
    ];
}
function sequence_encode(v) {
    return [
        "SequenceOfElementsOnPage",
        sequenceOfElementsOnPage_encode(v._0)
    ];
}
function action_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = exportTo_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sequence_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SequenceOfElementsOnPage") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = sequenceOfElementsOnPage_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* SequenceOfElementsOnPage */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "sequence",
            sequence_encode(v.sequence)
        ],
        [
            "actions",
            Decco.arrayToJson(action_encode, v.actions)
        ],
        [
            "paginateOptions",
            PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var sequence = sequence_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sequence"), null));
    if (sequence.TAG === /* Ok */ 0) {
        var actions = Decco.arrayFromJson(action_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
        if (actions.TAG === /* Ok */ 0) {
            var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
            if (paginateOptions.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        sequence: sequence._0,
                        actions: actions._0,
                        paginateOptions: paginateOptions._0
                    }
                };
            }
            var e = paginateOptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".paginateOptions" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = actions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".actions" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = sequence._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".sequence" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return "{ seqeuence: SequenceOfElementsOnPage({dataRegionsResolved, dataSchema}), actions: [" + (Belt_Array.map(param.actions, function(action) {
        var match = action._0;
        return "ExportTo({destination: GoogleSheet(_), columns: [n=" + (String(match.columns.length) + ("], exportExtraColumns: [" + (OptionUtils$SmartcutsMacros.stringify(function(exportExtraColumns) {
            return Belt_Array.map(exportExtraColumns, DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.stringify).join(",");
        }, match.maybeExtraColumns) + "]})")));
    }).join(", ") + "] }");
}
function getIdentifier(param) {
    return "collect SequenceOfElementsOnPage";
}
var RecordingAndAuthoring = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    destination_encode: destination_encode,
    destination_decode: destination_decode,
    sequence_encode: sequence_encode,
    sequence_decode: sequence_decode,
    sequenceOfElementsOnPage_encode: sequenceOfElementsOnPage_encode,
    sequenceOfElementsOnPage_decode: sequenceOfElementsOnPage_decode,
    dataRegionResolved_encode: dataRegionResolved_encode,
    dataRegionResolved_decode: dataRegionResolved_decode,
    dataNode_encode: dataNode_encode,
    dataNode_decode: dataNode_decode,
    action_encode: action_encode,
    action_decode: action_decode,
    exportTo_encode: exportTo_encode,
    exportTo_decode: exportTo_decode,
    stringify: stringify$1,
    getIdentifier: getIdentifier
};
function destination_encode$1(v) {
    if (v.TAG === /* ExistingGoogleSheet */ 0) {
        return [
            "ExistingGoogleSheet",
            googleSheet_encode(v._0)
        ];
    } else {
        return [
            "NewGoogleSheet",
            PromisedValue$SmartcutsMacros.t_encode(googleSheet_encode, Decco.stringToJson, v._0)
        ];
    }
}
function exportTo_encode$1(v) {
    return Js_dict.fromArray([
        [
            "destination",
            destination_encode$1(v.destination)
        ],
        [
            "columns",
            Decco.arrayToJson(function(param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
            }, v.columns)
        ],
        [
            "maybeExtraColumns",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
            }, v.maybeExtraColumns)
        ],
        [
            "maybePrimayKeys",
            Decco.optionToJson(function(param) {
                return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
            }, v.maybePrimayKeys)
        ],
        [
            "snapshotOfDataExported",
            snapshotOfDataExported_encode(v.snapshotOfDataExported)
        ]
    ]);
}
function sequenceOfElementsOnPage_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var alias = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alias"), null));
    if (alias.TAG === /* Ok */ 0) {
        var dataRecordPatterns = Decco.arrayFromJson(DataRecordPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecordPatterns"), null));
        if (dataRecordPatterns.TAG === /* Ok */ 0) {
            var dataRecordSchema = Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataRecordSchema"), null));
            if (dataRecordSchema.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        alias: alias._0,
                        dataRecordPatterns: dataRecordPatterns._0,
                        dataRecordSchema: dataRecordSchema._0
                    }
                };
            }
            var e = dataRecordSchema._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".dataRecordSchema" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = dataRecordPatterns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".dataRecordPatterns" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = alias._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".alias" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function sequenceOfElementsOnPage_encode$1(v) {
    return Js_dict.fromArray([
        [
            "alias",
            Decco.optionToJson(Decco.stringToJson, v.alias)
        ],
        [
            "dataRecordPatterns",
            Decco.arrayToJson(DataRecordPattern.t_encode, v.dataRecordPatterns)
        ],
        [
            "dataRecordSchema",
            Curry._1(DataExtraction__DataRecord$SmartcutsMacros.Schema.WithHTPIAndTagPathAndDataNodeId.t_encode, v.dataRecordSchema)
        ]
    ]);
}
function destination_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExistingGoogleSheet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExistingGoogleSheet */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "NewGoogleSheet":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = PromisedValue$SmartcutsMacros.t_decode(googleSheet_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewGoogleSheet */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function exportTo_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var destination = destination_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
    if (destination.TAG === /* Ok */ 0) {
        var columns = Decco.arrayFromJson(function(param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
        }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
        if (columns.TAG === /* Ok */ 0) {
            var maybeExtraColumns = Decco.optionFromJson(function(param) {
                return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
            if (maybeExtraColumns.TAG === /* Ok */ 0) {
                var maybePrimayKeys = Decco.optionFromJson(function(param) {
                    return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePrimayKeys"), null));
                if (maybePrimayKeys.TAG === /* Ok */ 0) {
                    var snapshotOfDataExported = snapshotOfDataExported_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "snapshotOfDataExported"), null));
                    if (snapshotOfDataExported.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                destination: destination._0,
                                columns: columns._0,
                                maybeExtraColumns: maybeExtraColumns._0,
                                maybePrimayKeys: maybePrimayKeys._0,
                                snapshotOfDataExported: snapshotOfDataExported._0
                            }
                        };
                    }
                    var e = snapshotOfDataExported._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".snapshotOfDataExported" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = maybePrimayKeys._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".maybePrimayKeys" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = maybeExtraColumns._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeExtraColumns" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = columns._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".columns" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = destination._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".destination" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function iteratorStrategy_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "PaginateAllFirstThenAct") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* PaginateAllFirstThenAct */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function action_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = exportTo_decode$1(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function sequence_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "SequenceOfElementsOnPage") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = sequenceOfElementsOnPage_decode$1(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* SequenceOfElementsOnPage */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function iteratorStrategy_encode(v) {
    return [
        "PaginateAllFirstThenAct"
    ];
}
function sequence_encode$1(v) {
    return [
        "SequenceOfElementsOnPage",
        sequenceOfElementsOnPage_encode$1(v._0)
    ];
}
function action_encode$1(v) {
    return [
        "ExportTo",
        exportTo_encode$1(v._0)
    ];
}
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "sequence",
            sequence_encode$1(v.sequence)
        ],
        [
            "iteratorStrategy",
            [
                "PaginateAllFirstThenAct"
            ]
        ],
        [
            "paginateOptions",
            PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
        ],
        [
            "transducers",
            Decco.arrayToJson(t_encode$2, v.transducers)
        ],
        [
            "actions",
            Decco.arrayToJson(action_encode$1, v.actions)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var sequence = sequence_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sequence"), null));
    if (sequence.TAG === /* Ok */ 0) {
        var iteratorStrategy = iteratorStrategy_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "iteratorStrategy"), null));
        if (iteratorStrategy.TAG === /* Ok */ 0) {
            var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
            if (paginateOptions.TAG === /* Ok */ 0) {
                var transducers = Decco.arrayFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "transducers"), null));
                if (transducers.TAG === /* Ok */ 0) {
                    var actions = Decco.arrayFromJson(action_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
                    if (actions.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                sequence: sequence._0,
                                iteratorStrategy: iteratorStrategy._0,
                                paginateOptions: paginateOptions._0,
                                transducers: transducers._0,
                                actions: actions._0
                            }
                        };
                    }
                    var e = actions._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".actions" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = transducers._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".transducers" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = paginateOptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".paginateOptions" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = iteratorStrategy._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".iteratorStrategy" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = sequence._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".sequence" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
function stringifyDestination(destination) {
    if (destination.TAG === /* ExistingGoogleSheet */ 0) {
        return "ExistingGoogleSheet(_)";
    } else {
        return "NewGoogleSheet(_)";
    }
}
function stringifyAction(action) {
    var match = action._0;
    return "ExportTo({destination: " + (stringifyDestination(match.destination) + (", columns: [n=" + (String(match.columns.length) + "]})")));
}
function stringify$2(param) {
    return "{ sequence: SequenceOfElementsOnPage({alias, dataRecordPatterns, dataRecordSchema}), iteratorStrategy: PaginateAllFirstThenAct, paginate: " + (PaginateOptions$SmartcutsMacros.stringify(param.paginateOptions) + (", transducers: [" + (Belt_Array.map(param.transducers, stringify).join(", ") + ("], actions: " + (Belt_Array.map(param.actions, stringifyAction).join(", ") + "]}")))));
}
function fromRecordingAuthoring(param3) {
    var match1 = param3.sequence._0;
    var dataSchema = match1.dataSchema;
    return {
        sequence: /* SequenceOfElementsOnPage */ {
            _0: {
                alias: dataSchema.friendlyName,
                dataRecordPatterns: Belt_Array.map(match1.dataRegionsResolved, function(dataRegionResolved) {
                    return /* TagPaths */ {
                        _0: {
                            rootPath: [],
                            subPatterns: Belt_Array.map(dataRegionResolved, function(param) {
                                return {
                                    id: param.htmlTagPathIdentifier,
                                    path: param.tagPath
                                };
                            })
                        }
                    };
                }),
                dataRecordSchema: dataSchema
            }
        },
        iteratorStrategy: /* PaginateAllFirstThenAct */ 0,
        paginateOptions: param3.paginateOptions,
        transducers: [],
        actions: Belt_Array.map(param3.actions, function(action) {
            var match = action._0;
            return /* ExportTo */ {
                _0: {
                    destination: {
                        TAG: /* ExistingGoogleSheet */ 0,
                        _0: match.destination._0
                    },
                    columns: match.columns,
                    maybeExtraColumns: match.maybeExtraColumns,
                    maybePrimayKeys: match.maybePrimayKeys,
                    snapshotOfDataExported: match.snapshotOfDataExported
                }
            };
        })
    };
}
var Playback = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    sequence_encode: sequence_encode$1,
    sequence_decode: sequence_decode$1,
    sequenceOfElementsOnPage_encode: sequenceOfElementsOnPage_encode$1,
    sequenceOfElementsOnPage_decode: sequenceOfElementsOnPage_decode$1,
    iteratorStrategy_encode: iteratorStrategy_encode,
    iteratorStrategy_decode: iteratorStrategy_decode,
    action_encode: action_encode$1,
    action_decode: action_decode$1,
    destination_encode: destination_encode$1,
    destination_decode: destination_decode$1,
    exportTo_encode: exportTo_encode$1,
    exportTo_decode: exportTo_decode$1,
    stringifyDestination: stringifyDestination,
    stringifyAction: stringifyAction,
    stringify: stringify$2,
    fromRecordingAuthoring: fromRecordingAuthoring
};
var CommandValue = {
    RecordingAndAuthoring: RecordingAndAuthoring,
    Playback: Playback
};
function action_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = destination_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function action_encode$2(v) {
    return [
        "ExportTo",
        destination_encode(v._0)
    ];
}
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "actions",
            Decco.arrayToJson(action_encode$2, v.actions)
        ],
        [
            "paginateOptions",
            PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */ 0) {
        var actions = Decco.arrayFromJson(action_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
        if (actions.TAG === /* Ok */ 0) {
            var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
            if (paginateOptions.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        playbackFormLabel: playbackFormLabel._0,
                        actions: actions._0,
                        paginateOptions: paginateOptions._0
                    }
                };
            }
            var e = paginateOptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".paginateOptions" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = actions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".actions" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = playbackFormLabel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromCommandValue(param) {
    return {
        playbackFormLabel: "Collect data from elements on page",
        actions: Belt_Array.map(param.actions, function(action) {
            return /* ExportTo */ {
                _0: action._0.destination
            };
        }),
        paginateOptions: param.paginateOptions
    };
}
function updateConfigWithPlaybackFormLabel(playbackFormLabel, authoringConfig) {
    return {
        playbackFormLabel: playbackFormLabel,
        actions: authoringConfig.actions,
        paginateOptions: authoringConfig.paginateOptions
    };
}
function isDynamic(_authoringConfig) {
    return true;
}
var AuthoringConfig = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    action_encode: action_encode$2,
    action_decode: action_decode$2,
    fromCommandValue: fromCommandValue,
    updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
    isDynamic: isDynamic
};
function action_decode$3(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = destination_decode$1(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function action_encode$3(v) {
    return [
        "ExportTo",
        destination_encode$1(v._0)
    ];
}
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "actions",
            Decco.arrayToJson(action_encode$3, v.actions)
        ],
        [
            "paginateOptions",
            PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */ 0) {
        var actions = Decco.arrayFromJson(action_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
        if (actions.TAG === /* Ok */ 0) {
            var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
            if (paginateOptions.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        playbackFormLabel: playbackFormLabel._0,
                        actions: actions._0,
                        paginateOptions: paginateOptions._0
                    }
                };
            }
            var e = paginateOptions._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".paginateOptions" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = actions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".actions" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = playbackFormLabel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringConfig(param) {
    return {
        playbackFormLabel: param.playbackFormLabel,
        actions: Belt_Array.map(param.actions, function(action) {
            return /* ExportTo */ {
                _0: {
                    TAG: /* ExistingGoogleSheet */ 0,
                    _0: action._0._0
                }
            };
        }),
        paginateOptions: param.paginateOptions
    };
}
function getPlaybackFormLabelFromParam(param) {
    return param.playbackFormLabel;
}
function removePrivateInfo(withElementGroupsParam) {
    return {
        playbackFormLabel: withElementGroupsParam.playbackFormLabel,
        actions: Belt_Array.map(withElementGroupsParam.actions, function(action) {
            return /* ExportTo */ {
                _0: {
                    TAG: /* NewGoogleSheet */ 1,
                    _0: {
                        TAG: /* Pending */ 1,
                        _0: "Insert sheet name here"
                    }
                }
            };
        }),
        paginateOptions: withElementGroupsParam.paginateOptions
    };
}
var ParamDescriptor = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    action_encode: action_encode$3,
    action_decode: action_decode$3,
    fromAuthoringConfig: fromAuthoringConfig,
    getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
    removePrivateInfo: removePrivateInfo
};
function action_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = destination_decode$1(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function action_encode$4(v) {
    return [
        "ExportTo",
        destination_encode$1(v._0)
    ];
}
var destination_decode$2 = destination_decode$1;
var destination_encode$2 = destination_encode$1;
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "actions",
            Decco.arrayToJson(action_encode$4, v.actions)
        ],
        [
            "paginateOptions",
            PaginateOptions$SmartcutsMacros.t_encode(v.paginateOptions)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var actions = Decco.arrayFromJson(action_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actions"), null));
    if (actions.TAG === /* Ok */ 0) {
        var paginateOptions = PaginateOptions$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateOptions"), null));
        if (paginateOptions.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    actions: actions._0,
                    paginateOptions: paginateOptions._0
                }
            };
        }
        var e = paginateOptions._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".paginateOptions" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = actions._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".actions" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$3(param) {
    return "{ action: [" + (Belt_Array.map(param.actions, function(action) {
        return "ExportTo(" + (stringifyDestination(action._0) + ")");
    }).join(", ") + "] }");
}
function fromParamDescriptor(param) {
    return {
        actions: Belt_Array.map(param.actions, function(action) {
            return /* ExportTo */ {
                _0: action._0
            };
        }),
        paginateOptions: param.paginateOptions
    };
}
function toPlaybackCommandValue(oldCommandValue, param4) {
    var actions = param4.actions;
    return {
        sequence: oldCommandValue.sequence,
        iteratorStrategy: oldCommandValue.iteratorStrategy,
        paginateOptions: param4.paginateOptions,
        transducers: oldCommandValue.transducers,
        actions: Belt_Array.map(Belt_Array.zip(oldCommandValue.actions, ArrayUtils$SmartcutsMacros.fillTo(Belt_Array.map(actions, function(action) {
            return action;
        }), oldCommandValue.actions.length - actions.length | 0, undefined)), function(param) {
            var actionParamValue = param[1];
            var action = param[0];
            if (actionParamValue === undefined) {
                return action;
            }
            var exportTo = action._0;
            return /* ExportTo */ {
                _0: {
                    destination: actionParamValue._0,
                    columns: exportTo.columns,
                    maybeExtraColumns: exportTo.maybeExtraColumns,
                    maybePrimayKeys: exportTo.maybePrimayKeys,
                    snapshotOfDataExported: exportTo.snapshotOfDataExported
                }
            };
        })
    };
}
function updateDestination_encode(v) {
    return [
        "GoogleSheetResolved",
        googleSheet_encode(v._0)
    ];
}
function updateDestination_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "GoogleSheetResolved") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = googleSheet_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* GoogleSheetResolved */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function updateAction_encode(v) {
    return [
        "ExportTo",
        updateDestination_encode(v._0)
    ];
}
function updateAction_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ExportTo") {
        if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        }
        var v0 = updateDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
        if (v0.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: /* ExportTo */ {
                    _0: v0._0
                }
            };
        }
        var e = v0._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[0]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$8(v) {
    return Js_dict.fromArray([
        [
            "actions",
            CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(updateAction_encode, v.actions)
        ]
    ]);
}
function t_decode$8(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var actions = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(updateAction_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "actions"), null));
    if (actions.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                actions: actions._0
            }
        };
    }
    var e = actions._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".actions" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function apply(paramValue, update) {
    return {
        actions: Belt_Array.reduce(Belt_MapInt.toArray(update.actions), paramValue.actions, function(actions, param) {
            var index = param[0];
            var match = Belt_Array.get(actions, index);
            if (match === undefined) {
                return actions;
            }
            var match$1 = match._0;
            if (match$1.TAG === /* ExistingGoogleSheet */ 0 || match$1._0.TAG === /* Resolved */ 0) {
                return actions;
            } else {
                return ArrayUtils$SmartcutsMacros.replaceAtIndex(actions, index, /* ExportTo */ {
                    _0: {
                        TAG: /* NewGoogleSheet */ 1,
                        _0: {
                            TAG: /* Resolved */ 0,
                            _0: param[1]._0._0
                        }
                    }
                });
            }
        }),
        paginateOptions: paramValue.paginateOptions
    };
}
var Update = {
    t_encode: t_encode$8,
    t_decode: t_decode$8,
    updateAction_encode: updateAction_encode,
    updateAction_decode: updateAction_decode,
    updateDestination_encode: updateDestination_encode,
    updateDestination_decode: updateDestination_decode,
    apply: apply
};
var PlaybackParamValue = {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    action_encode: action_encode$4,
    action_decode: action_decode$4,
    destination_encode: destination_encode$2,
    destination_decode: destination_decode$2,
    stringify: stringify$3,
    fromParamDescriptor: fromParamDescriptor,
    toPlaybackCommandValue: toPlaybackCommandValue,
    Update: Update
};
var unknownSpreadsheet = "Unknown";
exports.unknownSpreadsheet = unknownSpreadsheet;
exports.dataNodeId_encode = dataNodeId_encode;
exports.dataNodeId_decode = dataNodeId_decode;
exports.htmlTagPathIdentifier_encode = htmlTagPathIdentifier_encode;
exports.htmlTagPathIdentifier_decode = htmlTagPathIdentifier_decode;
exports.googleSheet_encode = googleSheet_encode;
exports.googleSheet_decode = googleSheet_decode;
exports.snapshotOfDataExported_encode = snapshotOfDataExported_encode;
exports.snapshotOfDataExported_decode = snapshotOfDataExported_decode;
exports.HtpiByTagPathString = HtpiByTagPathString;
exports.DataRecordPattern = DataRecordPattern;
exports.Transducer = Transducer;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* HtpiByTagPathString Not a pure module */ 


/***/ }),

/***/ 68998:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selection__ContentEditableCursor$SmartcutsMacros = __webpack_require__(43378);
var SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros = __webpack_require__(21014);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "contentEditableCursor",
            Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v.contentEditableCursor)
        ],
        [
            "semantics",
            SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var contentEditableCursor = Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableCursor"), null));
    if (contentEditableCursor.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__ContentEditableCursorSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    contentEditableCursor: contentEditableCursor._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = contentEditableCursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".contentEditableCursor" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function updateSelector(f, param) {
    return {
        contentEditableCursor: Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, param.contentEditableCursor),
        semantics: param.semantics
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.updateSelector = updateSelector; /* Selection__ContentEditableCursor-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 22142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var ContentScriptPlayback__FocusElement$SmartcutsMacros = __webpack_require__(86481);
function dispatchMouseEvent(buttonOpt, buttonsOpt, clientX, clientY, htmlElement, eventName) {
    var button = buttonOpt !== undefined ? buttonOpt : 0;
    var buttons = buttonsOpt !== undefined ? buttonsOpt : 0;
    var mouseEvent = new MouseEvent(eventName, {
        button: button,
        buttons: buttons,
        bubbles: true,
        cancelable: true,
        clientX: clientX,
        clientY: clientY,
        composed: true
    });
    return htmlElement.dispatchEvent(mouseEvent);
}
function click(clientX, clientY, element) {
    $$Array.map(function(eta) {
        return dispatchMouseEvent(undefined, undefined, clientX, clientY, element, eta);
    }, [
        "mouseover",
        "mousedown"
    ]);
    ContentScriptPlayback__FocusElement$SmartcutsMacros.maybeDispatchFocusEvents(element);
    $$Array.map(function(eta) {
        return dispatchMouseEvent(undefined, undefined, clientX, clientY, element, eta);
    }, [
        "mouseup",
        "click"
    ]);
    return Promise.resolve(undefined);
}
function contextmenu(clientX, clientY, element) {
    dispatchMouseEvent(2, 2, clientX, clientY, element, "contextmenu");
    return Promise.resolve(undefined);
}
exports.dispatchMouseEvent = dispatchMouseEvent;
exports.click = click;
exports.contextmenu = contextmenu; /* ContentScriptPlayback__FocusElement-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 86481:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Belt_Array = __webpack_require__(2971);
var Caml_format = __webpack_require__(63979);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Element = __webpack_require__(33116);
var Webapi__Dom__Document = __webpack_require__(8416);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var DOM__Shadow$SmartcutsMacros = __webpack_require__(2497);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
function getWindowForElement(htmlElement) {
    var arg = Webapi__Dom__Document.asHtmlDocument(htmlElement.ownerDocument);
    return Caml_option.nullable_to_opt(function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected html document").defaultView);
}
function simulateBlurEvent(htmlElement) {
    var $$window = getWindowForElement(htmlElement);
    var blurEvent = new FocusEvent("blur", {
        bubbles: false,
        cancelable: true,
        view: $$window,
        relatedTarget: null
    });
    var focusOutEvent = new FocusEvent("focusout", {
        bubbles: true,
        cancelable: true,
        view: $$window,
        relatedTarget: null
    });
    htmlElement.dispatchEvent(blurEvent);
    htmlElement.dispatchEvent(focusOutEvent);
}
function fireBlur(htmlElement) {
    htmlElement.blur();
    return simulateBlurEvent(htmlElement);
}
function simulateFocusEvent(htmlElement) {
    var $$window = getWindowForElement(htmlElement);
    var focusEvent = new FocusEvent("focus", {
        bubbles: false,
        cancelable: true,
        view: $$window
    });
    var focusInEvent = new FocusEvent("focusin", {
        bubbles: true,
        cancelable: true,
        view: $$window
    });
    htmlElement.dispatchEvent(focusEvent);
    htmlElement.dispatchEvent(focusInEvent);
}
function fireFocus(htmlElement) {
    var activeElement = DOM__Shadow$SmartcutsMacros.getActiveHtmlElementForDocument(undefined);
    if (activeElement !== undefined) {
        fireBlur(Caml_option.valFromOption(activeElement));
    }
    return simulateFocusEvent(htmlElement);
}
function focusOnElement(elementToFocus) {
    var tagName = elementToFocus.tagName;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        elementToFocus.focus();
        return;
    } else {
        DOM__Element$SmartcutsMacros.isContentEditable(elementToFocus);
        return fireFocus(elementToFocus);
    }
}
function tabIndexStringToTabIndexInt(tabIndex) {
    if (tabIndex === "") {
        return 0;
    } else {
        return Caml_format.caml_int_of_string(tabIndex);
    }
}
function hasNaturalFocusCapability(element) {
    var tagName = element.tagName;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        return true;
    } else {
        return DOM__Element$SmartcutsMacros.isContentEditable(element);
    }
}
function maybeDispatchFocusEvents(element) {
    var tagName = element.tagName;
    if (tagName === "INPUT" || tagName === "TEXTAREA" || DOM__Element$SmartcutsMacros.isContentEditable(element) || element.hasAttribute("tabindex")) {
        return focusOnElement(element);
    }
    var descendantsWithTabIndex = Belt_Array.keepMap(Array.prototype.slice.call(element.querySelectorAll("[tabIndex]")), Webapi__Dom__Element.ofNode);
    var visibleDescendantsWithTabIndex = Belt_Array.keep(descendantsWithTabIndex, DOM__Element$SmartcutsMacros.isVisibleOnPage);
    var visibleDescendantsWithNonNegativeTabIndex = Belt_Array.keep(visibleDescendantsWithTabIndex, function(el) {
        var arg = el.getAttribute("tabIndex");
        var arg$1 = arg == null ? undefined : Caml_option.some(arg);
        var maybeTabIndex = function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
        }(Caml_option.nullable_to_opt(el.getAttribute("tabindex")));
        if (maybeTabIndex === "-1") {
            return false;
        } else {
            return true;
        }
    });
    var orderedVisibleDescendantsWithNonNegativeTabIndex = ArrayUtils$SmartcutsMacros.sort(function(elA, elB) {
        var arg = elA.getAttribute("tabIndex");
        var arg$1 = arg == null ? undefined : Caml_option.some(arg);
        var match = OptionUtils$SmartcutsMacros.map(function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
        }(Caml_option.nullable_to_opt(elA.getAttribute("tabindex"))), tabIndexStringToTabIndexInt);
        var arg$2 = elB.getAttribute("tabIndex");
        var arg$3 = arg$2 == null ? undefined : Caml_option.some(arg$2);
        var match$1 = OptionUtils$SmartcutsMacros.map(function(param) {
            return OptionUtils$SmartcutsMacros.orElse(param, arg$3);
        }(Caml_option.nullable_to_opt(elA.getAttribute("tabindex"))), tabIndexStringToTabIndexInt);
        if (match === undefined) {
            return 0;
        }
        var exit = 0;
        if (match !== 0 || match$1 === undefined) {
            exit = 1;
        } else {
            if (match$1 > 0) {
                return 1;
            }
            exit = 1;
        }
        if (exit === 1) {
            if (match$1 === undefined) {
                return 0;
            }
            var exit$1 = 0;
            if (match$1 !== 0) {
                exit$1 = 2;
            } else {
                if (match > 0) {
                    return -1;
                }
                exit$1 = 2;
            }
            if (exit$1 === 2) {
                if (match !== match$1) {
                    return match - match$1 | 0;
                }
                var match$2 = hasNaturalFocusCapability(elA);
                var match$3 = hasNaturalFocusCapability(elB);
                if (!match$2) {
                    if (match$3) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
                if (!match$3) {
                    return -1;
                }
                var match$4 = DOM__Element$SmartcutsMacros.isVisibleInViewport(elA);
                var match$5 = DOM__Element$SmartcutsMacros.isVisibleInViewport(elB);
                if (match$4) {
                    if (match$5) {
                        return 0;
                    } else {
                        return -1;
                    }
                } else if (match$5) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }
    }, visibleDescendantsWithNonNegativeTabIndex);
    var descendantToFocus = Belt_Array.get(orderedVisibleDescendantsWithNonNegativeTabIndex, 0);
    if (descendantToFocus !== undefined) {
        return focusOnElement(Caml_option.valFromOption(descendantToFocus));
    }
}
exports.getWindowForElement = getWindowForElement;
exports.simulateBlurEvent = simulateBlurEvent;
exports.fireBlur = fireBlur;
exports.simulateFocusEvent = simulateFocusEvent;
exports.fireFocus = fireFocus;
exports.maybeDispatchFocusEvents = maybeDispatchFocusEvents; /* Webapi__Dom__Element Not a pure module */ 


/***/ }),

/***/ 4879:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Uuid = __webpack_require__(97466);
var $$Array = __webpack_require__(53209);
var Decco = __webpack_require__(78219);
var React = __webpack_require__(67294);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_MapInt = __webpack_require__(91094);
var Belt_Option = __webpack_require__(46517);
var Caml_module = __webpack_require__(27236);
var Belt_MapString = __webpack_require__(35082);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Clipboard$SmartcutsMacros = __webpack_require__(43718);
var CustomMap$SmartcutsMacros = __webpack_require__(65706);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
var RegExUtils$SmartcutsMacros = __webpack_require__(13257);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var TextEditing$SmartcutsMacros = __webpack_require__(68993);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "commandInfo",
            v.commandInfo
        ],
        [
            "text",
            Decco.stringToJson(v.text)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
    if (commandId.TAG === /* Ok */ 0) {
        var commandInfo = {
            TAG: /* Ok */ 0,
            _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandInfo"), null)
        };
        if (commandInfo.TAG === /* Ok */ 0) {
            var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
            if (text.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        commandId: commandId._0,
                        commandInfo: commandInfo._0,
                        text: text._0
                    }
                };
            }
            var e = text._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".text" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = commandInfo._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".commandInfo" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = commandId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandId" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{commandId: " + (String(param.commandId) + (", text: " + (StringUtils$SmartcutsMacros.quote(param.text) + ")")));
}
function applyClipboard(textFromCommand, clipboardContentByCommandLogIndex) {
    var commandId = textFromCommand.commandId;
    var arg = Belt_MapInt.get(clipboardContentByCommandLogIndex, commandId);
    var clipboardContent = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expected text to be copied by command " + String(commandId + 1 | 0));
    var textCopied = Clipboard$SmartcutsMacros.ClipboardContent.getTextExn(clipboardContent);
    return {
        commandId: textFromCommand.commandId,
        commandInfo: textFromCommand.commandInfo,
        text: textCopied
    };
}
var TextFromCommand = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    applyClipboard: applyClipboard
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "text",
            Decco.stringToJson(v.text)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
    if (commandId.TAG === /* Ok */ 0) {
        var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    commandId: commandId._0,
                    text: text._0
                }
            };
        }
        var e = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = commandId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$1(v) {
    return JSON.stringify(v);
}
var TextFromGSheetUpsertCommand = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "commandInfo",
            v.commandInfo
        ],
        [
            "selection",
            Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.selection)
        ],
        [
            "context",
            CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(v.context)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
    if (commandId.TAG === /* Ok */ 0) {
        var commandInfo = {
            TAG: /* Ok */ 0,
            _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandInfo"), null)
        };
        if (commandInfo.TAG === /* Ok */ 0) {
            var selection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selection"), null));
            if (selection.TAG === /* Ok */ 0) {
                var context = CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "context"), null));
                if (context.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            commandId: commandId._0,
                            commandInfo: commandInfo._0,
                            selection: selection._0,
                            context: context._0
                        }
                    };
                }
                var e = context._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".context" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = selection._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".selection" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = commandInfo._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".commandInfo" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = commandId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandId" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var TextFromPageElement = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "commandIndex",
            Decco.intToJson(v.commandIndex)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
    if (commandId.TAG === /* Ok */ 0) {
        var commandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandIndex"), null));
        if (commandIndex.TAG === /* Ok */ 0) {
            var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        commandId: commandId._0,
                        commandIndex: commandIndex._0,
                        url: url._0
                    }
                };
            }
            var e = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = commandIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".commandIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = commandId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandId" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$2(param) {
    return "{commandIndex: " + (String(param.commandIndex) + (", url: " + (param.url + "}")));
}
var TextFromUrl = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    stringify: stringify$2
};
function t_encode$4(v) {
    if (v.TAG === /* Text */ 0) {
        return [
            "Text",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Var",
            Decco.stringToJson(v._0)
        ];
    }
}
function t_decode$4(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Text":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Text */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Var":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Var */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
var TemplateComponent = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
function image_encode(v) {
    if (typeof v === "number") {
        return [
            "NotResolved"
        ];
    } else if (v.TAG === /* Base64Encoded */ 0) {
        return [
            "Base64Encoded",
            Decco.stringToJson(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
        ];
    } else {
        return [
            "BlobObject",
            Decco.stringToJson(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
        ];
    }
}
function image_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Base64Encoded":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* Base64Encoded */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "BlobObject":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* BlobObject */ 1,
                                _0: match$3._0,
                                _1: match$4._0
                            }
                        };
                    }
                    var e$2 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "NotResolved":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotResolved */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "commandId",
            Decco.intToJson(v.commandId)
        ],
        [
            "image",
            image_encode(v.image)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
    if (commandId.TAG === /* Ok */ 0) {
        var image = image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    commandId: commandId._0,
                    image: image._0
                }
            };
        }
        var e = image._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = commandId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".commandId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var ImageFromCommand = {
    t_encode: t_encode$5,
    t_decode: t_decode$5,
    image_encode: image_encode,
    image_decode: image_decode
};
var DataRef = Caml_module.init_mod([
    "DataDependency.re",
    169,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "isTextFromGSheetUpsertCommand"
        ],
        [
            /* Function */ 0,
            "humanize"
        ],
        [
            /* Function */ 0,
            "humanizeWithConcreteValue"
        ],
        [
            /* Function */ 0,
            "resolveAsText"
        ],
        [
            /* Function */ 0,
            "toStaticText"
        ],
        [
            /* Function */ 0,
            "compareRawSnapshotAndCalcUpdate"
        ],
        [
            /* Function */ 0,
            "adjustAnyPasteToReferenceLastCopyCommand"
        ],
        [
            /* Function */ 0,
            "getReferencedCommandIds"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "toReactElement"
        ],
        [
            /* Function */ 0,
            "valueForFormInput"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "factorOutDynamicVars"
                    ],
                    [
                        /* Function */ 0,
                        "substituteInDynamicVars"
                    ]
                ]
            },
            "Pack"
        ]
    ]
});
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "components",
            Decco.arrayToJson(t_encode$4, v.components)
        ],
        [
            "vars",
            CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(DataRef.t_encode, v.vars)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var components = Decco.arrayFromJson(t_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "components"), null));
    if (components.TAG === /* Ok */ 0) {
        var vars = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vars"), null));
        if (vars.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    components: components._0,
                    vars: vars._0
                }
            };
        }
        var e = vars._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".vars" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = components._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".components" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var empty_components = [];
var empty = {
    components: empty_components,
    vars: undefined
};
function appendText(text, template) {
    return {
        components: $$Array.append(template.components, [
            {
                TAG: /* Text */ 0,
                _0: text
            }
        ]),
        vars: template.vars
    };
}
function appendVar(value, param) {
    var uuid = Uuid.v1();
    return {
        components: $$Array.append(param.components, [
            {
                TAG: /* Var */ 1,
                _0: uuid
            }
        ]),
        vars: Belt_MapString.set(param.vars, uuid, value)
    };
}
function getReferencedCommandIds(param) {
    var arg = Belt_MapString.valuesToArray(param.vars);
    var param$1 = DataRef.getReferencedCommandIds;
    return ArrayUtils$SmartcutsMacros.mapcat(param$1, arg);
}
var Template = {
    t_encode: t_encode$6,
    t_decode: t_decode$6,
    empty: empty,
    appendText: appendText,
    appendVar: appendVar,
    getReferencedCommandIds: getReferencedCommandIds
};
function t_encode$7(v) {
    switch(v.TAG | 0){
        case /* StaticText */ 0:
            return [
                "StaticText",
                Decco.stringToJson(v._0)
            ];
        case /* PasteText */ 1:
            return [
                "PasteText",
                Decco.stringToJson(v._0)
            ];
        case /* TextFromCommand */ 2:
            return [
                "TextFromCommand",
                t_encode(v._0)
            ];
        case /* TextFromGSheetUpsertCommand */ 3:
            return [
                "TextFromGSheetUpsertCommand",
                t_encode$1(v._0)
            ];
        case /* TextFromPageElement */ 4:
            return [
                "TextFromPageElement",
                t_encode$2(v._0)
            ];
        case /* TextFromUrl */ 5:
            return [
                "TextFromUrl",
                t_encode$3(v._0)
            ];
        case /* Template */ 6:
            return [
                "Template",
                t_encode$6(v._0)
            ];
        case /* ImageFromCommand */ 7:
            return [
                "ImageFromCommand",
                t_encode$5(v._0)
            ];
    }
}
function t_decode$7(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ImageFromCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode$5(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ImageFromCommand */ 7,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "PasteText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* PasteText */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "StaticText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* StaticText */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "Template":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = t_decode$6(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Template */ 6,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "TextFromCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$4 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextFromCommand */ 2,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "TextFromGSheetUpsertCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$5 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextFromGSheetUpsertCommand */ 3,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "TextFromPageElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$6 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextFromPageElement */ 4,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "TextFromUrl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$7 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* TextFromUrl */ 5,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function isTextFromGSheetUpsertCommand(dataRef) {
    if (dataRef.TAG === /* TextFromGSheetUpsertCommand */ 3) {
        return true;
    } else {
        return false;
    }
}
function humanize(dataDep) {
    switch(dataDep.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return StringUtils$SmartcutsMacros.quote(dataDep._0);
        case /* TextFromCommand */ 2:
            return "the text copied in step " + String(dataDep._0.commandId + 1 | 0);
        case /* TextFromGSheetUpsertCommand */ 3:
            return "the row inserted into the Google Sheet in step " + String(dataDep._0.commandId + 1 | 0);
        case /* TextFromUrl */ 5:
            return "the url of the tab in step " + String(dataDep._0.commandIndex + 1 | 0);
        case /* TextFromPageElement */ 4:
        case /* Template */ 6:
            return "TODO";
        case /* ImageFromCommand */ 7:
            return "the image copied in step " + String(dataDep._0.commandId + 1 | 0);
    }
}
function humanizeWithConcreteValue(dataDep) {
    switch(dataDep.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return StringUtils$SmartcutsMacros.quote(dataDep._0);
        case /* TextFromCommand */ 2:
            var match = dataDep._0;
            return "the text copied in step " + (String(match.commandId + 1 | 0) + (" (during your recording, the text was " + (StringUtils$SmartcutsMacros.quote(match.text) + ", but could be different when you run the smartcut in the future)")));
        case /* TextFromGSheetUpsertCommand */ 3:
            var match$1 = dataDep._0;
            return "the row inserted into the Google Sheet in step " + (String(match$1.commandId + 1 | 0) + (" (during your recording, the inserted row added the cell value " + (StringUtils$SmartcutsMacros.quote(match$1.text) + ")")));
        case /* TextFromUrl */ 5:
            var match$2 = dataDep._0;
            return "the url of the tab in step " + (String(match$2.commandIndex + 1 | 0) + (" (during your recording, the url was " + (StringUtils$SmartcutsMacros.quote(match$2.url) + ", but could be different when you run the smartcut in the future)")));
        case /* TextFromPageElement */ 4:
        case /* Template */ 6:
            return "TODO";
        case /* ImageFromCommand */ 7:
            return "the image copied in step " + String(dataDep._0.commandId + 1 | 0);
    }
}
function resolveAsText(dataRef) {
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return dataRef._0;
        case /* TextFromCommand */ 2:
            return dataRef._0.text;
        case /* TextFromGSheetUpsertCommand */ 3:
            return dataRef._0.text;
        case /* TextFromUrl */ 5:
            return dataRef._0.url;
        case /* TextFromPageElement */ 4:
        case /* Template */ 6:
            return "TODO";
        case /* ImageFromCommand */ 7:
            return Util$SmartcutsMacros.logAndRaiseJsError("Not expect to resolveAsText for ImageFromCommand");
    }
}
function toStaticText(dataRef) {
    return {
        TAG: /* StaticText */ 0,
        _0: resolveAsText(dataRef)
    };
}
function compareRawSnapshotAndCalcUpdate(maybePaste, dataRef1, dataRef2) {
    if (maybePaste === undefined) {
        return;
    }
    if (dataRef1.TAG !== /* StaticText */ 0) {
        return [
            dataRef2,
            false
        ];
    }
    var textBefore = dataRef1._0;
    if (textBefore === "") {
        if (dataRef2.TAG !== /* StaticText */ 0) {
            return [
                dataRef2,
                false
            ];
        }
        if (dataRef2._0 === maybePaste) {
            return [
                {
                    TAG: /* PasteText */ 1,
                    _0: maybePaste
                },
                true
            ];
        }
    }
    if (dataRef2.TAG !== /* StaticText */ 0) {
        return [
            dataRef2,
            false
        ];
    }
    var textAfter = dataRef2._0;
    var match = TextEditing$SmartcutsMacros.calcStringTransformation(undefined, undefined, textBefore, textAfter);
    if (typeof match === "number") {
        return;
    }
    switch(match.TAG | 0){
        case /* ReplaceText */ 0:
            if (match._1.replaceWith === maybePaste) {
                return [
                    {
                        TAG: /* Template */ 6,
                        _0: appendText(match._2, appendVar({
                            TAG: /* PasteText */ 1,
                            _0: maybePaste
                        }, appendText(match._0, empty)))
                    },
                    true
                ];
            } else {
                return [
                    dataRef2,
                    false
                ];
            }
        case /* DeleteText */ 1:
            return;
        case /* InsertText */ 2:
            var insertedText = match._1;
            if (insertedText === maybePaste) {
                return [
                    {
                        TAG: /* Template */ 6,
                        _0: appendText(match._2, appendVar({
                            TAG: /* PasteText */ 1,
                            _0: insertedText
                        }, appendText(match._0, empty)))
                    },
                    true
                ];
            } else {
                return [
                    dataRef2,
                    false
                ];
            }
    }
}
function adjustAnyPasteToReferenceLastCopyCommand(lastCopyInfo, dataRef) {
    switch(dataRef.TAG | 0){
        case /* PasteText */ 1:
            var text = dataRef._0;
            if (lastCopyInfo === undefined) {
                return {
                    TAG: /* PasteText */ 1,
                    _0: text
                };
            }
            var lastCopiedText = lastCopyInfo[1];
            if (lastCopiedText === text) {
                return {
                    TAG: /* TextFromCommand */ 2,
                    _0: {
                        commandId: lastCopyInfo[0],
                        commandInfo: null,
                        text: lastCopiedText
                    }
                };
            } else {
                return {
                    TAG: /* PasteText */ 1,
                    _0: text
                };
            }
        case /* ImageFromCommand */ 7:
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected text variants of DataRef here");
        default:
            return dataRef;
    }
}
function getReferencedCommandIds$1(dataRef) {
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return [];
        case /* Template */ 6:
            return getReferencedCommandIds(dataRef._0);
        default:
            return [
                dataRef._0.commandId
            ];
    }
}
function stringify$3(dataRef) {
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
            return "StaticText(" + (dataRef._0 + ")");
        case /* PasteText */ 1:
            return "PasteText(" + (dataRef._0 + ")");
        case /* TextFromCommand */ 2:
            return "TextFromCommand(" + (stringify(dataRef._0) + ")");
        case /* TextFromGSheetUpsertCommand */ 3:
            return "TextFromGSheetUpsertCommand(" + (JSON.stringify(dataRef._0) + ")");
        case /* TextFromPageElement */ 4:
            return "TextFromPageElement(_)";
        case /* TextFromUrl */ 5:
            return "TextFromUrl(" + (stringify$2(dataRef._0) + ")");
        case /* Template */ 6:
            return "Template(_)";
        case /* ImageFromCommand */ 7:
            return "ImageFromCommand(_)";
    }
}
function staticTextToReactElements(s) {
    var index = s.search(RegExUtils$SmartcutsMacros.newLineRe);
    if (index !== -1) {
        return $$Array.append([
            $$String.sub(s, 0, index),
            React.createElement("br", undefined)
        ], staticTextToReactElements(s.slice(index + 1 | 0)));
    } else {
        return [
            s
        ];
    }
}
function toReactElement(dataRef) {
    var commandRef = function commandRef(commandId) {
        return React.createElement(React.Fragment, undefined, ReactUtils$SmartcutsMacros.s("from command (id="), React.createElement("b", undefined, ReactUtils$SmartcutsMacros.s(String(commandId))), ReactUtils$SmartcutsMacros.s(")"));
    };
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return staticTextToReactElements(dataRef._0);
        case /* TextFromCommand */ 2:
            return staticTextToReactElements(dataRef._0.text);
        case /* TextFromGSheetUpsertCommand */ 3:
            return staticTextToReactElements(dataRef._0.text);
        case /* TextFromUrl */ 5:
            return staticTextToReactElements(dataRef._0.url);
        case /* TextFromPageElement */ 4:
        case /* Template */ 6:
            return ReactUtils$SmartcutsMacros.s("TODO");
        case /* ImageFromCommand */ 7:
            var match = dataRef._0;
            var image = match.image;
            var tmp;
            if (typeof image === "number") {
                tmp = ReactUtils$SmartcutsMacros.s("Not resolved");
            } else if (image.TAG === /* Base64Encoded */ 0) {
                var mimeType = Image$SmartcutsMacros.Format.mimeType(image._1.format);
                tmp = React.createElement("img", {
                    src: "data:" + (mimeType + (";base64," + image._0))
                });
            } else {
                tmp = React.createElement("img", {
                    src: image._0
                });
            }
            return React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Image "), commandRef(match.commandId), tmp);
    }
}
function valueForFormInput(dataRef) {
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            return dataRef._0;
        default:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented form input value for non static text");
    }
}
function factorOutDynamicVars(dataRef) {
    var vars;
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            vars = [
                dataRef._0
            ];
            break;
        case /* TextFromCommand */ 2:
            var match = dataRef._0;
            vars = [
                match.commandId,
                match.commandInfo,
                match.text
            ];
            break;
        case /* TextFromGSheetUpsertCommand */ 3:
            var match$1 = dataRef._0;
            vars = [
                match$1.commandId,
                match$1.text
            ];
            break;
        case /* TextFromPageElement */ 4:
            vars = [
                dataRef._0.commandInfo
            ];
            break;
        default:
            vars = [];
    }
    var factoredValue;
    switch(dataRef.TAG | 0){
        case /* StaticText */ 0:
            factoredValue = {
                TAG: /* StaticText */ 0,
                _0: ""
            };
            break;
        case /* PasteText */ 1:
            factoredValue = {
                TAG: /* PasteText */ 1,
                _0: ""
            };
            break;
        case /* TextFromCommand */ 2:
            factoredValue = {
                TAG: /* TextFromCommand */ 2,
                _0: {
                    commandId: -1,
                    commandInfo: null,
                    text: ""
                }
            };
            break;
        case /* TextFromGSheetUpsertCommand */ 3:
            factoredValue = {
                TAG: /* TextFromGSheetUpsertCommand */ 3,
                _0: {
                    commandId: -1,
                    text: ""
                }
            };
            break;
        case /* TextFromPageElement */ 4:
            var inner = dataRef._0;
            factoredValue = {
                TAG: /* TextFromPageElement */ 4,
                _0: {
                    commandId: inner.commandId,
                    commandInfo: null,
                    selection: inner.selection,
                    context: inner.context
                }
            };
            break;
        default:
            factoredValue = dataRef;
    }
    return {
        vars: vars,
        factoredValue: factoredValue
    };
}
function substituteInDynamicVars(param1) {
    var factoredDataRef = param1.factoredValue;
    var vars = param1.vars;
    switch(factoredDataRef.TAG | 0){
        case /* StaticText */ 0:
        case /* PasteText */ 1:
            break;
        case /* TextFromCommand */ 2:
            var arg = Js_json.decodeNumber(Caml_array.get(vars, 0));
            var arg$1 = Js_json.decodeString(Caml_array.get(vars, 2));
            return {
                TAG: /* TextFromCommand */ 2,
                _0: {
                    commandId: function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expected var to be a string") | 0,
                    commandInfo: Caml_array.get(vars, 1),
                    text: function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    }("Expected var to be a string")
                }
            };
        case /* TextFromGSheetUpsertCommand */ 3:
            var arg$2 = Js_json.decodeNumber(Caml_array.get(vars, 0));
            var arg$3 = Js_json.decodeString(Caml_array.get(vars, 1));
            return {
                TAG: /* TextFromGSheetUpsertCommand */ 3,
                _0: {
                    commandId: function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
                    }("Expected var to be a string") | 0,
                    text: function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$3);
                    }("Expected var to be a string")
                }
            };
        case /* TextFromPageElement */ 4:
            var inner = factoredDataRef._0;
            return {
                TAG: /* TextFromPageElement */ 4,
                _0: {
                    commandId: inner.commandId,
                    commandInfo: Caml_array.get(vars, 0),
                    selection: inner.selection,
                    context: inner.context
                }
            };
        default:
            return factoredDataRef;
    }
    var arg$4 = Js_json.decodeString(Caml_array.get(vars, 0));
    var s = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$4);
    }("Expected var to be a string");
    return {
        TAG: /* StaticText */ 0,
        _0: s
    };
}
var Pack = {
    factorOutDynamicVars: factorOutDynamicVars,
    substituteInDynamicVars: substituteInDynamicVars
};
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "isTextFromGSheetUpsertCommand"
        ],
        [
            /* Function */ 0,
            "humanize"
        ],
        [
            /* Function */ 0,
            "humanizeWithConcreteValue"
        ],
        [
            /* Function */ 0,
            "resolveAsText"
        ],
        [
            /* Function */ 0,
            "toStaticText"
        ],
        [
            /* Function */ 0,
            "compareRawSnapshotAndCalcUpdate"
        ],
        [
            /* Function */ 0,
            "adjustAnyPasteToReferenceLastCopyCommand"
        ],
        [
            /* Function */ 0,
            "getReferencedCommandIds"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "toReactElement"
        ],
        [
            /* Function */ 0,
            "valueForFormInput"
        ],
        [
            {
                TAG: /* Module */ 0,
                _0: [
                    [
                        /* Function */ 0,
                        "factorOutDynamicVars"
                    ],
                    [
                        /* Function */ 0,
                        "substituteInDynamicVars"
                    ]
                ]
            },
            "Pack"
        ]
    ]
}, DataRef, {
    t_encode: t_encode$7,
    t_decode: t_decode$7,
    isTextFromGSheetUpsertCommand: isTextFromGSheetUpsertCommand,
    humanize: humanize,
    humanizeWithConcreteValue: humanizeWithConcreteValue,
    resolveAsText: resolveAsText,
    toStaticText: toStaticText,
    compareRawSnapshotAndCalcUpdate: compareRawSnapshotAndCalcUpdate,
    adjustAnyPasteToReferenceLastCopyCommand: adjustAnyPasteToReferenceLastCopyCommand,
    getReferencedCommandIds: getReferencedCommandIds$1,
    stringify: stringify$3,
    toReactElement: toReactElement,
    valueForFormInput: valueForFormInput,
    Pack: Pack
});
exports.TextFromCommand = TextFromCommand;
exports.TextFromGSheetUpsertCommand = TextFromGSheetUpsertCommand;
exports.TextFromPageElement = TextFromPageElement;
exports.TextFromUrl = TextFromUrl;
exports.TemplateComponent = TemplateComponent;
exports.ImageFromCommand = ImageFromCommand;
exports.DataRef = DataRef;
exports.Template = Template; /* DataRef Not a pure module */ 


/***/ }),

/***/ 5601:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Webapi__Dom__Element = __webpack_require__(33116);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var Label__Shared$SmartcutsMacros = __webpack_require__(4279);
function t_encode(encoder_emailText, v) {
    return Js_dict.fromArray([
        [
            "emailText",
            Curry._1(encoder_emailText, v.emailText)
        ],
        [
            "elementWithEmailText",
            Selector$SmartcutsMacros.selector_encode(v.elementWithEmailText)
        ],
        [
            "sharedRootDepth",
            Decco.intToJson(v.sharedRootDepth)
        ]
    ]);
}
function t_decode(decoder_emailText, v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var emailText = Curry._1(decoder_emailText, Belt_Option.getWithDefault(Js_dict.get(dict$1, "emailText"), null));
    if (emailText.TAG === /* Ok */ 0) {
        var elementWithEmailText = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementWithEmailText"), null));
        if (elementWithEmailText.TAG === /* Ok */ 0) {
            var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
            if (sharedRootDepth.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        emailText: emailText._0,
                        elementWithEmailText: elementWithEmailText._0,
                        sharedRootDepth: sharedRootDepth._0
                    }
                };
            }
            var e = sharedRootDepth._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".sharedRootDepth" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = elementWithEmailText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".elementWithEmailText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = emailText._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".emailText" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(stringifyEmailText, param) {
    return "{ emailText: " + (Curry._1(stringifyEmailText, param.emailText) + (", elementWithEmailText: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.elementWithEmailText) + (", sharedRootDepth: " + (String(param.sharedRootDepth) + " }")))));
}
function applyInnerTextSemantics(resolveEmailText, emailLabel) {
    var emailText = emailLabel.emailText;
    return {
        emailText: emailLabel.emailText,
        elementWithEmailText: Selector$SmartcutsMacros.updateLeafNode(function(node) {
            return {
                id: node.id,
                tagName: node.tagName,
                classNames: node.classNames,
                attributes: node.attributes,
                index: node.index,
                innerText: {
                    TAG: /* FullInnerText */ 0,
                    _0: Curry._1(resolveEmailText, emailText)
                },
                isScrollable: node.isScrollable,
                attributeBlacklist: node.attributeBlacklist
            };
        }, emailLabel.elementWithEmailText),
        sharedRootDepth: emailLabel.sharedRootDepth
    };
}
function waitForElementInForegroundWithMatchingLabel(resolveEmailText, emailLabel, selector) {
    var match = applyInnerTextSemantics(resolveEmailText, emailLabel);
    return Label__Shared$SmartcutsMacros.waitForElementInForegroundWithMatchingLabel(match.elementWithEmailText, match.sharedRootDepth, undefined, selector);
}
function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, resolveEmailText, emailLabel, selector) {
    var match = applyInnerTextSemantics(resolveEmailText, emailLabel);
    return Label__Shared$SmartcutsMacros.waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, match.elementWithEmailText, match.sharedRootDepth, undefined, selector);
}
var regexp = new RegExp("([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)", "g");
function maybeFromElement(element) {
    return Belt_Option.flatMap(DOM__Element$SmartcutsMacros.maybeInnerText(element), function(innerText) {
        return Belt_Option.map(StringUtils$SmartcutsMacros.myMatch(innerText, regexp), function(matches) {
            if (matches.length === 1) {
                var emailText = matches[0];
                if (Caml_obj.caml_equal(innerText, emailText)) {
                    return {
                        TAG: /* ExactMatch */ 0,
                        _0: innerText
                    };
                }
            }
            return {
                TAG: /* ContainsEmailText */ 1,
                _0: Belt_Array.keepMap(matches, function(x) {
                    return x;
                }),
                _1: innerText
            };
        });
    });
}
var EmailTextMatchResult = {
    maybeFromElement: maybeFromElement
};
function childElementsExactMatchEmailText(element) {
    return Belt_Array.reduce(Array.prototype.slice.call(element.childNodes), [], function(elementsExactMatchEmailText, childNode) {
        var arg = Belt_Option.flatMap(Webapi__Dom__Element.ofNode(childNode), function(childElement) {
            return Belt_Option.map(maybeFromElement(childElement), function(matchResult) {
                if (matchResult.TAG === /* ExactMatch */ 0) {
                    return Belt_Array.concat(elementsExactMatchEmailText, [
                        childElement
                    ]);
                } else {
                    return Belt_Array.concat(elementsExactMatchEmailText, childElementsExactMatchEmailText(childElement));
                }
            });
        });
        return OptionUtils$SmartcutsMacros.withDefault(elementsExactMatchEmailText, arg);
    });
}
function forDomElement(domElement) {
    var match = maybeFromElement(domElement);
    if (match !== undefined) {
        if (match.TAG === /* ExactMatch */ 0) {
            return /* ThisElement */ 0;
        } else {
            return {
                TAG: /* Children */ 0,
                _0: childElementsExactMatchEmailText(domElement)
            };
        }
    } else {
        return Belt_Option.map(DOM__Element$SmartcutsMacros.closestSome(function(element) {
            return Belt_Option.flatMap(maybeFromElement(element), function(result) {
                if (result.TAG === /* ExactMatch */ 0) {
                    return [
                        result._0
                    ];
                } else {
                    return result._0;
                }
            });
        }, domElement), function(param) {
            var sharedRoot = param[0];
            return {
                TAG: /* Cusins */ 1,
                _0: sharedRoot,
                _1: childElementsExactMatchEmailText(sharedRoot)
            };
        });
    }
}
var LocateEmailElements = {
    EmailTextMatchResult: EmailTextMatchResult,
    childElementsExactMatchEmailText: childElementsExactMatchEmailText,
    forDomElement: forDomElement
};
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.applyInnerTextSemantics = applyInnerTextSemantics;
exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel;
exports.regexp = regexp;
exports.LocateEmailElements = LocateEmailElements; /* regexp Not a pure module */ 


/***/ }),

/***/ 53022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selection__InputCursor$SmartcutsMacros = __webpack_require__(10207);
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = __webpack_require__(65768);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "inputCursor",
            Selection__InputCursor$SmartcutsMacros.ForNonRecording.t_encode(v.inputCursor)
        ],
        [
            "semantics",
            SelectionSemantics__InputCursorSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var inputCursor = Selection__InputCursor$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputCursor"), null));
    if (inputCursor.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    inputCursor: inputCursor._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = inputCursor._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".inputCursor" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function updateSelector(f, param) {
    return {
        inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.updateSelector(f, param.inputCursor),
        semantics: param.semantics
    };
}
function stringify(param) {
    return "{inputCursor, semantics: [" + (SelectionSemantics__InputCursorSemantics$SmartcutsMacros.stringify(param.semantics) + "]}");
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.updateSelector = updateSelector;
exports.stringify = stringify; /* Selection__InputCursor-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 43647:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var Label__Shared$SmartcutsMacros = __webpack_require__(4279);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "labelText",
            Decco.stringToJson(v.labelText)
        ],
        [
            "sharedRootDepth",
            Decco.intToJson(v.sharedRootDepth)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var labelText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labelText"), null));
        if (labelText.TAG === /* Ok */ 0) {
            var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
            if (sharedRootDepth.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        labelText: labelText._0,
                        sharedRootDepth: sharedRootDepth._0
                    }
                };
            }
            var e = sharedRootDepth._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".sharedRootDepth" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = labelText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labelText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify(param) {
    return "{ labelText: " + (param.labelText + (", sharedRootDepth: " + (String(param.sharedRootDepth) + " }")));
}
function labelTextGet(param) {
    return param.labelText;
}
function mapLabelText(f, inputLabel) {
    return {
        selector: inputLabel.selector,
        labelText: Curry._1(f, inputLabel.labelText),
        sharedRootDepth: inputLabel.sharedRootDepth
    };
}
function isConfusingLabelText(inputValue, text) {
    var trimmedText = text.trim();
    var trimmedInputValue = inputValue.trim();
    if (trimmedText === "" || /\d+\s*\/\s*\d+/.test(trimmedText)) {
        return true;
    } else if (trimmedText !== "" && trimmedInputValue !== "") {
        return trimmedText.includes(trimmedInputValue);
    } else {
        return false;
    }
}
function t_encode$1(v) {
    switch(v){
        case /* ViaId */ 0:
            return [
                "ViaId"
            ];
        case /* ViaName */ 1:
            return [
                "ViaName"
            ];
        case /* ViaAdjacentElement */ 2:
            return [
                "ViaAdjacentElement"
            ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ViaAdjacentElement":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ViaAdjacentElement */ 2
                    };
                }
            case "ViaId":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ViaId */ 0
                    };
                }
            case "ViaName":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ViaName */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify$1(v) {
    switch(v){
        case /* ViaId */ 0:
            return "ViaId";
        case /* ViaName */ 1:
            return "ViaName";
        case /* ViaAdjacentElement */ 2:
            return "ViaAdjacentElement";
    }
}
var LabelDerivedVia = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function label_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
    if (selector.TAG === /* Ok */ 0) {
        var labelText = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labelText"), null));
        if (labelText.TAG === /* Ok */ 0) {
            var derivedVia = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "derivedVia"), null));
            if (derivedVia.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        selector: selector._0,
                        labelText: labelText._0,
                        derivedVia: derivedVia._0
                    }
                };
            }
            var e = derivedVia._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".derivedVia" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = labelText._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labelText" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = selector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function label_encode(v) {
    return Js_dict.fromArray([
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ],
        [
            "labelText",
            Decco.stringToJson(v.labelText)
        ],
        [
            "derivedVia",
            t_encode$1(v.derivedVia)
        ]
    ]);
}
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "sharedRootDepth",
            Decco.intToJson(v.sharedRootDepth)
        ],
        [
            "labels",
            Decco.arrayToJson(label_encode, v.labels)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var sharedRootDepth = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sharedRootDepth"), null));
    if (sharedRootDepth.TAG === /* Ok */ 0) {
        var labels = Decco.arrayFromJson(label_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labels"), null));
        if (labels.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    sharedRootDepth: sharedRootDepth._0,
                    labels: labels._0
                }
            };
        }
        var e = labels._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".labels" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = sharedRootDepth._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".sharedRootDepth" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function mapAllLabelTexts(f, t) {
    return {
        sharedRootDepth: t.sharedRootDepth,
        labels: Belt_Array.map(t.labels, function(label) {
            return {
                selector: label.selector,
                labelText: Curry._1(f, label.labelText),
                derivedVia: label.derivedVia
            };
        })
    };
}
function stringify$2(param1) {
    return "{ labels: [" + (Belt_Array.map(param1.labels, function(param) {
        return stringify$1(param.derivedVia) + ("(" + (StringUtils$SmartcutsMacros.quote(param.labelText) + ")"));
    }).join(", ") + ("], sharedRootDepth: " + (String(param1.sharedRootDepth) + " }")));
}
function updateSelector(f, t) {
    return {
        sharedRootDepth: t.sharedRootDepth,
        labels: Belt_Array.map(t.labels, function(label) {
            return {
                selector: Curry._1(f, label.selector),
                labelText: label.labelText,
                derivedVia: label.derivedVia
            };
        })
    };
}
function forHtmlInputElement(inputElement) {
    var arg1 = OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(inputElement.id), function(id) {
        return [
            id,
            /* ViaId */ 0
        ];
    });
    var match = Belt_Option.flatMap(function(param) {
        return OptionUtils$SmartcutsMacros.orElse(param, arg1);
    }(OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.optionalString(inputElement.name), function(name) {
        return [
            name,
            /* ViaName */ 1
        ];
    })), function(param) {
        var labelSource = param[1];
        return OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(document.querySelector("label[for=" + (StringUtils$SmartcutsMacros.quote(param[0]) + "]"))), function(element) {
            return [
                element,
                labelSource
            ];
        });
    });
    var labelElementsWithDerivedVia;
    var exit = 0;
    if (match !== undefined) {
        var labelElement = match[0];
        if (labelElement.innerText.trim() !== "") {
            labelElementsWithDerivedVia = [
                [
                    labelElement,
                    match[1]
                ]
            ];
        } else {
            exit = 1;
        }
    } else {
        exit = 1;
    }
    if (exit === 1) {
        labelElementsWithDerivedVia = Belt_Array.map(Belt_Array.keep(Belt_Array.keep(Belt_Array.keep(DOM__Element$SmartcutsMacros.proximalElementsWithInnerText(inputElement), function(element) {
            return !DOM__Element$SmartcutsMacros.isLikelyAutosuggestResult(inputElement, element);
        }), function(element) {
            return !DOM__Element$SmartcutsMacros.doElementsGeometricallyOverlap(element, inputElement);
        }), function(element) {
            var arg = element.innerText;
            return !isConfusingLabelText(inputElement.value, arg);
        }), function(element) {
            return [
                element,
                /* ViaAdjacentElement */ 2
            ];
        });
    }
    if (labelElementsWithDerivedVia.length === 0) {
        return;
    }
    var sharedRoot1 = Belt_Array.reduce(labelElementsWithDerivedVia, inputElement, function(sharedRoot, param) {
        var labelElement = param[0];
        if (DOM__Element$SmartcutsMacros.contains(sharedRoot, labelElement)) {
            return sharedRoot;
        } else {
            return DOM__Element$SmartcutsMacros.commonAncestor(sharedRoot, labelElement);
        }
    });
    var sharedRootDepth = DOM__Element$SmartcutsMacros.getDepthRelativeToBody(sharedRoot1);
    return {
        sharedRootDepth: sharedRootDepth,
        labels: Belt_Array.map(labelElementsWithDerivedVia, function(param) {
            var labelElement = param[0];
            return {
                selector: Selector$SmartcutsMacros.forDomElement(labelElement),
                labelText: labelElement.innerText,
                derivedVia: param[1]
            };
        })
    };
}
var forEventTarget = forHtmlInputElement;
function getLabelText(param2) {
    return Belt_Option.map(Belt_Array.get(param2.labels, 0), function(param) {
        return param.labelText;
    });
}
var RecordingAndAuthoring = {
    LabelDerivedVia: LabelDerivedVia,
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    label_encode: label_encode,
    label_decode: label_decode,
    mapAllLabelTexts: mapAllLabelTexts,
    stringify: stringify$2,
    updateSelector: updateSelector,
    forHtmlInputElement: forHtmlInputElement,
    forEventTarget: forEventTarget,
    getLabelText: getLabelText
};
function fromRecordingAndAuthoring(param) {
    var match = Belt_Array.get(param.labels, 0);
    if (match !== undefined) {
        return {
            selector: match.selector,
            labelText: match.labelText,
            sharedRootDepth: param.sharedRootDepth
        };
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected at least 1 label when InputLabel.fromRecordingAndAuthoring()");
    }
}
function waitForElementInForegroundWithMatchingLabel(param, includeElementsNotVisible, selector) {
    return Label__Shared$SmartcutsMacros.waitForElementInForegroundWithMatchingLabel(param.selector, param.sharedRootDepth, includeElementsNotVisible, selector);
}
function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, param, $staropt$star, selector) {
    var includeElementsNotVisible = $staropt$star !== undefined ? $staropt$star : false;
    return Label__Shared$SmartcutsMacros.waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, param.selector, param.sharedRootDepth, includeElementsNotVisible, selector);
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.labelTextGet = labelTextGet;
exports.mapLabelText = mapLabelText;
exports.isConfusingLabelText = isConfusingLabelText;
exports.RecordingAndAuthoring = RecordingAndAuthoring;
exports.fromRecordingAndAuthoring = fromRecordingAndAuthoring;
exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 4279:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var Curry = __webpack_require__(41386);
var Belt_List = __webpack_require__(11332);
var Caml_option = __webpack_require__(57175);
var Util$SmartcutsMacros = __webpack_require__(25092);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var QueryInBackground$SmartcutsMacros = __webpack_require__(35646);
var Selector__Background$SmartcutsMacros = __webpack_require__(89403);
function nthParentInForeground(_n, _element) {
    while(true){
        var element = _element;
        var n = _n;
        if (n === 0) {
            return Promise.resolve(Caml_option.some(element));
        }
        var parentElement = element.parentElement;
        if (parentElement == null) {
            return Promise.resolve(undefined);
        }
        _element = parentElement;
        _n = n - 1 | 0;
        continue;
    }
    ;
}
function waitForElementInForegroundWithMatchingLabel(labelSelector, sharedRootDepth, includeElementsNotVisible, selector) {
    return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, undefined, undefined, includeElementsNotVisible, labelSelector).then(function(result_labelElement) {
        if (result_labelElement.TAG === /* Ok */ 0) {
            return nthParentInForeground(List.length(labelSelector) - sharedRootDepth | 0, result_labelElement._0).then(function(maybeSharedRoot) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: maybeSharedRoot
                });
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_labelElement._0
            });
        }
    }).then(function(result_maybeSharedRoot) {
        if (result_maybeSharedRoot.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_maybeSharedRoot._0
            });
        }
        var sharedRoot = OptionUtils$SmartcutsMacros.getExn("Expected Some(sharedRoot) when waitForElementInForegroundViaSearch()", result_maybeSharedRoot._0);
        var arg = Belt_List.drop(selector, sharedRootDepth);
        var selectorRelativeToSharedRoot = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expected Some(selector) after drop sharedRootDepth");
        return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, {
            TAG: /* Element */ 0,
            _0: sharedRoot,
            _1: sharedRootDepth
        }, false, undefined, undefined, undefined, selectorRelativeToSharedRoot);
    });
}
function waitForElementInBackgroundWithMatchingLabel(timeout, interval, tabId, labelSelector, sharedRootDepth, includeElementsNotVisibleOpt, selector) {
    var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
    return Util$SmartcutsMacros.waitForPromise2(timeout, interval, function(addOnPredicateTimedOutCallback) {
        return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
            return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when waitForElementInBackgroundWithMatchingLabel()", param);
        }, Selector__Background$SmartcutsMacros.fetchDomTree({
            tabId: tabId
        }, function(param) {})).then(function(domTree) {
            return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
                true,
                undefined,
                {
                    tabId: tabId
                },
                /* Document */ 0,
                labelSelector,
                addOnPredicateTimedOutCallback,
                Caml_option.some(domTree),
                undefined,
                includeElementsNotVisible,
                undefined
            ]).then(function(result_maybeLabelElement) {
                if (result_maybeLabelElement.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* ErrorDuringPredicate */ 2,
                        _0: result_maybeLabelElement._0
                    });
                }
                var labelElement = result_maybeLabelElement._0;
                if (labelElement === undefined) {
                    return Promise.resolve(/* PredicateNotSatisfied */ 0);
                }
                var maybeSharedRoot = Selector__Background$SmartcutsMacros.getNthParent(domTree, List.length(labelSelector) - sharedRootDepth | 0, labelElement);
                var sharedRoot = OptionUtils$SmartcutsMacros.getExn("Expected Some(sharedRoot) when waitForElementInBackgroundWithMatchingLabel()", maybeSharedRoot);
                var arg = Belt_List.drop(selector, sharedRootDepth);
                var selectorRelativeToSharedRoot = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                }("Expected Some(selector) after drop sharedRootDepth");
                return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
                    false,
                    undefined,
                    {
                        tabId: tabId
                    },
                    {
                        TAG: /* Element */ 0,
                        _0: sharedRoot,
                        _1: sharedRootDepth
                    },
                    selectorRelativeToSharedRoot,
                    addOnPredicateTimedOutCallback,
                    Caml_option.some(domTree),
                    undefined,
                    includeElementsNotVisible,
                    undefined
                ]).then(function(result_maybeNodeIdAndBackendNodeId) {
                    if (result_maybeNodeIdAndBackendNodeId.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* ErrorDuringPredicate */ 2,
                            _0: result_maybeNodeIdAndBackendNodeId._0
                        });
                    }
                    var nodeIdAndBackendNodeId = result_maybeNodeIdAndBackendNodeId._0;
                    if (nodeIdAndBackendNodeId !== undefined) {
                        return Promise.resolve({
                            TAG: /* PredicateSatisfied */ 0,
                            _0: nodeIdAndBackendNodeId
                        });
                    } else {
                        return Promise.resolve(/* PredicateNotSatisfied */ 0);
                    }
                });
            });
        });
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var nodeIdAndBackendNodeId = result._0;
            switch(nodeIdAndBackendNodeId.TAG | 0){
                case /* PredicateDidResolveTo */ 0:
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: nodeIdAndBackendNodeId._0
                    });
                case /* TimedOut */ 1:
                case /* PredicateTimedOut */ 2:
                    break;
            }
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* SearchElementTimedOut */ 7,
                    _0: {
                        selector: selector,
                        ms: nodeIdAndBackendNodeId._0
                    }
                }
            });
        }
        var jsPromiseError = result._0;
        if (jsPromiseError.TAG === /* UncaughtPredicateError */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ErrorWhileSearchForElement */ 9,
                    _0: jsPromiseError._0
                }
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: jsPromiseError._0
            });
        }
    });
}
exports.waitForElementInForegroundWithMatchingLabel = waitForElementInForegroundWithMatchingLabel;
exports.waitForElementInBackgroundWithMatchingLabel = waitForElementInBackgroundWithMatchingLabel; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 94429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Decco = __webpack_require__(78219);
var React = __webpack_require__(67294);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var ReactUtils$SmartcutsMacros = __webpack_require__(80310);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "altKey",
            Decco.boolToJson(v.altKey)
        ],
        [
            "ctrlKey",
            Decco.boolToJson(v.ctrlKey)
        ],
        [
            "metaKey",
            Decco.boolToJson(v.metaKey)
        ],
        [
            "shiftKey",
            Decco.boolToJson(v.shiftKey)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var altKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "altKey"), null));
    if (altKey.TAG === /* Ok */ 0) {
        var ctrlKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ctrlKey"), null));
        if (ctrlKey.TAG === /* Ok */ 0) {
            var metaKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "metaKey"), null));
            if (metaKey.TAG === /* Ok */ 0) {
                var shiftKey = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "shiftKey"), null));
                if (shiftKey.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            altKey: altKey._0,
                            ctrlKey: ctrlKey._0,
                            metaKey: metaKey._0,
                            shiftKey: shiftKey._0
                        }
                    };
                }
                var e = shiftKey._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".shiftKey" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = metaKey._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".metaKey" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = ctrlKey._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".ctrlKey" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = altKey._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".altKey" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(modifierKeys) {
    return $$Array.map(function(param) {
        return param[1];
    }, Belt_Array.keep([
        [
            modifierKeys.altKey,
            "Alt"
        ],
        [
            modifierKeys.ctrlKey,
            "Ctrl"
        ],
        [
            modifierKeys.metaKey,
            "Meta"
        ],
        [
            modifierKeys.shiftKey,
            "Shift"
        ]
    ], function(param) {
        return param[0];
    })).join("+");
}
function toInt(modifierKeys) {
    return Belt_List.reduceWithIndex({
        hd: modifierKeys.altKey,
        tl: {
            hd: modifierKeys.ctrlKey,
            tl: {
                hd: modifierKeys.metaKey,
                tl: {
                    hd: modifierKeys.shiftKey,
                    tl: /* [] */ 0
                }
            }
        }
    }, 0, function(bits, isPressed, index) {
        return bits + (isPressed ? 1 << index : 0) | 0;
    });
}
function areAnyPressed(param) {
    if (param.altKey || param.ctrlKey || param.metaKey) {
        return true;
    } else {
        return param.shiftKey;
    }
}
function reactify(classNameOpt, modifierKeys) {
    var className = classNameOpt !== undefined ? classNameOpt : "modifierKey";
    return ReactUtils$SmartcutsMacros.joinWith_(" + ", ArrayUtils$SmartcutsMacros.filterMap(function(param) {
        if (!param[0]) {
            return;
        }
        var keyString = param[1];
        return Caml_option.some(React.createElement("kbd", {
            key: "kbd-" + keyString,
            className: className
        }, keyString));
    }, [
        [
            modifierKeys.altKey,
            "Alt"
        ],
        [
            modifierKeys.ctrlKey,
            "Ctrl"
        ],
        [
            modifierKeys.metaKey,
            "\u2318"
        ],
        [
            modifierKeys.shiftKey,
            "Shift"
        ]
    ]));
}
var noKeyPressed = 0;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.noKeyPressed = noKeyPressed;
exports.toInt = toInt;
exports.areAnyPressed = areAnyPressed;
exports.reactify = reactify; /* react Not a pure module */ 


/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
function scrollDirection_encode(v) {
    return [
        "ScrollDown"
    ];
}
function scrollDirection_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0 && match._0 === "ScrollDown") {
        if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: /* ScrollDown */ 0
            };
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyScrollDirection(scrollDirection) {
    return "ScrollDown";
}
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "direction",
            [
                "ScrollDown"
            ]
        ],
        [
            "scrollRoot",
            Selector$SmartcutsMacros.elementSelector_encode(v.scrollRoot)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var direction = scrollDirection_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "direction"), null));
    if (direction.TAG === /* Ok */ 0) {
        var scrollRoot = Selector$SmartcutsMacros.elementSelector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scrollRoot"), null));
        if (scrollRoot.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    direction: direction._0,
                    scrollRoot: scrollRoot._0
                }
            };
        }
        var e = scrollRoot._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".scrollRoot" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = direction._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".direction" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "{ direction: ScrollDown, scrollRoot: " + Selector$SmartcutsMacros.stringifyElementSelector(param.scrollRoot);
}
var ScrollAction = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
function clickOnElement_encode(v) {
    return Js_dict.fromArray([
        [
            "elementSelector",
            Selector$SmartcutsMacros.elementSelector_encode(v.elementSelector)
        ],
        [
            "maybeInnerTextSemantic",
            Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v.maybeInnerTextSemantic)
        ],
        [
            "maybeScrollToRevealElement",
            Decco.optionToJson(t_encode, v.maybeScrollToRevealElement)
        ]
    ]);
}
function clickOnElement_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var elementSelector = Selector$SmartcutsMacros.elementSelector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "elementSelector"), null));
    if (elementSelector.TAG === /* Ok */ 0) {
        var maybeInnerTextSemantic = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeInnerTextSemantic"), null));
        if (maybeInnerTextSemantic.TAG === /* Ok */ 0) {
            var maybeScrollToRevealElement = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeScrollToRevealElement"), null));
            if (maybeScrollToRevealElement.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        elementSelector: elementSelector._0,
                        maybeInnerTextSemantic: maybeInnerTextSemantic._0,
                        maybeScrollToRevealElement: maybeScrollToRevealElement._0
                    }
                };
            }
            var e = maybeScrollToRevealElement._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".maybeScrollToRevealElement" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = maybeInnerTextSemantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".maybeInnerTextSemantic" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = elementSelector._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".elementSelector" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function paginateWithHints_encode(v) {
    if (v.TAG === /* Scroll */ 0) {
        return [
            "Scroll",
            t_encode(v._0)
        ];
    } else {
        return [
            "ClickOnElement",
            clickOnElement_encode(v._0)
        ];
    }
}
function paginateWithHints_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ClickOnElement":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = clickOnElement_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ClickOnElement */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Scroll":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Scroll */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function paginateMethod_encode(v) {
    if (v) {
        return [
            "PaginateWithHints",
            paginateWithHints_encode(v._0)
        ];
    } else {
        return [
            "PaginateByAutoScrolling"
        ];
    }
}
function paginateMethod_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "PaginateByAutoScrolling":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PaginateByAutoScrolling */ 0
                    };
                }
            case "PaginateWithHints":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = paginateWithHints_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PaginateWithHints */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function loadItems_encode(v) {
    if (typeof v === "number") {
        if (v !== 0) {
            return [
                "AllItems"
            ];
        } else {
            return [
                "ItemsOnFirstPage"
            ];
        }
    } else {
        return [
            "NumberOfItems",
            Decco.intToJson(v._0)
        ];
    }
}
function loadItems_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AllItems":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AllItems */ 1
                    };
                }
            case "ItemsOnFirstPage":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ItemsOnFirstPage */ 0
                    };
                }
            case "NumberOfItems":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NumberOfItems */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "paginateMethod",
            paginateMethod_encode(v.paginateMethod)
        ],
        [
            "loadItems",
            loadItems_encode(v.loadItems)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var paginateMethod = paginateMethod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateMethod"), null));
    if (paginateMethod.TAG === /* Ok */ 0) {
        var loadItems = loadItems_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loadItems"), null));
        if (loadItems.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    paginateMethod: paginateMethod._0,
                    loadItems: loadItems._0
                }
            };
        }
        var e = loadItems._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".loadItems" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = paginateMethod._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".paginateMethod" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringifyClickOnElement(param) {
    return "{ elementSelector: " + (Selector$SmartcutsMacros.stringifyElementSelector(param.elementSelector) + (", maybeInnerTextSemantic: " + (OptionUtils$SmartcutsMacros.stringify(InnerTextSemantic$SmartcutsMacros.stringify, param.maybeInnerTextSemantic) + (", maybeScrollToRevealElement: " + OptionUtils$SmartcutsMacros.stringify(stringify, param.maybeScrollToRevealElement)))));
}
function stringifyPaginateWithHints(paginateWithHints) {
    if (paginateWithHints.TAG === /* Scroll */ 0) {
        return "Scroll(" + (stringify(paginateWithHints._0) + ")");
    } else {
        return "ClickOnElement(" + (stringifyClickOnElement(paginateWithHints._0) + ")");
    }
}
function stringifyPaginateMethod(paginateMethod) {
    if (paginateMethod) {
        return "PaginateWithHints(" + (stringifyPaginateWithHints(paginateMethod._0) + ")");
    } else {
        return "PaginateByAutoScrolling";
    }
}
function stringifyLoadItems(loadItems) {
    if (typeof loadItems === "number") {
        if (loadItems !== 0) {
            return "AllItems";
        } else {
            return "ItemsOnFirstPage";
        }
    } else {
        return "NumberOfItems(" + (String(loadItems._0) + ")");
    }
}
function stringify$1(param) {
    return "{ paginateMethod: " + (stringifyPaginateMethod(param.paginateMethod) + (", loadItems: " + (stringifyLoadItems(param.loadItems) + " }")));
}
exports.scrollDirection_encode = scrollDirection_encode;
exports.scrollDirection_decode = scrollDirection_decode;
exports.stringifyScrollDirection = stringifyScrollDirection;
exports.ScrollAction = ScrollAction;
exports.clickOnElement_encode = clickOnElement_encode;
exports.clickOnElement_decode = clickOnElement_decode;
exports.paginateWithHints_encode = paginateWithHints_encode;
exports.paginateWithHints_decode = paginateWithHints_decode;
exports.paginateMethod_encode = paginateMethod_encode;
exports.paginateMethod_decode = paginateMethod_decode;
exports.loadItems_encode = loadItems_encode;
exports.loadItems_decode = loadItems_decode;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringifyClickOnElement = stringifyClickOnElement;
exports.stringifyPaginateWithHints = stringifyPaginateWithHints;
exports.stringifyPaginateMethod = stringifyPaginateMethod;
exports.stringifyLoadItems = stringifyLoadItems;
exports.stringify = stringify$1; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 48300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var DOM__Attributes$SmartcutsMacros = __webpack_require__(92169);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "text",
            Decco.optionToJson(Decco.stringToJson, v.text)
        ],
        [
            "value",
            Decco.optionToJson(Decco.stringToJson, v.value)
        ],
        [
            "id",
            Decco.optionToJson(Decco.stringToJson, v.id)
        ],
        [
            "selector",
            Selector$SmartcutsMacros.selector_encode(v.selector)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
    if (text.TAG === /* Ok */ 0) {
        var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */ 0) {
            var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
            if (id.TAG === /* Ok */ 0) {
                var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
                if (selector.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            text: text._0,
                            value: value._0,
                            id: id._0,
                            selector: selector._0
                        }
                    };
                }
                var e = selector._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".selector" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = id._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".id" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = value._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".value" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = text._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".text" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(opt) {
    return JSON.stringify(t_encode(opt));
}
function valueAndTextGet(opt) {
    var text = opt.text;
    if (text !== undefined) {
        var value = opt.value;
        if (value !== undefined) {
            return [
                value,
                text
            ];
        } else {
            return [
                text,
                text
            ];
        }
    }
    var value$1 = opt.value;
    if (value$1 !== undefined) {
        return [
            value$1,
            value$1
        ];
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: opt.text and opt.value are both None");
    }
}
function valueGet(opt) {
    return opt.value;
}
function fromDomElement(element) {
    var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
    var value = attributes.value;
    var value$1 = value !== undefined && value !== "" ? value : undefined;
    var match = element.tagName;
    switch(match){
        case "INPUT":
            var match$1 = attributes.type_;
            if (match$1 === undefined) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
            }
            if (match$1 !== "radio") {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
            }
            var id = DOM__Element$SmartcutsMacros.idGet(element);
            var element$1 = document.querySelector('label[for="' + id + '"]');
            var textInMatchingLabel = !(element$1 == null) ? DOM__Element$SmartcutsMacros.innerTextGet(element$1) : undefined;
            var match$2 = DOM__Element$SmartcutsMacros.innerTextGet(element);
            var text = textInMatchingLabel !== undefined ? textInMatchingLabel : match$2 !== undefined ? match$2 : undefined;
            return {
                text: text,
                value: value$1,
                id: id,
                selector: Selector$SmartcutsMacros.forDomElement(element)
            };
        case "OPTION":
            return {
                text: DOM__Element$SmartcutsMacros.innerTextGet(element),
                value: value$1,
                id: DOM__Element$SmartcutsMacros.idGet(element),
                selector: Selector$SmartcutsMacros.forDomElement(element)
            };
        default:
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected DOM element from extract opt from, tagName=" + match);
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.valueAndTextGet = valueAndTextGet;
exports.valueGet = valueGet;
exports.fromDomElement = fromDomElement; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 92787:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Option = __webpack_require__(46517);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var ContentOptionality$SmartcutsMacros = __webpack_require__(14017);
var SelectionWithSemantics$SmartcutsMacros = __webpack_require__(54183);
var ContentOptionalityConfig$SmartcutsMacros = __webpack_require__(79929);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
var SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros = __webpack_require__(33788);
function t_encode(v) {
    return Selection__StrictSelection$SmartcutsMacros.ForRecording.t_encode(v);
}
function t_decode(v) {
    return Selection__StrictSelection$SmartcutsMacros.ForRecording.t_decode(v);
}
var stringify = Selection__StrictSelection$SmartcutsMacros.ForRecording.stringify;
var Recording = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify
};
var t_encode$1 = SelectionWithSemantics$SmartcutsMacros.t_encode;
var t_decode$1 = SelectionWithSemantics$SmartcutsMacros.t_decode;
function fromRecordingCommandValue(selection) {
    var semantics = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.ofSelection(selection);
    return {
        selection: Selection__StrictSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection),
        semantics: semantics
    };
}
var updateSelector = SelectionWithSemantics$SmartcutsMacros.updateSelector;
var Authoring = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: SelectionWithSemantics$SmartcutsMacros.stringify,
    fromRecordingCommandValue: fromRecordingCommandValue,
    updateSelector: updateSelector
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "optionality",
            ContentOptionality$SmartcutsMacros.t_encode(v.optionality)
        ],
        [
            "semantic",
            SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.semantic)
        ],
        [
            "originalSelection",
            Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.originalSelection)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var optionality = ContentOptionality$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "optionality"), null));
    if (optionality.TAG === /* Ok */ 0) {
        var semantic = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
        if (semantic.TAG === /* Ok */ 0) {
            var originalSelection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalSelection"), null));
            if (originalSelection.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        optionality: optionality._0,
                        semantic: semantic._0,
                        originalSelection: originalSelection._0
                    }
                };
            }
            var e = originalSelection._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".originalSelection" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = semantic._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantic" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = optionality._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".optionality" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function selectorGet(param) {
    return SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.selectorGet(param.semantic);
}
function stringify$1(param) {
    return "{ semantic: " + (SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.stringify(param.semantic) + (", originalSelection, optionality: " + (ContentOptionality$SmartcutsMacros.stringify(param.optionality) + "}")));
}
var Playback = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    selectorGet: selectorGet,
    stringify: stringify$1
};
var CommandValue = {
    Recording: Recording,
    Authoring: Authoring,
    Playback: Playback
};
function fromAuthoringCommandValue(param) {
    var semantics = param.semantics;
    return {
        selection: param.selection,
        semantics: semantics,
        config: SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.getFirstSemantic(semantics)
    };
}
function applyToAuthoringCommandValueToGetPlaybackSemantic(commandValue, maybeConfig) {
    if (maybeConfig !== undefined) {
        return maybeConfig.config;
    } else {
        return SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.getFirstSemantic(commandValue.semantics);
    }
}
function isForAuthoringCommandValue(param, config) {
    return Caml_obj.caml_equal(config.selection, param.selection);
}
var SelectedContentConfig = {
    fromAuthoringCommandValue: fromAuthoringCommandValue,
    applyToAuthoringCommandValueToGetPlaybackSemantic: applyToAuthoringCommandValueToGetPlaybackSemantic,
    isForAuthoringCommandValue: isForAuthoringCommandValue
};
function isDynamic(param) {
    return false;
}
function fromAuthoringCommandValue$1(authoringCommandValue) {
    return {
        selectedContentConfig: fromAuthoringCommandValue(authoringCommandValue),
        contentOptionalityConfig: ContentOptionalityConfig$SmartcutsMacros.$$default
    };
}
function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
    var arg = OptionUtils$SmartcutsMacros.map(maybeConfig, function(config) {
        return config.contentOptionalityConfig;
    });
    return {
        optionality: function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(ContentOptionalityConfig$SmartcutsMacros.$$default),
        semantic: applyToAuthoringCommandValueToGetPlaybackSemantic(commandValue, OptionUtils$SmartcutsMacros.map(maybeConfig, function(config) {
            return config.selectedContentConfig;
        })),
        originalSelection: commandValue.selection
    };
}
function isForAuthoringCommandValue$1(commandValue, config) {
    return isForAuthoringCommandValue(commandValue, config.selectedContentConfig);
}
var AuthoringConfig = {
    SelectedContentConfig: SelectedContentConfig,
    isDynamic: isDynamic,
    fromAuthoringCommandValue: fromAuthoringCommandValue$1,
    applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
    isForAuthoringCommandValue: isForAuthoringCommandValue$1
};
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig; /* SelectionWithSemantics-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 54183:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Selection__StrictSelection$SmartcutsMacros = __webpack_require__(874);
var SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros = __webpack_require__(33788);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "selection",
            Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.selection)
        ],
        [
            "semantics",
            SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.t_encode(v.semantics)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selection"), null));
    if (selection.TAG === /* Ok */ 0) {
        var semantics = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
        if (semantics.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selection: selection._0,
                    semantics: semantics._0
                }
            };
        }
        var e = semantics._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".semantics" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selection._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selection" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function updateSelector(f, param) {
    return {
        selection: Selection__StrictSelection$SmartcutsMacros.ForNonRecording.updateSelector(f, param.selection),
        semantics: SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.updateSelector(f, param.semantics)
    };
}
function stringify(param) {
    return "{selection, semantics: [" + (SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.stringify(param.semantics) + "]}");
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.updateSelector = updateSelector;
exports.stringify = stringify; /* Selection__StrictSelection-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 65443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function t_encode(v) {
    switch(v.TAG | 0){
        case /* StaticCssSelector */ 0:
            return [
                "StaticCssSelector",
                Decco.stringToJson(v._0)
            ];
        case /* StaticXPath */ 1:
            return [
                "StaticXPath",
                Decco.stringToJson(v._0)
            ];
        case /* ParameterizedCssSelector */ 2:
            return [
                "ParameterizedCssSelector",
                Decco.stringToJson(v._0)
            ];
        case /* ParameterizedXPath */ 3:
            return [
                "ParameterizedXPath",
                Decco.stringToJson(v._0)
            ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ParameterizedCssSelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ParameterizedCssSelector */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ParameterizedXPath":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ParameterizedXPath */ 3,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "StaticCssSelector":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* StaticCssSelector */ 0,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "StaticXPath":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* StaticXPath */ 1,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toString(override) {
    return override._0;
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.toString = toString; /* No side effect */ 


/***/ }),

/***/ 51670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var DOM__Search$SmartcutsMacros = __webpack_require__(87092);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DevProtocol__DOM$SmartcutsMacros = __webpack_require__(58637);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
var SelectorOverrideWithoutScope$SmartcutsMacros = __webpack_require__(65443);
function t_encode(v) {
    return [
        selectorOverrideWithScope_encode(v[0]),
        Decco.arrayToJson(selectorOverrideWithScope_encode, v[1])
    ];
}
function t_decode(v) {
    var match = Js_json.classify(v);
    if (typeof match === "number") {
        return Decco.error(undefined, "Not a tuple", v);
    }
    if (match.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a tuple", v);
    }
    var match$1 = match._0;
    if (match$1.length !== 2) {
        return Decco.error(undefined, "Incorrect cardinality", v);
    }
    var v0 = match$1[0];
    var v1 = match$1[1];
    var match$2 = selectorOverrideWithScope_decode(v0);
    var match$3 = Decco.arrayFromJson(selectorOverrideWithScope_decode, v1);
    if (match$2.TAG === /* Ok */ 0) {
        if (match$3.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: [
                    match$2._0,
                    match$3._0
                ]
            };
        }
        var e = match$3._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = match$2._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function selectorOverrideWithScope_encode(v) {
    return Js_dict.fromArray([
        [
            "selectorOverride",
            SelectorOverrideWithoutScope$SmartcutsMacros.t_encode(v.selectorOverride)
        ],
        [
            "scope",
            scope_encode(v.scope)
        ]
    ]);
}
function selectorOverrideWithScope_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var selectorOverride = SelectorOverrideWithoutScope$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorOverride"), null));
    if (selectorOverride.TAG === /* Ok */ 0) {
        var scope = scope_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scope"), null));
        if (scope.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    selectorOverride: selectorOverride._0,
                    scope: scope._0
                }
            };
        }
        var e = scope._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".scope" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = selectorOverride._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".selectorOverride" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function scope_encode(v) {
    if (v) {
        return [
            "Element",
            elementLocatorInTermsOfStrategy_encode(v._0)
        ];
    } else {
        return [
            "Document"
        ];
    }
}
function scope_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Document":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Document */ 0
                    };
                }
            case "Element":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Element */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function elementLocatorInTermsOfStrategy_encode(v) {
    switch(v.TAG | 0){
        case /* DefaultSelector */ 0:
            return [
                "DefaultSelector",
                Selector$SmartcutsMacros.selector_encode(v._0),
                Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1)
            ];
        case /* SelectorOverrides */ 1:
            return [
                "SelectorOverrides",
                t_encode(v._0)
            ];
        case /* DefaultSelectorWithOverrides */ 2:
            return [
                "DefaultSelectorWithOverrides",
                Selector$SmartcutsMacros.selector_encode(v._0),
                Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1),
                t_encode(v._2)
            ];
    }
}
function elementLocatorInTermsOfStrategy_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "DefaultSelector":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* DefaultSelector */ 0,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "DefaultSelectorWithOverrides":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$3 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$4 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
                var match$5 = t_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$3.TAG === /* Ok */ 0) {
                    if (match$4.TAG === /* Ok */ 0) {
                        if (match$5.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* DefaultSelectorWithOverrides */ 2,
                                    _0: match$3._0,
                                    _1: match$4._0,
                                    _2: match$5._0
                                }
                            };
                        }
                        var e$2 = match$5._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = match$4._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = match$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "SelectorOverrides":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SelectorOverrides */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e$5 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringifyElementLocatorInTermsOfStrategy(elementLocatorInTermsOfStrategy, withPrefix, stringifySelector) {
    switch(elementLocatorInTermsOfStrategy.TAG | 0){
        case /* DefaultSelector */ 0:
            return (withPrefix ? "selector=" : "") + Curry._1(stringifySelector, elementLocatorInTermsOfStrategy._0);
        case /* SelectorOverrides */ 1:
            var match = elementLocatorInTermsOfStrategy._0;
            return (withPrefix ? "overrides=" : "") + Belt_Array.map($$Array.append([
                match[0]
            ], match[1]), function(param) {
                return SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride);
            }).join(", ");
        case /* DefaultSelectorWithOverrides */ 2:
            var match$1 = elementLocatorInTermsOfStrategy._2;
            return (withPrefix ? "overrides-including-selector=" : "") + $$Array.append(Belt_Array.map($$Array.append([
                match$1[0]
            ], match$1[1]), function(param) {
                return SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride);
            }), [
                "(selector=" + (Curry._1(stringifySelector, elementLocatorInTermsOfStrategy._0) + ")")
            ]).join(", ");
    }
}
function stringify(param1) {
    return "[" + (Belt_Array.map($$Array.append([
        param1[0]
    ], param1[1]), function(param) {
        return StringUtils$SmartcutsMacros.quote(SelectorOverrideWithoutScope$SmartcutsMacros.toString(param.selectorOverride));
    }).join(", ") + "]");
}
function fromArrayOfSelectorOverrideWithoutScope(overrides) {
    return [
        {
            selectorOverride: Belt_Array.getExn(overrides, 0),
            scope: /* Document */ 0
        },
        Belt_Array.map(Belt_Array.sliceToEnd(overrides, 1), function(selectorOverride) {
            return {
                selectorOverride: selectorOverride,
                scope: /* Document */ 0
            };
        })
    ];
}
function attemptToLocateSelectorOverrideWithScope(param, timeoutInMilliseconds) {
    var scope = param.scope;
    var selectorOverride = param.selectorOverride;
    if (scope) {
        var selectorOverrides_ancestor = scope._0;
        switch(selectorOverrides_ancestor.TAG | 0){
            case /* DefaultSelector */ 0:
                return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, selectorOverrides_ancestor._1, undefined, undefined, selectorOverrides_ancestor._0);
            case /* SelectorOverrides */ 1:
                return attemptToLocate(selectorOverrides_ancestor._0, timeoutInMilliseconds);
            case /* DefaultSelectorWithOverrides */ 2:
                var maybeInnerTextSemantic = selectorOverrides_ancestor._1;
                var defaultSelector = selectorOverrides_ancestor._0;
                return attemptToLocate(selectorOverrides_ancestor._2, timeoutInMilliseconds).then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve(result);
                    } else {
                        return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, true, maybeInnerTextSemantic, undefined, undefined, defaultSelector);
                    }
                });
        }
    } else {
        var querySelectorString = SelectorOverrideWithoutScope$SmartcutsMacros.toString(selectorOverride);
        return Util$SmartcutsMacros.waitForPromise2(timeoutInMilliseconds, undefined, function(param) {
            var maybeDomElement = document.querySelector(querySelectorString);
            if (maybeDomElement == null) {
                return Promise.resolve(/* PredicateNotSatisfied */ 0);
            } else {
                return Promise.resolve({
                    TAG: /* PredicateSatisfied */ 0,
                    _0: maybeDomElement
                });
            }
        }).then(function(result) {
            if (result.TAG === /* Ok */ 0) {
                var domElement = result._0;
                switch(domElement.TAG | 0){
                    case /* PredicateDidResolveTo */ 0:
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: domElement._0
                        });
                    case /* TimedOut */ 1:
                    case /* PredicateTimedOut */ 2:
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: {
                                TAG: /* QuerySelectorOverridesTimedOut */ 8,
                                _0: [
                                    selectorOverride
                                ]
                            }
                        });
                }
            } else {
                var jsPromiseError = result._0;
                if (jsPromiseError.TAG !== /* UncaughtPredicateError */ 0) {
                    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
                }
                var jsPromiseError$1 = jsPromiseError._0;
                console.error("Error for selector " + querySelectorString, jsPromiseError$1);
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ErrorWhileSearchForElement */ 9,
                        _0: jsPromiseError$1
                    }
                });
            }
        });
    }
}
function attemptToLocate(param, timeoutInMilliseconds) {
    var backupSelectorOverridesWithScopes = param[1];
    return attemptToLocateSelectorOverrideWithScope(param[0], timeoutInMilliseconds).then(function(result1) {
        if (result1.TAG === /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: result1._0
            });
        } else {
            return Belt_Array.reduce(backupSelectorOverridesWithScopes, Promise.resolve({
                TAG: /* Error */ 1,
                _0: result1._0
            }), function(promisedResult, currBackupSelectorOverrideWithScope) {
                return promisedResult.then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve(result);
                    } else {
                        return attemptToLocateSelectorOverrideWithScope(currBackupSelectorOverrideWithScope, timeoutInMilliseconds);
                    }
                });
            });
        }
    });
}
var ContentScriptLocator = {
    attemptToLocate: attemptToLocate
};
function attemptToLocate$1(param, tabId, timeoutInMilliseconds) {
    var backupSelectorOverridesWithScopes = param[1];
    return attemptToLocateSelectorOverrideWithScope$1(param[0], tabId, timeoutInMilliseconds).then(function(result2) {
        if (result2.TAG === /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: result2._0
            });
        } else {
            return Belt_Array.reduce(backupSelectorOverridesWithScopes, Promise.resolve({
                TAG: /* Error */ 1,
                _0: /* CdpUnableToGetDocument */ 1
            }), function(promisedResult, currBackupSelectorOverrideWithScope) {
                return promisedResult.then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve(result);
                    } else {
                        return attemptToLocateSelectorOverrideWithScope$1(currBackupSelectorOverrideWithScope, tabId, timeoutInMilliseconds);
                    }
                });
            });
        }
    });
}
function attemptToLocateSelectorOverrideWithScope$1(param2, tabId, timeoutInMilliseconds) {
    var scope = param2.scope;
    if (scope) {
        var selectorOverrides_ancestor = scope._0;
        switch(selectorOverrides_ancestor.TAG | 0){
            case /* DefaultSelector */ 0:
                return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaSearch(undefined, undefined, undefined, true, selectorOverrides_ancestor._1, tabId, undefined, undefined, selectorOverrides_ancestor._0).then(function(result) {
                    if (result.TAG === /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: result._0
                        });
                    } else {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result._0
                        });
                    }
                });
            case /* SelectorOverrides */ 1:
                return attemptToLocate$1(selectorOverrides_ancestor._0, tabId, timeoutInMilliseconds);
            case /* DefaultSelectorWithOverrides */ 2:
                var maybeInnerTextSemantic = selectorOverrides_ancestor._1;
                var defaultSelector = selectorOverrides_ancestor._0;
                return attemptToLocate$1(selectorOverrides_ancestor._2, tabId, timeoutInMilliseconds).then(function(result3) {
                    if (result3.TAG === /* Ok */ 0) {
                        return Promise.resolve(result3);
                    } else {
                        return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaSearch(undefined, undefined, undefined, true, maybeInnerTextSemantic, tabId, undefined, undefined, defaultSelector).then(function(result) {
                            if (result.TAG === /* Ok */ 0) {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: result._0
                                });
                            } else {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: result._0
                                });
                            }
                        });
                    }
                });
        }
    } else {
        var querySelectorString = SelectorOverrideWithoutScope$SmartcutsMacros.toString(param2.selectorOverride);
        return DOM__Search$SmartcutsMacros.waitForElementInBackgroundViaQuerySelector(timeoutInMilliseconds, undefined, /* Document */ 0, tabId, querySelectorString).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var nodeId = result._0;
            return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeNode) {
                var arg = Belt_Option.map(maybeNode, function(node) {
                    return [
                        nodeId,
                        node.backendNodeId
                    ];
                });
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expected CDP node")
                });
            });
        });
    }
}
var CdpLocator = {
    attemptToLocate: attemptToLocate$1
};
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.selectorOverrideWithScope_encode = selectorOverrideWithScope_encode;
exports.selectorOverrideWithScope_decode = selectorOverrideWithScope_decode;
exports.scope_encode = scope_encode;
exports.scope_decode = scope_decode;
exports.elementLocatorInTermsOfStrategy_encode = elementLocatorInTermsOfStrategy_encode;
exports.elementLocatorInTermsOfStrategy_decode = elementLocatorInTermsOfStrategy_decode;
exports.stringifyElementLocatorInTermsOfStrategy = stringifyElementLocatorInTermsOfStrategy;
exports.stringify = stringify;
exports.fromArrayOfSelectorOverrideWithoutScope = fromArrayOfSelectorOverrideWithoutScope;
exports.ContentScriptLocator = ContentScriptLocator;
exports.CdpLocator = CdpLocator; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 9697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Util$SmartcutsMacros = __webpack_require__(25092);
var UrlConstraint$SmartcutsMacros = __webpack_require__(32600);
var CommandContext$SmartcutsMacros = __webpack_require__(81848);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function urlCommandType_encode(v) {
    switch(v.TAG | 0){
        case /* NewWindowWithUrlCommand */ 0:
            return [
                "NewWindowWithUrlCommand",
                CommandContext$SmartcutsMacros.focusStatus_encode(v._0)
            ];
        case /* NewTabWithUrlCommand */ 1:
            return [
                "NewTabWithUrlCommand",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0),
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_encode(v._1),
                CommandContext$SmartcutsMacros.focusStatus_encode(v._2)
            ];
        case /* URLCommand */ 2:
            return [
                "URLCommand",
                InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
            ];
    }
}
function urlCommandType_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "NewTabWithUrlCommand":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.t_decode(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* NewTabWithUrlCommand */ 1,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "NewWindowWithUrlCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = CommandContext$SmartcutsMacros.focusStatus_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* NewWindowWithUrlCommand */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e$3 = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "URLCommand":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* URLCommand */ 2,
                            _0: v0$1._0
                        }
                    };
                }
                var e$4 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function isDynamic(param) {
    if (param.urlConfig) {
        return true;
    } else {
        return false;
    }
}
var AuthoringConfig = {
    urlCommandType_encode: urlCommandType_encode,
    urlCommandType_decode: urlCommandType_decode,
    isDynamic: isDynamic
};
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "originalUrl",
            Decco.stringToJson(v.originalUrl)
        ],
        [
            "urlPattern",
            UrlConstraint$SmartcutsMacros.UrlPattern.t_encode(v.urlPattern)
        ],
        [
            "urlCommandType",
            urlCommandType_encode(v.urlCommandType)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var originalUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalUrl"), null));
    if (originalUrl.TAG === /* Ok */ 0) {
        var urlPattern = UrlConstraint$SmartcutsMacros.UrlPattern.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPattern"), null));
        if (urlPattern.TAG === /* Ok */ 0) {
            var urlCommandType = urlCommandType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlCommandType"), null));
            if (urlCommandType.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        originalUrl: originalUrl._0,
                        urlPattern: urlPattern._0,
                        urlCommandType: urlCommandType._0
                    }
                };
            }
            var e = urlCommandType._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".urlCommandType" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = urlPattern._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".urlPattern" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = originalUrl._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".originalUrl" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function fromAuthoringConfig(config) {
    var urlPattern = config.urlConfig;
    if (urlPattern) {
        return {
            originalUrl: config.originalUrl,
            urlPattern: urlPattern._0,
            urlCommandType: config.urlCommandType
        };
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("URLConfig that ExactMatch can't be converted into a Smartcut.ParamDescriptor because it is not dynamic");
    }
}
var ParamDescriptor = {
    t_encode: t_encode,
    t_decode: t_decode,
    fromAuthoringConfig: fromAuthoringConfig
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "urlCommandType",
            urlCommandType_encode(v.urlCommandType)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */ 0) {
        var urlCommandType = urlCommandType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlCommandType"), null));
        if (urlCommandType.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    url: url._0,
                    urlCommandType: urlCommandType._0
                }
            };
        }
        var e = urlCommandType._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".urlCommandType" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = url._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".url" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify(param) {
    return "urlParam";
}
function fromParamDescriptor(param) {
    return {
        url: param.originalUrl,
        urlCommandType: param.urlCommandType
    };
}
var PlaybackParamValue = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify,
    fromParamDescriptor: fromParamDescriptor
};
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 21707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "clientX",
            Decco.intToJson(v.clientX)
        ],
        [
            "clientY",
            Decco.intToJson(v.clientY)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var clientX = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientX"), null));
    if (clientX.TAG === /* Ok */ 0) {
        var clientY = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientY"), null));
        if (clientY.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    clientX: clientX._0,
                    clientY: clientY._0
                }
            };
        }
        var e = clientY._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".clientY" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = clientX._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".clientX" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* No side effect */ 


/***/ }),

/***/ 87092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Query$SmartcutsMacros = __webpack_require__(33429);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var DevProtocol__DOM$SmartcutsMacros = __webpack_require__(58637);
var QueryInBackground$SmartcutsMacros = __webpack_require__(35646);
var Selector__Background$SmartcutsMacros = __webpack_require__(89403);
function waitForElementInBackgroundViaSearch(timeout, interval, maybeQueryRoot, useInnerText, maybeInnerTextSemantic, tabId, domTree, includeElementsNotVisibleOpt, selector) {
    var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
    var queryRoot = maybeQueryRoot !== undefined ? maybeQueryRoot : /* Document */ 0;
    return Util$SmartcutsMacros.waitForPromise2(timeout, interval, function(addOnPredicateTimedOutCallback) {
        return Curry.app(QueryInBackground$SmartcutsMacros.search1, [
            useInnerText,
            maybeInnerTextSemantic,
            {
                tabId: tabId
            },
            queryRoot,
            selector,
            addOnPredicateTimedOutCallback,
            domTree,
            undefined,
            includeElementsNotVisible,
            undefined
        ]).then(function(result_maybeNodeIdAndBackendNodeId) {
            if (result_maybeNodeIdAndBackendNodeId.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* ErrorDuringPredicate */ 2,
                    _0: result_maybeNodeIdAndBackendNodeId._0
                });
            }
            var nodeIdAndBackendNodeId = result_maybeNodeIdAndBackendNodeId._0;
            if (nodeIdAndBackendNodeId !== undefined) {
                return Promise.resolve({
                    TAG: /* PredicateSatisfied */ 0,
                    _0: nodeIdAndBackendNodeId
                });
            } else {
                return Promise.resolve(/* PredicateNotSatisfied */ 0);
            }
        });
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var nodeIdAndBackendNodeId = result._0;
            switch(nodeIdAndBackendNodeId.TAG | 0){
                case /* PredicateDidResolveTo */ 0:
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: nodeIdAndBackendNodeId._0
                    });
                case /* TimedOut */ 1:
                case /* PredicateTimedOut */ 2:
                    break;
            }
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* SearchElementTimedOut */ 7,
                    _0: {
                        selector: selector,
                        ms: nodeIdAndBackendNodeId._0
                    }
                }
            });
        }
        var jsPromiseError = result._0;
        if (jsPromiseError.TAG === /* UncaughtPredicateError */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ErrorWhileSearchForElement */ 9,
                    _0: jsPromiseError._0
                }
            });
        } else {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: jsPromiseError._0
            });
        }
    });
}
function waitForElementInForegroundViaSearch(timeout, interval, maybeQueryRoot, useInnerText, maybeInnerTextSemantic, onlyConsiderElementChainIf, includeElementsNotVisibleOpt, selector) {
    var includeElementsNotVisible = includeElementsNotVisibleOpt !== undefined ? includeElementsNotVisibleOpt : false;
    var queryRoot = OptionUtils$SmartcutsMacros.withDefault(/* Document */ 0, maybeQueryRoot);
    return Util$SmartcutsMacros.waitForPromise2(timeout, interval, function(addOnPredicateTimedOutCallback) {
        return Query$SmartcutsMacros.QueryInWebPage.searchWithScrolling(useInnerText, maybeInnerTextSemantic, /* Not_Used */ 0, queryRoot, selector, addOnPredicateTimedOutCallback, undefined, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function(result_maybeDomElement) {
            if (result_maybeDomElement.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* ErrorDuringPredicate */ 2,
                    _0: undefined
                });
            }
            var domElement = result_maybeDomElement._0;
            if (domElement !== undefined) {
                return Promise.resolve({
                    TAG: /* PredicateSatisfied */ 0,
                    _0: Caml_option.valFromOption(domElement)
                });
            } else {
                return Promise.resolve(/* PredicateNotSatisfied */ 0);
            }
        });
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var domElement = result._0;
            switch(domElement.TAG | 0){
                case /* PredicateDidResolveTo */ 0:
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: domElement._0
                    });
                case /* TimedOut */ 1:
                case /* PredicateTimedOut */ 2:
                    break;
            }
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* SearchElementTimedOut */ 7,
                    _0: {
                        selector: selector,
                        ms: domElement._0
                    }
                }
            });
        }
        var jsPromiseError = result._0;
        if (jsPromiseError.TAG === /* UncaughtPredicateError */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ErrorWhileSearchForElement */ 9,
                    _0: jsPromiseError._0
                }
            });
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
        }
    });
}
function waitForElementInBackgroundViaQuerySelector(timeout, interval, queryRoot, tabId, querySelectorStr) {
    return Util$SmartcutsMacros.waitForPromise2(timeout, interval, function(addOnPredicateTimedOutCallback) {
        var match1 = PromiseUtils$SmartcutsMacros.withRetries(3, function(addCancelCallback, param) {
            var tmp;
            if (typeof queryRoot === "number") {
                var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return DevProtocol__DOM$SmartcutsMacros.getDocument(undefined, true, tabId, undefined, undefined, undefined).then(function($$document) {
                        Curry._2(Log$SmartcutsMacros.playback.log2, "DOCUMENT", $$document);
                        if ($$document === undefined) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: /* CdpUnableToGetDocument */ 1
                            });
                        }
                        var rootNode = Caml_option.valFromOption($$document);
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: [
                                rootNode.nodeId,
                                rootNode.backendNodeId
                            ]
                        });
                    });
                });
                Curry._1(addCancelCallback, match[1]);
                tmp = Curry._1(match[0], undefined);
            } else {
                var match$1 = queryRoot._0;
                tmp = Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: [
                        match$1[0],
                        match$1[1]
                    ]
                });
            }
            return tmp.then(function(result_element) {
                if (result_element.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_element._0
                    });
                }
                var rootNodeId = result_element._0[0];
                var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return DevProtocol__DOM$SmartcutsMacros.querySelectorAll(rootNodeId, querySelectorStr, tabId, undefined, undefined, undefined);
                });
                Curry._1(addCancelCallback, match[1]);
                return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), function(results) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: results
                    };
                });
            }).then(function(result_results) {
                if (result_results.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* ErrorDuringPredicate */ 2,
                        _0: result_results._0
                    });
                }
                var nodeId = Belt_Array.get(result_results._0, 0);
                if (nodeId !== undefined) {
                    return Promise.resolve({
                        TAG: /* PredicateSatisfied */ 0,
                        _0: nodeId
                    });
                } else {
                    Curry._2(Log$SmartcutsMacros.dom.log2, "Failed waitForElementInBackgroundViaQuerySelector", querySelectorStr);
                    return Promise.resolve(/* PredicateNotSatisfied */ 0);
                }
            });
        }, function(param) {
            return Selector__Background$SmartcutsMacros.shouldRetryForJsPromiseError(queryRoot, param);
        }, /* PredicateNotSatisfied */ 0, undefined);
        Curry._1(addOnPredicateTimedOutCallback, match1[1]);
        return Curry._1(match1[0], undefined);
    }).then(function(result) {
        if (result.TAG === /* Ok */ 0) {
            var nodeIdAndBackendNodeId = result._0;
            switch(nodeIdAndBackendNodeId.TAG | 0){
                case /* PredicateDidResolveTo */ 0:
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: nodeIdAndBackendNodeId._0
                    });
                case /* TimedOut */ 1:
                case /* PredicateTimedOut */ 2:
                    break;
            }
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* CdpQuerySelectorTimedOut */ 10,
                    _0: {
                        querySelector: querySelectorStr,
                        ms: nodeIdAndBackendNodeId._0
                    }
                }
            });
        }
        var jsPromiseError = result._0;
        if (jsPromiseError.TAG === /* UncaughtPredicateError */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ErrorWhileCdpQuerySelector */ 11,
                    _0: jsPromiseError._0
                }
            });
        } else {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: OtherError not expected");
        }
    });
}
exports.waitForElementInBackgroundViaSearch = waitForElementInBackgroundViaSearch;
exports.waitForElementInForegroundViaSearch = waitForElementInForegroundViaSearch;
exports.waitForElementInBackgroundViaQuerySelector = waitForElementInBackgroundViaQuerySelector; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 81466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
function enable(tabId, extensionId, targetId, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "CSS.enable", undefined).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var CSSComputedStyleProperty = {};
var methodName = "CSS.getComputedStyleForNode";
var Params = {};
var GetComputedStyleForNode = {
    methodName: methodName,
    Params: Params
};
function getComputedStyleForNode(nodeId, tabId, extensionId, targetId, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, {
        nodeId: nodeId
    });
}
exports.enable = enable;
exports.CSSComputedStyleProperty = CSSComputedStyleProperty;
exports.GetComputedStyleForNode = GetComputedStyleForNode;
exports.getComputedStyleForNode = getComputedStyleForNode; /* Browser__Debugger-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 58637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Log$SmartcutsMacros = __webpack_require__(78088);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
var nodeId_encode = Decco.intToJson;
var nodeId_decode = Decco.intFromJson;
var backendNodeId_encode = Decco.intToJson;
var backendNodeId_decode = Decco.intFromJson;
var $$Node = {};
var methodName = "DOM.resolveNode";
var Params = {};
var Result = {};
var ResolveNode = {
    methodName: methodName,
    Params: Params,
    Result: Result
};
function resolveNode(backendNodeId, executionContextId, nodeId, objectGroup, tabId, extensionId, targetId, param) {
    var tmp = {};
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    if (executionContextId !== undefined) {
        tmp.executionContextId = Caml_option.valFromOption(executionContextId);
    }
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (objectGroup !== undefined) {
        tmp.objectGroup = Caml_option.valFromOption(objectGroup);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params).then(function(result) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.object;
        }));
    });
}
var methodName$1 = "DOM.requestNode";
var Params$1 = {};
var Result$1 = {};
var RequestNode = {
    methodName: methodName$1,
    Params: Params$1,
    Result: Result$1
};
function requestNode(objectId, tabId, extensionId, targetId, param) {
    var params = {
        objectId: objectId
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$1, params).then(function(maybeResult) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeResult, function(result) {
            return result.nodeId;
        }));
    });
}
var GetAttributes = {};
function getAttributes(nodeId, tabId, extensionId, targetId, param1) {
    var params = {
        nodeId: nodeId
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getAttributes", params).then(function(result) {
        if (result !== undefined) {
            return Promise.resolve(Belt_Array.reduce(ArrayUtils$SmartcutsMacros.groupIntoPairs(result.attributes), undefined, function(map, param) {
                return Belt_MapString.set(map, param[0], param[1]);
            }));
        } else {
            return Promise.resolve(undefined);
        }
    });
}
var SetAttributeValue = {};
function setAttributeValue(nodeId, name, value, tabId, extensionId, targetId, param) {
    var params = {
        nodeId: nodeId,
        name: name,
        value: value
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.setAttributeValue", params).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var RemoveAttribute = {};
function removeAttribute(nodeId, name, tabId, extensionId, targetId, param) {
    var params = {
        nodeId: nodeId,
        name: name
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.removeAttribute", params).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var Params$2 = {};
var Result$2 = {};
var All = {};
var QuerySelector = {
    Params: Params$2,
    Result: Result$2,
    All: All
};
function querySelector(nodeId, selector, tabId, extensionId, targetId, param) {
    var params = {
        nodeId: nodeId,
        selector: selector
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.querySelector", params).then(function(result) {
        var _$nodeId = OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.nodeId;
        });
        if (_$nodeId !== undefined && _$nodeId !== 0) {
            return Promise.resolve(_$nodeId);
        } else {
            return Promise.resolve(undefined);
        }
    });
}
function querySelectorAll(nodeId, selector, tabId, extensionId, targetId, param) {
    var params = {
        nodeId: nodeId,
        selector: selector
    };
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.querySelectorAll", params).then(function(result) {
        if (result !== undefined) {
            return Promise.resolve(result.nodeIds);
        } else {
            return Promise.resolve([]);
        }
    });
}
function enable(tabId, extensionId, targetId, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.enable", undefined).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var methodName$2 = "DOM.performSearch";
var Params$3 = {};
var Result$3 = {};
var PerformSearch = {
    methodName: methodName$2,
    Params: Params$3,
    Result: Result$3
};
function performSearch(tabId, extensionId, targetId, includeUserAgentShadowDOM, query, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$2, {
        query: query,
        includeUserAgentShadowDOM: includeUserAgentShadowDOM
    });
}
var methodName$3 = "DOM.getSearchResults";
var Params$4 = {};
var Result$4 = {};
var GetSearchResults = {
    methodName: methodName$3,
    Params: Params$4,
    Result: Result$4
};
function getSearchResults(tabId, extensionId, targetId, searchId, fromIndex, toIndex, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$3, {
        searchId: searchId,
        fromIndex: fromIndex,
        toIndex: toIndex
    });
}
function toInt(depth) {
    if (depth) {
        return depth._0;
    } else {
        return -1;
    }
}
var Depth = {
    toInt: toInt
};
var Params$5 = {};
var Result$5 = {};
var GetDocument = {
    Params: Params$5,
    Result: Result$5
};
function getDocument(depthOpt, pierce, tabId, extensionId, targetId, param) {
    var depth = depthOpt !== undefined ? depthOpt : /* TreeDepth */ ({
        _0: 1
    });
    var tmp = {
        depth: toInt(depth)
    };
    if (pierce !== undefined) {
        tmp.pierce = Caml_option.valFromOption(pierce);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getDocument", params).then(function(result) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.root;
        }));
    });
}
function centerPoint(param) {
    return [
        (param[0] + param[4]) / 2.0 | 0,
        (param[1] + param[5]) / 2.0 | 0
    ];
}
var $$Location = {
    centerPoint: centerPoint
};
var Params$6 = {};
var Result$6 = {};
var GetContentQuads = {
    Params: Params$6,
    Result: Result$6
};
function getContentQuads(tabId, extensionId, targetId, nodeId, backendNodeId, param) {
    var tmp = {};
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getContentQuads", params).catch(function(e) {
        Curry._2(Log$SmartcutsMacros.cdp.log2, "getContentQuads", e);
        return Promise.resolve(undefined);
    }).then(function(result) {
        var quads = OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.quads;
        });
        if (quads !== undefined) {
            return Promise.resolve(quads);
        } else {
            return Promise.resolve([]);
        }
    });
}
var Params$7 = {};
var Result$7 = {};
var DescribeNode = {
    Params: Params$7,
    Result: Result$7
};
function describeNode(nodeId, backendNodeId, objectId, depthOpt, pierce, tabId, extensionId, targetId, param) {
    var depth = depthOpt !== undefined ? depthOpt : /* TreeDepth */ ({
        _0: 1
    });
    var tmp = {
        depth: toInt(depth)
    };
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    if (objectId !== undefined) {
        tmp.objectId = Caml_option.valFromOption(objectId);
    }
    if (pierce !== undefined) {
        tmp.pierce = Caml_option.valFromOption(pierce);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.describeNode", params).then(function(result1) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.map(result1, function(result) {
            return result.node;
        }));
    });
}
var Params$8 = {};
var Result$8 = {};
var GetOuterHTML = {
    Params: Params$8,
    Result: Result$8
};
function getOuterHTML(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
    var tmp = {};
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    if (objectId !== undefined) {
        tmp.objectId = Caml_option.valFromOption(objectId);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getOuterHTML", params).then(function(result) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.outerHTML;
        }));
    });
}
var ShapeOutsideInfo = {};
var BoxModel = {};
var Params$9 = {};
var Result$9 = {};
var GetBoxModel = {
    Params: Params$9,
    Result: Result$9
};
function getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
    var tmp = {};
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    if (objectId !== undefined) {
        tmp.objectId = Caml_option.valFromOption(objectId);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getBoxModel", params).then(function(maybeResult) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeResult, function(result) {
            return result.model;
        }));
    });
}
var methodName$4 = "DOM.getNodeForLocation";
var Params$10 = {};
var Result$10 = {};
var GetNodeForLocation = {
    methodName: methodName$4,
    Params: Params$10,
    Result: Result$10
};
function getNodeForLocation(x, y, includeUserAgentShadowDOM, ignorePointerEventsNone, tabId, extensionId, targetId, param) {
    var tmp = {
        x: x,
        y: y
    };
    if (includeUserAgentShadowDOM !== undefined) {
        tmp.includeUserAgentShadowDOM = Caml_option.valFromOption(includeUserAgentShadowDOM);
    }
    if (ignorePointerEventsNone !== undefined) {
        tmp.ignorePointerEventsNone = Caml_option.valFromOption(ignorePointerEventsNone);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$4, params);
}
var methodName$5 = "DOM.scrollIntoViewIfNeeded";
var Params$11 = {};
var ScrollIntoViewIfNeeded = {
    methodName: methodName$5,
    Params: Params$11
};
function scrollIntoViewIfNeeded(nodeId, backendNodeId, objectId, rect, tabId, extensionId, targetId, param) {
    var tmp = {};
    if (nodeId !== undefined) {
        tmp.nodeId = Caml_option.valFromOption(nodeId);
    }
    if (backendNodeId !== undefined) {
        tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
    }
    if (objectId !== undefined) {
        tmp.objectId = Caml_option.valFromOption(objectId);
    }
    if (rect !== undefined) {
        tmp.rect = Caml_option.valFromOption(rect);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$5, params).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var RGBA = {};
var Rect;
exports.nodeId_encode = nodeId_encode;
exports.nodeId_decode = nodeId_decode;
exports.backendNodeId_encode = backendNodeId_encode;
exports.backendNodeId_decode = backendNodeId_decode;
exports.$$Node = $$Node;
exports.Rect = Rect;
exports.ResolveNode = ResolveNode;
exports.resolveNode = resolveNode;
exports.RequestNode = RequestNode;
exports.requestNode = requestNode;
exports.GetAttributes = GetAttributes;
exports.getAttributes = getAttributes;
exports.SetAttributeValue = SetAttributeValue;
exports.setAttributeValue = setAttributeValue;
exports.RemoveAttribute = RemoveAttribute;
exports.removeAttribute = removeAttribute;
exports.QuerySelector = QuerySelector;
exports.querySelector = querySelector;
exports.querySelectorAll = querySelectorAll;
exports.enable = enable;
exports.PerformSearch = PerformSearch;
exports.performSearch = performSearch;
exports.GetSearchResults = GetSearchResults;
exports.getSearchResults = getSearchResults;
exports.Depth = Depth;
exports.GetDocument = GetDocument;
exports.getDocument = getDocument;
exports.$$Location = $$Location;
exports.GetContentQuads = GetContentQuads;
exports.getContentQuads = getContentQuads;
exports.DescribeNode = DescribeNode;
exports.describeNode = describeNode;
exports.GetOuterHTML = GetOuterHTML;
exports.getOuterHTML = getOuterHTML;
exports.ShapeOutsideInfo = ShapeOutsideInfo;
exports.BoxModel = BoxModel;
exports.GetBoxModel = GetBoxModel;
exports.getBoxModel = getBoxModel;
exports.GetNodeForLocation = GetNodeForLocation;
exports.getNodeForLocation = getNodeForLocation;
exports.ScrollIntoViewIfNeeded = ScrollIntoViewIfNeeded;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.RGBA = RGBA; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 19186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_option = __webpack_require__(57175);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
var EventListener = {};
var methodName = "DOMDebugger.getEventListeners";
var Params = {};
var Result = {};
var GetEventListeners = {
    methodName: methodName,
    Params: Params,
    Result: Result
};
function getEventListeners(objectId, depth, pierce, tabId, extensionId, targetId, param) {
    var tmp = {
        objectId: objectId
    };
    if (depth !== undefined) {
        tmp.depth = Caml_option.valFromOption(depth);
    }
    if (pierce !== undefined) {
        tmp.pierce = Caml_option.valFromOption(pierce);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params).then(function(result) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, function(prim) {
            return prim.listeners;
        }));
    });
}
exports.EventListener = EventListener;
exports.GetEventListeners = GetEventListeners;
exports.getEventListeners = getEventListeners; /* Browser__Debugger-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 21434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var PlaybackModal$SmartcutsMacros = __webpack_require__(15618);
var DevProtocol__DOM$SmartcutsMacros = __webpack_require__(58637);
var DevProtocol__Page$SmartcutsMacros = __webpack_require__(35677);
var DevProtocol__Input$SmartcutsMacros = __webpack_require__(95533);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
var DevProtocol__Runtime$SmartcutsMacros = __webpack_require__(76584);
var DevProtocol__DOMDebugger$SmartcutsMacros = __webpack_require__(19186);
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = __webpack_require__(54837);
function getEventListenersForNodeId(tabId, nodeId) {
    return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function(maybeRemoteObject) {
        if (maybeRemoteObject === undefined) {
            return Promise.resolve([]);
        }
        var objectId = maybeRemoteObject.objectId;
        if (objectId !== undefined) {
            return DevProtocol__DOMDebugger$SmartcutsMacros.getEventListeners(objectId, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeListeners) {
                if (maybeListeners !== undefined) {
                    return Promise.resolve(maybeListeners);
                } else {
                    return Promise.resolve([]);
                }
            });
        } else {
            return Promise.resolve([]);
        }
    });
}
function fromNode(node) {
    return {
        TAG: /* BackendNodeId */ 1,
        _0: node.backendNodeId
    };
}
function describeNode(tabId, depth, node) {
    if (node.TAG === /* NodeId */ 0) {
        return DevProtocol__DOM$SmartcutsMacros.describeNode(node._0, undefined, undefined, depth, undefined, tabId, undefined, undefined, undefined);
    } else {
        return DevProtocol__DOM$SmartcutsMacros.describeNode(undefined, node._0, undefined, depth, undefined, tabId, undefined, undefined, undefined);
    }
}
function backendNodeIdGet(tabId, addCancelCallback, v) {
    if (v.TAG !== /* NodeId */ 0) {
        return Promise.resolve(v._0);
    }
    var nodeId = v._0;
    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(param, isCanceled) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return describeNode(tabId, /* TreeDepth */ {
            _0: 1
        }, v).then(function(maybeNode) {
            return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expected to describeNode for nodeId " + String(nodeId), maybeNode).backendNodeId);
        });
    });
    Curry._1(addCancelCallback, match[1]);
    return Curry._1(match[0], undefined);
}
var NodeRepresentation = {
    fromNode: fromNode,
    describeNode: describeNode,
    backendNodeIdGet: backendNodeIdGet
};
function rectFromBoxModel(param) {
    var border = param.border;
    var y1 = border[1];
    var x1 = border[0];
    return {
        x: x1,
        y: y1,
        width: border[2] - x1,
        height: border[5] - y1
    };
}
function rectFromVisualViewport(param) {
    return {
        x: param.pageX,
        y: param.pageY,
        width: param.clientWidth,
        height: param.clientHeight
    };
}
function isChildOrPseudoElement(tabId, addCancelCallback, childrenOrPseudoElementsFromNode, possibleAncestorNode, possibleDescendantNodeRep) {
    var childrenOrPsuedoElements = Curry._1(childrenOrPseudoElementsFromNode, possibleAncestorNode);
    if (childrenOrPsuedoElements !== undefined) {
        if (ArrayUtils$SmartcutsMacros.isEmpty(childrenOrPsuedoElements)) {
            return Promise.resolve([
                false,
                []
            ]);
        } else {
            return backendNodeIdGet(tabId, addCancelCallback, possibleDescendantNodeRep).then(function(possibleDescendantBackendNodeId) {
                var isPossibleDescendantIdOneOfTheChildren = $$Array.exists(function(childNode) {
                    return possibleDescendantBackendNodeId === childNode.backendNodeId;
                }, childrenOrPsuedoElements);
                return Promise.resolve([
                    isPossibleDescendantIdOneOfTheChildren,
                    childrenOrPsuedoElements
                ]);
            });
        }
    } else {
        return Promise.resolve([
            false,
            []
        ]);
    }
}
function isDescendant(tabId, addCancelCallback1, possibleAncestorNodeRep, possibleDescendantNodeRep) {
    var match1 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback2, isCanceled) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return describeNode(tabId, /* EntireSubTree */ 0, possibleAncestorNodeRep).then(function(maybeAncestor) {
            if (maybeAncestor === undefined) {
                return Promise.resolve(false);
            }
            var node = Caml_option.valFromOption(maybeAncestor);
            var match2 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback3, param1) {
                return isChildOrPseudoElement(tabId, addCancelCallback3, function(prim) {
                    return Caml_option.undefined_to_opt(prim.children);
                }, node, possibleDescendantNodeRep).then(function(param2) {
                    var isChild = param2[0];
                    if (isChild) {
                        return Promise.resolve(isChild);
                    }
                    var children = param2[1];
                    var match3 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback4, param3) {
                        return isChildOrPseudoElement(tabId, addCancelCallback4, function(prim) {
                            return Caml_option.undefined_to_opt(prim.pseudoElements);
                        }, node, possibleDescendantNodeRep).then(function(param) {
                            if (param[0]) {
                                return Promise.resolve(true);
                            } else if (ArrayUtils$SmartcutsMacros.isEmpty(children)) {
                                return Promise.resolve(false);
                            } else {
                                return Promise.race($$Array.map(function(childNode) {
                                    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param) {
                                        return isDescendant(tabId, addCancelCallback, {
                                            TAG: /* NodeId */ 0,
                                            _0: childNode.nodeId
                                        }, possibleDescendantNodeRep);
                                    });
                                    Curry._1(addCancelCallback4, match[1]);
                                    return Curry._1(match[0], undefined);
                                }, children));
                            }
                        });
                    });
                    Curry._1(addCancelCallback3, match3[1]);
                    return Curry._1(match3[0], undefined);
                });
            });
            Curry._1(addCancelCallback2, match2[1]);
            return Curry._1(match2[0], undefined);
        }).catch(function(jsPromiseError) {
            var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
            if (typeof jsExn !== "number") {
                switch(jsExn.TAG | 0){
                    case /* JsExn */ 0:
                        if (Caml_obj.caml_equal(jsExn._0.message, '{"code":-32000,"message":"Could not find node with given id"}')) {
                            return Promise.resolve(false);
                        }
                        break;
                    case /* UnknownPromiseError */ 13:
                        console.error(jsExn._0);
                        return Promise.resolve(false);
                    default:
                }
            }
            console.error(jsPromiseError);
            return Promise.resolve(false);
        });
    });
    Curry._1(addCancelCallback1, match1[1]);
    return Curry._1(match1[0], undefined);
}
function getParentInDomTree(domTree, backendNodeId) {
    var match = domTree.children;
    var match$1 = domTree.shadowRoots;
    var exit = 0;
    var childrenNodes;
    var shadowRoots;
    if (match !== undefined) {
        var exit$1 = 0;
        if (match.length !== 0) {
            exit$1 = 3;
        } else {
            if (match$1 === undefined) {
                return;
            }
            if (match$1.length === 0) {
                return;
            }
            exit$1 = 3;
        }
        if (exit$1 === 3) {
            if (match$1 !== undefined && match$1.length !== 0) {
                if (match.length !== 0) {
                    if (Belt_Array.some(match$1, function(shadowRoot) {
                        return shadowRoot.backendNodeId === backendNodeId;
                    })) {
                        return Caml_option.some(domTree);
                    }
                    if (Belt_Array.some(match, function(childNode) {
                        return childNode.backendNodeId === backendNodeId;
                    })) {
                        return Caml_option.some(domTree);
                    }
                    var parent = Util$SmartcutsMacros.shortcut(function(subTree) {
                        return getParentInDomTree(subTree, backendNodeId);
                    }, match$1);
                    if (parent !== undefined) {
                        return Caml_option.some(Caml_option.valFromOption(parent));
                    } else {
                        return Util$SmartcutsMacros.shortcut(function(subTree) {
                            return getParentInDomTree(subTree, backendNodeId);
                        }, match);
                    }
                }
                shadowRoots = match$1;
                exit = 2;
            } else {
                childrenNodes = match;
                exit = 1;
            }
        }
    } else {
        if (match$1 === undefined) {
            return;
        }
        if (match$1.length === 0) {
            return;
        }
        shadowRoots = match$1;
        exit = 2;
    }
    switch(exit){
        case 1:
            if (Belt_Array.some(childrenNodes, function(childNode) {
                return childNode.backendNodeId === backendNodeId;
            })) {
                return Caml_option.some(domTree);
            } else {
                return Util$SmartcutsMacros.shortcut(function(subTree) {
                    return getParentInDomTree(subTree, backendNodeId);
                }, childrenNodes);
            }
        case 2:
            if (Belt_Array.some(shadowRoots, function(shadowRoot) {
                return shadowRoot.backendNodeId === backendNodeId;
            })) {
                return Caml_option.some(domTree);
            } else {
                return Util$SmartcutsMacros.shortcut(function(subTree) {
                    return getParentInDomTree(subTree, backendNodeId);
                }, shadowRoots);
            }
    }
}
function findNodeInDomTreeByNodeIdOrBackendNodeId(maybeNodeId, maybeBackendNodeId, domTree) {
    if (maybeBackendNodeId !== undefined) {
        if (maybeNodeId !== undefined) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected at either nodeId or backendNodeId specified when findNodeInDomTreeByNodeIdOrBackendNodeId()");
        }
        if (domTree.backendNodeId === maybeBackendNodeId) {
            return Caml_option.some(domTree);
        }
        var arg = maybeBackendNodeId;
        var partial_arg = function partial_arg(eta) {
            return findNodeInDomTreeByNodeIdOrBackendNodeId(undefined, arg, eta);
        };
        return Belt_Option.flatMap(Caml_option.undefined_to_opt(domTree.children), function(param) {
            return ArrayUtils$SmartcutsMacros.shortcut(partial_arg, param);
        });
    }
    if (maybeNodeId === undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Expected at either nodeId or backendNodeId specified when findNodeInDomTreeByNodeIdOrBackendNodeId()");
    }
    if (domTree.nodeId === maybeNodeId) {
        return Caml_option.some(domTree);
    }
    var partial_arg$1 = maybeNodeId;
    var partial_arg$2 = function partial_arg$2(eta) {
        var param;
        return findNodeInDomTreeByNodeIdOrBackendNodeId(partial_arg$1, param, eta);
    };
    return Belt_Option.flatMap(Caml_option.undefined_to_opt(domTree.children), function(param) {
        return ArrayUtils$SmartcutsMacros.shortcut(partial_arg$2, param);
    });
}
function closestAncestorNode(f, domTree, node) {
    return Curry._1(f, node).then(function(result) {
        if (result) {
            return Promise.resolve(Caml_option.some(node));
        }
        var backendNodeId = node.backendNodeId;
        var parent = getParentInDomTree(domTree, backendNodeId);
        if (parent !== undefined) {
            return closestAncestorNode(f, domTree, Caml_option.valFromOption(parent));
        } else {
            return Promise.resolve(undefined);
        }
    });
}
function existsAncestorNode(f, domTree, node) {
    return closestAncestorNode(f, domTree, node).then(function(maybeAncestorNode) {
        return Promise.resolve(Belt_Option.isSome(maybeAncestorNode));
    });
}
function commonAncestorNode(tabId, domTree, addCancelCallback, nodeId1, nodeId2) {
    var nodeRep2 = {
        TAG: /* NodeId */ 0,
        _0: nodeId2
    };
    var node1 = findNodeInDomTreeByNodeIdOrBackendNodeId(nodeId1, undefined, domTree);
    if (node1 !== undefined) {
        return closestAncestorNode(function(node) {
            return isDescendant(tabId, addCancelCallback, {
                TAG: /* BackendNodeId */ 1,
                _0: node.backendNodeId
            }, nodeRep2);
        }, domTree, Caml_option.valFromOption(node1));
    } else {
        return Promise.resolve(undefined);
    }
}
function doesEitherNodeContainEachOther(tabId, nodeId1, nodeId2, addCancelCallback) {
    return Belt_List.reduce({
        hd: [
            nodeId1,
            nodeId2
        ],
        tl: {
            hd: [
                nodeId2,
                nodeId1
            ],
            tl: /* [] */ 0
        }
    }, Promise.resolve(false), function(promise_oneNodeIsDescendantOfTheOther, param) {
        var possibleAncestorNodeId = param[1];
        var possibleDescendantNodeId = param[0];
        return promise_oneNodeIsDescendantOfTheOther.then(function(oneNodeIsDescendantOfTheOther) {
            if (oneNodeIsDescendantOfTheOther) {
                return Promise.resolve(true);
            } else {
                return isDescendant(tabId, addCancelCallback, {
                    TAG: /* NodeId */ 0,
                    _0: possibleAncestorNodeId
                }, {
                    TAG: /* NodeId */ 0,
                    _0: possibleDescendantNodeId
                });
            }
        });
    });
}
function getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
    return DevProtocol__DOM$SmartcutsMacros.describeNode(nodeId, backendNodeId, objectId, undefined, undefined, tabId, extensionId, targetId, undefined).then(function(maybeNode) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeNode, function(prim) {
            return prim.nodeName;
        }));
    }).then(function(maybeNodeName) {
        if (maybeNodeName !== undefined && maybeNodeName !== "SLOT") {
            return DevProtocol__DOM$SmartcutsMacros.getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, undefined).catch(function(jsPromiseError) {
                var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */ 0 && Caml_obj.caml_equal(jsExn._0.message, '{"code":-32000,"message":"Could not compute box model."}'))) {
                    return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
                } else {
                    return Promise.resolve(undefined);
                }
            });
        } else {
            return Promise.resolve(undefined);
        }
    });
}
function waitForNonNegativeBoxModel(timeout, interval, nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param4) {
    return Util$SmartcutsMacros.waitForPromise2(timeout, interval, function(param5) {
        return getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, undefined).then(function(maybeBoxModel) {
            var arg = Belt_Option.map(maybeBoxModel, function(boxModel) {
                var match = rectFromBoxModel(boxModel);
                if (match.x < 0 || match.y < 0) {
                    return /* PredicateNotSatisfied */ 0;
                } else {
                    return {
                        TAG: /* PredicateSatisfied */ 0,
                        _0: boxModel
                    };
                }
            });
            return Promise.resolve(function(param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
            }(/* PredicateNotSatisfied */ 0));
        });
    });
}
function isNodeVisible(tabId, addCancelCallback, nodeId) {
    return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
        return getBoxModel(nodeId, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeBoxModel) {
            if (maybeBoxModel !== undefined) {
                return Promise.resolve(!(maybeBoxModel.width === 0 && maybeBoxModel.height === 0));
            } else {
                return Promise.resolve(false);
            }
        }).catch(function(jsPromiseError) {
            var jsExn = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
            if (typeof jsExn === "number" || !(jsExn.TAG === /* JsExn */ 0 && Caml_obj.caml_equal(jsExn._0.message, '{"code":-32000,"message":"Could not compute box model."}'))) {
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
            } else {
                return Promise.resolve(false);
            }
        });
    });
}
function getScrollHeight(tabId, backendNodeId) {
    return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeResult) {
        if (maybeResult === undefined) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Expect to get Some(object) when resolveNode() to getScrollHeight()");
        }
        var objectId = OptionUtils$SmartcutsMacros.getExn("Expect to get Some(objectId)", maybeResult.objectId);
        return DevProtocol__Runtime$SmartcutsMacros.getProperties(objectId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(properties) {
            console.warn("props for scrollHeight", properties);
            return Promise.resolve(properties);
        });
    }).then(function(maybeReturn) {
        if (maybeReturn !== undefined) {
            return Promise.resolve(Belt_Option.flatMap(Curry._2(DevProtocol__Runtime$SmartcutsMacros.GetProperties.Return.getPropertyValue, Caml_option.valFromOption(maybeReturn), "scrollHeight"), Js_json.decodeNumber));
        } else {
            return Promise.resolve(undefined);
        }
    });
}
function getClientHeight(tabId, nodeId) {
    return PromiseUtils$SmartcutsMacros.resolveWith(function(maybeBoxModel) {
        if (maybeBoxModel !== undefined) {
            return maybeBoxModel.height;
        }
    }, getBoxModel(nodeId, undefined, undefined, tabId, undefined, undefined, undefined));
}
function isNodeScrollable(tabId, node) {
    var nodeId = node.nodeId;
    var backendNodeId = node.backendNodeId;
    return Promise.all([
        getScrollHeight(tabId, backendNodeId),
        getClientHeight(tabId, nodeId)
    ]).then(function(param) {
        var maybeClientHeight = param[1];
        var maybeScrollHeight = param[0];
        if (maybeScrollHeight !== undefined && maybeClientHeight !== undefined) {
            return Promise.resolve(maybeScrollHeight > maybeClientHeight);
        } else {
            return Promise.resolve(false);
        }
    });
}
function scrollBy(tabId, nodeId, xOpt, yOpt, param6) {
    var x = xOpt !== undefined ? xOpt : 0;
    var y = yOpt !== undefined ? yOpt : 0;
    if (x === 0 && y === 0) {
        return Promise.resolve(undefined);
    }
    return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function(maybeRemoteObject) {
        var arg = Belt_Option.flatMap(maybeRemoteObject, function(param) {
            return param.objectId;
        });
        var objectId = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect to get Some({objectId: Some(objectId)}) as result of resolveNode() when try to scrollBy()");
        return DevProtocol__Runtime$SmartcutsMacros.callFunctionOn("Element.prototype.scrollBy", objectId, [
            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(x),
            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(y)
        ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function($$return) {
            var exceptionDetails = $$return.exceptionDetails;
            if (exceptionDetails !== undefined) {
                Curry._2(Log$SmartcutsMacros.cdp.error2, "Exception when trying to scrollBy()", exceptionDetails);
                return Promise.reject({
                    RE_EXN_ID: DevProtocol__Runtime$SmartcutsMacros.Exception,
                    _1: exceptionDetails
                });
            } else {
                return Promise.resolve(undefined);
            }
        });
    });
}
function scrollTo(tabId, nodeId, xOpt, yOpt, param7) {
    var x = xOpt !== undefined ? xOpt : 0;
    var y = yOpt !== undefined ? yOpt : 0;
    return DevProtocol__DOM$SmartcutsMacros.resolveNode(undefined, undefined, nodeId, undefined, tabId, undefined, undefined, undefined).then(function(maybeRemoteObject) {
        var arg = Belt_Option.flatMap(maybeRemoteObject, function(param) {
            return param.objectId;
        });
        var objectId = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }("Expect to get Some({objectId: Some(objectId)}) as result of resolveNode() when try to scrollTo()");
        return DevProtocol__Runtime$SmartcutsMacros.callFunctionOn("Element.prototype.scrollTo", objectId, [
            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(x),
            DevProtocol__Runtime$SmartcutsMacros.CallArgument.$$int(y)
        ], undefined, undefined, undefined, undefined, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function($$return) {
            var exceptionDetails = $$return.exceptionDetails;
            if (exceptionDetails !== undefined) {
                Curry._2(Log$SmartcutsMacros.cdp.error2, "Exception when trying to scrollTo()", exceptionDetails);
                return Promise.reject({
                    RE_EXN_ID: DevProtocol__Runtime$SmartcutsMacros.Exception,
                    _1: exceptionDetails
                });
            } else {
                return Promise.resolve(undefined);
            }
        });
    });
}
function findOverlayRoot(tabId, addCancelCallback, sharedRoot, nodeIdOfElementAtPoint) {
    var nodeRepOfElementAtPoint = {
        TAG: /* NodeId */ 0,
        _0: nodeIdOfElementAtPoint
    };
    var loop = function(node2) {
        var nodeId = node2.nodeId;
        return isNodeVisible(tabId, addCancelCallback, nodeId).then(function(result) {
            if (result) {
                return Promise.resolve(Caml_option.some(node2));
            }
            var childrenNodes = node2.children;
            if (childrenNodes !== undefined) {
                return ArrayUtils$SmartcutsMacros.shortcutAsync(function(node) {
                    return isDescendant(tabId, addCancelCallback, {
                        TAG: /* BackendNodeId */ 1,
                        _0: node.backendNodeId
                    }, nodeRepOfElementAtPoint).then(function(doesNodeContainElementAtPoint) {
                        if (doesNodeContainElementAtPoint) {
                            return loop(node);
                        } else {
                            return Promise.resolve(undefined);
                        }
                    });
                }, childrenNodes);
            } else {
                return Promise.resolve(undefined);
            }
        });
    };
    return loop(sharedRoot);
}
function clickPositionRelToElement(tabId, nodeId, positionRelToElement, modifiers, addCancelCallback, param8) {
    var match4 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback1, isCanceled1) {
        if (isCanceled1.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return getBoxModel(nodeId, undefined, undefined, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(tabId), undefined, undefined, undefined).then(function(maybeBoxModel) {
            if (maybeBoxModel === undefined) {
                return Promise.resolve(false);
            }
            var match = positionRelToElement.parent;
            var parentHeight = match.height;
            var parentWidth = match.width;
            var y = positionRelToElement.y;
            var x = positionRelToElement.x;
            var match$1 = maybeBoxModel.border;
            var y1 = match$1[1];
            var x1 = match$1[0];
            var xRatio = parentWidth > 0 ? x > 0 ? x / parentWidth : 0.5 : 0.5;
            var yRatio = parentHeight > 0 ? y > 0 ? y / parentHeight : 0.5 : 0.5;
            var xRel = maybeBoxModel.width * xRatio;
            var yRel = maybeBoxModel.height * yRatio;
            var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function(param9, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                var arg = x1 + xRel | 0;
                var arg$1 = y1 + yRel | 0;
                var dispatchMouseEvent = function dispatchMouseEvent(param10, param$11, param$2) {
                    var func = Curry._7(DevProtocol__Input$SmartcutsMacros.dispatchMouseEvent, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(tabId), param10, param$11, param$2, arg, arg$1, modifiers);
                    return function(param, param$1) {
                        return Curry._4(func, param, "left", param$1, 1);
                    };
                };
                return Curry._4(dispatchMouseEvent(undefined, undefined, "mousePressed")(undefined, undefined), undefined, undefined, undefined, undefined).then(function(param) {
                    return Curry._4(dispatchMouseEvent(undefined, undefined, "mouseReleased")(undefined, undefined), undefined, undefined, undefined, undefined);
                }).then(function(param) {
                    return Promise.resolve(true);
                });
            });
            Curry._1(addCancelCallback1, match$2[1]);
            return Curry._1(match$2[0], undefined);
        });
    });
    Curry._1(addCancelCallback, match4[1]);
    return Curry._1(match4[0], undefined);
}
function doesNodeMatchId(tabId, idToMatch, node) {
    var backendNodeId = node.backendNodeId;
    return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeResult) {
        if (maybeResult === undefined) {
            return Promise.resolve(false);
        }
        var objectId = maybeResult.objectId;
        if (objectId !== undefined) {
            return DevProtocol__Runtime$SmartcutsMacros.getProperties(objectId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeProperties) {
                var id = Belt_Option.flatMap(Belt_Option.flatMap(maybeProperties, function(properties) {
                    return Curry._2(DevProtocol__Runtime$SmartcutsMacros.GetProperties.Return.getPropertyValue, properties, "id");
                }), Js_json.decodeString);
                if (id !== undefined) {
                    return Promise.resolve(id === idToMatch);
                } else {
                    return Promise.resolve(false);
                }
            });
        } else {
            return Promise.resolve(false);
        }
    });
}
function isElementTopZIndexAtLocation(tabId, nodeId, maybeRelPosition, addCancelCallback5, param11) {
    var match5 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback6, isCanceled2) {
        if (isCanceled2.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return Promise.all([
            DevProtocol__Page$SmartcutsMacros.getLayoutMetrics(tabId, undefined, undefined, undefined),
            waitForNonNegativeBoxModel(4000, Util$SmartcutsMacros.WaitFor.checkIntervalMs, nodeId, undefined, undefined, tabId, undefined, undefined, undefined)
        ]).then(function(param12) {
            var waitForResult_boxModel = param12[1];
            var maybeLayoutMetrics = param12[0];
            console.warn("GOT LAYOUT AND BOX MODEL", maybeLayoutMetrics, waitForResult_boxModel);
            if (maybeLayoutMetrics === undefined) {
                return Promise.resolve(/* CannotGetLayoutMetricsOrBoxModelOfElement */ 1);
            }
            if (waitForResult_boxModel.TAG === /* Ok */ 0) {
                var boxModel = waitForResult_boxModel._0;
                switch(boxModel.TAG | 0){
                    case /* PredicateDidResolveTo */ 0:
                        var boxModel$1 = boxModel._0;
                        var height = boxModel$1.height;
                        var width = boxModel$1.width;
                        var visualViewportRect = rectFromVisualViewport(maybeLayoutMetrics.cssVisualViewport);
                        var pageY = visualViewportRect.y;
                        var pageX = visualViewportRect.x;
                        var elementBorderRect = rectFromBoxModel(boxModel$1);
                        var top = elementBorderRect.y;
                        var left = elementBorderRect.x;
                        console.warn("maybeRelPosition", maybeRelPosition);
                        var match6;
                        if (maybeRelPosition !== undefined) {
                            var match$1 = maybeRelPosition.parent;
                            var parentHeight = match$1.height;
                            var parentWidth = match$1.width;
                            var y = maybeRelPosition.y;
                            var x = maybeRelPosition.x;
                            var xRatio = parentWidth > 0 ? x > 0 ? x / parentWidth : 0.5 : 0.5;
                            var yRatio = parentHeight > 0 ? y > 0 ? y / parentHeight : 0.5 : 0.5;
                            console.warn("xRatio", xRatio);
                            console.warn("yRatio", yRatio);
                            match6 = [
                                width * xRatio,
                                height * yRatio
                            ];
                        } else {
                            match6 = [
                                width / 2,
                                height / 2
                            ];
                        }
                        var yRel = match6[1];
                        var xRel = match6[0];
                        var x$1 = pageX + left + xRel;
                        console.warn("Calculating x", pageX, left, xRel);
                        var y$1 = pageY + top + yRel;
                        console.warn("Calculating y", pageY, top, yRel);
                        var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback7, isCanceled) {
                            if (isCanceled.contents) {
                                throw {
                                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                                    Error: new Error()
                                };
                            }
                            console.warn("GETTING NODE FOR LOCATION", x$1, y$1);
                            return DevProtocol__DOM$SmartcutsMacros.getNodeForLocation(x$1 | 0, y$1 | 0, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeResult) {
                                if (maybeResult === undefined) {
                                    return Promise.resolve(/* ElementNotInViewport */ 2);
                                }
                                var nodeId2 = maybeResult.nodeId;
                                if (nodeId2 === undefined) {
                                    return Promise.resolve(/* ElementNotInViewport */ 2);
                                }
                                var isSameElement = nodeId2 === nodeId;
                                if (isSameElement) {
                                    return Promise.resolve(/* ElementIsTopZIndexAtLocation */ 0);
                                }
                                var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param13) {
                                    return doesEitherNodeContainEachOther(tabId, nodeId, nodeId2, addCancelCallback).then(function(eitherNodeContainsTheOther) {
                                        if (eitherNodeContainsTheOther) {
                                            return Promise.resolve(/* ElementIsTopZIndexAtLocation */ 0);
                                        } else {
                                            return DevProtocol__DOM$SmartcutsMacros.getDocument(/* EntireSubTree */ 0, true, tabId, undefined, undefined, undefined).then(function(maybeDomTree) {
                                                if (maybeDomTree === undefined) {
                                                    return Promise.resolve(/* CannotGetDomTree */ 3);
                                                }
                                                var domTree = Caml_option.valFromOption(maybeDomTree);
                                                var checkOverlayIsPlaybackModal = function checkOverlayIsPlaybackModal(param14) {
                                                    var overlayNode = findNodeInDomTreeByNodeIdOrBackendNodeId(nodeId2, undefined, domTree);
                                                    if (overlayNode !== undefined) {
                                                        return existsAncestorNode(function(param) {
                                                            return doesNodeMatchId(tabId, PlaybackModal$SmartcutsMacros.PlaybackModal.containerId, param);
                                                        }, domTree, Caml_option.valFromOption(overlayNode));
                                                    } else {
                                                        return Promise.resolve(false);
                                                    }
                                                };
                                                return checkOverlayIsPlaybackModal(undefined).then(function(overlayIsPlaybackModal) {
                                                    if (overlayIsPlaybackModal) {
                                                        return Promise.resolve(/* HideSmartcutsPlaybackModalUntilCompletedCommand */ 8);
                                                    } else {
                                                        return commonAncestorNode(tabId, domTree, addCancelCallback, nodeId, nodeId2).then(function(maybeCommonAncestor) {
                                                            if (maybeCommonAncestor === undefined) {
                                                                return Promise.resolve(/* CannotFindOverlayRoot */ 5);
                                                            }
                                                            var ancestor = Caml_option.valFromOption(maybeCommonAncestor);
                                                            return Promise.all([
                                                                closestAncestorNode(function(param) {
                                                                    return isNodeScrollable(tabId, param);
                                                                }, domTree, ancestor),
                                                                findOverlayRoot(tabId, addCancelCallback, ancestor, nodeId2)
                                                            ]).then(function(param) {
                                                                var maybeOverlayRoot = param[1];
                                                                var maybeScrollRoot = param[0];
                                                                if (maybeScrollRoot === undefined) {
                                                                    return Promise.resolve(/* CannotFindScrollRoot */ 6);
                                                                }
                                                                if (maybeOverlayRoot === undefined) {
                                                                    return Promise.resolve(/* CannotFindOverlayRoot */ 5);
                                                                }
                                                                var scrollRoot = Caml_option.valFromOption(maybeScrollRoot);
                                                                return getBoxModel(undefined, Caml_option.valFromOption(maybeOverlayRoot).backendNodeId, undefined, tabId, undefined, undefined, undefined).then(function(maybeBoxModel) {
                                                                    if (maybeBoxModel === undefined) {
                                                                        return Promise.resolve(/* CannotGetBoxModelOfOverlay */ 4);
                                                                    }
                                                                    var overlayBorderRect = rectFromBoxModel(maybeBoxModel);
                                                                    var viewportTop = Rect$SmartcutsMacros.top(visualViewportRect);
                                                                    var viewportBottom = Rect$SmartcutsMacros.bottom(visualViewportRect);
                                                                    var viewportHeight = visualViewportRect.height;
                                                                    var overlayTop = Rect$SmartcutsMacros.top(overlayBorderRect);
                                                                    var overlayBottom = Rect$SmartcutsMacros.bottom(overlayBorderRect);
                                                                    var overlayHeight = overlayBorderRect.height;
                                                                    if (!(viewportTop <= overlayTop && viewportBottom >= overlayBottom && viewportHeight > overlayHeight)) {
                                                                        return Promise.resolve(/* CannotScrollToRevealElement */ 7);
                                                                    }
                                                                    var distanceToScroll;
                                                                    if (viewportBottom - overlayBottom > overlayTop - viewportTop) {
                                                                        var elementTop = Rect$SmartcutsMacros.top(elementBorderRect);
                                                                        distanceToScroll = elementTop - overlayBottom;
                                                                    } else {
                                                                        var elementBottom = Rect$SmartcutsMacros.bottom(elementBorderRect);
                                                                        distanceToScroll = overlayTop - elementBottom;
                                                                    }
                                                                    return Promise.resolve(/* ScrollToRevealElement */ {
                                                                        _0: scrollRoot,
                                                                        _1: distanceToScroll
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    }
                                                });
                                            });
                                        }
                                    });
                                });
                                Curry._1(addCancelCallback7, match[1]);
                                return Curry._1(match[0], undefined);
                            });
                        });
                        Curry._1(addCancelCallback6, match$2[1]);
                        return Curry._1(match$2[0], undefined);
                    case /* TimedOut */ 1:
                    case /* PredicateTimedOut */ 2:
                        break;
                }
            }
            if (waitForResult_boxModel.TAG === /* Ok */ 0) {
                return Promise.resolve(/* CannotGetLayoutMetricsOrBoxModelOfElement */ 1);
            }
            var promiseError = waitForResult_boxModel._0;
            if (promiseError.TAG !== /* UncaughtPredicateError */ 0) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Error while waiting to get a non-negative box model");
            }
            console.error("Error while waiting to get a non-negative box model", promiseError._0);
            return Util$SmartcutsMacros.logAndRaiseJsError("Error while waiting to get a non-negative box model");
        });
    });
    Curry._1(addCancelCallback5, match5[1]);
    return Curry._1(match5[0], undefined);
}
function getNodeIdFromBackendNodeId(tabId, backendNodeId, addCancelCallback8) {
    return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback8, function(addCancelCallback) {
        return DevProtocol__DOM$SmartcutsMacros.resolveNode(backendNodeId, undefined, undefined, undefined, tabId, undefined, undefined, undefined).then(function(maybeRemoteObject) {
            if (maybeRemoteObject === undefined) {
                return Promise.resolve(undefined);
            }
            var objectId = maybeRemoteObject.objectId;
            if (objectId !== undefined) {
                return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
                    return DevProtocol__DOM$SmartcutsMacros.requestNode(objectId, tabId, undefined, undefined, undefined).then(function(maybeNodeId) {
                        return Promise.resolve(maybeNodeId);
                    });
                });
            } else {
                return Promise.resolve(undefined);
            }
        });
    });
}
exports.getEventListenersForNodeId = getEventListenersForNodeId;
exports.NodeRepresentation = NodeRepresentation;
exports.rectFromBoxModel = rectFromBoxModel;
exports.rectFromVisualViewport = rectFromVisualViewport;
exports.isChildOrPseudoElement = isChildOrPseudoElement;
exports.isDescendant = isDescendant;
exports.getParentInDomTree = getParentInDomTree;
exports.findNodeInDomTreeByNodeIdOrBackendNodeId = findNodeInDomTreeByNodeIdOrBackendNodeId;
exports.closestAncestorNode = closestAncestorNode;
exports.existsAncestorNode = existsAncestorNode;
exports.commonAncestorNode = commonAncestorNode;
exports.doesEitherNodeContainEachOther = doesEitherNodeContainEachOther;
exports.getBoxModel = getBoxModel;
exports.waitForNonNegativeBoxModel = waitForNonNegativeBoxModel;
exports.isNodeVisible = isNodeVisible;
exports.getScrollHeight = getScrollHeight;
exports.getClientHeight = getClientHeight;
exports.isNodeScrollable = isNodeScrollable;
exports.scrollBy = scrollBy;
exports.scrollTo = scrollTo;
exports.clickPositionRelToElement = clickPositionRelToElement;
exports.doesNodeMatchId = doesNodeMatchId;
exports.isElementTopZIndexAtLocation = isElementTopZIndexAtLocation;
exports.getNodeIdFromBackendNodeId = getNodeIdFromBackendNodeId; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 95533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Caml_option = __webpack_require__(57175);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
var DevProtocol__Shared$SmartcutsMacros = __webpack_require__(54246);
var _map = {
    "keyDown": "keyDown",
    "keyUp": "keyUp",
    "rawKeyDown": "rawKeyDown",
    "rawKeyUp": "rawKeyUp",
    "char_": "char"
};
var _revMap = {
    "keyDown": "keyDown",
    "keyUp": "keyUp",
    "rawKeyDown": "rawKeyDown",
    "rawKeyUp": "rawKeyUp",
    "char": "char_"
};
function keyEventTypeToJs(param) {
    return _map[param];
}
function keyEventTypeFromJs(param) {
    return _revMap[param];
}
var DispatchKeyEvent = {};
function dispatchKeyEvent(type_, modifiers, timestamp, text, unmodifiedText, keyIdentifier, code, key, windowsVirtualKeyCode, nativeVirtualKeyCode, autoRepeat, isKeypad, isSystemKey, $$location, tabId, extensionId, targetId, param) {
    var tmp = {
        type: keyEventTypeToJs(type_)
    };
    if (modifiers !== undefined) {
        tmp.modifiers = Caml_option.valFromOption(modifiers);
    }
    if (timestamp !== undefined) {
        tmp.timestamp = Caml_option.valFromOption(timestamp);
    }
    if (text !== undefined) {
        tmp.text = Caml_option.valFromOption(text);
    }
    if (unmodifiedText !== undefined) {
        tmp.unmodifiedText = Caml_option.valFromOption(unmodifiedText);
    }
    if (keyIdentifier !== undefined) {
        tmp.keyIdentifier = Caml_option.valFromOption(keyIdentifier);
    }
    if (code !== undefined) {
        tmp.code = Caml_option.valFromOption(code);
    }
    if (key !== undefined) {
        tmp.key = Caml_option.valFromOption(key);
    }
    if (windowsVirtualKeyCode !== undefined) {
        tmp.windowsVirtualKeyCode = Caml_option.valFromOption(windowsVirtualKeyCode);
    }
    if (nativeVirtualKeyCode !== undefined) {
        tmp.nativeVirtualKeyCode = Caml_option.valFromOption(nativeVirtualKeyCode);
    }
    if (autoRepeat !== undefined) {
        tmp.autoRepeat = Caml_option.valFromOption(autoRepeat);
    }
    if (isKeypad !== undefined) {
        tmp.isKeypad = Caml_option.valFromOption(isKeypad);
    }
    if (isSystemKey !== undefined) {
        tmp.isSystemKey = Caml_option.valFromOption(isSystemKey);
    }
    if ($$location !== undefined) {
        tmp.location = Caml_option.valFromOption($$location);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.dispatchKeyEvent", params).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}
var InsertTextParams = {};
function insertText(tabId, extensionId, targetId, text, param) {
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.insertText", {
        text: text
    }).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}
var _map$1 = {
    "mouse": "mouse",
    "pen": "pen"
};
function pointerTypeToJs(param) {
    return param;
}
function pointerTypeFromJs(param) {
    return _map$1[param];
}
var _map$2 = {
    "mousePressed": "mousePressed",
    "mouseReleased": "mouseReleased",
    "mouseMoved": "mouseMoved",
    "mouseWheel": "mouseWheel"
};
function type_ToJs(param) {
    return param;
}
function type_FromJs(param) {
    return _map$2[param];
}
var _map$3 = _defineProperty({
    "none": "none",
    "left": "left",
    "middle": "middle"
}, "left", "left");
function buttonToJs(param) {
    return param;
}
function buttonFromJs(param) {
    return _map$3[param];
}
var DispatchMouseEvent = {
    pointerTypeToJs: pointerTypeToJs,
    pointerTypeFromJs: pointerTypeFromJs,
    type_ToJs: type_ToJs,
    type_FromJs: type_FromJs,
    buttonToJs: buttonToJs,
    buttonFromJs: buttonFromJs
};
function dispatchMouseEvent(tabId, extensionId, targetId, type_, x, y, modifiers, timestamp, button, buttons, clickCount, deltaX, deltaY, pointerType, param) {
    var tmp = {
        type: type_,
        x: x,
        y: y
    };
    if (modifiers !== undefined) {
        tmp.modifiers = Caml_option.valFromOption(modifiers);
    }
    if (timestamp !== undefined) {
        tmp.timestamp = Caml_option.valFromOption(timestamp);
    }
    var tmp$1 = OptionUtils$SmartcutsMacros.$neg$question$great(button, buttonToJs);
    if (tmp$1 !== undefined) {
        tmp.button = Caml_option.valFromOption(tmp$1);
    }
    if (buttons !== undefined) {
        tmp.buttons = Caml_option.valFromOption(buttons);
    }
    if (clickCount !== undefined) {
        tmp.clickCount = Caml_option.valFromOption(clickCount);
    }
    if (deltaX !== undefined) {
        tmp.deltaX = Caml_option.valFromOption(deltaX);
    }
    if (deltaY !== undefined) {
        tmp.deltaY = Caml_option.valFromOption(deltaY);
    }
    var tmp$2 = OptionUtils$SmartcutsMacros.$neg$question$great(pointerType, pointerTypeToJs);
    if (tmp$2 !== undefined) {
        tmp.pointerType = Caml_option.valFromOption(tmp$2);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.dispatchMouseEvent", params).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}
exports.keyEventTypeToJs = keyEventTypeToJs;
exports.keyEventTypeFromJs = keyEventTypeFromJs;
exports.DispatchKeyEvent = DispatchKeyEvent;
exports.dispatchKeyEvent = dispatchKeyEvent;
exports.InsertTextParams = InsertTextParams;
exports.insertText = insertText;
exports.DispatchMouseEvent = DispatchMouseEvent;
exports.dispatchMouseEvent = dispatchMouseEvent; /* Browser__Debugger-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 35677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Image$SmartcutsMacros = __webpack_require__(68387);
var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
var LayoutViewport = {};
var $$VisualViewport = {};
var Viewport = {};
var methodName = "Page.getLayoutMetrics";
var Result = {};
var GetLayoutMetrics = {
    methodName: methodName,
    Result: Result
};
function getLayoutMetrics(tabId, extensionId, targetId, param) {
    var params = {};
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params);
}
var methodName$1 = "Page.captureScreenshot";
var Params = {};
var Result$1 = {};
var CaptureScreenshot = {
    methodName: methodName$1,
    Params: Params,
    Result: Result$1
};
function captureScreenshot(tabId, extensionId, targetId, format, quality, clip, fromSurface, captureBeyondViewport, param) {
    var tmp = {};
    var tmp$1 = Belt_Option.map(format, Image$SmartcutsMacros.Format.stringify);
    if (tmp$1 !== undefined) {
        tmp.format = Caml_option.valFromOption(tmp$1);
    }
    if (quality !== undefined) {
        tmp.quality = Caml_option.valFromOption(quality);
    }
    if (clip !== undefined) {
        tmp.clip = Caml_option.valFromOption(clip);
    }
    if (fromSurface !== undefined) {
        tmp.fromSurface = Caml_option.valFromOption(fromSurface);
    }
    if (captureBeyondViewport !== undefined) {
        tmp.captureBeyondViewport = Caml_option.valFromOption(captureBeyondViewport);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$1, params);
}
exports.LayoutViewport = LayoutViewport;
exports.$$VisualViewport = $$VisualViewport;
exports.Viewport = Viewport;
exports.GetLayoutMetrics = GetLayoutMetrics;
exports.getLayoutMetrics = getLayoutMetrics;
exports.CaptureScreenshot = CaptureScreenshot;
exports.captureScreenshot = captureScreenshot; /* Image-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 54246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
function sendCommandPromiseCallback(maybeError) {
    if (maybeError === undefined) {
        return Promise.resolve(undefined);
    }
    var lastError = browser.runtime.lastError;
    if (lastError == null) {
        return Promise.resolve(undefined);
    }
    Curry._2(Log$SmartcutsMacros.cdp.log2, "lastError", lastError);
    var message = lastError.message;
    if (message !== undefined) {
        return Util$SmartcutsMacros.logAndRaiseJsError(message);
    } else {
        return Util$SmartcutsMacros.logAndRaiseJsError("An unknown error occurred");
    }
}
exports.sendCommandPromiseCallback = sendCommandPromiseCallback; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 14017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
function t_encode(v) {
    if (v) {
        return [
            "ContentAllowedToBeMissing"
        ];
    } else {
        return [
            "ContentMustBePresent"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ContentAllowedToBeMissing":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentAllowedToBeMissing */ 1
                    };
                }
            case "ContentMustBePresent":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* ContentMustBePresent */ 0
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v) {
        return "ContentAllowedToBeMissing";
    } else {
        return "ContentMustBePresent";
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify; /* No side effect */ 


/***/ }),

/***/ 79929:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Util$SmartcutsMacros = __webpack_require__(25092);
var ContentOptionality$SmartcutsMacros = __webpack_require__(14017);
function fromInputValue(value) {
    switch(value){
        case "ContentAllowedToBeMissing":
            return /* ContentAllowedToBeMissing */ 1;
        case "ContentMustBePresent":
            return /* ContentMustBePresent */ 0;
        default:
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected valid content optionality config value");
    }
}
var $$default = /* ContentMustBePresent */ 0;
var toInputValue = ContentOptionality$SmartcutsMacros.stringify;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true;
exports.toInputValue = toInputValue;
exports.fromInputValue = fromInputValue; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 69679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Util$SmartcutsMacros = __webpack_require__(25092);
function t_encode(v) {
    if (v.TAG === /* ExpectToWaitForContentToLoad */ 0) {
        return [
            "ExpectToWaitForContentToLoad",
            Decco.floatToJson(v._0)
        ];
    } else {
        return [
            "ExpectContentImmediately",
            Decco.floatToJson(v._0)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "ExpectContentImmediately":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExpectContentImmediately */ 1,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ExpectToWaitForContentToLoad":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ExpectToWaitForContentToLoad */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v.TAG === /* ExpectToWaitForContentToLoad */ 0) {
        return "ExpectToWaitForContentToLoad(" + (v._0.toString() + ")");
    } else {
        return "ExpectContentImmediately(" + (v._0.toString() + ")");
    }
}
var $$default = {
    TAG: /* ExpectToWaitForContentToLoad */ 0,
    _0: Util$SmartcutsMacros.WaitFor.defaultTimeout
};
function toRadioInputValue(v) {
    if (v.TAG === /* ExpectToWaitForContentToLoad */ 0) {
        return "ExpectToWaitForContentToLoad";
    } else {
        return "ExpectContentImmediately";
    }
}
function fromRadioInputValue(waitValue, valueString) {
    switch(valueString){
        case "ExpectContentImmediately":
            return {
                TAG: /* ExpectContentImmediately */ 1,
                _0: 20
            };
        case "ExpectToWaitForContentToLoad":
            return {
                TAG: /* ExpectToWaitForContentToLoad */ 0,
                _0: waitValue
            };
        default:
            return Util$SmartcutsMacros.logAndRaiseJsError("Expected valid content timing value");
    }
}
function buildChoicesBasedOnCurrentChoice(currentChoice) {
    if (currentChoice.TAG === /* ExpectToWaitForContentToLoad */ 0) {
        return [
            currentChoice,
            {
                TAG: /* ExpectContentImmediately */ 1,
                _0: 20
            }
        ];
    } else {
        return [
            $$default,
            currentChoice
        ];
    }
}
function timeoutMillisecondsGet(v) {
    return v._0;
}
function intervalMillisecondsGet(v) {
    if (v.TAG === /* ExpectToWaitForContentToLoad */ 0) {
        return v._0 / 4 | 0;
    } else {
        return v._0 | 0;
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.$$default = $$default;
exports["default"] = $$default;
exports.__esModule = true;
exports.toRadioInputValue = toRadioInputValue;
exports.fromRadioInputValue = fromRadioInputValue;
exports.buildChoicesBasedOnCurrentChoice = buildChoicesBasedOnCurrentChoice;
exports.timeoutMillisecondsGet = timeoutMillisecondsGet;
exports.intervalMillisecondsGet = intervalMillisecondsGet; /* Util-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 2850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "playbackFormLabel",
            Decco.stringToJson(v.playbackFormLabel)
        ],
        [
            "defaultValue",
            Decco.stringToJson(v.defaultValue)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */ 0) {
        var defaultValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "defaultValue"), null));
        if (defaultValue.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    playbackFormLabel: playbackFormLabel._0,
                    defaultValue: defaultValue._0
                }
            };
        }
        var e = defaultValue._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".defaultValue" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = playbackFormLabel._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".playbackFormLabel" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var VariableInnerTextConfig = {
    t_encode: t_encode,
    t_decode: t_decode
};
function t_encode$1(v) {
    if (typeof v === "number") {
        return [
            "AnyInnerText"
        ];
    }
    switch(v.TAG | 0){
        case /* MatchesFullInnerText */ 0:
            return [
                "MatchesFullInnerText",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
            ];
        case /* MatchesInnerTextPrefix */ 1:
            return [
                "MatchesInnerTextPrefix",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
            ];
        case /* ContainsInnerText */ 2:
            return [
                "ContainsInnerText",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
            ];
        case /* ContainsInnerTextEnum */ 3:
            return [
                "ContainsInnerTextEnum",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.arrayToJson(Decco.stringToJson, v._2)
            ];
        case /* ContainsInnerTextAllStrings */ 4:
            return [
                "ContainsInnerTextAllStrings",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.arrayToJson(Decco.stringToJson, v._2)
            ];
        case /* VariableInnerText */ 5:
            return [
                "VariableInnerText",
                t_encode(v._0)
            ];
    }
}
function t_decode$1(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AnyInnerText":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AnyInnerText */ 0
                    };
                }
            case "ContainsInnerText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* ContainsInnerText */ 2,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "ContainsInnerTextAllStrings":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$3 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* ContainsInnerTextAllStrings */ 4,
                                    _0: match$1._0,
                                    _1: match$2._0,
                                    _2: match$3._0
                                }
                            };
                        }
                        var e$1 = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                            }
                        };
                    }
                    var e$2 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                        }
                    };
                }
                var e$3 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "ContainsInnerTextEnum":
                if (tagged.length !== 4) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
                var match$6 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 3));
                if (match$4.TAG === /* Ok */ 0) {
                    if (match$5.TAG === /* Ok */ 0) {
                        if (match$6.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    TAG: /* ContainsInnerTextEnum */ 3,
                                    _0: match$4._0,
                                    _1: match$5._0,
                                    _2: match$6._0
                                }
                            };
                        }
                        var e$4 = match$6._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[2]" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                            }
                        };
                    }
                    var e$5 = match$5._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                        }
                    };
                }
                var e$6 = match$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "MatchesFullInnerText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MatchesFullInnerText */ 0,
                            _0: v0$1._0
                        }
                    };
                }
                var e$7 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "MatchesInnerTextPrefix":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$2 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MatchesInnerTextPrefix */ 1,
                            _0: v0$2._0
                        }
                    };
                }
                var e$8 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "VariableInnerText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$3 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* VariableInnerText */ 5,
                            _0: v0$3._0
                        }
                    };
                }
                var e$9 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (typeof v === "number") {
        return "AnyInnerText";
    }
    switch(v.TAG | 0){
        case /* MatchesFullInnerText */ 0:
            return "MatchesFullInnerText(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
        case /* MatchesInnerTextPrefix */ 1:
            return "MatchesInnerTextPrefix(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
        case /* ContainsInnerText */ 2:
            return "ContainsInnerText(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, v._0) + ")");
        case /* ContainsInnerTextEnum */ 3:
            return "ContainsInnerTextEnum(" + (StringUtils$SmartcutsMacros.quote(v._0) + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", [" + (v._2.join(", ") + "])")))));
        case /* ContainsInnerTextAllStrings */ 4:
            return "ContainsInnerTextAllStrings(" + (StringUtils$SmartcutsMacros.quote(v._0) + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", [" + (v._2.join(", ") + "])")))));
        case /* VariableInnerText */ 5:
            var match = v._0;
            return "VariableInnerText({playbackFormLabel: " + (match.playbackFormLabel + (", defaultValue=" + (match.defaultValue + "})")));
    }
}
function isDynamic(v) {
    if (typeof v === "number" || v.TAG !== /* VariableInnerText */ 5) {
        return false;
    } else {
        return true;
    }
}
function getPrefixIntentionChoicesFromInnerText(text) {
    return Belt_Array.map(StringUtils$SmartcutsMacros.splitIntoPrefixesAtMost(text, 3), function(prefix) {
        return {
            TAG: /* MatchesInnerTextPrefix */ 1,
            _0: {
                TAG: /* StaticText */ 0,
                _0: prefix
            }
        };
    });
}
function getIntentionChoicesFromSelector(selector) {
    var match = Selector$SmartcutsMacros.maybeGetLeafNode(selector);
    if (match === undefined) {
        return [];
    }
    var innerText = match.innerText;
    if (typeof innerText === "number") {
        if (innerText === /* Ignored */ 0) {
            return [];
        } else {
            return [];
        }
    }
    if (innerText.TAG === /* FullInnerText */ 0) {
        var text = innerText._0;
        return $$Array.concat({
            hd: [
                /* AnyInnerText */ 0,
                {
                    TAG: /* ContainsInnerText */ 2,
                    _0: {
                        TAG: /* StaticText */ 0,
                        _0: text
                    }
                },
                {
                    TAG: /* MatchesFullInnerText */ 0,
                    _0: {
                        TAG: /* StaticText */ 0,
                        _0: text
                    }
                }
            ],
            tl: {
                hd: getPrefixIntentionChoicesFromInnerText(text),
                tl: {
                    hd: [
                        {
                            TAG: /* ContainsInnerTextEnum */ 3,
                            _0: text,
                            _1: "example phrase you can delete",
                            _2: []
                        },
                        {
                            TAG: /* VariableInnerText */ 5,
                            _0: {
                                playbackFormLabel: "[Add Label]",
                                defaultValue: text
                            }
                        }
                    ],
                    tl: /* [] */ 0
                }
            }
        });
    }
    var text$1 = innerText._0;
    return $$Array.concat({
        hd: [
            /* AnyInnerText */ 0,
            {
                TAG: /* ContainsInnerText */ 2,
                _0: {
                    TAG: /* StaticText */ 0,
                    _0: text$1
                }
            }
        ],
        tl: {
            hd: getPrefixIntentionChoicesFromInnerText(text$1),
            tl: {
                hd: [
                    {
                        TAG: /* ContainsInnerTextEnum */ 3,
                        _0: text$1,
                        _1: "example phrase you can delete",
                        _2: []
                    },
                    {
                        TAG: /* VariableInnerText */ 5,
                        _0: {
                            playbackFormLabel: "[Add Label]",
                            defaultValue: text$1
                        }
                    }
                ],
                tl: /* [] */ 0
            }
        }
    });
}
function mapDataRef(f, v) {
    if (typeof v === "number") {
        return /* AnyInnerText */ 0;
    }
    switch(v.TAG | 0){
        case /* MatchesFullInnerText */ 0:
            return {
                TAG: /* MatchesFullInnerText */ 0,
                _0: Curry._1(f, v._0)
            };
        case /* MatchesInnerTextPrefix */ 1:
            return {
                TAG: /* MatchesInnerTextPrefix */ 1,
                _0: Curry._1(f, v._0)
            };
        case /* ContainsInnerText */ 2:
            return {
                TAG: /* ContainsInnerText */ 2,
                _0: Curry._1(f, v._0)
            };
        case /* ContainsInnerTextEnum */ 3:
            return {
                TAG: /* ContainsInnerTextEnum */ 3,
                _0: v._0,
                _1: v._1,
                _2: v._2
            };
        case /* ContainsInnerTextAllStrings */ 4:
            return {
                TAG: /* ContainsInnerTextAllStrings */ 4,
                _0: v._0,
                _1: v._1,
                _2: v._2
            };
        case /* VariableInnerText */ 5:
            return {
                TAG: /* VariableInnerText */ 5,
                _0: v._0
            };
    }
}
function updatePlaybackFormLabel(playbackFormLabel, semantic) {
    if (typeof semantic === "number" || semantic.TAG !== /* VariableInnerText */ 5) {
        return semantic;
    } else {
        return {
            TAG: /* VariableInnerText */ 5,
            _0: {
                playbackFormLabel: playbackFormLabel,
                defaultValue: semantic._0.defaultValue
            }
        };
    }
}
exports.VariableInnerTextConfig = VariableInnerTextConfig;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.isDynamic = isDynamic;
exports.getIntentionChoicesFromSelector = getIntentionChoicesFromSelector;
exports.mapDataRef = mapDataRef;
exports.updatePlaybackFormLabel = updatePlaybackFormLabel; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 80093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
function isMergeable(_config) {
    return false;
}
function isDynamic(param) {
    return InnerTextSemantic$SmartcutsMacros.isDynamic(param.chosen);
}
function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
    var arg = config.chosen;
    return {
        intentionChoices: Belt_Array.map(config.intentionChoices, function(param) {
            return InnerTextSemantic$SmartcutsMacros.updatePlaybackFormLabel(playbackFormLabel, param);
        }),
        chosen: function(param) {
            return InnerTextSemantic$SmartcutsMacros.updatePlaybackFormLabel(param, arg);
        }(playbackFormLabel)
    };
}
function MakeTransformers(AuthoringCommandValue, PlaybackCommandValue) {
    var fromAuthoringCommandValue = function fromAuthoringCommandValue(cmdVal) {
        var _lastNode = ListUtils$SmartcutsMacros.getLast(Curry._1(AuthoringCommandValue.getSelector, cmdVal));
        if (_lastNode !== undefined) {
            if (typeof _lastNode.innerText === "number") {
                return;
            }
            var intentionChoices = InnerTextSemantic$SmartcutsMacros.getIntentionChoicesFromSelector(Curry._1(AuthoringCommandValue.getSelector, cmdVal));
            var arg = Belt_Array.get(intentionChoices, 0);
            return {
                intentionChoices: intentionChoices,
                chosen: function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                }("Expected at least one intention choice.")
            };
        }
        console.warn("no selector last");
    };
    var applyToAuthoringCommandValueToGetPlaybackCommandValue = function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
        var semantic;
        if (maybeConfig !== undefined) {
            var variableInnerTextConfig = maybeConfig.chosen;
            semantic = typeof variableInnerTextConfig === "number" || variableInnerTextConfig.TAG !== /* VariableInnerText */ 5 ? variableInnerTextConfig : {
                TAG: /* VariableInnerText */ 5,
                _0: {
                    playbackFormLabel: "[Add Label]",
                    defaultValue: variableInnerTextConfig._0.defaultValue
                }
            };
        } else {
            semantic = /* AnyInnerText */ 0;
        }
        return Curry._2(PlaybackCommandValue.fromAuthoringCommandValueAndSemantic, commandValue, semantic);
    };
    return {
        fromAuthoringCommandValue: fromAuthoringCommandValue,
        applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
    };
}
exports.isMergeable = isMergeable;
exports.isDynamic = isDynamic;
exports.updateConfigWithPlaybackFormLabel = updateConfigWithPlaybackFormLabel;
exports.MakeTransformers = MakeTransformers; /* InnerTextSemantic-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 79854:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Selector$SmartcutsMacros = __webpack_require__(14809);
function MakePlaybackParamValue(ParamDescriptor, PlaybackCommandValue) {
    var t_encode = Decco.stringToJson;
    var t_decode = Decco.stringFromJson;
    var fromParamDescriptor = function fromParamDescriptor(param) {
        return param.defaultValue;
    };
    var toCommandValueForPlayback = function toCommandValueForPlayback(oldCommandValue, value) {
        return Curry._2(PlaybackCommandValue.updateSelector, function(param) {
            return Selector$SmartcutsMacros.updateLeafNode(function(node) {
                return {
                    id: node.id,
                    tagName: node.tagName,
                    classNames: node.classNames,
                    attributes: node.attributes,
                    index: node.index,
                    innerText: {
                        TAG: /* FullInnerText */ 0,
                        _0: value
                    },
                    isScrollable: node.isScrollable,
                    attributeBlacklist: node.attributeBlacklist
                };
            }, param);
        }, oldCommandValue);
    };
    return {
        t_encode: t_encode,
        t_decode: t_decode,
        fromParamDescriptor: fromParamDescriptor,
        toCommandValueForPlayback: toCommandValueForPlayback
    };
}
exports.MakePlaybackParamValue = MakePlaybackParamValue; /* Selector-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 33143:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var InnerTextSemantic$SmartcutsMacros = __webpack_require__(2850);
function t_encode(v) {
    return InnerTextSemantic$SmartcutsMacros.VariableInnerTextConfig.t_encode(v);
}
function t_decode(v) {
    return InnerTextSemantic$SmartcutsMacros.VariableInnerTextConfig.t_decode(v);
}
function fromAuthoringConfig(param) {
    var chosen = param.chosen;
    if (typeof chosen === "number" || chosen.TAG !== /* VariableInnerText */ 5) {
        return;
    } else {
        return chosen._0;
    }
}
function getPlaybackFormLabelFromParam(param) {
    return param.playbackFormLabel;
}
function removePrivateInfo(v) {
    return {
        playbackFormLabel: v.playbackFormLabel,
        defaultValue: ""
    };
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.fromAuthoringConfig = fromAuthoringConfig;
exports.getPlaybackFormLabelFromParam = getPlaybackFormLabelFromParam;
exports.removePrivateInfo = removePrivateInfo; /* InnerTextSemantic-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 64372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var URLUtils$SmartcutsMacros = __webpack_require__(94971);
function t_encode(v) {
    if (v) {
        return [
            "MatchesLinkPrefix",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "AnyLink"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "AnyLink":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* AnyLink */ 0
                    };
                }
            case "MatchesLinkPrefix":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* MatchesLinkPrefix */ {
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (v) {
        return "MatchesLinkPrefix(" + (v._0 + ")");
    } else {
        return "AnyLink";
    }
}
function getIntentionChoicesFromOriginAndHref(origin, href) {
    var baseChoices = [
        /* AnyLink */ 0
    ];
    var url = URLUtils$SmartcutsMacros.$$URL.fromString(href);
    if (url !== undefined) {
        return $$Array.concat({
            hd: baseChoices,
            tl: {
                hd: url.origin === origin ? [] : [
                    /* MatchesLinkPrefix */ {
                        _0: url.origin
                    }
                ],
                tl: {
                    hd: Belt_Array.reduce(Belt_Array.keep(url.pathname.split("/"), function(s) {
                        return s !== "";
                    }), [
                        [],
                        url.origin
                    ], function(param, pathSegment) {
                        var nextPrefix = param[1] + ("/" + pathSegment);
                        return [
                            $$Array.append(param[0], [
                                /* MatchesLinkPrefix */ {
                                    _0: nextPrefix
                                }
                            ]),
                            nextPrefix
                        ];
                    })[0],
                    tl: /* [] */ 0
                }
            }
        });
    } else {
        return baseChoices;
    }
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.getIntentionChoicesFromOriginAndHref = getIntentionChoicesFromOriginAndHref; /* URLUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 57165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Belt_Array = __webpack_require__(2971);
function depthFirst(getChildNodesForNode, initResult, combineNodeWithResult, rootNode) {
    var traverse = function(result, currentNode) {
        return Belt_Array.reduce(Curry._1(getChildNodesForNode, currentNode), Curry._2(combineNodeWithResult, currentNode, result), traverse);
    };
    return traverse(initResult, rootNode);
}
exports.depthFirst = depthFirst; /* No side effect */ 


/***/ }),

/***/ 75997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
function make(set) {
    return {
        TAG: /* HaventGeneratedCombosYetForSet */ 0,
        _0: set
    };
}
function generateNextCombo(_generator) {
    while(true){
        var generator = _generator;
        if (generator.TAG === /* HaventGeneratedCombosYetForSet */ 0) {
            var set = generator._0;
            return [
                set,
                {
                    TAG: /* GeneratingSubsets */ 1,
                    currSubsetAlgo: {
                        TAG: /* ElideSingleElementFrom */ 0,
                        set: set,
                        remainingSingleElementsToRemove: set
                    },
                    iterations: []
                }
            ];
        }
        var iterations = generator.iterations;
        var currSubsetAlgo = generator.currSubsetAlgo;
        if (typeof currSubsetAlgo === "number") {
            var match = ArrayUtils$SmartcutsMacros.dequeue(iterations);
            if (match === undefined) {
                return;
            }
            _generator = {
                TAG: /* GeneratingSubsets */ 1,
                currSubsetAlgo: match[0],
                iterations: match[1]
            };
            continue;
        }
        if (currSubsetAlgo.TAG === /* ElideSingleElementFrom */ 0) {
            var remainingSingleElementsToRemove = currSubsetAlgo.remainingSingleElementsToRemove;
            if (!remainingSingleElementsToRemove) {
                return dequeueAndGenerateNextCombo(iterations);
            }
            var singleMemberToRemove = remainingSingleElementsToRemove.hd;
            var set$1 = currSubsetAlgo.set;
            var combo = ListUtils$SmartcutsMacros.removeValue(singleMemberToRemove, set$1);
            var set$p = ListUtils$SmartcutsMacros.removeValue(singleMemberToRemove, set$1);
            var numFixed = List.length(set$1) - List.length(remainingSingleElementsToRemove) | 0;
            var tmp;
            if (numFixed !== 0) {
                var match$1 = ListUtils$SmartcutsMacros.splitAt(numFixed, set$p);
                var nonFixed = match$1[1];
                tmp = {
                    TAG: /* CombineFixedWithCombosOfNonFixed */ 1,
                    fixed: match$1[0],
                    nonFixed: nonFixed,
                    remainingNonFixed: nonFixed
                };
            } else {
                tmp = {
                    TAG: /* ElideSingleElementFrom */ 0,
                    set: set$p,
                    remainingSingleElementsToRemove: set$p
                };
            }
            var nextGenerator_0 = {
                TAG: /* ElideSingleElementFrom */ 0,
                set: set$1,
                remainingSingleElementsToRemove: remainingSingleElementsToRemove.tl
            };
            var nextGenerator_1 = ArrayUtils$SmartcutsMacros.enqueue(tmp, iterations);
            var nextGenerator = {
                TAG: /* GeneratingSubsets */ 1,
                currSubsetAlgo: nextGenerator_0,
                iterations: nextGenerator_1
            };
            if (List.length(combo) !== 0) {
                return [
                    combo,
                    nextGenerator
                ];
            }
            _generator = nextGenerator;
            continue;
        }
        var remainingNonFixed = currSubsetAlgo.remainingNonFixed;
        if (!remainingNonFixed) {
            return dequeueAndGenerateNextCombo(iterations);
        }
        var nonFixed$1 = currSubsetAlgo.nonFixed;
        var fixed = currSubsetAlgo.fixed;
        var combo$1 = List.append(fixed, ListUtils$SmartcutsMacros.removeValue(remainingNonFixed.hd, nonFixed$1));
        var nextNumFixed = List.length(fixed) + (List.length(nonFixed$1) - List.length(remainingNonFixed) | 0) | 0;
        var tmp$1;
        if (List.length(combo$1) === nextNumFixed) {
            tmp$1 = /* CombosGeneratedByAPrecedingIterator */ 0;
        } else {
            var match$2 = ListUtils$SmartcutsMacros.splitAt(nextNumFixed, combo$1);
            var nonFixed$p = match$2[1];
            tmp$1 = {
                TAG: /* CombineFixedWithCombosOfNonFixed */ 1,
                fixed: match$2[0],
                nonFixed: nonFixed$p,
                remainingNonFixed: nonFixed$p
            };
        }
        var nextGenerator_0$1 = {
            TAG: /* CombineFixedWithCombosOfNonFixed */ 1,
            fixed: fixed,
            nonFixed: nonFixed$1,
            remainingNonFixed: remainingNonFixed.tl
        };
        var nextGenerator_1$1 = ArrayUtils$SmartcutsMacros.enqueue(tmp$1, iterations);
        var nextGenerator$1 = {
            TAG: /* GeneratingSubsets */ 1,
            currSubsetAlgo: nextGenerator_0$1,
            iterations: nextGenerator_1$1
        };
        return [
            combo$1,
            nextGenerator$1
        ];
    }
    ;
}
function dequeueAndGenerateNextCombo(iterations) {
    var match = ArrayUtils$SmartcutsMacros.dequeue(iterations);
    if (match !== undefined) {
        return generateNextCombo({
            TAG: /* GeneratingSubsets */ 1,
            currSubsetAlgo: match[0],
            iterations: match[1]
        });
    }
}
exports.make = make;
exports.generateNextCombo = generateNextCombo;
exports.dequeueAndGenerateNextCombo = dequeueAndGenerateNextCombo; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 22764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Node = __webpack_require__(98727);
var Webapi__Dom__Element = __webpack_require__(33116);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function t_encode(v) {
    if (typeof v === "number") {
        if (v === /* Ignored */ 0) {
            return [
                "Ignored"
            ];
        } else {
            return [
                "NoInnerText"
            ];
        }
    } else if (v.TAG === /* FullInnerText */ 0) {
        return [
            "FullInnerText",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "TruncatedInnerText",
            Decco.stringToJson(v._0),
            Decco.intToJson(v._1)
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "FullInnerText":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* FullInnerText */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Ignored":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* Ignored */ 0
                    };
                }
            case "NoInnerText":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NoInnerText */ 1
                    };
                }
            case "TruncatedInnerText":
                if (tagged.length !== 3) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
                if (match$1.TAG === /* Ok */ 0) {
                    if (match$2.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                TAG: /* TruncatedInnerText */ 1,
                                _0: match$1._0,
                                _1: match$2._0
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[1]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = match$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(v) {
    if (typeof v === "number") {
        if (v === /* Ignored */ 0) {
            return "Ignored";
        } else {
            return "NoInnerText";
        }
    } else if (v.TAG === /* FullInnerText */ 0) {
        return "FullInnerText(" + (v._0 + ")");
    } else {
        return "TruncatedInnerText(" + (v._0 + (String(v._1) + ")"));
    }
}
function fromString(s) {
    var s$1 = s.trim();
    if (s$1 === "") {
        return /* NoInnerText */ 1;
    } else {
        return {
            TAG: /* FullInnerText */ 0,
            _0: s$1
        };
    }
}
function equals(innerTextA, innerTextB) {
    if (typeof innerTextA === "number") {
        if (innerTextA === /* Ignored */ 0) {
            return innerTextB === 0;
        } else if (typeof innerTextB === "number") {
            return innerTextB !== 0;
        } else {
            return false;
        }
    } else if (innerTextA.TAG === /* FullInnerText */ 0) {
        if (typeof innerTextB === "number" || innerTextB.TAG !== /* FullInnerText */ 0) {
            return false;
        } else {
            return innerTextA._0 === innerTextB._0;
        }
    } else if (typeof innerTextB === "number" || !(innerTextB.TAG === /* TruncatedInnerText */ 1 && innerTextA._0 === innerTextB._0)) {
        return false;
    } else {
        return innerTextA._1 === innerTextB._1;
    }
}
var InnerText = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    fromString: fromString,
    equals: equals
};
function makeNode(id, tagName, classNames, attributes, innerText, clientLeft, clientTop, clientWidth, clientHeight, element) {
    var tmp;
    if (id !== undefined) {
        switch(id){
            case "":
            case "undefined":
                tmp = undefined;
                break;
            default:
                tmp = id;
        }
    } else {
        tmp = id;
    }
    var tmp$1;
    tmp$1 = innerText !== undefined && !(innerText === "undefined" || innerText.trim() === "") ? {
        TAG: /* FullInnerText */ 0,
        _0: innerText
    } : /* NoInnerText */ 1;
    return {
        TAG: /* ElementNode */ 1,
        _0: {
            id: tmp,
            tagName: OptionUtils$SmartcutsMacros.$neg$question$great(tagName, function(prim) {
                return prim.toLowerCase();
            }),
            classNames: classNames !== undefined ? classNames : [],
            attributes: attributes !== undefined ? attributes.filter(function(param) {
                switch(param[0]){
                    case "class":
                    case "id":
                    case "style":
                        return false;
                    default:
                        return true;
                }
            }) : [],
            innerText: tmp$1,
            shape: clientWidth !== undefined && clientHeight !== undefined ? {
                clientWidth: clientWidth,
                clientHeight: clientHeight
            } : undefined,
            offsetPosition: clientLeft !== undefined && clientTop !== undefined ? {
                clientLeft: clientLeft,
                clientTop: clientTop
            } : undefined,
            element: element
        }
    };
}
function getClassNames(element) {
    var classNames = [];
    element.classList.forEach(function(className, _index) {
        classNames.push(className);
    });
    return classNames;
}
function getAttributeNameValuePairs(element) {
    return $$Array.map(function(attribute) {
        return [
            attribute.name,
            attribute.value
        ];
    }, Array.prototype.slice.call(element.attributes));
}
var ElementHelpers = {
    getClassNames: getClassNames,
    getAttributeNameValuePairs: getAttributeNameValuePairs
};
function forDomElementAndItsAncestors(maybeUntilExclusiveAncestor, element) {
    var tagName = element.tagName;
    switch(tagName){
        case "":
        case "HTML":
        case "undefined":
            return /* [] */ 0;
        default:
            var node = makeNode(element.id, tagName, getClassNames(element), getAttributeNameValuePairs(element), element.innerText, element.clientLeft, element.clientTop, element.clientWidth, element.clientHeight, element);
            var match = element.parentNode;
            var parentNode;
            if (match == null) {
                return {
                    hd: node,
                    tl: /* [] */ 0
                };
            }
            if (maybeUntilExclusiveAncestor !== undefined) {
                if (Caml_obj.caml_equal(match, Caml_option.valFromOption(maybeUntilExclusiveAncestor))) {
                    return {
                        hd: node,
                        tl: /* [] */ 0
                    };
                }
                parentNode = match;
            } else {
                parentNode = match;
            }
            var match$1 = Webapi__Dom__Node.nodeType(parentNode);
            if (match$1 !== 10) {
                var parentElement = Webapi__Dom__Element.ofNode(parentNode);
                if (parentElement !== undefined) {
                    return {
                        hd: node,
                        tl: forDomElementAndItsAncestors(undefined, Caml_option.valFromOption(parentElement))
                    };
                } else {
                    console.warn("Expected host node of shadow root to be an element", parentNode);
                    return {
                        hd: node,
                        tl: /* [] */ 0
                    };
                }
            }
            var shadowRoot = {
                TAG: /* DocumentFragmentNode */ 0,
                _0: parentNode
            };
            var hostElement = Webapi__Dom__Element.ofNode(parentNode.host);
            if (hostElement !== undefined) {
                return {
                    hd: node,
                    tl: {
                        hd: shadowRoot,
                        tl: forDomElementAndItsAncestors(undefined, Caml_option.valFromOption(hostElement))
                    }
                };
            } else {
                console.warn("Expected host node of shadow root to be an element", parentNode.host);
                return {
                    hd: node,
                    tl: {
                        hd: shadowRoot,
                        tl: /* [] */ 0
                    }
                };
            }
    }
}
exports.InnerText = InnerText;
exports.makeNode = makeNode;
exports.ElementHelpers = ElementHelpers;
exports.forDomElementAndItsAncestors = forDomElementAndItsAncestors; /* Webapi__Dom__Node Not a pure module */ 


/***/ }),

/***/ 33429:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var Belt_SetString = __webpack_require__(41367);
var FastLevenshtein = __webpack_require__(95493);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var Webapi__Dom__Element = __webpack_require__(33116);
var XPath$SmartcutsMacros = __webpack_require__(73029);
var Selector$SmartcutsMacros = __webpack_require__(14809);
var HTMLNodes$SmartcutsMacros = __webpack_require__(22764);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DOM__Element$SmartcutsMacros = __webpack_require__(97209);
var PromiseUtils$SmartcutsMacros = __webpack_require__(57019);
var SelectorTree$SmartcutsMacros = __webpack_require__(47118);
var DOM__Document$SmartcutsMacros = __webpack_require__(79990);
var ComboGenerator$SmartcutsMacros = __webpack_require__(75997);
var DataDependency$SmartcutsMacros = __webpack_require__(4879);
var DevProtocol__DOM$SmartcutsMacros = __webpack_require__(58637);
function candidateBranch_encode(v) {
    return Js_dict.fromArray([
        [
            "branch",
            Decco.arrayToJson(DevProtocol__DOM$SmartcutsMacros.nodeId_encode, v.branch)
        ],
        [
            "distanceComponents",
            Decco.arrayToJson(Decco.floatToJson, v.distanceComponents)
        ]
    ]);
}
function candidateBranch_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var branch = Decco.arrayFromJson(DevProtocol__DOM$SmartcutsMacros.nodeId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "branch"), null));
    if (branch.TAG === /* Ok */ 0) {
        var distanceComponents = Decco.arrayFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "distanceComponents"), null));
        if (distanceComponents.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    branch: branch._0,
                    distanceComponents: distanceComponents._0
                }
            };
        }
        var e = distanceComponents._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".distanceComponents" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = branch._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".branch" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function MakeQueryInPromise(RunTime) {
    var doesElementMatchFullInnerText = function doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback1, element) {
        var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
            if (isCanceled.contents) {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                    Error: new Error()
                };
            }
            return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
        });
        Curry._1(addCancelCallback1, match[1]);
        return Curry._1(match[0], undefined).then(function(innerText) {
            var tmp;
            if (typeof innerText === "number") {
                tmp = innerText === /* Ignored */ 0 ? true : false;
            } else if (innerText.TAG === /* FullInnerText */ 0) {
                var normalizedText = $$String.lowercase_ascii(innerText._0.trim());
                var normalizedExpectedText = $$String.lowercase_ascii(fullTextToMatch.trim());
                tmp = Curry._2(compareFullInnerTextToExpectedFullInnerText, normalizedText, normalizedExpectedText);
            } else {
                var prefix = innerText._0;
                var normalizedPrefix = $$String.lowercase_ascii(prefix.trim());
                tmp = Curry._3(compareTruncatedInnerTextToExpectedFullInnerText, normalizedPrefix, innerText._1 - (prefix.length - normalizedPrefix.length | 0) | 0, $$String.lowercase_ascii(fullTextToMatch.trim()));
            }
            return Promise.resolve(tmp);
        });
    };
    var doesElementMatchInnerText = function doesElementMatchInnerText(maybeUseInnerTextExactMatch, maybeInnerTextSemantic, context, compareFullInnerTextToExpectedFullInnerText, compareFullInnerTextToExpectedTruncatedInnerText, compareTruncatedInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedTruncatedInnerText, addCancelCallback2, element) {
        if (maybeUseInnerTextExactMatch === undefined) {
            return Promise.resolve(true);
        }
        if (typeof maybeUseInnerTextExactMatch === "number") {
            if (maybeUseInnerTextExactMatch === /* Ignored */ 0) {
                if (maybeInnerTextSemantic === undefined) {
                    return Promise.resolve(true);
                }
                if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                    return Promise.resolve(true);
                }
            } else if (maybeInnerTextSemantic !== undefined) {
                if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                    return Promise.resolve(false);
                }
            } else {
                var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match[1]);
                return Curry._1(match[0], undefined).then(function(innerText) {
                    var tmp;
                    tmp = typeof innerText === "number" ? true : innerText._0 === "";
                    return Promise.resolve(tmp);
                });
            }
        } else if (maybeUseInnerTextExactMatch.TAG === /* FullInnerText */ 0) {
            var fullTextToMatch = maybeUseInnerTextExactMatch._0;
            if (maybeInnerTextSemantic === undefined) {
                return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback2, element);
            }
            if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                return doesElementMatchFullInnerText(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback2, element);
            }
        } else {
            var prefixToMatch = maybeUseInnerTextExactMatch._0;
            if (maybeInnerTextSemantic !== undefined) {
                if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected pairing with VariableInnerText: " + HTMLNodes$SmartcutsMacros.InnerText.stringify(maybeUseInnerTextExactMatch));
                }
            } else {
                var normalizedPrefixToMatch = $$String.lowercase_ascii(prefixToMatch.trim());
                var normalizedOriginalLength = maybeUseInnerTextExactMatch._1 - (prefixToMatch.length - normalizedPrefixToMatch.length | 0) | 0;
                var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match$1[1]);
                return Curry._1(match$1[0], undefined).then(function(innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */ 0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */ 0) {
                        var normalizedFullText = $$String.lowercase_ascii(innerText._0.trim());
                        tmp = Curry._3(compareFullInnerTextToExpectedTruncatedInnerText, normalizedFullText, normalizedPrefixToMatch, normalizedOriginalLength);
                    } else {
                        var prefix2 = innerText._0;
                        var normalizedPrefix2 = $$String.lowercase_ascii(prefix2.trim());
                        var normalizedLength2 = innerText._1 - (prefix2.length - normalizedPrefix2.length | 0) | 0;
                        tmp = Curry._4(compareTruncatedInnerTextToExpectedTruncatedInnerText, normalizedPrefix2, normalizedLength2, normalizedPrefixToMatch, normalizedOriginalLength);
                    }
                    return Promise.resolve(tmp);
                });
            }
        }
        if (typeof maybeInnerTextSemantic === "number") {
            return Promise.resolve(true);
        }
        switch(maybeInnerTextSemantic.TAG | 0){
            case /* MatchesFullInnerText */ 0:
                var fullTextToMatch$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
                return doesElementMatchFullInnerText(fullTextToMatch$1, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback2, element);
            case /* MatchesInnerTextPrefix */ 1:
                var stringThatShouldPrefixInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
                var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match$2[1]);
                return Curry._1(match$2[0], undefined).then(function(innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */ 0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */ 0) {
                        tmp = innerText._0.startsWith(stringThatShouldPrefixInnerText);
                    } else {
                        var prefix = innerText._0;
                        if (prefix.length > stringThatShouldPrefixInnerText.length) {
                            tmp = prefix.includes(stringThatShouldPrefixInnerText);
                        } else {
                            var truncatedStringThatShouldPrefixInnerText = stringThatShouldPrefixInnerText.slice(0, prefix.length);
                            tmp = truncatedStringThatShouldPrefixInnerText === prefix && truncatedStringThatShouldPrefixInnerText.length <= innerText._1;
                        }
                    }
                    return Promise.resolve(tmp);
                });
            case /* ContainsInnerText */ 2:
                var stringThatShouldBeInsideInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
                var match$3 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match$3[1]);
                return Curry._1(match$3[0], undefined).then(function(innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */ 0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */ 0) {
                        tmp = innerText._0.includes(stringThatShouldBeInsideInnerText);
                    } else {
                        var prefix = innerText._0;
                        if (prefix.length > stringThatShouldBeInsideInnerText.length) {
                            tmp = prefix.includes(stringThatShouldBeInsideInnerText);
                        } else {
                            console.warn("Unhandled ContainsInnerText against TruncatedInnerText");
                            tmp = false;
                        }
                    }
                    return Promise.resolve(tmp);
                });
            case /* ContainsInnerTextEnum */ 3:
                var possibleMatchingSubstrings = $$Array.append([
                    maybeInnerTextSemantic._0,
                    maybeInnerTextSemantic._1
                ], maybeInnerTextSemantic._2);
                var match$4 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match$4[1]);
                return Curry._1(match$4[0], undefined).then(function(innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */ 0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */ 0) {
                        var fullText = innerText._0;
                        tmp = Belt_Array.some(possibleMatchingSubstrings, function(substring) {
                            return fullText.includes(substring);
                        });
                    } else {
                        var prefix = innerText._0;
                        tmp = Belt_Array.some(possibleMatchingSubstrings, function(substring) {
                            if (prefix.length > substring.length) {
                                return prefix.includes(substring);
                            } else {
                                console.warn("Unhandled ContainsInnerTextEnum against TruncatedInnerText");
                                return false;
                            }
                        });
                    }
                    return Promise.resolve(tmp);
                });
            case /* ContainsInnerTextAllStrings */ 4:
                var allRequiredSubstrings = $$Array.append([
                    maybeInnerTextSemantic._0,
                    maybeInnerTextSemantic._1
                ], maybeInnerTextSemantic._2);
                var match$5 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                    if (isCanceled.contents) {
                        throw {
                            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                            Error: new Error()
                        };
                    }
                    return Curry._3(RunTime.getInnerTextForElement, context, addCancelCallback, element);
                });
                Curry._1(addCancelCallback2, match$5[1]);
                return Curry._1(match$5[0], undefined).then(function(innerText) {
                    var tmp;
                    if (typeof innerText === "number") {
                        tmp = innerText === /* Ignored */ 0 ? true : false;
                    } else if (innerText.TAG === /* FullInnerText */ 0) {
                        var fullText = innerText._0;
                        tmp = Belt_Array.every(allRequiredSubstrings, function(substring) {
                            return fullText.includes(substring);
                        });
                    } else {
                        var prefix = innerText._0;
                        tmp = Belt_Array.every(allRequiredSubstrings, function(substring) {
                            if (prefix.length > substring.length) {
                                return prefix.includes(substring);
                            } else {
                                console.warn("Unhandled ContainsInnerTextAllStrings against TruncatedInnerText");
                                return false;
                            }
                        });
                    }
                    return Promise.resolve(tmp);
                });
        }
    };
    var arg = function arg(text, expectedText) {
        return text === expectedText;
    };
    var arg$1 = function arg$1(text, expectedPrefix, param) {
        return text.startsWith(expectedPrefix);
    };
    var arg$2 = function arg$2(prefix, length, expectedText) {
        if (expectedText.startsWith(prefix)) {
            return length === expectedText.length;
        } else {
            return false;
        }
    };
    var arg$3 = function arg$3(prefix, length, expectedPrefix, expectedOriginalLength) {
        if (length === expectedOriginalLength) {
            if (prefix.length >= expectedPrefix.length) {
                return prefix.startsWith(expectedPrefix);
            } else {
                return expectedPrefix.startsWith(prefix);
            }
        } else {
            return false;
        }
    };
    var doesElementMatchInnerTextExactly = function doesElementMatchInnerTextExactly(param1) {
        return function(param$1) {
            var func = function func(param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
                return doesElementMatchInnerText(param1, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
            };
            return function(param) {
                return Curry._5(func, param, arg, arg$1, arg$2, arg$3);
            };
        };
    };
    var arg$4 = function arg$4(text, expectedText) {
        return text.includes(expectedText);
    };
    var arg$5 = function arg$5(text, expectedPrefix, expectedOriginalLength) {
        if (text.includes(expectedPrefix)) {
            return text.length >= expectedOriginalLength;
        } else {
            return false;
        }
    };
    var arg$6 = function arg$6(prefix, length, expectedText) {
        if (prefix.includes(expectedText)) {
            return length >= expectedText.length;
        } else {
            return false;
        }
    };
    var arg$7 = function arg$7(prefix, length, expectedPrefix, expectedOriginalLength) {
        if (prefix.startsWith(expectedPrefix)) {
            return length >= expectedOriginalLength;
        } else {
            return false;
        }
    };
    var doesElementIncludeInnerText = function doesElementIncludeInnerText(param2) {
        return function(param$1) {
            var func = function func(param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
                return doesElementMatchInnerText(param2, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
            };
            return function(param) {
                return Curry._5(func, param, arg$4, arg$5, arg$6, arg$7);
            };
        };
    };
    var keepElementsThatMatchInnerTextExactly = function keepElementsThatMatchInnerTextExactly(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
        return Promise.all($$Array.mapi(function(index, element) {
            return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
                return Promise.resolve([
                    doesMatch,
                    Caml_array.get(elements, index)
                ]);
            });
        }, elements)).then(function(pairsOfDoesMatchAndElement) {
            return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, function(param) {
                return param[0];
            }), function(prim) {
                return prim[1];
            }));
        });
    };
    var onlyKeepVisibleElements = function onlyKeepVisibleElements(context, addCancelCallback, elements) {
        return ArrayUtils$SmartcutsMacros.keepAsync(function(element) {
            return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
                return Curry._2(RunTime.isVisibleOnPage, context, element);
            });
        }, elements);
    };
    var checkIsOptionElement = function checkIsOptionElement(context, element) {
        return Curry._2(RunTime.getTagName, context, element).then(function(maybeTagName) {
            return Promise.resolve(Caml_obj.caml_equal(maybeTagName, "OPTION"));
        });
    };
    var onlyKeepVisibleElementsOrOptionElements = function onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, elements) {
        return ArrayUtils$SmartcutsMacros.keepAsync(function(element) {
            return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
                return checkIsOptionElement(context, element).then(function(isOptionElement) {
                    if (isOptionElement) {
                        return Promise.resolve(true);
                    } else {
                        return Curry._2(RunTime.isVisibleOnPage, context, element);
                    }
                });
            });
        }, elements);
    };
    var isElementScrollable = function isElementScrollable(context, element) {
        return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
            var hasScrollableContent = param[0] > param[1];
            var isOverflowHidden = param[2].includes("hidden");
            if (hasScrollableContent) {
                return !isOverflowHidden;
            } else {
                return false;
            }
        }, Promise.all([
            Curry._2(RunTime.getScrollHeight, context, element),
            Curry._2(RunTime.getClientHeight, context, element),
            Curry._2(RunTime.getOverflowYForElement, context, element)
        ]));
    };
    var getElementsWithSameDepthAndAttributeKeysAsSelector = function getElementsWithSameDepthAndAttributeKeysAsSelector(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param3) {
        var attributesFilter;
        if (typeof attributesExistencePredicate === "number") {
            switch(attributesExistencePredicate){
                case /* AllAttributes */ 0:
                    attributesFilter = function attributesFilter(_selectorNodeIndex, _attrName) {
                        return true;
                    };
                    break;
                case /* AttributesNotDataOrAria */ 1:
                    attributesFilter = function attributesFilter(_selectorNodeIndex, attrName) {
                        return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
                    };
                    break;
                case /* OnlyUseId */ 2:
                    attributesFilter = function attributesFilter(_selectorNodeIndex, attrName) {
                        return attrName === "id";
                    };
                    break;
            }
        } else {
            var nLevels = attributesExistencePredicate._0;
            attributesFilter = function attributesFilter(selectorNodeIndex, attrName) {
                if (attrName === "class") {
                    return (List.length(selector) - selectorNodeIndex | 0) > nLevels;
                } else {
                    return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
                }
            };
        }
        return Curry._1(RunTime.getCurrentUrl, context).then(function(currentUrl) {
            var cssSelector = Selector$SmartcutsMacros.toCssSelectorUsingTagChainAndAttributeExistence(queryRoot !== /* Document */ 0, attributesFilter, currentUrl, selector);
            var tagName = leafSelectorNode.tagName;
            return Curry._5(RunTime.querySelectorAll, context, queryRoot, domTree, tagName !== undefined && $$String.lowercase_ascii(tagName) === "option" ? true : includeElementsNotVisible, cssSelector);
        }).then(function(result_matches) {
            if (result_matches.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_matches._0
                });
            }
            var matches1 = result_matches._0;
            var tmp;
            if (useInnerText) {
                var param4 = leafSelectorNode.innerText;
                var func = function func(param$1, param$2, param$3, param$4) {
                    return keepElementsThatMatchInnerTextExactly(param4, param$1, param$2, param$3, param$4);
                };
                tmp = Curry._2(function(param6) {
                    var func$1 = Curry._1(func, param6);
                    return function(param7) {
                        var func$2 = Curry._1(func$1, param7);
                        return function(param) {
                            return Curry._2(func$2, param, matches1);
                        };
                    };
                }(maybeInnerTextSemantic), context, addCancelCallback);
            } else {
                tmp = Promise.resolve(matches1);
            }
            return tmp.then(function(elements) {
                if (includeElementsNotVisible) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: elements
                    });
                } else {
                    return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, elements).then(function(matches) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: matches
                        });
                    });
                }
            });
        });
    };
    var calcDistanceBetweenBetweenIds = function calcDistanceBetweenBetweenIds(elementAttributes, selectorNode) {
        var match = Curry._1(RunTime.idFromAttributes, elementAttributes);
        var match$1 = selectorNode.id;
        if (match === undefined) {
            if (match$1 !== undefined) {
                return 1000;
            } else {
                return 0;
            }
        }
        if (match$1 === undefined) {
            return 10;
        }
        if (match === match$1) {
            return 0;
        }
        if (match.length === match$1.length) {
            return 10;
        }
        var _prefix = StringUtils$SmartcutsMacros.commonPrefix(match, match$1);
        if (_prefix !== undefined) {
            return 10;
        } else {
            return 1000;
        }
    };
    var calcDistanceBetweenBetweenClasses = function calcDistanceBetweenBetweenClasses(elementAttributes, selectorNode) {
        var match = Curry._1(RunTime.classNamesFromAttributes, elementAttributes);
        var match$1 = selectorNode.classNames;
        var exit = 0;
        if (match.length !== 0) {
            exit = 2;
        } else {
            if (match$1.length === 0) {
                return 0;
            }
            if (match$1.length !== 0) {
                return 1000;
            }
            exit = 2;
        }
        if (exit === 2 && match$1.length === 0 && match.length !== 0) {
            return 1000;
        }
        var elementClassNamesSet = Belt_SetString.fromArray(match);
        var selectorClassNamesSet = Belt_SetString.fromArray(match$1);
        var commonClassNamesSet = Belt_SetString.intersect(elementClassNamesSet, selectorClassNamesSet);
        var elementClassNamesNotSharedBySelector = Belt_SetString.diff(elementClassNamesSet, selectorClassNamesSet);
        var selectorClassNamesNotSharedByElement = Belt_SetString.diff(selectorClassNamesSet, elementClassNamesSet);
        return (Math.imul(Belt_SetString.size(commonClassNamesSet), -10) + Math.imul(Belt_SetString.size(elementClassNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorClassNamesNotSharedByElement), 10) | 0;
    };
    var calcDistanceBetweenAttributes = function calcDistanceBetweenAttributes(elementAttributes, selectorNode) {
        var elementAttributesThatAreNotIdOrClass = Curry._2(RunTime.keepAttributes, function(attrName, _attrValue) {
            if (attrName !== "class" && attrName !== "id") {
                return !$$Array.mem(attrName, Selector$SmartcutsMacros.attributesToAvoidComparing);
            } else {
                return false;
            }
        }, elementAttributes);
        var selectorAttributes = Belt_Array.reduce(Selector$SmartcutsMacros.attributesToAvoidComparing, Belt_MapString.fromArray(selectorNode.attributes), Belt_MapString.remove);
        var match = Belt_MapString.size(elementAttributesThatAreNotIdOrClass);
        var match$1 = Belt_MapString.size(selectorAttributes);
        var exit = 0;
        if (match !== 0) {
            exit = 2;
        } else {
            if (match$1 === 0) {
                return 0;
            }
            if (match$1 > 0) {
                return 0;
            }
            exit = 2;
        }
        if (exit === 2 && match$1 === 0 && match > 0) {
            return 0;
        }
        var elementAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(elementAttributesThatAreNotIdOrClass));
        var selectorAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(selectorAttributes));
        var commonAttributeNamesSet = Belt_SetString.intersect(elementAttributeNames, selectorAttributeNames);
        var elementAttributeNamesNotSharedBySelector = Belt_SetString.diff(elementAttributeNames, selectorAttributeNames);
        var selectorAttributeNamesNotSharedByElement = Belt_SetString.diff(selectorAttributeNames, elementAttributeNames);
        return (Belt_Array.reduce(Belt_SetString.toArray(commonAttributeNamesSet), 0, function(commonAttrDistance, attrName) {
            var elementAttrVal = Belt_MapString.getExn(elementAttributesThatAreNotIdOrClass, attrName);
            var selectorAttrVal = Belt_MapString.getExn(selectorAttributes, attrName);
            var attributeValueDistance = FastLevenshtein.get(elementAttrVal, selectorAttrVal);
            var tmp = attrName === "aria-label" ? attributeValueDistance === 0 ? -1000 : attributeValueDistance === 0 ? -10 : attributeValueDistance : attributeValueDistance === 0 ? -10 : attributeValueDistance;
            return commonAttrDistance + tmp | 0;
        }) + Math.imul(Belt_SetString.size(elementAttributeNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorAttributeNamesNotSharedByElement), 10) | 0;
    };
    var distanceIsScrollable = function distanceIsScrollable(element, context, selectorNode) {
        return PromiseUtils$SmartcutsMacros.resolveWith(function(isElementScrollable1) {
            var match = selectorNode.isScrollable;
            if (match !== undefined) {
                if (match) {
                    if (isElementScrollable1) {
                        return 1;
                    } else {
                        return 0;
                    }
                } else if (isElementScrollable1) {
                    return 0;
                } else {
                    return 1;
                }
            } else if (isElementScrollable1) {
                return 0;
            } else {
                return 1;
            }
        }, isElementScrollable(context, element));
    };
    var distanceBetweenSelectorNodeAndElement = function distanceBetweenSelectorNodeAndElement(domTree, selectorNode, context, element) {
        var attributes = Curry._2(RunTime.getElementAttributes, domTree, element);
        var distanceId = calcDistanceBetweenBetweenIds(attributes, selectorNode);
        var distanceClasses = calcDistanceBetweenBetweenClasses(attributes, selectorNode);
        var distanceAttributes = calcDistanceBetweenAttributes(attributes, selectorNode);
        return checkIsOptionElement(context, element).then(function(isOptionElement) {
            if (isOptionElement && Caml_obj.caml_equal(selectorNode.tagName, "option")) {
                return Promise.resolve([
                    Math.imul(distanceId, 100),
                    Math.imul(distanceClasses, 10),
                    distanceAttributes << 0
                ]);
            } else {
                return PromiseUtils$SmartcutsMacros.resolveWith(function(distanceIsScrollable1) {
                    return [
                        Math.imul(distanceId, 100),
                        Math.imul(distanceClasses, 10),
                        distanceAttributes << 0,
                        Math.imul(distanceIsScrollable1, 50)
                    ];
                }, distanceIsScrollable(element, context, selectorNode));
            }
        });
    };
    var calcForElementChain = function calcForElementChain(domTree, selector, context, elementChain) {
        var depthDistance = Math.abs(List.length(selector) - elementChain.length | 0);
        if (depthDistance > 0) {
            return Promise.resolve(Math.pow(10, depthDistance + 2 | 0));
        } else {
            return PromiseUtils$SmartcutsMacros.resolveWith(function(distanceArray) {
                Curry._2(Log$SmartcutsMacros.selector.warn2, "calcForElementChain", Belt_Array.zip(elementChain, distanceArray));
                var sumBy = function sumBy(f, xs) {
                    return Belt_Array.reduce(xs, 0.0, function(acc, x) {
                        return Curry._1(f, x) + acc;
                    });
                };
                return sumBy(function(param) {
                    return sumBy(function(x) {
                        return x;
                    }, param);
                }, distanceArray);
            }, Belt_List.reduceWithIndex(selector, Promise.resolve([]), function(promise, selectorNode, index) {
                return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
                    return Belt_Array.concat(param[0], [
                        param[1]
                    ]);
                }, Promise.all([
                    promise,
                    distanceBetweenSelectorNodeAndElement(domTree, selectorNode, context, Caml_array.get(elementChain, index))
                ]));
            }));
        }
    };
    var findElementsMatchingTagNameChainAndAttributesExistence = function findElementsMatchingTagNameChainAndAttributesExistence(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
        var attributesExistencePredicateFallbacks = [
            /* AllAttributes */ 0,
            /* AttributesNotDataOrAria */ 1,
            /* StardardAttributesExceptClassNameAtLastNLevels */ {
                _0: 3
            },
            /* OnlyUseId */ 2
        ];
        return PromiseUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.shortcutAsync(function(attributesExistencePredicate) {
            return PromiseUtils$SmartcutsMacros.map(getElementsWithSameDepthAndAttributeKeysAsSelector(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, undefined), function(result_matchingElements) {
                if (result_matchingElements.TAG !== /* Ok */ 0) {
                    return {
                        TAG: /* Error */ 1,
                        _0: result_matchingElements._0
                    };
                }
                var matchingElements = result_matchingElements._0;
                var match = matchingElements.length;
                if (match !== 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: matchingElements
                    };
                }
            });
        }, attributesExistencePredicateFallbacks), function(maybe_result_matchingElements) {
            if (maybe_result_matchingElements !== undefined) {
                if (maybe_result_matchingElements.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: maybe_result_matchingElements._0
                    };
                } else {
                    return {
                        TAG: /* Error */ 1,
                        _0: maybe_result_matchingElements._0
                    };
                }
            } else {
                return {
                    TAG: /* Ok */ 0,
                    _0: []
                };
            }
        });
    };
    var _$init = function _$init(useInnerText, maybeInnerTextSemantic, queryRootOpt, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selector) {
        var queryRoot = queryRootOpt !== undefined ? queryRootOpt : /* Document */ 0;
        var arg2 = ListUtils$SmartcutsMacros.getLast(selector);
        var leafSelectorNode = function(param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg2);
        }("Expect to get leaf selector node");
        var selectorLength = List.length(selector);
        return findElementsMatchingTagNameChainAndAttributesExistence(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, maybeDomTree, selector, includeElementsNotVisible, undefined).then(function(result_matchingElements) {
            if (result_matchingElements.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_matchingElements._0
                });
            }
            var matchingElements = result_matchingElements._0;
            return PromiseUtils$SmartcutsMacros.map(maybeDomTree !== undefined ? Promise.resolve(Caml_option.valFromOption(maybeDomTree)) : PromiseUtils$SmartcutsMacros.map(Curry._2(RunTime.fetchDomTree, context, addCancelCallback), function(param) {
                return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when getting candidate branches", param);
            }), function(domTree) {
                var updatedMatchingElements = Belt_Array.map(matchingElements, Curry._1(RunTime.getUpdatedElementFromDomTree, domTree));
                var arg = Belt_Array.map(updatedMatchingElements, function(element) {
                    var fullChain = Curry._2(RunTime.getParentChain, domTree, element);
                    if (typeof queryRoot === "number") {
                        return fullChain;
                    } else {
                        var element$1 = queryRoot._0;
                        var index = Belt_Array.getIndexBy(fullChain, function(currElement) {
                            return Caml_obj.caml_equal(currElement, element$1);
                        });
                        if (index !== undefined) {
                            return Belt_Array.sliceToEnd(fullChain, index + 1 | 0);
                        } else {
                            return fullChain;
                        }
                    }
                });
                return {
                    TAG: /* Ok */ 0,
                    _0: [
                        Belt_Array.keep(Belt_Array.keep((function(param) {
                            return function(param$1) {
                                return Util$SmartcutsMacros.spyTransform(param, param$1, arg);
                            };
                        })("before chain length filter")(function(x) {
                            return x;
                        }), function(elementChain) {
                            return elementChain.length === selectorLength;
                        }), function(elementChain) {
                            if (maybeOnlyConsiderElementChainIf !== undefined) {
                                return Curry._1(maybeOnlyConsiderElementChainIf, elementChain);
                            } else {
                                return true;
                            }
                        }),
                        domTree
                    ]
                };
            });
        });
    };
    var alwaysRequiredAttributeNames1 = [
        "autofocus",
        "role"
    ];
    var factorOutRequiredAttributesFromNode = function factorOutRequiredAttributesFromNode(node) {
        var attributesByRequiredOrNotRequired = ArrayUtils$SmartcutsMacros.groupBy(function(param) {
            if ($$Array.mem(param[0], alwaysRequiredAttributeNames1)) {
                return "required";
            } else {
                return "not-required";
            }
        }, node.attributes);
        var requiredAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "required"));
        var optionalAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "not-required"));
        return [
            requiredAttributes,
            {
                id: node.id,
                tagName: node.tagName,
                classNames: node.classNames,
                attributes: optionalAttributes,
                index: node.index,
                innerText: node.innerText,
                isScrollable: node.isScrollable,
                attributeBlacklist: node.attributeBlacklist
            }
        ];
    };
    var getNextCombinationForNode = function getNextCombinationForNode(_searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes) {
        while(true){
            var searchStrategy = _searchStrategy;
            if (typeof searchStrategy === "number") {
                switch(searchStrategy){
                    case /* ByTagAndId */ 0:
                        var arg3 = selectorNodeWithoutRequiredAttributes.tagName;
                        return {
                            combo: {
                                id: selectorNodeWithoutRequiredAttributes.id,
                                tagName: selectorNodeWithoutRequiredAttributes.tagName,
                                classNames: [],
                                attributes: [],
                                index: undefined,
                                innerText: /* NoInnerText */ 1,
                                isScrollable: undefined,
                                attributeBlacklist: []
                            },
                            nextStrategy: {
                                TAG: /* ByTagAndClassNames */ 0,
                                _0: {
                                    tagName: (function(arg) {
                                        return function(param) {
                                            return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                        };
                                    })(arg3)("Expected tagName"),
                                    classComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.classNames))
                                }
                            }
                        };
                    case /* ByIndex */ 1:
                        var index = selectorNodeWithoutRequiredAttributes.index;
                        if (index !== undefined) {
                            return {
                                combo: {
                                    id: undefined,
                                    tagName: selectorNodeWithoutRequiredAttributes.tagName,
                                    classNames: [],
                                    attributes: $$Array.append(requiredAttributes, ArrayUtils$SmartcutsMacros.filterMap(function(param) {
                                        var key = param[0];
                                        if (key === "contenteditable") {
                                            return [
                                                key,
                                                param[1]
                                            ];
                                        }
                                    }, selectorNodeWithoutRequiredAttributes.attributes)),
                                    index: index,
                                    innerText: /* NoInnerText */ 1,
                                    isScrollable: undefined,
                                    attributeBlacklist: []
                                },
                                nextStrategy: /* NoMoreStrategies */ 2
                            };
                        } else {
                            return;
                        }
                    case /* NoMoreStrategies */ 2:
                        return;
                }
            } else {
                if (searchStrategy.TAG === /* ByTagAndClassNames */ 0) {
                    var match = searchStrategy._0;
                    var tagName = match.tagName;
                    var match$1 = ComboGenerator$SmartcutsMacros.generateNextCombo(match.classComboGenerator);
                    if (match$1 !== undefined) {
                        return {
                            combo: {
                                id: undefined,
                                tagName: tagName,
                                classNames: $$Array.of_list(match$1[0]),
                                attributes: requiredAttributes,
                                index: undefined,
                                innerText: /* NoInnerText */ 1,
                                isScrollable: undefined,
                                attributeBlacklist: []
                            },
                            nextStrategy: {
                                TAG: /* ByTagAndClassNames */ 0,
                                _0: {
                                    tagName: tagName,
                                    classComboGenerator: match$1[1]
                                }
                            }
                        };
                    }
                    _searchStrategy = {
                        TAG: /* ByTagAndAttributes */ 1,
                        _0: {
                            tagName: tagName,
                            attributeComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.attributes))
                        }
                    };
                    continue;
                }
                var match$2 = searchStrategy._0;
                var tagName$1 = match$2.tagName;
                var match$3 = ComboGenerator$SmartcutsMacros.generateNextCombo(match$2.attributeComboGenerator);
                if (match$3 !== undefined) {
                    return {
                        combo: {
                            id: undefined,
                            tagName: tagName$1,
                            classNames: [],
                            attributes: $$Array.append(requiredAttributes, $$Array.of_list(match$3[0])),
                            index: undefined,
                            innerText: /* NoInnerText */ 1,
                            isScrollable: undefined,
                            attributeBlacklist: []
                        },
                        nextStrategy: {
                            TAG: /* ByTagAndAttributes */ 1,
                            _0: {
                                tagName: tagName$1,
                                attributeComboGenerator: match$3[1]
                            }
                        }
                    };
                }
                _searchStrategy = /* ByIndex */ 1;
                continue;
            }
        }
        ;
    };
    var keepElementsThatIncludeInnerText = function keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
        return Promise.all($$Array.mapi(function(index, element) {
            return Curry._3(doesElementIncludeInnerText(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
                return Promise.resolve([
                    doesMatch,
                    Caml_array.get(elements, index)
                ]);
            });
        }, elements)).then(function(pairsOfDoesMatchAndElement) {
            return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, function(param) {
                return param[0];
            }), function(prim) {
                return prim[1];
            }));
        });
    };
    var withQuerySelectorAll = function withQuerySelectorAll(retriesOpt, context, queryRoot, $$default, cssSelector, withResults) {
        var retries = retriesOpt !== undefined ? retriesOpt : RunTime.maxRetries;
        return PromiseUtils$SmartcutsMacros.withRetries(retries, function(addCancelCallback3, param) {
            return Curry._5(RunTime.querySelectorAll, context, queryRoot, undefined, cssSelector.includes("option") || cssSelector.includes("select") || cssSelector.includes('[type="file"]'), cssSelector).then(function(result_results) {
                if (result_results.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_results._0
                    });
                }
                var results = result_results._0;
                var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param) {
                    return Curry._2(withResults, addCancelCallback, results);
                });
                Curry._1(addCancelCallback3, match[1]);
                return Curry._1(match[0], undefined);
            });
        }, Curry._1(RunTime.shouldRetryForJsPromiseError, queryRoot), {
            TAG: /* Ok */ 0,
            _0: $$default
        }, undefined);
    };
    var maybeFindMatch1 = function(useInnerTextExactMatch, maybeInnerTextSemantic, searchStrategy, requiredAttributes, context, queryRoot, addCancelCallback4, selectorNodeWithoutRequiredAttributes) {
        var match = getNextCombinationForNode(searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes);
        if (match === undefined) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: /* NoMatch */ 0
            });
        }
        var nextStrategy = match.nextStrategy;
        var arg_0 = match.combo;
        var arg = {
            hd: arg_0,
            tl: /* [] */ 0
        };
        var cssSelector = function(param) {
            return SelectorTree$SmartcutsMacros.stringify(param, arg);
        }(queryRoot !== /* Document */ 0);
        var maybeFindMatchByUsingNextStrategy = function maybeFindMatchByUsingNextStrategy(param, param$1) {
            return maybeFindMatch1(useInnerTextExactMatch, maybeInnerTextSemantic, nextStrategy, requiredAttributes, context, queryRoot, param, param$1);
        };
        var match$1 = withQuerySelectorAll(undefined, context, queryRoot, /* NoMatch */ 0, cssSelector, function(addCancelCallback, results1) {
            return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results1).then(function(results) {
                var _twoOrMore1 = results.length;
                if (_twoOrMore1 === 0) {
                    return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                }
                if (_twoOrMore1 !== 1) {
                    return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, results).then(function(elementsThatIncludeInnerText) {
                        var _twoOrMore2 = elementsThatIncludeInnerText.length;
                        if (_twoOrMore2 !== 0) {
                            if (_twoOrMore2 !== 1) {
                                return keepElementsThatMatchInnerTextExactly(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elementsThatIncludeInnerText).then(function(elementsThatMatchInnerTextExactly) {
                                    var _twoOrMore = elementsThatMatchInnerTextExactly.length;
                                    if (_twoOrMore !== 0) {
                                        if (_twoOrMore !== 1) {
                                            return Promise.resolve(undefined).then(function(maybeMatch) {
                                                if (maybeMatch !== undefined) {
                                                    return Promise.resolve({
                                                        TAG: /* Ok */ 0,
                                                        _0: /* ExactMatch */ {
                                                            _0: {
                                                                element: Caml_option.valFromOption(maybeMatch),
                                                                fallbackStrategy: nextStrategy
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                                }
                                            });
                                        } else {
                                            return Promise.resolve({
                                                TAG: /* Ok */ 0,
                                                _0: /* ExactMatch */ {
                                                    _0: {
                                                        element: Caml_array.get(elementsThatMatchInnerTextExactly, 0),
                                                        fallbackStrategy: nextStrategy
                                                    }
                                                }
                                            });
                                        }
                                    } else {
                                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                    }
                                });
                            } else {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: /* ExactMatch */ {
                                        _0: {
                                            element: Caml_array.get(elementsThatIncludeInnerText, 0),
                                            fallbackStrategy: nextStrategy
                                        }
                                    }
                                });
                            }
                        } else {
                            return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                        }
                    });
                }
                var element = Caml_array.get(results, 0);
                return Curry._3(doesElementMatchInnerTextExactly(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: doesMatch ? /* ExactMatch */ ({
                            _0: {
                                element: element,
                                fallbackStrategy: nextStrategy
                            }
                        }) : /* NoMatch */ 0
                    });
                });
            });
        });
        Curry._1(addCancelCallback4, match$1[1]);
        return Curry._1(match$1[0], undefined);
    };
    var isHtmlAttributeUsefulInOptimization = function isHtmlAttributeUsefulInOptimization(key, param) {
        if (key.startsWith("aria-")) {
            return true;
        } else {
            key.startsWith("data-");
            return false;
        }
    };
    var isSelectorNodeOptimalToBecomeNewQueryRoot1 = function(context, queryRoot, isLeafNode, addCancelCallback5, selectorNode) {
        var id = selectorNode.id;
        if (id !== undefined) {
            var selectorNodeWithOnlyId_id = id;
            var selectorNodeWithOnlyId_tagName = selectorNode.tagName;
            var selectorNodeWithOnlyId_classNames = [];
            var selectorNodeWithOnlyId_attributes = [];
            var selectorNodeWithOnlyId_attributeBlacklist = [];
            var selectorNodeWithOnlyId = {
                id: selectorNodeWithOnlyId_id,
                tagName: selectorNodeWithOnlyId_tagName,
                classNames: selectorNodeWithOnlyId_classNames,
                attributes: selectorNodeWithOnlyId_attributes,
                index: undefined,
                innerText: /* NoInnerText */ 1,
                isScrollable: undefined,
                attributeBlacklist: selectorNodeWithOnlyId_attributeBlacklist
            };
            var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
                hd: selectorNodeWithOnlyId,
                tl: /* [] */ 0
            });
            var match = withQuerySelectorAll(undefined, context, queryRoot, [
                false,
                []
            ], cssSelector, function(addCancelCallback, results) {
                return onlyKeepVisibleElements(context, addCancelCallback, results).then(function(elements) {
                    var isOptimal = 1 === elements.length;
                    if (isOptimal) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: [
                                isOptimal,
                                elements
                            ]
                        });
                    } else {
                        return isSelectorNodeOptimalToBecomeNewQueryRoot1(context, queryRoot, isLeafNode, addCancelCallback, {
                            id: undefined,
                            tagName: selectorNode.tagName,
                            classNames: selectorNode.classNames,
                            attributes: selectorNode.attributes,
                            index: selectorNode.index,
                            innerText: selectorNode.innerText,
                            isScrollable: selectorNode.isScrollable,
                            attributeBlacklist: selectorNode.attributeBlacklist
                        });
                    }
                });
            });
            Curry._1(addCancelCallback5, match[1]);
            return Curry._1(match[0], undefined);
        }
        var tagName = selectorNode.tagName;
        return Util$SmartcutsMacros.Shortcut.promise(function(param) {
            var value = param[1];
            var key = param[0];
            if (!isHtmlAttributeUsefulInOptimization(key, value)) {
                return Promise.resolve(undefined);
            }
            var selectorNodeToTry_classNames = [];
            var selectorNodeToTry_attributes = [
                [
                    key,
                    value
                ]
            ];
            var selectorNodeToTry_attributeBlacklist = [];
            var selectorNodeToTry = {
                id: undefined,
                tagName: tagName,
                classNames: selectorNodeToTry_classNames,
                attributes: selectorNodeToTry_attributes,
                index: undefined,
                innerText: /* NoInnerText */ 1,
                isScrollable: undefined,
                attributeBlacklist: selectorNodeToTry_attributeBlacklist
            };
            var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
                hd: selectorNodeToTry,
                tl: /* [] */ 0
            });
            var match = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, function(addCancelCallback, results) {
                return onlyKeepVisibleElements(context, addCancelCallback, results).then(function(elements) {
                    var length = elements.length;
                    if (length !== 0 && !(length !== 1 && !(length <= 2 && !isLeafNode))) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: elements
                        });
                    } else {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                });
            });
            Curry._1(addCancelCallback5, match[1]);
            return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), function(result_maybeElements) {
                if (result_maybeElements.TAG !== /* Ok */ 0) {
                    return {
                        TAG: /* Error */ 1,
                        _0: result_maybeElements._0
                    };
                }
                var elements = result_maybeElements._0;
                if (elements !== undefined) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: elements
                    };
                }
            });
        }, selectorNode.attributes).then(function(maybe_resultElements) {
            if (maybe_resultElements !== undefined) {
                if (maybe_resultElements.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: [
                            true,
                            maybe_resultElements._0
                        ]
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: maybe_resultElements._0
                    });
                }
            } else {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: [
                        false,
                        []
                    ]
                });
            }
        });
    };
    var findNestedNodesToStartSearch = function findNestedNodesToStartSearch(context, queryRoot, selector, addCancelCallback6) {
        if (List.length(selector) === 1) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: [
                    undefined,
                    selector
                ]
            });
        } else {
            return Belt_List.reduceReverse(selector, Promise.resolve({
                TAG: /* Ok */ 0,
                _0: [
                    undefined,
                    /* [] */ 0
                ]
            }), function(prevPromise, selectorNode) {
                return prevPromise.then(function(prevResult) {
                    if (prevResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: prevResult._0
                        });
                    }
                    var match1 = prevResult._0;
                    if (match1[0] !== undefined) {
                        return Promise.resolve(prevResult);
                    }
                    var prevSelector = match1[1];
                    return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback6, function(addCancelCallback) {
                        return isSelectorNodeOptimalToBecomeNewQueryRoot1(context, queryRoot, List.length(prevSelector) === 0, addCancelCallback, selectorNode).then(function(result_pair) {
                            if (result_pair.TAG !== /* Ok */ 0) {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: result_pair._0
                                });
                            }
                            var match = result_pair._0;
                            if (match[0]) {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        match[1],
                                        prevSelector
                                    ]
                                });
                            } else {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: [
                                        undefined,
                                        {
                                            hd: selectorNode,
                                            tl: prevSelector
                                        }
                                    ]
                                });
                            }
                        });
                    });
                });
            });
        }
    };
    var startComboSearchForSelectorNode = function startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace2, stack, selectorNode, recursiveSearch2, addCancelCallback, remainder) {
        var match2 = factorOutRequiredAttributesFromNode(selectorNode);
        var selectorNodeWithoutRequiredAttributes = match2[1];
        var requiredAttributes = match2[0];
        return maybeFindMatch1(useInnerTextExactMatch, maybeInnerTextSemantic, /* ByTagAndId */ 0, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes).then(function(result_found) {
            if (result_found.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_found._0
                });
            }
            var match = result_found._0;
            if (!match) {
                return Curry._5(backtrace2, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack);
            }
            var match$1 = match._0;
            var nextQueryRoot_0 = match$1.element;
            var nextQueryRoot = {
                TAG: /* Element */ 0,
                _0: nextQueryRoot_0,
                _1: undefined
            };
            return Curry._6(recursiveSearch2, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                queryRoot: nextQueryRoot,
                stack: {
                    hd: {
                        selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                        requiredAttributes: requiredAttributes,
                        queryRoot: nextQueryRoot,
                        fallbackStrategy: match$1.fallbackStrategy,
                        selector: remainder
                    },
                    tl: stack
                }
            }, remainder);
        });
    };
    var recursiveSearch_ = function recursiveSearch_(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback7, param8, selector) {
        var stack = param8.stack;
        var queryRoot = param8.queryRoot;
        if (selector) {
            var remainder = selector.tl;
            var selectorNode = selector.hd;
            var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
                hd: selectorNode,
                tl: /* [] */ 0
            });
            var match3 = withQuerySelectorAll(undefined, context, queryRoot, undefined, cssSelector, function(addCancelCallback, results) {
                return onlyKeepVisibleElementsOrOptionElements(context, addCancelCallback, results).then(function(resultElements) {
                    var _twoOrMore3 = resultElements.length;
                    if (_twoOrMore3 === 0) {
                        return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace1, stack, selectorNode, recursiveSearch1, addCancelCallback, remainder);
                    }
                    if (_twoOrMore3 !== 1) {
                        return keepElementsThatIncludeInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, resultElements).then(function(elementsThatIncludeInnerText) {
                            var _twoOrMore = elementsThatIncludeInnerText.length;
                            if (_twoOrMore === 0) {
                                return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace1, stack, selectorNode, recursiveSearch1, addCancelCallback, remainder);
                            }
                            if (_twoOrMore === 1) {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: Caml_option.some(Caml_array.get(elementsThatIncludeInnerText, 0))
                                });
                            }
                            var match = factorOutRequiredAttributesFromNode(selectorNode);
                            var selectorNodeWithoutRequiredAttributes = match[1];
                            var requiredAttributes = match[0];
                            return Util$SmartcutsMacros.shortcutPromise(function(element) {
                                return PromiseUtils$SmartcutsMacros.map(recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                    queryRoot: {
                                        TAG: /* Element */ 0,
                                        _0: element,
                                        _1: undefined
                                    },
                                    stack: {
                                        hd: {
                                            selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                                            requiredAttributes: requiredAttributes,
                                            queryRoot: queryRoot,
                                            fallbackStrategy: /* ByTagAndId */ 0,
                                            selector: remainder
                                        },
                                        tl: stack
                                    }
                                }, remainder), function(result_maybeResult) {
                                    if (result_maybeResult.TAG !== /* Ok */ 0) {
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: result_maybeResult._0
                                        };
                                    }
                                    var result_ = result_maybeResult._0;
                                    if (result_ !== undefined) {
                                        return {
                                            TAG: /* Ok */ 0,
                                            _0: Caml_option.valFromOption(result_)
                                        };
                                    }
                                });
                            }, elementsThatIncludeInnerText).then(function(maybe_result_Element) {
                                if (maybe_result_Element !== undefined) {
                                    if (maybe_result_Element.TAG === /* Ok */ 0) {
                                        return Promise.resolve({
                                            TAG: /* Ok */ 0,
                                            _0: Caml_option.some(maybe_result_Element._0)
                                        });
                                    } else {
                                        return Promise.resolve({
                                            TAG: /* Error */ 1,
                                            _0: maybe_result_Element._0
                                        });
                                    }
                                } else {
                                    return startComboSearchForSelectorNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace1, stack, selectorNode, recursiveSearch1, addCancelCallback, remainder);
                                }
                            });
                        });
                    }
                    var match5 = factorOutRequiredAttributesFromNode(selectorNode);
                    return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: {
                            TAG: /* Element */ 0,
                            _0: Caml_array.get(resultElements, 0),
                            _1: undefined
                        },
                        stack: {
                            hd: {
                                selectorNodeWithoutRequiredAttributes: match5[1],
                                requiredAttributes: match5[0],
                                queryRoot: queryRoot,
                                fallbackStrategy: /* ByTagAndId */ 0,
                                selector: remainder
                            },
                            tl: stack
                        }
                    }, remainder);
                });
            });
            Curry._1(addCancelCallback7, match3[1]);
            return Curry._1(match3[0], undefined);
        }
        if (typeof queryRoot === "number") {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
        var element1 = queryRoot._0;
        if (useInnerTextExactMatch === undefined) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: Caml_option.some(element1)
            });
        }
        var arg = Caml_option.some(element1);
        return PromiseUtils$SmartcutsMacros.map(function(param) {
            return OptionUtils$SmartcutsMacros.keepAsync(param, arg);
        }(function(param) {
            return doesElementMatchInnerText(useInnerTextExactMatch, maybeInnerTextSemantic, context, function(text, expectedText) {
                return text === expectedText;
            }, function(text, expectedPrefix, param) {
                return text.startsWith(expectedPrefix);
            }, function(prefix, param, expectedText) {
                return expectedText.startsWith(prefix);
            }, function(prefix, param, expectedPrefix, param$1) {
                return prefix.startsWith(expectedPrefix);
            }, addCancelCallback7, param);
        }), function(maybeElement) {
            return {
                TAG: /* Ok */ 0,
                _0: maybeElement
            };
        });
    };
    var recursiveSearch1 = function recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope) {
        return PromiseUtils$SmartcutsMacros.withTimeout(0, recursiveSearch_(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope));
    };
    var backtrace1 = function(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack) {
        if (!stack) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
        var prevBreakpoints = stack.tl;
        var lastBreakpoint = stack.hd;
        var selector = lastBreakpoint.selector;
        return maybeFindMatch1(useInnerTextExactMatch, maybeInnerTextSemantic, lastBreakpoint.fallbackStrategy, lastBreakpoint.requiredAttributes, context, lastBreakpoint.queryRoot, addCancelCallback, lastBreakpoint.selectorNodeWithoutRequiredAttributes).then(function(result_results) {
            if (result_results.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_results._0
                });
            }
            var match = result_results._0;
            if (!match) {
                return backtrace1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, prevBreakpoints);
            }
            var match$1 = match._0;
            return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                queryRoot: {
                    TAG: /* Element */ 0,
                    _0: match$1.element,
                    _1: undefined
                },
                stack: {
                    hd: {
                        selectorNodeWithoutRequiredAttributes: lastBreakpoint.selectorNodeWithoutRequiredAttributes,
                        requiredAttributes: lastBreakpoint.requiredAttributes,
                        queryRoot: lastBreakpoint.queryRoot,
                        fallbackStrategy: match$1.fallbackStrategy,
                        selector: lastBreakpoint.selector
                    },
                    tl: prevBreakpoints
                }
            }, selector);
        });
    };
    var attemptToFindDeepestNode = function attemptToFindDeepestNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector) {
        Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
        var maybePromisedResult = OptionUtils$SmartcutsMacros.map(Belt_List.get(List.rev(selector), 0), function(deepestNode) {
            return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                queryRoot: queryRoot,
                stack: /* [] */ 0
            }, {
                hd: deepestNode,
                tl: /* [] */ 0
            });
        });
        return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        }), maybePromisedResult);
    };
    var topDownSearch = function topDownSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback8) {
        var match6 = PromiseUtils$SmartcutsMacros.withRetries(3, function(addCancelCallback, param) {
            Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
            return findNestedNodesToStartSearch(context, queryRoot, selector, addCancelCallback).then(function(result) {
                if (result.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result._0
                    });
                }
                var match = result._0;
                var _$selector = match[1];
                var maybeOptimalStartElements = match[0];
                Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node - nested nodes");
                Curry._3(Log$SmartcutsMacros.selector.log3, "results", maybeOptimalStartElements, $$Array.of_list(_$selector));
                if (maybeOptimalStartElements === undefined) {
                    return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: queryRoot,
                        stack: /* [] */ 0
                    }, _$selector);
                }
                if (!_$selector && maybeOptimalStartElements.length === 1) {
                    return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: {
                            TAG: /* Element */ 0,
                            _0: Caml_array.get(maybeOptimalStartElements, 0),
                            _1: undefined
                        },
                        stack: /* [] */ 0
                    }, _$selector);
                }
                return Util$SmartcutsMacros.Shortcut.promise(function(element) {
                    return PromiseUtils$SmartcutsMacros.map(recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: {
                            TAG: /* Element */ 0,
                            _0: element,
                            _1: undefined
                        },
                        stack: /* [] */ 0
                    }, _$selector), function(result_maybeElement) {
                        if (result_maybeElement.TAG !== /* Ok */ 0) {
                            return {
                                TAG: /* Error */ 1,
                                _0: result_maybeElement._0
                            };
                        }
                        var _$element = result_maybeElement._0;
                        if (_$element !== undefined) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: Caml_option.valFromOption(_$element)
                            };
                        }
                    });
                }, maybeOptimalStartElements).then(function(maybe_result_element) {
                    if (maybe_result_element !== undefined) {
                        if (maybe_result_element.TAG === /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: Caml_option.some(maybe_result_element._0)
                            });
                        } else {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: maybe_result_element._0
                            });
                        }
                    } else {
                        return recursiveSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                            queryRoot: queryRoot,
                            stack: /* [] */ 0
                        }, _$selector);
                    }
                });
            });
        }, Curry._1(RunTime.shouldRetryForJsPromiseError, queryRoot), {
            TAG: /* Ok */ 0,
            _0: undefined
        }, undefined);
        Curry._1(addCancelCallback8, match6[1]);
        return Curry._1(match6[0], undefined);
    };
    var shouldOnlySearchViaInnerText = function shouldOnlySearchViaInnerText(selector) {
        var match = SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector);
        if (match !== undefined && typeof match.innerText !== "number") {
            return true;
        } else {
            return false;
        }
    };
    var scrollVerticallyToLoadAllElements = function scrollVerticallyToLoadAllElements(context, scrollableElement) {
        var loop = function(clientHeight, lastScrollHeight) {
            return Curry._2(RunTime.getScrollHeight, context, scrollableElement).then(function(scrollHeight) {
                if (scrollHeight <= lastScrollHeight) {
                    return Util$SmartcutsMacros.wait(120).then(function(param) {
                        return Curry._2(RunTime.getScrollHeight, context, scrollableElement).then(function(scrollHeight_2) {
                            if (scrollHeight_2 <= lastScrollHeight) {
                                return Promise.resolve(undefined);
                            }
                            var func = Curry._1(RunTime.scrollTo, context);
                            var arg = scrollHeight_2 - clientHeight | 0;
                            return Curry._3(func, undefined, arg, scrollableElement).then(function(param) {
                                return loop(clientHeight, scrollHeight_2);
                            });
                        });
                    });
                }
                var func1 = Curry._1(RunTime.scrollTo, context);
                var arg6 = scrollHeight - clientHeight | 0;
                return Curry._3(func1, undefined, arg6, scrollableElement).then(function(param) {
                    return loop(clientHeight, scrollHeight);
                });
            });
        };
        return Promise.all([
            Curry._2(RunTime.getScrollHeight, context, scrollableElement),
            Curry._2(RunTime.getClientHeight, context, scrollableElement)
        ]).then(function(param) {
            var clientHeight = param[1];
            var scrollHeight = param[0];
            var func = Curry._1(RunTime.scrollTo, context);
            var arg = scrollHeight - clientHeight | 0;
            return Curry._3(func, undefined, arg, scrollableElement).then(function(param) {
                return loop(clientHeight, scrollHeight);
            });
        });
    };
    var findChainWithLowestScoreAndAnyTiedChains = function findChainWithLowestScoreAndAnyTiedChains(chainDistancePairs) {
        return ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expect to get Some(chainWithLowestScore)", ArrayUtils$SmartcutsMacros.filterMap(function(param9) {
            var distance = param9[1];
            if (Belt_Array.every(chainDistancePairs, function(param) {
                return param[1] >= distance;
            })) {
                return param9[0];
            }
        }, chainDistancePairs));
    };
    var _$search1 = function _$search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, fullSelector, addOnPredicateTimedOutCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, param10) {
        var selectorSlices = Selector$SmartcutsMacros.splitForShadowDom(fullSelector);
        return Belt_Array.reduceWithIndex(selectorSlices, Promise.resolve({
            TAG: /* Ok */ 0,
            _0: [
                maybeDomTree,
                queryRoot
            ]
        }), function(lastProm, selectorSlice, selectorSliceIndex) {
            return lastProm.then(function(result_pair) {
                if (result_pair.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_pair._0
                    });
                }
                var match7 = result_pair._0;
                var maybeQueryRoot = match7[1];
                var _$maybeDomTree = match7[0];
                if (maybeQueryRoot === undefined) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: [
                            _$maybeDomTree,
                            maybeQueryRoot
                        ]
                    });
                }
                var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param11) {
                    var isLastSlice = selectorSliceIndex === (selectorSlices.length - 1 | 0);
                    return _$init(useInnerText && isLastSlice, maybeInnerTextSemantic, maybeQueryRoot, context, addCancelCallback, _$maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selectorSlice).then(function(result_chainsAndTree) {
                        if (result_chainsAndTree.TAG !== /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: result_chainsAndTree._0
                            });
                        }
                        var match8 = result_chainsAndTree._0;
                        var domTree = match8[1];
                        var elementChains = match8[0];
                        if (elementChains.length === 0) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: [
                                    Caml_option.some(domTree),
                                    undefined
                                ]
                            });
                        }
                        var func = function func(param, param$1, param$2) {
                            return Promise.all(Belt_Array.map(param$2, function(elementChain) {
                                return PromiseUtils$SmartcutsMacros.resolveWith(function(distance) {
                                    return [
                                        elementChain,
                                        distance
                                    ];
                                }, calcForElementChain(domTree, param, param$1, elementChain));
                            }));
                        };
                        var func$1 = Curry._1(func, selectorSlice);
                        return Curry._1(function(param) {
                            return Curry._2(func$1, param, elementChains);
                        }, context).then(function(chainDistancePairs) {
                            var func = function func(param, param$1) {
                                var match = findChainWithLowestScoreAndAnyTiedChains(param$1);
                                var chainWithLowestScore = match[0];
                                var tiedChains = match[1];
                                return Belt_Array.reduce(tiedChains, chainWithLowestScore, function(currBestChain, currChain) {
                                    var maybeNextBestChain = ListUtils$SmartcutsMacros.shortcutWithIndex(function(selectorNode, nodeIndex) {
                                        var maybeRecordedSiblingIndex = selectorNode.index;
                                        var currElementA = Caml_array.get(currBestChain, nodeIndex);
                                        var currElementB = Caml_array.get(currChain, nodeIndex);
                                        var siblingIndexA = Curry._2(RunTime.getSiblingIndex, param, currElementA);
                                        var siblingIndexB = Curry._2(RunTime.getSiblingIndex, param, currElementB);
                                        if (maybeRecordedSiblingIndex !== undefined && !(maybeRecordedSiblingIndex === siblingIndexA && maybeRecordedSiblingIndex === siblingIndexB)) {
                                            if (maybeRecordedSiblingIndex === siblingIndexA) {
                                                return currBestChain;
                                            } else if (maybeRecordedSiblingIndex === siblingIndexB) {
                                                return currChain;
                                            } else {
                                                return;
                                            }
                                        }
                                    }, selectorSlice);
                                    return OptionUtils$SmartcutsMacros.withDefault(currBestChain, maybeNextBestChain);
                                });
                            };
                            var bestChain = Curry._2(func, domTree, chainDistancePairs);
                            var maybeNextQueryRoot = OptionUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.last(bestChain), function(bestElement) {
                                if (isLastSlice) {
                                    var tmp;
                                    if (typeof maybeQueryRoot === "number") {
                                        tmp = bestChain.length;
                                    } else if (maybeQueryRoot.TAG === /* Element */ 0) {
                                        var depth = maybeQueryRoot._1;
                                        tmp = depth !== undefined ? depth + bestChain.length | 0 : bestChain.length;
                                    } else {
                                        tmp = maybeQueryRoot._1 + bestChain.length | 0;
                                    }
                                    return {
                                        TAG: /* Element */ 0,
                                        _0: bestElement,
                                        _1: tmp
                                    };
                                }
                                var arg = Curry._2(RunTime.getDomShadowRoot, domTree, bestElement);
                                var tmp$1;
                                if (typeof maybeQueryRoot === "number") {
                                    tmp$1 = bestChain.length + 1 | 0;
                                } else if (maybeQueryRoot.TAG === /* Element */ 0) {
                                    var depth$1 = maybeQueryRoot._1;
                                    tmp$1 = depth$1 !== undefined ? (depth$1 + bestChain.length | 0) + 1 | 0 : bestChain.length + 1 | 0;
                                } else {
                                    tmp$1 = (maybeQueryRoot._1 + bestChain.length | 0) + 1 | 0;
                                }
                                return {
                                    TAG: /* ShadowRoot */ 1,
                                    _0: function(param) {
                                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                    }("Expected dom shadow root"),
                                    _1: tmp$1
                                };
                            });
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: [
                                    Caml_option.some(domTree),
                                    maybeNextQueryRoot
                                ]
                            });
                        });
                    });
                });
                Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
                return Curry._1(match$1[0], undefined);
            });
        }).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var maybeQueryRoot = result._0[1];
            if (maybeQueryRoot !== undefined && typeof maybeQueryRoot !== "number") {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: Caml_option.some(maybeQueryRoot._0)
                });
            } else {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
        });
    };
    var _$searchWithScrolling = function _$searchWithScrolling(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, param12) {
        return _$search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            if (result._0 !== undefined) {
                return Promise.resolve(result);
            }
            if (!useInnerText) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                });
            }
            var selectorDepth = Belt_List.length(selector);
            return Belt_List.reduceWithIndex(Belt_List.reverse(selector), Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            }), function(promise, selectorNode, index) {
                return promise.then(function(result_maybeResult) {
                    if (result_maybeResult.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_maybeResult._0
                        });
                    }
                    var element = result_maybeResult._0;
                    if (element !== undefined) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: Caml_option.some(Caml_option.valFromOption(element))
                        });
                    }
                    if (selectorNode.isScrollable === undefined || Caml_obj.caml_equal(selectorNode.isScrollable, false)) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                    var indexOfLastScrollableElement = selectorDepth - index | 0;
                    var arg = Belt_List.take(selector, indexOfLastScrollableElement);
                    var selectorToScrollableElement = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    }("Expect to get selectorToScrollableElement");
                    var arg$1 = Belt_List.drop(selector, indexOfLastScrollableElement);
                    var selectorFromScrollableElement = function(param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                    }("Expect to get selectorFromScrollableElement");
                    return _$search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selectorToScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function(result_maybeElement) {
                        if (result_maybeElement.TAG !== /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: result_maybeElement._0
                            });
                        }
                        var scrollableElement = result_maybeElement._0;
                        if (scrollableElement === undefined) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: undefined
                            });
                        }
                        var scrollableElement$1 = Caml_option.valFromOption(scrollableElement);
                        return scrollVerticallyToLoadAllElements(context, scrollableElement$1).then(function(param) {
                            return _$search1(useInnerText, maybeInnerTextSemantic, context, {
                                TAG: /* Element */ 0,
                                _0: scrollableElement$1,
                                _1: indexOfLastScrollableElement
                            }, selectorFromScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined);
                        });
                    });
                });
            });
        });
    };
    var _$search2 = function _$search2(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback) {
        if (useInnerText && shouldOnlySearchViaInnerText(selector)) {
            Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via innerText");
            var match9 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param13) {
                var selectorReversed = List.rev(selector);
                return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: undefined
                }), Belt_Option.map(Belt_List.get(selectorReversed, 0), function(param) {
                    var innerText = param.innerText;
                    var maybeTagName = param.tagName;
                    if (typeof innerText === "number") {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                    if (maybeTagName === undefined) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                    if (innerText._0.trim() === "") {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                    var normalizedTextCriteria = $$String.lowercase_ascii(innerText._0.trim());
                    var applyToAppropriateElements = maybeTagName === "a" ? XPath$SmartcutsMacros.ExpressionBuilder.elementWithOrDescendantElementsWith : function applyToAppropriateElements(builder) {
                        return builder;
                    };
                    var xpath = "//" + (maybeTagName + ("[" + (Curry._1(applyToAppropriateElements, XPath$SmartcutsMacros.ExpressionBuilder.equals(normalizedTextCriteria, XPath$SmartcutsMacros.ExpressionBuilder.lowercase(XPath$SmartcutsMacros.ExpressionBuilder.normalizeSpace(XPath$SmartcutsMacros.ExpressionBuilder.text)))) + "]")));
                    return Curry._4(RunTime.queryXPath, context, queryRoot, addCancelCallback, xpath).then(function(elements1) {
                        Curry._3(Log$SmartcutsMacros.selector.log3, "xpath", xpath, elements1);
                        var len = elements1.length;
                        if (len !== 1) {
                            if (len !== 0) {
                                return Curry._2(RunTime.fetchDomTree, context, addCancelCallback).then(function(maybeDomTree) {
                                    var _$getParentElements = function _$getParentElements(elements) {
                                        if (maybeDomTree !== undefined) {
                                            return Curry._2(RunTime.getParentElements, Caml_option.valFromOption(maybeDomTree), elements);
                                        } else {
                                            return Belt_Array.map(elements, function(param) {});
                                        }
                                    };
                                    return Util$SmartcutsMacros.shortcutPromise(function(maybeParentElement) {
                                        var match = ListUtils$SmartcutsMacros.getLast(selector);
                                        var match$1 = Belt_List.get(selectorReversed, 1);
                                        if (maybeParentElement === undefined) {
                                            return Promise.resolve(undefined);
                                        }
                                        if (match === undefined) {
                                            return Promise.resolve(undefined);
                                        }
                                        if (match$1 === undefined) {
                                            return Promise.resolve(undefined);
                                        }
                                        var parentElement = Caml_option.valFromOption(maybeParentElement);
                                        return Curry._3(RunTime.couldElementMatchSelectorTreeNode, context, parentElement, match$1).then(function(couldMatch) {
                                            if (couldMatch) {
                                                return PromiseUtils$SmartcutsMacros.map(topDownSearch(innerText, maybeInnerTextSemantic, context, {
                                                    TAG: /* Element */ 0,
                                                    _0: parentElement,
                                                    _1: undefined
                                                }, {
                                                    hd: match,
                                                    tl: /* [] */ 0
                                                }, addCancelCallback), function(result_maybe_element) {
                                                    if (result_maybe_element.TAG !== /* Ok */ 0) {
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: result_maybe_element._0
                                                        };
                                                    }
                                                    var element = result_maybe_element._0;
                                                    if (element !== undefined) {
                                                        return {
                                                            TAG: /* Ok */ 0,
                                                            _0: Caml_option.valFromOption(element)
                                                        };
                                                    }
                                                });
                                            } else {
                                                return Promise.resolve(undefined);
                                            }
                                        });
                                    }, _$getParentElements(elements1));
                                });
                            } else {
                                return Promise.resolve(undefined);
                            }
                        }
                        var onlyElement = elements1[0];
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: onlyElement
                        });
                    }).then(function(maybeResultElement) {
                        if (maybeResultElement !== undefined) {
                            if (maybeResultElement.TAG === /* Ok */ 0) {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: Caml_option.some(maybeResultElement._0)
                                });
                            } else {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: maybeResultElement._0
                                });
                            }
                        }
                        var useInnerTextExactMatch = OptionUtils$SmartcutsMacros.andThen(function(leafNode) {
                            var match = leafNode.innerText;
                            if (typeof match === "number") {
                                return;
                            } else {
                                return match;
                            }
                        }, SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector));
                        return attemptToFindDeepestNode(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector).then(function(result_maybeElement) {
                            if (result_maybeElement.TAG !== /* Ok */ 0) {
                                return Promise.resolve({
                                    TAG: /* Error */ 1,
                                    _0: result_maybeElement._0
                                });
                            }
                            var element = result_maybeElement._0;
                            if (element !== undefined) {
                                return Promise.resolve({
                                    TAG: /* Ok */ 0,
                                    _0: Caml_option.some(Caml_option.valFromOption(element))
                                });
                            } else {
                                return topDownSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                            }
                        });
                    });
                }));
            });
            Curry._1(addOnPredicateTimedOutCallback, match9[1]);
            return Curry._1(match9[0], undefined);
        }
        var match$11 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param) {
            return attemptToFindDeepestNode(undefined, undefined, context, queryRoot, addCancelCallback, selector).then(function(result_maybeResult) {
                if (result_maybeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_maybeResult._0
                    });
                }
                var element = result_maybeResult._0;
                if (element !== undefined) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: Caml_option.some(Caml_option.valFromOption(element))
                    });
                } else {
                    return topDownSearch(undefined, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                }
            });
        });
        Curry._1(addOnPredicateTimedOutCallback, match$11[1]);
        return Curry._1(match$11[0], undefined);
    };
    return {
        CandidateBranches: {
            ElementChain: {},
            init: _$init
        },
        search1: _$search1,
        searchWithScrolling: _$searchWithScrolling,
        search2: _$search2
    };
}
function getCurrentUrl(param) {
    return Promise.resolve(window.location.href);
}
function getDomShadowRoot(param, element) {
    return Caml_option.some(element.shadowRoot);
}
function getElementAttributes(param, element) {
    return element.attributes;
}
function idFromAttributes(attributes) {
    return OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(attributes.getNamedItem("id")), function(prim) {
        return prim.value;
    });
}
function classNamesFromAttributes(attributes) {
    var arg = OptionUtils$SmartcutsMacros.map(Caml_option.nullable_to_opt(attributes.getNamedItem("class")), function(attr) {
        return Belt_Array.keepMap(attr.value.split(/\s+/), function(x) {
            return x;
        });
    });
    var param = [];
    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}
function keepAttributes(f, attributes) {
    var numAttributes = attributes.length;
    return Belt_MapString.fromArray(Belt_Array.keepMap(Belt_Array.mapWithIndex(Caml_array.make(numAttributes, undefined), function(i, param) {
        var attr = attributes.item(i);
        if (!(attr == null)) {
            return [
                attr.name,
                attr.value
            ];
        }
    }), function(maybeKV) {
        return OptionUtils$SmartcutsMacros.andThen(function(kv) {
            if (Curry._2(f, kv[0], kv[1])) {
                return kv;
            }
        }, maybeKV);
    }));
}
function querySelectorAll(param, queryRoot, param$1, includeElementsNotVisible, selectorExpression) {
    var nodesFound;
    nodesFound = typeof queryRoot === "number" ? document.querySelectorAll(selectorExpression) : queryRoot._0.querySelectorAll(selectorExpression);
    var result = [];
    nodesFound.forEach(function(node, _index) {
        var element = Webapi__Dom__Element.ofNode(node);
        if (element === undefined) {
            return;
        }
        var element$1 = Caml_option.valFromOption(element);
        if (!includeElementsNotVisible && DOM__Element$SmartcutsMacros.isNotVisibleOnPage(element$1)) {
            return;
        } else {
            result.push(element$1);
            return;
        }
    });
    return Promise.resolve({
        TAG: /* Ok */ 0,
        _0: result
    });
}
function queryXPath(param14, queryRoot, param$11, xpath) {
    var partial_arg = typeof queryRoot === "number" ? document : queryRoot._0;
    var func = function func(param, param$1, param$2, param$3) {
        return DOM__Document$SmartcutsMacros.evaluate(xpath, partial_arg, param, param$1, param$2, param$3);
    };
    var result = Curry._4(func, undefined, /* ORDERED_NODE_SNAPSHOT_TYPE */ 7, undefined, document);
    var snapshotResult = XPath$SmartcutsMacros.Result.classify(result);
    if (snapshotResult.TAG !== /* OrderedNodeSnapshotResult */ 7) {
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected resultType: ORDERED_NODE_SNAPSHOT_TYPE");
    }
    var snapshotResult$1 = snapshotResult._0;
    return Promise.resolve($$Array.mapi(function(i, param15) {
        var arg = Curry._2(XPath$SmartcutsMacros.Result.SnapshotResult.snapshotItem, snapshotResult$1, i);
        var arg$1 = function(param) {
            return OptionUtils$SmartcutsMacros.andThen(param, arg);
        }(Webapi__Dom__Element.ofNode);
        var param$1 = "Expected node to be an element";
        return OptionUtils$SmartcutsMacros.getExn(param$1, arg$1);
    }, Caml_array.make(snapshotResult$1.snapshotLength, 0)));
}
function getTagName(param, element) {
    return Promise.resolve(element.tagName);
}
function isVisibleOnPage(param, element) {
    return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
}
function fetchDomTree(param, param$1) {
    return Promise.resolve(Caml_option.some(undefined));
}
function getParentElement(param, element2) {
    var arg = element2.parentElement;
    var arg$1 = arg == null ? undefined : Caml_option.some(arg);
    var param$1 = function param$1(element) {
        var match = element.nodeName;
        if (match === "HTML") {
            return;
        } else {
            return Caml_option.some(element);
        }
    };
    return OptionUtils$SmartcutsMacros.andThen(param$1, arg$1);
}
function getParentChain(param, element) {
    var chain = [];
    var currNode = element;
    var $$break = false;
    while(!$$break){
        chain = $$Array.append([
            currNode
        ], chain);
        var parentNode = currNode.parentNode;
        if (parentNode == null || Caml_obj.caml_equal(OptionUtils$SmartcutsMacros.map(Webapi__Dom__Element.ofNode(parentNode), function(prim) {
            return prim.tagName;
        }), "HTML")) {
            $$break = true;
        } else {
            currNode = parentNode;
        }
    }
    ;
    return Belt_Array.map(chain, function(prim) {
        return prim;
    });
}
function getParentElements(param, elements) {
    return Belt_Array.map(elements, function(prim) {
        return Caml_option.nullable_to_opt(prim.parentElement);
    });
}
function getSiblingIndex(param16, element) {
    var parent = element.parentElement;
    if (parent == null) {
        return 1;
    }
    var arg = Belt_Array.getIndexBy(Array.prototype.slice.call(parent.children), function(child) {
        return child === element;
    });
    return 1 + function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(0) | 0;
}
function getUpdatedElementFromDomTree(param, element) {
    return element;
}
function getInnerTextForElement(param, param$1, element) {
    return Promise.resolve(HTMLNodes$SmartcutsMacros.InnerText.fromString(element.innerText));
}
function couldElementMatchSelectorTreeNode(param, element, node) {
    return Promise.resolve(Caml_obj.caml_equal($$String.lowercase_ascii(element.tagName), node.tagName));
}
function shouldRetryForJsPromiseError(param, _jsPromiseError) {
    return false;
}
function isElementEqualTo(elementA, elementB) {
    return elementA === elementB;
}
function getScrollHeight(param, element) {
    return Promise.resolve(element.scrollHeight);
}
function getClientHeight(param, element) {
    return Promise.resolve(element.clientHeight);
}
function getOverflowYForElement(param, element) {
    return Promise.resolve(window.getComputedStyle(element).overflowY);
}
function scrollTo(param17, maybeScrollToX, maybeScrollToY, element) {
    var scrollLeft = element.scrollLeft;
    var scrollTop = element.scrollTop;
    var arg = Belt_Option.map(maybeScrollToX, function(prim) {
        return prim;
    });
    var scrollToX = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(scrollLeft);
    var arg$1 = Belt_Option.map(maybeScrollToY, function(prim) {
        return prim;
    });
    var scrollToY = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }(scrollTop);
    element.scrollTo(scrollToX, scrollToY);
    return new Promise(function(resolve, param) {
        var _lastScrollLeft = scrollLeft;
        var _lastScrollTop = scrollTop;
        while(true){
            var lastScrollTop = _lastScrollTop;
            var lastScrollLeft = _lastScrollLeft;
            var scrollLeft$1 = element.scrollLeft;
            var scrollTop$1 = element.scrollTop;
            if (scrollLeft$1 === lastScrollLeft && scrollTop$1 === lastScrollTop || scrollLeft$1 === scrollToX && scrollTop$1 === scrollToY) {
                return resolve([
                    scrollLeft$1,
                    scrollTop$1
                ]);
            }
            _lastScrollTop = scrollTop$1;
            _lastScrollLeft = scrollLeft$1;
            continue;
        }
        ;
    }).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var WebPage = {
    getCurrentUrl: getCurrentUrl,
    getDomShadowRoot: getDomShadowRoot,
    getElementAttributes: getElementAttributes,
    idFromAttributes: idFromAttributes,
    classNamesFromAttributes: classNamesFromAttributes,
    keepAttributes: keepAttributes,
    querySelectorAll: querySelectorAll,
    maxRetries: 3,
    queryXPath: queryXPath,
    getTagName: getTagName,
    isVisibleOnPage: isVisibleOnPage,
    fetchDomTree: fetchDomTree,
    getParentElement: getParentElement,
    getParentChain: getParentChain,
    getParentElements: getParentElements,
    getSiblingIndex: getSiblingIndex,
    getUpdatedElementFromDomTree: getUpdatedElementFromDomTree,
    getInnerTextForElement: getInnerTextForElement,
    couldElementMatchSelectorTreeNode: couldElementMatchSelectorTreeNode,
    shouldRetryForJsPromiseError: shouldRetryForJsPromiseError,
    isElementEqualTo: isElementEqualTo,
    getScrollHeight: getScrollHeight,
    getClientHeight: getClientHeight,
    getOverflowYForElement: getOverflowYForElement,
    scrollTo: scrollTo
};
function doesElementMatchFullInnerText1(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback9, element) {
    var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return getInnerTextForElement(context, addCancelCallback, element);
    });
    Curry._1(addCancelCallback9, match[1]);
    return Curry._1(match[0], undefined).then(function(innerText) {
        var tmp;
        if (typeof innerText === "number") {
            tmp = innerText === /* Ignored */ 0 ? true : false;
        } else if (innerText.TAG === /* FullInnerText */ 0) {
            var normalizedText = $$String.lowercase_ascii(innerText._0.trim());
            var normalizedExpectedText = $$String.lowercase_ascii(fullTextToMatch.trim());
            tmp = Curry._2(compareFullInnerTextToExpectedFullInnerText, normalizedText, normalizedExpectedText);
        } else {
            var prefix = innerText._0;
            var normalizedPrefix = $$String.lowercase_ascii(prefix.trim());
            tmp = Curry._3(compareTruncatedInnerTextToExpectedFullInnerText, normalizedPrefix, innerText._1 - (prefix.length - normalizedPrefix.length | 0) | 0, $$String.lowercase_ascii(fullTextToMatch.trim()));
        }
        return Promise.resolve(tmp);
    });
}
function doesElementMatchInnerText1(maybeUseInnerTextExactMatch, maybeInnerTextSemantic, context, compareFullInnerTextToExpectedFullInnerText, compareFullInnerTextToExpectedTruncatedInnerText, compareTruncatedInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedTruncatedInnerText, addCancelCallback10, element) {
    if (maybeUseInnerTextExactMatch === undefined) {
        return Promise.resolve(true);
    }
    if (typeof maybeUseInnerTextExactMatch === "number") {
        if (maybeUseInnerTextExactMatch === /* Ignored */ 0) {
            if (maybeInnerTextSemantic === undefined) {
                return Promise.resolve(true);
            }
            if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                return Promise.resolve(true);
            }
        } else if (maybeInnerTextSemantic !== undefined) {
            if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                return Promise.resolve(false);
            }
        } else {
            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match[1]);
            return Curry._1(match[0], undefined).then(function(innerText) {
                var tmp;
                tmp = typeof innerText === "number" ? true : innerText._0 === "";
                return Promise.resolve(tmp);
            });
        }
    } else if (maybeUseInnerTextExactMatch.TAG === /* FullInnerText */ 0) {
        var fullTextToMatch = maybeUseInnerTextExactMatch._0;
        if (maybeInnerTextSemantic === undefined) {
            return doesElementMatchFullInnerText1(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback10, element);
        }
        if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
            return doesElementMatchFullInnerText1(fullTextToMatch, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback10, element);
        }
    } else {
        var prefixToMatch = maybeUseInnerTextExactMatch._0;
        if (maybeInnerTextSemantic !== undefined) {
            if (typeof maybeInnerTextSemantic !== "number" && maybeInnerTextSemantic.TAG === /* VariableInnerText */ 5) {
                return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected pairing with VariableInnerText: " + HTMLNodes$SmartcutsMacros.InnerText.stringify(maybeUseInnerTextExactMatch));
            }
        } else {
            var normalizedPrefixToMatch = $$String.lowercase_ascii(prefixToMatch.trim());
            var normalizedOriginalLength = maybeUseInnerTextExactMatch._1 - (prefixToMatch.length - normalizedPrefixToMatch.length | 0) | 0;
            var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match$1[1]);
            return Curry._1(match$1[0], undefined).then(function(innerText) {
                var tmp;
                if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */ 0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */ 0) {
                    var normalizedFullText = $$String.lowercase_ascii(innerText._0.trim());
                    tmp = Curry._3(compareFullInnerTextToExpectedTruncatedInnerText, normalizedFullText, normalizedPrefixToMatch, normalizedOriginalLength);
                } else {
                    var prefix2 = innerText._0;
                    var normalizedPrefix2 = $$String.lowercase_ascii(prefix2.trim());
                    var normalizedLength2 = innerText._1 - (prefix2.length - normalizedPrefix2.length | 0) | 0;
                    tmp = Curry._4(compareTruncatedInnerTextToExpectedTruncatedInnerText, normalizedPrefix2, normalizedLength2, normalizedPrefixToMatch, normalizedOriginalLength);
                }
                return Promise.resolve(tmp);
            });
        }
    }
    if (typeof maybeInnerTextSemantic === "number") {
        return Promise.resolve(true);
    }
    switch(maybeInnerTextSemantic.TAG | 0){
        case /* MatchesFullInnerText */ 0:
            var fullTextToMatch$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
            return doesElementMatchFullInnerText1(fullTextToMatch$1, context, compareFullInnerTextToExpectedFullInnerText, compareTruncatedInnerTextToExpectedFullInnerText, addCancelCallback10, element);
        case /* MatchesInnerTextPrefix */ 1:
            var stringThatShouldPrefixInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
            var match$2 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match$2[1]);
            return Curry._1(match$2[0], undefined).then(function(innerText) {
                var tmp;
                if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */ 0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */ 0) {
                    tmp = innerText._0.startsWith(stringThatShouldPrefixInnerText);
                } else {
                    var prefix = innerText._0;
                    if (prefix.length > stringThatShouldPrefixInnerText.length) {
                        tmp = prefix.includes(stringThatShouldPrefixInnerText);
                    } else {
                        var truncatedStringThatShouldPrefixInnerText = stringThatShouldPrefixInnerText.slice(0, prefix.length);
                        tmp = truncatedStringThatShouldPrefixInnerText === prefix && truncatedStringThatShouldPrefixInnerText.length <= innerText._1;
                    }
                }
                return Promise.resolve(tmp);
            });
        case /* ContainsInnerText */ 2:
            var stringThatShouldBeInsideInnerText = Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, maybeInnerTextSemantic._0);
            var match$3 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match$3[1]);
            return Curry._1(match$3[0], undefined).then(function(innerText) {
                var tmp;
                if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */ 0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */ 0) {
                    tmp = innerText._0.includes(stringThatShouldBeInsideInnerText);
                } else {
                    var prefix = innerText._0;
                    if (prefix.length > stringThatShouldBeInsideInnerText.length) {
                        tmp = prefix.includes(stringThatShouldBeInsideInnerText);
                    } else {
                        console.warn("Unhandled ContainsInnerText against TruncatedInnerText");
                        tmp = false;
                    }
                }
                return Promise.resolve(tmp);
            });
        case /* ContainsInnerTextEnum */ 3:
            var possibleMatchingSubstrings = $$Array.append([
                maybeInnerTextSemantic._0,
                maybeInnerTextSemantic._1
            ], maybeInnerTextSemantic._2);
            var match$4 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match$4[1]);
            return Curry._1(match$4[0], undefined).then(function(innerText) {
                var tmp;
                if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */ 0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */ 0) {
                    var fullText = innerText._0;
                    tmp = Belt_Array.some(possibleMatchingSubstrings, function(substring) {
                        return fullText.includes(substring);
                    });
                } else {
                    var prefix = innerText._0;
                    tmp = Belt_Array.some(possibleMatchingSubstrings, function(substring) {
                        if (prefix.length > substring.length) {
                            return prefix.includes(substring);
                        } else {
                            console.warn("Unhandled ContainsInnerTextEnum against TruncatedInnerText");
                            return false;
                        }
                    });
                }
                return Promise.resolve(tmp);
            });
        case /* ContainsInnerTextAllStrings */ 4:
            var allRequiredSubstrings = $$Array.append([
                maybeInnerTextSemantic._0,
                maybeInnerTextSemantic._1
            ], maybeInnerTextSemantic._2);
            var match$5 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, isCanceled) {
                if (isCanceled.contents) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return getInnerTextForElement(context, addCancelCallback, element);
            });
            Curry._1(addCancelCallback10, match$5[1]);
            return Curry._1(match$5[0], undefined).then(function(innerText) {
                var tmp;
                if (typeof innerText === "number") {
                    tmp = innerText === /* Ignored */ 0 ? true : false;
                } else if (innerText.TAG === /* FullInnerText */ 0) {
                    var fullText = innerText._0;
                    tmp = Belt_Array.every(allRequiredSubstrings, function(substring) {
                        return fullText.includes(substring);
                    });
                } else {
                    var prefix = innerText._0;
                    tmp = Belt_Array.every(allRequiredSubstrings, function(substring) {
                        if (prefix.length > substring.length) {
                            return prefix.includes(substring);
                        } else {
                            console.warn("Unhandled ContainsInnerTextAllStrings against TruncatedInnerText");
                            return false;
                        }
                    });
                }
                return Promise.resolve(tmp);
            });
    }
}
function arg1(text, expectedText) {
    return text === expectedText;
}
function arg$11(text, expectedPrefix, param) {
    return text.startsWith(expectedPrefix);
}
function arg$21(prefix, length, expectedText) {
    if (expectedText.startsWith(prefix)) {
        return length === expectedText.length;
    } else {
        return false;
    }
}
function arg$31(prefix, length, expectedPrefix, expectedOriginalLength) {
    if (length === expectedOriginalLength) {
        if (prefix.length >= expectedPrefix.length) {
            return prefix.startsWith(expectedPrefix);
        } else {
            return expectedPrefix.startsWith(prefix);
        }
    } else {
        return false;
    }
}
function doesElementMatchInnerTextExactly1(param18) {
    return function(param$1) {
        var func = function func(param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
            return doesElementMatchInnerText1(param18, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
        };
        return function(param) {
            return Curry._5(func, param, arg1, arg$11, arg$21, arg$31);
        };
    };
}
function arg$41(text, expectedText) {
    return text.includes(expectedText);
}
function arg$51(text, expectedPrefix, expectedOriginalLength) {
    if (text.includes(expectedPrefix)) {
        return text.length >= expectedOriginalLength;
    } else {
        return false;
    }
}
function arg$61(prefix, length, expectedText) {
    if (prefix.includes(expectedText)) {
        return length >= expectedText.length;
    } else {
        return false;
    }
}
function arg$71(prefix, length, expectedPrefix, expectedOriginalLength) {
    if (prefix.startsWith(expectedPrefix)) {
        return length >= expectedOriginalLength;
    } else {
        return false;
    }
}
function doesElementIncludeInnerText1(param19) {
    return function(param$1) {
        var func = function func(param$2, param$3, param$4, param$5, param$6, param$7, param$8) {
            return doesElementMatchInnerText1(param19, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8);
        };
        return function(param) {
            return Curry._5(func, param, arg$41, arg$51, arg$61, arg$71);
        };
    };
}
function keepElementsThatMatchInnerTextExactly1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
    return Promise.all($$Array.mapi(function(index, element) {
        return Curry._3(doesElementMatchInnerTextExactly1(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
            return Promise.resolve([
                doesMatch,
                Caml_array.get(elements, index)
            ]);
        });
    }, elements)).then(function(pairsOfDoesMatchAndElement) {
        return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, function(param) {
            return param[0];
        }), function(prim) {
            return prim[1];
        }));
    });
}
function onlyKeepVisibleElements1(context, addCancelCallback, elements) {
    return ArrayUtils$SmartcutsMacros.keepAsync(function(element) {
        return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
            return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
        });
    }, elements);
}
function checkIsOptionElement1(context, element) {
    return Promise.resolve(element.tagName).then(function(maybeTagName) {
        return Promise.resolve(Caml_obj.caml_equal(maybeTagName, "OPTION"));
    });
}
function onlyKeepVisibleElementsOrOptionElements1(context, addCancelCallback, elements) {
    return ArrayUtils$SmartcutsMacros.keepAsync(function(element) {
        return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback, function(param) {
            return checkIsOptionElement1(context, element).then(function(isOptionElement) {
                if (isOptionElement) {
                    return Promise.resolve(true);
                } else {
                    return Promise.resolve(DOM__Element$SmartcutsMacros.isVisibleOnPage(element));
                }
            });
        });
    }, elements);
}
function isElementScrollable2(context, element) {
    return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
        var hasScrollableContent = param[0] > param[1];
        var isOverflowHidden = param[2].includes("hidden");
        if (hasScrollableContent) {
            return !isOverflowHidden;
        } else {
            return false;
        }
    }, Promise.all([
        Promise.resolve(element.scrollHeight),
        Promise.resolve(element.clientHeight),
        getOverflowYForElement(context, element)
    ]));
}
function getElementsWithSameDepthAndAttributeKeysAsSelector1(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param20) {
    var attributesFilter;
    if (typeof attributesExistencePredicate === "number") {
        switch(attributesExistencePredicate){
            case /* AllAttributes */ 0:
                attributesFilter = function attributesFilter(_selectorNodeIndex, _attrName) {
                    return true;
                };
                break;
            case /* AttributesNotDataOrAria */ 1:
                attributesFilter = function attributesFilter(_selectorNodeIndex, attrName) {
                    return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
                };
                break;
            case /* OnlyUseId */ 2:
                attributesFilter = function attributesFilter(_selectorNodeIndex, attrName) {
                    return attrName === "id";
                };
                break;
        }
    } else {
        var nLevels = attributesExistencePredicate._0;
        attributesFilter = function attributesFilter(selectorNodeIndex, attrName) {
            if (attrName === "class") {
                return (List.length(selector) - selectorNodeIndex | 0) > nLevels;
            } else {
                return !(attrName.startsWith("data-") || attrName.startsWith("aria-"));
            }
        };
    }
    return Promise.resolve(window.location.href).then(function(currentUrl) {
        var cssSelector = Selector$SmartcutsMacros.toCssSelectorUsingTagChainAndAttributeExistence(queryRoot !== /* Document */ 0, attributesFilter, currentUrl, selector);
        var tagName = leafSelectorNode.tagName;
        return querySelectorAll(context, queryRoot, domTree, tagName !== undefined && $$String.lowercase_ascii(tagName) === "option" ? true : includeElementsNotVisible, cssSelector);
    }).then(function(result_matches) {
        if (result_matches.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_matches._0
            });
        }
        var matches2 = result_matches._0;
        var tmp;
        if (useInnerText) {
            var param21 = leafSelectorNode.innerText;
            var func = function func(param$1, param$2, param$3, param$4) {
                return keepElementsThatMatchInnerTextExactly1(param21, param$1, param$2, param$3, param$4);
            };
            tmp = Curry._2(function(param23) {
                var func$1 = Curry._1(func, param23);
                return function(param24) {
                    var func$2 = Curry._1(func$1, param24);
                    return function(param) {
                        return Curry._2(func$2, param, matches2);
                    };
                };
            }(maybeInnerTextSemantic), context, addCancelCallback);
        } else {
            tmp = Promise.resolve(matches2);
        }
        return tmp.then(function(elements) {
            if (includeElementsNotVisible) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: elements
                });
            } else {
                return onlyKeepVisibleElementsOrOptionElements1(context, addCancelCallback, elements).then(function(matches) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: matches
                    });
                });
            }
        });
    });
}
function calcDistanceBetweenBetweenIds1(elementAttributes, selectorNode) {
    var match = idFromAttributes(elementAttributes);
    var match$1 = selectorNode.id;
    if (match === undefined) {
        if (match$1 !== undefined) {
            return 1000;
        } else {
            return 0;
        }
    }
    if (match$1 === undefined) {
        return 10;
    }
    if (match === match$1) {
        return 0;
    }
    if (match.length === match$1.length) {
        return 10;
    }
    var _prefix = StringUtils$SmartcutsMacros.commonPrefix(match, match$1);
    if (_prefix !== undefined) {
        return 10;
    } else {
        return 1000;
    }
}
function calcDistanceBetweenBetweenClasses1(elementAttributes, selectorNode) {
    var match = classNamesFromAttributes(elementAttributes);
    var match$1 = selectorNode.classNames;
    var exit = 0;
    if (match.length !== 0) {
        exit = 2;
    } else {
        if (match$1.length === 0) {
            return 0;
        }
        if (match$1.length !== 0) {
            return 1000;
        }
        exit = 2;
    }
    if (exit === 2 && match$1.length === 0 && match.length !== 0) {
        return 1000;
    }
    var elementClassNamesSet = Belt_SetString.fromArray(match);
    var selectorClassNamesSet = Belt_SetString.fromArray(match$1);
    var commonClassNamesSet = Belt_SetString.intersect(elementClassNamesSet, selectorClassNamesSet);
    var elementClassNamesNotSharedBySelector = Belt_SetString.diff(elementClassNamesSet, selectorClassNamesSet);
    var selectorClassNamesNotSharedByElement = Belt_SetString.diff(selectorClassNamesSet, elementClassNamesSet);
    return (Math.imul(Belt_SetString.size(commonClassNamesSet), -10) + Math.imul(Belt_SetString.size(elementClassNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorClassNamesNotSharedByElement), 10) | 0;
}
function calcDistanceBetweenAttributes1(elementAttributes, selectorNode) {
    var elementAttributesThatAreNotIdOrClass = keepAttributes(function(attrName, _attrValue) {
        if (attrName !== "class" && attrName !== "id") {
            return !$$Array.mem(attrName, Selector$SmartcutsMacros.attributesToAvoidComparing);
        } else {
            return false;
        }
    }, elementAttributes);
    var selectorAttributes = Belt_Array.reduce(Selector$SmartcutsMacros.attributesToAvoidComparing, Belt_MapString.fromArray(selectorNode.attributes), Belt_MapString.remove);
    var match = Belt_MapString.size(elementAttributesThatAreNotIdOrClass);
    var match$1 = Belt_MapString.size(selectorAttributes);
    var exit = 0;
    if (match !== 0) {
        exit = 2;
    } else {
        if (match$1 === 0) {
            return 0;
        }
        if (match$1 > 0) {
            return 0;
        }
        exit = 2;
    }
    if (exit === 2 && match$1 === 0 && match > 0) {
        return 0;
    }
    var elementAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(elementAttributesThatAreNotIdOrClass));
    var selectorAttributeNames = Belt_SetString.fromArray(Belt_MapString.keysToArray(selectorAttributes));
    var commonAttributeNamesSet = Belt_SetString.intersect(elementAttributeNames, selectorAttributeNames);
    var elementAttributeNamesNotSharedBySelector = Belt_SetString.diff(elementAttributeNames, selectorAttributeNames);
    var selectorAttributeNamesNotSharedByElement = Belt_SetString.diff(selectorAttributeNames, elementAttributeNames);
    return (Belt_Array.reduce(Belt_SetString.toArray(commonAttributeNamesSet), 0, function(commonAttrDistance, attrName) {
        var elementAttrVal = Belt_MapString.getExn(elementAttributesThatAreNotIdOrClass, attrName);
        var selectorAttrVal = Belt_MapString.getExn(selectorAttributes, attrName);
        var attributeValueDistance = FastLevenshtein.get(elementAttrVal, selectorAttrVal);
        var tmp = attrName === "aria-label" ? attributeValueDistance === 0 ? -1000 : attributeValueDistance === 0 ? -10 : attributeValueDistance : attributeValueDistance === 0 ? -10 : attributeValueDistance;
        return commonAttrDistance + tmp | 0;
    }) + Math.imul(Belt_SetString.size(elementAttributeNamesNotSharedBySelector), 10) | 0) + Math.imul(Belt_SetString.size(selectorAttributeNamesNotSharedByElement), 10) | 0;
}
function distanceIsScrollable2(element, context, selectorNode) {
    return PromiseUtils$SmartcutsMacros.resolveWith(function(isElementScrollable) {
        var match = selectorNode.isScrollable;
        if (match !== undefined) {
            if (match) {
                if (isElementScrollable) {
                    return 1;
                } else {
                    return 0;
                }
            } else if (isElementScrollable) {
                return 0;
            } else {
                return 1;
            }
        } else if (isElementScrollable) {
            return 0;
        } else {
            return 1;
        }
    }, isElementScrollable2(context, element));
}
function distanceBetweenSelectorNodeAndElement1(domTree, selectorNode, context, element) {
    var attributes = element.attributes;
    var distanceId = calcDistanceBetweenBetweenIds1(attributes, selectorNode);
    var distanceClasses = calcDistanceBetweenBetweenClasses1(attributes, selectorNode);
    var distanceAttributes = calcDistanceBetweenAttributes1(attributes, selectorNode);
    return checkIsOptionElement1(context, element).then(function(isOptionElement) {
        if (isOptionElement && Caml_obj.caml_equal(selectorNode.tagName, "option")) {
            return Promise.resolve([
                Math.imul(distanceId, 100),
                Math.imul(distanceClasses, 10),
                distanceAttributes << 0
            ]);
        } else {
            return PromiseUtils$SmartcutsMacros.resolveWith(function(distanceIsScrollable) {
                return [
                    Math.imul(distanceId, 100),
                    Math.imul(distanceClasses, 10),
                    distanceAttributes << 0,
                    Math.imul(distanceIsScrollable, 50)
                ];
            }, distanceIsScrollable2(element, context, selectorNode));
        }
    });
}
function calcForElementChain1(domTree, selector, context, elementChain) {
    var depthDistance = Math.abs(List.length(selector) - elementChain.length | 0);
    if (depthDistance > 0) {
        return Promise.resolve(Math.pow(10, depthDistance + 2 | 0));
    } else {
        return PromiseUtils$SmartcutsMacros.resolveWith(function(distanceArray) {
            Curry._2(Log$SmartcutsMacros.selector.warn2, "calcForElementChain", Belt_Array.zip(elementChain, distanceArray));
            var sumBy = function sumBy(f, xs) {
                return Belt_Array.reduce(xs, 0.0, function(acc, x) {
                    return Curry._1(f, x) + acc;
                });
            };
            return sumBy(function(param) {
                return sumBy(function(x) {
                    return x;
                }, param);
            }, distanceArray);
        }, Belt_List.reduceWithIndex(selector, Promise.resolve([]), function(promise, selectorNode, index) {
            return PromiseUtils$SmartcutsMacros.resolveWith(function(param) {
                return Belt_Array.concat(param[0], [
                    param[1]
                ]);
            }, Promise.all([
                promise,
                distanceBetweenSelectorNodeAndElement1(domTree, selectorNode, context, Caml_array.get(elementChain, index))
            ]));
        }));
    }
}
function findElementsMatchingTagNameChainAndAttributesExistence1(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, param) {
    var attributesExistencePredicateFallbacks = [
        /* AllAttributes */ 0,
        /* AttributesNotDataOrAria */ 1,
        /* StardardAttributesExceptClassNameAtLastNLevels */ {
            _0: 3
        },
        /* OnlyUseId */ 2
    ];
    return PromiseUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.shortcutAsync(function(attributesExistencePredicate) {
        return PromiseUtils$SmartcutsMacros.map(getElementsWithSameDepthAndAttributeKeysAsSelector1(queryRoot, context, useInnerText, maybeInnerTextSemantic, attributesExistencePredicate, leafSelectorNode, addCancelCallback, domTree, selector, includeElementsNotVisible, undefined), function(result_matchingElements) {
            if (result_matchingElements.TAG !== /* Ok */ 0) {
                return {
                    TAG: /* Error */ 1,
                    _0: result_matchingElements._0
                };
            }
            var matchingElements = result_matchingElements._0;
            var match = matchingElements.length;
            if (match !== 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: matchingElements
                };
            }
        });
    }, attributesExistencePredicateFallbacks), function(maybe_result_matchingElements) {
        if (maybe_result_matchingElements !== undefined) {
            if (maybe_result_matchingElements.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: maybe_result_matchingElements._0
                };
            } else {
                return {
                    TAG: /* Error */ 1,
                    _0: maybe_result_matchingElements._0
                };
            }
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: []
            };
        }
    });
}
function init(useInnerText, maybeInnerTextSemantic, queryRootOpt, context, addCancelCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selector) {
    var queryRoot = queryRootOpt !== undefined ? queryRootOpt : /* Document */ 0;
    var arg7 = ListUtils$SmartcutsMacros.getLast(selector);
    var leafSelectorNode = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg7);
    }("Expect to get leaf selector node");
    var selectorLength = List.length(selector);
    return findElementsMatchingTagNameChainAndAttributesExistence1(queryRoot, context, useInnerText, maybeInnerTextSemantic, leafSelectorNode, addCancelCallback, maybeDomTree, selector, includeElementsNotVisible, undefined).then(function(result_matchingElements) {
        if (result_matchingElements.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_matchingElements._0
            });
        }
        var matchingElements = result_matchingElements._0;
        return PromiseUtils$SmartcutsMacros.map(maybeDomTree !== undefined ? Promise.resolve(Caml_option.valFromOption(maybeDomTree)) : PromiseUtils$SmartcutsMacros.map(Promise.resolve(Caml_option.some(undefined)), function(param) {
            return OptionUtils$SmartcutsMacros.getExn("Expect Some(domTree) when getting candidate branches", param);
        }), function(domTree) {
            var updatedMatchingElements = Belt_Array.map(matchingElements, function(param) {
                return param;
            });
            var arg = Belt_Array.map(updatedMatchingElements, function(element) {
                var fullChain = getParentChain(domTree, element);
                if (typeof queryRoot === "number") {
                    return fullChain;
                } else {
                    var element$1 = queryRoot._0;
                    var index = Belt_Array.getIndexBy(fullChain, function(currElement) {
                        return Caml_obj.caml_equal(currElement, element$1);
                    });
                    if (index !== undefined) {
                        return Belt_Array.sliceToEnd(fullChain, index + 1 | 0);
                    } else {
                        return fullChain;
                    }
                }
            });
            return {
                TAG: /* Ok */ 0,
                _0: [
                    Belt_Array.keep(Belt_Array.keep((function(param) {
                        return function(param$1) {
                            return Util$SmartcutsMacros.spyTransform(param, param$1, arg);
                        };
                    })("before chain length filter")(function(x) {
                        return x;
                    }), function(elementChain) {
                        return elementChain.length === selectorLength;
                    }), function(elementChain) {
                        if (maybeOnlyConsiderElementChainIf !== undefined) {
                            return Curry._1(maybeOnlyConsiderElementChainIf, elementChain);
                        } else {
                            return true;
                        }
                    }),
                    domTree
                ]
            };
        });
    });
}
var alwaysRequiredAttributeNames = [
    "autofocus",
    "role"
];
function factorOutRequiredAttributesFromNode1(node) {
    var attributesByRequiredOrNotRequired = ArrayUtils$SmartcutsMacros.groupBy(function(param) {
        if ($$Array.mem(param[0], alwaysRequiredAttributeNames)) {
            return "required";
        } else {
            return "not-required";
        }
    }, node.attributes);
    var requiredAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "required"));
    var optionalAttributes = OptionUtils$SmartcutsMacros.withDefault([], Belt_MapString.get(attributesByRequiredOrNotRequired, "not-required"));
    return [
        requiredAttributes,
        {
            id: node.id,
            tagName: node.tagName,
            classNames: node.classNames,
            attributes: optionalAttributes,
            index: node.index,
            innerText: node.innerText,
            isScrollable: node.isScrollable,
            attributeBlacklist: node.attributeBlacklist
        }
    ];
}
function getNextCombinationForNode1(_searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes) {
    while(true){
        var searchStrategy = _searchStrategy;
        if (typeof searchStrategy === "number") {
            switch(searchStrategy){
                case /* ByTagAndId */ 0:
                    var arg8 = selectorNodeWithoutRequiredAttributes.tagName;
                    return {
                        combo: {
                            id: selectorNodeWithoutRequiredAttributes.id,
                            tagName: selectorNodeWithoutRequiredAttributes.tagName,
                            classNames: [],
                            attributes: [],
                            index: undefined,
                            innerText: /* NoInnerText */ 1,
                            isScrollable: undefined,
                            attributeBlacklist: []
                        },
                        nextStrategy: {
                            TAG: /* ByTagAndClassNames */ 0,
                            _0: {
                                tagName: (function(arg) {
                                    return function(param) {
                                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                    };
                                })(arg8)("Expected tagName"),
                                classComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.classNames))
                            }
                        }
                    };
                case /* ByIndex */ 1:
                    var index = selectorNodeWithoutRequiredAttributes.index;
                    if (index !== undefined) {
                        return {
                            combo: {
                                id: undefined,
                                tagName: selectorNodeWithoutRequiredAttributes.tagName,
                                classNames: [],
                                attributes: $$Array.append(requiredAttributes, ArrayUtils$SmartcutsMacros.filterMap(function(param) {
                                    var key = param[0];
                                    if (key === "contenteditable") {
                                        return [
                                            key,
                                            param[1]
                                        ];
                                    }
                                }, selectorNodeWithoutRequiredAttributes.attributes)),
                                index: index,
                                innerText: /* NoInnerText */ 1,
                                isScrollable: undefined,
                                attributeBlacklist: []
                            },
                            nextStrategy: /* NoMoreStrategies */ 2
                        };
                    } else {
                        return;
                    }
                case /* NoMoreStrategies */ 2:
                    return;
            }
        } else {
            if (searchStrategy.TAG === /* ByTagAndClassNames */ 0) {
                var match = searchStrategy._0;
                var tagName = match.tagName;
                var match$1 = ComboGenerator$SmartcutsMacros.generateNextCombo(match.classComboGenerator);
                if (match$1 !== undefined) {
                    return {
                        combo: {
                            id: undefined,
                            tagName: tagName,
                            classNames: $$Array.of_list(match$1[0]),
                            attributes: requiredAttributes,
                            index: undefined,
                            innerText: /* NoInnerText */ 1,
                            isScrollable: undefined,
                            attributeBlacklist: []
                        },
                        nextStrategy: {
                            TAG: /* ByTagAndClassNames */ 0,
                            _0: {
                                tagName: tagName,
                                classComboGenerator: match$1[1]
                            }
                        }
                    };
                }
                _searchStrategy = {
                    TAG: /* ByTagAndAttributes */ 1,
                    _0: {
                        tagName: tagName,
                        attributeComboGenerator: ComboGenerator$SmartcutsMacros.make($$Array.to_list(selectorNodeWithoutRequiredAttributes.attributes))
                    }
                };
                continue;
            }
            var match$2 = searchStrategy._0;
            var tagName$1 = match$2.tagName;
            var match$3 = ComboGenerator$SmartcutsMacros.generateNextCombo(match$2.attributeComboGenerator);
            if (match$3 !== undefined) {
                return {
                    combo: {
                        id: undefined,
                        tagName: tagName$1,
                        classNames: [],
                        attributes: $$Array.append(requiredAttributes, $$Array.of_list(match$3[0])),
                        index: undefined,
                        innerText: /* NoInnerText */ 1,
                        isScrollable: undefined,
                        attributeBlacklist: []
                    },
                    nextStrategy: {
                        TAG: /* ByTagAndAttributes */ 1,
                        _0: {
                            tagName: tagName$1,
                            attributeComboGenerator: match$3[1]
                        }
                    }
                };
            }
            _searchStrategy = /* ByIndex */ 1;
            continue;
        }
    }
    ;
}
function keepElementsThatIncludeInnerText1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elements) {
    return Promise.all($$Array.mapi(function(index, element) {
        return Curry._3(doesElementIncludeInnerText1(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
            return Promise.resolve([
                doesMatch,
                Caml_array.get(elements, index)
            ]);
        });
    }, elements)).then(function(pairsOfDoesMatchAndElement) {
        return Promise.resolve(Belt_Array.map(Belt_Array.keep(pairsOfDoesMatchAndElement, function(param) {
            return param[0];
        }), function(prim) {
            return prim[1];
        }));
    });
}
function withQuerySelectorAll1(retriesOpt, context, queryRoot, $$default, cssSelector, withResults) {
    var retries = retriesOpt !== undefined ? retriesOpt : 3;
    return PromiseUtils$SmartcutsMacros.withRetries(retries, function(addCancelCallback11, param) {
        return querySelectorAll(context, queryRoot, undefined, cssSelector.includes("option") || cssSelector.includes("select") || cssSelector.includes('[type="file"]'), cssSelector).then(function(result_results) {
            if (result_results.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_results._0
                });
            }
            var results = result_results._0;
            var match = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param) {
                return Curry._2(withResults, addCancelCallback, results);
            });
            Curry._1(addCancelCallback11, match[1]);
            return Curry._1(match[0], undefined);
        });
    }, function(param) {
        return false;
    }, {
        TAG: /* Ok */ 0,
        _0: $$default
    }, undefined);
}
function maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, searchStrategy, requiredAttributes, context, queryRoot, addCancelCallback12, selectorNodeWithoutRequiredAttributes) {
    var match = getNextCombinationForNode1(searchStrategy, requiredAttributes, selectorNodeWithoutRequiredAttributes);
    if (match === undefined) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: /* NoMatch */ 0
        });
    }
    var nextStrategy = match.nextStrategy;
    var arg_0 = match.combo;
    var arg = {
        hd: arg_0,
        tl: /* [] */ 0
    };
    var cssSelector = function(param) {
        return SelectorTree$SmartcutsMacros.stringify(param, arg);
    }(queryRoot !== /* Document */ 0);
    var maybeFindMatchByUsingNextStrategy = function maybeFindMatchByUsingNextStrategy(param, param$1) {
        return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, nextStrategy, requiredAttributes, context, queryRoot, param, param$1);
    };
    var match$1 = withQuerySelectorAll1(undefined, context, queryRoot, /* NoMatch */ 0, cssSelector, function(addCancelCallback, results2) {
        return onlyKeepVisibleElementsOrOptionElements1(context, addCancelCallback, results2).then(function(results) {
            var _twoOrMore4 = results.length;
            if (_twoOrMore4 === 0) {
                return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
            }
            if (_twoOrMore4 !== 1) {
                return keepElementsThatIncludeInnerText1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, results).then(function(elementsThatIncludeInnerText) {
                    var _twoOrMore5 = elementsThatIncludeInnerText.length;
                    if (_twoOrMore5 !== 0) {
                        if (_twoOrMore5 !== 1) {
                            return keepElementsThatMatchInnerTextExactly1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, elementsThatIncludeInnerText).then(function(elementsThatMatchInnerTextExactly) {
                                var _twoOrMore = elementsThatMatchInnerTextExactly.length;
                                if (_twoOrMore !== 0) {
                                    if (_twoOrMore !== 1) {
                                        return Promise.resolve(undefined).then(function(maybeMatch) {
                                            if (maybeMatch !== undefined) {
                                                return Promise.resolve({
                                                    TAG: /* Ok */ 0,
                                                    _0: /* ExactMatch */ {
                                                        _0: {
                                                            element: Caml_option.valFromOption(maybeMatch),
                                                            fallbackStrategy: nextStrategy
                                                        }
                                                    }
                                                });
                                            } else {
                                                return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                            }
                                        });
                                    } else {
                                        return Promise.resolve({
                                            TAG: /* Ok */ 0,
                                            _0: /* ExactMatch */ {
                                                _0: {
                                                    element: Caml_array.get(elementsThatMatchInnerTextExactly, 0),
                                                    fallbackStrategy: nextStrategy
                                                }
                                            }
                                        });
                                    }
                                } else {
                                    return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                                }
                            });
                        } else {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: /* ExactMatch */ {
                                    _0: {
                                        element: Caml_array.get(elementsThatIncludeInnerText, 0),
                                        fallbackStrategy: nextStrategy
                                    }
                                }
                            });
                        }
                    } else {
                        return maybeFindMatchByUsingNextStrategy(addCancelCallback, selectorNodeWithoutRequiredAttributes);
                    }
                });
            }
            var element = Caml_array.get(results, 0);
            return Curry._3(doesElementMatchInnerTextExactly1(useInnerTextExactMatch)(maybeInnerTextSemantic), context, addCancelCallback, element).then(function(doesMatch) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: doesMatch ? /* ExactMatch */ ({
                        _0: {
                            element: element,
                            fallbackStrategy: nextStrategy
                        }
                    }) : /* NoMatch */ 0
                });
            });
        });
    });
    Curry._1(addCancelCallback12, match$1[1]);
    return Curry._1(match$1[0], undefined);
}
function isHtmlAttributeUsefulInOptimization1(key, param) {
    if (key.startsWith("aria-")) {
        return true;
    } else {
        key.startsWith("data-");
        return false;
    }
}
function isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, isLeafNode, addCancelCallback13, selectorNode) {
    var id = selectorNode.id;
    if (id !== undefined) {
        var selectorNodeWithOnlyId_id = id;
        var selectorNodeWithOnlyId_tagName = selectorNode.tagName;
        var selectorNodeWithOnlyId_classNames = [];
        var selectorNodeWithOnlyId_attributes = [];
        var selectorNodeWithOnlyId_attributeBlacklist = [];
        var selectorNodeWithOnlyId = {
            id: selectorNodeWithOnlyId_id,
            tagName: selectorNodeWithOnlyId_tagName,
            classNames: selectorNodeWithOnlyId_classNames,
            attributes: selectorNodeWithOnlyId_attributes,
            index: undefined,
            innerText: /* NoInnerText */ 1,
            isScrollable: undefined,
            attributeBlacklist: selectorNodeWithOnlyId_attributeBlacklist
        };
        var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
            hd: selectorNodeWithOnlyId,
            tl: /* [] */ 0
        });
        var match = withQuerySelectorAll1(undefined, context, queryRoot, [
            false,
            []
        ], cssSelector, function(addCancelCallback, results) {
            return onlyKeepVisibleElements1(context, addCancelCallback, results).then(function(elements) {
                var isOptimal = 1 === elements.length;
                if (isOptimal) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: [
                            isOptimal,
                            elements
                        ]
                    });
                } else {
                    return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, isLeafNode, addCancelCallback, {
                        id: undefined,
                        tagName: selectorNode.tagName,
                        classNames: selectorNode.classNames,
                        attributes: selectorNode.attributes,
                        index: selectorNode.index,
                        innerText: selectorNode.innerText,
                        isScrollable: selectorNode.isScrollable,
                        attributeBlacklist: selectorNode.attributeBlacklist
                    });
                }
            });
        });
        Curry._1(addCancelCallback13, match[1]);
        return Curry._1(match[0], undefined);
    }
    var tagName = selectorNode.tagName;
    return Util$SmartcutsMacros.Shortcut.promise(function(param) {
        var value = param[1];
        var key = param[0];
        if (!isHtmlAttributeUsefulInOptimization1(key, value)) {
            return Promise.resolve(undefined);
        }
        var selectorNodeToTry_classNames = [];
        var selectorNodeToTry_attributes = [
            [
                key,
                value
            ]
        ];
        var selectorNodeToTry_attributeBlacklist = [];
        var selectorNodeToTry = {
            id: undefined,
            tagName: tagName,
            classNames: selectorNodeToTry_classNames,
            attributes: selectorNodeToTry_attributes,
            index: undefined,
            innerText: /* NoInnerText */ 1,
            isScrollable: undefined,
            attributeBlacklist: selectorNodeToTry_attributeBlacklist
        };
        var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
            hd: selectorNodeToTry,
            tl: /* [] */ 0
        });
        var match = withQuerySelectorAll1(undefined, context, queryRoot, undefined, cssSelector, function(addCancelCallback, results) {
            return onlyKeepVisibleElements1(context, addCancelCallback, results).then(function(elements) {
                var length = elements.length;
                if (length !== 0 && !(length !== 1 && !(length <= 2 && !isLeafNode))) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: elements
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
            });
        });
        Curry._1(addCancelCallback13, match[1]);
        return PromiseUtils$SmartcutsMacros.map(Curry._1(match[0], undefined), function(result_maybeElements) {
            if (result_maybeElements.TAG !== /* Ok */ 0) {
                return {
                    TAG: /* Error */ 1,
                    _0: result_maybeElements._0
                };
            }
            var elements = result_maybeElements._0;
            if (elements !== undefined) {
                return {
                    TAG: /* Ok */ 0,
                    _0: elements
                };
            }
        });
    }, selectorNode.attributes).then(function(maybe_resultElements) {
        if (maybe_resultElements !== undefined) {
            if (maybe_resultElements.TAG === /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: [
                        true,
                        maybe_resultElements._0
                    ]
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: maybe_resultElements._0
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: [
                    false,
                    []
                ]
            });
        }
    });
}
function findNestedNodesToStartSearch1(context, queryRoot, selector, addCancelCallback14) {
    if (List.length(selector) === 1) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: [
                undefined,
                selector
            ]
        });
    } else {
        return Belt_List.reduceReverse(selector, Promise.resolve({
            TAG: /* Ok */ 0,
            _0: [
                undefined,
                /* [] */ 0
            ]
        }), function(prevPromise, selectorNode) {
            return prevPromise.then(function(prevResult) {
                if (prevResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: prevResult._0
                    });
                }
                var match11 = prevResult._0;
                if (match11[0] !== undefined) {
                    return Promise.resolve(prevResult);
                }
                var prevSelector = match11[1];
                return PromiseUtils$SmartcutsMacros.makePromiseCancelableBySurroundingPromise(addCancelCallback14, function(addCancelCallback) {
                    return isSelectorNodeOptimalToBecomeNewQueryRoot(context, queryRoot, List.length(prevSelector) === 0, addCancelCallback, selectorNode).then(function(result_pair) {
                        if (result_pair.TAG !== /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: result_pair._0
                            });
                        }
                        var match = result_pair._0;
                        if (match[0]) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: [
                                    match[1],
                                    prevSelector
                                ]
                            });
                        } else {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: [
                                    undefined,
                                    {
                                        hd: selectorNode,
                                        tl: prevSelector
                                    }
                                ]
                            });
                        }
                    });
                });
            });
        });
    }
}
function startComboSearchForSelectorNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace3, stack, selectorNode, recursiveSearch3, addCancelCallback, remainder) {
    var match12 = factorOutRequiredAttributesFromNode1(selectorNode);
    var selectorNodeWithoutRequiredAttributes = match12[1];
    var requiredAttributes = match12[0];
    return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, /* ByTagAndId */ 0, requiredAttributes, context, queryRoot, addCancelCallback, selectorNodeWithoutRequiredAttributes).then(function(result_found) {
        if (result_found.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_found._0
            });
        }
        var match = result_found._0;
        if (!match) {
            return Curry._5(backtrace3, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack);
        }
        var match$1 = match._0;
        var nextQueryRoot_0 = match$1.element;
        var nextQueryRoot = {
            TAG: /* Element */ 0,
            _0: nextQueryRoot_0,
            _1: undefined
        };
        return Curry._6(recursiveSearch3, useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
            queryRoot: nextQueryRoot,
            stack: {
                hd: {
                    selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                    requiredAttributes: requiredAttributes,
                    queryRoot: nextQueryRoot,
                    fallbackStrategy: match$1.fallbackStrategy,
                    selector: remainder
                },
                tl: stack
            }
        }, remainder);
    });
}
function recursiveSearch_1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback15, param25, selector) {
    var stack = param25.stack;
    var queryRoot = param25.queryRoot;
    if (selector) {
        var remainder = selector.tl;
        var selectorNode = selector.hd;
        var cssSelector = SelectorTree$SmartcutsMacros.stringify(queryRoot !== /* Document */ 0, {
            hd: selectorNode,
            tl: /* [] */ 0
        });
        var match13 = withQuerySelectorAll1(undefined, context, queryRoot, undefined, cssSelector, function(addCancelCallback, results) {
            return onlyKeepVisibleElementsOrOptionElements1(context, addCancelCallback, results).then(function(resultElements) {
                var _twoOrMore6 = resultElements.length;
                if (_twoOrMore6 === 0) {
                    return startComboSearchForSelectorNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                }
                if (_twoOrMore6 !== 1) {
                    return keepElementsThatIncludeInnerText1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, resultElements).then(function(elementsThatIncludeInnerText) {
                        var _twoOrMore = elementsThatIncludeInnerText.length;
                        if (_twoOrMore === 0) {
                            return startComboSearchForSelectorNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                        }
                        if (_twoOrMore === 1) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: Caml_option.some(Caml_array.get(elementsThatIncludeInnerText, 0))
                            });
                        }
                        var match = factorOutRequiredAttributesFromNode1(selectorNode);
                        var selectorNodeWithoutRequiredAttributes = match[1];
                        var requiredAttributes = match[0];
                        return Util$SmartcutsMacros.shortcutPromise(function(element) {
                            return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                                queryRoot: {
                                    TAG: /* Element */ 0,
                                    _0: element,
                                    _1: undefined
                                },
                                stack: {
                                    hd: {
                                        selectorNodeWithoutRequiredAttributes: selectorNodeWithoutRequiredAttributes,
                                        requiredAttributes: requiredAttributes,
                                        queryRoot: queryRoot,
                                        fallbackStrategy: /* ByTagAndId */ 0,
                                        selector: remainder
                                    },
                                    tl: stack
                                }
                            }, remainder), function(result_maybeResult) {
                                if (result_maybeResult.TAG !== /* Ok */ 0) {
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: result_maybeResult._0
                                    };
                                }
                                var result_ = result_maybeResult._0;
                                if (result_ !== undefined) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: Caml_option.valFromOption(result_)
                                    };
                                }
                            });
                        }, elementsThatIncludeInnerText).then(function(maybe_result_Element) {
                            if (maybe_result_Element !== undefined) {
                                if (maybe_result_Element.TAG === /* Ok */ 0) {
                                    return Promise.resolve({
                                        TAG: /* Ok */ 0,
                                        _0: Caml_option.some(maybe_result_Element._0)
                                    });
                                } else {
                                    return Promise.resolve({
                                        TAG: /* Error */ 1,
                                        _0: maybe_result_Element._0
                                    });
                                }
                            } else {
                                return startComboSearchForSelectorNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, backtrace, stack, selectorNode, recursiveSearch, addCancelCallback, remainder);
                            }
                        });
                    });
                }
                var match15 = factorOutRequiredAttributesFromNode1(selectorNode);
                return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                    queryRoot: {
                        TAG: /* Element */ 0,
                        _0: Caml_array.get(resultElements, 0),
                        _1: undefined
                    },
                    stack: {
                        hd: {
                            selectorNodeWithoutRequiredAttributes: match15[1],
                            requiredAttributes: match15[0],
                            queryRoot: queryRoot,
                            fallbackStrategy: /* ByTagAndId */ 0,
                            selector: remainder
                        },
                        tl: stack
                    }
                }, remainder);
            });
        });
        Curry._1(addCancelCallback15, match13[1]);
        return Curry._1(match13[0], undefined);
    }
    if (typeof queryRoot === "number") {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    }
    var element3 = queryRoot._0;
    if (useInnerTextExactMatch === undefined) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: Caml_option.some(element3)
        });
    }
    var arg = Caml_option.some(element3);
    return PromiseUtils$SmartcutsMacros.map(function(param) {
        return OptionUtils$SmartcutsMacros.keepAsync(param, arg);
    }(function(param) {
        return doesElementMatchInnerText1(useInnerTextExactMatch, maybeInnerTextSemantic, context, function(text, expectedText) {
            return text === expectedText;
        }, function(text, expectedPrefix, param) {
            return text.startsWith(expectedPrefix);
        }, function(prefix, param, expectedText) {
            return expectedText.startsWith(prefix);
        }, function(prefix, param, expectedPrefix, param$1) {
            return prefix.startsWith(expectedPrefix);
        }, addCancelCallback15, param);
    }), function(maybeElement) {
        return {
            TAG: /* Ok */ 0,
            _0: maybeElement
        };
    });
}
function recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope) {
    return PromiseUtils$SmartcutsMacros.withTimeout(0, recursiveSearch_1(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, state, selectorAndSearchScope));
}
function backtrace(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, stack) {
    if (!stack) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        });
    }
    var prevBreakpoints = stack.tl;
    var lastBreakpoint = stack.hd;
    var selector = lastBreakpoint.selector;
    return maybeFindMatch(useInnerTextExactMatch, maybeInnerTextSemantic, lastBreakpoint.fallbackStrategy, lastBreakpoint.requiredAttributes, context, lastBreakpoint.queryRoot, addCancelCallback, lastBreakpoint.selectorNodeWithoutRequiredAttributes).then(function(result_results) {
        if (result_results.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result_results._0
            });
        }
        var match = result_results._0;
        if (!match) {
            return backtrace(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, prevBreakpoints);
        }
        var match$1 = match._0;
        return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
            queryRoot: {
                TAG: /* Element */ 0,
                _0: match$1.element,
                _1: undefined
            },
            stack: {
                hd: {
                    selectorNodeWithoutRequiredAttributes: lastBreakpoint.selectorNodeWithoutRequiredAttributes,
                    requiredAttributes: lastBreakpoint.requiredAttributes,
                    queryRoot: lastBreakpoint.queryRoot,
                    fallbackStrategy: match$1.fallbackStrategy,
                    selector: lastBreakpoint.selector
                },
                tl: prevBreakpoints
            }
        }, selector);
    });
}
function attemptToFindDeepestNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector) {
    Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
    var maybePromisedResult = OptionUtils$SmartcutsMacros.map(Belt_List.get(List.rev(selector), 0), function(deepestNode) {
        return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
            queryRoot: queryRoot,
            stack: /* [] */ 0
        }, {
            hd: deepestNode,
            tl: /* [] */ 0
        });
    });
    return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
        TAG: /* Ok */ 0,
        _0: undefined
    }), maybePromisedResult);
}
function topDownSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback16) {
    var match16 = PromiseUtils$SmartcutsMacros.withRetries(3, function(addCancelCallback, param) {
        Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node");
        return findNestedNodesToStartSearch1(context, queryRoot, selector, addCancelCallback).then(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result._0
                });
            }
            var match = result._0;
            var _$selector = match[1];
            var maybeOptimalStartElements = match[0];
            Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via deepest node - nested nodes");
            Curry._3(Log$SmartcutsMacros.selector.log3, "results", maybeOptimalStartElements, $$Array.of_list(_$selector));
            if (maybeOptimalStartElements === undefined) {
                return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                    queryRoot: queryRoot,
                    stack: /* [] */ 0
                }, _$selector);
            }
            if (!_$selector && maybeOptimalStartElements.length === 1) {
                return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                    queryRoot: {
                        TAG: /* Element */ 0,
                        _0: Caml_array.get(maybeOptimalStartElements, 0),
                        _1: undefined
                    },
                    stack: /* [] */ 0
                }, _$selector);
            }
            return Util$SmartcutsMacros.Shortcut.promise(function(element) {
                return PromiseUtils$SmartcutsMacros.map(recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                    queryRoot: {
                        TAG: /* Element */ 0,
                        _0: element,
                        _1: undefined
                    },
                    stack: /* [] */ 0
                }, _$selector), function(result_maybeElement) {
                    if (result_maybeElement.TAG !== /* Ok */ 0) {
                        return {
                            TAG: /* Error */ 1,
                            _0: result_maybeElement._0
                        };
                    }
                    var _$element = result_maybeElement._0;
                    if (_$element !== undefined) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: Caml_option.valFromOption(_$element)
                        };
                    }
                });
            }, maybeOptimalStartElements).then(function(maybe_result_element) {
                if (maybe_result_element !== undefined) {
                    if (maybe_result_element.TAG === /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: Caml_option.some(maybe_result_element._0)
                        });
                    } else {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: maybe_result_element._0
                        });
                    }
                } else {
                    return recursiveSearch(useInnerTextExactMatch, maybeInnerTextSemantic, context, addCancelCallback, {
                        queryRoot: queryRoot,
                        stack: /* [] */ 0
                    }, _$selector);
                }
            });
        });
    }, function(param) {
        return false;
    }, {
        TAG: /* Ok */ 0,
        _0: undefined
    }, undefined);
    Curry._1(addCancelCallback16, match16[1]);
    return Curry._1(match16[0], undefined);
}
function shouldOnlySearchViaInnerText1(selector) {
    var match = SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector);
    if (match !== undefined && typeof match.innerText !== "number") {
        return true;
    } else {
        return false;
    }
}
function scrollVerticallyToLoadAllElements1(context, scrollableElement) {
    var loop = function(clientHeight, lastScrollHeight) {
        return Promise.resolve(scrollableElement.scrollHeight).then(function(scrollHeight) {
            if (scrollHeight <= lastScrollHeight) {
                return Util$SmartcutsMacros.wait(120).then(function(param26) {
                    return Promise.resolve(scrollableElement.scrollHeight).then(function(scrollHeight_2) {
                        if (scrollHeight_2 <= lastScrollHeight) {
                            return Promise.resolve(undefined);
                        }
                        var func = function func(param, param$1, param$2) {
                            return scrollTo(context, param, param$1, param$2);
                        };
                        var arg = scrollHeight_2 - clientHeight | 0;
                        return func(undefined, arg, scrollableElement).then(function(param) {
                            return loop(clientHeight, scrollHeight_2);
                        });
                    });
                });
            }
            var func2 = function func2(param, param$1, param$2) {
                return scrollTo(context, param, param$1, param$2);
            };
            var arg11 = scrollHeight - clientHeight | 0;
            return func2(undefined, arg11, scrollableElement).then(function(param) {
                return loop(clientHeight, scrollHeight);
            });
        });
    };
    return Promise.all([
        Promise.resolve(scrollableElement.scrollHeight),
        Promise.resolve(scrollableElement.clientHeight)
    ]).then(function(param27) {
        var clientHeight = param27[1];
        var scrollHeight = param27[0];
        var func = function func(param, param$1, param$2) {
            return scrollTo(context, param, param$1, param$2);
        };
        var arg = scrollHeight - clientHeight | 0;
        return func(undefined, arg, scrollableElement).then(function(param) {
            return loop(clientHeight, scrollHeight);
        });
    });
}
function findChainWithLowestScoreAndAnyTiedChains1(chainDistancePairs) {
    return ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expect to get Some(chainWithLowestScore)", ArrayUtils$SmartcutsMacros.filterMap(function(param28) {
        var distance = param28[1];
        if (Belt_Array.every(chainDistancePairs, function(param) {
            return param[1] >= distance;
        })) {
            return param28[0];
        }
    }, chainDistancePairs));
}
function search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, fullSelector, addOnPredicateTimedOutCallback, maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, param29) {
    var selectorSlices = Selector$SmartcutsMacros.splitForShadowDom(fullSelector);
    return Belt_Array.reduceWithIndex(selectorSlices, Promise.resolve({
        TAG: /* Ok */ 0,
        _0: [
            maybeDomTree,
            queryRoot
        ]
    }), function(lastProm, selectorSlice, selectorSliceIndex) {
        return lastProm.then(function(result_pair) {
            if (result_pair.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_pair._0
                });
            }
            var match17 = result_pair._0;
            var maybeQueryRoot = match17[1];
            var _$maybeDomTree = match17[0];
            if (maybeQueryRoot === undefined) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: [
                        _$maybeDomTree,
                        maybeQueryRoot
                    ]
                });
            }
            var match$1 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param30) {
                var isLastSlice = selectorSliceIndex === (selectorSlices.length - 1 | 0);
                return init(useInnerText && isLastSlice, maybeInnerTextSemantic, maybeQueryRoot, context, addCancelCallback, _$maybeDomTree, maybeOnlyConsiderElementChainIf, includeElementsNotVisible, selectorSlice).then(function(result_chainsAndTree) {
                    if (result_chainsAndTree.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_chainsAndTree._0
                        });
                    }
                    var match18 = result_chainsAndTree._0;
                    var domTree = match18[1];
                    var elementChains = match18[0];
                    if (elementChains.length === 0) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: [
                                Caml_option.some(domTree),
                                undefined
                            ]
                        });
                    }
                    var func = function func(param, param$1, param$2) {
                        return Promise.all(Belt_Array.map(param$2, function(elementChain) {
                            return PromiseUtils$SmartcutsMacros.resolveWith(function(distance) {
                                return [
                                    elementChain,
                                    distance
                                ];
                            }, calcForElementChain1(domTree, param, param$1, elementChain));
                        }));
                    };
                    var func$1 = Curry._1(func, selectorSlice);
                    return Curry._1(function(param) {
                        return Curry._2(func$1, param, elementChains);
                    }, context).then(function(chainDistancePairs) {
                        var func = function func(param, param$1) {
                            var match = findChainWithLowestScoreAndAnyTiedChains1(param$1);
                            var chainWithLowestScore = match[0];
                            var tiedChains = match[1];
                            return Belt_Array.reduce(tiedChains, chainWithLowestScore, function(currBestChain, currChain) {
                                var maybeNextBestChain = ListUtils$SmartcutsMacros.shortcutWithIndex(function(selectorNode, nodeIndex) {
                                    var maybeRecordedSiblingIndex = selectorNode.index;
                                    var currElementA = Caml_array.get(currBestChain, nodeIndex);
                                    var currElementB = Caml_array.get(currChain, nodeIndex);
                                    var siblingIndexA = getSiblingIndex(param, currElementA);
                                    var siblingIndexB = getSiblingIndex(param, currElementB);
                                    if (maybeRecordedSiblingIndex !== undefined && !(maybeRecordedSiblingIndex === siblingIndexA && maybeRecordedSiblingIndex === siblingIndexB)) {
                                        if (maybeRecordedSiblingIndex === siblingIndexA) {
                                            return currBestChain;
                                        } else if (maybeRecordedSiblingIndex === siblingIndexB) {
                                            return currChain;
                                        } else {
                                            return;
                                        }
                                    }
                                }, selectorSlice);
                                return OptionUtils$SmartcutsMacros.withDefault(currBestChain, maybeNextBestChain);
                            });
                        };
                        var bestChain = Curry._2(func, domTree, chainDistancePairs);
                        var maybeNextQueryRoot = OptionUtils$SmartcutsMacros.map(ArrayUtils$SmartcutsMacros.last(bestChain), function(bestElement) {
                            if (isLastSlice) {
                                var tmp;
                                if (typeof maybeQueryRoot === "number") {
                                    tmp = bestChain.length;
                                } else if (maybeQueryRoot.TAG === /* Element */ 0) {
                                    var depth = maybeQueryRoot._1;
                                    tmp = depth !== undefined ? depth + bestChain.length | 0 : bestChain.length;
                                } else {
                                    tmp = maybeQueryRoot._1 + bestChain.length | 0;
                                }
                                return {
                                    TAG: /* Element */ 0,
                                    _0: bestElement,
                                    _1: tmp
                                };
                            }
                            var arg = Caml_option.some(bestElement.shadowRoot);
                            var tmp$1;
                            if (typeof maybeQueryRoot === "number") {
                                tmp$1 = bestChain.length + 1 | 0;
                            } else if (maybeQueryRoot.TAG === /* Element */ 0) {
                                var depth$1 = maybeQueryRoot._1;
                                tmp$1 = depth$1 !== undefined ? (depth$1 + bestChain.length | 0) + 1 | 0 : bestChain.length + 1 | 0;
                            } else {
                                tmp$1 = (maybeQueryRoot._1 + bestChain.length | 0) + 1 | 0;
                            }
                            return {
                                TAG: /* ShadowRoot */ 1,
                                _0: function(param) {
                                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                }("Expected dom shadow root"),
                                _1: tmp$1
                            };
                        });
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: [
                                Caml_option.some(domTree),
                                maybeNextQueryRoot
                            ]
                        });
                    });
                });
            });
            Curry._1(addOnPredicateTimedOutCallback, match$1[1]);
            return Curry._1(match$1[0], undefined);
        });
    }).then(function(result) {
        if (result.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result._0
            });
        }
        var maybeQueryRoot = result._0[1];
        if (maybeQueryRoot !== undefined && typeof maybeQueryRoot !== "number") {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: Caml_option.some(maybeQueryRoot._0)
            });
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
    });
}
function searchWithScrolling(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, param31) {
    return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function(result) {
        if (result.TAG !== /* Ok */ 0) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: result._0
            });
        }
        if (result._0 !== undefined) {
            return Promise.resolve(result);
        }
        if (!useInnerText) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
        var selectorDepth = Belt_List.length(selector);
        return Belt_List.reduceWithIndex(Belt_List.reverse(selector), Promise.resolve({
            TAG: /* Ok */ 0,
            _0: undefined
        }), function(promise, selectorNode, index) {
            return promise.then(function(result_maybeResult) {
                if (result_maybeResult.TAG !== /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: result_maybeResult._0
                    });
                }
                var element = result_maybeResult._0;
                if (element !== undefined) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: Caml_option.some(Caml_option.valFromOption(element))
                    });
                }
                if (selectorNode.isScrollable === undefined || Caml_obj.caml_equal(selectorNode.isScrollable, false)) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                var indexOfLastScrollableElement = selectorDepth - index | 0;
                var arg = Belt_List.take(selector, indexOfLastScrollableElement);
                var selectorToScrollableElement = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                }("Expect to get selectorToScrollableElement");
                var arg$1 = Belt_List.drop(selector, indexOfLastScrollableElement);
                var selectorFromScrollableElement = function(param) {
                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                }("Expect to get selectorFromScrollableElement");
                return search1(useInnerText, maybeInnerTextSemantic, context, queryRoot, selectorToScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined).then(function(result_maybeElement) {
                    if (result_maybeElement.TAG !== /* Ok */ 0) {
                        return Promise.resolve({
                            TAG: /* Error */ 1,
                            _0: result_maybeElement._0
                        });
                    }
                    var scrollableElement = result_maybeElement._0;
                    if (scrollableElement === undefined) {
                        return Promise.resolve({
                            TAG: /* Ok */ 0,
                            _0: undefined
                        });
                    }
                    var scrollableElement$1 = Caml_option.valFromOption(scrollableElement);
                    return scrollVerticallyToLoadAllElements1(context, scrollableElement$1).then(function(param) {
                        return search1(useInnerText, maybeInnerTextSemantic, context, {
                            TAG: /* Element */ 0,
                            _0: scrollableElement$1,
                            _1: indexOfLastScrollableElement
                        }, selectorFromScrollableElement, addOnPredicateTimedOutCallback, domTree, onlyConsiderElementChainIf, includeElementsNotVisible, undefined);
                    });
                });
            });
        });
    });
}
function search2(useInnerText, maybeInnerTextSemantic, context, queryRoot, selector, addOnPredicateTimedOutCallback) {
    if (useInnerText && shouldOnlySearchViaInnerText1(selector)) {
        Curry._1(Log$SmartcutsMacros.selector.log1, "Searching via innerText");
        var match19 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param32) {
            var selectorReversed = List.rev(selector);
            return OptionUtils$SmartcutsMacros.withDefault(Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            }), Belt_Option.map(Belt_List.get(selectorReversed, 0), function(param) {
                var innerText = param.innerText;
                var maybeTagName = param.tagName;
                if (typeof innerText === "number") {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                if (maybeTagName === undefined) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                if (innerText._0.trim() === "") {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
                var normalizedTextCriteria = $$String.lowercase_ascii(innerText._0.trim());
                var applyToAppropriateElements = maybeTagName === "a" ? XPath$SmartcutsMacros.ExpressionBuilder.elementWithOrDescendantElementsWith : function applyToAppropriateElements(builder) {
                    return builder;
                };
                var xpath = "//" + (maybeTagName + ("[" + (Curry._1(applyToAppropriateElements, XPath$SmartcutsMacros.ExpressionBuilder.equals(normalizedTextCriteria, XPath$SmartcutsMacros.ExpressionBuilder.lowercase(XPath$SmartcutsMacros.ExpressionBuilder.normalizeSpace(XPath$SmartcutsMacros.ExpressionBuilder.text)))) + "]")));
                return queryXPath(context, queryRoot, addCancelCallback, xpath).then(function(elements2) {
                    Curry._3(Log$SmartcutsMacros.selector.log3, "xpath", xpath, elements2);
                    var len = elements2.length;
                    if (len !== 1) {
                        if (len !== 0) {
                            return Promise.resolve(Caml_option.some(undefined)).then(function(maybeDomTree) {
                                var getParentElements$1 = function getParentElements$1(elements) {
                                    if (maybeDomTree !== undefined) {
                                        return getParentElements(Caml_option.valFromOption(maybeDomTree), elements);
                                    } else {
                                        return Belt_Array.map(elements, function(param) {});
                                    }
                                };
                                return Util$SmartcutsMacros.shortcutPromise(function(maybeParentElement) {
                                    var match = ListUtils$SmartcutsMacros.getLast(selector);
                                    var match$1 = Belt_List.get(selectorReversed, 1);
                                    if (maybeParentElement === undefined) {
                                        return Promise.resolve(undefined);
                                    }
                                    if (match === undefined) {
                                        return Promise.resolve(undefined);
                                    }
                                    if (match$1 === undefined) {
                                        return Promise.resolve(undefined);
                                    }
                                    var parentElement = Caml_option.valFromOption(maybeParentElement);
                                    return couldElementMatchSelectorTreeNode(context, parentElement, match$1).then(function(couldMatch) {
                                        if (couldMatch) {
                                            return PromiseUtils$SmartcutsMacros.map(topDownSearch1(innerText, maybeInnerTextSemantic, context, {
                                                TAG: /* Element */ 0,
                                                _0: parentElement,
                                                _1: undefined
                                            }, {
                                                hd: match,
                                                tl: /* [] */ 0
                                            }, addCancelCallback), function(result_maybe_element) {
                                                if (result_maybe_element.TAG !== /* Ok */ 0) {
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: result_maybe_element._0
                                                    };
                                                }
                                                var element = result_maybe_element._0;
                                                if (element !== undefined) {
                                                    return {
                                                        TAG: /* Ok */ 0,
                                                        _0: Caml_option.valFromOption(element)
                                                    };
                                                }
                                            });
                                        } else {
                                            return Promise.resolve(undefined);
                                        }
                                    });
                                }, getParentElements$1(elements2));
                            });
                        } else {
                            return Promise.resolve(undefined);
                        }
                    }
                    var onlyElement = elements2[0];
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: onlyElement
                    });
                }).then(function(maybeResultElement) {
                    if (maybeResultElement !== undefined) {
                        if (maybeResultElement.TAG === /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: Caml_option.some(maybeResultElement._0)
                            });
                        } else {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: maybeResultElement._0
                            });
                        }
                    }
                    var useInnerTextExactMatch = OptionUtils$SmartcutsMacros.andThen(function(leafNode) {
                        var match = leafNode.innerText;
                        if (typeof match === "number") {
                            return;
                        } else {
                            return match;
                        }
                    }, SelectorTree$SmartcutsMacros.maybeGetLeafNode(selector));
                    return attemptToFindDeepestNode1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, addCancelCallback, selector).then(function(result_maybeElement) {
                        if (result_maybeElement.TAG !== /* Ok */ 0) {
                            return Promise.resolve({
                                TAG: /* Error */ 1,
                                _0: result_maybeElement._0
                            });
                        }
                        var element = result_maybeElement._0;
                        if (element !== undefined) {
                            return Promise.resolve({
                                TAG: /* Ok */ 0,
                                _0: Caml_option.some(Caml_option.valFromOption(element))
                            });
                        } else {
                            return topDownSearch1(useInnerTextExactMatch, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
                        }
                    });
                });
            }));
        });
        Curry._1(addOnPredicateTimedOutCallback, match19[1]);
        return Curry._1(match19[0], undefined);
    }
    var match$12 = PromiseUtils$SmartcutsMacros.makeCancelable(function(addCancelCallback, param) {
        return attemptToFindDeepestNode1(undefined, undefined, context, queryRoot, addCancelCallback, selector).then(function(result_maybeResult) {
            if (result_maybeResult.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result_maybeResult._0
                });
            }
            var element = result_maybeResult._0;
            if (element !== undefined) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: Caml_option.some(Caml_option.valFromOption(element))
                });
            } else {
                return topDownSearch1(undefined, maybeInnerTextSemantic, context, queryRoot, selector, addCancelCallback);
            }
        });
    });
    Curry._1(addOnPredicateTimedOutCallback, match$12[1]);
    return Curry._1(match$12[0], undefined);
}
var QueryInWebPage_CandidateBranches = {
    ElementChain: {},
    init: init
};
var QueryInWebPage = {
    CandidateBranches: QueryInWebPage_CandidateBranches,
    search1: search1,
    searchWithScrolling: searchWithScrolling,
    search2: search2
};
exports.candidateBranch_encode = candidateBranch_encode;
exports.candidateBranch_decode = candidateBranch_decode;
exports.MakeQueryInPromise = MakeQueryInPromise;
exports.WebPage = WebPage;
exports.QueryInWebPage = QueryInWebPage; /* fast-levenshtein Not a pure module */ 


/***/ }),

/***/ 48206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$String = __webpack_require__(65760);
var Belt_Array = __webpack_require__(2971);
var reEmberId = new RegExp("ember\\d+");
var reUUID = new RegExp($$String.concat("-", List.map(function(n) {
    return "\\b[a-fA-F0-9]{" + n + "}";
}, {
    hd: 8,
    tl: {
        hd: 4,
        tl: {
            hd: 4,
            tl: {
                hd: 4,
                tl: {
                    hd: 12,
                    tl: /* [] */ 0
                }
            }
        }
    }
})));
var githubIssueId = new RegExp("^issue_\\d+");
var googleDriveId = new RegExp("^:[\\d|\\w]{2}$");
function isGeneratedId(id) {
    return Belt_Array.some([
        reEmberId,
        reUUID,
        githubIssueId,
        googleDriveId
    ], function(re) {
        return re.test(id);
    });
}
exports.reEmberId = reEmberId;
exports.reUUID = reUUID;
exports.githubIssueId = githubIssueId;
exports.googleDriveId = googleDriveId;
exports.isGeneratedId = isGeneratedId; /* reEmberId Not a pure module */ 


/***/ }),

/***/ 47118:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_List = __webpack_require__(11332);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Belt_MapString = __webpack_require__(35082);
var SetUtils$SmartcutsMacros = __webpack_require__(45734);
var HTMLNodes$SmartcutsMacros = __webpack_require__(22764);
var ListUtils$SmartcutsMacros = __webpack_require__(57622);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.optionToJson(Decco.stringToJson, v.id)
        ],
        [
            "tagName",
            Decco.optionToJson(Decco.stringToJson, v.tagName)
        ],
        [
            "classNames",
            Decco.arrayToJson(Decco.stringToJson, v.classNames)
        ],
        [
            "attributes",
            Decco.arrayToJson(function(param) {
                return [
                    Decco.stringToJson(param[0]),
                    Decco.stringToJson(param[1])
                ];
            }, v.attributes)
        ],
        [
            "index",
            Decco.optionToJson(Decco.intToJson, v.index)
        ],
        [
            "innerText",
            HTMLNodes$SmartcutsMacros.InnerText.t_encode(v.innerText)
        ],
        [
            "isScrollable",
            Decco.optionToJson(Decco.boolToJson, v.isScrollable)
        ],
        [
            "attributeBlacklist",
            Decco.arrayToJson(function(param) {
                return [
                    Decco.stringToJson(param[0]),
                    Decco.arrayToJson(Decco.stringToJson, param[1])
                ];
            }, v.attributeBlacklist)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
        if (tagName.TAG === /* Ok */ 0) {
            var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
            if (classNames.TAG === /* Ok */ 0) {
                var attributes = Decco.arrayFromJson(function(json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */ 3) {
                        return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                        return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = Decco.stringFromJson(v0);
                    var match$3 = Decco.stringFromJson(v1);
                    if (match$2.TAG === /* Ok */ 0) {
                        if (match$3.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: [
                                    match$2._0,
                                    match$3._0
                                ]
                            };
                        }
                        var e = match$3._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = match$2._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
                if (attributes.TAG === /* Ok */ 0) {
                    var index = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
                    if (index.TAG === /* Ok */ 0) {
                        var innerText = HTMLNodes$SmartcutsMacros.InnerText.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "innerText"), null));
                        if (innerText.TAG === /* Ok */ 0) {
                            var isScrollable = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "isScrollable"), null));
                            if (isScrollable.TAG === /* Ok */ 0) {
                                var attributeBlacklist = Decco.arrayFromJson(function(json) {
                                    var match = Js_json.classify(json);
                                    if (typeof match === "number") {
                                        return Decco.error(undefined, "Not a tuple", json);
                                    }
                                    if (match.TAG !== /* JSONArray */ 3) {
                                        return Decco.error(undefined, "Not a tuple", json);
                                    }
                                    var match$1 = match._0;
                                    if (match$1.length !== 2) {
                                        return Decco.error(undefined, "Incorrect cardinality", json);
                                    }
                                    var v0 = match$1[0];
                                    var v1 = match$1[1];
                                    var match$2 = Decco.stringFromJson(v0);
                                    var match$3 = Decco.arrayFromJson(Decco.stringFromJson, v1);
                                    if (match$2.TAG === /* Ok */ 0) {
                                        if (match$3.TAG === /* Ok */ 0) {
                                            return {
                                                TAG: /* Ok */ 0,
                                                _0: [
                                                    match$2._0,
                                                    match$3._0
                                                ]
                                            };
                                        }
                                        var e = match$3._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: "[1]" + e.path,
                                                message: e.message,
                                                value: e.value
                                            }
                                        };
                                    }
                                    var e$1 = match$2._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: "[0]" + e$1.path,
                                            message: e$1.message,
                                            value: e$1.value
                                        }
                                    };
                                }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributeBlacklist"), null));
                                if (attributeBlacklist.TAG === /* Ok */ 0) {
                                    return {
                                        TAG: /* Ok */ 0,
                                        _0: {
                                            id: id._0,
                                            tagName: tagName._0,
                                            classNames: classNames._0,
                                            attributes: attributes._0,
                                            index: index._0,
                                            innerText: innerText._0,
                                            isScrollable: isScrollable._0,
                                            attributeBlacklist: attributeBlacklist._0
                                        }
                                    };
                                }
                                var e1 = attributeBlacklist._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".attributeBlacklist" + e1.path,
                                        message: e1.message,
                                        value: e1.value
                                    }
                                };
                            }
                            var e$11 = isScrollable._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".isScrollable" + e$11.path,
                                    message: e$11.message,
                                    value: e$11.value
                                }
                            };
                        }
                        var e$2 = innerText._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".innerText" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                            }
                        };
                    }
                    var e$3 = index._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".index" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                        }
                    };
                }
                var e$4 = attributes._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".attributes" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            }
            var e$5 = classNames._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".classNames" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                }
            };
        }
        var e$6 = tagName._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".tagName" + e$6.path,
                message: e$6.message,
                value: e$6.value
            }
        };
    }
    var e$7 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
        }
    };
}
function maybeGetAttributeValue(attr, param1) {
    return OptionUtils$SmartcutsMacros.map(Belt_Array.getBy(param1.attributes, function(param) {
        return param[0] === attr;
    }), function(prim) {
        return prim[1];
    });
}
function deepEquals(aNode, bNode) {
    if (!Caml_obj.caml_equal(aNode.id, bNode.id)) {
        return false;
    }
    if (!Caml_obj.caml_equal(aNode.tagName, bNode.tagName)) {
        return false;
    }
    var aClassNames = new Set(aNode.classNames);
    var bClassNames = new Set(bNode.classNames);
    if (!SetUtils$SmartcutsMacros.isSameSetAs(aClassNames, bClassNames)) {
        return false;
    }
    if (!Caml_obj.caml_equal(aNode.index, bNode.index)) {
        return false;
    }
    if (!Caml_obj.caml_equal(aNode.isScrollable, bNode.isScrollable)) {
        return false;
    }
    if (!HTMLNodes$SmartcutsMacros.InnerText.equals(aNode.innerText, bNode.innerText)) {
        return false;
    }
    var keysA = new Set(Belt_Array.map(aNode.attributes, function(prim) {
        return prim[0];
    }));
    var keysB = new Set(Belt_Array.map(bNode.attributes, function(prim) {
        return prim[0];
    }));
    var allKeys = SetUtils$SmartcutsMacros.union(keysA, keysB);
    var aKeyVals = Belt_MapString.fromArray(aNode.attributes);
    var bKeyVals = Belt_MapString.fromArray(bNode.attributes);
    if (!Belt_Array.reduce(Array.from(allKeys), true, function(acc, key) {
        var aVal = Belt_MapString.get(aKeyVals, key);
        var bVal = Belt_MapString.get(bKeyVals, key);
        if (acc) {
            return Caml_obj.caml_equal(aVal, bVal);
        } else {
            return false;
        }
    })) {
        return false;
    }
    var keysA$1 = new Set(Belt_Array.map(aNode.attributeBlacklist, function(prim) {
        return prim[0];
    }));
    var keysB$1 = new Set(Belt_Array.map(bNode.attributeBlacklist, function(prim) {
        return prim[0];
    }));
    var allKeys$1 = SetUtils$SmartcutsMacros.union(keysA$1, keysB$1);
    var aKeyVals$1 = Belt_MapString.fromArray(aNode.attributeBlacklist);
    var bKeyVals$1 = Belt_MapString.fromArray(bNode.attributeBlacklist);
    return Belt_Array.reduce(Array.from(allKeys$1), true, function(acc, key) {
        var match = Belt_MapString.get(aKeyVals$1, key);
        var match$1 = Belt_MapString.get(bKeyVals$1, key);
        if (match === undefined) {
            return false;
        }
        if (match$1 === undefined) {
            return false;
        }
        var aBlacklistValuesSet = new Set(match);
        var bBlacklistValuesSet = new Set(match$1);
        if (acc) {
            return SetUtils$SmartcutsMacros.isSameSetAs(aBlacklistValuesSet, bBlacklistValuesSet);
        } else {
            return false;
        }
    });
}
function allWithNode(aNode, bNode) {
    var aClassNames = new Set(aNode.classNames);
    var bClassNames = new Set(bNode.classNames);
    var classNameDiffAB = SetUtils$SmartcutsMacros.subtract(aClassNames, bClassNames);
    var classNameDiffBA = SetUtils$SmartcutsMacros.subtract(bClassNames, aClassNames);
    var classNameIntersect = SetUtils$SmartcutsMacros.intersect(aClassNames, bClassNames);
    return List.fold_left(function(res, param) {
        if (param[0]) {
            return List.append(res, {
                hd: param[1],
                tl: /* [] */ 0
            });
        } else {
            return res;
        }
    }, /* [] */ 0, {
        hd: [
            Caml_obj.caml_notequal(aNode.id, bNode.id),
            {
                TAG: /* Id */ 0,
                _0: aNode.id,
                _1: bNode.id
            }
        ],
        tl: {
            hd: [
                Caml_obj.caml_notequal(aNode.tagName, bNode.tagName),
                {
                    TAG: /* TagName */ 1,
                    _0: aNode.tagName,
                    _1: bNode.tagName
                }
            ],
            tl: {
                hd: [
                    !(SetUtils$SmartcutsMacros.isEmpty(classNameDiffAB) && SetUtils$SmartcutsMacros.isEmpty(classNameDiffBA)),
                    {
                        TAG: /* ClassNames */ 3,
                        _0: Array.from(classNameDiffAB),
                        _1: Array.from(classNameDiffBA),
                        _2: Array.from(classNameIntersect)
                    }
                ],
                tl: {
                    hd: [
                        Caml_obj.caml_notequal(aNode.index, bNode.index),
                        {
                            TAG: /* Index */ 2,
                            _0: aNode.index,
                            _1: bNode.index
                        }
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    });
}
function withNode(aNode, bNode) {
    var match = allWithNode(aNode, bNode);
    if (!match) {
        return /* NoDiff */ 0;
    }
    var diff = match.hd;
    return diff;
}
var Diff = {
    allWithNode: allWithNode,
    withNode: withNode
};
function fromSelectorNode(node) {
    var isScrollable = node.isScrollable;
    return Belt_List.concatMany([
        OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.tagName, function(tagName) {
            return {
                TAG: /* TagName */ 0,
                _0: tagName
            };
        })),
        OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.id, function(id) {
            return {
                TAG: /* Id */ 1,
                _0: id
            };
        })),
        $$Array.to_list($$Array.map(function(className) {
            return {
                TAG: /* ClassName */ 2,
                _0: className
            };
        }, node.classNames)),
        $$Array.to_list($$Array.map(function(param) {
            return {
                TAG: /* Attribute */ 3,
                _0: param[0],
                _1: param[1]
            };
        }, node.attributes)),
        OptionUtils$SmartcutsMacros.toList(OptionUtils$SmartcutsMacros.$neg$question$great(node.index, function(index) {
            return {
                TAG: /* AtIndex */ 4,
                _0: index
            };
        })),
        isScrollable !== undefined ? {
            hd: {
                TAG: /* IsScrollable */ 6,
                _0: isScrollable
            },
            tl: /* [] */ 0
        } : /* [] */ 0
    ]);
}
function toNode(components) {
    var tagName = ListUtils$SmartcutsMacros.shortcut(function(v) {
        if (v.TAG === /* TagName */ 0) {
            return v._0;
        }
    }, components);
    var id = ListUtils$SmartcutsMacros.shortcut(function(v) {
        if (v.TAG === /* Id */ 1) {
            return v._0;
        }
    }, components);
    var classNames1 = Belt_List.reduce(components, [], function(classNames, component) {
        if (component.TAG === /* ClassName */ 2) {
            return $$Array.append(classNames, [
                component._0
            ]);
        } else {
            return classNames;
        }
    });
    var attributes1 = Belt_List.reduce(components, [], function(attributes, component) {
        if (component.TAG === /* Attribute */ 3) {
            return $$Array.append(attributes, [
                [
                    component._0,
                    component._1
                ]
            ]);
        } else {
            return attributes;
        }
    });
    var index = ListUtils$SmartcutsMacros.shortcut(function(v) {
        if (v.TAG === /* AtIndex */ 4) {
            return v._0;
        }
    }, components);
    var maybeInnerText = ListUtils$SmartcutsMacros.shortcut(function(v) {
        if (v.TAG === /* InnerText */ 5) {
            return v._0;
        }
    }, components);
    var maybeIsScrollable = ListUtils$SmartcutsMacros.shortcut(function(v) {
        if (v.TAG === /* IsScrollable */ 6) {
            return v._0;
        }
    }, components);
    return {
        id: id,
        tagName: tagName,
        classNames: classNames1,
        attributes: attributes1,
        index: index,
        innerText: maybeInnerText !== undefined ? {
            TAG: /* FullInnerText */ 0,
            _0: maybeInnerText
        } : /* NoInnerText */ 1,
        isScrollable: maybeIsScrollable,
        attributeBlacklist: []
    };
}
var Components = {
    fromSelectorNode: fromSelectorNode,
    toNode: toNode
};
function maybeStringifyAttributeKey(attrKey) {
    if (attrKey === "xmlns") {
        return;
    }
    if (attrKey.indexOf(":") <= -1) {
        return window.CSS.escape(attrKey);
    }
    var arg = ArrayUtils$SmartcutsMacros.last(attrKey.split(":"));
    var keyWithoutNamespace = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect to get attribute key after namespace prefix from attribute " + StringUtils$SmartcutsMacros.quote(attrKey));
    return "*|" + window.CSS.escape(keyWithoutNamespace);
}
function stringify(node) {
    var expr = $$String.concat("", Belt_List.map(fromSelectorNode(node), function(component) {
        switch(component.TAG | 0){
            case /* TagName */ 0:
                return component._0;
            case /* Id */ 1:
                return "#" + window.CSS.escape(component._0);
            case /* ClassName */ 2:
                return "." + window.CSS.escape(component._0);
            case /* Attribute */ 3:
                var value = component._1;
                var key2 = maybeStringifyAttributeKey(component._0);
                if (key2 === undefined) {
                    return "";
                }
                if (value === "") {
                    return "[" + key2 + "]";
                }
                var escapedValue = window.CSS.escape(value);
                return "[" + key2 + '="' + escapedValue + '"]';
            case /* AtIndex */ 4:
                return ":nth-child(" + component._0 + ")";
            case /* InnerText */ 5:
            case /* IsScrollable */ 6:
                return "";
        }
    }));
    var match = node.tagName;
    if (match !== undefined) {
        return expr;
    } else {
        return "*" + expr;
    }
}
function fromHtmlNode(childIndex, htmlNode) {
    if (htmlNode.TAG === /* DocumentFragmentNode */ 0) {
        return {
            id: undefined,
            tagName: htmlNode._0.nodeName,
            classNames: [],
            attributes: [],
            index: childIndex,
            innerText: /* Ignored */ 0,
            isScrollable: undefined,
            attributeBlacklist: []
        };
    }
    var elementNode = htmlNode._0;
    var element = elementNode.element;
    var scrollHeight = element.scrollHeight;
    var isScrollable = Belt_Option.map(elementNode.shape, function(param) {
        var hasScrollableContent = scrollHeight > param.clientHeight;
        var computedStyle = window.getComputedStyle(element);
        var isOverflowHidden = computedStyle.overflowY.includes("hidden");
        if (hasScrollableContent) {
            return !isOverflowHidden;
        } else {
            return false;
        }
    });
    return {
        id: elementNode.id,
        tagName: elementNode.tagName,
        classNames: elementNode.classNames,
        attributes: elementNode.attributes,
        index: childIndex,
        innerText: elementNode.innerText,
        isScrollable: isScrollable,
        attributeBlacklist: []
    };
}
var $$Node = {
    t_encode: t_encode,
    t_decode: t_decode,
    maybeGetAttributeValue: maybeGetAttributeValue,
    deepEquals: deepEquals,
    Diff: Diff,
    Components: Components,
    maybeStringifyAttributeKey: maybeStringifyAttributeKey,
    stringify: stringify,
    fromHtmlNode: fromHtmlNode
};
function t_encode$1(v) {
    return Decco.listToJson(t_encode, v);
}
function t_decode$1(v) {
    return Decco.listFromJson(t_decode, v);
}
function findIndex(cond, iter, x) {
    var _index = 1;
    var _x = x;
    while(true){
        var x$1 = _x;
        var index = _index;
        if (Curry._1(cond, x$1)) {
            return index;
        }
        var x$p = Curry._1(iter, x$1);
        if (x$p === undefined) {
            return;
        }
        _x = Caml_option.valFromOption(x$p);
        _index = index + 1 | 0;
        continue;
    }
    ;
}
function determineChildIndex(htmlNode, parentHtmlNode) {
    if (htmlNode.TAG === /* DocumentFragmentNode */ 0) {
        return;
    }
    var elementNode = htmlNode._0;
    var firstSibling;
    firstSibling = parentHtmlNode.TAG === /* DocumentFragmentNode */ 0 ? Caml_option.nullable_to_opt(parentHtmlNode._0.firstElementChild) : Caml_option.nullable_to_opt(parentHtmlNode._0.element.firstElementChild);
    return findIndex(function(sibling) {
        if (sibling !== undefined) {
            return Caml_option.valFromOption(sibling) === elementNode.element;
        } else {
            return false;
        }
    }, function(sibling) {
        return OptionUtils$SmartcutsMacros.$neg$question$great(sibling, function(prim) {
            return Caml_option.nullable_to_opt(prim.nextElementSibling);
        });
    }, firstSibling);
}
function fromHTMLNodes(htmlNodes) {
    var lastNodeIndex = List.length(htmlNodes) - 1 | 0;
    return List.rev(Belt_List.mapWithIndex(htmlNodes, function(i, htmlNode) {
        if (i === lastNodeIndex) {
            if (htmlNode.TAG === /* DocumentFragmentNode */ 0) {
                console.warn("Expected last node to be 'body'; got #document-fragment; beware using a selector derived from this");
            } else {
                var tagName = htmlNode._0.tagName;
                if (Caml_obj.caml_notequal(tagName, "body")) {
                    console.warn("Expected last node to be 'body'; got " + (OptionUtils$SmartcutsMacros.withDefault("undefined", tagName) + "; beware using a selector derived from this since element may have been removed from page"));
                }
            }
            return fromHtmlNode(undefined, htmlNode);
        }
        var childIndex = determineChildIndex(htmlNode, Belt_List.getExn(htmlNodes, i + 1 | 0));
        return fromHtmlNode(childIndex, htmlNode);
    }));
}
function processInnerText(innerTextMaxLen, keepLastNLevels, alwaysKeepTags, alwaysIgnoreTags, tree) {
    var treeLen = List.length(tree);
    return List.mapi(function(i, node) {
        var innerText = node.innerText;
        var tagName = node.tagName;
        var tmp;
        var exit = 0;
        if (tagName !== undefined) {
            if ($$Array.exists(function(allowedTag) {
                return tagName === $$String.lowercase_ascii(allowedTag) ? true : tagName === $$String.uppercase_ascii(allowedTag);
            }, alwaysKeepTags)) {
                tmp = innerText;
            } else if (Belt_Array.some(alwaysIgnoreTags, function(tagToIgnore) {
                return tagName === $$String.lowercase_ascii(tagToIgnore) ? true : tagName === $$String.uppercase_ascii(tagToIgnore);
            })) {
                tmp = /* Ignored */ 0;
            } else {
                exit = 1;
            }
        } else {
            exit = 1;
        }
        if (exit === 1) {
            if (typeof innerText === "number") {
                tmp = innerText;
            } else {
                var text = innerText._0;
                tmp = keepLastNLevels === -1 || i >= (treeLen - keepLastNLevels | 0) ? text.length <= innerTextMaxLen ? {
                    TAG: /* FullInnerText */ 0,
                    _0: text
                } : {
                    TAG: /* TruncatedInnerText */ 1,
                    _0: $$String.sub(text, 0, innerTextMaxLen),
                    _1: text.length
                } : /* Ignored */ 0;
            }
        }
        return {
            id: node.id,
            tagName: node.tagName,
            classNames: node.classNames,
            attributes: node.attributes,
            index: node.index,
            innerText: tmp,
            isScrollable: node.isScrollable,
            attributeBlacklist: node.attributeBlacklist
        };
    }, tree);
}
function maybeGetLeafNode(tree) {
    var len = List.length(tree);
    if (len !== 0) {
        return Belt_List.get(tree, len - 1 | 0);
    }
}
function stringify$1(useScope, selectorNodes) {
    return Belt_List.reduce(selectorNodes, useScope ? ":scope" : "", function(prevString, node) {
        var stringifiedNode = stringify(node);
        if (node.index !== undefined) {
            if (prevString === "") {
                return stringifiedNode;
            } else {
                return prevString + (" > " + stringifiedNode);
            }
        } else {
            return prevString + (" " + stringifiedNode);
        }
    });
}
exports.$$Node = $$Node;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.findIndex = findIndex;
exports.determineChildIndex = determineChildIndex;
exports.fromHTMLNodes = fromHTMLNodes;
exports.processInnerText = processInnerText;
exports.maybeGetLeafNode = maybeGetLeafNode;
exports.stringify = stringify$1; /* HTMLNodes-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 83188:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$String = __webpack_require__(65760);
var Js_json = __webpack_require__(85688);
function Make(Config) {
    var id_encode = function id_encode(id) {
        return id;
    };
    var id_decode = function id_decode(json) {
        var id = Js_json.decodeString(json);
        if (id !== undefined) {
            return {
                TAG: /* Ok */ 0,
                _0: id
            };
        } else {
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: "",
                    message: "Failed to decode " + Config.name,
                    value: json
                }
            };
        }
    };
    var doesEqualStringId = function doesEqualStringId(stringId, id) {
        return id === stringId;
    };
    var cmp = $$String.compare;
    return {
        id_encode: id_encode,
        id_decode: id_decode,
        doesEqualStringId: doesEqualStringId,
        cmp: cmp
    };
}
exports.Make = Make; /* No side effect */ 


/***/ }),

/***/ 57019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Belt_List = __webpack_require__(11332);
var Js_option = __webpack_require__(10354);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Caml_option = __webpack_require__(57175);
var Log$SmartcutsMacros = __webpack_require__(78088);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var JsPromiseErrorUtils$SmartcutsMacros = __webpack_require__(72349);
function map(promise, f) {
    return promise.then(function(x) {
        return Promise.resolve(Curry._1(f, x));
    });
}
function map2(f, promise) {
    return promise.then(function(x) {
        return Promise.resolve(Curry._1(f, x));
    });
}
function resolveWith(f, promise) {
    return map(promise, f);
}
function rejectWith(message) {
    return Promise.reject(new __webpack_require__.g.Error(message));
}
function cancelTimeout(delay, message) {
    return new Promise(function(param, reject) {
        setTimeout(function(param) {
            return reject(new __webpack_require__.g.Error(message));
        }, delay);
    });
}
function toString(obj) {
    return Js_option.getExn(JSON.stringify(obj));
}
function getOrReject(opt) {
    if (opt !== undefined) {
        return Promise.resolve(Caml_option.valFromOption(opt));
    } else {
        return Promise.reject(new __webpack_require__.g.Error("Unable to get"));
    }
}
function rejectIfEmpty(error, results) {
    if (results.length !== 0) {
        return Promise.resolve(results);
    } else {
        return Promise.reject(new __webpack_require__.g.Error(error));
    }
}
function pickFirst(results) {
    return Promise.resolve(Caml_array.get(results, 0));
}
function append_result(results, prom) {
    return prom.then(function(result) {
        return Promise.resolve([
            result
        ].concat(results));
    });
}
function append_result2(prom, results) {
    return append_result(results, prom);
}
function doAll(promiseList) {
    return promiseList.reduce(function(accPromise, thisPromise) {
        return accPromise.then(function(results) {
            return append_result(results, thisPromise);
        });
    }, Promise.resolve([]));
}
function doAllWithProgressUpdate(onProgressUpdate, promises) {
    var nResolved = {
        contents: 0
    };
    return Promise.all(Belt_Array.map(promises, function(param) {
        return map(param, function(result) {
            nResolved.contents = nResolved.contents + 1 | 0;
            Curry._1(onProgressUpdate, nResolved.contents);
            return result;
        });
    }));
}
function sequentiallyWithIndex(fn, xs) {
    return $$Array.fold_left(function(promise, param) {
        var x = param[1];
        var index = param[0];
        return promise.then(function(results) {
            return append_result(results, Curry._2(fn, index, x));
        });
    }, Promise.resolve([]), $$Array.mapi(function(index, x) {
        return [
            index,
            x
        ];
    }, xs));
}
function sequentiallyWithIndex2(xs, fn) {
    return Belt_Array.reduceWithIndex(xs, Promise.resolve([]), function(promise, x, index) {
        return promise.then(function(results) {
            return append_result(results, Curry._2(fn, index, x));
        });
    });
}
function sequentially(fn, xs) {
    return sequentiallyWithIndex(function(_index, x) {
        return Curry._1(fn, x);
    }, xs);
}
function sequentially2(xs, fn) {
    return sequentiallyWithIndex2(xs, function(_index, x) {
        return Curry._1(fn, x);
    });
}
function sequentiallyEvalResults(f, xs) {
    var match = ArrayUtils$SmartcutsMacros.splitAtFirst(xs);
    if (match === undefined) {
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: []
        });
    }
    var partial_arg = [];
    return Belt_Array.reduceWithIndex(match[1], Curry._1(f, match[0]).then(function(param) {
        if (param.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: [
                    param._0
                ]
            };
        } else {
            return {
                TAG: /* Error */ 1,
                _0: {
                    returns: partial_arg,
                    error: param._0,
                    remaining: xs
                }
            };
        }
    }), function(promise, x, index) {
        return promise.then(function(result1) {
            if (result1.TAG !== /* Ok */ 0) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: result1._0
                });
            }
            var returns = result1._0;
            return Curry._1(f, x).then(function(result) {
                if (result.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: Belt_Array.concat(returns, [
                            result._0
                        ])
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Error */ 1,
                        _0: {
                            returns: returns,
                            error: result._0,
                            remaining: Belt_Array.sliceToEnd(xs, index)
                        }
                    });
                }
            });
        });
    });
}
function doAllFns(fns) {
    return $$Array.fold_left(function(promise, fn) {
        return promise.then(function(results) {
            return append_result(results, Curry._1(fn, undefined));
        });
    }, Promise.resolve([]), fns);
}
function sequentiallyList(fn, lst) {
    return Belt_List.reduce(lst, Promise.resolve(undefined), function(resolved, item) {
        return resolved.then(function(param) {
            return Curry._1(fn, item);
        });
    });
}
function wrapInTimeout(milliseconds, makePromise) {
    return new Promise(function(resolve, param) {
        setTimeout(function(param) {
            Curry._1(makePromise, undefined).then(function(x) {
                resolve(x);
                return Promise.resolve(undefined);
            });
        }, milliseconds);
    });
}
function shortcutWithIndexAndState(init, f, xs) {
    return Belt_Array.reduceWithIndex(xs, Promise.resolve([
        init,
        undefined
    ]), function(promise, x, index) {
        return promise.then(function(result) {
            if (result[1] !== undefined) {
                return Promise.resolve(result);
            } else {
                return Curry._3(f, result[0], x, index);
            }
        });
    }).then(function(param) {
        return Promise.resolve(param[1]);
    });
}
function shortcutWithState(init, f, xs) {
    return shortcutWithIndexAndState(init, function(state, x, _index) {
        return Curry._2(f, state, x);
    }, xs);
}
function shortcutWithIndex(f, xs) {
    return shortcutWithIndexAndState(undefined, function(unit, x, index) {
        return Curry._2(f, x, index).then(function(output) {
            return Promise.resolve([
                unit,
                output
            ]);
        });
    }, xs);
}
function shortcut(f, xs) {
    return shortcutWithIndexAndState(undefined, function(unit, x, _index) {
        return Curry._1(f, x).then(function(output) {
            return Promise.resolve([
                unit,
                output
            ]);
        });
    }, xs);
}
function orPromise(promiseA, promiseB) {
    return Promise.all([
        promiseA,
        promiseB
    ]).then(function(param) {
        return Promise.resolve(param[0] || param[1]);
    });
}
function makeCancelable(makePromise) {
    var isCanceled = {
        contents: false
    };
    var cancelCallbacks = {
        contents: []
    };
    var addCancelCallback = function addCancelCallback(callback) {
        if (isCanceled.contents) {
            return Curry._1(callback, undefined);
        } else {
            cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [
                callback
            ]);
            return;
        }
    };
    var cancelPromise = function cancelPromise(param) {
        isCanceled.contents = true;
        return Belt_Array.forEach(cancelCallbacks.contents, function(callback) {
            return Curry._1(callback, undefined);
        });
    };
    var doPromise = function doPromise(param) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return Curry._2(makePromise, addCancelCallback, isCanceled).then(function(res) {
            if (isCanceled.contents) {
                throw {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                    Error: new Error()
                };
            }
            return Promise.resolve(res);
        });
    };
    return [
        doPromise,
        cancelPromise
    ];
}
function makePromiseCancelableBySurroundingPromise(addCancelCallback1, promiseBuilder) {
    var match = makeCancelable(function(addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
            throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
            };
        }
        return Curry._1(promiseBuilder, addCancelCallback);
    });
    Curry._1(addCancelCallback1, match[1]);
    return Curry._1(match[0], undefined);
}
function withRetriesInner(retries, didCancelRetries, doPromise, shouldRetryForJsPromiseError, $$default) {
    if (Curry._1(didCancelRetries, undefined)) {
        if ($$default !== undefined) {
            return Promise.resolve(Caml_option.valFromOption($$default));
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
            Error: new Error()
        };
    }
    var promise = Curry._1(doPromise, undefined).then(function(result) {
        if (!Curry._1(didCancelRetries, undefined)) {
            return Promise.resolve(result);
        }
        if ($$default !== undefined) {
            return Promise.resolve(Caml_option.valFromOption($$default));
        }
        throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
            Error: new Error()
        };
    });
    if (Curry._1(didCancelRetries, undefined) || retries === 1) {
        if (retries === 1) {
            Curry._1(Log$SmartcutsMacros.promiseRetries.log1, "Last retry");
        } else if (Curry._1(didCancelRetries, undefined)) {
            Curry._1(Log$SmartcutsMacros.promiseCancels.log1, "Retries were canceled");
        }
        return promise.catch(function(jsPromiseError) {
            if (Curry._1(shouldRetryForJsPromiseError, jsPromiseError)) {
                if ($$default !== undefined) {
                    return Promise.resolve(Caml_option.valFromOption($$default));
                }
                if (Curry._1(didCancelRetries, undefined)) {
                    throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                    };
                }
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
            }
            var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
            if (match === 1) {} else {
                console.warn("ERROR", jsPromiseError);
            }
            return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
        });
    } else {
        return promise.catch(function(jsPromiseError) {
            var waitMilliseconds = Math.imul(100, Math.pow(2, (3 - retries | 0) + 1 | 0) | 0);
            if (Curry._1(shouldRetryForJsPromiseError, jsPromiseError)) {
                return new Promise(function(resolve, param) {
                    setTimeout(function(param) {
                        withRetriesInner(retries - 1 | 0, didCancelRetries, doPromise, shouldRetryForJsPromiseError, $$default).then(function(res) {
                            resolve(res);
                            return Promise.resolve(undefined);
                        });
                    }, waitMilliseconds);
                });
            }
            var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
            if (match === 1) {} else {
                console.warn("ERROR", jsPromiseError);
            }
            return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
        });
    }
}
function withRetries(retries, doPromise, shouldRetryForJsPromiseError, $$default, param) {
    var didCallerCancelRetries = {
        contents: false
    };
    var cancelCallbacks = {
        contents: []
    };
    var addCancelCallback = function addCancelCallback(callback) {
        if (didCallerCancelRetries.contents) {
            return Curry._1(callback, undefined);
        } else {
            cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [
                callback
            ]);
            return;
        }
    };
    var cancelRetries = function cancelRetries(param) {
        didCallerCancelRetries.contents = true;
        return Belt_Array.forEach(cancelCallbacks.contents, function(callback) {
            return Curry._1(callback, undefined);
        });
    };
    var doPromise$1 = function doPromise$1(param) {
        return withRetriesInner(retries, function(param) {
            return didCallerCancelRetries.contents;
        }, Curry._1(doPromise, addCancelCallback), shouldRetryForJsPromiseError, $$default);
    };
    return [
        doPromise$1,
        cancelRetries
    ];
}
function untilNoMatchingJsPromiseError(waitMillisecondsBeforeNextAttemptOpt, doPromise, doesErrorMatch, param) {
    var waitMillisecondsBeforeNextAttempt = waitMillisecondsBeforeNextAttemptOpt !== undefined ? waitMillisecondsBeforeNextAttemptOpt : 200;
    return Curry._1(doPromise, undefined).catch(function(jsPromiseError) {
        if (Curry._1(doesErrorMatch, jsPromiseError)) {
            return new Promise(function(resolve, param) {
                setTimeout(function(param) {
                    untilNoMatchingJsPromiseError(waitMillisecondsBeforeNextAttempt, doPromise, doesErrorMatch, undefined).then(function(result) {
                        resolve(result);
                        return Promise.resolve(undefined);
                    });
                }, waitMillisecondsBeforeNextAttempt);
            });
        } else {
            return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
        }
    });
}
function withTimeout(timeout, promise) {
    return new Promise(function(resolve_, param) {
        setTimeout(function(param) {
            promise.then(function(result) {
                resolve_(result);
                return Promise.resolve(undefined);
            });
        }, timeout);
    });
}
function retryAll(retries, makePromise, shouldRetryForJsPromiseError, $$default, xs) {
    var didCallerCancelRetries = {
        contents: false
    };
    var cancelCallbacks = {
        contents: []
    };
    var addCancelCallback = function addCancelCallback(callback) {
        if (didCallerCancelRetries.contents) {
            return Curry._1(callback, undefined);
        } else {
            cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [
                callback
            ]);
            return;
        }
    };
    var cancelRetries = function cancelRetries(param) {
        didCallerCancelRetries.contents = true;
        return Belt_Array.forEach(cancelCallbacks.contents, function(callback) {
            return Curry._1(callback, undefined);
        });
    };
    var doPromise = function doPromise(param) {
        return Belt_Array.reduce(xs, Promise.resolve([]), function(prevPromise, x) {
            return prevPromise.then(function(prevResults) {
                return map(withRetriesInner(retries, function(param) {
                    return didCallerCancelRetries.contents;
                }, function(param) {
                    return Curry._2(makePromise, addCancelCallback, x);
                }, shouldRetryForJsPromiseError, $$default), function(result) {
                    return Belt_Array.concat(prevResults, [
                        result
                    ]);
                });
            });
        });
    };
    return [
        doPromise,
        cancelRetries
    ];
}
function mapResult2(result, mapOk, mapError) {
    if (result.TAG === /* Ok */ 0) {
        return Curry._1(mapOk, result._0);
    } else {
        return Promise.resolve({
            TAG: /* Error */ 1,
            _0: Curry._1(mapError, result._0)
        });
    }
}
function mapResult(result, f) {
    return mapResult2(result, f, function(x) {
        return x;
    });
}
function mapOption(maybeValue, f, resolveNoneAs) {
    if (maybeValue !== undefined) {
        return Curry._1(f, Caml_option.valFromOption(maybeValue));
    } else {
        return Promise.resolve(resolveNoneAs);
    }
}
function withTimer(timerName, resolver, promise) {
    var performance$1 = performance;
    var t0 = performance$1.now();
    return promise.then(Curry.__1(resolver)).then(function(result) {
        var t1 = performance$1.now();
        console.log(timerName, t1 - t0);
        return Promise.resolve(result);
    });
}
exports.map = map;
exports.map2 = map2;
exports.resolveWith = resolveWith;
exports.rejectWith = rejectWith;
exports.cancelTimeout = cancelTimeout;
exports.toString = toString;
exports.getOrReject = getOrReject;
exports.rejectIfEmpty = rejectIfEmpty;
exports.pickFirst = pickFirst;
exports.append_result = append_result;
exports.append_result2 = append_result2;
exports.doAll = doAll;
exports.doAllWithProgressUpdate = doAllWithProgressUpdate;
exports.sequentiallyWithIndex = sequentiallyWithIndex;
exports.sequentiallyWithIndex2 = sequentiallyWithIndex2;
exports.sequentially = sequentially;
exports.sequentially2 = sequentially2;
exports.sequentiallyEvalResults = sequentiallyEvalResults;
exports.doAllFns = doAllFns;
exports.sequentiallyList = sequentiallyList;
exports.wrapInTimeout = wrapInTimeout;
exports.shortcutWithIndexAndState = shortcutWithIndexAndState;
exports.shortcutWithState = shortcutWithState;
exports.shortcutWithIndex = shortcutWithIndex;
exports.shortcut = shortcut;
exports.orPromise = orPromise;
exports.makeCancelable = makeCancelable;
exports.makePromiseCancelableBySurroundingPromise = makePromiseCancelableBySurroundingPromise;
exports.withRetries = withRetries;
exports.untilNoMatchingJsPromiseError = untilNoMatchingJsPromiseError;
exports.withTimeout = withTimeout;
exports.retryAll = retryAll;
exports.mapResult2 = mapResult2;
exports.mapResult = mapResult;
exports.mapOption = mapOption;
exports.withTimer = withTimer; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 45934:
/***/ (function(__unused_webpack_module, exports) {

// Generated by ReScript, PLEASE EDIT WITH CARE

function makeIdGenerator(param) {
    var nextId = {
        contents: 0
    };
    return function(param) {
        var id = nextId.contents;
        nextId.contents = id + 1 | 0;
        return id;
    };
}
exports.makeIdGenerator = makeIdGenerator; /* No side effect */ 


/***/ }),

/***/ 45734:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Belt_Array = __webpack_require__(2971);
function isEmpty(set) {
    return set.size === 0;
}
function isSubsetOf(aSet, bSet) {
    return Belt_Array.every(Array.from(aSet), function(item) {
        return bSet.has(item);
    });
}
function isStructSubsetOf(aSet, bSet) {
    if (isSubsetOf(aSet, bSet)) {
        return !isSubsetOf(bSet, aSet);
    } else {
        return false;
    }
}
function isSameSetAs(aSet, bSet) {
    if (isSubsetOf(aSet, bSet)) {
        return isSubsetOf(bSet, aSet);
    } else {
        return false;
    }
}
function intersect(aSet, bSet) {
    var jointed = [];
    aSet.forEach(function(item) {
        if (bSet.has(item)) {
            jointed.push(item);
            return;
        }
    });
    return new Set(jointed);
}
function union(aSet, bSet) {
    var unioned = [];
    var addUnioned = function addUnioned(item) {
        unioned.push(item);
    };
    aSet.forEach(addUnioned);
    bSet.forEach(function(item) {
        if (!aSet.has(item)) {
            return addUnioned(item);
        }
    });
    return new Set(unioned);
}
function subtract(aSet, bSet) {
    var diffs = [];
    aSet.forEach(function(item) {
        if (!bSet.has(item)) {
            diffs.push(item);
            return;
        }
    });
    return new Set(diffs);
}
function difference(aSet, bSet) {
    return union(subtract(aSet, bSet), subtract(bSet, aSet));
}
exports.isEmpty = isEmpty;
exports.isSubsetOf = isSubsetOf;
exports.isStructSubsetOf = isStructSubsetOf;
exports.isSameSetAs = isSameSetAs;
exports.intersect = intersect;
exports.union = union;
exports.subtract = subtract;
exports.difference = difference; /* No side effect */ 


/***/ }),

/***/ 94971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var List = __webpack_require__(68724);
var $$Array = __webpack_require__(53209);
var Js_exn = __webpack_require__(82900);
var $$String = __webpack_require__(65760);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_js_exceptions = __webpack_require__(74518);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var SearchParams = {};
function fromString(s) {
    var url;
    try {
        url = new URL(s);
    } catch (raw_err) {
        var err = Caml_js_exceptions.internalToOCamlException(raw_err);
        if (err.RE_EXN_ID === Js_exn.$$Error) {
            var err$1 = err._1;
            if (Caml_obj.caml_equal(err$1.name, "TypeError") && Caml_obj.caml_equal(err$1.message, "Failed to construct 'URL': Invalid URL")) {
                return;
            }
            throw err;
        }
        throw err;
    }
    return url;
}
function pathComponents(url) {
    var partsWithLeadingBlank = $$Array.of_list($$String.split_on_char(/* '/' */ 47, url.pathname));
    return Belt_Array.slice(partsWithLeadingBlank, 1, partsWithLeadingBlank.length);
}
function numPathComponents(url) {
    return pathComponents(url).length;
}
function sharesHostname(excludeSubdomain, urlA, urlB) {
    if (!excludeSubdomain) {
        return urlA.hostname === urlB.hostname;
    }
    var hostnameReversedPartsA = List.rev(StringUtils$SmartcutsMacros.split(".", urlA.hostname));
    var hostnameReversedPartsB = List.rev(StringUtils$SmartcutsMacros.split(".", urlB.hostname));
    if (!hostnameReversedPartsA) {
        return false;
    }
    var match = hostnameReversedPartsA.tl;
    if (!match) {
        return false;
    }
    if (!hostnameReversedPartsB) {
        return false;
    }
    var match$1 = hostnameReversedPartsB.tl;
    if (match$1 && hostnameReversedPartsA.hd === hostnameReversedPartsB.hd) {
        return match.hd === match$1.hd;
    } else {
        return false;
    }
}
var $$URL$1 = {
    SearchParams: SearchParams,
    fromString: fromString,
    pathComponents: pathComponents,
    numPathComponents: numPathComponents,
    sharesHostname: sharesHostname
};
function deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation(url, $$location) {
    if ($$location.origin !== url.origin) {
        return "[href=" + (window.CSS.escape(url.toString()) + "]");
    }
    if (url.pathname.startsWith($$location.pathname)) {
        var urlMinusSharedOriginAndPath = url.toString().slice(url.origin.length + $$location.pathname.length | 0);
        var relativePath = urlMinusSharedOriginAndPath.startsWith("/") ? urlMinusSharedOriginAndPath.slice(1) : urlMinusSharedOriginAndPath;
        return "[href*=" + (window.CSS.escape(relativePath) + "]");
    }
    var urlWithoutOrigin = url.toString().slice(url.origin.length);
    return "[href=" + (window.CSS.escape(urlWithoutOrigin) + "]");
}
function normalize(baseUrl, href) {
    var baseUrlRecord = fromString(baseUrl);
    if (baseUrlRecord === undefined) {
        return "";
    }
    if (href.startsWith("/")) {
        var origin = baseUrlRecord.origin;
        return origin + href;
    }
    if (!href.startsWith("#")) {
        if (href.startsWith(".")) {
            return new URL(href, baseUrl).toString();
        } else {
            return href;
        }
    }
    var newUrlRecord = new URL(baseUrlRecord);
    newUrlRecord.hash = href;
    return newUrlRecord.toString();
}
function extractDomainName(website) {
    return website.replace(new RegExp("^(https?://)?(www\\.)?"), "").replace(new RegExp("/.*$"), "");
}
exports.$$URL = $$URL$1;
exports.deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation = deriveHrefAttributeSelectorFromFullUrlAndDocumentLocation;
exports.normalize = normalize;
exports.extractDomainName = extractDomainName; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 59730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Generated by ReScript, PLEASE EDIT WITH CARE

var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var ManifestJson = __webpack_require__(10903);
var arg = "6d5a99f9967e5f631fc7307f24c017c98dd47bfa";
var arg$1 = function(param) {
    return OptionUtils$SmartcutsMacros.orElse(param, arg);
}(process.env.NEXT_PUBLIC_GIT_SHA);
var webappVersion = function(param) {
    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
}("Expected an appVersion to be set");
var manifest = ManifestJson;
var lastPublishedExtensionVersion = manifest.version;
var publicUserToken = "fnAFY84N3OAAQtwap150T-ibKaA1hniJrPq0na0O";
var extensionId = "pbdjbjpckecmjacpfkjnmahlfjjhjofp";
exports.webappVersion = webappVersion;
exports.manifest = manifest;
exports.lastPublishedExtensionVersion = lastPublishedExtensionVersion;
exports.publicUserToken = publicUserToken;
exports.extensionId = extensionId; /* arg Not a pure module */ 


/***/ }),

/***/ 10903:
/***/ (function(module) {

module.exports = JSON.parse('{"manifest_version":2,"name":"Smartcuts","version":"31.4.2","description":"Smartcuts helps you automate repetitive work on any website.","icons":{"16":"icons/icon16.png","48":"icons/icon48.png","128":"icons/icon128.png"},"browser_action":{"default_popup":"html/popup.html","default_icon":"icons/browser_action_icon32.png"},"background":{"scripts":["dist/development/browser-polyfill.min.js","segment.js","freshpaint.js","googleClient.js","dist/development/background.js"]},"content_scripts":[{"matches":["<all_urls>"],"js":["dist/development/browser-polyfill.min.js","dist/development/contentScript.js","dist/development/webfontloader.js"]}],"incognito":"spanning","permissions":["activeTab","contextMenus","debugger","identity","notifications","storage","unlimitedStorage"],"optional_permissions":["<all_urls>","alarms","idle","downloads","clipboardRead","clipboardWrite","webNavigation","tabs"],"web_accessible_resources":["html/notif.html","html/iframe.html","dist/development/inject_messaging.js","dist/development/browser-polyfill.min.js.map","dist/development/notif.js","icons/icon128.png","img/google_logo_oauth_1x.png","img/google_logo_oauth_2x.png"],"content_security_policy":"script-src \'self\' https://apis.google.com https://cdn.segment.com https://www.google-analytics.com https://cdn.mxpnl.com https://perfalytics.com https://cdn.amplitude.com; object-src \'self\'","oauth2":{"client_id":"48219858153-5h5df45ni8sph0pjfvphih17jhktmg7l.apps.googleusercontent.com","scopes":["https://www.googleapis.com/auth/spreadsheets"]}}');

/***/ })

}]);